// "By logging in, you agree to Buzzztech's Terms and Conditions": "Ao fazer login, você concorda com os Termos e Condições da Buzzztech"

const serviks = {
  en: {
    "cleaned_floor": "cleaned floor",
    "cleaned_toilet": "cleaned toilet",
    "cleaned_shower": "cleaned shower",
    "cleaned_sink": "cleaned sink",
    "cleaned_mirror": "cleaned mirror",
    "cleaned_stainless_steel": "cleaned stainless steel",
    "bad_smell": "bad smell",
    "dirty_floor": "dirty floor",
    "dirty_lavatory_seat": "dirty lavatory seat",
    "dirty_shower": "dirty shower",
    "dirty_sink": "dirty sink",
    "dirty_mirror": "dirty mirror",
    "dirty_stainless_steel": "dirty stainless steel",
    "missing_paper_towel": "missing paper towel",
    "missing_soap": "missing soap",
    "missing_toilet_paper": "missing toilet paper",
    "problem_shower": "problem shower",
    "problem_sink": "problem sink",
    "problem_mirror": "problem mirror",
    "problem_stainless_steel": "problem stainless steel",
    "problem_blockage": "problem blockage",
    "problem_door": "problem door",
    "problem_fluid_taps": "problem fluid taps",
    "problem_lightning": "problem lightning",
    "problem_broken_toilet": "problem broken toilet",
    "fixed_shower": "fixed shower",
    "fixed_sink": "fixed sink",
    "fixed_mirror": "fixed mirror",
    "fixed_stainless_steel": "fixed stainless steel",
    "fixed_blockage": "fixed blockage",
    "fixed_door": "fixed door",
    "fixed_fluid_taps": "fixed fluid taps",
    "fixed_lightning": "fixed lightning",
    "fixed_broken_toilet": "fixed broken toilet",
    "very_good": "very good",
    "excellent": "excellent",
    "good": "good",
    "like": "like",
    "needs_improvement": "needs improvement",
    "not_good": "not good",
    "supervise": "supervise",
    "maintenance": "maintenance",
    "cleaner": "cleaner",
    "tag_cleaner": "tag cleaner",
    "zone_is_clean": "zone is clean",
    "zone_is_dirty": "zone is dirty",
    "cleaner_arrived": "cleaner arrived",
    "start_clean_zone": "start clean zone",
    "counter": "counter",
    "counter_men": "counter men",
    "counter_woman": "counter woman",
    "counter_handycap": "counter handycap",
    "full_garbage_can": "full garbage can",
    "maintenance_fixed": "maintenance fixed",
    "maintenance_problem": "maintenance problem",
    "problem_soap_dispenser": "problem soap dispenser",
    "problem_paper_dispenser": "problem paper dispenser",
    "end_clean_zone": "end clean zone",
    "status_toilet_paper": "status toilet paper",
    "status_hend_paper": "status hend paper",
    "fixed": "fixed",
    "status_soap": "status soap",
    "status_garbage_can": "status garbage can",
    "general_cleaning": "general cleaning",
    "coffee_tea": "coffee tea",
    "water_bar": "water bar",
    "disposable_dishes": "disposable dishes",
    "head_coverage": "head coverage",
    "something_else": "something else",
    "missing_clothing": "missing clothing",
    "maintenance_link": "maintenance link",
    "problem_maintenance": "problem maintenance",
    "supervise_link": "supervise link",
    "cleaner_link": "cleaner link",
    "room_men+link": "room men + link",
    "room_men-link": "room men - link",
    "room_women+link": "room women + link",
    "room_women-link": "room women - link",
    "hebrew": "hebrew",
    "español": "español",
    "français": "français",
    "english": "english",
    "русский": "русский",
    "italiano": "italiano",
    "አማርኛ": "አማርኛ",
    "português": "português",
    "arabic": "arabic",
    "partial_information": "partial information",
    "professionalism": "professionalism",
    "the_attitude_of_the_representative": "the attitude of the representative",
    "waiting_time_for_service": "waiting time for service",
    "other_aspect_of_service": "other aspect of service",
    "language_of_the_service": "language of the service",
    "procedure_for_making_an_appointment": "procedure for making an appointment",
    "physical_conditions": "physical conditions",
    "found_another": "found another",
    "found_similar": "found similar",
    "did_not_find": "did not find",
    "found": "found",
    "need_improved": "need improved",
    "liked": "liked",
    "pleasant": "pleasant",
    "eilat_resident": "eilat resident",
    "once_a_week": "once a week",
    "once_a_month": "once a month",
    "twice_a_year": "twice a year",
    "once_a_year": "once a year",
    "friend": "friend",
    "newspaper": "newspaper",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "vacuum cleaner",
    "gaming_consoles": "gaming consoles",
    "laptop": "laptop",
    "cellular": "cellular",
    "shop": "shop",
    "restaurant_complex_cleaning": "restaurant complex cleaning",
    "dining_room": "dining room",
    "food_variety": "food variety",
    "quality_of_the_food": "quality of the food",
    "amount_of_the_food": "amount of the food",
    "quality_of_cooking": "quality of cooking",
    "side_courses": "side courses",
    "meat": "meat",
    "desserts": "desserts",
    "vegetarian": "vegetarian",
    "salad_bar": "salad bar",
    "main_courses": "main courses",
    "service": "service",
    "dining_room_cleanliness": "dining room cleanliness",
    "plates_and_cutlery_cleanliness": "plates and cutlery cleanliness",
    "product_inventory": "product inventory",
    "furnishers": "furnishers",
    "toilets": "toilets",
    "problem_coffee_machine": "problem coffee machine",
    "problem_water_bar": "problem water bar",
    "dirty_stairs": "dirty stairs",
    "toiletries": "toiletries",
    "fixed_soap_dispenser": "fixed soap dispenser",
    "fixed_paper_dispenser": "fixed paper dispenser",
    "fixed_coffee_machine": "fixed coffee machine",
    "fixed_water_bar": "fixed water bar",
    "problem_urinals": "problem urinals",
    "blockage_toilet": "blockage toilet",
    "appliance_problem": "appliance problem",
    "problem_broken_door": "problem broken door",
    "problem_door_lock": "problem door lock",
    "problem_broken_toilet_seat": "problem broken toilet seat",
    "problem_broken_niagara": "problem broken niagara",
    " broken_hand_paper_dispenser_hand_dryer": "broken hand paper dispenser + hand dryer",
    "rug": "rug",
    "tables": "tables",
    "kitchen": "kitchen",
    "air_condition": "air condition",
    "dirty_urinals": "dirty urinals",
    "hand_dryer": "hand_dryer",
    "non_sticky_carpet": "non-sticky carpet",
    "problem_bad_smell": "problem bad smell",
    "problem_broken_toilet_handle": "problem broken toilet handle",
    "problem_handle_door": "problem handle door",
    "call_cleaner": "call cleaner",
    "wall_painting": "wall painting",
    "missing_paper": "missing paper",
    "clean_surface": "clean surface",
    "problem_right_elevator": "problem right elevator",
    "problem_left_elevator": "problem left elevator",
    "missing_hand_sanitizer": "missing hand sanitizer",
    "problem_sink_blockage": "problem sink blockage",
    "electric_problem": "electric problem",
    "missing_coffe_tea": "missing coffe tea",
    "problem_air_condition": "problem air condition",
    "dishwashing": "dishwashing",
    "kitchen_cleanliness": "kitchen cleanliness",
    "weekly_cleaning": "weekly cleaning",
    "general_arrangement": "general arrangement",
    "meeting_room": "meeting room",
    "refrigerator": "refrigerator",
    "kitchen_supplies": "kitchen supplies",
    "toilet_services": "toilet services",
    "carousel_door": "carousel door",
    "desk": "desk",
    "compressor": "compressor",
    "compressor_rails": "compressor rails",
    "compressor_drainage": "compressor drainage",
    "dust": "dust",
    "door": "door",
    "scotch": "scotch",
    "food": "food",
    "room_conditions": "room conditions",
    "kindness_sensitivity": "kindness and sensitivity",
    "explain_process": "explain the process",
    "personal_attention": "personal attention",
    "service_problem": "service problem",
    "welcome_you": "welcome you",
    "invoice_submitted": "invoice submitted",
    "thank_you_bought": "thank you bought",
    "problem_seller": "problem seller",
    "lapel_pin": "lapel pin",
    "proper_performance": "proper performance",
    "name_tag": "name tag",
    "operational": "operational",
    "app_revealed": "app revealed",
    "register_load": "register load",
    "visibility_problem": "visibility problem",
    "clean_storefront": "clean storefront",
    "clean_garbage": "clean garbage",
    "clean_tables_chairs": "clean tables and chairs",
    "clean_shop_floor": "clean shop floor",
    "product_show": "view of product",
    "refrigerators_show": "view of refrigerators",
    "coffee_accessories": "coffee accessories and equipped",
    "cleanliness": "cleanliness",
    "convenience_scheduling_appointments": "convenience of scheduling appointments",
    "waiting_haircut": "waiting for a haircut",
    "courtesy_books": "courtesy of the books",
    "books_professionalism": "the professionalism of the books",
    "received_time": "received me on time",
    "dnot_appointment": "i did not make an appointment",
    "an_appointment": "i made an appointment",
    "tasty": "tasty",
    "courtesy_service": "courtesy of the service",
    "overall_experience": "the overall experience",
    "not_clean": "not clean",
    "diningroom_not_clean": "the dining room is not clean",
    "unclean_dishes": "unclean dishes",
    "so-so": "so-so",
    "not_tasty": "not tasty",
    "kind": "kind",
    "not_kind": "not kind",
    "clean": "clean",
    "hairdresser": "hairdresser",
    "wrong_price": "wrong price",
    "produc_has_expired": "product has expired",
    "missing_item": "missing item",
    "item_is_faulty_in_the_machine": "item is faulty in the machine",
    "machine_cleaning": "machine cleaning",
    "improper_temperature": "improper temperature",
    "green": "green",
    "orange": "orange",
    "red": "red",
    "yellow": "yellow",
    "red not prob": "red not prob",
    "professional": "professional",
    "unprofessional": "unprofessional",
    "delicacies": "delicacies",
    "sandwiches": "sandwiches",
    "vegetables": "vegetables",
    "fruits": "fruits",
    "salads": "salads",
    "milk": "milk",
    "room_link": "room link",
    "floor_link": "floor link",
    "services": "services",
    "check_list": "check list",
    "lighting_problem_lobby": "lighting problem lobby",
    "lighting_problem_garbage_room": "lighting problem garbage room",
    "lighting_problem_stairwell": "lighting problem stairwell",
    "problem_elevator_1": "problem elevator 1",
    "problem_elevator_2": "problem elevator 2",
    "problem_elevator_3": "problem elevator 3",
    "problem_elevator_4": "problem elevator 4",
    "problem_elevator_5": "problem elevator 5",
    "problem_elevator_6": "problem elevator 6",
    "problem_elevator_7": "problem elevator 7",
    "problem_elevator_8": "problem elevator 8",
    "problem_elevator_9": "problem elevator 9",
    "problem_elevator_10": "problem elevator 10",
    "stuck_item": "stuck item",
    "spoiling_product": "spoiling product",
    "machine_malfunction": "machine malfunction",
    "unreadable_product": "unreadable product",
    "i_am_satisfied": "i am satisfied",
    "beverage": "beverage",
    "program_malfunction": "program malfunction",
    "machine_1": "machine 1",
    "machine_2": "machine 2",
    "machine_3": "machine 3",
    "machine_4": "machine 4",
    "program malfunction 1": "program malfunction 1",
    "program malfunction 2": "program malfunction 2",
    "program malfunction 3": "program malfunction 3",
    "program malfunction 4": "program malfunction 4",
    "fish": "fish",
    "chicken": "chicken",
    "full_dining_room": "full dining room",
    "missing_amount": "missing amount",
    "missing_trays": "missing trays",
    "dirty_floor_g1": "dirty floor g1",
    "dirty_floor_g2": "dirty floor g2",
    "dirty_floor_g3": "dirty floor g3",
    "dirty_floor_g4": "dirty floor g4",
    "dirty_floor_g5": "dirty floor g5",
    "dirty_floor_eo": "dirty floor eo",
    "dirty_floor_ceo": "dirty floor ceo",
    "dirty_floor_storage": "dirty floor storage",
    "dirty_floor_inflorescence": "dirty floor inflorescence",
    "operating_instructions": "operating instructions",
    "general": "general",
    "connection_problem": "connection problem",
    "lighting": "lighting",
    "not _fixed": "not fixed",
    "cleaning_needed": "cleaning needed",
    "missing_milk": "missing milk",
    "no_sugar_coffee": "no sugar / coffee",
    "missing_tools": "missing tools",
    "coffee_water_machine": "coffee / water machine",
    "appliances": "appliances",
    "products": "products",
    "broken_chair": "broken furniture",
    "broken_cabinet": "broken cabinet",
    "micro": "micro",
    "toaster": "toaster",
    "clogged_sink_malfunction": "clogged sink malfunction",
    "coffee_cooling_malfunction": "coffee cooling malfunction",
    "no_coffee_beans": "no coffee beans",
    "machine_failure": "machine failure",
    "that_dirty": "that dirty",
    "dirty_refrigerator": "dirty refrigerator",
    "dirty_tables": "dirty tables",
    "plates": "plates",
    "silver_spoon": "silver_spoon",
    "cold_drinks_cups": "cold drinks cups",
    "hot_drink_cups": "hot drink cups",
    "a_dripping_faucet": "a dripping faucet",
    "disposable dishes": "disposable dishes",
    "problem_ coffee_water_machine": "problem coffee / water machine",
    "problem_micro": "problem micro",
    "problem_toaster": "problem toaster",
    "problem_machine_failure": "problem machine failure",
    "problem refrigerator": "problem refrigerator",
    "no_sugar/coffee": "no sugar / coffee",
    "missing_dishes": "missing dishes",
    "coffee/water_machine": "coffee / water machine",
    "coffee_machine_door_open": "coffee machine door open",
    "coffee_machine_door_close": "coffee machine door close",
    "coffee_machine_bin_full": "coffee machine bin full",
    "coffee_machine_bin_empty": "coffee machine bin empty",
    "coffee_machine_coffee_full": "coffee machine coffee full",
    "coffee_machine_coffee_empty": "coffee machine coffee empty",
    "coffee_machine_water_tank_empty": "coffee machine water tank empty",
    "coffee_machine_ water_tank_full": "coffee machine watertank full",
    "coffee_machine_milk_cleaning_not_performed": "coffee machine milk cleaning not performed",
    "coffee_machine _milk_cleaning_performed": "coffee machine milk cleaning performed",
    "coffee_machine_head_cleaning_not_performed": "coffee machine head cleaning not performed",
    "coffee_machine_head_ cleaning_performed": "coffee machine head cleaning performed",
    "coffee_machine_descaling_not_performed": "coffee machine  descaling not performed",
    "coffee_machine_descaling_performed": "coffee machine descaling performed",
    "floor_one": "floor 1",
    "floor_two": "floor 2",
    "floor_three": "floor 3",
    "floor_four": "floor 4",
    "floor_five": "floor 5",
    "floor_six": "floor 6",
    "floor_seven": "floor 7",
    "floor_eight": "floor 8",
    "floor_nine": "floor 9",
    "floor_ten": "floor 10",
    "floor_eleven": "floor 11",
    "floor_twelve": "floor 12",
    "floor_thirteen": "floor 13",
    "floor_fourteen": "floor 14",
    "floor_fifteen": "floor 15",
    "floor_sixteen": "floor 16",
    "floor_seventeen": "floor 17",
    "floor_eighteen": "floor 18",
    "floor_nineteen": "floor 19",
    "floor_twenty": "floor 20",
    "floor_twenty_one": "floor 21",
    "floor_twenty_two": "floor 22",
    "floor_twenty_three": "floor 23",
    "floor_twenty_four": "floor 24",
    "floor_twenty_five": "floor 25",
    "status_toilet_paper_cell_01_-_empty": "Status Toilet Paper Cell 01 - Empty",
    "status_toilet_paper_cell_02_-_empty": "Status Toilet Paper Cell 02 - Empty",
    "status_toilet_paper_cell_03_-_empty": "Status Toilet Paper Cell 03 - Empty",
    "status_toilet_paper_cell_04_-_empty": "Status Toilet Paper Cell 04 - Empty",
    "status_toilet_paper_cell_05_-_empty": "Status Toilet Paper Cell 05 - Empty",
    "status_toilet_paper_cell_06_-_empty": "Status Toilet Paper Cell 06 - Empty",
    "status_toilet_paper_cell_07_-_empty": "Status Toilet Paper Cell 07 - Empty",
    "status_toilet_paper_cell_08_-_empty": "Status Toilet Paper Cell 08 - Empty",
    "status_toilet_paper_cell_09_-_empty": "Status Toilet Paper Cell 09 - Empty",
    "status_toilet_paper_cell_10_-_empty": "Status Toilet Paper Cell 10 - Empty",
    "status_toilet_paper_cell_11_-_empty": "Status Toilet Paper Cell 11 - Empty",
    "status_toilet_paper_cell_12_-_empty": "Status Toilet Paper Cell 12 - Empty",
    "status_toilet_paper_cell_13_-_empty": "Status Toilet Paper Cell 13 - Empty",
    "status_toilet_paper_cell_14_-_empty": "Status Toilet Paper Cell 14 - Empty",
    "status_toilet_paper_cell_15_-_empty": "Status Toilet Paper Cell 15 - Empty",
    "status_toilet_paper_cell_16_-_empty": "Status Toilet Paper Cell 16 - Empty",
    "status_toilet_paper_cell_17_-_empty": "Status Toilet Paper Cell 17 - Empty",
    "status_toilet_paper_cell_18_-_empty": "Status Toilet Paper Cell 18 - Empty",
    "status_toilet_paper_cell_19_-_empty": "Status Toilet Paper Cell 19 - Empty",
    "status_toilet_paper_cell_20_-_empty": "Status Toilet Paper Cell 20 - Empty",
    "status_toilet_paper_cell_01_-_almost_empty": "Status Toilet Paper Cell 01 - Almost Empty",
    "status_toilet_paper_cell_02_-_almost_empty": "Status Toilet Paper Cell 02 - Almost Empty",
    "status_toilet_paper_cell_03_-_almost_empty": "Status Toilet Paper Cell 03 - Almost Empty",
    "status_toilet_paper_cell_04_-_almost_empty": "Status Toilet Paper Cell 04 - Almost Empty",
    "status_toilet_paper_cell_05_-_almost_empty": "Status Toilet Paper Cell 05 - Almost Empty",
    "status_toilet_paper_cell_06_-_almost_empty": "Status Toilet Paper Cell 06 - Almost Empty",
    "status_toilet_paper_cell_07_-_almost_empty": "Status Toilet Paper Cell 07 - Almost Empty",
    "status_toilet_paper_cell_08_-_almost_empty": "Status Toilet Paper Cell 08 - Almost Empty",
    "status_toilet_paper_cell_09_-_almost_empty": "Status Toilet Paper Cell 09 - Almost Empty",
    "status_toilet_paper_cell_10_-_almost_empty": "Status Toilet Paper Cell 10 - Almost Empty",
    "status_toilet_paper_cell_11_-_almost_empty": "Status Toilet Paper Cell 11 - Almost Empty",
    "status_toilet_paper_cell_12_-_almost_empty": "Status Toilet Paper Cell 12 - Almost Empty",
    "status_toilet_paper_cell_13_-_almost_empty": "Status Toilet Paper Cell 13 - Almost Empty",
    "status_toilet_paper_cell_14_-_almost_empty": "Status Toilet Paper Cell 14 - Almost Empty",
    "status_toilet_paper_cell_15_-_almost_empty": "Status Toilet Paper Cell 15 - Almost Empty",
    "status_toilet_paper_cell_16_-_almost_empty": "Status Toilet Paper Cell 16 - Almost Empty",
    "status_toilet_paper_cell_17_-_almost_empty": "Status Toilet Paper Cell 17 - Almost Empty",
    "status_toilet_paper_cell_18_-_almost_empty": "Status Toilet Paper Cell 18 - Almost Empty",
    "status_toilet_paper_cell_19_-_almost_empty": "Status Toilet Paper Cell 19 - Almost Empty",
    "status_toilet_paper_cell_20_-_almost_empty": "Status Toilet Paper Cell 20 - Almost Empty",
    "of": "of",
    "items": "items",
    "loading_charts": "loading charts",
    "refresh_the_room": "refresh the room",
    "clean_the_floor": "clean the floor",
    "clean_the_toilet": "clean the toilet",
    "refill_soap": "refill soap",
    "change_roll": "change roll",
    "great_job": "great job",
    "empty_the_trash": "empty the trash",
    "repair_required": "repair required",
    "cleaning": "cleaning",
    "cleaning_performed": "cleaning performed",
  },
  he: {
    "cleaned_floor": "הריצפה נקיה",
    "cleaned_toilet": "השירותים נוקו",
    "cleaned_shower": "המלתחות נוקו",
    "cleaned_sink": "הכיור נוקה",
    "cleaned_mirror": "המראה נקיה",
    "cleaned_stainless_steel": "נירוסטה נוקתה",
    "bad_smell": "ריח רע",
    "dirty_floor": "רצפה מלוכלכת",
    "dirty_lavatory_seat": "האסלה מלוכלכת",
    "dirty_shower": "המלתחות מלוכלכות",
    "dirty_sink": "כיור מלוכלך",
    "dirty_mirror": "מראה מלוכלכת",
    "dirty_stainless_steel": "נירוסטה מלוכלכת",
    "missing_paper_towel": "חסר ניר ידיים",
    "missing_soap": "חסר סבון",
    "missing_toilet_paper": "חסר נייר טואלט",
    "problem_shower": "בעיה במלתחה",
    "problem_sink": "בעיה בכיור",
    "problem_mirror": "בעיה במראה",
    "problem_stainless_steel": "בעיה בנירוסטה",
    "problem_blockage": "סתימה",
    "problem_door": "בעיה בדלת",
    "problem_fluid_taps": "ברזים נוזלים",
    "problem_lightning": "בעיית תאורה",
    "problem_broken_toilet": "אסלה שבורה",
    "fixed_shower": "המלתחות סודרו",
    "fixed_sink": "הכיור סודר",
    "fixed_mirror": "המראה סודרה",
    "fixed_stainless_steel": "הנירוסטה סודרה",
    "fixed_blockage": "סתימה סודרה",
    "fixed_door": "הדלת סודרה",
    "fixed_fluid_taps": "הנזילה סודרה",
    "fixed_lightning": "התאורה סודרה",
    "fixed_broken_toilet": "סודרה האסלה",
    "very_good": "טוב מאוד",
    "excellent": "מצויין",
    "good": "טוב",
    "like": "לייק",
    "needs_improvement": "טעון שיפור",
    "not_good": "לא טוב",
    "supervise": "מפקח",
    "maintenance": "תחזוקה",
    "cleaner": "מנקה",
    "tag_cleaner": "חישן הגעת מנקה",
    "zone_is_clean": "מפקח האזור נקי",
    "zone_is_dirty": "מפקח האזור מלוכלך",
    "cleaner_arrived": "מנקה הגיע",
    "start_clean_zone": "תחילת ניקיון",
    "counter": "קאונטר",
    "counter_men": "מספר גברים",
    "counter_woman": "מספר נשים",
    "counter_handycap": "מספר נכים",
    "full_garbage_can": "פח אשפה מלא",
    "maintenance_fixed": "תחזוקה סודרה",
    "maintenance_problem": "בעית תחזוקה",
    "problem_soap_dispenser": "בעית מתקן סבון",
    "problem_paper_dispenser": "בעית מתקן נייר",
    "end_clean_zone": "סיום ניקיון",
    "status_toilet_paper": "חישן ניר טואלט",
    "status_hend_paper": "חישן ניר ידים",
    "fixed": "תקין",
    "status_soap": "חישן נוזל סבון",
    "status_garbage_can": "חישן פח אשפה",
    "general_cleaning": "ניקיון כללי",
    "coffee_tea": "קפה / תה",
    "water_bar": "מתקן מים",
    "disposable_dishes": "כלים חד פעמיים",
    "head_coverage": "כיסוי חד״פ",
    "something_else": "משהו אחר",
    "missing_clothing": "חוסר בביגוד",
    "maintenance_link": "מעבר אחזקה",
    "problem_maintenance": "בעיית אחזקה",
    "supervise_link": "מעבר מפקח",
    "cleaner_link": "מעבר מנקה",
    "room_men+link": " מעבר חדר חיובי גברים",
    "room_men-link": " מעבר חדר שלילי גברים",
    "room_women+link": " מעבר חדר חיובי נשים",
    "room_women-link": " מעבר חדר שלילי נשים",
    "hebrew": "עברית",
    "español": "ספרדית",
    "français": "צרפתית",
    "english": "אנגלית",
    "русский": "רוסית",
    "italiano": "איטלקית",
    "አማርኛ": "אמהרית",
    "português": "פורטוגזית",
    "arabic": "ערבית",
    "partial_information": "מידע חלקי",
    "professionalism": "מקצועיות",
    "the_attitude_of_the_representative": "עמדתו של המייצג",
    "waiting_time_for_service": "זמן המתנה לשירות",
    "other_aspect_of_service": "היבט אחר של השירות",
    "language_of_the_service": "שפת השירות",
    "procedure_for_making_an_appointment": "נקיטת קביעת פגישה",
    "physical_conditions": "תנאים גופניים",
    "found_another": "בסוף מצאתי אחר",
    "found_similar": "מצאתי משהו דומה",
    "did_not_find": "לא מצאתי",
    "found": "מצאתי את המוצר",
    "need_improved": "ניתן לשפר",
    "liked": "אהבתי",
    "pleasant": "נעימה",
    "eilat_resident": "אני תושב אילת",
    "once_a_week": "פעם בשבוע",
    "once_a_month": "פעם בחודש",
    "twice_a_year": "פעמיים שלוש בשנה",
    "once_a_year": "פעם בשנה",
    "friend": "חבר",
    "newspaper": "עיתון",
    "google": "גוגל",
    "zap": "זאפ",
    "vacuum_cleaner": "שואב אבק",
    "gaming_consoles": "קונסולות גיימינג",
    "laptop": "מחשב נייד",
    "cellular": "סלולרי",
    "shop": "חנוית",
    "restaurant_complex_cleaning": "ניקיון מתחם מסעדה",
    "dining_room": "חדר אוכל",
    "food_variety": "מגוון המזון",
    "quality_of_the_food": "איכות המזון",
    "amount_of_the_food": "כמות  המזון",
    "quality_of_cooking": "איכות הבישול",
    "side_courses": "תוספות",
    "meat": "בשרי",
    "desserts": "קינוחים",
    "vegetarian": "צמחוני",
    "salad_bar": "סלטים",
    "main_courses": "המנה העיקרית",
    "service": "שירות",
    "dining_room_cleanliness": "ניקיון המתחם",
    "plates_and_cutlery_cleanliness": "ניקיון הסכום",
    "product_inventory": "מלאי פרודוקטים",
    "furnishers": "ריהוט",
    "toilets": "שירותים",
    "problem_coffee_machine": "בעיה מכונת קפה",
    "problem_water_bar": "בעיה בר מים",
    "dirty_stairs": "מדרגות כניסה מלוכלכות",
    "toiletries": "מוצרי טואלטיקה",
    "fixed_soap_dispenser": "מתקן סבון סודר",
    "fixed_paper_dispenser": "מתקן נייר סודר",
    "fixed_coffee_machine": "מכונת קפה סודרה",
    "fixed_water_bar": "בר מים סודר",
    "problem_urinals": "משתנה תקולה",
    "blockage_toilet": "ניאגרה תקולה",
    "appliance_problem": "מכשיר חשמל תקול",
    "problem_broken_door": "דלת שבורה",
    "problem_door_lock": "בעיה מנעול דלת",
    "problem_broken_toilet_seat": "אסלה שבורה",
    "problem_broken_niagara": "ניאגארה שבורה",
    " broken_hand_paper_dispenser_hand_dryer": "בעיה מיבש ידיים או דיספנסר",
    "rug": "שטיח",
    "tables": "שולחנות",
    "kitchen": "מטבח",
    "air_condition": "מיזוג",
    "dirty_urinals": "משתנה מלוכלכת",
    "hand_dryer": "מיבש ידים",
    "non_sticky_carpet": "שטיח לא דביק",
    "problem_bad_smell": "בעיה ריח רע",
    "problem_broken_toilet_handle": "בעיה ידית שירותים",
    "problem_handle_door": "בעיה ידית דלת",
    "call_cleaner": "קריאה למנקה",
    "wall_painting": "צביעת קירות",
    "missing_paper": "חסר נייר",
    "clean_surface": "נקיון משטחים",
    "problem_right_elevator": "תקלה מעלית ימין",
    "problem_left_elevator": "תקלה מעלית שמאל",
    "missing_hand_sanitizer": "חסר ספריי חיטוי",
    "problem_sink_blockage": "תקלה כיור סתום",
    "electric_problem": "בעיית חשמל",
    "missing_coffe_tea": "חסר קפה תה",
    "problem_air_condition": "בעיית מיזוג",
    "dishwashing": "שטיפת כליים",
    "kitchen_cleanliness": "נקיון מטבח",
    "weekly_cleaning": "נקיון שבועי",
    "general_arrangement": "סידור כללי",
    "meeting_room": "חדר ישיבות",
    "refrigerator": "מקרר",
    "kitchen_supplies": "אספקה מטבח",
    "toilet_services": "אספקה שירותים",
    "carousel_door": "דלת קרוסל ",
    "desk": "דלפק",
    "compressor": "דחסן",
    "compressor_rails": "דחסן מסילות",
    "compressor_drainage": "דחסן ניקוז",
    "dust": "אבק",
    "door": "דלת",
    "scotch": "סקוטש",
    "food": "אוכל",
    "room_conditions": "תנאים בחדר",
    "kindness_sensitivity": "אדיבות ורגישות",
    "explain_process": "הסבר התהליך",
    "personal_attention": "יחס אישי",
    "service_problem": "בעית שירות",
    "welcome_you": "קבל אותך בברכה",
    "invoice_submitted": "הגיש החשבונית תואמת מוצר",
    "thank_you_bought": "ברך תודה שקנית yellow ",
    "problem_seller": "בעית מוכרן",
    "lapel_pin": "עונד סיכת דש עגולה אפליקציה",
    "proper_performance": "בהופעה תקינה",
    "name_tag": "עונד תג שם",
    "operational": "היצא מבצעי החודש",
    "app_revealed": "חשף אותך לאפליקציית",
    "register_load": "עומס בקופה",
    "visibility_problem": "בעית נראות",
    "clean_storefront": "רחבת חזית החנות נקיה",
    "clean_garbage": "פחי האשפה נקיים ואינם",
    "clean_tables_chairs": "השולחנות וכיסאות נקיים",
    "clean_shop_floor": "רצפת החנות נקיה",
    "product_show": "תצוגת המוצרים מלאה",
    "refrigerators_show": "תצוגת המקררים מלאה ונקיה",
    "coffee_accessories": "מתקן לאביזרי קפה נקי ומאובזר",
    "cleanliness": "ניקיון",
    "convenience_scheduling_appointments": "נוחות קביעת תורים",
    "waiting_haircut": "המתנה לתספורת",
    "courtesy_books": "אדיבות הספרים",
    "books_professionalism": "מקצועיות הספרים",
    "received_time": "קיבלו אותי בזמן",
    "dnot_appointment": "לא תאמתי תור",
    "an_appointment": "תאמתי תור",
    "tasty": "טעים",
    "courtesy_service": "אדיבות השירות",
    "overall_experience": "החוויה הכללית",
    "not_clean": "לא נקי",
    "diningroom_not_clean": "חדר האוכל אינו נקי",
    "unclean_dishes": "כלים לא נקיים",
    "so-so": "ככה ככה",
    "not_tasty": "לא טעים",
    "kind": "אדיב",
    "not_kind": "לא אדיב",
    "clean": "נקי",
    "hairdresser": "ספר",
    "wrong_price": "מחיר שגוי",
    "produc_has_expired": "מוצר פג תוקף",
    "missing_item": "פריט חסר",
    "item_is_faulty_in_the_machine": "פריט תקוע תקלה במכונה",
    "machine_cleaning": "ניקיון מכונה",
    "improper_temperature": "טמפרטורה לא תקינה",
    "green": "ירוק",
    "orange": "כתום",
    "red": "אדום",
    "yellow": "צהוב",
    "red not prob": "אדום",
    "professional": "מקצועי",
    "unprofessional": "לא מקצועי",
    "delicacies": "מעדנים",
    "sandwiches": "כריכים",
    "vegetables": "ירקות",
    "fruits": "פירות",
    "salads": "סלטים",
    "milk": "חלב",
    "room_link": "חדר מעבר",
    "floor_link": "קומה מעבר",
    "services": "הספקה",
    "check_list": "רשימה",
    "lighting_problem_lobby": "בעיית תאורה בלובי",
    "lighting_problem_garbage_room": "בעיית תאורה בחדר אשפה",
    "lighting_problem_stairwell": "בעיית תאורה בחדר מדרגות",
    "problem_elevator_1": "תקלה במעלית 1",
    "problem_elevator_2": "תקלה במעלית 2",
    "problem_elevator_3": "תקלה במעלית 3",
    "problem_elevator_4": "תקלה במעלית 4",
    "problem_elevator_5": "תקלה במעלית 5",
    "problem_elevator_6": "תקלה במעלית 6",
    "problem_elevator_7": "תקלה במעלית 7",
    "problem_elevator_8": "תקלה במעלית 8",
    "problem_elevator_9": "תקלה במעלית 9",
    "problem_elevator_10": "תקלה במעלית 10",
    "stuck_item": "פריט תקוע",
    "spoiling_product": "מוצר מקלקל",
    "machine_malfunction": "תקלה במכונה",
    "unreadable_product": "מוצר לא קריא",
    "i_am_satisfied": "אני מרוצה",
    "beverage": "שתייה",
    "program_malfunction": "תקלה תכנית",
    "machine_1": "מכונה 1",
    "machine_2": "מכונה 2",
    "machine_3": "מכונה 3",
    "machine_4": "מכונה 4",
    "program malfunction 1": "תקלה בתכנית 1.",
    "program malfunction 2": "תקלה בתוכנית 2.",
    "program malfunction 3": "תקלה בתוכנית 3.",
    "program malfunction 4": "תקלה בתוכנית 4.",
    "fish": "דג",
    "chicken": "עוף",
    "full_dining_room": "חדר אוכל מלא",
    "missing_amount": "חסר סכום",
    "missing_trays": "חסר מגשים",
    "dirty_floor_g1": "ניקיון חממה 1",
    "dirty_floor_g2": "ניקיון חממה 2",
    "dirty_floor_g3": "ניקיון חממה 3",
    "dirty_floor_g4": "ניקיון חממה 4",
    "dirty_floor_g5": "ניקיון חממה 5",
    "dirty_floor_eo": "ניקיון לשכת סמנכ\"ל",
    "dirty_floor_ceo": "ניקיון לשכת מנכ\"ל",
    "dirty_floor_storage": "ניקיון בקומת מחסן",
    "dirty_floor_inflorescence": "ניקיון הפרחה",
    "operating_instructions": "הוראות הפעלה",
    "general": "כללי",
    "connection_problem": "בעיית חיבור",
    "lighting": "תאורה",
    "not _fixed": "לא תקין",
    "cleaning_needed": "דרוש ניקיון",
    "missing_milk": "חסר חלב",
    "no_sugar_coffee": "חסר סוכר/קפה",
    "missing_tools": "חסר כלים",
    "coffee_water_machine": "מכונות קפה / מכונות מים",
    "appliances": "מוצרי חשמל",
    "products": "פרודקטים",
    "broken_chair": "ריהוט תקול",
    "broken_cabinet": "ארונית שבורה",
    "micro": "מיקרו",
    "toaster": "טוסטר",
    "clogged_sink_malfunction": "תקלה כיור סתום",
    "coffee_cooling_malfunction": "תקלה בקירור הקפה",
    "no_coffee_beans": "חסר פולי קפה",
    "machine_failure": "תקלה במכונה",
    "that_dirty": "שיש מלוכלך",
    "dirty_refrigerator": "מקרר מלוכלך",
    "dirty_tables": "שולחנות מלוכלכים",
    "plates": "צלחות",
    "silver_spoon": "סכו״ם",
    "cold_drinks_cups": "כוסות שתיה קרה",
    "hot_drink_cups": "כוסות שתיה חמה",
    "a_dripping_faucet": "ברז מטפטף",
    "disposable dishes": "כלים חד פעמיים",
    "problem_ coffee_water_machine": "בעיה מכונות קפה / מכונות מים",
    "problem_micro": "בעיה מיקרו",
    "problem_toaster": "בעיה טוסטר",
    "problem_machine_failure": "בעיה תקלה במכונה",
    "problem refrigerator": "בעיה מקרר",
    "no_sugar/coffee": "חסר סוכר/קפה",
    "missing_dishes": "חסר כלים",
    "coffee/water_machine": "מכונות קפה / מכונות מים",
    "coffee_machine_door_open": "מכונת קפה דלת פתוחה",
    "coffee_machine_door_close": "מכונת קפה דלת נסגרה",
    "coffee_machine_bin_full": "מכונת קפה פח מלא",
    "coffee_machine_bin_empty": "מכונת קפה פח ריק",
    "coffee_machine_coffee_full": "מכונת קפה יש פוליים",
    "coffee_machine_coffee_empty": "מכונת קפה אין פוליים",
    "coffee_machine_water_tank_empty": "מכונת קפה מיכל מים ריק",
    "coffee_machine_ water_tank_full": "מכונת קפה מיכל מים מלא",
    "coffee_machine_milk_cleaning_not_performed": "מכונת קפה ניקוי חלב לא בוצע",
    "coffee_machine _milk_cleaning_performed": "מכונת קפה ניקוי חלב בוצע",
    "coffee_machine_head_cleaning_not_performed": "מכונת קפה ניקוי ראש לא ביצע",
    "coffee_machine_head_ cleaning_performed": "מכונת קפה ניקוי ראש בוצע",
    "coffee_machine_descaling_not_performed": "מכונת קפה הסרת אבנית לא בuצע",
    "coffee_machine_descaling_performed": "מכונת קפה הסרת אבנית ביצע",
    "floor_one": "קומה 1",
    "floor_two": "קומה 2",
    "floor_three": "קומה 3",
    "floor_four": "קומה 4",
    "floor_five": "קומה 5",
    "floor_six": "קומה 6",
    "floor_seven": "קומה 7",
    "floor_eight": "קומה 8",
    "floor_nine": "קומה 9",
    "floor_ten": "קומה 10",
    "floor_eleven": "קומה 11",
    "floor_twelve": "קומה 12",
    "floor_thirteen": "קומה 13",
    "floor_fourteen": "קומה 14",
    "floor_fifteen": "קומה 15",
    "floor_sixteen": "קומה 16",
    "floor_seventeen": "קומה 17",
    "floor_eighteen": "קומה 18",
    "floor_nineteen": "קומה 19",
    "floor_twenty": "קומה 20",
    "floor_twenty_one": "קומה 21",
    "floor_twenty_two": "קומה 22",
    "floor_twenty_three": "קומה 23",
    "floor_twenty_five": "קומה 25",
    "status_toilet_paper_cell_01_-_empty": "תא 01 חסר נייר טואלט",
    "status_toilet_paper_cell_02_-_empty": "תא 02 חסר נייר טואלט",
    "status_toilet_paper_cell_03_-_empty": "תא 03 חסר נייר טואלט",
    "status_toilet_paper_cell_04_-_empty": "תא 04 חסר נייר טואלט",
    "status_toilet_paper_cell_05_-_empty": "תא 05 חסר נייר טואלט",
    "status_toilet_paper_cell_06_-_empty": "תא 06 חסר נייר טואלט",
    "status_toilet_paper_cell_07_-_empty": "תא 07 חסר נייר טואלט",
    "status_toilet_paper_cell_08_-_empty": "תא 08 חסר נייר טואלט",
    "status_toilet_paper_cell_09_-_empty": "תא 09 חסר נייר טואלט",
    "status_toilet_paper_cell_10_-_empty": "תא 10 חסר נייר טואלט",
    "status_toilet_paper_cell_11_-_empty": "תא 11 חסר נייר טואלט",
    "status_toilet_paper_cell_12_-_empty": "תא 12 חסר נייר טואלט",
    "status_toilet_paper_cell_13_-_empty": "תא 13 חסר נייר טואלט",
    "status_toilet_paper_cell_14_-_empty": "תא 14 חסר נייר טואלט",
    "status_toilet_paper_cell_15_-_empty": "תא 15 חסר נייר טואלט",
    "status_toilet_paper_cell_16_-_empty": "תא 16 חסר נייר טואלט",
    "status_toilet_paper_cell_17_-_empty": "תא 17 חסר נייר טואלט",
    "status_toilet_paper_cell_18_-_empty": "תא 18 חסר נייר טואלט",
    "status_toilet_paper_cell_19_-_empty": "תא 19 חסר נייר טואלט",
    "status_toilet_paper_cell_20_-_empty": "תא 20 חסר נייר טואלט",
    "status_toilet_paper_cell_01_-_almost_empty": "תא 01 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_02_-_almost_empty": "תא 02 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_03_-_almost_empty": "תא 03 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_04_-_almost_empty": "תא 04 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_05_-_almost_empty": "תא 05 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_06_-_almost_empty": "תא 06 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_07_-_almost_empty": "תא 07 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_08_-_almost_empty": "תא 08 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_09_-_almost_empty": "תא 09 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_10_-_almost_empty": "תא 10 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_11_-_almost_empty": "תא 11 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_12_-_almost_empty": "תא 12 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_13_-_almost_empty": "תא 13 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_14_-_almost_empty": "תא 14 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_15_-_almost_empty": "תא 15 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_16_-_almost_empty": "תא 16 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_17_-_almost_empty": "תא 17 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_18_-_almost_empty": "תא 18 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_19_-_almost_empty": "תא 19 עומד להיגמר נייר טואלט",
    "status_toilet_paper_cell_20_-_almost_empty": "תא 20 עומד להיגמר נייר טואלט",
    "of": "מ",
    "items": "פריטים",
    "loading_charts": "טוען תרשימים",
    "refresh_the_room": "לרענן את החדר",
    "clean_the_floor": "לנקות את הריצפה",
    "clean_the_toilet": "לנקות את השירותים",
    "refill_soap": "למלא סבון",
    "change_roll": "להחליף גליל",
    "great_job": "עבודה מצוינת",
    "empty_the_trash": "לרוקן את הפח",
    "repair_required": "נדרש תיקון",
    "cleaning": "ניקוי",
    "cleaning_work_plan": "תוכנית עבודה לניקיון",
    "cleaning_work_plan_intro": "משתמש בסטטיסטיקות חדרי משמרת עבור החברה והאתר שמוגדרים בכותרת. ביקורים והגעות נלקחים מהיום היחיד עם מספר הביקורים הגבוה ביותר בטווח התאריכים ומהמשמרות שבמסנן הדשבורד (הגדירו אותם ב-Performance או ב-Analytics אם בלשונית זו אין בקרות זמן וסינון). הזינו ביקורים לניקוי, יעד כוח אדם, עלות לשעה וזמן ניקוי ממוצע בדקות; צרו תוכנית כדי לראות ניקיונות מוצעים לפי חדר וסיכומים.",
    "cleaning_work_plan_default_n": "ביקורים לניקוי",
    "cleaning_work_plan_cleaner_count": "מנקים (אופציונלי)",
    "cleaning_work_plan_avg_minutes": "זמן ניקוי ממוצע (דקות)",
    "cleaning_work_plan_run": "צור תוכנית",
    "cleaning_work_plan_export_csv": "ייצוא לאקסל",
    "cleaning_work_plan_suggested_n": "ביקורים לניקוי",
    "cleaning_work_plan_actual_cleans": "הגעות",
    "cleaning_work_plan_actual_cleans_hint": "סך הגעות מנקים בסטטיסטיקות חדרי משמרת ביום השיא (בתוך הטווח והמסננים שנבחרו).",
    "cleaning_work_plan_suggested_cleans": "ניקיונות מוצעים",
    "cleaning_work_plan_cleaner": "מנקה",
    "cleaning_work_plan_floors": "קומות",
    "cleaning_work_plan_peak_day": "היום הכי עמוס בחודש",
    "cleaning_work_plan_error": "לא ניתן היה ליצור תוכנית עבודה לניקיון",
    "cleaning_work_plan_no_rooms": "לא הוחזרו חדרים עבור אתר זה. בדקו את האתר וטווח התאריכים, או ודאו שחדרים קיימים בפאנל הבקרה.",
    "cleaning_work_plan_need_filter": "בחרו חברה ואתר בכותרת, הגדירו טווח תאריכים (ומשמרות במידת הצורך) ב-Performance או ב-Analytics, ואז נסו שוב.",
    "cleaning_work_plan_settings": "הגדרות תוכנית",
    "cleaning_work_plan_desired_employees": "מספר עובדים רצוי",
    "cleaning_work_plan_cost_per_hour": "עלות לשעה",
    "cleaning_work_plan_estimated_cost_suggested": "עלות משוערת (עומס מוצע)",
    "cleaning_work_plan_estimated_cost_actual": "עלות משוערת (בפועל)",
    "cleaning_work_plan_hours_per_cleaner": "שעות לכל מנקה",
    "cleaning_work_plan_metric_title": "מדדים",
    "cleaning_work_plan_metric_avg_cleaning_min": "זמן ניקוי ממוצע (דקות)",
    "cleaning_work_plan_metric_total_arrivals": "סך הגעות",
    "cleaning_work_plan_metric_total_cleaning_min": "סך זמן ניקוי (דקות)",
    "cleaning_work_plan_metric_total_cleaning_hours": "סך זמן ניקוי (שעות)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "שעות לכל מנקה",
    "cleaning_work_plan_metric_num_cleaners": "מספר מנקים",
    "cleaning_work_plan_summary": "סיכום",
    "cleaning_work_plan_summary_peak_note": "ביקורים, הגעות וניקיונות מוצעים משתמשים באותם כללי סטטיסטיקות חדרי משמרת כמו ב-Analytics (כולל איחוד הגעות). הם מחושבים עבור יום השיא - יום הלוח עם מספר הביקורים הגבוה ביותר בטווח המסנן. כלולים רק חדרים שחושבו, כמו בתצוגת overview ללא סינון חדר.",
    "cleaning_work_plan_summary_filter_period": "תקופת סינון",
    "cleaning_work_plan_summary_total_visits": "סה\"כ ביקורים",
    "cleaning_work_plan_summary_total_arrivals": "סה\"כ הגעות",
    "cleaning_work_plan_summary_employees_in_site": "מנקים פעילים",
    "cleaning_work_plan_summary_shift_working_hours": "שעות משמרת",
    "cleaning_work_plan_hours_unit": "שע׳",
    "cleaning_work_plan_rooms_table": "חדרים",
    "cleaning_work_plan_cleaners_table": "הקצאת מנקים מומלצת",
    "cleaning_work_plan_search_rooms": "חיפוש חדרים",
    "cleaning_work_plan_total_minutes": "סך דקות",
    "cleaning_work_plan_actual_total_minutes": "סך דקות בפועל",
    "cleaning_work_plan_actual_total_minutes_hint": "הגעות מנקים שנרשמו בסטטיסטיקות חדרי משמרת ביום השיא (בטווח שנבחר), כפול ממוצע הדקות שלכם לניקוי.",
    "cleaning_work_plan_suggested_total_minutes": "סך דקות מוצעות",
    "cleaning_work_plan_suggested_room_minutes": "דקות ניקוי מוצעות",
    "cleaning_work_plan_actual_room_minutes": "דקות ניקוי בפועל",
    "cleaning_work_plan_cleaner_suggested_minutes": "דקות מוצעות",
    "cleaning_work_plan_cleaner_actual_minutes": "דקות בפועל",
    "cleaning_work_plan_period": "תקופה",
    "cleaning_work_plan_room_count": "מספר חדרים",
    "cleaning_work_plan_cleaners_working_in_site": "מנקים פעילים באתר (אנשי קשר)",
    "cleaning_work_plan_cleaners_connection_table": "מנקים לפי חדרים",
    "cleaning_work_plan_connected_rooms_count": "חדרים",
    "cleaning_work_plan_connected_floor_count": "מספר קומות",
    "cleaning_work_plan_connected_floors_list": "קומות",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "יחס מבקר / כניסת ניקוי",
    "cleaning_work_plan_performance_comparison_table": "השוואת ביצועים",
    "cleaning_work_plan_performance_comparison_empty": "טענו נתוני קישור מנקים כדי לראות את השורות.",
    "cleaning_work_plan_performance_col_index": "מדד",
    "cleaning_work_plan_performance_existing_plan": "תוכנית עבודה קיימת",
    "cleaning_work_plan_performance_recommended_plan": "תוכנית מומלצת Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "מספר עובדים",
    "cleaning_work_plan_perf_working_hours_per_employee": "שעות עבודה לעובד",
    "cleaning_work_plan_perf_total_working_hours": "סה״כ שעות עבודה",
    "cleaning_work_plan_perf_total_cleaning_hours": "סה״כ שעות ניקוי",
    "cleaning_work_plan_perf_daily_cost": "עלות יומית",
    "cleaning_work_plan_perf_total_cleaning_visits": "סה״כ ביקורי ניקוי",
    "cleaning_work_plan_perf_busiest_area_visits": "אזור העבודה העמוס ביותר — ביקורים",
    "cleaning_work_plan_perf_cleaning_to_busiest": "ביקורי ניקוי לאזור העמוס ביותר",
    "cleaning_work_plan_perf_max_cleaning_ratio": "יחס ניקוי מקסימלי",
    "cleaning_work_plan_perf_least_busy_visits": "אזור העבודה הפחות עמוס — ביקורים",
    "cleaning_work_plan_perf_cleaning_to_least": "ביקורי ניקוי לאזור הפחות עמוס",
    "cleaning_work_plan_perf_min_cleaning_ratio": "יחס ניקוי מינימלי",
    "cleaning_work_plan_ai_allocate": "הקצאה באמצעות AI",
    "cleaning_work_plan_ai_allocation_result": "תוצאת הקצאה מבוססת AI",
    "cleaning_work_plan_ai_allocation_loading": "מייצר הקצאה באמצעות AI...",
    "cleaning_work_plan_ai_allocation_error": "נכשל בהפקת הקצאה באמצעות AI. אנא נסה שוב.",
    "cleaning_work_plan_ai_invalid_employees": "אנא הגדר מספר עובדים רצוי תקין.",
    "cleaning_work_plan_ai_status_elapsed": "זמן שחלף: {s} שנ׳",
    "cleaning_work_plan_ai_status_hint": "השרת מריץ מספר שלבי AI ברצף (תוכנית ראשונית, גיאוגרפיה, איזון ביקורים, ואז פלט סופי). זה עלול לקחת דקה עד שתיים—אנא השאר את העמוד פתוח.",
    "cleaning_work_plan_ai_status_step_1": "שלב 1 — טיוטת הקצאה ראשונית מנתוני חדרים וביקורים…",
    "cleaning_work_plan_ai_status_step_2": "שלב 2 — שיפור גיאוגרפיה (קיבוץ קומות ובניינים סמוכים)…",
    "cleaning_work_plan_ai_status_step_3": "שלב 3 — איזון ביקורים יומיים בין מנקים…",
    "cleaning_work_plan_ai_status_step_4": "שלב 4 — יצירת ההקצאה המובנית…",
    "cleaning_work_plan_ai_status_step_5": "שלב 5 — אימות וחישוב מדדים סופיים…",
    "cleaning_work_plan_ai_cleaner_number": "מנקה #",
    "cleaning_work_plan_room_minutes": "דקות ניקוי",
    "cleaning_work_plan_assigned_cleaner": "מנקה משויך",
    "cleaning_work_plan_summary_cleaners": "מנקים בתוכנית",
    "cleaning_work_plan_summary_avg_minutes": "דקות ממוצעות / ניקוי",
    "cleaning_work_plan_suggested_hours": "סך שעות מוצעות",
    "cleaning_work_plan_actual_hours": "סך שעות בפועל",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "ממוצע דקות מוצעות / מנקה",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "ממוצע דקות בפועל / מנקה",
    "cleaning_work_plan_guidelines_title": "הנחיות אופטימיזציה",
    "cleaning_work_plan_guidelines_intro": "כלי זה פועל לפי אותן מטרות של אופטימיזציה ידנית לתוכנית ניקיון: עומס עבודה מנתוני ביקורים, זמן ממוצע הדקות לניקוי, וכוח אדם שמאזן עבודה תוך שמירה על היגיון גיאוגרפי של קומות.",
    "cleaning_work_plan_guidelines_b1": "ביקורים לניקוי (ברירת מחדל 50) תואם כלל נפוץ בסגנון 1:50: מספר פעולות מוצע לחדר הוא בקירוב ביקורים חלקי ביקורים לניקוי (בעיגול כלפי מעלה). ביקורים והגעות נלקחים מהיום העמוס ביותר בטווח התאריכים שנבחר.",
    "cleaning_work_plan_guidelines_b2": "כאשר מגדירים מספר מנקים, כל קומת בניין היא קבוצה. הקומות מסודרות לפי בניין ומספר קומה, ואז מתחלקות לבלוקים רציפים בין מנקים כך שהניקיונות המוצעים יהיו מאוזנים וקומות סמוכות יישארו בדרך כלל אצל אותו מנקה.",
    "cleaning_work_plan_guidelines_b3": "כל השירותים באותה קומת בניין נשארים אצל אותו מנקה, כך שחדרי גברים ונשים באותה קומה לא יפוצלו בין מנקים שונים (כל עוד ערך הקומה זהה בפאנל הבקרה).",
    "cleaning_work_plan_guidelines_b4": "ממוצע הדקות לניקוי משפיע על סך הדקות והשעות בפועל ובמוצע, וכן על ממוצע הדקות למנקה. חישובי בפועל משתמשים בהגעות מנקים מתועדות כפול הממוצע שלכם; חישובים מוצעים משתמשים בניקיונות מחושבים כפול הממוצע שלכם.",
    "cleaning_work_plan_guidelines_b5": "השתמשו בייצוא CSV אם תרצו לחדד את ההקצאה במקום אחר (לדוגמה, כדי לשפר עוד את איזון הביקורים).",
    "cleaning_performed": "בוצע ניקיון",
  },
  pt: {
    "cleaned_floor": "chão limpo",
    "cleaned_toilet": "banheiro limp",
    "cleaned_shower": "chuveiro limpo",
    "cleaned_sink": "pia limpa",
    "cleaned_mirror": "espelho limpo",
    "cleaned_stainless_steel": "peças de inox limpas",
    "bad_smell": "mal cheiro",
    "dirty_floor": "chão sujo",
    "dirty_lavatory_seat": "assento do vaso sanitário sujo",
    "dirty_shower": "chuveiro sujo",
    "dirty_sink": "pia suja",
    "dirty_mirror": "espelho sujo",
    "dirty_stainless_steel": "peças de inox sujas",
    "missing_paper_towel": "sem papel toalha",
    "missing_soap": "sem sabão",
    "missing_toilet_paper": "sem papel higiênico",
    "problem_shower": "chuveiro com problema",
    "problem_sink": "pia com problema",
    "problem_mirror": "espelho com problema",
    "problem_stainless_steel": "peças de inox com problema",
    "problem_blockage": "entupimento",
    "problem_door": "porta com problema",
    "problem_fluid_taps": "torneira sem água",
    "problem_lightning": "iluminação com problema",
    "problem_broken_toilet": "vaso sanitário quebrado",
    "fixed_shower": "chuveuiro consertado",
    "fixed_sink": "pia consertada",
    "fixed_mirror": "espelho consertado",
    "fixed_stainless_steel": "peças de inox consertadas",
    "fixed_blockage": "entupimento consertado",
    "fixed_door": "porta consertada",
    "fixed_fluid_taps": "torneira consertada",
    "fixed_lightning": "iluminação consertada",
    "fixed_broken_toilet": "vaso sanitário consertado",
    "very_good": "muito bom",
    "excellent": "excelente",
    "good": "bom",
    "like": "gostei",
    "needs_improvement": "necessita melhorias",
    "not_good": "não é bom",
    "supervise": "supervisionar",
    "maintenance": "manutenção",
    "cleaner": "funcionário",
    "tag_cleaner": "tag do funcionário",
    "zone_is_clean": "área esta limpa",
    "zone_is_dirty": "área esta suja",
    "cleaner_arrived": "funcionário chegou",
    "start_clean_zone": "inicie a zona limpa",
    "counter": "contador",
    "counter_men": "contador masculino",
    "counter_woman": "contador feminino",
    "counter_handycap": "contados pcd",
    "full_garbage_can": "lata de lixo cheia",
    "maintenance_fixed": "manutenção realizada",
    "maintenance_problem": "problema de manutenção",
    "problem_soap_dispenser": "dispenser de sabão com problema",
    "problem_paper_dispenser": "dispenser de papel com problema",
    "end_clean_zone": "zona limpa final",
    "status_toilet_paper": "status do papel higiénico",
    "status_hend_paper": "status papel toalha",
    "fixed": "fixo",
    "status_soap": "status sabão",
    "status_garbage_can": "status lata de lixo",
    "general_cleaning": "limpeza geral",
    "coffee_tea": "café e chã",
    "water_bar": "água e bebidas",
    "disposable_dishes": "pratos descartáveis",
    "head_coverage": "cobertura de cabeça",
    "something_else": "algo mais",
    "missing_clothing": "roupas desaparecida",
    "maintenance_link": "ligação de manutenção",
    "problem_maintenance": "manutenção",
    "supervise_link": "supervisionar",
    "cleaner_link": "funcionário chegou",
    "room_men+link": "homens em todo o quarto adicional",
    "room_men-link": "homens em todo o negativo adicional",
    "room_women+link": "mulheres em todo o quarto adicional",
    "room_women-link": "mulheres em todo o negativo quarto",
    "hebrew": "hebraico",
    "español": "español",
    "français": "français",
    "english": "inglês",
    "русский": "русский",
    "italiano": "italiano",
    "አማርኛ": "አማርኛ",
    "português": "português",
    "arabic": "árabe",
    "partial_information": "informações parciais",
    "professionalism": "profissionalismo",
    "the_attitude_of_the_representative": "a atitude do representante",
    "waiting_time_for_service": "tempo de espera para o serviço",
    "other_aspect_of_service": "outro aspecto do serviço",
    "language_of_the_service": "linguagem do serviço",
    "procedure_for_making_an_appointment": "procedimento para fazer uma nomeação",
    "physical_conditions": "condições físicas",
    "found_another": "encontrou outro",
    "found_similar": "encontrados similares",
    "did_not_find": "não encontrou",
    "found": "encontrado",
    "need_improved": "necessita melhorias",
    "liked": "apreciado",
    "pleasant": "prazeroso",
    "eilat_resident": "residente eilat",
    "once_a_week": "uma vez por semana",
    "once_a_month": "uma vez por mês",
    "twice_a_year": "duas vezes por ano",
    "once_a_year": "uma vez por ano",
    "friend": "amigo",
    "newspaper": "jornal",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "aspirador de pó",
    "gaming_consoles": "video game",
    "laptop": "laptop",
    "cellular": "celular",
    "shop": "fazer compras",
    "restaurant_complex_cleaning": "restaurante de limpeza complexo",
    "dining_room": "sala de jantar",
    "food_variety": "variedade de alimentos",
    "quality_of_the_food": "qualidade dos alimentos",
    "amount_of_the_food": "quantidade de alimentos",
    "quality_of_cooking": "qualidade do cozinheiro",
    "side_courses": "acompanhamentos",
    "meat": "eu no",
    "desserts": "sobremesas",
    "vegetarian": "vegetariano",
    "salad_bar": "buffet de salada",
    "main_courses": "prato principal",
    "service": "serviço",
    "dining_room_cleanliness": "limpeza sala de jantar",
    "plates_and_cutlery_cleanliness": "limpeza pratos e talheres",
    "product_inventory": "estoque de produtos",
    "furnishers": "mobiliario",
    "toilets": "banheiros",
    "problem_coffee_machine": "problema com a maquina de café",
    "problem_water_bar": "problema agua e bebidas",
    "dirty_stairs": "escadas sujas",
    "toiletries": "artigos de higiene pessoal",
    "fixed_soap_dispenser": "dispenser de sabão consertado",
    "fixed_paper_dispenser": "dispenser de papel consertado",
    "fixed_coffee_machine": "máquina de café consertada",
    "fixed_water_bar": "água e bebidas consertado",
    "problem_urinals": "problema mictórios",
    "blockage_toilet": "vaso sanitário entupido",
    "appliance_problem": "problema eletrodoméstico",
    "problem_broken_door": "problema porta quebrada",
    "problem_door_lock": "problema fechadura quebrada",
    "problem_broken_toilet_seat": "problema quebrado assento do vaso sanitário",
    "problem_broken_niagara": "problema niagara quebrado",
    " broken_hand_paper_dispenser_hand_dryer": "dispenser de papel toalha e secador com problema",
    "rug": "tapete",
    "tables": "mesas",
    "kitchen": "cozinha",
    "air_condition": "ar condicionado",
    "dirty_urinals": "mictório sujo",
    "hand_dryer": "secador de mãos",
    "non_sticky_carpet": "tapete antiderrapante",
    "problem_bad_smell": "problema mal cheiro",
    "problem_broken_toilet_handle": "problema alça do banheiro",
    "problem_handle_door": "problema maçaneta da porta",
    "call_cleaner": "chamar funcionário",
    "wall_painting": "pintura da parede",
    "missing_paper": "faltando papel",
    "clean_surface": "superficie limpa",
    "problem_right_elevator": "problema no elevador direito",
    "problem_left_elevator": "problema no elevador esquerdo",
    "missing_hand_sanitizer": "faltando desinfetante para as mãos",
    "problem_sink_blockage": "pia entupida",
    "electric_problem": "problema elétrico",
    "missing_coffe_tea": "faltando café / chá",
    "problem_air_condition": "problema ar condicionado",
    "dishwashing": "lavar pratos",
    "kitchen_cleanliness": "cozinha limpeza",
    "weekly_cleaning": "limpeza semanal",
    "general_arrangement": "arranjo geral",
    "meeting_room": "sala de reuniões",
    "refrigerator": "frigorífico",
    "kitchen_supplies": "material de cozinha",
    "toilet_services": "serviços sanitários",
    "carousel_door": "porta carrossel",
    "desk": "escrivaninha",
    "compressor": "compressor",
    "compressor_rails": "rails compressor",
    "compressor_drainage": "drenagem compressor",
    "dust": "pó",
    "door": "porta",
    "scotch": "escocês",
    "food": "comida",
    "room_conditions": "condições da sala",
    "kindness_sensitivity": "amabilidade e sensibilidade",
    "explain_process": "explicar o processo",
    "personal_attention": "atenção pessoal",
    "service_problem": "serviço problem",
    "welcome_you": "recebê-lo",
    "invoice_submitted": "factura apresentada",
    "thank_you_bought": "thank you adquiridos",
    "problem_seller": "problema vendedor",
    "lapel_pin": "alfinete de lapela",
    "proper_performance": "desempenho adequado",
    "name_tag": "crachá",
    "operational": "operacional",
    "app_revealed": "app revelou",
    "register_load": "registo de carga",
    "visibility_problem": "problema de visibilidade",
    "clean_storefront": "vitrine limpa",
    "clean_garbage": "lixo limpo",
    "clean_tables_chairs": "mesas e cadeiras limpas",
    "clean_shop_floor": "chão de fábrica limpa",
    "product_show": "vista do produto",
    "refrigerators_show": "ver de refrigeradores",
    "coffee_accessories": "acessórios de café e equipado",
    "cleanliness": "limpeza",
    "convenience_scheduling_appointments": "conveniência de agendamento de compromissos",
    "waiting_haircut": "esperando por um corte de cabelo",
    "courtesy_books": "cortesia dos livros",
    "books_professionalism": "o profissionalismo dos livros",
    "received_time": "me recebeu a tempo",
    "dnot_appointment": "eu não marcasse uma consulta",
    "an_appointment": "eu fiz uma consulta",
    "tasty": "saboroso",
    "courtesy_service": "cortesia do serviço",
    "overall_experience": "a experiência geral",
    "not_clean": "não limpo",
    "diningroom_not_clean": "a sala de jantar não é limpa",
    "unclean_dishes": "pratos impuros",
    "so-so": "mais ou menos",
    "not_tasty": "não é saboroso",
    "kind": "gentil",
    "not_kind": "nada gentil",
    "clean": "limpar",
    "hairdresser": "cabeleireiro",
    "wrong_price": "preço errado",
    "produc_has_expired": "produto expirou",
    "missing_item": "item ausente",
    "item_is_faulty_in_the_machine": "item é com defeito na máquina",
    "machine_cleaning": "limpeza da máquina.",
    "improper_temperature": "temperatura imprópria",
    "green": "verde",
    "orange": "laranja",
    "red": "vermelho",
    "yellow": "amarelo",
    "red not prob": "vermelho",
    "professional": "loading...",
    "unprofessional": "loading...",
    "delicacies": "delicadeiras.",
    "sandwiches": "sanduíches",
    "vegetables": "legumes",
    "fruits": "frutas",
    "salads": "saladas.",
    "milk": "leite",
    "room_link": "link da sala",
    "floor_link": "ligação chão",
    "services": "serviços",
    "check_list": "lista de controle",
    "lighting_problem_lobby": "lobby de problemas de iluminação",
    "lighting_problem_garbage_room": "quarto de lixo do problema de iluminação",
    "lighting_problem_stairwell": "problema de iluminação stairwell.",
    "problem_elevator_1": "elevador do problema 1.",
    "problem_elevator_2": "elevador problema 2.",
    "problem_elevator_3": "elevador problema 3.",
    "problem_elevator_4": "elevador problema 4.",
    "problem_elevator_5": "elevador problema 5.",
    "problem_elevator_6": "elevador problema 6.",
    "problem_elevator_7": "elevador problema 7.",
    "problem_elevator_8": "elevador do problema 8.",
    "problem_elevator_9": "elevador do problema 9.",
    "problem_elevator_10": "elevador de problemas 10.",
    "stuck_item": "item preso",
    "spoiling_product": "estragar produto",
    "machine_malfunction": "mau funcionamento da máquina",
    "unreadable_product": "produto ilegível",
    "i_am_satisfied": "eu estou satisfeito",
    "beverage": "bebida",
    "program_malfunction": "mau funcionamento do programa",
    "machine_1": "máquina 1.",
    "machine_2": "máquina 2.",
    "machine_3": "máquina 3.",
    "machine_4": "máquina 4.",
    "program malfunction 1": "Malfunction do programa 1.",
    "program malfunction 2": "Programa de mau funcionamento 2.",
    "program malfunction 3": "Programa de mau funcionamento 3.",
    "program malfunction 4": "Programa de mau funcionamento 4.",
    "fish": "peixe",
    "chicken": "frango",
    "full_dining_room": "sala de jantar completa",
    "missing_amount": "quantidade ausente",
    "missing_trays": "bandejas ausentes",
    "dirty_floor_g1": "piso g1 sujo",
    "dirty_floor_g2": "piso g2 sujo",
    "dirty_floor_g3": "piso g3 sujo",
    "dirty_floor_g4": "piso g4 sujo",
    "dirty_floor_g5": "piso g5 sujo",
    "dirty_floor_eo": "piso eo sujo",
    "dirty_floor_ceo": "piso ceo sujo",
    "dirty_floor_storage": "armazenamento chão sujo",
    "dirty_floor_inflorescence": "piso inflorescência sujo",
    "operating_instructions": "instruções de operação",
    "general": "em geral",
    "connection_problem": "problema de conexão",
    "lighting": "iluminação",
    "not _fixed": "não consertado",
    "cleaning_needed": "limpeza necessária",
    "missing_milk": "leite em falta",
    "no_sugar_coffee": "sem açúcar / café",
    "missing_tools": "ferramentas faltando",
    "coffee_water_machine": "café / máquina de água",
    "appliances": "eletrodomésticos",
    "products": "produtos",
    "broken_chair": "móveis quebrados",
    "broken_cabinet": "armário quebrado",
    "micro": "micro",
    "toaster": "torradeira",
    "clogged_sink_malfunction": "entupidos mau funcionamento pia",
    "coffee_cooling_malfunction": "café mau funcionamento de refrigeração",
    "no_coffee_beans": "não há grãos de café",
    "machine_failure": "falha da máquina",
    "that_dirty": "isso suja",
    "dirty_refrigerator": "geladeira suja",
    "dirty_tables": "mesas sujas",
    "plates": "pratos",
    "silver_spoon": "colher de prata",
    "cold_drinks_cups": "frio bebe copos",
    "hot_drink_cups": "copos de bebidas quentes",
    "a_dripping_faucet": "loading...",
    "disposable dishes": "pratos descartáveis",
    "problem_ coffee_water_machine": "café / máquina de água",
    "problem_micro": "micro",
    "problem_toaster": "torradeira",
    "problem_machine_failure": "falha da máquina",
    "problem refrigerator": "frigorífico",
    "no_sugar/coffee": "sem açúcar / café",
    "missing_dishes": "ferramentas faltando",
    "coffee/water_machine": "café / máquina de água",
    "coffee_machine_door_open": "porta da máquina de café aberta",
    "coffee_machine_door_close": "porta de café perto da máquina",
    "coffee_machine_bin_full": "escaninha de máquina de café",
    "coffee_machine_bin_empty": "máquina de café lixo vazio",
    "coffee_machine_coffee_full": "café café café cheio",
    "coffee_machine_coffee_empty": "café máquina de café vazio",
    "coffee_machine_water_tank_empty": "tanque de água de máquina de café vazio",
    "coffee_machine_ water_tank_full": "máquina de café watertank completo",
    "coffee_machine_milk_cleaning_not_performed": "limpeza de leite de máquina de café não realizada",
    "coffee_machine _milk_cleaning_performed": "limpeza de leite de máquina de café realizada",
    "coffee_machine_head_cleaning_not_performed": "limpeza da cabeça da máquina de café não realizada",
    "coffee_machine_head_ cleaning_performed": "limpeza da cabeça da máquina de café realizada",
    "coffee_machine_descaling_not_performed": "descalcificação da máquina de café não realizada",
    "coffee_machine_descaling_performed": "descalificação da máquina de café realizada",
    "floor_one": "andar 1",
    "floor_two": "andar 2",
    "floor_three": "andar 3",
    "floor_four": "andar 4",
    "floor_five": "andar 5",
    "floor_six": "andar 6",
    "floor_seven": "andar 7",
    "floor_eight": "andar 8",
    "floor_nine": "andar 9",
    "floor_ten": "andar 10",
    "floor_eleven": "andar 11",
    "floor_twelve": "andar 12",
    "floor_thirteen": "andar 13",
    "floor_fourteen": "andar 14",
    "floor_fifteen": "andar 15",
    "floor_sixteen": "andar 16",
    "floor_seventeen": "andar 17",
    "floor_eighteen": "andar 18",
    "floor_nineteen": "andar 19",
    "floor_twenty": "andar 20",
    "floor_twenty_one": "andar 21",
    "floor_twenty_two": "andar 22",
    "floor_twenty_three": "andar 23",
    "floor_twenty_four": "andar 24",
    "floor_twenty_five": "andar 25",
    "status_toilet_paper_cell_01_-_empty": "Status do papel higiênico da célula 01 - vazio",
    "status_toilet_paper_cell_02_-_empty": "Status do papel higiênico da célula 02 - vazio",
    "status_toilet_paper_cell_03_-_empty": "Status do papel higiênico da célula 03 - vazio",
    "status_toilet_paper_cell_04_-_empty": "Status do papel higiênico da célula 04 - vazio",
    "status_toilet_paper_cell_05_-_empty": "Status do papel higiênico da célula 05 - vazio",
    "status_toilet_paper_cell_06_-_empty": "Status do papel higiênico da célula 06 - vazio",
    "status_toilet_paper_cell_07_-_empty": "Status do papel higiênico da célula 07 - vazio",
    "status_toilet_paper_cell_08_-_empty": "Status do papel higiênico da célula 08 - vazio",
    "status_toilet_paper_cell_09_-_empty": "Status do papel higiênico da célula 09 - vazio",
    "status_toilet_paper_cell_10_-_empty": "Status do papel higiênico da célula 10 - vazio",
    "status_toilet_paper_cell_11_-_empty": "Status do papel higiênico da célula 11 - vazio",
    "status_toilet_paper_cell_12_-_empty": "Status do papel higiênico da célula 12 - vazio",
    "status_toilet_paper_cell_13_-_empty": "Status do papel higiênico da célula 13 - vazio",
    "status_toilet_paper_cell_14_-_empty": "Status do papel higiênico da célula 14 - vazio",
    "status_toilet_paper_cell_15_-_empty": "Status do papel higiênico da célula 15 - vazio",
    "status_toilet_paper_cell_16_-_empty": "Status do papel higiênico da célula 16 - vazio",
    "status_toilet_paper_cell_17_-_empty": "Status do papel higiênico da célula 17 - vazio",
    "status_toilet_paper_cell_18_-_empty": "Status do papel higiênico da célula 18 - vazio",
    "status_toilet_paper_cell_19_-_empty": "Status do papel higiênico da célula 19 - vazio",
    "status_toilet_paper_cell_20_-_empty": "Status do papel higiênico da célula 20 - vazio",
    "status_toilet_paper_cell_01_-_almost_empty": "Status do papel higiênico da célula 01 - quase vazio",
    "status_toilet_paper_cell_02_-_almost_empty": "Status do papel higiênico da célula 02 - quase vazio",
    "status_toilet_paper_cell_03_-_almost_empty": "Status do papel higiênico da célula 03 - quase vazio",
    "status_toilet_paper_cell_04_-_almost_empty": "Status do papel higiênico da célula 04 - quase vazio",
    "status_toilet_paper_cell_05_-_almost_empty": "Status do papel higiênico da célula 05 - quase vazio",
    "status_toilet_paper_cell_06_-_almost_empty": "Status do papel higiênico da célula 06 - quase vazio",
    "status_toilet_paper_cell_07_-_almost_empty": "Status do papel higiênico da célula 07 - quase vazio",
    "status_toilet_paper_cell_08_-_almost_empty": "Status do papel higiênico da célula 08 - quase vazio",
    "status_toilet_paper_cell_09_-_almost_empty": "Status do papel higiênico da célula 09 - quase vazio",
    "status_toilet_paper_cell_10_-_almost_empty": "Status do papel higiênico da célula 10 - quase vazio",
    "status_toilet_paper_cell_11_-_almost_empty": "Status do papel higiênico da célula 11 - quase vazio",
    "status_toilet_paper_cell_12_-_almost_empty": "Status do papel higiênico da célula 12 - quase vazio",
    "status_toilet_paper_cell_13_-_almost_empty": "Status do papel higiênico da célula 13 - quase vazio",
    "status_toilet_paper_cell_14_-_almost_empty": "Status do papel higiênico da célula 14 - quase vazio",
    "status_toilet_paper_cell_15_-_almost_empty": "Status do papel higiênico da célula 15 - quase vazio",
    "status_toilet_paper_cell_16_-_almost_empty": "Status do papel higiênico da célula 16 - quase vazio",
    "status_toilet_paper_cell_17_-_almost_empty": "Status do papel higiênico da célula 17 - quase vazio",
    "status_toilet_paper_cell_18_-_almost_empty": "Status do papel higiênico da célula 18 - quase vazio",
    "status_toilet_paper_cell_19_-_almost_empty": "Status do papel higiênico da célula 19 - quase vazio",
    "status_toilet_paper_cell_20_-_almost_empty": "Status do papel higiênico da célula 20 - quase vazio",
    "of": "de",
    "items": "itens",
    "loading_charts": "Carregando gráficos",
    "refresh_the_room": "Aromatizar o Ambiente",
    "clean_the_floor": "Limpar o chão",
    "clean_the_toilet": "Higienizar o Vaso",
    "refill_soap": "Repor o sabão",
    "change_roll": "Trocar o rolo de papel higiênico",
    "great_job": "Ótimo trabalho",
    "empty_the_trash": "Esvaziar a lixeira",
    "repair_required": "Necessita reparo",
    "cleaning": "Limpeza",
    "cleaning_work_plan": "Plano de trabalho de limpeza",
    "cleaning_work_plan_intro": "Usa estatísticas de salas por turno para a empresa e o site do cabeçalho. Visitas e chegadas vêm do único dia com mais visitas no período selecionado e dos turnos definidos no filtro do dashboard (defina-os em Performance ou Analytics se esta aba ocultar os controles de tempo e filtro). Informe visitas por limpeza, meta de equipe, custo por hora e tempo médio de limpeza em minutos; gere o plano para ver limpezas sugeridas por ambiente e totais no resumo.",
    "cleaning_work_plan_default_n": "Visitas por limpeza",
    "cleaning_work_plan_cleaner_count": "Limpadores (opcional)",
    "cleaning_work_plan_avg_minutes": "Tempo médio de limpeza (min)",
    "cleaning_work_plan_run": "Gerar plano",
    "cleaning_work_plan_export_csv": "Exportar Excel",
    "cleaning_work_plan_suggested_n": "Visitas por limpeza",
    "cleaning_work_plan_actual_cleans": "Chegadas",
    "cleaning_work_plan_actual_cleans_hint": "Total de chegadas de limpadores nas estatísticas de salas por turno no dia de pico (dentro do período e filtros selecionados).",
    "cleaning_work_plan_suggested_cleans": "Limpezas sugeridas",
    "cleaning_work_plan_cleaner": "Limpador",
    "cleaning_work_plan_floors": "Andares",
    "cleaning_work_plan_peak_day": "Dia de pico",
    "cleaning_work_plan_error": "Não foi possível gerar o plano de trabalho de limpeza",
    "cleaning_work_plan_no_rooms": "Nenhum ambiente retornado para este site. Verifique o site e o período de datas ou confirme se os ambientes existem no painel de controle.",
    "cleaning_work_plan_need_filter": "Selecione empresa e site no cabeçalho, defina o período (e turnos, se necessário) em Performance ou Analytics e tente novamente.",
    "cleaning_work_plan_settings": "Configurações do plano",
    "cleaning_work_plan_desired_employees": "Número desejado de funcionários",
    "cleaning_work_plan_cost_per_hour": "Custo por hora",
    "cleaning_work_plan_estimated_cost_suggested": "Custo estimado (carga sugerida)",
    "cleaning_work_plan_estimated_cost_actual": "Custo estimado (carga real)",
    "cleaning_work_plan_hours_per_cleaner": "Horas por limpador",
    "cleaning_work_plan_metric_title": "Métricas",
    "cleaning_work_plan_metric_avg_cleaning_min": "Tempo médio de limpeza (min)",
    "cleaning_work_plan_metric_total_arrivals": "Total de chegadas",
    "cleaning_work_plan_metric_total_cleaning_min": "Tempo total de limpeza (min)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Tempo total de limpeza (horas)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Horas por limpador",
    "cleaning_work_plan_metric_num_cleaners": "Número de limpadores",
    "cleaning_work_plan_summary": "Resumo",
    "cleaning_work_plan_summary_peak_note": "Visitas, chegadas e limpezas sugeridas usam as mesmas regras de estatísticas por turno do Analytics (incluindo agregação de chegadas). Os números são do dia de pico - o dia calendário com mais visitas no período filtrado. Apenas ambientes calculados são incluídos.",
    "cleaning_work_plan_summary_filter_period": "Período do filtro",
    "cleaning_work_plan_summary_total_visits": "Total de visitas",
    "cleaning_work_plan_summary_total_arrivals": "Total de chegadas",
    "cleaning_work_plan_summary_employees_in_site": "Funcionários no local",
    "cleaning_work_plan_summary_shift_working_hours": "Horas de turno",
    "cleaning_work_plan_hours_unit": "h",
    "cleaning_work_plan_rooms_table": "Ambientes",
    "cleaning_work_plan_cleaners_table": "Alocação recomendada de limpadores",
    "cleaning_work_plan_search_rooms": "Buscar ambientes",
    "cleaning_work_plan_total_minutes": "Minutos totais",
    "cleaning_work_plan_actual_total_minutes": "Minutos totais reais",
    "cleaning_work_plan_actual_total_minutes_hint": "Chegadas registradas de limpadores nas estatísticas por turno no dia de pico (dentro do período selecionado), multiplicadas pelos seus minutos médios por limpeza.",
    "cleaning_work_plan_suggested_total_minutes": "Minutos totais sugeridos",
    "cleaning_work_plan_suggested_room_minutes": "Minutos sugeridos de limpeza",
    "cleaning_work_plan_actual_room_minutes": "Minutos reais de limpeza",
    "cleaning_work_plan_cleaner_suggested_minutes": "Min. sugeridos",
    "cleaning_work_plan_cleaner_actual_minutes": "Min. reais",
    "cleaning_work_plan_period": "Período",
    "cleaning_work_plan_room_count": "Quantidade de ambientes",
    "cleaning_work_plan_cleaners_working_in_site": "Limpadores no site (contatos do app)",
    "cleaning_work_plan_cleaners_connection_table": "Limpadores por ambientes",
    "cleaning_work_plan_connected_rooms_count": "Ambientes",
    "cleaning_work_plan_connected_floor_count": "Número de andares",
    "cleaning_work_plan_connected_floors_list": "Andares",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Razão visitante / entrada de limpeza",
    "cleaning_work_plan_performance_comparison_table": "Comparação de desempenho",
    "cleaning_work_plan_performance_comparison_empty": "Carregue os dados de vínculo dos limpadores para ver as linhas.",
    "cleaning_work_plan_performance_col_index": "Índice",
    "cleaning_work_plan_performance_existing_plan": "Plano de trabalho existente",
    "cleaning_work_plan_performance_recommended_plan": "Plano recomendado Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Número de funcionários",
    "cleaning_work_plan_perf_working_hours_per_employee": "Horas de trabalho por funcionário",
    "cleaning_work_plan_perf_total_working_hours": "Total de horas de trabalho",
    "cleaning_work_plan_perf_total_cleaning_hours": "Total de horas de limpeza",
    "cleaning_work_plan_perf_daily_cost": "Custo diário",
    "cleaning_work_plan_perf_total_cleaning_visits": "Total de visitas de limpeza",
    "cleaning_work_plan_perf_busiest_area_visits": "Área mais movimentada — visitas",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Visitas de limpeza à área mais movimentada",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Razão máxima de limpeza",
    "cleaning_work_plan_perf_least_busy_visits": "Área menos movimentada — visitas",
    "cleaning_work_plan_perf_cleaning_to_least": "Visitas de limpeza à área menos movimentada",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Razão mínima de limpeza",
    "cleaning_work_plan_ai_allocate": "Alocação por IA",
    "cleaning_work_plan_ai_allocation_result": "Resultado da Alocação por IA",
    "cleaning_work_plan_ai_allocation_loading": "Gerando alocação por IA...",
    "cleaning_work_plan_ai_allocation_error": "Falha ao gerar alocação por IA. Por favor, tente novamente.",
    "cleaning_work_plan_ai_invalid_employees": "Por favor, defina um número válido de funcionários desejados.",
    "cleaning_work_plan_ai_status_elapsed": "Decorridos: {s}s",
    "cleaning_work_plan_ai_status_hint": "O servidor executa várias etapas de IA em sequência (plano inicial, geografia, equilíbrio de visitas e saída final). Pode levar um a dois minutos—mantenha esta página aberta.",
    "cleaning_work_plan_ai_status_step_1": "Etapa 1 — rascunhando atribuição inicial a partir dos dados de salas e visitas…",
    "cleaning_work_plan_ai_status_step_2": "Etapa 2 — refinando geografia (agrupando andares e edifícios próximos)…",
    "cleaning_work_plan_ai_status_step_3": "Etapa 3 — equilibrando visitas diárias entre limpadores…",
    "cleaning_work_plan_ai_status_step_4": "Etapa 4 — gerando a alocação estruturada…",
    "cleaning_work_plan_ai_status_step_5": "Etapa 5 — validando e calculando métricas finais…",
    "cleaning_work_plan_ai_cleaner_number": "Limpador #",
    "cleaning_work_plan_room_minutes": "Minutos de limpeza",
    "cleaning_work_plan_assigned_cleaner": "Limpador atribuído",
    "cleaning_work_plan_summary_cleaners": "Limpadores no plano",
    "cleaning_work_plan_summary_avg_minutes": "Min. médios / limpeza",
    "cleaning_work_plan_suggested_hours": "Horas totais sugeridas",
    "cleaning_work_plan_actual_hours": "Horas totais reais",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Média de min. sugeridos / limpador",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Média de min. reais / limpador",
    "cleaning_work_plan_guidelines_title": "Diretrizes de otimização",
    "cleaning_work_plan_guidelines_intro": "Esta ferramenta segue os mesmos objetivos da otimização manual do plano de limpeza: carga de trabalho por dados de visita, tempo baseado na média de minutos por limpeza e equipe equilibrada com lógica geográfica por andares.",
    "cleaning_work_plan_guidelines_b1": "Visitas por limpeza (padrão 50) segue a regra 1:50: entradas sugeridas por ambiente aproximadamente igual a visitas dividido por visitas por limpeza (arredondado para cima). Visitas e chegadas vêm do dia mais movimentado no período.",
    "cleaning_work_plan_guidelines_b2": "Quando você define o número de limpadores, cada andar do prédio vira um grupo. Os andares são ordenados por prédio e número e divididos em blocos contíguos entre limpadores para equilibrar o trabalho sugerido e manter andares próximos com o mesmo limpador.",
    "cleaning_work_plan_guidelines_b3": "Todos os banheiros do mesmo andar ficam com o mesmo limpador, então banheiros masculino e feminino desse andar não são divididos entre pessoas diferentes (desde que compartilhem o mesmo valor de andar no painel de controle).",
    "cleaning_work_plan_guidelines_b4": "A média de minutos por limpeza determina minutos e horas totais sugeridos e reais, além da média por limpador. Totais reais usam chegadas registradas de limpadores multiplicadas pela sua média; totais sugeridos usam limpezas implícitas multiplicadas pela sua média.",
    "cleaning_work_plan_guidelines_b5": "Use Exportar CSV se quiser refinar a alocação em outro lugar (por exemplo, para melhorar ainda mais o equilíbrio de visitas).",
    "cleaning_performed": "Limpeza realizada",
  },
  ru: {
    "cleaned_floor": "пол чистый",
    "cleaned_toilet": "туалет убран",
    "cleaned_shower": "душевые убраны",
    "cleaned_sink": "раковина убрана",
    "cleaned_mirror": "зеркало чистое",
    "cleaned_stainless_steel": "нероста чисная",
    "bad_smell": "плохой запах",
    "dirty_floor": "Грязный пол",
    "dirty_lavatory_seat": "грязное сиденье унитаза",
    "dirty_shower": "грязная душевая",
    "dirty_sink": "грязная раковина",
    "dirty_mirror": "грязное зеркало",
    "dirty_stainless_steel": "грязная нероста",
    "missing_paper_towel": "нет бумажного полотенца ",
    "missing_soap": "нет мыло",
    "missing_toilet_paper": "нет туалетной бумаги",
    "problem_shower": "проблема в душевой ",
    "problem_sink": "проблема с раковиной",
    "problem_mirror": "проблема с зеркалом",
    "problem_stainless_steel": "проблема с неростай",
    "problem_blockage": "есть засорение",
    "problem_door": "проблема с дверью",
    "problem_fluid_taps": "протекает кран",
    "problem_lightning": "проблема с освещением",
    "problem_broken_toilet": "сломанный унитаз",
    "fixed_shower": "душевые починены",
    "fixed_sink": "раковина починена",
    "fixed_mirror": "зеркало починено",
    "fixed_stainless_steel": "нироста исправлена",
    "fixed_blockage": "засор исправлен",
    "fixed_door": "дверь исправлена",
    "fixed_fluid_taps": "протечка исправлена",
    "fixed_lightning": "освещение исправлено",
    "fixed_broken_toilet": "унитаз исправлен",
    "very_good": "очень хорошо",
    "excellent": "отлично",
    "good": "хорошо",
    "like": "клас",
    "needs_improvement": "требуется улучшение",
    "not_good": "не хорошо",
    "supervise": "инспектор",
    "maintenance": "техобслуживание",
    "cleaner": "уборщик",
    "tag_cleaner": "тег очиститель",
    "zone_is_clean": "зона чистая",
    "zone_is_dirty": "зона грязная",
    "cleaner_arrived": "прибыл уборщик",
    "start_clean_zone": "Начать чистую зону",
    "counter": "счетчик",
    "counter_men": "количество мужчин",
    "counter_woman": "количество женщин",
    "counter_handycap": "количество инвалидов",
    "full_garbage_can": "полная мусорка",
    "maintenance_fixed": "техобслуживание окончено",
    "maintenance_problem": "проблема техобслуживание",
    "problem_soap_dispenser": "проблема с диспенсером мыла",
    "problem_paper_dispenser": "проблема с диспенсером бумаги",
    "end_clean_zone": "Конец чистой зоны",
    "status_toilet_paper": "сенсор туалетной бумаги",
    "status_hend_paper": "сенсор бумаги для рук",
    "fixed": "фиксированный",
    "status_soap": "сенсор мыла",
    "status_garbage_can": "сенсор мусорки",
    "general_cleaning": "генеральная уборка",
    "coffee_tea": "чай кофе",
    "water_bar": "кулер",
    "disposable_dishes": "одноразовая посуда",
    "head_coverage": "покрытие головы",
    "something_else": "что то другое",
    "missing_clothing": "недостаточно одежды",
    "maintenance_link": "ссылка обслуживание",
    "problem_maintenance": "обслуживание проблемы",
    "supervise_link": "контролировать связь",
    "cleaner_link": "уборщик ссылка",
    "room_men+link": "Мужчины через заряды номера",
    "room_men-link": "Мужчины по всему отрицательному номера",
    "room_women+link": "Женщины во зарядах номеров",
    "room_women-link": "Женщины по всему отрицательному номер",
    "hebrew": "иврит",
    "español": "испанский",
    "français": "французский",
    "english": "английский",
    "русский": "русский",
    "italiano": "итальянский",
    "አማርኛ": "амхарский",
    "português": "португальский",
    "arabic": "арабский",
    "partial_information": "частичная информация",
    "professionalism": "профессионализм",
    "the_attitude_of_the_representative": "отношение представителя",
    "waiting_time_for_service": "время ожидания обслуживания",
    "other_aspect_of_service": "Другой аспект службы",
    "language_of_the_service": "язык обслуживания",
    "procedure_for_making_an_appointment": "Порядок предварительной записи",
    "physical_conditions": "физические условия",
    "found_another": "нашел другое",
    "found_similar": "нашел похожие",
    "did_not_find": "не нашел продукт",
    "found": "нашел продукт",
    "need_improved": "можно улучшить",
    "liked": "понравилось",
    "pleasant": "приятноя",
    "eilat_resident": "я житель эйлата",
    "once_a_week": "раз в неделю",
    "once_a_month": "раз в месяц",
    "twice_a_year": "два три раза в гор",
    "once_a_year": "раз в год",
    "friend": "друг",
    "newspaper": "газета",
    "google": "гугл",
    "zap": "зап",
    "vacuum_cleaner": "пылесос",
    "gaming_consoles": "игровая приставка",
    "laptop": "ноутбук",
    "cellular": "сотовый телефон",
    "shop": "магазин",
    "restaurant_complex_cleaning": "ресторанный комплекс очистки",
    "dining_room": "столовая",
    "food_variety": "разнообразие блюд",
    "quality_of_the_food": "качество пищи",
    "amount_of_the_food": "количество еды",
    "quality_of_cooking": "качество приготовления",
    "side_courses": "добавки",
    "meat": "мясное",
    "desserts": "десерты",
    "vegetarian": "вегетарианский",
    "salad_bar": "салаты",
    "main_courses": "основное блюдо",
    "service": "обслуживание",
    "dining_room_cleanliness": "чистота столовой",
    "plates_and_cutlery_cleanliness": "чистота столовых предметов",
    "product_inventory": "запас продуктов",
    "furnishers": "мебель",
    "toilets": "туалет",
    "problem_coffee_machine": "проблема с кофемашиной",
    "problem_water_bar": "проблема с кулерам",
    "dirty_stairs": "грязная входная лестница",
    "toiletries": "туалетные принадлежности",
    "fixed_soap_dispenser": "мыльница исправлена",
    "fixed_paper_dispenser": "диспенсер для бумаги исправлен",
    "fixed_coffee_machine": "кофемашина исправлена",
    "fixed_water_bar": "кулер исправен",
    "problem_urinals": "сломанный писсуар",
    "blockage_toilet": "сломанный сливной бачок",
    "appliance_problem": "неисправный электроприбор",
    "problem_broken_door": "сломанная дверь",
    "problem_door_lock": "проблема с замком в двери",
    "problem_broken_toilet_seat": "сломанный унитаз",
    "problem_broken_niagara": "сломанный сливной бачок",
    " broken_hand_paper_dispenser_hand_dryer": "проблема с сушилкой для рук или диспенсером",
    "rug": "ковер",
    "tables": "столы",
    "kitchen": "кухня",
    "air_condition": "кондиционер",
    "dirty_urinals": "грязный писсуар",
    "hand_dryer": "сушилка для рук",
    "non_sticky_carpet": "нелипкий ковер",
    "problem_bad_smell": "проблема с запахом",
    "problem_broken_toilet_handle": "неисправная ручка туалета",
    "problem_handle_door": "неисправная ручка двери",
    "call_cleaner": "требуется уборка",
    "wall_painting": "покраска стен",
    "missing_paper": "Отсутствует бумага",
    "clean_surface": "уборка поверхностей",
    "problem_right_elevator": "неисправность в правом лифте",
    "problem_left_elevator": "неисправность в левом лифте",
    "missing_hand_sanitizer": "отсутствует дезинфицирующий спрей",
    "problem_sink_blockage": "засоренная раковина",
    "electric_problem": "проблема с электрическим питанием",
    "missing_coffe_tea": "не хватает кофе чая",
    "problem_air_condition": "проблема с кондиционером",
    "dishwashing": "мытье посуды",
    "kitchen_cleanliness": "чистота кухня",
    "weekly_cleaning": "еженедельная уборка",
    "general_arrangement": "общее расположение",
    "meeting_room": "комната для переговоров",
    "refrigerator": "холодильник",
    "kitchen_supplies": "кухонные принадлежности",
    "toilet_services": "туалет услуги",
    "carousel_door": "карусельная дверь",
    "desk": "стол письменный",
    "compressor": "компрессор",
    "compressor_rails": "компрессорные рельсы",
    "compressor_drainage": "дренаж компрессора",
    "dust": "пыль",
    "door": "дверь",
    "scotch": "скотч",
    "food": "Еда",
    "room_conditions": "комнатные условия",
    "kindness_sensitivity": "Доброта и чувствительность",
    "explain_process": "Объяснить процесс",
    "personal_attention": "Персональное внимание",
    "service_problem": "Обслуживание Проблема",
    "welcome_you": "Приветствует Вас",
    "invoice_submitted": "Счет-фактура, представленный",
    "thank_you_bought": "Спасибо купили",
    "problem_seller": "Проблема Продавец",
    "lapel_pin": "контактный нагрудные",
    "proper_performance": "надлежащее исполнение",
    "name_tag": "Именная метка",
    "operational": "эксплуатационный",
    "app_revealed": "App показал",
    "register_load": "загрузка регистра",
    "visibility_problem": "проблема Видимость",
    "clean_storefront": "Чистая витрина",
    "clean_garbage": "Чистый мусор",
    "clean_tables_chairs": "Чистые столы и стулья",
    "clean_shop_floor": "Чистый цех",
    "product_show": "Вид продукта",
    "refrigerators_show": "Вид холодильников",
    "coffee_accessories": "Кофейные аксессуары и оборудованы",
    "cleanliness": "чистота",
    "convenience_scheduling_appointments": "Удобство планирования назначений",
    "waiting_haircut": "В ожидании стрижки стрижки",
    "courtesy_books": "вежливость книг",
    "books_professionalism": "Профессионализм книг",
    "received_time": "получил меня вовремя",
    "dnot_appointment": "Я не записал встречу",
    "an_appointment": "Я назначил встречу",
    "tasty": "вкусные",
    "courtesy_service": "вежливость службы",
    "overall_experience": "Общий опыт",
    "not_clean": "не чисто",
    "diningroom_not_clean": "Столовая не чистая",
    "unclean_dishes": "нечистые блюда",
    "so-so": "так себе",
    "not_tasty": "не вкусно",
    "kind": "своего рода",
    "not_kind": "не добрая",
    "clean": "чистый",
    "hairdresser": "парикмахерская",
    "wrong_price": "Неправильная цена",
    "produc_has_expired": "Продукт истек",
    "missing_item": "Отсутствует пункт",
    "item_is_faulty_in_the_machine": "Товар неисправен в машине",
    "machine_cleaning": "Машинная очистка",
    "improper_temperature": "Неправильная температура",
    "green": "зеленый",
    "orange": "оранжевый",
    "red": "красный",
    "yellow": "желтый",
    "red not prob": "красный",
    "professional": "профессиональный",
    "unprofessional": "непрофессиональный",
    "delicacies": "Деликатесы",
    "sandwiches": "Бутерброды",
    "vegetables": "овощи",
    "fruits": "фрукты",
    "salads": "Салаты",
    "milk": "Молоко",
    "room_link": "номер ссылка",
    "floor_link": "пол ссылка",
    "services": "Сервисы",
    "check_list": "Проверка списка",
    "lighting_problem_lobby": "Освещение Проблема Лобби",
    "lighting_problem_garbage_room": "Освещение проблемная мусорная комната",
    "lighting_problem_stairwell": "Лестница освещения лестницы",
    "problem_elevator_1": "Проблема лифта 1.",
    "problem_elevator_2": "Проблема лифта 2.",
    "problem_elevator_3": "Проблема лифта 3",
    "problem_elevator_4": "Проблема лифта 4",
    "problem_elevator_5": "Проблема лифта 5.",
    "problem_elevator_6": "Проблема лифта 6.",
    "problem_elevator_7": "Проблема лифта 7.",
    "problem_elevator_8": "Проблема лифта 8.",
    "problem_elevator_9": "Проблема лифта 9.",
    "problem_elevator_10": "Проблема лифта 10.",
    "stuck_item": "Застрял предмет",
    "spoiling_product": "Прятный продукт",
    "machine_malfunction": "Неисправность машины",
    "unreadable_product": "Непричитанный продукт",
    "i_am_satisfied": "я удовлетворен",
    "beverage": "Напиток",
    "program_malfunction": "Неисправность программы",
    "machine_1": "Машина 1.",
    "machine_2": "Машина 2.",
    "machine_3": "Машина 3.",
    "machine_4": "Машина 4.",
    "program malfunction 1": "Неисправность программы 1.",
    "program malfunction 2": "Неисправность программы 2.",
    "program malfunction 3": "Неисправность программы 3.",
    "program malfunction 4": "Неисправность программы 4.",
    "fish": "Рыбы",
    "chicken": "курица",
    "full_dining_room": "Полная столовая",
    "missing_amount": "Отсутствующая сумма",
    "missing_trays": "Отсутствующие лотки",
    "dirty_floor_g1": "грязный пол g1",
    "dirty_floor_g2": "грязный пол g2",
    "dirty_floor_g3": "грязный пол g3",
    "dirty_floor_g4": "грязный пол g4",
    "dirty_floor_g5": "грязный пол g5",
    "dirty_floor_eo": "грязный пол ео",
    "dirty_floor_ceo": "уборка офиса генерального директора",
    "dirty_floor_storage": "уборка на этаже со складом",
    "dirty_floor_inflorescence": "грязный пол соцветие",
    "operating_instructions": "Инструкция по эксплуатации",
    "general": "Генеральная",
    "connection_problem": "Проблема соединения",
    "lighting": "освещение",
    "not _fixed": "не фиксируется",
    "cleaning_needed": "Очистка необходима",
    "missing_milk": "Недостающее молоко",
    "no_sugar_coffee": "Нет сахар / кофе",
    "missing_tools": "Отсутствующие инструменты",
    "coffee_water_machine": "Кофе машина воды /",
    "appliances": "бытовая техника",
    "products": "продукты",
    "broken_chair": "Сломанная мебель",
    "broken_cabinet": "Сломанный шкаф",
    "micro": "Микро",
    "toaster": "тостер",
    "clogged_sink_malfunction": "Засорение неисправность раковины",
    "coffee_cooling_malfunction": "Кофе охлаждение неисправность",
    "no_coffee_beans": "Нет кофе в зернах",
    "machine_failure": "отказ машины",
    "that_dirty": "Этот грязный",
    "dirty_refrigerator": "Грязный холодильник",
    "dirty_tables": "Грязные столы",
    "plates": "Тарелки",
    "silver_spoon": "Серебряная ложка",
    "cold_drinks_cups": "Холодные напитки чашки",
    "hot_drink_cups": "Горячие чашки напитка",
    "a_dripping_faucet": "капающий смеситель",
    "disposable dishes": "одноразовая посуда",
    "problem_ coffee_water_machine": "Кофе машина воды /",
    "problem_micro": "Микро",
    "problem_toaster": "тостер",
    "problem_machine_failure": "отказ машины",
    "problem refrigerator": "холодильник",
    "no_sugar/coffee": "Нет сахар / кофе",
    "missing_dishes": "Отсутствующие инструменты",
    "coffee/water_machine": "Кофе машина воды /",
    "coffee_machine_door_open": "Кофемашина открыта дверь",
    "coffee_machine_door_close": "Кофемашина двери закрывается",
    "coffee_machine_bin_full": "Кофемашина Bin полный",
    "coffee_machine_bin_empty": "Кофемашина Bin пустой",
    "coffee_machine_coffee_full": "кофемашина кофе полный",
    "coffee_machine_coffee_empty": "кофемашина кофе пусто",
    "coffee_machine_water_tank_empty": "Кофемашина для воды Бак пустой",
    "coffee_machine_ water_tank_full": "Кофемашина Watertank полностью",
    "coffee_machine_milk_cleaning_not_performed": "Кофемашина Молочная уборка не выполнена",
    "coffee_machine _milk_cleaning_performed": "Кофемашина Молочная уборка выполнена",
    "coffee_machine_head_cleaning_not_performed": "Чистка головки кофемашины не выполнена",
    "coffee_machine_head_ cleaning_performed": "Уборка головки кофемашины выполнены",
    "coffee_machine_descaling_not_performed": "Кофемашина накипи не выполняется",
    "coffee_machine_descaling_performed": "Кофемашина для удаления накипи",
    "floor_one": "Пол 1",
    "floor_two": "Пол 2",
    "floor_three": "Пол 3",
    "floor_four": "Пол 4",
    "floor_five": "Пол 5",
    "floor_six": "Пол 6",
    "floor_seven": "Пол 7",
    "floor_eight": "Пол 8",
    "floor_nine": "Пол 9",
    "floor_ten": "Пол 10",
    "floor_eleven": "Пол 11",
    "floor_twelve": "Пол 12",
    "floor_thirteen": "Пол 13",
    "floor_fourteen": "Пол 14",
    "floor_fifteen": "Пол 15",
    "floor_sixteen": "Пол 16",
    "floor_seventeen": "Пол 17",
    "floor_eighteen": "Пол 18",
    "floor_nineteen": "Пол 19",
    "floor_twenty": "Пол 20",
    "floor_twenty_one": "Пол 21",
    "floor_twenty_two": "Пол 22",
    "floor_twenty_three": "Пол 23",
    "floor_twenty_four": "Пол 24",
    "floor_twenty_five": "Пол 25",
    "status_toilet_paper_cell_01_-_empty": "Статус туалетной бумаги ячейка 01 - пусто",
    "status_toilet_paper_cell_02_-_empty": "Статус туалетной бумаги ячейка 02 - пусто",
    "status_toilet_paper_cell_03_-_empty": "Статус туалетной бумаги ячейка 03 - пусто",
    "status_toilet_paper_cell_04_-_empty": "Статус туалетной бумаги ячейка 04 - пусто",
    "status_toilet_paper_cell_05_-_empty": "Статус туалетной бумаги ячейка 05 - пусто",
    "status_toilet_paper_cell_06_-_empty": "Статус туалетной бумаги ячейка 06 - пусто",
    "status_toilet_paper_cell_07_-_empty": "Статус туалетной бумаги ячейка 07 - пусто",
    "status_toilet_paper_cell_08_-_empty": "Статус туалетной бумаги ячейка 08 - пусто",
    "status_toilet_paper_cell_09_-_empty": "Статус туалетной бумаги ячейка 09 - пусто",
    "status_toilet_paper_cell_10_-_empty": "Статус туалетной бумаги ячейка 10 - пусто",
    "status_toilet_paper_cell_11_-_empty": "Статус туалетной бумаги ячейка 11 - пусто",
    "status_toilet_paper_cell_12_-_empty": "Статус туалетной бумаги ячейка 12 - пусто",
    "status_toilet_paper_cell_13_-_empty": "Статус туалетной бумаги ячейка 13 - пусто",
    "status_toilet_paper_cell_14_-_empty": "Статус туалетной бумаги ячейка 14 - пусто",
    "status_toilet_paper_cell_15_-_empty": "Статус туалетной бумаги ячейка 15 - пусто",
    "status_toilet_paper_cell_16_-_empty": "Статус туалетной бумаги ячейка 16 - пусто",
    "status_toilet_paper_cell_17_-_empty": "Статус туалетной бумаги ячейка 17 - пусто",
    "status_toilet_paper_cell_18_-_empty": "Статус туалетной бумаги ячейка 18 - пусто",
    "status_toilet_paper_cell_19_-_empty": "Статус туалетной бумаги ячейка 19 - пусто",
    "status_toilet_paper_cell_20_-_empty": "Статус туалетной бумаги ячейка 20 - пусто",
    "status_toilet_paper_cell_01_-_almost_empty": "Статус туалетной бумаги ячейка 01 - почти пусто",
    "status_toilet_paper_cell_02_-_almost_empty": "Статус туалетной бумаги ячейка 02 - почти пусто",
    "status_toilet_paper_cell_03_-_almost_empty": "Статус туалетной бумаги ячейка 03 - почти пусто",
    "status_toilet_paper_cell_04_-_almost_empty": "Статус туалетной бумаги ячейка 04 - почти пусто",
    "status_toilet_paper_cell_05_-_almost_empty": "Статус туалетной бумаги ячейка 05 - почти пусто",
    "status_toilet_paper_cell_06_-_almost_empty": "Статус туалетной бумаги ячейка 06 - почти пусто",
    "status_toilet_paper_cell_07_-_almost_empty": "Статус туалетной бумаги ячейка 07 - почти пусто",
    "status_toilet_paper_cell_08_-_almost_empty": "Статус туалетной бумаги ячейка 08 - почти пусто",
    "status_toilet_paper_cell_09_-_almost_empty": "Статус туалетной бумаги ячейка 09 - почти пусто",
    "status_toilet_paper_cell_10_-_almost_empty": "Статус туалетной бумаги ячейка 10 - почти пусто",
    "status_toilet_paper_cell_11_-_almost_empty": "Статус туалетной бумаги ячейка 11 - почти пусто",
    "status_toilet_paper_cell_12_-_almost_empty": "Статус туалетной бумаги ячейка 12 - почти пусто",
    "status_toilet_paper_cell_13_-_almost_empty": "Статус туалетной бумаги ячейка 13 - почти пусто",
    "status_toilet_paper_cell_14_-_almost_empty": "Статус туалетной бумаги ячейка 14 - почти пусто",
    "status_toilet_paper_cell_15_-_almost_empty": "Статус туалетной бумаги ячейка 15 - почти пусто",
    "status_toilet_paper_cell_16_-_almost_empty": "Статус туалетной бумаги ячейка 16 - почти пусто",
    "status_toilet_paper_cell_17_-_almost_empty": "Статус туалетной бумаги ячейка 17 - почти пусто",
    "status_toilet_paper_cell_18_-_almost_empty": "Статус туалетной бумаги ячейка 18 - почти пусто",
    "status_toilet_paper_cell_19_-_almost_empty": "Статус туалетной бумаги ячейка 19 - почти пусто",
    "status_toilet_paper_cell_20_-_almost_empty": "Статус туалетной бумаги ячейка 20 - почти пусто",
    "of": "из",
    "items": "элементы",
    "loading_charts": "Загрузка графиков",
    "refresh_the_room": "Освежите комнату",
    "clean_the_floor": "Помыть пол",
    "clean_the_toilet": "Почистить туалет",
    "refill_soap": "Пополнить мыло",
    "change_roll": "Сменить рулон туалетной бумаги",
    "great_job": "Отличная работа",
    "empty_the_trash": "Опорожнить урну",
    "repair_required": "Требуется ремонт",
    "cleaning": "Уборка",
    "cleaning_work_plan": "План уборки",
    "cleaning_work_plan_intro": "Используются статистики комнат по сменам для компании и объекта из шапки. Визиты и приходы берутся из одного дня с максимальным числом визитов в выбранном периоде и из смен в фильтре дашборда (задайте их в Performance или Analytics, если на этой вкладке скрыты фильтры времени). Укажите визиты на уборку, целевую численность персонала, стоимость часа и среднее время уборки в минутах; сформируйте план, чтобы увидеть рекомендуемые уборки по комнатам и итоги.",
    "cleaning_work_plan_default_n": "Визитов на уборку",
    "cleaning_work_plan_cleaner_count": "Уборщики (необязательно)",
    "cleaning_work_plan_avg_minutes": "Среднее время уборки (мин)",
    "cleaning_work_plan_run": "Сформировать план",
    "cleaning_work_plan_export_csv": "Экспорт в Excel",
    "cleaning_work_plan_suggested_n": "Визитов на уборку",
    "cleaning_work_plan_actual_cleans": "Приходы",
    "cleaning_work_plan_actual_cleans_hint": "Общее число приходов уборщиков в статистике комнат по сменам в пиковый день (в выбранном диапазоне и фильтрах).",
    "cleaning_work_plan_suggested_cleans": "Рекомендуемые уборки",
    "cleaning_work_plan_cleaner": "Уборщик",
    "cleaning_work_plan_floors": "Этажи",
    "cleaning_work_plan_peak_day": "Пиковый день",
    "cleaning_work_plan_error": "Не удалось сформировать план уборки",
    "cleaning_work_plan_no_rooms": "Для этого объекта не вернулись комнаты. Проверьте объект и диапазон дат или убедитесь, что комнаты есть в панели управления.",
    "cleaning_work_plan_need_filter": "Выберите компанию и объект в шапке, задайте диапазон дат (и смены при необходимости) в Performance или Analytics, затем попробуйте снова.",
    "cleaning_work_plan_settings": "Настройки плана",
    "cleaning_work_plan_desired_employees": "Желаемое число сотрудников",
    "cleaning_work_plan_cost_per_hour": "Стоимость часа",
    "cleaning_work_plan_estimated_cost_suggested": "Ориентировочная стоимость (рекомендуемая нагрузка)",
    "cleaning_work_plan_estimated_cost_actual": "Ориентировочная стоимость (фактическая нагрузка)",
    "cleaning_work_plan_hours_per_cleaner": "Часов на уборщика",
    "cleaning_work_plan_metric_title": "Метрики",
    "cleaning_work_plan_metric_avg_cleaning_min": "Среднее время уборки (мин)",
    "cleaning_work_plan_metric_total_arrivals": "Всего посещений",
    "cleaning_work_plan_metric_total_cleaning_min": "Общее время уборки (мин)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Общее время уборки (часы)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Часов на уборщика",
    "cleaning_work_plan_metric_num_cleaners": "Количество уборщиков",
    "cleaning_work_plan_summary": "Сводка",
    "cleaning_work_plan_summary_peak_note": "Визиты, приходы и рекомендуемые уборки используют те же правила статистики комнат по сменам, что и Analytics (включая агрегацию приходов). Они рассчитываются для пикового дня - календарного дня с наибольшим числом визитов в периоде фильтра. Включаются только рассчитанные комнаты.",
    "cleaning_work_plan_summary_filter_period": "Период фильтра",
    "cleaning_work_plan_summary_total_visits": "Всего визитов",
    "cleaning_work_plan_summary_total_arrivals": "Всего приходов",
    "cleaning_work_plan_summary_employees_in_site": "Сотрудников на объекте",
    "cleaning_work_plan_summary_shift_working_hours": "Часы смен",
    "cleaning_work_plan_hours_unit": "ч",
    "cleaning_work_plan_rooms_table": "Комнаты",
    "cleaning_work_plan_cleaners_table": "Рекомендуемое распределение уборщиков",
    "cleaning_work_plan_search_rooms": "Поиск комнат",
    "cleaning_work_plan_total_minutes": "Всего минут",
    "cleaning_work_plan_actual_total_minutes": "Фактические минуты (итого)",
    "cleaning_work_plan_actual_total_minutes_hint": "Зафиксированные приходы уборщиков в статистике комнат по сменам в пиковый день (в выбранном диапазоне), умноженные на ваше среднее минут на уборку.",
    "cleaning_work_plan_suggested_total_minutes": "Рекомендуемые минуты (итого)",
    "cleaning_work_plan_suggested_room_minutes": "Рекомендуемые минуты уборки",
    "cleaning_work_plan_actual_room_minutes": "Фактические минуты уборки",
    "cleaning_work_plan_cleaner_suggested_minutes": "Реком. мин.",
    "cleaning_work_plan_cleaner_actual_minutes": "Факт. мин.",
    "cleaning_work_plan_period": "Период",
    "cleaning_work_plan_room_count": "Количество комнат",
    "cleaning_work_plan_cleaners_working_in_site": "Уборщики на объекте (контакты приложения)",
    "cleaning_work_plan_cleaners_connection_table": "Уборщики по комнатам",
    "cleaning_work_plan_connected_rooms_count": "Комнаты",
    "cleaning_work_plan_connected_floor_count": "Количество этажей",
    "cleaning_work_plan_connected_floors_list": "Этажи",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Соотношение визиты / приходы уборки",
    "cleaning_work_plan_performance_comparison_table": "Сравнение эффективности",
    "cleaning_work_plan_performance_comparison_empty": "Загрузите данные привязки уборщиков, чтобы увидеть строки.",
    "cleaning_work_plan_performance_col_index": "Показатель",
    "cleaning_work_plan_performance_existing_plan": "Существующий план работ",
    "cleaning_work_plan_performance_recommended_plan": "Рекомендуемый план Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Число сотрудников",
    "cleaning_work_plan_perf_working_hours_per_employee": "Рабочие часы на сотрудника",
    "cleaning_work_plan_perf_total_working_hours": "Всего рабочих часов",
    "cleaning_work_plan_perf_total_cleaning_hours": "Всего часов уборки",
    "cleaning_work_plan_perf_daily_cost": "Суточная стоимость",
    "cleaning_work_plan_perf_total_cleaning_visits": "Всего визитов уборки",
    "cleaning_work_plan_perf_busiest_area_visits": "Самая загруженная зона — визиты",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Визиты уборки в самую загруженную зону",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Максимальное соотношение уборки",
    "cleaning_work_plan_perf_least_busy_visits": "Наименее загруженная зона — визиты",
    "cleaning_work_plan_perf_cleaning_to_least": "Визиты уборки в наименее загруженную зону",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Минимальное соотношение уборки",
    "cleaning_work_plan_ai_allocate": "Распределение ИИ",
    "cleaning_work_plan_ai_allocation_result": "Результат распределения ИИ",
    "cleaning_work_plan_ai_allocation_loading": "Генерация распределения ИИ...",
    "cleaning_work_plan_ai_allocation_error": "Не удалось сгенерировать распределение ИИ. Пожалуйста, попробуйте снова.",
    "cleaning_work_plan_ai_invalid_employees": "Пожалуйста, укажите допустимое количество сотрудников.",
    "cleaning_work_plan_ai_status_elapsed": "Прошло: {s} с",
    "cleaning_work_plan_ai_status_hint": "Сервер выполняет несколько шагов ИИ подряд (начальный план, география, баланс визитов, затем итог). Это может занять одну–две минуты—не закрывайте страницу.",
    "cleaning_work_plan_ai_status_step_1": "Шаг 1 — черновое назначение по данным помещений и визитов…",
    "cleaning_work_plan_ai_status_step_2": "Шаг 2 — уточнение географии (группировка этажей и зданий)…",
    "cleaning_work_plan_ai_status_step_3": "Шаг 3 — балансировка ежедневных визитов между уборщиками…",
    "cleaning_work_plan_ai_status_step_4": "Шаг 4 — формирование структурированного распределения…",
    "cleaning_work_plan_ai_status_step_5": "Шаг 5 — проверка и расчёт итоговых метрик…",
    "cleaning_work_plan_ai_cleaner_number": "Уборщик №",
    "cleaning_work_plan_room_minutes": "Минуты уборки",
    "cleaning_work_plan_assigned_cleaner": "Назначенный уборщик",
    "cleaning_work_plan_summary_cleaners": "Уборщиков в плане",
    "cleaning_work_plan_summary_avg_minutes": "Средние мин / уборка",
    "cleaning_work_plan_suggested_hours": "Рекомендуемые часы (итого)",
    "cleaning_work_plan_actual_hours": "Фактические часы (итого)",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Средние рекомен. мин / уборщик",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Средние факт. мин / уборщик",
    "cleaning_work_plan_guidelines_title": "Рекомендации по оптимизации",
    "cleaning_work_plan_guidelines_intro": "Инструмент следует тем же целям, что и ручная оптимизация плана уборки: нагрузка из данных визитов, время из среднего минут на уборку и распределение персонала с балансом нагрузки и географической логикой этажей.",
    "cleaning_work_plan_guidelines_b1": "Визитов на уборку (по умолчанию 50) соответствует правилу 1:50: рекомендованные срабатывания по комнате примерно равны визитам, деленным на визиты на уборку (с округлением вверх). Визиты и приходы берутся из самого загруженного дня в выбранном периоде.",
    "cleaning_work_plan_guidelines_b2": "Когда задаете число уборщиков, каждый этаж здания становится группой. Этажи сортируются по зданию и номеру этажа, затем делятся на непрерывные блоки между уборщиками, чтобы сбалансировать нагрузку и сохранить соседние этажи за одним человеком.",
    "cleaning_work_plan_guidelines_b3": "Все санузлы на одном этаже остаются за одним уборщиком, поэтому мужские и женские комнаты этого этажа не делятся между разными уборщиками (если в панели управления у них одинаковое значение этажа).",
    "cleaning_work_plan_guidelines_b4": "Средние минуты на уборку определяют рекомендуемые и фактические итоговые минуты и часы, а также средние минуты на уборщика. Фактические итоги = зафиксированные приходы уборщиков x ваше среднее; рекомендуемые итоги = расчетные уборки x ваше среднее.",
    "cleaning_work_plan_guidelines_b5": "Используйте экспорт CSV, если хотите донастроить распределение в другом инструменте (например, еще сильнее выровнять баланс визитов).",
    "cleaning_performed": "Очистка выполнена",
  },
  es: {
    "cleaned_floor": "piso limpio",
    "cleaned_toilet": "baño limpio",
    "cleaned_shower": "ducha limpia",
    "cleaned_sink": "fregadero limpio",
    "cleaned_mirror": "espejo limpio",
    "cleaned_stainless_steel": "acero inoxidable limpiado",
    "bad_smell": "mal olor",
    "dirty_floor": "piso sucio",
    "dirty_lavatory_seat": "asiento de inodoro sucio",
    "dirty_shower": "ducha sucia",
    "dirty_sink": "fregadero sucio",
    "dirty_mirror": "espejo sucio",
    "dirty_stainless_steel": "acero inoxidable sucio",
    "missing_paper_towel": "falta toalla de papel",
    "missing_soap": "falta jabon",
    "missing_toilet_paper": "falta papel higiénico",
    "problem_shower": "problemas con la ducha",
    "problem_sink": "problemas en el fregadero",
    "problem_mirror": "problemas con el espejo",
    "problem_stainless_steel": "problema con el acero inoxidable",
    "problem_blockage": "problema de bloqueo",
    "problem_door": "problemas con la puerta",
    "problem_fluid_taps": "problemas con el gripo",
    "problem_lightning": "problema de iluminación",
    "problem_broken_toilet": "inodoro roto",
    "fixed_shower": "ducha arreglada",
    "fixed_sink": "fregadero arreglado",
    "fixed_mirror": "espejo arreglado",
    "fixed_stainless_steel": "acero inoxidable arreglado",
    "fixed_blockage": "bloqueo eliminado",
    "fixed_door": "puerta arreglada",
    "fixed_fluid_taps": "grifo arreglado",
    "fixed_lightning": "iluminación arreglada",
    "fixed_broken_toilet": "inodoro arreglado",
    "very_good": "muy bueno",
    "excellent": "excelente",
    "good": "bueno",
    "like": "me gusta",
    "needs_improvement": "debe mejorar",
    "not_good": "nada bueno",
    "supervise": "supervisar",
    "maintenance": "mantenimiento",
    "cleaner": "persona de limpieza",
    "tag_cleaner": "credencial de limpiador",
    "zone_is_clean": "la zona está limpia",
    "zone_is_dirty": "la zona está sucia",
    "cleaner_arrived": "la persona de limpieza llegó",
    "start_clean_zone": "iniciar zona limpia",
    "counter": "contador",
    "counter_men": "contador hombres",
    "counter_woman": "contador mujeres",
    "counter_handycap": "contador discapacitados",
    "full_garbage_can": "cesto de basura lleno",
    "maintenance_fixed": "mantenimiento arreglado",
    "maintenance_problem": "problemas de mantenimiento",
    "problem_soap_dispenser": "problemas con el dispensador de jabón",
    "problem_paper_dispenser": "problemas con el dispensador de papel",
    "end_clean_zone": "zona limpia final",
    "status_toilet_paper": "estatus de papel de baño",
    "status_hend_paper": "estatus de papel de mano",
    "fixed": "reparado",
    "status_soap": "estatos de jabón",
    "status_garbage_can": "estatus del cesto de basura",
    "general_cleaning": "limpieza general",
    "coffee_tea": "café té",
    "water_bar": "barra de bebidas",
    "disposable_dishes": "platos descartables",
    "head_coverage": "cobertura de cabeza",
    "something_else": "algo más",
    "missing_clothing": "ropa extraviada/ falta ropa",
    "maintenance_link": "link/transición de mantenimiento",
    "problem_maintenance": "problemas de mantenimiento",
    "supervise_link": "link de supervisor",
    "cleaner_link": "link de la persona de limpieza",
    "room_men+link": "link + cuarto de hombres",
    "room_men-link": "link - cuarto de hombres",
    "room_women+link": "link + cuarto de mujeres",
    "room_women-link": "link - cuarto de mujeres",
    "hebrew": "hebreo",
    "español": "español",
    "français": "francés",
    "english": "inglés",
    "русский": "ruso",
    "italiano": "italiano",
    "አማርኛ": "amárico",
    "português": "portugués",
    "arabic": "árabe",
    "partial_information": "información parcial",
    "professionalism": "profesionalismo",
    "the_attitude_of_the_representative": "la actitud del representante",
    "waiting_time_for_service": "tiempo de espera del servicio",
    "other_aspect_of_service": "otros aspectos del servicio",
    "language_of_the_service": "lenguaje del servicio",
    "procedure_for_making_an_appointment": "procedimiento para agendar una cita",
    "physical_conditions": "condiciones físicas",
    "found_another": "encontrar otro",
    "found_similar": "encontrar similar",
    "did_not_find": "no se encuentra",
    "found": "se encontró",
    "need_improved": "necesita mejorar",
    "liked": "le ha gustado",
    "pleasant": "agradable",
    "eilat_resident": "residente de eilat",
    "once_a_week": "una a la semana",
    "once_a_month": "una al mes",
    "twice_a_year": "dos al año",
    "once_a_year": "una al año",
    "friend": "amigo",
    "newspaper": "diario",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "aspiradora",
    "gaming_consoles": "videojuegos",
    "laptop": "laptop",
    "cellular": "celular",
    "shop": "shop",
    "restaurant_complex_cleaning": "limpieza de restaurante",
    "dining_room": "comedor",
    "food_variety": "variedad de comidas",
    "quality_of_the_food": "calidad de la comida",
    "amount_of_the_food": "cantidad de la comida",
    "quality_of_cooking": "calidad de la cocina",
    "side_courses": "acompañamientos",
    "meat": "carne",
    "desserts": "postre",
    "vegetarian": "vegetariana",
    "salad_bar": "barra de ensaladas",
    "main_courses": "plato principal",
    "service": "servicio",
    "dining_room_cleanliness": "limpieza del comedor",
    "plates_and_cutlery_cleanliness": "limpieza de platos y cubiertos",
    "product_inventory": "stock de productos",
    "furnishers": "muebles",
    "toilets": "baños",
    "problem_coffee_machine": "problemas con la máquina de café",
    "problem_water_bar": "problema con la barra de bebidas",
    "dirty_stairs": "escaleras sucias",
    "toiletries": "artículos de aseo",
    "fixed_soap_dispenser": "dispensador de jabón arreglado",
    "fixed_paper_dispenser": "dispensador de papel arreglado",
    "fixed_coffee_machine": "máquina de café arreglada",
    "fixed_water_bar": "barra de bebidas arreglada",
    "problem_urinals": "problemas en migitorios",
    "blockage_toilet": "inodoro tapado",
    "appliance_problem": "problemas en electrodomésticos",
    "problem_broken_door": "puerta rota",
    "problem_door_lock": "puerta trabada",
    "problem_broken_toilet_seat": "asiento de inodoro roto",
    "problem_broken_niagara": "problema inodoro roto/descompuesto",
    " broken_hand_paper_dispenser_hand_dryer": "secador de manos dispensador de papel roto",
    "rug": "alfombra",
    "tables": "mesas",
    "kitchen": "cocina",
    "air_condition": "aire acondicionado",
    "dirty_urinals": "migitorios sucios",
    "hand_dryer": "secadora de manos",
    "non_sticky_carpet": "alfombra antiadherente",
    "problem_bad_smell": "mal olor",
    "problem_broken_toilet_handle": "manija de inodoro rota",
    "problem_handle_door": "picaporte roto",
    "call_cleaner": "llamar persona de limpieza",
    "wall_painting": "pared pintada",
    "missing_paper": "missing papel",
    "clean_surface": "superficie limpia",
    "problem_right_elevator": "problemas en ascensor derecho",
    "problem_left_elevator": "problemas en ascensor izquierdo",
    "missing_hand_sanitizer": "falta desinfectante de manos",
    "problem_sink_blockage": "fregadero tapado",
    "electric_problem": "problema eléctrico",
    "missing_coffe_tea": "falta café o té",
    "problem_air_condition": "falla el aire acondicionado",
    "dishwashing": "lavar platos",
    "kitchen_cleanliness": "cocina limpieza",
    "weekly_cleaning": "limpieza semanal",
    "general_arrangement": "acuerdo general",
    "meeting_room": "sala de reuniones",
    "refrigerator": "refrigerador",
    "kitchen_supplies": "utensilios de cocina",
    "toilet_services": "servicios higiénicos",
    "carousel_door": "puerta de carrusel",
    "desk": "escritorio",
    "compressor": "compresor",
    "compressor_rails": "carriles compresor",
    "compressor_drainage": "el drenaje del compresor",
    "dust": "polvo",
    "door": "puerta",
    "scotch": "escocés",
    "food": "comida",
    "room_conditions": "condiciones de la sala",
    "kindness_sensitivity": "la bondad y la sensibilidad",
    "explain_process": "explicar el proceso",
    "personal_attention": "atención personal",
    "service_problem": "problema servicio",
    "welcome_you": "bienvenido",
    "invoice_submitted": "factura presentada",
    "thank_you_bought": "gracias comprado",
    "problem_seller": "problema del vendedor",
    "lapel_pin": "perno de la solapa",
    "proper_performance": "rendimiento adecuado",
    "name_tag": "etiqueta con su nombre",
    "operational": "operacional",
    "app_revealed": "aplicación reveló",
    "register_load": "registro de carga",
    "visibility_problem": "problema de la visibilidad",
    "clean_storefront": "tienda limpia",
    "clean_garbage": "basura limpia",
    "clean_tables_chairs": "limpiar las mesas y sillas",
    "clean_shop_floor": "planta de producción limpia",
    "product_show": "vista del producto",
    "refrigerators_show": "vista de refrigeradores",
    "coffee_accessories": "accesorios café y equipado",
    "cleanliness": "limpieza",
    "convenience_scheduling_appointments": "conveniencia de programación de citas",
    "waiting_haircut": "esperando un corte de pelo",
    "courtesy_books": "cortesía de los libros",
    "books_professionalism": "la profesionalidad de los libros.",
    "received_time": "me recibió a tiempo",
    "dnot_appointment": "no hice una cita",
    "an_appointment": "yo hice una cita",
    "tasty": "sabroso",
    "courtesy_service": "cortesía del servicio",
    "overall_experience": "la experiencia general",
    "not_clean": "no está limpio",
    "diningroom_not_clean": "el comedor no está limpio.",
    "unclean_dishes": "platos sucios",
    "so-so": "regular",
    "not_tasty": "no es sabroso",
    "kind": "amable",
    "not_kind": "no grato",
    "clean": "limpio",
    "hairdresser": "peluquero",
    "wrong_price": "precio erróneo",
    "produc_has_expired": "el producto ha caducado",
    "missing_item": "objeto perdido",
    "item_is_faulty_in_the_machine": "el artículo está defectuoso en la máquina.",
    "machine_cleaning": "limpieza de la máquina",
    "improper_temperature": "temperatura incorrecta",
    "green": "verde",
    "orange": "naranja",
    "red": "rojo",
    "yellow": "amarillo",
    "red not prob": "rojo",
    "professional": "loading...",
    "unprofessional": "loading...",
    "delicacies": "delicias",
    "sandwiches": "sándwiches",
    "vegetables": "verduras",
    "fruits": "frutas",
    "salads": "ensaladas",
    "milk": "leche",
    "room_link": "vínculo de la sala",
    "floor_link": "enlace baja",
    "services": "servicios",
    "check_list": "lista de verificación",
    "lighting_problem_lobby": "problema de lugar lobby",
    "lighting_problem_garbage_room": "problema de iluminación sala de basura",
    "lighting_problem_stairwell": "problema de iluminación escalera",
    "problem_elevator_1": "problema elevador 1",
    "problem_elevator_2": "problema elevador 2",
    "problem_elevator_3": "problema elevador 3",
    "problem_elevator_4": "problema elevador 4",
    "problem_elevator_5": "problema elevador 5",
    "problem_elevator_6": "problema elevador 6",
    "problem_elevator_7": "problema elevador 7",
    "problem_elevator_8": "problema elevador 8",
    "problem_elevator_9": "problema elevador 9",
    "problem_elevator_10": "problema elevador 10",
    "stuck_item": "artículo atascado",
    "spoiling_product": "producto de arruinado",
    "machine_malfunction": "mal funcionamiento de la máquina",
    "unreadable_product": "producto ilegible",
    "i_am_satisfied": "estoy satisfecho",
    "beverage": "bebida",
    "program_malfunction": "programa mal funcionamiento",
    "machine_1": "máquina 1",
    "machine_2": "máquina 2",
    "machine_3": "máquina 3",
    "machine_4": "máquina 4",
    "program malfunction 1": "Programa mal funcionamiento 1",
    "program malfunction 2": "Programa mal funcionamiento 2",
    "program malfunction 3": "Programa mal funcionamiento 3",
    "program malfunction 4": "Programa mal funcionamiento 4",
    "fish": "pescado",
    "chicken": "pollo",
    "full_dining_room": "comedor completo",
    "missing_amount": "cantidad faltante",
    "missing_trays": "bandejas faltantes",
    "dirty_floor_g1": "piso sucio g1",
    "dirty_floor_g2": "piso sucio g2",
    "dirty_floor_g3": "piso sucio g3",
    "dirty_floor_g4": "piso sucio g4",
    "dirty_floor_g5": "piso sucio g5",
    "dirty_floor_eo": "piso sucio eo",
    "dirty_floor_ceo": "piso sucio ceo",
    "dirty_floor_storage": "piso sucio del almacenamiento",
    "dirty_floor_inflorescence": "inflorescencia del piso sucio",
    "operating_instructions": "instrucciones de operación",
    "general": "general",
    "connection_problem": "problema de conexión",
    "lighting": "encendiendo",
    "not _fixed": "no arreglado",
    "cleaning_needed": "limpieza necesaria",
    "missing_milk": "la leche que falta",
    "no_sugar_coffee": "sin azúcar / café",
    "missing_tools": "herramientas que faltan",
    "coffee_water_machine": "máquina de café / agua",
    "appliances": "accesorios",
    "products": "productos",
    "broken_chair": "muebles rotos",
    "broken_cabinet": "mueble roto",
    "micro": "micro",
    "toaster": "tostadora",
    "clogged_sink_malfunction": "obstruido mal funcionamiento del fregadero",
    "coffee_cooling_malfunction": "coffee mal funcionamiento de refrigeración",
    "no_coffee_beans": "no hay granos de café",
    "machine_failure": "fallo de la máquina",
    "that_dirty": "esa sucia",
    "dirty_refrigerator": "nevera sucia",
    "dirty_tables": "mesas sucias",
    "plates": "platos",
    "silver_spoon": "cuchara de plata",
    "cold_drinks_cups": "frío bebe copas",
    "hot_drink_cups": "tazas de bebidas calientes",
    "a_dripping_faucet": "loading...",
    "disposable dishes": "platos descartables",
    "problem_ coffee_water_machine": "máquina de café / agua",
    "problem_micro": "micro",
    "problem_toaster": "tostadora",
    "problem_machine_failure": "fallo de la máquina",
    "problem refrigerator": "refrigerador",
    "no_sugar/coffee": "sin azúcar / café",
    "missing_dishes": "herramientas que faltan",
    "coffee/water_machine": "máquina de café / agua",
    "coffee_machine_door_open": "puerta de la máquina de café abierta",
    "coffee_machine_door_close": "coffee machine puerta cerrar",
    "coffee_machine_bin_full": "máquina de café bin completa",
    "coffee_machine_bin_empty": "papelera de café vacío",
    "coffee_machine_coffee_full": "cafetera café llena",
    "coffee_machine_coffee_empty": "cafetera cafetera vacía",
    "coffee_machine_water_tank_empty": "tanque de agua de la máquina de café vacía",
    "coffee_machine_ water_tank_full": "máquina de café acuática llena",
    "coffee_machine_milk_cleaning_not_performed": "máquina de café limpieza de leche no realizado",
    "coffee_machine _milk_cleaning_performed": "máquina de café limpieza de leche realizada",
    "coffee_machine_head_cleaning_not_performed": "cafetera cabeza limpieza no realizada",
    "coffee_machine_head_ cleaning_performed": "coffee machine head limpieza realizada",
    "coffee_machine_descaling_not_performed": "máquina de café descalificante no realizada",
    "coffee_machine_descaling_performed": "máquina de café descalificada realizada.",
    "floor_one": "piso 1",
    "floor_two": "piso 2",
    "floor_three": "piso 3",
    "floor_four": "piso 4",
    "floor_five": "piso 5",
    "floor_six": "piso 6",
    "floor_seven": "piso 7",
    "floor_eight": "piso 8",
    "floor_nine": "piso 9",
    "floor_ten": "piso 10",
    "floor_eleven": "piso 11",
    "floor_twelve": "piso 12",
    "floor_thirteen": "piso 13",
    "floor_fourteen": "piso 14",
    "floor_fifteen": "piso 15",
    "floor_sixteen": "piso 16",
    "floor_seventeen": "piso 17",
    "floor_eighteen": "piso 18",
    "floor_nineteen": "piso 19",
    "floor_twenty": "piso 20",
    "floor_twenty_one": "piso 21",
    "floor_twenty_two": "piso 22",
    "floor_twenty_three": "piso 23",
    "floor_twenty_four": "piso 24",
    "floor_twenty_five": "piso 25",
    "status_toilet_paper_cell_01_-_empty": "Estado de la celda de papel higiénico 01 - vacío",
    "status_toilet_paper_cell_02_-_empty": "Estado de la celda de papel higiénico 02 - vacío",
    "status_toilet_paper_cell_03_-_empty": "Estado de la celda de papel higiénico 03 - vacío",
    "status_toilet_paper_cell_04_-_empty": "Estado de la celda de papel higiénico 04 - vacío",
    "status_toilet_paper_cell_05_-_empty": "Estado de la celda de papel higiénico 05 - vacío",
    "status_toilet_paper_cell_06_-_empty": "Estado de la celda de papel higiénico 06 - vacío",
    "status_toilet_paper_cell_07_-_empty": "Estado de la celda de papel higiénico 07 - vacío",
    "status_toilet_paper_cell_08_-_empty": "Estado de la celda de papel higiénico 08 - vacío",
    "status_toilet_paper_cell_09_-_empty": "Estado de la celda de papel higiénico 09 - vacío",
    "status_toilet_paper_cell_10_-_empty": "Estado de la celda de papel higiénico 10 - vacío",
    "status_toilet_paper_cell_11_-_empty": "Estado de la celda de papel higiénico 11 - vacío",
    "status_toilet_paper_cell_12_-_empty": "Estado de la celda de papel higiénico 12 - vacío",
    "status_toilet_paper_cell_13_-_empty": "Estado de la celda de papel higiénico 13 - vacío",
    "status_toilet_paper_cell_14_-_empty": "Estado de la celda de papel higiénico 14 - vacío",
    "status_toilet_paper_cell_15_-_empty": "Estado de la celda de papel higiénico 15 - vacío",
    "status_toilet_paper_cell_16_-_empty": "Estado de la celda de papel higiénico 16 - vacío",
    "status_toilet_paper_cell_17_-_empty": "Estado de la celda de papel higiénico 17 - vacío",
    "status_toilet_paper_cell_18_-_empty": "Estado de la celda de papel higiénico 18 - vacío",
    "status_toilet_paper_cell_19_-_empty": "Estado de la celda de papel higiénico 19 - vacío",
    "status_toilet_paper_cell_20_-_empty": "Estado de la celda de papel higiénico 20 - vacío",
    "status_toilet_paper_cell_01_-_almost_empty": "Estado de la celda de papel higiénico 01 - casi vacío",
    "status_toilet_paper_cell_02_-_almost_empty": "Estado de la celda de papel higiénico 02 - casi vacío",
    "status_toilet_paper_cell_03_-_almost_empty": "Estado de la celda de papel higiénico 03 - casi vacío",
    "status_toilet_paper_cell_04_-_almost_empty": "Estado de la celda de papel higiénico 04 - casi vacío",
    "status_toilet_paper_cell_05_-_almost_empty": "Estado de la celda de papel higiénico 05 - casi vacío",
    "status_toilet_paper_cell_06_-_almost_empty": "Estado de la celda de papel higiénico 06 - casi vacío",
    "status_toilet_paper_cell_07_-_almost_empty": "Estado de la celda de papel higiénico 07 - casi vacío",
    "status_toilet_paper_cell_08_-_almost_empty": "Estado de la celda de papel higiénico 08 - casi vacío",
    "status_toilet_paper_cell_09_-_almost_empty": "Estado de la celda de papel higiénico 09 - casi vacío",
    "status_toilet_paper_cell_10_-_almost_empty": "Estado de la celda de papel higiénico 10 - casi vacío",
    "status_toilet_paper_cell_11_-_almost_empty": "Estado de la celda de papel higiénico 11 - casi vacío",
    "status_toilet_paper_cell_12_-_almost_empty": "Estado de la celda de papel higiénico 12 - casi vacío",
    "status_toilet_paper_cell_13_-_almost_empty": "Estado de la celda de papel higiénico 13 - casi vacío",
    "status_toilet_paper_cell_14_-_almost_empty": "Estado de la celda de papel higiénico 14 - casi vacío",
    "status_toilet_paper_cell_15_-_almost_empty": "Estado de la celda de papel higiénico 15 - casi vacío",
    "status_toilet_paper_cell_16_-_almost_empty": "Estado de la celda de papel higiénico 16 - casi vacío",
    "status_toilet_paper_cell_17_-_almost_empty": "Estado de la celda de papel higiénico 17 - casi vacío",
    "status_toilet_paper_cell_18_-_almost_empty": "Estado de la celda de papel higiénico 18 - casi vacío",
    "status_toilet_paper_cell_19_-_almost_empty": "Estado de la celda de papel higiénico 19 - casi vacío",
    "status_toilet_paper_cell_20_-_almost_empty": "Estado de la celda de papel higiénico 20 - casi vacío",
    "of": "de",
    "items": "artículos",
    "loading_charts": "Cargando gráficos",
    "refresh_the_room": "Aromatizar el ambiente",
    "clean_the_floor": "Limpiar el piso",
    "clean_the_toilet": "Limpiar el inodoro",
    "refill_soap": "Rellenar el jabón",
    "change_roll": "Cambiar el rollo de papel higiénico",
    "great_job": "¡Gran trabajo!",
    "empty_the_trash": "Vaciar la basura",
    "repair_required": "Se requiere reparación",
    "cleaning": "Limpieza",
    "cleaning_work_plan": "Plan de trabajo de limpieza",
    "cleaning_work_plan_intro": "Usa estadísticas de salas por turno para la empresa y el sitio del encabezado. Las visitas y llegadas provienen del único día con más visitas dentro del rango seleccionado y de los turnos del filtro del dashboard (defínelos en Performance o Analytics si esta pestaña oculta controles de tiempo y filtro). Introduce visitas por limpieza, objetivo de personal, coste por hora y tiempo medio de limpieza en minutos; genera el plan para ver limpiezas sugeridas por sala y totales en el resumen.",
    "cleaning_work_plan_default_n": "Visitas por limpieza",
    "cleaning_work_plan_cleaner_count": "Limpiadores (opcional)",
    "cleaning_work_plan_avg_minutes": "Tiempo medio de limpieza (min)",
    "cleaning_work_plan_run": "Generar plan",
    "cleaning_work_plan_export_csv": "Exportar Excel",
    "cleaning_work_plan_suggested_n": "Visitas por limpieza",
    "cleaning_work_plan_actual_cleans": "Llegadas",
    "cleaning_work_plan_actual_cleans_hint": "Total de llegadas de limpiadores en estadísticas de salas por turno en el día pico (dentro del rango y filtros seleccionados).",
    "cleaning_work_plan_suggested_cleans": "Limpiezas sugeridas",
    "cleaning_work_plan_cleaner": "Limpiador",
    "cleaning_work_plan_floors": "Pisos",
    "cleaning_work_plan_peak_day": "Día pico",
    "cleaning_work_plan_error": "No se pudo generar el plan de trabajo de limpieza",
    "cleaning_work_plan_no_rooms": "No se devolvieron salas para este sitio. Revisa el sitio y el rango de fechas, o verifica que existan salas en el panel de control.",
    "cleaning_work_plan_need_filter": "Selecciona empresa y sitio en el encabezado, define un rango de fechas (y turnos si hace falta) en Performance o Analytics, y vuelve a intentarlo.",
    "cleaning_work_plan_settings": "Configuración del plan",
    "cleaning_work_plan_desired_employees": "Número deseado de empleados",
    "cleaning_work_plan_cost_per_hour": "Coste por hora",
    "cleaning_work_plan_estimated_cost_suggested": "Coste estimado (carga sugerida)",
    "cleaning_work_plan_estimated_cost_actual": "Coste estimado (carga real)",
    "cleaning_work_plan_hours_per_cleaner": "Horas por limpiador",
    "cleaning_work_plan_metric_title": "Métricas",
    "cleaning_work_plan_metric_avg_cleaning_min": "Tiempo promedio de limpieza (min)",
    "cleaning_work_plan_metric_total_arrivals": "Llegadas totales",
    "cleaning_work_plan_metric_total_cleaning_min": "Tiempo total de limpieza (min)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Tiempo total de limpieza (horas)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Horas por limpiador",
    "cleaning_work_plan_metric_num_cleaners": "Número de limpiadores",
    "cleaning_work_plan_summary": "Resumen",
    "cleaning_work_plan_summary_peak_note": "Las visitas, llegadas y limpiezas sugeridas usan las mismas reglas de estadísticas por turno que Analytics (incluida la agregación de llegadas). Se calculan para el día pico: el día calendario con más visitas del período filtrado. Solo se incluyen salas calculadas.",
    "cleaning_work_plan_summary_filter_period": "Período del filtro",
    "cleaning_work_plan_summary_total_visits": "Total de visitas",
    "cleaning_work_plan_summary_total_arrivals": "Total de llegadas",
    "cleaning_work_plan_summary_employees_in_site": "Empleados en el sitio",
    "cleaning_work_plan_summary_shift_working_hours": "Horas de turno",
    "cleaning_work_plan_hours_unit": "h",
    "cleaning_work_plan_rooms_table": "Salas",
    "cleaning_work_plan_cleaners_table": "Asignación recomendada de limpiadores",
    "cleaning_work_plan_search_rooms": "Buscar salas",
    "cleaning_work_plan_total_minutes": "Minutos totales",
    "cleaning_work_plan_actual_total_minutes": "Minutos reales totales",
    "cleaning_work_plan_actual_total_minutes_hint": "Llegadas de limpiadores registradas en estadísticas por turno en el día pico (dentro del rango seleccionado), multiplicadas por tu promedio de minutos por limpieza.",
    "cleaning_work_plan_suggested_total_minutes": "Minutos sugeridos totales",
    "cleaning_work_plan_suggested_room_minutes": "Minutos sugeridos de limpieza",
    "cleaning_work_plan_actual_room_minutes": "Minutos reales de limpieza",
    "cleaning_work_plan_cleaner_suggested_minutes": "Min sugeridos",
    "cleaning_work_plan_cleaner_actual_minutes": "Min reales",
    "cleaning_work_plan_period": "Período",
    "cleaning_work_plan_room_count": "Cantidad de salas",
    "cleaning_work_plan_cleaners_working_in_site": "Limpiadores en el sitio (contactos de la app)",
    "cleaning_work_plan_cleaners_connection_table": "Limpiadores por salas",
    "cleaning_work_plan_connected_rooms_count": "Salas",
    "cleaning_work_plan_connected_floor_count": "Número de pisos",
    "cleaning_work_plan_connected_floors_list": "Pisos",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Ratio visitas / entradas de limpieza",
    "cleaning_work_plan_performance_comparison_table": "Comparación de rendimiento",
    "cleaning_work_plan_performance_comparison_empty": "Cargue los datos de vinculación de limpiadores para ver las filas.",
    "cleaning_work_plan_performance_col_index": "Índice",
    "cleaning_work_plan_performance_existing_plan": "Plan de trabajo existente",
    "cleaning_work_plan_performance_recommended_plan": "Plan recomendado Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Número de empleados",
    "cleaning_work_plan_perf_working_hours_per_employee": "Horas de trabajo por empleado",
    "cleaning_work_plan_perf_total_working_hours": "Total de horas de trabajo",
    "cleaning_work_plan_perf_total_cleaning_hours": "Total de horas de limpieza",
    "cleaning_work_plan_perf_daily_cost": "Coste diario",
    "cleaning_work_plan_perf_total_cleaning_visits": "Total de visitas de limpieza",
    "cleaning_work_plan_perf_busiest_area_visits": "Área más ocupada — visitas",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Visitas de limpieza al área más ocupada",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Ratio máximo de limpieza",
    "cleaning_work_plan_perf_least_busy_visits": "Área menos ocupada — visitas",
    "cleaning_work_plan_perf_cleaning_to_least": "Visitas de limpieza al área menos ocupada",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Ratio mínimo de limpieza",
    "cleaning_work_plan_ai_allocate": "Asignación por IA",
    "cleaning_work_plan_ai_allocation_result": "Resultado de Asignación por IA",
    "cleaning_work_plan_ai_allocation_loading": "Generando asignación por IA...",
    "cleaning_work_plan_ai_allocation_error": "Error al generar asignación por IA. Por favor, intente de nuevo.",
    "cleaning_work_plan_ai_invalid_employees": "Por favor, establezca un número válido de empleados deseados.",
    "cleaning_work_plan_ai_status_elapsed": "Transcurrido: {s} s",
    "cleaning_work_plan_ai_status_hint": "El servidor ejecuta varios pasos de IA en secuencia (plan inicial, geografía, equilibrio de visitas y salida final). Puede tardar uno o dos minutos—mantenga esta página abierta.",
    "cleaning_work_plan_ai_status_step_1": "Paso 1 — borrador de asignación inicial según salas y visitas…",
    "cleaning_work_plan_ai_status_step_2": "Paso 2 — refinando geografía (agrupando plantas y edificios cercanos)…",
    "cleaning_work_plan_ai_status_step_3": "Paso 3 — equilibrando visitas diarias entre limpiadores…",
    "cleaning_work_plan_ai_status_step_4": "Paso 4 — generando la asignación estructurada…",
    "cleaning_work_plan_ai_status_step_5": "Paso 5 — validando y calculando métricas finales…",
    "cleaning_work_plan_ai_cleaner_number": "Limpiador #",
    "cleaning_work_plan_room_minutes": "Minutos de limpieza",
    "cleaning_work_plan_assigned_cleaner": "Limpiador asignado",
    "cleaning_work_plan_summary_cleaners": "Limpiadores en el plan",
    "cleaning_work_plan_summary_avg_minutes": "Min promedio / limpieza",
    "cleaning_work_plan_suggested_hours": "Horas totales sugeridas",
    "cleaning_work_plan_actual_hours": "Horas totales reales",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Promedio min sugeridos / limpiador",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Promedio min reales / limpiador",
    "cleaning_work_plan_guidelines_title": "Guías de optimización",
    "cleaning_work_plan_guidelines_intro": "Esta herramienta sigue los mismos objetivos que la optimización manual del plan de limpieza: carga de trabajo basada en visitas, tiempo basado en minutos promedio por limpieza y dotación equilibrada manteniendo coherencia geográfica por pisos.",
    "cleaning_work_plan_guidelines_b1": "Visitas por limpieza (predeterminado 50) sigue la regla 1:50: acciones sugeridas por sala aproximadamente igual a visitas dividido por visitas por limpieza (redondeado hacia arriba). Visitas y llegadas se toman del día más cargado del período seleccionado.",
    "cleaning_work_plan_guidelines_b2": "Cuando defines la cantidad de limpiadores, cada piso del edificio es un grupo. Los pisos se ordenan por edificio y número, y luego se reparten en bloques contiguos entre limpiadores para equilibrar la carga sugerida y mantener pisos cercanos con la misma persona.",
    "cleaning_work_plan_guidelines_b3": "Todos los baños del mismo piso quedan con el mismo limpiador, así que los baños de hombres y mujeres de ese piso no se separan entre diferentes personas (siempre que compartan el mismo valor de piso en el panel de control).",
    "cleaning_work_plan_guidelines_b4": "El promedio de minutos por limpieza impulsa minutos y horas totales sugeridos y reales, y el promedio por limpiador. Los totales reales usan llegadas registradas de limpiadores por tu promedio; los sugeridos usan limpiezas implícitas por tu promedio.",
    "cleaning_work_plan_guidelines_b5": "Usa Exportar CSV si quieres refinar la asignación en otra herramienta (por ejemplo, para ajustar aún más el balance de visitas).",
    "cleaning_performed": "Limpieza realizada",
  },
  ar: {
    "cleaned_floor": "الارضية نظيفة",
    "cleaned_toilet": "تم تنظيف المراحيض",
    "cleaned_shower": "تم تنظيف الخزائن",
    "cleaned_sink": "تم تنظيف الحوض",
    "cleaned_mirror": "المرآة نظيفة",
    "cleaned_stainless_steel": "تم تنظيف النيروستا",
    "bad_smell": "رائحة كريهة",
    "dirty_floor": "ارضية متسخة",
    "dirty_lavatory_seat": "مقعد المرحاض متسخ",
    "dirty_shower": "الخزائن متسخة",
    "dirty_sink": "الحوض متسخ",
    "dirty_mirror": "المرآة متسخة",
    "dirty_stainless_steel": "النيروستا متسخة",
    "missing_paper_towel": "لا يوجد ورق لليدين",
    "missing_soap": "لا يوجد صابون",
    "missing_toilet_paper": "لا يوجد ورق تواليت",
    "problem_shower": "مشكلة في الخزانة",
    "problem_sink": "مشكلة في الحوض",
    "problem_mirror": "مشكلة في المرأة",
    "problem_stainless_steel": "مشكلة في النيروستا",
    "problem_blockage": "انسداد",
    "problem_door": "مشكلة في الباب",
    "problem_fluid_taps": "حنفيات مسربة",
    "problem_lightning": "مشكلة اضاءة",
    "problem_broken_toilet": "مقعد حمام مكسور",
    "fixed_shower": "تم ترتيب الخزائن",
    "fixed_sink": "تمت معالجة الحوض",
    "fixed_mirror": "تمت معالجة المرآة",
    "fixed_stainless_steel": "تمت معالجة النيروستا",
    "fixed_blockage": "تمت معالجة الانسداد",
    "fixed_door": "تمت معالجة الباب",
    "fixed_fluid_taps": "تمت معالجة التسرب",
    "fixed_lightning": "تمت معالجة الاضاءة",
    "fixed_broken_toilet": "تمت معالجة مقعد الحمام",
    "very_good": "جيد جدا",
    "excellent": "ممتاز",
    "good": "جيد",
    "like": "لايك",
    "needs_improvement": "يحتاج الى تحسين",
    "not_good": "غير جيد",
    "supervise": "المشرف",
    "maintenance": "صيانة",
    "cleaner": "عاملة النظافة",
    "tag_cleaner": "جهاز استشعار وصول عاملة النظافة",
    "zone_is_clean": "مشرف المنطقة نظيف",
    "zone_is_dirty": "مشرف المنطقة متسخ",
    "cleaner_arrived": "وصل عامل النظافة",
    "start_clean_zone": "بداية النظافة",
    "counter": "عدّاد",
    "counter_men": "عدد الرجال",
    "counter_woman": "عدد النساء",
    "counter_handycap": "عدد المعاقين",
    "full_garbage_can": "سلة نفايات ممتلئة",
    "maintenance_fixed": "تمت معالجة الصيانة",
    "maintenance_problem": "مشكلة صيانة",
    "problem_soap_dispenser": "مشكلة مرفق صابون",
    "problem_paper_dispenser": "مشكلة مرفق ورق",
    "end_clean_zone": "الانتهاء من النظافة",
    "status_toilet_paper": "جهاز استشعار ورق التواليت",
    "status_hend_paper": "جهاز استشعار ورق اليدين",
    "fixed": "سليم",
    "status_soap": "جهاز استشعار الصابون السائل",
    "status_garbage_can": "جهاز استشعار سلة النفايات",
    "general_cleaning": "النظافة العامة",
    "coffee_tea": "قهوة/شاي",
    "water_bar": "مرفق للماء",
    "disposable_dishes": "اواني للاستعمال مرة واحدة",
    "head_coverage": "غطاء لمرة واحدة",
    "something_else": "شيء اخر",
    "missing_clothing": "نقص في الملابس",
    "maintenance_link": "ممر صيانة",
    "problem_maintenance": "مشكلة صيانة",
    "supervise_link": "ممر مشرف",
    "cleaner_link": "ممر عاملة نظافة",
    "room_men+link": "ممر غرفه ايجابي للرجال",
    "room_men-link": "ممر غرفه سلبي للرجال",
    "room_women+link": "ممر غرفه ايجابي للنساء",
    "room_women-link": "ممر غرفه سلبي للنساء",
    "hebrew": "العبرية",
    "español": "الاسبانية",
    "français": "الفرنسية",
    "english": "الانجليزية",
    "русский": "الروسية",
    "italiano": "الايطالية",
    "arabic": "العربية",
    "አማርኛ": "الامهرية",
    "português": "البرتغالية",
    "partial_information": "معلومات جزئية",
    "professionalism": "المهنية",
    "the_attitude_of_the_representative": "موقف المندوب",
    "waiting_time_for_service": "وقت الانتظار للخدمة",
    "other_aspect_of_service": "جانب اخر للخدمة",
    "language_of_the_service": "لغة الخدمة",
    "procedure_for_making_an_appointment": "اتخاذ تحديد اجتماع",
    "physical_conditions": "الشروط الجسدية",
    "found_another": "في النهاية وجدت اخراً",
    "found_similar": "وجدت شيئا مشابهاً",
    "did_not_find": "لم اجد",
    "found": "مجدت المنتج",
    "need_improved": "يمكن التحسين",
    "liked": "احببت",
    "pleasant": "لطيفة",
    "eilat_resident": "انا مواطن في ايلات",
    "once_a_week": "مرة في الاسبوع",
    "once_a_month": "مرة في الشهر",
    "twice_a_year": "مرتين الى ثلاث في العام",
    "once_a_year": "مرة في العام",
    "friend": "صديق",
    "newspaper": "جريدة",
    "google": "جوجل",
    "zap": "زاب",
    "vacuum_cleaner": "مكنسة كهربائية",
    "gaming_consoles": "لوحات مفاتيح العاب",
    "laptop": "حاسوب متنقل",
    "cellular": "خليوي",
    "shop": "حوانيت",
    "restaurant_complex_cleaning": "نظافة مجمع المطعم",
    "dining_room": "غرفة الطعام",
    "food_variety": "تنوع الطعام",
    "quality_of_the_food": "جودة الطعام",
    "amount_of_the_food": "كمية الطعام",
    "quality_of_cooking": "جودة الطهي",
    "side_courses": "الاضافات",
    "meat": "لحوم",
    "desserts": "حلويات",
    "vegetarian": "نباتي",
    "salad_bar": "سلطات",
    "main_courses": "الوجبة الاساسية",
    "service": "الخدمة",
    "dining_room_cleanliness": "نظافة المجمع",
    "plates_and_cutlery_cleanliness": "نظافة اواني وادوات تناول الطعام",
    "product_inventory": "مخزون المنتجات",
    "furnishers": "الاثاث",
    "toilets": "الحمامات",
    "problem_coffee_machine": "مشكلة في ماكينة القهوة",
    "problem_water_bar": "مشكلة في بار الماء",
    "dirty_stairs": "درجات المدخل متسخة",
    "toiletries": "مستلزمات المرحاض",
    "fixed_soap_dispenser": "تمت معالجة مرفق الصابون",
    "fixed_paper_dispenser": "تمت معالجة مرفق الورق",
    "fixed_coffee_machine": "تمت معالجة ماكينة القهوة",
    "fixed_water_bar": "تمت معالجة بار المياه",
    "problem_urinals": "مرفق بول معطوب",
    "blockage_toilet": "وعاء ماء المرحاض معطوب",
    "appliance_problem": "جهاز كهربائي معطوب",
    "problem_broken_door": "باب مكسور",
    "problem_door_lock": "مشكلة في قفل الباب",
    "problem_broken_toilet_seat": "مقعد حمام مكسور",
    "problem_broken_niagara": "وعاء ماء الحمام مكسور",
    " broken_hand_paper_dispenser_hand_dryer": "مشكلة مجفف اليدين او الموزع",
    "rug": "السجادة",
    "tables": "الطاولات",
    "kitchen": "مطبخ",
    "air_condition": "التكييف",
    "dirty_urinals": "مرفق البول متسخ",
    "hand_dryer": "مجفف اليدين",
    "non_sticky_carpet": "سجادة غير لاصقة",
    "problem_bad_smell": "مشكلة رائحة كريهة",
    "problem_broken_toilet_handle": "مشكلة في مقبض الحمام",
    "problem_handle_door": "مشكلة في مقبض الباب",
    "call_cleaner": "طلب عامل نظافة",
    "wall_painting": "صباغة الجدران",
    "missing_paper": "لا يوجد ورق",
    "clean_surface": "نظافة الاسطح",
    "problem_right_elevator": "خلل في المصعد الأيمن",
    "problem_left_elevator": "خلل في المصعد الايسر",
    "missing_hand_sanitizer": "البخّاخ المطهر مفقود",
    "problem_sink_blockage": "خلل حوض مسدود",
    "electric_problem": "مشكلة كهرباء",
    "missing_coffe_tea": "لا يوجد قهوة/شاي",
    "problem_air_condition": "مشكلة تكييف",
    "dishwashing": "غسل الاواني",
    "kitchen_cleanliness": "نظافة المطبخ",
    "weekly_cleaning": "التنظيف الاسبوعي",
    "general_arrangement": "الترتيب العام",
    "meeting_room": "غرفة اجتماعات",
    "refrigerator": "برّاد",
    "kitchen_supplies": "تزويد المطبخ",
    "toilet_services": "تزوبد الحمام",
    "carousel_door": "الباب الدائري",
    "desk": "نافذة",
    "compressor": "مكبس",
    "compressor_rails": "مكبس القضبان",
    "compressor_drainage": "مكبس تصريف",
    "dust": "غبار",
    "door": "باب",
    "scotch": "سكوتش",
    "food": "طعام",
    "room_conditions": "الظروف في الغرفة",
    "kindness_sensitivity": "اللباقة والحياسية",
    "explain_process": "شرح العملية",
    "personal_attention": "المعاملة الشخصية",
    "service_problem": "مشكلة خدمة",
    "welcome_you": "استقبلك بالترحاب",
    "invoice_submitted": "قدم الفاتورة ملائمة للمنتج",
    "thank_you_bought": "شكرك انك اشتريت من yellow",
    "problem_seller": "مشكلة بائع",
    "lapel_pin": "يضع دبوس مستدير تطبيق",
    "proper_performance": "بمظهر سليم",
    "name_tag": "يضع دبوس الاسم",
    "operational": "عرض حملات الشهر",
    "app_revealed": "عرض عليك التطبيق",
    "register_load": "ازدحام عند الصندوق",
    "visibility_problem": "مشكلة المظهر",
    "clean_storefront": "ساحة مدخل الحانوت نظيفة",
    "clean_garbage": "سلال المهملات نظيفة وغير",
    "clean_tables_chairs": "الطاولات والكراسي نظيفة",
    "clean_shop_floor": "ارضية الحانوت نظيفة",
    "product_show": "معرض المنتجات ممتلئ",
    "refrigerators_show": "معرض البرادات ممتلئ ونظيف",
    "coffee_accessories": "مرفق مستلزمات القهوة نظيف ومزود",
    "cleanliness": "النظافة",
    "convenience_scheduling_appointments": "سهولة تحديد الادوار",
    "waiting_haircut": "الانتظار لقص الشعر",
    "courtesy_books": "أدب مصففي الشعر",
    "books_professionalism": "مهنية مصففي الشعر",
    "received_time": "استقبلوني في الوقت المحدد",
    "dnot_appointment": "لم احدد دورا",
    "an_appointment": "حددت دورا",
    "tasty": "شهي",
    "courtesy_service": "لباقة الخدمة",
    "overall_experience": "التجربة العامة",
    "not_clean": "ليس نظيفا",
    "diningroom_not_clean": "غرفة الطعام ليست نظيفة",
    "unclean_dishes": "الاواني ليست نظيفة",
    "so-so": "بين بين",
    "not_tasty": "ليس شهيا",
    "kind": "مؤدب",
    "not_kind": "ليس مؤدبا",
    "clean": "نظيفا",
    "hairdresser": "مصفف شعر",
    "wrong_price": "سعر غير صحيح",
    "produc_has_expired": "منتهية الصلاحية المنتج",
    "missing_item": "مادة مفقودة",
    "item_is_faulty_in_the_machine": "عنصر عالق في عطل الجهاز",
    "machine_cleaning": "آلة التنظيف",
    "improper_temperature": "درجة حرارة غير طبيعية",
    "green": "اخضر",
    "orange": "برتقالي",
    "red": "احمر",
    "yellow": "اصفر",
    "red not prob": "احمر",
    "professional": "المحترفين",
    "unprofessional": "غير مهني",
    "delicacies": "الكفاءة",
    "sandwiches": "السندويشات",
    "vegetables": "خضروات",
    "fruits": "فواكه",
    "salads": "سلطة",
    "milk": "حليب",
    "room_link": "غرفة عبور",
    "floor_link": "طابق عبور",
    "services": "تزويد",
    "check_list": "قائمة",
    "lighting_problem_lobby": "مشكلة الإضاءة في الردهة",
    "lighting_problem_garbage_room": "مشكلة الإضاءة في غرفة القمامة",
    "lighting_problem_stairwell": "مشكلة الإضاءة في غرفة الدرج",
    "problem_elevator_1": "خطأ في الرفع 1",
    "problem_elevator_2": "خطأ في المصعد 2",
    "problem_elevator_3": "خطأ في الرفع 3",
    "problem_elevator_4": "خطأ في الرفع 4",
    "problem_elevator_5": "خطأ في الرفع 5",
    "problem_elevator_6": "خطأ في المصعد 6",
    "problem_elevator_7": "خطأ في المصعد 7",
    "problem_elevator_8": "خطأ في المصعد 8",
    "problem_elevator_9": "خطأ في الرفع 9",
    "problem_elevator_10": "خطأ في الرفع 10",
    "stuck_item": "السلعة عالقة",
    "spoiling_product": "منتج مدلل",
    "machine_malfunction": "عطل الجهاز",
    "unreadable_product": "منتج غير قابل للقراءة",
    "i_am_satisfied": "انا راضي",
    "beverage": "المشروبات",
    "program_malfunction": "برنامج خطأ",
    "machine_1": "آلة 1.",
    "machine_2": "آلة 2",
    "machine_3": "آلة 3.",
    "machine_4": "آلة 4.",
    "program malfunction 1": "عطل البرنامج 1.",
    "program malfunction 2": "عطل البرنامج 2.",
    "program malfunction 3": "عطل البرنامج 3",
    "program malfunction 4": "عطل البرنامج 4.",
    "fish": "سمكه",
    "chicken": "دجاج",
    "full_dining_room": "غرفة الطعام الكامل",
    "missing_amount": "مفقود المبلغ",
    "missing_trays": "صواني مفقودة",
    "dirty_floor_g1": "نظافة الدفيئة 1",
    "dirty_floor_g2": "نظافة الدفيئة 2",
    "dirty_floor_g3": "نظافة الدفيئة 3",
    "dirty_floor_g4": "نظافة الدفيئة 4",
    "dirty_floor_g5": "نظافة الدفيئة 5",
    "dirty_floor_eo": "نظافة مكتب مساعد المدير العام",
    "dirty_floor_ceo": "نظافة مكتب المدير العام",
    "dirty_floor_storage": "النظافة في طابق المخزن",
    "dirty_floor_inflorescence": "نظافة المزهرية",
    "operating_instructions": "تعليمات التشغيل",
    "general": "عام",
    "connection_problem": "مشكلة في التوصيل",
    "lighting": "الاضاءة",
    "not _fixed": "غير صالح",
    "cleaning_needed": "التنظيف مطلوب",
    "missing_milk": "لا يوجد حليب",
    "no_sugar_coffee": "لا يوجد سكر/قهوة",
    "missing_tools": "لا يوجد اواني",
    "coffee_water_machine": "ماكينات القهوة/ماكينات المياه",
    "appliances": "المنتجات الكهربائية",
    "products": "منتجات",
    "broken_chair": "اثاث معطوب",
    "broken_cabinet": "خزانة مكسورة",
    "micro": "ميكرو",
    "toaster": "توستر",
    "clogged_sink_malfunction": "خلل حوض مسدود",
    "coffee_cooling_malfunction": "خلل في تبريد القهوة",
    "no_coffee_beans": "حب القهوة غير موجود",
    "machine_failure": "خلل في الماكينة",
    "that_dirty": "الشايش متسخ",
    "dirty_refrigerator": "البراد متسخ",
    "dirty_tables": "الطاولات متسخة",
    "plates": "الصحون",
    "silver_spoon": "ملعقة فضية",
    "cold_drinks_cups": "اكواب المشروبات البارده",
    "hot_drink_cups": "اكواب المشروبات الساخنة",
    "a_dripping_faucet": "حنفية تنقيط",
    "disposable dishes": "اواني للاستعمال مرة واحدة",
    "problem_ coffee_water_machine": "مشكلة ماكينات القهوة/ماكينات المياه",
    "problem_micro": "مشكلة ميكرو",
    "problem_toaster": "مشكلة توستر",
    "problem_machine_failure": "مشكلة خلل في الماكينة",
    "problem refrigerator": "مشكلة براد",
    "no_sugar/coffee": "لا يوجد سكر/قهوة",
    "missing_dishes": "لا يوجد اواني",
    "coffee/water_machine": "ماكينات القهوة/ماكينات المياه",
    "coffee_machine_door_open": "فتح آلة القهوة",
    "coffee_machine_door_close": "أغلقت آلة القهوة",
    "coffee_machine_bin_full": "آلة القهوة الكامل",
    "coffee_machine_bin_empty": "آلة القهوة فارغة",
    "coffee_machine_coffee_full": "القهوة القهوة الكاملة",
    "coffee_machine_coffee_empty": "القهوة والقهوة الفارغة",
    "coffee_machine_water_tank_empty": "آلة القهوة المياه فارغة",
    "coffee_machine_ water_tank_full": "آلة القهوة الكامل",
    "coffee_machine_milk_cleaning_not_performed": "آلة تنظيف آلة القهوة لا يؤديها",
    "coffee_machine _milk_cleaning_performed": "آلة تنظيف آلة القهوة",
    "coffee_machine_head_cleaning_not_performed": "آلة القهوة ورأس التنظيف لم تؤدي",
    "coffee_machine_head_ cleaning_performed": "يتم إجراء تنظيف آلة القهوة",
    "coffee_machine_descaling_not_performed": "آلة القهوة descaling لم تؤدي",
    "coffee_machine_descaling_performed": "آلة صنع القهوة descaling",
    "floor_one": "الطابق 1",
    "floor_two": "الطابق 2",
    "floor_three": "الطابق 3",
    "floor_four": "الطابق 4",
    "floor_five": "الطابق 5",
    "floor_six": "الطابق 6",
    "floor_seven": "الطابق 7",
    "floor_eight": "الطابق 8",
    "floor_nine": "الطابق 9",
    "floor_ten": "الطابق 10",
    "floor_eleven": "الطابق 11",
    "floor_twelve": "الطابق 12",
    "floor_thirteen": "الطابق 13",
    "floor_fourteen": "الطابق 14",
    "floor_fifteen": "الطابق 15",
    "floor_sixteen": "الطابق 16",
    "floor_seventeen": "الطابق 17",
    "floor_eighteen": "الطابق 18",
    "floor_nineteen": "الطابق 19",
    "floor_twenty": "الطابق 20",
    "floor_twenty_one": "الطابق 21",
    "floor_twenty_two": "الطابق 22",
    "floor_twenty_three": "الطابق 23",
    "floor_twenty_four": "الطابق 24",
    "floor_twenty_five": "الطابق 25",
    "status_toilet_paper_cell_01_-_empty": "حالة خزان ورق الحمام 01 - فارغ",
    "status_toilet_paper_cell_02_-_empty": "حالة خزان ورق الحمام 02 - فارغ",
    "status_toilet_paper_cell_03_-_empty": "حالة خزان ورق الحمام 03 - فارغ",
    "status_toilet_paper_cell_04_-_empty": "حالة خزان ورق الحمام 04 - فارغ",
    "status_toilet_paper_cell_05_-_empty": "حالة خزان ورق الحمام 05 - فارغ",
    "status_toilet_paper_cell_06_-_empty": "حالة خزان ورق الحمام 06 - فارغ",
    "status_toilet_paper_cell_07_-_empty": "حالة خزان ورق الحمام 07 - فارغ",
    "status_toilet_paper_cell_08_-_empty": "حالة خزان ورق الحمام 08 - فارغ",
    "status_toilet_paper_cell_09_-_empty": "حالة خزان ورق الحمام 09 - فارغ",
    "status_toilet_paper_cell_10_-_empty": "حالة خزان ورق الحمام 10 - فارغ",
    "status_toilet_paper_cell_11_-_empty": "حالة خزان ورق الحمام 11 - فارغ",
    "status_toilet_paper_cell_12_-_empty": "حالة خزان ورق الحمام 12 - فارغ",
    "status_toilet_paper_cell_13_-_empty": "حالة خزان ورق الحمام 13 - فارغ",
    "status_toilet_paper_cell_14_-_empty": "حالة خزان ورق الحمام 14 - فارغ",
    "status_toilet_paper_cell_15_-_empty": "حالة خزان ورق الحمام 15 - فارغ",
    "status_toilet_paper_cell_16_-_empty": "حالة خزان ورق الحمام 16 - فارغ",
    "status_toilet_paper_cell_17_-_empty": "حالة خزان ورق الحمام 17 - فارغ",
    "status_toilet_paper_cell_18_-_empty": "حالة خزان ورق الحمام 18 - فارغ",
    "status_toilet_paper_cell_19_-_empty": "حالة خزان ورق الحمام 19 - فارغ",
    "status_toilet_paper_cell_20_-_empty": "حالة خزان ورق الحمام 20 - فارغ",
    "status_toilet_paper_cell_01_-_almost_empty": "حالة خزان ورق الحمام 01 - تقريبا فارغ",
    "status_toilet_paper_cell_02_-_almost_empty": "حالة خزان ورق الحمام 02 - تقريبا فارغ",
    "status_toilet_paper_cell_03_-_almost_empty": "حالة خزان ورق الحمام 03 - تقريبا فارغ",
    "status_toilet_paper_cell_04_-_almost_empty": "حالة خزان ورق الحمام 04 - تقريبا فارغ",
    "status_toilet_paper_cell_05_-_almost_empty": "حالة خزان ورق الحمام 05 - تقريبا فارغ",
    "status_toilet_paper_cell_06_-_almost_empty": "حالة خزان ورق الحمام 06 - تقريبا فارغ",
    "status_toilet_paper_cell_07_-_almost_empty": "حالة خزان ورق الحمام 07 - تقريبا فارغ",
    "status_toilet_paper_cell_08_-_almost_empty": "حالة خزان ورق الحمام 08 - تقريبا فارغ",
    "status_toilet_paper_cell_09_-_almost_empty": "حالة خزان ورق الحمام 09 - تقريبا فارغ",
    "status_toilet_paper_cell_10_-_almost_empty": "حالة خزان ورق الحمام 10 - تقريبا فارغ",
    "status_toilet_paper_cell_11_-_almost_empty": "حالة خزان ورق الحمام 11 - تقريبا فارغ",
    "status_toilet_paper_cell_12_-_almost_empty": "حالة خزان ورق الحمام 12 - تقريبا فارغ",
    "status_toilet_paper_cell_13_-_almost_empty": "حالة خزان ورق الحمام 13 - تقريبا فارغ",
    "status_toilet_paper_cell_14_-_almost_empty": "حالة خزان ورق الحمام 14 - تقريبا فارغ",
    "status_toilet_paper_cell_15_-_almost_empty": "حالة خزان ورق الحمام 15 - تقريبا فارغ",
    "status_toilet_paper_cell_16_-_almost_empty": "حالة خزان ورق الحمام 16 - تقريبا فارغ",
    "status_toilet_paper_cell_17_-_almost_empty": "حالة خزان ورق الحمام 17 - تقريبا فارغ",
    "status_toilet_paper_cell_18_-_almost_empty": "حالة خزان ورق الحمام 18 - تقريبا فارغ",
    "status_toilet_paper_cell_19_-_almost_empty": "حالة خزان ورق الحمام 19 - تقريبا فارغ",
    "status_toilet_paper_cell_20_-_almost_empty": "حالة خزان ورق الحمام 20 - تقريبا فارغ",
    "of": "من",
    "items": "العناصر",
    "loading_charts": "جارٍ تحميل الرسوم البيانية",
    "refresh_the_room": "إنعش الغرفة",
    "clean_the_floor": "نظّف الأرضية",
    "clean_the_toilet": "نظّف المرحاض",
    "refill_soap": "أعد تعبئة الصابون",
    "change_roll": "استبدل لفافة ورق التواليت",
    "great_job": "عمل رائع",
    "empty_the_trash": "أفرغ سلة المهملات",
    "repair_required": "بحاجة إلى إصلاح",
    "cleaning": "تنظيف",
    "cleaning_work_plan": "خطة عمل التنظيف",
    "cleaning_work_plan_intro": "يستخدم إحصاءات غرف الورديات للشركة والموقع المحددين في أعلى الصفحة. الزيارات والوصولات تؤخذ من اليوم الأعلى زيارة ضمن الفترة المحددة، ومن الورديات في فلتر لوحة التحكم (اضبطها من Performance أو Analytics إذا كانت عناصر الوقت والفلتر مخفية في هذه التبويب). أدخل الزيارات لكل تنظيف، هدف حجم الطاقم، تكلفة الساعة، ومتوسط وقت التنظيف بالدقائق؛ أنشئ الخطة لعرض عمليات التنظيف المقترحة لكل غرفة والإجماليات في الملخص.",
    "cleaning_work_plan_default_n": "الزيارات لكل تنظيف",
    "cleaning_work_plan_cleaner_count": "عمال النظافة (اختياري)",
    "cleaning_work_plan_avg_minutes": "متوسط وقت التنظيف (دقيقة)",
    "cleaning_work_plan_run": "إنشاء الخطة",
    "cleaning_work_plan_export_csv": "تصدير إلى Excel",
    "cleaning_work_plan_suggested_n": "الزيارات لكل تنظيف",
    "cleaning_work_plan_actual_cleans": "الوصولات",
    "cleaning_work_plan_actual_cleans_hint": "إجمالي وصولات عمال النظافة في إحصاءات غرف الورديات في يوم الذروة (ضمن الفترة والفلاتر المحددة).",
    "cleaning_work_plan_suggested_cleans": "عمليات تنظيف مقترحة",
    "cleaning_work_plan_cleaner": "عامل نظافة",
    "cleaning_work_plan_floors": "الطوابق",
    "cleaning_work_plan_peak_day": "يوم الذروة",
    "cleaning_work_plan_error": "تعذر إنشاء خطة عمل التنظيف",
    "cleaning_work_plan_no_rooms": "لم يتم إرجاع أي غرف لهذا الموقع. تحقق من الموقع ونطاق التاريخ، أو تأكد من وجود الغرف في لوحة التحكم.",
    "cleaning_work_plan_need_filter": "اختر الشركة والموقع من الأعلى، وحدد فترة زمنية (وورديات عند الحاجة) من Performance أو Analytics، ثم حاول مرة أخرى.",
    "cleaning_work_plan_settings": "إعدادات الخطة",
    "cleaning_work_plan_desired_employees": "العدد المرغوب للموظفين",
    "cleaning_work_plan_cost_per_hour": "تكلفة الساعة",
    "cleaning_work_plan_estimated_cost_suggested": "تكلفة تقديرية (عبء مقترح)",
    "cleaning_work_plan_estimated_cost_actual": "تكلفة تقديرية (عبء فعلي)",
    "cleaning_work_plan_hours_per_cleaner": "ساعات لكل عامل نظافة",
    "cleaning_work_plan_metric_title": "المؤشرات",
    "cleaning_work_plan_metric_avg_cleaning_min": "متوسط وقت التنظيف (دقيقة)",
    "cleaning_work_plan_metric_total_arrivals": "إجمالي الوصولات",
    "cleaning_work_plan_metric_total_cleaning_min": "إجمالي وقت التنظيف (دقيقة)",
    "cleaning_work_plan_metric_total_cleaning_hours": "إجمالي وقت التنظيف (ساعات)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "ساعات لكل عامل نظافة",
    "cleaning_work_plan_metric_num_cleaners": "عدد عمال النظافة",
    "cleaning_work_plan_summary": "الملخص",
    "cleaning_work_plan_summary_peak_note": "تستخدم الزيارات والوصولات والتنظيفات المقترحة نفس قواعد إحصاءات غرف الورديات المستخدمة في Analytics (بما في ذلك تجميع الوصولات). تُحسب الأرقام ليوم الذروة - اليوم التقويمي الأعلى زيارة ضمن فترة الفلترة. يتم تضمين الغرف المحسوبة فقط.",
    "cleaning_work_plan_summary_filter_period": "فترة الفلترة",
    "cleaning_work_plan_summary_total_visits": "إجمالي الزيارات",
    "cleaning_work_plan_summary_total_arrivals": "إجمالي الوصولات",
    "cleaning_work_plan_summary_employees_in_site": "الموظفون في الموقع",
    "cleaning_work_plan_summary_shift_working_hours": "ساعات الوردية",
    "cleaning_work_plan_hours_unit": "س",
    "cleaning_work_plan_rooms_table": "الغرف",
    "cleaning_work_plan_cleaners_table": "التوزيع المقترح لعمال النظافة",
    "cleaning_work_plan_search_rooms": "بحث عن الغرف",
    "cleaning_work_plan_total_minutes": "إجمالي الدقائق",
    "cleaning_work_plan_actual_total_minutes": "إجمالي الدقائق الفعلية",
    "cleaning_work_plan_actual_total_minutes_hint": "وصولات عمال النظافة المسجلة في إحصاءات غرف الورديات في يوم الذروة (ضمن الفترة المحددة) مضروبة في متوسط الدقائق لكل تنظيف.",
    "cleaning_work_plan_suggested_total_minutes": "إجمالي الدقائق المقترحة",
    "cleaning_work_plan_suggested_room_minutes": "دقائق التنظيف المقترحة",
    "cleaning_work_plan_actual_room_minutes": "دقائق التنظيف الفعلية",
    "cleaning_work_plan_cleaner_suggested_minutes": "دقائق مقترحة",
    "cleaning_work_plan_cleaner_actual_minutes": "دقائق فعلية",
    "cleaning_work_plan_period": "الفترة",
    "cleaning_work_plan_room_count": "عدد الغرف",
    "cleaning_work_plan_cleaners_working_in_site": "عمال نظافة في الموقع (جهات اتصال التطبيق)",
    "cleaning_work_plan_cleaners_connection_table": "عمال النظافة حسب الغرف",
    "cleaning_work_plan_connected_rooms_count": "غرف",
    "cleaning_work_plan_connected_floor_count": "عدد الطوابق",
    "cleaning_work_plan_connected_floors_list": "الطوابق",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "نسبة الزائر / دخول التنظيف",
    "cleaning_work_plan_performance_comparison_table": "مقارنة الأداء",
    "cleaning_work_plan_performance_comparison_empty": "حمّل بيانات ربط عمال النظافة لعرض الصفوف.",
    "cleaning_work_plan_performance_col_index": "المؤشر",
    "cleaning_work_plan_performance_existing_plan": "خطة العمل الحالية",
    "cleaning_work_plan_performance_recommended_plan": "خطة Buzzztech الموصى بها",
    "cleaning_work_plan_perf_number_of_employees": "عدد الموظفين",
    "cleaning_work_plan_perf_working_hours_per_employee": "ساعات العمل لكل موظف",
    "cleaning_work_plan_perf_total_working_hours": "إجمالي ساعات العمل",
    "cleaning_work_plan_perf_total_cleaning_hours": "إجمالي ساعات التنظيف",
    "cleaning_work_plan_perf_daily_cost": "التكلفة اليومية",
    "cleaning_work_plan_perf_total_cleaning_visits": "إجمالي زيارات التنظيف",
    "cleaning_work_plan_perf_busiest_area_visits": "أكثر منطقة عمل ازدحامًا — الزيارات",
    "cleaning_work_plan_perf_cleaning_to_busiest": "زيارات التنظيف لأكثر منطقة ازدحامًا",
    "cleaning_work_plan_perf_max_cleaning_ratio": "أقصى نسبة تنظيف",
    "cleaning_work_plan_perf_least_busy_visits": "أقل منطقة عمل ازدحامًا — الزيارات",
    "cleaning_work_plan_perf_cleaning_to_least": "زيارات التنظيف لأقل منطقة ازدحامًا",
    "cleaning_work_plan_perf_min_cleaning_ratio": "أدنى نسبة تنظيف",
    "cleaning_work_plan_ai_allocate": "توزيع بالذكاء الاصطناعي",
    "cleaning_work_plan_ai_allocation_result": "نتيجة التوزيع بالذكاء الاصطناعي",
    "cleaning_work_plan_ai_allocation_loading": "جارٍ إنشاء التوزيع بالذكاء الاصطناعي...",
    "cleaning_work_plan_ai_allocation_error": "فشل إنشاء التوزيع بالذكاء الاصطناعي. يرجى المحاولة مرة أخرى.",
    "cleaning_work_plan_ai_invalid_employees": "يرجى تحديد عدد صالح من الموظفين المطلوبين.",
    "cleaning_work_plan_ai_status_elapsed": "المنقضي: {s} ث",
    "cleaning_work_plan_ai_status_hint": "يشغّل الخادم عدة خطوات للذكاء الاصطناعي بالتتابع (خطة أولية، جغرافيا، توازن الزيارات، ثم المخرجات النهائية). قد يستغرق ذلك دقيقة أو دقيقتين—يرجى إبقاء هذه الصفحة مفتوحة.",
    "cleaning_work_plan_ai_status_step_1": "الخطوة 1 — مسودة تعيين أولية من بيانات الغرف والزيارات…",
    "cleaning_work_plan_ai_status_step_2": "الخطوة 2 — تحسين الجغرافيا (تجميع الطوابق والمباني القريبة)…",
    "cleaning_work_plan_ai_status_step_3": "الخطوة 3 — موازنة الزيارات اليومية بين عمال النظافة…",
    "cleaning_work_plan_ai_status_step_4": "الخطوة 4 — إنشاء التوزيع المنظم…",
    "cleaning_work_plan_ai_status_step_5": "الخطوة 5 — التحقق وحساب المقاييس النهائية…",
    "cleaning_work_plan_ai_cleaner_number": "عامل النظافة #",
    "cleaning_work_plan_room_minutes": "دقائق التنظيف",
    "cleaning_work_plan_assigned_cleaner": "عامل النظافة المعيّن",
    "cleaning_work_plan_summary_cleaners": "عدد عمال النظافة في الخطة",
    "cleaning_work_plan_summary_avg_minutes": "متوسط الدقائق / تنظيف",
    "cleaning_work_plan_suggested_hours": "إجمالي الساعات المقترحة",
    "cleaning_work_plan_actual_hours": "إجمالي الساعات الفعلية",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "متوسط الدقائق المقترحة / عامل",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "متوسط الدقائق الفعلية / عامل",
    "cleaning_work_plan_guidelines_title": "إرشادات التحسين",
    "cleaning_work_plan_guidelines_intro": "تتبع هذه الأداة نفس أهداف تحسين خطة التنظيف اليدوية: عبء العمل من بيانات الزيارات، الزمن من متوسط الدقائق لكل تنظيف، وتوزيع الطاقم بشكل متوازن مع مراعاة التجاور الجغرافي للطوابق.",
    "cleaning_work_plan_guidelines_b1": "الزيارات لكل تنظيف (الافتراضي 50) تطابق قاعدة 1:50 المعتادة: عدد عمليات التنظيف المقترحة لكل غرفة يساوي تقريبًا الزيارات مقسومة على الزيارات لكل تنظيف (مع التقريب للأعلى). تؤخذ الزيارات والوصولات من اليوم الأكثر ازدحامًا ضمن الفترة المحددة.",
    "cleaning_work_plan_guidelines_b2": "عند تحديد عدد عمال النظافة، يُعد كل طابق في المبنى مجموعة مستقلة. تُرتب الطوابق حسب المبنى ورقم الطابق ثم تُقسم إلى كتل متجاورة بين العمال لتحقيق توازن أفضل مع إبقاء الطوابق القريبة لدى العامل نفسه قدر الإمكان.",
    "cleaning_work_plan_guidelines_b3": "تبقى جميع دورات المياه في الطابق نفسه مع عامل النظافة نفسه، لذلك لا يتم تقسيم غرف الرجال والنساء في الطابق ذاته بين عمال مختلفين (طالما أن قيمة الطابق متطابقة في لوحة التحكم).",
    "cleaning_work_plan_guidelines_b4": "متوسط الدقائق لكل تنظيف هو ما يحدد إجمالي الدقائق والساعات المقترحة والفعلية ومتوسط الدقائق لكل عامل. الإجماليات الفعلية تستخدم الوصولات المسجلة x متوسطك؛ والإجماليات المقترحة تستخدم التنظيفات المحسوبة x متوسطك.",
    "cleaning_work_plan_guidelines_b5": "استخدم تصدير CSV إذا أردت تحسين التوزيع في مكان آخر (مثل تحسين توازن الزيارات بشكل أكبر).",
    "cleaning_performed": "تم إجراء التنظيف",
  },
  pl: {
    "cleaned_floor": "Wyczyszczono podłogi",
    "cleaned_toilet": "Wyczyszczono toaletę",
    "cleaned_shower": "Wyczyszczono prysznic",
    "cleaned_sink": "Wyczyszczono umywalkę",
    "cleaned_mirror": "Wyczyszczono lustro",
    "cleaned_stainless_steel": "Wyczyszczono stal nierdzewną",
    "bad_smell": "Zły zapach",
    "dirty_floor": "Brudna podłoga",
    "dirty_lavatory_seat": "Brudny fotel",
    "dirty_shower": "Brudny prysznic",
    "dirty_sink": "Brudna umywalka",
    "dirty_mirror": "Brudne lustro",
    "dirty_stainless_steel": "Brudna stal nierdzewna",
    "missing_paper_towel": "Brak papieru toaletowego",
    "missing_soap": "Brak mydła",
    "missing_toilet_paper": "Brak papieru toaletowego",
    "problem_shower": "Problem z prysznicem",
    "problem_sink": "Problem z umywalką",
    "problem_mirror": "Problem z lustrem",
    "problem_stainless_steel": "Problem z stalą nierdzewną",
    "problem_blockage": "Problem z zatkaniem",
    "problem_door": "Problem z drzwiami",
    "problem_fluid_taps": "Problem z kranami",
    "problem_lightning": "Problem z oświetleniem",
    "problem_broken_toilet": "Zepsuta toaleta",
    "fixed_shower": "Naprawiono prysznic",
    "fixed_sink": "Naprawiono umywalkę",
    "fixed_mirror": "Naprawiono lustro",
    "fixed_stainless_steel": "Naprawiono stal nierdzewną",
    "fixed_blockage": "Naprawiono zatkanie",
    "fixed_door": "Naprawiono drzwi",
    "fixed_fluid_taps": "Naprawiono kran",
    "fixed_lightning": "Naprawiono oświetlenie",
    "fixed_broken_toilet": "Naprawiono toaletę",
    "very_good": "Bardzo dobra",
    "excellent": "Doskonała",
    "good": "Dobra",
    "like": "Lubię",
    "needs_improvement": "Wymaga poprawy",
    "not_good": "Nie dobra",
    "supervise": "Nadzoruj",
    "maintenance": "Konserwacja",
    "cleaner": "Czysty",
    "tag_cleaner": "Tag Czysty",
    "zone_is_clean": "Strefa jest czysta",
    "zone_is_dirty": "Strefa jest brudna",
    "cleaner_arrived": "Czysty przybył",
    "start_clean_zone": "Rozpocznij czyszczenie strefy",
    "counter": "Licznik",
    "counter_men": "Licznik mężczyzn",
    "counter_woman": "Licznik kobiet",
    "counter_handycap": "Licznik niepełnosprawnych",
    "full_garbage_can": "Pełna kosza na śmieci",
    "maintenance_fixed": "Konserwacja naprawiona",
    "maintenance_problem": "Problem konserwacji",
    "problem_soap_dispenser": "Problem z dystrybutorem mydła",
    "problem_paper_dispenser": "Problem z dystrybutorem papieru",
    "end_clean_zone": "Zakończ czyszczenie strefy",
    "status_toilet_paper": "Status papieru toaletowego",
    "status_hend_paper": "Status papieru ręcznego",
    "fixed": "Naprawiono",
    "status_soap": "Status mydła",
    "status_garbage_can": "Status kosza na śmieci",
    "general_cleaning": "Ogólne czyszczenie",
    "coffee_tea": "Kawa / Herbata",
    "water_bar": "Bar wody",
    "disposable_dishes": "Pojemniki jednorazowe",
    "head_coverage": "Pokrycie głowy",
    "something_else": "Coś innego",
    "missing_clothing": "Brak ubrań",
    "maintenance_link": "Konserwacja linku",
    "problem_maintenance": "Problem konserwacji linku",
    "supervise_link": "Nadzoruj link",
    "cleaner_link": "Czysty link",
    "room_men+link": "Pokój mężczyzn + link",
    "room_men-link": "Pokój mężczyzn - link",
    "room_women+link": "Pokój kobiet + link",
    "room_women-link": "Pokój kobiet - link",
    "hebrew": "Hebrajski",
    "español": "Hiszpański",
    "français": "Francuski",
    "english": "Angielski",
    "русский": "Rosyjski",
    "italiano": "Włoski",
    "አማርኛ": "Amharski",
    "português": "Portugalski",
    "partial_information": "Częściowe informacje",
    "professionalism": "Profesjonalizm",
    "the_attitude_of_the_representative": "Postawa przedstawiciela",
    "waiting_time_for_service": "Czas oczekiwania na usługę",
    "other_aspect_of_service": "Inny aspekt usługi",
    "language_of_the_service": "Język usługi",
    "procedure_for_making_an_appointment": "Procedura umawiania się",
    "physical_conditions": "Warunki fizyczne",
    "found_another": "Znalazłem innego",
    "found_similar": "Znalazłem podobnego",
    "did_not_find": "Nie znalazłem",
    "found": "Znalazłem",
    "need_improved": "Wymaga poprawy",
    "liked": "Lubię",
    "pleasant": "Przyjemny",
    "eilat_resident": "Rezydent Eilat",
    "once_a_week": "Raz w tygod",
    "once_a_month": "Raz w miesiącu",
    "twice_a_year": "Dwa razy w roku",
    "once_a_year": "Raz w roku",
    "friend": "Przyjaciel",
    "newspaper": "Gazeta",
    "google": "Google",
    "zap": "Zap",
    "vacuum_cleaner": "Odkurzacz",
    "gaming_consoles": "Konsola do gier",
    "laptop": "Laptop",
    "cellular": "Komórka",
    "shop": "Sklep",
    "restaurant_complex_cleaning": "Czyszczenie kompleksu restauracyjnego",
    "dining_room": "Jadalnia",
    "food_variety": "Różnorodność jedzenia",
    "quality_of_the_food": "Jakość jedzenia",
    "amount_of_the_food": "Ilość jedzenia",
    "quality_of_cooking": "Jakość gotowania",
    "side_courses": "Przystawki",
    "meat": "Mięso",
    "desserts": "Desery",
    "vegetarian": "Wegetariański",
    "salad_bar": "Bar sałatek",
    "main_courses": "Dania główne",
    "service": "Obsługa",
    "dining_room_cleanliness": "Czystość jadalni",
    "plates_and_cutlery_cleanliness": "Czystość talerzy i sztućców",
    "product_inventory": "Inwentarz produktów",
    "furnishers": "Meble",
    "toilets": "Toalety",
    "problem_coffee_machine": "Problem z maszyną do kawy",
    "problem_water_bar": "Problem z bar wody",
    "dirty_stairs": "Brudne schody",
    "toiletries": "Artykuły toaletowe",
    "fixed_soap_dispenser": "Naprawiono dystrybutor mydła",
    "fixed_paper_dispenser": "Naprawiono dystrybutor papieru",
    "fixed_coffee_machine": "Naprawiono maszynę do kawy",
    "fixed_water_bar": "Naprawiono bar wody",
    "problem_urinals": "Problem z urynami",
    "blockage_toilet": "Zablokowanie toalety",
    "appliance_problem": "Problem z urządzeniem",
    "problem_broken_door": "Problem z uszkodzonym drzwiami",
    "problem_door_lock": "Problem z zamkiem drzwi",
    "problem_broken_toilet_seat": "Problem z uszkodzonym siedzeniem na toalecie",
    "problem_broken_niagara": "Problem z uszkodzonym Niagara",
    " broken_hand_paper_dispenser_hand_dryer": "Uszkodzony dystrybutor papieru do rąk / suszarka do rąk",
    "rug": "Wykładzina",
    "tables": "Stoły",
    "kitchen": "Kuchnia",
    "air_condition": "Klimatyzacja",
    "dirty_urinals": "Brudne uryny",
    "hand_dryer": "Suszarka do rąk",
    "non_sticky_carpet": "Nie klejąca wykładzina",
    "problem_bad_smell": "Problem z złą zapachem",
    "problem_broken_toilet_handle": "Problem z uszkodzonym uchwytem do toalety",
    "problem_handle_door": "Problem z uchwytem drzwi",
    "call_cleaner": "Zadzwoń do sprzątacza",
    "wall_painting": "Malowanie ścian",
    "missing_paper": "Brak papieru",
    "clean_surface": "Czysta powierzchnia",
    "problem_right_elevator": "Problem z prawym windą",
    "problem_left_elevator": "Problem z lewym windą",
    "missing_hand_sanitizer": "Brak dezynfekcji rąk",
    "problem_sink_blockage": "Problem z zablokowanym zlewem",
    "electric_problem": "Problem z elektryką",
    "missing_coffe_tea": "Brak kawy / herbaty",
    "problem_air_condition": "Problem z klimatyzacją",
    "dishwashing": "Myjnia naczyń",
    "kitchen_cleanliness": "Czystość kuchni",
    "weekly_cleaning": "Czyszczenie tygodniowe",
    "general_arrangement": "Ogólna aranżacja",
    "meeting_room": "Sala konferencyjna",
    "refrigerator": "Lodówka",
    "kitchen_supplies": "Artykuły kuchenne",
    "toilet_services": "Usługi toaletowe",
    "carousel_door": "Karuzela drzwi",
    "desk": "Biurko",
    "compressor": "Kompresor",
    "compressor_rails": "Śruby kompresora",
    "compressor_drainage": "Odprowadzenie kompresora",
    "dust": "Pył",
    "door": "Drzwi",
    "scotch": "Scotch",
    "food": "Jedzenie",
    "room_conditions": "Warunki pokoju",
    "kindness_sensitivity": "Uprzejmość i wrażliwość",
    "explain_process": "Wyjaśnij proces",
    "personal_attention": "Osobista uwaga",
    "service_problem": "Problem z obsługą",
    "welcome_you": "Witamy Cię",
    "invoice_submitted": "Faktura wysłana",
    "thank_you_bought": "Dziękujemy za zakupy",
    "problem_seller": "Problem z sprzedawcą",
    "lapel_pin": "Krawat",
    "proper_performance": "Dobry występ",
    "name_tag": "Etykieta nazwiska",
    "operational": "Operacyjny",
    "app_revealed": "Aplikacja ujawniona",
    "register_load": "Zarejestruj obciążenie",
    "visibility_problem": "Problem z widocznością",
    "clean_storefront": "Czyste okno sklepowe",
    "clean_garbage": "Czyste śmieci",
    "clean_tables_chairs": "Czyste stoły i krzesła",
    "clean_shop_floor": "Czysty podłóg sklepu",
    "product_show": "Pokaz produktu",
    "refrigerators_show": "Pokaz lodówek",
    "coffee_accessories": "Akcesoria do kawy",
    "cleanliness": "Czystość",
    "convenience_scheduling_appointments": "Wygoda w planowaniu spotkań",
    "waiting_haircut": "Czekanie na fryzjer",
    "courtesy_books": "Uprzejmość książek",
    "books_professionalism": "Książki profesjonalizmu",
    "received_time": "Otrzymano czas",
    "dnot_appointment": "Nie ma spotkania",
    "an_appointment": "Spotkanie",
    "tasty": "Smaczne",
    "courtesy_service": "Uprzejmość obsługi",
    "overall_experience": "Ogólny doświadczenie",
    "not_clean": "Nie czyste",
    "diningroom_not_clean": "Jadalnia nie czysta",
    "unclean_dishes": "Nieczyste naczynia",
    "so-so": "Tak sobie",
    "not_tasty": "Nie smaczne",
    "kind": "Rodzaj",
    "not_kind": "Nie uprzejmy",
    "clean": "Czyste",
    "hairdresser": "Fryzjer",
    "wrong_price": "Zła cena",
    "produc_has_expired": "Produkt wygasł",
    "missing_item": "Brakujący przedmiot",
    "item_is_faulty_in_the_machine": "Przedmiot jest wadliwy w maszynie",
    "machine_cleaning": "Czyszczenie maszyny",
    "improper_temperature": "Nieprawidłowa temperatura",
    "green": "Zielony",
    "orange": "Pomarańczowy",
    "red": "Czerwony",
    "yellow": "Żółty",
    "red not prob": "Czerwony nie problem",
    "professional": "Profesjonalny",
    "unprofessional": "Nieprofesjonalny",
    "delicacies": "Delikatesy",
    "sandwiches": "Kanapki",
    "vegetables": "Warzywa",
    "fruits": "Owoce",
    "salads": "Sałatki",
    "milk": "Mleko",
    "room_link": "Pokój link",
    "floor_link": "Link do piętra",
    "services": "Usługi",
    "check_list": "Lista kontrolna",
    "lighting_problem_lobby": "Problem z oświetleniem lobby",
    "lighting_problem_garbage_room": "Problem z oświetleniem pomieszczenia śmieci",
    "lighting_problem_stairwell": "Problem z oświetleniem klatki schodowej",
    "problem_elevator_1": "Problem z windą 1",
    "problem_elevator_2": "Problem z windą 2",
    "problem_elevator_3": "Problem z windą 3",
    "problem_elevator_4": "Problem z windą 4",
    "problem_elevator_5": "Problem z windą 5",
    "problem_elevator_6": "Problem z windą 6",
    "problem_elevator_7": "Problem z windą 7",
    "problem_elevator_8": "Problem z windą 8",
    "problem_elevator_9": "Problem z windą 9",
    "problem_elevator_10": "Problem z windą 10",
    "stuck_item": "Zablokowany przedmiot",
    "spoiling_product": "Produkt zepsuty",
    "machine_malfunction": "Awaria maszyny",
    "unreadable_product": "Nieczytelny produkt",
    "i_am_satisfied": "Jestem zadowolony",
    "beverage": "Napoje",
    "program_malfunction": "Awaria programu",
    "machine_1": "Maszyna 1",
    "machine_2": "Maszyna 2",
    "machine_3": "Maszyna 3",
    "machine_4": "Maszyna 4",
    "program malfunction 1": "Awaria programu 1",
    "program malfunction 2": "Awaria programu 2",
    "program malfunction 3": "Awaria programu 3",
    "program malfunction 4": "Awaria programu 4",
    "fish": "Ryby",
    "chicken": "Kurczak",
    "full_dining_room": "Pełna jadalnia",
    "missing_amount": "Brakująca kwota",
    "missing_trays": "Brakujące talerze",
    "dirty_floor_g1": "Brudna podłoga g1",
    "dirty_floor_g2": "Brudna podłoga g2",
    "dirty_floor_g3": "Brudna podłoga g3",
    "dirty_floor_g4": "Brudna podłoga g4",
    "dirty_floor_g5": "Brudna podłoga g5",
    "dirty_floor_eo": "Brudna podłoga eo",
    "dirty_floor_ceo": "Brudna podłoga ceo",
    "dirty_floor_storage": "Brudna podłoga magazyn",
    "dirty_floor_inflorescence": "Brudna podłoga inflorescencja",
    "operating_instructions": "Instrukcje obsługi",
    "general": "Ogólne",
    "connection_problem": "Problem z połączeniem",
    "lighting": "Oświetlenie",
    "not _fixed": "Nie naprawiono",
    "cleaning_needed": "Potrzebne czyszczenie",
    "missing_milk": "Brakujące mleko",
    "no_sugar_coffee": "Brak cukru do kawy",
    "missing_tools": "Brakujące narzędzia",
    "coffee_water_machine": "Kawa i woda w maszynie",
    "appliances": "Urządzenia",
    "products": "Produkty",
    "broken_chair": "Zepsuty krzesło",
    "broken_cabinet": "Zepsuty szafek",
    "micro": "Mikro",
    "toaster": "Toster",
    "clogged_sink_malfunction": "Zatopiony zlew awaria",
    "coffee_cooling_malfunction": "Awaria chłodzenia kawy",
    "no_coffee_beans": "Brak ziaren kawy",
    "machine_failure": "Awaria maszyny",
    "that_dirty": "To brudne",
    "dirty_refrigerator": "Brudny lodówka",
    "dirty_tables": "Brudne stoły",
    "plates": "Talerze",
    "silver_spoon": "Srebrna łyżka",
    "cold_drinks_cups": "Zimne napoje kubki",
    "hot_drink_cups": "Ciepłe napoje kubki",
    "a_dripping_faucet": "Ciekający kran",
    "disposable dishes": "Jednorazowe talerze",
    "problem_ coffee_water_machine": "Problem z kawą i wodą w maszynie",
    "problem_micro": "Problem z mikro",
    "problem_toaster": "Problem z tosterem",
    "problem_machine_failure": "Problem z awarią maszyny",
    "problem refrigerator": "Problem z lodówką",
    "no_sugar/coffee": "Brak cukru/kawy",
    "missing_dishes": "Brakujące talerze",
    "coffee/water_machine": "Kawa/woda w maszynie",
    "coffee_machine_door_open": "Drzwi kawy otwarte",
    "coffee_machine_door_close": "Drzwi kawy zamknięte",
    "coffee_machine_bin_full": "Kosz kawy pełny",
    "coffee_machine_bin_empty": "Kosz kawy pusty",
    "coffee_machine_coffee_full": "Kawa w maszynie pełna",
    "coffee_machine_coffee_empty": "Kawa w maszynie pusta",
    "coffee_machine_water_tank_empty": "Zbiornik wody w maszynie pusty",
    "coffee_machine_ water_tank_full": "Zbiornik wody w maszynie pełny",
    "coffee_machine_milk_cleaning_not_performed": "Czyszczenie mleka w maszynie nie wykonane",
    "coffee_machine _milk_cleaning_performed": "Czyszczenie mleka w maszynie wykonane",
    "coffee_machine_head_cleaning_not_performed": "Czyszczenie głowy w maszynie nie wykonane",
    "coffee_machine_head_ cleaning_performed": "Czyszczenie głowy w maszynie wykonane",
    "coffee_machine_descaling_not_performed": "Odkamienianie w maszynie nie wykonane",
    "coffee_machine_descaling_performed": "Odkamienianie w maszynie wykonane",
    "floor_one": "Piętro 1",
    "floor_two": "Piętro 2",
    "floor_three": "Piętro 3",
    "floor_four": "Piętro 4",
    "floor_five": "Piętro 5",
    "floor_six": "Piętro 6",
    "floor_seven": "Piętro 7",
    "floor_eight": "Piętro 8",
    "floor_nine": "Piętro 9",
    "floor_ten": "Piętro 10",
    "floor_eleven": "Piętro 11",
    "floor_twelve": "Piętro 12",
    "floor_thirteen": "Piętro 13",
    "floor_fourteen": "Piętro 14",
    "floor_fifteen": "Piętro 15",
    "floor_sixteen": "Piętro 16",
    "floor_seventeen": "Piętro 17",
    "floor_eighteen": "Piętro 18",
    "floor_nineteen": "Piętro 19",
    "floor_twenty": "Piętro 20",
    "floor_twenty_one": "Piętro 21",
    "floor_twenty_two": "Piętro 22",
    "floor_twenty_three": "Piętro 23",
    "floor_twenty_four": "Piętro 24",
    "floor_twenty_five": "Piętro 25",
    "status_toilet_paper_cell_01_-_empty": "Status papieru toaletowego komórka 01 - pusty",
    "status_toilet_paper_cell_02_-_empty": "Status papieru toaletowego komórka 02 - pusty",
    "status_toilet_paper_cell_03_-_empty": "Status papieru toaletowego komórka 03 - pusty",
    "status_toilet_paper_cell_04_-_empty": "Status papieru toaletowego komórka 04 - pusty",
    "status_toilet_paper_cell_05_-_empty": "Status papieru toaletowego komórka 05 - pusty",
    "status_toilet_paper_cell_06_-_empty": "Status papieru toaletowego komórka 06 - pusty",
    "status_toilet_paper_cell_07_-_empty": "Status papieru toaletowego komórka 07 - pusty",
    "status_toilet_paper_cell_08_-_empty": "Status papieru toaletowego komórka 08 - pusty",
    "status_toilet_paper_cell_09_-_empty": "Status papieru toaletowego komórka 09 - pusty",
    "status_toilet_paper_cell_10_-_empty": "Status papieru toaletowego komórka 10 - pusty",
    "status_toilet_paper_cell_11_-_empty": "Status papieru toaletowego komórka 11 - pusty",
    "status_toilet_paper_cell_12_-_empty": "Status papieru toaletowego komórka 12 - pusty",
    "status_toilet_paper_cell_13_-_empty": "Status papieru toaletowego komórka 13 - pusty",
    "status_toilet_paper_cell_14_-_empty": "Status papieru toaletowego komórka 14 - pusty",
    "status_toilet_paper_cell_15_-_empty": "Status papieru toaletowego komórka 15 - pusty",
    "status_toilet_paper_cell_16_-_empty": "Status papieru toaletowego komórka 16 - pusty",
    "status_toilet_paper_cell_17_-_empty": "Status papieru toaletowego komórka 17 - pusty",
    "status_toilet_paper_cell_18_-_empty": "Status papieru toaletowego komórka 18 - pusty",
    "status_toilet_paper_cell_19_-_empty": "Status papieru toaletowego komórka 19 - pusty",
    "status_toilet_paper_cell_20_-_empty": "Status papieru toaletowego komórka 20 - pusty",
    "status_toilet_paper_cell_01_-_almost_empty": "Status papieru toaletowego komórka 01 - prawie pusty",
    "status_toilet_paper_cell_02_-_almost_empty": "Status papieru toaletowego komórka 02 - prawie pusty",
    "status_toilet_paper_cell_03_-_almost_empty": "Status papieru toaletowego komórka 03 - prawie pusty",
    "status_toilet_paper_cell_04_-_almost_empty": "Status papieru toaletowego komórka 04 - prawie pusty",
    "status_toilet_paper_cell_05_-_almost_empty": "Status papieru toaletowego komórka 05 - prawie pusty",
    "status_toilet_paper_cell_06_-_almost_empty": "Status papieru toaletowego komórka 06 - prawie pusty",
    "status_toilet_paper_cell_07_-_almost_empty": "Status papieru toaletowego komórka 07 - prawie pusty",
    "status_toilet_paper_cell_08_-_almost_empty": "Status papieru toaletowego komórka 08 - prawie pusty",
    "status_toilet_paper_cell_09_-_almost_empty": "Status papieru toaletowego komórka 09 - prawie pusty",
    "status_toilet_paper_cell_10_-_almost_empty": "Status papieru toaletowego komórka 10 - prawie pusty",
    "status_toilet_paper_cell_11_-_almost_empty": "Status papieru toaletowego komórka 11 - prawie pusty",
    "status_toilet_paper_cell_12_-_almost_empty": "Status papieru toaletowego komórka 12 - prawie pusty",
    "status_toilet_paper_cell_13_-_almost_empty": "Status papieru toaletowego komórka 13 - prawie pusty",
    "status_toilet_paper_cell_14_-_almost_empty": "Status papieru toaletowego komórka 14 - prawie pusty",
    "status_toilet_paper_cell_15_-_almost_empty": "Status papieru toaletowego komórka 15 - prawie pusty",
    "status_toilet_paper_cell_16_-_almost_empty": "Status papieru toaletowego komórka 16 - prawie pusty",
    "status_toilet_paper_cell_17_-_almost_empty": "Status papieru toaletowego komórka 17 - prawie pusty",
    "status_toilet_paper_cell_18_-_almost_empty": "Status papieru toaletowego komórka 18 - prawie pusty",
    "status_toilet_paper_cell_19_-_almost_empty": "Status papieru toaletowego komórka 19 - prawie pusty",
    "status_toilet_paper_cell_20_-_almost_empty": "Status papieru toaletowego komórka 20 - prawie pusty",
    "of": "z",
    "items": "przedmioty",
    "loading_charts": "Ładowanie wykresów",
    "refresh_the_room": "Odśwież pokój",
    "clean_the_floor": "Umyj podłogę",
    "clean_the_toilet": "Wyczyść toaletę",
    "refill_soap": "Uzupełnij mydło",
    "change_roll": "Wymień rolkę papieru toaletowego",
    "great_job": "Świetna robota",
    "empty_the_trash": "Opróżnij kosz na śmieci",
    "repair_required": "Wymagana naprawa",
    "cleaning": "Czyszczenie",
    "cleaning_work_plan": "Plan pracy sprzątania",
    "cleaning_work_plan_intro": "Korzysta ze statystyk pomieszczeń w zmianach dla firmy i lokalizacji z nagłówka. Wizyty i wejścia są pobierane z jednego dnia o najwyższej liczbie wizyt w wybranym zakresie dat oraz ze zmian ustawionych w filtrze dashboardu (ustaw je w Performance lub Analytics, jeśli ta karta ukrywa kontrolki czasu i filtrów). Podaj wizyty na sprzątanie, docelową liczbę pracowników, koszt godziny i średni czas sprzątania w minutach; wygeneruj plan, aby zobaczyć sugerowane sprzątania wg pomieszczeń i podsumowanie.",
    "cleaning_work_plan_default_n": "Wizyty na sprzątanie",
    "cleaning_work_plan_cleaner_count": "Osoby sprzątające (opcjonalnie)",
    "cleaning_work_plan_avg_minutes": "Średni czas sprzątania (min)",
    "cleaning_work_plan_run": "Generuj plan",
    "cleaning_work_plan_export_csv": "Eksportuj do Excel",
    "cleaning_work_plan_suggested_n": "Wizyty na sprzątanie",
    "cleaning_work_plan_actual_cleans": "Wejścia",
    "cleaning_work_plan_actual_cleans_hint": "Łączna liczba wejść osób sprzątających w statystykach pomieszczeń zmianowych w dniu szczytu (w wybranym zakresie i filtrach).",
    "cleaning_work_plan_suggested_cleans": "Sugerowane sprzątania",
    "cleaning_work_plan_cleaner": "Osoba sprzątająca",
    "cleaning_work_plan_floors": "Piętra",
    "cleaning_work_plan_peak_day": "Dzień szczytu",
    "cleaning_work_plan_error": "Nie udało się wygenerować planu pracy sprzątania",
    "cleaning_work_plan_no_rooms": "Nie zwrócono pomieszczeń dla tej lokalizacji. Sprawdź lokalizację i zakres dat albo upewnij się, że pomieszczenia istnieją w panelu kontrolnym.",
    "cleaning_work_plan_need_filter": "Wybierz firmę i lokalizację w nagłówku, ustaw zakres dat (i zmiany, jeśli trzeba) w Performance lub Analytics, a następnie spróbuj ponownie.",
    "cleaning_work_plan_settings": "Ustawienia planu",
    "cleaning_work_plan_desired_employees": "Pożądana liczba pracowników",
    "cleaning_work_plan_cost_per_hour": "Koszt godziny",
    "cleaning_work_plan_estimated_cost_suggested": "Szacunkowy koszt (obciążenie sugerowane)",
    "cleaning_work_plan_estimated_cost_actual": "Szacunkowy koszt (obciążenie rzeczywiste)",
    "cleaning_work_plan_hours_per_cleaner": "Godziny na osobę sprzątającą",
    "cleaning_work_plan_metric_title": "Metryki",
    "cleaning_work_plan_metric_avg_cleaning_min": "Średni czas sprzątania (min)",
    "cleaning_work_plan_metric_total_arrivals": "Łączna liczba wejść",
    "cleaning_work_plan_metric_total_cleaning_min": "Łączny czas sprzątania (min)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Łączny czas sprzątania (godz.)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Godziny na osobę sprzątającą",
    "cleaning_work_plan_metric_num_cleaners": "Liczba osób sprzątających",
    "cleaning_work_plan_summary": "Podsumowanie",
    "cleaning_work_plan_summary_peak_note": "Wizyty, wejścia i sugerowane sprzątania używają tych samych reguł statystyk zmianowych co Analytics (w tym agregacji wejść). Dotyczą dnia szczytu - dnia kalendarzowego z największą liczbą wizyt w okresie filtra. Uwzględniane są tylko policzone pomieszczenia.",
    "cleaning_work_plan_summary_filter_period": "Okres filtra",
    "cleaning_work_plan_summary_total_visits": "Łączna liczba wizyt",
    "cleaning_work_plan_summary_total_arrivals": "Łączna liczba wejść",
    "cleaning_work_plan_summary_employees_in_site": "Pracownicy w lokalizacji",
    "cleaning_work_plan_summary_shift_working_hours": "Godziny zmian",
    "cleaning_work_plan_hours_unit": "h",
    "cleaning_work_plan_rooms_table": "Pomieszczenia",
    "cleaning_work_plan_cleaners_table": "Rekomendowany przydział osób sprzątających",
    "cleaning_work_plan_search_rooms": "Szukaj pomieszczeń",
    "cleaning_work_plan_total_minutes": "Łączna liczba minut",
    "cleaning_work_plan_actual_total_minutes": "Rzeczywiste minuty łącznie",
    "cleaning_work_plan_actual_total_minutes_hint": "Zarejestrowane wejścia osób sprzątających w statystykach zmianowych w dniu szczytu (w wybranym zakresie), pomnożone przez średnią liczbę minut na sprzątanie.",
    "cleaning_work_plan_suggested_total_minutes": "Sugerowane minuty łącznie",
    "cleaning_work_plan_suggested_room_minutes": "Sugerowane minuty sprzątania",
    "cleaning_work_plan_actual_room_minutes": "Rzeczywiste minuty sprzątania",
    "cleaning_work_plan_cleaner_suggested_minutes": "Suger. min.",
    "cleaning_work_plan_cleaner_actual_minutes": "Rzecz. min.",
    "cleaning_work_plan_period": "Okres",
    "cleaning_work_plan_room_count": "Liczba pomieszczeń",
    "cleaning_work_plan_cleaners_working_in_site": "Osoby sprzątające w lokalizacji (kontakty w aplikacji)",
    "cleaning_work_plan_cleaners_connection_table": "Osoby sprzątające według pomieszczeń",
    "cleaning_work_plan_connected_rooms_count": "Pomieszczenia",
    "cleaning_work_plan_connected_floor_count": "Liczba pięter",
    "cleaning_work_plan_connected_floors_list": "Piętra",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Stosunek wizyt / wejść sprzątających",
    "cleaning_work_plan_performance_comparison_table": "Porównanie wyników",
    "cleaning_work_plan_performance_comparison_empty": "Załaduj dane powiązań, aby zobaczyć wiersze.",
    "cleaning_work_plan_performance_col_index": "Wskaźnik",
    "cleaning_work_plan_performance_existing_plan": "Istniejący plan pracy",
    "cleaning_work_plan_performance_recommended_plan": "Plan rekomendowany Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Liczba pracowników",
    "cleaning_work_plan_perf_working_hours_per_employee": "Godziny pracy na pracownika",
    "cleaning_work_plan_perf_total_working_hours": "Łączne godziny pracy",
    "cleaning_work_plan_perf_total_cleaning_hours": "Łączne godziny sprzątania",
    "cleaning_work_plan_perf_daily_cost": "Koszt dzienny",
    "cleaning_work_plan_perf_total_cleaning_visits": "Łączna liczba wizyt sprzątających",
    "cleaning_work_plan_perf_busiest_area_visits": "Najbardziej obciążony obszar — wizyty",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Wizyty sprzątające do najbardziej obciążonego obszaru",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Maksymalny stosunek sprzątania",
    "cleaning_work_plan_perf_least_busy_visits": "Najmniej obciążony obszar — wizyty",
    "cleaning_work_plan_perf_cleaning_to_least": "Wizyty sprzątające do najmniej obciążonego obszaru",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Minimalny stosunek sprzątania",
    "cleaning_work_plan_ai_allocate": "Przydział AI",
    "cleaning_work_plan_ai_allocation_result": "Wynik przydziału AI",
    "cleaning_work_plan_ai_allocation_loading": "Generowanie przydziału AI...",
    "cleaning_work_plan_ai_allocation_error": "Nie udało się wygenerować przydziału AI. Spróbuj ponownie.",
    "cleaning_work_plan_ai_invalid_employees": "Proszę ustawić prawidłową liczbę pożądanych pracowników.",
    "cleaning_work_plan_ai_status_elapsed": "Upłynęło: {s} s",
    "cleaning_work_plan_ai_status_hint": "Serwer wykonuje kilka kolejnych kroków AI (plan początkowy, geografia, bilans wizyt, potem wynik końcowy). Może to potrwać minutę lub dwie—nie zamykaj tej strony.",
    "cleaning_work_plan_ai_status_step_1": "Krok 1 — szkic przydziału z danych pomieszczeń i wizyt…",
    "cleaning_work_plan_ai_status_step_2": "Krok 2 — dopracowanie geografii (grupowanie pięter i budynków)…",
    "cleaning_work_plan_ai_status_step_3": "Krok 3 — bilans dziennych wizyt między sprzątającymi…",
    "cleaning_work_plan_ai_status_step_4": "Krok 4 — generowanie ustrukturyzowanego przydziału…",
    "cleaning_work_plan_ai_status_step_5": "Krok 5 — walidacja i obliczanie końcowych metryk…",
    "cleaning_work_plan_ai_cleaner_number": "Sprzątacz #",
    "cleaning_work_plan_room_minutes": "Minuty sprzątania",
    "cleaning_work_plan_assigned_cleaner": "Przypisana osoba sprzątająca",
    "cleaning_work_plan_summary_cleaners": "Osoby sprzątające w planie",
    "cleaning_work_plan_summary_avg_minutes": "Śr. min / sprzątanie",
    "cleaning_work_plan_suggested_hours": "Sugerowane godziny łącznie",
    "cleaning_work_plan_actual_hours": "Rzeczywiste godziny łącznie",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Śr. suger. min / osoba",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Śr. rzecz. min / osoba",
    "cleaning_work_plan_guidelines_title": "Wytyczne optymalizacji",
    "cleaning_work_plan_guidelines_intro": "To narzędzie realizuje te same cele co ręczna optymalizacja planu sprzątania: obciążenie z danych o wizytach, czas ze średniej minut na sprzątanie oraz obsadę równoważącą pracę przy zachowaniu sensownej geografii pięter.",
    "cleaning_work_plan_guidelines_b1": "Wizyty na sprzątanie (domyślnie 50) odpowiadają regule 1:50: sugerowana liczba wejść na pomieszczenie to w przybliżeniu wizyty podzielone przez wizyty na sprzątanie (zaokrąglone w górę). Wizyty i wejścia pochodzą z najbardziej obciążonego dnia w wybranym okresie.",
    "cleaning_work_plan_guidelines_b2": "Po ustawieniu liczby osób sprzątających każde piętro budynku jest jedną grupą. Piętra są sortowane po budynku i numerze piętra, a potem dzielone na ciągłe bloki między osoby sprzątające, aby równoważyć sugerowaną pracę i utrzymywać pobliskie piętra u tej samej osoby.",
    "cleaning_work_plan_guidelines_b3": "Wszystkie toalety na tym samym piętrze budynku pozostają przy tej samej osobie, więc toalety męskie i damskie na tym piętrze nie są rozdzielane między różne osoby (o ile mają tę samą wartość piętra w panelu kontrolnym).",
    "cleaning_work_plan_guidelines_b4": "Średnia liczba minut na sprzątanie wpływa na sugerowane i rzeczywiste minuty oraz godziny łącznie, a także średnie minuty na osobę. Suma rzeczywista używa zarejestrowanych wejść x Twoja średnia; suma sugerowana używa wyliczonych sprzątań x Twoja średnia.",
    "cleaning_work_plan_guidelines_b5": "Użyj eksportu CSV, jeśli chcesz dopracować przydział gdzie indziej (np. jeszcze bardziej poprawić równowagę wizyt).",
    "cleaning_performed": "rozpoczęto sprzątanie",
  },
  uk: {
    "cleaned_floor": "Підлогу прибрано",
    "cleaned_toilet": "Туалет прибрано",
    "cleaned_shower": "Душ прибрано",
    "cleaned_sink": "Раковину прибрано",
    "cleaned_mirror": "Дзеркало прибрано",
    "cleaned_stainless_steel": "Нержавіючу сталь очищено",
    "bad_smell": "Поганий запах",
    "dirty_floor": "Брудна підлога",
    "dirty_lavatory_seat": "Брудний унітаз",
    "dirty_shower": "Брудний душ",
    "dirty_sink": "Брудна раковина",
    "dirty_mirror": "Брудне дзеркало",
    "dirty_stainless_steel": "Брудна нержавіюча сталь",
    "missing_paper_towel": "Відсутній рушник",
    "missing_soap": "Відсутнє мило",
    "missing_toilet_paper": "Відсутній туалетний папір",
    "problem_shower": "Проблема з душем",
    "problem_sink": "Проблема з раковиною",
    "problem_mirror": "Проблема з дзеркалом",
    "problem_stainless_steel": "Проблема з нержавіючою сталлю",
    "problem_blockage": "Проблема з затором",
    "problem_door": "Проблема з дверима",
    "problem_fluid_taps": "Проблема з кранами",
    "problem_lightning": "Проблема з освітленням",
    "problem_broken_toilet": "Зламаний унітаз",
    "fixed_shower": "Душ відремонтовано",
    "fixed_sink": "Раковину відремонтовано",
    "fixed_mirror": "Дзеркало відремонтовано",
    "fixed_stainless_steel": "Нержавіючу сталь відремонтовано",
    "fixed_blockage": "Затор відремонтовано",
    "fixed_door": "Двері відремонтовано",
    "fixed_fluid_taps": "Крани відремонтовано",
    "fixed_lightning": "Освітлення відремонтовано",
    "fixed_broken_toilet": "Унітаз відремонтовано",
    "very_good": "Дуже добре",
    "excellent": "Відмінно",
    "good": "Добре",
    "like": "Подобається",
    "needs_improvement": "Потребує покращення",
    "not_good": "Не добре",
    "supervise": "Нагляд",
    "maintenance": "Обслуговування",
    "cleaner": "Прибиральник",
    "tag_cleaner": "Тег Сервіс",
    "zone_is_clean": "Зона чиста",
    "zone_is_dirty": "Зона брудна",
    "cleaner_arrived": "Прибиральник прибув",
    "start_clean_zone": "Почати прибирання зони",
    "counter": "Лічильник входів",
    "counter_men": "Лічильник входів / чоловіки",
    "counter_woman": "Лічильник входів / жіночий",
    "counter_handycap": "Лічильник входів / інвалідний",
    "full_garbage_can": "Повний смітник",
    "maintenance_fixed": "Обслуговування виконано",
    "maintenance_problem": "Проблема з обслуговуванням",
    "problem_soap_dispenser": "Проблема з диспенсером для мила",
    "problem_paper_dispenser": "Проблема з диспенсером для паперу",
    "end_clean_zone": "Завершити прибирання зони",
    "status_toilet_paper": "Стан туалетного паперу",
    "status_hend_paper": "Стан рушників",
    "fixed": "Виправлено",
    "status_soap": "Стан мила",
    "status_garbage_can": "Стан смітника",
    "general_cleaning": "Загальне прибирання",
    "coffee_tea": "Кава / Чай",
    "water_bar": "Водяний бар",
    "disposable_dishes": "Одноразова посуда",
    "head_coverage": "Покриття голови",
    "something_else": "Щось інше",
    "missing_clothing": "Відсутня одяг",
    "maintenance_link": "Посилання на обслуговування",
    "problem_maintenance": "Обслуговування",
    "supervise_link": "Посилання на нагляд",
    "cleaner_link": "Посилання на прибиральника",
    "room_men+link": "Кімната для чоловіків + посилання",
    "room_men-link": "Кімната для чоловіків - посилання",
    "room_women+link": "Кімната для жінок + посилання",
    "room_women-link": "Кімната для жінок - посилання",
    "hebrew": "Іврит",
    "español": "Іспанська",
    "français": "Французька",
    "english": "Англійська",
    "русский": "Російська",
    "italiano": "Італійська",
    "አማርኛ": "Амхарська",
    "português": "Португальська",
    "partial_information": "Часткова інформація",
    "professionalism": "Професіоналізм",
    "the_attitude_of_the_representative": "Ставлення представника",
    "waiting_time_for_service": "Час очікування на обслуговування",
    "other_aspect_of_service": "Інший аспект обслуговування",
    "language_of_the_service": "Мова обслуговування",
    "procedure_for_making_an_appointment": "Процедура запису на прийом",
    "physical_conditions": "Фізичні умови",
    "found_another": "Знайшов іншого",
    "found_similar": "Знайшов схожого",
    "did_not_find": "Не знайшов",
    "found": "Знайшов",
    "need_improved": "Потребує покращення",
    "liked": "Сподобалося",
    "pleasant": "Приємний",
    "eilat_resident": "Мешканець Ейлату",
    "once_a_week": "Раз на тиждень",
    "once_a_month": "Раз на місяць",
    "twice_a_year": "Два рази на рік",
    "once_a_year": "Раз на рік",
    "friend": "Друг",
    "newspaper": "Газета",
    "google": "Google",
    "zap": "Zap",
    "vacuum_cleaner": "Пилосос",
    "gaming_consoles": "Ігрові консолі",
    "laptop": "Ноутбук",
    "cellular": "Клітинний",
    "shop": "Магазин",
    "restaurant_complex_cleaning": "Прибирання ресторанного комплексу",
    "dining_room": "Столова",
    "food_variety": "Різноманіття їжі",
    "quality_of_the_food": "Якість їжі",
    "amount_of_the_food": "Кількість їжі",
    "quality_of_cooking": "Якість приготування",
    "side_courses": "Гарніри",
    "meat": "М'ясо",
    "desserts": "Десерти",
    "vegetarian": "Вегетаріанський",
    "salad_bar": "Бар салатів",
    "main_courses": "Основні страви",
    "service": "Обслуговування",
    "dining_room_cleanliness": "Чистота столової",
    "plates_and_cutlery_cleanliness": "Чистота тарілок і столових приборів",
    "product_inventory": "Інвентаризація продуктів",
    "furnishers": "Меблі",
    "toilets": "Туалети",
    "problem_coffee_machine": "Проблема з кавоваркою",
    "problem_water_bar": "Проблема з водяним баром",
    "dirty_stairs": "Брудні сходи",
    "toiletries": "Туалетні принади",
    "fixed_soap_dispenser": "Виправлено диспенсер мила",
    "fixed_paper_dispenser": "Виправлено диспенсер паперу",
    "fixed_coffee_machine": "Виправлено кавоварку",
    "fixed_water_bar": "Виправлено водяний бар",
    "problem_urinals": "Проблема з пісуарами",
    "blockage_toilet": "Забиті туалети",
    "appliance_problem": "Проблема з пристроями",
    "problem_broken_door": "Пошкоджені двері",
    "problem_door_lock": "Проблема з замком дверей",
    "problem_broken_toilet_seat": "Пошкоджений сидіння унітазу",
    "problem_broken_niagara": "Пошкоджена змивка",
    "broken_hand_paper_dispenser_hand_dryer": "Пошкоджений диспенсер для рук / сушарка для рук",
    "rug": "Килим",
    "tables": "Столи",
    "kitchen": "Кухня",
    "air_condition": "Кондиціонер",
    "dirty_urinals": "Брудні пісуари",
    "hand_dryer": "Сушарка для рук",
    "non_sticky_carpet": "Не липкий килим",
    "problem_bad_smell": "Поганий запах",
    "problem_broken_toilet_handle": "Пошкоджена ручка унітазу",
    "problem_handle_door": "Пошкоджена ручка",
    "call_cleaner": "Викликати прибиральника",
    "wall_painting": "Фарбування стін",
    "missing_paper": "Відсутній папір",
    "clean_surface": "Чиста поверхня",
    "problem_right_elevator": "Проблема з правим ліфтом",
    "problem_left_elevator": "Проблема з лівим ліфтом",
    "missing_hand_sanitizer": "Відсутній антисептик для рук",
    "problem_sink_blockage": "Забитий раковина",
    "electric_problem": "Проблема з електрикою",
    "missing_coffe_tea": "Відсутні кава / чай",
    "problem_air_condition": "Проблема з кондиціонером",
    "dishwashing": "Миття посуду",
    "kitchen_cleanliness": "Чистота кухні",
    "weekly_cleaning": "Тижневе прибирання",
    "general_arrangement": "Загальна організація",
    "meeting_room": "Кімната для зустрічей",
    "refrigerator": "Холодильник",
    "kitchen_supplies": "Кухонне приладдя",
    "toilet_services": "Сантехнічні послуги",
    "carousel_door": "Двері каруселі",
    "desk": "Стіл",
    "compressor": "Компресор",
    "compressor_rails": "Рейки компресора",
    "compressor_drainage": "Відведення компресора",
    "dust": "Пил",
    "door": "Двері",
    "scotch": "Скотч",
    "food": "Їжа",
    "room_conditions": "Умови номера",
    "kindness_sensitivity": "Люб'язність і чутливість",
    "explain_process": "Поясніть процес",
    "personal_attention": "Особиста увага",
    "service_problem": "Проблема з обслуговуванням",
    "welcome_you": "Ласкаво просимо вас",
    "invoice_submitted": "Рахунок надісланий",
    "thank_you_bought": "Дякуємо, що придбали",
    "problem_seller": "Проблема з продавцем",
    "lapel_pin": "Значок на запічці",
    "proper_performance": "Правильна робота",
    "name_tag": "Табличка з ім'ям",
    "operational": "Операційний",
    "app_revealed": "Програма розкрита",
    "register_load": "Зареєструйте навантаження",
    "visibility_problem": "Проблема з видимістю",
    "clean_storefront": "Чиста вітрина",
    "clean_garbage": "Чисте сміття",
    "clean_tables_chairs": "Чисті столи та стільці",
    "clean_shop_floor": "Чистий підлога магазину",
    "product_show": "Товар",
    "refrigerators_show": "Холодильники",
    "coffee_accessories": "Аксесуари для кави",
    "cleanliness": "Чистота",
    "convenience_scheduling_appointments": "Зручність у плануванні зустрічей",
    "waiting_haircut": "Чекання на стрижку",
    "courtesy_books": "Книги про ввічливість",
    "books_professionalism": "Книги про професіоналізм",
    "received_time": "Отриманий час",
    "dnot_appointment": "Немає зустрічі",
    "an_appointment": "Зустріч",
    "tasty": "Смачно",
    "courtesy_service": "Ввічливість обслуговування",
    "overall_experience": "Загальний досвід",
    "not_clean": "Не чисто",
    "diningroom_not_clean": "Брудна їдальня",
    "unclean_dishes": "Брудні посуд",
    "so-so": "Так собі",
    "not_tasty": "Не смачно",
    "kind": "Люб'язний",
    "not_kind": "Неввічливий",
    "clean": "Чисто",
    "hairdresser": "Перукар",
    "wrong_price": "Неправильна ціна",
    "produc_has_expired": "Товар прострочений",
    "missing_item": "Відсутня позиція",
    "item_is_faulty_in_the_machine": "Позиція пошкоджена в пристрої",
    "machine_cleaning": "Чищення пристрою",
    "improper_temperature": "Неправильна температура",
    "green": "Зелений",
    "orange": "Помаранчевий",
    "red": "Червоний",
    "yellow": "Жовтий",
    "red not prob": "Червоний не проблема",
    "professional": "Професійний",
    "unprofessional": "Непрофесійний",
    "delicacies": "Делікатеси",
    "sandwiches": "Сендвічі",
    "vegetables": "Овочі",
    "fruits": "Фрукти",
    "salads": "Салати",
    "milk": "Молоко",
    "room_link": "Посилання на кімнату",
    "floor_link": "Посилання на поверх",
    "services": "Послуги",
    "check_list": "Перевірочний список",
    "lighting_problem_lobby": "Проблема з освітленням у фойє",
    "lighting_problem_garbage_room": "Проблема з освітленням у сміттєзбірнику",
    "lighting_problem_stairwell": "Проблема з освітленням у сходовій клітці",
    "problem_elevator_1": "Проблема з ліфтом 1",
    "problem_elevator_2": "Проблема з ліфтом 2",
    "problem_elevator_3": "Проблема з ліфтом 3",
    "problem_elevator_4": "Проблема з ліфтом 4",
    "problem_elevator_5": "Проблема з ліфтом 5",
    "problem_elevator_6": "Проблема з ліфтом 6",
    "problem_elevator_7": "Проблема з ліфтом 7",
    "problem_elevator_8": "Проблема з ліфтом 8",
    "problem_elevator_9": "Проблема з ліфтом 9",
    "problem_elevator_10": "Проблема з ліфтом 10",
    "stuck_item": "Застрягнутий елемент",
    "spoiling_product": "Продукт псується",
    "machine_malfunction": "Поломка пристрою",
    "unreadable_product": "Нечитаний продукт",
    "i_am_satisfied": "Я задоволений",
    "beverage": "Напій",
    "program_malfunction": "Поломка програми",
    "machine_1": "Пристрій 1",
    "machine_2": "Пристрій 2",
    "machine_3": "Пристрій 3",
    "machine_4": "Пристрій 4",
    "program malfunction 1": "Поломка програми 1",
    "program malfunction 2": "Поломка програми 2",
    "program malfunction 3": "Поломка програми 3",
    "program malfunction 4": "Поломка програми 4",
    "fish": "Риба",
    "chicken": "Курка",
    "full_dining_room": "Повна їдальня",
    "missing_amount": "Відсутня сума",
    "missing_trays": "Відсутні підноси",
    "dirty_floor_g1": "Брудна підлога g1",
    "dirty_floor_g2": "Брудна підлога g2",
    "dirty_floor_g3": "Брудна підлога g3",
    "dirty_floor_g4": "Брудна підлога g4",
    "dirty_floor_g5": "Брудна підлога g5",
    "dirty_floor_eo": "Брудна підлога eo",
    "dirty_floor_ceo": "Брудна підлога ceo",
    "dirty_floor_storage": "Брудна підлога на складі",
    "dirty_floor_inflorescence": "Брудна підлога навколо квітів",
    "operating_instructions": "Інструкції з експлуатації",
    "general": "Загальне",
    "connection_problem": "Проблема з підключенням",
    "lighting": "Освітлення",
    "not _fixed": "Не виправлено",
    "cleaning_needed": "Потрібне прибирання",
    "missing_milk": "Відсутнє молоко",
    "no_sugar_coffee": "Немає цукру/кави",
    "missing_tools": "Відсутній посуд",
    "coffee_water_machine": "Кавова/водяна машина",
    "appliances": "Пристрої",
    "products": "Продукти",
    "broken_chair": "Пошкоджене крісло",
    "broken_cabinet": "Пошкоджений шафа",
    "micro": "Мікрохвильова піч",
    "toaster": "Тостер",
    "clogged_sink_malfunction": "Забитий умивальник",
    "coffee_cooling_malfunction": "Непрацюючий охолоджуючий кавовий апарат",
    "no_coffee_beans": "Немає кавових зерен",
    "machine_failure": "Поломка машини",
    "that_dirty": "Це брудне",
    "dirty_refrigerator": "Брудний холодильник",
    "dirty_tables": "Брудні столи",
    "plates": "Тарілки",
    "silver_spoon": "Срібна ложка",
    "cold_drinks_cups": "Келихи для холодних напоїв",
    "hot_drink_cups": "Келихи для гарячих напоїв",
    "a_dripping_faucet": "Крапаючий кран",
    "disposable dishes": "Одноразові посудини",
    "problem_ coffee_water_machine": "Проблема з кавовою/водяною машиною",
    "problem_micro": "Проблема з мікрохвильовою піччю",
    "problem_toaster": "Проблема з тостером",
    "problem_machine_failure": "Поломка машини",
    "problem refrigerator": "Проблема з холодильником",
    "no_sugar/coffee": "Немає цукру/кави",
    "missing_dishes": "Відсутні тарілки",
    "coffee/water_machine": "Кавова/водяна машина",
    "coffee_machine_door_open": "Відкриті двері кавоварки",
    "coffee_machine_door_close": "Закриті двері кавоварки",
    "coffee_machine_bin_full": "Бункер для відходів від кави заповнений",
    "coffee_machine_bin_empty": "Бункер для відходів від кави порожній",
    "coffee_machine_coffee_full": "Бункер для кавових зерен заповнений",
    "coffee_machine_coffee_empty": "Бункер для кавових зерен порожній",
    "coffee_machine_water_tank_empty": "Бак для води в кавоварці порожній",
    "coffee_machine_water_tank_full": "Бак для води в кавоварці заповнений",
    "coffee_machine_milk_cleaning_not_performed": "Прибирання молочного насоса в машині не проведено",
    "coffee_machine _milk_cleaning_performed": "Прибирання молочного насоса в машині проведено",
    "coffee_machine_head_cleaning_not_performed": "Прибирання головки машини не проведено",
    "coffee_machine_head_ cleaning_performed": "Прибирання головки машини проведено",
    "coffee_machine_descaling_not_performed": "Дескальція не проведена",
    "coffee_machine_descaling_performed": "Дескальція проведена",
    "floor_one": "Поверх 1",
    "floor_two": "Поверх 2",
    "floor_three": "Поверх 3",
    "floor_four": "Поверх 4",
    "floor_five": "Поверх 5",
    "floor_six": "Поверх 6",
    "floor_seven": "Поверх 7",
    "floor_eight": "Поверх 8",
    "floor_nine": "Поверх 9",
    "floor_ten": "Поверх 10",
    "floor_eleven": "Поверх 11",
    "floor_twelve": "Поверх 12",
    "floor_thirteen": "Поверх 13",
    "floor_fourteen": "Поверх 14",
    "floor_fifteen": "Поверх 15",
    "floor_sixteen": "Поверх 16",
    "floor_seventeen": "Поверх 17",
    "floor_eighteen": "Поверх 18",
    "floor_nineteen": "Поверх 19",
    "floor_twenty": "Поверх 20",
    "floor_twenty_one": "Поверх 21",
    "floor_twenty_two": "Поверх 22",
    "floor_twenty_three": "Поверх 23",
    "floor_twenty_four": "Поверх 24",
    "floor_twenty_five": "Поверх 25",
    "status_toilet_paper_cell_01_-_empty": "Статус туалетного паперу в кабіні 01 - порожній",
    "status_toilet_paper_cell_02_-_empty": "Статус туалетного паперу в кабіні 02 - порожній",
    "status_toilet_paper_cell_03_-_empty": "Статус туалетного паперу в кабіні 03 - порожній",
    "status_toilet_paper_cell_04_-_empty": "Статус туалетного паперу в кабіні 04 - порожній",
    "status_toilet_paper_cell_05_-_empty": "Статус туалетного паперу в кабіні 05 - порожній",
    "status_toilet_paper_cell_06_-_empty": "Статус туалетного паперу в кабіні 06 - порожній",
    "status_toilet_paper_cell_07_-_empty": "Статус туалетного паперу в кабіні 07 - порожній",
    "status_toilet_paper_cell_08_-_empty": "Статус туалетного паперу в кабіні 08 - порожній",
    "status_toilet_paper_cell_09_-_empty": "Статус туалетного паперу в кабіні 09 - порожній",
    "status_toilet_paper_cell_10_-_empty": "Статус туалетного паперу в кабіні 10 - порожній",
    "status_toilet_paper_cell_11_-_empty": "Статус туалетного паперу в кабіні 11 - порожній",
    "status_toilet_paper_cell_12_-_empty": "Статус туалетного паперу в кабіні 12 - порожній",
    "status_toilet_paper_cell_13_-_empty": "Статус туалетного паперу в кабіні 13 - порожній",
    "status_toilet_paper_cell_14_-_empty": "Статус туалетного паперу в кабіні 14 - порожній",
    "status_toilet_paper_cell_15_-_empty": "Статус туалетного паперу в кабіні 15 - порожній",
    "status_toilet_paper_cell_16_-_empty": "Статус туалетного паперу в кабіні 16 - порожній",
    "status_toilet_paper_cell_17_-_empty": "Статус туалетного паперу в кабіні 17 - порожній",
    "status_toilet_paper_cell_18_-_empty": "Статус туалетного паперу в кабіні 18 - порожній",
    "status_toilet_paper_cell_19_-_empty": "Статус туалетного паперу в кабіні 19 - порожній",
    "status_toilet_paper_cell_20_-_empty": "Статус туалетного паперу в кабіні 20 - порожній",
    "status_toilet_paper_cell_01_-_almost_empty": "Статус туалетного паперу в кабіні 01 - майже порожній",
    "status_toilet_paper_cell_02_-_almost_empty": "Статус туалетного паперу в кабіні 02 - майже порожній",
    "status_toilet_paper_cell_03_-_almost_empty": "Статус туалетного паперу в кабіні 03 - майже порожній",
    "status_toilet_paper_cell_04_-_almost_empty": "Статус туалетного паперу в кабіні 04 - майже порожній",
    "status_toilet_paper_cell_05_-_almost_empty": "Статус туалетного паперу в кабіні 05 - майже порожній",
    "status_toilet_paper_cell_06_-_almost_empty": "Статус туалетного паперу в кабіні 06 - майже порожній",
    "status_toilet_paper_cell_07_-_almost_empty": "Статус туалетного паперу в кабіні 07 - майже порожній",
    "status_toilet_paper_cell_08_-_almost_empty": "Статус туалетного паперу в кабіні 08 - майже порожній",
    "status_toilet_paper_cell_09_-_almost_empty": "Статус туалетного паперу в кабіні 09 - майже порожній",
    "status_toilet_paper_cell_10_-_almost_empty": "Статус туалетного паперу в кабіні 10 - майже порожній",
    "status_toilet_paper_cell_11_-_almost_empty": "Статус туалетного паперу в кабіні 11 - майже порожній",
    "status_toilet_paper_cell_12_-_almost_empty": "Статус туалетного паперу в кабіні 12 - майже порожній",
    "status_toilet_paper_cell_13_-_almost_empty": "Статус туалетного паперу в кабіні 13 - майже порожній",
    "status_toilet_paper_cell_14_-_almost_empty": "Статус туалетного паперу в кабіні 14 - майже порожній",
    "status_toilet_paper_cell_15_-_almost_empty": "Статус туалетного паперу в кабіні 15 - майже порожній",
    "status_toilet_paper_cell_16_-_almost_empty": "Статус туалетного паперу в кабіні 16 - майже порожній",
    "status_toilet_paper_cell_17_-_almost_empty": "Статус туалетного паперу в кабіні 17 - майже порожній",
    "status_toilet_paper_cell_18_-_almost_empty": "Статус туалетного паперу в кабіні 18 - майже порожній",
    "status_toilet_paper_cell_19_-_almost_empty": "Статус туалетного паперу в кабіні 19 - майже порожній",
    "status_toilet_paper_cell_20_-_almost_empty": "Статус туалетного паперу в кабіні 20 - майже порожній",
    "of": "з",
    "items": "елементів",
    "loading_charts": "Завантаження діаграм",
    "refresh_the_room": "Освіжіть кімнату",
    "clean_the_floor": "Помийте підлогу",
    "clean_the_toilet": "Почистіть туалет",
    "refill_soap": "Поповніть мило",
    "change_roll": "Замінити рулон туалетного паперу",
    "great_job": "Чудова робота",
    "empty_the_trash": "Спорожніть смітник",
    "repair_required": "Потрібен ремонт",
    "cleaning": "Прибирання",
    "cleaning_work_plan": "План роботи з прибирання",
    "cleaning_work_plan_intro": "Використовує статистику кімнат за змінами для компанії та локації, обраних у шапці. Візити й приходи беруться з одного дня з найбільшою кількістю відвідувань у вибраному діапазоні та зі змін у фільтрі дашборду (налаштуйте їх у Performance або Analytics, якщо на цій вкладці приховані фільтри часу). Вкажіть візити на прибирання, цільову кількість працівників, вартість години та середній час прибирання в хвилинах; згенеруйте план, щоб побачити рекомендовані прибирання по кімнатах і підсумки.",
    "cleaning_work_plan_default_n": "Візитів на прибирання",
    "cleaning_work_plan_cleaner_count": "Прибиральники (необов'язково)",
    "cleaning_work_plan_avg_minutes": "Середній час прибирання (хв)",
    "cleaning_work_plan_run": "Згенерувати план",
    "cleaning_work_plan_export_csv": "Експорт до Excel",
    "cleaning_work_plan_suggested_n": "Візитів на прибирання",
    "cleaning_work_plan_actual_cleans": "Приходи",
    "cleaning_work_plan_actual_cleans_hint": "Загальна кількість приходів прибиральників у статистиці кімнат за змінами в день піку (у межах вибраного діапазону та фільтрів).",
    "cleaning_work_plan_suggested_cleans": "Рекомендовані прибирання",
    "cleaning_work_plan_cleaner": "Прибиральник",
    "cleaning_work_plan_floors": "Поверхи",
    "cleaning_work_plan_peak_day": "Піковий день",
    "cleaning_work_plan_error": "Не вдалося згенерувати план роботи з прибирання",
    "cleaning_work_plan_no_rooms": "Для цієї локації не повернуто кімнат. Перевірте локацію та діапазон дат або переконайтеся, що кімнати існують у панелі керування.",
    "cleaning_work_plan_need_filter": "Оберіть компанію та локацію в шапці, встановіть діапазон дат (і зміни за потреби) у Performance або Analytics, після чого спробуйте ще раз.",
    "cleaning_work_plan_settings": "Налаштування плану",
    "cleaning_work_plan_desired_employees": "Бажана кількість працівників",
    "cleaning_work_plan_cost_per_hour": "Вартість години",
    "cleaning_work_plan_estimated_cost_suggested": "Орієнтовна вартість (рекомендоване навантаження)",
    "cleaning_work_plan_estimated_cost_actual": "Орієнтовна вартість (фактичне навантаження)",
    "cleaning_work_plan_hours_per_cleaner": "Годин на прибиральника",
    "cleaning_work_plan_metric_title": "Метрики",
    "cleaning_work_plan_metric_avg_cleaning_min": "Середній час прибирання (хв)",
    "cleaning_work_plan_metric_total_arrivals": "Загальна кількість відвідувань",
    "cleaning_work_plan_metric_total_cleaning_min": "Загальний час прибирання (хв)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Загальний час прибирання (год)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Годин на прибиральника",
    "cleaning_work_plan_metric_num_cleaners": "Кількість прибиральників",
    "cleaning_work_plan_summary": "Підсумок",
    "cleaning_work_plan_summary_peak_note": "Візити, приходи та рекомендовані прибирання використовують ті самі правила статистики змін, що й Analytics (включно з агрегацією приходів). Вони розраховуються для пікового дня - календарного дня з найбільшою кількістю візитів у періоді фільтра. Включаються лише розраховані кімнати.",
    "cleaning_work_plan_summary_filter_period": "Період фільтра",
    "cleaning_work_plan_summary_total_visits": "Усього візитів",
    "cleaning_work_plan_summary_total_arrivals": "Усього приходів",
    "cleaning_work_plan_summary_employees_in_site": "Працівників на об'єкті",
    "cleaning_work_plan_summary_shift_working_hours": "Години змін",
    "cleaning_work_plan_hours_unit": "год",
    "cleaning_work_plan_rooms_table": "Кімнати",
    "cleaning_work_plan_cleaners_table": "Рекомендований розподіл прибиральників",
    "cleaning_work_plan_search_rooms": "Пошук кімнат",
    "cleaning_work_plan_total_minutes": "Загалом хвилин",
    "cleaning_work_plan_actual_total_minutes": "Фактичні хвилини (разом)",
    "cleaning_work_plan_actual_total_minutes_hint": "Зафіксовані приходи прибиральників у статистиці змін у піковий день (у межах вибраного періоду), помножені на ваш середній час прибирання.",
    "cleaning_work_plan_suggested_total_minutes": "Рекомендовані хвилини (разом)",
    "cleaning_work_plan_suggested_room_minutes": "Рекомендовані хвилини прибирання",
    "cleaning_work_plan_actual_room_minutes": "Фактичні хвилини прибирання",
    "cleaning_work_plan_cleaner_suggested_minutes": "Реком. хв.",
    "cleaning_work_plan_cleaner_actual_minutes": "Факт. хв.",
    "cleaning_work_plan_period": "Період",
    "cleaning_work_plan_room_count": "Кількість кімнат",
    "cleaning_work_plan_cleaners_working_in_site": "Прибиральники на об'єкті (контакти застосунку)",
    "cleaning_work_plan_cleaners_connection_table": "Прибиральники за кімнатами",
    "cleaning_work_plan_connected_rooms_count": "Кімнати",
    "cleaning_work_plan_connected_floor_count": "Кількість поверхів",
    "cleaning_work_plan_connected_floors_list": "Поверхи",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Співвідношення візити / прибирання",
    "cleaning_work_plan_performance_comparison_table": "Порівняння показників",
    "cleaning_work_plan_performance_comparison_empty": "Завантажте дані прив’язки прибиральників, щоб побачити рядки.",
    "cleaning_work_plan_performance_col_index": "Показник",
    "cleaning_work_plan_performance_existing_plan": "Поточний план робіт",
    "cleaning_work_plan_performance_recommended_plan": "Рекомендований план Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Кількість працівників",
    "cleaning_work_plan_perf_working_hours_per_employee": "Робочі години на працівника",
    "cleaning_work_plan_perf_total_working_hours": "Усього робочих годин",
    "cleaning_work_plan_perf_total_cleaning_hours": "Усього годин прибирання",
    "cleaning_work_plan_perf_daily_cost": "Добова вартість",
    "cleaning_work_plan_perf_total_cleaning_visits": "Усього візитів прибирання",
    "cleaning_work_plan_perf_busiest_area_visits": "Найзавантаженіша зона — візити",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Візити прибирання до найзавантаженішої зони",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Максимальне співвідношення прибирання",
    "cleaning_work_plan_perf_least_busy_visits": "Найменш завантажена зона — візити",
    "cleaning_work_plan_perf_cleaning_to_least": "Візити прибирання до найменш завантаженої зони",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Мінімальне співвідношення прибирання",
    "cleaning_work_plan_ai_allocate": "Розподіл за допомогою ШІ",
    "cleaning_work_plan_ai_allocation_result": "Результат розподілу за допомогою ШІ",
    "cleaning_work_plan_ai_allocation_loading": "Генерування розподілу за допомогою ШІ...",
    "cleaning_work_plan_ai_allocation_error": "Не вдалося згенерувати розподіл за допомогою ШІ. Будь ласка, спробуйте ще раз.",
    "cleaning_work_plan_ai_invalid_employees": "Будь ласка, вкажіть дійсну кількість бажаних працівників.",
    "cleaning_work_plan_ai_status_elapsed": "Минуло: {s} с",
    "cleaning_work_plan_ai_status_hint": "Сервер виконує кілька кроків ШІ послідовно (початковий план, географія, баланс візитів, потім фінальний вивід). Це може зайняти одну–дві хвилини—не закривайте сторінку.",
    "cleaning_work_plan_ai_status_step_1": "Крок 1 — чернетка призначення за даними кімнат і візитів…",
    "cleaning_work_plan_ai_status_step_2": "Крок 2 — уточнення географії (групування поверхів і будівель)…",
    "cleaning_work_plan_ai_status_step_3": "Крок 3 — балансування щоденних візитів між прибиральниками…",
    "cleaning_work_plan_ai_status_step_4": "Крок 4 — формування структурованого розподілу…",
    "cleaning_work_plan_ai_status_step_5": "Крок 5 — перевірка та обрахунок підсумкових метрик…",
    "cleaning_work_plan_ai_cleaner_number": "Прибиральник №",
    "cleaning_work_plan_room_minutes": "Хвилини прибирання",
    "cleaning_work_plan_assigned_cleaner": "Призначений прибиральник",
    "cleaning_work_plan_summary_cleaners": "Прибиральників у плані",
    "cleaning_work_plan_summary_avg_minutes": "Сер. хв / прибирання",
    "cleaning_work_plan_suggested_hours": "Рекомендовані години (разом)",
    "cleaning_work_plan_actual_hours": "Фактичні години (разом)",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Сер. реком. хв / прибиральник",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Сер. факт. хв / прибиральник",
    "cleaning_work_plan_guidelines_title": "Рекомендації з оптимізації",
    "cleaning_work_plan_guidelines_intro": "Інструмент дотримується тих самих цілей, що й ручна оптимізація плану прибирання: навантаження за даними візитів, час за середніми хвилинами на прибирання та збалансований розподіл персоналу зі збереженням географічної логіки поверхів.",
    "cleaning_work_plan_guidelines_b1": "Візити на прибирання (типово 50) відповідають правилу 1:50: рекомендована кількість спрацювань на кімнату приблизно дорівнює візитам, поділеним на візити на прибирання (з округленням вгору). Візити й приходи беруться з найзавантаженішого дня у вибраному періоді.",
    "cleaning_work_plan_guidelines_b2": "Коли задаєте кількість прибиральників, кожен поверх будівлі є однією групою. Поверхи впорядковуються за будівлею та номером поверху, а потім діляться на суміжні блоки між прибиральниками, щоб збалансувати роботу й утримувати близькі поверхи за однією людиною.",
    "cleaning_work_plan_guidelines_b3": "Усі санвузли на одному поверсі залишаються за одним прибиральником, тому чоловічі та жіночі кімнати цього поверху не діляться між різними людьми (якщо в панелі керування мають однакове значення поверху).",
    "cleaning_work_plan_guidelines_b4": "Середні хвилини на прибирання впливають на рекомендовані та фактичні загальні хвилини й години, а також на середні хвилини на прибиральника. Фактичні підсумки = зафіксовані приходи x ваш середній час; рекомендовані підсумки = розраховані прибирання x ваш середній час.",
    "cleaning_work_plan_guidelines_b5": "Використовуйте експорт CSV, якщо хочете доопрацювати розподіл в іншому місці (наприклад, ще краще збалансувати візити).",
    "cleaning_performed": "Прибирання виконано",
  },
  ro: {
    "cleaned_floor": "pardoseala curata",
    "cleaned_toilet": "toaleta curata",
    "cleaned_shower": "dus curat",
    "cleaned_sink": "chiuveta curata",
    "cleaned_mirror": "oglinda curata",
    "cleaned_stainless_steel": "otel inoxidabil curat",
    "bad_smell": "miros neplacut",
    "dirty_floor": "pardoseala murdara",
    "dirty_lavatory_seat": "scaun de toaleta murdar",
    "dirty_shower": "dus murdar",
    "dirty_sink": "chiuveta murdara",
    "dirty_mirror": "oglinda murdara",
    "dirty_stainless_steel": "otel inoxidabil murdar",
    "missing_paper_towel": "lipsa prosop de hartie",
    "missing_soap": "lipsa sapun",
    "missing_toilet_paper": "lipsa hartie igienica",
    "problem_shower": "problema dus",
    "problem_sink": "problema chiuveta",
    "problem_mirror": "problema oglinda",
    "problem_stainless_steel": "problema otel inoxidabil",
    "problem_blockage": "problema blocare",
    "problem_door": "problema usa",
    "problem_fluid_taps": "problema robineti",
    "problem_lightning": "problema iluminare",
    "problem_broken_toilet": "toaleta stricata",
    "fixed_shower": "dus reparat",
    "fixed_sink": "chiuveta reparata",
    "fixed_mirror": "oglinda reparata",
    "fixed_stainless_steel": "otel inoxidabil reparat",
    "fixed_blockage": "blocare reparata",
    "fixed_door": "usa reparata",
    "fixed_fluid_taps": "robineti reparati",
    "fixed_lightning": "iluminare reparata",
    "fixed_broken_toilet": "toaleta reparata",
    "very_good": "foarte bine",
    "excellent": "excelent",
    "good": "bine",
    "like": "imi place",
    "needs_improvement": "necesita imbunatatiri", 
    "not_good": "nu este bine",
    "supervise": "supraveghere",
    "maintenance": "intretinere",
    "cleaner": "curatenie",
    "tag_cleaner": "eticheta curatenie",
    "zone_is_clean": "zona este curata",
    "zone_is_dirty": "zona este murdara",
    "cleaner_arrived": "curatenie sosita",
    "start_clean_zone": "incepe curatenie zona",
    "counter": "ghiseu",
    "counter_men": "ghiseu barbati",
    "counter_woman": "ghiseu femei",
    "counter_handycap": "ghiseu handicapati",
    "full_garbage_can": "cos de gunoi plin",
    "maintenance_fixed": "intretinere reparata",
    "maintenance_problem": "problema intretinere",
    "problem_soap_dispenser": "problema dozator sapun",
    "problem_paper_dispenser": "problema dozator hartie",
    "end_clean_zone": "sfarsit curatenie zona",
    "status_toilet_paper": "status hartie igienica",
    "status_hend_paper": "status hartie maini",
    "fixed": "reparat",
    "status_soap": "status sapun",
    "status_garbage_can": "status cos de gunoi",
    "general_cleaning": "curatenie generala",
    "coffee_tea": "cafea/ceai",
    "water_bar": "bar apa",
    "disposable_dishes": "vase de unica folosinta",
    "head_coverage": "acoperire cap",
    "something_else": "altceva",
    "missing_clothing": "lipsa imbracaminte",
    "maintenance_link": "link intretinere",
    "problem_maintenance": "problema intretinere",
    "supervise_link": "link supraveghere",
    "cleaner_link": "link curatenie",
    "room_men+link": "camera barbati+link",
    "room_men-link": "camera barbati-link",
    "room_women+link": "camera femei+link",
    "room_women-link": "camera femei-link",
    "hebrew": "ebraica",
    "español": "spaniola",
    "français": "franceza",
    "english": "engleza",
    "русский": "rusa",
    "italiano": "italiana",
    "አማርኛ": "amharica",
    "português": "portugheza",
    "arabic": "araba",
    "partial_information": "informatii partiale",
    "professionalism": "profesionalism",
    "the_attitude_of_the_representative": "atitudinea reprezentantului",
    "waiting_time_for_service": "timpul de asteptare pentru serviciu",
    "other_aspect_of_service": "alt aspect al serviciului",
    "language_of_the_service": "limba serviciului",
    "procedure_for_making_an_appointment": "procedura de programare",
    "physical_conditions": "conditii fizice",
    "found_another": "gasit altul",
    "found_similar": "gasit similar",
    "did_not_find": "nu am gasit",
    "found": "gasit",
    "need_improved": "necesita imbunatatiri",
    "liked": "apreciat",
    "pleasant": "placut",
    "eilat_resident": "rezident eilat",
    "once_a_week": "o data pe saptamana",
    "once_a_month": "o data pe luna",
    "twice_a_year": "de doua ori pe an",
    "once_a_year": "o data pe an",
    "friend": "prieten",
    "newspaper": "ziar",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "aspirator",
    "gaming_consoles": "console de jocuri",
    "laptop": "laptop",
    "cellular": "celular",
    "shop": "magazin",
    "restaurant_complex_cleaning": "curatenie complex restaurant",
    "dining_room": "sala de mese",
    "food_variety": "varietatea mancarii",
    "quality_of_the_food": "calitatea mancarii",
    "amount_of_the_food": "cantitatea mancarii",
    "quality_of_cooking": "calitatea gatitului",
    "side_courses": "garnituri",
    "meat": "carne",
    "desserts": "deserturi",
    "vegetarian": "vegetarian",
    "salad_bar": "bar salate",
    "main_courses": "feluri principale",
    "service": "serviciu",
    "dining_room_cleanliness": "curatenie sala de mese",
    "plates_and_cutlery_cleanliness": "curatenie farfurii si tacamuri",
    "product_inventory": "inventar produse",
    "furnishers": "mobilier",
    "toilets": "toaleta",
    "problem_coffee_machine": "problema aparat de cafea",
    "problem_water_bar": "problema bar apa",
    "dirty_stairs": "scari murdare",
    "toiletries": "produse de toaleta",
    "fixed_soap_dispenser": "dozator sapun reparat",
    "fixed_paper_dispenser": "dozator hartie reparat",
    "fixed_coffee_machine": "aparat de cafea reparat",
    "fixed_water_bar": "bar apa reparat",
    "problem_urinals": "problema urinoare",
    "blockage_toilet": "blocaj toaleta",
    "appliance_problem": "problema aparat",
    "problem_broken_door": "problema usa stricata",
    "problem_door_lock": "problema incuietoare usa",
    "problem_broken_toilet_seat": "problema scaun toaleta stricat",
    "problem_broken_niagara": "problema niagara stricata",
    " broken_hand_paper_dispenser_hand_dryer": "dozator hartie maini stricat",
    "rug": "covor",
    "tables": "mese",
    "kitchen": "bucatarie",
    "air_condition": "aer conditionat",
    "dirty_urinals": "urinoare murdare",
    "hand_dryer": "uscator maini",
    "non_sticky_carpet": "covor non-lipicios",
    "problem_bad_smell": "miros neplacut",
    "problem_broken_toilet_handle": "problema maner toaleta stricat",
    "problem_handle_door": "problema maner usa",
    "call_cleaner": "apel curatenie",
    "wall_painting": "pictura perete",
    "missing_paper": "lipsa hartie",
    "clean_surface": "suprafata curata",
    "problem_right_elevator": "problema lift dreapta",
    "problem_left_elevator": "problema lift stanga",
    "missing_hand_sanitizer": "lipsa dezinfectant maini",
    "problem_sink_blockage": "problema blocare chiuveta",
    "electric_problem": "problema electrica",
    "missing_coffe_tea": "lipsa cafea/ceai",
    "problem_air_condition": "problema aer conditionat",
    "dishwashing": "spalat vase",
    "kitchen_cleanliness": "curatenie bucatarie",
    "weekly_cleaning": "curatenie saptamanala",
    "general_arrangement": "aranjament general",
    "meeting_room": "sala de intalniri",
    "refrigerator": "frigider",
    "kitchen_supplies": "provizii bucatarie",
    "toilet_services": "servicii toaleta",
    "carousel_door": "usa carusel",
    "desk": "birou",
    "compressor": "compresor",
    "compressor_rails": "sinuri compresor",
    "compressor_drainage": "drenaj compresor",
    "dust": "praf",
    "door": "usa",
    "scotch": "scotch",
    "food": "mancare",
    "room_conditions": "conditii camera",
    "kindness_sensitivity": "bunatate sensibilitate",
    "explain_process": "explica procesul",
    "personal_attention": "atentie personala",
    "service_problem": "problema serviciu",
    "welcome_you": "va ureaza bun venit",
    "invoice_submitted": "factura depusa",
    "thank_you_bought": "va multumim ca ati cumparat",
    "problem_seller": "problema vanzator",
    "lapel_pin": "ac de rever",
    "proper_performance": "performanta corecta",
    "name_tag": "eticheta nume",
    "operational": "operational",
    "app_revealed": "aplicatie dezvaluita",
    "register_load": "incarcare inregistrare",
    "visibility_problem": "problema vizibilitate",
    "clean_storefront": "fata de magazin curata",
    "clean_garbage": "gunoi curat",
    "clean_tables_chairs": "mese scaune curate",
    "clean_shop_floor": "podea magazin curata",
    "product_show": "produs expus",
    "refrigerators_show": "frigidere expuse",
    "coffee_accessories": "accesorii cafea",
    "cleanliness": "curatenie",
    "convenience_scheduling_appointments": "programare convenabila a programarilor",
    "waiting_haircut": "asteptare tuns",
    "courtesy_books": "carti de curtoazie",
    "books_professionalism": "profesionalism carti",
    "received_time": "timp primit",
    "dnot_appointment": "nu programare",
    "an_appointment": "o programare",
    "tasty": "gustos",
    "courtesy_service": "serviciu de curtoazie", 
    "overall_experience": "experienta generala",
    "not_clean": "nu este curat",
    "diningroom_not_clean": "sala de mese nu este curata",
    "unclean_dishes": "vase nespalate",
    "so-so": "asa si asa",
    "not_tasty": "nu este gustos",
    "kind": "amabil",
    "not_kind": "nu este amabil",
    "clean": "curat",
    "hairdresser": "coafor",
    "wrong_price": "pret gresit",
    "produc_has_expired": "produsul a expirat",
    "missing_item": "element lipsa",
    "item_is_faulty_in_the_machine": "elementul este defect in masina",
    "machine_cleaning": "curatare masina",
    "improper_temperature": "temperatura improprie",
    "green": "verde",
    "orange": "portocaliu",
    "red": "rosu",
    "yellow": "galben",
    "red not prob": "rosu nu este problema",
    "professional": "profesional",
    "unprofessional": "neprofesional",
    "delicacies": "delicatese",
    "sandwiches": "sandvisuri",
    "vegetables": "legume",
    "fruits": "fructe",
    "salads": "salate",
    "milk": "lapte",
    "room_link": "link camera",
    "floor_link": "link etaj",
    "services": "servicii",
    "check_list": "lista de verificare",
    "lighting_problem_lobby": "problema iluminare lobby",
    "lighting_problem_garbage_room": "problema iluminare camera gunoi",
    "lighting_problem_stairwell": "problema iluminare scara",
    "problem_elevator_1": "problema lift 1",
    "problem_elevator_2": "problema lift 2",
    "problem_elevator_3": "problema lift 3",
    "problem_elevator_4": "problema lift 4",
    "problem_elevator_5": "problema lift 5",
    "problem_elevator_6": "problema lift 6",
    "problem_elevator_7": "problema lift 7",
    "problem_elevator_8": "problema lift 8",
    "problem_elevator_9": "problema lift 9",
    "problem_elevator_10": "problema lift 10",
    "stuck_item": "element blocat",
    "spoiling_product": "produs stricat",
    "machine_malfunction": "defectiune masina",
    "unreadable_product": "produs ilegibil",
    "i_am_satisfied": "sunt multumit",
    "beverage": "bautura",
    "program_malfunction": "defectiune program",
    "machine_1": "masina 1",
    "machine_2": "masina 2",
    "machine_3": "masina 3",
    "machine_4": "masina 4",
    "program malfunction 1": "defectiune program 1",
    "program malfunction 2": "defectiune program 2",
    "program malfunction 3": "defectiune program 3",
    "program malfunction 4": "defectiune program 4",
    "fish": "peste",
    "chicken": "pui",
    "full_dining_room": "sala de mese plina",
    "missing_amount": "cantitate lipsa",
    "missing_trays": "tavi lipsa",
    "dirty_floor_g1": "pardoseala murdara g1",
    "dirty_floor_g2": "pardoseala murdara g2",
    "dirty_floor_g3": "pardoseala murdara g3",
    "dirty_floor_g4": "pardoseala murdara g4",
    "dirty_floor_g5": "pardoseala murdara g5",
    "dirty_floor_eo": "pardoseala murdara eo",
    "dirty_floor_ceo": "pardoseala murdara ceo",
    "dirty_floor_storage": "pardoseala murdara depozit",
    "dirty_floor_inflorescence": "pardoseala murdara inflorescenta",
    "operating_instructions": "instructiuni de functionare",
    "general": "general",
    "connection_problem": "problema de conectare",
    "lighting": "iluminare",
    "not_fixed": "nu este reparat",
    "cleaning_needed": "curatenie necesara",
    "missing_milk": "lipsa lapte",
    "no_sugar_coffee": "fara zahar/cafea",
    "missing_tools": "unelte lipsa",
    "coffee_water_machine": "aparat de cafea/apa",
    "appliances": "electrocasnice",
    "products": "produse",
    "broken_chair": "scaun stricat",
    "broken_cabinet": "cabinet stricat",
    "micro": "microunde",
    "toaster": "prajitor",
    "clogged_sink_malfunction": "chiuveta infundata",
    "coffee_cooling_malfunction": "racire cafea",
    "no_coffee_beans": "fara boabe de cafea",
    "machine_failure": "defectiune masina",
    "that_dirty": "acel murdar",
    "dirty_refrigerator": "frigider murdar",
    "dirty_tables": "mese murdare",
    "plates": "farfurii",
    "silver_spoon": "lingura de argint",
    "cold_drinks_cups": "pahare bauturi reci",
    "hot_drink_cups": "pahare bauturi calde",
    "a_dripping_faucet": "robinet picurand",
    "disposable dishes": "vase de unica folosinta",
    "problem_ coffee_water_machine": "problema aparat de cafea/apa",
    "problem_micro": "problema microunde",
    "problem_toaster": "problema prajitor",
    "problem_machine_failure": "problema defectiune masina",
    "problem refrigerator": "problema frigider",
    "no_sugar/coffee": "fara zahar/cafea",
    "missing_dishes": "vase lipsa",
    "coffee/water_machine": "aparat de cafea/apa",
    "coffee_machine_door_open": "usa aparat de cafea deschisa",
    "coffee_machine_door_close": "usa aparat de cafea inchisa",
    "coffee_machine_bin_full": "cos aparat de cafea plin",
    "coffee_machine_bin_empty": "cos aparat de cafea gol",
    "coffee_machine_coffee_full": "cafea aparat de cafea plina",
    "coffee_machine_coffee_empty": "cafea aparat de cafea goala",
    "coffee_machine_water_tank_empty": "rezervor apa aparat de cafea gol",
    "coffee_machine_ water_tank_full": "rezervor apa aparat de cafea plin",
    "coffee_machine_milk_cleaning_not_performed": "curatare lapte aparat de cafea neefectuata",
    "coffee_machine _milk_cleaning_performed": "curatare lapte aparat de cafea efectuata",
    "coffee_machine_head_cleaning_not_performed": "curatare cap aparat de cafea neefectuata",
    "coffee_machine_head_ cleaning_performed": "curatare cap aparat de cafea efectuata",
    "coffee_machine_descaling_not_performed": "descalcire aparat de cafea neefectuata",
    "coffee_machine_descaling_performed": "descalcire aparat de cafea efectuata",
    "floor_one": "etaj 1",
    "floor_two": "etaj 2",
    "floor_three": "etaj 3",
    "floor_four": "etaj 4",
    "floor_five": "etaj 5",
    "floor_six": "etaj 6",
    "floor_seven": "etaj 7",
    "floor_eight": "etaj 8",
    "floor_nine": "etaj 9",
    "floor_ten": "etaj 10",
    "floor_eleven": "etaj 11",
    "floor_twelve": "etaj 12",
    "floor_thirteen": "etaj 13",
    "floor_fourteen": "etaj 14",
    "floor_fifteen": "etaj 15",
    "floor_sixteen": "etaj 16",
    "floor_seventeen": "etaj 17",
    "floor_eighteen": "etaj 18",
    "floor_nineteen": "etaj 19",
    "floor_twenty": "etaj 20",
    "floor_twenty_one": "etaj 21",
    "floor_twenty_two": "etaj 22",
    "floor_twenty_three": "etaj 23",
    "floor_twenty_four": "etaj 24",
    "floor_twenty_five": "etaj 25",
    "status_toilet_paper_cell_01_-_empty": "status hartie igienica celula 01 - goala",
    "status_toilet_paper_cell_02_-_empty": "status hartie igienica celula 02 - goala",
    "status_toilet_paper_cell_03_-_empty": "status hartie igienica celula 03 - goala",
    "status_toilet_paper_cell_04_-_empty": "status hartie igienica celula 04 - goala",
    "status_toilet_paper_cell_05_-_empty": "status hartie igienica celula 05 - goala",
    "status_toilet_paper_cell_06_-_empty": "status hartie igienica celula 06 - goala",
    "status_toilet_paper_cell_07_-_empty": "status hartie igienica celula 07 - goala",
    "status_toilet_paper_cell_08_-_empty": "status hartie igienica celula 08 - goala",
    "status_toilet_paper_cell_09_-_empty": "status hartie igienica celula 09 - goala",
    "status_toilet_paper_cell_10_-_empty": "status hartie igienica celula 10 - goala",
    "status_toilet_paper_cell_11_-_empty": "status hartie igienica celula 11 - goala",
    "status_toilet_paper_cell_12_-_empty": "status hartie igienica celula 12 - goala",
    "status_toilet_paper_cell_13_-_empty": "status hartie igienica celula 13 - goala",
    "status_toilet_paper_cell_14_-_empty": "status hartie igienica celula 14 - goala",
    "status_toilet_paper_cell_15_-_empty": "status hartie igienica celula 15 - goala",
    "status_toilet_paper_cell_16_-_empty": "status hartie igienica celula 16 - goala",
    "status_toilet_paper_cell_17_-_empty": "status hartie igienica celula 17 - goala",
    "status_toilet_paper_cell_18_-_empty": "status hartie igienica celula 18 - goala",
    "status_toilet_paper_cell_19_-_empty": "status hartie igienica celula 19 - goala",
    "status_toilet_paper_cell_20_-_empty": "status hartie igienica celula 20 - goala",
    "status_toilet_paper_cell_01_-_almost_empty": "status hartie igienica celula 01 - aproape goala",
    "status_toilet_paper_cell_02_-_almost_empty": "status hartie igienica celula 02 - aproape goala",
    "status_toilet_paper_cell_03_-_almost_empty": "status hartie igienica celula 03 - aproape goala",
    "status_toilet_paper_cell_04_-_almost_empty": "status hartie igienica celula 04 - aproape goala",
    "status_toilet_paper_cell_05_-_almost_empty": "status hartie igienica celula 05 - aproape goala",
    "status_toilet_paper_cell_06_-_almost_empty": "status hartie igienica celula 06 - aproape goala",
    "status_toilet_paper_cell_07_-_almost_empty": "status hartie igienica celula 07 - aproape goala",
    "status_toilet_paper_cell_08_-_almost_empty": "status hartie igienica celula 08 - aproape goala",
    "status_toilet_paper_cell_09_-_almost_empty": "status hartie igienica celula 09 - aproape goala",
    "status_toilet_paper_cell_10_-_almost_empty": "status hartie igienica celula 10 - aproape goala",
    "status_toilet_paper_cell_11_-_almost_empty": "status hartie igienica celula 11 - aproape goala",
    "status_toilet_paper_cell_12_-_almost_empty": "status hartie igienica celula 12 - aproape goala",
    "status_toilet_paper_cell_13_-_almost_empty": "status hartie igienica celula 13 - aproape goala",
    "status_toilet_paper_cell_14_-_almost_empty": "status hartie igienica celula 14 - aproape goala",
    "status_toilet_paper_cell_15_-_almost_empty": "status hartie igienica celula 15 - aproape goala",
    "status_toilet_paper_cell_16_-_almost_empty": "status hartie igienica celula 16 - aproape goala",
    "status_toilet_paper_cell_17_-_almost_empty": "status hartie igienica celula 17 - aproape goala",
    "status_toilet_paper_cell_18_-_almost_empty": "status hartie igienica celula 18 - aproape goala",
    "status_toilet_paper_cell_19_-_almost_empty": "status hartie igienica celula 19 - aproape goala",
    "status_toilet_paper_cell_20_-_almost_empty": "status hartie igienica celula 20 - aproape goala",
    "of": "din",
    "items": "articole",
    "loading_charts": "Încărcare grafice",
    "refresh_the_room": "Reîmprospătează camera",
    "clean_the_floor": "Curăță podeaua",
    "clean_the_toilet": "Curăță toaleta",
    "refill_soap": "Reumple săpunul",
    "change_roll": "Schimbă rola de hârtie igienică",
    "great_job": "Treabă grozavă",
    "empty_the_trash": "Golește coșul de gunoi",
    "repair_required": "Necesită reparație",
    "cleaning": "Curatenie",
    "cleaning_work_plan": "Plan de lucru pentru curățenie",
    "cleaning_work_plan_intro": "Folosește statisticile camerelor pe ture pentru compania și locația selectate în antet. Vizitele și sosirile sunt preluate din ziua cu cele mai multe vizite din intervalul ales și din turele din filtrul dashboard-ului (setează-le în Performance sau Analytics dacă această filă ascunde controalele de timp și filtrare). Introdu vizite per curățenie, țintă de personal, cost pe oră și timpul mediu de curățenie în minute; generează planul pentru a vedea curățenii sugerate pe cameră și totalurile din rezumat.",
    "cleaning_work_plan_default_n": "Vizite per curățenie",
    "cleaning_work_plan_cleaner_count": "Lucrători curățenie (opțional)",
    "cleaning_work_plan_avg_minutes": "Timp mediu de curățenie (min)",
    "cleaning_work_plan_run": "Generează planul",
    "cleaning_work_plan_export_csv": "Exportă în Excel",
    "cleaning_work_plan_suggested_n": "Vizite per curățenie",
    "cleaning_work_plan_actual_cleans": "Sosiri",
    "cleaning_work_plan_actual_cleans_hint": "Totalul sosirilor lucrătorilor de curățenie în statisticile pe ture, în ziua de vârf (în intervalul și filtrele selectate).",
    "cleaning_work_plan_suggested_cleans": "Curățenii sugerate",
    "cleaning_work_plan_cleaner": "Lucrător",
    "cleaning_work_plan_floors": "Etaje",
    "cleaning_work_plan_peak_day": "Ziua de vârf",
    "cleaning_work_plan_error": "Nu s-a putut genera planul de lucru pentru curățenie",
    "cleaning_work_plan_no_rooms": "Nu au fost returnate camere pentru această locație. Verifică locația și intervalul de date sau confirmă că există camere în panoul de control.",
    "cleaning_work_plan_need_filter": "Selectează compania și locația din antet, setează intervalul de date (și turele, dacă e nevoie) în Performance sau Analytics, apoi încearcă din nou.",
    "cleaning_work_plan_settings": "Setări plan",
    "cleaning_work_plan_desired_employees": "Număr dorit de angajați",
    "cleaning_work_plan_cost_per_hour": "Cost pe oră",
    "cleaning_work_plan_estimated_cost_suggested": "Cost estimat (sarcină sugerată)",
    "cleaning_work_plan_estimated_cost_actual": "Cost estimat (sarcină reală)",
    "cleaning_work_plan_hours_per_cleaner": "Ore per lucrător",
    "cleaning_work_plan_metric_title": "Metrici",
    "cleaning_work_plan_metric_avg_cleaning_min": "Timp mediu de curățenie (min)",
    "cleaning_work_plan_metric_total_arrivals": "Sosiri totale",
    "cleaning_work_plan_metric_total_cleaning_min": "Timp total de curățenie (min)",
    "cleaning_work_plan_metric_total_cleaning_hours": "Timp total de curățenie (ore)",
    "cleaning_work_plan_metric_hours_per_cleaner_row": "Ore per lucrător",
    "cleaning_work_plan_metric_num_cleaners": "Număr de lucrători",
    "cleaning_work_plan_summary": "Rezumat",
    "cleaning_work_plan_summary_peak_note": "Vizitele, sosirile și curățeniile sugerate folosesc aceleași reguli de statistici pe ture ca Analytics (inclusiv agregarea sosirilor). Se calculează pentru ziua de vârf - ziua calendaristică cu cele mai multe vizite din perioada filtrată. Sunt incluse doar camerele calculate.",
    "cleaning_work_plan_summary_filter_period": "Perioada filtrului",
    "cleaning_work_plan_summary_total_visits": "Total vizite",
    "cleaning_work_plan_summary_total_arrivals": "Total sosiri",
    "cleaning_work_plan_summary_employees_in_site": "Angajați pe site",
    "cleaning_work_plan_summary_shift_working_hours": "Ore ture",
    "cleaning_work_plan_hours_unit": "h",
    "cleaning_work_plan_rooms_table": "Camere",
    "cleaning_work_plan_cleaners_table": "Alocare recomandată a personalului de curățenie",
    "cleaning_work_plan_search_rooms": "Caută camere",
    "cleaning_work_plan_total_minutes": "Minute totale",
    "cleaning_work_plan_actual_total_minutes": "Minute reale totale",
    "cleaning_work_plan_actual_total_minutes_hint": "Sosirile înregistrate ale lucrătorilor de curățenie în statisticile pe ture în ziua de vârf (în intervalul selectat), înmulțite cu media ta de minute per curățenie.",
    "cleaning_work_plan_suggested_total_minutes": "Minute sugerate totale",
    "cleaning_work_plan_suggested_room_minutes": "Minute sugerate de curățenie",
    "cleaning_work_plan_actual_room_minutes": "Minute reale de curățenie",
    "cleaning_work_plan_cleaner_suggested_minutes": "Min. sugerate",
    "cleaning_work_plan_cleaner_actual_minutes": "Min. reale",
    "cleaning_work_plan_period": "Perioadă",
    "cleaning_work_plan_room_count": "Număr camere",
    "cleaning_work_plan_cleaners_working_in_site": "Curățatori pe site (contacte din aplicație)",
    "cleaning_work_plan_cleaners_connection_table": "Curățatori după camere",
    "cleaning_work_plan_connected_rooms_count": "Camere",
    "cleaning_work_plan_connected_floor_count": "Număr etaje",
    "cleaning_work_plan_connected_floors_list": "Etaje",
    "cleaning_work_plan_visitor_cleaning_entry_ratio": "Raport vizitator / intrări curățenie",
    "cleaning_work_plan_performance_comparison_table": "Comparație performanță",
    "cleaning_work_plan_performance_comparison_empty": "Încărcați datele de legătură ale curățatorilor pentru a vedea rândurile.",
    "cleaning_work_plan_performance_col_index": "Indicator",
    "cleaning_work_plan_performance_existing_plan": "Plan de lucru existent",
    "cleaning_work_plan_performance_recommended_plan": "Plan recomandat Buzzztech",
    "cleaning_work_plan_perf_number_of_employees": "Număr de angajați",
    "cleaning_work_plan_perf_working_hours_per_employee": "Ore de lucru per angajat",
    "cleaning_work_plan_perf_total_working_hours": "Total ore de lucru",
    "cleaning_work_plan_perf_total_cleaning_hours": "Total ore de curățenie",
    "cleaning_work_plan_perf_daily_cost": "Cost zilnic",
    "cleaning_work_plan_perf_total_cleaning_visits": "Total vizite de curățenie",
    "cleaning_work_plan_perf_busiest_area_visits": "Zona cea mai aglomerată — vizite",
    "cleaning_work_plan_perf_cleaning_to_busiest": "Vizite de curățenie în zona cea mai aglomerată",
    "cleaning_work_plan_perf_max_cleaning_ratio": "Raport maxim de curățenie",
    "cleaning_work_plan_perf_least_busy_visits": "Zona cea mai puțin aglomerată — vizite",
    "cleaning_work_plan_perf_cleaning_to_least": "Vizite de curățenie în zona cea mai puțin aglomerată",
    "cleaning_work_plan_perf_min_cleaning_ratio": "Raport minim de curățenie",
    "cleaning_work_plan_ai_allocate": "Alocare prin IA",
    "cleaning_work_plan_ai_allocation_result": "Rezultat Alocare prin IA",
    "cleaning_work_plan_ai_allocation_loading": "Se generează alocarea prin IA...",
    "cleaning_work_plan_ai_allocation_error": "Eșec la generarea alocării prin IA. Vă rugăm să încercați din nou.",
    "cleaning_work_plan_ai_invalid_employees": "Vă rugăm să setați un număr valid de angajați doriți.",
    "cleaning_work_plan_ai_status_elapsed": "Timp scurs: {s} s",
    "cleaning_work_plan_ai_status_hint": "Serverul rulează mai mulți pași IA în secvență (plan inițial, geografie, echilibrare vizite, apoi rezultat final). Poate dura unul–două minute—păstrați această pagină deschisă.",
    "cleaning_work_plan_ai_status_step_1": "Pasul 1 — schiță de alocare inițială din datele sălilor și vizitelor…",
    "cleaning_work_plan_ai_status_step_2": "Pasul 2 — rafinare geografică (gruparea etajelor și clădirilor apropiate)…",
    "cleaning_work_plan_ai_status_step_3": "Pasul 3 — echilibrarea vizitelor zilnice între curățători…",
    "cleaning_work_plan_ai_status_step_4": "Pasul 4 — generarea alocării structurate…",
    "cleaning_work_plan_ai_status_step_5": "Pasul 5 — validare și calculul metricilor finale…",
    "cleaning_work_plan_ai_cleaner_number": "Curățător #",
    "cleaning_work_plan_room_minutes": "Minute de curățenie",
    "cleaning_work_plan_assigned_cleaner": "Lucrător asignat",
    "cleaning_work_plan_summary_cleaners": "Lucrători în plan",
    "cleaning_work_plan_summary_avg_minutes": "Min medii / curățenie",
    "cleaning_work_plan_suggested_hours": "Ore totale sugerate",
    "cleaning_work_plan_actual_hours": "Ore totale reale",
    "cleaning_work_plan_avg_suggested_min_per_cleaner": "Medie min. sugerate / lucrător",
    "cleaning_work_plan_avg_actual_min_per_cleaner": "Medie min. reale / lucrător",
    "cleaning_work_plan_guidelines_title": "Ghid de optimizare",
    "cleaning_work_plan_guidelines_intro": "Acest instrument urmează aceleași obiective ca optimizarea manuală a planului de curățenie: încărcare din datele de vizite, timp din media de minute pe curățenie și personal echilibrat cu logică geografică pe etaje.",
    "cleaning_work_plan_guidelines_b1": "Vizite per curățenie (implicit 50) urmează regula 1:50: intrările sugerate per cameră sunt aproximativ vizite împărțite la vizite per curățenie (rotunjite în sus). Vizitele și sosirile sunt luate din cea mai aglomerată zi din perioada selectată.",
    "cleaning_work_plan_guidelines_b2": "Când setezi numărul de lucrători, fiecare etaj al clădirii este un grup. Etajele sunt ordonate după clădire și număr de etaj, apoi împărțite în blocuri continue între lucrători pentru a echilibra munca sugerată și a păstra etajele apropiate la aceeași persoană.",
    "cleaning_work_plan_guidelines_b3": "Toate toaletele de pe același etaj rămân la același lucrător, deci toaletele de bărbați și femei de pe acel etaj nu sunt împărțite între persoane diferite (atât timp cât au aceeași valoare de etaj în panoul de control).",
    "cleaning_work_plan_guidelines_b4": "Media de minute per curățenie determină minutele și orele totale sugerate și reale, precum și media pe lucrător. Totalurile reale folosesc sosiri înregistrate x media ta; totalurile sugerate folosesc curățenii implicite x media ta.",
    "cleaning_work_plan_guidelines_b5": "Folosește Export CSV dacă vrei să rafinezi alocarea în altă parte (de exemplu pentru a echilibra și mai bine distribuția vizitelor).",
    "cleaning_performed": "Curățenia efectuată",
  },
  nl: {
  cleaned_floor: "Vloer schoongemaakt",
  cleaned_toilet: "Toilet schoongemaakt",
  cleaned_shower: "Douche schoongemaakt",
  cleaned_sink: "Wastafel schoongemaakt",
  cleaned_mirror: "Spiegel schoongemaakt",
  cleaned_stainless_steel: "Rvs schoongemaakt",
  bad_smell: "Bad geur",
  dirty_floor: "Vuile vloer",
  dirty_lavatory_seat: "Vuile toiletbril",
  dirty_shower: "Vuile douche",
  dirty_sink: "Vuile wastafel",
  dirty_mirror: "Vuile spiegel",
  dirty_stainless_steel: "Vuile rvs",
  missing_paper_towel: "Papieren handdoek ontbreekt",
  missing_soap: "Zeep ontbreekt",
  missing_toilet_paper: "Toiletpapier ontbreekt",
  problem_shower: "Probleem: douche",
  problem_sink: "Probleem: wastafel",
  problem_mirror: "Probleem: spiegel",
  problem_stainless_steel: "Probleem: rvs",
  problem_blockage: "Probleem: verstopping",
  problem_door: "Probleem: deur",
  problem_fluid_taps: "Probleem: kraan",
  problem_lightning: "Probleem: verlichting",
  problem_broken_toilet: "Probleem: kapotte toilet",
  fixed_shower: "Douche gerepareerd",
  fixed_sink: "Wastafel gerepareerd",
  fixed_mirror: "Spiegel gerepareerd",
  fixed_stainless_steel: "Rvs gerepareerd",
  fixed_blockage: "Verstopping gerepareerd",
  fixed_door: "Deur gerepareerd",
  fixed_fluid_taps: "Kraan gerepareerd",
  fixed_lightning: "Verlichting gerepareerd",
  fixed_broken_toilet: "Kapotte toilet gerepareerd",
  very_good: "Very good",
  excellent: "uitstekend",
  good: "goed",
  like: "leuk",
  needs_improvement: "verbetering nodig",
  not_good: "Not good",
  supervise: "supervisor",
  maintenance: "onderhoud",
  cleaner: "schoonmaker",
  tag_cleaner: "schoonmaker-tag",
  zone_is_clean: "zone is schoon",
  zone_is_dirty: "zone is vuil",
  cleaner_arrived: "schoonmaker aangekomen",
  start_clean_zone: "start schoonmaak zone",
  counter: "bezoekenteller",
  counter_men: "teller herentoilet",
  counter_woman: "teller damentoilet",
  counter_handycap: "teller mindervalidentoilet",
  full_garbage_can: "volle afvalbak",
  maintenance_fixed: "onderhoud opgelost",
  maintenance_problem: "onderhoudsprobleem",
  problem_soap_dispenser: "probleem zeepdispenser",
  problem_paper_dispenser: "probleem papierdispenser",
  end_clean_zone: "einde schoonmaak zone",
  status_toilet_paper: "status toiletpapier",
  status_hend_paper: "status handpapier",
  fixed: "opgelost",
  status_soap: "status zeep",
  status_garbage_can: "status afvalbak",
  general_cleaning: "algemene schoonmaak",
  coffee_tea: "koffie/thee",
  water_bar: "waterdispenser",
  disposable_dishes: "wegwerpservies",
  head_coverage: "hoofdbedekking",
  something_else: "iets anders",
  missing_clothing: "ontbrekende kleding",
  maintenance_link: "onderhoudskoppeling",
  problem_maintenance: "onderhoudsprobleem",
  supervise_link: "supervisor-koppeling",
  cleaner_link: "schoonmaker-koppeling",
  "room_men+link": "herentoilet + koppeling",
  "room_men-link": "herentoilet - koppeling",
  "room_women+link": "damentoilet + koppeling",
  "room_women-link": "damentoilet - koppeling",
  hebrew: "Hebreeuws",
  english: "Engels",
  italiano: "italiano",
  arabic: "Arabisch",
  partial_information: "gedeeltelijke informatie",
  professionalism: "professionaliteit",
  the_attitude_of_the_representative: "houding van de medewerker",
  waiting_time_for_service: "wachttijd voor service",
  other_aspect_of_service: "ander aspect van de service",
  language_of_the_service: "taal van de service",
  procedure_for_making_an_appointment: "procedure voor het maken van een afspraak",
  physical_conditions: "fysieke omstandigheden",
  found_another: "iets anders gevonden",
  found_similar: "vergelijkbaar gevonden",
  did_not_find: "niet gevonden",
  found: "Gevonden",
  need_improved: "verbetering nodig",
  liked: "bevallen",
  pleasant: "Prettig",
  eilat_resident: "inwoner van Eilat",
  once_a_week: "een keer per week",
  once_a_month: "een keer per maand",
  twice_a_year: "twee keer per jaar",
  once_a_year: "een keer per jaar",
  friend: "Vriend",
  newspaper: "Krant",
  google: "google",
  zap: "zap",
  vacuum_cleaner: "stofzuiger",
  gaming_consoles: "spelconsoles",
  laptop: "Laptop",
  cellular: "Mobiel",
  shop: "Winkel",
  restaurant_complex_cleaning: "schoonmaak restaurantcomplex",
  dining_room: "eetzaal",
  food_variety: "variëteit aan eten",
  quality_of_the_food: "kwaliteit van het eten",
  amount_of_the_food: "hoeveelheid eten",
  quality_of_cooking: "kwaliteit van bereiding",
  side_courses: "bijgerechten",
  meat: "Vlees",
  desserts: "Desserts",
  vegetarian: "Vegetarisch",
  salad_bar: "saladebar",
  main_courses: "hoofdgerechten",
  service: "Service",
  dining_room_cleanliness: "netheid eetzaal",
  plates_and_cutlery_cleanliness: "netheid borden en bestek",
  product_inventory: "productvoorraad",
  furnishers: "meubilair",
  toilets: "Toiletten",
  problem_coffee_machine: "probleem koffieapparaat",
  problem_water_bar: "probleem waterdispenser",
  dirty_stairs: "vuile trappen",
  toiletries: "toiletartikelen",
  fixed_soap_dispenser: "zeepdispenser gerepareerd",
  fixed_paper_dispenser: "papierdispenser gerepareerd",
  fixed_coffee_machine: "koffieapparaat gerepareerd",
  fixed_water_bar: "waterdispenser gerepareerd",
  problem_urinals: "probleem urinoirs",
  blockage_toilet: "verstopte toilet",
  appliance_problem: "apparaatprobleem",
  problem_broken_door: "probleem kapotte deur",
  problem_door_lock: "probleem deurslot",
  problem_broken_toilet_seat: "probleem kapotte toiletbril",
  problem_broken_niagara: "probleem kapotte niagara",
  " broken_hand_paper_dispenser_hand_dryer": "kapotte papierdispenser/handdroger",
  rug: "Kleed",
  tables: "Tafels",
  kitchen: "Keuken",
  air_condition: "airconditioning",
  dirty_urinals: "vuile urinoirs",
  hand_dryer: "handdroger",
  non_sticky_carpet: "niet-kleverig tapijt",
  problem_bad_smell: "probleem slechte geur",
  problem_broken_toilet_handle: "probleem kapotte toiletgreep",
  problem_handle_door: "probleem deurgreep",
  call_cleaner: "schoonmaker oproepen",
  wall_painting: "muurverf",
  missing_paper: "papier ontbreekt",
  clean_surface: "schoon oppervlak",
  problem_right_elevator: "probleem rechter lift",
  problem_left_elevator: "probleem linker lift",
  missing_hand_sanitizer: "handdesinfectie ontbreekt",
  problem_sink_blockage: "probleem verstopte wastafel",
  electric_problem: "elektrisch probleem",
  missing_coffe_tea: "koffie/thee ontbreekt",
  problem_air_condition: "probleem airconditioning",
  dishwashing: "afwassen",
  kitchen_cleanliness: "netheid keuken",
  weekly_cleaning: "wekelijkse schoonmaak",
  general_arrangement: "algemene indeling",
  meeting_room: "vergaderruimte",
  refrigerator: "Koelkast",
  kitchen_supplies: "keukenbenodigdheden",
  toilet_services: "toiletdiensten",
  carousel_door: "draaideur",
  desk: "Bureau",
  compressor: "compressor",
  compressor_rails: "compressor rails",
  compressor_drainage: "compressor afvoer",
  dust: "Stof",
  door: "Deur",
  scotch: "plakband",
  food: "Voedsel",
  room_conditions: "kamersituatie",
  kindness_sensitivity: "vriendelijkheid en aandacht",
  explain_process: "proces uitleggen",
  personal_attention: "persoonlijke aandacht",
  service_problem: "serviceprobleem",
  welcome_you: "welkom",
  invoice_submitted: "factuur ingediend",
  thank_you_bought: "bedankt voor uw aankoop",
  problem_seller: "probleem verkoper",
  lapel_pin: "reversspeld",
  proper_performance: "correcte uitvoering",
  name_tag: "naamkaartje",
  operational: "operationeel",
  app_revealed: "app getoond",
  register_load: "kassa belasting",
  visibility_problem: "zichtbaarheidsprobleem",
  clean_storefront: "schone etalage",
  clean_garbage: "schone afvalbak",
  clean_tables_chairs: "schone tafels en stoelen",
  clean_shop_floor: "schone winkelvloer",
  product_show: "productpresentatie",
  refrigerators_show: "koelkastpresentatie",
  coffee_accessories: "koffie-accessoires",
  cleanliness: "netheid",
  convenience_scheduling_appointments: "gemak bij het plannen van afspraken",
  waiting_haircut: "wachten op knipbeurt",
  courtesy_books: "vriendelijke boeken",
  books_professionalism: "professionaliteit",
  received_time: "op tijd ontvangen",
  dnot_appointment: "geen afspraak gemaakt",
  an_appointment: "afspraak gemaakt",
  tasty: "Lekker",
  courtesy_service: "vriendelijke service",
  overall_experience: "totale ervaring",
  not_clean: "niet schoon",
  diningroom_not_clean: "eetzaal niet schoon",
  unclean_dishes: "vuile afwas",
  "so-so": "matig",
  not_tasty: "niet lekker",
  kind: "Vriendelijk",
  not_kind: "niet vriendelijk",
  clean: "Schoon",
  hairdresser: "kapper",
  wrong_price: "verkeerde prijs",
  produc_has_expired: "product verlopen",
  missing_item: "item ontbreekt",
  item_is_faulty_in_the_machine: "item defect in machine",
  machine_cleaning: "machinereiniging",
  improper_temperature: "onjuiste temperatuur",
  green: "Groen",
  orange: "Oranje",
  red: "Rood",
  yellow: "Geel",
  "red not prob": "rood geen probleem",
  professional: "Professioneel",
  unprofessional: "onprofessioneel",
  delicacies: "delicatessen",
  sandwiches: "Broodjes",
  vegetables: "Groenten",
  fruits: "Fruit",
  salads: "Salades",
  milk: "Melk",
  room_link: "kamerkoppeling",
  floor_link: "verdiepingskoppeling",
  services: "diensten",
  check_list: "checklist",
  lighting_problem_lobby: "verlichtingsprobleem lobby",
  lighting_problem_garbage_room: "verlichtingsprobleem afvalruimte",
  lighting_problem_stairwell: "verlichtingsprobleem trappenhuis",
  problem_elevator_1: "Probleem: lift 1",
  problem_elevator_2: "Probleem: lift 2",
  problem_elevator_3: "Probleem: lift 3",
  problem_elevator_4: "Probleem: lift 4",
  problem_elevator_5: "Probleem: lift 5",
  problem_elevator_6: "Probleem: lift 6",
  problem_elevator_7: "Probleem: lift 7",
  problem_elevator_8: "Probleem: lift 8",
  problem_elevator_9: "Probleem: lift 9",
  problem_elevator_10: "Probleem: lift 10",
  stuck_item: "vastgelopen item",
  spoiling_product: "bedorven product",
  machine_malfunction: "machinestoring",
  unreadable_product: "onleesbaar product",
  i_am_satisfied: "ik ben tevreden",
  beverage: "Drank",
  program_malfunction: "programmastoring",
  machine_1: "Machine 1",
  machine_2: "Machine 2",
  machine_3: "Machine 3",
  machine_4: "Machine 4",
  "program malfunction 1": "Programmastoring 1",
  "program malfunction 2": "Programmastoring 2",
  "program malfunction 3": "Programmastoring 3",
  "program malfunction 4": "Programmastoring 4",
  fish: "Vis",
  chicken: "Kip",
  full_dining_room: "volle eetzaal",
  missing_amount: "ontbrekend bedrag",
  missing_trays: "ontbrekende dienbladen",
  dirty_floor_g1: "Vuile vloer g1",
  dirty_floor_g2: "Vuile vloer g2",
  dirty_floor_g3: "Vuile vloer g3",
  dirty_floor_g4: "Vuile vloer g4",
  dirty_floor_g5: "Vuile vloer g5",
  dirty_floor_eo: "Vuile vloer eo",
  dirty_floor_ceo: "Vuile vloer ceo",
  dirty_floor_storage: "Vuile vloer storage",
  dirty_floor_inflorescence: "Vuile vloer inflorescence",
  operating_instructions: "bedieningsinstructies",
  general: "Algemeen",
  connection_problem: "verbindingsprobleem",
  lighting: "Verlichting",
  "not _fixed": "Not fixed",
  cleaning_needed: "schoonmaak nodig",
  missing_milk: "melk ontbreekt",
  no_sugar_coffee: "geen suiker/koffie",
  missing_tools: "gereedschap ontbreekt",
  coffee_water_machine: "koffie/watermachine",
  appliances: "Apparatuur",
  products: "Producten",
  broken_chair: "kapotte stoel",
  broken_cabinet: "kapotte kast",
  micro: "magnetron",
  toaster: "Broodrooster",
  clogged_sink_malfunction: "verstopte wastafel",
  coffee_cooling_malfunction: "koelingsstoring koffie",
  no_coffee_beans: "geen koffiebonen",
  machine_failure: "machinestoring",
  that_dirty: "dat is vuil",
  dirty_refrigerator: "vuile koelkast",
  dirty_tables: "vuile tafels",
  plates: "Borden",
  silver_spoon: "zilveren lepel",
  cold_drinks_cups: "bekers koude dranken",
  hot_drink_cups: "bekers warme dranken",
  a_dripping_faucet: "druppelende kraan",
  "disposable dishes": "wegwerpservies",
  "problem_ coffee_water_machine": "probleem koffie/watermachine",
  problem_micro: "probleem magnetron",
  problem_toaster: "probleem broodrooster",
  problem_machine_failure: "machinestoring",
  "problem refrigerator": "probleem koelkast",
  "no_sugar/coffee": "geen suiker/koffie",
  missing_dishes: "servies ontbreekt",
  "coffee/water_machine": "koffie/watermachine",
  coffee_machine_door_open: "Koffieautomaat deur open",
  coffee_machine_door_close: "Koffieautomaat deur dicht",
  coffee_machine_bin_full: "Koffieautomaat bak vol",
  coffee_machine_bin_empty: "Koffieautomaat bak leeg",
  coffee_machine_coffee_full: "Koffieautomaat koffie vol",
  coffee_machine_coffee_empty: "Koffieautomaat koffie leeg",
  coffee_machine_water_tank_empty: "Koffieautomaat watertank leeg",
  "coffee_machine_ water_tank_full": "Koffieautomaat watertank vol",
  coffee_machine_milk_cleaning_not_performed: "Melkreiniging koffieautomaat niet uitgevoerd",
  "coffee_machine _milk_cleaning_performed": "Melkreiniging koffieautomaat uitgevoerd",
  coffee_machine_head_cleaning_not_performed: "Kopreiniging koffieautomaat niet uitgevoerd",
  "coffee_machine_head_ cleaning_performed": "Kopreiniging koffieautomaat uitgevoerd",
  coffee_machine_descaling_not_performed: "Ontkalking koffieautomaat niet uitgevoerd",
  coffee_machine_descaling_performed: "Ontkaling koffieautomaat uitgevoerd",
  floor_one: "Vloer 1",
  floor_two: "Vloer 2",
  floor_three: "Vloer 3",
  floor_four: "Vloer 4",
  floor_five: "Vloer 5",
  floor_six: "Vloer 6",
  floor_seven: "Vloer 7",
  floor_eight: "Vloer 8",
  floor_nine: "Vloer 9",
  floor_ten: "Vloer 10",
  floor_eleven: "Vloer 11",
  floor_twelve: "Vloer 12",
  floor_thirteen: "Vloer 13",
  floor_fourteen: "Vloer 14",
  floor_fifteen: "Vloer 15",
  floor_sixteen: "Vloer 16",
  floor_seventeen: "Vloer 17",
  floor_eighteen: "Vloer 18",
  floor_nineteen: "Vloer 19",
  floor_twenty: "Vloer 20",
  floor_twenty_one: "Vloer 21",
  floor_twenty_two: "Vloer 22",
  floor_twenty_three: "Vloer 23",
  floor_twenty_four: "Vloer 24",
  floor_twenty_five: "Vloer 25",
  "status_toilet_paper_cell_01_-_empty": "Status toiletpapier cel 01 - leeg",
  "status_toilet_paper_cell_02_-_empty": "Status toiletpapier cel 02 - leeg",
  "status_toilet_paper_cell_03_-_empty": "Status toiletpapier cel 03 - leeg",
  "status_toilet_paper_cell_04_-_empty": "Status toiletpapier cel 04 - leeg",
  "status_toilet_paper_cell_05_-_empty": "Status toiletpapier cel 05 - leeg",
  "status_toilet_paper_cell_06_-_empty": "Status toiletpapier cel 06 - leeg",
  "status_toilet_paper_cell_07_-_empty": "Status toiletpapier cel 07 - leeg",
  "status_toilet_paper_cell_08_-_empty": "Status toiletpapier cel 08 - leeg",
  "status_toilet_paper_cell_09_-_empty": "Status toiletpapier cel 09 - leeg",
  "status_toilet_paper_cell_10_-_empty": "Status toiletpapier cel 10 - leeg",
  "status_toilet_paper_cell_11_-_empty": "Status toiletpapier cel 11 - leeg",
  "status_toilet_paper_cell_12_-_empty": "Status toiletpapier cel 12 - leeg",
  "status_toilet_paper_cell_13_-_empty": "Status toiletpapier cel 13 - leeg",
  "status_toilet_paper_cell_14_-_empty": "Status toiletpapier cel 14 - leeg",
  "status_toilet_paper_cell_15_-_empty": "Status toiletpapier cel 15 - leeg",
  "status_toilet_paper_cell_16_-_empty": "Status toiletpapier cel 16 - leeg",
  "status_toilet_paper_cell_17_-_empty": "Status toiletpapier cel 17 - leeg",
  "status_toilet_paper_cell_18_-_empty": "Status toiletpapier cel 18 - leeg",
  "status_toilet_paper_cell_19_-_empty": "Status toiletpapier cel 19 - leeg",
  "status_toilet_paper_cell_20_-_empty": "Status toiletpapier cel 20 - leeg",
  "status_toilet_paper_cell_01_-_almost_empty": "Status toiletpapier cel 01 - bijna leeg",
  "status_toilet_paper_cell_02_-_almost_empty": "Status toiletpapier cel 02 - bijna leeg",
  "status_toilet_paper_cell_03_-_almost_empty": "Status toiletpapier cel 03 - bijna leeg",
  "status_toilet_paper_cell_04_-_almost_empty": "Status toiletpapier cel 04 - bijna leeg",
  "status_toilet_paper_cell_05_-_almost_empty": "Status toiletpapier cel 05 - bijna leeg",
  "status_toilet_paper_cell_06_-_almost_empty": "Status toiletpapier cel 06 - bijna leeg",
  "status_toilet_paper_cell_07_-_almost_empty": "Status toiletpapier cel 07 - bijna leeg",
  "status_toilet_paper_cell_08_-_almost_empty": "Status toiletpapier cel 08 - bijna leeg",
  "status_toilet_paper_cell_09_-_almost_empty": "Status toiletpapier cel 09 - bijna leeg",
  "status_toilet_paper_cell_10_-_almost_empty": "Status toiletpapier cel 10 - bijna leeg",
  "status_toilet_paper_cell_11_-_almost_empty": "Status toiletpapier cel 11 - bijna leeg",
  "status_toilet_paper_cell_12_-_almost_empty": "Status toiletpapier cel 12 - bijna leeg",
  "status_toilet_paper_cell_13_-_almost_empty": "Status toiletpapier cel 13 - bijna leeg",
  "status_toilet_paper_cell_14_-_almost_empty": "Status toiletpapier cel 14 - bijna leeg",
  "status_toilet_paper_cell_15_-_almost_empty": "Status toiletpapier cel 15 - bijna leeg",
  "status_toilet_paper_cell_16_-_almost_empty": "Status toiletpapier cel 16 - bijna leeg",
  "status_toilet_paper_cell_17_-_almost_empty": "Status toiletpapier cel 17 - bijna leeg",
  "status_toilet_paper_cell_18_-_almost_empty": "Status toiletpapier cel 18 - bijna leeg",
  "status_toilet_paper_cell_19_-_almost_empty": "Status toiletpapier cel 19 - bijna leeg",
  "status_toilet_paper_cell_20_-_almost_empty": "Status toiletpapier cel 20 - bijna leeg",
  of: "Van",
  items: "Items",
  loading_charts: "Grafieken laden",
  refresh_the_room: "kamer verversen",
  clean_the_floor: "vloer schoonmaken",
  clean_the_toilet: "toilet schoonmaken",
  refill_soap: "zeep bijvullen",
  change_roll: "rol vervangen",
  great_job: "goed gedaan",
  empty_the_trash: "afval legen",
  repair_required: "reparatie vereist",
  cleaning: "Schoonmaak",
  cleaning_performed: "schoonmaak uitgevoerd",
  },
  cs: {
  cleaned_floor: "vyčištěná podlaha",
  cleaned_toilet: "vyčištěná toaleta",
  cleaned_shower: "vyčištěná sprcha",
  cleaned_sink: "vyčištěný dřez",
  cleaned_mirror: "vyčištěné zrcadlo",
  cleaned_stainless_steel: "vyčištěná nerezová ocel",
  bad_smell: "zápach",
  dirty_floor: "špinavá podlaha",
  dirty_lavatory_seat: "špinavé záchodové sedátko",
  dirty_shower: "špinavá sprcha",
  dirty_sink: "špinavé umyvadlo",
  dirty_mirror: "špinavé zrcadlo",
  dirty_stainless_steel: "špinavá nerezová ocel",
  missing_paper_towel: "chybí papírový ručník",
  missing_soap: "chybí mýdlo",
  missing_toilet_paper: "chybí toaletní papír",
  problem_shower: "problémová sprcha",
  problem_sink: "problémová jímka",
  problem_mirror: "problémové zrcadlo",
  problem_stainless_steel: "problém z nerezové oceli",
  problem_blockage: "problémové zablokování",
  problem_door: "problémové dveře",
  problem_fluid_taps: "kohoutky problémových kapalin",
  problem_lightning: "problémový blesk",
  problem_broken_toilet: "problém rozbité WC",
  fixed_shower: "pevná sprcha",
  fixed_sink: "pevné umyvadlo",
  fixed_mirror: "pevné zrcadlo",
  fixed_stainless_steel: "pevná nerezová ocel",
  fixed_blockage: "pevná blokáda",
  fixed_door: "pevné dveře",
  fixed_fluid_taps: "pevné kohoutky na tekutiny",
  fixed_lightning: "pevný blesk",
  fixed_broken_toilet: "opravené rozbité WC",
  very_good: "velmi dobré",
  excellent: "vynikající",
  good: "dobrý",
  like: "jako",
  needs_improvement: "potřebuje zlepšení",
  not_good: "není dobré",
  supervise: "dohlížet",
  maintenance: "údržba",
  cleaner: "čistič",
  tag_cleaner: "čistič štítků",
  zone_is_clean: "zóna je čistá",
  zone_is_dirty: "zóna je špinavá",
  cleaner_arrived: "dorazil čistič",
  start_clean_zone: "spustit čistou zónu",
  counter: "čelit",
  counter_men: "pult muži",
  counter_woman: "pult žena",
  counter_handycap: "pult handycap",
  full_garbage_can: "plná popelnice",
  maintenance_fixed: "údržba opravena",
  maintenance_problem: "problém s údržbou",
  problem_soap_dispenser: "problémový dávkovač mýdla",
  problem_paper_dispenser: "problémový zásobník papíru",
  end_clean_zone: "konec čisté zóny",
  status_toilet_paper: "stav toaletního papíru",
  status_hend_paper: "stavový hed paper",
  fixed: "opraveno",
  status_soap: "stavové mýdlo",
  status_garbage_can: "stav popelnice",
  general_cleaning: "generální úklid",
  coffee_tea: "káva čaj",
  water_bar: "vodní bar",
  disposable_dishes: "nádobí na jedno použití",
  head_coverage: "krytí hlavy",
  something_else: "něco jiného",
  missing_clothing: "chybějící oblečení",
  maintenance_link: "odkaz na údržbu",
  problem_maintenance: "problémová údržba",
  supervise_link: "dohledový odkaz",
  cleaner_link: "čistší odkaz",
  "room_men+link": "pokoj muži + odkaz",
  "room_men-link": "pokoj muži - odkaz",
  "room_women+link": "pokoj ženy + odkaz",
  "room_women-link": "pokoj ženy - odkaz",
  hebrew: "hebrejština",
  english: "angličtina",
  italiano: "italština",
  arabic: "arabština",
  partial_information: "dílčí informace",
  professionalism: "profesionalita",
  the_attitude_of_the_representative: "postoj zastupitele",
  waiting_time_for_service: "čekací doba na servis",
  other_aspect_of_service: "jiný aspekt služby",
  language_of_the_service: "jazyk služby",
  procedure_for_making_an_appointment: "postup pro sjednání schůzky",
  physical_conditions: "fyzické podmínky",
  found_another: "našel další",
  found_similar: "našli podobné",
  did_not_find: "nenašel",
  found: "nalezeno",
  need_improved: "potřeba zlepšit",
  liked: "líbilo",
  pleasant: "příjemný",
  eilat_resident: "obyvatel eilatu",
  once_a_week: "jednou týdně",
  once_a_month: "jednou za měsíc",
  twice_a_year: "dvakrát ročně",
  once_a_year: "jednou za rok",
  friend: "přítel",
  newspaper: "noviny",
  google: "google",
  zap: "zap",
  vacuum_cleaner: "vysavač",
  gaming_consoles: "herní konzole",
  laptop: "notebook",
  cellular: "celulární",
  shop: "nakupovat",
  restaurant_complex_cleaning: "úklid restauračního komplexu",
  dining_room: "jídelna",
  food_variety: "rozmanitost jídla",
  quality_of_the_food: "kvalitu jídla",
  amount_of_the_food: "množství jídla",
  quality_of_cooking: "kvalita vaření",
  side_courses: "vedlejší kurzy",
  meat: "maso",
  desserts: "dezerty",
  vegetarian: "vegetariánský",
  salad_bar: "salátový bar",
  main_courses: "hlavní chody",
  service: "servis",
  dining_room_cleanliness: "čistota jídelny",
  plates_and_cutlery_cleanliness: "čistota talířů a příborů",
  product_inventory: "inventář produktů",
  furnishers: "nábytkáři",
  toilets: "toalety",
  problem_coffee_machine: "problémový kávovar",
  problem_water_bar: "problémový vodní bar",
  dirty_stairs: "špinavé schody",
  toiletries: "toaletní potřeby",
  fixed_soap_dispenser: "pevný dávkovač mýdla",
  fixed_paper_dispenser: "pevný zásobník papíru",
  fixed_coffee_machine: "pevný kávovar",
  fixed_water_bar: "pevný vodní bar",
  problem_urinals: "problémové pisoáry",
  blockage_toilet: "ucpaný záchod",
  appliance_problem: "problém se spotřebičem",
  problem_broken_door: "problém rozbité dveře",
  problem_door_lock: "problémový zámek dveří",
  problem_broken_toilet_seat: "problém rozbité záchodové prkénko",
  problem_broken_niagara: "problém zlomená niagara",
  " broken_hand_paper_dispenser_hand_dryer": "rozbitý zásobník na ruční papír + vysoušeč rukou",
  rug: "koberec",
  tables: "tabulky",
  kitchen: "kuchyně",
  air_condition: "klimatizace",
  dirty_urinals: "špinavé pisoáry",
  hand_dryer: "vysoušeč rukou",
  non_sticky_carpet: "nelepivý koberec",
  problem_bad_smell: "problém nepříjemný zápach",
  problem_broken_toilet_handle: "problém s rozbitou rukojetí toalety",
  problem_handle_door: "problémová klika dveří",
  call_cleaner: "zavolejte uklízečku",
  wall_painting: "nástěnná malba",
  missing_paper: "chybějící papír",
  clean_surface: "čistý povrch",
  problem_right_elevator: "problém pravý výtah",
  problem_left_elevator: "problém s levým výtahem",
  missing_hand_sanitizer: "chybí dezinfekce na ruce",
  problem_sink_blockage: "problémové ucpání dřezu",
  electric_problem: "elektrický problém",
  missing_coffe_tea: "chybí káva čaj",
  problem_air_condition: "problémová klimatizace",
  dishwashing: "mytí nádobí",
  kitchen_cleanliness: "čistota kuchyně",
  weekly_cleaning: "týdenní úklid",
  general_arrangement: "obecné uspořádání",
  meeting_room: "zasedací místnost",
  refrigerator: "lednička",
  kitchen_supplies: "kuchyňské potřeby",
  toilet_services: "toaletní služby",
  carousel_door: "karuselové dveře",
  desk: "stůl",
  compressor: "kompresor",
  compressor_rails: "kolejnice kompresoru",
  compressor_drainage: "odvodnění kompresoru",
  dust: "prach",
  door: "dveře",
  scotch: "skotská",
  food: "jídlo",
  room_conditions: "podmínky místnosti",
  kindness_sensitivity: "laskavost a citlivost",
  explain_process: "vysvětlit proces",
  personal_attention: "osobní pozornost",
  service_problem: "servisní problém",
  welcome_you: "vítám tě",
  invoice_submitted: "faktura předložena",
  thank_you_bought: "děkuji koupil",
  problem_seller: "problémový prodejce",
  lapel_pin: "špendlík do klopy",
  proper_performance: "řádný výkon",
  name_tag: "jmenovka",
  operational: "provozní",
  app_revealed: "aplikace odhalena",
  register_load: "zatížení registru",
  visibility_problem: "problém s viditelností",
  clean_storefront: "čistá výloha",
  clean_garbage: "čisté odpadky",
  clean_tables_chairs: "čisté stoly a židle",
  clean_shop_floor: "čistá podlaha dílny",
  product_show: "pohled na produkt",
  refrigerators_show: "pohled na ledničky",
  coffee_accessories: "kávové příslušenství a vybavení",
  cleanliness: "čistota",
  convenience_scheduling_appointments: "pohodlí při plánování schůzek",
  waiting_haircut: "čekání na ostříhání",
  courtesy_books: "s laskavým svolením knih",
  books_professionalism: "profesionalita knih",
  received_time: "přijal mě včas",
  dnot_appointment: "nedomluvil jsem si schůzku",
  an_appointment: "domluvil jsem si schůzku",
  tasty: "chutný",
  courtesy_service: "laskavost služby",
  overall_experience: "celkový zážitek",
  not_clean: "není čistý",
  diningroom_not_clean: "jídelna není čistá",
  unclean_dishes: "nečisté nádobí",
  "so-so": "tak-tak",
  not_tasty: "není chutné",
  kind: "druh",
  not_kind: "ne laskavý",
  clean: "čistý",
  hairdresser: "kadeřník",
  wrong_price: "špatná cena",
  produc_has_expired: "platnost produktu vypršela",
  missing_item: "chybějící položka",
  item_is_faulty_in_the_machine: "položka je ve stroji vadná",
  machine_cleaning: "strojové čištění",
  improper_temperature: "nevhodná teplota",
  green: "zelený",
  orange: "pomerančový",
  red: "červený",
  yellow: "žluť",
  "red not prob": "červená není problém",
  professional: "profesionální",
  unprofessional: "neprofesionální",
  delicacies: "lahůdky",
  sandwiches: "sendviče",
  vegetables: "zelenina",
  fruits: "ovoce",
  salads: "saláty",
  milk: "mléko",
  room_link: "odkaz na pokoj",
  floor_link: "podlahový odkaz",
  services: "služby",
  check_list: "kontrolní seznam",
  lighting_problem_lobby: "lobby problém s osvětlením",
  lighting_problem_garbage_room: "problém s osvětlením popelnice",
  lighting_problem_stairwell: "problém osvětlení schodiště",
  problem_elevator_1: "problémový výtah 1",
  problem_elevator_2: "problémový výtah 2",
  problem_elevator_3: "problémový výtah 3",
  problem_elevator_4: "problémový výtah 4",
  problem_elevator_5: "problémový výtah 5",
  problem_elevator_6: "problémový výtah 6",
  problem_elevator_7: "problémový výtah 7",
  problem_elevator_8: "problémový výtah 8",
  problem_elevator_9: "problémový výtah 9",
  problem_elevator_10: "problémový výtah 10",
  stuck_item: "zaseknutá položka",
  spoiling_product: "kazící se produkt",
  machine_malfunction: "porucha stroje",
  unreadable_product: "nečitelný produkt",
  i_am_satisfied: "jsem spokojený",
  beverage: "nápoj",
  program_malfunction: "nefunkčnost programu",
  machine_1: "stroj 1",
  machine_2: "stroj 2",
  machine_3: "stroj 3",
  machine_4: "stroj 4",
  "program malfunction 1": "nefunkčnost programu 1",
  "program malfunction 2": "nefunkčnost programu 2",
  "program malfunction 3": "porucha programu 3",
  "program malfunction 4": "porucha programu 4",
  fish: "ryba",
  chicken: "kuře",
  full_dining_room: "plná jídelna",
  missing_amount: "chybějící množství",
  missing_trays: "chybějící zásobníky",
  dirty_floor_g1: "špinavá podlaha g1",
  dirty_floor_g2: "špinavá podlaha g2",
  dirty_floor_g3: "špinavá podlaha g3",
  dirty_floor_g4: "špinavá podlaha g4",
  dirty_floor_g5: "špinavá podlaha g5",
  dirty_floor_eo: "špinavá podlaha eo",
  dirty_floor_ceo: "špinavá podlaha generální ředitel",
  dirty_floor_storage: "skladování špinavé podlahy",
  dirty_floor_inflorescence: "špinavé podlahové květenství",
  operating_instructions: "návod k obsluze",
  general: "generál",
  connection_problem: "problém s připojením",
  lighting: "osvětlení",
  "not _fixed": "neopraveno",
  cleaning_needed: "potřeba čištění",
  missing_milk: "chybějící mléko",
  no_sugar_coffee: "žádný cukr/káva",
  missing_tools: "chybějící nástroje",
  coffee_water_machine: "automat na kávu / vodu",
  appliances: "spotřebičů",
  products: "produkty",
  broken_chair: "rozbitý nábytek",
  broken_cabinet: "rozbitá skříň",
  micro: "mikro",
  toaster: "toustovač",
  clogged_sink_malfunction: "porucha ucpaného dřezu",
  coffee_cooling_malfunction: "porucha chlazení kávy",
  no_coffee_beans: "žádná kávová zrna",
  machine_failure: "selhání stroje",
  that_dirty: "ta špinavá",
  dirty_refrigerator: "špinavá lednice",
  dirty_tables: "špinavé stoly",
  plates: "desky",
  silver_spoon: "stříbrná_lžíce",
  cold_drinks_cups: "kelímky na studené nápoje",
  hot_drink_cups: "šálky na horké nápoje",
  a_dripping_faucet: "kapající kohoutek",
  "disposable dishes": "nádobí na jedno použití",
  "problem_ coffee_water_machine": "problémový automat na kávu / vodu",
  problem_micro: "problém mikro",
  problem_toaster: "problémový toustovač",
  problem_machine_failure: "problémová porucha stroje",
  "problem refrigerator": "problémová lednička",
  "no_sugar/coffee": "žádný cukr/káva",
  missing_dishes: "chybějící nádobí",
  "coffee/water_machine": "automat na kávu / vodu",
  coffee_machine_door_open: "otevřená dvířka kávovaru",
  coffee_machine_door_close: "dvířka kávovaru se zavřou",
  coffee_machine_bin_full: "plný koš kávovaru",
  coffee_machine_bin_empty: "prázdný koš kávovaru",
  coffee_machine_coffee_full: "kávovar plný kávy",
  coffee_machine_coffee_empty: "kávovar káva prázdný",
  coffee_machine_water_tank_empty: "nádrž na vodu kávovaru prázdná",
  "coffee_machine_ water_tank_full": "kávovar plná nádrž na vodu",
  coffee_machine_milk_cleaning_not_performed: "nebylo provedeno čištění mléka kávovaru",
  "coffee_machine _milk_cleaning_performed": "provedeno čištění mléka kávovaru",
  coffee_machine_head_cleaning_not_performed: "nebylo provedeno čištění hlavy kávovaru",
  "coffee_machine_head_ cleaning_performed": "provedeno čištění hlavy kávovaru",
  coffee_machine_descaling_not_performed: "nebylo provedeno odvápnění kávovaru",
  coffee_machine_descaling_performed: "provedeno odvápnění kávovaru",
  floor_one: "patro 1",
  floor_two: "patro 2",
  floor_three: "patro 3",
  floor_four: "patro 4",
  floor_five: "patro 5",
  floor_six: "patro 6",
  floor_seven: "patro 7",
  floor_eight: "patro 8",
  floor_nine: "patro 9",
  floor_ten: "patro 10",
  floor_eleven: "patro 11",
  floor_twelve: "patro 12",
  floor_thirteen: "patro 13",
  floor_fourteen: "patro 14",
  floor_fifteen: "patro 15",
  floor_sixteen: "patro 16",
  floor_seventeen: "patro 17",
  floor_eighteen: "patro 18",
  floor_nineteen: "patro 19",
  floor_twenty: "patro 20",
  floor_twenty_one: "patro 21",
  floor_twenty_two: "patro 22",
  floor_twenty_three: "patro 23",
  floor_twenty_four: "patro 24",
  floor_twenty_five: "patro 25",
  "status_toilet_paper_cell_01_-_empty": "Stav Toaletní papír Buňka 01 - Prázdná",
  "status_toilet_paper_cell_02_-_empty": "Stav Toaletní papír Buňka 02 - Prázdná",
  "status_toilet_paper_cell_03_-_empty": "Stav Toaletní papír Buňka 03 - Prázdná",
  "status_toilet_paper_cell_04_-_empty": "Stav Toaletní papír Buňka 04 - Prázdná",
  "status_toilet_paper_cell_05_-_empty": "Stav Toaletní papír Buňka 05 - Prázdná",
  "status_toilet_paper_cell_06_-_empty": "Stav Toaletní papír Buňka 06 - Prázdná",
  "status_toilet_paper_cell_07_-_empty": "Stav Toaletní papír Buňka 07 - Prázdná",
  "status_toilet_paper_cell_08_-_empty": "Stav Toaletní papír Buňka 08 - Prázdná",
  "status_toilet_paper_cell_09_-_empty": "Stav Toaletní papír Buňka 09 - Prázdná",
  "status_toilet_paper_cell_10_-_empty": "Stav buňka toaletního papíru 10 – prázdná",
  "status_toilet_paper_cell_11_-_empty": "Stav Toaletní papír Buňka 11 - Prázdná",
  "status_toilet_paper_cell_12_-_empty": "Stav buňka toaletního papíru 12 – prázdná",
  "status_toilet_paper_cell_13_-_empty": "Stav Toaletní papír Buňka 13 - Prázdná",
  "status_toilet_paper_cell_14_-_empty": "Stav Toaletní papír Buňka 14 - Prázdná",
  "status_toilet_paper_cell_15_-_empty": "Stav Toaletní papír Buňka 15 - Prázdná",
  "status_toilet_paper_cell_16_-_empty": "Stav Toaletní papír Buňka 16 - Prázdná",
  "status_toilet_paper_cell_17_-_empty": "Stav Toaletní papír Buňka 17 - Prázdná",
  "status_toilet_paper_cell_18_-_empty": "Stav Toaletní papír Buňka 18 - Prázdná",
  "status_toilet_paper_cell_19_-_empty": "Stav Toaletní papír Buňka 19 - Prázdná",
  "status_toilet_paper_cell_20_-_empty": "Stav buňka toaletního papíru 20 - prázdná",
  "status_toilet_paper_cell_01_-_almost_empty": "Stav buňky na toaletní papír 01 – téměř prázdná",
  "status_toilet_paper_cell_02_-_almost_empty": "Stav buňky na toaletní papír 02 – téměř prázdná",
  "status_toilet_paper_cell_03_-_almost_empty": "Stav buňky na toaletní papír 03 – téměř prázdná",
  "status_toilet_paper_cell_04_-_almost_empty": "Stav buňky na toaletní papír 04 – téměř prázdná",
  "status_toilet_paper_cell_05_-_almost_empty": "Stav buňky na toaletní papír 05 – téměř prázdná",
  "status_toilet_paper_cell_06_-_almost_empty": "Stav buňky na toaletní papír 06 – téměř prázdná",
  "status_toilet_paper_cell_07_-_almost_empty": "Stav buňky na toaletní papír 07 – téměř prázdná",
  "status_toilet_paper_cell_08_-_almost_empty": "Stav buňky na toaletní papír 08 – téměř prázdná",
  "status_toilet_paper_cell_09_-_almost_empty": "Stav buňky na toaletní papír 09 – téměř prázdná",
  "status_toilet_paper_cell_10_-_almost_empty": "Stav buňky toaletního papíru 10 – téměř prázdná",
  "status_toilet_paper_cell_11_-_almost_empty": "Stav buňky toaletního papíru 11 – téměř prázdná",
  "status_toilet_paper_cell_12_-_almost_empty": "Stav buňky toaletního papíru 12 – téměř prázdná",
  "status_toilet_paper_cell_13_-_almost_empty": "Stav buňky toaletního papíru 13 – téměř prázdná",
  "status_toilet_paper_cell_14_-_almost_empty": "Stav buňky toaletního papíru 14 – téměř prázdná",
  "status_toilet_paper_cell_15_-_almost_empty": "Stav buňky toaletního papíru 15 – téměř prázdná",
  "status_toilet_paper_cell_16_-_almost_empty": "Stav buňky toaletního papíru 16 – téměř prázdná",
  "status_toilet_paper_cell_17_-_almost_empty": "Stav buňky toaletního papíru 17 – téměř prázdná",
  "status_toilet_paper_cell_18_-_almost_empty": "Stav buňky toaletního papíru 18 – téměř prázdná",
  "status_toilet_paper_cell_19_-_almost_empty": "Stav buňky toaletního papíru 19 – téměř prázdná",
  "status_toilet_paper_cell_20_-_almost_empty": "Stav buňky toaletního papíru 20 – téměř prázdná",
  of: "z",
  items: "položky",
  loading_charts: "načítání grafů",
  refresh_the_room: "osvěžit místnost",
  clean_the_floor: "vyčistit podlahu",
  clean_the_toilet: "vyčistit záchod",
  refill_soap: "doplňovat mýdlo",
  change_roll: "vyměnit roli",
  great_job: "skvělá práce",
  empty_the_trash: "vyprázdnit odpadky",
  repair_required: "nutná oprava",
  cleaning: "čištění",
  cleaning_performed: "proveden úklid",
  cestina: "Čeština",
  },
  ml: {
  cleaned_floor: "വൃത്തിയാക്കിയ തറ",
  cleaned_toilet: "വൃത്തിയാക്കിയ ടോയ്‌ലറ്റ്",
  cleaned_shower: "വൃത്തിയാക്കിയ ഷവർ",
  cleaned_sink: "വൃത്തിയാക്കിയ സിങ്ക്",
  cleaned_mirror: "വൃത്തിയാക്കിയ കണ്ണാടി",
  cleaned_stainless_steel: "വൃത്തിയാക്കിയ സ്റ്റെയിൻലെസ്സ് സ്റ്റീൽ",
  bad_smell: "ദുർഗന്ധം",
  dirty_floor: "വൃത്തികെട്ട തറ",
  dirty_lavatory_seat: "വൃത്തികെട്ട ശുചിമുറി സീറ്റ്",
  dirty_shower: "വൃത്തികെട്ട ഷവർ",
  dirty_sink: "വൃത്തികെട്ട സിങ്ക്",
  dirty_mirror: "വൃത്തികെട്ട കണ്ണാടി",
  dirty_stainless_steel: "വൃത്തികെട്ട സ്റ്റെയിൻലെസ്സ് സ്റ്റീൽ",
  missing_paper_towel: "പേപ്പർ ടവൽ നഷ്ടപ്പെട്ടു",
  missing_soap: "നഷ്ടപ്പെട്ട സോപ്പ്",
  missing_toilet_paper: "ടോയ്‌ലറ്റ് പേപ്പർ കാണുന്നില്ല",
  problem_shower: "പ്രശ്നം ഷവർ",
  problem_sink: "പ്രശ്നം സിങ്ക്",
  problem_mirror: "പ്രശ്ന കണ്ണാടി",
  problem_stainless_steel: "പ്രശ്നം സ്റ്റെയിൻലെസ്സ് സ്റ്റീൽ",
  problem_blockage: "പ്രശ്നം തടസ്സം",
  problem_door: "പ്രശ്ന വാതിൽ",
  problem_fluid_taps: "പ്രശ്നം ദ്രാവക ടാപ്പുകൾ",
  problem_lightning: "പ്രശ്നം മിന്നൽ",
  problem_broken_toilet: "പ്രശ്നം തകർന്ന ടോയ്ലറ്റ്",
  fixed_shower: "നിശ്ചിത ഷവർ",
  fixed_sink: "നിശ്ചിത സിങ്ക്",
  fixed_mirror: "നിശ്ചിത കണ്ണാടി",
  fixed_stainless_steel: "നിശ്ചിത സ്റ്റെയിൻലെസ്സ് സ്റ്റീൽ",
  fixed_blockage: "നിശ്ചിത തടസ്സം",
  fixed_door: "ഉറപ്പിച്ച വാതിൽ",
  fixed_fluid_taps: "നിശ്ചിത ദ്രാവക ടാപ്പുകൾ",
  fixed_lightning: "നിശ്ചിത മിന്നൽ",
  fixed_broken_toilet: "തകർന്ന ടോയ്‌ലറ്റ് ശരിയാക്കി",
  very_good: "വളരെ നല്ലത്",
  excellent: "മികച്ചത്",
  good: "നല്ലത്",
  like: "പോലെ",
  needs_improvement: "മെച്ചപ്പെടുത്തൽ ആവശ്യമാണ്",
  not_good: "നല്ലതല്ല",
  supervise: "മേൽനോട്ടം വഹിക്കുന്നു",
  maintenance: "പരിപാലനം",
  cleaner: "ക്ലീനർ",
  tag_cleaner: "ടാഗ് ക്ലീനർ",
  zone_is_clean: "മേഖല ശുദ്ധമാണ്",
  zone_is_dirty: "മേഖല വൃത്തികെട്ടതാണ്",
  cleaner_arrived: "ക്ലീനർ എത്തി",
  start_clean_zone: "ക്ലീൻ സോൺ ആരംഭിക്കുക",
  counter: "കൗണ്ടർ",
  counter_men: "എതിർ പുരുഷന്മാർ",
  counter_woman: "എതിർ സ്ത്രീ",
  counter_handycap: "കൌണ്ടർ ഹാൻഡിക്യാപ്പ്",
  full_garbage_can: "മുഴുവൻ ചവറ്റുകുട്ട",
  maintenance_fixed: "അറ്റകുറ്റപ്പണി നിശ്ചയിച്ചു",
  maintenance_problem: "അറ്റകുറ്റപ്പണി പ്രശ്നം",
  problem_soap_dispenser: "പ്രശ്നം സോപ്പ് ഡിസ്പെൻസർ",
  problem_paper_dispenser: "പ്രശ്നം പേപ്പർ ഡിസ്പെൻസർ",
  end_clean_zone: "ക്ലീൻ സോൺ അവസാനിപ്പിക്കുക",
  status_toilet_paper: "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ",
  status_hend_paper: "സ്റ്റാറ്റസ് ഹെൻഡ് പേപ്പർ",
  fixed: "നിശ്ചയിച്ചു",
  status_soap: "സ്റ്റാറ്റസ് സോപ്പ്",
  status_garbage_can: "സ്റ്റാറ്റസ് ചവറ്റുകുട്ട",
  general_cleaning: "പൊതു വൃത്തിയാക്കൽ",
  coffee_tea: "കാപ്പി ചായ",
  water_bar: "വാട്ടർ ബാർ",
  disposable_dishes: "ഡിസ്പോസിബിൾ വിഭവങ്ങൾ",
  head_coverage: "തല കവറേജ്",
  something_else: "മറ്റെന്തെങ്കിലും",
  missing_clothing: "നഷ്ടപ്പെട്ട വസ്ത്രം",
  maintenance_link: "മെയിൻ്റനൻസ് ലിങ്ക്",
  problem_maintenance: "പ്രശ്നം പരിപാലനം",
  supervise_link: "മേൽനോട്ടം ലിങ്ക്",
  cleaner_link: "ക്ലീനർ ലിങ്ക്",
  "room_men+link": "റൂം മാൻ + ലിങ്ക്",
  "room_men-link": "റൂം പുരുഷന്മാർ - ലിങ്ക്",
  "room_women+link": "റൂം സ്ത്രീകൾ + ലിങ്ക്",
  "room_women-link": "റൂം സ്ത്രീകൾ - ലിങ്ക്",
  hebrew: "ഹീബ്രു",
  english: "ഇംഗ്ലീഷ്",
  italiano: "ഇറ്റാലിയൻ",
  arabic: "അറബിക്",
  partial_information: "ഭാഗിക വിവരങ്ങൾ",
  professionalism: "പ്രൊഫഷണലിസം",
  the_attitude_of_the_representative: "പ്രതിനിധിയുടെ മനോഭാവം",
  waiting_time_for_service: "സേവനത്തിനായി കാത്തിരിക്കുന്ന സമയം",
  other_aspect_of_service: "സേവനത്തിൻ്റെ മറ്റൊരു വശം",
  language_of_the_service: "സേവനത്തിൻ്റെ ഭാഷ",
  procedure_for_making_an_appointment: "ഒരു അപ്പോയിൻ്റ്മെൻ്റ് നടത്തുന്നതിനുള്ള നടപടിക്രമം",
  physical_conditions: "ശാരീരിക അവസ്ഥകൾ",
  found_another: "മറ്റൊന്ന് കണ്ടെത്തി",
  found_similar: "സമാനമായി കണ്ടെത്തി",
  did_not_find: "കണ്ടെത്തിയില്ല",
  found: "കണ്ടെത്തി",
  need_improved: "മെച്ചപ്പെടുത്തേണ്ടതുണ്ട്",
  liked: "ഇഷ്ടപ്പെട്ടു",
  pleasant: "പ്രസന്നമായ",
  eilat_resident: "എയിലത്ത് നിവാസി",
  once_a_week: "ആഴ്ചയിൽ ഒരിക്കൽ",
  once_a_month: "മാസത്തിൽ ഒരിക്കൽ",
  twice_a_year: "വർഷത്തിൽ രണ്ടുതവണ",
  once_a_year: "വർഷത്തിൽ ഒരിക്കൽ",
  friend: "സുഹൃത്ത്",
  newspaper: "പത്രം",
  google: "ഗൂഗിൾ",
  zap: "zap",
  vacuum_cleaner: "വാക്വം ക്ലീനർ",
  gaming_consoles: "ഗെയിമിംഗ് കൺസോളുകൾ",
  laptop: "ലാപ്ടോപ്പ്",
  cellular: "സെല്ലുലാർ",
  shop: "കട",
  restaurant_complex_cleaning: "റെസ്റ്റോറൻ്റ് സമുച്ചയം വൃത്തിയാക്കൽ",
  dining_room: "ഡൈനിംഗ് റൂം",
  food_variety: "ഭക്ഷണ വൈവിധ്യം",
  quality_of_the_food: "ഭക്ഷണത്തിൻ്റെ ഗുണനിലവാരം",
  amount_of_the_food: "ഭക്ഷണത്തിൻ്റെ അളവ്",
  quality_of_cooking: "പാചകത്തിൻ്റെ ഗുണനിലവാരം",
  side_courses: "സൈഡ് കോഴ്സുകൾ",
  meat: "മാംസം",
  desserts: "മധുരപലഹാരങ്ങൾ",
  vegetarian: "വെജിറ്റേറിയൻ",
  salad_bar: "സാലഡ് ബാർ",
  main_courses: "പ്രധാന കോഴ്സുകൾ",
  service: "സേവനം",
  dining_room_cleanliness: "ഡൈനിംഗ് റൂം ശുചിത്വം",
  plates_and_cutlery_cleanliness: "പ്ലേറ്റുകളും കട്ട്ലറി ശുചിത്വവും",
  product_inventory: "ഉൽപ്പന്ന ഇൻവെൻ്ററി",
  furnishers: "ഫർണിച്ചറുകൾ",
  toilets: "കക്കൂസുകൾ",
  problem_coffee_machine: "പ്രശ്നം കോഫി മെഷീൻ",
  problem_water_bar: "പ്രശ്നം വാട്ടർ ബാർ",
  dirty_stairs: "വൃത്തികെട്ട പടികൾ",
  toiletries: "ശൗചാലയങ്ങൾ",
  fixed_soap_dispenser: "സ്ഥിര സോപ്പ് ഡിസ്പെൻസർ",
  fixed_paper_dispenser: "നിശ്ചിത പേപ്പർ ഡിസ്പെൻസർ",
  fixed_coffee_machine: "നിശ്ചിത കോഫി മെഷീൻ",
  fixed_water_bar: "നിശ്ചിത വാട്ടർ ബാർ",
  problem_urinals: "പ്രശ്നം മൂത്രപ്പുരകൾ",
  blockage_toilet: "തടസ്സം ടോയ്ലറ്റ്",
  appliance_problem: "ഉപകരണ പ്രശ്നം",
  problem_broken_door: "പ്രശ്നം തകർന്ന വാതിൽ",
  problem_door_lock: "പ്രശ്നം വാതിൽ ലോക്ക്",
  problem_broken_toilet_seat: "പ്രശ്നം തകർന്ന ടോയ്‌ലറ്റ് സീറ്റ്",
  problem_broken_niagara: "പ്രശ്നം തകർന്ന നയാഗ്ര",
  " broken_hand_paper_dispenser_hand_dryer": "തകർന്ന ഹാൻഡ് പേപ്പർ ഡിസ്പെൻസർ + ഹാൻഡ് ഡ്രയർ",
  rug: "പരവതാനി",
  tables: "പട്ടികകൾ",
  kitchen: "അടുക്കള",
  air_condition: "എയർ കണ്ടീഷൻ",
  dirty_urinals: "വൃത്തികെട്ട മൂത്രപ്പുരകൾ",
  hand_dryer: "ഹാൻഡ്_ഡ്രയർ",
  non_sticky_carpet: "ഒട്ടിക്കാത്ത പരവതാനി",
  problem_bad_smell: "പ്രശ്നം ദുർഗന്ധം",
  problem_broken_toilet_handle: "പ്രശ്നം തകർന്ന ടോയ്‌ലറ്റ് ഹാൻഡിൽ",
  problem_handle_door: "പ്രശ്നം കൈകാര്യം വാതിൽ",
  call_cleaner: "ക്ലീനർ വിളിക്കുക",
  wall_painting: "ചുമർ ചിത്രകല",
  missing_paper: "കാണാതായ പേപ്പർ",
  clean_surface: "ശുദ്ധമായ ഉപരിതലം",
  problem_right_elevator: "പ്രശ്നം വലത് എലിവേറ്റർ",
  problem_left_elevator: "ഇടത് എലിവേറ്ററിൽ പ്രശ്നം",
  missing_hand_sanitizer: "ഹാൻഡ് സാനിറ്റൈസർ നഷ്ടപ്പെട്ടു",
  problem_sink_blockage: "പ്രശ്നം സിങ്ക് തടസ്സം",
  electric_problem: "വൈദ്യുത പ്രശ്നം",
  missing_coffe_tea: "കാപ്പി ചായ കാണുന്നില്ല",
  problem_air_condition: "പ്രശ്നം എയർ അവസ്ഥ",
  dishwashing: "പാത്രം കഴുകൽ",
  kitchen_cleanliness: "അടുക്കള ശുചിത്വം",
  weekly_cleaning: "പ്രതിവാര വൃത്തിയാക്കൽ",
  general_arrangement: "പൊതു ക്രമീകരണം",
  meeting_room: "മീറ്റിംഗ് റൂം",
  refrigerator: "റഫ്രിജറേറ്റർ",
  kitchen_supplies: "അടുക്കള സാധനങ്ങൾ",
  toilet_services: "ടോയ്‌ലറ്റ് സേവനങ്ങൾ",
  carousel_door: "കറൗസൽ വാതിൽ",
  desk: "മേശ",
  compressor: "കംപ്രസർ",
  compressor_rails: "കംപ്രസർ റെയിലുകൾ",
  compressor_drainage: "കംപ്രസർ ഡ്രെയിനേജ്",
  dust: "പൊടി",
  door: "വാതിൽ",
  scotch: "സ്കോച്ച്",
  food: "ഭക്ഷണം",
  room_conditions: "മുറി വ്യവസ്ഥകൾ",
  kindness_sensitivity: "ദയയും സംവേദനക്ഷമതയും",
  explain_process: "പ്രക്രിയ വിശദീകരിക്കുക",
  personal_attention: "വ്യക്തിപരമായ ശ്രദ്ധ",
  service_problem: "സേവന പ്രശ്നം",
  welcome_you: "നിങ്ങളെ സ്വാഗതം ചെയ്യുന്നു",
  invoice_submitted: "ഇൻവോയ്സ് സമർപ്പിച്ചു",
  thank_you_bought: "നന്ദി വാങ്ങി",
  problem_seller: "പ്രശ്ന വിൽപ്പനക്കാരൻ",
  lapel_pin: "ലാപൽ പിൻ",
  proper_performance: "ശരിയായ പ്രകടനം",
  name_tag: "പേര് ടാഗ്",
  operational: "പ്രവർത്തനക്ഷമമായ",
  app_revealed: "ആപ്പ് വെളിപ്പെടുത്തി",
  register_load: "രജിസ്റ്റർ ലോഡ്",
  visibility_problem: "ദൃശ്യപരത പ്രശ്നം",
  clean_storefront: "വൃത്തിയുള്ള കടയുടെ മുൻഭാഗം",
  clean_garbage: "ശുദ്ധമായ മാലിന്യം",
  clean_tables_chairs: "മേശകളും കസേരകളും വൃത്തിയാക്കുക",
  clean_shop_floor: "വൃത്തിയുള്ള കടയുടെ തറ",
  product_show: "ഉൽപ്പന്നത്തിൻ്റെ കാഴ്ച",
  refrigerators_show: "റഫ്രിജറേറ്ററുകളുടെ കാഴ്ച",
  coffee_accessories: "കോഫി ആക്സസറികളും സജ്ജീകരിച്ചിരിക്കുന്നു",
  cleanliness: "ശുചിത്വം",
  convenience_scheduling_appointments: "അപ്പോയിൻ്റ്മെൻ്റുകൾ ഷെഡ്യൂൾ ചെയ്യുന്നതിനുള്ള സൗകര്യം",
  waiting_haircut: "ഒരു മുടിവെട്ടിനായി കാത്തിരിക്കുന്നു",
  courtesy_books: "പുസ്തകങ്ങളുടെ കടപ്പാട്",
  books_professionalism: "പുസ്തകങ്ങളുടെ പ്രൊഫഷണലിസം",
  received_time: "കൃത്യസമയത്ത് എന്നെ സ്വീകരിച്ചു",
  dnot_appointment: "ഞാൻ ഒരു അപ്പോയിൻ്റ്മെൻ്റ് എടുത്തില്ല",
  an_appointment: "ഞാൻ ഒരു അപ്പോയിൻ്റ്മെൻ്റ് നടത്തി",
  tasty: "രുചിയുള്ള",
  courtesy_service: "സേവനത്തിൻ്റെ കടപ്പാട്",
  overall_experience: "മൊത്തത്തിലുള്ള അനുഭവം",
  not_clean: "ശുദ്ധമല്ല",
  diningroom_not_clean: "ഊണുമുറി വൃത്തിയില്ല",
  unclean_dishes: "അശുദ്ധമായ വിഭവങ്ങൾ",
  "so-so": "അങ്ങനെ-അങ്ങനെ",
  not_tasty: "രുചികരമല്ല",
  kind: "ദയയുള്ള",
  not_kind: "ദയയില്ല",
  clean: "ശുദ്ധമായ",
  hairdresser: "ഹെയർഡ്രെസ്സർ",
  wrong_price: "തെറ്റായ വില",
  produc_has_expired: "ഉൽപ്പന്നം കാലഹരണപ്പെട്ടു",
  missing_item: "നഷ്ടപ്പെട്ട ഇനം",
  item_is_faulty_in_the_machine: "ഇനം മെഷീനിൽ തകരാറാണ്",
  machine_cleaning: "യന്ത്രം വൃത്തിയാക്കൽ",
  improper_temperature: "അനുചിതമായ താപനില",
  green: "പച്ച",
  orange: "ഓറഞ്ച്",
  red: "ചുവപ്പ്",
  yellow: "മഞ്ഞ",
  "red not prob": "ചുവപ്പ് പ്രശ്നമല്ല",
  professional: "പ്രൊഫഷണൽ",
  unprofessional: "പ്രൊഫഷണലല്ല",
  delicacies: "പലഹാരങ്ങൾ",
  sandwiches: "സാൻഡ്വിച്ചുകൾ",
  vegetables: "പച്ചക്കറികൾ",
  fruits: "പഴങ്ങൾ",
  salads: "സലാഡുകൾ",
  milk: "പാൽ",
  room_link: "മുറി ലിങ്ക്",
  floor_link: "ഫ്ലോർ ലിങ്ക്",
  services: "സേവനങ്ങൾ",
  check_list: "ചെക്ക് ലിസ്റ്റ്",
  lighting_problem_lobby: "ലൈറ്റിംഗ് പ്രശ്നം ലോബി",
  lighting_problem_garbage_room: "ലൈറ്റിംഗ് പ്രശ്നം മാലിന്യ മുറി",
  lighting_problem_stairwell: "ലൈറ്റിംഗ് പ്രശ്നം സ്റ്റെയർവെൽ",
  problem_elevator_1: "പ്രശ്നം എലിവേറ്റർ 1",
  problem_elevator_2: "പ്രശ്നം എലിവേറ്റർ 2",
  problem_elevator_3: "പ്രശ്നം എലിവേറ്റർ 3",
  problem_elevator_4: "പ്രശ്നം എലിവേറ്റർ 4",
  problem_elevator_5: "പ്രശ്നം എലിവേറ്റർ 5",
  problem_elevator_6: "പ്രശ്നം എലിവേറ്റർ 6",
  problem_elevator_7: "പ്രശ്നം എലിവേറ്റർ 7",
  problem_elevator_8: "പ്രശ്നം എലിവേറ്റർ 8",
  problem_elevator_9: "പ്രശ്നം എലിവേറ്റർ 9",
  problem_elevator_10: "പ്രശ്നം എലിവേറ്റർ 10",
  stuck_item: "കുടുങ്ങിയ ഇനം",
  spoiling_product: "കേടായ ഉൽപ്പന്നം",
  machine_malfunction: "മെഷീൻ തകരാർ",
  unreadable_product: "വായിക്കാൻ കഴിയാത്ത ഉൽപ്പന്നം",
  i_am_satisfied: "ഞാൻ തൃപ്തനാണ്",
  beverage: "പാനീയം",
  program_malfunction: "പ്രോഗ്രാം തകരാർ",
  machine_1: "യന്ത്രം 1",
  machine_2: "യന്ത്രം 2",
  machine_3: "യന്ത്രം 3",
  machine_4: "യന്ത്രം 4",
  "program malfunction 1": "പ്രോഗ്രാം തകരാർ 1",
  "program malfunction 2": "പ്രോഗ്രാം തകരാറ് 2",
  "program malfunction 3": "പ്രോഗ്രാം തകരാറ് 3",
  "program malfunction 4": "പ്രോഗ്രാം തകരാറ് 4",
  fish: "മത്സ്യം",
  chicken: "കോഴി",
  full_dining_room: "മുഴുവൻ ഡൈനിംഗ് റൂം",
  missing_amount: "നഷ്ടപ്പെട്ട തുക",
  missing_trays: "നഷ്ടപ്പെട്ട ട്രേകൾ",
  dirty_floor_g1: "വൃത്തികെട്ട തറ g1",
  dirty_floor_g2: "വൃത്തികെട്ട തറ g2",
  dirty_floor_g3: "വൃത്തികെട്ട തറ g3",
  dirty_floor_g4: "വൃത്തികെട്ട തറ g4",
  dirty_floor_g5: "വൃത്തികെട്ട തറ g5",
  dirty_floor_eo: "വൃത്തികെട്ട തറ ഇ.ഒ",
  dirty_floor_ceo: "വൃത്തികെട്ട തറ സിഇഒ",
  dirty_floor_storage: "വൃത്തികെട്ട തറ സംഭരണം",
  dirty_floor_inflorescence: "വൃത്തികെട്ട തറ പൂങ്കുലകൾ",
  operating_instructions: "പ്രവർത്തന നിർദ്ദേശങ്ങൾ",
  general: "പൊതുവായ",
  connection_problem: "കണക്ഷൻ പ്രശ്നം",
  lighting: "ലൈറ്റിംഗ്",
  "not _fixed": "നിശ്ചയിച്ചിട്ടില്ല",
  cleaning_needed: "വൃത്തിയാക്കൽ ആവശ്യമാണ്",
  missing_milk: "പാൽ നഷ്ടപ്പെട്ടു",
  no_sugar_coffee: "പഞ്ചസാര / കാപ്പി ഇല്ല",
  missing_tools: "നഷ്ടപ്പെട്ട ഉപകരണങ്ങൾ",
  coffee_water_machine: "കോഫി / വാട്ടർ മെഷീൻ",
  appliances: "വീട്ടുപകരണങ്ങൾ",
  products: "ഉൽപ്പന്നങ്ങൾ",
  broken_chair: "തകർന്ന ഫർണിച്ചറുകൾ",
  broken_cabinet: "തകർന്ന കാബിനറ്റ്",
  micro: "സൂക്ഷ്മ",
  toaster: "ടോസ്റ്റർ",
  clogged_sink_malfunction: "അടഞ്ഞുപോയ സിങ്ക് തകരാർ",
  coffee_cooling_malfunction: "കോഫി തണുപ്പിക്കൽ തകരാറ്",
  no_coffee_beans: "കാപ്പിക്കുരു ഇല്ല",
  machine_failure: "മെഷീൻ പരാജയം",
  that_dirty: "അത് വൃത്തികെട്ടത്",
  dirty_refrigerator: "വൃത്തികെട്ട റഫ്രിജറേറ്റർ",
  dirty_tables: "വൃത്തികെട്ട മേശകൾ",
  plates: "പ്ലേറ്റുകൾ",
  silver_spoon: "വെള്ളി_സ്പൂൺ",
  cold_drinks_cups: "ശീതള പാനീയ കപ്പുകൾ",
  hot_drink_cups: "ചൂടുള്ള പാനീയ കപ്പുകൾ",
  a_dripping_faucet: "ഒരു തുള്ളി കുഴമ്പ്",
  "disposable dishes": "ഡിസ്പോസിബിൾ വിഭവങ്ങൾ",
  "problem_ coffee_water_machine": "പ്രശ്നം കോഫി / വെള്ളം യന്ത്രം",
  problem_micro: "പ്രശ്നം മൈക്രോ",
  problem_toaster: "പ്രശ്നം ടോസ്റ്റർ",
  problem_machine_failure: "പ്രശ്നം മെഷീൻ പരാജയം",
  "problem refrigerator": "പ്രശ്നം റഫ്രിജറേറ്റർ",
  "no_sugar/coffee": "പഞ്ചസാര / കാപ്പി ഇല്ല",
  missing_dishes: "കാണാതായ വിഭവങ്ങൾ",
  "coffee/water_machine": "കോഫി / വാട്ടർ മെഷീൻ",
  coffee_machine_door_open: "കോഫി മെഷീൻ വാതിൽ തുറന്നു",
  coffee_machine_door_close: "കോഫി മെഷീൻ വാതിൽ അടയ്ക്കുക",
  coffee_machine_bin_full: "കോഫി മെഷീൻ ബിൻ നിറഞ്ഞു",
  coffee_machine_bin_empty: "കോഫി മെഷീൻ ബിൻ ശൂന്യമാണ്",
  coffee_machine_coffee_full: "കോഫി മെഷീൻ കാപ്പി നിറഞ്ഞു",
  coffee_machine_coffee_empty: "കോഫി മെഷീൻ കോഫി ശൂന്യമാണ്",
  coffee_machine_water_tank_empty: "കോഫി മെഷീൻ വാട്ടർ ടാങ്ക് ശൂന്യം",
  "coffee_machine_ water_tank_full": "കോഫി മെഷീൻ വാട്ടർ ടാങ്ക് നിറഞ്ഞു",
  coffee_machine_milk_cleaning_not_performed: "കോഫി മെഷീൻ പാൽ വൃത്തിയാക്കൽ നടത്തിയിട്ടില്ല",
  "coffee_machine _milk_cleaning_performed": "കോഫി മെഷീൻ പാൽ വൃത്തിയാക്കൽ നടത്തി",
  coffee_machine_head_cleaning_not_performed: "കോഫി മെഷീൻ തല വൃത്തിയാക്കൽ നടത്തിയിട്ടില്ല",
  "coffee_machine_head_ cleaning_performed": "കോഫി മെഷീൻ ഹെഡ് ക്ലീനിംഗ് നടത്തി",
  coffee_machine_descaling_not_performed: "കോഫി മെഷീൻ ഡെസ്കലിംഗ് നടത്തിയിട്ടില്ല",
  coffee_machine_descaling_performed: "കോഫി മെഷീൻ ഡെസ്കലിംഗ് നടത്തി",
  floor_one: "നില 1",
  floor_two: "നില 2",
  floor_three: "നില 3",
  floor_four: "നില 4",
  floor_five: "നില 5",
  floor_six: "നില 6",
  floor_seven: "നില 7",
  floor_eight: "നില 8",
  floor_nine: "നില 9",
  floor_ten: "നില 10",
  floor_eleven: "നില 11",
  floor_twelve: "നില 12",
  floor_thirteen: "നില 13",
  floor_fourteen: "നില 14",
  floor_fifteen: "നില 15",
  floor_sixteen: "നില 16",
  floor_seventeen: "നില 17",
  floor_eighteen: "നില 18",
  floor_nineteen: "നില 19",
  floor_twenty: "നില 20",
  floor_twenty_one: "നില 21",
  floor_twenty_two: "നില 22",
  floor_twenty_three: "നില 23",
  floor_twenty_four: "നില 24",
  floor_twenty_five: "നില 25",
  "status_toilet_paper_cell_01_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 01 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_02_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 02 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_03_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 03 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_04_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 04 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_05_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 05 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_06_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 06 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_07_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 07 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_08_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 08 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_09_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 09 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_10_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 10 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_11_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 11 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_12_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 12 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_13_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 13 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_14_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 14 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_15_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 15 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_16_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 16 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_17_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 17 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_18_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 18 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_19_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 19 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_20_-_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 20 - ശൂന്യമാണ്",
  "status_toilet_paper_cell_01_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 01 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_02_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 02 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_03_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 03 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_04_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 04 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_05_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 05 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_06_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 06 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_07_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 07 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_08_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 08 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_09_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 09 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_10_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 10 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_11_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 11 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_12_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 12 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_13_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 13 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_14_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 14 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_15_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 15 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_16_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 16 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_17_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 17 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_18_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 18 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_19_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 19 - ഏതാണ്ട് ശൂന്യമാണ്",
  "status_toilet_paper_cell_20_-_almost_empty": "സ്റ്റാറ്റസ് ടോയ്‌ലറ്റ് പേപ്പർ സെൽ 20 - ഏതാണ്ട് ശൂന്യമാണ്",
  of: "ൻ്റെ",
  items: "ഇനങ്ങൾ",
  loading_charts: "ചാർട്ടുകൾ ലോഡ് ചെയ്യുന്നു",
  refresh_the_room: "മുറി പുതുക്കുക",
  clean_the_floor: "തറ വൃത്തിയാക്കുക",
  clean_the_toilet: "ടോയ്‌ലറ്റ് വൃത്തിയാക്കുക",
  refill_soap: "റീഫിൽ സോപ്പ്",
  change_roll: "റോൾ മാറ്റുക",
  great_job: "വലിയ ജോലി",
  empty_the_trash: "ട്രാഷ് ശൂന്യമാക്കുക",
  repair_required: "റിപ്പയർ ആവശ്യമാണ്",
  cleaning: "വൃത്തിയാക്കൽ",
  cleaning_performed: "ശുചീകരണം നടത്തി",
  malayalam: "മലയാളം",
  },
  sk: {
    "cleaned_floor": "vyčistená podlaha",
    "cleaned_toilet": "vyčistená toaleta",
    "cleaned_shower": "vyčistená sprcha",
    "cleaned_sink": "vyčistené umývadlo",
    "cleaned_mirror": "vyčistené zrkadlo",
    "cleaned_stainless_steel": "vyčistená nehrdzavejúca oceľ",
    "bad_smell": "zlý zápach",
    "dirty_floor": "špinavá podlaha",
    "dirty_lavatory_seat": "špinavé toaletné sedadlo",
    "dirty_shower": "špinavá sprcha",
    "dirty_sink": "špinavé umývadlo",
    "dirty_mirror": "špinavé zrkadlo",
    "dirty_stainless_steel": "špinavá nehrdzavejúca oceľ",
    "missing_paper_towel": "chýba papierová utierka",
    "missing_soap": "chýba mydlo",
    "missing_toilet_paper": "chýba toaletný papier",
    "problem_shower": "problémová sprcha",
    "problem_sink": "problémové umývadlo",
    "problem_mirror": "problémové zrkadlo",
    "problem_stainless_steel": "problémová nehrdzavejúca oceľ",
    "problem_blockage": "problémová blokáda",
    "problem_door": "problémové dvere",
    "problem_fluid_taps": "kohútiky problémových tekutín",
    "problem_lightning": "problémový blesk",
    "problem_broken_toilet": "problém rozbité WC",
    "fixed_shower": "pevná sprcha",
    "fixed_sink": "pevné umývadlo",
    "fixed_mirror": "pevné zrkadlo",
    "fixed_stainless_steel": "pevná nehrdzavejúca oceľ",
    "fixed_blockage": "pevná blokáda",
    "fixed_door": "pevné dvere",
    "fixed_fluid_taps": "pevné kvapalinové kohútiky",
    "fixed_lightning": "pevný blesk",
    "fixed_broken_toilet": "opravené pokazené WC",
    "very_good": "veľmi dobré",
    "excellent": "vynikajúce",
    "good": "dobre",
    "like": "ako",
    "needs_improvement": "potrebuje zlepšenie",
    "not_good": "nie dobre",
    "supervise": "dohliadať",
    "maintenance": "údržbu",
    "cleaner": "čistejšie",
    "tag_cleaner": "čistič štítkov",
    "zone_is_clean": "zóna je čistá",
    "zone_is_dirty": "zóna je špinavá",
    "cleaner_arrived": "dorazil čistič",
    "start_clean_zone": "spustiť čistú zónu",
    "counter": "počítadlo",
    "counter_men": "pult muži",
    "counter_woman": "pult žena",
    "counter_handycap": "počítadlo handycap",
    "full_garbage_can": "plný odpadkový kôš",
    "maintenance_fixed": "údržba opravená",
    "maintenance_problem": "problém s údržbou",
    "problem_soap_dispenser": "problémový dávkovač mydla",
    "problem_paper_dispenser": "problémový zásobník papiera",
    "end_clean_zone": "koniec čistej zóny",
    "status_toilet_paper": "stav toaletného papiera",
    "status_hend_paper": "stavový papier",
    "fixed": "pevné",
    "status_soap": "stavové mydlo",
    "status_garbage_can": "stav odpadkového koša",
    "general_cleaning": "generálne upratovanie",
    "coffee_tea": "kávový čaj",
    "water_bar": "vodný bar",
    "disposable_dishes": "jednorazový riad",
    "head_coverage": "pokrytie hlavy",
    "something_else": "niečo iné",
    "missing_clothing": "chýbajúce oblečenie",
    "maintenance_link": "odkaz na údržbu",
    "problem_maintenance": "problémová údržba",
    "supervise_link": "dohliadať na odkaz",
    "cleaner_link": "čistejší odkaz",
    "room_men+link": "izba muži + odkaz",
    "room_men-link": "izba muži - odkaz",
    "room_women+link": "izba ženy + odkaz",
    "room_women-link": "izba ženy - odkaz",
    "hebrew": "hebrejčina",
    "español": "español",
    "français": "français",
    "english": "anglicky",
    "русский": "русский",
    "italiano": "taliansky",
    "አማርኛ": "አማርኛ",
    "português": "português",
    "arabic": "arabčina",
    "partial_information": "čiastkové informácie",
    "professionalism": "profesionalita",
    "the_attitude_of_the_representative": "postojom zástupcu",
    "waiting_time_for_service": "čakacia doba na servis",
    "other_aspect_of_service": "iný aspekt služby",
    "language_of_the_service": "jazyk služby",
    "procedure_for_making_an_appointment": "postup pri objednávaní stretnutia",
    "physical_conditions": "fyzické stavy",
    "found_another": "našiel inú",
    "found_similar": "našli podobné",
    "did_not_find": "nenašiel",
    "found": "nájdené",
    "need_improved": "treba zlepšiť",
    "liked": "páčilo",
    "pleasant": "príjemné",
    "eilat_resident": "obyvateľ Eilatu",
    "once_a_week": "raz týždenne",
    "once_a_month": "raz za mesiac",
    "twice_a_year": "dvakrát do roka",
    "once_a_year": "raz za rok",
    "friend": "priateľ",
    "newspaper": "noviny",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "vysávač",
    "gaming_consoles": "herné konzoly",
    "laptop": "laptop",
    "cellular": "bunkový",
    "shop": "obchod",
    "restaurant_complex_cleaning": "čistenie reštauračného komplexu",
    "dining_room": "jedáleň",
    "food_variety": "rozmanitosť potravín",
    "quality_of_the_food": "kvalitu jedla",
    "amount_of_the_food": "množstvo jedla",
    "quality_of_cooking": "kvalita varenia",
    "side_courses": "vedľajšie kurzy",
    "meat": "mäso",
    "desserts": "dezerty",
    "vegetarian": "vegetariánsky",
    "salad_bar": "šalátový bar",
    "main_courses": "hlavné jedlá",
    "service": "služby",
    "dining_room_cleanliness": "čistota jedálne",
    "plates_and_cutlery_cleanliness": "čistota tanierov a príborov",
    "product_inventory": "inventár produktov",
    "furnishers": "nábytkári",
    "toilets": "toalety",
    "problem_coffee_machine": "problémový kávovar",
    "problem_water_bar": "problémová vodná tyčinka",
    "dirty_stairs": "špinavé schody",
    "toiletries": "toaletné potreby",
    "fixed_soap_dispenser": "pevný dávkovač mydla",
    "fixed_paper_dispenser": "pevný zásobník papiera",
    "fixed_coffee_machine": "pevný kávovar",
    "fixed_water_bar": "pevná vodná lišta",
    "problem_urinals": "problémové pisoáre",
    "blockage_toilet": "zablokovanie WC",
    "appliance_problem": "problém so spotrebičom",
    "problem_broken_door": "problém s rozbitými dverami",
    "problem_door_lock": "problémový zámok dverí",
    "problem_broken_toilet_seat": "problém s rozbitou záchodovou doskou",
    "problem_broken_niagara": "problém zlomená niagara",
    " broken_hand_paper_dispenser_hand_dryer": "pokazený zásobník na ručný papier + sušič rúk",
    "rug": "koberček",
    "tables": "tabuľky",
    "kitchen": "kuchyňa",
    "air_condition": "klimatizácia",
    "dirty_urinals": "špinavé pisoáre",
    "hand_dryer": "sušič_ruk",
    "non_sticky_carpet": "nelepivý koberec",
    "problem_bad_smell": "problém nepríjemný zápach",
    "problem_broken_toilet_handle": "problém so zlomenou rukoväťou toalety",
    "problem_handle_door": "problémová kľučka dverí",
    "call_cleaner": "zavolajte upratovačku",
    "wall_painting": "nástenná maľba",
    "missing_paper": "chýbajúci papier",
    "clean_surface": "čistý povrch",
    "problem_right_elevator": "problém pravý výťah",
    "problem_left_elevator": "problém ľavého výťahu",
    "missing_hand_sanitizer": "chýba dezinfekcia na ruky",
    "problem_sink_blockage": "problémové zablokovanie umývadla",
    "electric_problem": "elektrický problém",
    "missing_coffe_tea": "chýba káva čaj",
    "problem_air_condition": "problémová klimatizácia",
    "dishwashing": "umývanie riadu",
    "kitchen_cleanliness": "čistota kuchyne",
    "weekly_cleaning": "týždenné upratovanie",
    "general_arrangement": "všeobecné usporiadanie",
    "meeting_room": "zasadacia miestnosť",
    "refrigerator": "chladnička",
    "kitchen_supplies": "kuchynské potreby",
    "toilet_services": "toaletné služby",
    "carousel_door": "karuselové dvere",
    "desk": "pracovný stôl",
    "compressor": "kompresor",
    "compressor_rails": "kompresorové koľajnice",
    "compressor_drainage": "odvodnenie kompresora",
    "dust": "prach",
    "door": "dvere",
    "scotch": "škótska",
    "food": "jedlo",
    "room_conditions": "podmienky miestnosti",
    "kindness_sensitivity": "láskavosť a citlivosť",
    "explain_process": "vysvetliť proces",
    "personal_attention": "osobnú pozornosť",
    "service_problem": "servisný problém",
    "welcome_you": "vítam ťa",
    "invoice_submitted": "predložená faktúra",
    "thank_you_bought": "dakujem kupil",
    "problem_seller": "problémový predajca",
    "lapel_pin": "klopový špendlík",
    "proper_performance": "riadny výkon",
    "name_tag": "menovka",
    "operational": "operatívne",
    "app_revealed": "aplikácia odhalená",
    "register_load": "zaťaženie registra",
    "visibility_problem": "problém s viditeľnosťou",
    "clean_storefront": "čistý výklad",
    "clean_garbage": "čistý odpad",
    "clean_tables_chairs": "čisté stoly a stoličky",
    "clean_shop_floor": "čistá podlaha predajne",
    "product_show": "pohľad na produkt",
    "refrigerators_show": "pohľad na chladničky",
    "coffee_accessories": "príslušenstvo na kávu a vybavené",
    "cleanliness": "čistota",
    "convenience_scheduling_appointments": "pohodlie pri plánovaní stretnutí",
    "waiting_haircut": "čaká na ostrihanie",
    "courtesy_books": "s láskavým dovolením kníh",
    "books_professionalism": "profesionalita kníh",
    "received_time": "prijal ma včas",
    "dnot_appointment": "nedohodol som si stretnutie",
    "an_appointment": "dohodol som si stretnutie",
    "tasty": "chutné",
    "courtesy_service": "láskavosť služby",
    "overall_experience": "celkový zážitok",
    "not_clean": "nie čisté",
    "diningroom_not_clean": "jedáleň nie je čistá",
    "unclean_dishes": "nečistý riad",
    "so-so": "tak-tak",
    "not_tasty": "nie chutné",
    "kind": "druh",
    "not_kind": "nie láskavý",
    "clean": "čisté",
    "hairdresser": "kaderníčka",
    "wrong_price": "nesprávna cena",
    "produc_has_expired": "platnosť produktu vypršala",
    "missing_item": "chýbajúca položka",
    "item_is_faulty_in_the_machine": "položka je v stroji chybná",
    "machine_cleaning": "strojové čistenie",
    "improper_temperature": "nevhodná teplota",
    "green": "zelená",
    "orange": "oranžová",
    "red": "červená",
    "yellow": "žltá",
    "red not prob": "červená nie je problém",
    "professional": "profesionálny",
    "unprofessional": "neprofesionálne",
    "delicacies": "lahôdky",
    "sandwiches": "sendviče",
    "vegetables": "zeleniny",
    "fruits": "ovocie",
    "salads": "šaláty",
    "milk": "mlieko",
    "room_link": "odkaz na izbu",
    "floor_link": "podlahový odkaz",
    "services": "služby",
    "check_list": "kontrolný zoznam",
    "lighting_problem_lobby": "lobby problém s osvetlením",
    "lighting_problem_garbage_room": "problém s osvetlením smetnej miestnosti",
    "lighting_problem_stairwell": "problémové osvetlenie schodiska",
    "problem_elevator_1": "problémový výťah 1",
    "problem_elevator_2": "problémový výťah 2",
    "problem_elevator_3": "problémový výťah 3",
    "problem_elevator_4": "problémový výťah 4",
    "problem_elevator_5": "problémový výťah 5",
    "problem_elevator_6": "problémový výťah 6",
    "problem_elevator_7": "problémový výťah 7",
    "problem_elevator_8": "problémový výťah 8",
    "problem_elevator_9": "problémový výťah 9",
    "problem_elevator_10": "problémový výťah 10",
    "stuck_item": "zaseknutá položka",
    "spoiling_product": "kaziaci sa produkt",
    "machine_malfunction": "porucha stroja",
    "unreadable_product": "nečitateľný produkt",
    "i_am_satisfied": "som spokojný",
    "beverage": "nápoj",
    "program_malfunction": "nefunkčnosť programu",
    "machine_1": "stroj 1",
    "machine_2": "stroj 2",
    "machine_3": "stroj 3",
    "machine_4": "stroj 4",
    "program malfunction 1": "porucha programu 1",
    "program malfunction 2": "porucha programu 2",
    "program malfunction 3": "porucha programu 3",
    "program malfunction 4": "porucha programu 4",
    "fish": "ryby",
    "chicken": "kura",
    "full_dining_room": "plná jedáleň",
    "missing_amount": "chýbajúce množstvo",
    "missing_trays": "chýbajúce podnosy",
    "dirty_floor_g1": "špinavá podlaha g1",
    "dirty_floor_g2": "špinavá podlaha g2",
    "dirty_floor_g3": "špinavá podlaha g3",
    "dirty_floor_g4": "špinavá podlaha g4",
    "dirty_floor_g5": "špinavá podlaha g5",
    "dirty_floor_eo": "špinavá podlaha eo",
    "dirty_floor_ceo": "špinavá podlaha generálny riaditeľ",
    "dirty_floor_storage": "skladovanie špinavej podlahy",
    "dirty_floor_inflorescence": "špinavé podlahové kvetenstvo",
    "operating_instructions": "návod na obsluhu",
    "general": "všeobecný",
    "connection_problem": "problém s pripojením",
    "lighting": "osvetlenie",
    "not _fixed": "neopravené",
    "cleaning_needed": "potrebné čistenie",
    "missing_milk": "chýbajúce mlieko",
    "no_sugar_coffee": "žiadny cukor/káva",
    "missing_tools": "chýbajúce nástroje",
    "coffee_water_machine": "automat na kávu / vodu",
    "appliances": "spotrebičov",
    "products": "produktov",
    "broken_chair": "rozbitý nábytok",
    "broken_cabinet": "rozbitá skrinka",
    "micro": "mikro",
    "toaster": "hriankovač",
    "clogged_sink_malfunction": "porucha upchatého umývadla",
    "coffee_cooling_malfunction": "porucha chladenia kávy",
    "no_coffee_beans": "žiadne kávové zrná",
    "machine_failure": "porucha stroja",
    "that_dirty": "to špinavé",
    "dirty_refrigerator": "špinavá chladnička",
    "dirty_tables": "špinavé stoly",
    "plates": "taniere",
    "silver_spoon": "strieborná_lyžica",
    "cold_drinks_cups": "poháre na studené nápoje",
    "hot_drink_cups": "poháre na horúce nápoje",
    "a_dripping_faucet": "kvapkajúci kohútik",
    "disposable dishes": "jednorazový riad",
    "problem_ coffee_water_machine": "problémový automat na kávu / vodu",
    "problem_micro": "problém mikro",
    "problem_toaster": "problémový hriankovač",
    "problem_machine_failure": "problémová porucha stroja",
    "problem refrigerator": "problémová chladnička",
    "no_sugar/coffee": "žiadny cukor/káva",
    "missing_dishes": "chýbajúci riad",
    "coffee/water_machine": "automat na kávu / vodu",
    "coffee_machine_door_open": "otvorené dvierka kávovaru",
    "coffee_machine_door_close": "zatvorte dvierka kávovaru",
    "coffee_machine_bin_full": "plný kôš kávovaru",
    "coffee_machine_bin_empty": "prázdny kôš kávovaru",
    "coffee_machine_coffee_full": "kávovar plná káva",
    "coffee_machine_coffee_empty": "kávovar káva prázdna",
    "coffee_machine_water_tank_empty": "nádrž na vodu kávovaru prázdna",
    "coffee_machine_ water_tank_full": "plná nádrž na vodu kávovaru",
    "coffee_machine_milk_cleaning_not_performed": "čistenie mlieka kávovaru nebolo vykonané",
    "coffee_machine _milk_cleaning_performed": "vykonané čistenie mlieka kávovaru",
    "coffee_machine_head_cleaning_not_performed": "čistenie hlavy kávovaru nebolo vykonané",
    "coffee_machine_head_ cleaning_performed": "vykonané čistenie hlavy kávovaru",
    "coffee_machine_descaling_not_performed": "nie je vykonané odstraňovanie vodného kameňa z kávovaru",
    "coffee_machine_descaling_performed": "vykonané odstraňovanie vodného kameňa z kávovaru",
    "floor_one": "poschodie 1",
    "floor_two": "poschodie 2",
    "floor_three": "poschodie 3",
    "floor_four": "poschodie 4",
    "floor_five": "poschodie 5",
    "floor_six": "poschodie 6",
    "floor_seven": "poschodie 7",
    "floor_eight": "poschodie 8",
    "floor_nine": "poschodie 9",
    "floor_ten": "poschodie 10",
    "floor_eleven": "poschodie 11",
    "floor_twelve": "poschodie 12",
    "floor_thirteen": "poschodie 13",
    "floor_fourteen": "poschodie 14",
    "floor_fifteen": "poschodie 15",
    "floor_sixteen": "poschodie 16",
    "floor_seventeen": "poschodie 17",
    "floor_eighteen": "poschodie 18",
    "floor_nineteen": "poschodie 19",
    "floor_twenty": "poschodie 20",
    "floor_twenty_one": "poschodie 21",
    "floor_twenty_two": "poschodie 22",
    "floor_twenty_three": "poschodie 23",
    "floor_twenty_four": "poschodie 24",
    "floor_twenty_five": "poschodie 25",
    "status_toilet_paper_cell_01_-_empty": "Stav Bunka na toaletný papier 01 - Prázdna",
    "status_toilet_paper_cell_02_-_empty": "Stav Bunka na toaletný papier 02 - Prázdna",
    "status_toilet_paper_cell_03_-_empty": "Stav Bunka na toaletný papier 03 - Prázdna",
    "status_toilet_paper_cell_04_-_empty": "Stav Bunka na toaletný papier 04 - Prázdna",
    "status_toilet_paper_cell_05_-_empty": "Stav Bunka na toaletný papier 05 - Prázdna",
    "status_toilet_paper_cell_06_-_empty": "Stav Bunka na toaletný papier 06 - Prázdna",
    "status_toilet_paper_cell_07_-_empty": "Stav Bunka na toaletný papier 07 - Prázdna",
    "status_toilet_paper_cell_08_-_empty": "Stav Bunka na toaletný papier 08 - Prázdna",
    "status_toilet_paper_cell_09_-_empty": "Stav Bunka na toaletný papier 09 – prázdna",
    "status_toilet_paper_cell_10_-_empty": "Stav Bunka na toaletný papier 10 – prázdna",
    "status_toilet_paper_cell_11_-_empty": "Stav Bunka s toaletným papierom 11 – prázdna",
    "status_toilet_paper_cell_12_-_empty": "Stav Bunka 12 na toaletný papier – prázdna",
    "status_toilet_paper_cell_13_-_empty": "Stav Toaletný papier Bunka 13 - Prázdna",
    "status_toilet_paper_cell_14_-_empty": "Stav Bunka s toaletným papierom 14 - Prázdna",
    "status_toilet_paper_cell_15_-_empty": "Stav bunky toaletného papiera 15 – prázdna",
    "status_toilet_paper_cell_16_-_empty": "Stav bunky toaletného papiera 16 – prázdna",
    "status_toilet_paper_cell_17_-_empty": "Stav bunky toaletného papiera 17 – prázdna",
    "status_toilet_paper_cell_18_-_empty": "Stav Bunka s toaletným papierom 18 – prázdna",
    "status_toilet_paper_cell_19_-_empty": "Stav Bunka s toaletným papierom 19 – prázdna",
    "status_toilet_paper_cell_20_-_empty": "Stav bunky toaletného papiera 20 – prázdna",
    "status_toilet_paper_cell_01_-_almost_empty": "Stav bunky na toaletný papier 01 – takmer prázdna",
    "status_toilet_paper_cell_02_-_almost_empty": "Stav bunky na toaletný papier 02 – takmer prázdna",
    "status_toilet_paper_cell_03_-_almost_empty": "Stav bunky na toaletný papier 03 – takmer prázdna",
    "status_toilet_paper_cell_04_-_almost_empty": "Stav bunky na toaletný papier 04 – takmer prázdna",
    "status_toilet_paper_cell_05_-_almost_empty": "Stav bunky na toaletný papier 05 – takmer prázdna",
    "status_toilet_paper_cell_06_-_almost_empty": "Stav bunky na toaletný papier 06 – takmer prázdna",
    "status_toilet_paper_cell_07_-_almost_empty": "Stav bunky na toaletný papier 07 – takmer prázdna",
    "status_toilet_paper_cell_08_-_almost_empty": "Stav bunky na toaletný papier 08 – takmer prázdna",
    "status_toilet_paper_cell_09_-_almost_empty": "Stav bunky na toaletný papier 09 – takmer prázdna",
    "status_toilet_paper_cell_10_-_almost_empty": "Stav bunky 10 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_11_-_almost_empty": "Stav bunky 11 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_12_-_almost_empty": "Stav bunky 12 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_13_-_almost_empty": "Stav bunky 13 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_14_-_almost_empty": "Stav bunky 14 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_15_-_almost_empty": "Stav bunky 15 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_16_-_almost_empty": "Stav bunky 16 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_17_-_almost_empty": "Stav bunky 17 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_18_-_almost_empty": "Stav bunky 18 na toaletný papier – takmer prázdna",
    "status_toilet_paper_cell_19_-_almost_empty": "Stav bunka na toaletný papier 19 – takmer prázdna",
    "status_toilet_paper_cell_20_-_almost_empty": "Stav bunky 20 na toaletný papier – takmer prázdna",
    "of": "z",
    "items": "položky",
    "loading_charts": "načítavacie grafy",
    "refresh_the_room": "osviežte miestnosť",
    "clean_the_floor": "vyčistiť podlahu",
    "clean_the_toilet": "vyčistiť toaletu",
    "refill_soap": "doplniť mydlo",
    "change_roll": "vymeniť rolku",
    "great_job": "skvelá práca",
    "empty_the_trash": "vysypať odpadky",
    "repair_required": "potrebná oprava",
    "cleaning": "čistenie",
    "cleaning_performed": "vykonané čistenie",
    "slovenčina": "Slovenčina"
  },
  ka: {
    "cleaned_floor": "გაწმენდილი იატაკი",
    "cleaned_toilet": "გაწმენდილი ტუალეტი",
    "cleaned_shower": "გაწმენდილი შხაპი",
    "cleaned_sink": "გაწმენდილი ნიჟარა",
    "cleaned_mirror": "გაწმენდილი სარკე",
    "cleaned_stainless_steel": "გაწმენდილი უჟანგავი ფოლადი",
    "bad_smell": "ცუდი სუნი",
    "dirty_floor": "ბინძური იატაკი",
    "dirty_lavatory_seat": "ბინძური ტუალეტის სავარძელი",
    "dirty_shower": "ბინძური შხაპი",
    "dirty_sink": "ბინძური ნიჟარა",
    "dirty_mirror": "ბინძური სარკე",
    "dirty_stainless_steel": "ბინძური უჟანგავი ფოლადი",
    "missing_paper_towel": "აკლია ქაღალდის პირსახოცი",
    "missing_soap": "საპონი აკლია",
    "missing_toilet_paper": "აკლია ტუალეტის ქაღალდი",
    "problem_shower": "პრობლემური შხაპი",
    "problem_sink": "პრობლემური ნიჟარა",
    "problem_mirror": "პრობლემური სარკე",
    "problem_stainless_steel": "პრობლემა უჟანგავი ფოლადი",
    "problem_blockage": "პრობლემის ბლოკირება",
    "problem_door": "პრობლემური კარი",
    "problem_fluid_taps": "პრობლემური სითხის ონკანები",
    "problem_lightning": "პრობლემა ელვა",
    "problem_broken_toilet": "პრობლემა გატეხილი ტუალეტი",
    "fixed_shower": "ფიქსირებული შხაპი",
    "fixed_sink": "ფიქსირებული ნიჟარა",
    "fixed_mirror": "ფიქსირებული სარკე",
    "fixed_stainless_steel": "ფიქსირებული უჟანგავი ფოლადი",
    "fixed_blockage": "ფიქსირებული ბლოკირება",
    "fixed_door": "ფიქსირებული კარი",
    "fixed_fluid_taps": "ფიქსირებული სითხის ონკანები",
    "fixed_lightning": "ფიქსირებული ელვა",
    "fixed_broken_toilet": "შესწორებული გატეხილი ტუალეტი",
    "very_good": "ძალიან კარგი",
    "excellent": "შესანიშნავი",
    "good": "კარგი",
    "like": "მოსწონს",
    "needs_improvement": "გაუმჯობესება სჭირდება",
    "not_good": "არ არის კარგი",
    "supervise": "ზედამხედველობა",
    "maintenance": "მოვლა",
    "cleaner": "გამწმენდი",
    "tag_cleaner": "ტეგების გამწმენდი",
    "zone_is_clean": "ზონა სუფთაა",
    "zone_is_dirty": "ზონა ბინძურია",
    "cleaner_arrived": "დამლაგებელი ჩამოვიდა",
    "start_clean_zone": "სუფთა ზონის დაწყება",
    "counter": "მრიცხველი",
    "counter_men": "კონტრ მამაკაცები",
    "counter_woman": "მრიცხველი ქალი",
    "counter_handycap": "counter handycap",
    "full_garbage_can": "სავსე ნაგვის ურნა",
    "maintenance_fixed": "მოვლა დაფიქსირდა",
    "maintenance_problem": "შენარჩუნების პრობლემა",
    "problem_soap_dispenser": "პრობლემური საპნის დისპენსერი",
    "problem_paper_dispenser": "პრობლემური ქაღალდის დისპენსერი",
    "end_clean_zone": "ბოლო სუფთა ზონა",
    "status_toilet_paper": "სტატუსი ტუალეტის ქაღალდი",
    "status_hend_paper": "სტატუსის ქაღალდი",
    "fixed": "დაფიქსირდა",
    "status_soap": "სტატუსის საპონი",
    "status_garbage_can": "სტატუსის ნაგვის ურნა",
    "general_cleaning": "ზოგადი გაწმენდა",
    "coffee_tea": "ყავის ჩაი",
    "water_bar": "წყლის ბარი",
    "disposable_dishes": "ერთჯერადი ჭურჭელი",
    "head_coverage": "თავის დაფარვა",
    "something_else": "რაღაც სხვა",
    "missing_clothing": "ტანსაცმელი აკლია",
    "maintenance_link": "ტექნიკური ბმული",
    "problem_maintenance": "პრობლემის შენარჩუნება",
    "supervise_link": "ზედამხედველობის ლინკი",
    "cleaner_link": "სუფთა ბმული",
    "room_men+link": "ოთახი მამაკაცები + ბმული",
    "room_men-link": "ოთახის მამაკაცები - ბმული",
    "room_women+link": "ოთახი ქალები + ბმული",
    "room_women-link": "ოთახის ქალები - ბმული",
    "hebrew": "ებრაული",
    "español": "ესპანელი",
    "français": "ფრანგული",
    "english": "ინგლისური",
    "русский": "რუსული",
    "italiano": "იტალიური",
    "አማርኛ": "አማርኛ",
    "português": "პორტუგალიელები",
    "arabic": "არაბული",
    "partial_information": "ნაწილობრივი ინფორმაცია",
    "professionalism": "პროფესიონალიზმი",
    "the_attitude_of_the_representative": "წარმომადგენლის დამოკიდებულება",
    "waiting_time_for_service": "მომსახურების ლოდინის დრო",
    "other_aspect_of_service": "მომსახურების სხვა ასპექტი",
    "language_of_the_service": "სამსახურის ენა",
    "procedure_for_making_an_appointment": "დანიშვნის პროცედურა",
    "physical_conditions": "ფიზიკური პირობები",
    "found_another": "იპოვა სხვა",
    "found_similar": "იპოვეს მსგავსი",
    "did_not_find": "არ იპოვა",
    "found": "ნაპოვნია",
    "need_improved": "სჭირდება გაუმჯობესება",
    "liked": "მოეწონა",
    "pleasant": "სასიამოვნო",
    "eilat_resident": "ეილათის მცხოვრები",
    "once_a_week": "კვირაში ერთხელ",
    "once_a_month": "თვეში ერთხელ",
    "twice_a_year": "წელიწადში ორჯერ",
    "once_a_year": "წელიწადში ერთხელ",
    "friend": "მეგობარი",
    "newspaper": "გაზეთი",
    "google": "გუგლი",
    "zap": "zap",
    "vacuum_cleaner": "მტვერსასრუტი",
    "gaming_consoles": "სათამაშო კონსოლები",
    "laptop": "ლეპტოპი",
    "cellular": "ფიჭური",
    "shop": "მაღაზია",
    "restaurant_complex_cleaning": "სარესტორნო კომპლექსის დასუფთავება",
    "dining_room": "სასადილო ოთახი",
    "food_variety": "საკვების მრავალფეროვნება",
    "quality_of_the_food": "საკვების ხარისხი",
    "amount_of_the_food": "საკვების რაოდენობა",
    "quality_of_cooking": "სამზარეულოს ხარისხი",
    "side_courses": "გვერდითი კურსები",
    "meat": "ხორცი",
    "desserts": "დესერტები",
    "vegetarian": "ვეგეტარიანელი",
    "salad_bar": "სალათის ბარი",
    "main_courses": "ძირითადი კურსები",
    "service": "სერვისი",
    "dining_room_cleanliness": "სასადილო ოთახის სისუფთავე",
    "plates_and_cutlery_cleanliness": "თეფშები და დანაჩანგალი სისუფთავე",
    "product_inventory": "პროდუქტის ინვენტარი",
    "furnishers": "ავეჯეები",
    "toilets": "ტუალეტები",
    "problem_coffee_machine": "პრობლემური ყავის მანქანა",
    "problem_water_bar": "პრობლემური წყლის ბარი",
    "dirty_stairs": "ბინძური კიბეები",
    "toiletries": "ტუალეტის საშუალებები",
    "fixed_soap_dispenser": "ფიქსირებული საპნის დისპენსერი",
    "fixed_paper_dispenser": "ფიქსირებული ქაღალდის დისპენსერი",
    "fixed_coffee_machine": "ფიქსირებული ყავის აპარატი",
    "fixed_water_bar": "ფიქსირებული წყლის ბარი",
    "problem_urinals": "პრობლემური საშარდეები",
    "blockage_toilet": "ბლოკირების ტუალეტი",
    "appliance_problem": "ტექნიკის პრობლემა",
    "problem_broken_door": "პრობლემა გატეხილი კარი",
    "problem_door_lock": "პრობლემური კარის საკეტი",
    "problem_broken_toilet_seat": "პრობლემა გატეხილი ტუალეტის სავარძელი",
    "problem_broken_niagara": "პრობლემა გატეხილია ნიაგარა",
    " broken_hand_paper_dispenser_hand_dryer": "გატეხილი ხელის ქაღალდის დისპენსერი + ხელის საშრობი",
    "rug": "ხალიჩა",
    "tables": "მაგიდები",
    "kitchen": "სამზარეულო",
    "air_condition": "კონდიციონერი",
    "dirty_urinals": "ბინძური შარდსადენები",
    "hand_dryer": "ხელის საშრობი",
    "non_sticky_carpet": "არაწებოვანი ხალიჩა",
    "problem_bad_smell": "პრობლემა ცუდი სუნი",
    "problem_broken_toilet_handle": "პრობლემა გატეხილი ტუალეტის სახელური",
    "problem_handle_door": "პრობლემის სახელურის კარი",
    "call_cleaner": "დარეკეთ დამლაგებელს",
    "wall_painting": "კედლის მხატვრობა",
    "missing_paper": "დაკარგული ქაღალდი",
    "clean_surface": "სუფთა ზედაპირი",
    "problem_right_elevator": "პრობლემური მარჯვენა ლიფტი",
    "problem_left_elevator": "პრობლემა მარცხენა ლიფტი",
    "missing_hand_sanitizer": "აკლია ხელის სადეზინფექციო საშუალება",
    "problem_sink_blockage": "პრობლემური ნიჟარის ბლოკირება",
    "electric_problem": "ელექტრო პრობლემა",
    "missing_coffe_tea": "აკლია ყავის ჩაი",
    "problem_air_condition": "პრობლემური კონდიციონერი",
    "dishwashing": "ჭურჭლის რეცხვა",
    "kitchen_cleanliness": "სამზარეულოს სისუფთავე",
    "weekly_cleaning": "ყოველკვირეული დასუფთავება",
    "general_arrangement": "ზოგადი მოწყობა",
    "meeting_room": "შეხვედრის ოთახი",
    "refrigerator": "მაცივარი",
    "kitchen_supplies": "სამზარეულოს მარაგი",
    "toilet_services": "ტუალეტის მომსახურება",
    "carousel_door": "კარუსელის კარი",
    "desk": "მაგიდა",
    "compressor": "კომპრესორი",
    "compressor_rails": "კომპრესორის რელსები",
    "compressor_drainage": "კომპრესორის დრენაჟი",
    "dust": "მტვერი",
    "door": "კარი",
    "scotch": "სკოჩი",
    "food": "საკვები",
    "room_conditions": "ოთახის პირობები",
    "kindness_sensitivity": "სიკეთე და მგრძნობელობა",
    "explain_process": "აუხსენით პროცესი",
    "personal_attention": "პირადი ყურადღება",
    "service_problem": "სერვისის პრობლემა",
    "welcome_you": "მოგესალმებით",
    "invoice_submitted": "წარდგენილი ინვოისი",
    "thank_you_bought": "მადლობა იყიდე",
    "problem_seller": "პრობლემური გამყიდველი",
    "lapel_pin": "ლაპელ ქინძისთავით",
    "proper_performance": "სათანადო შესრულება",
    "name_tag": "სახელის ნიშანი",
    "operational": "ოპერატიული",
    "app_revealed": "აპლიკაცია გამოვლინდა",
    "register_load": "დატვირთვის რეგისტრაცია",
    "visibility_problem": "ხილვადობის პრობლემა",
    "clean_storefront": "სუფთა ვიტრინა",
    "clean_garbage": "სუფთა ნაგავი",
    "clean_tables_chairs": "სუფთა მაგიდები და სკამები",
    "clean_shop_floor": "სუფთა მაღაზიის იატაკი",
    "product_show": "პროდუქტის ხედი",
    "refrigerators_show": "მაცივრების ხედი",
    "coffee_accessories": "ყავის აქსესუარები და აღჭურვილი",
    "cleanliness": "სისუფთავე",
    "convenience_scheduling_appointments": "შეხვედრების დაგეგმვის მოხერხებულობა",
    "waiting_haircut": "თმის შეჭრის მოლოდინში",
    "courtesy_books": "წიგნების თავაზიანობით",
    "books_professionalism": "წიგნების პროფესიონალიზმი",
    "received_time": "დროულად მიმიღო",
    "dnot_appointment": "მე არ დავნიშნე შეხვედრა",
    "an_appointment": "მე დავნიშნე შეხვედრა",
    "tasty": "გემრიელი",
    "courtesy_service": "სერვისის თავაზიანობით",
    "overall_experience": "საერთო გამოცდილება",
    "not_clean": "არ არის სუფთა",
    "diningroom_not_clean": "სასადილო არ არის სუფთა",
    "unclean_dishes": "უწმინდური კერძები",
    "so-so": "ასე-ისე",
    "not_tasty": "არა გემრიელი",
    "kind": "კეთილი",
    "not_kind": "არა კეთილი",
    "clean": "სუფთა",
    "hairdresser": "პარიკმახერი",
    "wrong_price": "არასწორი ფასი",
    "produc_has_expired": "პროდუქტს ვადა გაუვიდა",
    "missing_item": "დაკარგული ნივთი",
    "item_is_faulty_in_the_machine": "ნივთი დეფექტურია მანქანაში",
    "machine_cleaning": "მანქანის გაწმენდა",
    "improper_temperature": "არასათანადო ტემპერატურა",
    "green": "მწვანე",
    "orange": "ფორთოხალი",
    "red": "წითელი",
    "yellow": "ყვითელი",
    "red not prob": "წითელი არ არის პრობ",
    "professional": "პროფესიონალი",
    "unprofessional": "არაპროფესიონალური",
    "delicacies": "დელიკატესები",
    "sandwiches": "სენდვიჩები",
    "vegetables": "ბოსტნეული",
    "fruits": "ხილი",
    "salads": "სალათები",
    "milk": "რძე",
    "room_link": "ოთახის ლინკი",
    "floor_link": "სართულის ბმული",
    "services": "მომსახურება",
    "check_list": "საკონტროლო სია",
    "lighting_problem_lobby": "განათების პრობლემური ლობი",
    "lighting_problem_garbage_room": "განათების პრობლემა ნაგვის ოთახი",
    "lighting_problem_stairwell": "განათების პრობლემა კიბეზე",
    "problem_elevator_1": "პრობლემური ლიფტი 1",
    "problem_elevator_2": "პრობლემური ლიფტი 2",
    "problem_elevator_3": "პრობლემური ლიფტი 3",
    "problem_elevator_4": "პრობლემური ლიფტი 4",
    "problem_elevator_5": "პრობლემური ლიფტი 5",
    "problem_elevator_6": "პრობლემური ლიფტი 6",
    "problem_elevator_7": "პრობლემური ლიფტი 7",
    "problem_elevator_8": "პრობლემური ლიფტი 8",
    "problem_elevator_9": "პრობლემური ლიფტი 9",
    "problem_elevator_10": "პრობლემური ლიფტი 10",
    "stuck_item": "ჩარჩენილი ნივთი",
    "spoiling_product": "გაფუჭებული პროდუქტი",
    "machine_malfunction": "მანქანის გაუმართაობა",
    "unreadable_product": "წაუკითხავი პროდუქტი",
    "i_am_satisfied": "კმაყოფილი ვარ",
    "beverage": "სასმელი",
    "program_malfunction": "პროგრამის გაუმართაობა",
    "machine_1": "მანქანა 1",
    "machine_2": "მანქანა 2",
    "machine_3": "მანქანა 3",
    "machine_4": "მანქანა 4",
    "program malfunction 1": "პროგრამის გაუმართაობა 1",
    "program malfunction 2": "პროგრამის გაუმართაობა 2",
    "program malfunction 3": "პროგრამის გაუმართაობა 3",
    "program malfunction 4": "პროგრამის გაუმართაობა 4",
    "fish": "თევზი",
    "chicken": "ქათამი",
    "full_dining_room": "სრული სასადილო ოთახი",
    "missing_amount": "დაკარგული თანხა",
    "missing_trays": "დაკარგული უჯრები",
    "dirty_floor_g1": "ჭუჭყიანი იატაკი g1",
    "dirty_floor_g2": "ბინძური იატაკი g2",
    "dirty_floor_g3": "ბინძური იატაკი g3",
    "dirty_floor_g4": "ბინძური იატაკი g4",
    "dirty_floor_g5": "ბინძური იატაკი g5",
    "dirty_floor_eo": "ბინძური იატაკი ეო",
    "dirty_floor_ceo": "ბინძური იატაკის აღმასრულებელი დირექტორი",
    "dirty_floor_storage": "ბინძური იატაკის საცავი",
    "dirty_floor_inflorescence": "ბინძური იატაკის inflorescence",
    "operating_instructions": "საოპერაციო ინსტრუქციები",
    "general": "გენერალი",
    "connection_problem": "კავშირის პრობლემა",
    "lighting": "განათება",
    "not _fixed": "არ არის დაფიქსირებული",
    "cleaning_needed": "საჭირო დასუფთავება",
    "missing_milk": "რძე აკლია",
    "no_sugar_coffee": "შაქრის / ყავის გარეშე",
    "missing_tools": "დაკარგული ხელსაწყოები",
    "coffee_water_machine": "ყავის/წყლის აპარატი",
    "appliances": "ტექნიკა",
    "products": "პროდუქტები",
    "broken_chair": "გატეხილი ავეჯი",
    "broken_cabinet": "გატეხილი კაბინეტი",
    "micro": "მიკრო",
    "toaster": "ტოსტერი",
    "clogged_sink_malfunction": "ჩაკეტილი ნიჟარის გაუმართაობა",
    "coffee_cooling_malfunction": "ყავის გაგრილების გაუმართაობა",
    "no_coffee_beans": "ყავის მარცვლების გარეშე",
    "machine_failure": "მანქანის უკმარისობა",
    "that_dirty": "რომ ბინძური",
    "dirty_refrigerator": "ბინძური მაცივარი",
    "dirty_tables": "ბინძური მაგიდები",
    "plates": "ფირფიტები",
    "silver_spoon": "ვერცხლის_კოვზი",
    "cold_drinks_cups": "ცივი სასმელების ჭიქები",
    "hot_drink_cups": "ცხელი სასმელის ჭიქები",
    "a_dripping_faucet": "წვეთოვანი ონკანი",
    "disposable dishes": "ერთჯერადი ჭურჭელი",
    "problem_ coffee_water_machine": "პრობლემური ყავის/წყლის აპარატი",
    "problem_micro": "პრობლემა მიკრო",
    "problem_toaster": "პრობლემური ტოსტერი",
    "problem_machine_failure": "პრობლემური აპარატის უკმარისობა",
    "problem refrigerator": "პრობლემური მაცივარი",
    "no_sugar/coffee": "შაქრის / ყავის გარეშე",
    "missing_dishes": "დაკარგული კერძები",
    "coffee/water_machine": "ყავის/წყლის აპარატი",
    "coffee_machine_door_open": "ყავის აპარატის კარი ღიაა",
    "coffee_machine_door_close": "ყავის აპარატის კარი დახურულია",
    "coffee_machine_bin_full": "ყავის აპარატის ურნა სავსეა",
    "coffee_machine_bin_empty": "ყავის აპარატის ურნა ცარიელი",
    "coffee_machine_coffee_full": "ყავის აპარატი ყავის სავსე",
    "coffee_machine_coffee_empty": "ყავის მანქანა ყავა ცარიელი",
    "coffee_machine_water_tank_empty": "ყავის აპარატის წყლის ავზი ცარიელი",
    "coffee_machine_ water_tank_full": "ყავის აპარატის წყლის ავზი სავსეა",
    "coffee_machine_milk_cleaning_not_performed": "ყავის აპარატის რძის გაწმენდა არ ჩატარებულა",
    "coffee_machine _milk_cleaning_performed": "შესრულებულია ყავის აპარატის რძის გაწმენდა",
    "coffee_machine_head_cleaning_not_performed": "ყავის აპარატის თავის გაწმენდა არ ჩატარებულა",
    "coffee_machine_head_ cleaning_performed": "შესრულებულია ყავის აპარატის თავის გაწმენდა",
    "coffee_machine_descaling_not_performed": "ყავის აპარატის გამწმენდი არ არის შესრულებული",
    "coffee_machine_descaling_performed": "შესრულებულია ყავის აპარატის გამწმენდი",
    "floor_one": "სართული 1",
    "floor_two": "სართული 2",
    "floor_three": "სართული 3",
    "floor_four": "სართული 4",
    "floor_five": "სართული 5",
    "floor_six": "სართული 6",
    "floor_seven": "სართული 7",
    "floor_eight": "სართული 8",
    "floor_nine": "სართული 9",
    "floor_ten": "სართული 10",
    "floor_eleven": "სართული 11",
    "floor_twelve": "სართული 12",
    "floor_thirteen": "სართული 13",
    "floor_fourteen": "სართული 14",
    "floor_fifteen": "სართული 15",
    "floor_sixteen": "სართული 16",
    "floor_seventeen": "სართული 17",
    "floor_eighteen": "სართული 18",
    "floor_nineteen": "სართული 19",
    "floor_twenty": "სართული 20",
    "floor_twenty_one": "სართული 21",
    "floor_twenty_two": "სართული 22",
    "floor_twenty_three": "სართული 23",
    "floor_twenty_four": "სართული 24",
    "floor_twenty_five": "სართული 25",
    "status_toilet_paper_cell_01_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 01 - ცარიელი",
    "status_toilet_paper_cell_02_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 02 - ცარიელი",
    "status_toilet_paper_cell_03_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 03 - ცარიელი",
    "status_toilet_paper_cell_04_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 04 - ცარიელი",
    "status_toilet_paper_cell_05_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 05 - ცარიელი",
    "status_toilet_paper_cell_06_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 06 - ცარიელი",
    "status_toilet_paper_cell_07_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 07 - ცარიელი",
    "status_toilet_paper_cell_08_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 08 - ცარიელი",
    "status_toilet_paper_cell_09_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 09 - ცარიელი",
    "status_toilet_paper_cell_10_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 10 - ცარიელი",
    "status_toilet_paper_cell_11_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 11 - ცარიელი",
    "status_toilet_paper_cell_12_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 12 - ცარიელი",
    "status_toilet_paper_cell_13_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 13 - ცარიელი",
    "status_toilet_paper_cell_14_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 14 - ცარიელი",
    "status_toilet_paper_cell_15_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 15 - ცარიელი",
    "status_toilet_paper_cell_16_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 16 - ცარიელი",
    "status_toilet_paper_cell_17_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 17 - ცარიელი",
    "status_toilet_paper_cell_18_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 18 - ცარიელი",
    "status_toilet_paper_cell_19_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 19 - ცარიელი",
    "status_toilet_paper_cell_20_-_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 20 - ცარიელი",
    "status_toilet_paper_cell_01_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 01 - თითქმის ცარიელი",
    "status_toilet_paper_cell_02_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 02 - თითქმის ცარიელი",
    "status_toilet_paper_cell_03_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 03 - თითქმის ცარიელი",
    "status_toilet_paper_cell_04_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 04 - თითქმის ცარიელი",
    "status_toilet_paper_cell_05_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 05 - თითქმის ცარიელი",
    "status_toilet_paper_cell_06_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 06 - თითქმის ცარიელი",
    "status_toilet_paper_cell_07_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 07 - თითქმის ცარიელი",
    "status_toilet_paper_cell_08_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 08 - თითქმის ცარიელი",
    "status_toilet_paper_cell_09_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 09 - თითქმის ცარიელი",
    "status_toilet_paper_cell_10_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 10 - თითქმის ცარიელი",
    "status_toilet_paper_cell_11_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 11 - თითქმის ცარიელი",
    "status_toilet_paper_cell_12_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 12 - თითქმის ცარიელი",
    "status_toilet_paper_cell_13_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 13 - თითქმის ცარიელი",
    "status_toilet_paper_cell_14_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 14 - თითქმის ცარიელი",
    "status_toilet_paper_cell_15_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 15 - თითქმის ცარიელი",
    "status_toilet_paper_cell_16_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 16 - თითქმის ცარიელი",
    "status_toilet_paper_cell_17_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 17 - თითქმის ცარიელი",
    "status_toilet_paper_cell_18_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 18 - თითქმის ცარიელი",
    "status_toilet_paper_cell_19_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 19 - თითქმის ცარიელი",
    "status_toilet_paper_cell_20_-_almost_empty": "სტატუსი ტუალეტის ქაღალდის უჯრედი 20 - თითქმის ცარიელი",
    "of": "დან",
    "items": "ნივთები",
    "loading_charts": "სქემების ჩატვირთვა",
    "refresh_the_room": "განაახლეთ ოთახი",
    "clean_the_floor": "გაასუფთავეთ იატაკი",
    "clean_the_toilet": "ტუალეტის გაწმენდა",
    "refill_soap": "შევსება საპონი",
    "change_roll": "რულონის შეცვლა",
    "great_job": "დიდი სამუშაო",
    "empty_the_trash": "დაცალე ნაგავი",
    "repair_required": "საჭიროა შეკეთება",
    "cleaning": "გაწმენდა",
    "cleaning_performed": "შესრულებული გაწმენდა",
    "georgian": "ქართული"
  },
  si: {
    "cleaned_floor": "පිරිසිදු බිම",
    "cleaned_toilet": "පිරිසිදු කළ වැසිකිළිය",
    "cleaned_shower": "පිරිසිදු නාන",
    "cleaned_sink": "පිරිසිදු සින්ක්",
    "cleaned_mirror": "පිරිසිදු කැඩපත",
    "cleaned_stainless_steel": "පිරිසිදු කරන ලද මල නොබැඳෙන වානේ",
    "bad_smell": "නරක සුවඳ",
    "dirty_floor": "අපිරිසිදු තට්ටුව",
    "dirty_lavatory_seat": "අපිරිසිදු වැසිකිළි ආසනය",
    "dirty_shower": "අපිරිසිදු වැස්ස",
    "dirty_sink": "අපිරිසිදු සින්ක්",
    "dirty_mirror": "අපිරිසිදු කැඩපත",
    "dirty_stainless_steel": "අපිරිසිදු මල නොබැඳෙන වානේ",
    "missing_paper_towel": "කඩදාසි තුවා අතුරුදහන්",
    "missing_soap": "නැති සබන්",
    "missing_toilet_paper": "වැසිකිළි කඩදාසි අතුරුදහන්",
    "problem_shower": "ගැටලුව ස්නානය",
    "problem_sink": "ගැටලුව ගිල්වීම",
    "problem_mirror": "ගැටළු කැඩපත",
    "problem_stainless_steel": "ගැටලුවක් මල නොබැඳෙන වානේ",
    "problem_blockage": "ගැටලුව අවහිර වීම",
    "problem_door": "ගැටළු දොර",
    "problem_fluid_taps": "ගැටළු තරල ටැප්",
    "problem_lightning": "ගැටලුව අකුණු",
    "problem_broken_toilet": "ගැටලුව කැඩුණු වැසිකිළිය",
    "fixed_shower": "ස්ථාවර ස්නානය",
    "fixed_sink": "ස්ථාවර සින්ක්",
    "fixed_mirror": "ස්ථාවර කැඩපත",
    "fixed_stainless_steel": "ස්ථාවර මල නොබැඳෙන වානේ",
    "fixed_blockage": "ස්ථාවර අවහිරතා",
    "fixed_door": "ස්ථාවර දොර",
    "fixed_fluid_taps": "ස්ථාවර තරල ටැප්",
    "fixed_lightning": "ස්ථාවර අකුණු",
    "fixed_broken_toilet": "ස්ථාවර කැඩුණු වැසිකිළිය",
    "very_good": "ඉතා හොඳයි",
    "excellent": "විශිෂ්ටයි",
    "good": "හොඳයි",
    "like": "වගේ",
    "needs_improvement": "වැඩිදියුණු කිරීම අවශ්ය වේ",
    "not_good": "හොඳ නැහැ",
    "supervise": "අධීක්ෂණය",
    "maintenance": "නඩත්තු කිරීම",
    "cleaner": "පිරිසිදු කරන්නා",
    "tag_cleaner": "ටැග් පිරිසිදු කරන්නා",
    "zone_is_clean": "කලාපය පිරිසිදුයි",
    "zone_is_dirty": "කලාපය අපිරිසිදු ය",
    "cleaner_arrived": "පිරිසිදු කරන්නා පැමිණියේය",
    "start_clean_zone": "පිරිසිදු කලාපය ආරම්භ කරන්න",
    "counter": "කවුන්ටරය",
    "counter_men": "විරුද්ධ මිනිසුන්",
    "counter_woman": "ප්රති කාන්තාවක්",
    "counter_handycap": "counter handycap",
    "full_garbage_can": "සම්පූර්ණ කුණු කූඩය",
    "maintenance_fixed": "නඩත්තු ස්ථාවර",
    "maintenance_problem": "නඩත්තු ගැටළුව",
    "problem_soap_dispenser": "ගැටළු සබන් බෙදාහරින්නා",
    "problem_paper_dispenser": "ගැටළු කඩදාසි බෙදාහරින්නා",
    "end_clean_zone": "අවසන් පිරිසිදු කලාපය",
    "status_toilet_paper": "තත්ත්වය වැසිකිලි කඩදාසි",
    "status_hend_paper": "තත්ත්වය හෙන්ඩ් කඩදාසි",
    "fixed": "ස්ථාවර",
    "status_soap": "තත්ත්ව සබන්",
    "status_garbage_can": "තත්ත්වය කුණු කූඩය",
    "general_cleaning": "සාමාන්ය පිරිසිදු කිරීම",
    "coffee_tea": "කෝපි තේ",
    "water_bar": "ජල තීරුව",
    "disposable_dishes": "ඉවත දැමිය හැකි කෑම වර්ග",
    "head_coverage": "හිස ආවරණය",
    "something_else": "වෙනත් දෙයක්",
    "missing_clothing": "නැති ඇඳුම්",
    "maintenance_link": "නඩත්තු සබැඳිය",
    "problem_maintenance": "ගැටළු නඩත්තු කිරීම",
    "supervise_link": "සබැඳිය අධීක්ෂණය",
    "cleaner_link": "පිරිසිදු සබැඳිය",
    "room_men+link": "කාමර මිනිසුන් + සබැඳිය",
    "room_men-link": "කාමර මිනිසුන් - සබැඳිය",
    "room_women+link": "කාමර කාන්තාවන් + සබැඳිය",
    "room_women-link": "කාමර කාන්තාවන් - සබැඳිය",
    "hebrew": "හෙබ්රෙව්",
    "español": "español",
    "français": "français",
    "english": "ඉංග්රීසි",
    "русский": "русский",
    "italiano": "ඉතාලි",
    "አማርኛ": "አማርኛ",
    "português": "පෘතුගීසි",
    "arabic": "අරාබි",
    "partial_information": "අර්ධ තොරතුරු",
    "professionalism": "වෘත්තීයභාවය",
    "the_attitude_of_the_representative": "නියෝජිතයාගේ ආකල්පය",
    "waiting_time_for_service": "සේවය සඳහා පොරොත්තු කාලය",
    "other_aspect_of_service": "සේවයේ වෙනත් අංශයක්",
    "language_of_the_service": "සේවාවේ භාෂාව",
    "procedure_for_making_an_appointment": "හමුවීමක් සිදු කිරීම සඳහා ක්රියා පටිපාටිය",
    "physical_conditions": "භෞතික තත්වයන්",
    "found_another": "තවත් එකක් සොයාගත්තා",
    "found_similar": "සමාන හමු විය",
    "did_not_find": "සොයා ගත්තේ නැත",
    "found": "සොයාගත්තා",
    "need_improved": "වැඩිදියුණු කළ යුතුය",
    "liked": "කැමති වුණා",
    "pleasant": "ප්රසන්න",
    "eilat_resident": "අයිලට් පදිංචි",
    "once_a_week": "සතියකට වරක්",
    "once_a_month": "මසකට වරක්",
    "twice_a_year": "වසරකට දෙවරක්",
    "once_a_year": "වසරකට වරක්",
    "friend": "මිතුරා",
    "newspaper": "පුවත්පත",
    "google": "google",
    "zap": "zap",
    "vacuum_cleaner": "වැකුම් ක්ලීනර්",
    "gaming_consoles": "ක්රීඩා කොන්සෝල",
    "laptop": "ලැප්ටොප්",
    "cellular": "සෛලීය",
    "shop": "කඩේ",
    "restaurant_complex_cleaning": "අවන්හල් සංකීර්ණ පිරිසිදු කිරීම",
    "dining_room": "කැම කන කාමරය",
    "food_variety": "ආහාර විවිධත්වය",
    "quality_of_the_food": "ආහාරවල ගුණාත්මකභාවය",
    "amount_of_the_food": "ආහාර ප්රමාණය",
    "quality_of_cooking": "පිසීමේ ගුණාත්මකභාවය",
    "side_courses": "පැති පාඨමාලා",
    "meat": "මස්",
    "desserts": "අතුරුපස",
    "vegetarian": "නිර්මාංශ",
    "salad_bar": "සලාද බාර්",
    "main_courses": "ප්රධාන පාඨමාලා",
    "service": "සේවය",
    "dining_room_cleanliness": "කෑම කාමරයේ පිරිසිදුකම",
    "plates_and_cutlery_cleanliness": "තහඩු සහ හැඳි ගෑරුප්පු පිරිසිදුකම",
    "product_inventory": "නිෂ්පාදන ඉන්වෙන්ටරි",
    "furnishers": "ගෘහ භාණ්ඩ",
    "toilets": "වැසිකිළි",
    "problem_coffee_machine": "ගැටලුව කෝපි යන්ත්රය",
    "problem_water_bar": "ගැටළු ජල තීරුව",
    "dirty_stairs": "අපිරිසිදු පඩිපෙළ",
    "toiletries": "වැසිකිළි භාණ්ඩ",
    "fixed_soap_dispenser": "ස්ථාවර සබන් බෙදාහරින්නා",
    "fixed_paper_dispenser": "ස්ථාවර කඩදාසි බෙදාහරින්නා",
    "fixed_coffee_machine": "ස්ථාවර කෝපි යන්ත්රය",
    "fixed_water_bar": "ස්ථාවර ජල තීරුව",
    "problem_urinals": "ගැටළු මුත්රා",
    "blockage_toilet": "අවහිර වැසිකිළිය",
    "appliance_problem": "උපකරණ ගැටළුව",
    "problem_broken_door": "ගැටලුව කැඩුණු දොර",
    "problem_door_lock": "ගැටලුව දොර අගුල",
    "problem_broken_toilet_seat": "ගැටලුවක් කැඩුණු වැසිකිළි ආසනය",
    "problem_broken_niagara": "ගැටලුව බිඳුණු නයගරා",
    " broken_hand_paper_dispenser_hand_dryer": "කැඩුණු අත් කඩදාසි ඩිස්පෙන්සර් + අත් වියළනය",
    "rug": "පාපිසි",
    "tables": "වගු",
    "kitchen": "කුස්සිය",
    "air_condition": "වායු තත්ත්වය",
    "dirty_urinals": "අපිරිසිදු මුත්රා",
    "hand_dryer": "අත්_වියළනය",
    "non_sticky_carpet": "නොඇලෙන කාපට්",
    "problem_bad_smell": "ගැටලුව නරක සුවඳ",
    "problem_broken_toilet_handle": "ගැටලුව කැඩුණු වැසිකිළි හසුරුව",
    "problem_handle_door": "ගැටලුව හැසිරවීමේ දොර",
    "call_cleaner": "පිරිසිදු කරන්නා අමතන්න",
    "wall_painting": "බිත්ති පින්තාරු කිරීම",
    "missing_paper": "අතුරුදහන් කඩදාසි",
    "clean_surface": "පිරිසිදු මතුපිට",
    "problem_right_elevator": "ගැටලුව දකුණු සෝපානය",
    "problem_left_elevator": "වම් සෝපානයේ ගැටලුව",
    "missing_hand_sanitizer": "අත් සනීපාරක්ෂක යන්ත්‍රය අතුරුදහන්",
    "problem_sink_blockage": "ගැටළුව සින්ක් අවහිර වීම",
    "electric_problem": "විදුලි ගැටලුව",
    "missing_coffe_tea": "කෝපි තේ අතුරුදහන්",
    "problem_air_condition": "ගැටළු වායු සමීකරණය",
    "dishwashing": "පිඟන් සේදීම",
    "kitchen_cleanliness": "මුළුතැන්ගෙයි පිරිසිදුකම",
    "weekly_cleaning": "සතිපතා පිරිසිදු කිරීම",
    "general_arrangement": "සාමාන්ය සැකැස්ම",
    "meeting_room": "රැස්වීම් කාමරය",
    "refrigerator": "ශීතකරණය",
    "kitchen_supplies": "මුළුතැන්ගෙයි සැපයුම්",
    "toilet_services": "වැසිකිළි සේවා",
    "carousel_door": "කැරොසල් දොර",
    "desk": "මේසය",
    "compressor": "සම්පීඩකය",
    "compressor_rails": "සම්පීඩක රේල් පීලි",
    "compressor_drainage": "සම්පීඩක ජලාපවහනය",
    "dust": "දූවිලි",
    "door": "දොර",
    "scotch": "ස්කොච්",
    "food": "ආහාර",
    "room_conditions": "කාමර කොන්දේසි",
    "kindness_sensitivity": "කරුණාව සහ සංවේදීතාව",
    "explain_process": "ක්රියාවලිය පැහැදිලි කරන්න",
    "personal_attention": "පුද්ගලික අවධානය",
    "service_problem": "සේවා ගැටළුව",
    "welcome_you": "ඔබව සාදරයෙන් පිළිගනිමු",
    "invoice_submitted": "ඉන්වොයිසිය ඉදිරිපත් කර ඇත",
    "thank_you_bought": "ස්තුතියි මිලදී ගත්තා",
    "problem_seller": "ගැටළු විකුණන්නා",
    "lapel_pin": "උකුල පින්",
    "proper_performance": "නිසි කාර්ය සාධනය",
    "name_tag": "නම ටැගය",
    "operational": "මෙහෙයුම්",
    "app_revealed": "යෙදුම අනාවරණය විය",
    "register_load": "ලියාපදිංචි බර",
    "visibility_problem": "දෘශ්‍යතා ගැටළුව",
    "clean_storefront": "පිරිසිදු කඩඉම",
    "clean_garbage": "පිරිසිදු කුණු",
    "clean_tables_chairs": "පිරිසිදු මේස සහ පුටු",
    "clean_shop_floor": "පිරිසිදු සාප්පු බිම",
    "product_show": "නිෂ්පාදනයේ දැක්ම",
    "refrigerators_show": "ශීතකරණවල දර්ශනය",
    "coffee_accessories": "කෝපි උපාංග සහ සන්නද්ධ",
    "cleanliness": "පිරිසිදුකම",
    "convenience_scheduling_appointments": "හමුවීම් කාලසටහන් කිරීමේ පහසුව",
    "waiting_haircut": "කොණ්ඩය කැපීම සඳහා බලා සිටීම",
    "courtesy_books": "පොත් අනුග්රහයෙනි",
    "books_professionalism": "පොත්වල වෘත්තීයභාවය",
    "received_time": "වෙලාවට මාව ලැබුනා",
    "dnot_appointment": "මම හමුවීමක් කළේ නැහැ",
    "an_appointment": "මම හමුවීමක් කළා",
    "tasty": "රසවත්",
    "courtesy_service": "සේවාව අනුග්රහයෙනි",
    "overall_experience": "සමස්ත අත්දැකීම",
    "not_clean": "පිරිසිදු නැත",
    "diningroom_not_clean": "කෑම කාමරය පිරිසිදු නැත",
    "unclean_dishes": "අපිරිසිදු කෑම",
    "so-so": "එසේ-එසේ",
    "not_tasty": "රසවත් නොවේ",
    "kind": "කාරුණික",
    "not_kind": "කරුණාවන්ත නොවේ",
    "clean": "පිරිසිදු",
    "hairdresser": "කොණ්ඩා මෝස්තරකරු",
    "wrong_price": "වැරදි මිල",
    "produc_has_expired": "නිෂ්පාදනය කල් ඉකුත් වී ඇත",
    "missing_item": "නැතිවූ අයිතමය",
    "item_is_faulty_in_the_machine": "අයිතමය යන්ත්‍රයේ දෝෂ සහිතයි",
    "machine_cleaning": "යන්ත්රය පිරිසිදු කිරීම",
    "improper_temperature": "නුසුදුසු උෂ්ණත්වය",
    "green": "කොළ පාටයි",
    "orange": "දොඩම්",
    "red": "රතු",
    "yellow": "කහ",
    "red not prob": "red prob නොවේ",
    "professional": "වෘත්තීය",
    "unprofessional": "වෘත්තීය නොවන",
    "delicacies": "ප්රණීත ආහාර",
    "sandwiches": "සැන්ඩ්විච්",
    "vegetables": "එළවළු",
    "fruits": "පළතුරු",
    "salads": "සලාද",
    "milk": "කිරි",
    "room_link": "කාමර සබැඳිය",
    "floor_link": "බිම් සම්බන්ධකය",
    "services": "සේවා",
    "check_list": "පිරික්සුම් ලැයිස්තුව",
    "lighting_problem_lobby": "ආලෝකකරණ ගැටළු ලොබිය",
    "lighting_problem_garbage_room": "ආලෝක ගැටළුව කුණු කාමරය",
    "lighting_problem_stairwell": "ආලෝක ගැටළුව පඩිපෙළ",
    "problem_elevator_1": "ගැටළු සෝපානය 1",
    "problem_elevator_2": "ගැටළු සෝපානය 2",
    "problem_elevator_3": "ගැටළු සෝපානය 3",
    "problem_elevator_4": "ගැටළු සෝපානය 4",
    "problem_elevator_5": "ගැටළු සෝපානය 5",
    "problem_elevator_6": "ගැටළු සෝපානය 6",
    "problem_elevator_7": "ගැටළු සෝපානය 7",
    "problem_elevator_8": "ගැටළු සෝපානය 8",
    "problem_elevator_9": "ගැටළු සෝපානය 9",
    "problem_elevator_10": "ගැටළු සෝපානය 10",
    "stuck_item": "සිරවී ඇති අයිතමය",
    "spoiling_product": "නරක් නිෂ්පාදන",
    "machine_malfunction": "යන්ත්රය අක්රිය වීම",
    "unreadable_product": "කියවිය නොහැකි නිෂ්පාදනයක්",
    "i_am_satisfied": "මම සෑහීමකට පත් වෙනවා",
    "beverage": "බීම",
    "program_malfunction": "වැඩසටහනේ අක්රිය වීම",
    "machine_1": "යන්ත්‍රය 1",
    "machine_2": "යන්ත්‍රය 2",
    "machine_3": "යන්ත්‍රය 3",
    "machine_4": "යන්ත්‍රය 4",
    "program malfunction 1": "වැඩසටහනේ දෝෂ 1",
    "program malfunction 2": "වැඩසටහනේ දෝෂ 2",
    "program malfunction 3": "වැඩසටහනේ දෝෂ 3",
    "program malfunction 4": "වැඩසටහනේ දෝෂ 4",
    "fish": "මාළු",
    "chicken": "කුකුල් මස්",
    "full_dining_room": "සම්පූර්ණ කෑම කාමරය",
    "missing_amount": "නැතිවූ මුදල",
    "missing_trays": "නැති තැටි",
    "dirty_floor_g1": "අපිරිසිදු තට්ටුව g1",
    "dirty_floor_g2": "අපිරිසිදු තට්ටුව g2",
    "dirty_floor_g3": "අපිරිසිදු තට්ටුව g3",
    "dirty_floor_g4": "අපිරිසිදු තට්ටුව g4",
    "dirty_floor_g5": "අපිරිසිදු තට්ටුව g5",
    "dirty_floor_eo": "අපිරිසිදු බිම eo",
    "dirty_floor_ceo": "අපිරිසිදු මහලේ ප්‍රධාන විධායක නිලධාරියා",
    "dirty_floor_storage": "අපිරිසිදු බිම් ගබඩා",
    "dirty_floor_inflorescence": "අපිරිසිදු බිම් පුෂ්ප මංජරිය",
    "operating_instructions": "මෙහෙයුම් උපදෙස්",
    "general": "සාමාන්ය",
    "connection_problem": "සම්බන්ධතා ගැටළුව",
    "lighting": "ආලෝකය",
    "not _fixed": "සවි කර නැත",
    "cleaning_needed": "අවශ්ය පිරිසිදු කිරීම",
    "missing_milk": "නැති කිරි",
    "no_sugar_coffee": "සීනි / කෝපි නැත",
    "missing_tools": "අතුරුදහන් මෙවලම්",
    "coffee_water_machine": "කෝපි / වතුර යන්ත්රය",
    "appliances": "උපකරණ",
    "products": "නිෂ්පාදන",
    "broken_chair": "කැඩුණු ගෘහ භාණ්ඩ",
    "broken_cabinet": "කැඩුණු කැබිනට්",
    "micro": "ක්ෂුද්ර",
    "toaster": "ටෝස්ටර්",
    "clogged_sink_malfunction": "අවහිර වූ සින්ක් අක්රිය වීම",
    "coffee_cooling_malfunction": "කෝපි සිසිලන අක්රිය වීම",
    "no_coffee_beans": "කෝපි බෝංචි නැත",
    "machine_failure": "යන්ත්රය අසාර්ථක වීම",
    "that_dirty": "අපිරිසිදු බව",
    "dirty_refrigerator": "අපිරිසිදු ශීතකරණයක්",
    "dirty_tables": "අපිරිසිදු මේස",
    "plates": "තහඩු",
    "silver_spoon": "රිදී_හැන්ද",
    "cold_drinks_cups": "සිසිල් බීම කෝප්ප",
    "hot_drink_cups": "උණුසුම් බීම කෝප්ප",
    "a_dripping_faucet": "ගලා යන කරාමයක්",
    "disposable dishes": "ඉවත දැමිය හැකි කෑම වර්ග",
    "problem_ coffee_water_machine": "ගැටලුව කෝපි / ජල යන්ත්රය",
    "problem_micro": "ගැටළුව ක්ෂුද්ර",
    "problem_toaster": "ගැටලුව ටෝස්ටර්",
    "problem_machine_failure": "ගැටළුව යන්ත්රය අසමත් වීම",
    "problem refrigerator": "ගැටලුව ශීතකරණය",
    "no_sugar/coffee": "සීනි / කෝපි නැත",
    "missing_dishes": "නැති කෑම",
    "coffee/water_machine": "කෝපි / වතුර යන්ත්රය",
    "coffee_machine_door_open": "කෝපි යන්ත්රයේ දොර විවෘතයි",
    "coffee_machine_door_close": "කෝපි යන්ත්රයේ දොර වසා ඇත",
    "coffee_machine_bin_full": "කෝපි යන්ත්‍ර බඳුන පිරී ඇත",
    "coffee_machine_bin_empty": "කෝපි යන්ත්‍ර බඳුන හිස්",
    "coffee_machine_coffee_full": "කෝපි යන්ත්‍රය කෝපි පිරී ඇත",
    "coffee_machine_coffee_empty": "කෝපි යන්ත්‍රය කෝපි හිස්",
    "coffee_machine_water_tank_empty": "කෝපි යන්ත්‍ර ජල ටැංකිය හිස්",
    "coffee_machine_ water_tank_full": "කෝපි යන්ත්‍ර ජල ටැංකිය පිරී ඇත",
    "coffee_machine_milk_cleaning_not_performed": "කෝපි යන්ත්රය කිරි පිරිසිදු කිරීම සිදු නොකෙරේ",
    "coffee_machine _milk_cleaning_performed": "කෝපි යන්ත්රය කිරි පිරිසිදු කිරීම සිදු කරන ලදී",
    "coffee_machine_head_cleaning_not_performed": "කෝපි යන්ත්‍රයේ හිස පිරිසිදු කිරීම සිදු නොකෙරේ",
    "coffee_machine_head_ cleaning_performed": "කෝපි යන්ත්රය හිස පිරිසිදු කිරීම සිදු කරන ලදී",
    "coffee_machine_descaling_not_performed": "කෝපි යන්ත්‍රය ඉවත් කිරීම සිදු නොකෙරේ",
    "coffee_machine_descaling_performed": "කෝපි යන්ත්‍රය ඉවත් කිරීම සිදු කරන ලදී",
    "floor_one": "මහල 1",
    "floor_two": "මහල 2",
    "floor_three": "මහල 3",
    "floor_four": "මහල 4",
    "floor_five": "මහල 5",
    "floor_six": "මහල 6",
    "floor_seven": "මහල 7",
    "floor_eight": "මහල 8",
    "floor_nine": "මහල 9",
    "floor_ten": "10 වන මහල",
    "floor_eleven": "මහල 11",
    "floor_twelve": "මහල 12",
    "floor_thirteen": "මහල 13",
    "floor_fourteen": "මහල 14",
    "floor_fifteen": "මහල 15",
    "floor_sixteen": "මහල 16",
    "floor_seventeen": "මහල 17",
    "floor_eighteen": "මහල 18",
    "floor_nineteen": "මහල 19",
    "floor_twenty": "මහල 20",
    "floor_twenty_one": "මහල 21",
    "floor_twenty_two": "මහල 22",
    "floor_twenty_three": "මහල 23",
    "floor_twenty_four": "මහල 24",
    "floor_twenty_five": "මහල 25",
    "status_toilet_paper_cell_01_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 01 - හිස්",
    "status_toilet_paper_cell_02_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 02 - හිස්",
    "status_toilet_paper_cell_03_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 03 - හිස්",
    "status_toilet_paper_cell_04_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 04 - හිස්",
    "status_toilet_paper_cell_05_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටිය 05 - හිස්",
    "status_toilet_paper_cell_06_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 06 - හිස්",
    "status_toilet_paper_cell_07_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 07 - හිස්",
    "status_toilet_paper_cell_08_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 08 - හිස්",
    "status_toilet_paper_cell_09_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 09 - හිස්",
    "status_toilet_paper_cell_10_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 10 - හිස්",
    "status_toilet_paper_cell_11_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 11 - හිස්",
    "status_toilet_paper_cell_12_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 12 - හිස්",
    "status_toilet_paper_cell_13_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 13 - හිස්",
    "status_toilet_paper_cell_14_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 14 - හිස්",
    "status_toilet_paper_cell_15_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 15 - හිස්",
    "status_toilet_paper_cell_16_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 16 - හිස්",
    "status_toilet_paper_cell_17_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 17 - හිස්",
    "status_toilet_paper_cell_18_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 18 - හිස්",
    "status_toilet_paper_cell_19_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 19 - හිස්",
    "status_toilet_paper_cell_20_-_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 20 - හිස්",
    "status_toilet_paper_cell_01_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 01 - පාහේ හිස්",
    "status_toilet_paper_cell_02_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 02 - පාහේ හිස්",
    "status_toilet_paper_cell_03_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටිය 03 - පාහේ හිස්",
    "status_toilet_paper_cell_04_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 04 - පාහේ හිස්",
    "status_toilet_paper_cell_05_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 05 - පාහේ හිස්",
    "status_toilet_paper_cell_06_-_almost_empty": "තත්ත්වය වැසිකිලි කඩදාසි කුටි 06 - පාහේ හිස්",
    "status_toilet_paper_cell_07_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 07 - පාහේ හිස්",
    "status_toilet_paper_cell_08_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කුටි 08 - පාහේ හිස්",
    "status_toilet_paper_cell_09_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 09 - පාහේ හිස්",
    "status_toilet_paper_cell_10_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 10 - පාහේ හිස්",
    "status_toilet_paper_cell_11_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 11 - පාහේ හිස්",
    "status_toilet_paper_cell_12_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 12 - පාහේ හිස්",
    "status_toilet_paper_cell_13_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 13 - පාහේ හිස්",
    "status_toilet_paper_cell_14_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 14 - පාහේ හිස්",
    "status_toilet_paper_cell_15_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 15 - පාහේ හිස්",
    "status_toilet_paper_cell_16_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 16 - පාහේ හිස්",
    "status_toilet_paper_cell_17_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 17 - පාහේ හිස්",
    "status_toilet_paper_cell_18_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 18 - පාහේ හිස්",
    "status_toilet_paper_cell_19_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 19 - පාහේ හිස්",
    "status_toilet_paper_cell_20_-_almost_empty": "තත්ත්‍වය වැසිකිලි කඩදාසි කොටුව 20 - පාහේ හිස්",
    "of": "හි",
    "items": "අයිතම",
    "loading_charts": "ප්‍රස්ථාර පැටවීම",
    "refresh_the_room": "කාමරය නැවුම් කරන්න",
    "clean_the_floor": "බිම පිරිසිදු කරන්න",
    "clean_the_toilet": "වැසිකිළිය පිරිසිදු කරන්න",
    "refill_soap": "සබන් නැවත පුරවන්න",
    "change_roll": "රෝල් වෙනස් කරන්න",
    "great_job": "නියම වැඩක්",
    "empty_the_trash": "කුණු කූඩය හිස් කරන්න",
    "repair_required": "අලුත්වැඩියා කිරීම අවශ්ය වේ",
    "cleaning": "පිරිසිදු කිරීම",
    "cleaning_performed": "පිරිසිදු කිරීම සිදු කරන ලදී",
    "sinhala": "සිංහල"
  },
}

export const en = {
  ...serviks.en,
  "notified": "Notified",
  "supervisor_arrival": "Supervisor arrival",
  "arrival": "Arrival",
  "arrival_badges": "Shift arrivals",
  "visits_since_cleaned": "Visits since last cleaned",
  "visits_since_cleaned_short": "Since last clean",
  "filter": "Filter",
  "logo": "Logo",
  "counter": "Counter",
  "sms": "Sms",
  "shifts": "Shifts",
  "call": "Call",
  "openCalls": "Open calls",
  "callsHistory": "Calls history",
  "duration": "Duration",
  "time_start": "Time start",
  "settings": "Settings",
  "always": "Always",
  "off": "Off",
  "time_based": "Time Based",
  "location_based": "Location Based",
  "notification_mode": "Notification Mode",
  "notification_times": "Notification Times",
  "notification_times_info": "Time ranges are managed from the mobile app",
  "notification_location": "Notification Location",
  "notification_sound": "Notification Sound",
  "no_sound": "No Sound",
  "default_sound": "Default Sound",
  "soft_bell": "Soft Bell",
  "digital_sound": "Digital Sound",
  "mallet_sound": "Mallet Sound",
  "phone_sound": "Phone Sound",
  "text_sound": "Text Sound",
  "manager_alert_delay": "Manager Alert Delay",
  "snooze_interval": "Reminder",
  "vocal_notifications": "Vocal Notifications",
  "no_delay": "No Delay",
  "no_snooze": "No reminder",
  "lat": "Lat",
  "lon": "Lon",
  "radius": "Radius",
  "no_location_set": "No location set",
  "when_to_notify": "When to Notify",
  "notification_preferences": "Notification Preferences",
  "notification_health": "Notification Health",
  "notification_health_summary": "Summary",
  "notification_health_loading": "Checking notification health...",
  "notification_health_refresh": "Refresh",
  "notification_health_fix": "What to do",
  "notification_health_unavailable": "Could not load notification health",
  "notification_health_healthy": "Healthy",
  "notification_health_blocked": "Blocked",
  "notification_health_degraded": "Needs attention",
  "notification_health_no_app_user": "No app login",
  "notification_health_unknown": "Unknown",
  "notification_health_app_version": "App version",
  "notification_health_last_delivery": "Last delivery",
  "notification_settings_no_app_user": "This cleaner has not logged into the mobile app yet. Notification settings will appear after first login.",
  "assignment_configuration": "Assignment & Configuration",
  "status": "Status",
  "working_area": "Working area",
  "complaints_NC": "Complaints / NC",
  "SLA_NC": "SLA / NC",
  "arrivals_NC": "Arrivals / NC",
  "staff": "Staff",
  "cleaning_complaints": "Cleaning complaints",
  "export": "Export",
  "maintenance_complaints": "Maintenance complaints",
  "maintenanceArrivals": "Maintenance arrivals",
  "maintenance_arrivals": "Maintenance arrivals",
  "last": "Last",
  "survey_name": "Survey name",
  "survey": "Survey",
  "pad_survey": "Pad survey",
  "pad_no_maintenance_survey": "Pad no maintenance survey",
  "pad_kitchen": "Pad kitchen",
  "number_of_assigned_devices": "# assigned devices",
  "number_of_pages": "# of pages",
  "date_created": "Date created",
  "updated_by": "Updated by",
  "date_updated": "Date updated",
  "search": "Search",
  "choose_type": "Choose type",
  "permitted_sites": "Permitted sites",
  "permitted_franchise": "Permitted franchise",
  "permitted_companies": "Permitted companies",
  "panel_permitted": "Panel permitted",
  "end_time": "End time",
  "last_update": "Last update",
  "add_device": "Add device",
  "detailed": "Detailed",
  "analysis": "Analysis",
  "suggestion": "Suggestion",
  "country": "Country",
  "management": "Management",
  "device": "Device",
  "mapping": "Mapping",
  "please_enter": "Please enter",
  "new_device": "New device",
  "assign_device": "Assign device",
  "installSpot": "Installation spot",
  "device_type": "Device type",
  "deviceCode": "Device code",
  "device_code": "Device code",
  "scan_or_enter_device_code": "Scan or enter device code...",
  "scan_device": "Assign",
  "scan_qr_in_frame": "Align the QR code in the frame. For small codes, hold 15–25 cm away and tap the preview to refocus if blurry.",
  "checking_device_code": "Checking device code...",
  "camera_not_available": "Camera not available. You can type the code manually.",
  "device_code_already_exists": "This device code is already assigned to another sensor.",
  "assigned_to_company_site_room": "Already assigned to {company} / {site} / {room}",
  "device_code_lookup_failed": "Could not verify device code. Please try again.",
  "device_code_no_site_access": "This code is already registered on a site you cannot access.",
  "device_code_check_unavailable": "The server could not check this code. Try again.",
  "device_code_not_a_code": "The scan read \"{code}\". Enter the device code itself.",
  "device_code_open_failed": "Could not open this device. Try again.",
  "device_code_save_failed": "The device code could not be saved. Try again.",
  "device_code_save_forbidden": "You cannot change this device.",
  "confirm_replace_device_code": "Replace device code?",
  "confirm_replace_device_code_body": "Are you sure you want to replace device code {oldCode} with {newCode}?",
  "room": "Room",
  "edit_room": "Edit room",
  "edit_franchise": "Edit franchise",
  "new_franchise": "New franchise",
  "desc": "Description",
  "address": "Address",
  "level": "Level",
  "no_companies_to_show": "No companies to show",
  "company_type": "Company type",
  "region": "Region",
  "new_company": "New company",
  "edit_company": "Edit company",
  "edit_user": "Edit user",
  "C.arrivals": "Cleaner arrived",
  "C.complaints": "Cleaning complaint",
  "M.complaints": "Maintenance complaints",
  "M.Arrivals": "Maintenance arrivals",
  "analyses": "Analyses",
  "clean_log": "Clean log",
  "maintenance_log": "Maintenance log",
  "like": "Like",
  "likes": "Likes",
  "new_user": "New user",
  "shift_parameters": "Shift parameter",
  "add_shift": "New shift",
  "edit_shift": "Edit shift",
  "username": "Username",
  "first_name": "First name",
  "job_function": "Role",
  "role": "Role",
  "property_manager": "Property Manager",
  "facility_manager": "Facility Manager",
  "site_manager": "Site Manager",
  "workplace_manager": "Workplace Manager/Lead",
  "cleaning_company_ceo": "Cleaning Company CEO",
  "operations_manager": "Operations Manager",
  "area_manager": "Area Manager",
  "site_cleaning_manager": "Site Cleaning Manager",
  "cleaning_supervisor": "Cleaning Supervisor",
  "other": "Other",
  "restroom_cleaner": "Restroom Cleaner",
  "general_cleaner": "General Cleaner",
  "day_porter": "Day Porter",
  "office_cleaner": "Office Cleaner",
  "public_area_cleaner": "Public Area Cleaner",
  "firstName": "First name",
  "description": "Description",
  "last_name": "Last name",
  "lastName": "Last name",
  "phone": "Phone",
  "building_area": "Building area",
  "users": "Users",
  "add_user": "Add user",
  "sites": "Sites",
  "new_site": "New site",
  "edit_site": "Edit site",
  "add_company": "Add company",
  "franchise": "Franchise",
  "floor": "Floor",
  "building": "Building",
  "humidity": "Humidity",
  "humidity_abbr": "Humid",
  "temperature": "Temperature",
  "temperature_abbr": "Temp",
  "gender": "Room type",
  "display_name": "Name",
  "zone": "Zone",
  "shift_number": "Shift#",
  "shift": "Shift",
  "shift_name": "Shift name",
  "shift_currently_inactive": "Currently inactive shift",
  "local_time": "Local",
  "end": "End",
  "min_sla": "Min SLA",
  "max_sla": "Max SLA",
  "days": "Days",
  "complaints_percent": "% Complaints",
  "sla_percent": "% SLA",
  "arrivals_percent": "% Arrivals",
  "save_arrivals": "Save",
  "clean_time": "Clean time (min)",
  "tooltip_shift_number": "Display order of this shift (e.g. 1, 2).",
  "tooltip_shift_name": "Name of the shift (e.g. Morning, Night).",
  "tooltip_start_time": "Shift start time in local time.",
  "tooltip_end_time": "Shift end time in local time.",
  "tooltip_cleaners_number": "Number of cleaners on this shift.",
  "tooltip_min_sla": "Best response time (minutes) to handle a room complaint; used as the lower bound for the score.",
  "tooltip_max_sla": "Max acceptable response time (minutes) to handle a room complaint; used as the upper bound for the score.",
  "tooltip_arrivals": "Expected cleaner arrivals per room per day; the score compares actual arrivals to this target.",
  "tooltip_save_arrivals": "Cleaner visits per room per day before BuzzzTV; used to calculate time saved (fewer visits now = minutes saved).",
  "tooltip_clean_time": "Minutes counted per cleaner visit in the time-saved calculation (e.g. 15).",
  "tooltip_complaints_percent": "Weight of complaints in the room score when the room has visits (higher = complaints affect the score more).",
  "tooltip_response_time_SLA": "Weight of response time in the room score when the room has visits (higher = faster response matters more).",
  "tooltip_arrivals_percent": "Weight of arrivals vs target in the room score when the room has visits.",
  "tooltip_complaints_NC": "Weight of complaints in the score when the room has no visits (no counter).",
  "tooltip_SLA_NC": "Weight of response time in the score when the room has no visits.",
  "tooltip_arrivals_NC": "Weight of arrivals in the score when the room has no visits.",
  "tooltip_days": "Days of the week when this shift is active.",
  "tooltip_active_calculation": "When enabled, this shift is included in scores and time-saved calculations.",
  "auto_close_complaints_hour": "Auto-close complaints hour",
  "tooltip_auto_close_complaints_hour": "Local hour at which open complaint SLAs in this shift are automatically closed. Leave empty to disable.",
  "auto_close_maintenance_complaints_hour": "Auto-close maintenance complaints hour",
  "tooltip_auto_close_maintenance_complaints_hour": "Local hour at which open maintenance complaint SLAs in this shift are automatically closed. Leave empty to disable.",
  "no_auto_close": "-- None --",
  "tooltip_shift_rooms": "Rooms assigned to this shift. Leave empty for a site-level shift.",
  "company_name": "Company name",
  "site_name": "Site name",
  "site_desc": "Site description",
  "service_provider_name": "Service provider",
  "service_provider_type": "Service provider type",
  "service_provider_desc": "Service provider description",
  "user": "User",
  "map": "Map",
  "delete": "Delete",
  "new_room": "New room",
  "issue_times": "Issue times",
  "solved": "Solved",
  "visits": "Visits",
  "visits_also_went_up": "Visits also went up",

  "complaints": "Complaints",
  "complaints_in_shift": "Complaints this shift",
  "cleaner_arrivals": "Cleaner arrivals",
  "unnecessary_arrivals": "No-call arrivals",
  "unnecessary_arrivals_hint": "A cleaner visit while no call was open in the room.",
  "of_arrivals": "of arrivals",
  "per_working_day": "per working day",
  "per_working_day_count": "per working day ({count} days)",
  "arrivals_per_day_suffix": "/day",
  "hour_values_total": "Total",
  "hour_values_per_day": "Per day",
  "response_time_SLA": "Response time",
  "score": "Score",
  "avg_score": "Avg score",
  "score_goal": "Score goal",
  "top_problem_issues": "Top issues",
  "top_problem_rooms": "Top rooms",
  "top_problem_hours": "Top hours",
  "is_time_save": "Time saved",
  "options": "Options",
  "send_battery_alerts": "Send battery alerts",
  "environment_alerts": "Environment alerts",
  "environment_alerts_description": "Send email alerts when temperature or humidity leaves the allowed range",
  "environment_alert_emails": "Environment alert emails",
  "offline_alerts": "Device offline alerts",
  "offline_alerts_description": "Send email alerts when a pad or tablet goes offline",
  "offline_alert_emails": "Offline alert emails",
  "offline_alert_emails_invalid": "One or more offline alert email addresses are invalid",
  "temperature_min": "Temperature min",
  "temperature_max": "Temperature max",
  "humidity_min": "Humidity min",
  "humidity_max": "Humidity max",
  "environment_alert_range_invalid": "Environment alert ranges must be numeric and min must be less than or equal to max",
  "coming_soon": "Coming Soon",
  "alert_emails": "Alert emails",
  "alert_emails_placeholder": "Enter email address",
  "alert_language": "Alert Language",
  "select_language": "Select language",
  "invalid_email_format": "One or more email addresses are invalid",
  "add_email": "Add another email",
  "next": "Next",
  "back": "Back",
  "basic_information": "Basic Information",
  "service_providers": "Service Providers",
  "settings_alerts": "Settings & Alerts",
  "configuration": "Configuration",
  "contact_settings": "Contact & Settings",
  "notifications": "Notifications",
  "features": "Features",
  "battery_alerts": "Battery Alerts",
  "alerts_title": "Alerts",
  "location": "Location",
  "time_save_description": "Enable time saving features",
  "exposures_description": "Track non exposure data",
  "alerts_description": "Device information alerts",
  "shift_description": "Create default shifts",
  "battery_alerts_description": "Send email alerts for low battery",
  "est_ROI": "Est ROI",
  "complaints_vs_visits": "Complaints vs Visits",
  "view_by_years": "View years",
  "view_by_months": "View months",
  "view_by_weeks": "View weeks",
  "view_by_days": "View days",
  "minutes": "Min",
  "company": "Company",
  "site": "Site",
  "alerts": "Devices info",
  "performance": "Performance",
  "devices": "Devices",
  "total_devices": "Total Devices",
  "working": "Working",
  "warning": "Warning",
  "by_device_type": "By Device Type",
  "surveys": "Surveys",
  "real_time": "Real time",
  "real-time": "Real time",
  "cleaner-activity": "Cleaner Activity",
  "device-actions": "Device actions",
  "pad-presence-testing": "Pad presence testing",
  "real-time-cleaning": "Real time - cleaning",
  "real-time-maintenance": "Real time - maintenance",
  "no_real_time_tabs_permitted": "You don't have permission to view any real-time tab",
  "admin": "Admin",
  "all": "All",
  "overview": "Overview",
  "exit_full_screen": "Exit full screen",
  "full_screen": "Full screen",
  "total": "Total",
  "analytics": "Analytics",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Communication",
  "overview_complaints_devices_caption": "Devices installed (cumulative)",
  "overview_complaints_devices_caption_hint": "Total number of devices installed at the site through the end of each month, based on installation dates.",
  "overview_complaints_devices_toggle_aria": "Show or hide devices installed under the complaints chart",
  "dashboard_customize": "Customize",
  "dashboard_save_layout": "Save layout",
  "dashboard_cancel_edit": "Cancel",
  "dashboard_reset_default": "Reset to default",
  "dashboard_add_widget": "Add widget",
  "dashboard_widget_unavailable": "Not available for this site",
  "dashboard_widget_line_chart": "Line chart",
  "dashboard_widget_room_table": "Room table",
  "dashboard_widget_donuts": "Donut chart",
  "dashboard_widget_kpi_bar": "KPI card",
  "dashboard_config_metric": "Metric",
  "dashboard_config_time_range": "Time range",
  "dashboard_config_view_mode": "View mode",
  "dashboard_config_donut": "Donut",
  "dashboard_config_kpi": "KPI",
  "dashboard_remove_widget": "Remove widget",
  "dashboard_drag_handle": "Drag to move widget",
  "dashboard_widget_settings": "Widget settings",
  "dashboard_configure": "Configure",
  "dashboard_edit_hint": "Drag to move, use corners to resize",
  "dashboard_dismiss_hint": "Dismiss",
  "dashboard_category_charts": "Charts",
  "dashboard_category_tables": "Tables",
  "dashboard_category_kpis": "KPIs",
  "dashboard_widget_line_chart_desc": "Trend line for a selected metric",
  "dashboard_widget_room_table_desc": "Room scores and real-time status",
  "dashboard_widget_donuts_desc": "Analytics breakdown donut chart",
  "dashboard_widget_kpi_bar_desc": "Single KPI summary card",
  "dashboard_no_data": "No data",
  "dashboard_layout_saved": "Dashboard layout saved",
  "dashboard_layout_save_failed": "Failed to save dashboard layout",
  "communication_select_site_title": "Choose a site",
  "communication_select_site": "Select a company and site from the filters above to view and add notes for that location.",
  "communication_viewing_site": "Viewing",
  "communication_add_note": "Add a note",
  "communication_add_note_open_aria": "Open add note dialog",
  "communication_form_hint": "Share updates or notes with everyone who has access to this site. They'll see new notes in real time.",
  "communication_page_intro_title": "Site notes — shared log for this location",
  "communication_page_intro_body": "Use this page to leave handoffs, issues, updates, and meeting notes for your team. Everyone who can open this site in the portal can read and add notes.",
  "communication_page_intro_dismiss": "Hide this tip",
  "communication_page_intro_aria": "About site notes",
  "communication_content_placeholder": "Write your note here...",
  "communication_keyboard_hint": "Ctrl+Enter to post",
  "communication_submitting": "Posting...",
  "communication_submit": "Post note",
  "communication_recent_notes": "Notes",
  "communication_search_placeholder": "Search by author or text...",
  "communication_refresh": "Refresh",
  "communication_clear_filters": "Clear filters",
  "communication_search_aria_label": "Search notes",
  "communication_submit_aria_label": "Post note",
  "communication_copy_note_aria_label": "Copy note text",
  "communication_copied": "Copied to clipboard.",
  "communication_copy_empty": "There is no note text to copy.",
  "communication_filter_hidden_one": "(1 note hidden by filters)",
  "communication_filter_hidden_many": "({n} notes hidden by filters)",
  "communication_request_timeout": "Request timed out. Please try again.",
  "communication_load_failed": "Could not load notes.",
  "communication_retry": "Try again",
  "communication_no_matches": "No notes match your search or filters. Try adjusting them.",
  "communication_no_entries": "No notes yet.",
  "communication_no_entries_hint": "Add a note above to get started.",
  "communication_just_now": "Just now",
  "communication_minutes_ago": "{n} min ago",
  "communication_hours_ago": "{n} hr ago",
  "communication_days_ago": "{n} days ago",
  "communication_note_posted": "Note posted.",
  "communication_post_failed": "Could not post note. Please try again.",
  "communication_note_type": "Note type",
  "communication_type_general": "General",
  "communication_type_update": "Update",
  "communication_type_issue": "Issue",
  "communication_type_follow_up": "Follow-up",
  "communication_type_meeting": "Meeting note",
  "communication_filter_all_types": "All types",
  "communication_pinned": "Pinned",
  "communication_pin": "Pin",
  "communication_unpin": "Unpin",
  "communication_pin_limit": "Max 2 pinned",
  "communication_pinned_toast": "Note pinned.",
  "communication_unpinned_toast": "Note unpinned.",
  "communication_pin_failed": "Could not update pin. Please try again.",
  "communication_note_not_found": "Note not found or you don't have access.",
  "communication_site_not_in_filters": "This note’s site is not in your current filters. You may not have access to that location.",
  "communication_edit": "Edit",
  "communication_delete": "Delete",
  "communication_save": "Save",
  "communication_cancel": "Cancel",
  "communication_saving": "Saving...",
  "communication_note_updated": "Note updated.",
  "communication_update_failed": "Failed to update note. Please try again.",
  "communication_delete_confirm": "Are you sure you want to delete this note? This action cannot be undone.",
  "communication_delete_confirm_title": "Delete Note",
  "communication_note_preview": "Note preview:",
  "communication_note_deleted": "Note deleted.",
  "communication_delete_failed": "Failed to delete note. Please try again.",
  "communication_edited": "Edited",
  "communication_show_more": "Show more",
  "communication_show_less": "Show less",
  "communication_sort_date_newest": "Newest first",
  "communication_sort_date_oldest": "Oldest first",
  "communication_sort_author": "By author",
  "communication_sort_type": "By type",
  "communication_sort_pinned": "Pinned first",
  "communication_sort_label": "Sort",
  "communication_filter_by_type": "Type",
  "communication_filters_group_aria": "Filter and sort notes",
  "communication_search_label_short": "Search",
  "employees": "Employees",
  "last_time_of_arrival": "Last time of arrival",
  "arrival_and_status": "Arrival & Status",
  "preview_arrivals": "Preview arrivals",
  "men toilet": "Men's restroom",
  "women toilet": "Women's restroom",
  "shared toilet": "Shared restroom",
  "unisex restroom": "Unisex restroom",
  "handicapped toilet": "Accessible restroom",
  "logistics": "Logistics",
  "cubicle": "Cubicle",
  "gym": "Gym",
  monthMap: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  },
  weekMap: {
    1: 'Sunday',
    2: 'Monday',
    3: 'Tuesday',
    4: 'Wednesday',
    5: 'Thursday',
    6: 'Friday',
    7: 'Saturday',
  },
  "dayOfWeek": "Days",
  "service_log": "Service log",
  "rooms": "Rooms",
  "bulk_add_rooms": "Bulk add rooms",
  "adding_to": "Adding to",
  "add_rooms": "Add rooms",
  "room_names_one_per_line": "Room names (one per line)",
  "enter_at_least_one_room": "Enter at least one room name",
  "room_names_placeholder": "Room 1\nRoom 2\nWomen toilet",
  "rooms_with_prefix": "rooms with prefix",
  "apply_to_all_rooms": "Apply to all rooms (optional)",
  "bulk_rooms_intro": "Add one or more groups. Each group has its own building, floor, zone, gender and room names.",
  "group": "Group",
  "add_group": "+ Add another group",
  "adding_rooms": "Adding rooms...",
  "bulk_summary": "Summary",
  "in": "in",
  "bulk_rooms_success": "{n} rooms added successfully",
  "displayName": "Room name",
  "SLA": "SLA",
  "supervisors": "Supervisors",
  "supervisor": "Supervisor",
  "performance_analytics": "Performance analytics",
  "arrivals": "Cleaner arrivals",
  "inspections": "Inspections",
  "avgResponseTime": "Avg response time",
  "missedSla": "Missed Sla",
  "cleaner_arrived": "Cleaner arrived",
  "load_more": "Load more",
  "login": "Login",
  "email": "Email",
  "emails": "Emails",
  "password": "Password",
  "min": "Min",
  "Logout": "Logout",
  "time_range": "Time range",
  "select_time_range": "Select time range",
  "custom_time": "Choose dates",
  "last_day": "Yesterday",
  "last_week": "Last 7 days",
  "last_month": "Last 30 days",
  "last_quarter": "Last 90 days",
  "last_6_months": "Last 6 months",
  "last_year": "Last 365 days",
  "data_by_hour": "Data by hour",
  "general": "General",
  "cleaning": "Cleaning",
  "maintenance": "Maintenance",
  "start": "Start",
  "start_time": "Start time",
  "management_co": "Management company",
  "cleaning_co": "Cleaning company",
  "companies": "Companies",
  "name": "Name",
  "site_count": "site #",
  "associated_companies": "Associated end clients",
  "OK": "OK",
  "cancel": "Cancel",
  "client": "Client",
  "dates": "Dates",
  "shift": "Shift",
  "issue": "Issue",
  "time": "Time",
  "top complaint of the week": "Top complaint of the week",
  "top room of the week": "Top room of the week",
  "top hour of the week": "Top hour of the week",
  "top complaint of the month": "Top complaint of the month",
  "top room of the month": "Top room of the month",
  "top hour of the month": "Top hour of the month",
  "franchises": "Franchises",
  "add_franchise": "Add franchise",
  "room_names": "Room name",
  "type": "Type",
  "please_select_company_site": "Please select a company & site",
  "number": "Number",
  "create_building_map": "Create building map",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Hey quickest way to add floors and rooms to a buildings via this quick wizard",
  "avg number of toilets per floor": "Avg number of toilets per floor",
  "avg.number of toilet cells per room": "Avg.number of toilet cells per room",
  "number of floors": "Number of floors",
  "avg.number of disabled toilets": "Avg.number of disabled toilets",
  "avg.number of soap dispensers": "Avg.number of soap dispensers",
  "reset_filter": "Reset filter",
  "add": "Add",
  "new_survey": "New survey",
  "api_configuration": "API configuration",
  "please_edit_the_api_information": "Please edit the API information",
  "method": "Method",
  "authorization": "Authorization",
  "api_url": "API_url",
  "token": "Token",
  "endpoint": "Endpoint",
  "add_url": "Add URL",
  "remove": "Remove",
  "format": "Format",
  "auth_api_key": "API key",
  "auth_dynamic_key": "Dynamic key (GET)",
  "auth_login_token": "Login token (HTTP)",
  "dynamic_token_url": "Token URL (GET)",
  "token_response_field_name": "Token field in response",
  "token_login_url": "Login URL",
  "login_request_method": "Login request method",
  "login_request_body": "Login request body (JSON)",
  "login_token_placeholder_hint": "Optional: secret used to replace {{token}} in the login body JSON",
  "token_response_key": "Access token field name",
  "survey_api_auth_header_name": "Auth header name (optional)",
  "survey_api_auth_header_prefix": "Text before the token in that header",
  "survey_api_auth_header_name_placeholder": "e.g. Authorization, X-Api-Key",
  "survey_api_auth_header_prefix_placeholder": "e.g. Bearer — final header is: prefix + space + token",
  "api_request_info": "API request info",
  "roomName": "Room name",
  "servikName": "Complaint name",
  "siteName": "Site name",
  "stage": "Stage",
  "number_of_buttons": "Number of buttons",
  "button_shape": "Button shape",
  "delay_time_stage": "Delay time stage",
  "go_to_stage": "Go to stage",
  "color": "Color",
  "add_stage": "Add stage",
  "save": "Save",
  "number_of_issues": "number of issues",
  "online": "Online",
  "offline": "Offline",
  "offline_devices": "Offline Devices",
  "no_offline_devices": "No offline devices found",
  "working_devices": "Working Devices",
  "no_working_devices": "No working devices found",
  "room_name": "Room name",
  "installation_spot": "Spot",
  "device_id": "Device id",
  "date": "Date",
  "status": "Status",
  "device_status": "Device status",
  "none": "none",
  "no_surveys_created": "No surveys created",
  "dashboard": "Dashboard",
  "franchise_name": "Franchise name",
  "franchise_country": "Franchise country",
  "choose_franchise": "Choose franchise",
  "choose_country": "Choose country",
  "select_template": "Select template",
  "default_survey": "Default survey",
  "cleaning_survey": "Cleaning survey",
  "kitchen_survey": "Kitchen survey",
  "template": "Template",
  "area_name": "Area name",
  "rooms_names": "Rooms names",
  "rooms_number": "Rooms #",
  "assign_number": "Assign #",
  "active_notification_task": "Active notification task",
  "amount_limit": "Counter interval",
  "after_max": "Counter after Max",
  "new_area": "New area",
  "edit_area": "Edit area",
  "tablet": "Tablet",
  "counter women": "Counter women",
  "counter men": "Counter man",
  "counter handicap": "Counter handicap",
  "counter man/woman": "Counter man / woman",
  "counter man / woman": "Counter man / woman",
  "sensor liquid": "Sensor liquid",
  "double toilet paper": "Double toilet paper",
  "toilet paper": "Toilet paper",
  "tag": "Tag",
  "qr tag": "QR Tag",
  "additional_info": "Additional info",
  "servikCategory": "Call type",
  "dishwashing": "Dishwashing",
  "cafeteria": "Cafeteria",
  "clean room": "Clean room",
  "office": "Office",
  "meeting room": "Meeting room",
  "cubic": "Cubic",
  "women": "Women",
  "men": "Men",
  "handicap": "Handicap",
  "Combined": "Combined",
  "kitchen": "Kitchen",
  "east": "East",
  "west": "West",
  "north": "North",
  "south": "South",
  "right": "Right",
  "left": "Left",
  "center": "Center",
  "up": "Up",
  "down": "Down",
  "combined": "Combined",
  "lobby": "Lobby",
  "entrance": "Entrance",
  "reception": "Reception",
  "area": "Area",
  "mezzanine": "Mezzanine",
  "gallery": "Gallery",
  "ground": "Ground",
  "elevator": "Elevator",
  "is_calculated": "Calculated room",
  "calculated_room": "Calculated room",
  "splitted_survey": "Splitted survey",
  "redirect_to_url": "Redirect to url",
  "survey_site": "Survey site",
  "clicks": "Clicks",
  "add_stage_number_to_signal": "Attach stage number",
  "including_pad9": "Including pad9",
  "room_type_required": "Please select a room type for every group",
  "Tech Manufacturers": "Tech Manufacturers",
  "Tech Offices": "Tech Offices",
  "Offices": "Offices",
  "Terminal": "Terminal",
  "Universities": "Universities",
  "Factories": "Factories",
  "Hospital": "Hospital",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Convenience Stores",
  "Food Chains": "Food Chains",
  "Residential": "Residential",
  "Shopping Center": "Shopping Center",
  "Survey": "Survey",
  "Demo": "Demo",
  "Vision": "Vision",
  "Court": "Court",
  "Office Management": "Office Management",
  "Government Office": "Government Office",
  "default_name": "Name in english",
  "exposures": "Clean exposure",
  "exposures_tab": "Room Activity",
  "cleaner_activity": "Cleaner Activity",
  "pad_presence_testing": "Pad presence testing",
  "pad_presence_testing_subtitle": "Live enter, exit, and phone-relayed offline pad presses for the selected site",
  "pad_presence_timeline": "Live timeline",
  "pad_presence_sessions": "Presence sessions",
  "pad_presence_offline_presses": "Offline presses from phones",
  "pad_presence_select_site_hint": "Select a company and site in the header to watch presence events.",
  "pad_presence_no_events": "No presence events in this window.",
  "pad_presence_open": "Open",
  "pad_presence_exit_phone": "Phone exit",
  "pad_presence_exit_auto": "Auto exit",
  "pad_presence_exit_stale": "Stale exit",
  "pad_presence_enter": "Enter",
  "pad_presence_exit": "Exit",
  "pad_presence_offline": "Offline press",
  "pad_presence_faulty": "Faulty",
  "pad_presence_employee": "Employee",
  "pad_presence_room": "Room",
  "pad_presence_time_from": "From",
  "pad_presence_last_updated": "Updated",
  "pad_presence_duration": "Duration",
  "pad_presence_exit_type": "Exit type",
  "pad_presence_button": "Button",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Count",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "All employees",
  "pad_presence_all_rooms": "All rooms",
  "pad_presence_load_error": "Could not load pad presence data.",
  "pad_presence_in_room_now": "In a room now",
  "pad_presence_in_room": "in",
  "pad_presence_since": "since",
  "pad_presence_just_now": "Just now",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Phone",
  "pad_presence_all_phones": "All phones",
  "pad_presence_window": "Show",
  "pad_presence_window_hour": "Last hour",
  "pad_presence_window_today": "Today",
  "pad_presence_window_month": "Last month",
  "pad_presence_pads": "Pads in this site",
  "pad_presence_no_pads": "No pads are assigned to rooms on this site.",
  "pad_presence_last_enter": "Last enter",
  "pad_presence_last_offline": "Last offline press",
  "pad_presence_auto_exit_leave": "Leave now → auto-exit in",
  "pad_presence_auto_exit_earliest": "Earliest from enter:",
  "pad_presence_auto_exit_passed": "Earliest auto-exit passed. Still open = pad still heard, or leave and wait 5m 45s.",
  "cleaner_activity_live_footer": "Data updates in real time",
  "ca_empty_select_site_hint": "Select a company and site in the header to view cleaner activity for today.",
  "ca_empty_no_cleaners_hint": "No cleaners are assigned to this site and the current shift. Assign active sites and shifts in Users.",
  "ca_empty_access_denied": "Access denied",
  "ca_empty_access_denied_hint": "You don't have permission to view cleaner activity for this site.",
  "ca_empty_load_error_hint": "Could not load cleaner activity. Please try again or contact support if the problem continues.",
  "ca_empty_no_filter_match": "No cleaners match these filters",
  "ca_empty_no_filter_match_hint": "Try clearing the filters or choosing a different cleaner, working area, or room.",
  "ca_timeline_all_cleaners": "Today's activity — all cleaners",
  "ca_legend_work": "Active",
  "ca_clock_sessions_more": "more",
  "ca_clock_sessions_less": "Show less",
  "ca_sort_label": "Sort",
  "ca_sort_needs_attention": "Needs attention",
  "ca_sort_best_avg_response": "Best avg response",
  "ca_sort_worst_avg_response": "Worst avg response",
  "ca_sort_most_sla_breaches": "Most SLA breaches",
  "ca_sort_most_open_complaints": "Most open complaints",
  "ca_sort_most_work_time": "Most work time",
  "ca_sort_least_work_time": "Least work time",
  "ca_stat_avg_short": "avg",
  "ca_stat_open_short": "open",
  "ca_stat_breach_short": "breach",
  "ca_stat_work_short": "work",
  "ca_assigned_room_avg_hint": "Avg response for assigned rooms today",
  "ca_transit_tooltip": "Transit time between tasks",
  "ca_transit_live_tooltip": "Time since last task closed",
  "ca_legend_visits": "Visits between calls",
  "ca_visits_between_sla": "Visits since previous call closed",
  "ca_apply": "Apply",
  "ca_visits_since": "since",
  "ca_deferred_tip_title": "Deferred complaint",
  "ca_deferred_tip_resolved": "Resolved",
  "ca_deferred_tip_desc_open": "Still open — the cleaner serviced other rooms first instead of this one.",
  "ca_deferred_tip_desc_closed": "This complaint stayed open while the cleaner serviced other rooms first.",
  "ca_deferred_tip_rooms_label": "Serviced first:",
  "ca_attention_title": "Needs attention",
  "ca_attention_empty": "All clear — no issues right now",
  "ca_attention_sla_breach_one": "{name} · SLA breached",
  "ca_attention_sla_breach_many": "{name} · {count} SLA breaches",
  "ca_attention_open_while_out_one": "{name} · open complaint while clocked out",
  "ca_attention_open_while_out_many": "{name} · {count} open while clocked out",
  "ca_attention_idle": "{name} · idle {duration}",
  "ca_attention_late": "{name} · clocked in late",
  "ca_attention_show": "Show",
  "ca_attention_hide": "Hide",
  "ca_view_shift": "Shift",
  "ca_view_history": "History",
  "ca_hist_preset_this_month": "This month",
  "ca_hist_preset_last_month": "Last month",
  "ca_hist_preset_this_week": "This week",
  "ca_hist_preset_last_week": "Last week",
  "ca_hist_preset_custom": "Custom",
  "ca_hist_from": "From",
  "ca_hist_to": "To",
  "ca_hist_people_count": "{count} employees",
  "ca_filters_done": "Done",
  "ca_hist_range_too_long": "Range can be at most {max} days",
  "ca_hist_range_invalid": "Start date must be before end date",
  "ca_hist_search": "Search name or phone",
  "ca_hist_kpi_days": "Days worked",
  "ca_hist_kpi_net": "Net hours",
  "ca_hist_kpi_breaks": "Breaks",
  "ca_hist_empty": "No attendance in this period",
  "ca_hist_empty_hint": "Nobody clocked in at this site and no cleaners are assigned to it.",
  "ca_hist_no_match": "No employees match the filters",
  "ca_hist_load_error_hint": "The attendance history could not be loaded. Try again in a moment.",
  "ca_hist_col_person": "Employee",
  "ca_hist_col_total": "Total hours",
  "ca_hist_col_total_tip": "Clock-in to clock-out before breaks, the same figure the employee sees in the app",
  "ca_hist_col_net": "Net hours",
  "ca_hist_col_breaks": "Breaks",
  "ca_hist_col_issues": "Issues",
  "ca_hist_col_late": "Late",
  "ca_hist_col_missed": "Missed",
  "ca_hist_col_no_clock_out": "No clock-out",
  "ca_hist_unknown_name": "Unknown",
  "ca_hist_not_assigned": "Not assigned to this site",
  "ca_hist_no_shift": "No shift assigned",
  "ca_hist_clocked_in_now": "Clocked in now",
  "ca_hist_auto": "auto",
  "ca_hist_late_by": "Late {duration}",
  "ca_hist_late_tip": "Clocked in {time}, {shift} starts {start}",
  "ca_hist_missed": "Missed",
  "ca_hist_missed_tip": "Scheduled shift ended with no clock-in",
  "ca_hist_no_clock_out": "No clock-out",
  "ca_hist_no_clock_out_tip": "Session never closed; its hours are not counted",
  "ca_hist_in_progress": "Still clocked in",
  "ca_hist_open_break": "open",
  "ca_hist_day_col_gross": "Total hours",
  "ca_hist_day_col_breaks": "Breaks",
  "ca_hist_legend_worked": "Worked",
  "ca_hist_legend_late": "Late",
  "ca_hist_legend_missed": "Missed",
  "ca_hist_legend_no_clock_out": "No clock-out",
  "ca_hist_prev_person": "Previous employee",
  "ca_hist_next_person": "Next employee",
  "ca_hist_close": "Close",
  "active_cleaners": "Active cleaners",
  "closed_complaints": "Closed complaints",
  "total_work_time": "Total work time",
  "total_work_time_net": "Total work time (Today Net)",
  "total_break_time": "Total break time",
  "avg_response_time": "Avg. resolved",
  "cleaner": "Cleaner",
  "clocked_in": "Clocked in",
  "clocked_out": "Clocked out",
  "still_clocked_in": "Still clocked in",
  "clocked_in_late": "Clocked in late",
  "total_hours": "Total hours",
  "auto_punch": "Auto (geofence)",
  "manual_punch": "Manual",
  "complaint_opened": "Complaint opened",
  "complaint_closed": "Complaint closed",
  "complaint_still_open": "Still open",
  "resolved_in": "Resolved in",
  "open_for": "Open for",
  "sla_breached": "SLA breached",
  "no_activity_today": "No activity yet today",
  "just_now": "just now",
  "ago": "ago",
  "today": "Today",
  "live": "Live",
  "last_updated": "Updated",
  "expose_results": "Results",
  "events_expose": "Events",
  "expose_score": "Rate",
  "shift_events_expose": "Shift events & expose",
  "type_of_site": "Type of site",
  "morning_shift": "Morning shift",
  "afternoon_shift": "Afternoon shift",
  "night_shift": "Night shift",
  "update": "Update",
  "restart": "Restart",
  "send_data": "Send data",
  "send_count": "Send count",
  "blink": "Blink",
  "beacon": "Beacon",
  "like_btn": "Like button",
  "requires_like_btn": "Requires the like button to be on",
  "maintenance_btn": "Maintenance button",
  "battery": "Battery",
  "version": "Version",
  "actions": "Actions",
  "device_actions": "Device Actions",
  "device_settings": "Device Settings",
  "drains_battery": "Drains battery",
  "latest_errors": "Latest errors",
  "no_errors": "No errors",
  "offline_calls": "Offline calls",
  "offline_duration_calls": "Offline duration calls",
  "counterCalls": "Counter calls",
  "active": "Active",
  "no_active_supervisors": "No active supervisors",
  "active_supervisors_column": "Active supervisors",
  "supervisors_active_label": "supervisors active now",
  "active_supervisors_coverage_hint": "Active supervisors have this area switched on in the mobile app. This does not indicate online status or physical presence.",
  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Active calculation",
  "pad": "Pad",
  "pad_counter": "Pad counter",
  "counter_status": "Counter status",
  "choose_state": "Choose state",
  "choose_city": "Choose city",
  "start_hour": "Start hour",
  "end_hour": "End Hour",
  "analytics_log": "Analytics log",
  "or": "or",
  "no_data_available": "No data available",
  "filter_by_cleaner": "Filter by cleaner",
  "all_cleaners": "All cleaners",
  "not_available": "N/A",
  "failed_to_load_data": "Failed to load data",
  "new_task": "New task",
  "new_personal_task": "New personal task",
  "task_assignment": "Task assignment",
  "task_assignment_room": "Room task",
  "task_assignment_personal": "Personal task (assign to cleaner)",
  "temporarily_unavailable": "Temporarily unavailable",
  "task_details": "Task details",
  "task_languages": "Task languages",
  "task_languages_hint": "Select the languages for this task. You will enter the title in each selected language.",
  "settings_and_assignment": "Settings & assignment",
  "assignee": "Assignee",
  "category": "Category",
  "title": "Title",
  "task_type": "Task type",
  "task_category": "Task category",
  "call_to_action": "Call to action",
  "schedule": "Schedule",
  "insert_text": "Insert text",
  "select": "Select",
  "select_all": "Select All",
  "n_selected": "{count} selected",
  "clear_selection": "Clear selection",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Schedule dates",
  "language": "Language",
  "calendar": "Calendar",
  "operation": "Operation",
  "daily": "Daily",
  "weekly": "Weekly",
  "monthly": "Monthly",
  "quarterly": "Quarterly",
  "yearly": "Yearly",
  "sunday": "Sunday",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "1st week": "1st Week",
  "2nd week": "2nd Week",
  "3rd week": "3rd Week",
  "4th week": "4th Week",
  "5th week": "5th Week",
  "1st quarter": "1st Quarter",
  "2nd quarter": "2nd Quarter",
  "3rd quarter": "3rd Quarter",
  "4th quarter": "4th Quarter",
  "edit_task": "Edit task",
  "created_at": "Created at",
  "installed_at": "Installed at",
  "hour": "Hour",
  "week_days": "Week days",
  "month_weeks": "Month weeks",
  "month_days": "Month days",
  "no_tasks_found": "No tasks found",
  "invalid_language": "Invalid language",
  "no_active_tasks_found": "No active tasks found",
  "edit": "Edit",
  "send_date": "Send date",
  "invalid_date": "Invalid date",
  "hour_must_be_after_current": "Please select an hour that is after the current time",
  "cells_num": "Cells #",
  "sinks_num": "Sinks #",
  "urinals_num": "Urinals #",
  "toilet_paper_size": "Toilet paper size",
  "email_configuration": "Email configuration",
  "please_edit_the_email_information": "Please edit the email information",
  "email_sender_info": "Email sender info",
  "email_subject_info": "Email subject info",
  "email_message_info": "Email message info",
  "companyName": "Company name",
  "email_language": "Email language",
  "complaint_language": "Complaint language",
  "email_message_format": "Email message format",
  "line": "Line",
  "list": "List",
  "roomType": "Room type",
  "By logging in, you agree to Buzzztech's": "By logging in, you agree to Buzzztech's",
  "Terms and Conditions": "Terms and Conditions",
  "and": "And",
  "Privacy Policy": "Privacy Policy",
  "All actions within this panel are recorded for quality control and improvement": "All actions within this panel are recorded for quality control and improvement",
  "You must agree to the terms and conditions": "You must agree to the terms and conditions",
  "months": "Months",
  "ref_id": "Reference id",
  "room_name_en": "Room name in english",
  "site_state": "Site state",
  "site_city": "Site city",
  "city": "City",
  "state": "State",
  "site_country": "Site country",
  "first_date": "First date",
  "pinned": "Pinned",
  "no.": "No.",
  "must_be_numbers": "Must be numbers",
  "must_be_3_digits": "Must be 3 digits",
  "must_have_english_title": "Must have english title",
  "total_sites": "Total",
  "site_information": "Site information",
  "holiday_offdays": "Holidays & Days-Off",
  "add_offday": "Day-Off",
  "add_holiday": "Holiday",
  "name_under_chars": "Name under 25 characters",
  "days_comma_separated": "Valid days, separated by a comma",
  "year": "Year",
  "month": "Month",
  "day": "Day",
  "holiday_name": "Holiday name",
  "offday_name": "Day-off name",
  "delete_confirmation_title": "Are you sure?",
  "delete_confirmation_message": "This action cannot be undone.",
  "are_you_sure": "Are you sure?",
  "israel": "Israel",
  "USA": "USA",
  "poland": "Poland",
  "mexico": "Mexico",
  "cyprus": "Cyprus",
  "brazil": "Brazil",
  "romania": "Romania",
  "netherlands": "Netherlands",
  "tablet_survey": "Tablet survey",
  "no_shift_survey": "No shift tablet survey",
  "number_of_rows": "Number of rows",
  "rating_shape": "Rating shape",
  "content_survey": "Content survey",
  "rating_survey": "Rating survey",
  "device-alerts": "Problem",
  "device-active": "Active",
  "device-search": "Search",
  "mac_id": "MAC address",
  "qr_tag": "QR tag",
  "sensor": "Sensor",
  "image_survey": "Image survey",
  "open_text": "Open text",
  "open_text_survey": "Open text survey",
  "embedded_link": "Embedded link",
  "device-counter": "Counter",
  "count": "Count",
  "last_date": "Last date",
  "last_arrival":"Last cleaner arrival",
  "cleaners": "Cleaners",
  "viewer": "Viewer",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "No users found",
  "no_cleaners_found": "No cleaners found",
  "new_cleaner": "New cleaner",
  "edit_cleaner": "Edit cleaner",
  "have_you_finished_making_changes": "Have you finished making changes?",
  "assignment_issues_found": "Assignment issues found",
  "unassigned_rooms_title": "Unassigned rooms",
  "overlapping_assignments_title": "Overlapping assignments",
  "and_n_more": "and {count} more",
  "continue_anyway": "Continue anyway",
  "stay_and_fix": "Stay and fix",
  "assignment_coverage_issues": "{unassigned} unassigned · {overlaps} overlaps",
  "assignment_check_failed": "Could not verify room assignments",
  "tap_for_details": "Tap for details",
  "has_app": "App",
  "has_app_tooltip": "Cleaner has the app",
  "notifications_tooltip": "Push notifications are on",
  "assigned_to_rooms": "Assigned to rooms",
  "assigned_to_rooms_tooltip": "Has rooms on this site",
  "recently_active": "Recently active",
  "works_at_site": "Works at site",
  "recently_active_tooltip": "Opened the app in the last 30 minutes",
  "please_select": "Please select",
  "please_select_site_first": "Please select a site first",
  "working_areas": "Working areas",
  "no_working_areas": "No working areas yet",
  "working_area_alerts": "Alerts",
  "api": "API",
  "task_target_by_working_areas": "By working areas (all rooms in selected areas)",
  "task_target_by_rooms": "By specific rooms",
  "task_target_label": "Task opens on",
  "step_what": "What",
  "step_when": "When",
  "step_where": "Where",
  "step_options": "Options",
  "please_create_room_before_working_area": "Please create at least one room before creating a working area",
  "isWorkingInSite": "Working in site",
  "you_are_not_allowed_to_edit": "You are not allowed to edit",
  "you_are_not_allowed_to_remove": "You are not allowed to remove",
  "task": "Task",
  "portuguese": "Portuguese",
  "russian": "Russian",
  "spanish": "Spanish",
  "polish": "Polish",
  "installer": "Installer",
  "once": "Once",
  "time_saved": "Time Saved",
  "yes": "Yes",
  "no": "No",
  "workingAreaNames": "Working area names",
  "shift_rooms":"Rooms",
  "shift_validation_overlap": "This shift overlaps with \"{shiftName}\" on room \"{roomName}\". Remove the room from one of the shifts or adjust their hours.",
  "shift_validation_missing_fields": "Please fill in all required shift fields (hours, days, and site).",
  "shift_validation_empty_rooms": "Please assign at least one room to this shift.",
  "shift_validation_no_valid_rooms": "No valid rooms selected for this shift.",
  "shift_validation_empty_room_map": "Could not build the shift schedule. Check the selected days and hours.",
  "new_shift":"New shift",
  "add_shift_inactive": "Add reflective shifts",
  "remove_auto_shift_inactive": "Remove automated reflective shifts",
  "additional_options": "Additional options",
  "add_default_shifts": "Add default shifts",
  "no_user_found": "No user found",
  "no_site_found": "No site found",
  "open_complaints": "Open Complaints",
  "site_alerts": "Site Alerts",
  "open_sla_alerts": "Open Complaints Alerts",
  "open_duration": "Open Duration",
  "no_open_slas": "No open SLAs found",
  "no_open_slas_description": "There are currently no sites with open SLAs.",
  "no_slas_to_send": "No open SLAs found for this site",
  "total_open_complaints": "Total Open Complaints",
  "longest_duration": "Longest Duration",
  "complaints_details": "Complaints Details",
  "rooms_with_open_complaints_percentage": "Rooms with Open Complaints",
  "rooms_with_cleaner_arrival_percentage": "Rooms with Cleaner Arrival",
  "rooms_without_cleaner_arrival_percentage": "Rooms without Cleaner Arrival",
  "site_alerts_total_rooms": "Total rooms",
  "site_alerts_open_complaints_count": "Number of open complaints",
  "site_alerts_customer_opening_date": "Customer opening date",
  "company_country": "Company country",
  "select_message": "Select Message",
  "message_no_cleaner_arrival": "Hello everyone,\nPlease note that there are rooms where cleaner arrival has not been reported today.\nPlease handle this",
  "message_open_complaints": "Hello everyone,\nPlease note that there are several rooms with open complaints for a long time.\nPlease handle this",
  "rooms_list": "Rooms:",
  "please_address_issues_promptly": "Please address these issues promptly.",
  "no_results_found": "No results found",
  "showing": "Showing",
  "per_page": "Per page",
  "whatsapp": "WhatsApp",
  "loading": "Loading",
  "error_opening_whatsapp": "Error opening WhatsApp. Please try again.",
  "error_loading_slas": "Error loading SLA details. Please try again.",
  "send_whatsapp": "Send WhatsApp",
  "more_options": "More options",
  "preview_message": "Preview Message",
  "copy_message": "Copy Message",
  "message_preview": "Message Preview",
  "phone_number_optional": "Phone Number (Optional)",
  "enter_phone_number": "Enter phone number (e.g., +1234567890)",
  "phone_number_hint": "Leave empty to open WhatsApp without a specific contact",
  "message_copied": "Message copied to clipboard!",
  "error_copying_message": "Error copying message. Please try again.",
  "opening_whatsapp": "Opening WhatsApp...",
  "preview_message_description": "Preview and edit the message before sending",
  "copy_message_description": "Copy the message to clipboard",
  "service_provider": "Service provider",
  "qr task": "QR task",
  "qr_task": "QR task",
  "all_day": "All day",
  "auto_start": "Auto start",
  "more_options": "More options",
  "english_title": "English title",
  "connectivity": "Connectivity",
  "power": "Power",
  "Your work has been saved": "Your work has been saved",
  "schedule_call_time": "Schedule call time",
  "schedule_call_gap": "Schedule call gap",
  "gapInMinutes": "Gap in minutes",
  "no_manual_calls_available": "No manual calls available",
  "manual_calls": "Manual calls",
  "cleandexCalls": "Cleandex calls",
  "manualCalls": "Manual calls",
  "inactive": "Inactive",
  "on hold": "On hold",
  "sequential": "Sequential",
  "ratio": "Ratio",
  "must_choose": "Must choose",
  "surveyApp": "Survey app",
  "installation": "Installation",
  "manager": "Manager",
  "previous": "Previous",
  "no_rooms_found": "No rooms found",
  "show_calendar": "Show calendar",
  "seeAll": "See all",
  "showPaginated": "Show paginated",
  "cleaners_arrivals": "Cleaners arrivals",
  "qr validator": "QR validator",
  "qr_validator": "QR validator",
  "searchAddress": "Search for an address",
  "sector": "Sector",
  "add_address": "Add address",
  "site_auto_attendance_enabled":
    "Allow automatic clock-in and clock-out using the mobile app geofence (employees need the app and location permission).",
  "site_auto_attendance_requires_location":
    "Set a location on the map first (pin and radius at least 100 m) before enabling automatic attendance.",
  "site_mandatory_clock_in": "Require clock-in before work",
  "site_mandatory_clock_in_description":
    "Employees at this site must clock in before they can open the cleaning, maintenance and missions tabs in the mobile app.",
  "site_mandatory_clock_in_without_location":
    "This site has no map location, so the app cannot tell when an employee is on site. Until you set one, the requirement applies to these employees everywhere.",
  "auto_attendance": "Auto attendance",
  "auto_attendance_ready": "Ready",
  "auto_attendance_off": "Off",
  "auto_attendance_needs_setup": "Needs setup",
  "auto_attendance_ready_tooltip": "Toggle is on, geofence radius ≥ 100m, ready for automatic clock-in/out.",
  "auto_attendance_off_tooltip": "Toggle is off. Edit the site to enable automatic attendance.",
  "auto_attendance_needs_setup_tooltip": "Toggle is on but the geofence is missing or below the 100m minimum. Edit the site to fix it.",
  "edit_address": "Edit address",
  "choose_radius": "Choose radius",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Green = OK. Red = Recommended to clean.\nHover the cell icon for details.",
  "recommended_to_clean": "Recommended to clean",
  "cleandex_warning_level": "Cleandex warning level",
  "select_warning_level": "Select warning level",
  "bronze": "Bronze",
  "silver": "Silver",
  "gold": "Gold",
  "ai": "AI",
  "daily_employees_num": "Daily employees number",
  "daily_shift_hours": "Daily shift hours",
  "rooms_num": "Rooms number",
  "buildings_num": "Buildings number",
  "cleaner_entries": "Cleaner entries",
  "avg_daily_visits_monthly": "Avg daily visits monthly",
  "avg_daily_cleaners_to_save": "Avg daily cleaners to save",
  "saving_hours_per_day": "Saving hours per day",
  "saving_money_per_day": "Saving money per day",
  "saving_money_per_month": "Saving money per month",
  "cleaners_to_visitors_ratio": "Cleaners to visitors ratio",
  "cleaning_time_in_minutes_per_room": "Cleaning time in minutes per room",
  "max_number_of_rooms_per_employee": "Max number of rooms per employee",
  "break_time_per_hour": "Break time per hour",
  "transition_time_between_tasks": "Transition time between tasks",
  "employer_cost_hour": "Employer cost per hour",
  "lobby_cleaning_per_floor": "Lobby cleaning per floor",
  "desired_cleaning_time": "Desired cleaning time",
  "desired_number_of_entries": "Desired number of entries",
  "buzz_system_cost_per_unit_per_month": "Buzz system cost per unit per month",
  "total_buzz_system_cost_per_month": "Total Buzz system cost per month",
  "return_on_investment_in_months": "Return on investment in months",
  "annual_savings": "Annual savings",
  "roi_calculator": "ROI calculator",
  "cleaning_work_plan": "Cleaning work plan",
  "cleaning_work_plan_intro": "Uses shift room statistics for the company and site in the header. Visits and arrivals come from the single day with the highest site visits inside the date range and shifts from the dashboard filter (set those on Performance or Analytics if this tab hides the time and filter controls). Enter visits per clean, staffing target, hourly cost, and average minutes per clean; generate to see room-level suggested cleans and summary totals.",
  "cleaning_work_plan_default_n": "Visits per clean",
  "cleaning_work_plan_cleaner_count": "Cleaners (optional)",
  "cleaning_work_plan_avg_minutes": "Average cleaning time (min)",
  "cleaning_work_plan_run": "Generate plan",
  "cleaning_work_plan_export_csv": "Export Excel",
  "cleaning_work_plan_suggested_n": "Visits per clean",
  "cleaning_work_plan_actual_cleans": "Cleaner arrivals",
  "cleaning_work_plan_actual_cleans_hint": "Total cleaner arrivals in shift room stats on the peak day (within the selected range and filters).",
  "cleaning_work_plan_suggested_cleans": "Suggested cleans",
  "cleaning_work_plan_cleaner": "Cleaner",
  "cleaning_work_plan_floors": "Floors",
  "cleaning_work_plan_peak_day": "Peak day",
  "cleaning_work_plan_error": "Could not generate cleaning work plan",
  "cleaning_work_plan_no_rooms": "No rooms returned for this site. Check the site and date range, or verify rooms exist in the control panel.",
  "cleaning_work_plan_need_filter": "Select company and site in the header, set a date range (and shifts if needed) on Performance or Analytics, then try again.",
  "cleaning_work_plan_settings": "Plan settings",
  "cleaning_work_plan_desired_employees": "Desired number of employees",
  "cleaning_work_plan_cost_per_hour": "Cost per hour",
  "cleaning_work_plan_estimated_cost_suggested": "Estimated cost (suggested workload)",
  "cleaning_work_plan_estimated_cost_actual": "Estimated cost (actual workload)",
  "cleaning_work_plan_hours_per_cleaner": "Hours per cleaner",
  "cleaning_work_plan_metric_title": "Metric",
  "cleaning_work_plan_metric_avg_cleaning_min": "Avg. cleaning time (min)",
  "cleaning_work_plan_metric_total_arrivals": "Total cleaner arrivals",
  "cleaning_work_plan_metric_total_cleaning_min": "Total cleaning time (min)",
  "cleaning_work_plan_metric_total_cleaning_hours": "Total cleaning time (hours)",
  "cleaning_work_plan_metric_hours_per_cleaner_row": "Hours per cleaner",
  "cleaning_work_plan_metric_num_cleaners": "Number of cleaners",
  "cleaning_work_plan_summary": "Summary",
  "cleaning_work_plan_summary_peak_note": "Visits, arrivals, and suggested cleans use the same shift room stats rules as Analytics (including arrivals aggregation). They are for the peak day—the calendar day with the highest site visits in the filter period. Only calculated rooms are included, like the overview when no room filter is applied.",
  "cleaning_work_plan_summary_filter_period": "Filter period",
  "cleaning_work_plan_summary_total_visits": "Total visits",
  "cleaning_work_plan_summary_total_arrivals": "Total cleaner arrivals",
  "cleaning_work_plan_summary_employees_in_site": "Active cleaners",
  "cleaning_work_plan_summary_shift_working_hours": "Shift working hours",
  "cleaning_work_plan_hours_unit": "h",
  "cleaning_work_plan_rooms_table": "Rooms",
  "cleaning_work_plan_cleaners_table": "Recommended cleaner allocation",
  "cleaning_work_plan_search_rooms": "Search rooms",
  "cleaning_work_plan_total_minutes": "Total minutes",
  "cleaning_work_plan_actual_total_minutes": "Actual total minutes",
  "cleaning_work_plan_actual_total_minutes_hint": "Recorded cleaner arrivals in shift room stats on the peak day (within the selected range), multiplied by your average minutes per clean.",
  "cleaning_work_plan_suggested_total_minutes": "Suggested total minutes",
  "cleaning_work_plan_suggested_room_minutes": "Suggested cleaning minutes",
  "cleaning_work_plan_actual_room_minutes": "Actual cleaning minutes",
  "cleaning_work_plan_cleaner_suggested_minutes": "Suggested min.",
  "cleaning_work_plan_cleaner_actual_minutes": "Actual min.",
  "cleaning_work_plan_period": "Period",
  "cleaning_work_plan_room_count": "Room count",
  "cleaning_work_plan_cleaners_working_in_site": "Cleaners working in site (app contacts)",
  "cleaning_work_plan_cleaners_connection_table": "Cleaners by rooms",
  "cleaning_work_plan_connected_rooms_count": "Rooms",
  "cleaning_work_plan_connected_floor_count": "Number of floors",
  "cleaning_work_plan_connected_floors_list": "Floors",
  "cleaning_work_plan_visitor_cleaning_entry_ratio": "Visitor / cleaning entry ratio",
  "cleaning_work_plan_performance_comparison_table": "Performance comparison",
  "cleaning_work_plan_performance_comparison_empty": "Load cleaner connection data to see comparison rows.",
  "cleaning_work_plan_performance_col_index": "Index",
  "cleaning_work_plan_performance_existing_plan": "Existing work plan",
  "cleaning_work_plan_performance_recommended_plan": "Buzzztech recommended plan",
  "cleaning_work_plan_perf_number_of_employees": "Number of employees",
  "cleaning_work_plan_perf_working_hours_per_employee": "Working hours per employee",
  "cleaning_work_plan_perf_total_working_hours": "Total working hours",
  "cleaning_work_plan_perf_total_cleaning_hours": "Total cleaning hours",
  "cleaning_work_plan_perf_daily_cost": "Daily cost",
  "cleaning_work_plan_perf_total_cleaning_visits": "Total cleaning visits",
  "cleaning_work_plan_perf_busiest_area_visits": "Busiest work area — visits",
  "cleaning_work_plan_perf_cleaning_to_busiest": "Cleaning visits to busiest area",
  "cleaning_work_plan_perf_max_cleaning_ratio": "Maximum cleaning ratio",
  "cleaning_work_plan_perf_least_busy_visits": "Least busy work area — visits",
  "cleaning_work_plan_perf_cleaning_to_least": "Cleaning visits to least busy area",
  "cleaning_work_plan_perf_min_cleaning_ratio": "Minimum cleaning ratio",
  "cleaning_work_plan_ai_allocate": "AI Allocate",
  "cleaning_work_plan_ai_allocation_result": "AI Allocation Result",
  "cleaning_work_plan_ai_allocation_loading": "Generating AI allocation...",
  "cleaning_work_plan_ai_allocation_error": "Failed to generate AI allocation. Please try again.",
  "cleaning_work_plan_ai_invalid_employees": "Please set a valid desired number of employees.",
  "cleaning_work_plan_ai_status_elapsed": "Elapsed: {s}s",
  "cleaning_work_plan_ai_status_hint": "The server runs several AI steps in sequence (initial plan, geography, visit balance, then final output). This can take one to two minutes—please keep this page open.",
  "cleaning_work_plan_ai_status_step_1": "Step 1 — drafting an initial assignment from room and visit data…",
  "cleaning_work_plan_ai_status_step_2": "Step 2 — refining geography (grouping nearby floors and buildings)…",
  "cleaning_work_plan_ai_status_step_3": "Step 3 — balancing daily visits across cleaners…",
  "cleaning_work_plan_ai_status_step_4": "Step 4 — generating the structured allocation…",
  "cleaning_work_plan_ai_status_step_5": "Step 5 — validating and computing final metrics…",
  "cleaning_work_plan_ai_cleaner_number": "Cleaner #",
  "cleaning_work_plan_room_minutes": "Cleaning minutes",
  "cleaning_work_plan_assigned_cleaner": "Assigned cleaner",
  "cleaning_work_plan_summary_cleaners": "Cleaners in plan",
  "cleaning_work_plan_summary_avg_minutes": "Avg minutes / clean",
  "cleaning_work_plan_suggested_hours": "Suggested total hours",
  "cleaning_work_plan_actual_hours": "Actual total hours",
  "cleaning_work_plan_avg_suggested_min_per_cleaner": "Avg suggested min / cleaner",
  "cleaning_work_plan_avg_actual_min_per_cleaner": "Avg actual min / cleaner",
  "cleaning_work_plan_guidelines_title": "Optimization guidelines",
  "cleaning_work_plan_guidelines_intro": "This tool follows the same goals as manual cleaning-plan optimization: workload from visit data, time from your average minutes per clean, and staffing that balances work while keeping floors geographically sensible.",
  "cleaning_work_plan_guidelines_b1": "Visits per clean (default 50) matches the usual 1:50-style rule: suggested entries per room ≈ visits ÷ visits per clean (rounded up). Visits and arrivals are taken from the busiest day (highest site visits) within your selected date range, so the plan matches a peak-load day.",
  "cleaning_work_plan_guidelines_b2": "When you set a cleaner count, each building floor is one group. Floors are ordered by building and floor number, then split into contiguous blocks across cleaners so suggested cleans (implied work) are balanced while nearby floors tend to stay on the same cleaner.",
  "cleaning_work_plan_guidelines_b3": "All restrooms on the same building floor stay with the same cleaner, so men’s and women’s rooms on that floor are not split between different cleaners (as long as they share the same floor value in the control panel).",
  "cleaning_work_plan_guidelines_b4": "Average minutes per clean drives suggested and actual total minutes, hours, and average minutes per cleaner. Actual totals use recorded cleaner arrivals × your average; suggested totals use implied cleans × your average.",
  "cleaning_work_plan_guidelines_b5": "Use Export CSV if you want to refine allocation elsewhere (for example to tighten visit balance further).",
  "cleaners_number": "Cleaners number",
  "floors_num": "Floors number",
  "avg_daily_cleaners_required": "Avg daily cleaners required",
  "app_pages": "App pages",
  "buzzzTime": "Buzzz time",
  "missions": "Missions",
  "send_emails": "Send emails",
  "enter": "Enter",
  "account": "Account",
  "privacy": "Privacy",
  "personal_settings": "Personal settings",
  "personal_settings_lead": "Manage your language and privacy preferences.",
  "personal_settings_read_only": "These details are managed by your administrator. Contact them if something needs updating.",
  "change_password": "Change password",
  "change_password_hint": "Changing your password will sign you out of your other devices.",
  "current_password": "Current password",
  "new_password": "New password",
  "confirm_new_password": "Confirm new password",
  "password_min_length": "Password must be at least 8 characters",
  "passwords_do_not_match": "Passwords do not match",
  "new_password_same_as_current": "New password must be different from the current password",
  "current_password_incorrect": "Current password is incorrect",
  "current_password_required": "Current password is required",
  "password_changed_successfully": "Password changed successfully",
  "change_password_failed": "Could not change password",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "Incorrect username or password",
  "login_credentials_required": "Enter your username or email and password",
  "login_network_error": "Cannot reach the server. Check your connection and try again",
  "login_failed": "Unable to sign in. Please try again",
  "login_too_many_attempts": "Too many sign-in attempts. Wait 15 minutes and try again.",
  "forgot_password_too_many": "Too many password reset requests. Wait an hour and try again.",
  "reset_password_too_many": "Too many password reset attempts. Wait an hour and try again.",
  "change_password_too_many": "Too many password change attempts. Wait 15 minutes and try again.",
  "sign_in_with_microsoft": "Sign in with Microsoft",
  "login_or_divider": "or",
  "login_choose_method": "Choose how you want to sign in",
  "login_sso_section_title": "Work account (SSO)",
  "login_sso_section_hint": "Use your company Microsoft account. No Buzzz password needed.",
  "login_password_section_title": "Buzzz username & password",
  "login_password_section_hint": "Use the username/email and password created for this portal.",
  "login_with_password": "Sign in with password",
  "sso_user_not_found": "No Buzzz account for this work email. Ask an admin to create your user first.",
  "sso_not_configured": "Microsoft sign-in is not configured yet.",
  "sso_email_missing": "Microsoft did not return an email address for this account.",
  "sso_state_invalid": "Microsoft sign-in expired. Please try again.",
  "sso_provider_error": "Microsoft sign-in was cancelled or failed. Please try again.",
  "sso_failed": "Unable to sign in with Microsoft. Please try again.",

  "personal_settings_language_hint": "Applies to the whole portal for this browser.",
  "personal_settings_privacy_hint": "Request erasure of your personal data under applicable privacy laws.",
  "personal_settings_export_hint": "Download a readable JSON copy of the personal data we hold about you: your portal profile, sites you can access, and your linked mobile app profile (when your phone matches). Limited exports per day.",
  "Download my data": "Download my data",
  "personal_settings_role": "Role",
  "Request deletion of my data": "Request deletion of my data",
  "Request deletion of my data - confirm": "Request deletion of my data? An email will be sent to the administrator. We will process your request within 30 days.",
  "Request deletion of my data - success": "Request sent. We will process it within 30 days.",
  "Request deletion of my data - error": "Failed to submit request. Please try again or email privacy@buzzztech.com.",
  "metrics": "Metrics",
  "select_three_metrics": "Select up to 3 metrics to compare",
  "select_four_metrics": "Select up to 4 metrics to compare",
  "legend": "Legend",
  "more_details": "More Details",
  "performance_overview": "Performance Overview",
  "loading_chart": "Loading chart",
  "retry": "Retry",
  "performance_trending_upward": "Performance trending upward",
  "high_complaint_ratio": "High complaint ratio",
  "click_bars_for_details": "Click on bars to drill down into daily analytics",
  "refresh": "Refresh",
  "table": "Table",
  "cards": "Cards",
  "no_recent_arrivals": "No recent arrivals",
  "feedback_charts": "Feedback charts",
  "general_overview": "General overview",
  "cleaning_complaints_breakdown": "Cleaning complaints breakdown",
  "maintenance_complaints_breakdown": "Maintenance complaints breakdown",
  "refresh_failed": "Refresh failed",
  "data_exported_successfully": "Data exported successfully",
  "data_export_failed": "Data export failed",
  "analytics_export_confirm": "Download analytics CSV files?",
  "analytics_export_title": "Export analytics data",
  "analytics_export_description": "A ZIP file with your currently filtered analytics will be downloaded — summary, donut, hours, rooms and cleaner/supervisor arrivals.",
  "download": "Download",
  "analytics_export_blocked_loading": "Analytics data is still loading. Please wait and try again.",
  "analytics_export_blocked_no_data": "No analytics data to export. Apply your filters and wait for the page to load.",
  "analytics_export_blocked_stale_filters": "Filters have changed. Apply filters and wait for analytics to reload before exporting.",
  "executive_report_period_title": "Report covers a full month",
  "executive_report_period_description": "The executive report is always built for a complete calendar month, so its numbers will not match the range currently shown on screen.",
  "executive_report_period_selected": "Selected range",
  "executive_report_period_used": "Report will cover",
  "drill_down_unavailable": "Drill-down only available for daily view",
  "sort_by": "Sort by",
  "no_active_shift": "No active shift",
  "check_site_and_shift": "Please check if a site is selected and has an active shift",
  "please_add_shift_first": "Please add shift first",
  "cleandex_no_data_message": "No cleandex data is currently available",
  "task_no_data_message": "No task data is currently available",
  "navigation": "Navigation",
  "network_information": "Network information",
  "target_effectiveness": "Target effectiveness",
  "cleandex_call_cleaner": "Cleandex call cleaner",
  "top_complaint": "Top complaint",
  "no_complaints": "No complaints",
  "official_start_date": "Official start date",
  "note_text": "Note text",
  "add_note": "Add note",
  "general_note": "General Note",
  "general_note_short": "General",
  "battery_short": "Battery",
  "panel_short": "Panel",
  "technician_short": "Technician",
  "battery_replacement": "Battery replacement",
  "device_maintenance": "Device maintenance",
  "maintenance_type": "Maintenance type",
  "panel_change": "Panel change",
  "technician_check": "Technician check",
  "enter_note_details": "Enter note details",
  "replacement_date": "Replacement date",
  "replaced_by_name": "Replaced by name",
  "replacement_note": "Replacement note",
  "enter_replacement_details": "Enter replacement details",
  "replacement_history": "Replacement history",
  "loading_history": "Loading history",
  "no_replacement_history": "No replacement history available",
  "enter_technician_name": "Enter technician name",
  "prefilled_from_account": "Prefilled from your account — you can edit",
  "user_information": "User information",
  "enter_change_details": "Enter change details",
  "panel_change_history": "Panel change history",
  "check_date": "Check date",
  "checked_by_name": "Checked by name",
  "enter_check_details": "Enter check details",
  "technician_check_history": "Technician check history",
  "no_technician_check_history": "No technician check history available",
  "change_date": "Change date",
  "changed_by_name": "Changed by name",
  "change_note": "Change note",
  "check_note": "Check note",
  "replaced_by": "Replaced by",
  "no_data_entered": "No data entered",
  "no_panel_change_history": "No panel change history available",
  "invalid_username": "Invalid username",
  "invalid_phone": "Invalid phone number",
  "username_must_be_at_least_5_characters": "Username must be at least 5 characters",
  "data_loading_please_wait": "Data is currently loading. Please wait...",
  "dates_not_changed": "Dates have not changed. No reload needed.",
  "date_outside_stats_range": "Selected dates are outside the available stats range.",

  "date_range_invalid": "\"To\" date must be on or after \"From\" date.",
  "filter_help_text": "Filter Rules: Select Building first to enable Floor filter. Most filters support multiple selections.",
  "select_building_first": "Please select a Building first to enable Floor filter",
  "cannot_select_gender_with_rooms": "Cannot select a room type when rooms are selected",
  "cannot_select_gender_with_rooms_tooltip": "The room type filter cannot be used when rooms are selected. Please clear the room selection first.",
  "cannot_select_building_with_rooms": "Cannot select building when rooms are selected",
  "cannot_select_building_with_rooms_tooltip": "Building filter cannot be used when rooms are selected. Please clear rooms selection first.",
  "multi_select_hint": "You can select multiple options",
  "filter_applied": "Filter applied successfully",
  "no_filters_selected": "No filters selected. Select at least one filter option.",
  "filters": "Filters",
  "location": "Location",
  "attributes": "Attributes",
  "applying": "Applying...",
  "active_filters": "Active Filters",
  "viewing_room": "Viewing room",
  "multiple": "Multiple",
  "close": "Close",
  "save_replacement": "Save replacement",
  "save_change": "Save change",
  "save_check": "Save check",
  "failed_to_load_maintenance_history": "Failed to load maintenance history",
  "Battery replacement recorded successfully": "Battery replacement recorded successfully",
  "Panel change recorded successfully": "Panel change recorded successfully",
  "Technician check recorded successfully": "Technician check recorded successfully",
  "no_network_data_available": "No network data available",
  "configuration": "Configuration",
  "contact_settings": "Contact & Settings",
  "notifications": "Notifications",
  "features": "Features",
  "chat_ask_buzzz": "Ask Buzzz",
  "chat_hide": "Hide",
  "chat_buzzz_assistant": "Buzzz Assistant",
  "chat_export": "Export",
  "chat_clear": "Clear",
  "chat_unpin": "Unpin",
  "chat_pin": "Pin",
  "chat_retry": "Retry",
  "chat_copy": "Copy",
  "chat_copied": "Copied!",
  "chat_share": "Share",
  "chat_suggestions": "Suggestions",
  "chat_input_placeholder": "Ask about your stats...",
  "chat_stop": "Stop",
  "chat_error": "Something went wrong. Please try again.",
  "chat_placeholder": "Ask me about your cleaning stats...",
  "chat_placeholder_context": "Ask about {scope}...",
  "chat_chip_briefing": "Morning briefing",
  "chat_chip_live_status": "Live status",
  "chat_chip_staff_status": "Staff status",
  "chat_chip_summary": "Summary",
  "chat_chip_cleaning_priority": "Cleaning priority",
  "chat_chip_worst_rooms": "Worst rooms",
  "chat_chip_focus": "Focus areas",
  "chat_chip_compare_periods": "Compare periods",
  "chat_chip_sla_issues": "SLA issues",
  "chat_chip_shift_stats": "Shift stats",
  "chat_chip_complaint_types": "Complaint types",
  "chat_chip_busiest_hours": "Busiest hours",
  "chat_chip_worst_days": "Worst days",
  "chat_chip_improving": "Improving rooms",
  "chat_chip_best_rooms": "Best rooms",
  "chat_chip_help": "Help",
  "chat_chip_why_drilldown": "Why? Drill down",
  "chat_deep_analysis": "Deep analysis (slower)",
  "chat_greeting": "Hi {name}, how can I help?",
  "chat_status_online": "Online",
  "chat_status_thinking": "Thinking...",
  "chat_tool_overview": "Pulling overview...",
  "chat_tool_rooms": "Checking rooms...",
  "chat_tool_hours": "Analyzing hours...",
  "chat_tool_days": "Reviewing daily data...",
  "chat_tool_live": "Checking live status...",
  "chat_tool_priority": "Checking priorities...",
  "chat_tool_room_detail": "Getting room details...",
  "chat_tool_shifts": "Looking at shifts...",
  "chat_tool_staff": "Checking staff...",
  "chat_tool_devices": "Checking devices...",
  "chat_feedback_good": "Good response",
  "chat_feedback_bad": "Bad response",
  "chat_feedback_thanks": "Thanks for your feedback!",
  "chat_feedback_wrong_data": "Wrong data",
  "chat_feedback_didnt_understand": "Didn't understand",
  "chat_feedback_missing_info": "Missing info",
  "chat_feedback_bad_format": "Bad formatting",
  "chat_feedback_hallucinated": "Made up numbers",
  "chat_feedback_submit": "Submit",
  "change_history": "Change History",
  "change_datetime": "Date & time",
  "change_client_site": "Client / Site",
  "change_user": "Changed by",
  "change_field": "Field",
  "change_old_value": "Previous value",
  "change_new_value": "New value",
  "change_source": "Source",
  "change_source_all": "All",
  "change_source_manual": "Manual",
  "change_source_automatic": "Auto",
  "actor_name": "Changed by",
  "field_name": "Field",
  "entity_label": "Shift",
  "no_change_history": "No change history found",
  "error_loading_change_history": "Error loading change history. Please try again.",
  "change_field_complaints_percent": "Complaints %",
  "change_field_sla_percent": "SLA %",
  "change_field_arrivals_percent": "Arrivals %",
  "change_field_complaints_percent_no_visits": "Complaints % (no visits)",
  "change_field_sla_percent_no_visits": "SLA % (no visits)",
  "change_field_arrivals_percent_no_visits": "Arrivals % (no visits)",
  "change_field_min_sla": "Min SLA",
  "change_field_max_sla": "Max SLA",
  "change_field_day_arrivals": "Day arrivals",
  "change_field_save_arrivals": "Save arrivals",
  "change_field_clean_time": "Clean time",
  "change_field_start_hour": "Start hour",
  "change_field_end_hour": "End hour",
  "change_field_shift_name": "Shift name",
  "change_field_shift_number": "Shift number",
  "change_field_week_arrivals": "Week arrivals",
  "change_field_is_active": "Active",
  "change_field_cleaners_number": "Cleaners number",
  "change_field_auto_close_complaint_sla_utc_hour": "Auto-close complaint SLA hour",
  "change_field_auto_close_maintenance_complaint_sla_utc_hour": "Auto-close maintenance SLA hour",
}

export const he = {
  ...serviks.he,
  "notified": "התראה",
  "supervisor_arrival": "הגעת מפקח",
  "arrival": "הגעה",
  "arrival_badges": "הגעות במשמרת",
  "callsHistory": "היסטוריית תלונות",
  "openCalls": "תלונות פתוחות",
  "visits_since_cleaned": "ביקורים מאז הניקוי האחרון",
  "visits_since_cleaned_short": "ביקורים מאז הניקוי",
  "filter": "סנן",
  "logo": "לוגו",
  "counter": "מונה",
  "sms": "סמס",
  "shifts": "משמרות",
  "call": "תלונה",
  "duration": "זמן מפתיחה",
  "time_start": "זמן התחלה",
  "settings": "הגדרות",
  "always": "תמיד",
  "off": "כבוי",
  "time_based": "מבוסס זמן",
  "location_based": "מבוסס מיקום",
  "notification_mode": "מצב התראות",
  "notification_times": "זמני התראות",
  "notification_times_info": "טווחי זמן מנוהלים מהאפליקציה הניידת",
  "notification_location": "מיקום התראות",
  "notification_sound": "צליל התראה",
  "no_sound": "ללא צליל",
  "default_sound": "צליל ברירת מחדל",
  "soft_bell": "פעמון רך",
  "digital_sound": "צליל דיגיטלי",
  "mallet_sound": "צליל פטיש",
  "phone_sound": "צליל טלפון",
  "text_sound": "צליל טקסט",
  "manager_alert_delay": "עיכוב התראת מנהל",
  "snooze_interval": "תזכורת",
  "vocal_notifications": "התראות קוליות",
  "no_delay": "ללא עיכוב",
  "no_snooze": "ללא תזכורת",
  "lat": "קו רוחב",
  "lon": "קו אורך",
  "radius": "רדיוס",
  "no_location_set": "לא הוגדר מיקום",
  "when_to_notify": "מתי להודיע",
  "notification_preferences": "העדפות התראות",
  "notification_health": "בריאות התראות",
  "notification_health_summary": "סיכום",
  "notification_health_loading": "בודק בריאות התראות...",
  "notification_health_refresh": "רענון",
  "notification_health_fix": "מה לעשות",
  "notification_health_unavailable": "לא ניתן לטעון את בריאות ההתראות",
  "notification_health_healthy": "תקין",
  "notification_health_blocked": "חסום",
  "notification_health_degraded": "דורש טיפול",
  "notification_health_no_app_user": "לא התחבר לאפליקציה",
  "notification_health_unknown": "לא ידוע",
  "notification_health_app_version": "גרסת אפליקציה",
  "notification_health_last_delivery": "משלוח אחרון",
  "notification_settings_no_app_user": "עובד הניקיון עדיין לא התחבר לאפליקציה. הגדרות ההתראות יופיעו לאחר ההתחברות הראשונה.",
  "assignment_configuration": "הקצאה והגדרות",
  "status": "סטטוס",
  "working_area": "איזור עבודה",
  "complaints_NC": "תלונות ללא מונה",
  "SLA_NC": "SLA ללא מונה",
  "arrivals_NC": "הגעות ללא מונה",
  "staff": "צוות",
  "cleaning_complaints": "תלונות ניקיון",
  "export": "ייצוא",
  "maintenance_complaints": "תלונות אחזקה",
  "maintenanceArrivals": "תיקוני אחזקה",
  "maintenance_arrivals": "הגעות אחזקה",
  "last": "אחרון",
  "survey_name": "סקר",
  "survey": "שם הסקר",
  "pad_survey": "סקר לפאד",
  "pad_no_maintenance_survey": "סקר לפאד ללא תחזוקה",
  "pad_kitchen": "סקר פאד מטבח",
  "number_of_assigned_devices": "מספר מכשירים",
  "number_of_pages": "מספר דפים",
  "date_created": "תאריך יצירה",
  "updated_by": "עודכן ע״י",
  "date_updated": "תאריך עידכון",
  "search": "חיפוש",
  "choose_type": "בחר סוג",
  "permitted_sites": "הרשאות לאתרים",
  "permitted_franchise": "הרשאה לזכיינים",
  "permitted_companies": "הרשאה לחברות",
  "panel_permitted": "הרשאה לפאנל",
  "end_time": "זמן סיום",
  "last_update": "עדכון אחרון",
  "add_device": "הוסף מכשיר",
  "detailed": "פירוט",
  "analysis": "ניתוח",
  "suggestion": "הצעות",
  "country": "מדינה",
  "management": "ניהול",
  "device": "מכשירים",
  "mapping": "מיפוי",
  "please_enter": "הכנס/י בבקשה",
  "new_device": "מכשיר חדש",
  "assign_device": "חבר מכשיר",
  "installSpot": "מקום התקנה",
  "device_type": "סוג מכשיר",
  "deviceCode": "קוד מכשיר",
  "device_code": "קוד מכשיר",
  "scan_or_enter_device_code": "סרוק או הזן קוד מכשיר...",
  "scan_device": "שיוך",
  "scan_qr_in_frame": "יש לכוון את קוד ה-QR במסגרת. לקודים קטנים, החזיקו במרחק 15–25 ס\"מ והקישו על התצוגה לפוקוס מחדש אם התמונה מטושטשת.",
  "checking_device_code": "בודק קוד מכשיר...",
  "camera_not_available": "מצלמה לא זמינה. ניתן להזין את הקוד ידנית.",
  "device_code_already_exists": "קוד מכשיר זה כבר משויך לחיישן אחר.",
  "assigned_to_company_site_room": "כבר משויך ל-{company} / {site} / {room}",
  "device_code_lookup_failed": "לא ניתן לאמת את קוד המכשיר. נסה שוב.",
  "device_code_no_site_access": "הקוד הזה כבר רשום באתר שאין לך גישה אליו.",
  "device_code_check_unavailable": "השרת לא הצליח לבדוק את הקוד. נסה שוב.",
  "device_code_not_a_code": "הסריקה קראה \"{code}\". הזן את קוד המכשיר עצמו.",
  "device_code_open_failed": "לא ניתן לפתוח את המכשיר הזה. נסה שוב.",
  "device_code_save_failed": "לא ניתן לשמור את קוד המכשיר. נסה שוב.",
  "device_code_save_forbidden": "אין לך הרשאה לשנות את המכשיר הזה.",
  "confirm_replace_device_code": "להחליף קוד מכשיר?",
  "confirm_replace_device_code_body": "האם אתה בטוח שברצונך להחליף את קוד המכשיר {oldCode} ב-{newCode}?",
  "room": "חדר",
  "edit_room": "ערוך חדר",
  "edit_franchise": "ערוך זכיין",
  "new_franchise": "הוסף זכיין",
  "desc": "תיאור",
  "address": "כתובת",
  "level": "רמה",
  "no_companies_to_show": "אין חברות לתצוגה",
  "company_type": "סוג החברה",
  "region": "איזור",
  "new_company": "חברה חדשה",
  "edit_company": "ערוך חברה",
  "edit_user": "ערוך משתמש",
  "C.arrivals": "ביקורי מנקים",
  "C.complaints": "תלונות ניקיון",
  "M.complaints": "תלונות תחזוקה",
  "M.Arrivals": "ביקורי אחזקה",
  "analyses": "ניתוח ללא חדרים",
  "clean_log": "יומן נקיונות",
  "maintenance_log": "יומן תחזוקה",
  "like": "לייק",
  "likes": "לייקים",
  "new_user": "משתמש חדש",
  "shift_parameters": "מאפייני משמרת",
  "add_shift": "משמרת חדשה",
  "edit_shift": "ערוך משמרת",
  "username": "שם משתמש",
  "first_name": "שם פרטי",
  "job_function": "תפקיד",
  "role": "תפקיד",
  "property_manager": "מנהל נכס",
  "facility_manager": "מנהל אחזקה",
  "site_manager": "מנהל אתר",
  "workplace_manager": "מנהל/מוביל סביבת עבודה",
  "cleaning_company_ceo": "מנכ\"ל חברת ניקיון",
  "operations_manager": "מנהל תפעול",
  "area_manager": "מנהל אזור",
  "site_cleaning_manager": "מנהל ניקיון אתר",
  "cleaning_supervisor": "מפקח ניקיון",
  "other": "אחר",
  "restroom_cleaner": "מנקה שירותים",
  "general_cleaner": "מנקה כללי",
  "day_porter": "דיי פורטר",
  "office_cleaner": "מנקה משרדים",
  "public_area_cleaner": "מנקה שטחים ציבוריים",
  "firstName": "שם פרטי",
  "description": "תיאור",
  "last_name": "שם משפחה",
  "lastName": "שם משפחה",
  "phone": "טלפון",
  "building_area": "איזור בניין",
  "users": "משתמשים",
  "add_user": "הוסף משתמש",
  "sites": "אתרים",
  "new_site": "אתר חדש",
  "edit_site": "ערוך אתר",
  "add_company": "הוסף חברה",
  "franchise": "זכיינות",
  "floor": "קומה",
  "building": "בניין",
  "humidity": "לחות",
  "humidity_abbr": "לחות",
  "temperature": "טמפרטורה",
  "temperature_abbr": "טמפ'",
  "gender": "סוג חדר",
  "display_name": "שם",
  "zone": "אזור",
  "shift_number": "מספר משמרת",
  "shift": "משמרת",
  "shift_name": "שם משמרת",
  "shift_currently_inactive": "משמרת לא פעילה כרגע",
  "local_time": "מקומי",
  "end": "סוף",
  "min_sla": "מינ׳ זמן תגובה",
  "max_sla": "מקס׳ זמן תגובה",
  "days": "ימים",
  "complaints_percent": "תלונות %",
  "sla_percent": "זמן תגובה %",
  "arrivals_percent": "% הגעות מנקה",
  "save_arrivals": "חיסכון",
  "clean_time": "זמן ניקוי (דק')",
  "tooltip_shift_number": "סדר התצוגה של המשמרת (למשל 1, 2).",
  "tooltip_shift_name": "שם המשמרת (למשל בוקר, לילה).",
  "tooltip_start_time": "שעת התחלת המשמרת בשעה מקומית.",
  "tooltip_end_time": "שעת סיום המשמרת בשעה מקומית.",
  "tooltip_cleaners_number": "מספר מנקות במשמרת זו.",
  "tooltip_min_sla": "זמן תגובה מינימלי (דקות) לטיפול בתלונה; גבול תחתון לציון.",
  "tooltip_max_sla": "זמן תגובה מקסימלי מקובל (דקות) לטיפול בתלונה; גבול עליון לציון.",
  "tooltip_arrivals": "הגעות מנקה צפויות לחדר ליום; הציון משווה הגעות בפועל ליעד.",
  "tooltip_save_arrivals": "ביקורי מנקה לחדר ליום לפני BuzzzTV; משמש לחישוב זמן חיסכון.",
  "tooltip_clean_time": "דקות לכל ביקור מנקה בחישוב זמן החיסכון (למשל 15).",
  "tooltip_complaints_percent": "משקל התלונות בציון החדר כשיש ביקורים.",
  "tooltip_response_time_SLA": "משקל זמן התגובה בציון החדר כשיש ביקורים.",
  "tooltip_arrivals_percent": "משקל הגעות לעומת יעד בציון החדר כשיש ביקורים.",
  "tooltip_complaints_NC": "משקל התלונות בציון כשאין ביקורים (ללא מונה).",
  "tooltip_SLA_NC": "משקל זמן התגובה בציון כשאין ביקורים.",
  "tooltip_arrivals_NC": "משקל ההגעות בציון כשאין ביקורים.",
  "tooltip_days": "ימי השבוע שבהם המשמרת פעילה.",
  "tooltip_active_calculation": "כשמופעל, המשמרת נכללת בציונים ובחישוב זמן החיסכון.",
  "auto_close_complaints_hour": "שעת סגירת תלונות אוטומטית",
  "tooltip_auto_close_complaints_hour": "שעה מקומית שבה תלונות SLA פתוחות במשמרת זו נסגרות אוטומטית. השאר ריק לביטול.",
  "auto_close_maintenance_complaints_hour": "שעת סגירת תלונות תחזוקה אוטומטית",
  "tooltip_auto_close_maintenance_complaints_hour": "שעה מקומית שבה תלונות SLA תחזוקה פתוחות במשמרת זו נסגרות אוטומטית. השאר ריק לביטול.",
  "no_auto_close": "-- ללא --",
  "tooltip_shift_rooms": "חדרים המשויכים למשמרת. השאר ריק למשמרת ברמת האתר.",
  "company_name": "שם החברה",
  "site_name": "שם האתר",
  "site_desc": "תיאור האתר",
  "service_provider_name": "ספק שירות",
  "service_provider_type": "סוג ספק שירות",
  "service_provider_desc": "תיאור ספק שירות",
  "user": "משתמש",
  "map": "מפה",
  "delete": "מחיקה",
  "new_room": "חדר חדש",
  "issue_times": "תלונות וסגירות",
  "solved": "נפתר",
  "visits": "ביקורים",
  "visits_also_went_up": "גם הביקורים עלו",

  "complaints": "תלונות",
  "cleaner_arrivals": "הגעות מנקה",
  "unnecessary_arrivals": "הגעות ללא קריאה",
  "unnecessary_arrivals_hint": "ביקור של המנקה בזמן שלא הייתה קריאה פתוחה בחדר.",
  "of_arrivals": "מההגעות",
  "per_working_day": "ליום עבודה",
  "per_working_day_count": "ליום עבודה ({count} ימים)",
  "arrivals_per_day_suffix": "/יום",
  "hour_values_total": "סך הכל",
  "hour_values_per_day": "ליום",
  "response_time_SLA": "זמן תגובה",
  "score": "ציון",
  "avg_score": "ציון ממוצע",
  "score_goal": "ציון רצוי",
  "top_problem_issues": "תלונות עיקריות",
  "top_problem_rooms": "חדרים עיקריים",
  "top_problem_hours": "שעות עיקריות",
  "is_time_save": "זמן שנחסך",
  "options": "אפשרויות",
  "send_battery_alerts": "שליחת התראות סוללה",
  "environment_alerts": "התראות סביבה",
  "environment_alerts_description": "שליחת התראות אימייל כאשר טמפרטורה או לחות יוצאות מהטווח המותר",
  "environment_alert_emails": "אימיילים להתראות סביבה",
  "temperature_min": "טמפרטורה מינימלית",
  "temperature_max": "טמפרטורה מקסימלית",
  "humidity_min": "לחות מינימלית",
  "humidity_max": "לחות מקסימלית",
  "environment_alert_range_invalid": "טווחי התראות הסביבה חייבים להיות מספריים והמינימום חייב להיות קטן או שווה למקסימום",
  "coming_soon": "בקרוב",
  "alert_emails": "אימיילים להתראות",
  "alert_emails_placeholder": "הכנס כתובת אימייל",
  "alert_language": "שפת התראות",
  "select_language": "בחר שפה",
  "invalid_email_format": "אחד או יותר מכתובות האימייל אינן תקינות",
  "add_email": "הוסף אימייל נוסף",
  "next": "הבא",
  "back": "חזור",
  "basic_information": "מידע בסיסי",
  "service_providers": "ספקי שירות",
  "settings_alerts": "הגדרות והתראות",
  "configuration": "תצורה",
  "contact_settings": "יצירת קשר והגדרות",
  "notifications": "התראות",
  "features": "תכונות",
  "battery_alerts": "התראות סוללה",
  "alerts_title": "התראות",
  "location": "מיקום",
  "time_save_description": "הפעל תכונות חיסכון זמן",
  "exposures_description": "עקוב אחר נתוני חשיפה",
  "alerts_description": "התראות מידע על מכשירים",
  "shift_description": "צור משמרות ברירת מחדל",
  "battery_alerts_description": "שלח התראות אימייל לסוללה נמוכה",
  "est_ROI": "החזרת השקעה משוערת",
  "complaints_vs_visits": "תלונות מול ביקורים",
  "view_by_years": "צפה  בשנים",
  "view_by_months": "צפה בחודשים",
  "view_by_weeks": "צפה בשבועות",
  "view_by_days": "צפה בימים",
  "minutes": "דקות",
  "company": "חברה",
  "site": "אתר",
  "alerts": "מידע ממכשירים",
  "performance": "ביצועים",
  "devices": "מכשירים",
  "total_devices": "סה\"כ מכשירים",
  "working": "פעיל",
  "warning": "אזהרה",
  "by_device_type": "לפי סוג מכשיר",
  "surveys": "סקרים",
  "real_time": "זמן אמת",
  "real-time": "זמן אמת",
  "cleaner-activity": "פעילות מנקים",
  "device-actions": "פעולות מכשיר",
  "pad-presence-testing": "בדיקת נוכחות פד",
  "real-time-cleaning": "זמן אמת - ניקיון",
  "real-time-maintenance": "זמן אמת - תחזוקה",
  "no_real_time_tabs_permitted": "אין לך הרשאה לצפות באף לשונית של זמן אמת",
  "admin": "מנהל",
  "all": "הכל",
  "overview": "סקירה כללית",
  "total": "סה\"כ",
  "analytics": "ניתוח",
  "pdf_export_title_analytics": "דוח ניתוח",
  "pdf_export_title_cleaner_arrivals": "הגעות מנקים",
  "communication": "תקשורת",
  "overview_complaints_devices_caption": "מכשירים מותקנים (מצטבר)",
  "overview_complaints_devices_caption_hint": "מספר המכשירים שהותקנו באתר עד סוף כל חודש, לפי תאריך ההתקנה.",
  "overview_complaints_devices_toggle_aria": "הצג או הסתר מכשירים מותקנים מתחת לתרשים תלונות",
  "dashboard_customize": "התאמה אישית",
  "dashboard_save_layout": "שמור פריסה",
  "dashboard_cancel_edit": "ביטול",
  "dashboard_reset_default": "איפוס לברירת מחדל",
  "dashboard_add_widget": "הוסף ווידג'ט",
  "dashboard_widget_unavailable": "לא זמין עבור אתר זה",
  "dashboard_widget_line_chart": "תרשים קווי",
  "dashboard_widget_room_table": "טבלת חדרים",
  "dashboard_widget_donuts": "תרשים דונאט",
  "dashboard_widget_kpi_bar": "כרטיס KPI",
  "dashboard_config_metric": "מדד",
  "dashboard_config_time_range": "טווח זמן",
  "dashboard_config_view_mode": "מצב תצוגה",
  "dashboard_config_donut": "דונאט",
  "dashboard_config_kpi": "KPI",
  "dashboard_remove_widget": "הסר ווידג'ט",
  "dashboard_drag_handle": "גרור להזזת הווידג'ט",
  "dashboard_widget_settings": "הגדרות ווידג'ט",
  "dashboard_configure": "הגדר",
  "dashboard_edit_hint": "גרור להזזה, השתמש בפינות לשינוי גודל",
  "dashboard_dismiss_hint": "סגור",
  "dashboard_category_charts": "תרשימים",
  "dashboard_category_tables": "טבלאות",
  "dashboard_category_kpis": "מדדי KPI",
  "dashboard_widget_line_chart_desc": "קו מגמה למדד נבחר",
  "dashboard_widget_room_table_desc": "ציוני חדרים וסטטוס בזמן אמת",
  "dashboard_widget_donuts_desc": "תרשים דונאט לפירוט אנליטי",
  "dashboard_widget_kpi_bar_desc": "כרטיס סיכום KPI בודד",
  "dashboard_no_data": "אין נתונים",
  "dashboard_layout_saved": "פריסת לוח המחוונים נשמרה",
  "dashboard_layout_save_failed": "שמירת פריסת לוח המחוונים נכשלה",
  "communication_select_site_title": "בחר אתר",
  "communication_select_site": "בחר חברה ואתר במסננים למעלה כדי לצפות ולהוסיף הערות למיקום זה.",
  "communication_viewing_site": "צופה ב",
  "communication_add_note": "הוסף הערה",
  "communication_add_note_open_aria": "פתח תיבת הוספת הערה",
  "communication_form_hint": "שתף עדכונים או הערות עם כל מי שיש לו גישה לאתר זה. הם יראו הערות חדשות בזמן אמת.",
  "communication_page_intro_title": "הערות אתר — יומן משותף למיקום זה",
  "communication_page_intro_body": "כאן משאירים העברות משמרת, תקלות, עדכונים והערות מפגשים לצוות. כל מי שיכול לפתוח את האתר בפורטל יכול לקרוא ולהוסיף הערות.",
  "communication_page_intro_dismiss": "הסתר טיפ",
  "communication_page_intro_aria": "אודות הערות האתר",
  "communication_content_placeholder": "כתוב את ההערה שלך כאן...",
  "communication_keyboard_hint": "Ctrl+Enter לשליחה",
  "communication_submitting": "שולח...",
  "communication_submit": "פרסם הערה",
  "communication_recent_notes": "הערות",
  "communication_search_placeholder": "חפש לפי מחבר או טקסט...",
  "communication_refresh": "רענן",
  "communication_clear_filters": "נקה מסננים",
  "communication_search_aria_label": "חיפוש הערות",
  "communication_submit_aria_label": "פרסם הערה",
  "communication_copy_note_aria_label": "העתק את טקסט ההערה",
  "communication_copied": "הועתק ללוח.",
  "communication_copy_empty": "אין טקסט בהערה להעתקה.",
  "communication_filter_hidden_one": "(הערה אחת מוסתרת על ידי מסננים)",
  "communication_filter_hidden_many": "({n} הערות מוסתרות על ידי מסננים)",
  "communication_request_timeout": "הבקשה נכשלה בזמן. נסה שוב.",
  "communication_load_failed": "לא ניתן לטעון הערות.",
  "communication_retry": "נסה שוב",
  "communication_no_matches": "אין הערות התואמות לחיפוש או למסננים. נסה לשנות אותם.",
  "communication_no_entries": "אין עדיין הערות.",
  "communication_no_entries_hint": "הוסף הערה למעלה כדי להתחיל.",
  "communication_just_now": "עכשיו",
  "communication_minutes_ago": "לפני {n} דק'",
  "communication_hours_ago": "לפני {n} שעות",
  "communication_days_ago": "לפני {n} ימים",
  "communication_note_posted": "ההערה פורסמה.",
  "communication_post_failed": "לא ניתן לפרסם הערה. נסה שוב.",
  "communication_note_type": "סוג הערה",
  "communication_type_general": "כללי",
  "communication_type_update": "עדכון",
  "communication_type_issue": "תקלה",
  "communication_type_follow_up": "מעקב",
  "communication_type_meeting": "הערת פגישה",
  "communication_filter_all_types": "כל הסוגים",
  "communication_pinned": "מצורף",
  "communication_pin": "הצמד",
  "communication_unpin": "הסר הצמדה",
  "communication_pin_limit": "מקסימום 2 מוצמדים",
  "communication_pinned_toast": "ההערה הוצמדה.",
  "communication_unpinned_toast": "ההערה בוטלה הצמדה.",
  "communication_pin_failed": "לא ניתן לעדכן הצמדה. נסה שוב.",
  "communication_note_not_found": "ההערה לא נמצאה או שאין לך גישה.",
  "communication_site_not_in_filters": "האתר של ההערה אינו מופיע במסננים הנוכחיים. ייתכן שאין לך גישה לאותו מיקום.",
  "communication_edit": "ערוך",
  "communication_delete": "מחק",
  "communication_save": "שמור",
  "communication_cancel": "בטל",
  "communication_saving": "שומר...",
  "communication_note_updated": "הערה עודכנה.",
  "communication_update_failed": "עדכון הערה נכשל. נסה שוב.",
  "communication_delete_confirm": "האם אתה בטוח שברצונך למחוק את ההערה הזו? פעולה זו לא ניתנת לביטול.",
  "communication_delete_confirm_title": "מחיקת הערה",
  "communication_note_preview": "תצוגה מקדימה של ההערה:",
  "communication_note_deleted": "הערה נמחקה.",
  "communication_delete_failed": "מחיקת הערה נכשלה. נסה שוב.",
  "communication_edited": "נערך",
  "communication_show_more": "הצג עוד",
  "communication_show_less": "הצג פחות",
  "communication_sort_date_newest": "החדש ביותר קודם",
  "communication_sort_date_oldest": "הישן ביותר קודם",
  "communication_sort_author": "לפי מחבר",
  "communication_sort_type": "לפי סוג",
  "communication_sort_pinned": "מצורף קודם",
  "communication_sort_label": "מיון",
  "communication_filter_by_type": "סוג",
  "communication_filters_group_aria": "סינון ומיון הערות",
  "communication_search_label_short": "חיפוש",
  "employees": "עובדים",
  "dayOfWeek": "ימים",
  "service_log": "פירוט החדר",
  "rooms": "חדרים",
  "bulk_add_rooms": "הוספת חדרים במקבץ",
  "adding_to": "מוסיף ל",
  "add_rooms": "הוסף חדרים",
  "room_names_one_per_line": "שמות חדרים (שורה אחת לכל חדר)",
  "enter_at_least_one_room": "יש להזין לפחות שם חדר אחד",
  "room_names_placeholder": "חדר 1\nחדר 2\nשירותי נשים",
  "rooms_with_prefix": "חדרים עם תחילית",
  "apply_to_all_rooms": "החל על כל החדרים (אופציונלי)",
  "bulk_rooms_intro": "הוסף קבוצה אחת או יותר. לכל קבוצה יש בניין, קומה, אזור, מגדר ושמות חדרים משלה.",
  "group": "קבוצה",
  "add_group": "+ הוסף קבוצה נוספת",
  "adding_rooms": "מוסיף חדרים...",
  "bulk_summary": "סיכום",
  "in": "ב",
  "bulk_rooms_success": "{n} חדרים נוספו בהצלחה",
  "displayName": "שם החדר",
  "SLA": "SLA",
  "supervisors": "מפקחים",
  "supervisor": "מפקח",
  "performance_analytics": "סקירת החדר",
  "arrivals": "מנקה",
  "inspections": "ביקורות",
  "avgResponseTime": "זמן תגובה ממוצע",
  "missedSla": "איחורים",
  "cleaner_arrived": "מנקה הגיע/ה",
  "load_more": "טען עוד",
  "login": "התחבר/י",
  "email": "דואל",
  "emails": "כתובות דואל",
  "password": "סיסמא",
  "min": "דק׳",
  "Logout": "התנתק",
  "time_range": "טווח זמן",
  "select_time_range": "בחר טווח זמן",
  "custom_time": "הגדר תאריך",
  "last_day": "אתמול",
  "last_week": "7 ימים אחרונים",
  "last_month": "30 ימים אחרונים",
  "last_quarter": "90 ימים אחרונים",
  "last_6_months": "חצי שנה אחרונה,",
  "last_year": "365 ימים אחרונים",
  "data_by_hour": "נתונים לפי שעה",
  "general": "כללי",
  "cleaning": "ניקיון",
  "maintenance": "תחזוקה",
  "start": "פתיחה",
  "start_time": "זמן התחלה",
  "management_co": "חב ניהול,",
  "cleaning_co": "חב ניקיון,",
  "companies": "חברות",
  "name": "שם",
  "site_count": "אתרים #",
  "associated_companies": "חברות מקושרות",
  "OK": "אשר",
  "cancel": "בטל",
  "client": "לקוח",
  "dates": "תאריכים",
  "shift": "משמרת",
  "issue": "בעיה",
  "time": "זמן",
  "top complaint of the week": "התלונה התדירה ביותר השבוע",
  "top room of the week": "החדר הבעייתי ביותר השבוע",
  "top hour of the week": "השעה הבעייתית ביותר השבוע",
  "top complaint of the month": "התלונה התדירה ביותר החודש",
  "top room of the month": "החדר הבעייתי ביותר החודש",
  "top hour of the month": "השעה הבעייתית ביותר החודש",
  "franchises": "זכייניות",
  "add_franchise": "הוסף זכיינית",
  "room_names": "שם החדר",
  "type": "סוג",
  "please_select_company_site": "אנא בחר חברה ואתר",
  "number": "מספר",
  "create_building_map": "צור מיפוי לבניין",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "היי, הדרך המהירה ביותר לייצר חדרים, קומות ובניינים היא בעזרת האשף המהיר הבא",
  "avg number of toilets per floor": "ממוצע חדרי שירותים בקומה",
  "avg.number of toilet cells per room": "ממוצע תאי שירותים בחדר",
  "number of floors": "מספר הקומות",
  "avg.number of disabled toilets": "ממוצע שירותי לנכים בקומה",
  "avg.number of soap dispensers": "ממוצע מתקני סבון בחדר",
  "reset_filter": "נקה סינון",
  "add": "הוסף",
  "new_survey": "סקר חדש",
  "api_configuration": "הגדרות API",
  "please_edit_the_api_information": "ערוך פרטי API",
  "method": "סוג בקשה",
  "authorization": "הרשאה",
  "api_url": "כתובת בקשה",
  "token": "מפתח",
  "endpoint": "נקודת קצה",
  "add_url": "הוסף כתובת",
  "remove": "הסר",
  "format": "פורמט",
  "auth_api_key": "מפתח API",
  "auth_dynamic_key": "מפתח דינמי (GET)",
  "auth_login_token": "אסימון התחברות (HTTP)",
  "dynamic_token_url": "כתובת אסימון (GET)",
  "token_response_field_name": "שם שדה האסימון בתשובה",
  "token_login_url": "כתובת התחברות",
  "login_request_method": "שיטת בקשת התחברות",
  "login_request_body": "גוף בקשת התחברות (JSON)",
  "login_token_placeholder_hint": "אופציונלי: סוד להחלפת {{token}} ב-JSON של ההתחברות",
  "token_response_key": "שם שדה access token בתשובה",
  "survey_api_auth_header_name": "שם כותרת לאימות (אופציונלי)",
  "survey_api_auth_header_prefix": "טקסט לפני האסימון באותה כותרת",
  "survey_api_auth_header_name_placeholder": "למשל Authorization, X-Api-Key",
  "survey_api_auth_header_prefix_placeholder": "למשל Bearer — הכותרת הסופית: קידום + רווח + אסימון",
  "api_request_info": "מידע לשליחה",
  "roomName": "שם חדר",
  "servikName": "שם תלונה",
  "siteName": "שם אתר",
  "stage": "עמוד",
  "number_of_buttons": "מספר כפתורים",
  "button_shape": "צורת כפתור",
  "delay_time_stage": "זמן המתנה",
  "go_to_stage": "עבור לעמוד",
  "color": "צבע",
  "add_stage": "הוסף עמוד",
  "save": "שמור סקר",
  "number_of_issues": "מספר תלונות",
  "online": "פעיל",
  "offline": "לא פעיל",
  "offline_devices": "מכשירים לא פעילים",
  "no_offline_devices": "לא נמצאו מכשירים לא פעילים",
  "working_devices": "מכשירים פעילים",
  "no_working_devices": "לא נמצאו מכשירים פעילים",
  "room_name": "שם חדר",
  "installation_spot": "מקום",
  "device_id": "מזהה מכשיר",
  "date": "תאריך",
  "status": "סטאטוס",
  "device_status": "סטאטוס מכשיר",
  "none": "אין",
  "no_surveys_created": "אין סקרים",
  "dashboard": "לוח בקרה",
  "franchise_name": "שם זכיין",
  "franchise_country": "מדינת זכיין",
  "choose_franchise": "בחר זכיין",
  "choose_country": "בחר מדינה",
  "select_template": "בחר תבנית",
  "default_survey": "סקר ברירת מחדל",
  "cleaning_survey": "סקר נקיון",
  "kitchen_survey": "סקר מטבח",
  "template": "תבנית",
  "area_name": "שם חלוקה",
  "rooms_names": "שמות חדרים",
  "rooms_number": "חדרים #",
  "assign_number": "אחראי #",
  "active_notification_task": "התראות פעילות",
  "amount_limit": "גבול ספירה",
  "after_max": "גבול התראה",
  "new_area": "איזור עבודה חדש",
  "edit_area": "ערוך איזור עבודה",
  "tablet": "טאבלט",
  "counter women": "קאונטר נשים",
  "counter men": "קאונטר גברים",
  "counter handicap": "קאונטר נכים",
  "counter man/woman": "קאונטר משולב",
  "counter man / woman": "קאונטר משולב",
  "sensor liquid": "חיישן נוזלים",
  "double toilet paper": "חיישן נייר כפול",
  "toilet paper": "חיישן נייר",
  "'counter'": "קאונטר",
  "tag": "טאג",
  "qr tag": "קוד Qr",
  "additional_info": "מידע נוסף לשליחה",
  "servikCategory": "סוג תלונה",
  "dishwashing": "מדיח כלים",
  "cafeteria": "קפיטריה",
  "clean room": "חדר נקי",
  "office": "משרד",
  "meeting room": "חדר ישיבות",
  "cubic": "קיוביק",
  "women": "נשים",
  "men": "גברים",
  "handicap": "נכים",
  "Combined": "משולב",
  "kitchen": "מטבח",
  "east": "מזרח",
  "west": "מערב",
  "north": "צפון",
  "south": "דרום",
  "right": "ימין",
  "left": "שמאל",
  "center": "מרכז",
  "up": "למעלה",
  "down": "למטה",
  "combined": "משולב",
  "lobby": "לובי",
  "entrance": "כניסה",
  "reception": "קבלה",
  "area": "אזור",
  "mezzanine": "מזאני",
  "gallery": "גלריה",
  "ground": "קרקע",
  "elevator": "מעליות",
  "is_calculated": "חישוב חדר",
  "calculated_room": "חישוב חדר",
  "splitted_survey": "סקר מפוצל",
  "redirect_to_url": "הפנה לכתובת",
  "survey_site": "אתר סקר",
  "clicks": "לחיצות",
  "add_stage_number_to_signal": "צרף מספר סקר",
  "including_pad9": "כולל פאד",
  "room_type_required": "יש לבחור סוג חדר לכל קבוצה",
  "Tech Manufacturers": "יצרני הייטק",
  "Tech Offices": "משרדי הייטק",
  "Offices": "משרדים",
  "Terminal": "טרמינל",
  "Universities": "אוניברסיטאות",
  "Factories": "מפעלים",
  "Hospital": "בית חולים",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "חנויות נוחות",
  "Food Chains": "רשתות מזון",
  "Residential": "מגורים",
  "Shopping Center": "קניון",
  "Survey": "סקר",
  "Demo": "הדגמה",
  "Vision": "ויז׳ן",
  "Court": "בית משפט",
  "Office Management": "ניהול משרדים",
  "Government Office": "משרד ממשלתי",
  "default_name": "שם באנגלית",
  "exposures": "חדרי שירותים נקיים שחווינו",
  "exposures_tab": "פעילות חדר",
  "expose_results": "תוצאות",
  "events_expose": "אירועים",
  "expose_score": "שיעור",
  "shift_events_expose": "משמרות חשיפות ואירועים",
  "type_of_site": "סוג האתר",
  "sector": "מגזָר",
  "last_time_of_arrival": "זמן הגעה אחרון",
  "arrival_and_status": "הגעה & מצב",
  "preview_arrivals": "תצוגה מקדימה של כניסות",
  "men toilet": "שירותי גברים",
  "women toilet": "שירותי נשים",
  "shared toilet": "שירותים משולבים",
  "unisex restroom": "שירותים לשני המינים",
  "handicapped toilet": "שירותי נכים",
  "logistics": "לוגיסטיקה",
  "cubicle": "תא",
  "gym": "חדר כושר",
  "morning_shift": "משמרת בוקר",
  "afternoon_shift": "משמרת אחר הצהריים",
  "night_shift": "משמרת לילה",
  "update": "עדכון",
  "restart": "הפעל מחדש",
  "send_data": "שלח נתונים",
  "send_count": "שלח קאונט",
  "blink": "להבהב",
  "beacon": "ביקון",
  "like_btn": "כפתור לייק",
  "requires_like_btn": "דורש שכפתור הלייק יהיה מופעל",
  "maintenance_btn": "כפתור תחזוקה",
  "battery": "סוללה",
  "version": "גרסה",
  "actions": "פעולות",
  "device_actions": "פעולות מכשיר",
  "device_settings": "הגדרות מכשיר",
  "drains_battery": "מרוקן את הסוללה",
  "latest_errors": "שגיאות אחרונות",
  "no_errors": "אין שגיאות",
  "offline_calls": "התראות אופליין",
  "offline_duration_calls": "משך התראות אופליין",
  "counterCalls": "התראות קאונטר",
  "active": "פעיל",
  "no_active_supervisors": "אין מפקחים פעילים",
  "active_supervisors_column": "מפקחים פעילים",
  "supervisors_active_label": "מפקחים פעילים כעת",
  "active_supervisors_coverage_hint": "מפקחים פעילים הפעילו את האזור באפליקציה. זה לא מציין נוכחות מקוונת או פיזית.",
  "site_supervisor_coverage_ok": "כיסוי מלא — {covered}/{total} חדרים עם מפקח פעיל",
  "site_supervisor_coverage_issues": "{count} חדרים ללא מפקח פעיל",
  "site_supervisor_coverage_title": "חדרים ללא מפקח פעיל",
  "uncovered_rooms_title": "חדרים ללא כיסוי",
  "uncovered_working_areas_title": "אזורי עבודה ללא מפקח פעיל",
  "active_calculation": "חישוב פעיל",
  "pad": "פאד",
  "pad_counter": "פאד קאונטר",
  "counter_status": "סטאטוס קאונטר",
  "choose_state": "בחר מחוז",
  "choose_city": "בחר עיר",
  "start_hour": "שעת התחלה",
  "end_hour": "שעת סיום",
  "analytics_log": "לוג ניתוח",
  "or": "או",
  "no_data_available": "אין נתונים",
  "filter_by_cleaner": "סנן לפי מנקה",
  "all_cleaners": "כל המנקים",
  "not_available": "לא זמין",
  "failed_to_load_data": "נכשל בטעינת הנתונים",
  "new_task": "משימה חדשה",
  "temporarily_unavailable": "לא זמין זמנית",
  "category": "קטגוריה",
  "title": "כותרת",
  "task_type": "סוג משימה",
  "task_languages": "שפות המשימה",
  "task_languages_hint": "בחר את השפות עבור משימה זו. תזין את הכותרת בכל שפה שנבחרה.",
  "task_category": "קטגוריה משימה",
  "call_to_action": "קרא לפעולה",
  "schedule": "לוח זמנים",
  "insert_text": "הכנס טקסט",
  "select": "בחר",
  "select_all": "בחר הכל",
  "n_selected": "{count} נבחרו",
  "clear_selection": "נקה בחירה",
  "wa_bulk_edit": "עריכה מרובה",
  "wa_bulk_edit_hint": "החל שינוי אחד על {count} אזורי עבודה שנבחרו.",
  "wa_bulk_action": "מה לשנות?",
  "wa_bulk_set_counter": "קאונטר",
  "wa_bulk_add_task": "הוספת התראת משימה",
  "wa_bulk_remove_task": "הסרת התראת משימה",
  "wa_bulk_enable_counter": "הפעל קאונטר אם כבוי",
  "wa_bulk_apply_to_n": "החל על {count} אזורים",
  "wa_bulk_edit_result": "עודכנו {updated} · ללא שינוי {unchanged} · דולגו {skipped}",
  "wa_bulk_set_counter_desc": "הפעלה/כיבוי קאונטר או הגדרת אותו גבול באזורים שנבחרו",
  "wa_bulk_add_task_desc": "הוספת התראת משימה אחת לאזורים שנבחרו",
  "wa_bulk_remove_task_desc": "הסרת התראת משימה אחת מהאזורים שנבחרו",
  "wa_bulk_enable_counter_hint": "אזורים עם קאונטר כבוי יופעלו",
  "wa_bulk_search_task": "חיפוש התראות משימה",
  "wa_bulk_selected_task": "משימה שנבחרה",
  "wa_bulk_counter_state": "סטטוס קאונטר",
  "wa_bulk_counter_on": "הפעלה",
  "wa_bulk_counter_off": "כיבוי",
  "wa_bulk_counter_unchanged": "שמור סטטוס",
  "wa_bulk_counter_on_hint": "הפעלת קאונטר בכל האזורים שנבחרו והגדרת הגבול",
  "wa_bulk_counter_off_hint": "כיבוי קאונטר בכל האזורים שנבחרו",
  "wa_bulk_counter_unchanged_hint": "עדכון הגבול בלבד; בלי לשנות פעיל/כבוי",
  "wa_bulk_task_coverage_remove": "{withTask} מתוך {total} אזורים שנבחרו כוללים משימה זו · {willChange} יעודכנו",
  "wa_bulk_task_coverage_add": "{withTask} מתוך {total} אזורים שנבחרו כבר כוללים משימה זו · {willChange} יעודכנו",
  "schedule_dates": "תאריכי לוח זמנים",
  "language": "שפה",
  "calendar": "לוח שנה",
  "operation": "פעולה",
  "daily": "יומי",
  "weekly": "שבועי",
  "monthly": "חודשי",
  "quarterly": "רבעוני",
  "yearly": "שנתי",
  "sunday": "ראשון",
  "monday": "שני",
  "tuesday": "שלישי",
  "wednesday": "רביעי",
  "thursday": "חמישי",
  "friday": "שישי",
  "saturday": "שבת",
  "january": "ינואר",
  "february": "פברואר",
  "march": "מרץ",
  "april": "אפריל",
  "may": "מאי",
  "june": "יוני",
  "july": "יולי",
  "august": "אוגוסט",
  "september": "ספטמבר",
  "october": "אוקטובר",
  "november": "נובמבר",
  "december": "דצמבר",
  "1st week": "שבוע 1",
  "2nd week": "שבוע 2",
  "3rd week": "שבוע 3",
  "4th week": "שבוע 4",
  "5th week": "שבוע 5",
  "1st quarter": "רבעון 1",
  "2nd quarter": "רבעון 2",
  "3rd quarter": "רבעון 3",
  "4th quarter": "רבעון 4",
  "edit_task": "ערוך משימה",
  "created_at": "נוצר ב",
  "installed_at": "הותקן ב",
  "hour": "שעה",
  "week_days": "ימי השבוע",
  "month_weeks": "שבועות בחודש",
  "month_days": "ימים בחודש",
  "no_tasks_found": "לא נמצאו משימות",
  "invalid_language": "שפה לא חוקית",
  "no_active_tasks_found": "לא נמצאו משימות פעילות",
  "edit": "ערוך",
  "send_date": "תאריך שליחה",
  "invalid_date": "תאריך לא חוקי",
  "hour_must_be_after_current": "אנא בחר שעה שעדיין לא עברה",
  "cells_num": "# תאים",
  "sinks_num": "# כיורים",
  "urinals_num": "# משתנות",
  "toilet_paper_size": "גודל ניירות כלים",
  "email_configuration": "הגדרות דואר אלקטרוני",
  "please_edit_the_email_information": "נא לערוך את פרטי הדואר האלקטרוני",
  "email_sender_info": "פרטי שולח הדואר האלקטרוני",
  "email_subject_info": "פרטי נושא הדואר האלקטרוני",
  "email_message_info": "פרטי הודעת הדואר האלקטרוני",
  "companyName": "שם החברה",
  "email_language": "שפת הדואר האלקטרוני",
  "complaint_language": "שפת התלונה",
  "email_message_format": "פורמט הודעת הדואר האלקטרוני",
  "line": "שורה",
  "list": "רשימה",
  "roomType": "סוג חדר",
  "By logging in, you agree to Buzzztech's": "בהתחברות, אתה מסכים לתנאי שימוש של באזזטק",
  "Terms and Conditions": "תנאי שימוש",
  "and": "ו",
  "Privacy Policy": "מדיניות הפרטיות",
  "All actions within this panel are recorded for quality control and improvement": "כל הפעולות בלוח זה נקלטות לשם בקרה ושיפור איכות",
  "You must agree to the terms and conditions": "עליך להסכים לתנאי השימוש",
  "months": "חודשים",
  "ref_id": "מזהה פניה",
  "room_name_en": "שם חדר באנגלית",
  "site_state": "איזור",
  "state":"איזור",
  "site_city": "עיר",
  "city":"עיר",
  "site_country": "מדינה",
  "first_date": "תאריך ראשון",
  "pinned": "נעוץ",
  "no.": "מס.",
  "must_be_numbers": "חייב להיות מספרים",
  "must_be_3_digits": "חייב להיות 3 ספרות",
  "must_have_english_title": "חייב להיות כותרת באנגלית",
  "total_sites": "סה\"כ",
  "site_information": "פרטי אתר",
  "holiday_offdays": "חגים & חופשות",
  "add_offday": "חופשה",
  "add_holiday": "חג",
  "name_under_chars": "שם תקין עד 25 תווים",
  "days_comma_separated": "תאריכים תקינים, מופרדים בפסיק",
  "year": "שנה",
  "month": "חודש",
  "day": "יום",
  "holiday_name": "שם חג",
  "offday_name": "שם חופשה",
  "delete_confirmation_title": "האם אתה בטוח?",
  "delete_confirmation_message": "פעולה זו לא ניתנת לביטול.",
  "are_you_sure": "האם אתה בטוח?",
  "israel": "ישראל",
  "USA": "ארצות הברית",
  "poland": "פולין",
  "mexico": "מקסיקו",
  "cyprus": "קפריסין",
  "brazil": "ברזיל",
  "romania": "רומניה",
  "netherlands": "הולנד",
  "Purim Eve": "ערב פורים",
  "Aliyah Day": "יום העלייה",
  "Passover Eve": "ערב פסח",
  "Passover (Day 1)": "פסח",
  "Passover (Day 2)": "א חוה\"מ",
  "Passover (Day 3)": "ב חוה\"מ",
  "Passover (Day 4)": "ג חוה\"מ",
  "Passover (Day 5)": "ד חוה\"מ",
  "Passover (Day 6)": "שביעי של פסח",
  "Passover (Day 7)": "איסרו חג",
  "Yom HaShoah": "יום השואה",
  "Yom HaZikaron": "יום הזיכרון",
  "Yom HaAtzmaut": "יום העצמאות",
  "Jerusalem Day": "יום ירושלים",
  "Shavuot Eve": "ערב שבועות",
  "Shavuot": "שבועות",
  "Tisha B'Av Eve": "ערב תשעה באב",
  "Tisha B'Av": "תשעה באב",
  "Rosh Hashana Eve": "ערב ראש השנה",
  "Rosh Hashana": "ראש השנה",
  "Rosh Hashana (Day 2)": "ראש השנה",
  "Yom Kippur Eve": "ערב יום כיפור",
  "Yom Kippur": "יום כיפור",
  "Sukkot Eve": "ערב סוכות",
  "Sukkot (Day 1)": "סוכות",
  "Sukkot (Day 2)": "א חוה\"מ",
  "Sukkot (Day 3)": "ב חוה\"מ",
  "Sukkot (Day 4)": "ג חוה\"מ",
  "Sukkot (Day 5)": "ד חוה\"מ",
  "Sukkot (Day 6)": "ה חוה\"מ",
  "Sukkot (Day 7) / Hoshanah Rabah": "הושענא רבה",
  "Shemini Atzeret / Simchat Torah": "שמחת תורה",
  "Aliyah Day School Observance": "יום העלייה בבתי הספר",
  "Hanukkah (Day 1)": "חנוכה",
  "Hanukkah (Day 2)": "חנוכה",
  "Hanukkah (Day 3)": "חנוכה",
  "Hanukkah (Day 4)": "חנוכה",
  "Hanukkah (Day 5)": "חנוכה",
  "Hanukkah (Day 6) / Rosh Chodesh Tevet": "חנוכה",
  "Hanukkah (Day 7)": "חנוכה",
  "Hanukkah (Day 8)": "חנוכה",
  "tablet_survey": "סקר טאבלט",
  "no_shift_survey": "סקר ללא משמרת",
  "number_of_rows": "מספר שורות",
  "rating_shape": "צורת הדירוג",
  "content_survey": "סקר תוכן",
  "rating_survey": "סקר דירוג",
  "device-alerts": "בעיות",
  "device-active": "פעילים",
  "device-search": "חיפוש",
  "mac_id": "כתובת MAC",
  "qr_tag": "תג QR",
  "sensor": "חיישן",
  "image_survey": "סקר תמונה",
  "open_text": "טקסט פתוח",
  "open_text_survey": "סקר טקסט פתוח",
  "embedded_link": "קישור מוטמע",
  "device-counter": "מונים",
  "count": "מספר פעמים",
  "last_date": "תאריך אחרון",
  "last_arrival":"הגעת מנקה אחרונה",
  "cleaners": "מנקים",
  "viewer": "צופה",
  "android": "אנדרואיד",
  "ios": "אייפון",
  "no_users_found": "לא נמצאו משתמשים",
  "cleaner_activity": "פעילות מנקים",
  "pad_presence_testing": "בדיקת נוכחות פד",
  "pad_presence_testing_subtitle": "כניסה, יציאה ולחיצות פד לא מקוונות שנשלחו מהטלפון באתר שנבחר",
  "pad_presence_timeline": "ציר זמן חי",
  "pad_presence_sessions": "סשנים של נוכחות",
  "pad_presence_offline_presses": "לחיצות לא מקוונות מהטלפונים",
  "pad_presence_select_site_hint": "בחר חברה ואתר בכותרת כדי לצפות באירועי נוכחות.",
  "pad_presence_no_events": "אין אירועי נוכחות בחלון זה.",
  "pad_presence_open": "פתוח",
  "pad_presence_exit_phone": "יציאה מהטלפון",
  "pad_presence_exit_auto": "יציאה אוטומטית",
  "pad_presence_exit_stale": "יציאה ישנה",
  "pad_presence_enter": "כניסה",
  "pad_presence_exit": "יציאה",
  "pad_presence_offline": "לחיצה לא מקוונת",
  "pad_presence_faulty": "שגוי",
  "pad_presence_employee": "עובד",
  "pad_presence_room": "חדר",
  "pad_presence_time_from": "מ",
  "pad_presence_last_updated": "עודכן",
  "pad_presence_duration": "משך",
  "pad_presence_exit_type": "סוג יציאה",
  "pad_presence_button": "כפתור",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "ספירה",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "כל העובדים",
  "pad_presence_all_rooms": "כל החדרים",
  "pad_presence_load_error": "לא ניתן לטעון נתוני נוכחות פד.",
  "pad_presence_in_room_now": "נמצא בחדר כעת",
  "pad_presence_in_room": "ב",
  "pad_presence_since": "מאז",
  "pad_presence_just_now": "ממש עכשיו",
  "pad_presence_pad": "פד",
  "pad_presence_phone": "טלפון",
  "pad_presence_all_phones": "כל הטלפונים",
  "pad_presence_window": "הצג",
  "pad_presence_window_hour": "שעה אחרונה",
  "pad_presence_window_today": "היום",
  "pad_presence_window_month": "חודש אחרון",
  "pad_presence_pads": "פדים באתר זה",
  "pad_presence_no_pads": "לא משויכים פדים לחדרים באתר זה.",
  "pad_presence_last_enter": "כניסה אחרונה",
  "pad_presence_last_offline": "לחיצה לא מקוונת אחרונה",
  "pad_presence_auto_exit_leave": "צא עכשיו → יציאה אוטומטית בעוד",
  "pad_presence_auto_exit_earliest": "המוקדם ביותר מכניסה:",
  "pad_presence_auto_exit_passed": "חלף המועד המוקדם ליציאה אוטומטית. עדיין פתוח = הפד עדיין נשמע, או צא והמתן 5 דק׳ 45 שנ׳.",
  "cleaner_activity_live_footer": "הנתונים מתעדכנים בזמן אמת",
  "ca_empty_select_site_hint": "בחר חברה ואתר בכותרת כדי לצפות בפעילות המנקים להיום.",
  "ca_empty_no_cleaners_hint": "אין מנקים המשויכים לאתר זה ולמשמרת הנוכחית. הקצה אתרים פעילים ומשמרות במסך משתמשים.",
  "ca_empty_access_denied": "גישה נדחתה",
  "ca_empty_access_denied_hint": "אין לך הרשאה לצפות בפעילות המנקים באתר זה.",
  "ca_empty_load_error_hint": "לא ניתן לטעון את פעילות המנקים. נסה שוב או פנה לתמיכה אם הבעיה נמשכת.",
  "ca_empty_no_filter_match": "אין מנקים התואמים למסננים האלה",
  "ca_empty_no_filter_match_hint": "נסה לנקות את המסננים או לבחור מנק, אזור עבודה או חדר אחר.",
  "ca_timeline_all_cleaners": "פעילות היום — כל המנקים",
  "ca_legend_work": "פעיל",
  "ca_clock_sessions_more": "נוספים",
  "ca_clock_sessions_less": "הצג פחות",
  "ca_sort_label": "מיון",
  "ca_sort_needs_attention": "דורש תשומת לב",
  "ca_sort_best_avg_response": "זמן תגובה ממוצע הטוב ביותר",
  "ca_sort_worst_avg_response": "זמן תגובה ממוצע הגרוע ביותר",
  "ca_sort_most_sla_breaches": "הכי הרבה הפרות SLA",
  "ca_sort_most_open_complaints": "הכי הרבה תלונות פתוחות",
  "ca_sort_most_work_time": "הכי הרבה זמן עבודה",
  "ca_sort_least_work_time": "הכי מעט זמן עבודה",
  "ca_stat_avg_short": "ממוצע",
  "ca_stat_open_short": "פתוח",
  "ca_stat_breach_short": "הפרה",
  "ca_stat_work_short": "עבודה",
  "ca_assigned_room_avg_hint": "זמן תגובה ממוצע לחדרים משויכים היום",
  "ca_transit_tooltip": "זמן מעבר בין משימות",
  "ca_transit_live_tooltip": "זמן שחלף מאז סגירת המשימה האחרונה",
  "ca_legend_visits": "מבקרים בין קריאות",
  "ca_visits_between_sla": "מבקרים מאז סגירת הקריאה הקודמת",
  "ca_apply": "החל",
  "ca_visits_since": "מאז",
  "ca_deferred_tip_title": "תלונה שנדחתה",
  "ca_deferred_tip_resolved": "טופלה",
  "ca_deferred_tip_desc_open": "עדיין פתוחה — המנקה טיפל/ה בחדרים אחרים תחילה במקום בתלונה הזו.",
  "ca_deferred_tip_desc_closed": "התלונה נותרה פתוחה בזמן שהמנקה טיפל/ה בחדרים אחרים תחילה.",
  "ca_deferred_tip_rooms_label": "טופלו תחילה:",
  "ca_attention_title": "דורש תשומת לב",
  "ca_attention_empty": "הכל תקין — אין בעיות כרגע",
  "ca_attention_sla_breach_one": "{name} · הפרת SLA",
  "ca_attention_sla_breach_many": "{name} · {count} הפרות SLA",
  "ca_attention_open_while_out_one": "{name} · תלונה פתוחה בזמן יציאה",
  "ca_attention_open_while_out_many": "{name} · {count} פתוחות בזמן יציאה",
  "ca_attention_idle": "{name} · לא פעיל {duration}",
  "ca_attention_late": "{name} · נכנס/ה באיחור",
  "ca_attention_show": "הצג",
  "ca_attention_hide": "הסתר",
  "ca_view_shift": "משמרת",
  "ca_view_history": "היסטוריה",
  "ca_hist_preset_this_month": "החודש",
  "ca_hist_preset_last_month": "חודש שעבר",
  "ca_hist_preset_this_week": "השבוע",
  "ca_hist_preset_last_week": "שבוע שעבר",
  "ca_hist_preset_custom": "מותאם אישית",
  "ca_hist_from": "מתאריך",
  "ca_hist_to": "עד תאריך",
  "ca_hist_people_count": "{count} עובדים",
  "ca_filters_done": "סיום",
  "ca_hist_range_too_long": "הטווח יכול להיות עד {max} ימים",
  "ca_hist_range_invalid": "תאריך ההתחלה חייב להיות לפני תאריך הסיום",
  "ca_hist_search": "חיפוש לפי שם או טלפון",
  "ca_hist_kpi_days": "ימי עבודה",
  "ca_hist_kpi_net": "שעות נטו",
  "ca_hist_kpi_breaks": "הפסקות",
  "ca_hist_empty": "אין נוכחות בתקופה זו",
  "ca_hist_empty_hint": "אף אחד לא החתים כניסה באתר זה ואין מנקים משויכים אליו.",
  "ca_hist_no_match": "אין עובדים התואמים לסינון",
  "ca_hist_load_error_hint": "לא ניתן היה לטעון את היסטוריית הנוכחות. נסו שוב בעוד רגע.",
  "ca_hist_col_person": "עובד",
  "ca_hist_col_total": "סך שעות",
  "ca_hist_col_total_tip": "מכניסה ועד יציאה לפני הפסקות, אותו נתון שהעובד רואה באפליקציה",
  "ca_hist_col_net": "שעות נטו",
  "ca_hist_col_breaks": "הפסקות",
  "ca_hist_col_issues": "בעיות",
  "ca_hist_col_late": "איחורים",
  "ca_hist_col_missed": "היעדרויות",
  "ca_hist_col_no_clock_out": "ללא יציאה",
  "ca_hist_unknown_name": "לא ידוע",
  "ca_hist_not_assigned": "לא משויך לאתר זה",
  "ca_hist_no_shift": "לא משויכת משמרת",
  "ca_hist_clocked_in_now": "בעבודה כעת",
  "ca_hist_auto": "אוטומטי",
  "ca_hist_late_by": "איחור {duration}",
  "ca_hist_late_tip": "כניסה ב-{time}, {shift} מתחילה ב-{start}",
  "ca_hist_missed": "נעדר/ת",
  "ca_hist_missed_tip": "המשמרת המתוכננת הסתיימה ללא כניסה",
  "ca_hist_no_clock_out": "ללא יציאה",
  "ca_hist_no_clock_out_tip": "המשמרת לא נסגרה; השעות שלה לא נספרות",
  "ca_hist_in_progress": "עדיין בעבודה",
  "ca_hist_open_break": "פתוחה",
  "ca_hist_day_col_gross": "סך שעות",
  "ca_hist_day_col_breaks": "הפסקות",
  "ca_hist_legend_worked": "עבד/ה",
  "ca_hist_legend_late": "איחור",
  "ca_hist_legend_missed": "נעדר/ת",
  "ca_hist_legend_no_clock_out": "ללא יציאה",
  "ca_hist_prev_person": "העובד הקודם",
  "ca_hist_next_person": "העובד הבא",
  "ca_hist_close": "סגור",
  "active_cleaners": "מנקים פעילים",
  "closed_complaints": "תלונות שנסגרו",
  "total_work_time": "סה\"כ זמן עבודה",
  "total_work_time_net": "סה\"כ זמן עבודה (נטו היום)",
  "total_break_time": "סה\"כ זמן הפסקה",
  "avg_response_time": "ממוצע טיפול",
  "cleaner": "מנקה",
  "clocked_in": "החתים כניסה",
  "clocked_out": "החתים יציאה",
  "still_clocked_in": "עדיין בכניסה",
  "clocked_in_late": "החתים כניסה באיחור",
  "total_hours": "סך שעות",
  "auto_punch": "אוטומטי (גיאופנסינג)",
  "manual_punch": "ידני",
  "complaint_opened": "תלונה נפתחה",
  "complaint_closed": "תלונה נסגרה",
  "complaint_still_open": "עדיין פתוחה",
  "resolved_in": "נפתר בתוך",
  "open_for": "פתוח כבר",
  "sla_breached": "חריגת SLA",
  "no_activity_today": "אין עדיין פעילות היום",
  "just_now": "ממש עכשיו",
  "ago": "לפני",
  "today": "היום",
  "live": "בשידור חי",
  "last_updated": "עודכן",
  "no_cleaners_found": "לא נמצאו מנקים",
  "new_cleaner": "מנקה חדש",
  "edit_cleaner": "ערוך מנקה",
  "have_you_finished_making_changes": "האם סיימת לבצע שינויים?",
  "assignment_issues_found": "נמצאו בעיות בשיוכים",
  "unassigned_rooms_title": "חדרים ללא שיוך",
  "overlapping_assignments_title": "חפיפות שיוך",
  "and_n_more": "ועוד {count}",
  "continue_anyway": "המשך בכל זאת",
  "stay_and_fix": "הישאר ותקן",
  "assignment_coverage_issues": "{unassigned} ללא שיוך · {overlaps} חפיפות",
  "assignment_check_failed": "לא ניתן לבדוק את שיוכי החדרים",
  "tap_for_details": "לחץ לפרטים",
  "has_app": "אפליקציה",
  "has_app_tooltip": "העובד מחובר לאפליקציה",
  "notifications_tooltip": "התראות פוש פעילות",
  "assigned_to_rooms": "משויך לחדרים",
  "assigned_to_rooms_tooltip": "משויך לחדרים באתר",
  "recently_active": "פעיל לאחרונה",
  "works_at_site": "עובד באתר",
  "recently_active_tooltip": "נכנס לאפליקציה ב-30 הדקות האחרונות",
  "please_select": "אנא בחר",
  "please_select_site_first": "אנא בחר אתר תחילה",
  "working_areas": "אזורי עבודה",
  "no_working_areas": "אין עדיין אזורי עבודה",
  "working_area_alerts": "התראות",
  "api": "API",
  "task_target_by_working_areas": "לפי אזורי עבודה (כל החדרים באזורים שנבחרו)",
  "task_target_by_rooms": "לפי חדרים ספציפיים",
  "task_target_label": "המשימה נפתחת ב",
  "step_what": "מה",
  "step_when": "מתי",
  "step_where": "איפה",
  "step_options": "אפשרויות",
  "please_create_room_before_working_area": "אנא צור לפחות חדר אחד לפני יצירת אזור עבודה",
  "isWorkingInSite": "עובד באתר",
  "you_are_not_allowed_to_edit": "אין לך הרשאה לערוך",
  "you_are_not_allowed_to_remove": "אין לך הרשאה למחוק",
  "task": "משימה",
  "portuguese": "פורטוגזית",
  "russian": "רוסית",
  "spanish": "ספרדית",
  "polish": "פולנית",
  "installer": "מתקין",
  "once": "פעם אחת",
  "time_saved": "זמן שנחסך",
  "yes": "כן",
  "no": "לא",
  "workingAreaNames": "שמות אזורי עבודה",
  "shift_rooms":"חדרים",
  "shift_validation_overlap": "משמרת זו חופפת עם \"{shiftName}\" בחדר \"{roomName}\". הסר את החדר מאחת המשמרות או שנה את שעות העבודה.",
  "shift_validation_missing_fields": "יש למלא את כל שדות החובה של המשמרת (שעות, ימים ואתר).",
  "shift_validation_empty_rooms": "יש לשייך לפחות חדר אחד למשמרת.",
  "shift_validation_no_valid_rooms": "לא נבחרו חדרים תקינים למשמרת.",
  "shift_validation_empty_room_map": "לא ניתן לבנות את לוח הזמנים של המשמרת. בדוק את הימים והשעות שנבחרו.",
  "new_shift":"משמרת חדשה",
  "add_shift_inactive": "הוספת משמרות שיקוף",
  "remove_auto_shift_inactive": "הסרת משמרות שיקוף אוטומטיות",
  "additional_options": "אפשרויות נוספות",
  "add_default_shifts": "הוספת משמרות קבועות מראש",
  "no_user_found": "לא נמצא משתמש",
  "no_site_found": "לא נמצא אתר",
  "service_provider": "ספק שירות",
  "qr task": "משימת QR",
  "qr_task": "משימות QR",
  "all_day": "כל היום",
  "auto_start": "התחלה אוטומטית",
  "more_options": "אפשרויות נוספות",
  "english_title": "כותרת באנגלית",
  "connectivity": "קישוריות",
  "power": "כוח",
  "Your work has been saved": "העבודה שלך נשמרה",
  "schedule_call_time": "זמן תלונה",
  "schedule_call_gap": "פער זמן תלונה",
  "gapInMinutes": "פער בדקות",
  "no_manual_calls_available": "אין תלונות ידניות זמינות",
  "manual_calls": "תלונות ידניות",
  "cleandex_calls": "תלונות קלינדקס",
  "cleandexCalls": "תלונות קלינדקס",
  "manualCalls": "תלונות ידניות",
  "inactive": "לא פעיל",
  "on hold": "בהקפאה",
  "sequential": "רצף",
  "ratio": "יחס",
  "must_choose": "חייב לבחור",
  "surveyApp": "אפליקציית סקר",
  "installation": "התקנה",
  "manager": "מנהל",
  "buzzz": "באזזז",
  "previous": "קודם",
  "no_rooms_found": "לא נמצאו חדרים",
  "show_calendar": "הצג לוח שנה",
  "seeAll": "ראה הכל",
  "showPaginated": "הצג בעמודים",
  "cleaners_arrivals": "הגעות מנקים",
  "add_address": "הוסף כתובת",
  "site_auto_attendance_enabled":
    "אפשר רישום כניסה ויציאה אוטומטיים דרך גדר גיאוגרפית באפליקציה לנייד (נדרש הרשאת מיקום למשתמשים).",
  "site_auto_attendance_requires_location":
    "יש להגדיר במפה נקודה והקפה ברדיוס של לפחות 100 מ׳ לפני הפעלת הנוכחות האוטומטית.",
  "site_mandatory_clock_in": "חובה להחתים כניסה לפני העבודה",
  "site_mandatory_clock_in_description":
    "עובדים באתר זה חייבים להחתים כניסה לפני שיוכלו לפתוח את לשוניות הניקיון, האחזקה והמשימות באפליקציה.",
  "site_mandatory_clock_in_without_location":
    "לאתר זה לא הוגדר מיקום במפה, ולכן האפליקציה לא יכולה לזהות מתי העובד נמצא באתר. עד שיוגדר מיקום, הדרישה תחול על עובדים אלה בכל מקום.",
  "edit_address": "ערוך כתובת",
  "choose_radius": "בחר רדיוס",
  "cleandex": "קלינדקס",
  "cleandex_column_tooltip": "ירוק = בסדר. אדום = מומלץ לניקוי. ריחוף על האייקון לפרטים.",
  "recommended_to_clean": "מומלץ לניקוי",
  "cleandex_warning_level": "רמת אזהרה קלינדקס",
  "select_warning_level": "בחר רמת אזהרה",
  "bronze": "ברונזה",
  "silver": "כסף",
  "gold": "זהב",
  "ai": "בינה מלאכותית",
  "daily_employees_num": "מספר עובדים יומי",
  "daily_shift_hours": "שעות משמרת יומית",
  "rooms_num": "מספר חדרים",
  "buildings_num": "מספר מבנים",
  "cleaner_entries": "מספר כניסות מנקים",
  "avg_daily_visits_monthly": "ממוצע כניסות יומיות חודשי",
  "avg_daily_cleaners_to_save": "ממוצע מנקים יומי לחיסכון",
  "saving_hours_per_day": "שעות חיסכון ביום",
  "saving_money_per_day": "חיסכון כספי יומי",
  "saving_money_per_month": "חיסכון כספי חודשי",
  "cleaners_to_visitors_ratio": "יחס מנקים למבקרים",
  "cleaning_time_in_minutes_per_room": "זמן ניקיון בדקות לחדר",
  "max_number_of_rooms_per_employee": "מספר חדרים מקסימלי לעובד", 
  "break_time_per_hour": "זמן הפסקה בשעה",
  "transition_time_between_tasks": "זמן מעבר בין משימות",
  "employer_cost_hour": "שעת עלות מעביד",
  "lobby_cleaning_per_floor": "ניקוי לובי לקומה",
  "desired_cleaning_time": "זמן ניקוי רצוי",
  "desired_number_of_entries": "כמות כניסות רצוי",
  "buzz_system_cost_per_unit_per_month": "עלות מערכת באזזז ליחידה לחודש",
  "total_buzz_system_cost_per_month": "עלות כוללת של מערכת באזזז לחודש",
  "return_on_investment_in_months": "החזר על ההשקעה בחודשים",
  "annual_savings": "חיסכון שנתי",
  "roi_calculator": "מחשבון החזר על השקעה",
  "cleaners_number": "מספר מנקים",
  "floors_num": "מספר קומות",
  "avg_daily_cleaners_required": "ממוצע מנקים יומיים נדרשים",
  "app_pages": "עמודי אפליקציה",
  "buzzzTime": "באזזז טיים",
  "missions": "משימות",
  "send_emails": "שלח דוא\"ל",
  "enter": "הכנס",
  "account": "חשבון",
  "privacy": "פרטיות",
  "personal_settings": "הגדרות אישיות",
  "personal_settings_lead": "ניהול שפה והעדפות פרטיות.",
  "personal_settings_read_only": "הפרטים מנוהלים על ידי המנהל. פנו אליו לעדכון.",
  "change_password": "שינוי סיסמה",
  "change_password_hint": "שינוי הסיסמה ינתק אתכם משאר המכשירים.",
  "current_password": "סיסמה נוכחית",
  "new_password": "סיסמה חדשה",
  "confirm_new_password": "אימות סיסמה חדשה",
  "password_min_length": "הסיסמה חייבת להכיל לפחות 8 תווים",
  "passwords_do_not_match": "הסיסמאות אינן תואמות",
  "new_password_same_as_current": "הסיסמה החדשה חייבת להיות שונה מהסיסמה הנוכחית",
  "current_password_incorrect": "הסיסמה הנוכחית שגויה",
  "current_password_required": "יש להזין את הסיסמה הנוכחית",
  "password_changed_successfully": "הסיסמה שונתה בהצלחה",
  "change_password_failed": "לא ניתן לשנות את הסיסמה",
  "forgot_password": "שכחתם סיסמה?",
  "forgot_password_title": "שכחתם סיסמה",
  "forgot_password_hint": "הזינו את כתובת האימייל של חשבון הפאנל ונשלח קישור לאיפוס אם החשבון קיים.",
  "forgot_password_sent": "אם קיים חשבון עבור האימייל, נשלח קישור לאיפוס. בדקו את תיבת הדואר.",
  "forgot_password_invalid_email": "נא להזין כתובת אימייל תקינה",
  "forgot_password_failed": "לא ניתן לשלוח את מייל האיפוס. נסו שוב.",
  "send_reset_link": "שליחת קישור לאיפוס",
  "back_to_login": "חזרה להתחברות",
  "reset_password": "איפוס סיסמה",
  "reset_password_hint": "בחרו סיסמה חדשה לחשבון.",
  "reset_password_missing_token": "קישור האיפוס חסר. בקשו קישור חדש ממסך ההתחברות.",
  "reset_password_invalid_token": "קישור האיפוס אינו תקף או שפג תוקפו. בקשו קישור חדש.",
  "reset_password_failed": "לא ניתן לאפס את הסיסמה",
  "password_reset_successfully": "הסיסמה אופסה בהצלחה. ניתן להתחבר עם הסיסמה החדשה.",
  "login_invalid_credentials": "שם משתמש או סיסמה שגויים",
  "login_credentials_required": "יש להזין שם משתמש או אימייל וסיסמה",
  "login_network_error": "לא ניתן להתחבר לשרת. בדקו את החיבור ונסו שוב",
  "login_failed": "לא ניתן להתחבר. נסו שוב",
  "login_too_many_attempts": "יותר מדי ניסיונות כניסה. המתינו 15 דקות ונסו שוב.",
  "forgot_password_too_many": "יותר מדי בקשות לאיפוס סיסמה. המתינו שעה ונסו שוב.",
  "reset_password_too_many": "יותר מדי ניסיונות לאיפוס סיסמה. המתינו שעה ונסו שוב.",
  "change_password_too_many": "יותר מדי ניסיונות לשינוי סיסמה. המתינו 15 דקות ונסו שוב.",

  "personal_settings_language_hint": "חל על כל הפורטל בדפדפן זה.",
  "personal_settings_privacy_hint": "בקשת מחיקת נתונים אישיים לפי חוקי פרטיות.",
  "personal_settings_export_hint": "הורדת עותק JSON של הנתונים האישיים שאנו מחזיקים עליך: פרופיל הפורטל, אתרים שאליהם יש לך גישה, ופרופיל האפליקציה (כשמספר הטלפון תואם). מספר הורדות מוגבל ליום.",
  "Download my data": "הורדת הנתונים שלי",
  "personal_settings_role": "תפקיד",
  "Request deletion of my data": "בקשת מחיקת הנתונים שלי",
  "Request deletion of my data - confirm": "לבקש מחיקת הנתונים שלי? יישלח מייל למנהל. נטפל בבקשה תוך 30 יום.",
  "Request deletion of my data - success": "הבקשה נשלחה. נטפל בה תוך 30 יום.",
  "Request deletion of my data - error": "שליחת הבקשה נכשלה. נסה שוב או כתוב ל-privacy@buzzztech.com.",
  "metrics": "מדדים",
  "select_three_metrics": "בחר עד שלושה מדדים להשוואה",
  "select_four_metrics": "בחר עד ארבעה מדדים להשוואה",
  "legend": "מקרא",
  "more_details": "פרטים נוספים",
  "performance_overview": "סקירת ביצועים",
  "loading_chart": "טוען תרשים",
  "retry": "נסה שוב",
  "performance_trending_upward": "המגמה מציגה שיפור בביצועים",
  "high_complaint_ratio": "שיעור תלונות גבוה",
  "click_bars_for_details": "לחץ על העמודות לצפייה באנליטיקה יומית",
  "refresh": "רענן",
  "table": "טבלה",
  "cards": "קלפים",
  "no_recent_arrivals": "אין הגעות אחרונות",
  "feedback_charts": "תרשימי משוב",
  "general_overview": "סקירה כללית",
  "cleaning_complaints_breakdown": "פילוח תלונות ניקיון",
  "maintenance_complaints_breakdown": "פילוח תלונות תחזוקה",
  "refresh_failed": "הרענון נכשל",
  "data_exported_successfully": "הנתונים יוצאו בהצלחה",
  "data_export_failed": "ייצוא הנתונים נכשל",
  "analytics_export_confirm": "להוריד קבצי CSV של האנליטיקס?",
  "analytics_export_title": "ייצוא נתוני אנליטיקס",
  "analytics_export_description": "יורד קובץ ZIP עם נתוני האנליטיקס המסוננים — סיכום, גרף, שעות, חדרים והגעות מנקים/מפקחים.",
  "download": "הורדה",
  "analytics_export_blocked_loading": "נתוני האנליטיקס עדיין נטענים. אנא המתן ונסה שוב.",
  "analytics_export_blocked_no_data": "אין נתוני אנליטיקס לייצוא. החל מסננים והמתן לטעינת הדף.",
  "analytics_export_blocked_stale_filters": "המסננים השתנו. החל מסננים והמתן לטעינה מחדש לפני הייצוא.",
  "executive_report_period_title": "הדוח מציג חודש מלא",
  "executive_report_period_description": "הדוח הניהולי נבנה תמיד לחודש קלנדרי שלם, ולכן הנתונים בו לא יתאימו לטווח המוצג כעת במסך.",
  "executive_report_period_selected": "הטווח שנבחר",
  "executive_report_period_used": "הדוח יכסה",
  "drill_down_unavailable": "ניתוח לעומק זמין רק בתצוגה יומית",
  "sort_by": "מיין לפי",
  "no_active_shift": "אין משמרת פעילה",
  "check_site_and_shift": "אנא בדוק אם נבחר אתר ויש משמרת פעילה",
  "please_add_shift_first": "אנא הוסף משמרת תחילה",
  "cleandex_no_data_message": "אין כרגע נתוני Cleandex זמינים",
  "task_no_data_message": "אין כרגע נתוני משימות זמינים",
  "navigation": "ניווט",
  "network_information": "מידע רשת",
  "target_effectiveness": "יעילות המטרה",
  "cleandex_call_cleaner": "תלונת קלינדקס למנקה",
  "top_complaint": "תלונה תדירה",
  "no_complaints": "אין תלונות",
  "official_start_date": "תאריך התחלה רשמי",
  "note_text": "הערה",
  "add_note": "הוסף הערה",
  "general_note": "הערה כללית",
  "general_note_short": "כללי",
  "battery_short": "סוללה",
  "panel_short": "לוח",
  "technician_short": "טכנאי",
  "battery_replacement": "החלפת סוללה",
  "device_maintenance": "תחזוקת מכשיר",
  "maintenance_type": "סוג תחזוקה",
  "panel_change": "החלפת לוח",
  "technician_check": "בדיקת טכנאי",
  "enter_note_details": "הזן פרטי הערה",
  "replacement_date": "תאריך ההחלפה",
  "replaced_by_name": "הוחלף על ידי",
  "replacement_note": "הערת החלפה",
  "enter_replacement_details": "הזן פרטי החלפה",
  "replacement_history": "היסטוריית החלפות",
  "loading_history": "טוען היסטוריה",
  "no_replacement_history": "אין היסטוריית החלפות זמינה",
  "enter_technician_name": "הזן שם טכנאי",
  "prefilled_from_account": "מולא אוטומטית מהחשבון שלך — ניתן לערוך",
  "user_information": "מידע על המשתמש",
  "enter_change_details": "הזן פרטי שינוי",
  "panel_change_history": "היסטוריית שינוי לוח",
  "check_date": "תאריך בדיקה",
  "checked_by_name": "נבדק על ידי",
  "enter_check_details": "הזן פרטי בדיקה",
  "technician_check_history": "היסטוריית בדיקות טכנאי",
  "no_technician_check_history": "אין היסטוריית בדיקות טכנאי זמינה",
  "change_date": "תאריך שינוי",
  "changed_by_name": "שונה על ידי",
  "change_note": "הערת שינוי",
  "check_note": "הערת בדיקה",
  "replaced_by": "הוחלף על ידי",
  "no_data_entered": "לא הוזנו נתונים",
  "no_panel_change_history": "אין היסטוריית שינוי לוח זמינה",
  "invalid_username": "שם משתמש לא חוקי",
  "invalid_phone": "מספר טלפון לא חוקי",
  "username_must_be_at_least_5_characters": "שם המשתמש חייב להכיל לפחות 5 תווים",
  monthMap: {
    1: 'ינ׳',
    2: 'פב׳',
    3: 'מרץ',
    4: 'אפר׳',
    5: 'מאי',
    6: 'יוני',
    7: 'יולי',
    8: 'אוג׳',
    9: 'ספט׳',
    10: 'אוק׳',
    11: 'נוב׳',
    12: 'דצמ׳',
  },
  weekMap: {
    1: 'ראשון',
    2: 'שני',
    3: 'שלישי',
    4: 'רביעי',
    5: 'חמישי',
    6: 'שישי',
    7: 'שבת',
  },
  "open_complaints": "תלונות פתוחות",
  "open_sla_alerts": "התראות תלונות פתוחות",
  "site_alerts": "התראות אתרים",
  "open_duration": "משך פתוח",
  "no_open_slas": "לא נמצאו SLA פתוחים",
  "no_open_slas_description": "כרגע אין אתרים עם SLA פתוחים.",
  "no_slas_to_send": "לא נמצאו SLA פתוחים לאתר זה",
  "total_open_complaints": "סה\"כ תלונות פתוחות",
  "longest_duration": "משך הזמן הארוך ביותר",
  "complaints_details": "פרטי תלונות",
  "rooms_with_open_complaints_percentage": "חדרים עם תלונות פתוחות",
  "rooms_with_cleaner_arrival_percentage": "חדרים עם הגעת מנקה",
  "rooms_without_cleaner_arrival_percentage": "חדרים ללא הגעת מנקה",
  "site_alerts_total_rooms": "כמות חדרים",
  "site_alerts_open_complaints_count": "מספר תלונות פתוחות",
  "site_alerts_customer_opening_date": "תאריך פתיחת לקוח",
  "company_country": "מדינת חברה",
  "select_message": "בחר הודעה",
  "message_no_cleaner_arrival": "שלום לכולם,\nשימו לב כי ישנם חדרים שעדיין לא דווח בהם הגעת מנקה היום.\nלטיפולכם בבקשה",
  "message_open_complaints": "שלום לכולם,\nשימו לב כי ישנם מספר חדרים בהם יש תלונות פתוחות זמן רב.\nלטיפולכם בבקשה",
  "rooms_list": "חדרים:",
  "no_results_found": "לא נמצאו תוצאות",
  "whatsapp": "וואטסאפ",
  "loading": "טוען",
  "error_opening_whatsapp": "שגיאה בפתיחת וואטסאפ. אנא נסה שוב.",
  "send_whatsapp": "שלח WhatsApp",
  "more_options": "אפשרויות נוספות",
  "preview_message": "תצוגה מקדימה של ההודעה",
  "copy_message": "העתק הודעה",
  "message_preview": "תצוגה מקדימה של ההודעה",
  "phone_number_optional": "מספר טלפון (אופציונלי)",
  "enter_phone_number": "הכנס מספר טלפון (למשל, +972501234567)",
  "phone_number_hint": "השאר ריק כדי לפתוח WhatsApp ללא איש קשר ספציפי",
  "message_copied": "ההודעה הועתקה ללוח!",
  "error_copying_message": "שגיאה בהעתקת ההודעה. נסה שוב.",
  "opening_whatsapp": "פותח WhatsApp...",
  "preview_message_description": "תצוגה מקדימה ועריכה של ההודעה לפני השליחה",
  "copy_message_description": "העתק את ההודעה ללוח",
  "error_loading_slas": "שגיאה בטעינת פרטי SLA. אנא נסה שוב.",
  "send_whatsapp": "שלח WhatsApp",
  "more_options": "אפשרויות נוספות",
  "preview_message": "תצוגה מקדימה של ההודעה",
  "copy_message": "העתק הודעה",
  "message_preview": "תצוגה מקדימה של ההודעה",
  "phone_number_optional": "מספר טלפון (אופציונלי)",
  "enter_phone_number": "הכנס מספר טלפון (למשל, +972501234567)",
  "phone_number_hint": "השאר ריק כדי לפתוח WhatsApp ללא איש קשר ספציפי",
  "message_copied": "ההודעה הועתקה ללוח!",
  "error_copying_message": "שגיאה בהעתקת ההודעה. נסה שוב.",
  "opening_whatsapp": "פותח WhatsApp...",
  "data_loading_please_wait": "הנתונים נטענים כעת. אנא המתן...",
  "dates_not_changed": "התאריכים לא השתנו. אין צורך בטעינה מחדש.",
  "date_outside_stats_range": "התאריכים שנבחרו מחוץ לטווח הנתונים הזמין.",

  "date_range_invalid": "תאריך \"עד\" חייב להיות זהה או מאוחר מתאריך \"מ\".",
  "filter_help_text": "כללי סינון: בחר בניין תחילה כדי לאפשר סינון לפי קומה. רוב המסננים תומכים בבחירה מרובה.",
  "select_building_first": "אנא בחר בניין תחילה כדי לאפשר סינון לפי קומה",
  "cannot_select_gender_with_rooms": "לא ניתן לבחור סוג חדר כאשר חדרים נבחרו",
  "cannot_select_gender_with_rooms_tooltip": "לא ניתן להשתמש במסנן סוג חדר כאשר חדרים נבחרו. אנא נקה את בחירת החדרים תחילה.",
  "cannot_select_building_with_rooms": "לא ניתן לבחור בניין כאשר חדרים נבחרו",
  "cannot_select_building_with_rooms_tooltip": "לא ניתן להשתמש במסנן בניין כאשר חדרים נבחרו. אנא נקה את בחירת החדרים תחילה.",
  "multi_select_hint": "ניתן לבחור מספר אפשרויות",
  "filter_applied": "הסינון הוחל בהצלחה",
  "no_filters_selected": "לא נבחרו מסננים. בחר לפחות אפשרות סינון אחת.",
  "filters": "מסננים",
  "location": "מיקום",
  "attributes": "תכונות",
  "applying": "מחיל...",
  "active_filters": "מסננים פעילים",
  "viewing_room": "צפייה בחדר",
  "multiple": "מרובה",
  "close": "סגור",
  "save_replacement": "שמור החלפה",
  "save_change": "שמור שינוי",
  "save_check": "שמור בדיקה",
  "failed_to_load_maintenance_history": "נכשל בטעינת היסטוריית תחזוקה",
  "Battery replacement recorded successfully": "החלפת סוללה נרשמה בהצלחה",
  "Panel change recorded successfully": "שינוי לוח נרשם בהצלחה",
  "Technician check recorded successfully": "בדיקת טכנאי נרשמה בהצלחה",
  "no_network_data_available": "אין נתוני רשת זמינים",
  "configuration": "תצורה",
  "contact_settings": "יצירת קשר והגדרות",
  "notifications": "התראות",
  "features": "תכונות",
  "chat_ask_buzzz": "שאל את Buzzz",
  "chat_hide": "הסתר",
  "chat_buzzz_assistant": "עוזר Buzzz",
  "chat_export": "ייצוא",
  "chat_clear": "נקה",
  "chat_unpin": "בטל הצמדה",
  "chat_pin": "הצמד",
  "chat_retry": "נסה שוב",
  "chat_copy": "העתק",
  "chat_copied": "הועתק!",
  "chat_share": "שתף",
  "chat_suggestions": "הצעות",
  "chat_input_placeholder": "שאל על הנתונים שלך...",
  "chat_stop": "עצור",
  "chat_error": "משהו השתבש. נסה שוב.",
  "chat_placeholder": "שאל אותי על נתוני הניקיון שלך...",
  "chat_placeholder_context": "שאל על {scope}...",
  "chat_chip_briefing": "תדריך בוקר",
  "chat_chip_live_status": "סטטוס חי",
  "chat_chip_staff_status": "סטטוס צוות",
  "chat_chip_summary": "סיכום",
  "chat_chip_cleaning_priority": "עדיפות ניקיון",
  "chat_chip_worst_rooms": "חדרים גרועים",
  "chat_chip_focus": "תחומי מיקוד",
  "chat_chip_compare_periods": "השוואת תקופות",
  "chat_chip_sla_issues": "בעיות SLA",
  "chat_chip_shift_stats": "נתוני משמרות",
  "chat_chip_complaint_types": "סוגי תלונות",
  "chat_chip_busiest_hours": "שעות עמוסות",
  "chat_chip_worst_days": "ימים גרועים",
  "chat_chip_improving": "חדרים משתפרים",
  "chat_chip_best_rooms": "חדרים מצטיינים",
  "chat_chip_help": "עזרה",
  "chat_chip_why_drilldown": "למה? חקור לעומק",
  "chat_deep_analysis": "ניתוח מעמיק (איטי יותר)",
  "chat_greeting": "היי {name}, איך אני יכול לעזור?",
  "chat_status_online": "מחובר",
  "chat_status_thinking": "חושב...",
  "chat_tool_overview": "מביא סקירה...",
  "chat_tool_rooms": "בודק חדרים...",
  "chat_tool_hours": "מנתח שעות...",
  "chat_tool_days": "סוקר נתונים יומיים...",
  "chat_tool_live": "בודק סטטוס חי...",
  "chat_tool_priority": "בודק עדיפויות...",
  "chat_tool_room_detail": "מביא פרטי חדר...",
  "chat_tool_shifts": "בודק משמרות...",
  "chat_tool_staff": "בודק צוות...",
  "chat_tool_devices": "בודק מכשירים...",
  "chat_feedback_good": "תשובה טובה",
  "chat_feedback_bad": "תשובה גרועה",
  "chat_feedback_thanks": "תודה על המשוב!",
  "chat_feedback_wrong_data": "נתונים שגויים",
  "chat_feedback_didnt_understand": "לא הבין",
  "chat_feedback_missing_info": "חסר מידע",
  "chat_feedback_bad_format": "עיצוב גרוע",
  "chat_feedback_hallucinated": "מספרים בדויים",
  "chat_feedback_submit": "שלח",
  "change_history": "היסטוריית שינויים",
  "change_datetime": "תאריך ושעה",
  "change_client_site": "לקוח / אתר",
  "change_user": "בוצע על ידי",
  "change_field": "שדה שהשתנה",
  "change_old_value": "ערך קודם",
  "change_new_value": "ערך חדש",
  "change_source": "מקור השינוי",
  "change_source_all": "הכל",
  "change_source_manual": "ידני",
  "change_source_automatic": "אוטומטי",
  "actor_name": "בוצע על ידי",
  "field_name": "שדה",
  "entity_label": "משמרת",
  "no_change_history": "לא נמצאה היסטוריית שינויים",
  "error_loading_change_history": "שגיאה בטעינת היסטוריית השינויים. נסה שוב.",
  "change_field_complaints_percent": "אחוז תלונות",
  "change_field_sla_percent": "אחוז SLA",
  "change_field_arrivals_percent": "אחוז הגעות",
  "change_field_complaints_percent_no_visits": "אחוז תלונות (ללא ביקורים)",
  "change_field_sla_percent_no_visits": "אחוז SLA (ללא ביקורים)",
  "change_field_arrivals_percent_no_visits": "אחוז הגעות (ללא ביקורים)",
  "change_field_min_sla": "SLA מינימום",
  "change_field_max_sla": "SLA מקסימום",
  "change_field_day_arrivals": "הגעות יומיות",
  "change_field_save_arrivals": "שמירת הגעות",
  "change_field_clean_time": "זמן ניקוי",
  "change_field_start_hour": "שעת התחלה",
  "change_field_end_hour": "שעת סיום",
  "change_field_shift_name": "שם משמרת",
  "change_field_shift_number": "מספר משמרת",
  "change_field_week_arrivals": "הגעות שבועיות",
  "change_field_is_active": "פעיל",
  "change_field_cleaners_number": "מספר מנקים",
  "change_field_auto_close_complaint_sla_utc_hour": "שעת סגירה אוטומטית לתלונה",
  "change_field_auto_close_maintenance_complaint_sla_utc_hour": "שעת סגירה אוטומטית לתחזוקה",
}

export const pt = {
  ...serviks.pt,
  monthMap: {
    1: 'Jan',
    2: 'fevereiro',
    3: 'Março',
    4: 'abril',
    5: 'Maio',
    6: 'junho',
    7: 'julho',
    8: 'agosto',
    9: 'setembro',
    10: 'outubro',
    11: 'novembro',
    12: 'dezembro',
  },
  weekMap: {
    1: 'domingo',
    2: 'Segunda-feira',
    3: 'terça-feira',
    4: 'quarta-feira',
    5: 'quinta-feira',
    6: 'sexta-feira',
    7: 'sábado',
  },
  "notified": "notificado",
  "supervisor_arrival": "Supervisões Realizadas",
  "arrival": "chegada",
  "arrival_badges": "Limpezas no Turno",
  "callsHistory": "Histórico de chamadas",
  "openCalls": "Chamadas abertas",
  "visits_since_cleaned": "usuários desde a última limpeza",
  "visits_since_cleaned_short": "usuários desde limpeza",
  "filter": "filtro",
  "logo": "logotipo",
  "counter": "contador",
  "sms": "SMS",
  "shifts": "Turnos",
  "call": "Chamado",
  "duration": "duração",
  "time_start": "hora de início",
  "settings": "definições",
  "always": "Sempre",
  "off": "Desligado",
  "time_based": "Baseado em Tempo",
  "location_based": "Baseado em Localização",
  "notification_mode": "Modo de Notificação",
  "notification_times": "Horários de Notificação",
  "notification_times_info": "Intervalos de tempo são gerenciados pelo aplicativo móvel",
  "notification_location": "Localização da Notificação",
  "notification_sound": "Som de Notificação",
  "no_sound": "Sem Som",
  "default_sound": "Som Padrão",
  "soft_bell": "Sino Suave",
  "digital_sound": "Som Digital",
  "mallet_sound": "Som de Martelo",
  "phone_sound": "Som de Telefone",
  "text_sound": "Som de Texto",
  "manager_alert_delay": "Atraso de Alerta do Gerente",
  "snooze_interval": "Lembrete",
  "vocal_notifications": "Notificações Vocais",
  "no_delay": "Sem Atraso",
  "no_snooze": "Sem lembrete",
  "lat": "Lat",
  "lon": "Lon",
  "radius": "Raio",
  "no_location_set": "Nenhum local definido",
  "when_to_notify": "Quando Notificar",
  "notification_preferences": "Preferências de Notificação",
  "assignment_configuration": "Atribuição e Configuração",
  "status": "Status",
  "working_area": "área de trabalho",
  "complaints_NC": "Reclamações / NC",
  "SLA_NC": "SLA / NC",
  "arrivals_NC": "Limpezas Realizadas / NC",
  "staff": "pessoal",
  "cleaning_complaints": "Principais Reclamações",
  "export": "exportar",
  "maintenance_complaints": "Reclamações de manutenção",
  "maintenanceArrivals": "Manutenções Realizadas",
  "maintenance_arrivals": "Manutenções Realizadas",
  "last": "último",
  "survey_name": "nome de pesquisa",
  "survey": "enquete",
  "pad_survey": "levantamento pad",
  "pad_no_maintenance_survey": "Pad sem pesquisa de manutenção",
  "pad_kitchen": "cozinha pad",
  "number_of_assigned_devices": "# dispositivos atribuídos",
  "number_of_pages": "# De páginas",
  "date_created": "Data Criada",
  "updated_by": "atualizado por",
  "date_updated": "data de atualização",
  "search": "procurar",
  "choose_type": "escolher o tipo de",
  "permitted_sites": "sites permitidos",
  "permitted_franchise": "franquia permitida",
  "permitted_companies": "empresas autorizadas",
  "panel_permitted": "painel permitido",
  "end_time": "Fim do tempo",
  "last_update": "última atualização",
  "add_device": "Adicionar Dispositivo",
  "detailed": "detalhado",
  "analysis": "análise",
  "suggestion": "sugestão",
  "country": "país",
  "management": "gestão",
  "device": "dispositivo",
  "mapping": "mapeamento",
  "please_enter": "Por favor, insira",
  "new_device": "Novo dispositivo",
  "assign_device": "dispositivo atribuir",
  "installSpot": "local de instalação",
  "device_type": "tipo de dispositivo",
  "deviceCode": "código do dispositivo",
  "device_code": "código do dispositivo",
  "scan_or_enter_device_code": "Escanear ou introduzir código do dispositivo...",
  "scan_device": "Atribuir",
  "scan_qr_in_frame": "Alinhe o código QR na moldura. Para códigos pequenos, mantenha 15–25 cm de distância e toque na pré-visualização para refocar se estiver desfocado.",
  "checking_device_code": "A verificar código do dispositivo...",
  "camera_not_available": "Câmara indisponível. Pode introduzir o código manualmente.",
  "device_code_already_exists": "Este código de dispositivo já está atribuído a outro sensor.",
  "assigned_to_company_site_room": "Já atribuído a {company} / {site} / {room}",
  "device_code_lookup_failed": "Não foi possível verificar o código do dispositivo. Tente novamente.",
  "device_code_no_site_access": "Este código já está registado num local a que não tem acesso.",
  "device_code_check_unavailable": "O servidor não conseguiu verificar o código. Tente novamente.",
  "device_code_not_a_code": "A leitura foi \"{code}\". Introduza o código do dispositivo.",
  "device_code_open_failed": "Não foi possível abrir este dispositivo. Tente novamente.",
  "device_code_save_failed": "Não foi possível guardar o código do dispositivo. Tente novamente.",
  "device_code_save_forbidden": "Não pode alterar este dispositivo.",
  "confirm_replace_device_code": "Substituir código do dispositivo?",
  "confirm_replace_device_code_body": "Tem a certeza de que deseja substituir o código {oldCode} por {newCode}?",
  "room": "quarto",
  "edit_room": "sala de edição",
  "edit_franchise": "editar franquia",
  "new_franchise": "nova franquia",
  "desc": "Descrição",
  "address": "Morada",
  "level": "nível",
  "no_companies_to_show": "Nenhuma empresa para mostrar",
  "company_type": "Tipo de companhia",
  "region": "região",
  "new_company": "nova empresa",
  "edit_company": "editar empresa",
  "edit_user": "Editar usuário",
  "C.arrivals": "limpador chegou",
  "C.complaints": "queixa de limpeza",
  "M.complaints": "manutenção chegou",
  "M.Arrivals": "Manutenções Realizadas",
  "analyses": "análises",
  "clean_log": "Registro de Limpeza",
  "maintenance_log": "registo de manutenção",
  "like": "gostar",
  "likes": "Curtidas",
  "new_user": "novo usuário",
  "shift_parameters": "parâmetro turno",
  "add_shift": "mudança add",
  "edit_shift": "editar turno",
  "username": "nome de usuário",
  "first_name": "primeiro nome",
  "job_function": "Função",
  "role": "Função",
  "property_manager": "Gerente de propriedade",
  "facility_manager": "Gerente de facilities",
  "site_manager": "Gerente do local",
  "workplace_manager": "Gerente do local de trabalho",
  "cleaning_company_ceo": "CEO da empresa de limpeza",
  "operations_manager": "Gerente de operações",
  "area_manager": "Gerente de área",
  "site_cleaning_manager": "Gerente de limpeza do local",
  "cleaning_supervisor": "Supervisor de limpeza",
  "other": "Outro",
  "restroom_cleaner": "Auxiliar de limpeza de banheiros",
  "general_cleaner": "Auxiliar de limpeza geral",
  "day_porter": "Auxiliar diurno",
  "office_cleaner": "Auxiliar de limpeza de escritórios",
  "public_area_cleaner": "Auxiliar de áreas comuns",
  "firstName": "primeiro nome",
  "description": "Descrição",
  "last_name": "sobrenome",
  "lastName": "sobrenome",
  "phone": "telefone",
  "building_area": "área de construção",
  "users": "Usuarios",
  "add_user": "adicionar usuário",
  "sites": "locais",
  "new_site": "novo site",
  "edit_site": "editar local",
  "add_company": "empresa add",
  "franchise": "franquia",
  "floor": "Piso",
  "building": "prédio",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Tipo de sala",
  "display_name": "nome",
  "zone": "Zona",
  "shift_number": "mudança#",
  "shift": "Turno",
  "shift_name": "nome mudança",
  "shift_currently_inactive": "Turno atualmente inativo",
  "local_time": "Local",
  "end": "fim",
  "min_sla": "min SLA",
  "max_sla": "Max SLA",
  "days": "Dias",
  "complaints_percent": "% Reclamações",
  "sla_percent": "% SLA",
  "arrivals_percent": "% Limpezas Realizadas",
  "save_arrivals": "Salve ",
  "clean_time": "Tempo de limpeza (min)",
  "tooltip_shift_number": "Ordem de exibição do turno (ex.: 1, 2).",
  "tooltip_shift_name": "Nome do turno (ex.: Manhã, Noite).",
  "tooltip_start_time": "Hora de início do turno (hora local).",
  "tooltip_end_time": "Hora de fim do turno (hora local).",
  "tooltip_cleaners_number": "Número de auxiliares de limpeza neste turno.",
  "tooltip_min_sla": "Tempo de resposta mínimo (min) para reclamação de sala; limite inferior da pontuação.",
  "tooltip_max_sla": "Tempo de resposta máximo aceitável (min) para reclamação; limite superior da pontuação.",
  "tooltip_arrivals": "Chegadas de limpeza esperadas por sala por dia; a pontuação compara com este alvo.",
  "tooltip_save_arrivals": "Visitas de limpeza por sala por dia antes do BuzzzTV; usado para tempo poupado.",
  "tooltip_clean_time": "Minutos por visita de limpeza no cálculo de tempo poupado (ex.: 15).",
  "tooltip_complaints_percent": "Peso das reclamações na pontuação da sala quando há visitas.",
  "tooltip_response_time_SLA": "Peso do tempo de resposta na pontuação da sala quando há visitas.",
  "tooltip_arrivals_percent": "Peso das chegadas vs alvo na pontuação da sala quando há visitas.",
  "tooltip_complaints_NC": "Peso das reclamações na pontuação quando não há visitas (sem contador).",
  "tooltip_SLA_NC": "Peso do tempo de resposta na pontuação quando não há visitas.",
  "tooltip_arrivals_NC": "Peso das chegadas na pontuação quando não há visitas.",
  "tooltip_days": "Dias da semana em que o turno está ativo.",
  "tooltip_active_calculation": "Quando ativo, o turno entra nas pontuações e no cálculo de tempo poupado.",
  "auto_close_complaints_hour": "Hora de fecho automático de reclamações",
  "tooltip_auto_close_complaints_hour": "Hora local em que os SLAs de reclamação abertos neste turno são fechados automaticamente. Deixe vazio para desativar.",
  "auto_close_maintenance_complaints_hour": "Hora de fecho automático de reclamações de manutenção",
  "tooltip_auto_close_maintenance_complaints_hour": "Hora local em que os SLAs de reclamação de manutenção abertos neste turno são fechados automaticamente. Deixe vazio para desativar.",
  "no_auto_close": "-- Nenhum --",
  "tooltip_shift_rooms": "Salas atribuídas a este turno. Deixe vazio para turno ao nível do site.",
  "company_name": "Nome da empresa",
  "site_name": "nome do site",
  "site_desc": "Descrição do Site",
  "service_provider_name": "provedor de serviço",
  "service_provider_type": "Tipo de provedor de serviços",
  "service_provider_desc": "A inscrição provedor de serviços",
  "user": "do utilizador",
  "map": "mapa",
  "delete": "excluir",
  "remove": "Remover",
  "new_room": "nova sala",
  "issue_times": "Número de emissão",
  "solved": "resolvido",
  "visits": "Quantidade de Usuários",
  "visits_also_went_up": "As visitas também aumentaram",

  "complaints": "Reclamações",
  "cleaner_arrivals": "Limpezas Realizadas",
  "unnecessary_arrivals": "Limpezas sem chamado",
  "unnecessary_arrivals_hint": "Uma visita do limpador enquanto não havia um chamado aberto na sala.",
  "of_arrivals": "das limpezas realizadas",
  "response_time_SLA": "tempo de resposta",
  "score": "pontuação",
  "avg_score": "Nota média",
  "score_goal": "Meta pontuação",
  "top_problem_issues": "Questões principais",
  "top_problem_rooms": "Topo Quartos",
  "top_problem_hours": "Principais Horas",
  "is_time_save": "O tempo economizado",
  "est_ROI": "Est ROI",
  "complaints_vs_visits": "Reclamações X Usuários",
  "view_by_years": "Ver Anos",
  "view_by_months": "Veja Meses",
  "view_by_weeks": "view Weeks",
  "view_by_days": "Veja Dias",
  "minutes": "min",
  "company": "Companhia",
  "site": "Local",
  "alerts": "Informações dos dispositivos",
  "performance": "Desempenho",
  "devices": "Dispositivos",
  "total_devices": "Total de Dispositivos",
  "working": "Funcionando",
  "warning": "Aviso",
  "by_device_type": "Por Tipo de Dispositivo",
  "surveys": "pesquisas",
  "real_time": "Tempo real",
  "real-time": "Tempo real",
  "cleaner-activity": "Atividade do funcionário",
  "device-actions": "Ações do dispositivo",
  "pad-presence-testing": "Teste de presença do pad",
  "real-time-cleaning": "Tempo real - limpeza",
  "real-time-maintenance": "Tempo real - manutenção",
  "no_real_time_tabs_permitted": "Você não tem permissão para ver nenhuma aba de tempo real",
  "admin": "administrador",
  "all": "Todo",
  "overview": "Visão geral",
  "total": "Total",
  "analytics": "analítica",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Comunicação",
  "overview_complaints_devices_caption": "Dispositivos instalados (acumulado)",
  "overview_complaints_devices_caption_hint": "Total de dispositivos instalados no local até o fim de cada mês, com base nas datas de instalação.",
  "overview_complaints_devices_toggle_aria": "Mostrar ou ocultar dispositivos instalados por baixo do gráfico de reclamações",
  "communication_select_site_title": "Escolha um site",
  "communication_select_site": "Selecione uma empresa e um site nos filtros acima para ver e adicionar notas para esse local.",
  "communication_viewing_site": "A ver",
  "communication_add_note": "Adicionar uma nota",
  "communication_add_note_open_aria": "Abrir janela para adicionar nota",
  "communication_form_hint": "Partilhe atualizações ou notas com todos os que têm acesso a este site. Verão novas notas em tempo real.",
  "communication_page_intro_title": "Notas do site — registo partilhado deste local",
  "communication_page_intro_body": "Use esta página para passagens de turno, problemas, atualizações e notas de reunião. Quem tiver acesso a este site no portal pode ler e adicionar notas.",
  "communication_page_intro_dismiss": "Ocultar dica",
  "communication_page_intro_aria": "Sobre as notas do site",
  "communication_content_placeholder": "Escreva a sua nota aqui...",
  "communication_keyboard_hint": "Ctrl+Enter para publicar",
  "communication_submitting": "A publicar...",
  "communication_submit": "Publicar nota",
  "communication_recent_notes": "Notas",
  "communication_search_placeholder": "Pesquisar por autor ou texto...",
  "communication_refresh": "Atualizar",
  "communication_clear_filters": "Limpar filtros",
  "communication_search_aria_label": "Pesquisar notas",
  "communication_submit_aria_label": "Publicar nota",
  "communication_copy_note_aria_label": "Copiar texto da nota",
  "communication_copied": "Copiado para a área de transferência.",
  "communication_copy_empty": "Esta nota não tem texto para copiar.",
  "communication_filter_hidden_one": "(1 nota oculta pelos filtros)",
  "communication_filter_hidden_many": "({n} notas ocultas pelos filtros)",
  "communication_request_timeout": "O pedido expirou. Tente novamente.",
  "communication_load_failed": "Não foi possível carregar as notas.",
  "communication_retry": "Tentar novamente",
  "communication_no_matches": "Nenhuma nota corresponde à pesquisa ou aos filtros. Tente ajustá-los.",
  "communication_no_entries": "Ainda não há notas.",
  "communication_no_entries_hint": "Adicione uma nota acima para começar.",
  "communication_just_now": "Agora mesmo",
  "communication_minutes_ago": "há {n} min",
  "communication_hours_ago": "há {n} h",
  "communication_days_ago": "há {n} dias",
  "communication_note_posted": "Nota publicada.",
  "communication_post_failed": "Não foi possível publicar a nota. Tente novamente.",
  "communication_note_type": "Tipo de nota",
  "communication_type_general": "Geral",
  "communication_type_update": "Atualização",
  "communication_type_issue": "Problema",
  "communication_type_follow_up": "Acompanhamento",
  "communication_type_meeting": "Nota de reunião",
  "communication_filter_all_types": "Todos os tipos",
  "communication_pinned": "Fixado",
  "communication_pin": "Fixar",
  "communication_unpin": "Desfixar",
  "communication_pin_limit": "Máx. 2 fixados",
  "communication_pinned_toast": "Nota fixada.",
  "communication_unpinned_toast": "Nota desfixada.",
  "communication_pin_failed": "Não foi possível atualizar o fixar. Tente novamente.",
  "communication_note_not_found": "Nota não encontrada ou não tem acesso.",
  "communication_site_not_in_filters": "O site desta nota não está nos filtros atuais. Pode não ter acesso a essa localização.",
  "communication_edit": "Editar",
  "communication_delete": "Eliminar",
  "communication_save": "Guardar",
  "communication_cancel": "Cancelar",
  "communication_saving": "A guardar...",
  "communication_note_updated": "Nota atualizada.",
  "communication_update_failed": "Falha ao atualizar a nota. Tente novamente.",
  "communication_delete_confirm": "Tem a certeza de que pretende eliminar esta nota? Esta ação não pode ser anulada.",
  "communication_delete_confirm_title": "Eliminar nota",
  "communication_note_preview": "Pré-visualização da nota:",
  "communication_note_deleted": "Nota eliminada.",
  "communication_delete_failed": "Falha ao eliminar a nota. Tente novamente.",
  "communication_edited": "Editado",
  "communication_show_more": "Mostrar mais",
  "communication_show_less": "Mostrar menos",
  "communication_sort_date_newest": "Mais recentes primeiro",
  "communication_sort_date_oldest": "Mais antigos primeiro",
  "communication_sort_author": "Por autor",
  "communication_sort_type": "Por tipo",
  "communication_sort_pinned": "Fixados primeiro",
  "communication_sort_label": "Ordenar",
  "communication_filter_by_type": "Tipo",
  "communication_filters_group_aria": "Filtrar e ordenar notas",
  "communication_search_label_short": "Pesquisar",
  "employees": "Funcionários",
  "dayOfWeek": "Dias",
  "service_log": "log serviço",
  "rooms": "quartos",
  "bulk_add_rooms": "Adicionar quartos em massa",
  "add_rooms": "Adicionar quartos",
  "room_names_one_per_line": "Nomes dos quartos (um por linha)",
  "enter_at_least_one_room": "Insira pelo menos um nome de sala",
  "room_names_placeholder": "Quarto 1\nQuarto 2\nToalete feminino",
  "rooms_with_prefix": "quartos com prefixo",
  "apply_to_all_rooms": "Aplicar a todos os quartos (opcional)",
  "bulk_rooms_intro": "Adicione um ou mais grupos. Cada grupo tem seu próprio edifício, andar, zona, género e nomes de quartos.",
  "group": "Grupo",
  "add_group": "+ Adicionar outro grupo",
  "adding_rooms": "A adicionar quartos...",
  "bulk_summary": "Resumo",
  "in": "em",
  "bulk_rooms_success": "{n} quartos adicionados com sucesso",
  "displayName": "Nome da sala",
  "SLA": "SLA",
  "supervisors": "supervisores",
  "supervisor": "Supervisor",
  "performance_analytics": "desempenho Analytics",
  "arrivals": "Limpezas Realizadas",
  "inspections": "inspeções",
  "avgResponseTime": "Tempo de resposta média",
  "missedSla": "perdeu Sla",
  "cleaner_arrived": "Cleaner Chegou",
  "load_more": "Carregue mais",
  "login": "Conecte-se",
  "email": "O email",
  "emails": "emails",
  "password": "Senha",
  "min": "min",
  "Logout": "Sair",
  "time_range": "Intervalo de tempo",
  "select_time_range": "Selecionar intervalo de tempo",
  "custom_time": "Escolha datas",
  "last_day": "Ontem",
  "last_week": "Últimos 7 dias",
  "last_month": "Últimos 30 dias",
  "last_quarter": "Últimos 90 dias",
  "last_6_months": "Últimos 6 meses",
  "last_year": "Últimos 365 dias",
  "data_by_hour": "Dados por hora",
  "general": "Em geral",
  "cleaning": "Reclamações",
  "maintenance": "Manutenção",
  "start": "Começar",
  "start_time": "hora de início",
  "management_co": "Administradora",
  "cleaning_co": "Companhia de limpeza",
  "companies": "empresas",
  "name": "nome",
  "site_count": "local #",
  "associated_companies": "clientes finais associados",
  "OK": "OK",
  "cancel": "cancelar",
  "client": "cliente",
  "dates": "datas",
  "shift": "turno",
  "issue": "Reclamação",
  "time": "Tempo",
  "top complaint of the week": "A chamada mais frequente da semana",
  "top room of the week": "A sala mais problemática da semana",
  "top hour of the week": "O horário mais problemático da semana",
  "top complaint of the month": "A chamada mais frequente do mês",
  "top room of the month": "A sala mais problemática do mês",
  "top hour of the month": "O horário mais problemático do mês",
  "franchises": "franquias",
  "add_franchise": "franchise add",
  "room_names": "nome da sala",
  "type": "modelo",
  "please_select_company_site": "por favor selecione uma empresa e local",
  "number": "número",
  "create_building_map": "criar mapa construção",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "hey maneira mais rápida de adicionar pisos e quartos para uma edifícios através deste assistente rápida",
  "avg number of toilets per floor": "Avg number de banheiros por andar",
  "avg.number of toilet cells per room": "Avg.number de células de higiene por quarto",
  "number of floors": "Número de pisos",
  "avg.number of disabled toilets": "Avg.number de banheiros com deficiência",
  "avg.number of soap dispensers": "Avg.number de distribuidores de sabão",
  "reset_filter": "Filtro de reset",
  "add": "adicionar",
  "new_survey": "nova pesquisa",
  "api_configuration": "Configuração API",
  "please_edit_the_api_information": "Edite as informações da API",
  "method": "método",
  "authorization": "autorização",
  "api_url": "api_url",
  "token": "token",
  "api_request_info": "Informações API",
  "roomName": "Nome da sala",
  "servikName": "Nome da queixa",
  "siteName": "Nome do site",
  "stage": "Página",
  "number_of_buttons": "Número de botões",
  "button_shape": "forma de botão",
  "delay_time_stage": "Adiar página",
  "go_to_stage": "Vá para página",
  "color": "Cor",
  "add_stage": "Adicionar Página",
  "save": "Salve ",
  "number_of_issues": "número de questões",
  "online": "conectados",
  "offline": "desligada",
  "offline_devices": "Dispositivos Offline",
  "no_offline_devices": "Nenhum dispositivo offline encontrado",
  "working_devices": "Dispositivos Funcionando",
  "no_working_devices": "Nenhum dispositivo funcionando encontrado",
  "room_name": "nome da sala",
  "installation_spot": "local",
  "device_id": "Identificador do dispositivo",
  "date": "encontro",
  "status": "status",
  "device_status": "status do dispositivo",
  "none": "Nenhum",
  "no_surveys_created": "Não há inquéritos criados",
  "dashboard": "Painel",
  "franchise_name": "Nome franquia",
  "franchise_country": "franchise País",
  "choose_franchise": "Escolha Franchise",
  "choose_country": "Escolha o país",
  "select_template": "Selecionar modelo",
  "default_survey": "padrão Levantamento",
  "cleaning_survey": "Levantamento de limpeza",
  "kitchen_survey": "Levantamento cozinha",
  "template": "Modelo",
  "area_name": "Nome area",
  "rooms_names": "Quartos Names",
  "rooms_number": "Quartos #",
  "assign_number": "Atribuir #",
  "active_notification_task": "Ativo Notificação Task",
  "amount_limit": "Intervalo de contagem",
  "after_max": "Contador após Máx",
  "new_area": "nova área",
  "edit_area": "editar área",
  "tablet": "Tábua",
  "counter women": "contra Mulheres",
  "counter men": "contador Man",
  "counter handicap": "contador Handicap",
  "counter man/woman": "Contador Homem / Mulher",
  "counter man / woman": "Contador Homem / Mulher",
  "sensor liquid": "sensor de líquido",
  "double toilet paper": "Papel Higiênico Duplo",
  "toilet paper": "Papel higiênico",
  "tag": "Marcação",
  "qr tag": "QR Tag",
  "additional_info": "informação adicional",
  "servikCategory": "tipo de chamada",
  "dishwashing": "Lavar pratos",
  "cafeteria": "Cantina",
  "clean room": "Quarto limpo",
  "office": "Escritório",
  "meeting room": "Sala de reuniões",
  "cubic": "Cúbico",
  "women": "Mulheres",
  "men": "Homens",
  "handicap": "desvantagem",
  "Combined": "Combinado",
  "kitchen": "Cozinha",
  "east": "leste",
  "west": "Oeste",
  "north": "Norte",
  "south": "Sul",
  "right": "Direita",
  "left": "Deixou",
  "center": "Centro",
  "up": "Acima",
  "down": "Abaixo",
  "combined": "Combinado",
  "lobby": "Salão",
  "entrance": "Entrada",
  "reception": "Recepção",
  "area": "Área",
  "mezzanine": "Mezanino",
  "gallery": "Galeria",
  "ground": "Terra",
  "elevator": "Elevador",
  "is_calculated": "Quarto calculado",
  "calculated_room": "Quarto Calculado",
  "splitted_survey": "pesquisa dividida",
  "redirect_to_url": "redirecionar para url",
  "survey_site": "Site de pesquisa",
  "clicks": "cliques",
  "add_stage_number_to_signal": "anexar o número do página",
  "including_pad9": "Incluir pad9",
  "room_type_required": "Selecione um tipo de sala para cada grupo",
  "Tech Manufacturers": "Fabricantes de tecnologia",
  "Tech Offices": "Escritórios de tecnologia",
  "Offices": "Escritórios",
  "Terminal": "Terminal",
  "Universities": "Universidades",
  "Factories": "Fábricas",
  "Hospital": "Hospital",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Lojas de conveniência",
  "Food Chains": "Redes de alimentação",
  "Residential": "Residencial",
  "Shopping Center": "Shopping",
  "Survey": "Pesquisa",
  "Demo": "Demonstração",
  "Vision": "Vision",
  "Court": "Tribunal",
  "Office Management": "Gestão de escritórios",
  "Government Office": "Repartição pública",
  "default_name": "Nome da Unidade",
  "exposures": "Exposição a Banheiros Limpos",
  "exposures_tab": "Atividade da Sala",
  "expose_results": "Resultados",
  "events_expose": "Eventos",
  "expose_score": "Taxa",
  "shift_events_expose": "Eventos do Turno",
  "type_of_site": "tipo de site",
  "sector": "setor",
  "last_time_of_arrival": "última hora de chegada",
  "arrival_and_status": "chegada & Status",
  "preview_arrivals": "visualizar chegadas",
  "men toilet": "banheiro masculino",
  "women toilet": "banheiro feminino",
  "shared toilet": "Banheiro compartilhado",
  "unisex restroom": "Banheiro unissex",
  "handicapped toilet": "banheiro para deficientes",
  "logistics": "Logística",
  "cubicle": "Cabine",
  "gym": "Academia",
  "morning_shift": "turno da manhã",
  "afternoon_shift": "turno da tarde",
  "night_shift": "turno da noite",
  "update": "atualizar",
  "restart": "reiniciar",
  "send_data": "enviar dados",
  "send_count": "enviar contador",
  "blink": "piscar",
  "beacon": "Beacon",
  "like_btn": "botão de curtir",
  "requires_like_btn": "requer que o botão de curtir esteja ativado",
  "maintenance_btn": "botão de manutenção",
  "battery": "bateria",
  "version": "versão",
  "actions": "ações",
  "device_actions": "Ações do Dispositivo",
  "device_settings": "Configurações do Dispositivo",
  "drains_battery": "Uso a bateria",
  "latest_errors": "últimos erros",
  "no_errors": "nenhum erro",
  "offline_calls": "Alertas off-line",
  "offline_duration_calls": "Duração dos alertas offline",
  "counterCalls": "Contador de chamadas",
  "active": "Ativo",
  "no_active_supervisors": "Sem supervisores ativos",
  "active_supervisors_column": "Supervisores ativos",
  "supervisors_active_label": "supervisores ativos agora",
  "active_supervisors_coverage_hint": "Supervisores ativos ligaram esta área no app. Isso não indica presença online ou física.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Calculo ativo",
  "pad": "Tablet",
  "pad_counter": "contador do tablet",
  "counter_status": "status do contador",
  "choose_state": "Escolha o estado",
  "choose_city": "Escolha a cidade",
  "start_hour": "Hora de início",
  "end_hour": "Hora de término",
  "analytics_log": "Registro de análise",
  "or": "ou",
  "no_data_available": "Nenhum dado disponível",
  "filter_by_cleaner": "Filtrar por funcionário",
  "all_cleaners": "Todos os funcionários",
  "not_available": "N/A",
  "failed_to_load_data": "Falha ao carregar dados",
  "new_task": "Nova tarefa",
  "temporarily_unavailable": "Temporariamente indisponível",
  "category": "Categoria",
  "title": "Título",
  "task_type": "Tipo de tarefa",
  "task_languages": "Idiomas da tarefa",
  "task_languages_hint": "Selecione os idiomas desta tarefa. Você inserirá o título em cada idioma selecionado.",
  "task_category": "Categoria de tarefa",
  "call_to_action": "Chamar para ação",
  "schedule": "Agenda",
  "daily": "Diariamente",
  "insert_text": "Inserir texto",
  "select": "Selecione",
  "select_all": "Selecionar Tudo",
  "n_selected": "{count} selecionados",
  "clear_selection": "Limpar seleção",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Datas de agendamento",
  "language": "Língua",
  "calendar": "Calendário",
  "operation": "Operação",
  "weekly": "Semanal",
  "monthly": "Mensal",
  "quarterly": "Trimestral",
  "yearly": "Anual",
  "sunday": "Domingo",
  "monday": "Segunda-feira",
  "tuesday": "Terça-feira",
  "wednesday": "Quarta-feira",
  "thursday": "Quinta-feira",
  "friday": "Sexta-feira",
  "saturday": "Sábado",
  "january": "Janeiro",
  "february": "Fevereiro",
  "march": "Março",
  "april": "Abril",
  "may": "Maio",
  "june": "Junho",
  "july": "Julho",
  "august": "Agosto",
  "september": "Setembro",
  "october": "Outubro",
  "november": "Novembro",
  "december": "Dezembro",
  "1st week": "1ª semana",
  "2nd week": "2ª semana",
  "3rd week": "3ª semana",
  "4th week": "4ª semana",
  "5th week": "5ª semana",
  "1st quarter": "1º trimestre",
  "2nd quarter": "2º trimestre",
  "3rd quarter": "3º trimestre",
  "4th quarter": "4º trimestre",
  "edit_task": "Editar tarefa",
  "created_at": "Criado em",
  "installed_at": "Instalado em",
  "hour": "Hora",
  "week_days": "Dias da semana",
  "month_weeks": "Semanas do mês",
  "month_days": "Dias do mês",
  "no_tasks_found": "Nenhuma tarefa encontrada",
  "invalid_language": "Língua inválida",
  "no_active_tasks_found": "Nenhuma tarefa ativa encontrada",
  "edit": "Editar",
  "send_date": "Data de envio",
  "invalid_date": "Data inválida",
  "cells_num": "# de células",
  "sinks_num": "# de pias",
  "urinals_num": "# de urinóis",
  "toilet_paper_size": "Tamanho do papel higiênico",
  "email_configuration": "Configuração de e-mail",
  "please_edit_the_email_information": "Por favor, edite as informações de e-mail",
  "email_sender_info": "Informações do remetente do e-mail",
  "email_subject_info": "Informações do assunto do e-mail",
  "email_message_info": "Informações da mensagem do e-mail",
  "companyName": "Nome da empresa",
  "email_language": "Língua do e-mail",
  "complaint_language": "Língua da reclamação",
  "email_message_format": "Formato da mensagem do e-mail",
  "line": "Linha",
  "list": "Lista",
  "roomType": "Tipo de quarto",
  "By logging in, you agree to Buzzztech's": "Ao fazer login, você concorda com os Termos e Condições da Buzzztech",
  "Terms and Conditions": "Termos e Condições",
  "and": "e",
  "Privacy Policy": "Política de Privacidade",
  "All actions within this panel are recorded for quality control and improvement": "Todas as ações dentro deste painel são gravadas para controle de qualidade e melhoria",
  "You must agree to the terms and conditions": "Você deve concordar com os termos e condições",
  "months": "Meses",
  "ref_id": "ID de referência",
  "room_name_en": "Nome do quarto em inglês",
  "site_state": "Região do site",
  "site_city": "Cidade Local",
  "site_country": "País do Local",
  "first_date": "Primeira Data",
  "pinned": "Fixado",
  "no.": "Nº",
  "must_be_numbers": "Deve ser números",
  "must_be_3_digits": "Deve ser 3 dígitos",
  "must_have_english_title": "Deve ter título em inglês",
  "total_sites": "Total",
  "site_information": "Informações do Local",
  "holiday_offdays": "Feriados e folgas",
  "add_offday": "Folga",
  "add_holiday": "Feriado",
  "name_under_chars": "nome com menos de 25 caracteres",
  "days_comma_separated": "dias válidos, separados por vírgula",
  "year": "ano",
  "month": "mês",
  "day": "dia",
  "holiday_name": "nome do feriado",
  "offday_name": "nome do dia de folga",
  "delete_confirmation_title": "Tem certeza?",
  "delete_confirmation_message": "Esta ação não pode ser desfeita.",
  "are_you_sure": "Tem certeza?",
  "israel": "Israel",
  "USA": "EUA",
  "poland": "Polônia",
  "mexico": "México",
  "cyprus": "Chipre",
  "brazil": "Brasil",
  "romania": "Romênia",
  "netherlands": "Países Baixos",
  "tablet_survey": "Pesquisa de tablet",
  "no_shift_survey": "Pesquisa de turno",
  "number_of_rows": "Número de linhas",
  "rating_shape": "Forma de classificação",
  "content_survey": "Pesquisa de conteúdo",
  "rating_survey": "Pesquisa de classificação",
  "device-alerts": "Alerta",
  "device-active": "Ativos",
  "device-search": "Procurar",
  "mac_id": "Endereço MAC",
  "qr_tag": "Etiqueta QR",
  "sensor": "Sensor",
  "image_survey": "Pesquisa de imagem",
  "open_text": "Texto aberto",
  "open_text_survey": "Pesquisa de texto aberto",
  "embedded_link": "Link incorporado",
  "device-counter": "Contadores",
  "count": "Contar",
  "last_date": "Última data",
  "last_arrival": "Horário da Última Limpeza",
  "cleaners": "Limpadores",
  "viewer": "Visualizador",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "Nenhum usuário encontrado",
  "cleaner_activity": "Atividade do funcionário",
  "pad_presence_testing": "Teste de presença do pad",
  "pad_presence_testing_subtitle": "Entradas, saídas e pressões offline do pad enviadas pelo telefone no local selecionado",
  "pad_presence_timeline": "Linha do tempo ao vivo",
  "pad_presence_sessions": "Sessões de presença",
  "pad_presence_offline_presses": "Pressões offline dos telefones",
  "pad_presence_select_site_hint": "Selecione uma empresa e um local no cabeçalho para ver os eventos de presença.",
  "pad_presence_no_events": "Nenhum evento de presença neste período.",
  "pad_presence_open": "Aberto",
  "pad_presence_exit_phone": "Saída pelo telefone",
  "pad_presence_exit_auto": "Saída automática",
  "pad_presence_exit_stale": "Saída atrasada",
  "pad_presence_enter": "Entrada",
  "pad_presence_exit": "Saída",
  "pad_presence_offline": "Pressão offline",
  "pad_presence_faulty": "Inválido",
  "pad_presence_employee": "Funcionário",
  "pad_presence_room": "Sala",
  "pad_presence_time_from": "De",
  "pad_presence_last_updated": "Atualizado",
  "pad_presence_duration": "Duração",
  "pad_presence_exit_type": "Tipo de saída",
  "pad_presence_button": "Botão",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Contagem",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Todos os funcionários",
  "pad_presence_all_rooms": "Todas as salas",
  "pad_presence_load_error": "Não foi possível carregar os dados de presença do pad.",
  "pad_presence_in_room_now": "Na sala agora",
  "pad_presence_in_room": "em",
  "pad_presence_since": "desde",
  "pad_presence_just_now": "Agora mesmo",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefone",
  "pad_presence_all_phones": "Todos os telefones",
  "pad_presence_window": "Mostrar",
  "pad_presence_window_hour": "Última hora",
  "pad_presence_window_today": "Hoje",
  "pad_presence_window_month": "Último mês",
  "pad_presence_pads": "Pads neste local",
  "pad_presence_no_pads": "Nenhum pad está atribuído a salas neste local.",
  "pad_presence_last_enter": "Última entrada",
  "pad_presence_last_offline": "Última pressão offline",
  "pad_presence_auto_exit_leave": "Saia agora → saída automática em",
  "pad_presence_auto_exit_earliest": "Mais cedo a partir da entrada:",
  "pad_presence_auto_exit_passed": "O prazo mais cedo de saída automática já passou. Ainda aberto = o pad ainda é ouvido, ou saia e aguarde 5m 45s.",
  "cleaner_activity_live_footer": "Os dados são atualizados em tempo real",
  "ca_empty_select_site_hint": "Selecione uma empresa e um local no cabeçalho para ver a atividade dos funcionários de hoje.",
  "ca_empty_no_cleaners_hint": "Nenhum funcionário está atribuído a este local e ao turno atual. Atribua locais ativos e turnos em Utilizadores.",
  "ca_empty_access_denied": "Acesso negado",
  "ca_empty_access_denied_hint": "Não tem permissão para ver a atividade dos funcionários neste local.",
  "ca_empty_load_error_hint": "Não foi possível carregar a atividade. Tente novamente ou contacte o suporte se o problema persistir.",
  "ca_empty_no_filter_match": "Nenhum funcionário corresponde a estes filtros",
  "ca_empty_no_filter_match_hint": "Tente limpar os filtros ou escolher outro funcionário, área de trabalho ou sala.",
  "ca_timeline_all_cleaners": "Atividade de hoje — todos os funcionários",
  "ca_legend_work": "Ativo",
  "ca_clock_sessions_more": "mais",
  "ca_clock_sessions_less": "Mostrar menos",
  "ca_sort_label": "Ordenar",
  "ca_sort_needs_attention": "Precisa de atenção",
  "ca_sort_best_avg_response": "Melhor tempo médio de resposta",
  "ca_sort_worst_avg_response": "Pior tempo médio de resposta",
  "ca_sort_most_sla_breaches": "Mais violações de SLA",
  "ca_sort_most_open_complaints": "Mais reclamações abertas",
  "ca_sort_most_work_time": "Mais tempo de trabalho",
  "ca_sort_least_work_time": "Menos tempo de trabalho",
  "ca_stat_avg_short": "méd",
  "ca_stat_open_short": "aberto",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "trabalho",
  "ca_assigned_room_avg_hint": "Tempo médio de resposta para salas atribuídas hoje",
  "ca_transit_tooltip": "Tempo de deslocação entre tarefas",
  "ca_transit_live_tooltip": "Tempo desde o fecho da última tarefa",
  "ca_legend_visits": "Visitas entre chamadas",
  "ca_visits_between_sla": "Visitas desde o fecho da chamada anterior",
  "ca_apply": "Aplicar",
  "ca_visits_since": "desde",
  "ca_deferred_tip_title": "Reclamação adiada",
  "ca_deferred_tip_resolved": "Resolvida",
  "ca_deferred_tip_desc_open": "Ainda aberta — o funcionário atendeu outras salas primeiro em vez desta.",
  "ca_deferred_tip_desc_closed": "Esta reclamação ficou aberta enquanto o funcionário atendeu outras salas primeiro.",
  "ca_deferred_tip_rooms_label": "Atendidas primeiro:",
  "ca_attention_title": "Precisa de atenção",
  "ca_attention_empty": "Tudo certo — sem problemas no momento",
  "ca_attention_sla_breach_one": "{name} · SLA violado",
  "ca_attention_sla_breach_many": "{name} · {count} violações de SLA",
  "ca_attention_open_while_out_one": "{name} · reclamação aberta fora do turno",
  "ca_attention_open_while_out_many": "{name} · {count} abertas fora do turno",
  "ca_attention_idle": "{name} · inativo {duration}",
  "ca_attention_late": "{name} · entrada atrasada",
  "ca_attention_show": "Mostrar",
  "ca_attention_hide": "Ocultar",
  "ca_view_shift": "Turno",
  "ca_view_history": "Histórico",
  "ca_filters_done": "Concluído",
  "ca_hist_preset_this_month": "Este mês",
  "ca_hist_preset_last_month": "Mês passado",
  "ca_hist_preset_this_week": "Esta semana",
  "ca_hist_preset_last_week": "Semana passada",
  "ca_hist_preset_custom": "Personalizado",
  "ca_hist_from": "De",
  "ca_hist_to": "Até",
  "ca_hist_range_invalid": "A data inicial deve ser anterior à data final",
  "ca_hist_range_too_long": "O intervalo pode ter no máximo {max} dias",
  "ca_hist_search": "Pesquisar nome ou telefone",
  "ca_hist_people_count": "{count} funcionários",
  "ca_hist_kpi_days": "Dias trabalhados",
  "ca_hist_kpi_net": "Horas líquidas",
  "ca_hist_kpi_breaks": "Pausas",
  "ca_hist_col_person": "Funcionário",
  "ca_hist_col_total": "Horas totais",
  "ca_hist_col_total_tip": "Da entrada à saída antes das pausas, o mesmo valor que o funcionário vê no aplicativo",
  "ca_hist_col_net": "Horas líquidas",
  "ca_hist_col_breaks": "Pausas",
  "ca_hist_col_issues": "Ocorrências",
  "ca_hist_col_late": "Atraso",
  "ca_hist_col_missed": "Falta",
  "ca_hist_col_no_clock_out": "Sem saída",
  "ca_hist_clocked_in_now": "Em serviço agora",
  "ca_hist_not_assigned": "Não atribuído a este local",
  "ca_hist_no_shift": "Sem turno atribuído",
  "ca_hist_unknown_name": "Desconhecido",
  "ca_hist_empty": "Sem presença neste período",
  "ca_hist_empty_hint": "Ninguém registrou entrada neste local e nenhum funcionário está atribuído a ele.",
  "ca_hist_no_match": "Nenhum funcionário corresponde aos filtros",
  "ca_hist_load_error_hint": "Não foi possível carregar o histórico de presença. Tente novamente em instantes.",
  "ca_hist_prev_person": "Funcionário anterior",
  "ca_hist_next_person": "Próximo funcionário",
  "ca_hist_close": "Fechar",
  "ca_hist_legend_worked": "Trabalhou",
  "ca_hist_legend_late": "Atraso",
  "ca_hist_legend_missed": "Falta",
  "ca_hist_legend_no_clock_out": "Sem saída",
  "ca_hist_late_by": "Atraso de {duration}",
  "ca_hist_late_tip": "Entrada às {time}, {shift} começa às {start}",
  "ca_hist_missed": "Falta",
  "ca_hist_missed_tip": "Turno agendado terminou sem registro de entrada",
  "ca_hist_no_clock_out": "Sem saída",
  "ca_hist_no_clock_out_tip": "Sessão nunca encerrada; suas horas não são contadas",
  "ca_hist_in_progress": "Ainda em serviço",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "aberta",
  "ca_hist_day_col_gross": "Horas totais",
  "ca_hist_day_col_breaks": "Pausas",
  "active_cleaners": "Funcionários ativos",
  "closed_complaints": "Reclamações fechadas",
  "total_work_time": "Tempo total de trabalho",
  "total_work_time_net": "Tempo total de trabalho (líquido hoje)",
  "total_break_time": "Tempo total de pausa",
  "avg_response_time": "Média resolvidas",
  "cleaner": "Funcionário",
  "clocked_in": "Entrada registrada",
  "clocked_out": "Saída registrada",
  "still_clocked_in": "Ainda em serviço",
  "clocked_in_late": "Entrada registrada com atraso",
  "total_hours": "Total de horas",
  "auto_punch": "Automático (geofence)",
  "manual_punch": "Manual",
  "complaint_opened": "Reclamação aberta",
  "complaint_closed": "Reclamação fechada",
  "complaint_still_open": "Ainda aberta",
  "resolved_in": "Resolvida em",
  "open_for": "Aberta há",
  "sla_breached": "SLA violado",
  "no_activity_today": "Ainda sem atividade hoje",
  "just_now": "agora mesmo",
  "ago": "atrás",
  "today": "Hoje",
  "live": "Ao vivo",
  "last_updated": "Atualizado",
  "no_cleaners_found": "Nenhum aspirador encontrado",
  "new_cleaner": "Novo aspirador",
  "edit_cleaner": "Editar aspirador",
  "have_you_finished_making_changes": "Já terminou de fazer alterações?",
  "assignment_issues_found": "Problemas de atribuição encontrados",
  "unassigned_rooms_title": "Salas sem atribuição",
  "overlapping_assignments_title": "Atribuições sobrepostas",
  "and_n_more": "e mais {count}",
  "continue_anyway": "Continuar mesmo assim",
  "stay_and_fix": "Ficar e corrigir",
  "assignment_coverage_issues": "{unassigned} sem atribuição · {overlaps} sobreposições",
  "assignment_check_failed": "Não foi possível verificar as atribuições das salas",
  "tap_for_details": "Toque para detalhes",
  "has_app": "App",
  "has_app_tooltip": "O limpador tem o app",
  "notifications_tooltip": "Notificações push ativas",
  "assigned_to_rooms": "Atribuído a salas",
  "assigned_to_rooms_tooltip": "Tem salas neste local",
  "recently_active": "Ativo recentemente",
  "works_at_site": "Trabalha no local",
  "recently_active_tooltip": "Abriu o app nos últimos 30 minutos",
  "please_select": "Por favor selecione",
  "please_select_site_first": "Por favor, selecione um local primeiro",
  "working_areas": "Áreas de trabalho",
  "no_working_areas": "Ainda não há áreas de trabalho",
  "working_area_alerts": "Alertas",
  "api": "API",
  "please_create_room_before_working_area": "Por favor, crie pelo menos uma sala antes de criar uma área de trabalho",
  "isWorkingInSite": "Trabalhando no local",
  "you_are_not_allowed_to_edit": "Você não tem permissão para editar",
  "you_are_not_allowed_to_remove": "Você não tem permissão para remover",
  "task": "Tarefa",
  "portuguese": "Português",
  "russian": "Russo",
  "spanish": "Espanhol",
  "polish": "Polonês",
  "installer": "Instalador",
  "once": "Uma vez",
  "time_saved": "Tempo salvo",
  "yes": "Sim",
  "no": "Não",
  "workingAreaNames": "Nomes das áreas de trabalho",
  "shift_rooms":"Quartas",
  "new_shift":"Novo turno",
  "add_shift_inactive": "Adicione turno invisível",
  "remove_auto_shift_inactive": "Remova turnos invisiveis automatizadas",
  "additional_options": "Opções adicionais",
  "add_default_shifts": "Adicionar turnos padrão",
  "no_user_found": "Nenhum usuário encontrado",
  "no_site_found": "Nenhum site encontrado",
  "service_provider": "Provedor de serviços",
  "qr task": "Tarefa QR",
  "qr_task": "Tarefas QR",
  "all_day": "O dia todo",
  "auto_start": "Início automático",
  "english_title": "Título em inglês",
  "connectivity": "Conectividade",
  "power": "Energia",
  "Your work has been saved": "Seu trabalho foi salvo",
  "schedule_call_time": "Tempo de chamada",
  "schedule_call_gap": "Intervalo de chamada",
  "gapInMinutes": "Intervalo em minutos",
  "no_manual_calls_available": "Nenhuma chamada manual disponível",
  "manual_calls": "Chamadas manuais",
  "cleandex_calls": "Chamadas Cleandex",
  "cleandexCalls": "Chamadas Cleandex",
  "manualCalls": "Chamadas manuais",
  "inactive": "Inativo",
  "on hold": "Em espera",
  "sequential": "Sequencial",
  "ratio": "Proporção",
  "must_choose": "Deve escolher",
  "surveyApp": "Aplicativo de pesquisa",
  "installation": "Instalação",
  "manager": "Gerente",
  "previous": "Anterior",
  "next": "Próximo",
  "no_rooms_found": "Nenhum quarto encontrado",
  "show_calendar": "Mostrar calendário",
  "seeAll": "Ver tudo",
  "showPaginated": "Mostrar paginado",
  "cleaners_arrivals": "Limpezas Realizadas",
  "add_address": "Adicionar endereço",
  "site_auto_attendance_enabled":
    "Permitir registro automático de entrada/saída pela geocerca no aplicativo móvel (requer permissão de localização).",
  "site_auto_attendance_requires_location":
    "Defina primeiro o local no mapa (marca e raio de pelo menos 100 m) antes de ativar a frequência automática.",
  "site_mandatory_clock_in": "Exigir registro de entrada antes do trabalho",
  "site_mandatory_clock_in_description":
    "Os funcionários deste local devem registrar a entrada antes de poderem abrir as abas de limpeza, manutenção e missões no aplicativo.",
  "site_mandatory_clock_in_without_location":
    "Este local não tem localização no mapa, então o aplicativo não consegue identificar quando um funcionário está no local. Até você definir uma, a exigência se aplica a esses funcionários em qualquer lugar.",
  "edit_address": "Editar endereço",
  "choose_radius": "Escolha o raio (em metros)",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Verde = OK. Vermelho = Recomendado limpar. Passe o mouse no ícone para detalhes.",
  "recommended_to_clean": "Recomendado limpar",
  "cleandex_warning_level": "Nível de alerta Cleandex",
  "select_warning_level": "Selecione o nível de alerta",
  "bronze": "Bronze",
  "silver": "Prata",
  "gold": "Ouro",
  "ai": "AI",
  "daily_employees_num": "Número diário de funcionários",
  "daily_shift_hours": "Horas de turno diário",
  "rooms_num": "Número de quartos",
  "buildings_num": "Número de edifícios",
  "cleaner_entries": "Limpeza de funcionários de limpeza",
  "avg_daily_visits_monthly": "usuários diárias médias mensais",
  "avg_daily_cleaners_to_save": "Média diária de funcionários de limpeza a economizar",
  "saving_hours_per_day": "Horas economizadas por dia",
  "saving_money_per_day": "Dinheiro economizado por dia",
  "saving_money_per_month": "Dinheiro economizado por mês",
  "cleaners_to_visitors_ratio": "Relação entre funcionários de limpeza e visitantes",
  "cleaning_time_in_minutes_per_room": "Tempo de limpeza em minutos por quarto",
  "max_number_of_rooms_per_employee": "Número máximo de quartos por funcionário",
  "break_time_per_hour": "Tempo de pausa por hora",
  "transition_time_between_tasks": "Tempo de transição entre tarefas",
  "employer_cost_hour": "Custo do empregador por hora",
  "lobby_cleaning_per_floor": "Limpeza do lobby por andar",
  "desired_cleaning_time": "Tempo de limpeza desejado",
  "desired_number_of_entries": "Número desejado de entradas",
  "buzz_system_cost_per_unit_per_month": "Custo do sistema Buzz por unidade por mês",
  "total_buzz_system_cost_per_month": "Custo total do sistema Buzz por mês",
  "return_on_investment_in_months": "Retorno sobre o investimento em meses",
  "annual_savings": "Economia anual",
  "roi_calculator": "Calculadora de ROI",
  "cleaners_number": "Número de limpadores",
  "floors_num": "Número de andares",
  "avg_daily_cleaners_required": "Média diária de limpadores necessários",
  "app_pages": "Páginas do aplicativo",
  "buzzzTime": "Tempo Buzzz",
  "missions": "Missões",
  "send_emails": "Enviar e-mails",
  "enter": "Entrar",
  "account": "Conta",
  "privacy": "Privacidade",
  "personal_settings": "Definições pessoais",
  "personal_settings_lead": "Gerir idioma e preferências de privacidade.",
  "personal_settings_read_only": "Estes dados são geridos pelo administrador. Contacte-o para alterações.",
  "change_password": "Alterar palavra-passe",
  "change_password_hint": "Alterar a palavra-passe termina a sessão nos seus outros dispositivos.",
  "current_password": "Palavra-passe atual",
  "new_password": "Nova palavra-passe",
  "confirm_new_password": "Confirmar nova palavra-passe",
  "password_min_length": "A palavra-passe deve ter pelo menos 8 caracteres",
  "passwords_do_not_match": "As palavras-passe não coincidem",
  "new_password_same_as_current": "A nova palavra-passe deve ser diferente da atual",
  "current_password_incorrect": "A palavra-passe atual está incorreta",
  "current_password_required": "A palavra-passe atual é obrigatória",
  "password_changed_successfully": "Palavra-passe alterada com sucesso",
  "change_password_failed": "Não foi possível alterar a palavra-passe",
  "forgot_password": "Esqueceu a palavra-passe?",
  "forgot_password_title": "Esqueceu a palavra-passe",
  "forgot_password_hint": "Introduza o email da sua conta do painel e enviaremos um link de reposição se existir.",
  "forgot_password_sent": "Se existir uma conta para esse email, foi enviado um link de reposição. Verifique a caixa de entrada.",
  "forgot_password_invalid_email": "Introduza um endereço de email válido",
  "forgot_password_failed": "Não foi possível enviar o email de reposição. Tente novamente.",
  "send_reset_link": "Enviar link de reposição",
  "back_to_login": "Voltar ao login",
  "reset_password": "Repor palavra-passe",
  "reset_password_hint": "Escolha uma nova palavra-passe para a sua conta.",
  "reset_password_missing_token": "Este link de reposição está incompleto. Peça um novo na página de login.",
  "reset_password_invalid_token": "Este link de reposição é inválido ou expirou. Peça um novo.",
  "reset_password_failed": "Não foi possível repor a palavra-passe",
  "password_reset_successfully": "Palavra-passe reposta com sucesso. Já pode iniciar sessão com a nova palavra-passe.",
  "login_invalid_credentials": "Nome de utilizador ou palavra-passe incorretos",
  "login_credentials_required": "Introduza o nome de utilizador ou e-mail e a palavra-passe",
  "login_network_error": "Não é possível contactar o servidor. Verifique a ligação e tente novamente",
  "login_failed": "Não foi possível iniciar sessão. Tente novamente",
  "login_too_many_attempts": "Demasiadas tentativas de início de sessão. Aguarde 15 minutos e tente novamente.",
  "forgot_password_too_many": "Demasiados pedidos de reposição da palavra-passe. Aguarde uma hora e tente novamente.",
  "reset_password_too_many": "Demasiadas tentativas de reposição da palavra-passe. Aguarde uma hora e tente novamente.",
  "change_password_too_many": "Demasiadas tentativas de alteração da palavra-passe. Aguarde 15 minutos e tente novamente.",

  "personal_settings_language_hint": "Aplica-se a todo o portal neste navegador.",
  "personal_settings_privacy_hint": "Pedir eliminação dos seus dados ao abrigo das leis de privacidade.",
  "personal_settings_role": "Função",
  "Request deletion of my data": "Solicitar exclusão dos meus dados",
  "Request deletion of my data - confirm": "Solicitar exclusão dos meus dados? Um e-mail será enviado ao administrador. Processaremos em até 30 dias.",
  "Request deletion of my data - success": "Pedido enviado. Processaremos em até 30 dias.",
  "Request deletion of my data - error": "Falha ao enviar. Tente novamente ou e-mail privacy@buzzztech.com.",
  "metrics": "Métricas",
  "select_three_metrics": "Selecione até 3 métricas para comparar",
  "select_four_metrics": "Selecione até 4 métricas para comparar",
  "legend": "Legenda",
  "more_details": "Mais Detalhes",
  "performance_overview": "Visão Geral de Desempenho",
  "loading_chart": "Carregando gráfico",
  "retry": "Tentar novamente",
  "performance_trending_upward": "Desempenho em tendência de alta",
  "high_complaint_ratio": "Alta taxa de reclamações",
  "click_bars_for_details": "Clique nas barras para ver detalhes diários da análise",
  "refresh": "Atualizar",
  "table": "Tabela", 
  "cards": "Cartões",
  "no_recent_arrivals": "Nenhuma chegada recente",
  "feedback_charts": "Gráficos de feedback",
  "general_overview": "Visão geral",
  "cleaning_complaints_breakdown": "Detalhamento das reclamações de limpeza",
  "maintenance_complaints_breakdown": "Detalhamento das reclamações de manutenção",
  "refresh_failed": "Falha na atualização",
  "data_exported_successfully": "Dados exportados com sucesso",
  "data_export_failed": "Falha na exportação dos dados",
  "drill_down_unavailable": "Detalhamento disponível apenas na visualização diária",
  "sort_by": "Ordenar por",
  "no_active_shift": "Nenhum turno ativo",
  "check_site_and_shift": "Por favor, verifique se um local está selecionado e possui um turno ativo",
  "please_add_shift_first": "Por favor, adicione um turno primeiro",
  "cleandex_no_data_message": "Nenhum dado do Cleandex disponível no momento",
  "task_no_data_message": "Nenhum dado de tarefa disponível no momento",
  "navigation": "Navegação",
  "network_information": "Informações de rede",
  "target_effectiveness": "Eficácia do alvo",
  "cleandex_call_cleaner": "Chamada Cleandex para limpador",
  "top_complaint": "Principal reclamação",
  "no_complaints": "Nenhuma reclamação",
  "official_start_date": "Data de início oficial",
  "note_text": "Texto da nota",
  "add_note": "Adicionar nota",
  "general_note": "Nota geral",
  "general_note_short": "Geral",
  "battery_short": "Bateria",
  "panel_short": "Painel",
  "technician_short": "Técnico",
  "battery_replacement": "Troca de bateria",
  "device_maintenance": "Manutenção do dispositivo",
  "maintenance_type": "Tipo de manutenção",
  "panel_change": "Troca de painel",
  "technician_check": "Verificação do técnico",
  "enter_note_details": "Insira os detalhes da nota",
  "replacement_date": "Data da substituição",
  "replaced_by_name": "Substituído por",
  "replacement_note": "Nota da substituição",
  "enter_replacement_details": "Insira os detalhes da substituição",
  "replacement_history": "Histórico de substituições",
  "loading_history": "Carregando histórico",
  "no_replacement_history": "Nenhum histórico de substituição disponível",
  "enter_technician_name": "Insira o nome do técnico",
  "user_information": "Informações do usuário",
  "enter_change_details": "Insira os detalhes da alteração",
  "panel_change_history": "Histórico de troca de painel",
  "check_date": "Data da verificação",
  "checked_by_name": "Verificado por",
  "enter_check_details": "Insira os detalhes da verificação",
  "technician_check_history": "Histórico de verificações do técnico",
  "no_technician_check_history": "Nenhum histórico de verificação do técnico disponível",
  "change_date": "Data da alteração",
  "changed_by_name": "Alterado por",
  "change_note": "Nota da alteração",
  "check_note": "Nota da verificação",
  "replaced_by": "Substituído por",
  "no_data_entered": "Nenhum dado inserido",
  "no_panel_change_history": "Nenhum histórico de troca de painel disponível",
  "invalid_username": "Nome de usuário inválido",
  "invalid_phone": "Número de telefone inválido",
  "username_must_be_at_least_5_characters": "O nome de usuário deve ter pelo menos 5 caracteres",
  "open_complaints": "Reclamações Abertas",
  "open_sla_alerts": "Alertas de Reclamações Abertas",
  "site_alerts": "Alertas de Sites",
  "open_duration": "Duração Aberta",
  "rooms_with_open_complaints_percentage": "Salas com Reclamações Abertas",
  "rooms_with_cleaner_arrival_percentage": "Salas com Chegada de Limpeza",
  "rooms_without_cleaner_arrival_percentage": "Salas sem Chegada de Limpeza",
  "site_alerts_total_rooms": "Total de salas",
  "site_alerts_open_complaints_count": "Número de reclamações abertas",
  "site_alerts_customer_opening_date": "Data de abertura do cliente",
  "company_country": "País da empresa",
  "select_message": "Selecionar Mensagem",
  "message_no_cleaner_arrival": "Olá a todos,\nPor favor, observem que há salas onde a chegada do funcionário de limpeza não foi relatada hoje.\nPor favor, tratem disso",
  "message_open_complaints": "Olá a todos,\nPor favor, observem que há várias salas com reclamações abertas há muito tempo.\nPor favor, tratem disso",
  "rooms_list": "Salas:",
  "no_open_slas": "Nenhum SLA aberto encontrado",
  "no_open_slas_description": "Atualmente não há sites com SLAs abertos.",
  "no_slas_to_send": "Nenhum SLA aberto encontrado para este site",
  "total_open_complaints": "Total de Reclamações Abertas",
  "longest_duration": "Duração Mais Longa",
  "complaints_details": "Detalhes das Reclamações",
  "no_results_found": "Nenhum resultado encontrado",
  "whatsapp": "WhatsApp",
  "loading": "Carregando",
  "error_opening_whatsapp": "Erro ao abrir o WhatsApp. Por favor, tente novamente.",
  "send_whatsapp": "Enviar WhatsApp",
  "more_options": "Mais opções",
  "preview_message": "Visualizar Mensagem",
  "copy_message": "Copiar Mensagem",
  "message_preview": "Visualização da Mensagem",
  "phone_number_optional": "Número de Telefone (Opcional)",
  "enter_phone_number": "Digite o número de telefone (ex: +5511999999999)",
  "phone_number_hint": "Deixe vazio para abrir WhatsApp sem um contato específico",
  "message_copied": "Mensagem copiada para a área de transferência!",
  "error_copying_message": "Erro ao copiar mensagem. Tente novamente.",
  "opening_whatsapp": "Abrindo WhatsApp...",
  "error_loading_slas": "Erro ao carregar detalhes do SLA. Por favor, tente novamente.",
  "send_whatsapp": "Enviar WhatsApp",
  "more_options": "Mais opções",
  "preview_message": "Visualizar Mensagem",
  "copy_message": "Copiar Mensagem",
  "message_preview": "Visualização da Mensagem",
  "phone_number_optional": "Número de Telefone (Opcional)",
  "enter_phone_number": "Digite o número de telefone (ex: +5511999999999)",
  "phone_number_hint": "Deixe vazio para abrir WhatsApp sem um contato específico",
  "message_copied": "Mensagem copiada para a área de transferência!",
  "error_copying_message": "Erro ao copiar mensagem. Tente novamente.",
  "opening_whatsapp": "Abrindo WhatsApp...",
  "data_loading_please_wait": "Os dados estão sendo carregados. Por favor, aguarde...",
  "dates_not_changed": "As datas não foram alteradas. Não é necessário recarregar.",
  "date_outside_stats_range": "As datas selecionadas estão fora do intervalo de estatísticas disponível.",

  "date_range_invalid": "A data \"Até\" deve ser igual ou posterior à data \"De\".",
  "filter_help_text": "Regras de Filtro: Selecione o Prédio primeiro para habilitar o filtro de Andar. A maioria dos filtros suporta seleções múltiplas.",
  "select_building_first": "Por favor, selecione um Prédio primeiro para habilitar o filtro de Andar",
  "cannot_select_gender_with_rooms": "Não é possível selecionar o tipo de sala quando salas estão selecionadas",
  "cannot_select_gender_with_rooms_tooltip": "O filtro de tipo de sala não pode ser usado quando salas estão selecionadas. Limpe a seleção de salas primeiro.",
  "cannot_select_building_with_rooms": "Não é possível selecionar prédio quando quartos estão selecionados",
  "cannot_select_building_with_rooms_tooltip": "O filtro de prédio não pode ser usado quando quartos estão selecionados. Por favor, limpe a seleção de quartos primeiro.",
  "multi_select_hint": "Você pode selecionar várias opções",
  "filter_applied": "Filtro aplicado com sucesso",
  "no_filters_selected": "Nenhum filtro selecionado. Selecione pelo menos uma opção de filtro.",
  "filters": "Filtros",
  "location": "Localização",
  "attributes": "Atributos",
  "applying": "Aplicando...",
  "active_filters": "Filtros Ativos",
  "viewing_room": "Visualizando quarto",
  "multiple": "Múltiplo",
  "close": "Fechar",
  "save_replacement": "Salvar substituição",
  "save_change": "Salvar alteração",
  "save_check": "Salvar verificação",
  "failed_to_load_maintenance_history": "Falha ao carregar histórico de manutenção",
  "Battery replacement recorded successfully": "Substituição de bateria registrada com sucesso",
  "Panel change recorded successfully": "Alteração de painel registrada com sucesso",
  "Technician check recorded successfully": "Verificação do técnico registrada com sucesso",
  "no_network_data_available": "Nenhum dado de rede disponível",
  "basic_information": "Informações Básicas",
  "service_providers": "Provedores de Serviço",
  "settings_alerts": "Configurações e Alertas",
  "configuration": "Configuração",
  "contact_settings": "Contato e Configurações",
  "notifications": "Notificações",
  "alert_language": "Idioma do Alerta",
  "select_language": "Selecione o idioma",
  "features": "Recursos",
  "chat_ask_stats": "Perguntar estatísticas",
  "chat_ask_buzzz": "Perguntar ao Buzzz",
  "chat_stats_assistant": "Assistente de estatísticas",
  "chat_buzzz_assistant": "Assistente Buzzz",
  "chat_clear": "Limpar",
  "chat_placeholder": "Pergunte sobre suas estatísticas de limpeza, ex. \"Quantas reclamações na semana passada?\" ou \"Quais salas precisam de mais atenção?\"",
  "chat_placeholder_context": "Pergunte sobre {scope}, ex. \"Quantas reclamações?\" ou \"Quais salas precisam de atenção?\"",
  "chat_thinking": "Pensando…",
  "chat_input_placeholder": "Pergunte sobre visitas, reclamações, salas…",
  "chat_send": "Enviar",
  "chat_chip_summary": "Resumo",
  "chat_chip_worst_rooms": "Piores salas",
  "chat_chip_counter_calls": "Chamadas de contador",
  "chat_chip_sla_issues": "Problemas de SLA",
  "chat_chip_busiest_hours": "Horários mais movimentados",
  "chat_chip_help": "O que posso perguntar?",
  "chat_chip_focus": "No que devo focar?",
  "chat_chip_improving": "Quais salas estão melhorando?",
  "chat_chip_best_rooms": "Melhores salas por pontuação",
  "chat_chip_worst_days": "Piores dias",
  "chat_chip_complaint_types": "Principais reclamações",
  "chat_chip_positive_feedback": "Feedback positivo",
  "chat_suggestions": "Sugestões",
  "chat_error": "Algo deu errado. Tente novamente.",
  "chat_copy": "Copiar",
  "chat_copied": "Copiado!",
  "chat_retry": "Tentar novamente",
  "chat_chip_compare_periods": "Comparar com o período anterior",
  "chat_chip_briefing": "Briefing matinal",
  "chat_chip_cleaning_priority": "Prioridade de limpeza",
  "chat_chip_live_status": "Status ao vivo",
  "chat_chip_shift_stats": "Desempenho por turno",
  "chat_chip_staff_status": "Quem está trabalhando agora?",
  "chat_chip_why_drilldown": "Por quê? Detalhar",
  "chat_pin": "Adicionar aos favoritos",
  "chat_unpin": "Remover dos favoritos",
  "chat_share": "Enviar por e-mail",
  "chat_export": "Exportar",
  "chat_helpful": "Útil",
  "chat_not_helpful": "Não útil",
  "chat_hide": "Ocultar assistente",
  "chat_stop": "Parar geração",
}

export const ru = {
  ...serviks.ru,
  monthMap: {
    1: 'январь',
    2: 'февраль',
    3: 'март',
    4: 'апрель',
    5: 'Май',
    6: 'июнь',
    7: 'июль',
    8: 'август',
    9: 'сентябрь',
    10: 'октябрь',
    11: 'ноябрь',
    12: 'декабрь',
  },
  weekMap: {
    1: 'воскресенье',
    2: 'понедельник',
    3: 'вторник',
    4: 'среда',
    5: 'Четверг',
    6: 'Пятница',
    7: 'Суббота',
  },
  "notified": "уведомление",
  "supervisor_arrival": "прибытие инспектора",
  "arrival": "пребытие",
  "arrival_badges": "Прибытия за смену",
  "callsHistory": "История вызовов",
  "openCalls": "Открытые вызовы",
  "visits_since_cleaned": "Посещений с последней уборки",
  "visits_since_cleaned_short": "Визиты с уборки",
  "filter": "фильтр",
  "logo": "логотип",
  "counter": "счетчик",
  "sms": "смс",
  "shifts": "смены",
  "call": "вызов",
  "duration": "продолжительность",
  "time_start": "время начала",
  "settings": "настройки",
  "always": "Всегда",
  "off": "Выключено",
  "time_based": "По времени",
  "location_based": "По местоположению",
  "notification_mode": "Режим уведомлений",
  "notification_times": "Время уведомлений",
  "notification_times_info": "Временные интервалы управляются из мобильного приложения",
  "notification_location": "Местоположение уведомлений",
  "notification_sound": "Звук уведомления",
  "no_sound": "Без звука",
  "default_sound": "Звук по умолчанию",
  "soft_bell": "Мягкий звонок",
  "digital_sound": "Цифровой звук",
  "mallet_sound": "Звук молотка",
  "phone_sound": "Звук телефона",
  "text_sound": "Звук текста",
  "manager_alert_delay": "Задержка оповещения менеджера",
  "snooze_interval": "напоминание",
  "vocal_notifications": "Голосовые уведомления",
  "no_delay": "Без задержки",
  "no_snooze": "без напоминания",
  "lat": "Широта",
  "lon": "Долгота",
  "radius": "Радиус",
  "no_location_set": "Местоположение не задано",
  "when_to_notify": "Когда уведомлять",
  "notification_preferences": "Настройки уведомлений",
  "assignment_configuration": "Назначение и Конфигурация",
  "status": "Статус",
  "working_area": "рабочая область",
  "complaints_NC": "жалобы без счетчика",
  "SLA_NC": "SLA без счетчика",
  "arrivals_NC": "прибытия без счетчика",
  "staff": "сотрудники",
  "cleaning_complaints": "Очистители Жалобы",
  "export": "экспорт",
  "maintenance_complaints": "Техподдержка Жалобы",
  "maintenanceArrivals": "Техническое обслуживание прибытия",
  "maintenance_arrivals": "Техническое обслуживание прибытия",
  "last": "последний",
  "survey_name": "название опроса",
  "survey": "опрос",
  "pad_survey": "опрос подушечка",
  "pad_no_maintenance_survey": "Pad без опроса по техническому обслуживанию",
  "pad_kitchen": "кухня подушечка",
  "number_of_assigned_devices": "# назначенные устройства",
  "number_of_pages": "# Страниц",
  "date_created": "Дата создания",
  "updated_by": "обновляется",
  "date_updated": "дата обновления",
  "search": "поиск",
  "choose_type": "выберите тип",
  "permitted_sites": "разрешенные сайты",
  "permitted_franchise": "разрешается франшиза",
  "permitted_companies": "допускаемые компании",
  "panel_permitted": "панель разрешено",
  "end_time": "время окончания",
  "last_update": "последнее обновление",
  "add_device": "добавить устройство",
  "detailed": "детальнее",
  "analysis": "анализ",
  "suggestion": "предложение",
  "country": "страна",
  "management": "управление",
  "device": "устройство",
  "mapping": "отображение",
  "please_enter": "пожалуйста, введите",
  "new_device": "новое устройство",
  "assign_device": "правопреемником устройство",
  "installSpot": "установка место",
  "device_type": "тип устройства",
  "deviceCode": "код прибора",
  "device_code": "код прибора",
  "scan_or_enter_device_code": "Сканируйте или введите код устройства...",
  "scan_device": "Назначить",
  "scan_qr_in_frame": "Поместите QR-код в рамку. Для мелких кодов держите телефон на расстоянии 15–25 см и коснитесь экрана для перефокусировки, если изображение размыто.",
  "checking_device_code": "Проверка кода устройства...",
  "camera_not_available": "Камера недоступна. Вы можете ввести код вручную.",
  "device_code_already_exists": "Этот код устройства уже назначен другому датчику.",
  "assigned_to_company_site_room": "Уже назначено: {company} / {site} / {room}",
  "device_code_lookup_failed": "Не удалось проверить код устройства. Попробуйте снова.",
  "device_code_no_site_access": "Этот код уже зарегистрирован на объекте, к которому у вас нет доступа.",
  "device_code_check_unavailable": "Сервер не смог проверить код. Попробуйте снова.",
  "device_code_not_a_code": "Сканер прочитал «{code}». Введите сам код устройства.",
  "device_code_open_failed": "Не удалось открыть это устройство. Попробуйте снова.",
  "device_code_save_failed": "Не удалось сохранить код устройства. Попробуйте снова.",
  "device_code_save_forbidden": "Вы не можете изменить это устройство.",
  "confirm_replace_device_code": "Заменить код устройства?",
  "confirm_replace_device_code_body": "Вы уверены, что хотите заменить код {oldCode} на {newCode}?",
  "room": "комната",
  "edit_room": "редактировать номер",
  "edit_franchise": "редактировать франшизы",
  "new_franchise": "новая франшиза",
  "desc": "описание",
  "address": "адрес",
  "level": "уровень",
  "no_companies_to_show": "Нет компании для показа",
  "company_type": "тип компании",
  "region": "область, край",
  "new_company": "новая компания",
  "edit_company": "редактировать компании",
  "edit_user": "редактировать пользователь",
  "C.arrivals": "очиститель прибыли",
  "C.complaints": "чистка жалобы",
  "M.complaints": "обслуживание прибыли",
  "M.Arrivals": "содержание жалобы",
  "analyses": "анализы",
  "clean_log": "чистый журнал",
  "maintenance_log": "журнал технического обслуживания",
  "like": "подобно",
  "likes": "лайки",
  "new_user": "новый пользователь",
  "shift_parameters": "параметр сдвига",
  "add_shift": "добавить сдвиг",
  "edit_shift": "редактировать сдвиг",
  "username": "имя пользователя",
  "first_name": "имя",
  "job_function": "Должность",
  "role": "Роль",
  "property_manager": "Управляющий объектом",
  "facility_manager": "Менеджер по эксплуатации",
  "site_manager": "Менеджер площадки",
  "workplace_manager": "Руководитель рабочего пространства",
  "cleaning_company_ceo": "Генеральный директор клининговой компании",
  "operations_manager": "Операционный менеджер",
  "area_manager": "Региональный менеджер",
  "site_cleaning_manager": "Менеджер по уборке объекта",
  "cleaning_supervisor": "Супервайзер по уборке",
  "other": "Другое",
  "restroom_cleaner": "Уборщик санузлов",
  "general_cleaner": "Уборщик",
  "day_porter": "Дневной портер",
  "office_cleaner": "Уборщик офисов",
  "public_area_cleaner": "Уборщик общественных зон",
  "firstName": "имя",
  "description": "описание",
  "last_name": "фамилия",
  "lastName": "фамилия",
  "phone": "Телефон",
  "building_area": "Площадь застройки",
  "users": "пользователи",
  "add_user": "Добавить пользователя",
  "sites": "места",
  "new_site": "новый сайт",
  "edit_site": "редактировать сайт",
  "add_company": "добавить компанию",
  "franchise": "франшиза",
  "floor": "Этаж",
  "building": "строительство",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Тип помещения",
  "display_name": "имя",
  "zone": "зона",
  "shift_number": "сдвиг#",
  "shift": "Смена",
  "shift_name": "имя сдвига",
  "shift_currently_inactive": "Смена в настоящее время неактивна",
  "local_time": "Местное",
  "end": "конец",
  "min_sla": "Минимальная ОАС",
  "max_sla": "Макс ОАС",
  "days": "дней",
  "complaints_percent": "% Жалобы",
  "sla_percent": "% ОАС",
  "arrivals_percent": "% Прибытие",
  "save_arrivals": "спасти",
  "clean_time": "Время уборки (мин)",
  "tooltip_shift_number": "Порядок отображения смены (напр. 1, 2).",
  "tooltip_shift_name": "Название смены (напр. Утро, Ночь).",
  "tooltip_start_time": "Время начала смены (местное).",
  "tooltip_end_time": "Время окончания смены (местное).",
  "tooltip_cleaners_number": "Количество уборщиков в этой смене.",
  "tooltip_min_sla": "Минимальное время реакции (мин) на жалобу по комнате; нижняя граница оценки.",
  "tooltip_max_sla": "Максимально допустимое время реакции (мин) на жалобу; верхняя граница оценки.",
  "tooltip_arrivals": "Ожидаемые приходы уборщика в комнату в день; оценка сравнивает факт с целью.",
  "tooltip_save_arrivals": "Визиты уборщика в комнату в день до BuzzzTV; для расчёта сэкономленного времени.",
  "tooltip_clean_time": "Минуты на один визит уборщика в расчёте сэкономленного времени (напр. 15).",
  "tooltip_complaints_percent": "Вес жалоб в оценке комнаты при наличии визитов.",
  "tooltip_response_time_SLA": "Вес времени реакции в оценке комнаты при наличии визитов.",
  "tooltip_arrivals_percent": "Вес приходов к цели в оценке комнаты при наличии визитов.",
  "tooltip_complaints_NC": "Вес жалоб в оценке при отсутствии визитов (без счётчика).",
  "tooltip_SLA_NC": "Вес времени реакции в оценке при отсутствии визитов.",
  "tooltip_arrivals_NC": "Вес приходов в оценке при отсутствии визитов.",
  "tooltip_days": "Дни недели, когда смена активна.",
  "tooltip_active_calculation": "Если включено, смена участвует в оценках и расчёте сэкономленного времени.",
  "auto_close_complaints_hour": "Час автозакрытия жалоб",
  "tooltip_auto_close_complaints_hour": "Местное время, когда открытые SLA-жалобы этой смены закрываются автоматически. Оставьте пустым для отключения.",
  "auto_close_maintenance_complaints_hour": "Час автозакрытия жалоб на обслуживание",
  "tooltip_auto_close_maintenance_complaints_hour": "Местное время, когда открытые SLA-жалобы на обслуживание этой смены закрываются автоматически. Оставьте пустым для отключения.",
  "no_auto_close": "-- Нет --",
  "tooltip_shift_rooms": "Комнаты, привязанные к смене. Оставьте пустым для смены уровня сайта.",
  "company_name": "название компании",
  "site_name": "Название сайта",
  "site_desc": "описание сайта",
  "service_provider_name": "поставщик услуг",
  "service_provider_type": "тип услуги поставщика",
  "service_provider_desc": "Описание поставщика услуг",
  "user": "Пользователь",
  "map": "карта",
  "delete": "Удалить",
  "remove": "Удалить",
  "new_room": "новый номер",
  "issue_times": "Времена выпуска",
  "solved": "решаемая",
  "visits": "просмотров",
  "visits_also_went_up": "Посещения также выросли",

  "complaints": "жалобы",
  "cleaner_arrivals": "Очистители прибытий",
  "unnecessary_arrivals": "Прибытия без вызова",
  "unnecessary_arrivals_hint": "Визит уборщика, когда в комнате не было открытого вызова.",
  "of_arrivals": "от прибытий",
  "response_time_SLA": "Время отклика",
  "score": "счет",
  "avg_score": "Средние баллы",
  "score_goal": "Оценка цели",
  "top_problem_issues": "Популярные вопросы",
  "top_problem_rooms": "Лучшие Комнаты",
  "top_problem_hours": "Лучшие часы",
  "is_time_save": "сэкономленное время",
  "est_ROI": "Est ROI",
  "complaints_vs_visits": "Жалобы и посещение",
  "view_by_years": "Просмотр года",
  "view_by_months": "Просмотр месяца",
  "view_by_weeks": "Просмотр недели",
  "view_by_days": "Посмотреть дни",
  "minutes": "мин",
  "company": "Компания",
  "site": "Сайт",
  "alerts": "Информация об устройствах",
  "performance": "Спектакль",
  "devices": "приборы",
  "total_devices": "Всего устройств",
  "working": "Работает",
  "warning": "Предупреждение",
  "by_device_type": "По типу устройства",
  "surveys": "Обзоры",
  "real_time": "реальное время",
  "real-time": "реальное время",
  "cleaner-activity": "Активность уборщиков",
  "device-actions": "Действия с устройством",
  "pad-presence-testing": "Тест присутствия у пада",
  "real-time-cleaning": "Реальное время - уборка",
  "real-time-maintenance": "Реальное время - обслуживание",
  "no_real_time_tabs_permitted": "У вас нет доступа ни к одной вкладке реального времени",
  "admin": "Администратор",
  "all": "Все",
  "overview": "обзор",
  "total": "Всего",
  "analytics": "аналитика",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Связь",
  "overview_complaints_devices_caption": "Установлено устройств (накопительно)",
  "overview_complaints_devices_caption_hint": "Общее число устройств, установленных на объекте к концу каждого месяца, по датам установки.",
  "overview_complaints_devices_toggle_aria": "Показать или скрыть установленные устройства под графиком жалоб",
  "communication_select_site_title": "Выберите объект",
  "communication_select_site": "Выберите компанию и объект в фильтрах выше, чтобы просматривать и добавлять заметки для этого места.",
  "communication_viewing_site": "Просмотр",
  "communication_add_note": "Добавить заметку",
  "communication_add_note_open_aria": "Открыть окно добавления заметки",
  "communication_form_hint": "Делитесь обновлениями или заметками со всеми, у кого есть доступ к этому объекту. Они будут видеть новые заметки в реальном времени.",
  "communication_page_intro_title": "Заметки по объекту — общий журнал для этой локации",
  "communication_page_intro_body": "Здесь оставляют передачи смен, проблемы, обновления и итоги встреч. Все, у кого есть доступ к этому объекту в портале, могут читать и добавлять заметки.",
  "communication_page_intro_dismiss": "Скрыть подсказку",
  "communication_page_intro_aria": "О заметках по объекту",
  "communication_content_placeholder": "Напишите заметку здесь...",
  "communication_keyboard_hint": "Ctrl+Enter — отправить",
  "communication_submitting": "Отправка...",
  "communication_submit": "Опубликовать заметку",
  "communication_recent_notes": "Заметки",
  "communication_search_placeholder": "Поиск по автору или тексту...",
  "communication_refresh": "Обновить",
  "communication_clear_filters": "Сбросить фильтры",
  "communication_search_aria_label": "Поиск заметок",
  "communication_submit_aria_label": "Опубликовать заметку",
  "communication_copy_note_aria_label": "Копировать текст заметки",
  "communication_copied": "Скопировано в буфер обмена.",
  "communication_copy_empty": "В заметке нет текста для копирования.",
  "communication_filter_hidden_one": "(1 заметка скрыта фильтрами)",
  "communication_filter_hidden_many": "({n} заметок скрыто фильтрами)",
  "communication_request_timeout": "Время ожидания истекло. Попробуйте снова.",
  "communication_load_failed": "Не удалось загрузить заметки.",
  "communication_retry": "Повторить",
  "communication_no_matches": "Нет заметок, соответствующих поиску или фильтрам. Попробуйте изменить их.",
  "communication_no_entries": "Пока нет заметок.",
  "communication_no_entries_hint": "Добавьте заметку выше, чтобы начать.",
  "communication_just_now": "Только что",
  "communication_minutes_ago": "{n} мин назад",
  "communication_hours_ago": "{n} ч назад",
  "communication_days_ago": "{n} дн. назад",
  "communication_note_posted": "Заметка опубликована.",
  "communication_post_failed": "Не удалось опубликовать заметку. Попробуйте снова.",
  "communication_note_type": "Тип заметки",
  "communication_type_general": "Общая",
  "communication_type_update": "Обновление",
  "communication_type_issue": "Проблема",
  "communication_type_follow_up": "Продолжение",
  "communication_type_meeting": "Заметка встречи",
  "communication_filter_all_types": "Все типы",
  "communication_pinned": "Закреплено",
  "communication_pin": "Закрепить",
  "communication_unpin": "Открепить",
  "communication_pin_limit": "Макс. 2 закреплённых",
  "communication_pinned_toast": "Заметка закреплена.",
  "communication_unpinned_toast": "Заметка откреплена.",
  "communication_pin_failed": "Не удалось обновить закрепление. Попробуйте снова.",
  "communication_note_not_found": "Заметка не найдена или у вас нет доступа.",
  "communication_site_not_in_filters": "Сайт этой заметки не в текущих фильтрах. Возможно, у вас нет доступа к этой локации.",
  "communication_edit": "Изменить",
  "communication_delete": "Удалить",
  "communication_save": "Сохранить",
  "communication_cancel": "Отмена",
  "communication_saving": "Сохранение...",
  "communication_note_updated": "Заметка обновлена.",
  "communication_update_failed": "Не удалось обновить заметку. Попробуйте снова.",
  "communication_delete_confirm": "Удалить эту заметку? Это действие нельзя отменить.",
  "communication_delete_confirm_title": "Удалить заметку",
  "communication_note_preview": "Предпросмотр заметки:",
  "communication_note_deleted": "Заметка удалена.",
  "communication_delete_failed": "Не удалось удалить заметку. Попробуйте снова.",
  "communication_edited": "Изменено",
  "communication_show_more": "Показать ещё",
  "communication_show_less": "Свернуть",
  "communication_sort_date_newest": "Сначала новые",
  "communication_sort_date_oldest": "Сначала старые",
  "communication_sort_author": "По автору",
  "communication_sort_type": "По типу",
  "communication_sort_pinned": "Сначала закреплённые",
  "communication_sort_label": "Сортировка",
  "communication_filter_by_type": "Тип",
  "communication_filters_group_aria": "Фильтрация и сортировка заметок",
  "communication_search_label_short": "Поиск",
  "employees": "Сотрудники",
  "dayOfWeek": "дней",
  "service_log": "Служебный журнал",
  "rooms": "Номера",
  "bulk_add_rooms": "Массовое добавление комнат",
  "add_rooms": "Добавить комнаты",
  "room_names_one_per_line": "Названия комнат (по одному на строку)",
  "enter_at_least_one_room": "Введите хотя бы одно название помещения",
  "room_names_placeholder": "Комната 1\nКомната 2\nЖенский туалет",
  "rooms_with_prefix": "комнат с префиксом",
  "apply_to_all_rooms": "Применить ко всем комнатам (необязательно)",
  "bulk_rooms_intro": "Добавьте одну или несколько групп. У каждой группы свои здание, этаж, зона, тип и названия комнат.",
  "group": "Группа",
  "add_group": "+ Добавить другую группу",
  "adding_rooms": "Добавление комнат...",
  "bulk_summary": "Итого",
  "in": "в",
  "bulk_rooms_success": "Успешно добавлено комнат: {n}",
  "displayName": "Название комнаты",
  "SLA": "ОАС",
  "supervisors": "контролеры",
  "supervisor": "руководитель",
  "performance_analytics": "Производительность Аналитика",
  "arrivals": "Прибытие",
  "inspections": "инспекции",
  "avgResponseTime": "время отклика",
  "missedSla": "Пропущенный Сла",
  "cleaner_arrived": "Очиститель Прибыл",
  "load_more": "Загрузи больше",
  "login": "Авторизоваться",
  "email": "Электронное письмо",
  "emails": "Письма",
  "password": "Пароль",
  "min": "мин",
  "Logout": "Выйти",
  "time_range": "Период времени",
  "select_time_range": "Выберите период времени",
  "custom_time": "Выберите даты",
  "last_day": "Вчера",
  "last_week": "Последние 7 дней",
  "last_month": "Последние 30 дней",
  "last_quarter": "Последние 90 дней",
  "last_6_months": "Последние 6 месяцев",
  "last_year": "Последние 365 дней",
  "data_by_hour": "Данные по часу",
  "general": "Общий",
  "cleaning": "очищающий",
  "maintenance": "Обслуживание",
  "start": "Начинать",
  "start_time": "начальное время",
  "management_co": "управление совместно.",
  "cleaning_co": "очистки сотрудничества.",
  "companies": "компании",
  "name": "имя",
  "site_count": "сайт #",
  "associated_companies": "связанные с конечными клиентами",
  "OK": "Ok",
  "cancel": "Отмена",
  "client": "клиент",
  "dates": "даты",
  "shift": "сдвиг",
  "issue": "проблема",
  "time": "время",
  "top complaint of the week": "Верхняя жалоба недели",
  "top room of the week": "Верхняя комната недели",
  "top hour of the week": "топ час недели",
  "top complaint of the month": "Верхняя жалоба месяца",
  "top room of the month": "Верхняя комната месяца",
  "top hour of the month": "топ час месяца",
  "franchises": "франшиз",
  "add_franchise": "добавить франшизу",
  "room_names": "название комнаты",
  "type": "тип",
  "please_select_company_site": "пожалуйста, выберите компанию & сайт",
  "number": "номер",
  "create_building_map": "создать здание карты",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "эй быстрый способ добавить этажи и комнаты до здания с помощью этого быстрого мастера",
  "avg number of toilets per floor": "туалетов на этаже",
  "avg.number of toilet cells per room": "Avg.number туалетных клеток в комнате",
  "number of floors": "Количество этажей",
  "avg.number of disabled toilets": "Avg.number туалетов для инвалидов",
  "avg.number of soap dispensers": "Avg.number из мыла",
  "reset_filter": "сброс фильтра",
  "add": "Добавить",
  "new_survey": "повторная съемка",
  "api_configuration": "Конфигурация API",
  "please_edit_the_api_information": "Измените API Информация",
  "method": "метод",
  "authorization": "авторизация",
  "api_url": "api_url",
  "token": "знак",
  "api_request_info": "API Запросить информацию",
  "roomName": "Название комнаты",
  "servikName": "Имя жалобы",
  "siteName": "Название сайта",
  "stage": "Этап",
  "number_of_buttons": "Количество кнопок",
  "button_shape": "Кнопка Shape",
  "delay_time_stage": "Время задержки Этап",
  "go_to_stage": "Перейти к Этап",
  "color": "Цвет",
  "add_stage": "Добавить этап",
  "save": "Сохранять",
  "number_of_issues": "ряд вопросов",
  "online": "онлайн",
  "offline": "не в сети",
  "offline_devices": "Офлайн устройства",
  "no_offline_devices": "Офлайн устройства не найдены",
  "working_devices": "Работающие устройства",
  "no_working_devices": "Работающие устройства не найдены",
  "room_name": "название комнаты",
  "installation_spot": "место",
  "device_id": "идентификатор устройства",
  "date": "Дата",
  "status": "положение дел",
  "device_status": "состояние устройства",
  "none": "никто",
  "no_surveys_created": "Нет опросов Дата создания",
  "dashboard": "Приборная панель",
  "franchise_name": "Франшиза Имя",
  "franchise_country": "Франшиза Страна",
  "choose_franchise": "Выберите Франчайзинг",
  "choose_country": "Выберите страну",
  "select_template": "Выбор шаблона",
  "default_survey": "По умолчанию Обзор",
  "cleaning_survey": "Обзор Очистка",
  "kitchen_survey": "Кухня Обзор",
  "template": "Шаблон",
  "area_name": "Имя Регион",
  "rooms_names": "Номера Имена",
  "rooms_number": "Номера #",
  "assign_number": "Назначать #",
  "active_notification_task": "Активный Уведомление Task",
  "amount_limit": "счетчик интервалов",
  "after_max": "Счетчик после Max",
  "new_area": "новая область",
  "edit_area": "редактировать область",
  "tablet": "таблетка",
  "counter women": "Счетчик Женщины",
  "counter men": "Счетчик Человек",
  "counter handicap": "Счетчик фора",
  "counter man/woman": "Счетчик Мужчина / женщина",
  "counter man / woman": "Счетчик Мужчина / женщина",
  "sensor liquid": "Датчик Жидкая",
  "double toilet paper": "Двойная туалетная бумага",
  "toilet paper": "Туалетная бумага",
  "tag": "Тег",
  "qr tag": "QR тег",
  "additional_info": "Дополнительная информация",
  "servikCategory": "тип вызова",
  "dishwashing": "Посудомоечные",
  "cafeteria": "кафетерий",
  "clean room": "Чистая комната",
  "office": "Офис",
  "meeting room": "Комната для переговоров",
  "cubic": "кубический",
  "women": "Женщины",
  "men": "Мужчины",
  "handicap": "гандикап",
  "Combined": "комбинированный",
  "kitchen": "Кухня",
  "east": "Восток",
  "west": "Запад",
  "north": "север",
  "south": "юг",
  "right": "Правильно",
  "left": "Оставили",
  "center": "Центр",
  "up": "Вверх",
  "down": "Вниз",
  "combined": "комбинированный",
  "lobby": "Лобби",
  "entrance": "Вход",
  "reception": "прием",
  "area": "Площадь",
  "mezzanine": "мезонин",
  "gallery": "Галерея",
  "ground": "Земля",
  "elevator": "Лифт",
  "is_calculated": "Рассчитано номер",
  "calculated_room": "Расчетный номер",
  "splitted_survey": "разделенный опрос",
  "redirect_to_url": "перенаправить на url",
  "survey_site": "Сайт исследования",
  "clicks": "щелчки",
  "add_stage_number_to_signal": "прикрепить номер этапа",
  "including_pad9": "в том числе pad9",
  "room_type_required": "Выберите тип помещения для каждой группы",
  "Tech Manufacturers": "Технологические производители",
  "Tech Offices": "Технологические офисы",
  "Offices": "Офисы",
  "Terminal": "Терминал",
  "Universities": "Университеты",
  "Factories": "Фабрики",
  "Hospital": "Больница",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Магазины у дома",
  "Food Chains": "Сети общественного питания",
  "Residential": "Жилой сектор",
  "Shopping Center": "Торговый центр",
  "Survey": "Опрос",
  "Demo": "Демо",
  "Vision": "Vision",
  "Court": "Суд",
  "Office Management": "Управление офисами",
  "Government Office": "Госучреждение",
  "default_name": "Имя на английском",
  "exposures": "Опытные чистые туалеты",
  "exposures_tab": "Активность комнаты",
  "expose_results": "Результаты",
  "events_expose": "События",
  "expose_score": "Ставка",
  "shift_events_expose": "cмежные события и разоблачить",
  "type_of_site": "тип сайта",
  "sector": "сектор",
  "last_time_of_arrival": "последнее время прибытия",
  "arrival_and_status": "прибытие & статус",
  "preview_arrivals": "предварительный просмотр прибытия",
  "men toilet": "мужской туалет",
  "women toilet": "женский туалет",
  "shared toilet": "общий туалет",
  "unisex restroom": "Туалет унисекс",
  "handicapped toilet": "туалет для инвалидов",
  "logistics": "Логистика",
  "cubicle": "Кабинка",
  "gym": "Спортзал",
  "morning_shift": "утренняя смена",
  "afternoon_shift": "вторую смену",
  "night_shift": "ночная смена",
  "update": "обновить",
  "restart": "перезапуск",
  "send_data": "отправить данные",
  "send_count": "отправить счетчик",
  "blink": "подсветить",
  "beacon": "Маяк",
  "like_btn": "кнопка лайка",
  "requires_like_btn": "требуется включенная кнопка лайка",
  "maintenance_btn": "кнопка обслуживания",
  "battery": "батарея",
  "version": "версия",
  "actions": "действия",
  "device_actions": "Действия устройства",
  "device_settings": "Настройки устройства",
  "drains_battery": "разряжает батарею",
  "latest_errors": "последние ошибки",
  "no_errors": "нет ошибок",
  "offline_calls": "Офлайн-оповещения",
  "offline_duration_calls": "Продолжительность автономных оповещений",
  "counterCalls": "Счетчик оповещений",
  "active": "Активный",
  "no_active_supervisors": "Нет активных супервайзеров",
  "active_supervisors_column": "Активные супервайзеры",
  "supervisors_active_label": "супервайзеры активны сейчас",
  "active_supervisors_coverage_hint": "Активные супервайзеры включили эту зону в приложении. Это не означает онлайн- или физическое присутствие.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Активный расчет",
  "pad": "ПАД",
  "pad_counter": "Счетчик ПАД",
  "counter_status": "Статус счетчика",
  "choose_state": "Выберите состояние",
  "choose_city": "Выберите город",
  "start_hour": "Начало часа",
  "end_hour": "Конец часа",
  "analytics_log": "Аналитика",
  "or": "или же",
  "no_data_available": "Нет данных",
  "filter_by_cleaner": "Фильтр по уборщику",
  "all_cleaners": "Все уборщики",
  "failed_to_load_data": "Не удалось загрузить данные",
  "not_available": "Н/Д",
  "no_tasks": "Нет задач",
  "temporarily_unavailable": "Временно недоступно",
  "category": "Категория",
  "title": "Заголовок",
  "task_type": "Тип задачи",
  "task_languages": "Языки задачи",
  "task_languages_hint": "Выберите языки для этой задачи. Введите название на каждом выбранном языке.",
  "task_category": "Категория задачи",
  "call_to_action": "Звонок к действию",
  "schedule": "Расписание",
  "insert_text": "Вставить текст",
  "select": "Выбрать",
  "select_all": "Выбрать все",
  "n_selected": "Выбрано: {count}",
  "clear_selection": "Очистить выбор",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Даты расписания",
  "language": "Язык",
  "calendar": "Календарь",
  "operation": "Операция",
  "daily": "Ежедневно",
  "weekly": "Еженедельно",
  "monthly": "Ежемесячно",
  "quarterly": "Квартально",
  "yearly": "Ежегодно",
  "sunday": "Воскресенье",
  "monday": "Понедельник",
  "tuesday": "Вторник",
  "wednesday": "Среда",
  "thursday": "Четверг",
  "friday": "Пятница",
  "saturday": "Суббота",
  "january": "Январь",
  "february": "Февраль",
  "march": "Март",
  "april": "Апрель",
  "may": "Май",
  "june": "Июнь",
  "july": "Июль",
  "august": "Август",
  "september": "Сентябрь",
  "october": "Октябрь",
  "november": "Ноябрь",
  "december": "Декабрь",
  "1st week": "1 неделя",
  "2nd week": "2 неделя",
  "3rd week": "3 неделя",
  "4th week": "4 неделя",
  "5th week": "5 неделя",
  "1st quarter": "1 квартал",
  "2nd quarter": "2 квартал",
  "3rd quarter": "3 квартал",
  "4th quarter": "4 квартал",
  "edit_task": "Редактировать задачу",
  "created_at": "Создано",
  "installed_at": "Установлено",
  "hour": "Час",
  "week_days": "Дни недели",
  "month_weeks": "Недели месяца",
  "month_days": "Дни месяца",
  "no_tasks_found": "Задачи не найдены",
  "invalid_lanauge": "Неверный язык",
  "no_active_tasks_found": "Активные задачи не найдены",
  "edit": "Редактировать",
  "send_date": "Дата отправки",
  "invalid_date": "Неверная дата",
  "cells_num": "# ячеек",
  "sinks_num": "# раковин",
  "urinals_num": "# унитазов",
  "toilet_paper_size": "Размер туалетной бумаги",
  "email_configuration": "Настройки электронной почты",
  "please_edit_the_email_information": "Пожалуйста, отредактируйте информацию электронной почты",
  "email_sender_info": "Информация о отправителе электронной почты",
  "email_subject_info": "Информация о теме электронной почты",
  "email_message_info": "Информация о сообщении электронной почты",
  "companyName": "Название компании",
  "email_language": "Язык электронной почты",
  "complaint_language": "Язык жалобы",
  "email_message_format": "Формат сообщения электронной почты",
  "line": "Линия",
  "list": "Список",
  "roomType": "Тип комнаты",
  "By logging in, you agree to Buzzztech's": "Войдя в систему, вы соглашаетесь с условиями использования Buzzztech",
  "Terms and Conditions": "Условия использования",
  "and": "и",
  "Privacy Policy": "Политика конфиденциальности",
  "All actions within this panel are recorded for quality control and improvement": "Все действия в этой панели записываются для контроля качества и улучшения",
  "You must agree to the terms and conditions": "Вы должны согласиться с условиями использования",
  "months": "Месяцы",
  "ref_id": "Идентификатор",
  "room_name_en": "Название комнаты (англ.)",
  "site_state": "Государство сайта",
  "site_city": "Cайт город",
  "site_country": "Cтрана сайта",
  "first_date": "Первое свидание",
  "pinned": "Закреплено",
  "no.": "№",
  "must_be_numbers": "Должны быть цифры",
  "must_be_3_digits": "Должно быть 3 цифры",
  "must_have_english_title": "Должно быть английское название",
  "total_sites": "Общий",
  "site_information": "информация сайта",
  "holiday_offdays": "Праздники и выходной",
  "add_offday": "выходной",
  "add_holiday": "Holiday",
  "name_under_chars": "имя до 25 символов",
  "days_comma_separated": "действительные дни, разделенные запятой",
  "year": "год",
  "month": "месяц",
  "day": "день",
  "holiday_name": "название праздника",
  "offday_name": "название выходного дня",
  "delete_confirmation_title": "Вы уверены?",
  "delete_confirmation_message": "Это действие нельзя отменить.",
  "are_you_sure": "Вы уверены?",
  "israel": "Израиль",
  "USA": "США",
  "poland": "Польша",
  "mexico": "Мексика",
  "cyprus": "Кипр",
  "brazil": "Бразилия",
  "romania": "Румыния",
  "netherlands": "Нидерланды",
  "tablet_survey": "Планшетный опрос",
  "no_shift_survey": "Нет сменного опроса",
  "number_of_rows": "Количество строк",
  "rating_shape": "Форма рейтинга",
  "content_survey": "Опрос содержания",
  "rating_survey": "Опрос рейтинга",
  "device-alerts": "Проблема",
  "device-active": "Активный",
  "device-search": "Поиск",
  "mac_id": "MAC-адрес",
  "qr_tag": "QR-тег",
  "sensor": "Датчик",
  "image_survey": "Опрос изображения",
  "open_text": "Открытый текст",
  "open_text_survey": "Открытый текст",
  "embedded_link": "Встроенная ссылка",
  "device-counter": "Счетчики",
  "count": "Считать",
  "last_date": "Последнее свидание",
  "last_arrival":"Последний приезд уборщицы",
  "cleaners": "Уборщицы",
  "viewer": "Зритель",
  "android": "Андроид",
  "ios": "iOS",
  "no_users_found": "Пользователи не найдены",
  "cleaner_activity": "Активность уборщиков",
  "pad_presence_testing": "Тест присутствия у пада",
  "pad_presence_testing_subtitle": "Входы, выходы и офлайн-нажатия пада, переданные с телефона, для выбранного объекта",
  "pad_presence_timeline": "Живая лента",
  "pad_presence_sessions": "Сессии присутствия",
  "pad_presence_offline_presses": "Офлайн-нажатия с телефонов",
  "pad_presence_select_site_hint": "Выберите компанию и объект в шапке, чтобы смотреть события присутствия.",
  "pad_presence_no_events": "В этом периоде нет событий присутствия.",
  "pad_presence_open": "Открыто",
  "pad_presence_exit_phone": "Выход с телефона",
  "pad_presence_exit_auto": "Автовыход",
  "pad_presence_exit_stale": "Устаревший выход",
  "pad_presence_enter": "Вход",
  "pad_presence_exit": "Выход",
  "pad_presence_offline": "Офлайн-нажатие",
  "pad_presence_faulty": "Ошибка",
  "pad_presence_employee": "Сотрудник",
  "pad_presence_room": "Комната",
  "pad_presence_time_from": "С",
  "pad_presence_last_updated": "Обновлено",
  "pad_presence_duration": "Длительность",
  "pad_presence_exit_type": "Тип выхода",
  "pad_presence_button": "Кнопка",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Счётчик",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Все сотрудники",
  "pad_presence_all_rooms": "Все комнаты",
  "pad_presence_load_error": "Не удалось загрузить данные присутствия у пада.",
  "pad_presence_in_room_now": "Сейчас в комнате",
  "pad_presence_in_room": "в",
  "pad_presence_since": "с",
  "pad_presence_just_now": "Только что",
  "pad_presence_pad": "Пад",
  "pad_presence_phone": "Телефон",
  "pad_presence_all_phones": "Все телефоны",
  "pad_presence_window": "Показать",
  "pad_presence_window_hour": "Последний час",
  "pad_presence_window_today": "Сегодня",
  "pad_presence_window_month": "Последний месяц",
  "pad_presence_pads": "Пады на этом объекте",
  "pad_presence_no_pads": "На этом объекте пады не назначены комнатам.",
  "pad_presence_last_enter": "Последний вход",
  "pad_presence_last_offline": "Последнее офлайн-нажатие",
  "pad_presence_auto_exit_leave": "Выйдите сейчас → автовыход через",
  "pad_presence_auto_exit_earliest": "Самый ранний с момента входа:",
  "pad_presence_auto_exit_passed": "Самое раннее время автовыхода прошло. Всё ещё открыто = пад всё ещё слышен, либо выйдите и подождите 5м 45с.",
  "cleaner_activity_live_footer": "Данные обновляются в реальном времени",
  "ca_empty_select_site_hint": "Выберите компанию и объект в шапке, чтобы просмотреть активность уборщиков за сегодня.",
  "ca_empty_no_cleaners_hint": "Нет уборщиков, назначенных на этот объект и текущую смену. Назначьте активные объекты и смены в разделе Пользователи.",
  "ca_empty_access_denied": "Доступ запрещён",
  "ca_empty_access_denied_hint": "У вас нет прав на просмотр активности уборщиков для этого объекта.",
  "ca_empty_load_error_hint": "Не удалось загрузить активность. Попробуйте снова или обратитесь в поддержку, если проблема сохраняется.",
  "ca_empty_no_filter_match": "Нет уборщиков по этим фильтрам",
  "ca_empty_no_filter_match_hint": "Очистите фильтры или выберите другого уборщика, рабочую зону или комнату.",
  "ca_timeline_all_cleaners": "Активность за сегодня — все уборщики",
  "ca_legend_work": "Активен",
  "ca_clock_sessions_more": "ещё",
  "ca_clock_sessions_less": "Показать меньше",
  "ca_sort_label": "Сортировка",
  "ca_sort_needs_attention": "Требует внимания",
  "ca_sort_best_avg_response": "Лучшее среднее время ответа",
  "ca_sort_worst_avg_response": "Худшее среднее время ответа",
  "ca_sort_most_sla_breaches": "Больше всего нарушений SLA",
  "ca_sort_most_open_complaints": "Больше всего открытых жалоб",
  "ca_sort_most_work_time": "Больше всего рабочего времени",
  "ca_sort_least_work_time": "Меньше всего рабочего времени",
  "ca_stat_avg_short": "ср.",
  "ca_stat_open_short": "откр.",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "работа",
  "ca_assigned_room_avg_hint": "Среднее время ответа по назначенным комнатам сегодня",
  "ca_transit_tooltip": "Время перехода между задачами",
  "ca_transit_live_tooltip": "Время с момента закрытия последней задачи",
  "ca_legend_visits": "Посещения между вызовами",
  "ca_visits_between_sla": "Посещения с момента закрытия предыдущего вызова",
  "ca_apply": "Применить",
  "ca_visits_since": "с",
  "ca_deferred_tip_title": "Отложенная жалоба",
  "ca_deferred_tip_resolved": "Решена",
  "ca_deferred_tip_desc_open": "Ещё открыта — уборщик сначала обслужил другие комнаты вместо этой.",
  "ca_deferred_tip_desc_closed": "Эта жалоба оставалась открытой, пока уборщик сначала обслуживал другие комнаты.",
  "ca_deferred_tip_rooms_label": "Сначала обслужены:",
  "ca_attention_title": "Требует внимания",
  "ca_attention_empty": "Всё в порядке — проблем нет",
  "ca_attention_sla_breach_one": "{name} · нарушение SLA",
  "ca_attention_sla_breach_many": "{name} · {count} нарушений SLA",
  "ca_attention_open_while_out_one": "{name} · открытая жалоба вне смены",
  "ca_attention_open_while_out_many": "{name} · {count} открытых вне смены",
  "ca_attention_idle": "{name} · простой {duration}",
  "ca_attention_late": "{name} · опоздание на смену",
  "ca_attention_show": "Показать",
  "ca_attention_hide": "Скрыть",
  "ca_view_shift": "Смена",
  "ca_view_history": "История",
  "ca_filters_done": "Готово",
  "ca_hist_preset_this_month": "Этот месяц",
  "ca_hist_preset_last_month": "Прошлый месяц",
  "ca_hist_preset_this_week": "Эта неделя",
  "ca_hist_preset_last_week": "Прошлая неделя",
  "ca_hist_preset_custom": "Произвольный",
  "ca_hist_from": "С",
  "ca_hist_to": "По",
  "ca_hist_range_invalid": "Дата начала должна быть раньше даты окончания",
  "ca_hist_range_too_long": "Период не может превышать {max} дней",
  "ca_hist_search": "Поиск по имени или телефону",
  "ca_hist_people_count": "{count} сотрудников",
  "ca_hist_kpi_days": "Отработано дней",
  "ca_hist_kpi_net": "Чистые часы",
  "ca_hist_kpi_breaks": "Перерывы",
  "ca_hist_col_person": "Сотрудник",
  "ca_hist_col_total": "Всего часов",
  "ca_hist_col_total_tip": "От прихода до ухода без вычета перерывов — то же значение, что видит сотрудник в приложении",
  "ca_hist_col_net": "Чистые часы",
  "ca_hist_col_breaks": "Перерывы",
  "ca_hist_col_issues": "Замечания",
  "ca_hist_col_late": "Опоздание",
  "ca_hist_col_missed": "Пропуск",
  "ca_hist_col_no_clock_out": "Без ухода",
  "ca_hist_clocked_in_now": "Сейчас на смене",
  "ca_hist_not_assigned": "Не закреплён за этим объектом",
  "ca_hist_no_shift": "Смена не назначена",
  "ca_hist_unknown_name": "Неизвестно",
  "ca_hist_empty": "Нет посещаемости за этот период",
  "ca_hist_empty_hint": "На этом объекте никто не отмечался, и к нему не закреплены сотрудники.",
  "ca_hist_no_match": "Нет сотрудников, соответствующих фильтрам",
  "ca_hist_load_error_hint": "Не удалось загрузить историю посещаемости. Повторите попытку чуть позже.",
  "ca_hist_prev_person": "Предыдущий сотрудник",
  "ca_hist_next_person": "Следующий сотрудник",
  "ca_hist_close": "Закрыть",
  "ca_hist_legend_worked": "Работал",
  "ca_hist_legend_late": "Опоздание",
  "ca_hist_legend_missed": "Пропуск",
  "ca_hist_legend_no_clock_out": "Без ухода",
  "ca_hist_late_by": "Опоздание {duration}",
  "ca_hist_late_tip": "Приход в {time}, {shift} начинается в {start}",
  "ca_hist_missed": "Пропуск",
  "ca_hist_missed_tip": "Запланированная смена закончилась без отметки прихода",
  "ca_hist_no_clock_out": "Без ухода",
  "ca_hist_no_clock_out_tip": "Сессия не закрыта; её часы не учитываются",
  "ca_hist_in_progress": "Всё ещё на смене",
  "ca_hist_auto": "авто",
  "ca_hist_open_break": "открыт",
  "ca_hist_day_col_gross": "Всего часов",
  "ca_hist_day_col_breaks": "Перерывы",
  "active_cleaners": "Активные уборщики",
  "closed_complaints": "Закрытые жалобы",
  "total_work_time": "Общее время работы",
  "total_work_time_net": "Общее время работы (сегодня нетто)",
  "total_break_time": "Общее время перерывов",
  "avg_response_time": "Среднее время решения",
  "cleaner": "Уборщик",
  "clocked_in": "Отметка прихода",
  "clocked_out": "Отметка ухода",
  "still_clocked_in": "Ещё на смене",
  "clocked_in_late": "Поздняя отметка входа",
  "total_hours": "Всего часов",
  "auto_punch": "Авто (геозона)",
  "manual_punch": "Вручную",
  "complaint_opened": "Жалоба открыта",
  "complaint_closed": "Жалоба закрыта",
  "complaint_still_open": "Ещё открыта",
  "resolved_in": "Решено за",
  "open_for": "Открыта уже",
  "sla_breached": "Нарушение SLA",
  "no_activity_today": "Сегодня ещё нет активности",
  "just_now": "только что",
  "ago": "назад",
  "today": "Сегодня",
  "live": "В реальном времени",
  "last_updated": "Обновлено",
  "no_cleaners_found": "Уборщицы не найдены",
  "new_cleaner": "Новая уборщица",
  "edit_cleaner": "Редактировать уборщицу",
  "have_you_finished_making_changes": "Вы закончили вносить изменения?",
  "assignment_issues_found": "Найдены проблемы с назначениями",
  "unassigned_rooms_title": "Неназначенные комнаты",
  "overlapping_assignments_title": "Пересекающиеся назначения",
  "and_n_more": "и ещё {count}",
  "continue_anyway": "Всё равно продолжить",
  "stay_and_fix": "Остаться и исправить",
  "assignment_coverage_issues": "{unassigned} без назначения · {overlaps} пересечений",
  "assignment_check_failed": "Не удалось проверить назначения комнат",
  "tap_for_details": "Нажмите для подробностей",
  "has_app": "Приложение",
  "has_app_tooltip": "У уборщика есть приложение",
  "notifications_tooltip": "Пуш-уведомления включены",
  "assigned_to_rooms": "Назначен на комнаты",
  "assigned_to_rooms_tooltip": "Назначены комнаты на объекте",
  "recently_active": "Недавно активен",
  "works_at_site": "Работает на объекте",
  "recently_active_tooltip": "Открывал приложение за последние 30 минут",
  "please_select": "Пожалуйста, выберите",
  "please_select_site_first": "Пожалуйста, сначала выберите сайт",
  "working_areas": "Рабочие области",
  "no_working_areas": "Рабочих областей пока нет",
  "working_area_alerts": "Оповещения",
  "api": "API",
  "please_create_room_before_working_area": "Пожалуйста, создайте хотя бы одну комнату перед созданием рабочей области",
  "isWorkingInSite": "Работает на сайте",
  "you_are_not_allowed_to_edit": "Вы не можете редактировать",
  "you_are_not_allowed_to_remove": "Вы не можете удалить",
  "task": "Задача",
  "portuguese": "португальский",
  "russian": "русский",
  "spanish": "испанский",
  "polish": "польский",
  "installer": "Установщик",
  "once": "Один раз",
  "time_saved": "Время сохранено",
  "yes": "да",
  "no": "нет",
  "workingAreaNames": "Рабочие области",
  "shift_rooms":"Номера",
  "new_shift":"Новая смена",
  "add_shift_inactive": "Добавьте отражающие сдвиги",
  "remove_auto_shift_inactive": "Удалить автоматические рефлексивные смены",
  "additional_options": "Дополнительные опции",
  "add_default_shifts": "Добавить смены по умолчанию",
  "no_user_found": "Пользователь не найден",
  "no_site_found": "Сайт не найден",
  "service_provider": "Поставщик услуг",
  "qr task": "QR задача",
  "qr_task": "QR задача",
  "all_day": "Весь день",
  "auto_start": "Автозапуск",
  "english_title": "Английское название",
  "connectivity": "Связь",
  "power": "Мощность",
  "Your work has been saved": "Ваша работа была сохранена",
  "schedule_call_time": "Время звонка",
  "schedule_call_gap": "Интервал звонка",
  "gapInMinutes": "Интервал в минутах",
  "no_manual_calls_available": "Нет доступных ручных вызовов",
  "manual_calls": "Ручные вызовы",
  "cleandex_calls": "Cleandex звонки",
  "cleandexCalls": "Cleandex звонки",
  "manualCalls": "Ручные вызовы",
  "inactive": "Неактивный",
  "on hold": "На удержании",
  "sequential": "Последовательный",
  "ratio": "Соотношение",
  "must_choose": "Должен выбрать",
  "surveyApp": "Приложение для опросов",
  "installation": "Установка",
  "manager": "Менеджер",
  "previous": "Предыдущий",
  "next": "Следующий",
  "no_rooms_found": "Комнаты не найдены",
  "show_calendar": "Показать календарь",
  "seeAll": "Смотреть все",
  "showPaginated": "Показать постранично",
  "cleaners_arrivals": "Прибытие уборщиц",
  "add_address": "Добавить адрес",
  "site_auto_attendance_enabled":
    "Разрешить автоматическую регистрацию входа и выхода через геозону в мобильном приложении (нужны разрешения на геолокацию у сотрудников).",
  "site_auto_attendance_requires_location":
    "Сначала укажите на карте точку и радиус не менее 100 м, затем включайте автоматическую отметку.",
  "site_mandatory_clock_in": "Требовать отметку прихода перед работой",
  "site_mandatory_clock_in_description":
    "Сотрудники этого объекта должны отметить приход, прежде чем смогут открыть разделы уборки, обслуживания и заданий в мобильном приложении.",
  "site_mandatory_clock_in_without_location":
    "Для этого объекта не задано место на карте, поэтому приложение не может определить, находится ли сотрудник на объекте. Пока место не задано, требование действует для этих сотрудников везде.",
  "edit_address": "Редактировать адрес",
  "choose_radius": "Выберите радиус",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Зелёный = OK. Красный = Рекомендуется уборка. Наведите на значок для деталей.",
  "recommended_to_clean": "Рекомендуется уборка",
  "cleandex_warning_level": "Уровень предупреждения Cleandex",
  "select_warning_level": "Выберите уровень предупреждения",
  "bronze": "Бронза",
  "silver": "Серебро",
  "gold": "Золото",
  "ai": "ИИ",
  "daily_employees_num": "Ежедневное количество сотрудников",
  "daily_shift_hours": "Часы ежедневной смены",
  "rooms_num": "Количество комнат",
  "buildings_num": "Количество зданий",
  "cleaner_entries": "Входы уборщиков",
  "avg_daily_visits_monthly": "Среднее количество ежедневных посещений в месяц",
  "avg_daily_cleaners_to_save": "Среднее количество уборщиков для экономии в день",
  "saving_hours_per_day": "Экономия часов в день",
  "saving_money_per_day": "Экономия денег в день",
  "saving_money_per_month": "Экономия денег в месяц",
  "cleaners_to_visitors_ratio": "Соотношение уборщиков к посетителям",
  "cleaning_time_in_minutes_per_room": "Время уборки в минутах на комнату",
  "max_number_of_rooms_per_employee": "Максимальное количество комнат на сотрудника",
  "break_time_per_hour": "Время перерыва в час",
  "transition_time_between_tasks": "Время перехода между задачами",
  "employer_cost_hour": "Стоимость работодателя за час",
  "lobby_cleaning_per_floor": "Уборка лобби на этаж",
  "desired_cleaning_time": "Желаемое время уборки",
  "desired_number_of_entries": "Желаемое количество входов",
  "buzz_system_cost_per_unit_per_month": "Стоимость системы Buzz за единицу в месяц",
  "total_buzz_system_cost_per_month": "Общая стоимость системы Buzz в месяц",
  "return_on_investment_in_months": "Окупаемость в месяцах",
  "annual_savings": "Годовая экономия",
  "roi_calculator": "Калькулятор ROI",
  "cleaners_number": "Количество уборщиков",
  "floors_num": "Количество этажей",
  "avg_daily_cleaners_required": "Среднее количество уборщиков, необходимых в день",
  "app_pages": "Страницы приложения",
  "buzzzTime": "Время Buzzz",
  "missions": "Миссии",
  "send_emails": "Отправить письма",
  "enter": "Введите",
  "account": "Аккаунт",
  "privacy": "Конфиденциальность",
  "personal_settings": "Личные настройки",
  "personal_settings_lead": "Язык и настройки конфиденциальности.",
  "personal_settings_read_only": "Данные управляются администратором. Обратитесь к нему для изменений.",
  "change_password": "Сменить пароль",
  "change_password_hint": "Смена пароля завершит сеансы на других устройствах.",
  "current_password": "Текущий пароль",
  "new_password": "Новый пароль",
  "confirm_new_password": "Подтвердите новый пароль",
  "password_min_length": "Пароль должен содержать не менее 8 символов",
  "passwords_do_not_match": "Пароли не совпадают",
  "new_password_same_as_current": "Новый пароль должен отличаться от текущего",
  "current_password_incorrect": "Текущий пароль неверен",
  "current_password_required": "Введите текущий пароль",
  "password_changed_successfully": "Пароль успешно изменён",
  "change_password_failed": "Не удалось изменить пароль",
  "forgot_password": "Забыли пароль?",
  "forgot_password_title": "Забыли пароль",
  "forgot_password_hint": "Введите email учётной записи панели — мы отправим ссылку для сброса, если аккаунт существует.",
  "forgot_password_sent": "Если аккаунт с таким email существует, ссылка для сброса отправлена. Проверьте почту.",
  "forgot_password_invalid_email": "Введите корректный адрес email",
  "forgot_password_failed": "Не удалось отправить письмо для сброса. Попробуйте снова.",
  "send_reset_link": "Отправить ссылку",
  "back_to_login": "Вернуться ко входу",
  "reset_password": "Сбросить пароль",
  "reset_password_hint": "Выберите новый пароль для учётной записи.",
  "reset_password_missing_token": "Ссылка для сброса неполная. Запросите новую на странице входа.",
  "reset_password_invalid_token": "Ссылка для сброса недействительна или устарела. Запросите новую.",
  "reset_password_failed": "Не удалось сбросить пароль",
  "password_reset_successfully": "Пароль успешно сброшен. Войдите с новым паролем.",
  "login_invalid_credentials": "Неверное имя пользователя или пароль",
  "login_credentials_required": "Введите имя пользователя или email и пароль",
  "login_network_error": "Не удалось связаться с сервером. Проверьте соединение и попробуйте снова",
  "login_failed": "Не удалось войти. Попробуйте снова",
  "login_too_many_attempts": "Слишком много попыток входа. Подождите 15 минут и попробуйте снова.",
  "forgot_password_too_many": "Слишком много запросов на сброс пароля. Подождите час и попробуйте снова.",
  "reset_password_too_many": "Слишком много попыток сброса пароля. Подождите час и попробуйте снова.",
  "change_password_too_many": "Слишком много попыток смены пароля. Подождите 15 минут и попробуйте снова.",

  "personal_settings_language_hint": "Для всего портала в этом браузере.",
  "personal_settings_privacy_hint": "Запрос на удаление персональных данных по закону о защите данных.",
  "personal_settings_role": "Роль",
  "Request deletion of my data": "Запросить удаление моих данных",
  "Request deletion of my data - confirm": "Запросить удаление моих данных? Администратору будет отправлено письмо. Мы обработаем запрос в течение 30 дней.",
  "Request deletion of my data - success": "Запрос отправлен. Мы обработаем его в течение 30 дней.",
  "Request deletion of my data - error": "Не удалось отправить запрос. Попробуйте снова или напишите на privacy@buzzztech.com.",
  "metrics": "Метрики",
  "select_three_metrics": "Выберите до 3 метрик для сравнения",
  "select_four_metrics": "Выберите до 4 метрик для сравнения",
  "legend": "Легенда",
  "more_details": "Подробнее",
  "performance_overview": "Обзор производительности",
  "loading_chart": "Загрузка графика",
  "retry": "Повторить",
  "performance_trending_upward": "Производительность растет",
  "high_complaint_ratio": "Высокий уровень жалоб",
  "click_bars_for_details": "Нажмите на столбцы для просмотра ежедневной аналитики",
  "refresh": "Обновить",
  "table": "Таблица",
  "cards": "Карты",
  "no_recent_arrivals": "Нет недавних прибытия",
  "feedback_charts": "Графики отзывов",
  "general_overview": "Общий обзор",
  "cleaning_complaints_breakdown": "Разделение жалоб на уборку",
  "maintenance_complaints_breakdown": "Разделение жалоб на обслуживание",
  "refresh_failed": "Обновление не удалось",
  "data_exported_successfully": "Данные успешно экспортированы",
  "data_export_failed": "Ошибка экспорта данных",
  "drill_down_unavailable": "Детализация доступна только в ежедневном просмотре",
  "sort_by": "Сортировать по",
  "no_active_shift": "Нет активной смены",
  "check_site_and_shift": "Пожалуйста, проверьте, выбран ли объект и есть ли активная смена",
  "please_add_shift_first": "Пожалуйста, сначала добавьте смену",
  "cleandex_no_data_message": "Данные Cleandex в настоящее время недоступны",
  "task_no_data_message": "Данные по задачам в настоящее время недоступны",
  "navigation": "Навигация",
  "network_information": "Информация о сети",
  "target_effectiveness": "Эффективность цели",
  "cleandex_call_cleaner": "Вызов уборщицы Cleandex",
  "top_complaint": "Верхняя жалоба", 
  "no_complaints": "Нет жалоб", 
  "official_start_date": "Официальная дата начала",
  "note_text": "Текст заметки",
  "add_note": "Добавить заметку",
  "general_note": "Общая заметка",
  "general_note_short": "Общая",
  "battery_short": "Батарея",
  "panel_short": "Панель",
  "technician_short": "Техник",
  "battery_replacement": "Замена батареи",
  "device_maintenance": "Обслуживание устройства",
  "maintenance_type": "Тип обслуживания",
  "panel_change": "Смена панели",
  "technician_check": "Проверка техником",
  "enter_note_details": "Введите детали заметки",
  "replacement_date": "Дата замены",
  "replaced_by_name": "Заменено кем",
  "replacement_note": "Заметка о замене",
  "enter_replacement_details": "Введите данные о замене",
  "replacement_history": "История замен",
  "loading_history": "Загрузка истории",
  "no_replacement_history": "История замен недоступна",
  "enter_technician_name": "Введите имя техника",
  "user_information": "Информация о пользователе",
  "enter_change_details": "Введите детали изменения",
  "panel_change_history": "История смены панели",
  "check_date": "Дата проверки",
  "checked_by_name": "Проверено кем",
  "enter_check_details": "Введите детали проверки",
  "technician_check_history": "История проверок техником",
  "no_technician_check_history": "История проверок техником недоступна",
  "change_date": "Дата изменения",
  "changed_by_name": "Изменено кем",
  "change_note": "Заметка об изменении",
  "check_note": "Заметка о проверке",
  "replaced_by": "Заменено кем",
  "no_data_entered": "Нет введенных данных",
  "no_panel_change_history": "История смены панели недоступна",
  "invalid_username": "Неверное имя пользователя",
  "invalid_phone": "Неверный номер телефона",
  "username_must_be_at_least_5_characters": "Имя пользователя должно содержать не менее 5 символов",
  "open_complaints": "Открытые жалобы",
  "open_sla_alerts": "Открытые оповещения о жалобах",
  "site_alerts": "Оповещения о сайтах",
  "open_duration": "Открытая продолжительность",
  "rooms_with_open_complaints_percentage": "Комнаты с открытыми жалобами",
  "rooms_with_cleaner_arrival_percentage": "Комнаты с прибытием уборщика",
  "rooms_without_cleaner_arrival_percentage": "Комнаты без прибытия уборщика",
  "site_alerts_total_rooms": "Всего комнат",
  "site_alerts_open_complaints_count": "Количество открытых жалоб",
  "site_alerts_customer_opening_date": "Дата открытия клиента",
  "company_country": "Страна компании",
  "select_message": "Выбрать сообщение",
  "message_no_cleaner_arrival": "Всем привет,\nОбратите внимание, что есть комнаты, где сегодня не было зарегистрировано прибытие уборщика.\nПожалуйста, разберитесь с этим",
  "message_open_complaints": "Всем привет,\nОбратите внимание, что есть несколько комнат с открытыми жалобами в течение долгого времени.\nПожалуйста, разберитесь с этим",
  "rooms_list": "Комнаты:",
  "no_open_slas": "Открытые SLA не найдены",
  "no_open_slas_description": "В настоящее время нет сайтов с открытыми SLA.",
  "no_slas_to_send": "Открытые SLA для этого сайта не найдены",
  "total_open_complaints": "Всего открытых жалоб",
  "longest_duration": "Самая длинная продолжительность",
  "complaints_details": "Детали жалоб",
  "no_results_found": "Результаты не найдены",
  "whatsapp": "WhatsApp",
  "loading": "Загрузка",
  "error_opening_whatsapp": "Ошибка при открытии WhatsApp. Пожалуйста, попробуйте снова.",
  "send_whatsapp": "Отправить WhatsApp",
  "more_options": "Больше опций",
  "preview_message": "Предпросмотр сообщения",
  "copy_message": "Копировать сообщение",
  "message_preview": "Предпросмотр сообщения",
  "phone_number_optional": "Номер телефона (необязательно)",
  "enter_phone_number": "Введите номер телефона (например, +79123456789)",
  "phone_number_hint": "Оставьте пустым, чтобы открыть WhatsApp без конкретного контакта",
  "message_copied": "Сообщение скопировано в буфер обмена!",
  "error_copying_message": "Ошибка при копировании сообщения. Попробуйте снова.",
  "opening_whatsapp": "Открытие WhatsApp...",
  "error_loading_slas": "Ошибка при загрузке деталей SLA. Пожалуйста, попробуйте снова.",
  "send_whatsapp": "Отправить WhatsApp",
  "more_options": "Больше опций",
  "preview_message": "Предпросмотр сообщения",
  "copy_message": "Копировать сообщение",
  "message_preview": "Предпросмотр сообщения",
  "phone_number_optional": "Номер телефона (необязательно)",
  "enter_phone_number": "Введите номер телефона (например, +79123456789)",
  "phone_number_hint": "Оставьте пустым, чтобы открыть WhatsApp без конкретного контакта",
  "message_copied": "Сообщение скопировано в буфер обмена!",
  "error_copying_message": "Ошибка при копировании сообщения. Попробуйте снова.",
  "opening_whatsapp": "Открытие WhatsApp...",
  "data_loading_please_wait": "Данные загружаются. Пожалуйста, подождите...",
  "dates_not_changed": "Даты не изменились. Перезагрузка не требуется.",
  "date_outside_stats_range": "Выбранные даты вне доступного диапазона статистики.",

  "date_range_invalid": "Дата «До» должна быть не раньше даты «От».",
  "filter_help_text": "Правила фильтрации: Сначала выберите Здание, чтобы включить фильтр Этажа. Большинство фильтров поддерживают множественный выбор.",
  "select_building_first": "Пожалуйста, сначала выберите Здание, чтобы включить фильтр Этажа",
  "cannot_select_gender_with_rooms": "Нельзя выбрать тип помещения, когда выбраны помещения",
  "cannot_select_gender_with_rooms_tooltip": "Фильтр типа помещения нельзя использовать, когда помещения выбраны. Сначала очистите выбор помещений.",
  "cannot_select_building_with_rooms": "Нельзя выбрать здание, когда выбраны комнаты",
  "cannot_select_building_with_rooms_tooltip": "Фильтр здания нельзя использовать, когда выбраны комнаты. Пожалуйста, сначала очистите выбор комнат.",
  "multi_select_hint": "Вы можете выбрать несколько вариантов",
  "filter_applied": "Фильтр успешно применен",
  "no_filters_selected": "Фильтры не выбраны. Выберите хотя бы один вариант фильтра.",
  "filters": "Фильтры",
  "location": "Местоположение",
  "attributes": "Атрибуты",
  "applying": "Применение...",
  "active_filters": "Активные фильтры",
  "viewing_room": "Просмотр комнаты",
  "multiple": "Множественный",
  "close": "Закрыть",
  "save_replacement": "Сохранить замену",
  "save_change": "Сохранить изменение",
  "save_check": "Сохранить проверку",
  "failed_to_load_maintenance_history": "Не удалось загрузить историю обслуживания",
  "Battery replacement recorded successfully": "Замена батареи успешно записана",
  "Panel change recorded successfully": "Изменение панели успешно записано",
  "Technician check recorded successfully": "Проверка техником успешно записана",
  "no_network_data_available": "Нет данных сети",
  "basic_information": "Основная информация",
  "service_providers": "Поставщики услуг",
  "settings_alerts": "Настройки и оповещения",
  "configuration": "Конфигурация",
  "contact_settings": "Контакты и настройки",
  "notifications": "Уведомления",
  "alert_language": "Язык оповещений",
  "select_language": "Выберите язык",
  "features": "Функции",
  "chat_ask_stats": "Спросить статистику",
  "chat_ask_buzzz": "Спросить Buzzz",
  "chat_stats_assistant": "Помощник по статистике",
  "chat_buzzz_assistant": "Помощник Buzzz",
  "chat_clear": "Очистить",
  "chat_placeholder": "Спросите о статистике уборки, например \"Сколько жалоб за прошлую неделю?\" или \"Какие комнаты требуют внимания?\"",
  "chat_placeholder_context": "Спросите о {scope}, например \"Сколько жалоб?\" или \"Какие комнаты требуют внимания?\"",
  "chat_thinking": "Думаю…",
  "chat_input_placeholder": "Спросите о посещениях, жалобах, комнатах…",
  "chat_send": "Отправить",
  "chat_chip_summary": "Сводка",
  "chat_chip_worst_rooms": "Худшие комнаты",
  "chat_chip_counter_calls": "Вызовы счётчика",
  "chat_chip_sla_issues": "Проблемы SLA",
  "chat_chip_busiest_hours": "Загруженные часы",
  "chat_chip_help": "Что можно спросить?",
  "chat_chip_focus": "На чём сосредоточиться?",
  "chat_chip_improving": "Какие комнаты улучшаются?",
  "chat_chip_best_rooms": "Лучшие комнаты по оценке",
  "chat_chip_worst_days": "Худшие дни",
  "chat_chip_complaint_types": "Типы жалоб",
  "chat_chip_positive_feedback": "Положительные отзывы",
  "chat_suggestions": "Предложения",
  "chat_error": "Что-то пошло не так. Попробуйте снова.",
  "chat_copy": "Копировать",
  "chat_copied": "Скопировано!",
  "chat_retry": "Повторить",
  "chat_chip_compare_periods": "Сравнить с прошлым периодом",
  "chat_chip_briefing": "Утренний брифинг",
  "chat_chip_cleaning_priority": "Приоритет уборки",
  "chat_chip_live_status": "Текущий статус",
  "chat_chip_shift_stats": "Эффективность смен",
  "chat_chip_staff_status": "Кто сейчас на работе?",
  "chat_chip_why_drilldown": "Почему? Детализация",
  "chat_pin": "Добавить в избранное",
  "chat_unpin": "Удалить из избранного",
  "chat_share": "Отправить по почте",
  "chat_export": "Экспорт",
  "chat_helpful": "Полезно",
  "chat_not_helpful": "Не полезно",
  "chat_hide": "Скрыть помощника",
  "chat_stop": "Остановить",
}

export const es = {
  ...serviks.es,
  monthMap: {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
  },
  weekMap: {
    1: 'Domingo',
    2: 'Lunes',
    3: 'Martes',
    4: 'Miércoles',
    5: 'Jueves',
    6: 'Viernes',
    7: 'Sábado',
  },
  "notified": "notificado",
  "supervisor_arrival": "llegada del supervisor",
  "arrival": "llegada",
  "arrival_badges": "Llegadas en turno",
  "callsHistory": "Historial de llamadas",
  "openCalls": "Llamadas abiertas",
  "visits_since_cleaned": "usuarios desde última limpieza",
  "visits_since_cleaned_short": "usuarios desde limpieza",
  "filter": "filtro",
  "logo": "logo",
  "counter": "contador",
  "sms": "SMS",
  "shifts": "turno",
  "call": "llamada",
  "duration": "duración",
  "time_start": "hora de inicio",
  "settings": "Ajustes",
  "always": "Siempre",
  "off": "Desactivado",
  "time_based": "Basado en Tiempo",
  "location_based": "Basado en Ubicación",
  "notification_mode": "Modo de Notificación",
  "notification_times": "Horarios de Notificación",
  "notification_times_info": "Los rangos de tiempo se gestionan desde la aplicación móvil",
  "notification_location": "Ubicación de Notificación",
  "notification_sound": "Sonido de Notificación",
  "no_sound": "Sin Sonido",
  "default_sound": "Sonido Predeterminado",
  "soft_bell": "Campana Suave",
  "digital_sound": "Sonido Digital",
  "mallet_sound": "Sonido de Martillo",
  "phone_sound": "Sonido de Teléfono",
  "text_sound": "Sonido de Texto",
  "manager_alert_delay": "Retraso de Alerta del Gerente",
  "snooze_interval": "Recordatorio",
  "vocal_notifications": "Notificaciones Vocales",
  "no_delay": "Sin Retraso",
  "no_snooze": "No recordatorio",
  "lat": "Lat",
  "lon": "Lon",
  "radius": "Radio",
  "no_location_set": "No se ha establecido ubicación",
  "when_to_notify": "Cuándo Notificar",
  "notification_preferences": "Preferencias de Notificación",
  "assignment_configuration": "Asignación y Configuración",
  "status": "Estado",
  "working_area": "área de trabajo",
  "complaints_NC": "quejas fuera del contador",
  "SLA_NC": "SLA fuera del contador",
  "arrivals_NC": "llegadas fuera del contador",
  "staff": "personal",
  "cleaning_complaints": "Quejas sobre la persona de limpieza",
  "export": "exportar",
  "maintenance_complaints": "quejas de mantenimiento",
  "maintenanceArrivals": "Reparaciones de mantenimiento",
  "maintenance_arrivals": "Llegadas de mantenimiento",
  "last": "último",
  "survey_name": "nombre de la inspección",
  "survey": "Inspección",
  "pad_survey": "Inspección para pad",
  "pad_no_maintenance_survey": "Pad sin encuesta de mantenimiento",
  "pad_kitchen": "cocina  para pad",
  "number_of_assigned_devices": "número de dispositivos asignados",
  "number_of_pages": "número de páginas",
  "date_created": "fecha de creación",
  "updated_by": "actualizado por",
  "date_updated": "fecha de actualización",
  "search": "buscar / búsqueda",
  "choose_type": "elegir tipo",
  "permitted_sites": "lugares permitidos",
  "permitted_franchise": "franquicias permitidas",
  "permitted_companies": "empresas autorizadas",
  "panel_permitted": "panel autorizado",
  "end_time": "hora de finalización",
  "last_update": "última actualización",
  "add_device": "agregar dispositivo",
  "detailed": "detallado",
  "analysis": "análisis",
  "suggestion": "sugerencia",
  "country": "país",
  "management": "gestión",
  "device": "dispositivo",
  "mapping": "mapeo",
  "please_enter": "por favor, introduzca",
  "new_device": "nuevo dispositivo",
  "assign_device": "asignar dispositivo",
  "installSpot": "lugar de instalación",
  "device_type": "tipo de dispositivo",
  "deviceCode": "código de dispositivo",
  "device_code": "código de dispositivo",
  "scan_or_enter_device_code": "Escanear o introducir código del dispositivo...",
  "scan_device": "Asignar",
  "scan_qr_in_frame": "Alinee el código QR en el marco. Para códigos pequeños, mantenga 15–25 cm de distancia y toque la vista previa para reenfocar si está borrosa.",
  "checking_device_code": "Comprobando código del dispositivo...",
  "camera_not_available": "Cámara no disponible. Puede introducir el código manualmente.",
  "device_code_already_exists": "Este código de dispositivo ya está asignado a otro sensor.",
  "assigned_to_company_site_room": "Ya asignado a {company} / {site} / {room}",
  "device_code_lookup_failed": "No se pudo verificar el código del dispositivo. Inténtelo de nuevo.",
  "device_code_no_site_access": "Este código ya está registrado en un sitio al que no tiene acceso.",
  "device_code_check_unavailable": "El servidor no pudo comprobar el código. Inténtelo de nuevo.",
  "device_code_not_a_code": "El escaneo leyó \"{code}\". Introduzca el código del dispositivo.",
  "device_code_open_failed": "No se pudo abrir este dispositivo. Inténtelo de nuevo.",
  "device_code_save_failed": "No se pudo guardar el código del dispositivo. Inténtelo de nuevo.",
  "device_code_save_forbidden": "No puede cambiar este dispositivo.",
  "confirm_replace_device_code": "¿Reemplazar código del dispositivo?",
  "confirm_replace_device_code_body": "¿Está seguro de que desea reemplazar el código {oldCode} por {newCode}?",
  "room": "sala",
  "edit_room": "editar sala",
  "edit_franchise": "editar franquicia",
  "new_franchise": "nueva franquicia",
  "desc": "descripción",
  "address": "dirección",
  "level": "nivel",
  "no_companies_to_show": "no hay empresas para mostrar",
  "company_type": "tipo de empresa",
  "region": "región",
  "new_company": "nueva empresa",
  "edit_company": "editar empresa",
  "edit_user": "editar usuario",
  "C.arrivals": "llegó persona de limpieza",
  "C.complaints": "queja de limpieza",
  "M.complaints": "llegó la persona de mantenimiento",
  "M.Arrivals": "quejas de mantenimiento",
  "analyses": "análisis",
  "clean_log": "limpiar registro",
  "maintenance_log": "registro de mantenimiento",
  "like": "me gusta",
  "likes": "Me gusta",
  "new_user": "nuevo usuario",
  "shift_parameters": "parámetro de turno",
  "add_shift": "agregar turno",
  "edit_shift": "editar turno",
  "username": "nombre de usuario",
  "first_name": "primer nombre",
  "job_function": "Función",
  "role": "Función",
  "property_manager": "Gerente de propiedad",
  "facility_manager": "Gerente de instalaciones",
  "site_manager": "Gerente de sitio",
  "workplace_manager": "Gerente del lugar de trabajo",
  "cleaning_company_ceo": "CEO de la empresa de limpieza",
  "operations_manager": "Gerente de operaciones",
  "area_manager": "Gerente de área",
  "site_cleaning_manager": "Gerente de limpieza del sitio",
  "cleaning_supervisor": "Supervisor de limpieza",
  "other": "Otro",
  "restroom_cleaner": "Limpiador de baños",
  "general_cleaner": "Limpiador general",
  "day_porter": "Auxiliar diurno",
  "office_cleaner": "Limpiador de oficinas",
  "public_area_cleaner": "Limpiador de áreas públicas",
  "firstName": "primer nombre",
  "description": "descripción",
  "last_name": "apellido",
  "lastName": "apellido",
  "phone": "teléfono",
  "building_area": "área de edificio",
  "users": "usuario",
  "add_user": "agregar usuario",
  "sites": "lugares",
  "new_site": "nuevo lugar",
  "edit_site": "editar lugar",
  "add_company": "agregar empresa",
  "franchise": "franquicia",
  "floor": "Piso",
  "building": "edificio",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Tipo de sala",
  "display_name": "nombre",
  "zone": "Zona",
  "shift_number": "turno número",
  "shift_name": "nome mudança",
  "shift_currently_inactive": "Turno actualmente inactivo",
  "local_time": "Local",
  "end": "fin",
  "min_sla": "Tiempo de respuesta mínimo",
  "max_sla": "Tiempo de respuesta máximo",
  "days": "días",
  "complaints_percent": "% quejas",
  "sla_percent": "% Tiempo de respuesta",
  "arrivals_percent": "% llegadas",
  "save_arrivals": "guardar",
  "clean_time": "Tiempo de limpieza (min)",
  "tooltip_shift_number": "Orden de visualización del turno (ej. 1, 2).",
  "tooltip_shift_name": "Nombre del turno (ej. Mañana, Noche).",
  "tooltip_start_time": "Hora de inicio del turno (hora local).",
  "tooltip_end_time": "Hora de fin del turno (hora local).",
  "tooltip_cleaners_number": "Número de limpiadores en este turno.",
  "tooltip_min_sla": "Tiempo de respuesta mínimo (min) a una queja de sala; límite inferior de la puntuación.",
  "tooltip_max_sla": "Tiempo de respuesta máximo aceptable (min) a una queja; límite superior de la puntuación.",
  "tooltip_arrivals": "Llegadas de limpieza esperadas por sala y día; la puntuación compara con este objetivo.",
  "tooltip_save_arrivals": "Visitas de limpieza por sala y día antes de BuzzzTV; para calcular tiempo ahorrado.",
  "tooltip_clean_time": "Minutos por visita de limpieza en el cálculo de tiempo ahorrado (ej. 15).",
  "tooltip_complaints_percent": "Peso de las quejas en la puntuación de la sala cuando hay visitas.",
  "tooltip_response_time_SLA": "Peso del tiempo de respuesta en la puntuación de la sala cuando hay visitas.",
  "tooltip_arrivals_percent": "Peso de llegadas vs objetivo en la puntuación de la sala cuando hay visitas.",
  "tooltip_complaints_NC": "Peso de las quejas en la puntuación cuando no hay visitas (sin contador).",
  "tooltip_SLA_NC": "Peso del tiempo de respuesta en la puntuación cuando no hay visitas.",
  "tooltip_arrivals_NC": "Peso de las llegadas en la puntuación cuando no hay visitas.",
  "tooltip_days": "Días de la semana en que el turno está activo.",
  "tooltip_active_calculation": "Si está activo, el turno se incluye en puntuaciones y en el tiempo ahorrado.",
  "auto_close_complaints_hour": "Hora de cierre automático de quejas",
  "tooltip_auto_close_complaints_hour": "Hora local en la que los SLA de quejas abiertos en este turno se cierran automáticamente. Deje vacío para desactivar.",
  "auto_close_maintenance_complaints_hour": "Hora de cierre automático de quejas de mantenimiento",
  "tooltip_auto_close_maintenance_complaints_hour": "Hora local en la que los SLA de quejas de mantenimiento abiertos en este turno se cierran automáticamente. Deje vacío para desactivar.",
  "no_auto_close": "-- Ninguno --",
  "tooltip_shift_rooms": "Salas asignadas a este turno. Deje vacío para turno a nivel de sitio.",
  "company_name": "nombre de la empresa",
  "site_name": "nombre del lugar",
  "site_desc": "descripción del lugar",
  "service_provider_name": "proveedor de servicio",
  "service_provider_type": "tipo de profedor de servicio",
  "service_provider_desc": "descripción de proveedor de servicio",
  "user": "usuario",
  "map": "mapa",
  "delete": "eliminar",
  "remove": "Eliminar",
  "new_room": "nueva sala",
  "issue_times": "Tiempos de emisión",
  "solved": "resuelto",
  "visits": "visitas",
  "visits_also_went_up": "Las visitas también aumentaron",

  "complaints": "quejas",
  "cleaner_arrivals": "llegadas de personas de limpieza",
  "unnecessary_arrivals": "Llegadas sin llamada",
  "unnecessary_arrivals_hint": "Una visita del limpiador mientras no había una llamada abierta en la sala.",
  "of_arrivals": "de las llegadas",
  "response_time_SLA": "tiempo de respuesta",
  "score": "puntaje",
  "avg_score": "puntaje promedio",
  "score_goal": "meta de puntale",
  "top_problem_issues": "principales problemas",
  "top_problem_rooms": "principales salas",
  "top_problem_hours": "principales horas",
  "is_time_save": "tiempo ahorrado",
  "est_ROI": "retorno de Inversión estimado",
  "complaints_vs_visits": "quejas Vs visitas",
  "view_by_years": "ver años",
  "view_by_months": "ver meses",
  "view_by_weeks": "ver semanas",
  "view_by_days": "ver días",
  "minutes": "minutos",
  "company": "empresa",
  "site": "lugar",
  "alerts": "Información de dispositivos",
  "performance": "desempeño",
  "devices": "dispositivos",
  "total_devices": "Total de Dispositivos",
  "working": "Funcionando",
  "warning": "Advertencia",
  "by_device_type": "Por Tipo de Dispositivo",
  "surveys": "Inspecciones",
  "real_time": "tiempo real",
  "real-time": "tiempo real",
  "cleaner-activity": "Actividad de limpiadores",
  "device-actions": "Acciones del dispositivo",
  "pad-presence-testing": "Prueba de presencia del pad",
  "real-time-cleaning": "Tiempo real - limpieza",
  "real-time-maintenance": "Tiempo real - mantenimiento",
  "no_real_time_tabs_permitted": "No tienes permiso para ver ninguna pestaña de tiempo real",
  "admin": "administrador",
  "all": "todo",
  "overview": "información general",
  "total": "Total",
  "analytics": "analítica",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Comunicación",
  "overview_complaints_devices_caption": "Dispositivos instalados (acumulado)",
  "overview_complaints_devices_caption_hint": "Total de dispositivos instalados en el sitio al final de cada mes, según las fechas de instalación.",
  "overview_complaints_devices_toggle_aria": "Mostrar u ocultar dispositivos instalados bajo el gráfico de reclamaciones",
  "communication_select_site_title": "Elige un sitio",
  "communication_select_site": "Selecciona una empresa y un sitio en los filtros de arriba para ver y añadir notas para esa ubicación.",
  "communication_viewing_site": "Viendo",
  "communication_add_note": "Añadir una nota",
  "communication_add_note_open_aria": "Abrir ventana para añadir nota",
  "communication_form_hint": "Comparte actualizaciones o notas con todos los que tienen acceso a este sitio. Verán las nuevas notas en tiempo real.",
  "communication_page_intro_title": "Notas del sitio — registro compartido de esta ubicación",
  "communication_page_intro_body": "Usa esta página para dejar turnos, incidencias, actualizaciones y notas de reunión. Quien tenga acceso a este sitio en el portal puede leer y añadir notas.",
  "communication_page_intro_dismiss": "Ocultar consejo",
  "communication_page_intro_aria": "Acerca de las notas del sitio",
  "communication_content_placeholder": "Escribe tu nota aquí...",
  "communication_keyboard_hint": "Ctrl+Enter para publicar",
  "communication_submitting": "Publicando...",
  "communication_submit": "Publicar nota",
  "communication_recent_notes": "Notas",
  "communication_search_placeholder": "Buscar por autor o texto...",
  "communication_refresh": "Actualizar",
  "communication_clear_filters": "Limpiar filtros",
  "communication_search_aria_label": "Buscar notas",
  "communication_submit_aria_label": "Publicar nota",
  "communication_copy_note_aria_label": "Copiar texto de la nota",
  "communication_copied": "Copiado al portapapeles.",
  "communication_copy_empty": "Esta nota no tiene texto para copiar.",
  "communication_filter_hidden_one": "(1 nota oculta por los filtros)",
  "communication_filter_hidden_many": "({n} notas ocultas por los filtros)",
  "communication_request_timeout": "La solicitud ha expirado. Inténtelo de nuevo.",
  "communication_load_failed": "No se pudieron cargar las notas.",
  "communication_retry": "Reintentar",
  "communication_no_matches": "Ninguna nota coincide con tu búsqueda ni con los filtros. Prueba a ajustarlos.",
  "communication_no_entries": "Aún no hay notas.",
  "communication_no_entries_hint": "Añade una nota arriba para empezar.",
  "communication_just_now": "Ahora mismo",
  "communication_minutes_ago": "hace {n} min",
  "communication_hours_ago": "hace {n} h",
  "communication_days_ago": "hace {n} días",
  "communication_note_posted": "Nota publicada.",
  "communication_post_failed": "No se pudo publicar la nota. Inténtalo de nuevo.",
  "communication_note_type": "Tipo de nota",
  "communication_type_general": "General",
  "communication_type_update": "Actualización",
  "communication_type_issue": "Incidencia",
  "communication_type_follow_up": "Seguimiento",
  "communication_type_meeting": "Nota de reunión",
  "communication_filter_all_types": "Todos los tipos",
  "communication_pinned": "Fijado",
  "communication_pin": "Fijar",
  "communication_unpin": "Desfijar",
  "communication_pin_limit": "Máx. 2 fijados",
  "communication_pinned_toast": "Nota fijada.",
  "communication_unpinned_toast": "Nota desfijada.",
  "communication_pin_failed": "No se pudo actualizar el fijado. Inténtalo de nuevo.",
  "communication_note_not_found": "Nota no encontrada o no tiene acceso.",
  "communication_site_not_in_filters": "El sitio de esta nota no está en sus filtros actuales. Es posible que no tenga acceso a esa ubicación.",
  "communication_edit": "Editar",
  "communication_delete": "Eliminar",
  "communication_save": "Guardar",
  "communication_cancel": "Cancelar",
  "communication_saving": "Guardando...",
  "communication_note_updated": "Nota actualizada.",
  "communication_update_failed": "No se pudo actualizar la nota. Inténtelo de nuevo.",
  "communication_delete_confirm": "¿Seguro que desea eliminar esta nota? Esta acción no se puede deshacer.",
  "communication_delete_confirm_title": "Eliminar nota",
  "communication_note_preview": "Vista previa de la nota:",
  "communication_note_deleted": "Nota eliminada.",
  "communication_delete_failed": "No se pudo eliminar la nota. Inténtelo de nuevo.",
  "communication_edited": "Editado",
  "communication_show_more": "Mostrar más",
  "communication_show_less": "Mostrar menos",
  "communication_sort_date_newest": "Más recientes primero",
  "communication_sort_date_oldest": "Más antiguos primero",
  "communication_sort_author": "Por autor",
  "communication_sort_type": "Por tipo",
  "communication_sort_pinned": "Fijadas primero",
  "communication_sort_label": "Ordenar",
  "communication_filter_by_type": "Tipo",
  "communication_filters_group_aria": "Filtrar y ordenar notas",
  "communication_search_label_short": "Buscar",
  "employees": "Empleados",
  "dayOfWeek": "Días",
  "service_log": "Registro serviço",
  "rooms": "Cuartos",
  "bulk_add_rooms": "Añadir cuartos en masa",
  "add_rooms": "Añadir cuartos",
  "room_names_one_per_line": "Nombres de cuartos (uno por línea)",
  "enter_at_least_one_room": "Introduzca al menos un nombre de sala",
  "room_names_placeholder": "Cuarto 1\nCuarto 2\nBaño de mujeres",
  "rooms_with_prefix": "cuartos con prefijo",
  "apply_to_all_rooms": "Aplicar a todos los cuartos (opcional)",
  "bulk_rooms_intro": "Añade uno o más grupos. Cada grupo tiene su propio edificio, planta, zona, género y nombres de cuartos.",
  "group": "Grupo",
  "add_group": "+ Añadir otro grupo",
  "adding_rooms": "Añadiendo cuartos...",
  "bulk_summary": "Resumen",
  "in": "en",
  "bulk_rooms_success": "{n} cuartos añadidos correctamente",
  "displayName": "Nombre del cuarto",
  "SLA": "SLA",
  "supervisors": "supervisores",
  "supervisor": "supervisor",
  "performance_analytics": "Analítica de desempeño",
  "arrivals": "Llegadas",
  "inspections": "Inspecciones",
  "avgResponseTime": "Tiempo de respuesta promedio",
  "missedSla": "Sla perdido",
  "cleaner_arrived": "Llegó la persona de limpieza",
  "load_more": "Cargar más",
  "login": "Iniciar sesión",
  "email": "Correo electrónico",
  "emails": "Correos electrónicos",
  "password": "Contraseña",
  "min": "min",
  "Logout": "Cerrar sesión",
  "time_range": "Rango de tiempo",
  "select_time_range": "Seleccionar rango de tiempo",
  "custom_time": "Elegir fecha / Escoger horarios",
  "last_day": "Ayer",
  "last_week": "Últimos 7 días",
  "last_month": "Últimos 30 días",
  "last_quarter": "Últimos 90 días",
  "last_6_months": "Últimos 6 meses",
  "last_year": "Últimos 365 días",
  "data_by_hour": "Datos por horas",
  "general": "General",
  "cleaning": "Limpieza",
  "maintenance": "Mantenimiento",
  "start": "Inicio",
  "start_time": "hora de inicio",
  "management_co": "empresa de gestión",
  "cleaning_co": "empresa de limpieza",
  "companies": "empresas",
  "name": "nombre",
  "site_count": "# lugar",
  "associated_companies": "clientes finales asociados",
  "OK": "OK",
  "cancel": "cancelar",
  "client": "cliente",
  "dates": "fecha",
  "shift": "turno",
  "issue": "problema",
  "time": "tiempo",
  "top complaint of the week": "principal queja de la semana",
  "top room of the week": "principal sala de la semana",
  "top hour of the week": "principal hora de la semana",
  "top complaint of the month": "principal queja del mes",
  "top room of the month": "principal sala del mes",
  "top hour of the month": "principal hora del mes",
  "franchises": "franquicias",
  "add_franchise": "agregar franquicias",
  "room_names": "nombre de la sala",
  "type": "tipo",
  "please_select_company_site": "por favor elije una empresa y lugar",
  "number": "número",
  "create_building_map": "crear un mapa del lugar",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "La forma más rápida de agregar pisos y habitaciones a un edificio es a través de este asistente rápido",
  "avg number of toilets per floor": "Promedio de baños por piso",
  "avg.number of toilet cells per room": "Promedio de inodoros por baño",
  "number of floors": "número de pisos",
  "avg.number of disabled toilets": "Promedio de baños desabilitados",
  "avg.number of soap dispensers": "Promedio de dispensadores de jabón",
  "reset_filter": "Restablecer filtro",
  "add": "agregar",
  "new_survey": "Nueva inspección",
  "api_configuration": "Configuración de API",
  "please_edit_the_api_information": "Por favor edite la información de la API",
  "method": "método",
  "authorization": "autorización",
  "api_url": "api_url",
  "token": "token",
  "api_request_info": "Información requerida de la API",
  "roomName": "Nombre del cuarto",
  "servikName": "Nombre de la queja",
  "siteName": "Nombre del sitio",
  "stage": "Etapa",
  "number_of_buttons": "Número de botonoes",
  "button_shape": "Forma del botón",
  "delay_time_stage": "Etapa de tiempo de retardo",
  "go_to_stage": "ir a la etapa",
  "color": "Color",
  "add_stage": "Agregar Etapa",
  "save": "Guardar",
  "number_of_issues": "número de problemas",
  "online": "conectado",
  "offline": "descontectado",
  "offline_devices": "Dispositivos Desconectados",
  "no_offline_devices": "No se encontraron dispositivos desconectados",
  "working_devices": "Dispositivos Funcionando",
  "no_working_devices": "No se encontraron dispositivos funcionando",
  "room_name": "nombre del cuarto",
  "installation_spot": "lugar",
  "device_id": "identificador del dispositivo",
  "date": "fecha",
  "status": "estado",
  "device_status": "estado del dispositivo",
  "none": "ninguno",
  "no_surveys_created": "No se han creado inspecciones",
  "dashboard": "Panel de control",
  "franchise_name": "Nombre de la Franquicia",
  "franchise_country": "País de la Franquicia",
  "choose_franchise": "Elige Franquicia",
  "choose_country": "Elige País",
  "select_template": "Seleccione Plantilla",
  "default_survey": "Inspección predeterminada",
  "cleaning_survey": "Inspección de limpieza",
  "kitchen_survey": "Inspección de cocina",
  "template": "Plantilla",
  "area_name": "Nombre del área",
  "rooms_names": "Nombres de los cuartos",
  "rooms_number": "Cuartos #",
  "assign_number": "Asignar #",
  "active_notification_task": "Activar notificaciones de tarea",
  "amount_limit": "Contador de intervalo",
  "after_max": "Contador después del máximo",
  "new_area": "nueva área",
  "edit_area": "editar área",
  "tablet": "tables",
  "counter women": "Contador de mujeres",
  "counter men": "Contador de hombres",
  "counter handicap": "Contador de discapacitados",
  "counter man/woman": "Contador Hombre / Mujer",
  "counter man / woman": "Contador Hombre / Mujer",
  "sensor liquid": "Sensor de líquido",
  "double toilet paper": "Papel Higiénico Doble",
  "toilet paper": "Palel Higiénico",
  "tag": "Marcador",
  "qr tag": "etiqueta QR",
  "additional_info": "información adicional",
  "servikCategory": "tipo de llamada",
  "dishwashing": "Lavaplatos",
  "cafeteria": "Caferería",
  "clean room": "Cuarto de limpieza",
  "office": "Oficina",
  "meeting room": "Sala de reuniones",
  "cubic": "Cúbico",
  "women": "Mujer",
  "men": "Hombre",
  "handicap": "Discapacidad",
  "Combined": "Combinada",
  "kitchen": "Cocina",
  "east": "Este",
  "west": "Oeste",
  "north": "Norte",
  "south": "Sur",
  "right": "Derecha",
  "left": "Izquierda",
  "center": "Centro",
  "up": "Arriba",
  "down": "Abajo",
  "combined": "Combinado",
  "lobby": "Lobby",
  "entrance": "Entrada",
  "reception": "Recepción",
  "area": "Área",
  "mezzanine": "Mezzanine",
  "gallery": "Galería",
  "ground": "Suelo",
  "elevator": "Ascensor",
  "is_calculated": "es calculado",
  "calculated_room": "Habitación calculada",
  "splitted_survey": "encuesta dividida",
  "redirect_to_url": "Redirigir a URL",
  "survey_site": "Sitio de la encuesta",
  "clicks": "clics",
  "add_stage_number_to_signal": "adjuntar el número de etapa",
  "including_pad9": "incluyendo pad9",
  "room_type_required": "Seleccione un tipo de sala para cada grupo",
  "Tech Manufacturers": "Fabricantes tecnológicos",
  "Tech Offices": "Oficinas tecnológicas",
  "Offices": "Oficinas",
  "Terminal": "Terminal",
  "Universities": "Universidades",
  "Factories": "Fábricas",
  "Hospital": "Hospital",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Tiendas de conveniencia",
  "Food Chains": "Cadenas de comida",
  "Residential": "Residencial",
  "Shopping Center": "Centro comercial",
  "Survey": "Encuesta",
  "Demo": "Demostración",
  "Vision": "Vision",
  "Court": "Juzgado",
  "Office Management": "Gestión de oficinas",
  "Government Office": "Oficina gubernamental",
  "default_name": "Nombre en ingles",
  "exposures": "Baños limpios experimentados",
  "exposures_tab": "Actividad de la Sala",
  "expose_results": "Resultados",
  "events_expose": "Eventos",
  "expose_score": "Tasa",
  "shift_events_expose": "desplazar eventos y exponer",
  "type_of_site": "tipo de sitio",
  "sector": "sector",
  "last_time_of_arrival": "última hora de llegada",
  "arrival_and_status": "llegada & estado",
  "preview_arrivals": "vista previa de llegadas",
  "men toilet": "baño de hombres",
  "women toilet": "baño de mujeres",
  "shared toilet": "baño compartido",
  "unisex restroom": "Baño unisex",
  "handicapped toilet": "baño para discapacitados",
  "logistics": "Logística",
  "cubicle": "Cubículo",
  "gym": "Gimnasio",
  "morning_shift": "turno de mañana",
  "afternoon_shift": "Turno de la tarde",
  "night_shift": "Turno nocturno",
  "update": "actualizar",
  "restart": "reiniciar",
  "send_data": "enviar datos",
  "send_count": "enviar contador",
  "blink": "parpadeo",
  "beacon": "Baliza",
  "like_btn": "botón de me gusta",
  "requires_like_btn": "requiere que el botón de me gusta esté activado",
  "maintenance_btn": "botón de mantenimiento",
  "battery": "batería",
  "version": "versión",
  "actions": "acciones",
  "device_actions": "Acciones del Dispositivo",
  "device_settings": "Configuración del Dispositivo",
  "drains_battery": "agota la batería",
  "latest_version": "última versión",
  "no_errors": "no hay errores",
  "offline_calls": "Alertas fuera de línea",
  "offline_duration_calls": "Duración de las alertas sin conexión",
  "counterCalls": "Contador de llamadas",
  "active": "activo",
  "no_active_supervisors": "Sin supervisores activos",
  "active_supervisors_column": "Supervisores activos",
  "supervisors_active_label": "supervisores activos ahora",
  "active_supervisors_coverage_hint": "Los supervisores activos tienen esta área activada en la app. No indica presencia en línea ni física.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "calculo activo",
  "pad": "pad",
  "pad_counter": "contador pad",
  "counter_status": "estado del contador",
  "choose_state": "Elige Estado",
  "city": "Ciudad",
  "state": "Estado",
  "choose_city": "Elige Ciudad",
  "start_hour": "Hora de inicio",
  "end_hour": "Hora de finalización",
  "analytics_log": "Registro de análisis",
  "or": "o",
  "no_data_available": "No hay datos disponibles",
  "filter_by_cleaner": "Filtrar por limpiador",
  "all_cleaners": "Todos los limpiadores",
  "failed_to_load_data": "Error al cargar los datos",
  "not_available": "N/A",
  "new_task": "Nueva tarea",
  "temporarily_unavailable": "Temporalmente no disponible",
  "category": "Categoría",
  "title": "Título",
  "task_type": "Tipo de tarea",
  "task_languages": "Idiomas de la tarea",
  "task_languages_hint": "Seleccione los idiomas de esta tarea. Introducirá el título en cada idioma seleccionado.",
  "task_category": "Categoría de tarea",
  "call_to_action": "Llamar a la acción",
  "schedule": "Horario",
  "insert_text": "Insertar texto",
  "select": "Seleccionar",
  "select_all": "Seleccionar todo",
  "n_selected": "{count} seleccionados",
  "clear_selection": "Borrar selección",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Fechas de programación",
  "language": "Idioma",
  "calendar": "Calendario",
  "operation": "Operación",
  "daily": "Diario",
  "weekly": "Semanal",
  "monthly": "Mensual",
  "quarterly": "Trimestral",
  "yearly": "Anual",
  "sunday": "Domingo",
  "monday": "Lunes",
  "tuesday": "Martes",
  "wednesday": "Miércoles",
  "thursday": "Jueves",
  "friday": "Viernes",
  "saturday": "Sábado",
  "january": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "Mayo",
  "june": "Junio",
  "july": "Julio",
  "august": "Agosto",
  "september": "Septiembre",
  "october": "Octubre",
  "november": "Noviembre",
  "december": "Diciembre",
  "1st week": "1ª semana",
  "2nd week": "2ª semana",
  "3rd week": "3ª semana",
  "4th week": "4ª semana",
  "5th week": "5ª semana",
  "1st quarter": "1º trimestre",
  "2nd quarter": "2º trimestre",
  "3rd quarter": "3º trimestre",
  "4th quarter": "4º trimestre",
  "edit_task": "Editar tarea",
  "created_at": "Creado en",
  "installed_at": "Instalado el",
  "hour": "Hora",
  "week_days": "Días de la semana",
  "month_weeks": "Semanas del mes",
  "month_days": "Días del mes",
  "quarter_months": "Meses del trimestre",
  "invalid_language": "Idioma inválido",
  "no_active_tasks_found": "No se encontraron tareas activas",
  "edit": "Editar",
  "send_date": "Fecha de envío",
  "invalid_date": "Fecha inválida",
  "cells_num": "# de celdas",
  "sinks_num": "# de lavabos",
  "urinals_num": "# de urinarios",
  "toilet_paper_size": "Tamaño del papel higiénico",
  "email_configuration": "Configuración de correo electrónico",
  "please_edit_the_email_information": "Por favor, edite la información del correo electrónico",
  "email_sender_info": "Información del remitente del correo electrónico",
  "email_subject_info": "Información del asunto del correo electrónico",
  "email_message_info": "Información del mensaje de correo electrónico",
  "companyName": "Nombre de la empresa",
  "email_language": "Idioma del correo electrónico",
  "complaint_language": "Idioma de la queja",
  "email_message_format": "Formato del mensaje de correo electrónico",
  "line": "Línea",
  "list": "Lista",
  "roomType": "Tipo de habitación",
  "By logging in, you agree to Buzzztech's": "Al iniciar sesión, acepta los Buzzztech",
  "Terms and Conditions": "Términos y condiciones",
  "and": "y",
  "Privacy Policy": "Política de privacidad",
  "All actions within this panel are recorded for quality control and improvement": "Todas las acciones dentro de este panel se registran para control de calidad y mejora",
  "You must agree to the terms and conditions": "Debe aceptar los términos y condiciones",
  "months": "Meses",
  "ref_id": "ID de referencia",
  "room_name_en": "Nombre de la habitación en inglés",
  "site_state": "Estatal del sitio",
  "site_city": "Ciudad del sitio",
  "site_country": "Sitio País",
  "first_date": "Primera fecha",
  "pinned": "Fijado",
  "no.": "Nº",
  "must_be_numbers": "Debe ser un número",
  "must_be_3_digits": "Debe tener 3 dígitos",
  "must_have_english_title": "Debe tener un título en inglés",
  "total_sites": "Total",
  "site_information": "Información del sitio",
  "holiday_offdays": "Días festivos y libres",
  "add_offday": "Día libre",
  "add_holiday": "Día festivo",
  "name_under_chars": "nombre de menos de 25 caracteres",
  "days_comma_separated": "días válidos, separados por una coma",
  "year": "año",
  "month": "mes",
  "day": "día",
  "holiday_name": "nombre de vacaciones",
  "offday_name": "nombre del día libre",
  "delete_confirmation_title": "¿Estás seguro?",
  "delete_confirmation_message": "Esta acción no se puede deshacer.",
  "are_you_sure": "¿Estás seguro?",
  "israel": "Israel",
  "USA": "EE.UU",
  "poland": "Polonia",
  "mexico": "México",
  "cyprus": "Chipre",
  "brazil": "Brasil",
  "romania": "Rumania",
  "netherlands": "Países Bajos",
  "tablet_survey": "Encuesta de tableta",
  "no_shift_survey": "Encuesta de turno",
  "number_of_rows": "Número de filas",
  "rating_shape": "Forma de calificación",
  "content_survey": "Encuesta de contenido",
  "rating_survey": "Encuesta de calificación",
  "device-alerts": "Problema",
  "device-active": "Activo",
  "device-search": "Buscar",
  "mac_id": "Dirección MAC",
  "qr_tag": "Etiqueta QR",
  "sensor": "Sensor",
  "image_survey": "Encuesta de imagen",
  "open_text": "Texto abierto",
  "open_text_survey": "Encuesta de texto abierto",
  "embedded_link": "Enlace incrustado",
  "device-counter": "Contadores",
  "count": "Contar",
  "last_date": "Ultima cita",
  "last_arrival":"Llegada del último limpiador",
  "cleaners": "Limpiadores",
  "viewer": "Espectador",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "No se encontraron usuarios",
  "cleaner_activity": "Actividad de limpiadores",
  "pad_presence_testing": "Prueba de presencia del pad",
  "pad_presence_testing_subtitle": "Entradas, salidas y pulsaciones offline del pad enviadas por el teléfono en el sitio seleccionado",
  "pad_presence_timeline": "Línea de tiempo en vivo",
  "pad_presence_sessions": "Sesiones de presencia",
  "pad_presence_offline_presses": "Pulsaciones offline de los teléfonos",
  "pad_presence_select_site_hint": "Seleccione una empresa y un sitio en la cabecera para ver los eventos de presencia.",
  "pad_presence_no_events": "No hay eventos de presencia en este período.",
  "pad_presence_open": "Abierto",
  "pad_presence_exit_phone": "Salida por teléfono",
  "pad_presence_exit_auto": "Salida automática",
  "pad_presence_exit_stale": "Salida atrasada",
  "pad_presence_enter": "Entrada",
  "pad_presence_exit": "Salida",
  "pad_presence_offline": "Pulsación offline",
  "pad_presence_faulty": "Erróneo",
  "pad_presence_employee": "Empleado",
  "pad_presence_room": "Sala",
  "pad_presence_time_from": "Desde",
  "pad_presence_last_updated": "Actualizado",
  "pad_presence_duration": "Duración",
  "pad_presence_exit_type": "Tipo de salida",
  "pad_presence_button": "Botón",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Recuento",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Todos los empleados",
  "pad_presence_all_rooms": "Todas las salas",
  "pad_presence_load_error": "No se pudieron cargar los datos de presencia del pad.",
  "pad_presence_in_room_now": "En una sala ahora",
  "pad_presence_in_room": "en",
  "pad_presence_since": "desde",
  "pad_presence_just_now": "Ahora mismo",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Teléfono",
  "pad_presence_all_phones": "Todos los teléfonos",
  "pad_presence_window": "Mostrar",
  "pad_presence_window_hour": "Última hora",
  "pad_presence_window_today": "Hoy",
  "pad_presence_window_month": "Último mes",
  "pad_presence_pads": "Pads en este sitio",
  "pad_presence_no_pads": "No hay pads asignados a salas en este sitio.",
  "pad_presence_last_enter": "Última entrada",
  "pad_presence_last_offline": "Última pulsación offline",
  "pad_presence_auto_exit_leave": "Salga ahora → salida automática en",
  "pad_presence_auto_exit_earliest": "Más temprano desde la entrada:",
  "pad_presence_auto_exit_passed": "Ya pasó el momento más temprano de salida automática. Sigue abierto = el pad aún se oye, o salga y espere 5m 45s.",
  "cleaner_activity_live_footer": "Los datos se actualizan en tiempo real",
  "ca_empty_select_site_hint": "Seleccione una empresa y un sitio en el encabezado para ver la actividad de limpiadores de hoy.",
  "ca_empty_no_cleaners_hint": "No hay limpiadores asignados a este sitio y al turno actual. Asigne sitios activos y turnos en Usuarios.",
  "ca_empty_access_denied": "Acceso denegado",
  "ca_empty_access_denied_hint": "No tiene permiso para ver la actividad de limpiadores en este sitio.",
  "ca_empty_load_error_hint": "No se pudo cargar la actividad. Inténtelo de nuevo o contacte con soporte si el problema continúa.",
  "ca_empty_no_filter_match": "Ningún limpiador coincide con estos filtros",
  "ca_empty_no_filter_match_hint": "Pruebe a borrar los filtros o elija otro limpiador, área de trabajo o sala.",
  "ca_timeline_all_cleaners": "Actividad de hoy — todos los limpiadores",
  "ca_legend_work": "Activo",
  "ca_clock_sessions_more": "más",
  "ca_clock_sessions_less": "Mostrar menos",
  "ca_sort_label": "Ordenar",
  "ca_sort_needs_attention": "Necesita atención",
  "ca_sort_best_avg_response": "Mejor tiempo medio de respuesta",
  "ca_sort_worst_avg_response": "Peor tiempo medio de respuesta",
  "ca_sort_most_sla_breaches": "Más incumplimientos de SLA",
  "ca_sort_most_open_complaints": "Más quejas abiertas",
  "ca_sort_most_work_time": "Más tiempo de trabajo",
  "ca_sort_least_work_time": "Menos tiempo de trabajo",
  "ca_stat_avg_short": "prom",
  "ca_stat_open_short": "abierto",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "trabajo",
  "ca_assigned_room_avg_hint": "Tiempo medio de respuesta para salas asignadas hoy",
  "ca_transit_tooltip": "Tiempo de desplazamiento entre tareas",
  "ca_transit_live_tooltip": "Tiempo desde el cierre de la última tarea",
  "ca_legend_visits": "Visitas entre llamadas",
  "ca_visits_between_sla": "Visitas desde el cierre de la llamada anterior",
  "ca_apply": "Aplicar",
  "ca_visits_since": "desde",
  "ca_deferred_tip_title": "Queja aplazada",
  "ca_deferred_tip_resolved": "Resuelta",
  "ca_deferred_tip_desc_open": "Aún abierta — el limpiador atendió otras salas primero en lugar de esta.",
  "ca_deferred_tip_desc_closed": "Esta queja quedó abierta mientras el limpiador atendió otras salas primero.",
  "ca_deferred_tip_rooms_label": "Atendidas primero:",
  "ca_attention_title": "Requiere atención",
  "ca_attention_empty": "Todo bien — sin problemas ahora",
  "ca_attention_sla_breach_one": "{name} · SLA incumplido",
  "ca_attention_sla_breach_many": "{name} · {count} incumplimientos de SLA",
  "ca_attention_open_while_out_one": "{name} · queja abierta sin fichar",
  "ca_attention_open_while_out_many": "{name} · {count} abiertas sin fichar",
  "ca_attention_idle": "{name} · inactivo {duration}",
  "ca_attention_late": "{name} · fichó tarde",
  "ca_attention_show": "Mostrar",
  "ca_attention_hide": "Ocultar",
  "ca_view_shift": "Turno",
  "ca_view_history": "Historial",
  "ca_filters_done": "Listo",
  "ca_hist_preset_this_month": "Este mes",
  "ca_hist_preset_last_month": "Mes pasado",
  "ca_hist_preset_this_week": "Esta semana",
  "ca_hist_preset_last_week": "Semana pasada",
  "ca_hist_preset_custom": "Personalizado",
  "ca_hist_from": "Desde",
  "ca_hist_to": "Hasta",
  "ca_hist_range_invalid": "La fecha de inicio debe ser anterior a la fecha de fin",
  "ca_hist_range_too_long": "El rango puede ser de como máximo {max} días",
  "ca_hist_search": "Buscar nombre o teléfono",
  "ca_hist_people_count": "{count} empleados",
  "ca_hist_kpi_days": "Días trabajados",
  "ca_hist_kpi_net": "Horas netas",
  "ca_hist_kpi_breaks": "Descansos",
  "ca_hist_col_person": "Empleado",
  "ca_hist_col_total": "Horas totales",
  "ca_hist_col_total_tip": "De la entrada a la salida antes de los descansos, la misma cifra que ve el empleado en la app",
  "ca_hist_col_net": "Horas netas",
  "ca_hist_col_breaks": "Descansos",
  "ca_hist_col_issues": "Incidencias",
  "ca_hist_col_late": "Tarde",
  "ca_hist_col_missed": "Ausente",
  "ca_hist_col_no_clock_out": "Sin salida",
  "ca_hist_clocked_in_now": "Fichado ahora",
  "ca_hist_not_assigned": "No asignado a este sitio",
  "ca_hist_no_shift": "Sin turno asignado",
  "ca_hist_unknown_name": "Desconocido",
  "ca_hist_empty": "Sin asistencia en este periodo",
  "ca_hist_empty_hint": "Nadie fichó en este sitio y no hay empleados asignados.",
  "ca_hist_no_match": "Ningún empleado coincide con los filtros",
  "ca_hist_load_error_hint": "No se pudo cargar el historial de asistencia. Inténtalo de nuevo en un momento.",
  "ca_hist_prev_person": "Empleado anterior",
  "ca_hist_next_person": "Siguiente empleado",
  "ca_hist_close": "Cerrar",
  "ca_hist_legend_worked": "Trabajó",
  "ca_hist_legend_late": "Tarde",
  "ca_hist_legend_missed": "Ausente",
  "ca_hist_legend_no_clock_out": "Sin salida",
  "ca_hist_late_by": "Tarde {duration}",
  "ca_hist_late_tip": "Fichó a las {time}, {shift} empieza a las {start}",
  "ca_hist_missed": "Ausente",
  "ca_hist_missed_tip": "El turno programado terminó sin fichaje de entrada",
  "ca_hist_no_clock_out": "Sin salida",
  "ca_hist_no_clock_out_tip": "Sesión nunca cerrada; sus horas no se cuentan",
  "ca_hist_in_progress": "Aún fichado",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "abierto",
  "ca_hist_day_col_gross": "Horas totales",
  "ca_hist_day_col_breaks": "Descansos",
  "active_cleaners": "Limpiadores activos",
  "closed_complaints": "Quejas cerradas",
  "total_work_time": "Tiempo total de trabajo",
  "total_work_time_net": "Tiempo total de trabajo (neto hoy)",
  "total_break_time": "Tiempo total de descanso",
  "avg_response_time": "Prom. resueltas",
  "cleaner": "Limpiador",
  "clocked_in": "Entrada registrada",
  "clocked_out": "Salida registrada",
  "still_clocked_in": "Aún en turno",
  "clocked_in_late": "Entrada registrada tarde",
  "total_hours": "Horas totales",
  "auto_punch": "Automático (geovalla)",
  "manual_punch": "Manual",
  "complaint_opened": "Queja abierta",
  "complaint_closed": "Queja cerrada",
  "complaint_still_open": "Aún abierta",
  "resolved_in": "Resuelta en",
  "open_for": "Abierta desde hace",
  "sla_breached": "SLA incumplido",
  "no_activity_today": "Aún sin actividad hoy",
  "just_now": "ahora mismo",
  "ago": "hace",
  "today": "Hoy",
  "live": "En vivo",
  "last_updated": "Actualizado",
  "no_cleaners_found": "No se encontraron limpiadores",
  "new_cleaner": "Nuevo limpiador",
  "edit_cleaner": "Editar limpiador",
  "have_you_finished_making_changes": "¿Has terminado de hacer cambios?",
  "assignment_issues_found": "Se encontraron problemas de asignación",
  "unassigned_rooms_title": "Habitaciones sin asignar",
  "overlapping_assignments_title": "Asignaciones superpuestas",
  "and_n_more": "y {count} más",
  "continue_anyway": "Continuar de todos modos",
  "stay_and_fix": "Quedarse y corregir",
  "assignment_coverage_issues": "{unassigned} sin asignar · {overlaps} solapamientos",
  "assignment_check_failed": "No se pudieron verificar las asignaciones de habitaciones",
  "tap_for_details": "Toca para ver detalles",
  "has_app": "App",
  "has_app_tooltip": "El limpiador tiene la app",
  "notifications_tooltip": "Notificaciones push activas",
  "assigned_to_rooms": "Asignado a habitaciones",
  "assigned_to_rooms_tooltip": "Tiene habitaciones en este sitio",
  "recently_active": "Activo recientemente",
  "works_at_site": "Trabaja en el sitio",
  "recently_active_tooltip": "Abrió la app en los últimos 30 minutos",
  "please_select": "Por favor seleccione",
  "please_select_site_first": "Por favor, seleccione un sitio primero",
  "working_areas": "Áreas de trabajo",
  "no_working_areas": "Aún no hay áreas de trabajo",
  "working_area_alerts": "Alertas",
  "api": "API",
  "please_create_room_before_working_area": "Por favor, cree al menos una sala antes de crear un área de trabajo",
  "isWorkingInSite": "Está trabajando en el sitio",
  "you_are_not_allowed_to_edit": "No tienes permiso para editar",
  "you_are_not_allowed_to_remove": "No tienes permiso para eliminar",
  "task": "Tarea",
  "portuguese": "Portugués",
  "russian": "Ruso",
  "spanish": "Español",
  "polish": "Polaco",
  "installer": "Instalador",
  "once": "Una vez",
  "time_saved": "Tiempo ahorrado",
  "yes": "Sí",
  "no": "No",
  "workingAreaNames": "Nombres de áreas de trabajo",
  "shift_rooms":"Habitaciones",
  "new_shift":"Nuevo turno",
  "add_shift_inactive": "Agregar turnos reflectantes",
  "remove_auto_shift_inactive": "Eliminar turnos reflectantes automatizados",
  "additional_options": "Opciones adicionales",
  "add_default_shifts": "Agregar turnos predeterminados",
  "no_user_found": "No se encontró usuario",
  "no_site_found": "No se encontró sitio",
  "service_provider": "Proveedor de servicios",
  "qr task": "Tarea QR",
  "qr_task": "Tarea QR",
  "all_day": "Todo el día",
  "auto_start": "Inicio automático",
  "english_title": "Título en inglés",
  "connectivity": "Conectividad",
  "power": "Energía",
  "Your work has been saved": "Tu trabajo ha sido guardado",
  "schedule_call_time": "Hora de llamada",
  "schedule_call_gap": "Intervalo de llamada",
  "gapInMinutes": "Intervalo en minutos",
  "no_manual_calls_available": "No hay llamadas manuales disponibles",
  "manual_calls": "Llamadas manuales",
  "cleandex_calls": "Llamadas de Cleandex",
  "cleandexCalls": "Llamadas de Cleandex",
  "manualCalls": "Llamadas manuales",
  "inactive": "Inactivo",
  "on hold": "En espera",
  "sequential": "Secuencial",
  "ratio": "Proporción",
  "must_choose": "Debes elegir",
  "surveyApp": "Aplicación de encuestas",
  "installation": "Instalación",
  "manager": "Gerente",
  "previous": "Anterior",
  "next": "Siguiente",
  "no_rooms_found": "No se encontraron habitaciones",
  "show_calendar": "Mostrar calendario",
  "seeAll": "Ver todo",
  "showPaginated": "Mostrar paginado",
  "cleaners_arrivals": "Llegadas de limpiadores",
  "add_address": "Agregar dirección",
  "site_auto_attendance_enabled":
    "Permitir la entrada y salida automática mediante la geocerca en la app móvil (los usuarios necesitan permiso de ubicación).",
  "site_auto_attendance_requires_location":
    "Primero defina la ubicación en el mapa (pin y radio de al menos 100 m) antes de activar el registro automático.",
  "site_mandatory_clock_in": "Exigir fichaje antes de trabajar",
  "site_mandatory_clock_in_description":
    "Los empleados de este sitio deben fichar la entrada antes de poder abrir las pestañas de limpieza, mantenimiento y misiones en la aplicación móvil.",
  "site_mandatory_clock_in_without_location":
    "Este sitio no tiene ubicación en el mapa, por lo que la aplicación no puede saber cuándo un empleado está en el sitio. Hasta que la defina, el requisito se aplica a estos empleados en cualquier lugar.",
  "edit_address": "Editar dirección",
  "choose_radius": "Elegir radio",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Verde = OK. Rojo = Recomendado limpiar. Pase el cursor sobre el icono para más detalles.",
  "recommended_to_clean": "Recomendado limpiar",
  "cleandex_warning_level": "Nivel de advertencia Cleandex",
  "select_warning_level": "Seleccione el nivel de advertencia",
  "bronze": "Bronce",
  "silver": "Plata",
  "gold": "Oro",
  "ai": "IA",
  "daily_employees_num": "Número diario de empleados",
  "daily_shift_hours": "Horas de turno diario",
  "rooms_num": "Número de habitaciones",
  "buildings_num": "Número de edificios",
  "cleaner_entries": "Limpieza de limpiadores",
  "avg_daily_visits_monthly": "usuarios diarias promedio mensuales",
  "avg_daily_cleaners_to_save": "Promedio diario de limpiadores a ahorrar",
  "saving_hours_per_day": "Horas ahorradas por día",
  "saving_money_per_day": "Dinero ahorrado por día",
  "saving_money_per_month": "Dinero ahorrado por mes",
  "cleaners_to_visitors_ratio": "Proporción de limpiadores por visitantes",
  "cleaning_time_in_minutes_per_room": "Tiempo de limpieza en minutos por habitación",
  "max_number_of_rooms_per_employee": "Número máximo de habitaciones por empleado",
  "break_time_per_hour": "Tiempo de descanso por hora",
  "transition_time_between_tasks": "Tiempo de transición entre tareas",
  "employer_cost_hour": "Costo del empleador por hora",
  "lobby_cleaning_per_floor": "Limpieza del lobby por piso",
  "desired_cleaning_time": "Tiempo de limpieza deseado",
  "desired_number_of_entries": "Número deseado de entradas",
  "buzz_system_cost_per_unit_per_month": "Costo del sistema Buzz por unidad al mes",
  "total_buzz_system_cost_per_month": "Costo total del sistema Buzz al mes",
  "return_on_investment_in_months": "Retorno de inversión en meses",
  "annual_savings": "Ahorro anual",
  "roi_calculator": "Calculadora de ROI",
  "cleaners_number": "Número de limpiadores",
  "floors_num": "Número de pisos",
  "avg_daily_cleaners_required": "Promedio diario de limpiadores requeridos",
  "app_pages": "Páginas de la aplicación",
  "buzzzTime": "Tiempo de Buzzz",
  "missions": "Misiones",
  "send_emails": "Enviar correos",
  "enter": "Entrar",
  "account": "Cuenta",
  "privacy": "Privacidad",
  "personal_settings": "Ajustes personales",
  "personal_settings_lead": "Idioma y preferencias de privacidad.",
  "personal_settings_read_only": "Los datos los gestiona su administrador. Contacte con él para cambios.",
  "change_password": "Cambiar contraseña",
  "change_password_hint": "Cambiar la contraseña cerrará la sesión en sus otros dispositivos.",
  "current_password": "Contraseña actual",
  "new_password": "Nueva contraseña",
  "confirm_new_password": "Confirmar nueva contraseña",
  "password_min_length": "La contraseña debe tener al menos 8 caracteres",
  "passwords_do_not_match": "Las contraseñas no coinciden",
  "new_password_same_as_current": "La nueva contraseña debe ser diferente de la actual",
  "current_password_incorrect": "La contraseña actual es incorrecta",
  "current_password_required": "La contraseña actual es obligatoria",
  "password_changed_successfully": "Contraseña cambiada correctamente",
  "change_password_failed": "No se pudo cambiar la contraseña",
  "forgot_password": "¿Olvidó su contraseña?",
  "forgot_password_title": "¿Olvidó su contraseña",
  "forgot_password_hint": "Introduzca el correo de su cuenta del panel y le enviaremos un enlace de restablecimiento si existe.",
  "forgot_password_sent": "Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento. Revise su bandeja de entrada.",
  "forgot_password_invalid_email": "Introduzca una dirección de correo válida",
  "forgot_password_failed": "No se pudo enviar el correo de restablecimiento. Inténtelo de nuevo.",
  "send_reset_link": "Enviar enlace",
  "back_to_login": "Volver al inicio de sesión",
  "reset_password": "Restablecer contraseña",
  "reset_password_hint": "Elija una nueva contraseña para su cuenta.",
  "reset_password_missing_token": "Este enlace de restablecimiento está incompleto. Solicite uno nuevo desde el inicio de sesión.",
  "reset_password_invalid_token": "Este enlace no es válido o ha caducado. Solicite uno nuevo.",
  "reset_password_failed": "No se pudo restablecer la contraseña",
  "password_reset_successfully": "Contraseña restablecida correctamente. Ya puede iniciar sesión con la nueva contraseña.",
  "login_invalid_credentials": "Usuario o contraseña incorrectos",
  "login_credentials_required": "Introduzca su usuario o correo y contraseña",
  "login_network_error": "No se puede conectar con el servidor. Compruebe la conexión e inténtelo de nuevo",
  "login_failed": "No se pudo iniciar sesión. Inténtelo de nuevo",
  "login_too_many_attempts": "Demasiados intentos de inicio de sesión. Espere 15 minutos e inténtelo de nuevo.",
  "forgot_password_too_many": "Demasiadas solicitudes de restablecimiento de contraseña. Espere una hora e inténtelo de nuevo.",
  "reset_password_too_many": "Demasiados intentos de restablecimiento de contraseña. Espere una hora e inténtelo de nuevo.",
  "change_password_too_many": "Demasiados intentos de cambio de contraseña. Espere 15 minutos e inténtelo de nuevo.",

  "personal_settings_language_hint": "Se aplica a todo el portal en este navegador.",
  "personal_settings_privacy_hint": "Solicitar borrado de sus datos según las leyes de privacidad.",
  "personal_settings_role": "Rol",
  "Request deletion of my data": "Solicitar eliminación de mis datos",
  "Request deletion of my data - confirm": "¿Solicitar eliminación de mis datos? Se enviará un correo al administrador. Procesaremos su solicitud en 30 días.",
  "Request deletion of my data - success": "Solicitud enviada. La procesaremos en 30 días.",
  "Request deletion of my data - error": "Error al enviar. Inténtelo de nuevo o escriba a privacy@buzzztech.com.",
  "metrics": "Métricas",
  "select_three_metrics": "Selecciona hasta 3 métricas para comparar",
  "select_four_metrics": "Selecciona hasta 4 métricas para comparar",
  "legend": "Leyenda",
  "more_details": "Más Detalles",
  "performance_overview": "Resumen de rendimiento",
  "loading_chart": "Cargando gráfico",
  "retry": "Reintentar",
  "performance_trending_upward": "El rendimiento está en aumento",
  "high_complaint_ratio": "Alta tasa de quejas",
  "click_bars_for_details": "Haz clic en las barras para ver los análisis diarios",
  "refresh": "Actualizar",
  "table": "Tabla",
  "cards": "Tarjetas",
  "no_recent_arrivals": "No hay llegadas recientes",
  "feedback_charts": "Gráficos de retroalimentación",
  "general_overview": "Visión general",
  "cleaning_complaints_breakdown": "Desglose de quejas de limpieza",
  "maintenance_complaints_breakdown": "Desglose de quejas de mantenimiento",
  "refresh_failed": "Actualización fallida",
  "data_exported_successfully": "Datos exportados con éxito",
  "data_export_failed": "Error al exportar datos",
  "drill_down_unavailable": "El desglose solo está disponible en la vista diaria",
  "sort_by": "Ordenar por",
  "no_active_shift": "No hay turno activo",
  "check_site_and_shift": "Por favor, compruebe si se ha seleccionado un sitio y tiene un turno activo",
  "please_add_shift_first": "Por favor, agregue un turno primero",
  "cleandex_no_data_message": "Actualmente no hay datos de Cleandex disponibles",
  "task_no_data_message": "Actualmente no hay datos de tareas disponibles",
  "navigation": "Navegación",
  "network_information": "Información de red",
  "target_effectiveness": "Efectividad del objetivo",
  "cleandex_call_cleaner": "Llamada de Cleandex al limpiador",
  "top_complaint": "Queja principal",
  "no_complaints": "No hay quejas",
  "official_start_date": "Fecha de inicio oficial",
  "note_text": "Texto de la nota",
  "add_note": "Agregar nota",
  "general_note": "Nota general",
  "general_note_short": "General",
  "battery_short": "Batería",
  "panel_short": "Panel",
  "technician_short": "Técnico",
  "battery_replacement": "Reemplazo de batería",
  "device_maintenance": "Mantenimiento del dispositivo",
  "maintenance_type": "Tipo de mantenimiento",
  "panel_change": "Cambio de panel",
  "technician_check": "Revisión del técnico",
  "enter_note_details": "Ingrese los detalles de la nota",
  "replacement_date": "Fecha de reemplazo",
  "replaced_by_name": "Reemplazado por",
  "replacement_note": "Nota del reemplazo",
  "enter_replacement_details": "Ingrese los detalles del reemplazo",
  "replacement_history": "Historial de reemplazos",
  "loading_history": "Cargando historial",
  "no_replacement_history": "No hay historial de reemplazos disponible",
  "enter_technician_name": "Ingrese el nombre del técnico",
  "user_information": "Información del usuario",
  "enter_change_details": "Ingrese los detalles del cambio",
  "panel_change_history": "Historial de cambios de panel",
  "check_date": "Fecha de revisión",
  "checked_by_name": "Revisado por",
  "enter_check_details": "Ingrese los detalles de la revisión",
  "technician_check_history": "Historial de revisiones del técnico",
  "no_technician_check_history": "No hay historial de revisiones del técnico disponible",
  "change_date": "Fecha del cambio",
  "changed_by_name": "Cambiado por",
  "change_note": "Nota del cambio",
  "check_note": "Nota de la revisión",
  "replaced_by": "Reemplazado por",
  "no_data_entered": "No se han ingresado datos",
  "no_panel_change_history": "No hay historial de cambios de panel disponible",
  "invalid_username": "Nombre de usuario no válido",
  "invalid_phone": "Número de teléfono no válido",
  "username_must_be_at_least_5_characters": "El nombre de usuario debe tener al menos 5 caracteres",
  "open_slas": "SLAs Abiertos",
  "open_sla_alerts": "Alertas de Quejas Abiertas",
  "open_duration": "Duración Abierta",
  "open_complaints": "Quejas Abiertas",
  "site_alerts": "Alertas de Sitios",
  "rooms_with_open_complaints_percentage": "Habitaciones con Quejas Abiertas",
  "rooms_with_cleaner_arrival_percentage": "Habitaciones con Llegada de Limpieza",
  "rooms_without_cleaner_arrival_percentage": "Habitaciones sin Llegada de Limpieza",
  "site_alerts_total_rooms": "Total de habitaciones",
  "site_alerts_open_complaints_count": "Número de quejas abiertas",
  "site_alerts_customer_opening_date": "Fecha de apertura del cliente",
  "company_country": "País de la empresa",
  "select_message": "Seleccionar Mensaje",
  "message_no_cleaner_arrival": "Hola a todos,\nTengan en cuenta que hay habitaciones donde no se ha reportado la llegada del personal de limpieza hoy.\nPor favor, atiendan esto",
  "message_open_complaints": "Hola a todos,\nTengan en cuenta que hay varias habitaciones con quejas abiertas durante mucho tiempo.\nPor favor, atiendan esto",
  "rooms_list": "Habitaciones:",
  "no_open_slas": "No se encontraron SLAs abiertos",
  "no_open_slas_description": "Actualmente no hay sitios con SLAs abiertos.",
  "no_slas_to_send": "No se encontraron SLAs abiertos para este sitio",
  "total_open_complaints": "Total de Quejas Abiertas",
  "longest_duration": "Duración Más Larga",
  "complaints_details": "Detalles de Quejas",
  "no_results_found": "No se encontraron resultados",
  "whatsapp": "WhatsApp",
  "loading": "Cargando",
  "error_opening_whatsapp": "Error al abrir WhatsApp. Por favor, intente de nuevo.",
  "error_loading_slas": "Error al cargar los detalles del SLA. Por favor, intente de nuevo.",
  "send_whatsapp": "Enviar WhatsApp",
  "more_options": "Más opciones",
  "preview_message": "Vista Previa del Mensaje",
  "copy_message": "Copiar Mensaje",
  "message_preview": "Vista Previa del Mensaje",
  "phone_number_optional": "Número de Teléfono (Opcional)",
  "enter_phone_number": "Ingrese el número de teléfono (ej: +34612345678)",
  "phone_number_hint": "Deje vacío para abrir WhatsApp sin un contacto específico",
  "message_copied": "¡Mensaje copiado al portapapeles!",
  "error_copying_message": "Error al copiar mensaje. Por favor, intente de nuevo.",
  "opening_whatsapp": "Abriendo WhatsApp...",
  "data_loading_please_wait": "Los datos se están cargando. Por favor, espere...",
  "dates_not_changed": "Las fechas no han cambiado. No es necesario recargar.",
  "date_outside_stats_range": "Las fechas seleccionadas están fuera del rango de estadísticas disponible.",

  "date_range_invalid": "La fecha \"Hasta\" debe ser igual o posterior a la fecha \"Desde\".",
  "filter_help_text": "Reglas de Filtro: Seleccione el Edificio primero para habilitar el filtro de Piso. La mayoría de los filtros admiten selecciones múltiples.",
  "select_building_first": "Por favor, seleccione un Edificio primero para habilitar el filtro de Piso",
  "cannot_select_gender_with_rooms": "No se puede seleccionar el tipo de sala cuando hay salas seleccionadas",
  "cannot_select_gender_with_rooms_tooltip": "El filtro de tipo de sala no se puede usar cuando hay salas seleccionadas. Borre primero la selección de salas.",
  "cannot_select_building_with_rooms": "No se puede seleccionar edificio cuando hay habitaciones seleccionadas",
  "cannot_select_building_with_rooms_tooltip": "El filtro de edificio no se puede usar cuando hay habitaciones seleccionadas. Por favor, limpie la selección de habitaciones primero.",
  "multi_select_hint": "Puede seleccionar múltiples opciones",
  "filter_applied": "Filtro aplicado exitosamente",
  "no_filters_selected": "No se seleccionaron filtros. Seleccione al menos una opción de filtro.",
  "filters": "Filtros",
  "location": "Ubicación",
  "attributes": "Atributos",
  "applying": "Aplicando...",
  "active_filters": "Filtros Activos",
  "viewing_room": "Viendo habitación",
  "multiple": "Múltiple",
  "close": "Cerrar",
  "save_replacement": "Guardar reemplazo",
  "save_change": "Guardar cambio",
  "save_check": "Guardar verificación",
  "failed_to_load_maintenance_history": "Error al cargar el historial de mantenimiento",
  "Battery replacement recorded successfully": "Reemplazo de batería registrado exitosamente",
  "Panel change recorded successfully": "Cambio de panel registrado exitosamente",
  "Technician check recorded successfully": "Verificación del técnico registrada exitosamente",
  "no_network_data_available": "No hay datos de red disponibles",
  "basic_information": "Información Básica",
  "service_providers": "Proveedores de Servicios",
  "settings_alerts": "Configuración y Alertas",
  "configuration": "Configuración",
  "contact_settings": "Contacto y Configuración",
  "notifications": "Notificaciones",
  "alert_language": "Idioma de Alerta",
  "select_language": "Seleccionar idioma",
  "features": "Características",
  "chat_ask_stats": "Consultar estadísticas",
  "chat_ask_buzzz": "Preguntar a Buzzz",
  "chat_stats_assistant": "Asistente de estadísticas",
  "chat_buzzz_assistant": "Asistente Buzzz",
  "chat_clear": "Limpiar",
  "chat_placeholder": "Pregunta sobre tus estadísticas de limpieza, ej. \"¿Cuántas quejas la semana pasada?\" o \"¿Qué salas necesitan más atención?\"",
  "chat_placeholder_context": "Pregunta sobre {scope}, ej. \"¿Cuántas quejas?\" o \"¿Qué salas necesitan atención?\"",
  "chat_thinking": "Pensando…",
  "chat_input_placeholder": "Pregunta sobre visitas, quejas, salas…",
  "chat_send": "Enviar",
  "chat_chip_summary": "Resumen",
  "chat_chip_worst_rooms": "Peores salas",
  "chat_chip_counter_calls": "Llamadas de contador",
  "chat_chip_sla_issues": "Problemas de SLA",
  "chat_chip_busiest_hours": "Horas más ocupadas",
  "chat_chip_help": "¿Qué puedo preguntar?",
  "chat_chip_focus": "¿En qué debo enfocarme?",
  "chat_chip_improving": "¿Qué salas están mejorando?",
  "chat_chip_best_rooms": "Mejores salas por puntuación",
  "chat_chip_worst_days": "Peores días",
  "chat_chip_complaint_types": "Tipos de quejas",
  "chat_chip_positive_feedback": "Comentarios positivos",
  "chat_suggestions": "Sugerencias",
  "chat_error": "Algo salió mal. Inténtalo de nuevo.",
  "chat_copy": "Copiar",
  "chat_copied": "¡Copiado!",
  "chat_retry": "Reintentar",
  "chat_chip_compare_periods": "Comparar con el período anterior",
  "chat_chip_briefing": "Informe matutino",
  "chat_chip_cleaning_priority": "Prioridad de limpieza",
  "chat_chip_live_status": "Estado en vivo",
  "chat_chip_shift_stats": "Rendimiento por turno",
  "chat_chip_staff_status": "¿Quién está trabajando ahora?",
  "chat_chip_why_drilldown": "¿Por qué? Detallar",
  "chat_pin": "Añadir a favoritos",
  "chat_unpin": "Quitar de favoritos",
  "chat_share": "Enviar por correo",
  "chat_export": "Exportar",
  "chat_helpful": "Útil",
  "chat_not_helpful": "No útil",
  "chat_hide": "Ocultar asistente",
  "chat_stop": "Detener",
}

export const ar = {
  ...serviks.ar,
  monthMap: {
    1: "يناير",
    2: "فبراير",
    3: "مارس",
    4: "ابريل",
    5: "مايو",
    6: "يونيو",
    7: "يوليو",
    8: "اغسطس",
    9: "سبتمبر",
    10: "اوكتوبر",
    11: "نوفمبر",
    12: "ديسمبر",
  },
  weekMap: {
    1: 'الاحد',
    2: 'الاثنين',
    3: 'الثلاثاء',
    4: 'الاربعاء',
    5: 'الخميس',
    6: 'الجمعة',
    7: 'السبت',
  },
  "notified": "تنبيه",
  "supervisor_arrival": "وصول المشرف",
  "arrival": "وصول",
  "arrival_badges": "وصول في المناوبة",
  "callsHistory": "سجل المكالمات",
  "openCalls": "مكالمات مفتوحة",
  "visits_since_cleaned": "الزيارات منذ آخر تنظيف",
  "visits_since_cleaned_short": "الزيارات منذ التنظيف",
  "filter": "ترشيح",
  "logo": "لوغو",
  "counter": "عدّاد",
  "sms": "رسالة نصية",
  "shifts": "ورديات",
  "call": "طلب",
  "duration": "وقت منذ الافتتاح",
  "time_start": "وقت البداية",
  "settings": "تعريفات",
  "always": "دائماً",
  "off": "إيقاف",
  "time_based": "على أساس الوقت",
  "location_based": "على أساس الموقع",
  "notification_mode": "وضع الإشعارات",
  "notification_times": "أوقات الإشعارات",
  "notification_times_info": "يتم إدارة النطاقات الزمنية من التطبيق المحمول",
  "notification_location": "موقع الإشعار",
  "notification_sound": "صوت الإشعار",
  "no_sound": "بدون صوت",
  "default_sound": "الصوت الافتراضي",
  "soft_bell": "جرس ناعم",
  "digital_sound": "صوت رقمي",
  "mallet_sound": "صوت المطرقة",
  "phone_sound": "صوت الهاتف",
  "text_sound": "صوت النص",
  "manager_alert_delay": "تأخير تنبيه المدير",
  "snooze_interval": "تذكير",
  "vocal_notifications": "إشعارات صوتية",
  "no_delay": "بدون تأخير",
  "no_snooze": "بدون تذكير",
  "lat": "خط العرض",
  "lon": "خط الطول",
  "radius": "نصف القطر",
  "no_location_set": "لم يتم تعيين موقع",
  "when_to_notify": "متى يتم الإشعار",
  "notification_preferences": "تفضيلات الإشعارات",
  "assignment_configuration": "التعيين والإعدادات",
  "status": "الحالة",
  "working_area": "منطقة عمل",
  "complaints_NC": "شكاوى بدون عداد",
  "SLA_NC": "SLA بدون عداد",
  "arrivals_NC": "مرات وصول بدون عدّاد",
  "staff": "طاقم",
  "cleaning_complaints": "شكاوى نظافة",
  "export": "إخراج",
  "maintenance_complaints": "شكوى صيانه",
  "maintenanceArrivals": "تصليحات صيانه",
  "maintenance_arrivals": "مرات الوصول للصيانة",
  "last": "الاخير",
  "survey_name": "تقرير",
  "survey": "اسم التقرير",
  "pad_survey": "تقرير للباد",
  "pad_no_maintenance_survey": "تقرير للباد بدون صيانة",
  "pad_kitchen": "تقرير مطبخ للباد",
  "number_of_assigned_devices": "عدد الاجهزة",
  "number_of_pages": "عدد الصفحات",
  "date_created": "تاريخ الإنشاء",
  "updated_by": "تم التحديث بواسطة",
  "date_updated": "تاريخ التحديث",
  "search": "بحث",
  "choose_type": "اختر نوع",
  "permitted_sites": "اذونات للمواقع",
  "permitted_franchise": "إذن لاصحاب الامتياز",
  "permitted_companies": "إذن للشركات",
  "panel_permitted": "إذن للوحة",
  "end_time": "وقت الانهاء",
  "last_update": "التحديث الاخير",
  "add_device": "اضف جهازا",
  "detailed": "تفصيل",
  "analysis": "تحليل",
  "suggestion": "اقتراحات",
  "country": "دولة",
  "management": "ادارة",
  "device": "اجهزة",
  "mapping": "مسح",
  "please_enter": "ادخل/ي رجاءا",
  "new_device": "جهازا جديدا",
  "assign_device": "اوصل جهازا",
  "installSpot": "مكان التركيب",
  "device_type": "نوع الجهاز",
  "deviceCode": "كود الجهاز",
  "device_code": "كود الجهاز",
  "scan_or_enter_device_code": "امسح أو أدخل رمز الجهاز...",
  "scan_device": "تعيين",
  "scan_qr_in_frame": "ضع رمز QR داخل الإطار. للرموز الصغيرة، أبقِ الهاتف على مسافة 15–25 سم واضغط على المعاينة لإعادة التركيز إذا كانت الصورة ضبابية.",
  "checking_device_code": "جاري التحقق من رمز الجهاز...",
  "camera_not_available": "الكاميرا غير متاحة. يمكنك إدخال الرمز يدوياً.",
  "device_code_already_exists": "رمز الجهاز هذا مُعيَّن بالفعل لمستشعر آخر.",
  "assigned_to_company_site_room": "مُعيَّن بالفعل إلى {company} / {site} / {room}",
  "device_code_lookup_failed": "تعذر التحقق من رمز الجهاز. حاول مرة أخرى.",
  "device_code_no_site_access": "هذا الرمز مسجّل مسبقاً في موقع لا يمكنك الوصول إليه.",
  "device_code_check_unavailable": "تعذر على الخادم التحقق من الرمز. حاول مرة أخرى.",
  "device_code_not_a_code": "قرأ المسح \"{code}\". أدخل رمز الجهاز نفسه.",
  "device_code_open_failed": "تعذر فتح هذا الجهاز. حاول مرة أخرى.",
  "device_code_save_failed": "تعذر حفظ رمز الجهاز. حاول مرة أخرى.",
  "device_code_save_forbidden": "لا يمكنك تغيير هذا الجهاز.",
  "confirm_replace_device_code": "استبدال رمز الجهاز؟",
  "confirm_replace_device_code_body": "هل أنت متأكد أنك تريد استبدال رمز {oldCode} بـ {newCode}؟",
  "room": "غرفة",
  "edit_room": "عدّل الغرفة",
  "edit_franchise": "عدّل صاحب الامتياز",
  "new_franchise": "اضف صاحب امتياز",
  "desc": "وصف",
  "address": "بريد الكتروني",
  "level": "مستوى",
  "no_companies_to_show": "لا شركات العرض",
  "company_type": "نوع الشركة",
  "region": "منطقة",
  "new_company": "شركة جديدة",
  "edit_company": "تعديل شركة",
  "edit_user": "تعديل مستخدم",
  "C.arrivals": "زيارات عمال النظافة",
  "C.complaints": "شكاوى نظافة",
  "M.complaints": "شكاوى الصيانة",
  "M.Arrivals": "زيارات الصيانة",
  "analyses": "تحليل بدون غرف",
  "clean_log": "مفكرة النظافة",
  "maintenance_log": "مفكرة الصيانة",
  "like": "لايك",
  "likes": "إعجابات",
  "new_user": "مستخدم جديد",
  "shift_parameters": "مواصفات الوردية",
  "add_shift": "اضف وردية",
  "edit_shift": "تعديل وردية",
  "username": "اسم المستخدم",
  "first_name": "الاسم السخصي",
  "job_function": "الدور الوظيفي",
  "role": "الدور",
  "property_manager": "مدير العقار",
  "facility_manager": "مدير المرافق",
  "site_manager": "مدير الموقع",
  "workplace_manager": "مدير بيئة العمل",
  "cleaning_company_ceo": "المدير التنفيذي لشركة التنظيف",
  "operations_manager": "مدير العمليات",
  "area_manager": "مدير المنطقة",
  "site_cleaning_manager": "مدير نظافة الموقع",
  "cleaning_supervisor": "مشرف النظافة",
  "other": "أخرى",
  "restroom_cleaner": "عامل نظافة دورات المياه",
  "general_cleaner": "عامل نظافة عام",
  "day_porter": "عامل نظافة نهاري",
  "office_cleaner": "عامل نظافة المكاتب",
  "public_area_cleaner": "عامل نظافة الأماكن العامة",
  "firstName": "الاسم السخصي",
  "description": "وصف",
  "last_name": "اسم العائلة",
  "lastName": "اسم العائلة",
  "phone": "الهاتف",
  "building_area": "منطقة البناء",
  "users": "المستخدمين",
  "add_user": "اضافة مستخدم",
  "sites": "مواقع",
  "new_site": "موقع جديد",
  "edit_site": "تعديل موقع",
  "add_company": "اضف شركة",
  "franchise": "الامتياز",
  "floor": "الطابق",
  "building": "البناية",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "نوع الغرفة",
  "display_name": "الاسم",
  "zone": "المنطقة",
  "shift_number": "رقم الوردية",
  "shift": "الوردية",
  "shift_name": "اسم الوردية",
  "shift_currently_inactive": "الوردية غير نشطة حالياً",
  "local_time": "محلي",
  "end": "النهاية",
  "min_sla": "وقت الاستجابة الادنى",
  "max_sla": "وقت الاستجابة الاقصى",
  "days": "ايام",
  "complaints_percent": "شكاوى %",
  "sla_percent": "وقت الاستجابة %",
  "arrivals_percent": "% وصول عاملة النظافة",
  "save_arrivals": "توفير",
  "clean_time": "وقت التنظيف (د)",
  "tooltip_shift_number": "ترتيب عرض الوردية (مثلاً 1، 2).",
  "tooltip_shift_name": "اسم الوردية (مثلاً صباح، ليل).",
  "tooltip_start_time": "وقت بداية الوردية (الوقت المحلي).",
  "tooltip_end_time": "وقت نهاية الوردية (الوقت المحلي).",
  "tooltip_cleaners_number": "عدد المنظّفين في هذه الوردية.",
  "tooltip_min_sla": "أقل وقت استجابة (دقائق) لشكوى الغرفة؛ الحد الأدنى للنقاط.",
  "tooltip_max_sla": "أقصى وقت استجابة مقبول (دقائق) لشكوى؛ الحد الأقصى للنقاط.",
  "tooltip_arrivals": "الوصولات المتوقعة للمنظّف للغرفة يومياً؛ النقاط تقارن الفعلي بالهدف.",
  "tooltip_save_arrivals": "زيارات المنظّف للغرفة يومياً قبل BuzzzTV؛ لحساب الوقت الموفر.",
  "tooltip_clean_time": "دقائق لكل زيارة تنظيف في حساب الوقت الموفر (مثلاً 15).",
  "tooltip_complaints_percent": "وزن الشكاوى في نقاط الغرفة عند وجود زيارات.",
  "tooltip_response_time_SLA": "وزن وقت الاستجابة في نقاط الغرفة عند وجود زيارات.",
  "tooltip_arrivals_percent": "وزن الوصولات مقابل الهدف في نقاط الغرفة عند وجود زيارات.",
  "tooltip_complaints_NC": "وزن الشكاوى في النقاط عند عدم وجود زيارات (بدون عداد).",
  "tooltip_SLA_NC": "وزن وقت الاستجابة في النقاط عند عدم وجود زيارات.",
  "tooltip_arrivals_NC": "وزن الوصولات في النقاط عند عدم وجود زيارات.",
  "tooltip_days": "أيام الأسبوع التي تكون فيها الوردية نشطة.",
  "tooltip_active_calculation": "عند التفعيل، تُحسب الوردية في النقاط والوقت الموفر.",
  "auto_close_complaints_hour": "ساعة إغلاق الشكاوى تلقائياً",
  "tooltip_auto_close_complaints_hour": "الساعة المحلية التي يتم فيها إغلاق شكاوى SLA المفتوحة في هذه الوردية تلقائياً. اترك فارغاً للتعطيل.",
  "auto_close_maintenance_complaints_hour": "ساعة إغلاق شكاوى الصيانة تلقائياً",
  "tooltip_auto_close_maintenance_complaints_hour": "الساعة المحلية التي يتم فيها إغلاق شكاوى SLA الصيانة المفتوحة في هذه الوردية تلقائياً. اترك فارغاً للتعطيل.",
  "no_auto_close": "-- بدون --",
  "tooltip_shift_rooms": "الغرف المخصصة لهذه الوردية. اترك فارغاً لوردية على مستوى الموقع.",
  "company_name": "اسم الشركة",
  "site_name": "اسم الموقع",
  "site_desc": "وصف الموقع",
  "service_provider_name": "مورد الخدمة",
  "service_provider_type": "نوع مورد الخدمة",
  "service_provider_desc": "وصف مورد الخدمة",
  "user": "مستخدم",
  "map": "خارطة",
  "delete": "حذف",
  "remove": "إزالة",
  "new_room": "غرفة جديدة",
  "issue_times": "شكاوى واغلاقات",
  "solved": "تم الحل",
  "visits": "الزيارات",
  "visits_also_went_up": "ارتفعت الزيارات أيضاً",

  "complaints": "الشكاوى",
  "cleaner_arrivals": "مرات وصول عاملة النظافة",
  "unnecessary_arrivals": "مرات وصول بدون نداء",
  "unnecessary_arrivals_hint": "زيارة عامل النظافة بينما لم يكن هناك بلاغ مفتوح في الغرفة.",
  "of_arrivals": "من مرات الوصول",
  "response_time_SLA": "(SLA_ وقت الاستجابة",
  "score": "العلامة",
  "avg_score": "متوسط العلامات",
  "score_goal": "العلامة المطلوبة",
  "top_problem_issues": "الشكاوى الاساسية",
  "top_problem_rooms": "الغرف الاساسية",
  "top_problem_hours": "الساعات الاساسية",
  "is_time_save": "الوقت الذي تم توفيره",
  "est_ROI": "(ROI) استعادة الاستثمار المقدّر",
  "complaints_vs_visits": "الشكاوى مقارنة بالزيارات",
  "view_by_years": "عرض السنوات",
  "view_by_months": "عرض الشهور",
  "view_by_weeks": "عرض الاسابيع",
  "view_by_days": "عرض الايام",
  "minutes": "الدقائق",
  "company": "الشركة",
  "site": "الموقع",
  "alerts": "معلومات الأجهزة",
  "performance": "الأداء",
  "devices": "اجهزة",
  "total_devices": "إجمالي الأجهزة",
  "working": "يعمل",
  "warning": "تحذير",
  "by_device_type": "حسب نوع الجهاز",
  "surveys": "تقارير",
  "real_time": "الوقت الحقيقي",
  "real-time": "الوقت الحقيقي",
  "cleaner-activity": "نشاط عمال النظافة",
  "device-actions": "إجراءات الجهاز",
  "pad-presence-testing": "اختبار حضور الـ Pad",
  "real-time-cleaning": "الوقت الحقيقي - التنظيف",
  "real-time-maintenance": "الوقت الحقيقي - الصيانة",
  "no_real_time_tabs_permitted": "ليس لديك إذن لعرض أي علامة تبويب للوقت الحقيقي",
  "admin": "المدير",
  "all": "الكل",
  "overview": "مسح عام",
  "total": "المجموع",
  "analytics": "تحليل",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "التواصل",
  "overview_complaints_devices_caption": "الأجهزة المثبتة (تراكمي)",
  "overview_complaints_devices_caption_hint": "إجمالي الأجهزة المثبتة في الموقع حتى نهاية كل شهر، وفقاً لتواريخ التثبيت.",
  "overview_complaints_devices_toggle_aria": "إظهار أو إخفاء الأجهزة المثبتة تحت مخطط الشكاوى",
  "communication_select_site_title": "اختر موقعاً",
  "communication_select_site": "اختر الشركة والموقع من الفلاتر أعلاه لعرض وإضافة ملاحظات لهذا الموقع.",
  "communication_viewing_site": "عرض",
  "communication_add_note": "إضافة ملاحظة",
  "communication_add_note_open_aria": "فتح نافذة إضافة ملاحظة",
  "communication_form_hint": "شارك التحديثات أو الملاحظات مع كل من لديه حق الوصول لهذا الموقع. سيرون الملاحظات الجديدة في الوقت الفعلي.",
  "communication_page_intro_title": "ملاحظات الموقع — سجل مشترك لهذا الموقع",
  "communication_page_intro_body": "استخدم هذه الصفحة لتسجيل تسليم الوردية والمشكلات والتحديثات وملاحظات الاجتماعات. يمكن لكل من يصل إلى هذا الموقع في البوابة قراءة الملاحظات وإضافتها.",
  "communication_page_intro_dismiss": "إخفاء التلميح",
  "communication_page_intro_aria": "حول ملاحظات الموقع",
  "communication_content_placeholder": "اكتب ملاحظتك هنا...",
  "communication_keyboard_hint": "Ctrl+Enter للنشر",
  "communication_submitting": "جاري النشر...",
  "communication_submit": "نشر الملاحظة",
  "communication_recent_notes": "الملاحظات",
  "communication_search_placeholder": "البحث بالكاتب أو النص...",
  "communication_refresh": "تحديث",
  "communication_clear_filters": "مسح عوامل التصفية",
  "communication_search_aria_label": "البحث في الملاحظات",
  "communication_submit_aria_label": "نشر الملاحظة",
  "communication_copy_note_aria_label": "نسخ نص الملاحظة",
  "communication_copied": "تم النسخ إلى الحافظة.",
  "communication_copy_empty": "لا يوجد نص في هذه الملاحظة للنسخ.",
  "communication_filter_hidden_one": "(ملاحظة واحدة مخفية بسبب عوامل التصفية)",
  "communication_filter_hidden_many": "({n} ملاحظات مخفية بسبب عوامل التصفية)",
  "communication_request_timeout": "انتهت مهلة الطلب. حاول مرة أخرى.",
  "communication_load_failed": "تعذر تحميل الملاحظات.",
  "communication_retry": "حاول مرة أخرى",
  "communication_no_matches": "لا توجد ملاحظات تطابق البحث أو عوامل التصفية. حاول تعديلها.",
  "communication_no_entries": "لا توجد ملاحظات بعد.",
  "communication_no_entries_hint": "أضف ملاحظة أعلاه للبدء.",
  "communication_just_now": "الآن",
  "communication_minutes_ago": "منذ {n} د",
  "communication_hours_ago": "منذ {n} س",
  "communication_days_ago": "منذ {n} أيام",
  "communication_note_posted": "تم نشر الملاحظة.",
  "communication_post_failed": "تعذر نشر الملاحظة. حاول مرة أخرى.",
  "communication_note_type": "نوع الملاحظة",
  "communication_type_general": "عام",
  "communication_type_update": "تحديث",
  "communication_type_issue": "مشكلة",
  "communication_type_follow_up": "متابعة",
  "communication_type_meeting": "ملاحظة اجتماع",
  "communication_filter_all_types": "جميع الأنواع",
  "communication_pinned": "مثبتة",
  "communication_pin": "تثبيت",
  "communication_unpin": "إلغاء التثبيت",
  "communication_pin_limit": "حد أقصى 2 مثبتة",
  "communication_pinned_toast": "تم تثبيت الملاحظة.",
  "communication_unpinned_toast": "تم إلغاء تثبيت الملاحظة.",
  "communication_pin_failed": "تعذر تحديث التثبيت. حاول مرة أخرى.",
  "communication_note_not_found": "الملاحظة غير موجودة أو ليس لديك صلاحية.",
  "communication_site_not_in_filters": "موقع هذه الملاحظة ليس ضمن عوامل التصفية الحالية. قد لا يكون لديك صلاحية لذلك الموقع.",
  "communication_edit": "تعديل",
  "communication_delete": "حذف",
  "communication_save": "حفظ",
  "communication_cancel": "إلغاء",
  "communication_saving": "جاري الحفظ...",
  "communication_note_updated": "تم تحديث الملاحظة.",
  "communication_update_failed": "تعذّر تحديث الملاحظة. حاول مرة أخرى.",
  "communication_delete_confirm": "هل أنت متأكد من حذف هذه الملاحظة؟ لا يمكن التراجع عن هذا الإجراء.",
  "communication_delete_confirm_title": "حذف الملاحظة",
  "communication_note_preview": "معاينة الملاحظة:",
  "communication_note_deleted": "تم حذف الملاحظة.",
  "communication_delete_failed": "تعذّر حذف الملاحظة. حاول مرة أخرى.",
  "communication_edited": "تم التعديل",
  "communication_show_more": "عرض المزيد",
  "communication_show_less": "عرض أقل",
  "communication_sort_date_newest": "الأحدث أولاً",
  "communication_sort_date_oldest": "الأقدم أولاً",
  "communication_sort_author": "حسب المؤلف",
  "communication_sort_type": "حسب النوع",
  "communication_sort_pinned": "المثبتة أولاً",
  "communication_sort_label": "فرز",
  "communication_filter_by_type": "النوع",
  "communication_filters_group_aria": "تصفية وترتيب الملاحظات",
  "communication_search_label_short": "بحث",
  "employees": "الموظفين",
  "dayOfWeek": "ايام",
  "service_log": "تفاصيل الغرفة",
  "rooms": "الغرف",
  "bulk_add_rooms": "إضافة غرف بالجملة",
  "add_rooms": "إضافة غرف",
  "room_names_one_per_line": "أسماء الغرف (واحدة في كل سطر)",
  "enter_at_least_one_room": "يرجى إدخال اسم غرفة واحد على الأقل",
  "room_names_placeholder": "غرفة 1\nغرفة 2\nدورة مياه نساء",
  "rooms_with_prefix": "غرف ذات بادئة",
  "apply_to_all_rooms": "تطبيق على كل الغرف (اختياري)",
  "bulk_rooms_intro": "أضف مجموعة واحدة أو أكثر. لكل مجموعة مبنى وطابق ومنطقة وجنس وأسماء غرف خاصة بها.",
  "group": "مجموعة",
  "add_group": "+ إضافة مجموعة أخرى",
  "adding_rooms": "جاري إضافة الغرف...",
  "bulk_summary": "ملخص",
  "in": "في",
  "bulk_rooms_success": "تمت إضافة {n} غرف بنجاح",
  "displayName": "اسم الغرفة",
  "SLA": "SLA",
  "supervisors": "المشرفين",
  "supervisor": "المشرف",
  "performance_analytics": "مسح الغرفة",
  "arrivals": "عاملة النظافة",
  "inspections": "المراقبة",
  "avgResponseTime": "متوسط وقت الاستجابة",
  "missedSla": "التاخيرات",
  "cleaner_arrived": "وصول عامل/ة النظافة",
  "load_more": "حمل المزيد",
  "login": "اتصل/ي",
  "email": "بريد الكتروني",
  "emails": "عناوين البريد الالكتروني",
  "password": "الرمز",
  "min": "`دق`",
  "Logout": "انفصال",
  "time_range": "النطاق الزمني",
  "select_time_range": "حدد النطاق الزمني",
  "custom_time": "حدد التاريخ",
  "last_day": "أمس",
  "last_week": "آخر 7 أيام",
  "last_month": "آخر 30 يوم",
  "last_quarter": "آخر 90 يوم",
  "last_6_months": "نصف السنة الاخيرة",
  "last_year": "آخر 365 يوم",
  "data_by_hour": "البيانات حسب الساعة",
  "general": "عام",
  "cleaning": "النظافة",
  "maintenance": "صيانة",
  "start": "فتح",
  "start_time": "وقت البداية",
  "management_co": "مكافحة الإدارة،",
  "cleaning_co": "تنظيف حفرة،",
  "companies": "الشركات،",
  "name": "الاسم",
  "site_count": "المواقع #",
  "associated_companies": "الشركات المرتبطة",
  "OK": "موافقة",
  "cancel": "الغاء",
  "client": "زبون",
  "dates": "التواريخ",
  "shift": "الوردية",
  "issue": "المشكلة",
  "time": "الوقت",
  "top complaint of the week": "الغرفة الاكثر اشكالية هذا الشهر",
  "top room of the week": "الغرفة الاكثر اشكالية هذا الاسبوع",
  "top hour of the week": "الساعة الاكثر اشكالية هذا الاسبوع",
  "top complaint of the month": "الشكوى الاكثر اشكالية هذا الشهر",
  "top room of the month": "الغرفة الاكثر اشكالية هذا الشهر",
  "top hour of the month": "الساعة الاكثر اشكالية هذا الشهر",
  "franchises": "الامتياز",
  "add_franchise": "إضافة الفوضوي",
  "room_names": "اسم الغرفة",
  "type": "النوع",
  "please_select_company_site": "يرجى اختيار شركة وموقع",
  "number": "ارقم",
  "create_building_map": "إنشاء تعيين لبناء",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "مرحبا، الطريقة الاسرع لانشاء الغرف، الطوابق والبنايات بمساعدة المعالج السريع التالي",
  "avg number of toilets per floor": "متوسط ​​الحمامات على الأرض",
  "avg.number of toilet cells per room": "متوسط خلايا المراحيض في اغرفة",
  "number of floors": "عدد الطوابق",
  "avg.number of disabled toilets": "متوسط مراحيض ذوي الاعاقة في الطابق",
  "avg.number of soap dispensers": "متوسط مرافق الصابون في الغرفة",
  "reset_filter": "تنظيف الترشيح",
  "add": "اضافة",
  "new_survey": "تقرير جديد",
  "api_configuration": "تعريفت API",
  "please_edit_the_api_information": "تعديل تفاصيل API",
  "method": "نوع الطلب",
  "authorization": "التصريح",
  "api_url": "عنوان الطلب",
  "token": "مفتاح",
  "api_request_info": "معلومات للارسال",
  "roomName": "اسم الغرفة",
  "servikName": "اسم الشكوى",
  "siteName": "اسم الموقع",
  "stage": "الصفحة",
  "number_of_buttons": "عدد الازرار",
  "button_shape": "شكل الزر",
  "delay_time_stage": "وقت الانتظار",
  "go_to_stage": "انتقل الى الصفحة",
  "color": "اللون",
  "add_stage": "اضف صفحة",
  "save": "حفظ التقرير",
  "number_of_issues": "عدد الشكاوى",
  "online": "نشط",
  "offline": "غير نشط",
  "offline_devices": "الأجهزة غير النشطة",
  "no_offline_devices": "لم يتم العثور على أجهزة غير نشطة",
  "working_devices": "الأجهزة العاملة",
  "no_working_devices": "لم يتم العثور على أجهزة عاملة",
  "room_name": "اسم الغرفة",
  "installation_spot": "المكان",
  "device_id": "معرف الجهاز",
  "date": "التاريخ",
  "status": "الوضع",
  "device_status": "وضع الجهاز",
  "none": "لا يوجد",
  "no_surveys_created": "لا يوجد تقارير",
  "dashboard": "لوحة المراقبة",
  "franchise_name": "اسم صاحب الامتياز",
  "franchise_country": "دولة صاحب الامتياز",
  "choose_franchise": "اختر صاحب امتياز",
  "choose_country": "اختر دولة",
  "select_template": "اختر قالبا",
  "default_survey": "التقرير الافتراضي",
  "cleaning_survey": "تقرير النظافة",
  "kitchen_survey": "تقرير المطبخ",
  "template": "قالب",
  "area_name": "اسم التوزيع",
  "rooms_names": "اسماء الغرف",
  "rooms_number": "الغرف #",
  "assign_number": "المسؤول #",
  "active_notification_task": "تنبيهات النشاط",
  "amount_limit": "حد العد",
  "after_max": "حد التنبيه",
  "new_area": "منطقة عمل جديدة",
  "edit_area": "تعديل منطقة عمل",
  "tablet": "تابلت",
  "counter women": "عدّاد نساء",
  "counter men": "عدّاد رجال",
  "counter handicap": "عدّاد ذوي الاعاقة",
  "counter man/woman": "عدّاد مدمج",
  "counter man / woman": "عدّاد مدمج",
  "sensor liquid": "جهاز استشعار سوائل",
  "double toilet paper": "جهاز استشعار ورق مزدوج",
  "toilet paper": "جهاز استشعار ورق",
  "tag": "تاج",
  "qr tag": "كود QR",
  "additional_info": "معلومات اخرى للإرسال",
  "servikCategory": "نوع الطلب",
  "dishwashing": "جلاية",
  "cafeteria": "كافيتيريا",
  "clean room": "غرفة نظيفة",
  "office": "مكتب",
  "meeting room": "غرفة اجتماعات",
  "cubic": "كيوبيك",
  "women": "نساء",
  "men": "رجال",
  "handicap": "معاقون",
  "Combined": "مدمج",
  "kitchen": "مطبخ",
  "east": "شرق",
  "west": "غرب",
  "north": "شمال",
  "south": "جنوب",
  "right": "يمين",
  "left": "يسار",
  "center": "المركز",
  "up": "للاعلى",
  "down": "للاسفل",
  "combined": "مدمج",
  "lobby": "لوبي",
  "entrance": "مدخل",
  "reception": "استقبال",
  "area": "المنطقة",
  "mezzanine": "الميزاني",
  "gallery": "المعرض",
  "ground": "الارضية",
  "elevator": "المصاعد",
  "is_calculated": "حساب الغرفة",
  "calculated_room": "حساب الغرفة",
  "splitted_survey": "تقرير مقسّم",
  "redirect_to_url": "ارشد الى العنوان",
  "survey_site": "منطقة التقرير",
  "clicks": "نقرات",
  "add_stage_number_to_signal": "اضف رقم المنصة الى الاشارة",
  "including_pad9": "يشمل Pad9.",
  "room_type_required": "يرجى اختيار نوع الغرفة لكل مجموعة",
  "Tech Manufacturers": "مصنّعو التكنولوجيا",
  "Tech Offices": "مكاتب التكنولوجيا",
  "Offices": "مكاتب",
  "Terminal": "محطة",
  "Universities": "جامعات",
  "Factories": "مصانع",
  "Hospital": "مستشفى",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "متاجر صغيرة",
  "Food Chains": "سلاسل غذائية",
  "Residential": "سكني",
  "Shopping Center": "مركز تسوق",
  "Survey": "استبيان",
  "Demo": "عرض تجريبي",
  "Vision": "Vision",
  "Court": "محكمة",
  "Office Management": "إدارة المكاتب",
  "Government Office": "مكتب حكومي",
  "default_name": "الاسم الافتراضي.",
  "type_of_site": "نوع المنطقة",
  "No companies to show": "لا توجد شركات لعرضها",
  "add franchise": "اضف صاحبة امتياز",
  "room name": "اسم الغرفة",
  "please select a company & site": "يرجى اختيار الشركة والموقع",
  "create building map": "انشئ مسحا للبناية",
  "avg.number of toilets per floor": "متوسط غرف الحمامات في الطابق",
  "management co.": "شركة الادارة،",
  "cleaning co.": "شركة النظافة،",
  "exposures": "مراحيض نظيفة تم تجربتها",
  "exposures_tab": "نشاط الغرفة",
  "expose_results": "النتائج",
  "events_expose": "الأحداث",
  "expose_score": "المعدل",
  "shift_events_expose": "تحولات التعرض والأحداث",
  "sector": "قطاع",
  "last_time_of_arrival": "وقت الوصول الأخير",
  "arrival_and_status": "الوصول & الحالة",
  "preview_arrivals": "معاينة الوافدين",
  "men toilet": "مرحاض الرجال",
  "women toilet": "مرحاض النساء",
  "shared toilet": "مرحاض مشترك",
  "unisex restroom": "مرحاض للجنسين",
  "handicapped toilet": "مرحاض المعاقون",
  "logistics": "لوجستيات",
  "cubicle": "مقصورة",
  "gym": "صالة رياضية",
  "morning_shift": "دوام صباحي",
  "afternoon_shift": "دوام بعد الظهر",
  "night_shift": "دوام ليلي",
  "update": "تحديث",
  "restart": "إعادة تشغيل",
  "send_data": "إرسال البيانات",
  "send_count": "إرسال العداد",
  "blink": "مومض",
  "beacon": "منارة",
  "like_btn": "زر الإعجاب",
  "requires_like_btn": "يتطلب تشغيل زر الإعجاب",
  "maintenance_btn": "زر الصيانة",
  "battery": "بطارية",
  "version": "الإصدار",
  "actions": "إجراءات",
  "device_actions": "إجراءات الجهاز",
  "device_settings": "إعدادات الجهاز",
  "drains_battery": "يستنزف البطارية",
  "latest_errors": "آخر الأخطاء",
  "no_errors": "لا يوجد أخطاء",
  "offline_calls": "تنبيهات في وضع عدم الاتصال",
  "offline_duration_calls": "مدة التنبيهات في وضع عدم الاتصال",
  "counterCalls": "تنبيهات العداد",
  "active": "مفعل",
  "no_active_supervisors": "لا يوجد مشرفون نشطون",
  "active_supervisors_column": "المشرفون النشطون",
  "supervisors_active_label": "مشرفون نشطون الآن",
  "active_supervisors_coverage_hint": "المشرفون النشطون فعّلوا هذه المنطقة في التطبيق. هذا لا يدل على التواجد عبر الإنترنت أو الحضور الفعلي.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "حساب مفعل",
  "pad": "باد",
  "pad_counter": "عداد الباد",
  "counter_status": "حالة العداد",
  "choose_state": "اختر المحافظة",
  "city": "المدينة",
  "state": "المحافظة",
  "choose_city": "اختر المدينة",
  "start_hour": "بداية الساعة",
  "end_hour": "نهاية الساعة",
  "analytics_log": "سجل التحليلات",
  "or": "أو",
  "no_data_available": "لا توجد بيانات متاحة",
  "filter_by_cleaner": "تصفية حسب عامل النظافة",
  "all_cleaners": "جميع عمال النظافة",
  "failed_to_load_data": "فشل تحميل البيانات",
  "not_available": "غير متاح",
  "new_task": "مهمة جديدة",
  "temporarily_unavailable": "غير متاح مؤقتاً",
  "category": "الفئة",
  "title": "العنوان",
  "task_type": "نوع المهمة",
  "task_languages": "لغات المهمة",
  "task_languages_hint": "اختر اللغات لهذه المهمة. ستُدخل العنوان بكل لغة محددة.",
  "task_category": "فئة المهمة",
  "call_to_action": "استدعاء الإجراء",
  "schedule": "الجدول الزمني",
  "insert_text": "أدخل النص",
  "select": "اختر",
  "select_all": "اختر الكل",
  "n_selected": "{count} محدّد",
  "clear_selection": "مسح التحديد",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "تاريخ الجدول الزمني",
  "language": "اللغة",
  "calendar": "التقويم",
  "operation": "عملية",
  "daily": "يوميا",
  "weekly": "أسبوعيا",
  "monthly": "شهريا",
  "quarterly": "ربع سنويا",
  "yearly": "سنويا",
  "sunday": "الأحد",
  "monday": "الاثنين",
  "tuesday": "الثلاثاء",
  "wednesday": "الأربعاء",
  "thursday": "الخميس",
  "friday": "الجمعة",
  "saturday": "السبت",
  "january": "يناير",
  "february": "فبراير",
  "march": "مارس",
  "april": "أبريل",
  "may": "مايو",
  "june": "يونيو",
  "july": "يوليو",
  "august": "أغسطس",
  "september": "سبتمبر",
  "october": "أكتوبر",
  "november": "نوفمبر",
  "december": "ديسمبر",
  "1st week": "الأسبوع الأول",
  "2nd week": "الأسبوع الثاني",
  "3rd week": "الأسبوع الثالث",
  "4th week": "الأسبوع الرابع",
  "5th week": "الأسبوع الخامس",
  "1st quarter": "الربع الأول",
  "2nd quarter": "الربع الثاني",
  "3rd quarter": "الربع الثالث",
  "4th quarter": "الربع الرابع",
  "edit_task": "تعديل المهمة",
  "created_at": "تم الإنشاء في",
  "installed_at": "تاريخ التثبيت",
  "hour": "ساعة",
  "week_days": "أيام الأسبوع",
  "month_weeks": "أسابيع الشهر",
  "month_days": "أيام الشهر",
  "no_tasks_found": "لم يتم العثور على مهام",
  "invalid_language": "لغة غير صالحة",
  "no_active_tasks_found": "لم يتم العثور على مهام نشطة",
  "edit": "تعديل",
  "send_date": "تاريخ الإرسال",
  "invalid_date": "تاريخ غير صالح",
  "cells_num": "# الخلايا",
  "sinks_num": "# أحواض",
  "urinals_num": "# المباول",
  "toilet_paper_size": "حجم ورق الحمام",
  "email_configuration": "تكوين البريد الإلكتروني",
  "please_edit_the_email_information": "يرجى تعديل معلومات البريد الإلكتروني",
  "email_sender_info": "معلومات مرسل البريد الإلكتروني",
  "email_subject_info": "معلومات موضوع البريد الإلكتروني",
  "email_message_info": "معلومات رسالة البريد الإلكتروني",
  "companyName": "اسم الشركة",
  "email_language": "لغة البريد الإلكتروني",
  "complaint_language": "لغة الشكوى",
  "email_message_format": "تنسيق رسالة البريد الإلكتروني",
  "line": "خط",
  "list": "قائمة",
  "roomType": "نوع الغرفة",
  "By logging in, you agree to Buzzztech's": "بتسجيل الدخول ، فإنك توافق على شروط Buzzztech",
  "Terms and Conditions": "الشروط والأحكام",
  "and": "و",
  "Privacy Policy": "سياسة الخصوصية",
  "All actions within this panel are recorded for quality control and improvement": "يتم تسجيل جميع الإجراءات داخل هذا اللوح للتحكم في الجودة والتحسين",
  "You must agree to the terms and conditions": "يجب أن توافق على الشروط والأحكام",
  "months": "الشهور",
  "ref_id": "الرقم المرجع",
  "room_name_en": "اسم الغرفة باللغة الإنجليزية",
  "site_state": "ولاية الموقع",
  "site_city": "مدينة الموقع",
  "site_country": "دولة الموقع",
  "first_date": "الموعد الاول",
  "pinned": "مثبت",
  "no.": "رقم",
  "must_be_numbers": "يجب أن يكون رقمًا",
  "must_be_3_digits": "يجب أن يكون 3 أرقام",
  "must_have_english_title": "يجب أن يكون له عنوان إنجليزي",
  "total_sites": "المجموع",
  "site_information": "معلومات الموقع",
  "holiday_offdays": "أيام الإجازات والأعياد",
  "add_offday": "يوم الإجازة",
  "add_holiday": "الأعياد",
  "name_under_chars": "اسم أقل من 25 حرفًا",
  "days_comma_separated": "أيام صالحة ، مفصولة بفاصلة",
  "year": "السنة",
  "month": "الشهر",
  "day": "اليوم",
  "holiday_name": "اسم العطلة",
  "offday_name": "اسم يوم العطلة",
  "delete_confirmation_title": "هل أنت متأكد؟",
  "delete_confirmation_message": "لا يمكن التراجع عن هذا الإجراء.",
  "are_you_sure": "هل أنت متأكد؟",
  "israel": "إسرائيل",
  "USA": "الولايات المتحدة الأمريكية",
  "poland": "بولندا",
  "mexico": "المكسيك",
  "cyprus": "قبرص",
  "brazil": "البرازيل",
  "romania": "رومانيا",
  "netherlands": "هولندا",
  "tablet_survey": "استطلاع التابلت",
  "no_shift_survey": "لا يوجد وردية",
  "number_of_rows": "عدد الصفوف",
  "rating_shape": "شكل التقييم",
  "content_survey": "محتوى الاستطلاع",
  "rating_survey": "تقييم الاستطلاع",
  "device-alerts": "مشكلة",
  "device-active": "نشيط",
  "device-search": "يبحث",
  "mac_id": "عنوان ماك",
  "qr_tag": "علامة QR",
  "sensor": "المستشعر",
  "image_survey": "صورة الاستطلاع",
  "open_text": "نص مفتوح",
  "open_text_survey": "نص مفتوح",
  "embedded_link": "رابط مضمن",
  "device-counter": "عدادات",
  "count": "عدد",
  "last_date": "اخر موعد",
  "last_arrival":"آخر وصول نظافة",
  "cleaners": "عمال النظافة",
  "viewer": "عارض",
  "android": "أندرويد",
  "ios": "آيفون",
  "no_users_found": "لم يتم العثور على مستخدمين",
  "cleaner_activity": "نشاط عمال النظافة",
  "pad_presence_testing": "اختبار حضور الـ Pad",
  "pad_presence_testing_subtitle": "دخول وخروج وضغطات الـ Pad دون اتصال المرسلة من الهاتف للموقع المحدد",
  "pad_presence_timeline": "الجدول الزمني المباشر",
  "pad_presence_sessions": "جلسات الحضور",
  "pad_presence_offline_presses": "ضغطات دون اتصال من الهواتف",
  "pad_presence_select_site_hint": "اختر شركة وموقعًا في الترويسة لمشاهدة أحداث الحضور.",
  "pad_presence_no_events": "لا توجد أحداث حضور في هذه الفترة.",
  "pad_presence_open": "مفتوح",
  "pad_presence_exit_phone": "خروج من الهاتف",
  "pad_presence_exit_auto": "خروج تلقائي",
  "pad_presence_exit_stale": "خروج متأخر",
  "pad_presence_enter": "دخول",
  "pad_presence_exit": "خروج",
  "pad_presence_offline": "ضغطة دون اتصال",
  "pad_presence_faulty": "خاطئ",
  "pad_presence_employee": "موظف",
  "pad_presence_room": "غرفة",
  "pad_presence_time_from": "من",
  "pad_presence_last_updated": "تم التحديث",
  "pad_presence_duration": "المدة",
  "pad_presence_exit_type": "نوع الخروج",
  "pad_presence_button": "زر",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "العدد",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "كل الموظفين",
  "pad_presence_all_rooms": "كل الغرف",
  "pad_presence_load_error": "تعذر تحميل بيانات حضور الـ Pad.",
  "pad_presence_in_room_now": "في غرفة الآن",
  "pad_presence_in_room": "في",
  "pad_presence_since": "منذ",
  "pad_presence_just_now": "الآن",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "هاتف",
  "pad_presence_all_phones": "كل الهواتف",
  "pad_presence_window": "عرض",
  "pad_presence_window_hour": "الساعة الأخيرة",
  "pad_presence_window_today": "اليوم",
  "pad_presence_window_month": "الشهر الأخير",
  "pad_presence_pads": "أجهزة الـ Pad في هذا الموقع",
  "pad_presence_no_pads": "لا توجد أجهزة Pad مرتبطة بغرف في هذا الموقع.",
  "pad_presence_last_enter": "آخر دخول",
  "pad_presence_last_offline": "آخر ضغطة دون اتصال",
  "pad_presence_auto_exit_leave": "غادر الآن ← خروج تلقائي خلال",
  "pad_presence_auto_exit_earliest": "الأبكر من الدخول:",
  "pad_presence_auto_exit_passed": "انتهى أقرب وقت للخروج التلقائي. ما زال مفتوحًا = الـ Pad ما زال يُسمع، أو غادر وانتظر 5د 45ث.",
  "cleaner_activity_live_footer": "يتم تحديث البيانات في الوقت الفعلي",
  "ca_empty_select_site_hint": "اختر الشركة والموقع في الرأس لعرض نشاط عمال النظافة لليوم.",
  "ca_empty_no_cleaners_hint": "لا يوجد عمال نظافة معيّنون لهذا الموقع والوردية الحالية. عيّن المواقع النشطة والورديات في المستخدمين.",
  "ca_empty_access_denied": "تم رفض الوصول",
  "ca_empty_access_denied_hint": "ليس لديك إذن لعرض نشاط عمال النظافة لهذا الموقع.",
  "ca_empty_load_error_hint": "تعذّر تحميل النشاط. حاول مرة أخرى أو تواصل مع الدعم إذا استمرت المشكلة.",
  "ca_empty_no_filter_match": "لا يوجد عمال نظافة يطابقون هذه الفلاتر",
  "ca_empty_no_filter_match_hint": "جرّب مسح الفلاتر أو اختيار عامل نظافة أو منطقة عمل أو غرفة أخرى.",
  "ca_timeline_all_cleaners": "نشاط اليوم — جميع عمال النظافة",
  "ca_legend_work": "نشط",
  "ca_clock_sessions_more": "المزيد",
  "ca_clock_sessions_less": "عرض أقل",
  "ca_sort_label": "ترتيب",
  "ca_sort_needs_attention": "يحتاج انتباهاً",
  "ca_sort_best_avg_response": "أفضل متوسط وقت استجابة",
  "ca_sort_worst_avg_response": "أسوأ متوسط وقت استجابة",
  "ca_sort_most_sla_breaches": "أكثر مخالفات SLA",
  "ca_sort_most_open_complaints": "أكثر شكاوى مفتوحة",
  "ca_sort_most_work_time": "أكثر وقت عمل",
  "ca_sort_least_work_time": "أقل وقت عمل",
  "ca_stat_avg_short": "متوسط",
  "ca_stat_open_short": "مفتوح",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "عمل",
  "ca_assigned_room_avg_hint": "متوسط وقت الاستجابة للغرف المخصصة اليوم",
  "ca_transit_tooltip": "وقت الانتقال بين المهام",
  "ca_transit_live_tooltip": "الوقت منذ إغلاق المهمة الأخيرة",
  "ca_legend_visits": "الزيارات بين النداءات",
  "ca_visits_between_sla": "الزيارات منذ إغلاق النداء السابق",
  "ca_apply": "تطبيق",
  "ca_visits_since": "منذ",
  "ca_deferred_tip_title": "شكوى مؤجلة",
  "ca_deferred_tip_resolved": "تم الحل",
  "ca_deferred_tip_desc_open": "ما زالت مفتوحة — قام عامل النظافة بخدمة غرف أخرى أولاً بدلاً من هذه.",
  "ca_deferred_tip_desc_closed": "بقيت هذه الشكوى مفتوحة بينما خدم عامل النظافة غرفاً أخرى أولاً.",
  "ca_deferred_tip_rooms_label": "تمت خدمتها أولاً:",
  "ca_attention_title": "يحتاج إلى اهتمام",
  "ca_attention_empty": "كل شيء على ما يرام — لا توجد مشكلات الآن",
  "ca_attention_sla_breach_one": "{name} · خرق SLA",
  "ca_attention_sla_breach_many": "{name} · {count} خروقات SLA",
  "ca_attention_open_while_out_one": "{name} · شكوى مفتوحة أثناء الخروج",
  "ca_attention_open_while_out_many": "{name} · {count} مفتوحة أثناء الخروج",
  "ca_attention_idle": "{name} · خامل {duration}",
  "ca_attention_late": "{name} · دخول متأخر",
  "ca_attention_show": "إظهار",
  "ca_attention_hide": "إخفاء",
  "ca_view_shift": "الوردية",
  "ca_view_history": "السجل",
  "ca_filters_done": "تم",
  "ca_hist_preset_this_month": "هذا الشهر",
  "ca_hist_preset_last_month": "الشهر الماضي",
  "ca_hist_preset_this_week": "هذا الأسبوع",
  "ca_hist_preset_last_week": "الأسبوع الماضي",
  "ca_hist_preset_custom": "مخصص",
  "ca_hist_from": "من",
  "ca_hist_to": "إلى",
  "ca_hist_range_invalid": "يجب أن يكون تاريخ البداية قبل تاريخ النهاية",
  "ca_hist_range_too_long": "لا يمكن أن يتجاوز النطاق {max} يومًا",
  "ca_hist_search": "ابحث بالاسم أو الهاتف",
  "ca_hist_people_count": "{count} موظفين",
  "ca_hist_kpi_days": "أيام العمل",
  "ca_hist_kpi_net": "ساعات صافية",
  "ca_hist_kpi_breaks": "استراحات",
  "ca_hist_col_person": "الموظف",
  "ca_hist_col_total": "إجمالي الساعات",
  "ca_hist_col_total_tip": "من تسجيل الدخول حتى تسجيل الخروج قبل الاستراحات، وهو نفس الرقم الذي يراه الموظف في التطبيق",
  "ca_hist_col_net": "ساعات صافية",
  "ca_hist_col_breaks": "استراحات",
  "ca_hist_col_issues": "ملاحظات",
  "ca_hist_col_late": "تأخير",
  "ca_hist_col_missed": "غياب",
  "ca_hist_col_no_clock_out": "بدون خروج",
  "ca_hist_clocked_in_now": "مسجّل الدخول الآن",
  "ca_hist_not_assigned": "غير مُعيّن لهذا الموقع",
  "ca_hist_no_shift": "لا توجد وردية مُعيّنة",
  "ca_hist_unknown_name": "غير معروف",
  "ca_hist_empty": "لا يوجد حضور في هذه الفترة",
  "ca_hist_empty_hint": "لم يسجّل أحد الدخول في هذا الموقع ولا يوجد موظفون مُعيّنون له.",
  "ca_hist_no_match": "لا يوجد موظفون مطابقون للفلاتر",
  "ca_hist_load_error_hint": "تعذّر تحميل سجل الحضور. حاول مرة أخرى بعد قليل.",
  "ca_hist_prev_person": "الموظف السابق",
  "ca_hist_next_person": "الموظف التالي",
  "ca_hist_close": "إغلاق",
  "ca_hist_legend_worked": "عمل",
  "ca_hist_legend_late": "تأخير",
  "ca_hist_legend_missed": "غياب",
  "ca_hist_legend_no_clock_out": "بدون خروج",
  "ca_hist_late_by": "تأخير {duration}",
  "ca_hist_late_tip": "سجّل الدخول في {time}، تبدأ {shift} في {start}",
  "ca_hist_missed": "غياب",
  "ca_hist_missed_tip": "انتهت الوردية المجدولة دون تسجيل دخول",
  "ca_hist_no_clock_out": "بدون خروج",
  "ca_hist_no_clock_out_tip": "لم تُغلق الجلسة؛ ساعاتها غير محسوبة",
  "ca_hist_in_progress": "لا يزال مسجّل الدخول",
  "ca_hist_auto": "تلقائي",
  "ca_hist_open_break": "مفتوحة",
  "ca_hist_day_col_gross": "إجمالي الساعات",
  "ca_hist_day_col_breaks": "استراحات",
  "active_cleaners": "عمال نظافة نشطون",
  "closed_complaints": "الشكاوى المغلقة",
  "total_work_time": "إجمالي وقت العمل",
  "total_work_time_net": "إجمالي وقت العمل (صافي اليوم)",
  "total_break_time": "إجمالي وقت الاستراحة",
  "avg_response_time": "متوسط المعالجة",
  "cleaner": "عامل النظافة",
  "clocked_in": "تسجيل الدخول",
  "clocked_out": "تسجيل الخروج",
  "still_clocked_in": "لا يزال مسجلاً للدخول",
  "clocked_in_late": "تسجيل دخول متأخر",
  "total_hours": "إجمالي الساعات",
  "auto_punch": "تلقائي (تحديد جغرافي)",
  "manual_punch": "يدوي",
  "complaint_opened": "تم فتح الشكوى",
  "complaint_closed": "تم إغلاق الشكوى",
  "complaint_still_open": "لا تزال مفتوحة",
  "resolved_in": "تم الحل خلال",
  "open_for": "مفتوحة منذ",
  "sla_breached": "خرق اتفاقية مستوى الخدمة",
  "no_activity_today": "لا يوجد نشاط حتى الآن اليوم",
  "just_now": "الآن",
  "ago": "منذ",
  "today": "اليوم",
  "live": "مباشر",
  "last_updated": "تم التحديث",
  "no_cleaners_found": "لم يتم العثور على عمال النظافة",
  "new_cleaner": "عامل نظافة جديد",
  "edit_cleaner": "تعديل عامل نظافة",
  "have_you_finished_making_changes": "هل انتهيت من إجراء التغييرات؟",
  "assignment_issues_found": "تم العثور على مشاكل في التعيين",
  "unassigned_rooms_title": "غرف غير معيّنة",
  "overlapping_assignments_title": "تعيينات متداخلة",
  "and_n_more": "و{count} إضافية",
  "continue_anyway": "المتابعة على أي حال",
  "stay_and_fix": "البقاء والإصلاح",
  "assignment_coverage_issues": "{unassigned} غير معيّنة · {overlaps} تداخلات",
  "assignment_check_failed": "تعذر التحقق من تعيينات الغرف",
  "tap_for_details": "اضغط للتفاصيل",
  "has_app": "التطبيق",
  "has_app_tooltip": "العامل لديه التطبيق",
  "notifications_tooltip": "الإشعارات مفعّلة",
  "assigned_to_rooms": "مُعيَّن للغرف",
  "assigned_to_rooms_tooltip": "معيّن لغرف في هذا الموقع",
  "recently_active": "نشط مؤخراً",
  "works_at_site": "يعمل في الموقع",
  "recently_active_tooltip": "فتح التطبيق خلال آخر 30 دقيقة",
  "please_select": "يرجى اختيار",
  "please_select_site_first": "يرجى اختيار موقع أولاً",
  "working_areas": "مناطق العمل",
  "no_working_areas": "لا توجد مناطق عمل بعد",
  "working_area_alerts": "التنبيهات",
  "api": "API",
  "please_create_room_before_working_area": "يرجى إنشاء غرفة واحدة على الأقل قبل إنشاء منطقة عمل",
  "isWorkingInSite": "يعمل في الموقع",
  "you_are_not_allowed_to_edit": "غير مسموح لك بالتعديل",
  "you_are_not_allowed_to_remove": "غير مسموح لك بالحذف",
  "task": "مهمة",
  "portuguese": "البرتغالية",
  "russian": "الروسية",
  "spanish": "الأسبانية",
  "polish": "البولندية",
  "installer": "مثبت",
  "once": "مرة واحدة",
  "time_saved": "الوقت المحفوظ",
  "yes": "نعم",
  "no": "لا",
  "workingAreaNames": "اسماء مناطق العمل",
  "shift_rooms":"غرف الوردية",
  "new_shift":"وردية جديده",
  "add_shift_inactive": "اضافه وردية غير ناشطه",
  "remove_auto_shift_inactive": "يزيل وردية غير ناشطه",
  "additional_options": "المزيد من الخيارات",
  "add_default_shifts": "اضافه ورديات افتراضية",
  "no_user_found": "لم يتم العثور على مستخدم",
  "no_site_found": "لم يتم العثور على موقع",
  "service_provider": "مزود الخدمة",
  "qr task": "مهمة QR",
  "qr_task": "مهمة QR",
  "all_day": "طوال اليوم",
  "auto_start": "بدء تلقائي",
  "english_title": "العنوان بالإنجليزية",
  "connectivity": "الاتصال",
  "power": "الطاقة",
  "Your work has been saved": "تم حفظ عملك",
  "schedule_call_time": "وقت الطلب",
  "schedule_call_gap": "فجوة الطلب",
  "gapInMinutes": "الفجوة بالدقائق",
  "no_manual_calls_available": "لا توجد مكالمات يدوية متاحة",
  "manual_calls": "مكالمات يدوية",
  "cleandex_calls": "تنبيهات كلينديكس",
  "cleandexCalls": "تنبيهات كلينديكس",
  "manualCalls": "مكالمات يدوية",
  "inactive": "غير نشط",
  "on hold": "تجميد",
  "sequential": "تسلسلي",
  "ratio": "نسبة",
  "must_choose": "يجب اختيار",
  "surveyApp": "تطبيق الاستطلاع",
  "installation": "تثبيت",
  "manager": "مدير",
  "previous": "السابق",
  "next": "التالي",
  "no_rooms_found": "لم يتم العثور على غرف",
  "show_calendar": "عرض التقويم",
  "seeAll": "عرض الكل",
  "showPaginated": "عرض مقسم",
  "cleaners_arrivals": "وصول عمال النظافة",
  "add_address": "اضافة عنوان",
  "site_auto_attendance_enabled":
    "السماح بتسجيل الدخول والخروج تلقائيًا عبر السياج الجغرافي في التطبيق (بحاجة لإذن تحديد المواقع).",
  "site_auto_attendance_requires_location":
    "حدد الموقع على الخريطة أولاً (تثبيت ونصف قطر 100 م على الأقل) قبل تفعيل التسجيل التلقائي.",
  "site_mandatory_clock_in": "إلزام تسجيل الدخول قبل العمل",
  "site_mandatory_clock_in_description":
    "يجب على العاملين في هذا الموقع تسجيل الدخول قبل أن يتمكنوا من فتح تبويبات التنظيف والصيانة والمهام في التطبيق.",
  "site_mandatory_clock_in_without_location":
    "لم يتم تحديد موقع على الخريطة لهذا الموقع، لذا لا يستطيع التطبيق معرفة وجود العامل في الموقع. وحتى تحدد موقعًا، ينطبق الشرط على هؤلاء العاملين في كل مكان.",
  "edit_address": "تعديل العنوان",
  "choose_radius": "اختر نصف القطر",
  "cleandex": "كلينديكس",
  "cleandex_column_tooltip": "أخضر = OK. أحمر = يُوصى بالتنظيف. مرر فوق الأيقونة للتفاصيل.",
  "recommended_to_clean": "يُوصى بالتنظيف",
  "cleandex_warning_level": "مستوى تحذير كلينديكس",
  "select_warning_level": "اختر مستوى التحذير",
  "bronze": "برونزي",
  "silver": "فضي",
  "gold": "ذهبي",
  "ai": "الذكاء الاصطناعي",
  "daily_employees_num": "عدد الموظفين اليومي",
  "daily_shift_hours": "ساعات الدوام اليومي",
  "rooms_num": "عدد الغرف",
  "buildings_num": "عدد المباني",
  "cleaner_entries": "دخول عمال النظافة",
  "avg_daily_visits_monthly": "متوسط الزيارات اليومية الشهرية",
  "avg_daily_cleaners_to_save": "متوسط عدد عمال النظافة الموفَّر يوميًا",
  "saving_hours_per_day": "ساعات التوفير اليومية",
  "saving_money_per_day": "التوفير المالي اليومي",
  "saving_money_per_month": "التوفير المالي الشهري",
  "cleaners_to_visitors_ratio": "نسبة عمال النظافة إلى الزوار",
  "cleaning_time_in_minutes_per_room": "وقت التنظيف بالدقائق لكل غرفة",
  "max_number_of_rooms_per_employee": "الحد الأقصى لعدد الغرف لكل موظف",
  "break_time_per_hour": "وقت الاستراحة لكل ساعة",
  "transition_time_between_tasks": "وقت الانتقال بين المهام",
  "employer_cost_hour": "تكلفة صاحب العمل لكل ساعة",
  "lobby_cleaning_per_floor": "تنظيف الردهة لكل طابق",
  "desired_cleaning_time": "وقت التنظيف المطلوب",
  "desired_number_of_entries": "عدد الدخول المطلوب",
  "buzz_system_cost_per_unit_per_month": "تكلفة نظام Buzz لكل وحدة شهريًا",
  "total_buzz_system_cost_per_month": "إجمالي تكلفة نظام Buzz شهريًا",
  "return_on_investment_in_months": "المدة الزمنية لاسترداد الاستثمار بالأشهر",
  "annual_savings": "التوفير السنوي",
  "roi_calculator": "حاسبة عائد الاستثمار",
  "cleaners_number": "عدد عمال النظافة",
  "floors_num": "عدد الطوابق",
  "avg_daily_cleaners_required": "متوسط عدد عمال النظافة المطلوب يوميًا",
  "app_pages": "صفحات التطبيق",
  "buzzzTime": "وقت Buzzz",
  "missions": "مهام",
  "send_emails": "إرسال إيميلات",
  "enter": "أدخل",
  "account": "حساب",
  "privacy": "الخصوصية",
  "personal_settings": "الإعدادات الشخصية",
  "personal_settings_lead": "إدارة اللغة وتفضيلات الخصوصية.",
  "personal_settings_read_only": "تُدار هذه التفاصيل بواسطة المسؤول. تواصل معه للتحديث.",
  "change_password": "تغيير كلمة المرور",
  "change_password_hint": "تغيير كلمة المرور سيؤدي إلى تسجيل خروجك من أجهزتك الأخرى.",
  "current_password": "كلمة المرور الحالية",
  "new_password": "كلمة المرور الجديدة",
  "confirm_new_password": "تأكيد كلمة المرور الجديدة",
  "password_min_length": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
  "passwords_do_not_match": "كلمتا المرور غير متطابقتين",
  "new_password_same_as_current": "يجب أن تختلف كلمة المرور الجديدة عن الحالية",
  "current_password_incorrect": "كلمة المرور الحالية غير صحيحة",
  "current_password_required": "كلمة المرور الحالية مطلوبة",
  "password_changed_successfully": "تم تغيير كلمة المرور بنجاح",
  "change_password_failed": "تعذر تغيير كلمة المرور",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "اسم المستخدم أو كلمة المرور غير صحيحة",
  "login_credentials_required": "أدخل اسم المستخدم أو البريد الإلكتروني وكلمة المرور",
  "login_network_error": "تعذر الوصول إلى الخادم. تحقق من الاتصال وحاول مرة أخرى",
  "login_failed": "تعذر تسجيل الدخول. يرجى المحاولة مرة أخرى",
  "login_too_many_attempts": "محاولات تسجيل دخول كثيرة. انتظر 15 دقيقة ثم حاول مرة أخرى.",
  "forgot_password_too_many": "طلبات إعادة تعيين كلمة المرور كثيرة. انتظر ساعة ثم حاول مرة أخرى.",
  "reset_password_too_many": "محاولات إعادة تعيين كلمة المرور كثيرة. انتظر ساعة ثم حاول مرة أخرى.",
  "change_password_too_many": "محاولات تغيير كلمة المرور كثيرة. انتظر 15 دقيقة ثم حاول مرة أخرى.",

  "personal_settings_language_hint": "تنطبق على البوابة بالكامل في هذا المتصفح.",
  "personal_settings_privacy_hint": "طلب محو بياناتك الشخصية بموجب قوانين الخصوصية.",
  "personal_settings_role": "الدور",
  "Request deletion of my data": "طلب حذف بياناتي",
  "Request deletion of my data - confirm": "طلب حذف بياناتي؟ سيتم إرسال بريد إلكتروني إلى المسؤول. سنعالج طلبك خلال 30 يوماً.",
  "Request deletion of my data - success": "تم إرسال الطلب. سنعالجه خلال 30 يوماً.",
  "Request deletion of my data - error": "فشل إرسال الطلب. حاول مرة أخرى أو راسل privacy@buzzztech.com.",
  "metrics": "المقاييس",
  "select_three_metrics": "اختر ما يصل إلى 3 مقاييس للمقارنة",
  "select_four_metrics": "اختر ما يصل إلى 4 مقاييس للمقارنة",
  "legend": "مفتاح الرموز",
  "more_details": "تفاصيل أكثر",
  "performance_overview": "نظرة عامة على الأداء",
  "loading_chart": "جارٍ تحميل الرسم البياني",
  "retry": "إعادة المحاولة",
  "performance_trending_upward": "الأداء في تصاعد",
  "high_complaint_ratio": "نسبة شكاوى مرتفعة",
  "click_bars_for_details": "انقر على الأعمدة لعرض التحليلات اليومية",
  "refresh": "تحديث",
  "table": "جدول",
  "cards": "بطاقات",
  "no_recent_arrivals": "لا توجد وصولات حديثة",
  "feedback_charts": "مخططات التعليقات",
  "general_overview": "نظرة عامة",
  "cleaning_complaints_breakdown": "تفصيل شكاوى التنظيف",
  "maintenance_complaints_breakdown": "تفصيل شكاوى الصيانة",
  "refresh_failed": "فشل التحديث",
  "data_exported_successfully": "تم تصدير البيانات بنجاح",
  "data_export_failed": "فشل تصدير البيانات",
  "drill_down_unavailable": "التفصيل متاح فقط في العرض اليومي",
  "sort_by": "ترتيب حسب",
  "no_active_shift": "لا توجد وردية نشطة",
  "check_site_and_shift": "يرجى التحقق مما إذا تم تحديد موقع وهناك وردية نشطة",
  "please_add_shift_first": "يرجى إضافة وردية أولاً",
  "cleandex_no_data_message": "لا توجد بيانات Cleandex متاحة حالياً",
  "task_no_data_message": "لا توجد بيانات مهام متاحة حالياً",
  "navigation": "التنقل",
  "network_information": "معلومات الشبكة",
  "target_effectiveness": "فعالية الهدف",
  "cleandex_call_cleaner": "اتصل بعامل النظافة",
  "top_complaint": "أعلى شكوى",
  "no_complaints": "لا توجد شكاوى",
  "official_start_date": "تاريخ البدء الرسمي",
  "note_text": "نص الملاحظة",
  "add_note": "إضافة ملاحظة",
  "general_note": "ملاحظة عامة",
  "general_note_short": "عام",
  "battery_short": "بطارية",
  "panel_short": "لوحة",
  "technician_short": "فني",
  "battery_replacement": "استبدال البطارية",
  "device_maintenance": "صيانة الجهاز",
  "maintenance_type": "نوع الصيانة",
  "panel_change": "تغيير اللوحة",
  "technician_check": "فحص الفني",
  "enter_note_details": "أدخل تفاصيل الملاحظة",
  "replacement_date": "تاريخ الاستبدال",
  "replaced_by_name": "تم الاستبدال بواسطة",
  "replacement_note": "ملاحظة الاستبدال",
  "enter_replacement_details": "أدخل تفاصيل الاستبدال",
  "replacement_history": "سجل الاستبدال",
  "loading_history": "جارٍ تحميل السجل",
  "no_replacement_history": "لا يوجد سجل استبدال متاح",
  "enter_technician_name": "أدخل اسم الفني",
  "user_information": "معلومات المستخدم",
  "enter_change_details": "أدخل تفاصيل التغيير",
  "panel_change_history": "سجل تغيير اللوحة",
  "check_date": "تاريخ الفحص",
  "checked_by_name": "تم الفحص بواسطة",
  "enter_check_details": "أدخل تفاصيل الفحص",
  "technician_check_history": "سجل فحص الفني",
  "no_technician_check_history": "لا يوجد سجل فحص فني متاح",
  "change_date": "تاريخ التغيير",
  "changed_by_name": "تم التغيير بواسطة",
  "change_note": "ملاحظة التغيير",
  "check_note": "ملاحظة الفحص",
  "replaced_by": "تم الاستبدال بواسطة",
  "no_data_entered": "لم يتم إدخال بيانات",
  "no_panel_change_history": "لا يوجد سجل تغيير لوحة متاح",
  "invalid_username": "اسم المستخدم غير صالح",
  "invalid_phone": "رقم هاتف غير صالح",
  "username_must_be_at_least_5_characters": "يجب أن يحتوي اسم المستخدم على 5 أحرف على الأقل",
  "open_slas": "SLAs مفتوحة",
  "open_sla_alerts": "تنبيهات الشكاوى المفتوحة",
  "open_duration": "المدة المفتوحة",
  "open_complaints": "شكاوى مفتوحة",
  "site_alerts": "تنبيهات المواقع",
  "rooms_with_open_complaints_percentage": "الغرف مع الشكاوى المفتوحة",
  "rooms_with_cleaner_arrival_percentage": "الغرف مع وصول عامل النظافة",
  "rooms_without_cleaner_arrival_percentage": "الغرف بدون وصول عامل النظافة",
  "site_alerts_total_rooms": "إجمالي الغرف",
  "site_alerts_open_complaints_count": "عدد الشكاوى المفتوحة",
  "site_alerts_customer_opening_date": "تاريخ فتح العميل",
  "company_country": "دولة الشركة",
  "select_message": "اختر الرسالة",
  "message_no_cleaner_arrival": "مرحباً بالجميع،\nيرجى ملاحظة أن هناك غرف لم يتم الإبلاغ عن وصول عامل النظافة فيها اليوم.\nيرجى التعامل مع هذا",
  "message_open_complaints": "مرحباً بالجميع،\nيرجى ملاحظة أن هناك عدة غرف بها شكاوى مفتوحة منذ وقت طويل.\nيرجى التعامل مع هذا",
  "rooms_list": "الغرف:",
  "no_open_slas": "لم يتم العثور على SLAs مفتوحة",
  "no_open_slas_description": "لا توجد حالياً مواقع بها SLAs مفتوحة.",
  "no_slas_to_send": "لم يتم العثور على SLAs مفتوحة لهذا الموقع",
  "total_open_complaints": "إجمالي الشكاوى المفتوحة",
  "longest_duration": "أطول مدة",
  "complaints_details": "تفاصيل الشكاوى",
  "no_results_found": "لم يتم العثور على نتائج",
  "whatsapp": "واتساب",
  "loading": "جاري التحميل",
  "error_opening_whatsapp": "خطأ في فتح واتساب. يرجى المحاولة مرة أخرى.",
  "error_loading_slas": "خطأ في تحميل تفاصيل SLA. يرجى المحاولة مرة أخرى.",
  "send_whatsapp": "إرسال WhatsApp",
  "more_options": "المزيد من الخيارات",
  "preview_message": "معاينة الرسالة",
  "copy_message": "نسخ الرسالة",
  "message_preview": "معاينة الرسالة",
  "phone_number_optional": "رقم الهاتف (اختياري)",
  "enter_phone_number": "أدخل رقم الهاتف (مثال: +966501234567)",
  "phone_number_hint": "اتركه فارغًا لفتح WhatsApp بدون جهة اتصال محددة",
  "message_copied": "تم نسخ الرسالة إلى الحافظة!",
  "error_copying_message": "خطأ في نسخ الرسالة. يرجى المحاولة مرة أخرى.",
  "opening_whatsapp": "جاري فتح WhatsApp...",
  "data_loading_please_wait": "البيانات قيد التحميل. يرجى الانتظار...",
  "dates_not_changed": "لم تتغير التواريخ. لا حاجة لإعادة التحميل.",
  "date_outside_stats_range": "التواريخ المحددة خارج نطاق الإحصاءات المتاح.",

  "date_range_invalid": "يجب أن يكون تاريخ \"إلى\" مساوياً أو لاحقاً لتاريخ \"من\".",
  "filter_help_text": "قواعد التصفية: حدد المبنى أولاً لتمكين تصفية الطابق. تدعم معظم المرشحات التحديدات المتعددة.",
  "select_building_first": "يرجى تحديد مبنى أولاً لتمكين تصفية الطابق",
  "cannot_select_gender_with_rooms": "لا يمكن تحديد نوع الغرفة عند تحديد الغرف",
  "cannot_select_gender_with_rooms_tooltip": "لا يمكن استخدام مرشح نوع الغرفة عند تحديد الغرف. يرجى مسح تحديد الغرف أولاً.",
  "cannot_select_building_with_rooms": "لا يمكن تحديد المبنى عند تحديد الغرف",
  "cannot_select_building_with_rooms_tooltip": "لا يمكن استخدام مرشح المبنى عند تحديد الغرف. يرجى مسح تحديد الغرف أولاً.",
  "multi_select_hint": "يمكنك تحديد خيارات متعددة",
  "filter_applied": "تم تطبيق التصفية بنجاح",
  "no_filters_selected": "لم يتم تحديد أي مرشحات. يرجى تحديد خيار تصفية واحد على الأقل.",
  "filters": "المرشحات",
  "location": "الموقع",
  "attributes": "الخصائص",
  "applying": "جارٍ التطبيق...",
  "active_filters": "المرشحات النشطة",
  "viewing_room": "عرض الغرفة",
  "multiple": "متعدد",
  "close": "إغلاق",
  "save_replacement": "حفظ الاستبدال",
  "save_change": "حفظ التغيير",
  "save_check": "حفظ الفحص",
  "failed_to_load_maintenance_history": "فشل تحميل سجل الصيانة",
  "Battery replacement recorded successfully": "تم تسجيل استبدال البطارية بنجاح",
  "Panel change recorded successfully": "تم تسجيل تغيير اللوحة بنجاح",
  "Technician check recorded successfully": "تم تسجيل فحص الفني بنجاح",
  "no_network_data_available": "لا توجد بيانات شبكة متاحة",
  "basic_information": "المعلومات الأساسية",
  "service_providers": "مقدمي الخدمات",
  "settings_alerts": "الإعدادات والتنبيهات",
  "configuration": "التكوين",
  "contact_settings": "جهات الاتصال والإعدادات",
  "notifications": "الإشعارات",
  "alert_language": "لغة التنبيه",
  "select_language": "اختر اللغة",
  "features": "الميزات",
  "chat_ask_buzzz": "اسأل Buzzz",
  "chat_hide": "إخفاء",
  "chat_buzzz_assistant": "مساعد Buzzz",
  "chat_export": "تصدير",
  "chat_clear": "مسح",
  "chat_unpin": "إلغاء التثبيت",
  "chat_pin": "تثبيت",
  "chat_retry": "إعادة المحاولة",
  "chat_copy": "نسخ",
  "chat_copied": "تم النسخ!",
  "chat_share": "مشاركة",
  "chat_suggestions": "اقتراحات",
  "chat_input_placeholder": "اسأل عن إحصائياتك...",
  "chat_stop": "إيقاف",
  "chat_error": "حدث خطأ ما. حاول مرة أخرى.",
  "chat_placeholder": "اسألني عن إحصائيات النظافة...",
  "chat_placeholder_context": "اسأل عن {scope}...",
  "chat_chip_briefing": "إحاطة صباحية",
  "chat_chip_live_status": "الحالة المباشرة",
  "chat_chip_staff_status": "حالة الطاقم",
  "chat_chip_summary": "ملخص",
  "chat_chip_cleaning_priority": "أولوية التنظيف",
  "chat_chip_worst_rooms": "أسوأ الغرف",
  "chat_chip_focus": "مجالات التركيز",
  "chat_chip_compare_periods": "مقارنة الفترات",
  "chat_chip_sla_issues": "مشاكل SLA",
  "chat_chip_shift_stats": "إحصائيات الورديات",
  "chat_chip_complaint_types": "أنواع الشكاوى",
  "chat_chip_busiest_hours": "أوقات الذروة",
  "chat_chip_worst_days": "أسوأ الأيام",
  "chat_chip_improving": "غرف تتحسن",
  "chat_chip_best_rooms": "أفضل الغرف",
  "chat_chip_help": "مساعدة",
  "chat_chip_why_drilldown": "لماذا؟ تعمق أكثر",
  "chat_deep_analysis": "تحليل معمّق (أبطأ)",
  "chat_greeting": "مرحبًا {name}، كيف أقدر أساعدك؟",
  "chat_status_online": "متصل",
  "chat_status_thinking": "يفكر...",
  "chat_tool_overview": "جارٍ سحب النظرة العامة...",
  "chat_tool_rooms": "جارٍ فحص الغرف...",
  "chat_tool_hours": "جارٍ تحليل الساعات...",
  "chat_tool_days": "جارٍ مراجعة البيانات اليومية...",
  "chat_tool_live": "جارٍ فحص الحالة المباشرة...",
  "chat_tool_priority": "جارٍ فحص الأولويات...",
  "chat_tool_room_detail": "جارٍ جلب تفاصيل الغرفة...",
  "chat_tool_shifts": "جارٍ فحص الورديات...",
  "chat_tool_staff": "جارٍ فحص الموظفين...",
  "chat_tool_devices": "جارٍ فحص الأجهزة...",
  "chat_feedback_good": "إجابة جيدة",
  "chat_feedback_bad": "إجابة سيئة",
  "chat_feedback_thanks": "شكراً على ملاحظاتك!",
  "chat_feedback_wrong_data": "بيانات خاطئة",
  "chat_feedback_didnt_understand": "لم يفهم",
  "chat_feedback_missing_info": "معلومات ناقصة",
  "chat_feedback_bad_format": "تنسيق سيء",
  "chat_feedback_hallucinated": "أرقام ملفقة",
  "chat_feedback_submit": "إرسال",
}

export const pl = {
  ...serviks.pl,
  "notified": "Powiadomiono",
  "supervisor_arrival": "Inspekcje",
  "arrival": "Serwis",
  "arrival_badges": "Serwisy w zmianie",
  "callsHistory": "Historia zgłoszeń",
  "openCalls": "Otwarte zgłoszenia",
  "visits_since_cleaned": "Wizyty od ostatniego sprzątania",
  "visits_since_cleaned_short": "Wizyty od sprzątania",
  "filter": "Filtr",
  "logo": "Logo",
  "counter": "Licznik wejść",
  "sms": "SMS",
  "shifts": "Zmiany",
  "call": "Zgłoszenie",
  "duration": "Czas trwania",
  "time_start": "Czas rozpoczęcia",
  "settings": "Ustawienia",
  "always": "Zawsze",
  "off": "Wyłączone",
  "time_based": "Na podstawie czasu",
  "location_based": "Na podstawie lokalizacji",
  "notification_mode": "Tryb powiadomień",
  "notification_times": "Czasy powiadomień",
  "notification_times_info": "Zakresy czasowe są zarządzane z aplikacji mobilnej",
  "notification_location": "Lokalizacja powiadomień",
  "notification_sound": "Dźwięk powiadomienia",
  "no_sound": "Bez dźwięku",
  "default_sound": "Dźwięk domyślny",
  "soft_bell": "Miękki dzwonek",
  "digital_sound": "Dźwięk cyfrowy",
  "mallet_sound": "Dźwięk młotka",
  "phone_sound": "Dźwięk telefonu",
  "text_sound": "Dźwięk tekstu",
  "manager_alert_delay": "Opóźnienie alertu menedżera",
  "snooze_interval": "Przypomnienie",
  "vocal_notifications": "Powiadomienia głosowe",
  "no_delay": "Bez opóźnienia",
  "no_snooze": "Bez przypomnienia",
  "lat": "Szerokość",
  "lon": "Długość",
  "radius": "Promień",
  "no_location_set": "Nie ustawiono lokalizacji",
  "when_to_notify": "Kiedy Powiadamiać",
  "notification_preferences": "Preferencje Powiadomień",
  "assignment_configuration": "Przypisanie i Konfiguracja",
  "status": "Status",
  "working_area": "Obszar pracy",
  "complaints_NC": "Zgłoszenia i NC",
  "SLA_NC": "SLA i NC",
  "arrivals_NC": "Serwisy i NC",
  "staff": "Personel",
  "cleaning_complaints": "Zgłoszenia dotyczące sprzątania",
  "export": "Eksport",
  "maintenance_complaints": "Zgłoszenia dotyczące konserwacji",
  "maintenanceArrivals": "Wykonane konserwacje",
  "maintenance_arrivals": "Wykonane konserwacje",
  "last": "Ostatni",
  "survey_name": "Nazwa badania",
  "survey": "Badanie",
  "pad_survey": "Badanie typu panel",
  "pad_no_maintenance_survey": "Badanie typu panel bez konserwacji",
  "pad_kitchen": "Badanie typu kuchnia",
  "number_of_assigned_devices": "Liczba urządzeń",
  "number_of_pages": "Liczba stron",
  "date_created": "Data utworzenia",
  "updated_by": "Zaktualizowane przez",
  "date_updated": "Data aktualizacji",
  "search": "Szukaj",
  "choose_type": "Wybierz typ",
  "permitted_sites": "Dostępne budynki",
  "permitted_franchise": "Dostępni partnerzy",
  "permitted_companies": "Dostępne firmy",
  "panel_permitted": "Dostępny panel",
  "end_time": "Godzina zakończenia",
  "last_update": "Ostatnia aktualizacja",
  "add_device": "Dodaj urządzenie",
  "detailed": "Szczegóły",
  "analysis": "Analiza",
  "suggestion": "Sugestie",
  "country": "Kraj",
  "management": "Zarządzanie",
  "device": "Urządzenie",
  "mapping": "Mapowanie",
  "please_enter": "Wprowadź",
  "new_device": "Nowe urządzenie",
  "assign_device": "Przypisz urządzenie",
  "installSpot": "Miejsce instalacji",
  "device_type": "Typ urządzenia",
  "deviceCode": "Kod urządzenia",
  "device_code": "Kod urządzenia",
  "scan_or_enter_device_code": "Zeskanuj lub wprowadź kod urządzenia...",
  "scan_device": "Przypisz",
  "scan_qr_in_frame": "Umieść kod QR w ramce. Dla małych kodów trzymaj telefon 15–25 cm dalej i dotknij podglądu, aby ponownie ustawić ostrość, jeśli obraz jest rozmazany.",
  "checking_device_code": "Sprawdzanie kodu urządzenia...",
  "camera_not_available": "Aparat niedostępny. Możesz wpisać kod ręcznie.",
  "device_code_already_exists": "Ten kod urządzenia jest już przypisany do innego czujnika.",
  "assigned_to_company_site_room": "Już przypisany do {company} / {site} / {room}",
  "device_code_lookup_failed": "Nie udało się zweryfikować kodu urządzenia. Spróbuj ponownie.",
  "device_code_no_site_access": "Ten kod jest już zarejestrowany w obiekcie, do którego nie masz dostępu.",
  "device_code_check_unavailable": "Serwer nie mógł sprawdzić kodu. Spróbuj ponownie.",
  "device_code_not_a_code": "Skan odczytał „{code}”. Wpisz sam kod urządzenia.",
  "device_code_open_failed": "Nie udało się otworzyć tego urządzenia. Spróbuj ponownie.",
  "device_code_save_failed": "Nie udało się zapisać kodu urządzenia. Spróbuj ponownie.",
  "device_code_save_forbidden": "Nie możesz zmienić tego urządzenia.",
  "confirm_replace_device_code": "Zastąpić kod urządzenia?",
  "confirm_replace_device_code_body": "Czy na pewno chcesz zastąpić kod {oldCode} kodem {newCode}?",
  "room": "Pomieszczenie",
  "edit_room": "Edytuj pomieszczenie",
  "edit_franchise": "Edytuj partnera",
  "new_franchise": "Nowy partner",
  "desc": "Opis",
  "address": "Adres",
  "level": "Poziom",
  "no_companies_to_show": "Brak firm do wyświetlenia",
  "company_type": "Typ firmy",
  "region": "Region",
  "new_company": "Nowa firma",
  "edit_company": "Edytuj firmę",
  "edit_user": "Edytuj użytkownika",
  "C.arrivals": "Serwis wykonany",
  "C.complaints": "Zgłoszenia dotyczące sprzątania",
  "M.complaints": "Zgłoszenia dotyczące konserwacji",
  "M.Arrivals": "Konserwacja wykonana",
  "analyses": "Analizy",
  "clean_log": "Dziennik serwisów",
  "maintenance_log": "Dziennik konserwacji",
  "like": "Lubię",
  "likes": "Polubienia",
  "new_user": "Nowy użytkownik",
  "shift_parameters": "Parametry zmiany",
  "add_shift": "Dodaj zmianę",
  "edit_shift": "Edytuj zmianę",
  "username": "Nazwa użytkownika",
  "first_name": "Imię",
  "job_function": "Funkcja",
  "role": "Rola",
  "property_manager": "Zarządca nieruchomości",
  "facility_manager": "Kierownik obiektu",
  "site_manager": "Kierownik lokalizacji",
  "workplace_manager": "Kierownik miejsca pracy",
  "cleaning_company_ceo": "Prezes firmy sprzątającej",
  "operations_manager": "Kierownik operacyjny",
  "area_manager": "Kierownik regionu",
  "site_cleaning_manager": "Kierownik sprzątania obiektu",
  "cleaning_supervisor": "Nadzorca sprzątania",
  "other": "Inne",
  "restroom_cleaner": "Sprzątacz toalet",
  "general_cleaner": "Sprzątacz ogólny",
  "day_porter": "Pracownik dzienny",
  "office_cleaner": "Sprzątacz biur",
  "public_area_cleaner": "Sprzątacz części wspólnych",
  "firstName": "Imię",
  "description": "Opis",
  "last_name": "Nazwisko",
  "lastName": "Nazwisko",
  "phone": "Telefon",
  "building_area": "Powierzchnia budynku",
  "users": "Użytkownicy",
  "add_user": "Dodaj użytkownika",
  "sites": "Miejsca",
  "new_site": "Nowy budynek",
  "edit_site": "Edytuj budynek",
  "add_company": "Dodaj firmę",
  "franchise": "Partner",
  "floor": "Piętro",
  "building": "Budynek",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Typ pomieszczenia",
  "display_name": "Wyświetlana nazwa",
  "zone": "Strefa",
  "shift_number": "Numer zmiany",
  "shift": "Zmiana",
  "shift_name": "Zmiana",
  "shift_currently_inactive": "Obecnie nieaktywna zmiana",
  "local_time": "Lokalny",
  "end": "Koniec",
  "min_sla": "Min SLA",
  "max_sla": "Max SLA",
  "days": "Dni",
  "complaints_percent": "% Zgłoszeń",
  "sla_percent": "% SLA",
  "arrivals_percent": "% Serwisów",
  "save_arrivals": "Zapisz serwisy",
  "clean_time": "Czas sprzątania (min)",
  "tooltip_shift_number": "Kolejność wyświetlania zmiany (np. 1, 2).",
  "tooltip_shift_name": "Nazwa zmiany (np. Rano, Noc).",
  "tooltip_start_time": "Godzina rozpoczęcia zmiany (czas lokalny).",
  "tooltip_end_time": "Godzina zakończenia zmiany (czas lokalny).",
  "tooltip_cleaners_number": "Liczba sprzątaczy w tej zmianie.",
  "tooltip_min_sla": "Minimalny czas reakcji (min) na skargę; dolna granica oceny.",
  "tooltip_max_sla": "Maksymalny dopuszczalny czas reakcji (min) na skargę; górna granica oceny.",
  "tooltip_arrivals": "Oczekiwane przyjścia sprzątacza na salę dziennie; ocena porównuje z celem.",
  "tooltip_save_arrivals": "Wizyty sprzątacza na salę dziennie przed BuzzzTV; do obliczania zaoszczędzonego czasu.",
  "tooltip_clean_time": "Minuty na jedną wizytę sprzątacza w obliczeniu zaoszczędzonego czasu (np. 15).",
  "tooltip_complaints_percent": "Waga skarg w ocenie sali przy obecności wizyt.",
  "tooltip_response_time_SLA": "Waga czasu reakcji w ocenie sali przy obecności wizyt.",
  "tooltip_arrivals_percent": "Waga przyjść do celu w ocenie sali przy obecności wizyt.",
  "tooltip_complaints_NC": "Waga skarg w ocenie przy braku wizyt (bez licznika).",
  "tooltip_SLA_NC": "Waga czasu reakcji w ocenie przy braku wizyt.",
  "tooltip_arrivals_NC": "Waga przyjść w ocenie przy braku wizyt.",
  "tooltip_days": "Dni tygodnia, w których zmiana jest aktywna.",
  "tooltip_active_calculation": "Gdy włączone, zmiana wlicza się do ocen i zaoszczędzonego czasu.",
  "auto_close_complaints_hour": "Godzina automatycznego zamykania skarg",
  "tooltip_auto_close_complaints_hour": "Godzina lokalna, o której otwarte SLA skarg w tej zmianie są automatycznie zamykane. Zostaw puste, aby wyłączyć.",
  "auto_close_maintenance_complaints_hour": "Godzina automatycznego zamykania skarg konserwacyjnych",
  "tooltip_auto_close_maintenance_complaints_hour": "Godzina lokalna, o której otwarte SLA skarg konserwacyjnych w tej zmianie są automatycznie zamykane. Zostaw puste, aby wyłączyć.",
  "no_auto_close": "-- Brak --",
  "tooltip_shift_rooms": "Sale przypisane do tej zmiany. Zostaw puste dla zmiany na poziomie lokacji.",
  "company_name": "Nazwa firmy",
  "site_name": "Nazwa miejsca",
  "site_desc": "Opis miejsca",
  "service_provider_name": "Nazwa dostawcy usług",
  "service_provider_type": "Typ dostawcy usług",
  "service_provider_desc": "Opis dostawcy usług",
  "user": "Użytkownik",
  "map": "Mapa",
  "delete": "Usuń",
  "remove": "Usuń",
  "new_room": "Nowe Pomieszczenie",
  "issue_times": "Wystąpienia",
  "solved": "Rozwiązano",
  "visits": "Wizyty",
  "visits_also_went_up": "Wizyty również wzrosły",

  "complaints": "Zgłoszenia",
  "cleaner_arrivals": "Wykonane serwisy",
  "unnecessary_arrivals": "Serwisy bez zgłoszenia",
  "unnecessary_arrivals_hint": "Wizyta sprzątacza, gdy w pomieszczeniu nie było otwartego zgłoszenia.",
  "of_arrivals": "wykonanych serwisów",
  "response_time_SLA": "Czas reakcji",
  "score": "Ocena",
  "avg_score": "Średnia ocena",
  "score_goal": "Planowana ocena",
  "top_problem_issues": "Najczęstsze problemy",
  "top_problem_rooms": "Problematyczne pomieszczenia",
  "top_problem_hours": "Problematyczne godziny",
  "is_time_save": "Oszczędzony czas",
  "est_ROI": "Szacowany ROI",
  "complaints_vs_visits": "Zgłoszenia vs Wizyty",
  "view_by_years": "W latach",
  "view_by_months": "W miesiącach",
  "view_by_weeks": "W tygodniach",
  "view_by_days": "W dniach",
  "minutes": "min",
  "company": "Firma",
  "site": "Budynek",
  "alerts": "Informacje o urządzeniach",
  "performance": "Wydajność",
  "devices": "Urządzenia",
  "total_devices": "Wszystkie urządzenia",
  "working": "Działa",
  "warning": "Ostrzeżenie",
  "by_device_type": "Według typu urządzenia",
  "surveys": "Badania",
  "real_time": "Na żywo",
  "real-time": "Na żywo",
  "cleaner-activity": "Aktywność sprzątaczy",
  "device-actions": "Akcje urządzenia",
  "pad-presence-testing": "Test obecności przy padzie",
  "real-time-cleaning": "Na żywo - sprzątanie",
  "real-time-maintenance": "Na żywo - konserwacja",
  "no_real_time_tabs_permitted": "Nie masz uprawnień do żadnej karty widoku na żywo",
  "admin": "Admin",
  "all": "Wszystko",
  "overview": "Przegląd",
  "total": "Razem",
  "analytics": "Analiza",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Komunikacja",
  "overview_complaints_devices_caption": "Zainstalowane urządzenia (łącznie)",
  "overview_complaints_devices_caption_hint": "Łączna liczba urządzeń zainstalowanych w lokalizacji do końca każdego miesiąca, według dat instalacji.",
  "overview_complaints_devices_toggle_aria": "Pokaż lub ukryj zainstalowane urządzenia pod wykresem skarg",
  "communication_select_site_title": "Wybierz lokalizację",
  "communication_select_site": "Wybierz firmę i lokalizację w filtrach powyżej, aby przeglądać i dodawać notatki dla tej lokalizacji.",
  "communication_viewing_site": "Podgląd",
  "communication_add_note": "Dodaj notatkę",
  "communication_add_note_open_aria": "Otwórz okno dodawania notatki",
  "communication_form_hint": "Udostępniaj aktualizacje lub notatki wszystkim z dostępem do tej lokalizacji. Będą widzieć nowe notatki na żywo.",
  "communication_page_intro_title": "Notatki lokalizacji — wspólny dziennik",
  "communication_page_intro_body": "Zostawiaj tu przekazania zmiany, problemy, aktualizacje i notatki ze spotkań. Każdy z dostępem do tej lokalizacji w portalu może czytać i dodawać notatki.",
  "communication_page_intro_dismiss": "Ukryj wskazówkę",
  "communication_page_intro_aria": "O notatkach lokalizacji",
  "communication_content_placeholder": "Wpisz notatkę tutaj...",
  "communication_keyboard_hint": "Ctrl+Enter, aby opublikować",
  "communication_submitting": "Publikowanie...",
  "communication_submit": "Opublikuj notatkę",
  "communication_recent_notes": "Notatki",
  "communication_search_placeholder": "Szukaj po autorze lub tekście...",
  "communication_refresh": "Odśwież",
  "communication_clear_filters": "Wyczyść filtry",
  "communication_search_aria_label": "Szukaj w notatkach",
  "communication_submit_aria_label": "Opublikuj notatkę",
  "communication_copy_note_aria_label": "Skopiuj tekst notatki",
  "communication_copied": "Skopiowano do schowka.",
  "communication_copy_empty": "Ta notatka nie zawiera tekstu do skopiowania.",
  "communication_filter_hidden_one": "(1 notatka ukryta przez filtry)",
  "communication_filter_hidden_many": "({n} notatek ukrytych przez filtry)",
  "communication_request_timeout": "Przekroczono limit czasu żądania. Spróbuj ponownie.",
  "communication_load_failed": "Nie udało się załadować notatek.",
  "communication_retry": "Spróbuj ponownie",
  "communication_no_matches": "Brak notatek pasujących do wyszukiwania lub filtrów. Spróbuj je zmienić.",
  "communication_no_entries": "Brak notatek.",
  "communication_no_entries_hint": "Dodaj notatkę powyżej, aby rozpocząć.",
  "communication_just_now": "Właśnie teraz",
  "communication_minutes_ago": "{n} min temu",
  "communication_hours_ago": "{n} godz. temu",
  "communication_days_ago": "{n} dni temu",
  "communication_note_posted": "Notatka opublikowana.",
  "communication_post_failed": "Nie udało się opublikować notatki. Spróbuj ponownie.",
  "communication_note_type": "Typ notatki",
  "communication_type_general": "Ogólna",
  "communication_type_update": "Aktualizacja",
  "communication_type_issue": "Problem",
  "communication_type_follow_up": "Kontynuacja",
  "communication_type_meeting": "Notatka ze spotkania",
  "communication_filter_all_types": "Wszystkie typy",
  "communication_pinned": "Przypięta",
  "communication_pin": "Przypnij",
  "communication_unpin": "Odepnij",
  "communication_pin_limit": "Maks. 2 przypięte",
  "communication_pinned_toast": "Notatka przypięta.",
  "communication_unpinned_toast": "Notatka odpięta.",
  "communication_pin_failed": "Nie udało się zaktualizować przypięcia. Spróbuj ponownie.",
  "communication_note_not_found": "Nie znaleziono notatki lub brak dostępu.",
  "communication_site_not_in_filters": "Strona tej notatki nie jest w bieżących filtrach. Być może nie masz dostępu do tej lokalizacji.",
  "communication_edit": "Edytuj",
  "communication_delete": "Usuń",
  "communication_save": "Zapisz",
  "communication_cancel": "Anuluj",
  "communication_saving": "Zapisywanie...",
  "communication_note_updated": "Notatka zaktualizowana.",
  "communication_update_failed": "Nie udało się zaktualizować notatki. Spróbuj ponownie.",
  "communication_delete_confirm": "Czy na pewno chcesz usunąć tę notatkę? Tej operacji nie można cofnąć.",
  "communication_delete_confirm_title": "Usuń notatkę",
  "communication_note_preview": "Podgląd notatki:",
  "communication_note_deleted": "Notatka usunięta.",
  "communication_delete_failed": "Nie udało się usunąć notatki. Spróbuj ponownie.",
  "communication_edited": "Edytowano",
  "communication_show_more": "Pokaż więcej",
  "communication_show_less": "Pokaż mniej",
  "communication_sort_date_newest": "Najpierw najnowsze",
  "communication_sort_date_oldest": "Najpierw najstarsze",
  "communication_sort_author": "Według autora",
  "communication_sort_type": "Według typu",
  "communication_sort_pinned": "Najpierw przypięte",
  "communication_sort_label": "Sortuj",
  "communication_filter_by_type": "Typ",
  "communication_filters_group_aria": "Filtruj i sortuj notatki",
  "communication_search_label_short": "Szukaj",
  "employees": "Pracownicy",
  "last_time_of_arrival": "Ostatni serwis",
  "arrival_and_status": "Serwis i status",
  "preview_arrivals": "Przegląd serwisów",
  "men toilet": "Toaleta męska",
  "women toilet": "Toaleta damska",
  "shared toilet": "Toaleta wspólna",
  "unisex restroom": "Toaleta uniseks",
  "handicapped toilet": "Toaleta dla niepełnosprawnych",
  "logistics": "Logistyka",
  "cubicle": "Kabina",
  "gym": "Siłownia",
  "metrics": "Metryki",
  "select_three_metrics": "Wybierz maksymalnie 3 metryki do porównania",
  "select_four_metrics": "Wybierz maksymalnie 4 metryki do porównania",
  "legend": "Legenda",
  "more_details": "Więcej Szczegółów",
  "performance_overview": "Przegląd wydajności",
  "loading_chart": "Ładowanie wykresu",
  "retry": "Spróbuj ponownie",
  "performance_trending_upward": "Wydajność rośnie",
  "high_complaint_ratio": "Wysoki współczynnik skarg",
  "click_bars_for_details": "Kliknij słupki, aby zobaczyć dzienną analizę",
  "refresh": "Odśwież",
  "table": "Tabela",
  "cards": "Karty",
  "no_recent_arrivals": "Brak ostatnich serwisów",
  "feedback_charts": "Wykresy opinii",
  "general_overview": "Ogólny przegląd",
  "cleaning_complaints_breakdown": "Podział skarg na sprzątanie",
  "maintenance_complaints_breakdown": "Podział skarg na konserwację",
  "refresh_failed": "Odświeżenie nie powiodło się",
  "data_exported_successfully": "Dane zostały pomyślnie wyeksportowane",
  "data_export_failed": "Eksport danych nie powiódł się",
  "drill_down_unavailable": "Drążenie dostępne tylko w widoku dziennym",
  "sort_by": "Sortuj według",
  monthMap: {
    1: 'Styczeń',
    2: 'Luty',
    3: 'Marzec',
    4: 'Kwiecień',
    5: 'Maj',
    6: 'Czerwiec',
    7: 'Lipiec',
    8: 'Sierpień',
    9: 'Wrzesień',
    10: 'Październik',
    11: 'Listopad',
    12: 'Grudzień',
  },
  weekMap: {
    1: 'Niedziela',
    2: 'Poniedziałek',
    3: 'Wtorek',
    4: 'Środa',
    5: 'Czwartek',
    6: 'Piątek',
    7: 'Sobota',
  },
  "dayOfWeek": "Dzień tygodnia",
  "service_log": "Dziennik działań",
  "rooms": "Pomieszczenia",
  "bulk_add_rooms": "Dodaj pomieszczenia zbiorczo",
  "add_rooms": "Dodaj pomieszczenia",
  "room_names_one_per_line": "Nazwy pomieszczeń (jedna na linię)",
  "enter_at_least_one_room": "Wpisz co najmniej jedną nazwę pomieszczenia",
  "room_names_placeholder": "Pomieszczenie 1\nPomieszczenie 2\nToalety damskie",
  "rooms_with_prefix": "pomieszczeń z prefiksem",
  "apply_to_all_rooms": "Zastosuj do wszystkich pomieszczeń (opcjonalnie)",
  "bulk_rooms_intro": "Dodaj jedną lub więcej grup. Każda grupa ma własny budynek, piętro, strefę, typ i nazwy pomieszczeń.",
  "group": "Grupa",
  "add_group": "+ Dodaj kolejną grupę",
  "adding_rooms": "Dodawanie pomieszczeń...",
  "bulk_summary": "Podsumowanie",
  "in": "w",
  "bulk_rooms_success": "Pomyślnie dodano {n} pomieszczeń",
  "displayName": "Nazwa wyświetlana",
  "SLA": "SLA",
  "supervisors": "Inspekcje",
  "supervisor": "Koordynator",
  "performance_analytics": "Analizy wydajności",
  "arrivals": "Serwisy",
  "inspections": "Inspekcje",
  "avgResponseTime": "Średni czas reakcji",
  "missedSla": "Nie dotrzymano SLA",
  "cleaner_arrived": "Serwis wykonany",
  "load_more": "Pokaż więcej",
  "login": "Zaloguj",
  "email": "Email",
  "emails": "Emaile",
  "password": "Hasło",
  "min": "min",
  "Logout": "Wyloguj",
  "time_range": "Zakres czasu",
  "select_time_range": "Wybierz zakres czasu",
  "custom_time": "Wybierz",
  "last_day": "Wczoraj",
  "last_week": "Ostatnie 7 dni",
  "last_month": "Ostatnie 30 dni",
  "last_quarter": "Ostatnie 90 dni",
  "last_6_months": "Ostatnich 6 miesięcy",
  "last_year": "Ostatnie 365 dni",
  "data_by_hour": "Godzinowo",
  "general": "Ogólne",
  "cleaning": "Sprzątanie",
  "maintenance": "Konserwacja",
  "start": "Zgłoszono",
  "start_time": "Godzina rozpoczęcia",
  "management_co": "Firma zarządzająca",
  "cleaning_co": "Firma sprzątająca",
  "companies": "Firmy",
  "name": "Nazwa",
  "site_count": "Numer budynku",
  "associated_companies": "Powiązane firmy",
  "OK": "OK",
  "cancel": "Anuluj",
  "client": "Klient",
  "dates": "Daty",
  "shift": "Zmiana",
  "issue": "Problem",
  "time": "Czas",
  "top complaint of the week": "Najczęstsze zgłoszenie w bieżącym tygodniu",
  "top room of the week": "Problematyczne pomieszczenie w bieżącym tygodniu",
  "top hour of the week": "Problematyczna godzina w bieżącym tygodniu",
  "top complaint of the month": "Najczęstsze zgłoszenie w bieżącym miesiącu",
  "top room of the month": "Problematyczne pomieszczenie w bieżącym miesiącu",
  "top hour of the month": "Problematyczna godzina w bieżącym miesiącu",
  "franchises": "Partnerzy",
  "add_franchise": "Dodaj partnera",
  "room_names": "Nazwy pomieszczeń",
  "type": "Typ",
  "please_select_company_site": "Proszę wybrać firmę/budynek",
  "number": "Numer",
  "create_building_map": "Utwórz mapę budynku",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Hej, najszybciej dodasz piętra i pomieszczenia do budynku za pomocą tego prostego kreatora",
  "avg number of toilets per floor": "Średnia liczba toalet na piętro",
  "avg.number of toilet cells per room": "Średnia liczba kabin w toalecie",
  "number of floors": "Liczba pięter",
  "avg.number of disabled toilets": "Średnia liczba toalet dla niepełnosprawnych",
  "avg.number of soap dispensers": "Średnia liczba dozowników mydła",
  "reset_filter": "Wyczyść filtr",
  "add": "Dodaj",
  "new_survey": "Nowe badanie",
  "api_configuration": "Konfiguracja API",
  "please_edit_the_api_information": "Proszę wprowadzić informacje API",
  "method": "Metoda",
  "authorization": "Autoryzacja",
  "api_url": "API URL",
  "token": "Token",
  "api_request_info": "Informacje o żądaniu API",
  "roomName": "Pomieszczenie",
  "servikName": "Nazwa usługi",
  "siteName": "Nazwa budynku",
  "stage": "Etap",
  "number_of_buttons": "Liczba przycisków",
  "button_shape": "Kształt przycisku",
  "delay_time_stage": "Czas opóźnienia etapu",
  "go_to_stage": "Przejdź do etapu",
  "color": "Kolor",
  "add_stage": "Dodaj etap",
  "save": "Zapisz",
  "number_of_issues": "Liczba problemów",
  "online": "online",
  "offline": "offline",
  "offline_devices": "Urządzenia Offline",
  "no_offline_devices": "Nie znaleziono urządzeń offline",
  "working_devices": "Działające Urządzenia",
  "no_working_devices": "Nie znaleziono działających urządzeń",
  "room_name": "Pomieszczenie",
  "installation_spot": "Miejsce instalacji",
  "device_id": "ID urządzenia",
  "date": "Data",
  "status": "Status",
  "device_status": "Status urządzenia",
  "none": "Brak",
  "no_surveys_created": "Nie utworzono żadnych badań",
  "dashboard": "Kokpit",
  "franchise_name": "Nazwa partnera",
  "franchise_country": "Kraj partnera",
  "choose_franchise": "Wybierz partnera",
  "choose_country": "Wybierz kraj",
  "select_template": "Wybierz szablon",
  "default_survey": "Domyślne badanie",
  "cleaning_survey": "Badanie sprzątania",
  "kitchen_survey": "Badanie kuchni",
  "template": "Szablon",
  "area_name": "Nazwa obszaru",
  "rooms_names": "Nazwy pokoi",
  "rooms_number": "Numery pokoi",
  "assign_number": "Przypisz numer",
  "active_notification_task": "Aktywne powiadomienie",
  "amount_limit": "Limit",
  "after_max": "Licznik po Max",
  "new_area": "Nowy obszar",
  "edit_area": "Edytuj obszar",
  "tablet": "Tablet",
  "counter women": "Licznik wejść / damska",
  "counter men": "Licznik wejść / męska",
  "counter handicap": "Licznik wejść / niepełnosprawni",
  "counter man/woman": "Licznik wejsć męska/damska",
  "counter man / woman": "Licznik wejść męska / damska",
  "sensor liquid": "Sensor poziomu płynu",
  "double toilet paper": "Podwójna rolka papieru toaletowego",
  "toilet paper": "Rolka papieru toaletowego",
  "tag": "Kod",
  "qr tag": "Kod QR",
  "additional_info": "Dodatkowe informacje",
  "servikCategory": "Kategoria Servik",
  "dishwashing": "Zmywanie naczyń",
  "cafeteria": "Bistro",
  "clean room": "Pomieszczenie gospodarcze",
  "office": "Biuro",
  "meeting room": "Pokój konferencyjny",
  "cubic": "Kubik",
  "women": "Kobiety",
  "men": "Mężczyźni",
  "handicap": "Niepełnosprawni",
  "Combined": "Wspólne",
  "kitchen": "Kuchnia",
  "east": "Wschód",
  "west": "Zachód",
  "north": "Północ",
  "south": "Południe",
  "right": "Prawo",
  "left": "Lewo",
  "center": "Środek",
  "up": "Góra",
  "down": "Dół",
  "combined": "Połączone",
  "lobby": "Lobby",
  "entrance": "Wejście",
  "reception": "Recepcja",
  "area": "Obszar",
  "mezzanine": "Antresola",
  "gallery": "Galeria",
  "ground": "Podłoga",
  "elevator": "Winda",
  "is_calculated": "Uwzględniaj w statystykach",
  "calculated_room": "Uwzględnione pomieszczenie",
  "splitted_survey": "Podzielone badanie",
  "redirect_to_url": "Przekieruj do URL",
  "survey_site": "Badanie-budynk",
  "clicks": "Kliknięcia",
  "add_stage_number_to_signal": "Przypisz numer etapu",
  "including_pad9": "W tym Pad9",
  "room_type_required": "Wybierz typ pomieszczenia dla każdej grupy",
  "Tech Manufacturers": "Producenci technologii",
  "Tech Offices": "Biura technologiczne",
  "Offices": "Biura",
  "Terminal": "Terminal",
  "Universities": "Uniwersytety",
  "Factories": "Fabryki",
  "Hospital": "Szpital",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Sklepy convenience",
  "Food Chains": "Sieci gastronomiczne",
  "Residential": "Mieszkalny",
  "Shopping Center": "Centrum handlowe",
  "Survey": "Ankieta",
  "Demo": "Demo",
  "Vision": "Vision",
  "Court": "Sąd",
  "Office Management": "Zarządzanie biurami",
  "Government Office": "Urząd",
  "default_name": "Domyślna nazwa",
  "exposures": "Doświadczone czyste toalety",
  "exposures_tab": "Aktywność pokoju",
  "expose_results": "Wyniki",
  "events_expose": "Wydarzenia",
  "expose_score": "Stawka",
  "shift_events_expose": "Wydarzenia w trakcie zmiany",
  "type_of_site": "Typ budynku",
  "morning_shift": "Zmiana poranna",
  "afternoon_shift": "Zmiana popołudniowa",
  "night_shift": "Zmiana nocna",
  "update": "Aktualizuj",
  "restart": "Zrestartuj",
  "send_data": "Wysyłaj dane",
  "send_count": "Wysyłaj odczyty licznika wejść",
  "blink": "Miganie LED",
  "beacon": "Beacon",
  "like_btn": "Przycisk polubienia",
  "requires_like_btn": "Wymaga włączonego przycisku polubienia",
  "maintenance_btn": "Przycisk konserwacji",
  "battery": "Bateria",
  "version": "Wersja",
  "actions": "Ustawienia",
  "device_actions": "Akcje urządzenia",
  "device_settings": "Ustawienia urządzenia",
  "drains_battery": "Rozładowuje baterię",
  "latest_errors": "Ostatnie błędy",
  "no_errors": "Brak błędów",
  "offline_calls": "połączenia offline",
  "offline_duration_calls": "czas trwania offline",
  "counterCalls": "Wezwania licznikiem",
  "active": "Aktywny",
  "no_active_supervisors": "Brak aktywnych supervisorów",
  "active_supervisors_column": "Aktywni supervisorzy",
  "supervisors_active_label": "supervisorzy aktywni teraz",
  "active_supervisors_coverage_hint": "Aktywni supervisorzy włączyli ten obszar w aplikacji. Nie oznacza to obecności online ani fizycznej.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Uwzględniaj w statystykach",
  "pad": "pad",
  "pad_counter": "Licznik wejść",
  "counter_status": "Status licznika wejść",
  "choose_state": "Wybierz województwo",
  "choose_city": "Wybierz miasto",
  "city": "Miasto",
  "state": "Województwo",
  "start_hour": "Godzina rozpoczęcia",
  "end_hour": "Godzina zakończenia",
  "analytics_log": "Analityka",
  "or": "lub",
  "no_data_available": "Brak danych",
  "filter_by_cleaner": "Filtruj według sprzątającego",
  "all_cleaners": "Wszyscy sprzątający",
  "failed_to_load_data": "Nie udało się załadować danych",
  "not_available": "N/A",
  "new_task": "Nowe zadanie",
  "temporarily_unavailable": "Tymczasowo niedostępne",
  "category": "Kategoria",
  "title": "Tytuł",
  "task_type": "Typ zadania",
  "task_languages": "Języki zadania",
  "task_languages_hint": "Wybierz języki dla tego zadania. Wprowadzisz tytuł w każdym wybranym języku.",
  "task_category": "Kategoria zadania",
  "call_to_action": "Działanie",
  "schedule": "Harmonogram",
  "insert_text": "Wstaw tekst",
  "select": "Wybierz",
  "select_all": "Wybierz wszystkie",
  "n_selected": "Wybrano: {count}",
  "clear_selection": "Wyczyść zaznaczenie",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Harmonogram",
  "language": "Język",
  "calendar": "Kalendarz",
  "operation": "Operacja",
  "daily": "Codziennie",
  "weekly": "Tygodniowo",
  "monthly": "Miesięcznie",
  "quarterly": "Kwartalnie",
  "yearly": "Rocznie",
  "sunday": "Niedziela",
  "monday": "Poniedziałek",
  "tuesday": "Wtorek",
  "wednesday": "Środa",
  "thursday": "Czwartek",
  "friday": "Piątek",
  "saturday": "Sobota",
  "january": "Styczeń",
  "february": "Luty",
  "march": "Marzec",
  "april": "Kwiecień",
  "may": "Maj",
  "june": "Czerwiec",
  "july": "Lipiec",
  "august": "Sierpień",
  "september": "Wrzesień",
  "october": "Październik",
  "november": "Listopad",
  "december": "Grudzień",
  "1st week": "Pierwszy tydzień",
  "2nd week": "Drugi tydzień",
  "3rd week": "Trzeci tydzień",
  "4th week": "Czwarty tydzień",
  "5th week": "Piąty tydzień",
  "1st quarter": "Pierwszy kwartał",
  "2nd quarter": "Drugi kwartał",
  "3rd quarter": "Trzeci kwartał",
  "4th quarter": "Czwarty kwartał",
  "edit_task": "Edytuj zadanie",
  "created_at": "Utworzono",
  "installed_at": "Data instalacji",
  "hour": "Godzina",
  "week_days": "Dni tygodnia",
  "month_weeks": "Tygodnie miesiąca",
  "month_days": "Dni miesiąca",
  "no_tasks_found": "Nie znaleziono zadań",
  "invalid_language": "Nieprawidłowy język",
  "no_active_tasks_found": "Nie znaleziono aktywnych zadań",
  "edit": "Edytuj",
  "send_date": "Wyślij datę",
  "invalid_date": "Nieprawidłowa data",
  "cells_num": "Liczba kabin",
  "sinks_num": "Liczba zlewów",
  "urinals_num": "Liczba pisuarów",
  "toilet_paper_size": "Rozmiar papieru toaletowego",
  "email_configuration": "Konfiguracja e-mail",
  "please_edit_the_email_information": "Proszę wprowadzić e-mail",
  "email_sender_info": "Nadawca",
  "email_subject_info": "Temat wiadomości",
  "email_message_info": "Wiadomość",
  "companyName": "Nazwa firmy",
  "email_language": "Język e-mail",
  "complaint_language": "Język zgłoszeń",
  "email_message_format": "Format wiadomości e-mail",
  "line": "Linia",
  "list": "Lista",
  "roomType": "Typ pomieszczenia",
  "By logging in, you agree to Buzzztech's": "Logując się akceptujesz regulamin korzystania z usługi Buzzztech",
  "Terms and Conditions": "Regulamin",
  "and": "i",
  "Privacy Policy": "Polityka prywatności",
  "All actions within this panel are recorded for quality control and improvement": "Wszystkie działania w tym panelu są zapisywane w celu kontroli jakości i ciągłego udoskonalania usługi",
  "You must agree to the terms and conditions": "Zaakceptuj regulamin korzystania",
  "months": "Miesiące",
  "ref_id": "ID referencyjne",
  "room_name_en": "Nazwa pomieszczenia (EN)",
  "site_state": "Państwo",
  "site_city": "Miasto",
  "site_country": "Kraj",
  "first_date": "Data początkowa",
  "pinned": "Przypięty",
  "no.": "Nr",
  "must_be_numbers": "Musi być liczbą",
  "must_be_3_digits": "Minimum 3 cyfry",
  "must_have_english_title": "Musi mieć angielski tytuł",
  "total_sites": "Liczba budynków",
  "site_information": "Informacje o budynku",
  "holiday_offdays": "Święta i dni wolne",
  "add_offday": "Dodaj dzień wolny",
  "add_holiday": "Dodaj święto",
  "name_under_chars": "nazwa poniżej 25 znaków",
  "days_comma_separated": "dni, oddzielone przecinkiem",
  "year": "rok",
  "month": "miesiąc",
  "day": "dzień",
  "holiday_name": "nazwa święta",
  "offday_name": "nazwa dnia wolnego",
  "delete_confirmation_title": "Czy jesteś pewien?",
  "delete_confirmation_message": "Tej akcji nie można cofnąć.",
  "are_you_sure": "Czy jesteś pewien?",
  "israel": "Izrael",
  "USA": "USA",
  "poland": "Polska",
  "mexico": "Meksyk",
  "cyprus": "Cypr",
  "brazil": "Brazylia",
  "romania": "Rumunia",
  "netherlands": "Holandia",
  "tablet_survey": "Badanie z tabletem",
  "no_shift_survey": "Brak zmiany badania",
  "number_of_rows": "Liczba wierszy",
  "rating_shape": "Kształt oceny",
  "content_survey": "Zawartość badania",
  "rating_survey": "Ocena badania",
  "device-alerts": "Problem",
  "device-active": "Aktywny",
  "device-search": "Szukaj",
  "mac_id": "Adres MAC",
  "qr_tag": "Kod QR",
  "sensor": "Czujnik",
  "image_survey": "Badanie obrazu",
  "open_text": "Otwarty tekst",
  "open_text_survey": "Badanie tekstu",
  "embedded_link": "Osadzony link",
  "device-counter": "Licznik wejść",
  "count": "Liczba",
  "last_date": "Ostatnia data",
  "last_arrival":"Ostatni serwis",
  "cleaners": "Zespół serwisowy",
  "viewer": "Widz",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "Nie znaleziono użytkowników",
  "cleaner_activity": "Aktywność sprzątaczy",
  "pad_presence_testing": "Test obecności przy padzie",
  "pad_presence_testing_subtitle": "Wejścia, wyjścia i offline naciśnięcia pada przesłane z telefonu dla wybranej lokalizacji",
  "pad_presence_timeline": "Oś czasu na żywo",
  "pad_presence_sessions": "Sesje obecności",
  "pad_presence_offline_presses": "Naciśnięcia offline z telefonów",
  "pad_presence_select_site_hint": "Wybierz firmę i lokalizację w nagłówku, aby obserwować zdarzenia obecności.",
  "pad_presence_no_events": "Brak zdarzeń obecności w tym okresie.",
  "pad_presence_open": "Otwarte",
  "pad_presence_exit_phone": "Wyjście z telefonu",
  "pad_presence_exit_auto": "Wyjście automatyczne",
  "pad_presence_exit_stale": "Przeterminowane wyjście",
  "pad_presence_enter": "Wejście",
  "pad_presence_exit": "Wyjście",
  "pad_presence_offline": "Naciśnięcie offline",
  "pad_presence_faulty": "Błędne",
  "pad_presence_employee": "Pracownik",
  "pad_presence_room": "Pomieszczenie",
  "pad_presence_time_from": "Od",
  "pad_presence_last_updated": "Zaktualizowano",
  "pad_presence_duration": "Czas trwania",
  "pad_presence_exit_type": "Typ wyjścia",
  "pad_presence_button": "Przycisk",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Licznik",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Wszyscy pracownicy",
  "pad_presence_all_rooms": "Wszystkie pomieszczenia",
  "pad_presence_load_error": "Nie udało się wczytać danych obecności przy padzie.",
  "pad_presence_in_room_now": "Teraz w pomieszczeniu",
  "pad_presence_in_room": "w",
  "pad_presence_since": "od",
  "pad_presence_just_now": "Przed chwilą",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefon",
  "pad_presence_all_phones": "Wszystkie telefony",
  "pad_presence_window": "Pokaż",
  "pad_presence_window_hour": "Ostatnia godzina",
  "pad_presence_window_today": "Dzisiaj",
  "pad_presence_window_month": "Ostatni miesiąc",
  "pad_presence_pads": "Pady w tej lokalizacji",
  "pad_presence_no_pads": "W tej lokalizacji pady nie są przypisane do pomieszczeń.",
  "pad_presence_last_enter": "Ostatnie wejście",
  "pad_presence_last_offline": "Ostatnie naciśnięcie offline",
  "pad_presence_auto_exit_leave": "Wyjdź teraz → auto-wyjście za",
  "pad_presence_auto_exit_earliest": "Najwcześniej od wejścia:",
  "pad_presence_auto_exit_passed": "Minął najwcześniejszy czas auto-wyjścia. Nadal otwarte = pad jest nadal słyszany albo wyjdź i poczekaj 5m 45s.",
  "cleaner_activity_live_footer": "Dane są aktualizowane w czasie rzeczywistym",
  "ca_empty_select_site_hint": "Wybierz firmę i lokalizację w nagłówku, aby zobaczyć aktywność sprzątaczy na dziś.",
  "ca_empty_no_cleaners_hint": "Brak sprzątaczy przypisanych do tej lokalizacji i bieżącej zmiany. Przypisz aktywne lokalizacje i zmiany w Użytkownikach.",
  "ca_empty_access_denied": "Odmowa dostępu",
  "ca_empty_access_denied_hint": "Nie masz uprawnień do przeglądania aktywności sprzątaczy dla tej lokalizacji.",
  "ca_empty_load_error_hint": "Nie udało się załadować aktywności. Spróbuj ponownie lub skontaktuj się z pomocą techniczną, jeśli problem się utrzymuje.",
  "ca_empty_no_filter_match": "Brak sprzątaczy pasujących do tych filtrów",
  "ca_empty_no_filter_match_hint": "Wyczyść filtry lub wybierz innego sprzątacza, obszar roboczy lub pomieszczenie.",
  "ca_timeline_all_cleaners": "Dzisiejsza aktywność — wszyscy sprzątacze",
  "ca_legend_work": "Aktywny",
  "ca_clock_sessions_more": "więcej",
  "ca_clock_sessions_less": "Pokaż mniej",
  "ca_sort_label": "Sortuj",
  "ca_sort_needs_attention": "Wymaga uwagi",
  "ca_sort_best_avg_response": "Najlepszy średni czas reakcji",
  "ca_sort_worst_avg_response": "Najgorszy średni czas reakcji",
  "ca_sort_most_sla_breaches": "Najwięcej naruszeń SLA",
  "ca_sort_most_open_complaints": "Najwięcej otwartych zgłoszeń",
  "ca_sort_most_work_time": "Najwięcej czasu pracy",
  "ca_sort_least_work_time": "Najmniej czasu pracy",
  "ca_stat_avg_short": "śr.",
  "ca_stat_open_short": "otw.",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "praca",
  "ca_assigned_room_avg_hint": "Średni czas reakcji dla przypisanych pomieszczeń dziś",
  "ca_transit_tooltip": "Czas przejścia między zadaniami",
  "ca_transit_live_tooltip": "Czas od zamknięcia ostatniego zadania",
  "ca_legend_visits": "Wizyty między zgłoszeniami",
  "ca_visits_between_sla": "Wizyty od zamknięcia poprzedniego zgłoszenia",
  "ca_apply": "Zastosuj",
  "ca_visits_since": "od",
  "ca_deferred_tip_title": "Odroczone zgłoszenie",
  "ca_deferred_tip_resolved": "Rozwiązane",
  "ca_deferred_tip_desc_open": "Wciąż otwarte — sprzątacz najpierw obsłużył inne pomieszczenia zamiast tego.",
  "ca_deferred_tip_desc_closed": "To zgłoszenie pozostało otwarte, gdy sprzątacz najpierw obsłużył inne pomieszczenia.",
  "ca_deferred_tip_rooms_label": "Obsłużone najpierw:",
  "ca_attention_title": "Wymaga uwagi",
  "ca_attention_empty": "Wszystko w porządku — brak problemów",
  "ca_attention_sla_breach_one": "{name} · naruszenie SLA",
  "ca_attention_sla_breach_many": "{name} · {count} naruszeń SLA",
  "ca_attention_open_while_out_one": "{name} · otwarte zgłoszenie po wyjściu",
  "ca_attention_open_while_out_many": "{name} · {count} otwartych po wyjściu",
  "ca_attention_idle": "{name} · bezczynny {duration}",
  "ca_attention_late": "{name} · spóźnione wejście",
  "ca_attention_show": "Pokaż",
  "ca_attention_hide": "Ukryj",
  "ca_view_shift": "Zmiana",
  "ca_view_history": "Historia",
  "ca_filters_done": "Gotowe",
  "ca_hist_preset_this_month": "Ten miesiąc",
  "ca_hist_preset_last_month": "Poprzedni miesiąc",
  "ca_hist_preset_this_week": "Ten tydzień",
  "ca_hist_preset_last_week": "Poprzedni tydzień",
  "ca_hist_preset_custom": "Własny",
  "ca_hist_from": "Od",
  "ca_hist_to": "Do",
  "ca_hist_range_invalid": "Data początkowa musi być wcześniejsza niż końcowa",
  "ca_hist_range_too_long": "Zakres może obejmować maksymalnie {max} dni",
  "ca_hist_search": "Szukaj po imieniu lub telefonie",
  "ca_hist_people_count": "{count} pracowników",
  "ca_hist_kpi_days": "Dni przepracowane",
  "ca_hist_kpi_net": "Godziny netto",
  "ca_hist_kpi_breaks": "Przerwy",
  "ca_hist_col_person": "Pracownik",
  "ca_hist_col_total": "Godziny łącznie",
  "ca_hist_col_total_tip": "Od wejścia do wyjścia przed przerwami — ta sama wartość, którą pracownik widzi w aplikacji",
  "ca_hist_col_net": "Godziny netto",
  "ca_hist_col_breaks": "Przerwy",
  "ca_hist_col_issues": "Uwagi",
  "ca_hist_col_late": "Spóźnienie",
  "ca_hist_col_missed": "Nieobecność",
  "ca_hist_col_no_clock_out": "Brak wyjścia",
  "ca_hist_clocked_in_now": "Obecnie zalogowany",
  "ca_hist_not_assigned": "Nieprzypisany do tego obiektu",
  "ca_hist_no_shift": "Brak przypisanej zmiany",
  "ca_hist_unknown_name": "Nieznany",
  "ca_hist_empty": "Brak obecności w tym okresie",
  "ca_hist_empty_hint": "Nikt nie zarejestrował wejścia w tym obiekcie i nie ma przypisanych pracowników.",
  "ca_hist_no_match": "Żaden pracownik nie pasuje do filtrów",
  "ca_hist_load_error_hint": "Nie udało się wczytać historii obecności. Spróbuj ponownie za chwilę.",
  "ca_hist_prev_person": "Poprzedni pracownik",
  "ca_hist_next_person": "Następny pracownik",
  "ca_hist_close": "Zamknij",
  "ca_hist_legend_worked": "Pracował",
  "ca_hist_legend_late": "Spóźnienie",
  "ca_hist_legend_missed": "Nieobecność",
  "ca_hist_legend_no_clock_out": "Brak wyjścia",
  "ca_hist_late_by": "Spóźnienie {duration}",
  "ca_hist_late_tip": "Wejście o {time}, {shift} zaczyna się o {start}",
  "ca_hist_missed": "Nieobecność",
  "ca_hist_missed_tip": "Zaplanowana zmiana zakończyła się bez rejestracji wejścia",
  "ca_hist_no_clock_out": "Brak wyjścia",
  "ca_hist_no_clock_out_tip": "Sesja nigdy nie została zamknięta; jej godziny nie są liczone",
  "ca_hist_in_progress": "Nadal zalogowany",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "otwarta",
  "ca_hist_day_col_gross": "Godziny łącznie",
  "ca_hist_day_col_breaks": "Przerwy",
  "active_cleaners": "Aktywni sprzątacze",
  "closed_complaints": "Zamknięte skargi",
  "total_work_time": "Całkowity czas pracy",
  "total_work_time_net": "Całkowity czas pracy (dziś netto)",
  "total_break_time": "Całkowity czas przerw",
  "avg_response_time": "Śr. rozwiązanych",
  "cleaner": "Sprzątacz",
  "clocked_in": "Zarejestrowano wejście",
  "clocked_out": "Zarejestrowano wyjście",
  "still_clocked_in": "Nadal na zmianie",
  "clocked_in_late": "Spóźnione zgłoszenie wejścia",
  "total_hours": "Łączna liczba godzin",
  "auto_punch": "Automatycznie (geofencing)",
  "manual_punch": "Ręcznie",
  "complaint_opened": "Zgłoszenie otwarte",
  "complaint_closed": "Zgłoszenie zamknięte",
  "complaint_still_open": "Nadal otwarte",
  "resolved_in": "Rozwiązano w",
  "open_for": "Otwarte od",
  "sla_breached": "Naruszenie SLA",
  "no_activity_today": "Brak aktywności dzisiaj",
  "just_now": "przed chwilą",
  "ago": "temu",
  "today": "Dzisiaj",
  "live": "Na żywo",
  "last_updated": "Zaktualizowano",
  "no_cleaners_found": "Nie znaleziono pracownika serwisu sprzątającego",
  "new_cleaner": "Nowy pracownik serwisu sprzątającego",
  "edit_cleaner": "Edytuj pracownika serwisu sprzątającego",
  "have_you_finished_making_changes": "Czy zakończyłeś wprowadzanie zmian?",
  "assignment_issues_found": "Znaleziono problemy z przypisaniami",
  "unassigned_rooms_title": "Nieprzypisane pokoje",
  "overlapping_assignments_title": "Nakładające się przypisania",
  "and_n_more": "i jeszcze {count}",
  "continue_anyway": "Kontynuuj mimo to",
  "stay_and_fix": "Zostań i popraw",
  "assignment_coverage_issues": "{unassigned} nieprzypisane · {overlaps} nakładania",
  "assignment_check_failed": "Nie udało się zweryfikować przypisań pokoi",
  "tap_for_details": "Dotknij, aby zobaczyć szczegóły",
  "has_app": "Aplikacja",
  "has_app_tooltip": "Pracownik ma aplikację",
  "notifications_tooltip": "Powiadomienia push włączone",
  "assigned_to_rooms": "Przypisany do pomieszczeń",
  "assigned_to_rooms_tooltip": "Ma pomieszczenia w tej lokalizacji",
  "recently_active": "Ostatnio aktywny",
  "works_at_site": "Pracuje w obiekcie",
  "recently_active_tooltip": "Otworzył aplikację w ciągu ostatnich 30 minut",
  "please_select": "Proszę wybrać",
  "please_select_site_first": "Proszę najpierw wybrać lokalizację",
  "working_areas": "Obszary robocze",
  "no_working_areas": "Brak obszarów roboczych",
  "working_area_alerts": "Alerty",
  "api": "API",
  "please_create_room_before_working_area": "Proszę utworzyć co najmniej jedno pomieszczenie przed utworzeniem obszaru roboczego",
  "isWorkingInSite": "Pracuje w budynku",
  "you_are_not_allowed_to_edit": "Nie masz uprawnień do edycji",
  "you_are_not_allowed_to_remove": "Nie masz uprawnień do usunięcia",
  "task": "Zadania",
  "portuguese": "Portugalski",
  "russian": "Rosyjski",
  "spanish": "Hiszpański",
  "polish": "Polski",
  "installer": "Instalator",
  "once": "Raz",
  "time_saved": "Oszczędzony czas",
  "yes": "Tak",
  "no": "Nie",
  "workingAreaNames": "Nazwy obszarów pracy",
  "shift_rooms":"Pomieszczenia",
  "new_shift":"Nowa zmiana",
  "add_shift_inactive": "Dodaj nieaktywne zmiany",
  "remove_auto_shift_inactive": "Usuń automatyczne zmiany nieaktywne",
  "additional_options": "Opcje zaawansowane",
  "add_default_shifts": "Dodaj domyślne zmiany",
  "no_user_found": "Nie znaleziono użytkownika",
  "no_site_found": "Nie znaleziono budynku",
  "service_provider": "Dostawca usług",
  "qr task": "Zadanie QR",
  "qr_task": "Zadanie QR",
  "all_day": "Cały dzień",
  "auto_start": "Automatyczny start",
  "english_title": "Tytuł w języku angielskim",
  "connectivity": "Połączenie",
  "power": "Zasilanie",
  "Your work has been saved": "Twoja praca została zapisana",
  "schedule_call_time": "Harmonogram czasu połączenia",
  "schedule_call_gap": "Harmonogram przerwy w połączeniu",
  "gapInMinutes": "Przerwa w minutach",
  "no_manual_calls_available": "Brak dostępnych wezwań ręcznych",
  "manual_calls": "Wezwania ręczne",
  "cleandex_calls": "Wezwania Cleandex",
  "cleandexCalls": "Wezwania Cleandex",
  "manualCalls": "Wezwania ręczne",
  "inactive": "Nieaktywny",
  "on hold": "Wstrzymane",
  "sequential": "Kolejny",
  "ratio": "Wizyty/Serwisy",
  "must_choose": "Musisz wybrać",
  "surveyApp": "Aplikacja badawcza",
  "installation": "Instalacja",
  "manager": "Menedżer",
  "previous": "Poprzedni",
  "next": "Następny",
  "no_rooms_found": "Nie znaleziono pomieszczeń",
  "show_calendar": "Pokaż kalendarz",
  "seeAll": "Zobacz wszystko",
  "showPaginated": "Pokaż stronę",
  "cleaners_arrivals": "Serwisy serwisantów",
  "add_address": "Dodaj adres",
  "site_auto_attendance_enabled":
    "Zezwalaj na automatyczne wejście i wyjście przez geofence w aplikacji mobilnej (wymaga zgód na lokalizację).",
  "site_auto_attendance_requires_location":
    "Najpierw ustaw na mapie pinezkę i promień co najmniej 100 m, potem włącz automatyczne wejście/wyjście.",
  "site_mandatory_clock_in": "Wymagaj rejestracji wejścia przed pracą",
  "site_mandatory_clock_in_description":
    "Pracownicy tego obiektu muszą zarejestrować wejście, zanim będą mogli otworzyć zakładki sprzątania, konserwacji i zadań w aplikacji mobilnej.",
  "site_mandatory_clock_in_without_location":
    "Ten obiekt nie ma lokalizacji na mapie, więc aplikacja nie rozpozna, kiedy pracownik jest na miejscu. Dopóki jej nie ustawisz, wymóg obowiązuje tych pracowników wszędzie.",
  "edit_address": "Edytuj adres",
  "choose_radius": "Wybierz promień",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Zielony = OK. Czerwony = Zalecane czyszczenie. Najedź na ikonę po szczegóły.",
  "recommended_to_clean": "Zalecane czyszczenie",
  "cleandex_warning_level": "Poziom ostrzeżenia Cleandex",
  "select_warning_level": "Wybierz poziom ostrzeżenia",
  "bronze": "Brązowy",
  "silver": "Srebrny",
  "gold": "Złoty",
  "ai": "AI",
  "daily_employees_num": "Liczba pracowników dziennie",
  "daily_shift_hours": "Godziny zmiany dziennej",
  "rooms_num": "Liczba pokoi",
  "buildings_num": "Liczba budynków",
  "cleaner_entries": "Wejścia sprzątaczy",
  "avg_daily_visits_monthly": "Średnia dzienna liczba wizyt miesięcznie",
  "avg_daily_cleaners_to_save": "Średnia dzienna liczba sprzątaczy do zaoszczędzenia",
  "saving_hours_per_day": "Zaoszczędzone godziny dziennie",
  "saving_money_per_day": "Zaoszczędzone pieniądze dziennie",
  "saving_money_per_month": "Zaoszczędzone pieniądze miesięcznie",
  "cleaners_to_visitors_ratio": "Stosunek sprzątaczy do odwiedzających",
  "cleaning_time_in_minutes_per_room": "Czas sprzątania w minutach na pokój",
  "max_number_of_rooms_per_employee": "Maksymalna liczba pokoi na pracownika",
  "break_time_per_hour": "Czas przerwy na godzinę",
  "transition_time_between_tasks": "Czas przejścia między zadaniami",
  "employer_cost_hour": "Koszt pracodawcy na godzinę",
  "lobby_cleaning_per_floor": "Sprzątanie lobby na piętro",
  "desired_cleaning_time": "Pożądany czas sprzątania",
  "desired_number_of_entries": "Pożądana liczba wejść",
  "buzz_system_cost_per_unit_per_month": "Koszt systemu Buzz na jednostkę miesięcznie",
  "total_buzz_system_cost_per_month": "Całkowity koszt systemu Buzz miesięcznie",
  "return_on_investment_in_months": "Zwrot z inwestycji w miesiącach",
  "annual_savings": "Oszczędności roczne",
  "roi_calculator": "Kalkulator ROI",
  "cleaners_number": "Liczba sprzątaczy",
  "floors_num": "Liczba pięter",
  "avg_daily_cleaners_required": "Średnia dzienna liczba wymaganych sprzątaczy",
  "app_pages": "Strony aplikacji",
  "buzzzTime": "Czas Buzzz",
  "missions": "Misje",
  "send_emails": "Wyślij e-maile",
  "enter": "Wprowadź",
  "account": "Konto",
  "privacy": "Prywatność",
  "personal_settings": "Ustawienia osobiste",
  "personal_settings_lead": "Język i preferencje prywatności.",
  "personal_settings_read_only": "Dane zarządza administrator. Skontaktuj się z nim w sprawie zmian.",
  "change_password": "Zmień hasło",
  "change_password_hint": "Zmiana hasła wyloguje Cię z pozostałych urządzeń.",
  "current_password": "Obecne hasło",
  "new_password": "Nowe hasło",
  "confirm_new_password": "Potwierdź nowe hasło",
  "password_min_length": "Hasło musi mieć co najmniej 8 znaków",
  "passwords_do_not_match": "Hasła nie są zgodne",
  "new_password_same_as_current": "Nowe hasło musi różnić się od obecnego",
  "current_password_incorrect": "Obecne hasło jest nieprawidłowe",
  "current_password_required": "Obecne hasło jest wymagane",
  "password_changed_successfully": "Hasło zostało zmienione",
  "change_password_failed": "Nie udało się zmienić hasła",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "Nieprawidłowa nazwa użytkownika lub hasło",
  "login_credentials_required": "Wprowadź nazwę użytkownika lub e-mail oraz hasło",
  "login_network_error": "Nie można połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie",
  "login_failed": "Nie udało się zalogować. Spróbuj ponownie",
  "login_too_many_attempts": "Zbyt wiele prób logowania. Odczekaj 15 minut i spróbuj ponownie.",
  "forgot_password_too_many": "Zbyt wiele próśb o reset hasła. Odczekaj godzinę i spróbuj ponownie.",
  "reset_password_too_many": "Zbyt wiele prób resetu hasła. Odczekaj godzinę i spróbuj ponownie.",
  "change_password_too_many": "Zbyt wiele prób zmiany hasła. Odczekaj 15 minut i spróbuj ponownie.",

  "personal_settings_language_hint": "Dotyczy całego portalu w tej przeglądarce.",
  "personal_settings_privacy_hint": "Żądanie usunięcia danych osobowych zgodnie z przepisami.",
  "personal_settings_role": "Rola",
  "Request deletion of my data": "Żądaj usunięcia moich danych",
  "Request deletion of my data - confirm": "Żądaj usunięcia moich danych? Administrator otrzyma e-mail. Przetworzymy wniosek w ciągu 30 dni.",
  "Request deletion of my data - success": "Wniosek wysłany. Przetworzymy go w ciągu 30 dni.",
  "Request deletion of my data - error": "Nie udało się wysłać. Spróbuj ponownie lub napisz na privacy@buzzztech.com.",
  "no_active_shift": "Brak aktywnej zmiany",
  "check_site_and_shift": "Sprawdź, czy wybrano lokalizację i czy jest aktywna zmiana",
  "please_add_shift_first": "Proszę najpierw dodać zmianę",
  "cleandex_no_data_message": "Brak dostępnych danych Cleandex",
  "task_no_data_message": "Brak dostępnych danych zadań",
  "navigation": "Nawigacja",
  "network_information": "Informacje o sieci",
  "target_effectiveness": "Skuteczność celu",
  "cleandex_call_cleaner": "Wezwanie sprzątacza Cleandex",
  "top_complaint": "Najczęstsze zgłoszenie", 
  "no_complaints": "Brak zgłoszeń",
  "start_date": "official_start_date",
  "note_text": "Tekst notatki",
  "add_note": "Dodaj notatkę",
  "general_note": "Notatka ogólna",
  "general_note_short": "Ogólna",
  "battery_short": "Bateria",
  "panel_short": "Panel",
  "technician_short": "Technik",
  "battery_replacement": "Wymiana baterii",
  "device_maintenance": "Konserwacja urządzenia",
  "maintenance_type": "Rodzaj konserwacji",
  "panel_change": "Zmiana panelu",
  "technician_check": "Sprawdzenie przez technika",
  "enter_note_details": "Wprowadź szczegóły notatki",
  "replacement_date": "Data wymiany",
  "replaced_by_name": "Wymienione przez",
  "replacement_note": "Notatka o wymianie",
  "enter_replacement_details": "Wprowadź szczegóły wymiany",
  "replacement_history": "Historia wymian",
  "loading_history": "Ładowanie historii",
  "no_replacement_history": "Brak dostępnej historii wymian",
  "enter_technician_name": "Wprowadź imię technika",
  "user_information": "Informacje o użytkowniku",
  "enter_change_details": "Wprowadź szczegóły zmiany",
  "panel_change_history": "Historia zmian panelu",
  "check_date": "Data sprawdzenia",
  "checked_by_name": "Sprawdzone przez",
  "enter_check_details": "Wprowadź szczegóły sprawdzenia",
  "technician_check_history": "Historia sprawdzeń technika",
  "no_technician_check_history": "Brak dostępnej historii sprawdzeń technika",
  "change_date": "Data zmiany",
  "changed_by_name": "Zmienione przez",
  "change_note": "Notatka o zmianie",
  "check_note": "Notatka ze sprawdzenia",
  "replaced_by": "Wymienione przez",
  "no_data_entered": "Brak wprowadzonych danych",
  "no_panel_change_history": "Brak dostępnej historii zmian panelu",
  "invalid_username": "Nieprawidłowa nazwa użytkownika",
  "invalid_phone": "Nieprawidłowy numer telefonu",
  "username_must_be_at_least_5_characters": "Nazwa użytkownika musi mieć co najmniej 5 znaków",
  "open_slas": "Otwarte SLA",
  "open_sla_alerts": "Otwarte alerty skarg",
  "open_duration": "Otwarty czas trwania",
  "open_complaints": "Otwarte skargi",
  "site_alerts": "Alerty Stron",
  "rooms_with_open_complaints_percentage": "Pokoje z otwartymi skargami",
  "rooms_with_cleaner_arrival_percentage": "Pokoje z przybyciem sprzątacza",
  "rooms_without_cleaner_arrival_percentage": "Pokoje bez przybycia sprzątacza",
  "site_alerts_total_rooms": "Łączna liczba pokoi",
  "site_alerts_open_complaints_count": "Liczba otwartych skarg",
  "site_alerts_customer_opening_date": "Data otwarcia klienta",
  "company_country": "Kraj firmy",
  "select_message": "Wybierz wiadomość",
  "message_no_cleaner_arrival": "Witajcie wszyscy,\nProszę zauważyć, że są pokoje, w których nie zgłoszono dzisiaj przybycia sprzątacza.\nProszę się tym zająć",
  "message_open_complaints": "Witajcie wszyscy,\nProszę zauważyć, że jest kilka pokoi z otwartymi skargami od dłuższego czasu.\nProszę się tym zająć",
  "rooms_list": "Pokoje:",
  "no_open_slas": "Nie znaleziono otwartych SLA",
  "no_open_slas_description": "Obecnie nie ma miejsc z otwartymi SLA.",
  "no_slas_to_send": "Nie znaleziono otwartych SLA dla tej lokalizacji",
  "total_open_complaints": "Całkowita liczba otwartych skarg",
  "longest_duration": "Najdłuższy czas trwania",
  "complaints_details": "Szczegóły skarg",
  "no_results_found": "Nie znaleziono wyników",
  "whatsapp": "WhatsApp",
  "loading": "Ładowanie",
  "error_opening_whatsapp": "Błąd podczas otwierania WhatsApp. Spróbuj ponownie.",
  "error_loading_slas": "Błąd podczas ładowania szczegółów SLA. Spróbuj ponownie.",
  "send_whatsapp": "Wyślij WhatsApp",
  "more_options": "Więcej opcji",
  "preview_message": "Podgląd wiadomości",
  "copy_message": "Kopiuj wiadomość",
  "message_preview": "Podgląd wiadomości",
  "phone_number_optional": "Numer telefonu (opcjonalnie)",
  "enter_phone_number": "Wprowadź numer telefonu (np. +48123456789)",
  "phone_number_hint": "Pozostaw puste, aby otworzyć WhatsApp bez konkretnego kontaktu",
  "message_copied": "Wiadomość skopiowana do schowka!",
  "error_copying_message": "Błąd podczas kopiowania wiadomości. Spróbuj ponownie.",
  "opening_whatsapp": "Otwieranie WhatsApp...",
  "data_loading_please_wait": "Dane są ładowane. Proszę czekać...",
  "dates_not_changed": "Daty się nie zmieniły. Przeładowanie nie jest wymagane.",
  "date_outside_stats_range": "Wybrane daty są poza dostępnym zakresem statystyk.",

  "date_range_invalid": "Data \"Do\" musi być równa lub późniejsza niż data \"Od\".",
  "filter_help_text": "Zasady filtrowania: Najpierw wybierz Budynek, aby włączyć filtr Piętra. Większość filtrów obsługuje wielokrotny wybór.",
  "select_building_first": "Proszę najpierw wybrać Budynek, aby włączyć filtr Piętra",
  "cannot_select_gender_with_rooms": "Nie można wybrać typu pomieszczenia, gdy wybrano pomieszczenia",
  "cannot_select_gender_with_rooms_tooltip": "Filtr typu pomieszczenia nie może być używany, gdy wybrano pomieszczenia. Najpierw wyczyść wybór pomieszczeń.",
  "cannot_select_building_with_rooms": "Nie można wybrać budynku, gdy wybrano pokoje",
  "cannot_select_building_with_rooms_tooltip": "Filtr budynku nie może być używany, gdy wybrano pokoje. Proszę najpierw wyczyścić wybór pokoi.",
  "multi_select_hint": "Możesz wybrać wiele opcji",
  "filter_applied": "Filtr zastosowany pomyślnie",
  "no_filters_selected": "Nie wybrano filtrów. Wybierz co najmniej jedną opcję filtrowania.",
  "filters": "Filtry",
  "location": "Lokalizacja",
  "attributes": "Atrybuty",
  "applying": "Stosowanie...",
  "active_filters": "Aktywne Filtry",
  "viewing_room": "Przeglądanie pokoju",
  "multiple": "Wielokrotny",
  "close": "Zamknij",
  "save_replacement": "Zapisz wymianę",
  "save_change": "Zapisz zmianę",
  "save_check": "Zapisz sprawdzenie",
  "failed_to_load_maintenance_history": "Nie udało się załadować historii konserwacji",
  "Battery replacement recorded successfully": "Wymiana baterii została pomyślnie zapisana",
  "Panel change recorded successfully": "Zmiana panelu została pomyślnie zapisana",
  "Technician check recorded successfully": "Sprawdzenie przez technika zostało pomyślnie zapisane",
  "no_network_data_available": "Brak danych sieciowych",
  "basic_information": "Podstawowe informacje",
  "service_providers": "Dostawcy usług",
  "settings_alerts": "Ustawienia i alerty",
  "configuration": "Konfiguracja",
  "contact_settings": "Kontakt i ustawienia",
  "notifications": "Powiadomienia",
  "alert_language": "Język alertów",
  "select_language": "Wybierz język",
  "features": "Funkcje",
  "chat_ask_stats": "Zapytaj o statystyki",
  "chat_ask_buzzz": "Zapytaj Buzzz",
  "chat_stats_assistant": "Asystent statystyk",
  "chat_buzzz_assistant": "Asystent Buzzz",
  "chat_clear": "Wyczyść",
  "chat_placeholder": "Zapytaj o statystyki sprzątania, np. \"Ile skarg w zeszłym tygodniu?\" lub \"Które pokoje wymagają uwagi?\"",
  "chat_placeholder_context": "Zapytaj o {scope}, np. \"Ile skarg?\" lub \"Które pokoje wymagają uwagi?\"",
  "chat_thinking": "Myślę…",
  "chat_input_placeholder": "Zapytaj o wizyty, skargi, pokoje…",
  "chat_send": "Wyślij",
  "chat_chip_summary": "Podsumowanie",
  "chat_chip_worst_rooms": "Najgorsze pokoje",
  "chat_chip_counter_calls": "Połączenia licznika",
  "chat_chip_sla_issues": "Problemy z SLA",
  "chat_chip_busiest_hours": "Najbardziej zajęte godziny",
  "chat_chip_help": "O co mogę zapytać?",
  "chat_chip_focus": "Na czym powinienem się skupić?",
  "chat_chip_improving": "Które pokoje się poprawiają?",
  "chat_chip_best_rooms": "Najlepsze pokoje wg oceny",
  "chat_chip_worst_days": "Najgorsze dni",
  "chat_chip_complaint_types": "Rodzaje skarg",
  "chat_chip_positive_feedback": "Pozytywne opinie",
  "chat_suggestions": "Sugestie",
  "chat_error": "Coś poszło nie tak. Spróbuj ponownie.",
  "chat_copy": "Kopiuj",
  "chat_copied": "Skopiowano!",
  "chat_retry": "Ponów",
  "chat_chip_compare_periods": "Porównaj z poprzednim okresem",
  "chat_chip_briefing": "Poranne podsumowanie",
  "chat_chip_cleaning_priority": "Priorytet sprzątania",
  "chat_chip_live_status": "Status na żywo",
  "chat_chip_shift_stats": "Wyniki zmian",
  "chat_chip_staff_status": "Kto teraz pracuje?",
  "chat_chip_why_drilldown": "Dlaczego? Szczegóły",
  "chat_pin": "Dodaj do ulubionych",
  "chat_unpin": "Usuń z ulubionych",
  "chat_share": "Wyślij e-mailem",
  "chat_export": "Eksportuj",
  "chat_helpful": "Pomocne",
  "chat_not_helpful": "Nie pomocne",
  "chat_hide": "Ukryj asystenta",
  "chat_stop": "Zatrzymaj",
}

export const uk = {
  ...serviks.uk,
  "notified": "Повідомлено",
  "supervisor_arrival": "Інспекція виконана",
  "arrival": "Сервіс",
  "arrival_badges": "Сервіси за зміну",
  "callsHistory": "Історія викликів",
  "openCalls": "Відкриті виклики",
  "visits_since_cleaned": "Візитів з останнього прибирання",
  "visits_since_cleaned_short": "Візити з прибирання",
  "filter": "Фільтр",
  "logo": "Логотип",
  "counter": "Лічильник входів",
  "sms": "SMS",
  "shifts": "Зміни",
  "call": "Виклик",
  "duration": "Тривалість",
  "time_start": "Час початку",
  "settings": "Налаштування",
  "always": "Завжди",
  "off": "Вимкнено",
  "time_based": "За часом",
  "location_based": "За місцезнаходженням",
  "notification_mode": "Режим сповіщень",
  "notification_times": "Час сповіщень",
  "notification_times_info": "Часові інтервали керуються з мобільного додатку",
  "notification_location": "Місцезнаходження сповіщень",
  "notification_sound": "Звук сповіщення",
  "no_sound": "Без звуку",
  "default_sound": "Звук за замовчуванням",
  "soft_bell": "М'який дзвінок",
  "digital_sound": "Цифровий звук",
  "mallet_sound": "Звук молотка",
  "phone_sound": "Звук телефону",
  "text_sound": "Звук тексту",
  "manager_alert_delay": "Затримка сповіщення менеджера",
  "snooze_interval": "Нагадування",
  "vocal_notifications": "Голосові сповіщення",
  "no_delay": "Без затримки",
  "no_snooze": "Жодного нагадування",
  "lat": "Широта",
  "lon": "Довгота",
  "radius": "Радіус",
  "no_location_set": "Місцезнаходження не встановлено",
  "when_to_notify": "Коли Сповіщати",
  "notification_preferences": "Налаштування Сповіщень",
  "assignment_configuration": "Призначення та Конфігурація",
  "status": "Статус",
  "working_area": "Робоча зона",
  "complaints_NC": "Скарги та NC",
  "SLA_NC": "SLA та NC",
  "arrivals_NC": "Сервіси та NC",
  "staff": "Персонал",
  "cleaning_complaints": "Скарги на прибирання",
  "export": "Експорт",
  "maintenance_complaints": "Скарги на обслуговування",
  "maintenanceArrivals": "Виконані обслуговування",
  "maintenance_arrivals": "Виконані обслуговування",
  "last": "Останній",
  "survey_name": "Назва опитування",
  "survey": "Опитування",
  "pad_survey": "Опитування типу панель",
  "pad_no_maintenance_survey": "Опитування типу панель без обслуговування",
  "pad_kitchen": "Опитування типу кухня",
  "number_of_assigned_devices": "Кількість призначених пристроїв",
  "number_of_pages": "Кількість сторінок",
  "date_created": "Дата створення",
  "updated_by": "Оновлено користувачем",
  "date_updated": "Дата оновлення",
  "search": "Пошук",
  "choose_type": "Виберіть тип",
  "permitted_sites": "Дозволені сайти",
  "permitted_franchise": "Дозволені франшизи",
  "permitted_companies": "Дозволені компанії",
  "panel_permitted": "Дозволена панель",
  "end_time": "Час завершення",
  "last_update": "Останнє оновлення",
  "add_device": "Додати пристрій",
  "detailed": "Детально",
  "analysis": "Аналіз",
  "suggestion": "Пропозиція",
  "country": "Країна",
  "management": "Управління",
  "device": "Пристрій",
  "mapping": "Карта",
  "please_enter": "Будь ласка, введіть",
  "new_device": "Новий пристрій",
  "assign_device": "Призначити пристрій",
  "installSpot": "Місце встановлення",
  "device_type": "Тип пристрою",
  "deviceCode": "Код пристрою",
  "device_code": "Код пристрою",
  "scan_or_enter_device_code": "Скануйте або введіть код пристрою...",
  "scan_device": "Призначити",
  "scan_qr_in_frame": "Розмістіть QR-код у рамці. Для малих кодів тримайте телефон на відстані 15–25 см і торкніться попереднього перегляду для повторного фокусування, якщо зображення розмите.",
  "checking_device_code": "Перевірка коду пристрою...",
  "camera_not_available": "Камера недоступна. Ви можете ввести код вручну.",
  "device_code_already_exists": "Цей код пристрою вже призначено іншому датчику.",
  "assigned_to_company_site_room": "Вже призначено: {company} / {site} / {room}",
  "device_code_lookup_failed": "Не вдалося перевірити код пристрою. Спробуйте ще раз.",
  "device_code_no_site_access": "Цей код уже зареєстровано на об'єкті, до якого у вас немає доступу.",
  "device_code_check_unavailable": "Сервер не зміг перевірити код. Спробуйте ще раз.",
  "device_code_not_a_code": "Сканер прочитав «{code}». Введіть сам код пристрою.",
  "device_code_open_failed": "Не вдалося відкрити цей пристрій. Спробуйте ще раз.",
  "device_code_save_failed": "Не вдалося зберегти код пристрою. Спробуйте ще раз.",
  "device_code_save_forbidden": "Ви не можете змінити цей пристрій.",
  "confirm_replace_device_code": "Замінити код пристрою?",
  "confirm_replace_device_code_body": "Ви впевнені, що хочете замінити код {oldCode} на {newCode}?",
  "room": "Кімната",
  "edit_room": "Редагувати кімнату",
  "edit_franchise": "Редагувати франшизу",
  "new_franchise": "Нова франшиза",
  "desc": "Опис",
  "address": "Адреса",
  "level": "Рівень",
  "no_companies_to_show": "Немає компаній для відображення",
  "company_type": "Тип компанії",
  "region": "Регіон",
  "new_company": "Нова компанія",
  "edit_company": "Редагувати компанію",
  "edit_user": "Редагувати користувача",
  "C.arrivals": "Виконані сервіси",
  "C.complaints": "Скарги на прибирання",
  "M.complaints": "Скарги на обслуговування",
  "M.Arrivals": "Виконані обслуговування",
  "analyses": "Аналізи",
  "clean_log": "Журнал сервісу",
  "maintenance_log": "Журнал обслуговування",
  "like": "Лайк",
  "likes": "Лайки",
  "new_user": "Новий користувач",
  "shift_parameters": "Параметри зміни",
  "add_shift": "Додати зміну",
  "edit_shift": "Редагувати зміну",
  "username": "Ім'я користувача",
  "first_name": "Ім'я",
  "job_function": "Посада",
  "role": "Роль",
  "property_manager": "Керуючий об'єктом",
  "facility_manager": "Менеджер з експлуатації",
  "site_manager": "Керівник майданчика",
  "workplace_manager": "Керівник робочого простору",
  "cleaning_company_ceo": "Генеральний директор клінінгової компанії",
  "operations_manager": "Операційний менеджер",
  "area_manager": "Регіональний менеджер",
  "site_cleaning_manager": "Менеджер з прибирання об'єкта",
  "cleaning_supervisor": "Супервайзер з прибирання",
  "other": "Інше",
  "restroom_cleaner": "Прибиральник санвузлів",
  "general_cleaner": "Прибиральник",
  "day_porter": "Денний портьє",
  "office_cleaner": "Прибиральник офісів",
  "public_area_cleaner": "Прибиральник громадських зон",
  "firstName": "Ім'я",
  "description": "Опис",
  "last_name": "Прізвище",
  "lastName": "Прізвище",
  "phone": "Телефон",
  "building_area": "Площа будівлі",
  "users": "Користувачі",
  "add_user": "Додати користувача",
  "sites": "Місця",
  "new_site": "Нова будівля",
  "edit_site": "Редагувати будівлю",
  "add_company": "Додати компанію",
  "franchise": "Франшиза",
  "floor": "Поверх",
  "building": "Будівля",
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Тип приміщення",
  "display_name": "Відображуване ім'я",
  "zone": "Зона",
  "shift_number": "Номер",
  "shift": "Зміна",
  "shift_name": "Назва",
  "shift_currently_inactive": "Наразі неактивна зміна",
  "local_time": "Місцевий",
  "end": "Кінець",
  "min_sla": "Мін SLA",
  "max_sla": "Макс SLA",
  "days": "Дні",
  "complaints_percent": "% Скарг",
  "sla_percent": "% SLA",
  "arrivals_percent": "% Сервісів",
  "save_arrivals": "Зберегти сервіси",
  "clean_time": "Час прибирання (хв)",
  "tooltip_shift_number": "Порядок відображення зміни (напр. 1, 2).",
  "tooltip_shift_name": "Назва зміни (напр. Ранок, Ніч).",
  "tooltip_start_time": "Час початку зміни (місцевий).",
  "tooltip_end_time": "Час закінчення зміни (місцевий).",
  "tooltip_cleaners_number": "Кількість прибиральників у цій зміні.",
  "tooltip_min_sla": "Мінімальний час реакції (хв) на скаргу по кімнаті; нижня межа оцінки.",
  "tooltip_max_sla": "Максимально допустимий час реакції (хв) на скаргу; верхня межа оцінки.",
  "tooltip_arrivals": "Очікувані приходи прибиральника в кімнату на день; оцінка порівнює з ціллю.",
  "tooltip_save_arrivals": "Візити прибиральника в кімнату на день до BuzzzTV; для розрахунку заощадженого часу.",
  "tooltip_clean_time": "Хвилини на один візит прибиральника в розрахунку заощадженого часу (напр. 15).",
  "tooltip_complaints_percent": "Вага скарг в оцінці кімнати за наявності візитів.",
  "tooltip_response_time_SLA": "Вага часу реакції в оцінці кімнати за наявності візитів.",
  "tooltip_arrivals_percent": "Вага приходів до цілі в оцінці кімнати за наявності візитів.",
  "tooltip_complaints_NC": "Вага скарг в оцінці за відсутності візитів (без лічильника).",
  "tooltip_SLA_NC": "Вага часу реакції в оцінці за відсутності візитів.",
  "tooltip_arrivals_NC": "Вага приходів в оцінці за відсутності візитів.",
  "tooltip_days": "Дні тижня, коли зміна активна.",
  "tooltip_active_calculation": "Якщо ввімкнено, зміна враховується в оцінках та заощадженому часі.",
  "auto_close_complaints_hour": "Година автозакриття скарг",
  "tooltip_auto_close_complaints_hour": "Місцева година, коли відкриті SLA-скарги цієї зміни автоматично закриваються. Залиште порожнім для вимкнення.",
  "auto_close_maintenance_complaints_hour": "Година автозакриття скарг з обслуговування",
  "tooltip_auto_close_maintenance_complaints_hour": "Місцева година, коли відкриті SLA-скарги з обслуговування цієї зміни автоматично закриваються. Залиште порожнім для вимкнення.",
  "no_auto_close": "-- Немає --",
  "tooltip_shift_rooms": "Кімнати, привʼязані до зміни. Залиште порожнім для зміни рівня сайту.",
  "company_name": "Назва компанії",
  "site_name": "Назва місця",
  "site_desc": "Опис місця",
  "service_provider_name": "Назва постачальника послуг",
  "service_provider_type": "Тип постачальника послуг",
  "service_provider_desc": "Опис постачальника послуг",
  "user": "Користувач",
  "map": "Карта",
  "delete": "Видалити",
  "remove": "Видалити",
  "new_room": "Нове приміщення",
  "issue_times": "Часи виникнення",
  "solved": "Вирішено",
  "visits": "Візити",
  "visits_also_went_up": "Візити також зросли",

  "complaints": "Скарги",
  "cleaner_arrivals": "Виконані сервіси",
  "unnecessary_arrivals": "Сервіси без виклику",
  "unnecessary_arrivals_hint": "Візит прибиральника, коли в кімнаті не було відкритого виклику.",
  "of_arrivals": "від виконаних сервісів",
  "response_time_SLA": "Час реакції",
  "score": "Оцінка",
  "avg_score": "Середня оцінка",
  "score_goal": "Планована оцінка",
  "top_problem_issues": "Найбільші проблеми",
  "top_problem_rooms": "Проблемні приміщення",
  "top_problem_hours": "Проблемні години",
  "is_time_save": "Економія часу",
  "est_ROI": "Приблизний ROI",
  "complaints_vs_visits": "Скарги проти візитів",
  "view_by_years": "За роками",
  "view_by_months": "За місяцями",
  "view_by_weeks": "За тижнями",
  "view_by_days": "За днями",
  "minutes": "хв",
  "company": "Компанія",
  "site": "Будівля",
  "alerts": "Сповіщення про пристрої",
  "performance": "Продуктивність",
  "devices": "Пристрої",
  "total_devices": "Всього пристроїв",
  "working": "Працює",
  "warning": "Попередження",
  "by_device_type": "За типом пристрою",
  "surveys": "Опитування",
  "real_time": "В реальному часі",
  "real-time": "В реальному часі",
  "cleaner-activity": "Активність прибиральників",
  "device-actions": "Дії з пристроєм",
  "pad-presence-testing": "Тест присутності біля пада",
  "real-time-cleaning": "В реальному часі - прибирання",
  "real-time-maintenance": "В реальному часі - обслуговування",
  "no_real_time_tabs_permitted": "У вас немає доступу до жодної вкладки реального часу",
  "admin": "Адмін",
  "all": "Все",
  "overview": "Огляд",
  "total": "Всього",
  "analytics": "Аналітика",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Комунікація",
  "overview_complaints_devices_caption": "Встановлено пристроїв (наростаюче)",
  "overview_complaints_devices_caption_hint": "Загальна кількість пристроїв, встановлених на об'єкті до кінця кожного місяця, за датами встановлення.",
  "overview_complaints_devices_toggle_aria": "Показати або приховати встановлені пристрої під графіком скарг",
  "communication_select_site_title": "Оберіть об'єкт",
  "communication_select_site": "Оберіть компанію та об'єкт у фільтрах вище, щоб переглядати та додавати нотатки для цього місця.",
  "communication_viewing_site": "Перегляд",
  "communication_add_note": "Додати нотатку",
  "communication_add_note_open_aria": "Відкрити вікно додавання нотатки",
  "communication_form_hint": "Діліться оновленнями або нотатками з усіма, хто має доступ до цього об'єкта. Вони бачитимуть нові нотатки в реальному часі.",
  "communication_page_intro_title": "Нотатки об'єкта — спільний журнал для цієї локації",
  "communication_page_intro_body": "Тут залишають передачі зміни, проблеми, оновлення та підсумки зустрічей. Усі, хто має доступ до цього об'єкта в порталі, можуть читати й додавати нотатки.",
  "communication_page_intro_dismiss": "Приховати підказку",
  "communication_page_intro_aria": "Про нотатки об'єкта",
  "communication_content_placeholder": "Напишіть нотатку тут...",
  "communication_keyboard_hint": "Ctrl+Enter — опублікувати",
  "communication_submitting": "Публікація...",
  "communication_submit": "Опублікувати нотатку",
  "communication_recent_notes": "Нотатки",
  "communication_search_placeholder": "Пошук за автором або текстом...",
  "communication_refresh": "Оновити",
  "communication_clear_filters": "Очистити фільтри",
  "communication_search_aria_label": "Пошук нотаток",
  "communication_submit_aria_label": "Опублікувати нотатку",
  "communication_copy_note_aria_label": "Копіювати текст нотатки",
  "communication_copied": "Скопійовано в буфер обміну.",
  "communication_copy_empty": "У нотатці немає тексту для копіювання.",
  "communication_filter_hidden_one": "(1 нотатку приховано фільтрами)",
  "communication_filter_hidden_many": "({n} нотаток приховано фільтрами)",
  "communication_request_timeout": "Час очікування вичерпано. Спробуйте ще раз.",
  "communication_load_failed": "Не вдалося завантажити нотатки.",
  "communication_retry": "Повторити",
  "communication_no_matches": "Немає нотаток, що відповідають пошуку чи фільтрам. Спробуйте їх змінити.",
  "communication_no_entries": "Поки немає нотаток.",
  "communication_no_entries_hint": "Додайте нотатку вище, щоб почати.",
  "communication_just_now": "Щойно",
  "communication_minutes_ago": "{n} хв тому",
  "communication_hours_ago": "{n} год тому",
  "communication_days_ago": "{n} дн. тому",
  "communication_note_posted": "Нотатку опубліковано.",
  "communication_post_failed": "Не вдалося опублікувати нотатку. Спробуйте знову.",
  "communication_note_type": "Тип нотатки",
  "communication_type_general": "Загальна",
  "communication_type_update": "Оновлення",
  "communication_type_issue": "Проблема",
  "communication_type_follow_up": "Продовження",
  "communication_type_meeting": "Нотатка зустрічі",
  "communication_filter_all_types": "Усі типи",
  "communication_pinned": "Закріплено",
  "communication_pin": "Закріпити",
  "communication_unpin": "Відкріпити",
  "communication_pin_limit": "Макс. 2 закріплених",
  "communication_pinned_toast": "Нотатку закріплено.",
  "communication_unpinned_toast": "Нотатку відкріплено.",
  "communication_pin_failed": "Не вдалося оновити закріплення. Спробуйте знову.",
  "communication_note_not_found": "Нотатку не знайдено або у вас немає доступу.",
  "communication_site_not_in_filters": "Сайт цієї нотатки не в поточних фільтрах. Можливо, у вас немає доступу до цієї локації.",
  "communication_edit": "Редагувати",
  "communication_delete": "Видалити",
  "communication_save": "Зберегти",
  "communication_cancel": "Скасувати",
  "communication_saving": "Збереження...",
  "communication_note_updated": "Нотатку оновлено.",
  "communication_update_failed": "Не вдалося оновити нотатку. Спробуйте ще раз.",
  "communication_delete_confirm": "Видалити цю нотатку? Цю дію не можна скасувати.",
  "communication_delete_confirm_title": "Видалити нотатку",
  "communication_note_preview": "Попередній перегляд нотатки:",
  "communication_note_deleted": "Нотатку видалено.",
  "communication_delete_failed": "Не вдалося видалити нотатку. Спробуйте ще раз.",
  "communication_edited": "Змінено",
  "communication_show_more": "Показати більше",
  "communication_show_less": "Показати менше",
  "communication_sort_date_newest": "Спочатку новіші",
  "communication_sort_date_oldest": "Спочатку старіші",
  "communication_sort_author": "За автором",
  "communication_sort_type": "За типом",
  "communication_sort_pinned": "Спочатку закріплені",
  "communication_sort_label": "Сортування",
  "communication_filter_by_type": "Тип",
  "communication_filters_group_aria": "Фільтр і сортування нотаток",
  "communication_search_label_short": "Пошук",
  "last_time_of_arrival": "Останній сервіс",
  "arrival_and_status": "Сервіс і статус",
  "preview_arrivals": "Перегляд сервісів",
  "men toilet": "Чоловічий туалет",
  "women toilet": "Жіночий туалет",
  "shared toilet": "Спільний туалет",
  "unisex restroom": "Туалет унісекс",
  "handicapped toilet": "Туалет для людей з обмеженими можливостями",
  "logistics": "Логістика",
  "cubicle": "Кабінка",
  "gym": "Спортзал",
  "monthMap": {
      1: "Січень",
      2: "Лютий",
      3: "Березень",
      4: "Квітень",
      5: "Травень",
      6: "Червень",
      7: "Липень",
      8: "Серпень",
      9: "Вересень",
      10: "Жовтень",
      11: "Листопад",
      12: "Грудень"
    },
  "weekMap": {
    1: "Неділя",
    2: "Понеділок",
    3: "Вівторок",
    4: "Середа",
    5: "Четвер",
    6: "П'ятниця",
    7: "Субота"
  },
  "dayOfWeek": "День тижня",
  "service_log": "Журнал обслуговування",
  "rooms": "Кімнати",
  "bulk_add_rooms": "Масове додавання кімнат",
  "add_rooms": "Додати кімнати",
  "room_names_one_per_line": "Назви кімнат (по одній на рядок)",
  "enter_at_least_one_room": "Введіть принаймні одну назву приміщення",
  "room_names_placeholder": "Кімната 1\nКімната 2\nЖіночий туалет",
  "rooms_with_prefix": "кімнат з префіксом",
  "apply_to_all_rooms": "Застосувати до всіх кімнат (необов'язково)",
  "bulk_rooms_intro": "Додайте одну або кілька груп. Кожна група має власну будівлю, поверх, зону, тип та назви кімнат.",
  "group": "Група",
  "add_group": "+ Додати іншу групу",
  "adding_rooms": "Додавання кімнат...",
  "bulk_summary": "Підсумок",
  "in": "у",
  "bulk_rooms_success": "Успішно додано {n} кімнат",
  "displayName": "Відображувана назва",
  "SLA": "SLA",
  "supervisors": "Супервізори",
  "supervisor": "Супервізор",
  "performance_analytics": "Аналіз продуктивності",
  "arrivals": "Сервіси",
  "inspections": "Інспекції",
  "avgResponseTime": "Середній час реакції",
  "missedSla": "Невиконане SLA",
  "cleaner_arrived": "Виконано сервіс",
  "load_more": "Завантажити ще",
  "login": "Увійти",
  "email": "Електронна пошта",
  "emails": "Електронні листи",
  "password": "Пароль",
  "min": "хв",
  "Logout": "Вийти",
  "time_range": "Часовий діапазон",
  "select_time_range": "Виберіть часовий діапазон",
  "custom_time": "Вибрати",
  "last_day": "Вчора",
  "last_week": "Останні 7 днів",
  "last_month": "Останні 30 днів",
  "last_quarter": "Останні 90 днів",
  "last_6_months": "Останні 6 місяців",
  "last_year": "Останні 365 днів",
  "data_by_hour": "По годинах",
  "general": "Загальне",
  "cleaning": "Прибирання",
  "maintenance": "Технічне обслуговування",
  "start": "Початок",
  "start_time": "Час початку",
  "management_co": "Керівна компанія",
  "cleaning_co": "Прибиральна компанія",
  "companies": "Компанії",
  "name": "Назва",
  "site_count": "Кількість місць",
  "associated_companies": "Пов'язані компанії",
  "OK": "OK",
  "cancel": "Скасувати",
  "client": "Клієнт",
  "dates": "Дати",
  "shift": "Зміна",
  "issue": "Проблема",
  "time": "Час",
  "top complaint of the week": "Найпоширеніші скарги на тиждень",
  "top room of the week": "Проблемне приміщення на цьому тижні",
  "top hour of the week": "Проблемний час на цьому тижні",
  "top complaint of the month": "Найпоширеніша скарга цього місяця",
  "top room of the month": "Проблемне приміщення цього місяця",
  "top hour of the month": "Проблемний час цього місяця",
  "franchises": "Франшизи",
  "add_franchise": "Додати франшизу",
  "room_names": "Назви приміщень",
  "type": "Тип",
  "please_select_company_site": "Будь ласка, виберіть фірму/будівлю",
  "number": "Номер",
  "create_building_map": "Створити карту будівлі",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Привіт, найшвидший спосіб додати поверхи та кімнати до будівлі за допомогою цього швидкого майстра",
  "avg number of toilets per floor": "Середня кількість туалетів на поверсі",
  "avg.number of toilet cells per room": "Середня кількість кабінок у туалеті",
  "number of floors": "Кількість поверхів",
  "avg.number of disabled toilets": "Середня кількість туалетів для інвалідів",
  "avg.number of soap dispensers": "Середня кількість диспенсерів для милка",
  "reset_filter": "Скинути фільтр",
  "add": "Додати",
  "new_survey": "Нове опитування",
  "api_configuration": "Конфігурація API",
  "please_edit_the_api_information": "Будь ласка, відредагуйте інформацію API",
  "method": "Метод",
  "authorization": "Авторизація",
  "api_url": "URL API",
  "token": "Токен",
  "api_request_info": "Інформація про запит API",
  "roomName": "Назва кімнати",
  "servikName": "Назва скарги",
  "siteName": "Назва будівлі",
  "stage": "Етап",
  "number_of_buttons": "Кількість кнопок",
  "button_shape": "Форма кнопки",
  "delay_time_stage": "Час затримки етапу",
  "go_to_stage": "Перейти до етапу",
  "color": "Колір",
  "add_stage": "Додати етап",
  "save": "Зберегти",
  "number_of_issues": "Кількість проблем",
  "online": "Онлайн",
  "offline": "Офлайн",
  "offline_devices": "Офлайн пристрої",
  "no_offline_devices": "Офлайн пристрої не знайдено",
  "working_devices": "Працюючі пристрої",
  "no_working_devices": "Працюючі пристрої не знайдено",
  "room_name": "Назва кімнати",
  "installation_spot": "Місце установки",
  "device_id": "Ідентифікатор пристрою",
  "date": "Дата",
  "status": "Статус",
  "device_status": "Статус пристрою",
  "none": "Немає",
  "no_surveys_created": "Не створено жодних опитувань",
  "dashboard": "Інформаційна панель",
  "franchise_name": "Назва франшизи",
  "franchise_country": "Країна франшизи",
  "choose_franchise": "Виберіть франшизу",
  "choose_country": "Виберіть країну",
  "select_template": "Виберіть шаблон",
  "default_survey": "Стандартне опитування",
  "cleaning_survey": "Опитування про прибирання",
  "kitchen_survey": "Опитування кухні",
  "template": "Шаблон",
  "area_name": "Назва області",
  "rooms_names": "Назви кімнат",
  "rooms_number": "Номери кімнат",
  "assign_number": "Призначити номер",
  "active_notification_task": "Активне сповіщення",
  "amount_limit": "Ліміт",
  "after_max": "Після макс.",
  "new_area": "Нова область",
  "edit_area": "Редагувати область",
  "tablet": "Планшет",
  "counter women": "Лічильник / жінки",
  "counter men": "Лічильник / чоловіки",
  "counter handicap": "Лічильник / інваліди",
  "counter man/woman": "Лічильник чоловіки/жінки",
  "counter man / woman": "Лічильник чоловіки / жінки",
  "sensor liquid": "Рівень рідини",
  "double toilet paper": "Подвійний туалетний папір",
  "toilet paper": "Туалетний папір",
  "tag": "Мітка",
  "qr tag": "QR-код",
  "additional_info": "Додаткова інформація",
  "servikCategory": "Категорія сервісу",
  "dishwashing": "Миття посуду",
  "cafeteria": "Кафетерій",
  "clean room": "Прибиральна кімната",
  "office": "Офіс",
  "meeting room": "Зала для зустрічей",
  "cubic": "Кубічний",
  "women": "Жінки",
  "men": "Чоловіки",
  "handicap": "Інваліди",
  "Combined": "Комбінований",
  "kitchen": "Кухня",
  "east": "Схід",
  "west": "Захід",
  "north": "Північ",
  "south": "Південь",
  "right": "Право",
  "left": "Ліво",
  "center": "Центр",
  "up": "Вгору",
  "down": "Вниз",
  "combined": "Комбіноване",
  "lobby": "Лобі",
  "entrance": "Вхід",
  "reception": "Рецепція",
  "area": "Область",
  "mezzanine": "Мезонін",
  "gallery": "Галерея",
  "ground": "Підлога",
  "elevator": "Ліфт",
  "is_calculated": "Враховувати у статистиці",
  "calculated_room": "Врахована кімната",
  "splitted_survey": "Розділене дослідження",
  "redirect_to_url": "Перенаправлення на URL",
  "survey_site": "Дослідження місця",
  "clicks": "Кліки",
  "add_stage_number_to_signal": "Додати номер етапу до сигналу",
  "including_pad9": "Включаючи Pad9",
  "room_type_required": "Виберіть тип приміщення для кожної групи",
  "Tech Manufacturers": "Виробники технологій",
  "Tech Offices": "Технологічні офіси",
  "Offices": "Офіси",
  "Terminal": "Термінал",
  "Universities": "Університети",
  "Factories": "Фабрики",
  "Hospital": "Лікарня",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Магазини біля дому",
  "Food Chains": "Мережі харчування",
  "Residential": "Житловий",
  "Shopping Center": "Торговий центр",
  "Survey": "Опитування",
  "Demo": "Демо",
  "Vision": "Vision",
  "Court": "Суд",
  "Office Management": "Управління офісами",
  "Government Office": "Держустанова",
  "default_name": "Спеціальне ім'я",
  "exposures": "Досвідчені чисті туалети",
  "exposures_tab": "Активність кімнати",
  "expose_results": "Результати",
  "events_expose": "Події експозиції",
  "expose_score": "Ставка",
  "shift_events_expose": "Події зміни експозиції",
  "type_of_site": "Тип місця",
  "morning_shift": "Ранкова зміна",
  "afternoon_shift": "Післяполуденна зміна",
  "night_shift": "Нічна зміна",
  "update": "Оновлення",
  "restart": "Перезапуск",
  "send_data": "Надсилати дані",
  "send_count": "Надсилати лічильник",
  "blink": "Миготіння",
  "beacon": "Маяк",
  "like_btn": "Кнопка лайка",
  "requires_like_btn": "Потрібна увімкнена кнопка лайка",
  "maintenance_btn": "Кнопка обслуговування",
  "battery": "Батарея",
  "version": "Версія",
  "actions": "Дії",
  "device_actions": "Дії пристрою",
  "device_settings": "Налаштування пристрою",
  "drains_battery": "Розряджає батарею",
  "latest_errors": "Останні помилки",
  "no_errors": "Без помилок",
  "offline_calls": "Виклики в автономному режимі",
  "offline_duration_calls": "Тривалість викликів в автономному режимі",
  "counterCalls": "Виклики лічильником",
  "active": "Активний",
  "no_active_supervisors": "Немає активних супервайзерів",
  "active_supervisors_column": "Активні супервайзери",
  "supervisors_active_label": "супервайзери активні зараз",
  "active_supervisors_coverage_hint": "Активні супервайзери увімкнули цю зону в додатку. Це не означає онлайн- або фізичну присутність.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Враховувати у статистиці",
  "pad": "планшет",
  "pad_counter": "Лічильник",
  "counter_status": "Статус лічильника",
  "choose_state": "Виберіть область",
  "choose_city": "Виберіть місто",
  "city": "Місто",
  "state": "Область",
  "start_hour": "Початкова година",
  "end_hour": "Кінцева година",
  "analytics_log": "Журнал аналітики",
  "or": "або",
  "no_data_available": "Дані відсутні",
  "filter_by_cleaner": "Фільтр за прибиральником",
  "all_cleaners": "Усі прибиральники",
  "failed_to_load_data": "Не вдалося завантажити дані",
  "not_available": "Н/Д",
  "new_task": "Нове завдання",
  "temporarily_unavailable": "Тимчасово недоступно",
  "category": "Категорія",
  "title": "Назва",
  "task_type": "Тип завдання",
  "task_languages": "Мови завдання",
  "task_languages_hint": "Виберіть мови для цього завдання. Ви введете назву кожною обраною мовою.",
  "task_category": "Категорія завдання",
  "call_to_action": "Виклик до дії",
  "schedule": "Розклад",
  "insert_text": "Вставити текст",
  "select": "Вибрати",
  "select_all": "Вибрати все",
  "n_selected": "Вибрано: {count}",
  "clear_selection": "Очистити вибір",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Розклад",
  "language": "Мова",
  "calendar": "Календар",
  "operation": "Операція",
  "daily": "Щоденно",
  "weekly": "Щотижня",
  "monthly": "Щомісяця",
  "quarterly": "Квартально",
  "yearly": "Щорічно",
  "sunday": "Неділя",
  "monday": "Понеділок",
  "tuesday": "Вівторок",
  "wednesday": "Середа",
  "thursday": "Четвер",
  "friday": "П'ятниця",
  "saturday": "Субота",
  "january": "Січень",
  "february": "Лютий",
  "march": "Березень",
  "april": "Квітень",
  "may": "Травень",
  "june": "Червень",
  "july": "Липень",
  "august": "Серпень",
  "september": "Вересень",
  "october": "Жовтень",
  "november": "Листопад",
  "december": "Грудень",
  "1st week": "Перший тиждень",
  "2nd week": "Другий тиждень",
  "3rd week": "Третій тиждень",
  "4th week": "Четвертий тиждень",
  "5th week": "П'ятий тиждень",
  "1st quarter": "Перший квартал",
  "2nd quarter": "Другий квартал",
  "3rd quarter": "Третій квартал",
  "4th quarter": "Четвертий квартал",
  "edit_task": "Редагувати завдання",
  "created_at": "Створено",
  "installed_at": "Встановлено",
  "hour": "Година",
  "week_days": "Дні тижня",
  "month_weeks": "Тижні місяця",
  "month_days": "Дні місяця",
  "no_tasks_found": "Задачі не знайдено",
  "invalid_language": "Неправильна мова",
  "no_active_tasks_found": "Активні задачі не знайдено",
  "edit": "Редагувати",
  "send_date": "Відправити дату",
  "invalid_date": "Неправильна дата",
  "cells_num": "Кількість кабін",
  "sinks_num": "Кількість раковин",
  "urinals_num": "Кількість унітазів",
  "toilet_paper_size": "Розмір туалетного паперу",
  "email_configuration": "Налаштування електронної пошти",
  "please_edit_the_email_information": "Будь ласка, введіть інформацію про електронну пошту",
  "email_sender_info": "Відправник",
  "email_subject_info": "Тема повідомлення",
  "email_message_info": "Повідомлення",
  "companyName": "Назва компанії",
  "email_language": "Мова електронної пошти",
  "complaint_language": "Мова скарг",
  "email_message_format": "Формат повідомлення електронної пошти",
  "line": "Рядок",
  "list": "Список",
  "roomType": "Тип приміщення",
  "By logging in, you agree to Buzzztech's": "Логуючись, ви погоджуєтеся з умовами користування сервісом Buzzztech",
  "Terms and Conditions": "Умови користування",
  "and": "і",
  "Privacy Policy": "Політика конфіденційності",
  "All actions within this panel are recorded for quality control and improvement": "Всі дії в цій панелі записуються для контролю якості та покращення",
  "You must agree to the terms and conditions": "Ви повинні погодитися з умовами користування",
  "months": "Місяці",
  "ref_id": "ID посилання",
  "room_name_en": "Назва приміщення (EN)",
  "site_state": "Штат",
  "site_city": "Місто",
  "site_country": "Країна",
  "first_date": "Перша дата",
  "pinned": "Закріплено",
  "no.": "№",
  "must_be_numbers": "Повинно бути числом",
  "must_be_3_digits": "Мінімум 3 цифри",
  "must_have_english_title": "Має мати англійський заголовок",
  "total_sites": "Загальна кількість будівель",
  "site_information": "Інформація про будівлю",
  "holiday_offdays": "Свята та вихідні",
  "add_offday": "Додати вихідний",
  "add_holiday": "Додати свято",
  "name_under_chars": "назва менше 25 символів",
  "days_comma_separated": "дні, розділені комою",
  "year": "рік",
  "month": "місяць",
  "day": "день",
  "holiday_name": "назва свята",
  "offday_name": "назва вихідного дня",
  "delete_confirmation_title": "Ви впевнені?",
  "delete_confirmation_message": "Цю дію неможливо скасувати.",
  "are_you_sure": "Ви впевнені?",
  "israel": "Ізраїль",
  "USA": "США",
  "poland": "Польща",
  "mexico": "Мексика",
  "cyprus": "Кіпр",
  "brazil": "Бразилія",
  "romania": "Румунія",
  "netherlands": "Нідерланди",
  "tablet_survey": "Опитування з планшетом",
  "no_shift_survey": "Відсутнє опитування про зміни",
  "number_of_rows": "Кількість рядків",
  "rating_shape": "Форма оцінки",
  "content_survey": "Зміст опитування",
  "rating_survey": "Оцінка опитування",
  "device-alerts": "Попередження",
  "device-active": "Активний",
  "device-search": "Пошук",
  "mac_id": "MAC-адреса",
  "qr_tag": "QR-код",
  "sensor": "Датчик",
  "image_survey": "Опитування зображення",
  "open_text": "Відкритий текст",
  "open_text_survey": "Опитування тексту",
  "embedded_link": "Вбудоване посилання",
  "device-counter": "Лічильник пристроїв",
  "count": "Кількість",
  "last_date": "Остання дата",
  "last_arrival":"Останній прихід",
  "cleaners": "Прибиральники",
  "viewer": "Переглядач",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "Користувачів не знайдено",
  "cleaner_activity": "Активність прибиральників",
  "pad_presence_testing": "Тест присутності біля пада",
  "pad_presence_testing_subtitle": "Входи, виходи та офлайн-натискання пада, передані з телефону, для вибраного об’єкта",
  "pad_presence_timeline": "Жива стрічка",
  "pad_presence_sessions": "Сесії присутності",
  "pad_presence_offline_presses": "Офлайн-натискання з телефонів",
  "pad_presence_select_site_hint": "Виберіть компанію та об’єкт у шапці, щоб переглядати події присутності.",
  "pad_presence_no_events": "У цьому періоді немає подій присутності.",
  "pad_presence_open": "Відкрито",
  "pad_presence_exit_phone": "Вихід із телефону",
  "pad_presence_exit_auto": "Автовихід",
  "pad_presence_exit_stale": "Застарілий вихід",
  "pad_presence_enter": "Вхід",
  "pad_presence_exit": "Вихід",
  "pad_presence_offline": "Офлайн-натискання",
  "pad_presence_faulty": "Помилкове",
  "pad_presence_employee": "Працівник",
  "pad_presence_room": "Кімната",
  "pad_presence_time_from": "З",
  "pad_presence_last_updated": "Оновлено",
  "pad_presence_duration": "Тривалість",
  "pad_presence_exit_type": "Тип виходу",
  "pad_presence_button": "Кнопка",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Лічильник",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Усі працівники",
  "pad_presence_all_rooms": "Усі кімнати",
  "pad_presence_load_error": "Не вдалося завантажити дані присутності біля пада.",
  "pad_presence_in_room_now": "Зараз у кімнаті",
  "pad_presence_in_room": "у",
  "pad_presence_since": "з",
  "pad_presence_just_now": "Щойно",
  "pad_presence_pad": "Пад",
  "pad_presence_phone": "Телефон",
  "pad_presence_all_phones": "Усі телефони",
  "pad_presence_window": "Показати",
  "pad_presence_window_hour": "Остання година",
  "pad_presence_window_today": "Сьогодні",
  "pad_presence_window_month": "Останній місяць",
  "pad_presence_pads": "Пади на цьому об’єкті",
  "pad_presence_no_pads": "На цьому об’єкті пади не призначені кімнатам.",
  "pad_presence_last_enter": "Останній вхід",
  "pad_presence_last_offline": "Останнє офлайн-натискання",
  "pad_presence_auto_exit_leave": "Вийдіть зараз → автовихід через",
  "pad_presence_auto_exit_earliest": "Найраніше від входу:",
  "pad_presence_auto_exit_passed": "Найраніший час автовиходу минув. Досі відкрито = пад досі чути, або вийдіть і зачекайте 5хв 45с.",
  "cleaner_activity_live_footer": "Дані оновлюються в реальному часі",
  "ca_empty_select_site_hint": "Оберіть компанію та об'єкт у заголовку, щоб переглянути активність прибиральників за сьогодні.",
  "ca_empty_no_cleaners_hint": "Немає прибиральників, призначених на цей об'єкт і поточну зміну. Призначте активні об'єкти та зміни в Користувачах.",
  "ca_empty_access_denied": "Доступ заборонено",
  "ca_empty_access_denied_hint": "У вас немає дозволу переглядати активність прибиральників для цього об'єкта.",
  "ca_empty_load_error_hint": "Не вдалося завантажити активність. Спробуйте ще раз або зверніться до підтримки, якщо проблема не зникне.",
  "ca_empty_no_filter_match": "Немає прибиральників за цими фільтрами",
  "ca_empty_no_filter_match_hint": "Спробуйте очистити фільтри або оберіть іншого прибиральника, робочу зону чи кімнату.",
  "ca_timeline_all_cleaners": "Активність за сьогодні — усі прибиральники",
  "ca_legend_work": "Активний",
  "ca_clock_sessions_more": "ще",
  "ca_clock_sessions_less": "Показати менше",
  "ca_sort_label": "Сортування",
  "ca_sort_needs_attention": "Потребує уваги",
  "ca_sort_best_avg_response": "Найкращий середній час відповіді",
  "ca_sort_worst_avg_response": "Найгірший середній час відповіді",
  "ca_sort_most_sla_breaches": "Найбільше порушень SLA",
  "ca_sort_most_open_complaints": "Найбільше відкритих скарг",
  "ca_sort_most_work_time": "Найбільше робочого часу",
  "ca_sort_least_work_time": "Найменше робочого часу",
  "ca_stat_avg_short": "сер.",
  "ca_stat_open_short": "відкр.",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "робота",
  "ca_assigned_room_avg_hint": "Середній час відповіді для призначених кімнат сьогодні",
  "ca_transit_tooltip": "Час переходу між завданнями",
  "ca_transit_live_tooltip": "Час від закриття останнього завдання",
  "ca_legend_visits": "Відвідування між викликами",
  "ca_visits_between_sla": "Відвідування з моменту закриття попереднього виклику",
  "ca_apply": "Застосувати",
  "ca_visits_since": "з",
  "ca_deferred_tip_title": "Відкладена скарга",
  "ca_deferred_tip_resolved": "Вирішено",
  "ca_deferred_tip_desc_open": "Ще відкрита — прибиральник спершу обслужив інші кімнати замість цієї.",
  "ca_deferred_tip_desc_closed": "Ця скарга залишалася відкритою, поки прибиральник спершу обслуговував інші кімнати.",
  "ca_deferred_tip_rooms_label": "Обслужено спершу:",
  "ca_attention_title": "Потребує уваги",
  "ca_attention_empty": "Усе добре — проблем немає",
  "ca_attention_sla_breach_one": "{name} · порушення SLA",
  "ca_attention_sla_breach_many": "{name} · {count} порушень SLA",
  "ca_attention_open_while_out_one": "{name} · відкрита скарга поза зміною",
  "ca_attention_open_while_out_many": "{name} · {count} відкритих поза зміною",
  "ca_attention_idle": "{name} · простій {duration}",
  "ca_attention_late": "{name} · запізнення на зміну",
  "ca_attention_show": "Показати",
  "ca_attention_hide": "Сховати",
  "ca_view_shift": "Зміна",
  "ca_view_history": "Історія",
  "ca_filters_done": "Готово",
  "ca_hist_preset_this_month": "Цей місяць",
  "ca_hist_preset_last_month": "Минулий місяць",
  "ca_hist_preset_this_week": "Цей тиждень",
  "ca_hist_preset_last_week": "Минулий тиждень",
  "ca_hist_preset_custom": "Власний",
  "ca_hist_from": "З",
  "ca_hist_to": "По",
  "ca_hist_range_invalid": "Дата початку має бути раніше дати завершення",
  "ca_hist_range_too_long": "Період не може перевищувати {max} днів",
  "ca_hist_search": "Пошук за ім'ям або телефоном",
  "ca_hist_people_count": "{count} працівників",
  "ca_hist_kpi_days": "Відпрацьовано днів",
  "ca_hist_kpi_net": "Чисті години",
  "ca_hist_kpi_breaks": "Перерви",
  "ca_hist_col_person": "Працівник",
  "ca_hist_col_total": "Усього годин",
  "ca_hist_col_total_tip": "Від приходу до виходу без вирахування перерв — те саме значення, що бачить працівник у застосунку",
  "ca_hist_col_net": "Чисті години",
  "ca_hist_col_breaks": "Перерви",
  "ca_hist_col_issues": "Зауваження",
  "ca_hist_col_late": "Запізнення",
  "ca_hist_col_missed": "Пропуск",
  "ca_hist_col_no_clock_out": "Без виходу",
  "ca_hist_clocked_in_now": "Зараз на зміні",
  "ca_hist_not_assigned": "Не закріплений за цим об'єктом",
  "ca_hist_no_shift": "Зміну не призначено",
  "ca_hist_unknown_name": "Невідомо",
  "ca_hist_empty": "Немає відвідуваності за цей період",
  "ca_hist_empty_hint": "На цьому об'єкті ніхто не відмічався, і до нього не закріплено працівників.",
  "ca_hist_no_match": "Немає працівників, що відповідають фільтрам",
  "ca_hist_load_error_hint": "Не вдалося завантажити історію відвідуваності. Спробуйте ще раз за мить.",
  "ca_hist_prev_person": "Попередній працівник",
  "ca_hist_next_person": "Наступний працівник",
  "ca_hist_close": "Закрити",
  "ca_hist_legend_worked": "Працював",
  "ca_hist_legend_late": "Запізнення",
  "ca_hist_legend_missed": "Пропуск",
  "ca_hist_legend_no_clock_out": "Без виходу",
  "ca_hist_late_by": "Запізнення {duration}",
  "ca_hist_late_tip": "Прихід о {time}, {shift} починається о {start}",
  "ca_hist_missed": "Пропуск",
  "ca_hist_missed_tip": "Запланована зміна завершилася без відмітки приходу",
  "ca_hist_no_clock_out": "Без виходу",
  "ca_hist_no_clock_out_tip": "Сесію не закрито; її години не враховуються",
  "ca_hist_in_progress": "Досі на зміні",
  "ca_hist_auto": "авто",
  "ca_hist_open_break": "відкрита",
  "ca_hist_day_col_gross": "Усього годин",
  "ca_hist_day_col_breaks": "Перерви",
  "active_cleaners": "Активні прибиральники",
  "closed_complaints": "Закриті скарги",
  "total_work_time": "Загальний час роботи",
  "total_work_time_net": "Загальний час роботи (сьогодні нетто)",
  "total_break_time": "Загальний час перерв",
  "avg_response_time": "Середній час вирішення",
  "cleaner": "Прибиральник",
  "clocked_in": "Відмітка приходу",
  "clocked_out": "Відмітка виходу",
  "still_clocked_in": "Ще на зміні",
  "clocked_in_late": "Пізня відмітка входу",
  "total_hours": "Усього годин",
  "auto_punch": "Авто (геозона)",
  "manual_punch": "Вручну",
  "complaint_opened": "Скаргу відкрито",
  "complaint_closed": "Скаргу закрито",
  "complaint_still_open": "Ще відкрита",
  "resolved_in": "Вирішено за",
  "open_for": "Відкрита вже",
  "sla_breached": "Порушення SLA",
  "no_activity_today": "Сьогодні ще немає активності",
  "just_now": "щойно",
  "ago": "тому",
  "today": "Сьогодні",
  "live": "У реальному часі",
  "last_updated": "Оновлено",
  "no_cleaners_found": "Прибиральники не знайдені",
  "new_cleaner": "Новий прибиральник",
  "edit_cleaner": "Редагувати прибиральника",
  "have_you_finished_making_changes": "Ви закінчили вносити зміни?",
  "assignment_issues_found": "Знайдено проблеми з призначеннями",
  "unassigned_rooms_title": "Непризначені кімнати",
  "overlapping_assignments_title": "Перетин призначень",
  "and_n_more": "і ще {count}",
  "continue_anyway": "Продовжити все одно",
  "stay_and_fix": "Залишитись і виправити",
  "assignment_coverage_issues": "{unassigned} без призначення · {overlaps} перетинів",
  "assignment_check_failed": "Не вдалося перевірити призначення кімнат",
  "tap_for_details": "Натисніть для деталей",
  "has_app": "Додаток",
  "has_app_tooltip": "Прибиральник має додаток",
  "notifications_tooltip": "Push-сповіщення увімкнено",
  "assigned_to_rooms": "Призначено до кімнат",
  "assigned_to_rooms_tooltip": "Призначено кімнати на об'єкті",
  "recently_active": "Нещодавно активний",
  "works_at_site": "Працює на об'єкті",
  "recently_active_tooltip": "Відкривав додаток за останні 30 хвилин",
  "please_select": "Будь ласка, виберіть",
  "please_select_site_first": "Будь ласка, спочатку виберіть сайт",
  "working_areas": "Робочі зони",
  "no_working_areas": "Робочих зон ще немає",
  "working_area_alerts": "Сповіщення",
  "api": "API",
  "please_create_room_before_working_area": "Будь ласка, створіть принаймні одну кімнату перед створенням робочої зони",
  "isWorkingInSite": "Працює на місці",
  "you_are_not_allowed_to_edit": "Вам не дозволено редагувати",
  "you_are_not_allowed_to_remove": "Вам не дозволено видаляти",
  "task": "Завдання",
  "portuguese": "Португальська",
  "russian": "Російська",
  "spanish": "Іспанська",
  "polish": "Польська",
  "installer": "Інсталятор",
  "once": "Одного разу",
  "time_saved": "Збережений час",
  "yes": "Так",
  "no": "Ні",
  "workingAreaNames": "Назви робочих зон",
  "shift_rooms":"Приміщення",
  "new_shift":"Нова зміна",
  "add_shift_inactive": "Додати неактивні зміни",
  "remove_auto_shift_inactive": "Видалити автоматичні неактивні зміни",
  "additional_options": "Додаткові опції",
  "add_default_shifts": "Додати типові зміни",
  "no_user_found": "Користувача не знайдено",
  "no_site_found": "Не знайдено будівлі",
  "service_provider": "Постачальник послуг",
  "qr task": "QR-код завдання",
  "qr_task": "QR-код завдання",
  "all_day": "Весь день",
  "auto_start": "Автозапуск",
  "english_title": "Англійський заголовок",
  "connectivity": "Підключення",
  "power": "Живлення",
  "Your work has been saved": "Вашу роботу збережено",
  "schedule_call_time": "Час виклику",
  "schedule_call_gap": "Інтервал виклику",
  "gapInMinutes": "Інтервал в хвилинах",
  "no_manual_calls_available": "Немає доступних вручну викликів",
  "manual_calls": "Вручні виклики",
  "cleandex_calls": "Виклики Cleandex",
  "cleandexCalls": "Виклики Cleandex",
  "manualCalls": "Вручні виклики",
  "inactive": "Неактивний",
  "on hold": "На утриманні",
  "sequential": "Послідов",
  "ratio": "Відношення",
  "must_choose": "Потрібно вибрати",
  "surveyApp": "Додаток опитування",
  "installation": "Установка",
  "manager": "Менеджер",
  "previous": "Попередній",
  "next": "Наступний",
  "no_rooms_found": "Кімнати не знайдені",
  "show_calendar": "Показати календар",
  "seeAll": "Показати все",
  "showPaginated": "Показати по сторінках",
  "cleaners_arrivals": "Прибиральники прибули",
  "add_address": "Додати адресу",
  "site_auto_attendance_enabled":
    "Дозволити автоматичну реєстрацію входу й виходу через геозону в мобільному застосунку (потрібний дозвіл на локацію).",
  "site_auto_attendance_requires_location":
    "Спочатку задайте на карті точку та радіус щонайменше 100 м, потім увімкніть автоматичний облік.",
  "site_mandatory_clock_in": "Вимагати відмітку приходу перед роботою",
  "site_mandatory_clock_in_description":
    "Працівники цього об'єкта повинні відмітити прихід, перш ніж зможуть відкрити розділи прибирання, обслуговування та завдань у мобільному застосунку.",
  "site_mandatory_clock_in_without_location":
    "Для цього об'єкта не задано місце на карті, тому застосунок не може визначити, чи працівник на об'єкті. Доки місце не задано, вимога діє для цих працівників усюди.",
  "edit_address": "Редагувати адресу",
  "choose_radius": "Виберіть радіус",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Зелений = OK. Червоний = Рекомендовано прибирання. Наведіть на значок для деталей.",
  "recommended_to_clean": "Рекомендовано прибирання",
  "cleandex_warning_level": "Рівень попередження Cleandex",
  "select_warning_level": "Виберіть рівень попередження",
  "bronze": "Бронза",
  "silver": "Срібло",
  "gold": "Золото",
  "ai": "Штучний інтелект",
  "daily_employees_num": "Щоденна кількість працівників",
  "daily_shift_hours": "Щоденні робочі години",
  "rooms_num": "Кількість кімнат",
  "buildings_num": "Кількість будівель",
  "cleaner_entries": "Кількість входів прибиральників",
  "avg_daily_visits_monthly": "Середній щоденний візит за місяць",
  "avg_daily_cleaners_to_save": "Середня кількість прибиральників для економії за день",
  "saving_hours_per_day": "Зекономлені години за день",
  "saving_money_per_day": "Економія коштів за день",
  "saving_money_per_month": "Економія коштів за місяць",
  "cleaners_to_visitors_ratio": "Співвідношення прибиральників до відвідувачів",
  "cleaning_time_in_minutes_per_room": "Час прибирання у хвилинах на кімнату",
  "max_number_of_rooms_per_employee": "Максимальна кількість кімнат на одного працівника",
  "break_time_per_hour": "Час перерви за годину",
  "transition_time_between_tasks": "Час переходу між завданнями",
  "employer_cost_hour": "Вартість роботодавця за годину",
  "lobby_cleaning_per_floor": "Прибирання лобі на поверх",
  "desired_cleaning_time": "Бажаний час прибирання",
  "desired_number_of_entries": "Бажана кількість входів",
  "buzz_system_cost_per_unit_per_month": "Вартість системи Buzz за одиницю на місяць",
  "total_buzz_system_cost_per_month": "Загальна вартість системи Buzz на місяць",
  "return_on_investment_in_months": "Окупність у місяцях",
  "annual_savings": "Річна економія",
  "roi_calculator": "Калькулятор окупності",
  "cleaners_number": "Кількість прибиральників",
  "floors_num": "Кількість поверхів",
  "avg_daily_cleaners_required": "Середня кількість прибиральників, необхідних щоденно",
  "app_pages": "Сторінки додатка",
  "buzzzTime": "Час Buzzz",
  "missions": "Місії",
  "send_emails": "Надіслати імейли",
  "enter": "Введіть",
  "account": "Обліковий запис",
  "privacy": "Конфіденційність",
  "personal_settings": "Особисті налаштування",
  "personal_settings_lead": "Мова та налаштування конфіденційності.",
  "personal_settings_read_only": "Дані керує адміністратор. Зверніться до нього для змін.",
  "change_password": "Змінити пароль",
  "change_password_hint": "Зміна пароля завершить сеанси на інших пристроях.",
  "current_password": "Поточний пароль",
  "new_password": "Новий пароль",
  "confirm_new_password": "Підтвердьте новий пароль",
  "password_min_length": "Пароль має містити щонайменше 8 символів",
  "passwords_do_not_match": "Паролі не збігаються",
  "new_password_same_as_current": "Новий пароль має відрізнятися від поточного",
  "current_password_incorrect": "Поточний пароль неправильний",
  "current_password_required": "Введіть поточний пароль",
  "password_changed_successfully": "Пароль успішно змінено",
  "change_password_failed": "Не вдалося змінити пароль",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "Неправильне імʼя користувача або пароль",
  "login_credentials_required": "Введіть імʼя користувача або email і пароль",
  "login_network_error": "Не вдалося зʼєднатися із сервером. Перевірте зʼєднання та спробуйте знову",
  "login_failed": "Не вдалося увійти. Спробуйте знову",
  "login_too_many_attempts": "Забагато спроб входу. Зачекайте 15 хвилин і спробуйте знову.",
  "forgot_password_too_many": "Забагато запитів на скидання пароля. Зачекайте годину і спробуйте знову.",
  "reset_password_too_many": "Забагато спроб скидання пароля. Зачекайте годину і спробуйте знову.",
  "change_password_too_many": "Забагато спроб зміни пароля. Зачекайте 15 хвилин і спробуйте знову.",

  "personal_settings_language_hint": "Для всього порталу в цьому браузері.",
  "personal_settings_privacy_hint": "Запит на видалення персональних даних відповідно до законів.",
  "personal_settings_role": "Роль",
  "Request deletion of my data": "Запросити видалення моїх даних",
  "Request deletion of my data - confirm": "Запросити видалення моїх даних? Адміністратору буде надіслано лист. Ми обробимо запит протягом 30 днів.",
  "Request deletion of my data - success": "Запит надіслано. Ми обробимо його протягом 30 днів.",
  "Request deletion of my data - error": "Не вдалося надіслати. Спробуйте знову або напишіть на privacy@buzzztech.com.",
  "metrics": "Метрики",
  "select_three_metrics": "Виберіть до 3 метрик для порівняння",
  "select_four_metrics": "Виберіть до 4 метрик для порівняння",
  "legend": "Легенда",
  "more_details": "Детальніше",
  "performance_overview": "Огляд продуктивності",
  "loading_chart": "Завантаження графіка",
  "retry": "Спробувати ще раз",
  "performance_trending_upward": "Продуктивність зростає",
  "high_complaint_ratio": "Високий рівень скарг",
  "click_bars_for_details": "Натисніть на стовпці для перегляду щоденної аналітики",
  "refresh": "Оновити",
  "table": "Таблиця",
  "cards": "Картки",
  "no_recent_arrivals": "Немає останніх прибуттів",
  "feedback_charts": "Графіки зворотного зв’язку",
  "general_overview": "Загальний огляд",
  "cleaning_complaints_breakdown": "Розподіл скарг на прибирання",
  "maintenance_complaints_breakdown": "Розподіл скарг на обслуговування",
  "refresh_failed": "Не вдалося оновити",
  "data_exported_successfully": "Дані успішно експортовано",
  "data_export_failed": "Не вдалося експортувати дані",
  "drill_down_unavailable": "Деталізація доступна лише в денному перегляді",
  "sort_by": "Сортувати за",
  "no_active_shift": "Немає активної зміни",
  "check_site_and_shift": "Будь ласка, перевірте, чи вибрано об'єкт і чи є активна зміна",
  "please_add_shift_first": "Будь ласка, спочатку додайте зміну",
  "cleandex_no_data_message": "Дані Cleandex наразі недоступні",
  "task_no_data_message": "Дані про завдання наразі недоступні",
  "navigation": "Навігація",
  "network_information": "Інформація про мережу",
  "target_effectiveness": "Ефективність цілі",
  "cleandex_call_cleaner": "Виклик прибиральника Cleandex",
  "top_complaint": "Найпоширеніша скарга",
  "no_complaints": "Немає скарг",
  "official_start_date": "Офіційна дата початку",
  "note_text": "Текст примітки",
  "add_note": "Додати примітку",
  "general_note": "Загальна примітка",
  "general_note_short": "Загальна",
  "battery_short": "Батарея",
  "panel_short": "Панель",
  "technician_short": "Технік",
  "battery_replacement": "Заміна батареї",
  "device_maintenance": "Обслуговування пристрою",
  "maintenance_type": "Тип обслуговування",
  "panel_change": "Заміна панелі",
  "technician_check": "Перевірка техніком",
  "enter_note_details": "Введіть деталі примітки",
  "replacement_date": "Дата заміни",
  "replaced_by_name": "Замінено ким",
  "replacement_note": "Примітка до заміни",
  "enter_replacement_details": "Введіть деталі заміни",
  "replacement_history": "Історія замін",
  "loading_history": "Завантаження історії",
  "no_replacement_history": "Історія замін недоступна",
  "enter_technician_name": "Введіть ім’я техніка",
  "user_information": "Інформація про користувача",
  "enter_change_details": "Введіть деталі зміни",
  "panel_change_history": "Історія замін панелі",
  "check_date": "Дата перевірки",
  "checked_by_name": "Перевірено ким",
  "enter_check_details": "Введіть деталі перевірки",
  "technician_check_history": "Історія перевірок техніком",
  "no_technician_check_history": "Історія перевірок техніком недоступна",
  "change_date": "Дата зміни",
  "changed_by_name": "Змінено ким",
  "change_note": "Примітка до зміни",
  "check_note": "Примітка до перевірки",
  "replaced_by": "Заменено ким",
  "no_data_entered": "Дані не введено",
  "invalid_username": "Невірне ім'я користувача",
  "invalid_phone": "Невірний номер телефону",
  "username_must_be_at_least_5_characters": "Ім'я користувача повинно містити щонайменше 5 символів",
  "open_slas": "Відкриті SLA",
  "open_sla_alerts": "Відкриті сповіщення про скарги",
  "open_duration": "Відкрита тривалість",
  "open_complaints": "Відкриті скарги",
  "site_alerts": "Сповіщення про сайти",
  "rooms_with_open_complaints_percentage": "Кімнати з відкритими скаргами",
  "rooms_with_cleaner_arrival_percentage": "Кімнати з прибуттям прибиральника",
  "rooms_without_cleaner_arrival_percentage": "Кімнати без прибуття прибиральника",
  "site_alerts_total_rooms": "Всього кімнат",
  "site_alerts_open_complaints_count": "Кількість відкритих скарг",
  "site_alerts_customer_opening_date": "Дата відкриття клієнта",
  "company_country": "Країна компанії",
  "select_message": "Виберіть повідомлення",
  "message_no_cleaner_arrival": "Всім привіт,\nБудь ласка, зверніть увагу, що є кімнати, де сьогодні не було зареєстровано прибуття прибиральника.\nБудь ласка, займіться цим",
  "message_open_complaints": "Всім привіт,\nБудь ласка, зверніть увагу, що є кілька кімнат з відкритими скаргами протягом тривалого часу.\nБудь ласка, займіться цим",
  "rooms_list": "Кімнати:",
  "no_open_slas": "Відкриті SLA не знайдено",
  "no_open_slas_description": "Наразі немає сайтів з відкритими SLA.",
  "no_slas_to_send": "Відкриті SLA для цього сайту не знайдено",
  "total_open_complaints": "Загальна кількість відкритих скарг",
  "longest_duration": "Найдовша тривалість",
  "complaints_details": "Деталі скарг",
  "no_results_found": "Результатів не знайдено",
  "whatsapp": "WhatsApp",
  "loading": "Завантаження",
  "error_opening_whatsapp": "Помилка відкриття WhatsApp. Будь ласка, спробуйте ще раз.",
  "error_loading_slas": "Помилка завантаження деталей SLA. Будь ласка, спробуйте ще раз.",
  "send_whatsapp": "Надіслати WhatsApp",
  "more_options": "Більше опцій",
  "preview_message": "Попередній перегляд повідомлення",
  "copy_message": "Копіювати повідомлення",
  "message_preview": "Попередній перегляд повідомлення",
  "phone_number_optional": "Номер телефону (необов'язково)",
  "enter_phone_number": "Введіть номер телефону (наприклад, +380501234567)",
  "phone_number_hint": "Залиште порожнім, щоб відкрити WhatsApp без конкретного контакту",
  "message_copied": "Повідомлення скопійовано в буфер обміну!",
  "error_copying_message": "Помилка копіювання повідомлення. Будь ласка, спробуйте ще раз.",
  "opening_whatsapp": "Відкриття WhatsApp...",
  "data_loading_please_wait": "Дані завантажуються. Будь ласка, зачекайте...",
  "dates_not_changed": "Дати не змінилися. Перезавантаження не потрібне.",
  "date_outside_stats_range": "Вибрані дати поза доступним діапазоном статистики.",

  "date_range_invalid": "Дата «До» має бути не раніше дати «Від».",
  "filter_help_text": "Правила фільтрації: Спочатку виберіть Будівлю, щоб увімкнути фільтр Поверху. Більшість фільтрів підтримують множинний вибір.",
  "select_building_first": "Будь ласка, спочатку виберіть Будівлю, щоб увімкнути фільтр Поверху",
  "cannot_select_gender_with_rooms": "Неможливо вибрати тип приміщення, коли вибрані приміщення",
  "cannot_select_gender_with_rooms_tooltip": "Фільтр типу приміщення не можна використовувати, коли вибрані приміщення. Спочатку очистіть вибір приміщень.",
  "cannot_select_building_with_rooms": "Неможливо вибрати будівлю, коли вибрані кімнати",
  "cannot_select_building_with_rooms_tooltip": "Фільтр будівлі не може бути використаний, коли вибрані кімнати. Будь ласка, спочатку очистіть вибір кімнат.",
  "multi_select_hint": "Ви можете вибрати кілька варіантів",
  "filter_applied": "Фільтр успішно застосовано",
  "no_filters_selected": "Фільтри не вибрані. Виберіть принаймні один варіант фільтрації.",
  "filters": "Фільтри",
  "location": "Розташування",
  "attributes": "Атрибути",
  "applying": "Застосування...",
  "active_filters": "Активні фільтри",
  "viewing_room": "Перегляд кімнати",
  "multiple": "Множинний",
  "close": "Закрити",
  "save_replacement": "Зберегти заміну",
  "save_change": "Зберегти зміну",
  "save_check": "Зберегти перевірку",
  "failed_to_load_maintenance_history": "Не вдалося завантажити історію обслуговування",
  "Battery replacement recorded successfully": "Заміна батареї успішно записана",
  "Panel change recorded successfully": "Зміна панелі успішно записана",
  "Technician check recorded successfully": "Перевірка техніком успішно записана",
  "no_network_data_available": "Немає даних мережі",
  "basic_information": "Основна інформація",
  "service_providers": "Постачальники послуг",
  "settings_alerts": "Налаштування та сповіщення",
  "configuration": "Конфігурація",
  "contact_settings": "Контакти та налаштування",
  "notifications": "Сповіщення",
  "alert_language": "Мова сповіщень",
  "select_language": "Виберіть мову",
  "features": "Функції",
  "chat_ask_stats": "Запитати статистику",
  "chat_ask_buzzz": "Запитати Buzzz",
  "chat_stats_assistant": "Помічник зі статистики",
  "chat_buzzz_assistant": "Помічник Buzzz",
  "chat_clear": "Очистити",
  "chat_placeholder": "Запитайте про статистику прибирання, наприклад \"Скільки скарг за минулий тиждень?\" або \"Які кімнати потребують уваги?\"",
  "chat_placeholder_context": "Запитайте про {scope}, наприклад \"Скільки скарг?\" або \"Які кімнати потребують уваги?\"",
  "chat_thinking": "Думаю…",
  "chat_input_placeholder": "Запитайте про відвідування, скарги, кімнати…",
  "chat_send": "Надіслати",
  "chat_chip_summary": "Підсумок",
  "chat_chip_worst_rooms": "Найгірші кімнати",
  "chat_chip_counter_calls": "Виклики лічильника",
  "chat_chip_sla_issues": "Проблеми SLA",
  "chat_chip_busiest_hours": "Найзавантаженіші години",
  "chat_chip_help": "Що можна запитати?",
  "chat_chip_focus": "На чому зосередитись?",
  "chat_chip_improving": "Які кімнати покращуються?",
  "chat_chip_best_rooms": "Найкращі кімнати за оцінкою",
  "chat_chip_worst_days": "Найгірші дні",
  "chat_chip_complaint_types": "Типи скарг",
  "chat_chip_positive_feedback": "Позитивні відгуки",
  "chat_suggestions": "Пропозиції",
  "chat_error": "Щось пішло не так. Спробуйте ще раз.",
  "chat_copy": "Копіювати",
  "chat_copied": "Скопійовано!",
  "chat_retry": "Повторити",
  "chat_chip_compare_periods": "Порівняти з попереднім періодом",
  "chat_chip_briefing": "Ранковий брифінг",
  "chat_chip_cleaning_priority": "Пріоритет прибирання",
  "chat_chip_live_status": "Поточний статус",
  "chat_chip_shift_stats": "Ефективність змін",
  "chat_chip_staff_status": "Хто зараз на роботі?",
  "chat_chip_why_drilldown": "Чому? Деталізація",
  "chat_pin": "Додати до обраного",
  "chat_unpin": "Видалити з обраного",
  "chat_share": "Надіслати поштою",
  "chat_export": "Експорт",
  "chat_helpful": "Корисно",
  "chat_not_helpful": "Не корисно",
  "chat_hide": "Сховати помічника",
  "chat_stop": "Зупинити",
}

export const ro = {
  ...serviks.ro,
  "notified": "Notificat",
  "supervisor_arrival": "Sosirea supervizorului",
  "arrival": "Sosire",
  "arrival_badges": "Sosiri în tură",
  "callsHistory": "Istoric apeluri",
  "openCalls": "Apeluri deschise",
  "visits_since_cleaned": "Vizite de la ultima curățenie",
  "visits_since_cleaned_short": "Vizite de la curățenie",
  "filter": "Filtru",
  "logo": "Logo",
  "counter": "Contor",
  "sms": "SMS",
  "shifts": "Schimburi",
  "call": "Apel",
  "duration": "Durată",
  "time_start": "Timpul de începere",
  "settings": "Setări",
  "always": "Întotdeauna",
  "off": "Dezactivat",
  "time_based": "Bazat pe timp",
  "location_based": "Bazat pe locație",
  "notification_mode": "Modul de notificare",
  "notification_times": "Orele de notificare",
  "notification_times_info": "Intervalele de timp sunt gestionate din aplicația mobilă",
  "notification_location": "Locația notificării",
  "notification_sound": "Sunetul notificării",
  "no_sound": "Fără sunet",
  "default_sound": "Sunet implicit",
  "soft_bell": "Clopot moale",
  "digital_sound": "Sunet digital",
  "mallet_sound": "Sunet de ciocan",
  "phone_sound": "Sunet de telefon",
  "text_sound": "Sunet de text",
  "manager_alert_delay": "Întârziere alertă manager",
  "snooze_interval": "Reminder",
  "vocal_notifications": "Notificări vocale",
  "no_delay": "Fără întârziere",
  "no_snooze": "Fără notificare",
  "lat": "Lat",
  "lon": "Lon",
  "radius": "Rază",
  "no_location_set": "Nu este setată locația",
  "when_to_notify": "Când să Notific",
  "notification_preferences": "Preferințe Notificări",
  "assignment_configuration": "Atribuire și Configurare",
  "status": "Status",
  "working_area": "Zonă de lucru",
  "complaints_NC": "Reclamații",
  "SLA_NC": "SLA",
  "arrivals_NC": "Sosiri",
  "staff": "Personal",
  "cleaning_complaints": "Reclamații de curățare",
  "export": "Export",
  "maintenance_complaints": "Reclamații de întreținere",
  "maintenanceArrivals": "Sosiri de întreținere",
  "maintenance_arrivals": "Sosiri de întreținere",
  "last": "Ultimul",
  "survey_name": "Numele sondajului",
  "survey": "Sondaj",
  "pad_survey": "Sondaj pad",
  "pad_no_maintenance_survey": "Sondaj pad fără întreținere",
  "pad_kitchen": "Bucătărie pad",
  "number_of_assigned_devices": "Numărul de dispozitive atribuite",
  "number_of_pages": "Numărul de pagini",
  "date_created": "Data creării",
  "updated_by": "Actualizat de",
  "date_updated": "Data actualizării",
  "search": "Căutare",
  "choose_type": "Alegeți tipul",
  "permitted_sites": "Site-uri permise",
  "permitted_franchise": "Franciză permisă",
  "permitted_companies": "Companii permise",
  "panel_permitted": "Panou permis",
  "end_time": "Timpul de încheiere",
  "last_update": "Ultima actualizare",
  "add_device": "Adăugați dispozitiv",
  "detailed": "Detaliat",
  "analysis": "Analiză",
  "suggestion": "Sugestie",
  "country": "Țară",
  "management": "Management",
  "device": "Dispozitiv",
  "mapping": "Hartă",
  "please_enter": "Vă rugăm să introduceți",
  "new_device": "Dispozitiv nou",
  "assign_device": "Atribuiți dispozitivul",
  "installSpot": "Locul de instalare",
  "device_type": "Tipul dispozitivului",
  "deviceCode": "Codul dispozitivului",
  "device_code": "Codul dispozitivului",
  "scan_or_enter_device_code": "Scanați sau introduceți codul dispozitivului...",
  "scan_device": "Atribui",
  "scan_qr_in_frame": "Aliniați codul QR în cadru. Pentru coduri mici, țineți telefonul la 15–25 cm distanță și atingeți previzualizarea pentru refocalizare dacă imaginea este neclară.",
  "checking_device_code": "Se verifică codul dispozitivului...",
  "camera_not_available": "Camera nu este disponibilă. Puteți introduce codul manual.",
  "device_code_already_exists": "Acest cod de dispozitiv este deja atribuit unui alt senzor.",
  "assigned_to_company_site_room": "Deja atribuit la {company} / {site} / {room}",
  "device_code_lookup_failed": "Codul dispozitivului nu a putut fi verificat. Încercați din nou.",
  "device_code_no_site_access": "Acest cod este deja înregistrat într-un loc la care nu aveți acces.",
  "device_code_check_unavailable": "Serverul nu a putut verifica codul. Încercați din nou.",
  "device_code_not_a_code": "Scanarea a citit „{code}”. Introduceți codul dispozitivului.",
  "device_code_open_failed": "Acest dispozitiv nu a putut fi deschis. Încercați din nou.",
  "device_code_save_failed": "Codul dispozitivului nu a putut fi salvat. Încercați din nou.",
  "device_code_save_forbidden": "Nu puteți modifica acest dispozitiv.",
  "confirm_replace_device_code": "Înlocuiți codul dispozitivului?",
  "confirm_replace_device_code_body": "Sigur doriți să înlocuiți codul {oldCode} cu {newCode}?",
  "room": "cameră",
  "edit_room": "Editați cameră",
  "edit_franchise": "Editați franciza",
  "new_franchise": "Franciză nouă",
  "desc": "Descriere",
  "address": "Adresă",
  "level": "Nivel",
  "no_companies_to_show": "Nu există companii de afișat",
  "company_type": "Tipul companiei",
  "region": "Regiune",
  "new_company": "Companie nouă",
  "edit_company": "Editați compania",
  "edit_user": "Editați utilizatorul",
  "C.arrivals": "Sosiri",
  "C.complaints": "Reclamații",
  "M.complaints": "Reclamații",
  "M.Arrivals": "Sosiri",
  "analyses": "Analize",
  "clean_log": "Jurnal de curățare",
  "maintenance_log": "Jurnal de întreținere",
  "like": "Asemănător",
  "likes": "Aprecieri",
  "new_user": "Utilizator nou",
  "shift_parameters": "Parametrii de schimb",
  "add_shift": "Adăugați schimb",
  "edit_shift": "Editați schimb",
  "username": "Nume de utilizator",
  "first_name": "Prenume",
  "job_function": "Funcție",
  "role": "Rol",
  "property_manager": "Manager de proprietate",
  "facility_manager": "Manager de facilități",
  "site_manager": "Manager de locație",
  "workplace_manager": "Manager de loc de muncă",
  "cleaning_company_ceo": "Director al companiei de curățenie",
  "operations_manager": "Manager operațional",
  "area_manager": "Manager de zonă",
  "site_cleaning_manager": "Manager de curățenie al locației",
  "cleaning_supervisor": "Supervizor de curățenie",
  "other": "Altele",
  "restroom_cleaner": "Curățenie grupuri sanitare",
  "general_cleaner": "Curățenie generală",
  "day_porter": "Îngrijitor de zi",
  "office_cleaner": "Curățenie birouri",
  "public_area_cleaner": "Curățenie zone publice",
  "firstName": "Prenume",
  "description": "Descriere",
  "last_name": "Nume",
  "lastName": "Nume",
  "phone": "Telefon",
  "building_area": "Zonă de construcție",
  "users": "Utilizatori",
  "add_user": "Adăugați utilizator",
  "sites": "Site-uri",
  "new_site": "Site nou",
  "edit_site": "Editați site-ul",
  "add_company": "Adăugați companie",
  "franchise": "Franciză",
  "floor": "Etaj", 
  "building": "Clădire", 
  "humidity": "Humidity",
  "temperature": "Temperature",
  "gender": "Tip de cameră",
  "display_name": "Numele afișat", 
  "zone": "Zonă", 
  "shift_number": "Numărul de schimburi",
  "shift": "Schimb",
  "shift_name": "Numele schimbului",
  "shift_currently_inactive": "Schimbul este în prezent inactiv",
  "local_time": "Local",
  "end": "Sfârșit", 
  "min_sla": "SLA minim", 
  "max_sla": "SLA maxim",
  "days": "Zile",  
  "complaints_percent": "Procentajul reclamațiilor", 
  "sla_percent": "Procentajul SLA", 
  "arrivals_percent": "Procentajul sosirilor", 
  "save_arrivals": "Salvați sosirile", 
  "clean_time": "Timp curățare (min)",
  "tooltip_shift_number": "Ordinea afișării schimbului (ex. 1, 2).",
  "tooltip_shift_name": "Numele schimbului (ex. Dimineață, Noapte).",
  "tooltip_start_time": "Ora de început a schimbului (ora locală).",
  "tooltip_end_time": "Ora de sfârșit a schimbului (ora locală).",
  "tooltip_cleaners_number": "Numărul de curățeni în acest schimb.",
  "tooltip_min_sla": "Timp minim de răspuns (min) la o plângere pentru sală; limita inferioară a scorului.",
  "tooltip_max_sla": "Timp maxim acceptabil de răspuns (min) la o plângere; limita superioară a scorului.",
  "tooltip_arrivals": "Sosiri curățenie așteptate per sală pe zi; scorul compară cu acest obiectiv.",
  "tooltip_save_arrivals": "Vizite curățenie per sală pe zi înainte de BuzzzTV; pentru timp economisit.",
  "tooltip_clean_time": "Minute per vizită curățenie în calculul timpului economisit (ex. 15).",
  "tooltip_complaints_percent": "Ponderea plângerilor în scorul sălii când există vizite.",
  "tooltip_response_time_SLA": "Ponderea timpului de răspuns în scorul sălii când există vizite.",
  "tooltip_arrivals_percent": "Ponderea sosirilor față de obiectiv în scorul sălii când există vizite.",
  "tooltip_complaints_NC": "Ponderea plângerilor în scor când nu există vizite (fără contor).",
  "tooltip_SLA_NC": "Ponderea timpului de răspuns în scor când nu există vizite.",
  "tooltip_arrivals_NC": "Ponderea sosirilor în scor când nu există vizite.",
  "tooltip_days": "Zilele săptămânii în care schimbul este activ.",
  "tooltip_active_calculation": "Când e activat, schimbul intră în scoruri și în timpul economisit.",
  "auto_close_complaints_hour": "Ora de închidere automată a reclamațiilor",
  "tooltip_auto_close_complaints_hour": "Ora locală la care SLA-urile de reclamații deschise în acest schimb sunt închise automat. Lăsați gol pentru dezactivare.",
  "auto_close_maintenance_complaints_hour": "Ora de închidere automată a reclamațiilor de mentenanță",
  "tooltip_auto_close_maintenance_complaints_hour": "Ora locală la care SLA-urile de reclamații de mentenanță deschise în acest schimb sunt închise automat. Lăsați gol pentru dezactivare.",
  "no_auto_close": "-- Niciunul --",
  "tooltip_shift_rooms": "Săli alocate acestui schimb. Lăsați gol pentru schimb la nivel de site.",
  "company_name": "Numele companiei",
  "site_name": "Numele site-ului",
  "site_desc": "Descrierea site-ului", 
  "service_provider_name": "Numele furnizorului de servicii", 
  "service_provider_type": "Tipul furnizorului de servicii", 
  "service_provider_desc": "Descrierea furnizorului de servicii",
  "user": "Utilizator", 
  "map": "Hartă", 
  "delete": "Șterge", 
  "remove": "Eliminați",
  "new_room": "Cameră nouă", 
  "issue_times": "Timpurile problemelor", 
  "solved": "Rezolvat", 
  "visits": "Vizite",
  "visits_also_went_up": "Vizitele au crescut de asemenea",

  "complaints": "Reclamații", 
  "cleaner_arrivals": "Sosirile curățătorului",   
  "unnecessary_arrivals": "Sosiri fără apel",
  "unnecessary_arrivals_hint": "O vizită a personalului de curățenie cât timp în cameră nu era niciun apel deschis.",
  "of_arrivals": "din sosiri",   
  "response_time_SLA": "Timpul de răspuns SLA",
  "score": "Scor", 
  "avg_score": "Scor mediu",
  "score_goal": "Scorul dorit",
  "top_problem_issues": "Cele mai mari probleme",
  "top_problem_rooms": "Cele mai mari probleme",
  "top_problem_hours": "Cele mai mari probleme",
  "is_time_save": "Este timpul salvat", 
  "est_ROI": "Estimarea ROI",
  "complaints_vs_visits": "Reclamații vs. Vizite",
  "view_by_years": "Vizualizare pe ani",
  "view_by_months": "Vizualizare pe luni",
  "view_by_weeks": "Vizualizare pe săptămâni",
  "view_by_days": "Vizualizare pe zile",
  "minutes": "Minute",
  "company": "Companie",
  "site": "Site",
  "alerts": "Alerte",
  "performance": "Performanță", 
  "devices": "Dispozitive",
  "total_devices": "Total Dispozitive",
  "working": "Funcționează",
  "warning": "Avertisment",
  "by_device_type": "După Tip de Dispozitiv",
  "surveys": "Sondaje", 
  "real_time": "Timp real",
  "real-time": "Timp real",
  "cleaner-activity": "Activitatea curățătorilor",
  "device-actions": "Acțiuni dispozitiv",
  "pad-presence-testing": "Test prezență pad",
  "real-time-cleaning": "Timp real - curățenie",
  "real-time-maintenance": "Timp real - mentenanță",
  "no_real_time_tabs_permitted": "Nu aveți permisiunea de a vedea nicio filă de timp real",
  "admin": "Admin",
  "all": "Toate",
  "overview": "Prezentare generală",
  "total": "Total",
  "analytics": "Analize",
  "pdf_export_title_analytics": "Analytics report",
  "pdf_export_title_cleaner_arrivals": "Cleaner arrivals",
  "communication": "Comunicare",
  "overview_complaints_devices_caption": "Dispozitive instalate (cumulativ)",
  "overview_complaints_devices_caption_hint": "Numărul total de dispozitive instalate la locație până la sfârșitul fiecărei luni, după datele de instalare.",
  "overview_complaints_devices_toggle_aria": "Afișează sau ascunde dispozitivele instalate sub graficul reclamațiilor",
  "communication_select_site_title": "Alege un site",
  "communication_select_site": "Selectează o companie și un site din filtrele de mai sus pentru a vedea și adăuga note pentru acea locație.",
  "communication_viewing_site": "Vizualizare",
  "communication_add_note": "Adaugă o notă",
  "communication_add_note_open_aria": "Deschide fereastra de adăugare notă",
  "communication_form_hint": "Partajează actualizări sau note cu toți cei care au acces la acest site. Vor vedea notele noi în timp real.",
  "communication_page_intro_title": "Note site — jurnal partajat pentru această locație",
  "communication_page_intro_body": "Folosiți pagina pentru schimb de tură, probleme, actualizări și note de ședință. Oricine are acces la acest site în portal poate citi și adăuga note.",
  "communication_page_intro_dismiss": "Ascunde sfatul",
  "communication_page_intro_aria": "Despre notele site-ului",
  "communication_content_placeholder": "Scrie nota aici...",
  "communication_keyboard_hint": "Ctrl+Enter pentru a publica",
  "communication_submitting": "Se publică...",
  "communication_submit": "Publică nota",
  "communication_recent_notes": "Note",
  "communication_search_placeholder": "Caută după autor sau text...",
  "communication_refresh": "Actualizează",
  "communication_clear_filters": "Șterge filtrele",
  "communication_search_aria_label": "Caută în note",
  "communication_submit_aria_label": "Publică nota",
  "communication_copy_note_aria_label": "Copiază textul notei",
  "communication_copied": "Copiat în clipboard.",
  "communication_copy_empty": "Această notă nu are text de copiat.",
  "communication_filter_hidden_one": "(1 notă ascunsă de filtre)",
  "communication_filter_hidden_many": "({n} note ascunse de filtre)",
  "communication_request_timeout": "Cererea a expirat. Încercați din nou.",
  "communication_load_failed": "Nu s-au putut încărca notele.",
  "communication_retry": "Încearcă din nou",
  "communication_no_matches": "Nicio notă nu corespunde căutării sau filtrelor. Încearcă să le ajustezi.",
  "communication_no_entries": "Încă nu există note.",
  "communication_no_entries_hint": "Adaugă o notă mai sus pentru a începe.",
  "communication_just_now": "Acum",
  "communication_minutes_ago": "acum {n} min",
  "communication_hours_ago": "acum {n} h",
  "communication_days_ago": "acum {n} zile",
  "communication_note_posted": "Notă publicată.",
  "communication_post_failed": "Nu s-a putut publica nota. Încearcă din nou.",
  "communication_note_type": "Tip notă",
  "communication_type_general": "General",
  "communication_type_update": "Actualizare",
  "communication_type_issue": "Problemă",
  "communication_type_follow_up": "Urmărire",
  "communication_type_meeting": "Notă întâlnire",
  "communication_filter_all_types": "Toate tipurile",
  "communication_pinned": "Fixat",
  "communication_pin": "Fixează",
  "communication_unpin": "Anulează fixarea",
  "communication_pin_limit": "Max. 2 fixate",
  "communication_pinned_toast": "Nota a fost fixată.",
  "communication_unpinned_toast": "Nota a fost desfixată.",
  "communication_pin_failed": "Nu s-a putut actualiza fixarea. Încearcă din nou.",
  "communication_note_not_found": "Nota nu a fost găsită sau nu aveți acces.",
  "communication_site_not_in_filters": "Site-ul acestei note nu este în filtrele curente. Este posibil să nu aveți acces la acea locație.",
  "communication_edit": "Editare",
  "communication_delete": "Ștergere",
  "communication_save": "Salvare",
  "communication_cancel": "Anulare",
  "communication_saving": "Se salvează...",
  "communication_note_updated": "Notă actualizată.",
  "communication_update_failed": "Nu s-a putut actualiza nota. Încercați din nou.",
  "communication_delete_confirm": "Sigur doriți să ștergeți această notă? Acțiunea nu poate fi anulată.",
  "communication_delete_confirm_title": "Ștergere notă",
  "communication_note_preview": "Previzualizare notă:",
  "communication_note_deleted": "Notă ștearsă.",
  "communication_delete_failed": "Nu s-a putut șterge nota. Încercați din nou.",
  "communication_edited": "Editat",
  "communication_show_more": "Afișează mai mult",
  "communication_show_less": "Afișează mai puțin",
  "communication_sort_date_newest": "Cele mai noi întâi",
  "communication_sort_date_oldest": "Cele mai vechi întâi",
  "communication_sort_author": "După autor",
  "communication_sort_type": "După tip",
  "communication_sort_pinned": "Fixate întâi",
  "communication_sort_label": "Sortare",
  "communication_filter_by_type": "Tip",
  "communication_filters_group_aria": "Filtrează și sortează notele",
  "communication_search_label_short": "Căutare",
  "last_time_of_arrival": "Ultima dată de sosire", 
  "arrival_and_status": "Sosire și stare",
  "preview_arrivals": "Previzualizare sosiri",
  "men toilet": "Toaletă pentru bărbați", 
  "women toilet": "Toaletă pentru femei",
  "shared toilet": "Toaletă comună", 
  "unisex restroom": "Toaletă unisex",
  "handicapped toilet": "Toaletă pentru persoane cu dizabilități", 
  "logistics": "Logistică",
  "cubicle": "Cabină",
  "gym": "Sală de sport",
  monthMap: {
    1: "Ianuarie",
    2: "Februarie",
    3: "Martie", 
    4: "Aprilie", 
    5: "Mai", 
    6: "Iunie",
    7: "Iulie", 
    8: "August", 
    9: "Septembrie",
    10: "Octombrie",
    11: "Noiembrie",
    12: "Decembrie" 
  },
  weekMap: {
    1: "Luni", 
    2: "Marți", 
    3: "Miercuri", 
    4: "Joi",
    5: "Vineri",
    6: "Sâmbătă",
    7: "Duminică"
  },
  "dayOfWeek": "Ziua săptămânii",
  "service_log": "Jurnal de serviciu",
  "rooms": "Camere",
  "bulk_add_rooms": "Adăugare camere în masă",
  "add_rooms": "Adaugă camere",
  "room_names_one_per_line": "Nume camere (câte unul pe rând)",
  "enter_at_least_one_room": "Introduceți cel puțin un nume de cameră",
  "room_names_placeholder": "Cameră 1\nCameră 2\nToalete femei",
  "rooms_with_prefix": "camere cu prefix",
  "apply_to_all_rooms": "Aplică la toate camerele (opțional)",
  "bulk_rooms_intro": "Adaugă unul sau mai multe grupuri. Fiecare grup are propria clădire, etaj, zonă, gen și nume de camere.",
  "group": "Grup",
  "add_group": "+ Adaugă alt grup",
  "adding_rooms": "Se adaugă camere...",
  "bulk_summary": "Rezumat",
  "in": "în",
  "bulk_rooms_success": "{n} camere adăugate cu succes",
  "displayName": "Numele afișat",
  "SLA": "SLA",
  "supervisors": "Supervizori",
  "supervisor": "Supervizor",
  "performance_analytics": "Analize de performanță",
  "arrivals": "Sosiri",
  "inspections": "Inspecții",
  "avgResponseTime": "Timpul mediu de răspuns",
  "missedSla": "SLA ratat",
  "cleaner_arrived": "Curățătorul a sosit",
  "load_more": "Încărcați mai mult",
  "login": "Autentificare",
  "email": "Email",
  "emails": "Emailuri", 
  "password": "Parolă",
  "min": "Min",
  "Logout": "Deconectare",
  "time_range": "Interval de timp",
  "select_time_range": "Selectează intervalul de timp",
  "custom_time": "Timp personalizat",
  "last_day": "Ieri",
  "last_week": "Ultimele 7 zile",
  "last_month": "Ultimele 30 de zile",
  "last_quarter": "Ultimele 90 de zile",
  "last_6_months": "Ultimele 6 luni",
  "last_year": "Ultimele 365 de zile",
  "data_by_hour": "Date pe oră",
  "general": "General",
  "cleaning": "Curățare",
  "maintenance": "Întreținere",
  "start": "Start",
  "start_time": "Timpul de începere",
  "management_co": "Companii de management",
  "cleaning_co": "Companii de curățare",
  "companies": "Companii",
  "name": "Nume",
  "site_count": "Numărul de site-uri",
  "associated_companies": "Companii asociate",
  "OK": "OK",
  "cancel": "Anulare",
  "client": "Client",
  "dates": "Date",
  "shift": "Schimb",
  "issue": "Problemă",
  "time": "Timp",
  "top complaint of the week": "Topul plângerilor săptămânii",
  "top room of the week": "Topul camerei săptămânii",
  "top hour of the week": "Topul orei săptămânii",
  "top complaint of the month": "Topul plângerilor lunii",
  "top room of the month": "Topul camerei lunii",
  "top hour of the month": "Topul orei lunii",
  "franchises": "Francize",
  "add_franchise": "Adăugați franciză",
  "room_names": "Numele camerelor",
  "type": "Tip",
  "please_select_company_site": "Vă rugăm să selectați compania și site-ul",
  "number": "Număr",
  "create_building_map": "Creați harta clădirii", 
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Cel mai rapid mod de a adăuga etaje și camere într-o clădire prin intermediul acestui asistent rapid",
  "avg number of toilets per floor": "Numărul mediu de toalete pe etaj",
  "avg.number of toilet cells per room": "Numărul mediu de celule de toaletă pe cameră",
  "number of floors": "Numărul de etaje",
  "avg.number of disabled toilets": "Numărul mediu de toalete pentru persoane cu dizabilități",
  "avg.number of soap dispensers": "Numărul mediu de dozatoare de săpun",
  "reset_filter": "Resetați filtrul",
  "add": "Adăugați",
  "new_survey": "Sondaj nou",
  "api_configuration": "Configurare API",
  "please_edit_the_api_information": "Vă rugăm să editați informațiile API",
  "method": "Metodă",
  "authorization": "Autorizare",
  "api_url": "URL API",
  "token": "Token",
  "api_request_info": "Informații despre cererea API",
  "roomName": "Numele camerei",
  "servikName": "Numele reclamației",
  "siteName": "Numele site-ului",
  "stage": "Etapa",
  "number_of_buttons": "Numărul de butoane",
  "button_shape": "Forma butonului",
  "delay_time_stage": "Timpul de întârziere al etapei",
  "go_to_stage": "Du-te la etapă",
  "color": "Culoare",
  "add_stage": "Adăugați etapă",
  "save": "Salvați",
  "number_of_issues": "Numărul de probleme",
  "online": "Online",
  "offline": "Offline",
  "offline_devices": "Dispozitive Offline",
  "no_offline_devices": "Nu s-au găsit dispozitive offline",
  "working_devices": "Dispozitive Funcționale",
  "no_working_devices": "Nu s-au găsit dispozitive funcționale",
  "room_name": "Numele camerei",
  "installation_spot": "Locul de instalare",
  "device_id": "ID dispozitiv",
  "date": "Data",
  "status": "Stare",
  "device_status": "Starea dispozitivului",
  "none": "Niciunul",
  "no_surveys_created": "Nu s-au creat sondaje", 
  "dashboard": "Tablou de bord",
  "franchise_name": "Numele francizei",
  "franchise_country": "Țara francizei",
  "choose_franchise": "Alegeți franciza",
  "choose_country": "Alegeți țara",
  "select_template": "Selectați șablonul",
  "default_survey": "Sondaj implicit",
  "cleaning_survey": "Sondaj de curățare",
  "kitchen_survey": "Sondaj de bucătărie",
  "template": "Șablon",
  "area_name": "Numele zonei",
  "rooms_names": "Numele camerelor",
  "rooms_number": "Numărul camerelor",
  "assign_number": "Atribuiți numărul",
  "active_notification_task": "Activare notificare",
  "amount_limit": "Limita de sumă",
  "after_max": "După maxim",
  "new_area": "Zonă nouă",
  "edit_area": "Editați zona",
  "tablet": "Tabletă",
  "counter women": "Contor femei",
  "counter men": "Contor bărbați",
  "counter handicap": "Contor persoane cu dizabilități",
  "counter man/woman": "Contor bărbați/femei",
  "counter man / woman": "Contor bărbați / femei",
  "sensor liquid": "Senzor lichid",
  "double toilet paper": "Hârtie igienică dublă",
  "toilet paper": "Hârtie igienică",
  "tag": "Etichetă",
  "qr tag": "Etichetă QR",
  "additional_info": "Informații suplimentare",
  "servikCategory": "Categorie servik",
  "dishwashing": "Spălarea vaselor",
  "cafeteria": "Cafenea",
  "clean room": "Cameră curată",
  "office": "Oficiu",
  "meeting room": "Sală de întâlniri",
  "cubic": "Cubic",
  "women": "Femei",
  "men": "Bărbați",
  "handicap": "Persoane cu dizabilități",
  "Combined": "Combinat",
  "kitchen": "Bucătărie",
  "east": "Est",
  "west": "Vest",
  "north": "Nord",
  "south": "Sud",
  "right": "Dreapta",
  "left": "Stânga",
  "center": "Centru",
  "up": "Sus",
  "down": "Jos",
  "combined": "Combinat",
  "lobby": "Hol",
  "entrance": "Intrare",
  "reception": "Recepție",
  "area": "Zonă",
  "mezzanine": "Mezanin",
  "gallery": "Galerie",
  "ground": "Parter",
  "elevator": "Lift",
  "is_calculated": "Este calculat",
  "calculated_room": "Cameră calculată",
  "splitted_survey": "Sondaj împărțit",
  "redirect_to_url": "Redirecționare către URL",
  "survey_site": "Site-ul sondajului",
  "clicks": "Clicuri",
  "add_stage_number_to_signal": "Adăugați numărul etapei la semnal",
  "including_pad9": "Inclusiv pad9",
  "room_type_required": "Selectați un tip de cameră pentru fiecare grup",
  "Tech Manufacturers": "Producători tehnologici",
  "Tech Offices": "Birouri tehnologice",
  "Offices": "Birouri",
  "Terminal": "Terminal",
  "Universities": "Universități",
  "Factories": "Fabrici",
  "Hospital": "Spital",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Magazine de proximitate",
  "Food Chains": "Lanțuri alimentare",
  "Residential": "Rezidențial",
  "Shopping Center": "Centru comercial",
  "Survey": "Sondaj",
  "Demo": "Demonstrație",
  "Vision": "Vision",
  "Court": "Instanță",
  "Office Management": "Administrare birouri",
  "Government Office": "Instituție publică",
  "default_name": "Nume implicit",
  "exposures": "Toalete curate experimentate",
  "exposures_tab": "Activitate Cameră",
  "expose_results": "Rezultate",
  "events_expose": "Evenimente",
  "expose_score": "Rată",
  "shift_events_expose": "Evenimente de schimbare expuse",
  "type_of_site": "Tipul site-ului",
  "morning_shift": "Schimb de dimineață",
  "afternoon_shift": "Schimb de după-amiază",
  "night_shift": "Schimb de noapte",
  "update": "Actualizare",
  "restart": "Repornire",
  "send_data": "Trimiteți datele",
  "send_count": "Trimiteți numărul",
  "blink": "Clipi",
  "beacon": "Beacon",
  "like_btn": "Buton de apreciere",
  "requires_like_btn": "Necesită activarea butonului de apreciere",
  "maintenance_btn": "Buton de întreținere",
  "battery": "Baterie",
  "version": "Versiune",
  "actions": "Acțiuni",
  "device_actions": "Acțiuni dispozitiv",
  "device_settings": "Setări dispozitiv",
  "drains_battery": "Bateria se scurge",
  "latest_errors": "Ultimele erori",
  "no_errors": "Fără erori",
  "offline_calls": "Apeluri offline",
  "offline_duration_calls": "Durata apelurilor offline",
  "counterCalls": "Apeluri de contor",
  "active": "Activ",
  "no_active_supervisors": "Niciun supervizor activ",
  "active_supervisors_column": "Supervizori activi",
  "supervisors_active_label": "supervizori activi acum",
  "active_supervisors_coverage_hint": "Supervizorii activi au activat această zonă în aplicație. Nu indică prezență online sau fizică.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Calcul activ",
  "pad": "Pad",
  "pad_counter": "Contor pad",
  "counter_status": "Starea contorului",
  "choose_state": "Alegeți statul",
  "choose_city": "Alegeți orașul",
  "start_hour": "Ora de începere",
  "end_hour": "Ora de încheiere", 
  "analytics_log": "Jurnal de analize",
  "or": "sau", 
  "no_data_available": "Nu sunt date disponibile",
  "filter_by_cleaner": "Filtrează după curățător",
  "all_cleaners": "Toți curățătorii",
  "failed_to_load_data": "Nu s-au putut încărca datele",
  "not_available": "N/A",
  "new_task": "Sarcină nouă",
  "temporarily_unavailable": "Temporar indisponibil",
  "category": "Categorie",
  "title": "Titlu",
  "task_type": "Tip de sarcină",
  "task_languages": "Limbi pentru sarcină",
  "task_languages_hint": "Selectați limbile pentru această sarcină. Veți introduce titlul în fiecare limbă selectată.",
  "task_category": "Categorie de sarcină",
  "call_to_action": "Apel la acțiune",
  "schedule": "Programare",
  "insert_text": "Introduceți text",
  "select": "Selectați",
  "select_all": "Selectați tot",
  "n_selected": "{count} selectate",
  "clear_selection": "Șterge selecția",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Programați datele",
  "language": "Limbă",
  "calendar": "Calendar", 
  "operation": "Operație", 
  "daily": "Zilnic",
  "weekly": "Săptămânal",
  "monthly": "Lunar",
  "quarterly": "Trimestrial",
  "yearly": "Anual",
  "sunday": "Duminică",
  "monday": "Luni", 
  "tuesday": "Marți",
  "wednesday": "Miercuri",
  "thursday": "Joi",
  "friday": "Vineri", 
  "saturday": "Sâmbătă", 
  "january": "Ianuarie",
  "february": "Februarie",
  "march": "Martie",
  "april": "Aprilie",
  "may": "Mai",
  "june": "Iunie",
  "july": "Iulie",
  "august": "August",
  "september": "Septembrie",
  "october": "Octombrie",
  "november": "Noiembrie",
  "december": "Decembrie",
  "1st week": "1 săptămână",
  "2nd week": "2 săptămână",
  "3rd week": "3 săptămână",
  "4th week": "4 săptămână",
  "5th week": "5 săptămână",
  "1st quarter": "1 trimestru",
  "2nd quarter": "2 trimestru",
  "3rd quarter": "3 trimestru",
  "4th quarter": "4 trimestru",
  "edit_task":  "Editați sarcina",
  "created_at":  "Creat la",
  "installed_at": "Instalat la",
  "hour":  "Oră",
  "week_days": "Zilele săptămânii",
  "month_weeks": "Săptămânile lunii",
  "month_days": "Zilele lunii",
  "no_tasks_found": "Nu s-au găsit sarcini",
  "invalid_language": "Limbă invalidă",
  "no_active_tasks_found": "Nu s-au găsit sarcini active",
  "edit": "Editați",
  "send_date": "Trimiteți data",
  "invalid_date": "Data invalidă",
  "cells_num": "Numărul de celule",
  "sinks_num": "Numărul de chiuvete",
  "urinals_num": "Numărul de urinoare",
  "toilet_paper_size": "Dimensiunea hârtiei igienice",
  "email_configuration": "Configurare email",
  "please_edit_the_email_information": "Vă rugăm să editați informațiile de email",
  "email_sender_info": "Informații despre expeditorul de email",
  "email_subject_info": "Informații despre subiectul emailului",
  "email_message_info": "Informații despre mesajul emailului",
  "companyName": "Numele companiei",
  "email_language": "Limbă de email",
  "complaint_language": "Limbă de reclamație",
  "email_message_format": "Formatul mesajului email",
  "line": "Linie",
  "list": "Listă",
  "roomType": "Tipul camerei",
  "By logging in, you agree to Buzzztech's": "Prin conectare, sunteți de acord cu",
  "Terms and Conditions": "Termeni și condiții",
  "and": "și",
  "Privacy Policy": "Politica de confidențialitate",
  "All actions within this panel are recorded for quality control and improvement": "Toate acțiunile din acest panou sunt înregistrate pentru controlul calității și îmbunătățirea",
  "You must agree to the terms and conditions": "Trebuie să fiți de acord cu termenii și condițiile",
  "months": "Luni",
  "ref_id": "ID de referință",
  "room_name_en": "Numele camerei în engleză",
  "site_state": "Statul site-ului",
  "site_city": "Orașul site-ului",
  "city": "Oraș",
  "state": "Stat", 
  "site_country": "Țara site-ului",
  "first_date": "Prima dată",
  "pinned": "Pinned",
  "no.": "Nr.",
  "must_be_numbers": "Trebuie să fie numere",
  "must_be_3_digits": "Trebuie să fie 3 cifre",
  "must_have_english_title": "Trebuie să aibă titlu în engleză",
  "total_sites": "Total site-uri",
  "site_information": "Informații despre site",
  "holiday_offdays": "Sărbători și zile libere",
  "add_offday": "Adăugați zi liberă",
  "add_holiday": "Adăugați sărbătoare",
  "name_under_chars": "Numele trebuie să fie sub 50 de caractere",
  "days_comma_separated": "zile, separate prin virgulă",
  "year": "an",
  "month": "lună",
  "day": "zi",
  "holiday_name": "numele sărbătorii",
  "offday_name": "numele zilei libere",
  "delete_confirmation_title": "Ești sigur?",
  "delete_confirmation_message": "Această acțiune nu poate fi anulată.",
  "are_you_sure": "Ești sigur?",
  "israel": "Israel",
  "USA": "SUA",
  "poland": "Polonia",
  "mexico": "Mexic",
  "cyprus": "Cipru",
  "brazil": "Brazilia",
  "romania": "România",
  "netherlands": "Olanda",
  "tablet_survey": "Sondaj tabletă",
  "no_shift_survey": "Niciun sondaj de schimb",
  "number_of_rows": "Numărul de rânduri",
  "rating_shape": "Forma de evaluare",
  "content_survey": "Conținutul sondajului",
  "rating_survey": "Evaluarea sondajului",
  "device-alerts": "Alerte dispozitiv",
  "device-active": "Dispozitiv activ",
  "device-search": "Căutare dispozitiv",
  "mac_id": "Adresa MAC",
  "qr_tag": "Cod QR",
  "sensor": "Senor",
  "image_survey": "Sondaj de imagine",
  "open_text": "Text deschis",
  "open_text_survey": "Sondaj de text deschis",
  "embedded_link": "Link încorporat",
  "device-counter": "Contor dispozitiv",
  "count": "Număr",
  "last_date": "Ultima dată",
  "last_arrival": "Ultima sosire",
  "cleaners": "Curățători",
  "viewer": "Vizualizator",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "Nu s-au găsit utilizatori",
  "cleaner_activity": "Activitatea curățătorilor",
  "pad_presence_testing": "Test prezență pad",
  "pad_presence_testing_subtitle": "Intrări, ieșiri și apăsări offline ale pad-ului trimise de telefon pentru site-ul selectat",
  "pad_presence_timeline": "Cronologie live",
  "pad_presence_sessions": "Sesiuni de prezență",
  "pad_presence_offline_presses": "Apăsări offline de pe telefoane",
  "pad_presence_select_site_hint": "Selectați o companie și un site în antet pentru a urmări evenimentele de prezență.",
  "pad_presence_no_events": "Nu există evenimente de prezență în această perioadă.",
  "pad_presence_open": "Deschis",
  "pad_presence_exit_phone": "Ieșire de pe telefon",
  "pad_presence_exit_auto": "Ieșire automată",
  "pad_presence_exit_stale": "Ieșire întârziată",
  "pad_presence_enter": "Intrare",
  "pad_presence_exit": "Ieșire",
  "pad_presence_offline": "Apăsare offline",
  "pad_presence_faulty": "Eronat",
  "pad_presence_employee": "Angajat",
  "pad_presence_room": "Cameră",
  "pad_presence_time_from": "De la",
  "pad_presence_last_updated": "Actualizat",
  "pad_presence_duration": "Durată",
  "pad_presence_exit_type": "Tip ieșire",
  "pad_presence_button": "Buton",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Număr",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Toți angajații",
  "pad_presence_all_rooms": "Toate camerele",
  "pad_presence_load_error": "Nu s-au putut încărca datele de prezență ale pad-ului.",
  "pad_presence_in_room_now": "Într-o cameră acum",
  "pad_presence_in_room": "în",
  "pad_presence_since": "din",
  "pad_presence_just_now": "Chiar acum",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefon",
  "pad_presence_all_phones": "Toate telefoanele",
  "pad_presence_window": "Afișează",
  "pad_presence_window_hour": "Ultima oră",
  "pad_presence_window_today": "Azi",
  "pad_presence_window_month": "Ultima lună",
  "pad_presence_pads": "Pad-uri pe acest site",
  "pad_presence_no_pads": "Nu există pad-uri atribuite camerelor pe acest site.",
  "pad_presence_last_enter": "Ultima intrare",
  "pad_presence_last_offline": "Ultima apăsare offline",
  "pad_presence_auto_exit_leave": "Pleacă acum → ieșire automată în",
  "pad_presence_auto_exit_earliest": "Cel mai devreme de la intrare:",
  "pad_presence_auto_exit_passed": "A trecut cel mai devreme moment de ieșire automată. Încă deschis = pad-ul încă se aude, sau pleacă și așteaptă 5m 45s.",
  "cleaner_activity_live_footer": "Datele se actualizează în timp real",
  "ca_empty_select_site_hint": "Selectați compania și site-ul în antet pentru a vedea activitatea curățătorilor de astăzi.",
  "ca_empty_no_cleaners_hint": "Niciun curățător nu este atribuit acestui site și turei curente. Atribuiți site-uri active și ture în Utilizatori.",
  "ca_empty_access_denied": "Acces refuzat",
  "ca_empty_access_denied_hint": "Nu aveți permisiunea de a vedea activitatea curățătorilor pentru acest site.",
  "ca_empty_load_error_hint": "Activitatea nu a putut fi încărcată. Încercați din nou sau contactați suportul dacă problema persistă.",
  "ca_empty_no_filter_match": "Niciun curățător nu corespunde acestor filtre",
  "ca_empty_no_filter_match_hint": "Încercați să ștergeți filtrele sau să alegeți alt curățător, zonă de lucru sau cameră.",
  "ca_timeline_all_cleaners": "Activitatea de azi — toți curățătorii",
  "ca_legend_work": "Activ",
  "ca_clock_sessions_more": "mai mult",
  "ca_clock_sessions_less": "Afișează mai puțin",
  "ca_sort_label": "Sortare",
  "ca_sort_needs_attention": "Necesită atenție",
  "ca_sort_best_avg_response": "Cel mai bun timp mediu de răspuns",
  "ca_sort_worst_avg_response": "Cel mai prost timp mediu de răspuns",
  "ca_sort_most_sla_breaches": "Cele mai multe încălcări SLA",
  "ca_sort_most_open_complaints": "Cele mai multe reclamații deschise",
  "ca_sort_most_work_time": "Cel mai mult timp de lucru",
  "ca_sort_least_work_time": "Cel mai puțin timp de lucru",
  "ca_stat_avg_short": "med",
  "ca_stat_open_short": "deschis",
  "ca_stat_breach_short": "SLA",
  "ca_stat_work_short": "lucru",
  "ca_assigned_room_avg_hint": "Timp mediu de răspuns pentru camerele atribuite astăzi",
  "ca_transit_tooltip": "Timp de tranzit între sarcini",
  "ca_transit_live_tooltip": "Timp de la închiderea ultimei sarcini",
  "ca_legend_visits": "Vizite între apeluri",
  "ca_visits_between_sla": "Vizite de la închiderea apelului anterior",
  "ca_apply": "Aplică",
  "ca_visits_since": "de la",
  "ca_deferred_tip_title": "Reclamație amânată",
  "ca_deferred_tip_resolved": "Rezolvată",
  "ca_deferred_tip_desc_open": "Încă deschisă — curățătorul a servit alte camere mai întâi în loc de aceasta.",
  "ca_deferred_tip_desc_closed": "Această reclamație a rămas deschisă în timp ce curățătorul a servit alte camere mai întâi.",
  "ca_deferred_tip_rooms_label": "Servite mai întâi:",
  "ca_attention_title": "Necesită atenție",
  "ca_attention_empty": "Totul e în regulă — fără probleme acum",
  "ca_attention_sla_breach_one": "{name} · SLA încălcat",
  "ca_attention_sla_breach_many": "{name} · {count} încălcări SLA",
  "ca_attention_open_while_out_one": "{name} · reclamație deschisă în afara turei",
  "ca_attention_open_while_out_many": "{name} · {count} deschise în afara turei",
  "ca_attention_idle": "{name} · inactiv {duration}",
  "ca_attention_late": "{name} · pontaj întârziat",
  "ca_attention_show": "Afișează",
  "ca_attention_hide": "Ascunde",
  "ca_view_shift": "Schimb",
  "ca_view_history": "Istoric",
  "ca_filters_done": "Gata",
  "ca_hist_preset_this_month": "Luna aceasta",
  "ca_hist_preset_last_month": "Luna trecută",
  "ca_hist_preset_this_week": "Săptămâna aceasta",
  "ca_hist_preset_last_week": "Săptămâna trecută",
  "ca_hist_preset_custom": "Personalizat",
  "ca_hist_from": "De la",
  "ca_hist_to": "Până la",
  "ca_hist_range_invalid": "Data de început trebuie să fie înaintea datei de sfârșit",
  "ca_hist_range_too_long": "Intervalul poate avea cel mult {max} zile",
  "ca_hist_search": "Caută după nume sau telefon",
  "ca_hist_people_count": "{count} angajați",
  "ca_hist_kpi_days": "Zile lucrate",
  "ca_hist_kpi_net": "Ore nete",
  "ca_hist_kpi_breaks": "Pauze",
  "ca_hist_col_person": "Angajat",
  "ca_hist_col_total": "Ore totale",
  "ca_hist_col_total_tip": "De la pontajul de intrare la cel de ieșire, înainte de pauze — aceeași valoare pe care o vede angajatul în aplicație",
  "ca_hist_col_net": "Ore nete",
  "ca_hist_col_breaks": "Pauze",
  "ca_hist_col_issues": "Probleme",
  "ca_hist_col_late": "Întârziere",
  "ca_hist_col_missed": "Absență",
  "ca_hist_col_no_clock_out": "Fără ieșire",
  "ca_hist_clocked_in_now": "Pontat acum",
  "ca_hist_not_assigned": "Nealocat acestei locații",
  "ca_hist_no_shift": "Niciun schimb alocat",
  "ca_hist_unknown_name": "Necunoscut",
  "ca_hist_empty": "Nicio prezență în această perioadă",
  "ca_hist_empty_hint": "Nimeni nu a pontat la această locație și niciun angajat nu îi este alocat.",
  "ca_hist_no_match": "Niciun angajat nu corespunde filtrelor",
  "ca_hist_load_error_hint": "Istoricul prezenței nu a putut fi încărcat. Încearcă din nou în câteva momente.",
  "ca_hist_prev_person": "Angajatul anterior",
  "ca_hist_next_person": "Angajatul următor",
  "ca_hist_close": "Închide",
  "ca_hist_legend_worked": "A lucrat",
  "ca_hist_legend_late": "Întârziere",
  "ca_hist_legend_missed": "Absență",
  "ca_hist_legend_no_clock_out": "Fără ieșire",
  "ca_hist_late_by": "Întârziere {duration}",
  "ca_hist_late_tip": "Pontat la {time}, {shift} începe la {start}",
  "ca_hist_missed": "Absență",
  "ca_hist_missed_tip": "Schimbul programat s-a încheiat fără pontaj de intrare",
  "ca_hist_no_clock_out": "Fără ieșire",
  "ca_hist_no_clock_out_tip": "Sesiunea nu a fost închisă; orele ei nu sunt numărate",
  "ca_hist_in_progress": "Încă pontat",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "deschisă",
  "ca_hist_day_col_gross": "Ore totale",
  "ca_hist_day_col_breaks": "Pauze",
  "active_cleaners": "Curățători activi",
  "closed_complaints": "Plângeri închise",
  "total_work_time": "Timp total de lucru",
  "total_work_time_net": "Timp total de lucru (astăzi net)",
  "total_break_time": "Timp total de pauză",
  "avg_response_time": "Medie rezolvate",
  "cleaner": "Curățător",
  "clocked_in": "Pontaj de intrare",
  "clocked_out": "Pontaj de ieșire",
  "still_clocked_in": "Încă pontat",
  "clocked_in_late": "Pontare intrare întârziată",
  "total_hours": "Total ore",
  "auto_punch": "Automat (geofencing)",
  "manual_punch": "Manual",
  "complaint_opened": "Reclamație deschisă",
  "complaint_closed": "Reclamație închisă",
  "complaint_still_open": "Încă deschisă",
  "resolved_in": "Rezolvată în",
  "open_for": "Deschisă de",
  "sla_breached": "SLA încălcat",
  "no_activity_today": "Încă nicio activitate azi",
  "just_now": "chiar acum",
  "ago": "în urmă",
  "today": "Azi",
  "live": "În direct",
  "last_updated": "Actualizat",
  "no_cleaners_found": "Nu s-au găsit curățători",
  "new_cleaner": "Curățător nou",
  "edit_cleaner": "Editați curățătorul",
  "have_you_finished_making_changes": "Ai terminat de făcut modificările?",
  "assignment_issues_found": "Probleme de atribuire găsite",
  "unassigned_rooms_title": "Camere neatribuite",
  "overlapping_assignments_title": "Atribuiri care se suprapun",
  "and_n_more": "și încă {count}",
  "continue_anyway": "Continuă oricum",
  "stay_and_fix": "Rămâi și corectează",
  "assignment_coverage_issues": "{unassigned} neatribuite · {overlaps} suprapuneri",
  "assignment_check_failed": "Nu s-au putut verifica atribuirile camerelor",
  "tap_for_details": "Apasă pentru detalii",
  "has_app": "Aplicație",
  "has_app_tooltip": "Curățătorul are aplicația",
  "notifications_tooltip": "Notificările push sunt active",
  "assigned_to_rooms": "Atribuit la camere",
  "assigned_to_rooms_tooltip": "Are camere pe acest site",
  "recently_active": "Activ recent",
  "works_at_site": "Lucrează la locație",
  "recently_active_tooltip": "A deschis aplicația în ultimele 30 de minute",
  "please_select": "Vă rugăm să selectați",
  "please_select_site_first": "Vă rugăm să selectați mai întâi un site",
  "working_areas": "Zone de lucru",
  "no_working_areas": "Nu există încă zone de lucru",
  "working_area_alerts": "Alerte",
  "api": "API",
  "please_create_room_before_working_area": "Vă rugăm să creați cel puțin o cameră înainte de a crea o zonă de lucru",
  "isWorkingInSite": "Lucrează în site",
  "you_are_not_allowed_to_edit": "Nu aveți permisiunea de a edita",
  "you_are_not_allowed_to_remove": "Nu aveți permisiunea de a șterge",
  "task": "Sarcină",
  "portuguese": "Portugheză",
  "russian": "Rusă",
  "spanish": "Spaniolă",
  "polish": "Poloneză",
  "installer": "Instalator",
  "once": "O dată",
  "time_saved": "Timp salvat",
  "yes": "Da",
  "no": "Nu",
  "workingAreaNames": "Numele zonelor de lucru",
  "shift_rooms": "Camere de schimb",
  "new_shift": "Schimb nou",
  "add_shift_inactive": "Adăugați schimburi inactive",
  "remove_auto_shift_inactive": "Eliminați schimburi automate inactive",
  "additional_options": "Opțiuni suplimentare",
  "add_default_shifts": "Adăugați schimburi implicite",
  "no_user_found": "Utilizatorul nu a fost găsit",
  "no_site_found": "Site-ul nu a fost găsit",
  "service_provider": "Furnizor de servicii",
  "qr task": "Sarcină QR",
  "qr_task": "Sarcină QR",
  "all_day": "Toată ziua",
  "auto_start": "Pornire automată",
  "english_title": "Titlu în engleză",
  "connectivity": "Conectivitate",
  "power": "Putere",
  "Your work has been saved": "Munca ta a fost salvată",
  "schedule_call_time": "Timpul de apelare",
  "schedule_call_gap": "Intervalul de apelare",
  "gapInMinutes": "Interval în minute",
  "no_manual_calls_available": "Nu sunt apeluri manuale disponibile",
  "manual_calls": "Apeluri manuale",
  "cleandexCalls": "Apeluri Cleandex",
  "manualCalls": "Apeluri manuale",
  "inactive": "Inactiv",
  "on hold": "În așteptare",
  "sequential": "Secvențial",
  "ratio": "Raport",
  "must_choose": "Trebuie să alegeți",
  "surveyApp": "Aplicație de sondaj",
  "installation": "Instalare",
  "manager": "Manager",
  "previous": "Anterior",
  "next": "Următor",
  "no_rooms_found": "Nu s-au găsit camere",
  "show_calendar": "Afișați calendarul",
  "seeAll": "Afișați tot",
  "showPaginated": "Afișați paginat",
  "cleaners_arrivals": "Sosirile curățătorilor",
  "add_address": "Adăugați adresă",
  "site_auto_attendance_enabled":
    "Permiteți intrarea și ieșirea automată folosind geofence-ul din aplicația mobilă (necesită permisiuni de locație).",
  "site_auto_attendance_requires_location":
    "Setați mai întâi pe hartă pinul și raza de cel puțin 100 m înainte de a activa prezența automată.",
  "site_mandatory_clock_in": "Solicită pontarea intrării înainte de lucru",
  "site_mandatory_clock_in_description":
    "Angajații acestui sit trebuie să ponteze intrarea înainte de a putea deschide filele de curățenie, mentenanță și misiuni în aplicația mobilă.",
  "site_mandatory_clock_in_without_location":
    "Acest sit nu are o locație pe hartă, așa că aplicația nu poate ști când un angajat este la sit. Până când setați una, cerința se aplică acestor angajați oriunde.",
  "edit_address": "Editați adresa",
  "choose_radius": "Alegeți raza",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Verde = OK. Roșu = Recomandat curățare. Treceți peste icon pentru detalii.",
  "recommended_to_clean": "Recomandat curățare",
  "cleandex_warning_level": "Nivel de avertizare Cleandex",
  "select_warning_level": "Selectați nivelul de avertizare",
  "bronze": "Bronz",
  "silver": "Argint",
  "gold": "Aur",
  "ai": "Inteligenta artificiala",
  "daily_employees_num": "Număr zilnic de angajați",
  "daily_shift_hours": "Ore de tură zilnică",
  "rooms_num": "Număr de camere",
  "buildings_num": "Număr de clădiri",
  "cleaner_entries": "Intrări ale personalului de curățenie",
  "avg_daily_visits_monthly": "Vizite zilnice medii pe lună",
  "avg_daily_cleaners_to_save": "Medie zilnică de personal de curățenie economisit",
  "saving_hours_per_day": "Ore economisite pe zi",
  "saving_money_per_day": "Economie de bani pe zi",
  "saving_money_per_month": "Economie de bani pe lună",
  "cleaners_to_visitors_ratio": "Raport între personalul de curățenie și vizitatori",
  "cleaning_time_in_minutes_per_room": "Timp de curățenie în minute per cameră",
  "max_number_of_rooms_per_employee": "Număr maxim de camere per angajat",
  "break_time_per_hour": "Timp de pauză pe oră",
  "transition_time_between_tasks": "Timp de tranziție între sarcini",
  "employer_cost_hour": "Costul angajatorului pe oră",
  "lobby_cleaning_per_floor": "Curățenie în lobby per etaj",
  "desired_cleaning_time": "Timp dorit pentru curățenie",
  "desired_number_of_entries": "Număr dorit de intrări",
  "buzz_system_cost_per_unit_per_month": "Costul sistemului Buzz per unitate pe lună",
  "total_buzz_system_cost_per_month": "Cost total al sistemului Buzz pe lună",
  "return_on_investment_in_months": "Recuperarea investiției în luni",
  "annual_savings": "Economie anuală",
  "roi_calculator": "Calculator ROI",
  "cleaners_number": "Numărul de curățători",
  "floors_num": "Numărul de etaje",
  "avg_daily_cleaners_required": "Curățători zilnici necesari",
  "app_pages": "Pagini de aplicație",
  "buzzzTime": "Timp Buzzz",
  "missions": "Misiuni",
  "send_emails": "Trimiteți emailuri",
  "enter": "Introduceți",
  "account": "Cont",
  "privacy": "Confidențialitate",
  "personal_settings": "Setări personale",
  "personal_settings_lead": "Limbă și preferințe de confidențialitate.",
  "personal_settings_read_only": "Detaliile sunt gestionate de administrator. Contactați-l pentru modificări.",
  "change_password": "Schimbați parola",
  "change_password_hint": "Schimbarea parolei vă va deconecta de pe celelalte dispozitive.",
  "current_password": "Parola actuală",
  "new_password": "Parola nouă",
  "confirm_new_password": "Confirmați parola nouă",
  "password_min_length": "Parola trebuie să aibă cel puțin 8 caractere",
  "passwords_do_not_match": "Parolele nu coincid",
  "new_password_same_as_current": "Parola nouă trebuie să fie diferită de cea actuală",
  "current_password_incorrect": "Parola actuală este incorectă",
  "current_password_required": "Parola actuală este obligatorie",
  "password_changed_successfully": "Parola a fost schimbată cu succes",
  "change_password_failed": "Parola nu a putut fi schimbată",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "Nume de utilizator sau parolă incorectă",
  "login_credentials_required": "Introduceți numele de utilizator sau e-mailul și parola",
  "login_network_error": "Nu se poate contacta serverul. Verificați conexiunea și încercați din nou",
  "login_failed": "Nu s-a putut autentifica. Încercați din nou",
  "login_too_many_attempts": "Prea multe încercări de autentificare. Așteptați 15 minute și încercați din nou.",
  "forgot_password_too_many": "Prea multe cereri de resetare a parolei. Așteptați o oră și încercați din nou.",
  "reset_password_too_many": "Prea multe încercări de resetare a parolei. Așteptați o oră și încercați din nou.",
  "change_password_too_many": "Prea multe încercări de schimbare a parolei. Așteptați 15 minute și încercați din nou.",

  "personal_settings_language_hint": "Se aplică întregului portal în acest browser.",
  "personal_settings_privacy_hint": "Solicitați ștergerea datelor personale conform legilor aplicabile.",
  "personal_settings_role": "Rol",
  "Request deletion of my data": "Solicit ștergerea datelor mele",
  "Request deletion of my data - confirm": "Solicit ștergerea datelor mele? Administratorul va primi un e-mail. Vom procesa cererea în 30 zile.",
  "Request deletion of my data - success": "Cerere trimisă. O vom procesa în 30 zile.",
  "Request deletion of my data - error": "Trimiterea a eșuat. Încercați din nou sau scrieți la privacy@buzzztech.com.",
  "metrics": "Metrici",
  "select_three_metrics": "Selectează până la 3 metrici pentru comparație",
  "select_four_metrics": "Selectează până la 4 metrici pentru comparație",
  "legend": "Legendă",
  "more_details": "Mai Multe Detalii",
  "performance_overview": "Prezentare generală a performanței",
  "loading_chart": "Se încarcă graficul",
  "retry": "Reîncearcă",
  "performance_trending_upward": "Performanța este în creștere",
  "high_complaint_ratio": "Rată ridicată de reclamații",
  "click_bars_for_details": "Fă clic pe bare pentru a vedea analiza zilnică",
  "refresh": "Reîmprospătează",
  "table": "Tabel",
  "cards": "Carduri",
  "no_recent_arrivals": "Nu există sosiri recente",
  "feedback_charts": "Grafice de feedback",
  "general_overview": "Prezentare generală",
  "cleaning_complaints_breakdown": "Defalcare a plângerilor de curățenie",
  "maintenance_complaints_breakdown": "Defalcare a plângerilor de întreținere",
  "refresh_failed": "Reîmprospătare eșuată",
  "data_exported_successfully": "Datele au fost exportate cu succes",
  "data_export_failed": "Exportul datelor a eșuat",
  "drill_down_unavailable": "Detalierea este disponibilă doar în vizualizarea zilnică",
  "sort_by": "Sortează după",
  "no_active_shift": "Nu există tură activă",
  "check_site_and_shift": "Vă rugăm să verificați dacă a fost selectat un site și dacă există o tură activă",
  "please_add_shift_first": "Vă rugăm să adăugați mai întâi o tură",
  "cleandex_no_data_message": "Nu există date Cleandex disponibile în acest moment",
  "task_no_data_message": "Nu există date despre sarcini disponibile în acest moment",
  "navigation": "Navigare",
  "network_information": "Informații despre rețea",
  "target_effectiveness": "Eficiența țintei",
  "cleandex_call_cleaner": "Apel Cleandex Curățător",
  "top_complaint": "Reclamație principală",
  "no_complaints": "Nu există reclamații",
  "official_start_date": "Data oficială de început",
  "note_text": "Textul notei",
  "add_note": "Adaugă notă",
  "general_note": "Notă generală",
  "general_note_short": "Generală",
  "battery_short": "Baterie",
  "panel_short": "Panou",
  "technician_short": "Tehnician",
  "battery_replacement": "Înlocuire baterie",
  "device_maintenance": "Întreținerea dispozitivului",
  "maintenance_type": "Tip întreținere",
  "panel_change": "Schimbare panou",
  "technician_check": "Verificare tehnician",
  "enter_note_details": "Introduceți detaliile notei",
  "replacement_date": "Data înlocuirii",
  "replaced_by_name": "Înlocuit de",
  "replacement_note": "Notă de înlocuire",
  "enter_replacement_details": "Introduceți detaliile înlocuirii",
  "replacement_history": "Istoric înlocuiri",
  "loading_history": "Se încarcă istoricul",
  "no_replacement_history": "Nu există istoric de înlocuiri disponibil",
  "enter_technician_name": "Introduceți numele tehnicianului",
  "user_information": "Informații despre utilizator",
  "enter_change_details": "Introduceți detaliile schimbării",
  "panel_change_history": "Istoric schimbări panou",
  "check_date": "Data verificării",
  "checked_by_name": "Verificat de",
  "enter_check_details": "Introduceți detaliile verificării",
  "technician_check_history": "Istoric verificări tehnician",
  "no_technician_check_history": "Nu există istoric de verificări tehnician",
  "change_date": "Data schimbării",
  "changed_by_name": "Schimbat de",
  "change_note": "Notă de schimbare",
  "check_note": "Notă de verificare",
  "replaced_by": "Înlocuit de",
  "no_data_entered": "Nu s-au introdus date",
  "invalid_username": "Nume de utilizator invalid",
  "invalid_phone": "Număr de telefon invalid",
  "username_must_be_at_least_5_characters": "Numele de utilizator trebuie să aibă cel puțin 5 caractere",
  "open_slas": "SLA-uri Deschise",
  "open_sla_alerts": "Alerte de plângeri deschise",
  "open_duration": "Durată Deschisă",
  "open_complaints": "Plângeri Deschise",
  "site_alerts": "Alerte Site",
  "rooms_with_open_complaints_percentage": "Camere cu plângeri deschise",
  "rooms_with_cleaner_arrival_percentage": "Camere cu sosirea curățătorului",
  "rooms_without_cleaner_arrival_percentage": "Camere fără sosirea curățătorului",
  "site_alerts_total_rooms": "Total camere",
  "site_alerts_open_complaints_count": "Număr plângeri deschise",
  "site_alerts_customer_opening_date": "Data deschiderii clientului",
  "company_country": "Țara companiei",
  "select_message": "Selectează mesajul",
  "message_no_cleaner_arrival": "Bună tuturor,\nVă rugăm să rețineți că există camere în care nu s-a raportat sosirea curățătorului astăzi.\nVă rugăm să vă ocupați de acest lucru",
  "message_open_complaints": "Bună tuturor,\nVă rugăm să rețineți că există mai multe camere cu plângeri deschise de mult timp.\nVă rugăm să vă ocupați de acest lucru",
  "rooms_list": "Camere:",
  "no_open_slas": "Nu s-au găsit SLA-uri deschise",
  "no_open_slas_description": "În prezent nu există site-uri cu SLA-uri deschise.",
  "no_slas_to_send": "Nu s-au găsit SLA-uri deschise pentru acest site",
  "total_open_complaints": "Total Plângeri Deschise",
  "longest_duration": "Cea Mai Lungă Durată",
  "complaints_details": "Detalii Plângeri",
  "no_results_found": "Nu s-au găsit rezultate",
  "whatsapp": "WhatsApp",
  "loading": "Se încarcă",
  "error_opening_whatsapp": "Eroare la deschiderea WhatsApp. Vă rugăm să încercați din nou.",
  "error_loading_slas": "Eroare la încărcarea detaliilor SLA. Vă rugăm să încercați din nou.",
  "send_whatsapp": "Trimite WhatsApp",
  "more_options": "Mai multe opțiuni",
  "preview_message": "Previzualizare mesaj",
  "copy_message": "Copiază mesajul",
  "message_preview": "Previzualizare mesaj",
  "phone_number_optional": "Număr de telefon (opțional)",
  "enter_phone_number": "Introduceți numărul de telefon (ex: +40712345678)",
  "phone_number_hint": "Lăsați gol pentru a deschide WhatsApp fără un contact specific",
  "message_copied": "Mesajul a fost copiat în clipboard!",
  "error_copying_message": "Eroare la copierea mesajului. Vă rugăm să încercați din nou.",
  "opening_whatsapp": "Se deschide WhatsApp...",
  "data_loading_please_wait": "Datele se încarcă. Vă rugăm să așteptați...",
  "dates_not_changed": "Datele nu s-au schimbat. Nu este necesară reîncărcarea.",
  "date_outside_stats_range": "Datele selectate sunt în afara intervalului de statistici disponibil.",

  "date_range_invalid": "Data «Până la» trebuie să fie egală sau ulterioară datei «De la».",
  "filter_help_text": "Reguli de filtrare: Selectați mai întâi Clădirea pentru a activa filtrul de Etaj. Majoritatea filtrelor acceptă selecții multiple.",
  "select_building_first": "Vă rugăm să selectați mai întâi o Clădire pentru a activa filtrul de Etaj",
  "cannot_select_gender_with_rooms": "Nu se poate selecta tipul de cameră când sunt selectate camere",
  "cannot_select_gender_with_rooms_tooltip": "Filtrul de tip de cameră nu poate fi folosit când sunt selectate camere. Ștergeți mai întâi selecția camerelor.",
  "cannot_select_building_with_rooms": "Nu se poate selecta clădirea când sunt selectate camere",
  "cannot_select_building_with_rooms_tooltip": "Filtrul de clădire nu poate fi folosit când sunt selectate camere. Vă rugăm să ștergeți mai întâi selecția camerelor.",
  "multi_select_hint": "Puteți selecta mai multe opțiuni",
  "filter_applied": "Filtru aplicat cu succes",
  "no_filters_selected": "Nu au fost selectate filtre. Selectați cel puțin o opțiune de filtrare.",
  "filters": "Filtre",
  "location": "Locație",
  "attributes": "Atribute",
  "applying": "Se aplică...",
  "active_filters": "Filtre Active",
  "viewing_room": "Vizualizare cameră",
  "multiple": "Multiple",
  "close": "Închide",
  "save_replacement": "Salvează înlocuirea",
  "save_change": "Salvează schimbarea",
  "save_check": "Salvează verificarea",
  "failed_to_load_maintenance_history": "Nu s-a putut încărca istoricul de întreținere",
  "Battery replacement recorded successfully": "Înlocuirea bateriei a fost înregistrată cu succes",
  "Panel change recorded successfully": "Schimbarea panoului a fost înregistrată cu succes",
  "Technician check recorded successfully": "Verificarea tehnicianului a fost înregistrată cu succes",
  "no_network_data_available": "Nu sunt date de rețea disponibile",
  "basic_information": "Informații de bază",
  "service_providers": "Furnizori de servicii",
  "settings_alerts": "Setări și alerte",
  "configuration": "Configurare",
  "contact_settings": "Contact și setări",
  "notifications": "Notificări",
  "alert_language": "Limba alertei",
  "select_language": "Selectați limba",
  "features": "Caracteristici",
  "chat_ask_stats": "Întreabă statistici",
  "chat_ask_buzzz": "Întreabă Buzzz",
  "chat_stats_assistant": "Asistent statistici",
  "chat_buzzz_assistant": "Asistent Buzzz",
  "chat_clear": "Șterge",
  "chat_placeholder": "Întreabă despre statisticile de curățenie, de ex. \"Câte reclamații au fost săptămâna trecută?\" sau \"Care camere au nevoie de atenție?\"",
  "chat_placeholder_context": "Întreabă despre {scope}, de ex. \"Câte reclamații?\" sau \"Care camere au nevoie de atenție?\"",
  "chat_thinking": "Se gândește…",
  "chat_input_placeholder": "Întreabă despre vizite, reclamații, camere…",
  "chat_send": "Trimite",
  "chat_chip_summary": "Rezumat",
  "chat_chip_worst_rooms": "Cele mai slabe camere",
  "chat_chip_counter_calls": "Apeluri contor",
  "chat_chip_sla_issues": "Probleme SLA",
  "chat_chip_busiest_hours": "Cele mai aglomerate ore",
  "chat_chip_help": "Ce pot întreba?",
  "chat_chip_focus": "Pe ce ar trebui să mă concentrez?",
  "chat_chip_improving": "Care camere se îmbunătățesc?",
  "chat_chip_best_rooms": "Cele mai bune camere după scor",
  "chat_chip_worst_days": "Cele mai rele zile",
  "chat_chip_complaint_types": "Tipuri de reclamații",
  "chat_chip_positive_feedback": "Feedback pozitiv",
  "chat_suggestions": "Sugestii",
  "chat_error": "Ceva nu a funcționat. Încercați din nou.",
  "chat_copy": "Copiază",
  "chat_copied": "Copiat!",
  "chat_retry": "Reîncearcă",
  "chat_chip_compare_periods": "Compară cu perioada anterioară",
  "chat_chip_briefing": "Briefing dimineață",
  "chat_chip_cleaning_priority": "Prioritate curățenie",
  "chat_chip_live_status": "Status live",
  "chat_chip_shift_stats": "Performanță schimburi",
  "chat_chip_staff_status": "Cine lucrează acum?",
  "chat_chip_why_drilldown": "De ce? Detalii",
  "chat_pin": "Adaugă la favorite",
  "chat_unpin": "Elimină din favorite",
  "chat_share": "Trimite pe e-mail",
  "chat_export": "Export",
  "chat_helpful": "Util",
  "chat_not_helpful": "Nu e util",
  "chat_hide": "Ascunde asistentul",
  "chat_stop": "Oprește",
}

export const nl = {
  "room_type_required": "Selecteer een ruimtetype voor elke groep",
  ...serviks.nl,
  notified: "Geïnformeerd",
  supervisor_arrival: "Aankomst supervisor",
  arrival: "Aankomst",
  arrival_badges: "Ploegaankomsten",
  visits_since_cleaned: "Bezoeken sinds laatste schoonmaak",
  visits_since_cleaned_short: "Sinds laatste keer schoon",
  filter: "Filter",
  logo: "Logo",
  sms: "Sms",
  shifts: "Diensten",
  call: "Oproep",
  openCalls: "Open oproepen",
  callsHistory: "Oproepgeschiedenis",
  duration: "Duur",
  time_start: "Tijdstart",
  settings: "Instellingen",
  always: "Altijd",
  off: "Uit",
  time_based: "Tijdgebonden",
  location_based: "Locatie gebaseerd",
  notification_mode: "Meldingsmodus",
  notification_times: "Meldingstijden",
  notification_times_info: "Tijdsintervallen worden beheerd vanuit de mobiele app",
  notification_location: "Melding - locatiegegevens",
  notification_sound: "Meldingsgeluid",
  no_sound: "Er is geen geluid",
  default_sound: "Standaardgeluid",
  soft_bell: "Zachte bel",
  digital_sound: "Digitaal geluid",
  mallet_sound: "Hamerklank",
  phone_sound: "Telefoongeluid",
  text_sound: "Tekstgeluid",
  manager_alert_delay: "Vertraging managerwaarschuwing",
  snooze_interval: "Herinnering",
  vocal_notifications: "Vocale meldingen",
  no_delay: "Geen vertraging",
  no_snooze: "Geen herinnering",
  lat: "Breedtegraad",
  lon: "Lengtegraad",
  radius: "Straal",
  no_location_set: "Geen locatie ingesteld",
  when_to_notify: "Wanneer op de hoogte stellen",
  notification_preferences: "Meldingsvoorkeuren",
  assignment_configuration: "Toewijzing en configuratie",
  status: "Status",
  working_area: "Werkgebied",
  complaints_NC: "Klachten / NC",
  SLA_NC: "SLA / NC",
  arrivals_NC: "Aankomst / NC",
  staff: "Medewerker",
  cleaning_complaints: "Schoonmaakklachten",
  export: "Export",
  maintenance_complaints: "Onderhoudsklachten",
  maintenanceArrivals: "Aankomsten onderhoud",
  maintenance_arrivals: "Aankomsten onderhoud",
  last: "Laatste",
  survey_name: "Onderzoeksnaam",
  survey: "Enquête",
  pad_survey: "Pad-enquête",
  pad_no_maintenance_survey: "Pad geen onderhoudsenquête",
  pad_kitchen: "Pad keuken",
  number_of_assigned_devices: "# toegewezen apparaten",
  number_of_pages: "Aantal pagina's",
  date_created: "Aangemaakt op",
  updated_by: "Bijgewerkt door",
  date_updated: "Datum update",
  search: "Zoekopdracht",
  choose_type: "Selecteren",
  permitted_sites: "Toegestane sites",
  permitted_franchise: "Toegestane franchise",
  permitted_companies: "Toegestane bedrijven",
  panel_permitted: "Paneel toegestaan",
  end_time: "Eindtijd",
  last_update: "Laatste update",
  add_device: "Apparaat toevoegen",
  detailed: "Gedetaileerd",
  analysis: "Analyse",
  suggestion: "Suggestie",
  country: "Land",
  management: "Beheer",
  device: "Toestel",
  mapping: "In kaart brengen",
  please_enter: "Gelieve in te voeren",
  new_device: "Nieuw apparaat",
  assign_device: "Apparaat toewijzen",
  installSpot: "Installatieplaats",
  device_type: "Type apparaat",
  deviceCode: "Apparaatcode",
  device_code: "Apparaatcode",
  scan_or_enter_device_code: "Scan of voer apparaatcode in...",
  scan_device: "Toewijzen",
  scan_qr_in_frame: "Lijn de QR-code uit in het kader. Houd voor kleine codes 15–25 cm afstand en tik op het voorbeeld om opnieuw scherp te stellen als het beeld wazig is.",
  checking_device_code: "Apparaatcode controleren...",
  camera_not_available: "Camera niet beschikbaar. U kunt de code handmatig invoeren.",
  device_code_already_exists: "Deze apparaatcode is al toegewezen aan een andere sensor.",
  assigned_to_company_site_room: "Al toegewezen aan {company} / {site} / {room}",
  device_code_lookup_failed: "Kon apparaatcode niet verifiëren. Probeer het opnieuw.",
  device_code_no_site_access: "Deze code is al geregistreerd op een locatie waar u geen toegang toe hebt.",
  device_code_check_unavailable: "De server kon de code niet controleren. Probeer het opnieuw.",
  device_code_not_a_code: "De scan las \"{code}\". Voer de apparaatcode zelf in.",
  device_code_open_failed: "Dit apparaat kon niet worden geopend. Probeer het opnieuw.",
  device_code_save_failed: "De apparaatcode kon niet worden opgeslagen. Probeer het opnieuw.",
  device_code_save_forbidden: "U kunt dit apparaat niet wijzigen.",
  confirm_replace_device_code: "Apparaatcode vervangen?",
  confirm_replace_device_code_body: "Weet u zeker dat u {oldCode} wilt vervangen door {newCode}?",
  room: "Kamer",
  edit_room: "Bewerk kamer",
  edit_franchise: "Franchise bewerken",
  new_franchise: "Nieuwe franchise",
  desc: "Beschrijving",
  address: "Adres",
  level: "Niveau",
  no_companies_to_show: "Geen bedrijven om te laten zien",
  company_type: "Soort bedrijf",
  region: "Regio",
  new_company: "Nieuw bedrijf",
  edit_company: "Bewerk bedrijf",
  edit_user: "Gebruiker bewerken",
  "C.arrivals": "Schoonmaker gearriveerd",
  "C.complaints": "Reinigingsklacht",
  "M.complaints": "Onderhoudsklachten",
  "M.Arrivals": "Aankomsten onderhoud",
  analyses: "Analyses",
  clean_log: "Logboek opschonen",
  maintenance_log: "Onderhoudslogboek",
  like: "Leuk",
  likes: "Positief",
  new_user: "Nieuwe gebruiker",
  shift_parameters: "Shiftparameter",
  add_shift: "Nieuwe dienst",
  edit_shift: "Dienst Bewerken",
  username: "Gebruikersnaam",
  first_name: "Voornaam",
  job_function: "Functie",
  role: "Rol",
  property_manager: "Vastgoedbeheerder",
  facility_manager: "Facilitair manager",
  site_manager: "Locatiemanager",
  workplace_manager: "Werkplekmanager",
  cleaning_company_ceo: "Directeur schoonmaakbedrijf",
  operations_manager: "Operations manager",
  area_manager: "Regiomanager",
  site_cleaning_manager: "Schoonmaakmanager locatie",
  cleaning_supervisor: "Schoonmaaksupervisor",
  other: "Overig",
  restroom_cleaner: "Toiletreiniger",
  general_cleaner: "Algemeen schoonmaker",
  day_porter: "Dagdienstmedewerker",
  office_cleaner: "Kantoorschoonmaker",
  public_area_cleaner: "Schoonmaker openbare ruimtes",
  firstName: "Voornaam",
  description: "Beschrijving",
  last_name: "Achternaam",
  lastName: "Achternaam",
  phone: "Telefoon",
  building_area: "Gebouwarea",
  users: "Gebruikers",
  add_user: "Voeg gebruiker toe",
  sites: "Websites",
  new_site: "Nieuwe site",
  edit_site: "Site Bewerken",
  add_company: "Bedrijf toevoegen",
  franchise: "Franchise",
  floor: "Verdieping",
  building: "Gebouw",
  humidity: "Luchtvochtigheid",
  humidity_abbr: "Luchtvochtigheid",
  temperature: "Temperatuur",
  temperature_abbr: "Temp.",
  gender: "Type ruimte",
  display_name: "Naam",
  zone: "Zone",
  shift_number: "Dienstnummer",
  shift: "Dienst",
  shift_name: "Shiftnaam",
  shift_currently_inactive: "Momenteel inactieve dienst",
  local_time: "Lokaal",
  end: "Einde",
  min_sla: "Min sla",
  max_sla: "Max sla",
  days: "Dagen",
  complaints_percent: "Klachten",
  sla_percent: "SLA",
  arrivals_percent: "Aankomsten",
  save_arrivals: "Opslaan",
  clean_time: "Reinigingstijd (min)",
  tooltip_shift_number: "Weergavevolgorde van deze dienst (bijv. 1, 2).",
  tooltip_shift_name: "Naam van de dienst (bijv. ochtend, nacht).",
  tooltip_start_time: "Starttijd verschuiven in lokale tijd.",
  tooltip_end_time: "Eindtijd verschuiven in lokale tijd.",
  tooltip_cleaners_number: "Aantal schoonmakers in deze dienst.",
  tooltip_min_sla: "Beste responstijd (minuten) om een kamerklacht af te handelen; gebruikt als ondergrens voor de score.",
  tooltip_max_sla: "Maximale acceptabele responstijd (minuten) om een kamerklacht af te handelen; gebruikt als bovengrens voor de score.",
  tooltip_arrivals: "Verwachte aankomsten van schoonmakers per kamer per dag; de score vergelijkt de werkelijke aankomsten met dit doel.",
  tooltip_save_arrivals: "Schoonmakerbezoeken per kamer per dag vóór BuzzzTV; gebruikt om de bespaarde tijd te berekenen (nu minder bezoeken = minuten bespaard).",
  tooltip_clean_time: "Minuten geteld per schoonmakerbezoek in de tijdbesparende berekening (bijv. 15).",
  tooltip_complaints_percent: "Gewicht van klachten in de kamer scoren wanneer de kamer bezoeken heeft (hoger = klachten beïnvloeden de score meer).",
  tooltip_response_time_SLA: "Gewicht van de responstijd in de kamer score wanneer de kamer bezoeken heeft (hogere = snellere reactie is belangrijker).",
  tooltip_arrivals_percent: "Gewicht van aankomsten versus doel in de kamerscore wanneer de kamer bezoeken heeft.",
  tooltip_complaints_NC: "Gewicht van klachten in de score wanneer de kamer geen bezoeken heeft (geen teller).",
  tooltip_SLA_NC: "Gewicht van de responstijd in de score wanneer de kamer geen bezoeken heeft.",
  tooltip_arrivals_NC: "Gewicht van aankomsten in de score wanneer de kamer geen bezoeken heeft.",
  tooltip_days: "Dagen van de week waarop deze dienst actief is.",
  tooltip_active_calculation: "Indien ingeschakeld, wordt deze dienst opgenomen in scores en tijdbesparende berekeningen.",
  auto_close_complaints_hour: "Klachtenuur automatisch sluiten",
  tooltip_auto_close_complaints_hour: "Lokaal uur waarop openstaande klacht-SLA's in deze dienst automatisch worden gesloten. Laat leeg om uit te schakelen.",
  auto_close_maintenance_complaints_hour: "Onderhoudsklachtenuur automatisch sluiten",
  tooltip_auto_close_maintenance_complaints_hour: "Lokaal uur waarop openstaande onderhoudsklacht-SLA's in deze dienst automatisch worden gesloten. Laat leeg om uit te schakelen.",
  no_auto_close: "-- Geen --",
  tooltip_shift_rooms: "Kamers toegewezen aan deze dienst. Laat leeg voor een verschuiving op siteniveau.",
  company_name: "Bedrijfsnaam",
  site_name: "Sitenaam",
  site_desc: "Site omschrijving",
  service_provider_name: "Serviceprovider",
  service_provider_type: "Serviceprovider",
  service_provider_desc: "Beschrijving van dienstverlener",
  user: "Gebruiker",
  map: "Plattegrond",
  delete: "Verwijderen",
  new_room: "Nieuwe Kamer",
  issue_times: "Uitgiftetijden",
  solved: "Opgelost",
  visits: "Weergave",
  complaints: "klachten",
  complaints_in_shift: "Klaagt over deze dienst",
  cleaner_arrivals: "Aankomsten van schoonmakers",
  unnecessary_arrivals: "Aankomsten zonder oproep",
  unnecessary_arrivals_hint: "Een bezoek van de schoonmaker terwijl er geen oproep openstond in de ruimte.",
  of_arrivals: "van de aankomsten",
  response_time_SLA: "Reactietijd",
  score: "Score",
  avg_score: "Gemiddelde score",
  score_goal: "Score doel",
  top_problem_issues: "Belangrijkste problemen",
  top_problem_rooms: "Topkamers",
  top_problem_hours: "Topuren",
  is_time_save: "Tijd bespaard",
  options: "Opties",
  send_battery_alerts: "Batterijwaarschuwingen verzenden",
  environment_alerts: "Milieuwaarschuwingen",
  environment_alerts_description: "Stuur e-mailwaarschuwingen wanneer de temperatuur of luchtvochtigheid het toegestane bereik verlaat",
  environment_alert_emails: "E-mails met milieuwaarschuwingen",
  temperature_min: "Temperatuur min.",
  temperature_max: "Maximale temperatuur",
  humidity_min: "Vochtigheid min.",
  humidity_max: "Vochtigheid max.",
  environment_alert_range_invalid: "Omgevingswaarschuwingsbereiken moeten numeriek zijn en min moet kleiner zijn dan of gelijk zijn aan max",
  coming_soon: "Binnenkort",
  alert_emails: "Waarschuwingsmails",
  alert_emails_placeholder: "Voer e-mailadres in",
  alert_language: "Waarschuwingstaal",
  select_language: "Selecteer taal",
  invalid_email_format: "Een of meer e-mailadressen zijn ongeldig",
  add_email: "Nog een e-mail",
  next: "Volgende",
  back: "Terug",
  basic_information: "Basisgegevens",
  service_providers: "Onderaannemers",
  settings_alerts: "Instellingen en waarschuwingen",
  configuration: "Configuratie",
  contact_settings: "Contact instellingen",
  notifications: "Meldingen",
  features: "Kenmerken",
  battery_alerts: "Batterijwaarschuwingen",
  alerts_title: "Waarschuwingen",
  location: "Plaats",
  time_save_description: "Tijdbesparende functies inschakelen",
  exposures_description: "Niet-blootstellingsgegevens bijhouden",
  alerts_description: "Waarschuwingen over apparaatinformatie",
  shift_description: "Standaarddiensten aanmaken",
  battery_alerts_description: "Stuur e-mailwaarschuwingen voor een lege batterij",
  est_ROI: "Geschatte ROI",
  complaints_vs_visits: "Klachten vs. bezoeken",
  view_by_years: "Jaren bekijken",
  view_by_months: "Maanden bekijken",
  view_by_weeks: "Bekijk weken",
  view_by_days: "Dagen bekijken",
  minutes: "minuten",
  company: "Firma",
  site: "Locatie",
  alerts: "Apparateninformatie",
  performance: "Prestaties",
  devices: "Toestellen",
  total_devices: "Totaal aantal apparaten:",
  working: "Samen-",
  warning: "Waarschuwing",
  by_device_type: "Op apparaattype",
  surveys: "Enquêtes",
  real_time: "Realtime",
  "real-time": "Realtime",
  admin: "Beheer",
  all: "Alles",
  overview: "Overzicht",
  exit_full_screen: "Volledig scherm afsluiten",
  full_screen: "Volledig scherm",
  total: "totaal",
  analytics: "Analyses",
  pdf_export_title_analytics: "Analyserapport",
  pdf_export_title_cleaner_arrivals: "Aankomsten van schoonmakers",
  communication: "Communicatie",
  overview_complaints_devices_caption: "Geïnstalleerde apparaten (cumulatief)",
  overview_complaints_devices_caption_hint: "Totaal aantal apparaten dat tot het einde van elke maand op de locatie is geïnstalleerd, op basis van installatiedatums.",
  overview_complaints_devices_toggle_aria: "Toon of verberg apparaten die zijn geïnstalleerd onder het klachtenoverzicht",
  communication_select_site_title: " kies een site",
  communication_select_site: "Selecteer een bedrijf en site uit de bovenstaande filters om notities voor die locatie te bekijken en toe te voegen.",
  communication_viewing_site: "Bezichtigen",
  communication_add_note: "Een notitie toevoegen",
  communication_add_note_open_aria: "Dialoogvenster Notitie toevoegen openen",
  communication_form_hint: "Deel updates of notities met iedereen die toegang heeft tot deze site. Ze zien nieuwe notities in realtime.",
  communication_page_intro_title: "Notities van locatie — gedeeld logboek voor deze locatie",
  communication_page_intro_body: "Gebruik deze pagina voor overdracht, problemen, updates en vergadernotities voor je team. Iedereen die deze site in het portaal kan openen, kan notities lezen en toevoegen.",
  communication_page_intro_dismiss: "Deze tip verbergen",
  communication_page_intro_aria: "Over site-opmerkingen",
  communication_content_placeholder: "Schrijf hier je notitie...",
  communication_keyboard_hint: "Ctrl+Enter om te posten",
  communication_submitting: "Aan het posten...",
  communication_submit: "Bericht notitie",
  communication_recent_notes: "Opmerkingen",
  communication_search_placeholder: "Zoeken op auteur of tekst...",
  communication_refresh: "Vernieuwen",
  communication_clear_filters: "Filters wissen",
  communication_search_aria_label: "Zoek notities",
  communication_submit_aria_label: "Bericht notitie",
  communication_copy_note_aria_label: "Tekst notitie kopiëren",
  communication_copied: "Gekopieerd naar klembord",
  communication_copy_empty: "Er is geen notitietekst om te kopiëren.",
  communication_filter_hidden_one: "(1 opmerking verborgen door filters)",
  communication_filter_hidden_many: "({n} notities verborgen door filters)",
  communication_request_timeout: "Time-out van verzoek. Probeer het opnieuw.",
  communication_load_failed: "Kan notities niet laden.",
  communication_retry: "Probeer opnieuw",
  communication_no_matches: "Er komen geen notities overeen met je zoekopdracht of filters. Probeer ze aan te passen.",
  communication_no_entries: "Er zijn nog geen notities",
  communication_no_entries_hint: "Voeg hierboven een opmerking toe om aan de slag te gaan.",
  communication_just_now: "Nu net",
  communication_minutes_ago: "{n} min geleden",
  communication_hours_ago: "{n} uur geleden",
  communication_days_ago: "{n} dagen geleden",
  communication_note_posted: "Notitie geplaatst.",
  communication_post_failed: "Kan notitie niet plaatsen. Probeer het opnieuw.",
  communication_note_type: "Notitietype",
  communication_type_general: "Algemeen",
  communication_type_update: "Bijwerking",
  communication_type_issue: "Probleemstelling",
  communication_type_follow_up: "Opvolging",
  communication_type_meeting: "Notitie van vergadering",
  communication_filter_all_types: "Alle types",
  communication_pinned: "Vastgezet",
  communication_pin: "Speld",
  communication_unpin: "Losmaken",
  communication_pin_limit: "Max 2 vastgepind",
  communication_pinned_toast: "Notitie vastgezet.",
  communication_unpinned_toast: "Notitie losgemaakt.",
  communication_pin_failed: "Kan optie niet bijwerken. Probeer het opnieuw.",
  communication_note_not_found: "Opmerking niet gevonden of je hebt geen toegang.",
  communication_site_not_in_filters: "De site van deze notitie staat niet in je huidige filters. Mogelijk heb je geen toegang tot die locatie.",
  communication_edit: "Bewerken",
  communication_delete: "Verwijderen",
  communication_save: "Opslaan",
  communication_cancel: "Annuleren",
  communication_saving: "Opslaan...",
  communication_note_updated: "Opmerking bijgewerkt",
  communication_update_failed: "Mislukt om entry bij te werken. Alsjeblieft, probeer het opnieuw.",
  communication_delete_confirm: "Weet je zeker dat je deze opmerking wil verwijderen? Dit kan niet ongedaan gemaakt worden.",
  communication_delete_confirm_title: "Notitie verwijderen",
  communication_note_preview: "Voorbeeld van notitie:",
  communication_note_deleted: "Notitie verwijderd.",
  communication_delete_failed: "Kan items niet wissen. Alsjeblieft, probeer het opnieuw.",
  communication_edited: "Bewerkt",
  communication_show_more: "Meer weergeven",
  communication_show_less: "Toon minder",
  communication_sort_date_newest: "Nieuwste eerst",
  communication_sort_date_oldest: "Oudste eerst",
  communication_sort_author: "Door auteur",
  communication_sort_type: "Op type",
  communication_sort_pinned: "Eerst vastgepind",
  communication_sort_label: "Sorteren",
  communication_filter_by_type: "Type",
  communication_filters_group_aria: "Notities filteren en sorteren",
  communication_search_label_short: "Zoekopdracht",
  employees: "Medewerkers",
  last_time_of_arrival: "Aankomsttijd",
  arrival_and_status: "Aankomst en status",
  preview_arrivals: "Bekijk aankomsten",
  "men toilet": "Heren toilet",
  "women toilet": "Vrouwentoilet",
  "shared toilet": "Gedeeld toilet",
  "unisex restroom": "Unisex toilet",
  "handicapped toilet": "Invalidentoilet",
  "kitchen": "Keuken",
  "tablet": "Tablet",
  "office": "Kantoor",
  "logistics": "Logistiek",
  "area": "Zone",
  "cafeteria": "Kantine",
  "lobby": "Lobby",
  "cubicle": "Cabine",
  "elevator": "Lift",
  "gym": "Sportschool",
  monthMap: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mrt',
    4: 'Apr',
    5: 'Mei',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Okt',
    11: 'Nov',
    12: 'Dec',
  },
  weekMap: {
    1: 'Zondag',
    2: 'Maandag',
    3: 'Dinsdag',
    4: 'Woensdag',
    5: 'Donderdag',
    6: 'Vrijdag',
    7: 'Zaterdag',
  },
  dayOfWeek: "Dagen van de week",
  service_log: "Servicelogboek",
  rooms: "Kamers",
  bulk_add_rooms: "Bulk kamers toevoegen",
  adding_to: "Toevoegen aan winkelwagen",
  add_rooms: "Kamers toevoegen",
  room_names_one_per_line: "Kamernamen (één per regel)",
  "enter_at_least_one_room": "Voer minstens één kamernaam in",
  room_names_placeholder: "Kamer 1\nKamer 2\nVrouwentoilet",
  rooms_with_prefix: "kamers met voorvoegsel",
  apply_to_all_rooms: "Toepassen op alle kamers (optioneel)",
  bulk_rooms_intro: "Voeg een of meer groepen toe. Elke groep heeft zijn eigen gebouw-, verdieping-, zone-, gender- en kamernamen.",
  group: "Groep",
  add_group: "+ Nog een groep toevoegen",
  adding_rooms: "Kamers toevoegen...",
  bulk_summary: "Samenvatting",
  in: "in",
  bulk_rooms_success: "{n} kamers succesvol toegevoegd",
  displayName: "Ruimtenaam",
  SLA: "SLA",
  supervisors: "Personen die goedkeuren",
  supervisor: "Promotor",
  performance_analytics: "Prestaties en analyses",
  arrivals: "Aankomsten",
  inspections: "Inspecties",
  avgResponseTime: "Responstijd",
  missedSla: "Gemiste sla",
  load_more: "Laad meer",
  login: "Inloggen",
  email: "E-mail",
  emails: "E-mails",
  password: "Wachtwoord",
  min: "min",
  Logout: "Uitloggen",
  time_range: "Tijdsbereik",
  select_time_range: "Selecteer een tijdbereik",
  custom_time: "Datums kiezen",
  last_day: "Gisteren",
  last_week: "Laatste 7 dagen",
  last_month: "Laatste 30 dagen",
  last_quarter: "Laatste 90 dagen",
  last_6_months: "Afgelopen 6 maanden",
  last_year: "Laatste 365 dagen",
  data_by_hour: "Gegevens per uur",
  start: "Beginnen",
  start_time: "Starttijd",
  management_co: "Beheermaatschappij",
  cleaning_co: "Schoonmaakbedrijf",
  companies: "Bedrijven",
  name: "Naam",
  site_count: "  uitsteken",
  associated_companies: "Gekoppelde eindklanten",
  OK: "OK",
  cancel: "Annuleren",
  client: "Opdrpchtgever",
  dates: "Datums",
  issue: "Probleemstelling",
  time: "Tijd",
  "top complaint of the week": "Topklacht van de week",
  "top room of the week": "Topkamer van de week",
  "top hour of the week": "Topuur van de week",
  "top complaint of the month": "Topklacht van de maand",
  "top room of the month": "Topkamer van de maand",
  "top hour of the month": "Topuur van de maand",
  franchises: "Franchise",
  add_franchise: "Voeg franchise toe",
  room_names: "Ruimtenaam",
  type: "Type",
  please_select_company_site: "Selecteer a.u.b. een bedrijf",
  number: "Nummer",
  create_building_map: "Gebouwkaart maken",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Hey snelste manier om vloeren en kamers toe te voegen aan een gebouw via deze snelle wizard",
  "avg number of toilets per floor": "Gem. aantal toiletten per verdieping",
  "avg.number of toilet cells per room": "Gem.aantal toiletcellen per kamer",
  "number of floors": "Aantal verdiepingen",
  "avg.number of disabled toilets": "Gem. aantal invalidentoiletten",
  "avg.number of soap dispensers": "Gem. aantal zeepdispensers",
  reset_filter: "Filter resetten",
  add: "Toevoegen",
  new_survey: "Nieuwe enquête",
  api_configuration: "API-configuratie",
  please_edit_the_api_information: "Bewerk de API-informatie",
  method: "Methode",
  authorization: "Autorisatie",
  api_url: "Pcc API url",
  token: "Token",
  endpoint: "Eindpunt",
  add_url: "Voeg URL toe",
  remove: "Verwijderen",
  format: "Formaat",
  auth_api_key: "API-key",
  auth_dynamic_key: "Dynamische toets (GET)",
  auth_login_token: "Inlogtoken",
  dynamic_token_url: "Token-URL (GET)",
  token_response_field_name: "Tokenveld in reactie",
  token_login_url: "Inlog-URL",
  login_request_method: "Aanvraagmethode voor inloggen",
  login_request_body: "Inlogverzoek body (JSON)",
  login_token_placeholder_hint: "Optioneel: geheim gebruikt om {{token}} in de login body JSON te vervangen",
  token_response_key: "Toegangstoken veldnaam",
  survey_api_auth_header_name: "Auth-headernaam (optioneel)",
  survey_api_auth_header_prefix: "Tekst voor het token in die koptekst",
  survey_api_auth_header_name_placeholder: "bijv. Autorisatie, X-Api-Key",
  survey_api_auth_header_prefix_placeholder: "bijv. Drager — uiteindelijke koptekst is: prefix + spatie + token",
  api_request_info: "informatie aanvragen",
  roomName: "Ruimtenaam",
  servikName: "Naam klacht",
  siteName: "Sitenaam",
  stage: "Stadium",
  number_of_buttons: "Aantal buttons",
  button_shape: "Knopvorm",
  delay_time_stage: "Wachttijd fase",
  go_to_stage: "Ga naar fase",
  color: "Kleur",
  add_stage: "Fase toevoegen",
  save: "Opslaan",
  number_of_issues: "aantal problemen",
  online: "Online",
  offline: "Offline",
  offline_devices: "Offline apparaten",
  no_offline_devices: "Geen offline apparaten",
  working_devices: "Werkende apparaten",
  no_working_devices: "Geen werkende apparaten",
  room_name: "Ruimtenaam",
  installation_spot: "Installatieplaats",
  device_id: "Apparaat-ID",
  date: "Datum",
  device_status: "Apparaatstatus",
  none: "Geen",
  no_surveys_created: "Geen enquêtes gemaakt",
  dashboard: "Gösterge Paneli",
  franchise_name: "Franchisenaam",
  franchise_country: "Franchiseland",
  choose_franchise: "Kies franchise",
  choose_country: "Land kiezen",
  select_template: "Sjabloon selecteren ",
  default_survey: "Standaard vragenlijst",
  cleaning_survey: "Schoonmaakonderzoek",
  kitchen_survey: "Keukensurvey",
  template: "Sjabloon",
  area_name: "Gebiedsnaam",
  rooms_names: "Namen van kamers",
  rooms_number: "Kamers",
  assign_number: "Opdr. nr.",
  active_notification_task: "Actieve meldingstaak",
  amount_limit: "Tellerinterval",
  after_max: "Teller na Max",
  new_area: "Nieuw gebied",
  edit_area: "Gebied bewerken",
  tablet: "Tablet",
  "counter women": "Teller vrouwen",
  "counter men": "Balieman",
  "counter handicap": "Tellerhandicap",
  "counter man/woman": "Teller man / vrouw",
  "counter man / woman": "Teller man / vrouw",
  "sensor liquid": "Sensorvloeistof",
  "double toilet paper": "Dubbel toiletpapier",
  "toilet paper": "Toiletpapier",
  tag: "Tag",
  "qr tag": "QR-tag",
  additional_info: "Social Media",
  servikCategory: "Oproeptype",
  cafeteria: "Cafetaria",
  "clean room": "Cleanroom",
  office: "Vestiging",
  "meeting room": "Vergaderruimte",
  cubic: "Kubisch",
  women: "Vrouwen",
  men: "Mannen",
  handicap: "Mindervalide",
  Combined: "Gecombineerd",
  east: "Oost",
  west: "westen",
  north: "NOORDER",
  south: "zuiden",
  right: "Rechts",
  left: "Links",
  center: "Midden",
  up: "Omhoog",
  down: "Omlaag",
  combined: "Gecombineerd",
  lobby: "Lobby",
  entrance: "Ingang",
  reception: "Onthaal",
  area: "Zone",
  mezzanine: "Tussen etage",
  gallery: "Galerie",
  ground: "Begane grond",
  elevator: "Lift",
  is_calculated: "Berekende ruimte",
  calculated_room: "Berekende ruimte",
  splitted_survey: "Uitgesplitste enquête",
  redirect_to_url: "Doorverwijzen naar URL",
  survey_site: "Enquêtesite",
  clicks: "Klikken",
  add_stage_number_to_signal: "Fasenummer bijvoegen",
  including_pad9: "Inclusief pad9",
  "Tech Manufacturers": "Techfabrikanten",
  "Tech Offices": "Techkantoren",
  "Offices": "Kantoren",
  "Terminal": "Terminal",
  "Universities": "Universiteiten",
  "Factories": "Fabrieken",
  "Hospital": "Ziekenhuis",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Gemakswinkels",
  "Food Chains": "Voedselketens",
  "Residential": "Residentieel",
  "Shopping Center": "Winkelcentrum",
  "Survey": "Enquête",
  "Demo": "Demo",
  "Vision": "Vision",
  "Court": "Rechtbank",
  "Office Management": "Kantoorbeheer",
  "Government Office": "Overheidskantoor",
  default_name: "Naam (in het Engels)",
  exposures: "Blootstelling reinigen",
  exposures_tab: "Kameractiviteit",
  expose_results: "Resultaten",
  events_expose: "Evenementen",
  expose_score: "Koers",
  shift_events_expose: "Shiftgebeurtenissen & belichten",
  type_of_site: "Type site",
  morning_shift: "OCHTENDDIENST",
  afternoon_shift: "MIDDAGDIENST",
  night_shift: "Nachtdienst",
  update: "Bijwerking",
  restart: "Herstarten",
  send_data: "Gegevens verzenden",
  send_count: "Aantal verzenden",
  blink: "Knipperen",
  beacon: "Beacon",
  like_btn: "Like-knop",
  requires_like_btn: "Vereist dat de like-knop aan staat",
  maintenance_btn: "Onderhoudsknop",
  battery: "Accu",
  version: "Versie",
  actions: "Acties",
  device_actions: "ApparaatactiesComment",
  device_settings: "Apparaatinstellingen",
  drains_battery: "Laadt de batterij op",
  latest_errors: "Laatste fouten",
  no_errors: "Geen fouten",
  offline_calls: "Offline oproepen",
  offline_duration_calls: "Offline oproepduur",
  counterCalls: "Telleroproepen",
  active: "Actief",
  no_active_supervisors: "Geen actieve supervisors",
  active_supervisors_column: "Actieve leidinggevenden",
  supervisors_active_label: "supervisors nu actief",
  active_supervisors_coverage_hint: "Actieve begeleiders hebben dit gebied ingeschakeld in de mobiele app. Dit duidt niet op online status of fysieke aanwezigheid.",
  active_calculation: "Actieve berekening",
  pad: "Pad",
  pad_counter: "Pad-teller",
  counter_status: "Tellerstatus",
  choose_state: "Kies Staat",
  choose_city: "Stad kiezen",
  start_hour: "Start uur",
  end_hour: "Eindtijd",
  analytics_log: "Analyselogboek",
  or: "of",
  no_data_available: "Geen gegevens beschikbaar",
  filter_by_cleaner: "Filteren op reiniger",
  all_cleaners: "Alle schoonmakers",
  not_available: "NVT",
  failed_to_load_data: "Gegevens opladen mislukt",
  new_task: "Nieuwe taak",
  new_personal_task: "Nieuwe persoonlijke taak",
  task_assignment: "Taak/Vaststelling",
  task_assignment_room: "Ruimtetaak",
  task_assignment_personal: "Persoonlijke taak (toewijzen aan schoonmaker)",
  temporarily_unavailable: "Tijdelijk niet beschikbaar",
  task_details: "Taakdetails",
  task_languages: "Taaktalen",
  task_languages_hint: "Selecteer de talen voor deze taak. U voert de titel in elke geselecteerde taal in.",
  settings_and_assignment: "Instellingen & toewijzing",
  assignee: "Geadresseerde",
  category: "Categorie",
  title: "Titel",
  task_type: "Type taak",
  task_category: "Taakcategorie",
  call_to_action: "Oproep tot actie",
  schedule: "Schema",
  insert_text: "Tekst invoegen",
  select: "Selecteren",
  select_all: "Alles selecteren",
  n_selected: "{count} geselecteerd",
  clear_selection: "Selectie wissen",
  wa_bulk_edit: "Bulk edit",
  wa_bulk_edit_hint: "Apply one change to {count} selected work areas.",
  wa_bulk_action: "What do you want to change?",
  wa_bulk_set_counter: "Counter",
  wa_bulk_add_task: "Add notification task",
  wa_bulk_remove_task: "Remove notification task",
  wa_bulk_enable_counter: "Turn counter on if currently off",
  wa_bulk_apply_to_n: "Apply to {count} areas",
  wa_bulk_edit_result: "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  wa_bulk_set_counter_desc: "Turn counter on/off or set the same interval on selected areas",
  wa_bulk_add_task_desc: "Add one active notification task to selected areas",
  wa_bulk_remove_task_desc: "Remove one active notification task from selected areas",
  wa_bulk_enable_counter_hint: "Areas with counter currently off will be turned on",
  wa_bulk_search_task: "Search notification tasks",
  wa_bulk_selected_task: "Selected task",
  wa_bulk_counter_state: "Counter status",
  wa_bulk_counter_on: "Turn on",
  wa_bulk_counter_off: "Turn off",
  wa_bulk_counter_unchanged: "Keep status",
  wa_bulk_counter_on_hint: "Turn counter on for all selected areas and set the interval",
  wa_bulk_counter_off_hint: "Turn counter off for all selected areas",
  wa_bulk_counter_unchanged_hint: "Only update the interval; leave on/off as it is",
  wa_bulk_task_coverage_remove: "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  wa_bulk_task_coverage_add: "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  schedule_dates: "Planning, examendata",
  language: "Taal",
  calendar: "Kalender",
  operation: "Functionering",
  daily: "Dagelijks",
  weekly: "Wekelijks",
  monthly: "Maandelijks",
  quarterly: "Per kwartaal",
  yearly: "Jaarlijks",
  sunday: "Zondag",
  monday: "Maandag",
  tuesday: "Dinsdag",
  wednesday: "Woensdag",
  thursday: "Donderdag",
  friday: "Vrijdag",
  saturday: "Zaterdag",
  january: "Januari",
  february: "Februari",
  march: "Maart",
  april: "april",
  may: "Mei",
  june: "Juni",
  july: "juli",
  august: "Augustus",
  september: "september",
  october: "Oktober",
  november: "november",
  december: "december",
  "1st week": "1st Week",
  "2nd week": "2nd Week",
  "3rd week": "3rd Week",
  "4th week": "4th Week",
  "5th week": "5th Week",
  "1st quarter": "1e kwartaal",
  "2nd quarter": "2e kwartaal",
  "3rd quarter": "Derde kwartaal",
  "4th quarter": "Vierde kwartaal",
  edit_task: "Taak bewerken",
  created_at: "Aangemaakt op",
  installed_at: "Geïnstalleerd op",
  hour: "Uur",
  week_days: "Weekdagen",
  month_weeks: "Maand weken",
  month_days: "Maand dagen",
  no_tasks_found: "Geen taken gevonden!",
  invalid_language: "Onjuiste taal opgegeven.",
  no_active_tasks_found: "Geen actieve taken gevonden",
  edit: "Bewerken",
  send_date: "Verzenddatum",
  invalid_date: "Datum ongeldig",
  hour_must_be_after_current: "Selecteer een uur na de huidige tijd",
  cells_num: "Cellen",
  sinks_num: "Gootstenen",
  urinals_num: "Urinoirs",
  toilet_paper_size: "Toiletpapier",
  email_configuration: "E-mailconfiguratie",
  please_edit_the_email_information: "Bewerk de e-mailgegevens",
  email_sender_info: "Email afzender",
  email_subject_info: "Onderwerp e-mail",
  email_message_info: "Email Bericht",
  companyName: "Bedrijfsnaam",
  email_language: "Taal van e-mail",
  complaint_language: "Taal van de klacht",
  email_message_format: "Formaat e-mailbericht",
  line: "Regel",
  list: "Lijst",
  roomType: "Kamertype",
  "By logging in, you agree to Buzzztech's": "Door in te loggen, gaat u akkoord met Buzzztech's",
  "Terms and Conditions": "Algemene voorwaarden",
  and: "En",
  "Privacy Policy": "Privacybeleid",
  "All actions within this panel are recorded for quality control and improvement": "Alle acties binnen dit panel worden geregistreerd voor kwaliteitscontrole en verbetering",
  "You must agree to the terms and conditions": "Je moet akkoord gaan met de gebruikersvoorwaarden",
  months: "Maanden",
  ref_id: "Referentienummer",
  room_name_en: "Kamernaam in het Engels",
  site_state: "Provincie van de locatie",
  site_city: "Werf Plaats",
  city: "Plaats",
  state: "Gemoeds",
  site_country: "Werf Land",
  first_date: "Eerste datum",
  pinned: "Vastgezet",
  "no.": "Nr.",
  must_be_numbers: "Moet cijfers zijn",
  must_be_3_digits: "Moet uit 3 cijfers bestaan",
  must_have_english_title: "Moet een Engelse titel hebben",
  total_sites: "totaal",
  site_information: "Site-informatie",
  holiday_offdays: "Feestdagen en vrije dagen",
  add_offday: "Vrije dag",
  add_holiday: "Vakantie",
  name_under_chars: "Naam van minder dan 25 tekens",
  days_comma_separated: "Geldige dagen, gescheiden door een komma",
  year: "Jaar",
  month: "Maand",
  day: "Dag",
  holiday_name: "Vakantie naam",
  offday_name: "Naam vrije dag",
  delete_confirmation_title: "Weet u het zeker?",
  delete_confirmation_message: "Deze actie kan niet ongedaan gemaakt worden.",
  are_you_sure: "Weet u het zeker?",
  israel: "Israël",
  USA: "VS",
  poland: "Polen",
  mexico: "Mexico",
  cyprus: "Cyprus",
  brazil: "Brazilië",
  romania: "Roemenië",
  tablet_survey: "Tablet-enquête",
  no_shift_survey: "Geen dienst tablet enquête",
  number_of_rows: "Aantal rijen",
  rating_shape: "Beoordelingsvorm",
  content_survey: "Inhoudsonderzoek",
  rating_survey: "Beoordelingsenquête",
  "device-alerts": "Problem",
  "device-active": "Actief",
  "device-search": "Zoekopdracht",
  mac_id: "MAC adres",
  qr_tag: "QR-tag",
  sensor: "Sensor",
  image_survey: "• Imago-onderzoek",
  open_text: "Open tekst",
  open_text_survey: "Enquête met open tekst",
  embedded_link: "Ingesloten link",
  "device-counter": "Teller",
  count: "Rekenen",
  last_date: "Laatste datum",
  last_arrival: "Laatste schoonmaker aankomst",
  cleaners: "Reinigingsmiddelen",
  viewer: "Viewer",
  android: "Android",
  ios: "iOS ",
  no_users_found: "Geen gebruikers gevonden",
  no_cleaners_found: "Geen schoonmakers gevonden",
  new_cleaner: "Nieuwe reiniger",
  edit_cleaner: "Schoonmaker bewerken",
  please_select: "﻿Selecteer",
  please_select_site_first: "Voer de voornaam in.",
  working_areas: "Werkgebieden",
  no_working_areas: "Nog geen werkgebieden",
  working_area_alerts: "Waarschuwingen",
  api: "API",
  task_target_by_working_areas: "Op werkgebied (alle kamers in geselecteerde gebieden)",
  task_target_by_rooms: "Op specifieke kamers",
  task_target_label: "Beschikbaar op",
  step_what: "Wat",
  step_when: "Wanneer",
  step_where: "Waarop",
  step_options: "Opties",
  please_create_room_before_working_area: "Maak ten minste één kamer aan voordat u een werkgebied aanmaakt",
  isWorkingInSite: "Wij werken ",
  you_are_not_allowed_to_edit: "U bent niet bevoegd om dit bericht te mogen bewerken",
  you_are_not_allowed_to_remove: "Het is niet toegestaan om te verwijderen",
  task: "Taak",
  portuguese: "Portugees",
  russian: "Russisch",
  spanish: "Spaans",
  polish: "Pools",
  installer: "Installateur",
  once: "1 keer",
  time_saved: "Tijdsbesparing",
  yes: "Ja",
  no: "Nee",
  workingAreaNames: "Namen van werkgebieden",
  shift_rooms: "Kamers",
  shift_validation_overlap: "Deze dienst overlapt met \"{shiftName}\" in kamer \"{roomName}\". Verwijder de ruimte uit een van de diensten of pas de uren aan.",
  shift_validation_missing_fields: "Vul alle vereiste dienstvelden in (uren, dagen en locatie).",
  shift_validation_empty_rooms: "Wijs ten minste één kamer toe aan deze dienst.",
  shift_validation_no_valid_rooms: "Geen geldige kamers geselecteerd voor deze dienst.",
  shift_validation_empty_room_map: "Kon het ploegendienstschema niet samenstellen. Controleer de geselecteerde dagen en uren.",
  new_shift: "Nieuwe {{shift}}",
  add_shift_inactive: "Reflecterende diensten toevoegen",
  remove_auto_shift_inactive: "Automatische reflecterende verschuivingen verwijderen",
  additional_options: "Extra opties",
  add_default_shifts: "Standaarddiensten toevoegen",
  no_user_found: "Geen gebruiker gevonden",
  no_site_found: "Geen site gevonden",
  open_complaints: "Openstaande klachten",
  site_alerts: "Sitewaarschuwingen",
  open_sla_alerts: "Klachtenmeldingen openen",
  open_duration: "Open Duur",
  no_open_slas: "Geen openstaande SLA's gevonden",
  no_open_slas_description: "Er zijn momenteel geen sites met open SLA's.",
  no_slas_to_send: "Geen openstaande SLA's gevonden voor deze site",
  total_open_complaints: "Totaal aantal openstaande klachten",
  longest_duration: "Langste duur",
  complaints_details: "Klachtengegevens",
  rooms_with_open_complaints_percentage: "Kamers met openstaande klachten",
  rooms_with_cleaner_arrival_percentage: "Kamers met schoonmaker aankomst",
  rooms_without_cleaner_arrival_percentage: "Kamers zonder schoonmaker Aankomst",
  site_alerts_total_rooms: "Totaalaantal kamers",
  site_alerts_open_complaints_count: "Aantal klachten",
  site_alerts_customer_opening_date: "Openingsdatum klant",
  company_country: "Vestigingsland bedrijf",
  select_message: "Selecteer het bericht:",
  message_no_cleaner_arrival: "Hallo allemaal,\nHoud er rekening mee dat er kamers zijn waar vandaag geen schonere aankomst is gemeld.\nGelieve dit af te handelen",
  message_open_complaints: "Hallo allemaal,\nHoud er rekening mee dat er meerdere kamers zijn met lange tijd openstaande klachten.\nGelieve dit af te handelen",
  rooms_list: "Kamers:",
  please_address_issues_promptly: "Los deze problemen zo snel mogelijk op.",
  no_results_found: "Geen resultaten gevonden",
  showing: "Zichtbaar",
  per_page: "Aantal items per pagina",
  whatsapp: "WhatsApp",
  loading: "Aan het laden",
  error_opening_whatsapp: "Fout bij het openen van WhatsApp. Probeer het opnieuw.",
  error_loading_slas: "Fout bij het laden van SLA-gegevens. Probeer het opnieuw.",
  send_whatsapp: "Stuur een WhatsApp",
  more_options: "Meer opties",
  preview_message: "VOORBEELD VAN BERICHT",
  copy_message: "Bericht kopiëren",
  message_preview: "Voorbeeldweergave berichten",
  phone_number_optional: "Telefoonnummer (optioneel)",
  enter_phone_number: "Voer telefoonnummer in (bijv. +1234567890)",
  phone_number_hint: "Laat leeg om WhatsApp te openen zonder een specifiek contact",
  message_copied: "Bericht gekopieerd naar klembord!",
  error_copying_message: "Fout bij het kopiëren van bericht. Probeer het opnieuw.",
  opening_whatsapp: "WhatsApp wordt geopend...",
  preview_message_description: "Bekijk en bewerk het bericht voordat u het verzendt",
  copy_message_description: "Bericht naar klembord kopiëren",
  service_provider: "Serviceprovider",
  "qr task": "QR-taak",
  qr_task: "QR-taak",
  all_day: "Volledige dag",
  auto_start: "Autostart",
  english_title: "Titel in het Engels",
  connectivity: "Connectiviteit",
  power: "Vermogen",
  "Your work has been saved": "Je werk is opgeslagen",
  schedule_call_time: "Geplande oproep",
  schedule_call_gap: "Geplande oproep",
  gapInMinutes: "in minuten",
  no_manual_calls_available: "Geen handmatige oproepen beschikbaar",
  manual_calls: "Handmatige oproepen",
  cleandexCalls: "Cleandex-oproepen",
  manualCalls: "Handmatige oproepen",
  inactive: "Inactief",
  "on hold": "In de wacht",
  sequential: "Sequentieel",
  ratio: "Verhouding",
  must_choose: "Moet kiezen",
  surveyApp: "Enquête-app",
  installation: "Installatie",
  manager: "Manager",
  previous: "Vorige",
  no_rooms_found: "Niet beschikbaar op geselecteerde  datum",
  show_calendar: "Toon de agenda",
  seeAll: "Alles weergeven",
  showPaginated: "Toon gepagineerd",
  cleaners_arrivals: "Aankomsten schoonmakers",
  "qr validator": "QR-validator",
  qr_validator: "QR-validator",
  searchAddress: "Zoek voor een adres:",
  sector: "Branche",
  add_address: "Adres toevoegen",
  site_auto_attendance_enabled: "Sta automatisch in- en uitklokken toe met de mobiele app geofence (medewerkers hebben de app en locatietoestemming nodig).",
  site_auto_attendance_requires_location: "Stel eerst een locatie op de kaart in (pin en straal minstens 100 m) voordat u automatische aanwezigheid inschakelt.",
  site_mandatory_clock_in: "Inklokken verplicht vóór het werk",
  site_mandatory_clock_in_description: "Medewerkers op deze locatie moeten inklokken voordat ze de tabbladen schoonmaak, onderhoud en opdrachten in de mobiele app kunnen openen.",
  site_mandatory_clock_in_without_location: "Deze locatie heeft geen plek op de kaart, dus de app kan niet zien wanneer een medewerker op locatie is. Zolang u er geen instelt, geldt de eis voor deze medewerkers overal.",
  auto_attendance: "Automatische aanwezigheid",
  auto_attendance_ready: "Klaar",
  auto_attendance_off: "Automatische aanwezigheid uit",
  auto_attendance_needs_setup: "Instellen nodig",
  auto_attendance_ready_tooltip: "In-/uitschakelen is ingeschakeld, geofence radius ≥ 100m, klaar voor automatisch in-/uitklokken.",
  auto_attendance_off_tooltip: "Schakelen is uitgeschakeld. Bewerk de site om automatische aanwezigheid in te schakelen.",
  auto_attendance_needs_setup_tooltip: "Schakelen is ingeschakeld, maar de geofence ontbreekt of ligt onder het minimum van 100 meter. Bewerk de site om deze te repareren.",
  edit_address: "Adres bewerken",
  choose_radius: "Kies straal:",
  cleandex: "Cleandex",
  cleandex_column_tooltip: "Groen = OK. Rood = Aanbevolen om schoon te maken.\nBeweeg de muis over het celpictogram voor meer informatie.",
  recommended_to_clean: "Aanbevolen om schoon te maken",
  cleandex_warning_level: "Cleandex waarschuwingsniveau",
  select_warning_level: "Waarschuwingsniveau selecteren",
  bronze: "Brons",
  silver: "Zilver",
  gold: "Goud",
  ai: "AI",
  daily_employees_num: "Dagelijks aantal werknemers",
  daily_shift_hours: "Dagelijkse diensturen",
  rooms_num: "Kamers aantal",
  buildings_num: "Aantal gebouwen",
  cleaner_entries: "Schoonmaker-aankomsten",
  avg_daily_visits_monthly: "Gem. dagelijkse bezoeken per maand",
  avg_daily_cleaners_to_save: "Gem. dagelijkse schoonmaakmiddelen om te besparen",
  saving_hours_per_day: "Uren besparen per dag",
  saving_money_per_day: "Geld besparen per dag",
  saving_money_per_month: "Geld besparen per maand",
  cleaners_to_visitors_ratio: "Verhouding schoonmakers/bezoekers",
  cleaning_time_in_minutes_per_room: "Schoonmaaktijd in minuten per kamer",
  max_number_of_rooms_per_employee: "Maximaal aantal kamers per werknemer",
  break_time_per_hour: "Pauzetijd per uur",
  transition_time_between_tasks: "Overgangstijd tussen taken",
  employer_cost_hour: "Werkgeverskosten per uur",
  lobby_cleaning_per_floor: "Lobbyreiniging per verdieping",
  desired_cleaning_time: "Gewenste reinigingstijd",
  desired_number_of_entries: "Gewenst aantal inzendingen",
  buzz_system_cost_per_unit_per_month: "Kosten van het buzz-systeem per eenheid per maand",
  total_buzz_system_cost_per_month: "Totale kosten Buzz-systeem per maand",
  return_on_investment_in_months: "Rendement op investering in maanden",
  annual_savings: "Jaarlijkse  netto besparing (€)",
  roi_calculator: "ROI-calculator",
  cleaning_work_plan: "Reinigingswerken",
  cleaning_work_plan_intro: "Gebruikt shiftroomstatistieken voor het bedrijf en de site in de koptekst. Bezoeken en aankomsten komen van de enkele dag met de hoogste sitebezoeken binnen het datumbereik en verschuiven van het dashboardfilter (stel die in op Prestaties of Analyse als dit tabblad de tijd- en filterbesturingselementen verbergt). Voer bezoeken per schoonmaakbeurt, personeelsdoel, uurtarief en gemiddelde minuten per schoonmaakbeurt in; genereer om voorgestelde schoonmaakbeurten op kamerniveau en overzichtstotalen te zien.",
  cleaning_work_plan_default_n: "Bezoeken per schoonmaakbeurt",
  cleaning_work_plan_cleaner_count: "Reinigers (optioneel)",
  cleaning_work_plan_avg_minutes: "Gemiddelde schoonmaaktijd (min)",
  cleaning_work_plan_run: "Genereer plan",
  cleaning_work_plan_export_csv: "Exporteren naar Excel",
  cleaning_work_plan_suggested_n: "Bezoeken per schoonmaakbeurt",
  cleaning_work_plan_actual_cleans: "Aankomsten",
  cleaning_work_plan_actual_cleans_hint: "Totaal aantal schoonmaker-aankomsten in dienst-kamerstatistieken op de piekdag (binnen het geselecteerde bereik en filters).",
  cleaning_work_plan_suggested_cleans: "Voorgestelde reinigingen",
  cleaning_work_plan_cleaner: "Schoonmaker",
  cleaning_work_plan_floors: "Verdiepingen",
  cleaning_work_plan_peak_day: "piekdag",
  cleaning_work_plan_error: "Kan schoonmaakwerkplan niet genereren",
  cleaning_work_plan_no_rooms: "Er zijn geen kamers geretourneerd voor deze site. Controleer de locatie en het datumbereik, of controleer of er kamers zijn in het bedieningspaneel.",
  cleaning_work_plan_need_filter: "Selecteer bedrijf en site in de koptekst, stel een datumbereik in (en verschuift indien nodig) op Prestaties of Analytics en probeer het opnieuw.",
  cleaning_work_plan_settings: "Plan instellingen",
  cleaning_work_plan_desired_employees: "Gewenst aantal medewerkers",
  cleaning_work_plan_cost_per_hour: "Prijs per uur",
  cleaning_work_plan_estimated_cost_suggested: "Geschatte kosten (voorgestelde werklast)",
  cleaning_work_plan_estimated_cost_actual: "Geraamde kosten (werkelijke werklast)",
  cleaning_work_plan_hours_per_cleaner: "Uren per schoonmaker",
  cleaning_work_plan_metric_title: "Metrisch",
  cleaning_work_plan_metric_avg_cleaning_min: "Gem. reinigingstijd (min)",
  cleaning_work_plan_metric_total_arrivals: "Totaal aantal aankomsten",
  cleaning_work_plan_metric_total_cleaning_min: "Totale reinigingstijd (min)",
  cleaning_work_plan_metric_total_cleaning_hours: "Totale reinigingstijd (uren)",
  cleaning_work_plan_metric_hours_per_cleaner_row: "Uren per schoonmaker",
  cleaning_work_plan_metric_num_cleaners: "Aantal schoonmakers",
  cleaning_work_plan_summary: "Samenvatting",
  cleaning_work_plan_summary_peak_note: "Bezoeken, aankomsten en voorgestelde reinigingen gebruiken dezelfde regels voor ploegenkamerstatistieken als Analytics (inclusief aankomstenaggregatie). Ze zijn voor de piekdag - de kalenderdag met de hoogste locatiebezoeken in de filterperiode. Alleen berekende kamers zijn inbegrepen, zoals het overzicht wanneer er geen kamerfilter wordt toegepast.",
  cleaning_work_plan_summary_filter_period: "Filterperiode",
  cleaning_work_plan_summary_total_visits: "Totaal aantal bezoeken",
  cleaning_work_plan_summary_total_arrivals: "Totaal aantal aankomsten",
  cleaning_work_plan_summary_employees_in_site: "Medewerkers op locatie",
  cleaning_work_plan_summary_shift_working_hours: "Werkuren in ploegendienst",
  cleaning_work_plan_hours_unit: "u",
  cleaning_work_plan_rooms_table: "Kamers",
  cleaning_work_plan_cleaners_table: "Aanbevolen schonere toewijzing",
  cleaning_work_plan_search_rooms: "Zoek kamers",
  cleaning_work_plan_total_minutes: "Totaal aantal minuten",
  cleaning_work_plan_actual_total_minutes: "Werkelijke totale minuten",
  cleaning_work_plan_actual_total_minutes_hint: "Geregistreerde aankomsten van schoonmakers in ploegenkamerstatistieken op de piekdag (binnen het geselecteerde bereik), vermenigvuldigd met uw gemiddelde minuten per schoonmaakbeurt.",
  cleaning_work_plan_suggested_total_minutes: "Voorgestelde totale minuten",
  cleaning_work_plan_suggested_room_minutes: "Voorgestelde schoonmaakminuten",
  cleaning_work_plan_actual_room_minutes: "Werkelijke schoonmaakminuten",
  cleaning_work_plan_cleaner_suggested_minutes: "Aanbevolen min.",
  cleaning_work_plan_cleaner_actual_minutes: "Werkelijke min.",
  cleaning_work_plan_period: "Periode",
  cleaning_work_plan_room_count: "Aantal slaapkamers",
  cleaning_work_plan_cleaners_working_in_site: "Schoonmakers die op locatie werken (app-contacten)",
  cleaning_work_plan_cleaners_connection_table: "Schoonmakers per kamer",
  cleaning_work_plan_connected_rooms_count: "Kamers",
  cleaning_work_plan_connected_floor_count: "Aantal verdiepingen",
  cleaning_work_plan_connected_floors_list: "Verdiepingen",
  cleaning_work_plan_visitor_cleaning_entry_ratio: "Toegangsratio bezoeker / schoonmaak",
  cleaning_work_plan_performance_comparison_table: "Prestatievergelijking",
  cleaning_work_plan_performance_comparison_empty: "Laad de koppelingsgegevens van schoonmakers om de vergelijkingsrijen te zien.",
  cleaning_work_plan_performance_col_index: "Inhoud",
  cleaning_work_plan_performance_existing_plan: "Bestaand werkplan",
  cleaning_work_plan_performance_recommended_plan: "Buzzztech aanbevolen plan",
  cleaning_work_plan_perf_number_of_employees: "Aantal medewerkers",
  cleaning_work_plan_perf_working_hours_per_employee: "Arbeidsduur per werknemer",
  cleaning_work_plan_perf_total_working_hours: "Totaal aantal werkuren",
  cleaning_work_plan_perf_total_cleaning_hours: "Totaal aantal schoonmaakuren",
  cleaning_work_plan_perf_daily_cost: "Dagelijkse kosten",
  cleaning_work_plan_perf_total_cleaning_visits: "Totaal aantal schoonmaakbezoeken",
  cleaning_work_plan_perf_busiest_area_visits: "Drukste werkgebied — bezoeken",
  cleaning_work_plan_perf_cleaning_to_busiest: "Schoonmaakbezoeken aan het drukste gebied",
  cleaning_work_plan_perf_max_cleaning_ratio: "Maximale reinigingsverhouding",
  cleaning_work_plan_perf_least_busy_visits: "Minst drukke werkgebied — bezoeken",
  cleaning_work_plan_perf_cleaning_to_least: "Schoonmaakbezoeken aan het minst drukke gebied",
  cleaning_work_plan_perf_min_cleaning_ratio: "Minimale reinigingsverhouding",
  cleaning_work_plan_ai_allocate: "AI-toewijzing",
  cleaning_work_plan_ai_allocation_result: "AI Toewijzingsresultaat",
  cleaning_work_plan_ai_allocation_loading: "AI-toewijzing genereren...",
  cleaning_work_plan_ai_allocation_error: "Kan AI-toewijzing niet genereren. Probeer het opnieuw.",
  cleaning_work_plan_ai_invalid_employees: "Stel een geldig gewenst aantal werknemers in.",
  cleaning_work_plan_ai_status_elapsed: "Verstreken: {s}s",
  cleaning_work_plan_ai_status_hint: "De server voert verschillende AI-stappen achter elkaar uit (initieel plan, geografie, bezoekbalans, dan definitieve uitvoer). Dit kan een tot twee minuten duren. Houd deze pagina open.",
  cleaning_work_plan_ai_status_step_1: "Stap 1 — het opstellen van een eerste opdracht vanuit kamer- en bezoekgegevens...",
  cleaning_work_plan_ai_status_step_2: "Stap 2 — geografie verfijnen (groepering van nabijgelegen verdiepingen en gebouwen)...",
  cleaning_work_plan_ai_status_step_3: "Stap 3 — het balanceren van dagelijkse bezoeken tussen schoonmakers...",
  cleaning_work_plan_ai_status_step_4: "Stap 4 — het genereren van de gestructureerde toewijzing...",
  cleaning_work_plan_ai_status_step_5: "Stap 5 — valideren en berekenen van definitieve statistieken...",
  cleaning_work_plan_ai_cleaner_number: "Schoonmaker #",
  cleaning_work_plan_room_minutes: "Schoonmaakminuten",
  cleaning_work_plan_assigned_cleaner: "Toegewezen schoonmaker",
  cleaning_work_plan_summary_cleaners: "Schoonmakers in plan",
  cleaning_work_plan_summary_avg_minutes: "Gem. minuten / schoonmaken",
  cleaning_work_plan_suggested_hours: "Voorgesteld totaal aantal uren",
  cleaning_work_plan_actual_hours: "Werkelijk totaal aantal uren",
  cleaning_work_plan_avg_suggested_min_per_cleaner: "Gem. gesuggereerd min / reiniger",
  cleaning_work_plan_avg_actual_min_per_cleaner: "Gem. werkelijke min / reiniger",
  cleaning_work_plan_guidelines_title: "Optimalisatierichtlijnen",
  cleaning_work_plan_guidelines_intro: "Deze tool volgt dezelfde doelen als handmatige optimalisatie van het schoonmaakplan: werkbelasting van bezoekgegevens, tijd van uw gemiddelde minuten per schoonmaakbeurt en personeel dat werk in evenwicht houdt en vloeren geografisch verantwoord houdt.",
  cleaning_work_plan_guidelines_b1: "Bezoeken per schoonmaakbeurt (standaard 50) komen overeen met de gebruikelijke 1:50 -stijlregel: voorgestelde inzendingen per kamer ≈ bezoeken ÷ bezoeken per schoonmaakbeurt (afgerond). Bezoeken en aankomsten worden genomen van de drukste dag (hoogste bezoeken ter plaatse) binnen het door u geselecteerde datumbereik, dus het plan komt overeen met een piekdag.",
  cleaning_work_plan_guidelines_b2: "Wanneer je een schonere telling instelt, is elke gebouwverdieping één groep. Vloeren worden gerangschikt op gebouw- en vloernummer en vervolgens opgesplitst in aaneengesloten blokken over schoonmaakmiddelen, zodat voorgestelde reinigingen (impliciet werk) in evenwicht zijn, terwijl vloeren in de buurt de neiging hebben om op dezelfde reiniger te blijven.",
  cleaning_work_plan_guidelines_b3: "Alle toiletten op dezelfde verdieping van het gebouw blijven met dezelfde reiniger, dus de mannen- en vrouwenkamers op die verdieping zijn niet verdeeld over verschillende schoonmakers (zolang ze dezelfde vloerwaarde delen in het bedieningspaneel).",
  cleaning_work_plan_guidelines_b4: "Gemiddelde minuten per schone ritten voorgesteld en werkelijke totale minuten, uren en gemiddelde minuten per schoonmaker. Werkelijke totalen gebruiken geregistreerde schoonmakersaankomsten × uw gemiddelde; voorgestelde totalen gebruiken impliciete reinigingen × uw gemiddelde.",
  cleaning_work_plan_guidelines_b5: "Gebruik CSV exporteren als u de toewijzing elders wilt verfijnen (bijvoorbeeld om het bezoekensaldo verder aan te scherpen).",
  cleaners_number: "Nummer schoonmakers",
  floors_num: "Vloernummer",
  avg_daily_cleaners_required: "Gem. dagelijkse schoonmaakmiddelen vereist",
  app_pages: "App-pagina's",
  buzzzTime: "Buzzz-tijd",
  missions: "Opdrachten",
  send_emails: "Stuur emails",
  enter: "Invoeren",
  account: "Rekening",
  privacy: "Privacy",
  personal_settings: "Persoonlijke instellingen",
  personal_settings_lead: "Beheer uw taal- en privacyvoorkeuren.",
  personal_settings_read_only: "Deze gegevens worden beheerd door uw beheerder. Neem contact met ze op als er iets moet worden bijgewerkt.",
  change_password: "Wachtwoord wijzigen",
  change_password_hint: "Als u uw wachtwoord wijzigt, wordt u op uw andere apparaten afgemeld.",
  current_password: "Huidig wachtwoord",
  new_password: "Nieuw wachtwoord",
  confirm_new_password: "Bevestig nieuw wachtwoord",
  password_min_length: "Het wachtwoord moet minimaal 8 tekens bevatten",
  passwords_do_not_match: "Wachtwoorden komen niet overeen",
  new_password_same_as_current: "Het nieuwe wachtwoord moet verschillen van het huidige",
  current_password_incorrect: "Het huidige wachtwoord is onjuist",
  current_password_required: "Het huidige wachtwoord is verplicht",
  password_changed_successfully: "Wachtwoord succesvol gewijzigd",
  change_password_failed: "Wachtwoord wijzigen is mislukt",
  forgot_password: "Wachtwoord vergeten?",
  forgot_password_title: "Wachtwoord vergeten",
  forgot_password_hint: "Voer het e-mailadres van uw panelaccount in. Als het bestaat, sturen we een resetlink.",
  forgot_password_sent: "Als er een account bestaat voor dat e-mailadres, is er een resetlink verzonden. Controleer uw inbox.",
  forgot_password_invalid_email: "Voer een geldig e-mailadres in",
  forgot_password_failed: "Reset-e-mail kon niet worden verzonden. Probeer opnieuw.",
  send_reset_link: "Resetlink verzenden",
  back_to_login: "Terug naar inloggen",
  reset_password: "Wachtwoord resetten",
  reset_password_hint: "Kies een nieuw wachtwoord voor uw account.",
  reset_password_missing_token: "Deze resetlink is onvolledig. Vraag een nieuwe aan via de inlogpagina.",
  reset_password_invalid_token: "Deze resetlink is ongeldig of verlopen. Vraag een nieuwe aan.",
  reset_password_failed: "Wachtwoord resetten is mislukt",
  password_reset_successfully: "Wachtwoord succesvol gereset. U kunt inloggen met uw nieuwe wachtwoord.",
  login_invalid_credentials: "Onjuiste gebruikersnaam of wachtwoord",
  login_credentials_required: "Voer uw gebruikersnaam of e-mailadres en wachtwoord in",
  login_network_error: "Kan de server niet bereiken. Controleer uw verbinding en probeer het opnieuw",
  login_failed: "Inloggen mislukt. Probeer het opnieuw",
  login_too_many_attempts: "Te veel aanmeldpogingen. Wacht 15 minuten en probeer het opnieuw.",
  forgot_password_too_many: "Te veel verzoeken om het wachtwoord te resetten. Wacht een uur en probeer het opnieuw.",
  reset_password_too_many: "Te veel pogingen om het wachtwoord te resetten. Wacht een uur en probeer het opnieuw.",
  change_password_too_many: "Te veel pogingen om het wachtwoord te wijzigen. Wacht 15 minuten en probeer het opnieuw.",

  personal_settings_language_hint: "Is van toepassing op het hele portaal voor deze browser.",
  personal_settings_privacy_hint: "Verzoek om verwijdering van uw persoonsgegevens onder de toepasselijke privacywetgeving.",
  personal_settings_export_hint: "Download een leesbare JSON-kopie van de persoonlijke gegevens die we over u bewaren: uw portaalprofiel, sites waartoe u toegang hebt en uw gekoppelde mobiele app-profiel (wanneer uw telefoon overeenkomt). Beperkte export per dag.",
  "Download my data": "Mijn gegevens downloaden",
  personal_settings_role: "Rol",
  "Request deletion of my data": "Verzoek om verwijdering van mijn gegevens",
  "Request deletion of my data - confirm": "Verzoek om verwijdering van mijn gegevens? Er wordt een e-mail verzonden naar de beheerder. We verwerken je verzoek binnen 30 dagen.",
  "Request deletion of my data - success": "Verzoek verzonden. We zullen het binnen 30 dagen verwerken.",
  "Request deletion of my data - error": "Kan verzoek niet indienen. Probeer het opnieuw of stuur een e-mail naar privacy@buzzztech.com.",
  metrics: "Meting",
  select_three_metrics: "Selecteer maximaal 3 statistieken om te vergelijken",
  select_four_metrics: "Selecteer maximaal 4 statistieken om te vergelijken",
  legend: "Legende",
  more_details: "Meer details",
  performance_overview: "Prestatieoverzicht",
  loading_chart: "Grafiek wordt geladen",
  retry: "Opnieuw proberen",
  performance_trending_upward: "Prestaties trending naar boven",
  high_complaint_ratio: "Hoge klachtenratio",
  click_bars_for_details: "Klik op balken om in te zoomen op dagelijkse analyses",
  refresh: "Vernieuwen",
  table: "Tabel",
  cards: "Kaarten",
  no_recent_arrivals: "Geen recente aankomsten",
  feedback_charts: "Feedbackgrafieken",
  general_overview: "Algemeen overzicht",
  cleaning_complaints_breakdown: "Storing schoonmaakklachten",
  maintenance_complaints_breakdown: "Uitsplitsing onderhoudsklachten",
  refresh_failed: "Vernieuwen mislukt",
  data_exported_successfully: "Succesvol geëxporteerd.",
  data_export_failed: "Exporteren mislukt",
  drill_down_unavailable: "Drill-down alleen beschikbaar voor dagelijkse weergave",
  sort_by: "Sorteer op",
  no_active_shift: "Geen actieve dienst",
  check_site_and_shift: "Controleer of een locatie is geselecteerd en een actieve dienst heeft",
  please_add_shift_first: "Voeg eerst een dienst toe",
  cleandex_no_data_message: "Er zijn momenteel geen cleandex-gegevens beschikbaar",
  task_no_data_message: "Er zijn momenteel geen taakgegevens beschikbaar",
  navigation: "Navigatie",
  network_information: "Netwerkinformatie",
  target_effectiveness: "Doeleffectiviteit van",
  cleandex_call_cleaner: "Cleandex-oproepreiniger",
  top_complaint: "Top klacht",
  no_complaints: "Geen klachten",
  official_start_date: "Officiële startdatum",
  note_text: "Notitie tekst",
  add_note: "Opmerking toevoegen",
  general_note: "Algemeen",
  general_note_short: "Algemeen",
  battery_short: "Accu",
  panel_short: "Paneel",
  technician_short: "Technieker",
  battery_replacement: "Batterijvervanging",
  device_maintenance: "Apparaatonderhoud",
  maintenance_type: "Onderhoudstype",
  panel_change: "Paneelwissel",
  technician_check: "TECHNICUS<x id=\"2\"/> CHECK-OUT",
  enter_note_details: "Notitiegegevens invoeren",
  replacement_date: "Vervangingsdatum",
  replaced_by_name: "Vervangen door naam",
  replacement_note: "Vervangingsbiljet",
  enter_replacement_details: "Voer vervangende gegevens in",
  replacement_history: "Vervangingsgeschiedenis",
  loading_history: "Geschiedenis laden",
  no_replacement_history: "Geen vervangingsgeschiedenis beschikbaar",
  enter_technician_name: "Voer de naam van de technicus in",
  prefilled_from_account: "Vooraf ingevuld vanuit je account — je kunt bewerken",
  user_information: "Gebruikersinformatie",
  enter_change_details: "Voer wijzigingsgegevens in",
  panel_change_history: "Geschiedenis van paneelwijzigingen",
  check_date: "Controledatum",
  checked_by_name: "Rookgasafvoer getest door",
  enter_check_details: "Voer controlegegevens in",
  technician_check_history: "Controlehistorie technieker",
  no_technician_check_history: "Geen geschiedenis van controle door technicus beschikbaar",
  change_date: "Datum wijzigen",
  changed_by_name: "Gewijzigd door",
  change_note: "wijzigingsbesluit",
  check_note: "Opmerking controleren",
  replaced_by: "Vervangen door",
  no_data_entered: "Geen gegevens ingevoerd.",
  no_panel_change_history: "Geen geschiedenis van paneelwijzigingen beschikbaar",
  invalid_username: "Ongeldige gebruikersnaam",
  invalid_phone: "Ongeldig telefoonnummer",
  username_must_be_at_least_5_characters: "Nog iets langer, minimaal 4 tekens",
  data_loading_please_wait: "Gegevens worden momenteel geladen. Een ogenblik geduld...",
  dates_not_changed: "Datums zijn niet gewijzigd. Herladen is niet nodig.",
  date_outside_stats_range: "Geselecteerde datums liggen buiten het beschikbare statistiekbereik.",

  date_range_invalid: "\"Tot\" datum moet op of na \"Vanaf\" datum zijn.",
  filter_help_text: "Filterregels: selecteer eerst Gebouw om Vloerfilter in te schakelen. De meeste filters ondersteunen meerdere selecties.",
  select_building_first: "Selecteer eerst een gebouw om de vloerfilter in te schakelen",
  cannot_select_gender_with_rooms: "Kan geen ruimtetype selecteren wanneer ruimtes zijn geselecteerd",
  cannot_select_gender_with_rooms_tooltip: "Het ruimtetypefilter kan niet worden gebruikt wanneer ruimtes zijn geselecteerd. Wis eerst de ruimteselectie.",
  cannot_select_building_with_rooms: "Kan gebouw niet selecteren wanneer kamers zijn geselecteerd",
  cannot_select_building_with_rooms_tooltip: "Gebouwfilter kan niet worden gebruikt wanneer kamers zijn geselecteerd. Maak eerst de kamerselectie leeg.",
  multi_select_hint: "Meerdere opties selecteren",
  filter_applied: "Filter succesvol toegepast",
  no_filters_selected: "Geen filters geselecteerd. Selecteer ten minste één filteroptie.",
  filters: "Filters",
  attributes: "Attributen",
  applying: "Toepassen",
  active_filters: "Actieve Filters",
  viewing_room: "projectiezaal",
  multiple: "Meervoudig",
  close: "Sluiten",
  save_replacement: "Vervanging opslaan",
  save_change: "Wijziging opslaan",
  save_check: "Controle opslaan",
  failed_to_load_maintenance_history: "Kan onderhoudsgeschiedenis niet laden",
  "Battery replacement recorded successfully": "Batterijvervanging succesvol geregistreerd",
  "Panel change recorded successfully": "Paneelwijziging succesvol geregistreerd",
  "Technician check recorded successfully": "Controle door technicus succesvol geregistreerd",
  no_network_data_available: "Geen netwerkgegevens beschikbaar",
  chat_ask_buzzz: "Vraag het aan Buzzz",
  chat_hide: "Verberger",
  chat_buzzz_assistant: "Buzzz-assistent",
  chat_export: "Exporteren",
  chat_clear: "Wissen",
  chat_unpin: "Losmaken",
  chat_pin: "Speld",
  chat_retry: "Opnieuw proberen",
  chat_copy: "Kopie",
  chat_copied: "Gekopieerd!",
  chat_share: "Delen",
  chat_suggestions: "Advies",
  chat_input_placeholder: "Vraag naar je statistieken...",
  chat_stop: "Stoppen",
  chat_error: "Er ging iets mis; probeer het nog eens.",
  chat_placeholder: "Vraag me naar je schoonmaakstatistieken...",
  chat_placeholder_context: "Vraag naar {scope}...",
  chat_chip_briefing: "Ochtendbriefing",
  chat_chip_live_status: "Live status",
  chat_chip_staff_status: "personeelsstatus",
  chat_chip_summary: "Samenvatting",
  chat_chip_cleaning_priority: "Schoonmaak prioriteit",
  chat_chip_worst_rooms: "Slechtste kamers",
  chat_chip_focus: "Aandachtsgebieden",
  chat_chip_compare_periods: "Vergelijk &perioden",
  chat_chip_sla_issues: "SLA-problemen",
  chat_chip_shift_stats: "Verschuivingsstatistieken",
  chat_chip_complaint_types: "Klachtensoorten",
  chat_chip_busiest_hours: "Drukste uren",
  chat_chip_worst_days: "Slechtste dagen",
  chat_chip_improving: "Kamers verbeteren",
  chat_chip_best_rooms: "Beste kamers",
  chat_chip_help: "Help",
  chat_chip_why_drilldown: "Waarom? Drill down",
  chat_deep_analysis: "Diepe analyse (langzamer)",
  chat_greeting: "Hoi {name}, hoe kan ik je helpen?",
  chat_status_online: "Online",
  chat_status_thinking: "Aan het denken…",
  chat_tool_overview: "Overzicht aan het trekken...",
  chat_tool_rooms: "Kamers controleren...",
  chat_tool_hours: "Uren analyseren...",
  chat_tool_days: "Dagelijkse gegevens bekijken...",
  chat_tool_live: "Live-status controleren...",
  chat_tool_priority: "Prioriteiten controleren...",
  chat_tool_room_detail: "Kamerdetails ophalen...",
  chat_tool_shifts: "Diensten bekijken...",
  chat_tool_staff: "Personeel controleren...",
  chat_tool_devices: "Apparaten controleren...",
  chat_feedback_good: "Goed antwoord",
  chat_feedback_bad: "Slecht antwoord",
  chat_feedback_thanks: "Bedankt voor je feedback!",
  chat_feedback_wrong_data: "Onjuiste gegevens",
  chat_feedback_didnt_understand: "Niet begrepen",
  chat_feedback_missing_info: "Ontbrekende informatie",
  chat_feedback_bad_format: "Slechte opmaak",
  chat_feedback_hallucinated: "Verzonnen cijfers",
  chat_feedback_submit: "Verzenden",

  "español": "Spaans",
  "français": "Frans",
  "русский": "русский",
  "አማርኛ": "Ja",
  "português": "portugees",
  "cleaner-activity": "Schonere activiteit",
  "device-actions": "Apparaatacties",
  "pad-presence-testing": "Pad-aanwezigheidstest",
  "real-time-cleaning": "Realtime - schoonmaak",
  "real-time-maintenance": "Realtime - onderhoud",
  "no_real_time_tabs_permitted": "Je hebt geen toestemming om een realtime-tabblad te bekijken",
  "cleaner_activity": "Schonere activiteit",
  "pad_presence_testing": "Pad-aanwezigheidstest",
  "pad_presence_testing_subtitle": "Binnenkomst, vertrek en offline pad-drukken via de telefoon voor de geselecteerde locatie",
  "pad_presence_timeline": "Live tijdlijn",
  "pad_presence_sessions": "Aanwezigheidssessies",
  "pad_presence_offline_presses": "Offline drukken van telefoons",
  "pad_presence_select_site_hint": "Selecteer een bedrijf en locatie in de kop om aanwezigheidsgebeurtenissen te bekijken.",
  "pad_presence_no_events": "Geen aanwezigheidsgebeurtenissen in dit venster.",
  "pad_presence_open": "Open",
  "pad_presence_exit_phone": "Telefoonvertrek",
  "pad_presence_exit_auto": "Automatisch vertrek",
  "pad_presence_exit_stale": "Verouderd vertrek",
  "pad_presence_enter": "Binnenkomst",
  "pad_presence_exit": "Vertrek",
  "pad_presence_offline": "Offline druk",
  "pad_presence_faulty": "Ongeldig",
  "pad_presence_employee": "Medewerker",
  "pad_presence_room": "Ruimte",
  "pad_presence_time_from": "Van",
  "pad_presence_last_updated": "Bijgewerkt",
  "pad_presence_duration": "Duur",
  "pad_presence_exit_type": "Type vertrek",
  "pad_presence_button": "Knop",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Aantal",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Alle medewerkers",
  "pad_presence_all_rooms": "Alle ruimtes",
  "pad_presence_load_error": "Kon pad-aanwezigheidsgegevens niet laden.",
  "pad_presence_in_room_now": "Nu in een ruimte",
  "pad_presence_in_room": "in",
  "pad_presence_since": "sinds",
  "pad_presence_just_now": "Zojuist",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefoon",
  "pad_presence_all_phones": "Alle telefoons",
  "pad_presence_window": "Tonen",
  "pad_presence_window_hour": "Laatste uur",
  "pad_presence_window_today": "Vandaag",
  "pad_presence_window_month": "Laatste maand",
  "pad_presence_pads": "Pads op deze locatie",
  "pad_presence_no_pads": "Er zijn geen pads aan ruimtes op deze locatie gekoppeld.",
  "pad_presence_last_enter": "Laatste binnenkomst",
  "pad_presence_last_offline": "Laatste offline druk",
  "pad_presence_auto_exit_leave": "Vertrek nu → automatisch vertrek over",
  "pad_presence_auto_exit_earliest": "Vroegst vanaf binnenkomst:",
  "pad_presence_auto_exit_passed": "Het vroegste automatische vertrek is voorbij. Nog open = de pad wordt nog gehoord, of vertrek en wacht 5m 45s.",
  "cleaner_activity_live_footer": "Gegevensupdates in realtime",
  "ca_empty_select_site_hint": "Selecteer een bedrijf en locatie in de koptekst om de schoonmaakactiviteiten van vandaag te bekijken.",
  "ca_empty_no_cleaners_hint": "Er zijn geen schoonmakers toegewezen aan deze locatie en de huidige dienst. Wijs actieve sites en ploegen in gebruikers toe.",
  "ca_empty_access_denied": "Toegang geweigerd",
  "ca_empty_access_denied_hint": "U heeft geen toestemming om schoonmaakactiviteiten voor deze site te bekijken.",
  "ca_empty_load_error_hint": "Kan schoonmaakactiviteit niet laden. Probeer het opnieuw of neem contact op met de ondersteuning als het probleem zich blijft voordoen.",
  "ca_empty_no_filter_match": "Er zijn geen schoonmaakmiddelen die overeenkomen met deze filters",
  "ca_empty_no_filter_match_hint": "Probeer de filters leeg te maken of kies een andere stofzuiger, werkruimte of kamer.",
  "ca_timeline_all_cleaners": "Activiteit van vandaag — alle schoonmakers",
  "ca_legend_work": "Actief",
  "ca_clock_sessions_more": "meer",
  "ca_clock_sessions_less": "Laat minder zien",
  "ca_sort_label": "Soort",
  "ca_sort_needs_attention": "Heeft aandacht nodig",
  "ca_sort_best_avg_response": "Beste gemiddelde reactie",
  "ca_sort_worst_avg_response": "Slechtste gemiddelde reactie",
  "ca_sort_most_sla_breaches": "De meeste SLA-schendingen",
  "ca_sort_most_open_complaints": "Meest openstaande klachten",
  "ca_sort_most_work_time": "De meeste werktijd",
  "ca_sort_least_work_time": "Minste werktijd",
  "ca_stat_avg_short": "gem",
  "ca_stat_open_short": "open",
  "ca_stat_breach_short": "inbreuk",
  "ca_stat_work_short": "werk",
  "ca_assigned_room_avg_hint": "Gemiddelde respons voor toegewezen kamers vandaag",
  "ca_transit_tooltip": "Transittijd tussen taken",
  "ca_transit_live_tooltip": "Tijd sinds de laatste taak is gesloten",
  "ca_legend_visits": "Bezoeken tussen meldingen",
  "ca_visits_between_sla": "Bezoeken sinds de vorige melding is gesloten",
  "ca_apply": "Toepassen",
  "ca_visits_since": "sinds",
  "ca_deferred_tip_title": "Uitgestelde klacht",
  "ca_deferred_tip_resolved": "Opgelost",
  "ca_deferred_tip_desc_open": "Nog steeds open - de schoonmaker heeft eerst andere kamers onderhouden in plaats van deze.",
  "ca_deferred_tip_desc_closed": "Deze klacht bleef open terwijl de schoonmaker eerst andere kamers bediende.",
  "ca_deferred_tip_rooms_label": "Eerst onderhouden:",
  "ca_attention_title": "Heeft aandacht nodig",
  "ca_attention_empty": "Alles duidelijk - momenteel geen problemen",
  "ca_attention_sla_breach_one": "{name} · SLA geschonden",
  "ca_attention_sla_breach_many": "{name} · {count} SLA-schendingen",
  "ca_attention_open_while_out_one": "{naam} · open klacht terwijl u bent uitgeklokt",
  "ca_attention_open_while_out_many": "{name} · {count} open terwijl uitgeklokt",
  "ca_attention_idle": "{naam} · inactief {duur}",
  "ca_attention_late": "{naam} · te laat ingeklokt",
  "ca_attention_show": "Show",
  "ca_attention_hide": "Verbergen",
  "all": "Alle",
  "check_site_and_shift": "Controleer of er een locatie is geselecteerd met een actieve dienst",
  "cleaner": "Schoonmaker",
  "close": "Sluiten",
  "communication_clear_filters": "Filters wissen",
  "failed_to_load_data": "Gegevens laden mislukt",
  "filters": "Filters",
  "next": "Volgende",
  "no_active_shift": "Geen actieve dienst",
  "no_cleaners_found": "Geen schoonmakers gevonden",
  "open_complaints": "Open klachten",
  "please_select_company_site": "Selecteer een bedrijf en locatie",
  "refresh_failed": "Vernieuwen mislukt",
  "rooms": "Ruimtes",
  "select": "Selecteren",
  "shift": "Dienst",
  "working_area": "Werkgebied",
  "ca_view_shift": "Dienst",
  "ca_view_history": "Geschiedenis",
  "ca_filters_done": "Klaar",
  "ca_hist_preset_this_month": "Deze maand",
  "ca_hist_preset_last_month": "Vorige maand",
  "ca_hist_preset_this_week": "Deze week",
  "ca_hist_preset_last_week": "Vorige week",
  "ca_hist_preset_custom": "Aangepast",
  "ca_hist_from": "Van",
  "ca_hist_to": "Tot",
  "ca_hist_range_invalid": "De begindatum moet vóór de einddatum liggen",
  "ca_hist_range_too_long": "Het bereik mag maximaal {max} dagen zijn",
  "ca_hist_search": "Zoek op naam of telefoon",
  "ca_hist_people_count": "{count} medewerkers",
  "ca_hist_kpi_days": "Gewerkte dagen",
  "ca_hist_kpi_net": "Netto uren",
  "ca_hist_kpi_breaks": "Pauzes",
  "ca_hist_col_person": "Medewerker",
  "ca_hist_col_total": "Totaal uren",
  "ca_hist_col_total_tip": "Van inklokken tot uitklokken vóór pauzes, hetzelfde cijfer dat de medewerker in de app ziet",
  "ca_hist_col_net": "Netto uren",
  "ca_hist_col_breaks": "Pauzes",
  "ca_hist_col_issues": "Aandachtspunten",
  "ca_hist_col_late": "Te laat",
  "ca_hist_col_missed": "Gemist",
  "ca_hist_col_no_clock_out": "Niet uitgeklokt",
  "ca_hist_clocked_in_now": "Nu ingeklokt",
  "ca_hist_not_assigned": "Niet toegewezen aan deze locatie",
  "ca_hist_no_shift": "Geen dienst toegewezen",
  "ca_hist_unknown_name": "Onbekend",
  "ca_hist_empty": "Geen aanwezigheid in deze periode",
  "ca_hist_empty_hint": "Niemand heeft op deze locatie ingeklokt en er zijn geen medewerkers aan toegewezen.",
  "ca_hist_no_match": "Geen medewerkers voldoen aan de filters",
  "ca_hist_load_error_hint": "De aanwezigheidsgeschiedenis kon niet worden geladen. Probeer het zo opnieuw.",
  "ca_hist_prev_person": "Vorige medewerker",
  "ca_hist_next_person": "Volgende medewerker",
  "ca_hist_close": "Sluiten",
  "ca_hist_legend_worked": "Gewerkt",
  "ca_hist_legend_late": "Te laat",
  "ca_hist_legend_missed": "Gemist",
  "ca_hist_legend_no_clock_out": "Niet uitgeklokt",
  "ca_hist_late_by": "{duration} te laat",
  "ca_hist_late_tip": "Ingeklokt om {time}, {shift} begint om {start}",
  "ca_hist_missed": "Gemist",
  "ca_hist_missed_tip": "Geplande dienst is geëindigd zonder inklokken",
  "ca_hist_no_clock_out": "Niet uitgeklokt",
  "ca_hist_no_clock_out_tip": "Sessie nooit afgesloten; de uren tellen niet mee",
  "ca_hist_in_progress": "Nog ingeklokt",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "open",
  "ca_hist_day_col_gross": "Totaal uren",
  "ca_hist_day_col_breaks": "Pauzes",
  "active_cleaners": "Actieve reinigers",
  "closed_complaints": "Gesloten klachten",
  "total_work_time": "Totale werktijd",
  "total_work_time_net": "Totale werktijd (vandaag netto)",
  "total_break_time": "Totale pauzetijd",
  "avg_response_time": "Gem. opgelost",
  "clocked_in": "Ingeklokt",
  "clocked_out": "Uitgeklokt",
  "still_clocked_in": "Nog steeds ingeklokt",
  "clocked_in_late": "Te laat ingeklokt",
  "total_hours": "Totaal uren",
  "auto_punch": "Automatisch (geofence)",
  "manual_punch": "Handmatig",
  "complaint_opened": "Klacht geopend",
  "complaint_closed": "Klacht gesloten",
  "complaint_still_open": "Nog steeds geopend",
  "resolved_in": "Binnen opgelost",
  "open_for": "Open voor",
  "sla_breached": "SLA geschonden",
  "no_activity_today": "Vandaag nog geen activiteit",
  "just_now": "zojuist",
  "ago": "geleden",
  "today": "Vandaag",
  "live": "Live",
  "last_updated": "Bijgewerkt",
  "analytics_export_confirm": "Analytics CSV-bestanden downloaden?",
  "analytics_export_title": "Analysegegevens exporteren",
  "analytics_export_description": "Er wordt een ZIP-bestand met uw momenteel gefilterde analyses gedownload: samenvatting, donut, uren, kamers en aankomsten van schoonmaker/supervisor.",
  "download": "Downloaden",
  "analytics_export_blocked_loading": "Analytics-gegevens worden nog geladen. Wacht even en probeer het opnieuw.",
  "analytics_export_blocked_no_data": "Er zijn geen analysegegevens om te exporteren. Pas uw filters toe en wacht tot de pagina is geladen.",
  "analytics_export_blocked_stale_filters": "Filters zijn veranderd. Pas filters toe en wacht tot de analyses opnieuw zijn geladen voordat u exporteert.",
  "have_you_finished_making_changes": "Ben je klaar met het maken van wijzigingen?",
  "assignment_issues_found": "Toewijzingsproblemen gevonden",
  "unassigned_rooms_title": "Niet-toegewezen ruimtes",
  "overlapping_assignments_title": "Overlappende toewijzingen",
  "and_n_more": "en nog {count}",
  "continue_anyway": "Toch doorgaan",
  "stay_and_fix": "Blijven en herstellen",
  "assignment_coverage_issues": "{unassigned} niet toegewezen · {overlaps} overlappingen",
  "assignment_check_failed": "Kon ruimtetoewijzingen niet verifiëren",
  "tap_for_details": "Tik voor details",

  "has_app": "App",
  "has_app_tooltip": "Schoonmaker heeft de app",
  "notifications_tooltip": "Pushmeldingen staan aan",
  "assigned_to_rooms": "Toegewezen aan kamers",
  "assigned_to_rooms_tooltip": "Heeft ruimtes op deze locatie",
  "recently_active": "Recent actief",
  "works_at_site": "Werkt op locatie",
  "recently_active_tooltip": "Opende de app in de laatste 30 minuten",
}

export const cs = {
  "room_type_required": "Vyberte typ místnosti pro každou skupinu",
  ...serviks.cs,
  notified: "Oznámeno",
  supervisor_arrival: "Příjezd supervizora",
  arrival: "Příchod",
  arrival_badges: "Příjezdy na směny",
  visits_since_cleaned: "Návštěvy od posledního čištění",
  visits_since_cleaned_short: "Od posledního čištění",
  filter: "Filtr",
  logo: "Logo",
  counter: "Čelit",
  sms: "SMS",
  shifts: "Směny",
  call: "Volání",
  openCalls: "Otevřené hovory",
  callsHistory: "Historie hovorů",
  duration: "Trvání",
  time_start: "Začátek času",
  settings: "Nastavení",
  always: "Vždy",
  off: "Vypnuto",
  time_based: "Na základě času",
  location_based: "Umístění založené",
  notification_mode: "Režim oznámení",
  notification_times: "Časy oznámení",
  notification_times_info: "Časová období se spravují z mobilní aplikace",
  notification_location: "Umístění oznámení",
  notification_sound: "Zvuk upozornění",
  no_sound: "Žádný zvuk",
  default_sound: "Výchozí zvuk",
  soft_bell: "Měkký zvonek",
  digital_sound: "Digitální zvuk",
  mallet_sound: "Zvuk paličky",
  phone_sound: "Zvuk telefonu",
  text_sound: "Textový zvuk",
  manager_alert_delay: "Zpoždění výstrahy manažera",
  snooze_interval: "Připomínka",
  vocal_notifications: "Hlasová upozornění",
  no_delay: "Žádné zpoždění",
  no_snooze: "Žádná připomínka",
  lat: "lat",
  lon: "Lon",
  radius: "Poloměr",
  no_location_set: "Není nastaveno žádné umístění",
  when_to_notify: "Kdy upozornit",
  notification_preferences: "Předvolby oznámení",
  assignment_configuration: "Přiřazení a konfigurace",
  status: "Postavení",
  working_area: "Pracovní oblast",
  complaints_NC: "Reklamace / NC",
  SLA_NC: "SLA / NC",
  arrivals_NC: "Příjezdy / NC",
  staff: "Personál",
  cleaning_complaints: "Reklamace úklidu",
  export: "Vývozní",
  maintenance_complaints: "Reklamace údržby",
  maintenanceArrivals: "Příjezdy údržby",
  maintenance_arrivals: "Příjezdy údržby",
  last: "Poslední",
  survey_name: "Název průzkumu",
  survey: "Přehled",
  pad_survey: "Průzkum podložky",
  pad_no_maintenance_survey: "Podložka bez průzkumu údržby",
  pad_kitchen: "Kuchyňská podložka",
  number_of_assigned_devices: "# přiřazených zařízení",
  number_of_pages: "# stránek",
  date_created: "Datum vytvoření",
  updated_by: "Aktualizováno uživatelem",
  date_updated: "Datum aktualizováno",
  search: "Vyhledávání",
  choose_type: "Vyberte typ",
  permitted_sites: "Povolené stránky",
  permitted_franchise: "Povolená franšíza",
  permitted_companies: "Povolené společnosti",
  panel_permitted: "Panel povolen",
  end_time: "Čas ukončení",
  last_update: "Poslední aktualizace",
  add_device: "Přidat zařízení",
  detailed: "Detailní",
  analysis: "Analýza",
  suggestion: "Návrh",
  country: "Země",
  management: "Řízení",
  device: "Zařízení",
  mapping: "Mapování",
  please_enter: "Zadejte prosím",
  new_device: "Nové zařízení",
  assign_device: "Přiřadit zařízení",
  installSpot: "Místo instalace",
  device_type: "Typ zařízení",
  deviceCode: "Kód zařízení",
  device_code: "Kód zařízení",
  scan_or_enter_device_code: "Naskenujte nebo zadejte kód zařízení...",
  scan_device: "Přiřadit",
  scan_qr_in_frame: "Zarovnejte QR kód do rámečku. U malých kódů držte telefon 15–25 cm daleko a klepněte na náhled pro opětovné zaostření, pokud je obraz rozmazaný.",
  checking_device_code: "Kontrola kódu zařízení...",
  camera_not_available: "Kamera není k dispozici. Kód můžete zadat ručně.",
  device_code_already_exists: "Tento kód zařízení je již přiřazen jinému senzoru.",
  assigned_to_company_site_room: "Již přiřazeno k {company} / {site} / {room}",
  device_code_lookup_failed: "Kód zařízení se nepodařilo ověřit. Zkuste to znovu.",
  device_code_no_site_access: "Tento kód je již registrován v místě, ke kterému nemáte přístup.",
  device_code_check_unavailable: "Server kód nemohl ověřit. Zkuste to znovu.",
  device_code_not_a_code: "Sken přečetl „{code}“. Zadejte samotný kód zařízení.",
  device_code_open_failed: "Toto zařízení se nepodařilo otevřít. Zkuste to znovu.",
  device_code_save_failed: "Kód zařízení se nepodařilo uložit. Zkuste to znovu.",
  device_code_save_forbidden: "Toto zařízení nemůžete změnit.",
  confirm_replace_device_code: "Nahradit kód zařízení?",
  confirm_replace_device_code_body: "Opravdu chcete nahradit kód {oldCode} kódem {newCode}?",
  room: "Pokoj",
  edit_room: "Upravit místnost",
  edit_franchise: "Upravit franšízu",
  new_franchise: "Nová franšíza",
  desc: "Popis",
  address: "Adresa",
  level: "Úroveň",
  no_companies_to_show: "Žádné společnosti k zobrazení",
  company_type: "Typ společnosti",
  region: "Kraj",
  new_company: "Nová společnost",
  edit_company: "Upravit společnost",
  edit_user: "Upravit uživatele",
  "C.arrivals": "Přišel čistič",
  "C.complaints": "Reklamace čištění",
  "M.complaints": "Reklamace údržby",
  "M.Arrivals": "Příjezdy údržby",
  analyses: "Analýzy",
  clean_log: "Čistý protokol",
  maintenance_log: "Deník údržby",
  like: "Jako",
  likes: "Líbí se",
  new_user: "Nový uživatel",
  shift_parameters: "Parametr Shift",
  add_shift: "Nová směna",
  edit_shift: "Upravit směnu",
  username: "Uživatelské jméno",
  first_name: "Křestní jméno",
  job_function: "Funkce",
  role: "Role",
  property_manager: "Správce nemovitosti",
  facility_manager: "Facility manažer",
  site_manager: "Vedoucí objektu",
  workplace_manager: "Vedoucí pracoviště",
  cleaning_company_ceo: "Ředitel úklidové firmy",
  operations_manager: "Provozní manažer",
  area_manager: "Oblastní manažer",
  site_cleaning_manager: "Vedoucí úklidu objektu",
  cleaning_supervisor: "Supervizor úklidu",
  other: "Jiné",
  restroom_cleaner: "Úklid toalet",
  general_cleaner: "Generální uklízeč",
  day_porter: "Denní pomocník",
  office_cleaner: "Úklid kanceláří",
  public_area_cleaner: "Úklid společných prostor",
  firstName: "Křestní jméno",
  description: "Popis",
  last_name: "Příjmení",
  lastName: "Příjmení",
  phone: "Telefon",
  building_area: "Stavební plocha",
  users: "Uživatelé",
  add_user: "Přidat uživatele",
  sites: "Weby",
  new_site: "Nové stránky",
  edit_site: "Upravit web",
  add_company: "Přidat společnost",
  franchise: "Franšíza",
  floor: "Patro",
  building: "Budova",
  humidity: "Vlhkost",
  humidity_abbr: "Vlhký",
  temperature: "Teplota",
  temperature_abbr: "Temp",
  gender: "Typ místnosti",
  display_name: "Jméno",
  zone: "Zóna",
  shift_number: "Posun#",
  shift: "Posun",
  shift_name: "Název směny",
  shift_currently_inactive: "Momentálně neaktivní směna",
  local_time: "Místní",
  end: "Konec",
  min_sla: "Min. SLA",
  max_sla: "Maximální SLA",
  days: "Dny",
  complaints_percent: "% stížností",
  sla_percent: "% SLA",
  arrivals_percent: "% Příjezdy",
  save_arrivals: "Uložit",
  clean_time: "Doba čištění (min)",
  tooltip_shift_number: "Pořadí zobrazení tohoto posunu (např. 1, 2).",
  tooltip_shift_name: "Název směny (např. Ráno, Noc).",
  tooltip_start_time: "Čas začátku směny v místním čase.",
  tooltip_end_time: "Posunout čas konce směny v místním čase.",
  tooltip_cleaners_number: "Počet uklízeček na této směně.",
  tooltip_min_sla: "Nejlepší doba odezvy (minuty) pro vyřízení stížnosti na pokoj; používá se jako spodní hranice skóre.",
  tooltip_max_sla: "Maximální přijatelná doba odezvy (minuty) pro vyřízení stížnosti na pokoj; používá se jako horní hranice skóre.",
  tooltip_arrivals: "Očekávané čistší příjezdy na pokoj a den; skóre porovnává skutečné příjezdy k tomuto cíli.",
  tooltip_save_arrivals: "Čistší návštěvy na pokoj a den před BuzzzTV; slouží k výpočtu ušetřeného času (nyní méně návštěv = ušetřených minut).",
  tooltip_clean_time: "Minuty započítané na návštěvu uklízečky v časově úsporném výpočtu (např. 15).",
  tooltip_complaints_percent: "Váha stížností ve skóre pokoje, když má pokoj návštěvy (vyšší = stížnosti ovlivňují skóre více).",
  tooltip_response_time_SLA: "Váha doby odezvy ve skóre místnosti, když má místnost návštěvy (vyšší = rychlejší odezva je důležitější).",
  tooltip_arrivals_percent: "Váha příchozích vs. cíl ve skóre pokoje, když má pokoj návštěvy.",
  tooltip_complaints_NC: "Váha stížností ve skóre, když místnost nemá žádné návštěvy (žádné počítadlo).",
  tooltip_SLA_NC: "Váha doby odezvy ve skóre, když místnost nemá žádné návštěvy.",
  tooltip_arrivals_NC: "Váha příchodů v skóre, když místnost nemá žádné návštěvy.",
  tooltip_days: "Dny v týdnu, kdy je tato směna aktivní.",
  tooltip_active_calculation: "Je-li povoleno, je tento posun zahrnut do skóre a časově uložených výpočtů.",
  auto_close_complaints_hour: "Hodina automatického uzavření stížností",
  tooltip_auto_close_complaints_hour: "Místní hodina, kdy jsou otevřené SLA SLA v této směně automaticky uzavřeny. Pro deaktivaci ponechejte prázdné.",
  auto_close_maintenance_complaints_hour: "Hodina automatického uzavření stížností údržby",
  tooltip_auto_close_maintenance_complaints_hour: "Místní hodina, kdy jsou otevřené SLA stížností údržby v této směně automaticky uzavřeny. Pro deaktivaci ponechejte prázdné.",
  no_auto_close: "-- Žádné --",
  tooltip_shift_rooms: "Místnosti přiřazené k této směně. Ponechte prázdné pro posun na úrovni webu.",
  company_name: "Název společnosti",
  site_name: "Název webu",
  site_desc: "Popis webu",
  service_provider_name: "Poskytovatel služeb",
  service_provider_type: "Typ poskytovatele služeb",
  service_provider_desc: "Popis poskytovatele služeb",
  user: "Uživatel",
  map: "Mapa",
  delete: "Vymazat",
  new_room: "Nový pokoj",
  issue_times: "Časy vydání",
  solved: "Vyřešeno",
  visits: "Návštěvy",
  complaints: "Stížnosti",
  complaints_in_shift: "Stěžuje si na tento posun",
  cleaner_arrivals: "Čistší příjezdy",
  unnecessary_arrivals: "Příjezdy bez výzvy",
  unnecessary_arrivals_hint: "Návštěva uklízeče v době, kdy v místnosti nebyl otevřený požadavek.",
  of_arrivals: "z příjezdů",
  response_time_SLA: "Doba odezvy",
  score: "Skóre",
  avg_score: "Prům. skóre",
  score_goal: "Vstřelit gól",
  top_problem_issues: "Hlavní problémy",
  top_problem_rooms: "Nejlepší pokoje",
  top_problem_hours: "Nejlepší hodiny",
  is_time_save: "Ušetřený čas",
  options: "Možnosti",
  send_battery_alerts: "Odesílat upozornění na baterii",
  environment_alerts: "Upozornění na prostředí",
  environment_alerts_description: "Odešlete e-mailová upozornění, když teplota nebo vlhkost opustí povolený rozsah",
  environment_alert_emails: "E-maily s upozorněním na životní prostředí",
  temperature_min: "Teplota min",
  temperature_max: "Teplota max",
  humidity_min: "Vlhkost min",
  humidity_max: "Vlhkost max",
  environment_alert_range_invalid: "Rozsah výstrah prostředí musí být číselný a min musí být menší nebo rovno max",
  coming_soon: "Již brzy",
  alert_emails: "Výstražné e-maily",
  alert_emails_placeholder: "Zadejte e-mailovou adresu",
  alert_language: "Jazyk upozornění",
  select_language: "Vyberte jazyk",
  invalid_email_format: "Jedna nebo více e-mailových adres je neplatných",
  add_email: "Přidejte další e-mail",
  next: "Další",
  back: "Zadní",
  basic_information: "Základní informace",
  service_providers: "Poskytovatelé služeb",
  settings_alerts: "Nastavení a upozornění",
  configuration: "Konfigurace",
  contact_settings: "Kontakt a nastavení",
  notifications: "Oznámení",
  features: "Vlastnosti",
  battery_alerts: "Upozornění na baterie",
  alerts_title: "Upozornění",
  location: "Umístění",
  time_save_description: "Povolit funkce pro úsporu času",
  exposures_description: "Sledujte údaje bez expozice",
  alerts_description: "Upozornění na informace o zařízení",
  shift_description: "Vytvořte výchozí směny",
  battery_alerts_description: "Odešlete e-mailová upozornění na nízkou baterii",
  est_ROI: "Odhadovaná návratnost investic",
  complaints_vs_visits: "Stížnosti vs návštěvy",
  view_by_years: "Zobrazit roky",
  view_by_months: "Zobrazit měsíce",
  view_by_weeks: "Zobrazit týdny",
  view_by_days: "Zobrazit dny",
  minutes: "Min",
  company: "Společnost",
  site: "místo",
  alerts: "Informace o zařízení",
  performance: "Výkon",
  devices: "Zařízení",
  total_devices: "Celkový počet zařízení",
  working: "Pracovní",
  warning: "Varování",
  by_device_type: "Podle typu zařízení",
  surveys: "Průzkumy",
  real_time: "v reálném čase",
  "real-time": "v reálném čase",
  admin: "Admin",
  all: "Vše",
  overview: "Přehled",
  exit_full_screen: "Ukončete celou obrazovku",
  full_screen: "Celá obrazovka",
  total: "Celkový",
  analytics: "Analytics",
  pdf_export_title_analytics: "Přehled Analytics",
  pdf_export_title_cleaner_arrivals: "Čistší příjezdy",
  communication: "Sdělení",
  overview_complaints_devices_caption: "Nainstalovaná zařízení (kumulativní)",
  overview_complaints_devices_caption_hint: "Celkový počet zařízení nainstalovaných na místě do konce každého měsíce na základě dat instalace.",
  overview_complaints_devices_toggle_aria: "Zobrazit nebo skrýt zařízení nainstalovaná pod grafem stížností",
  communication_select_site_title: "Vyberte web",
  communication_select_site: "Vyberte společnost a web z filtrů výše, chcete-li zobrazit a přidat poznámky pro toto místo.",
  communication_viewing_site: "Prohlížení",
  communication_add_note: "Přidejte poznámku",
  communication_add_note_open_aria: "Otevřete dialogové okno pro přidání poznámky",
  communication_form_hint: "Sdílejte aktualizace nebo poznámky s každým, kdo má přístup k tomuto webu. Nové poznámky uvidí v reálném čase.",
  communication_page_intro_title: "Poznámky k webu — sdílený protokol pro toto umístění",
  communication_page_intro_body: "Na této stránce můžete svému týmu zanechat předání, problémy, aktualizace a poznámky ze schůzek. Každý, kdo může otevřít tento web na portálu, může číst a přidávat poznámky.",
  communication_page_intro_dismiss: "Skryjte tento tip",
  communication_page_intro_aria: "O poznámkách k webu",
  communication_content_placeholder: "Sem napište svou poznámku...",
  communication_keyboard_hint: "Ctrl+Enter pro odeslání příspěvku",
  communication_submitting: "Odesílání...",
  communication_submit: "Odeslat poznámku",
  communication_recent_notes: "Poznámky",
  communication_search_placeholder: "Hledat podle autora nebo textu...",
  communication_refresh: "Obnovit",
  communication_clear_filters: "Vymazat filtry",
  communication_search_aria_label: "Hledat poznámky",
  communication_submit_aria_label: "Odeslat poznámku",
  communication_copy_note_aria_label: "Zkopírujte text poznámky",
  communication_copied: "Zkopírováno do schránky.",
  communication_copy_empty: "Neexistuje žádný text poznámky ke kopírování.",
  communication_filter_hidden_one: "(1 poznámka skrytá filtry)",
  communication_filter_hidden_many: "({n} poznámek skrytých filtry)",
  communication_request_timeout: "Časový limit požadavku vypršel. Zkuste to prosím znovu.",
  communication_load_failed: "Poznámky se nepodařilo načíst.",
  communication_retry: "Zkuste to znovu",
  communication_no_matches: "Vašemu vyhledávání ani filtrům neodpovídají žádné poznámky. Zkuste je upravit.",
  communication_no_entries: "Zatím žádné poznámky.",
  communication_no_entries_hint: "Začněte přidáním poznámky výše.",
  communication_just_now: "Právě teď",
  communication_minutes_ago: "před {n} min",
  communication_hours_ago: "před {n} h",
  communication_days_ago: "před {n} dny",
  communication_note_posted: "Poznámka zveřejněna.",
  communication_post_failed: "Nepodařilo se přidat poznámku. Zkuste to prosím znovu.",
  communication_note_type: "Typ poznámky",
  communication_type_general: "Generál",
  communication_type_update: "Aktualizovat",
  communication_type_issue: "Problém",
  communication_type_follow_up: "Sledování",
  communication_type_meeting: "Poznámka k setkání",
  communication_filter_all_types: "Všechny typy",
  communication_pinned: "Připnuto",
  communication_pin: "Kolík",
  communication_unpin: "Odepnout",
  communication_pin_limit: "Maximálně 2 připnuté",
  communication_pinned_toast: "Poznámka připnuta.",
  communication_unpinned_toast: "Poznámka odepnuta.",
  communication_pin_failed: "PIN se nepodařilo aktualizovat. Zkuste to prosím znovu.",
  communication_note_not_found: "Poznámka nebyla nalezena nebo nemáte přístup.",
  communication_site_not_in_filters: "Web této poznámky není ve vašich aktuálních filtrech. Je možné, že k tomuto umístění nemáte přístup.",
  communication_edit: "Upravit",
  communication_delete: "Vymazat",
  communication_save: "Uložit",
  communication_cancel: "Zrušit",
  communication_saving: "Ukládání...",
  communication_note_updated: "Poznámka aktualizována.",
  communication_update_failed: "Aktualizace poznámky se nezdařila. Zkuste to prosím znovu.",
  communication_delete_confirm: "Opravdu chcete smazat tuto poznámku? Tuto akci nelze vrátit zpět.",
  communication_delete_confirm_title: "Smazat poznámku",
  communication_note_preview: "Náhled poznámky:",
  communication_note_deleted: "Poznámka smazána.",
  communication_delete_failed: "Poznámku se nepodařilo smazat. Zkuste to prosím znovu.",
  communication_edited: "Upraveno",
  communication_show_more: "Zobrazit více",
  communication_show_less: "Ukažte méně",
  communication_sort_date_newest: "Nejdříve nejnovější",
  communication_sort_date_oldest: "Nejdříve nejstarší",
  communication_sort_author: "Podle autora",
  communication_sort_type: "Podle typu",
  communication_sort_pinned: "Nejprve připnuto",
  communication_sort_label: "Seřadit",
  communication_filter_by_type: "Typ",
  communication_filters_group_aria: "Filtrovat a třídit poznámky",
  communication_search_label_short: "Vyhledávání",
  employees: "Zaměstnanci",
  last_time_of_arrival: "Poslední čas příjezdu",
  arrival_and_status: "Příjezd a stav",
  preview_arrivals: "Náhled příletů",
  "men toilet": "Pánská toaleta",
  "women toilet": "Dámská toaleta",
  "shared toilet": "Společné WC",
  "unisex restroom": "Unisex toaleta",
  "handicapped toilet": "Bezbariérové ​​WC",
  "kitchen": "Kuchyně",
  "tablet": "Tablet",
  "office": "Kancelář",
  "logistics": "Logistika",
  "area": "Zóna",
  "cafeteria": "Jídelna",
  "lobby": "Vstupní hala",
  "cubicle": "Kabinka",
  "elevator": "Výtah",
  "gym": "Posilovna",
  dayOfWeek: "Dny",
  service_log: "Servisní deník",
  rooms: "Pokoje",
  bulk_add_rooms: "Hromadně přidat místnosti",
  adding_to: "Přidávání do",
  add_rooms: "Přidat místnosti",
  room_names_one_per_line: "Názvy pokojů (jeden na řádek)",
  "enter_at_least_one_room": "Zadejte alespoň jeden název místnosti",
  room_names_placeholder: "Pokoj 1\\nPokoj 2\\nZáchod pro ženy",
  rooms_with_prefix: "pokoje s prefixem",
  apply_to_all_rooms: "Použít na všechny místnosti (volitelné)",
  bulk_rooms_intro: "Přidejte jednu nebo více skupin. Každá skupina má svou vlastní budovu, patro, zónu, pohlaví a názvy místností.",
  group: "Skupina",
  add_group: "+ Přidat další skupinu",
  adding_rooms: "Přidávání místností...",
  bulk_summary: "Shrnutí",
  in: "v",
  bulk_rooms_success: "Úspěšně přidáno {n} místností",
  displayName: "Název místnosti",
  SLA: "SLA",
  supervisors: "Dozorci",
  supervisor: "Vedoucí",
  performance_analytics: "Analytika výkonu",
  arrivals: "Příjezdy",
  inspections: "Inspekce",
  avgResponseTime: "Prům. doba odezvy",
  missedSla: "Chyběla Sla",
  cleaner_arrived: "Přišel čistič",
  load_more: "Načíst více",
  login: "Přihlášení",
  email: "E-mail",
  emails: "e-maily",
  password: "Heslo",
  min: "Min",
  Logout: "Odhlášení",
  time_range: "Časový rozsah",
  select_time_range: "Vyberte časový rozsah",
  custom_time: "Vyberte termíny",
  last_day: "Včera",
  last_week: "Posledních 7 dní",
  last_month: "Posledních 30 dní",
  last_quarter: "Posledních 90 dní",
  last_6_months: "Posledních 6 měsíců",
  last_year: "Posledních 365 dní",
  data_by_hour: "Údaje po hodinách",
  general: "Generál",
  cleaning: "Čištění",
  maintenance: "Údržba",
  start: "Start",
  start_time: "Čas zahájení",
  management_co: "Manažerská společnost",
  cleaning_co: "Úklidová firma",
  companies: "Společnosti",
  name: "Jméno",
  site_count: "místo #",
  associated_companies: "Přidružení koncoví klienti",
  OK: "OK",
  cancel: "Zrušit",
  client: "Klient",
  dates: "Termíny",
  shift: "Posun",
  issue: "Problém",
  time: "Čas",
  "top complaint of the week": "Top stížnost týdne",
  "top room of the week": "Nejlepší místnost týdne",
  "top hour of the week": "Nejlepší hodina týdne",
  "top complaint of the month": "Nejlepší stížnost měsíce",
  "top room of the month": "Nejlepší místnost měsíce",
  "top hour of the month": "Nejlepší hodina měsíce",
  franchises: "Franšízy",
  add_franchise: "Přidat franšízu",
  room_names: "Název místnosti",
  type: "Typ",
  please_select_company_site: "Vyberte prosím společnost a web",
  number: "Číslo",
  create_building_map: "Vytvořte mapu budovy",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Hej, nejrychlejší způsob, jak přidat patra a místnosti do budov pomocí tohoto rychlého průvodce",
  "avg number of toilets per floor": "Průměrný počet toalet na patro",
  "avg.number of toilet cells per room": "Průměrný počet toaletních buněk na pokoj",
  "number of floors": "Počet pater",
  "avg.number of disabled toilets": "Prům. počet bezbariérových toalet",
  "avg.number of soap dispensers": "Prům. počet dávkovačů mýdla",
  reset_filter: "Resetovat filtr",
  add: "Přidat",
  new_survey: "Nový průzkum",
  api_configuration: "Konfigurace API",
  please_edit_the_api_information: "Upravte prosím informace API",
  method: "Metoda",
  authorization: "Povolení",
  api_url: "API_url",
  token: "Žeton",
  endpoint: "Koncový bod",
  add_url: "Přidat URL",
  remove: "Odstranit",
  format: "Formát",
  auth_api_key: "API klíč",
  auth_dynamic_key: "Dynamický klíč (GET)",
  auth_login_token: "Přihlašovací token (HTTP)",
  dynamic_token_url: "Adresa URL tokenu (GET)",
  token_response_field_name: "Token pole jako odpověď",
  token_login_url: "Přihlašovací URL",
  login_request_method: "Způsob žádosti o přihlášení",
  login_request_body: "Tělo žádosti o přihlášení (JSON)",
  login_token_placeholder_hint: "Volitelné: tajný klíč používaný k nahrazení {{tokenu}} v těle přihlášení JSON",
  token_response_key: "Název pole přístupového tokenu",
  survey_api_auth_header_name: "Název záhlaví ověření (volitelné)",
  survey_api_auth_header_prefix: "Text před tokenem v tomto záhlaví",
  survey_api_auth_header_name_placeholder: "např. Autorizace, X-Api-Key",
  survey_api_auth_header_prefix_placeholder: "např. Nosič — konečná hlavička je: prefix + mezera + token",
  api_request_info: "Informace o požadavku API",
  roomName: "Název místnosti",
  servikName: "Název stížnosti",
  siteName: "Název webu",
  stage: "Fáze",
  number_of_buttons: "Počet tlačítek",
  button_shape: "Tvar tlačítka",
  delay_time_stage: "Fáze zpoždění",
  go_to_stage: "Jděte na pódium",
  color: "Barva",
  add_stage: "Přidat fázi",
  save: "Uložit",
  number_of_issues: "počet problémů",
  online: "Online",
  offline: "Offline",
  offline_devices: "Offline zařízení",
  no_offline_devices: "Nebyla nalezena žádná offline zařízení",
  working_devices: "Pracovní zařízení",
  no_working_devices: "Nebyla nalezena žádná funkční zařízení",
  room_name: "Název místnosti",
  installation_spot: "Místo",
  device_id: "ID zařízení",
  date: "Datum",
  status: "Postavení",
  device_status: "Stav zařízení",
  none: "žádný",
  no_surveys_created: "Nebyly vytvořeny žádné průzkumy",
  dashboard: "Dashboard",
  franchise_name: "Název franšízy",
  franchise_country: "Země franšízy",
  choose_franchise: "Vyberte si franšízu",
  choose_country: "Vyberte zemi",
  select_template: "Vyberte šablonu",
  default_survey: "Výchozí průzkum",
  cleaning_survey: "Průzkum úklidu",
  kitchen_survey: "Průzkum kuchyně",
  template: "Šablona",
  area_name: "Název oblasti",
  rooms_names: "Názvy místností",
  rooms_number: "Místnosti #",
  assign_number: "Přiřadit #",
  active_notification_task: "Aktivní oznamovací úloha",
  amount_limit: "Interval čítače",
  after_max: "Počítadlo po Max",
  new_area: "Nová oblast",
  edit_area: "Upravit oblast",
  tablet: "Tableta",
  "counter women": "Proti ženám",
  "counter men": "Proti muži",
  "counter handicap": "Counter handicap",
  "counter man/woman": "Counter muž / žena",
  "counter man / woman": "Counter muž / žena",
  "sensor liquid": "Senzorová kapalina",
  "double toilet paper": "Dvojitý toaletní papír",
  "toilet paper": "Toaletní papír",
  tag: "Štítek",
  "qr tag": "QR tag",
  additional_info: "Další informace",
  servikCategory: "Typ hovoru",
  dishwashing: "Mytí nádobí",
  cafeteria: "Jídelna",
  "clean room": "Čistá místnost",
  office: "Kancelář",
  "meeting room": "Zasedací místnost",
  cubic: "Krychlový",
  women: "Ženy",
  men: "Muži",
  handicap: "Handicap",
  Combined: "Kombinovaný",
  kitchen: "Kuchyně",
  east: "Východní",
  west: "Západ",
  north: "Severní",
  south: "Jižní",
  right: "Právo",
  left: "Vlevo",
  center: "Centrum",
  up: "Nahoru",
  down: "Dolů",
  combined: "Kombinovaný",
  lobby: "Lobby",
  entrance: "Vjezd",
  reception: "Recepce",
  area: "Plocha",
  mezzanine: "Mezipatro",
  gallery: "Galerie",
  ground: "Země",
  elevator: "Výtah",
  is_calculated: "Vypočítaná místnost",
  calculated_room: "Vypočítaná místnost",
  splitted_survey: "Rozdělený průzkum",
  redirect_to_url: "Přesměrování na url",
  survey_site: "Místo průzkumu",
  clicks: "kliknutí",
  add_stage_number_to_signal: "Připojte číslo etapy",
  including_pad9: "Včetně podložky 9",
  "Tech Manufacturers": "Technologičtí výrobci",
  "Tech Offices": "Technologické kanceláře",
  "Offices": "Kanceláře",
  "Terminal": "Terminál",
  "Universities": "Univerzity",
  "Factories": "Továrny",
  "Hospital": "Nemocnice",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Večerky",
  "Food Chains": "Potravinové řetězce",
  "Residential": "Rezidenční",
  "Shopping Center": "Obchodní centrum",
  "Survey": "Průzkum",
  "Demo": "Ukázka",
  "Vision": "Vision",
  "Court": "Soud",
  "Office Management": "Správa kanceláří",
  "Government Office": "Úřad",
  default_name: "Jméno v angličtině",
  exposures: "Čistá expozice",
  exposures_tab: "Aktivita místnosti",
  expose_results: "Výsledky",
  events_expose: "Události",
  expose_score: "Hodnotit",
  shift_events_expose: "Posunout události a vystavit",
  type_of_site: "Typ webu",
  morning_shift: "Ranní směna",
  afternoon_shift: "Odpolední směna",
  night_shift: "Noční směna",
  update: "Aktualizovat",
  restart: "Restartujte",
  send_data: "Odeslat data",
  send_count: "Počet odeslání",
  blink: "Blikat",
  beacon: "Beacon",
  like_btn: "Tlačítko líbí se mi",
  requires_like_btn: "Vyžaduje zapnuté tlačítko líbí se mi",
  maintenance_btn: "Tlačítko údržby",
  battery: "Baterie",
  version: "Verze",
  actions: "Akce",
  device_actions: "Akce zařízení",
  device_settings: "Nastavení zařízení",
  drains_battery: "Vybíjí baterii",
  latest_errors: "Nejnovější chyby",
  no_errors: "Žádné chyby",
  offline_calls: "Offline hovory",
  offline_duration_calls: "Doba trvání hovorů offline",
  counterCalls: "Počítadlo hovorů",
  active: "Aktivní",
  no_active_supervisors: "Žádní aktivní dozorci",
  active_supervisors_column: "Aktivní supervizoři",
  supervisors_active_label: "supervizoři jsou nyní aktivní",
  active_supervisors_coverage_hint: "Aktivní supervizoři mají tuto oblast zapnutou v mobilní aplikaci. To neznamená online stav nebo fyzickou přítomnost.",
  active_calculation: "Aktivní výpočet",
  pad: "Podložka",
  pad_counter: "Počítadlo podložek",
  counter_status: "Stav počítadla",
  choose_state: "Vyberte stát",
  choose_city: "Vyberte město",
  start_hour: "Začátek hodiny",
  end_hour: "Koncová hodina",
  analytics_log: "Analytický protokol",
  or: "nebo",
  no_data_available: "Nejsou k dispozici žádné údaje",
  filter_by_cleaner: "Filtrujte čističem",
  all_cleaners: "Všechny čističe",
  not_available: "N/A",
  failed_to_load_data: "Data se nepodařilo načíst",
  new_task: "Nový úkol",
  new_personal_task: "Nový osobní úkol",
  task_assignment: "Zadání úkolu",
  task_assignment_room: "Pokojový úkol",
  task_assignment_personal: "Osobní úkol (přidělit uklízečce)",
  temporarily_unavailable: "Dočasně nedostupné",
  task_details: "Podrobnosti úkolu",
  task_languages: "Jazyky úkolů",
  task_languages_hint: "Vyberte jazyky pro tento úkol. Název zadáte v každém zvoleném jazyce.",
  settings_and_assignment: "Nastavení a přiřazení",
  assignee: "Zmocněnec",
  category: "Kategorie",
  title: "Titul",
  task_type: "Typ úkolu",
  task_category: "Kategorie úkolu",
  call_to_action: "Výzva k akci",
  schedule: "Naplánovat",
  insert_text: "Vložte text",
  select: "Vybrat",
  select_all: "Vyberte Vše",
  n_selected: "Vybráno: {count}",
  clear_selection: "Zrušit výběr",
  wa_bulk_edit: "Bulk edit",
  wa_bulk_edit_hint: "Apply one change to {count} selected work areas.",
  wa_bulk_action: "What do you want to change?",
  wa_bulk_set_counter: "Counter",
  wa_bulk_add_task: "Add notification task",
  wa_bulk_remove_task: "Remove notification task",
  wa_bulk_enable_counter: "Turn counter on if currently off",
  wa_bulk_apply_to_n: "Apply to {count} areas",
  wa_bulk_edit_result: "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  wa_bulk_set_counter_desc: "Turn counter on/off or set the same interval on selected areas",
  wa_bulk_add_task_desc: "Add one active notification task to selected areas",
  wa_bulk_remove_task_desc: "Remove one active notification task from selected areas",
  wa_bulk_enable_counter_hint: "Areas with counter currently off will be turned on",
  wa_bulk_search_task: "Search notification tasks",
  wa_bulk_selected_task: "Selected task",
  wa_bulk_counter_state: "Counter status",
  wa_bulk_counter_on: "Turn on",
  wa_bulk_counter_off: "Turn off",
  wa_bulk_counter_unchanged: "Keep status",
  wa_bulk_counter_on_hint: "Turn counter on for all selected areas and set the interval",
  wa_bulk_counter_off_hint: "Turn counter off for all selected areas",
  wa_bulk_counter_unchanged_hint: "Only update the interval; leave on/off as it is",
  wa_bulk_task_coverage_remove: "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  wa_bulk_task_coverage_add: "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  schedule_dates: "Naplánujte si termíny",
  language: "Jazyk",
  calendar: "Kalendář",
  operation: "Operace",
  daily: "Denní",
  weekly: "Týdně",
  monthly: "Měsíční",
  quarterly: "Čtvrtletní",
  yearly: "Roční",
  sunday: "neděle",
  monday: "pondělí",
  tuesday: "úterý",
  wednesday: "středa",
  thursday: "čtvrtek",
  friday: "pátek",
  saturday: "sobota",
  january: "leden",
  february: "únor",
  march: "Pochod",
  april: "duben",
  may: "květen",
  june: "červen",
  july: "červenec",
  august: "srpen",
  september: "září",
  october: "říjen",
  november: "listopad",
  december: "prosinec",
  "1st week": "1. týden",
  "2nd week": "2. týden",
  "3rd week": "3. týden",
  "4th week": "4. týden",
  "5th week": "5. týden",
  "1st quarter": "1. čtvrtletí",
  "2nd quarter": "2. čtvrtletí",
  "3rd quarter": "3. čtvrtletí",
  "4th quarter": "4. čtvrtletí",
  edit_task: "Upravit úkol",
  created_at: "Vytvořeno v",
  installed_at: "Instalováno na",
  hour: "Hodina",
  week_days: "Týdenní dny",
  month_weeks: "Měsíc týdny",
  month_days: "Dny měsíce",
  no_tasks_found: "Nebyly nalezeny žádné úkoly",
  invalid_language: "Neplatný jazyk",
  no_active_tasks_found: "Nebyly nalezeny žádné aktivní úkoly",
  edit: "Upravit",
  send_date: "Datum odeslání",
  invalid_date: "Neplatné datum",
  hour_must_be_after_current: "Vyberte prosím hodinu, která je po aktuálním čase",
  cells_num: "buňky #",
  sinks_num: "Umyvadla #",
  urinals_num: "Pisoáry č.",
  toilet_paper_size: "Velikost toaletního papíru",
  email_configuration: "Konfigurace e-mailu",
  please_edit_the_email_information: "Upravte prosím e-mailové informace",
  email_sender_info: "Informace o odesílateli e-mailu",
  email_subject_info: "Informace o předmětu e-mailu",
  email_message_info: "Informace o emailové zprávě",
  companyName: "Název společnosti",
  email_language: "Jazyk e-mailu",
  complaint_language: "Jazyk stížnosti",
  email_message_format: "Formát e-mailové zprávy",
  line: "Čára",
  list: "Seznam",
  roomType: "Typ pokoje",
  "By logging in, you agree to Buzzztech's": "Přihlášením souhlasíte s Buzzztech's",
  "Terms and Conditions": "Smluvní podmínky",
  and: "A",
  "Privacy Policy": "Zásady ochrany osobních údajů",
  "All actions within this panel are recorded for quality control and improvement": "Všechny akce v rámci tohoto panelu jsou zaznamenávány pro kontrolu kvality a zlepšování",
  "You must agree to the terms and conditions": "Musíte souhlasit s podmínkami",
  months: "měsíce",
  ref_id: "Referenční id",
  room_name_en: "Název pokoje v angličtině",
  site_state: "Stav webu",
  site_city: "Místo města",
  city: "Město",
  state: "Stát",
  site_country: "Země webu",
  first_date: "První rande",
  pinned: "Připnuto",
  "no.": "Žádný.",
  must_be_numbers: "Musí to být čísla",
  must_be_3_digits: "Musí být 3 číslice",
  must_have_english_title: "Musí mít anglický název",
  total_sites: "Celkový",
  site_information: "Informace o webu",
  holiday_offdays: "Svátky a dny volna",
  add_offday: "Den volna",
  add_holiday: "Dovolená",
  name_under_chars: "Název do 25 znaků",
  days_comma_separated: "Platné dny oddělené čárkou",
  year: "Rok",
  month: "Měsíc",
  day: "Den",
  holiday_name: "Název dovolené",
  offday_name: "Jméno dne volna",
  delete_confirmation_title: "jsi si jistý?",
  delete_confirmation_message: "Tuto akci nelze vrátit zpět.",
  are_you_sure: "jsi si jistý?",
  israel: "Izrael",
  USA: "USA",
  poland: "Polsko",
  mexico: "Mexiko",
  cyprus: "Kypr",
  brazil: "Brazílie",
  romania: "Rumunsko",
  tablet_survey: "Tabletový průzkum",
  no_shift_survey: "Žádný průzkum tabletu směny",
  number_of_rows: "Počet řádků",
  rating_shape: "Tvar hodnocení",
  content_survey: "Průzkum obsahu",
  rating_survey: "Hodnotící průzkum",
  "device-alerts": "Problém",
  "device-active": "Aktivní",
  "device-search": "Vyhledávání",
  mac_id: "MAC adresa",
  qr_tag: "QR tag",
  sensor: "Senzor",
  image_survey: "Obrazový průzkum",
  open_text: "Otevřít text",
  open_text_survey: "Otevřený textový průzkum",
  embedded_link: "Vložený odkaz",
  "device-counter": "Čelit",
  count: "Počítat",
  last_date: "Poslední datum",
  last_arrival: "Poslední příjezd čistší",
  cleaners: "Čističe",
  viewer: "Prohlížeč",
  android: "Android",
  ios: "iOS",
  no_users_found: "Nebyli nalezeni žádní uživatelé",
  no_cleaners_found: "Nebyly nalezeny žádné čističe",
  new_cleaner: "Nový čistič",
  edit_cleaner: "Upravit čistič",
  please_select: "Vyberte prosím",
  please_select_site_first: "Nejprve prosím vyberte web",
  working_areas: "Pracovní oblasti",
  no_working_areas: "Zatím žádné pracovní oblasti",
  working_area_alerts: "Upozornění",
  api: "API",
  task_target_by_working_areas: "Podle pracovních oblastí (všechny místnosti ve vybraných oblastech)",
  task_target_by_rooms: "Podle konkrétních místností",
  task_target_label: "Úkol se otevře",
  step_what: "Co",
  step_when: "Když",
  step_where: "Kde",
  step_options: "Možnosti",
  please_create_room_before_working_area: "Před vytvořením pracovní oblasti vytvořte alespoň jednu místnost",
  isWorkingInSite: "Práce na místě",
  you_are_not_allowed_to_edit: "Nemáte oprávnění upravovat",
  you_are_not_allowed_to_remove: "Nemáte povoleno odebrat",
  task: "Úkol",
  portuguese: "portugalština",
  russian: "ruština",
  spanish: "španělština",
  polish: "polština",
  installer: "Instalátor",
  once: "Jednou",
  time_saved: "Čas ušetřen",
  yes: "Ano",
  no: "Žádný",
  workingAreaNames: "Názvy pracovních oblastí",
  shift_rooms: "Pokoje",
  shift_validation_overlap: "Tato směna se překrývá s „{shiftName}“ v místnosti „{roomName}“. Odeberte místnost z jedné ze směn nebo upravte jejich otevírací dobu.",
  shift_validation_missing_fields: "Vyplňte prosím všechna požadovaná pole směny (hodiny, dny a místo).",
  shift_validation_empty_rooms: "Přiřaďte této směně alespoň jednu místnost.",
  shift_validation_no_valid_rooms: "Pro tuto směnu nejsou vybrány žádné platné místnosti.",
  shift_validation_empty_room_map: "Nelze sestavit rozvrh směn. Zkontrolujte vybrané dny a hodiny.",
  new_shift: "Nová směna",
  add_shift_inactive: "Přidejte reflexní posuny",
  remove_auto_shift_inactive: "Odstraňte automatické reflexní posuny",
  additional_options: "Další možnosti",
  add_default_shifts: "Přidat výchozí směny",
  no_user_found: "Nebyl nalezen žádný uživatel",
  no_site_found: "Nebyly nalezeny žádné stránky",
  open_complaints: "Otevřete Stížnosti",
  site_alerts: "Upozornění na webu",
  open_sla_alerts: "Otevřete Upozornění na stížnosti",
  open_duration: "Otevřená doba trvání",
  no_open_slas: "Nebyly nalezeny žádné otevřené smlouvy SLA",
  no_open_slas_description: "Momentálně zde nejsou žádné weby s otevřenými smlouvami SLA.",
  no_slas_to_send: "Pro tento web nebyly nalezeny žádné otevřené smlouvy SLA",
  total_open_complaints: "Celkem otevřených stížností",
  longest_duration: "Nejdelší trvání",
  complaints_details: "Podrobnosti o stížnostech",
  rooms_with_open_complaints_percentage: "Místnosti s otevřenými stížnostmi",
  rooms_with_cleaner_arrival_percentage: "Pokoje s čistším příjezdem",
  rooms_without_cleaner_arrival_percentage: "Pokoje bez příchodu čistší",
  site_alerts_total_rooms: "Celkem pokojů",
  site_alerts_open_complaints_count: "Počet otevřených stížností",
  site_alerts_customer_opening_date: "Datum otevření zákazníka",
  company_country: "Země společnosti",
  select_message: "Vyberte možnost Zpráva",
  message_no_cleaner_arrival: "Ahoj všichni,\\nUpozorňujeme, že jsou pokoje, kde dnes nebyl nahlášen příchod čistšího zařízení.\\nProsím, vyřiďte to",
  message_open_complaints: "Ahoj všichni,\\nUpozorňujeme, že existuje několik místností s otevřenými stížnostmi po dlouhou dobu.\\nVyřiďte to prosím",
  rooms_list: "Pokoje:",
  please_address_issues_promptly: "Prosím, řešte tyto problémy neprodleně.",
  no_results_found: "Nebyly nalezeny žádné výsledky",
  showing: "Zobrazení",
  per_page: "Na stránku",
  whatsapp: "WhatsApp",
  loading: "Načítání",
  error_opening_whatsapp: "Chyba při otevírání WhatsApp. Zkuste to prosím znovu.",
  error_loading_slas: "Chyba při načítání podrobností SLA. Zkuste to prosím znovu.",
  send_whatsapp: "Odeslat WhatsApp",
  more_options: "Více možností",
  preview_message: "Náhled zprávy",
  copy_message: "Kopírovat zprávu",
  message_preview: "Náhled zprávy",
  phone_number_optional: "Telefonní číslo (volitelné)",
  enter_phone_number: "Zadejte telefonní číslo (např. +1234567890)",
  phone_number_hint: "Chcete-li otevřít WhatsApp bez konkrétního kontaktu, ponechte prázdné",
  message_copied: "Zpráva zkopírována do schránky!",
  error_copying_message: "Chyba při kopírování zprávy. Zkuste to prosím znovu.",
  opening_whatsapp: "Otevírání WhatsApp...",
  preview_message_description: "Před odesláním si zprávu prohlédněte a upravte",
  copy_message_description: "Zkopírujte zprávu do schránky",
  service_provider: "Poskytovatel služeb",
  "qr task": "QR úkol",
  qr_task: "QR úkol",
  all_day: "Celý den",
  auto_start: "Auto start",
  more_options: "Více možností",
  english_title: "Anglický název",
  connectivity: "Konektivita",
  power: "Moc",
  "Your work has been saved": "Vaše práce byla uložena",
  schedule_call_time: "Naplánujte si čas hovoru",
  schedule_call_gap: "Naplánujte mezeru mezi hovory",
  gapInMinutes: "Mezera v minutách",
  no_manual_calls_available: "Nejsou k dispozici žádné ruční hovory",
  manual_calls: "Manuální hovory",
  cleandexCalls: "Volá Cleandex",
  manualCalls: "Manuální hovory",
  inactive: "Neaktivní",
  "on hold": "Podrženo",
  sequential: "Sekvenční",
  ratio: "Poměr",
  must_choose: "Musí se vybrat",
  surveyApp: "Průzkumná aplikace",
  installation: "Instalace",
  manager: "Manažer",
  previous: "Předchozí",
  no_rooms_found: "Nebyly nalezeny žádné pokoje",
  show_calendar: "Zobrazit kalendář",
  seeAll: "Zobrazit vše",
  showPaginated: "Zobrazit stránkované",
  cleaners_arrivals: "Příjezdy čističů",
  "qr validator": "QR validátor",
  qr_validator: "QR validátor",
  searchAddress: "Vyhledejte adresu",
  sector: "Sektor",
  add_address: "Přidat adresu",
  site_auto_attendance_enabled: "Povolte automatické načítání a odhlašování pomocí geofence mobilní aplikace (zaměstnanci potřebují oprávnění k aplikaci a poloze).",
  site_auto_attendance_requires_location: "Před povolením automatické docházky nejprve nastavte místo na mapě (špendlík a poloměr alespoň 100 m).",
  site_mandatory_clock_in: "Vyžadovat zaznamenání příchodu před prací",
  site_mandatory_clock_in_description: "Zaměstnanci na tomto místě musí zaznamenat příchod, než budou moci otevřít karty úklidu, údržby a úkolů v mobilní aplikaci.",
  site_mandatory_clock_in_without_location: "Toto místo nemá polohu na mapě, takže aplikace nepozná, kdy je zaměstnanec na místě. Dokud ji nenastavíte, platí požadavek pro tyto zaměstnance všude.",
  auto_attendance: "Automatická docházka",
  auto_attendance_ready: "Připraveno",
  auto_attendance_off: "Vypnuto",
  auto_attendance_needs_setup: "Vyžaduje nastavení",
  auto_attendance_ready_tooltip: "Přepínač je zapnutý, poloměr geofence ≥ 100 m, připraven k automatickému zapnutí/vypnutí.",
  auto_attendance_off_tooltip: "Přepínač je vypnutý. Upravte web, abyste povolili automatickou docházku.",
  auto_attendance_needs_setup_tooltip: "Přepínač je zapnutý, ale geofence chybí nebo je pod minimem 100 m. Chcete-li to opravit, upravte web.",
  edit_address: "Upravit adresu",
  choose_radius: "Vyberte poloměr",
  cleandex: "Cleandex",
  cleandex_column_tooltip: "Zelená = OK. Červená = Doporučeno k čištění.\\nPodrobnosti zobrazíte najetím na ikonu buňky.",
  recommended_to_clean: "Doporučeno k čištění",
  cleandex_warning_level: "Úroveň varování Cleandex",
  select_warning_level: "Vyberte úroveň varování",
  bronze: "Bronz",
  silver: "Stříbro",
  gold: "Zlato",
  ai: "AI",
  daily_employees_num: "Denní počet zaměstnanců",
  daily_shift_hours: "Hodiny denních směn",
  rooms_num: "Číslo pokoje",
  buildings_num: "Číslo budovy",
  cleaner_entries: "Čistší záznamy",
  avg_daily_visits_monthly: "Průměrná denní návštěva za měsíc",
  avg_daily_cleaners_to_save: "Průměrný denní úklid na úsporu",
  saving_hours_per_day: "Úspora hodin denně",
  saving_money_per_day: "Úspora peněz za den",
  saving_money_per_month: "Úspora peněz za měsíc",
  cleaners_to_visitors_ratio: "Poměr uklízečů a návštěvníků",
  cleaning_time_in_minutes_per_room: "Doba úklidu v minutách na pokoj",
  max_number_of_rooms_per_employee: "Maximální počet pokojů na zaměstnance",
  break_time_per_hour: "Přestávka za hodinu",
  transition_time_between_tasks: "Doba přechodu mezi úkoly",
  employer_cost_hour: "Náklady zaměstnavatele na hodinu",
  lobby_cleaning_per_floor: "Úklid vestibulu na patře",
  desired_cleaning_time: "Požadovaná doba čištění",
  desired_number_of_entries: "Požadovaný počet záznamů",
  buzz_system_cost_per_unit_per_month: "Cena systému Buzz za jednotku za měsíc",
  total_buzz_system_cost_per_month: "Celkové náklady na systém Buzz za měsíc",
  return_on_investment_in_months: "Návratnost investice v měsících",
  annual_savings: "Roční úspory",
  roi_calculator: "Kalkulačka návratnosti investic",
  cleaning_work_plan: "Plán úklidových prací",
  cleaning_work_plan_intro: "Používá statistiky směnárny pro společnost a web v záhlaví. Návštěvy a příchody pocházejí z jednoho dne s nejvyššími návštěvami webu v daném časovém období a posuny z filtru řídicího panelu (nastavte je na Výkon nebo Analytics, pokud tato karta skrývá ovládací prvky času a filtru). Zadejte návštěvy na úklid, počet zaměstnanců, hodinové náklady a průměrné minuty na úklid; vygenerovat, abyste viděli navrhované úklidy na úrovni místnosti a souhrnné součty.",
  cleaning_work_plan_default_n: "Návštěvy za úklid",
  cleaning_work_plan_cleaner_count: "Čističe (volitelné)",
  cleaning_work_plan_avg_minutes: "Průměrná doba čištění (min)",
  cleaning_work_plan_run: "Vytvořte plán",
  cleaning_work_plan_export_csv: "Exportovat Excel",
  cleaning_work_plan_suggested_n: "Návštěvy za úklid",
  cleaning_work_plan_actual_cleans: "Příjezdy",
  cleaning_work_plan_actual_cleans_hint: "Celkový počet příchodů uklízečů ve statistikách směnárny v den špičky (v rámci zvoleného rozsahu a filtrů).",
  cleaning_work_plan_suggested_cleans: "Doporučené čištění",
  cleaning_work_plan_cleaner: "Čistič",
  cleaning_work_plan_floors: "Podlahy",
  cleaning_work_plan_peak_day: "Špičkový den",
  cleaning_work_plan_error: "Nelze vygenerovat plán úklidových prací",
  cleaning_work_plan_no_rooms: "Pro tento web nebyly vráceny žádné pokoje. Zkontrolujte web a časové období nebo ověřte existenci místností na ovládacím panelu.",
  cleaning_work_plan_need_filter: "V záhlaví vyberte společnost a web, nastavte časové období (a v případě potřeby i posuny) na stránce Výkon nebo Analytics a zkuste to znovu.",
  cleaning_work_plan_settings: "Nastavení plánu",
  cleaning_work_plan_desired_employees: "Požadovaný počet zaměstnanců",
  cleaning_work_plan_cost_per_hour: "Cena za hodinu",
  cleaning_work_plan_estimated_cost_suggested: "Odhadovaná cena (doporučená pracovní zátěž)",
  cleaning_work_plan_estimated_cost_actual: "Odhadované náklady (skutečné vytížení)",
  cleaning_work_plan_hours_per_cleaner: "Hodiny na úklid",
  cleaning_work_plan_metric_title: "Metrický",
  cleaning_work_plan_metric_avg_cleaning_min: "Prům. doba čištění (min)",
  cleaning_work_plan_metric_total_arrivals: "Celkový počet příchozích",
  cleaning_work_plan_metric_total_cleaning_min: "Celková doba čištění (min)",
  cleaning_work_plan_metric_total_cleaning_hours: "Celková doba čištění (hodiny)",
  cleaning_work_plan_metric_hours_per_cleaner_row: "Hodiny na úklid",
  cleaning_work_plan_metric_num_cleaners: "Počet čističů",
  cleaning_work_plan_summary: "Shrnutí",
  cleaning_work_plan_summary_peak_note: "Návštěvy, příchody a navrhované úklidy používají stejná pravidla statistiky směnárny jako Analytics (včetně agregace příchodů). Jsou pro den ve špičce – kalendářní den s nejvyšší návštěvností webu ve filtrovaném období. Jsou zahrnuty pouze vypočítané místnosti, jako přehled, když není použit žádný filtr místností.",
  cleaning_work_plan_summary_filter_period: "Období filtrování",
  cleaning_work_plan_summary_total_visits: "Celkový počet návštěv",
  cleaning_work_plan_summary_total_arrivals: "Celkový počet příchozích",
  cleaning_work_plan_summary_employees_in_site: "Zaměstnanci na místě",
  cleaning_work_plan_summary_shift_working_hours: "Směnná pracovní doba",
  cleaning_work_plan_hours_unit: "h",
  cleaning_work_plan_rooms_table: "Pokoje",
  cleaning_work_plan_cleaners_table: "Doporučené přidělení čističe",
  cleaning_work_plan_search_rooms: "Prohledejte pokoje",
  cleaning_work_plan_total_minutes: "Celkem minut",
  cleaning_work_plan_actual_total_minutes: "Skutečný celkový počet minut",
  cleaning_work_plan_actual_total_minutes_hint: "Zaznamenané příchody uklízečů ve statistikách směnárny v den špičky (ve zvoleném rozsahu), vynásobené vaším průměrným počtem minut na úklid.",
  cleaning_work_plan_suggested_total_minutes: "Doporučený celkový počet minut",
  cleaning_work_plan_suggested_room_minutes: "Doporučené minuty čištění",
  cleaning_work_plan_actual_room_minutes: "Skutečné minuty čištění",
  cleaning_work_plan_cleaner_suggested_minutes: "Doporučená min.",
  cleaning_work_plan_cleaner_actual_minutes: "Skutečná min.",
  cleaning_work_plan_period: "Období",
  cleaning_work_plan_room_count: "Počet pokojů",
  cleaning_work_plan_cleaners_working_in_site: "Čističi pracující na místě (kontakty aplikace)",
  cleaning_work_plan_cleaners_connection_table: "Uklízečky po pokojích",
  cleaning_work_plan_connected_rooms_count: "Pokoje",
  cleaning_work_plan_connected_floor_count: "Počet pater",
  cleaning_work_plan_connected_floors_list: "Podlahy",
  cleaning_work_plan_visitor_cleaning_entry_ratio: "Poměr vstupů návštěvník / úklid",
  cleaning_work_plan_performance_comparison_table: "Srovnání výkonu",
  cleaning_work_plan_performance_comparison_empty: "Načtěte čistší data připojení, abyste viděli srovnávací řádky.",
  cleaning_work_plan_performance_col_index: "Index",
  cleaning_work_plan_performance_existing_plan: "Stávající pracovní plán",
  cleaning_work_plan_performance_recommended_plan: "Plán doporučený společností Buzzztech",
  cleaning_work_plan_perf_number_of_employees: "Počet zaměstnanců",
  cleaning_work_plan_perf_working_hours_per_employee: "Pracovní doba na zaměstnance",
  cleaning_work_plan_perf_total_working_hours: "Celková pracovní doba",
  cleaning_work_plan_perf_total_cleaning_hours: "Celková doba úklidu",
  cleaning_work_plan_perf_daily_cost: "Denní náklady",
  cleaning_work_plan_perf_total_cleaning_visits: "Celkové úklidové návštěvy",
  cleaning_work_plan_perf_busiest_area_visits: "Nejrušnější pracovní oblast — návštěvy",
  cleaning_work_plan_perf_cleaning_to_busiest: "Úklidové návštěvy v nejrušnějších oblastech",
  cleaning_work_plan_perf_max_cleaning_ratio: "Maximální čisticí poměr",
  cleaning_work_plan_perf_least_busy_visits: "Nejméně rušná pracovní oblast — návštěvy",
  cleaning_work_plan_perf_cleaning_to_least: "Úklid návštěvy v nejméně vytížené oblasti",
  cleaning_work_plan_perf_min_cleaning_ratio: "Minimální poměr čištění",
  cleaning_work_plan_ai_allocate: "Přidělit AI",
  cleaning_work_plan_ai_allocation_result: "Výsledek alokace AI",
  cleaning_work_plan_ai_allocation_loading: "Generování alokace AI...",
  cleaning_work_plan_ai_allocation_error: "Vygenerování přidělení AI se nezdařilo. Zkuste to prosím znovu.",
  cleaning_work_plan_ai_invalid_employees: "Nastavte prosím platný požadovaný počet zaměstnanců.",
  cleaning_work_plan_ai_status_elapsed: "Uplynulo: {s} s",
  cleaning_work_plan_ai_status_hint: "Server spustí několik kroků umělé inteligence za sebou (počáteční plán, geografie, bilance návštěv, poté konečný výstup). To může trvat jednu až dvě minuty – mějte prosím tuto stránku otevřenou.",
  cleaning_work_plan_ai_status_step_1: "Krok 1 — sestavení počátečního úkolu z dat místnosti a návštěvy…",
  cleaning_work_plan_ai_status_step_2: "Krok 2 — upřesnění geografie (seskupení blízkých podlaží a budov)…",
  cleaning_work_plan_ai_status_step_3: "Krok 3 – vyvážení denních návštěv napříč čističkami…",
  cleaning_work_plan_ai_status_step_4: "Krok 4 — generování strukturované alokace…",
  cleaning_work_plan_ai_status_step_5: "Krok 5 – ověření a výpočet konečných metrik…",
  cleaning_work_plan_ai_cleaner_number: "Čistič #",
  cleaning_work_plan_room_minutes: "Minuty čištění",
  cleaning_work_plan_assigned_cleaner: "Přidělený čistič",
  cleaning_work_plan_summary_cleaners: "Čističe v plánu",
  cleaning_work_plan_summary_avg_minutes: "Prům. minuty / čisté",
  cleaning_work_plan_suggested_hours: "Doporučený celkový počet hodin",
  cleaning_work_plan_actual_hours: "Skutečný celkový počet hodin",
  cleaning_work_plan_avg_suggested_min_per_cleaner: "Průměrná doporučená min / čistší",
  cleaning_work_plan_avg_actual_min_per_cleaner: "Průměr skutečné min / čistší",
  cleaning_work_plan_guidelines_title: "Pokyny pro optimalizaci",
  cleaning_work_plan_guidelines_intro: "Tento nástroj sleduje stejné cíle jako manuální optimalizace plánu úklidu: pracovní vytížení z údajů o návštěvách, čas z vašich průměrných minut na úklid a personální obsazení, které vyvažuje práci a zároveň udržuje podlahy geograficky rozumné.",
  cleaning_work_plan_guidelines_b1: "Počet návštěv na úklid (výchozí 50) odpovídá obvyklému pravidlu ve stylu 1:50: navrhované položky na pokoj ≈ návštěvy ÷ návštěvy na úklid (zaokrouhleno nahoru). Návštěvy a příchody se berou z nejrušnějšího dne (nejvyšší návštěvy webu) ve zvoleném časovém období, takže plán odpovídá dni s nejvyšším zatížením.",
  cleaning_work_plan_guidelines_b2: "Když nastavíte počet čističů, každé podlaží budovy je jedna skupina. Podlahy jsou seřazeny podle budovy a čísla podlaží, poté rozděleny do souvislých bloků napříč čističi, takže navrhované čištění (implicitní práce) jsou vyvážené, zatímco okolní podlahy mají tendenci zůstat na stejném čističi.",
  cleaning_work_plan_guidelines_b3: "Všechny toalety na stejném patře budovy zůstávají u stejného čističe, takže pokoje pro muže a ženy na tomto patře nejsou rozděleny mezi různé čističe (pokud mají stejnou hodnotu podlahy na ovládacím panelu).",
  cleaning_work_plan_guidelines_b4: "Doporučený průměr minut na čisté disky a skutečný celkový počet minut, hodin a průměrný počet minut na čistič. Skutečné součty používají zaznamenané příchody čističů × váš průměr; navrhované součty používají implicitní čištění × váš průměr.",
  cleaning_work_plan_guidelines_b5: "Použijte Export CSV, pokud chcete upřesnit alokaci jinde (například k dalšímu zpřísnění zůstatku návštěv).",
  cleaners_number: "Číslo čističe",
  floors_num: "Číslo podlaží",
  avg_daily_cleaners_required: "Požadované průměrné denní čisticí prostředky",
  app_pages: "Stránky aplikace",
  buzzzTime: "Čas buzzu",
  missions: "Mise",
  send_emails: "Odesílejte e-maily",
  enter: "Vstupte",
  account: "Účet",
  privacy: "Soukromí",
  personal_settings: "Osobní nastavení",
  personal_settings_lead: "Spravujte svůj jazyk a předvolby ochrany osobních údajů.",
  personal_settings_read_only: "Tyto podrobnosti spravuje váš administrátor. Kontaktujte je, pokud je potřeba něco aktualizovat.",
  change_password: "Změnit heslo",
  change_password_hint: "Změna hesla vás odhlásí z ostatních zařízení.",
  current_password: "Aktuální heslo",
  new_password: "Nové heslo",
  confirm_new_password: "Potvrďte nové heslo",
  password_min_length: "Heslo musí mít alespoň 8 znaků",
  passwords_do_not_match: "Hesla se neshodují",
  new_password_same_as_current: "Nové heslo se musí lišit od aktuálního",
  current_password_incorrect: "Aktuální heslo je nesprávné",
  current_password_required: "Aktuální heslo je povinné",
  password_changed_successfully: "Heslo bylo úspěšně změněno",
  change_password_failed: "Heslo se nepodařilo změnit",
  forgot_password: "Forgot password?",
  forgot_password_title: "Forgot password",
  forgot_password_hint: "Enter the email address for your panel account and we will send you a reset link if it exists.",
  forgot_password_sent: "If an account exists for that email, a reset link has been sent. Check your inbox.",
  forgot_password_invalid_email: "Please enter a valid email address",
  forgot_password_failed: "Could not send reset email. Please try again.",
  send_reset_link: "Send reset link",
  back_to_login: "Back to login",
  reset_password: "Reset password",
  reset_password_hint: "Choose a new password for your account.",
  reset_password_missing_token: "This reset link is incomplete. Request a new one from the login page.",
  reset_password_invalid_token: "This reset link is invalid or has expired. Request a new one.",
  reset_password_failed: "Could not reset password",
  password_reset_successfully: "Password reset successfully. You can log in with your new password.",
  login_invalid_credentials: "Nesprávné uživatelské jméno nebo heslo",
  login_credentials_required: "Zadejte uživatelské jméno nebo e-mail a heslo",
  login_network_error: "Nelze se připojit k serveru. Zkontrolujte připojení a zkuste to znovu",
  login_failed: "Přihlášení se nezdařilo. Zkuste to znovu",
  login_too_many_attempts: "Příliš mnoho pokusů o přihlášení. Počkejte 15 minut a zkuste to znovu.",
  forgot_password_too_many: "Příliš mnoho žádostí o obnovení hesla. Počkejte hodinu a zkuste to znovu.",
  reset_password_too_many: "Příliš mnoho pokusů o obnovení hesla. Počkejte hodinu a zkuste to znovu.",
  change_password_too_many: "Příliš mnoho pokusů o změnu hesla. Počkejte 15 minut a zkuste to znovu.",

  personal_settings_language_hint: "Platí pro celý portál pro tento prohlížeč.",
  personal_settings_privacy_hint: "Požádejte o vymazání vašich osobních údajů podle platných zákonů na ochranu soukromí.",
  personal_settings_export_hint: "Stáhněte si čitelnou kopii JSON osobních údajů, které o vás uchováváme: váš profil portálu, weby, ke kterým máte přístup, a váš propojený profil mobilní aplikace (pokud se váš telefon shoduje). Omezený vývoz za den.",
  "Download my data": "Stáhnout moje data",
  personal_settings_role: "Role",
  "Request deletion of my data": "Požádat o vymazání mých údajů",
  "Request deletion of my data - confirm": "Požádat o vymazání mých údajů? Administrátorovi bude zaslán e-mail. Vaši žádost zpracujeme do 30 dnů.",
  "Request deletion of my data - success": "Žádost odeslána. Zpracujeme do 30 dnů.",
  "Request deletion of my data - error": "Žádost se nepodařilo odeslat. Zkuste to prosím znovu nebo napište na privacy@buzzztech.com.",
  metrics: "Metriky",
  select_three_metrics: "Vyberte až 3 metriky k porovnání",
  select_four_metrics: "Vyberte až 4 metriky k porovnání",
  legend: "Legenda",
  more_details: "Další podrobnosti",
  performance_overview: "Přehled výkonu",
  loading_chart: "Načítání grafu",
  retry: "Zkuste to znovu",
  performance_trending_upward: "Výkonnost má stoupající tendenci",
  high_complaint_ratio: "Vysoký poměr reklamací",
  click_bars_for_details: "Kliknutím na pruhy se dostanete do denní analýzy",
  refresh: "Obnovit",
  table: "Tabulka",
  cards: "Karty",
  no_recent_arrivals: "Žádné nedávné příchody",
  feedback_charts: "Grafy zpětné vazby",
  general_overview: "Obecný přehled",
  cleaning_complaints_breakdown: "Rozpis reklamací úklidu",
  maintenance_complaints_breakdown: "Rozdělení reklamací údržby",
  refresh_failed: "Obnovení se nezdařilo",
  data_exported_successfully: "Data byla úspěšně exportována",
  data_export_failed: "Export dat se nezdařil",
  drill_down_unavailable: "Rozbalení je k dispozici pouze pro denní zobrazení",
  sort_by: "Seřadit podle",
  no_active_shift: "No active shift",
  check_site_and_shift: "Please check if a site is selected and has an active shift",
  please_add_shift_first: "Please add shift first",
  cleandex_no_data_message: "Momentálně nejsou k dispozici žádná data cleandex",
  task_no_data_message: "Momentálně nejsou k dispozici žádná data úkolu",
  navigation: "Navigace",
  network_information: "Informace o síti",
  target_effectiveness: "Cílová účinnost",
  cleandex_call_cleaner: "Cleandex čistič volání",
  top_complaint: "Top stížnost",
  no_complaints: "Žádné stížnosti",
  official_start_date: "Oficiální datum zahájení",
  note_text: "Text poznámky",
  add_note: "Přidat poznámku",
  general_note: "Obecná poznámka",
  general_note_short: "Generál",
  battery_short: "Baterie",
  panel_short: "Panel",
  technician_short: "Technik",
  battery_replacement: "Výměna baterie",
  device_maintenance: "Údržba zařízení",
  maintenance_type: "Typ údržby",
  panel_change: "Změna panelu",
  technician_check: "Kontrola technikem",
  enter_note_details: "Zadejte podrobnosti poznámky",
  replacement_date: "Náhradní termín",
  replaced_by_name: "Nahrazeno jménem",
  replacement_note: "Poznámka k výměně",
  enter_replacement_details: "Zadejte podrobnosti o výměně",
  replacement_history: "Historie výměny",
  loading_history: "Načítání historie",
  no_replacement_history: "Není k dispozici žádná historie výměn",
  enter_technician_name: "Zadejte jméno technika",
  prefilled_from_account: "Předvyplněno z vašeho účtu – můžete upravit",
  user_information: "Informace o uživateli",
  enter_change_details: "Zadejte podrobnosti o změně",
  panel_change_history: "Historie změn panelu",
  check_date: "Zkontrolujte datum",
  checked_by_name: "Zkontrolováno podle jména",
  enter_check_details: "Zadejte podrobnosti o kontrole",
  technician_check_history: "Technik kontroluje historii",
  no_technician_check_history: "Není k dispozici žádná historie kontrol technikem",
  change_date: "Změnit datum",
  changed_by_name: "Změněno podle jména",
  change_note: "Změnit poznámku",
  check_note: "Zkontrolujte poznámku",
  replaced_by: "Nahrazeno uživatelem",
  no_data_entered: "Nebyla zadána žádná data",
  no_panel_change_history: "Není k dispozici žádná historie změn panelu",
  invalid_username: "Neplatné uživatelské jméno",
  invalid_phone: "Neplatné telefonní číslo",
  username_must_be_at_least_5_characters: "Uživatelské jméno musí mít alespoň 5 znaků",
  data_loading_please_wait: "Data se právě načítají. Čekejte prosím...",
  dates_not_changed: "Termíny se nezměnily. Není potřeba žádné nabíjení.",
  date_outside_stats_range: "Vybraná data jsou mimo dostupný rozsah statistik.",

  date_range_invalid: "Datum „Do“ musí být stejné nebo pozdější než datum „Od“.",
  filter_help_text: "Pravidla filtrování: Chcete-li aktivovat filtr podlaží, vyberte nejprve Budova. Většina filtrů podporuje vícenásobný výběr.",
  select_building_first: "Chcete-li aktivovat filtr podlaží, vyberte nejprve budovu",
  cannot_select_gender_with_rooms: "Při výběru místností nelze vybrat typ místnosti",
  cannot_select_gender_with_rooms_tooltip: "Filtr typu místnosti nelze použít, když jsou vybrány místnosti. Nejprve vymažte výběr místností.",
  cannot_select_building_with_rooms: "Při výběru místností nelze vybrat budovu",
  cannot_select_building_with_rooms_tooltip: "Filtr budovy nelze použít, když jsou vybrány místnosti. Nejprve prosím vymažte výběr pokojů.",
  multi_select_hint: "Můžete vybrat více možností",
  filter_applied: "Filtr byl úspěšně použit",
  no_filters_selected: "Nejsou vybrány žádné filtry. Vyberte alespoň jednu možnost filtru.",
  filters: "Filtry",
  location: "Umístění",
  attributes: "Atributy",
  applying: "Aplikace...",
  active_filters: "Aktivní filtry",
  viewing_room: "Prohlížecí místnost",
  multiple: "Násobek",
  close: "Blízko",
  save_replacement: "Uložte výměnu",
  save_change: "Uložit změnu",
  save_check: "Uložit šek",
  failed_to_load_maintenance_history: "Načtení historie údržby se nezdařilo",
  "Battery replacement recorded successfully": "Výměna baterie byla úspěšně zaznamenána",
  "Panel change recorded successfully": "Změna panelu byla úspěšně zaznamenána",
  "Technician check recorded successfully": "Kontrola technikem byla úspěšně zaznamenána",
  no_network_data_available: "Nejsou k dispozici žádná síťová data",
  configuration: "Konfigurace",
  contact_settings: "Kontakt a nastavení",
  notifications: "Oznámení",
  features: "Vlastnosti",
  chat_ask_buzzz: "Zeptejte se Buzzze",
  chat_hide: "Skrýt",
  chat_buzzz_assistant: "Buzzz asistent",
  chat_export: "Vývozní",
  chat_clear: "Jasný",
  chat_unpin: "Odepnout",
  chat_pin: "Kolík",
  chat_retry: "Zkuste to znovu",
  chat_copy: "Kopie",
  chat_copied: "Zkopírováno!",
  chat_share: "Podíl",
  chat_suggestions: "Návrhy",
  chat_input_placeholder: "Zeptejte se na statistiky...",
  chat_stop: "Zastávka",
  chat_error: "Něco se pokazilo. Zkuste to prosím znovu.",
  chat_placeholder: "Zeptejte se mě na statistiky čištění...",
  chat_placeholder_context: "Zeptejte se na {scope}...",
  chat_chip_briefing: "Ranní briefing",
  chat_chip_live_status: "Živý stav",
  chat_chip_staff_status: "Stav personálu",
  chat_chip_summary: "Shrnutí",
  chat_chip_cleaning_priority: "Priorita čištění",
  chat_chip_worst_rooms: "Nejhorší pokoje",
  chat_chip_focus: "Oblasti zaměření",
  chat_chip_compare_periods: "Porovnejte období",
  chat_chip_sla_issues: "Problémy SLA",
  chat_chip_shift_stats: "Statistiky posunu",
  chat_chip_complaint_types: "Typy stížností",
  chat_chip_busiest_hours: "Nejrušnější hodiny",
  chat_chip_worst_days: "Nejhorší dny",
  chat_chip_improving: "Vylepšování pokojů",
  chat_chip_best_rooms: "Nejlepší pokoje",
  chat_chip_help: "Pomoc",
  chat_chip_why_drilldown: "Proč? Vrtejte dolů",
  chat_deep_analysis: "Hluboká analýza (pomalejší)",
  chat_greeting: "Dobrý den, {name}, jak vám mohu pomoci?",
  chat_status_online: "Online",
  chat_status_thinking: "Myslící...",
  chat_tool_overview: "Stahující přehled...",
  chat_tool_rooms: "Kontrola místností...",
  chat_tool_hours: "Analýza hodin...",
  chat_tool_days: "Kontrola denních dat...",
  chat_tool_live: "Kontrola živého stavu...",
  chat_tool_priority: "Kontrola priorit...",
  chat_tool_room_detail: "Načítání podrobností o místnosti...",
  chat_tool_shifts: "Při pohledu na směny...",
  chat_tool_staff: "Kontrola personálu...",
  chat_tool_devices: "Kontrola zařízení...",
  chat_feedback_good: "Dobrá odezva",
  chat_feedback_bad: "Špatná odezva",
  chat_feedback_thanks: "Děkujeme za vaši zpětnou vazbu!",
  chat_feedback_wrong_data: "Špatná data",
  chat_feedback_didnt_understand: "Nerozuměl",
  chat_feedback_missing_info: "Chybějící informace",
  chat_feedback_bad_format: "Špatné formátování",
  chat_feedback_hallucinated: "Vymyšlená čísla",
  chat_feedback_submit: "Předložit",
  cestina: "Čeština",
  monthMap: {
    1: 'Led',
    2: 'Úno',
    3: 'Bře',
    4: 'Dub',
    5: 'Kvě',
    6: 'Čer',
    7: 'Čvc',
    8: 'Srp',
    9: 'Zář',
    10: 'Říj',
    11: 'Lis',
    12: 'Pro',
  },
  weekMap: {
    1: 'Neděle',
    2: 'Pondělí',
    3: 'Úterý',
    4: 'Středa',
    5: 'Čtvrtek',
    6: 'Pátek',
    7: 'Sobota',
  },

  "español": "španělština",
  "français": "français",
  "русский": "русский",
  "አማርኛ": "አማርኛ",
  "português": "português",
  "cleaner-activity": "Čistící činnost",
  "device-actions": "Akce zařízení",
  "pad-presence-testing": "Test přítomnosti u padu",
  "real-time-cleaning": "V reálném čase - úklid",
  "real-time-maintenance": "V reálném čase - údržba",
  "no_real_time_tabs_permitted": "Nemáte oprávnění zobrazit žádnou kartu v reálném čase",
  "cleaner_activity": "Čistící činnost",
  "pad_presence_testing": "Test přítomnosti u padu",
  "pad_presence_testing_subtitle": "Vstupy, odchody a offline stisky padu odeslané z telefonu pro vybranou lokalitu",
  "pad_presence_timeline": "Živá časová osa",
  "pad_presence_sessions": "Relace přítomnosti",
  "pad_presence_offline_presses": "Offline stisky z telefonů",
  "pad_presence_select_site_hint": "Vyberte společnost a lokalitu v záhlaví, abyste sledovali události přítomnosti.",
  "pad_presence_no_events": "V tomto období nejsou žádné události přítomnosti.",
  "pad_presence_open": "Otevřeno",
  "pad_presence_exit_phone": "Odchod z telefonu",
  "pad_presence_exit_auto": "Automatický odchod",
  "pad_presence_exit_stale": "Zastaralý odchod",
  "pad_presence_enter": "Vstup",
  "pad_presence_exit": "Odchod",
  "pad_presence_offline": "Offline stisk",
  "pad_presence_faulty": "Chybné",
  "pad_presence_employee": "Zaměstnanec",
  "pad_presence_room": "Místnost",
  "pad_presence_time_from": "Od",
  "pad_presence_last_updated": "Aktualizováno",
  "pad_presence_duration": "Trvání",
  "pad_presence_exit_type": "Typ odchodu",
  "pad_presence_button": "Tlačítko",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Počet",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Všichni zaměstnanci",
  "pad_presence_all_rooms": "Všechny místnosti",
  "pad_presence_load_error": "Nepodařilo se načíst data o přítomnosti u padu.",
  "pad_presence_in_room_now": "Právě v místnosti",
  "pad_presence_in_room": "v",
  "pad_presence_since": "od",
  "pad_presence_just_now": "Právě teď",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefon",
  "pad_presence_all_phones": "Všechny telefony",
  "pad_presence_window": "Zobrazit",
  "pad_presence_window_hour": "Poslední hodina",
  "pad_presence_window_today": "Dnes",
  "pad_presence_window_month": "Poslední měsíc",
  "pad_presence_pads": "Pady na této lokalitě",
  "pad_presence_no_pads": "Na této lokalitě nejsou pady přiřazeny k místnostem.",
  "pad_presence_last_enter": "Poslední vstup",
  "pad_presence_last_offline": "Poslední offline stisk",
  "pad_presence_auto_exit_leave": "Odejděte teď → automatický odchod za",
  "pad_presence_auto_exit_earliest": "Nejdříve od vstupu:",
  "pad_presence_auto_exit_passed": "Nejdřívější automatický odchod už uplynul. Stále otevřeno = pad je stále slyšet, nebo odejděte a počkejte 5m 45s.",
  "cleaner_activity_live_footer": "Aktualizace dat v reálném čase",
  "ca_empty_select_site_hint": "Vyberte společnost a web v záhlaví, chcete-li zobrazit čistší aktivitu pro dnešek.",
  "ca_empty_no_cleaners_hint": "K tomuto webu a aktuální směně nejsou přiřazeny žádné uklízečky. Přiřaďte aktivní weby a směny v Uživatelích.",
  "ca_empty_access_denied": "Přístup odepřen",
  "ca_empty_access_denied_hint": "Nemáte oprávnění k zobrazení čistší aktivity pro tento web.",
  "ca_empty_load_error_hint": "Aktivitu čističe nelze načíst. Zkuste to znovu nebo pokud problém přetrvává, kontaktujte podporu.",
  "ca_empty_no_filter_match": "Těmto filtrům neodpovídají žádné čističe",
  "ca_empty_no_filter_match_hint": "Zkuste vyčistit filtry nebo zvolit jiný čistič, pracovní oblast nebo místnost.",
  "ca_timeline_all_cleaners": "Dnešní aktivita — všechny čističe",
  "ca_legend_work": "Aktivní",
  "ca_clock_sessions_more": "více",
  "ca_clock_sessions_less": "Ukázat méně",
  "ca_sort_label": "Seřadit",
  "ca_sort_needs_attention": "Vyžaduje pozornost",
  "ca_sort_best_avg_response": "Nejlepší průměrná odezva",
  "ca_sort_worst_avg_response": "Nejhorší průměrná odezva",
  "ca_sort_most_sla_breaches": "Většina porušení SLA",
  "ca_sort_most_open_complaints": "Většina otevřených stížností",
  "ca_sort_most_work_time": "Nejvíce pracovní doby",
  "ca_sort_least_work_time": "Nejmenší pracovní doba",
  "ca_stat_avg_short": "prům",
  "ca_stat_open_short": "OTEVŘENO",
  "ca_stat_breach_short": "porušení",
  "ca_stat_work_short": "práce",
  "ca_assigned_room_avg_hint": "Průměrná odpověď pro dnešní přidělené místnosti",
  "ca_transit_tooltip": "Doba přechodu mezi úkoly",
  "ca_transit_live_tooltip": "Čas od uzavření posledního úkolu",
  "ca_legend_visits": "Návštěvy mezi hlášeními",
  "ca_visits_between_sla": "Návštěvy od uzavření předchozího hlášení",
  "ca_apply": "Použít",
  "ca_visits_since": "od",
  "ca_deferred_tip_title": "Odložená reklamace",
  "ca_deferred_tip_resolved": "Vyřešeno",
  "ca_deferred_tip_desc_open": "Stále otevřeno – uklízečka místo této obstarala nejprve jiné místnosti.",
  "ca_deferred_tip_desc_closed": "Tato stížnost zůstala otevřená, zatímco uklízečka nejprve obsluhovala ostatní pokoje.",
  "ca_deferred_tip_rooms_label": "Nejprve servisováno:",
  "ca_attention_title": "Vyžaduje pozornost",
  "ca_attention_empty": "Vše jasné – momentálně žádné problémy",
  "ca_attention_sla_breach_one": "{name} · Porušení smlouvy SLA",
  "ca_attention_sla_breach_many": "{name} · {count} porušení smlouvy SLA",
  "ca_attention_open_while_out_one": "{jméno} · otevřená stížnost při odhlášení",
  "ca_attention_open_while_out_many": "{jméno} · {count} otevřeno, dokud není čas",
  "ca_attention_idle": "{name} · nečinný {duration}",
  "ca_attention_late": "{jméno} · přišel pozdě",
  "ca_attention_show": "Show",
  "ca_attention_hide": "Skrýt",
  "all": "Vše",
  "check_site_and_shift": "Zkontrolujte, zda je vybrána lokalita s aktivní směnou",
  "cleaner": "Uklízeč",
  "close": "Zavřít",
  "communication_clear_filters": "Vymazat filtry",
  "failed_to_load_data": "Načtení dat se nezdařilo",
  "filters": "Filtry",
  "next": "Další",
  "no_active_shift": "Žádná aktivní směna",
  "no_cleaners_found": "Nenalezeni žádní uklízeči",
  "open_complaints": "Otevřené stížnosti",
  "please_select_company_site": "Vyberte firmu a lokalitu",
  "refresh_failed": "Obnovení se nezdařilo",
  "rooms": "Místnosti",
  "select": "Vybrat",
  "shift": "Směna",
  "working_area": "Pracovní oblast",
  "ca_view_shift": "Směna",
  "ca_view_history": "Historie",
  "ca_filters_done": "Hotovo",
  "ca_hist_preset_this_month": "Tento měsíc",
  "ca_hist_preset_last_month": "Minulý měsíc",
  "ca_hist_preset_this_week": "Tento týden",
  "ca_hist_preset_last_week": "Minulý týden",
  "ca_hist_preset_custom": "Vlastní",
  "ca_hist_from": "Od",
  "ca_hist_to": "Do",
  "ca_hist_range_invalid": "Počáteční datum musí být před koncovým",
  "ca_hist_range_too_long": "Rozsah může být nejvýše {max} dní",
  "ca_hist_search": "Hledat jméno nebo telefon",
  "ca_hist_people_count": "{count} zaměstnanců",
  "ca_hist_kpi_days": "Odpracované dny",
  "ca_hist_kpi_net": "Čisté hodiny",
  "ca_hist_kpi_breaks": "Přestávky",
  "ca_hist_col_person": "Zaměstnanec",
  "ca_hist_col_total": "Celkem hodin",
  "ca_hist_col_total_tip": "Od příchodu do odchodu před přestávkami — stejná hodnota, kterou zaměstnanec vidí v aplikaci",
  "ca_hist_col_net": "Čisté hodiny",
  "ca_hist_col_breaks": "Přestávky",
  "ca_hist_col_issues": "Problémy",
  "ca_hist_col_late": "Pozdě",
  "ca_hist_col_missed": "Zmeškáno",
  "ca_hist_col_no_clock_out": "Bez odchodu",
  "ca_hist_clocked_in_now": "Nyní přihlášen",
  "ca_hist_not_assigned": "Nepřiřazen k této lokalitě",
  "ca_hist_no_shift": "Žádná přiřazená směna",
  "ca_hist_unknown_name": "Neznámý",
  "ca_hist_empty": "V tomto období žádná docházka",
  "ca_hist_empty_hint": "Na této lokalitě se nikdo nepřihlásil a nejsou k ní přiřazeni žádní zaměstnanci.",
  "ca_hist_no_match": "Filtrům neodpovídá žádný zaměstnanec",
  "ca_hist_load_error_hint": "Historii docházky se nepodařilo načíst. Zkuste to za chvíli znovu.",
  "ca_hist_prev_person": "Předchozí zaměstnanec",
  "ca_hist_next_person": "Další zaměstnanec",
  "ca_hist_close": "Zavřít",
  "ca_hist_legend_worked": "Pracoval",
  "ca_hist_legend_late": "Pozdě",
  "ca_hist_legend_missed": "Zmeškáno",
  "ca_hist_legend_no_clock_out": "Bez odchodu",
  "ca_hist_late_by": "Zpoždění {duration}",
  "ca_hist_late_tip": "Příchod v {time}, {shift} začíná v {start}",
  "ca_hist_missed": "Zmeškáno",
  "ca_hist_missed_tip": "Plánovaná směna skončila bez zaznamenaného příchodu",
  "ca_hist_no_clock_out": "Bez odchodu",
  "ca_hist_no_clock_out_tip": "Relace nebyla nikdy ukončena; její hodiny se nepočítají",
  "ca_hist_in_progress": "Stále přihlášen",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "otevřená",
  "ca_hist_day_col_gross": "Celkem hodin",
  "ca_hist_day_col_breaks": "Přestávky",
  "active_cleaners": "Aktivní čističe",
  "closed_complaints": "Uzavřené stížnosti",
  "total_work_time": "Celková pracovní doba",
  "total_work_time_net": "Celková pracovní doba (dnes čistá)",
  "total_break_time": "Celková doba přestávky",
  "avg_response_time": "Prům. vyřešeno",
  "clocked_in": "Zamčený",
  "clocked_out": "Vypnuto",
  "still_clocked_in": "Stále zapsáno",
  "clocked_in_late": "Přišel pozdě",
  "total_hours": "Celkový počet hodin",
  "auto_punch": "Auto (geofence)",
  "manual_punch": "Manuál",
  "complaint_opened": "Stížnost otevřena",
  "complaint_closed": "Reklamace uzavřena",
  "complaint_still_open": "Stále otevřeno",
  "resolved_in": "Vyřešeno v",
  "open_for": "Otevřeno pro",
  "sla_breached": "SLA porušena",
  "no_activity_today": "Dnes ještě žádná aktivita",
  "just_now": "právě teď",
  "ago": "před",
  "today": "Dnes",
  "live": "Žít",
  "last_updated": "Aktualizováno",
  "analytics_export_confirm": "Stáhnout analytické soubory CSV?",
  "analytics_export_title": "Export analytických dat",
  "analytics_export_description": "Stáhne se soubor ZIP s aktuálně filtrovanou analýzou – shrnutí, kobliha, otevírací doba, pokoje a příchody uklízeček/dozorců.",
  "download": "Stáhnout",
  "analytics_export_blocked_loading": "Data Analytics se stále načítají. Počkejte prosím a zkuste to znovu.",
  "analytics_export_blocked_no_data": "Žádná analytická data k exportu. Použijte své filtry a počkejte, až se stránka načte.",
  "analytics_export_blocked_stale_filters": "Filtry se změnily. Před exportem použijte filtry a počkejte, až se analytika znovu načte.",
  "have_you_finished_making_changes": "Dokončili jste provádění změn?",
  "assignment_issues_found": "Byly nalezeny problémy s přiřazením",
  "unassigned_rooms_title": "Nepřiřazené místnosti",
  "overlapping_assignments_title": "Překrývající se přiřazení",
  "and_n_more": "a dalších {count}",
  "continue_anyway": "Přesto pokračovat",
  "stay_and_fix": "Zůstat a opravit",
  "assignment_coverage_issues": "{unassigned} nepřiřazeno · {overlaps} překrytí",
  "assignment_check_failed": "Nepodařilo se ověřit přiřazení místností",
  "tap_for_details": "Klepněte pro podrobnosti",

  "has_app": "Aplikace",
  "has_app_tooltip": "Ukližeč má aplikaci",
  "notifications_tooltip": "Push oznámení jsou zapnutá",
  "assigned_to_rooms": "Přiřazen k místnostem",
  "assigned_to_rooms_tooltip": "Má místnosti na tomto místě",
  "recently_active": "Nedávno aktivní",
  "works_at_site": "Pracuje na místě",
  "recently_active_tooltip": "Otevřel aplikaci za posledních 30 minut",
}

export const ml = {
  "room_type_required": "ഓരോ ഗ്രൂപ്പിനും ഒരു മുറിയുടെ തരം തിരഞ്ഞെടുക്കുക",
  ...serviks.ml,
  notified: "അറിയിച്ചു",
  supervisor_arrival: "സൂപ്പർവൈസർ വരവ്",
  arrival: "വരവ്",
  arrival_badges: "ഷിഫ്റ്റ് വരവ്",
  visits_since_cleaned: "അവസാനം വൃത്തിയാക്കിയത് മുതൽ സന്ദർശനങ്ങൾ",
  visits_since_cleaned_short: "അവസാനം വൃത്തിയാക്കിയത് മുതൽ",
  filter: "ഫിൽട്ടർ ചെയ്യുക",
  logo: "ലോഗോ",
  counter: "കൗണ്ടർ",
  sms: "എസ്എംഎസ്",
  shifts: "ഷിഫ്റ്റുകൾ",
  call: "വിളിക്കൂ",
  openCalls: "കോളുകൾ തുറക്കുക",
  callsHistory: "കോളുകൾ ചരിത്രം",
  duration: "ദൈർഘ്യം",
  time_start: "സമയം ആരംഭം",
  settings: "ക്രമീകരണങ്ങൾ",
  always: "എപ്പോഴും",
  off: "ഓഫ്",
  time_based: "സമയം അടിസ്ഥാനമാക്കി",
  location_based: "ലൊക്കേഷൻ അടിസ്ഥാനമാക്കി",
  notification_mode: "അറിയിപ്പ് മോഡ്",
  notification_times: "അറിയിപ്പ് സമയം",
  notification_times_info: "മൊബൈൽ ആപ്പിൽ നിന്നാണ് സമയ പരിധികൾ നിയന്ത്രിക്കുന്നത്",
  notification_location: "അറിയിപ്പ് സ്ഥാനം",
  notification_sound: "അറിയിപ്പ് ശബ്ദം",
  no_sound: "ശബ്ദമില്ല",
  default_sound: "ഡിഫോൾട്ട് ശബ്ദം",
  soft_bell: "സോഫ്റ്റ് ബെൽ",
  digital_sound: "ഡിജിറ്റൽ ശബ്ദം",
  mallet_sound: "മാലറ്റ് ശബ്ദം",
  phone_sound: "ഫോൺ ശബ്ദം",
  text_sound: "ടെക്സ്റ്റ് ശബ്ദം",
  manager_alert_delay: "മാനേജർ അലേർട്ട് കാലതാമസം",
  snooze_interval: "ഓർമ്മപ്പെടുത്തൽ",
  vocal_notifications: "വോക്കൽ അറിയിപ്പുകൾ",
  no_delay: "കാലതാമസം ഇല്ല",
  no_snooze: "ഓർമ്മപ്പെടുത്തലൊന്നുമില്ല",
  lat: "ലാറ്റ്",
  lon: "ലോൺ",
  radius: "ആരം",
  no_location_set: "ലൊക്കേഷൻ സജ്ജീകരിച്ചിട്ടില്ല",
  when_to_notify: "എപ്പോൾ അറിയിക്കണം",
  notification_preferences: "അറിയിപ്പ് മുൻഗണനകൾ",
  assignment_configuration: "അസൈൻമെൻ്റും കോൺഫിഗറേഷനും",
  status: "നില",
  working_area: "പ്രവർത്തന മേഖല",
  complaints_NC: "പരാതികൾ / NC",
  SLA_NC: "SLA / NC",
  arrivals_NC: "വരവ് / NC",
  staff: "സ്റ്റാഫ്",
  cleaning_complaints: "ക്ലീനിംഗ് പരാതികൾ",
  export: "കയറ്റുമതി",
  maintenance_complaints: "മെയിൻ്റനൻസ് പരാതികൾ",
  maintenanceArrivals: "മെയിൻ്റനൻസ് വരവ്",
  maintenance_arrivals: "മെയിൻ്റനൻസ് വരവ്",
  last: "അവസാനത്തേത്",
  survey_name: "സർവേയുടെ പേര്",
  survey: "സർവേ",
  pad_survey: "പാഡ് സർവേ",
  pad_no_maintenance_survey: "പാഡ് മെയിൻ്റനൻസ് സർവേ ഇല്ല",
  pad_kitchen: "പാഡ് അടുക്കള",
  number_of_assigned_devices: "# അസൈൻ ചെയ്‌ത ഉപകരണങ്ങൾ",
  number_of_pages: "# പേജുകൾ",
  date_created: "സൃഷ്ടിച്ച തീയതി",
  updated_by: "അപ്ഡേറ്റ് ചെയ്തത്",
  date_updated: "തീയതി അപ്ഡേറ്റ് ചെയ്തു",
  search: "തിരയുക",
  choose_type: "തരം തിരഞ്ഞെടുക്കുക",
  permitted_sites: "അനുവദനീയമായ സൈറ്റുകൾ",
  permitted_franchise: "അനുവദനീയമായ ഫ്രാഞ്ചൈസി",
  permitted_companies: "അനുമതിയുള്ള കമ്പനികൾ",
  panel_permitted: "പാനൽ അനുവദിച്ചു",
  end_time: "അവസാന സമയം",
  last_update: "അവസാന അപ്ഡേറ്റ്",
  add_device: "ഉപകരണം ചേർക്കുക",
  detailed: "വിശദമായി",
  analysis: "വിശകലനം",
  suggestion: "നിർദ്ദേശം",
  country: "രാജ്യം",
  management: "മാനേജ്മെൻ്റ്",
  device: "ഉപകരണം",
  mapping: "മാപ്പിംഗ്",
  please_enter: "ദയവായി നൽകുക",
  new_device: "പുതിയ ഉപകരണം",
  assign_device: "ഉപകരണം അസൈൻ ചെയ്യുക",
  installSpot: "ഇൻസ്റ്റലേഷൻ സ്ഥലം",
  device_type: "ഉപകരണ തരം",
  deviceCode: "ഉപകരണ കോഡ്",
  device_code: "ഉപകരണ കോഡ്",
  scan_or_enter_device_code: "സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ ഉപകരണ കോഡ് നൽകുക...",
  scan_device: "назначение",
  scan_qr_in_frame: "QR കോഡ് ഫ്രെയിമിനുള്ളിൽ വയ്ക്കുക. ചെറിയ കോഡുകൾക്ക് 15–25 സെമി ദൂരത്തിൽ പിടിക്കുക; ചിത്രം മങ്ങിയാൽ refocus ചെയ്യാൻ preview-ിൽ ടാപ്പ് ചെയ്യുക.",
  checking_device_code: "ഉപകരണ കോഡ് പരിശോധിക്കുന്നു...",
  camera_not_available: "ക്യാമറ ലabh്യമല്ല. നിങ്ങൾക്ക് കോഡ് manually typing cheyyanam.",
  device_code_already_exists: "ഈ ഉപകരണ കോഡ് മറ്റൊരു സенсорുമayi nazначeno nazначeno.",
  assigned_to_company_site_room: "ഇAlready {company} / {site} / {room} il nazначeno nazначeno.",
  device_code_lookup_failed: "ഉപകരണ കോഡ് പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക.",
  device_code_no_site_access: "ഈ കോഡ് നിങ്ങൾക്ക് ആക്സസ് ഇല്ലാത്ത സൈറ്റിൽ ഇതിനകം രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.",
  device_code_check_unavailable: "സെർവറിന് കോഡ് പരിശോധിക്കാനായില്ല. വീണ്ടും ശ്രമിക്കുക.",
  device_code_not_a_code: "സ്കാൻ \"{code}\" വായിച്ചു. ഉപകരണ കോഡ് തന്നെ നൽകുക.",
  device_code_open_failed: "ഈ ഉപകരണം തുറക്കാനായില്ല. വീണ്ടും ശ്രമിക്കുക.",
  device_code_save_failed: "ഉപകരണ കോഡ് സംരക്ഷിക്കാനായില്ല. വീണ്ടും ശ്രമിക്കുക.",
  device_code_save_forbidden: "ഈ ഉപകരണം മാറ്റാൻ നിങ്ങൾക്ക് കഴിയില്ല.",
  confirm_replace_device_code: "ഉപകരണ കോഡ് മaarreplace nazначeno?",
  confirm_replace_device_code_body: "ഉപകരണ കോഡ് {oldCode} enna code {newCode} aayi maarnno ennu nazначeno?",
  room: "മുറി",
  edit_room: "എഡിറ്റ് റൂം",
  edit_franchise: "ഫ്രാഞ്ചൈസി എഡിറ്റ് ചെയ്യുക",
  new_franchise: "പുതിയ ഫ്രാഞ്ചൈസി",
  desc: "വിവരണം",
  address: "വിലാസം",
  level: "ലെവൽ",
  no_companies_to_show: "കാണിക്കാൻ കമ്പനികളൊന്നുമില്ല",
  company_type: "കമ്പനി തരം",
  region: "മേഖല",
  new_company: "പുതിയ കമ്പനി",
  edit_company: "കമ്പനി എഡിറ്റ് ചെയ്യുക",
  edit_user: "ഉപയോക്താവിനെ എഡിറ്റ് ചെയ്യുക",
  "C.arrivals": "ക്ലീനർ എത്തി",
  "C.complaints": "ക്ലീനിംഗ് പരാതി",
  "M.complaints": "മെയിൻ്റനൻസ് പരാതികൾ",
  "M.Arrivals": "മെയിൻ്റനൻസ് വരവ്",
  analyses: "വിശകലനം ചെയ്യുന്നു",
  clean_log: "ലോഗ് വൃത്തിയാക്കുക",
  maintenance_log: "മെയിൻ്റനൻസ് ലോഗ്",
  like: "ഇഷ്ടപ്പെടുക",
  likes: "ഇഷ്ടപ്പെടുന്നു",
  new_user: "പുതിയ ഉപയോക്താവ്",
  shift_parameters: "ഷിഫ്റ്റ് പാരാമീറ്റർ",
  add_shift: "പുതിയ ഷിഫ്റ്റ്",
  edit_shift: "ഷിഫ്റ്റ് എഡിറ്റ് ചെയ്യുക",
  username: "ഉപയോക്തൃനാമം",
  first_name: "പേരിന്റെ ആദ്യഭാഗം",
  job_function: "റോൾ",
  role: "റോൾ",
  property_manager: "പ്രോപ്പർട്ടി മാനേജർ",
  facility_manager: "ഫെസിലിറ്റി മാനേജർ",
  site_manager: "സൈറ്റ് മാനേജർ",
  workplace_manager: "വർക്ക്‌പ്ലേസ് മാനേജർ",
  cleaning_company_ceo: "ക്ലീനിംഗ് കമ്പനി സിഇഒ",
  operations_manager: "ഓപ്പറേഷൻസ് മാനേജർ",
  area_manager: "ഏരിയ മാനേജർ",
  site_cleaning_manager: "സൈറ്റ് ക്ലീനിംഗ് മാനേജർ",
  cleaning_supervisor: "ക്ലീനിംഗ് സൂപ്പർവൈസർ",
  other: "മറ്റുള്ളവ",
  restroom_cleaner: "ടോയ്‌ലറ്റ് ക്ലീനർ",
  general_cleaner: "ജനറൽ ക്ലീനർ",
  day_porter: "ഡേ പോർട്ടർ",
  office_cleaner: "ഓഫീസ് ക്ലീനർ",
  public_area_cleaner: "പൊതുഇടം ക്ലീനർ",
  firstName: "പേരിന്റെ ആദ്യഭാഗം",
  description: "വിവരണം",
  last_name: "പേരിന്റെ അവസാന ഭാഗം",
  lastName: "പേരിന്റെ അവസാന ഭാഗം",
  phone: "ഫോൺ",
  building_area: "കെട്ടിട പ്രദേശം",
  users: "ഉപയോക്താക്കൾ",
  add_user: "ഉപയോക്താവിനെ ചേർക്കുക",
  sites: "സൈറ്റുകൾ",
  new_site: "പുതിയ സൈറ്റ്",
  edit_site: "സൈറ്റ് എഡിറ്റ് ചെയ്യുക",
  add_company: "കമ്പനി ചേർക്കുക",
  franchise: "ഫ്രാഞ്ചൈസി",
  floor: "തറ",
  building: "കെട്ടിടം",
  humidity: "ഈർപ്പം",
  humidity_abbr: "ഈർപ്പമുള്ളത്",
  temperature: "താപനില",
  temperature_abbr: "താപനില",
  gender: "മുറിയുടെ തരം",
  display_name: "പേര്",
  zone: "മേഖല",
  shift_number: "Shift#",
  shift: "ഷിഫ്റ്റ്",
  shift_name: "ഷിഫ്റ്റിൻ്റെ പേര്",
  shift_currently_inactive: "നിലവിൽ പ്രവർത്തനരഹിതമായ ഷിഫ്റ്റ്",
  local_time: "പ്രാദേശിക",
  end: "അവസാനിക്കുന്നു",
  min_sla: "മിനിമം SLA",
  max_sla: "പരമാവധി SLA",
  days: "ദിവസങ്ങൾ",
  complaints_percent: "% പരാതികൾ",
  sla_percent: "% SLA",
  arrivals_percent: "% ആഗമനങ്ങൾ",
  save_arrivals: "സംരക്ഷിക്കുക",
  clean_time: "വൃത്തിയുള്ള സമയം (മിനിറ്റ്)",
  tooltip_shift_number: "ഈ ഷിഫ്റ്റിൻ്റെ ക്രമം പ്രദർശിപ്പിക്കുക (ഉദാ. 1, 2).",
  tooltip_shift_name: "ഷിഫ്റ്റിൻ്റെ പേര് (ഉദാ. രാവിലെ, രാത്രി).",
  tooltip_start_time: "പ്രാദേശിക സമയം ആരംഭിക്കുന്ന സമയം മാറ്റുക.",
  tooltip_end_time: "പ്രാദേശിക സമയം അവസാനിക്കുന്ന സമയം മാറ്റുക.",
  tooltip_cleaners_number: "ഈ ഷിഫ്റ്റിലെ ക്ലീനർമാരുടെ എണ്ണം.",
  tooltip_min_sla: "റൂം പരാതി കൈകാര്യം ചെയ്യുന്നതിനുള്ള മികച്ച പ്രതികരണ സമയം (മിനിറ്റുകൾ); സ്‌കോറിൻ്റെ ലോവർ ബൗണ്ടായി ഉപയോഗിച്ചു.",
  tooltip_max_sla: "റൂം പരാതി കൈകാര്യം ചെയ്യുന്നതിനുള്ള പരമാവധി സ്വീകാര്യമായ പ്രതികരണ സമയം (മിനിറ്റുകൾ); സ്‌കോറിൻ്റെ മുകളിലെ ബൗണ്ടായി ഉപയോഗിക്കുന്നു.",
  tooltip_arrivals: "പ്രതിദിനം ഒരു മുറിയിൽ പ്രതീക്ഷിക്കുന്ന ക്ലീനർ വരവ്; സ്കോർ യഥാർത്ഥ വരവുകളെ ഈ ലക്ഷ്യവുമായി താരതമ്യം ചെയ്യുന്നു.",
  tooltip_save_arrivals: "BuzzzTV-ന് മുമ്പായി പ്രതിദിനം ഓരോ മുറിയിലും ക്ലീനർ സന്ദർശനങ്ങൾ; ലാഭിച്ച സമയം കണക്കാക്കാൻ ഉപയോഗിക്കുന്നു (ഇപ്പോൾ കുറച്ച് സന്ദർശനങ്ങൾ = മിനിറ്റുകൾ ലാഭിച്ചു).",
  tooltip_clean_time: "സമയം ലാഭിക്കുന്ന കണക്കുകൂട്ടലിൽ ഒരു ക്ലീനർ സന്ദർശനത്തിന് മിനിറ്റുകൾ കണക്കാക്കുന്നു (ഉദാ. 15).",
  tooltip_complaints_percent: "റൂം സന്ദർശനങ്ങൾ ഉള്ളപ്പോൾ റൂം സ്‌കോറിലെ പരാതികളുടെ ഭാരം (കൂടുതൽ = പരാതികൾ സ്‌കോറിനെ കൂടുതൽ ബാധിക്കുന്നു).",
  tooltip_response_time_SLA: "റൂം സന്ദർശനങ്ങൾ ഉള്ളപ്പോൾ റൂം സ്‌കോറിലെ പ്രതികരണ സമയത്തിൻ്റെ ഭാരം (ഉയർന്നത് = വേഗത്തിലുള്ള പ്രതികരണം കൂടുതൽ പ്രധാനമാണ്).",
  tooltip_arrivals_percent: "റൂം സന്ദർശനങ്ങൾ ഉള്ളപ്പോൾ റൂം സ്‌കോറിലെ വരവ് വെയ്‌സ് ടാർഗെറ്റിൻ്റെ ഭാരം.",
  tooltip_complaints_NC: "റൂം സന്ദർശനങ്ങൾ ഇല്ലാത്തപ്പോൾ (കൗണ്ടർ ഇല്ല) സ്‌കോറിലെ പരാതികളുടെ ഭാരം.",
  tooltip_SLA_NC: "റൂം സന്ദർശനങ്ങളില്ലാത്തപ്പോൾ സ്‌കോറിലെ പ്രതികരണ സമയത്തിൻ്റെ ഭാരം.",
  tooltip_arrivals_NC: "റൂം സന്ദർശനങ്ങളില്ലാത്തപ്പോൾ സ്‌കോറിലെ വരവുകളുടെ ഭാരം.",
  tooltip_days: "ഈ ഷിഫ്റ്റ് സജീവമായിരിക്കുന്ന ആഴ്‌ചയിലെ ദിവസങ്ങൾ.",
  tooltip_active_calculation: "പ്രവർത്തനക്ഷമമാക്കുമ്പോൾ, ഈ ഷിഫ്റ്റ് സ്‌കോറുകളിലും സമയം ലാഭിക്കുന്ന കണക്കുകൂട്ടലുകളിലും ഉൾപ്പെടുത്തും.",
  auto_close_complaints_hour: "പരാതികൾ സ്വയമേവ അടയ്ക്കുക",
  tooltip_auto_close_complaints_hour: "ഈ ഷിഫ്റ്റിലെ തുറന്ന പരാതി SLA-കൾ സ്വയമേവ അടയുന്ന പ്രാദേശിക സമയം. പ്രവർത്തനരഹിതമാക്കാൻ ശൂന്യമായി വിടുക.",
  auto_close_maintenance_complaints_hour: "പരിപാലന പരാതികൾ സ്വയമേവ അടയ്ക്കുക",
  tooltip_auto_close_maintenance_complaints_hour: "ഈ ഷിഫ്റ്റിലെ തുറന്ന പരിപാലന പരാതി SLA-കൾ സ്വയമേവ അടയുന്ന പ്രാദേശിക സമയം. പ്രവർത്തനരഹിതമാക്കാൻ ശൂന്യമായി വിടുക.",
  no_auto_close: "-- ഒന്നുമില്ല --",
  tooltip_shift_rooms: "ഈ ഷിഫ്റ്റിന് അനുവദിച്ചിരിക്കുന്ന മുറികൾ. ഒരു സൈറ്റ് ലെവൽ ഷിഫ്റ്റിനായി ശൂന്യമായി വിടുക.",
  company_name: "കമ്പനി പേര്",
  site_name: "സൈറ്റിൻ്റെ പേര്",
  site_desc: "സൈറ്റ് വിവരണം",
  service_provider_name: "സേവന ദാതാവ്",
  service_provider_type: "സേവന ദാതാവിൻ്റെ തരം",
  service_provider_desc: "സേവന ദാതാവിൻ്റെ വിവരണം",
  user: "ഉപയോക്താവ്",
  map: "മാപ്പ്",
  delete: "ഇല്ലാതാക്കുക",
  new_room: "പുതിയ മുറി",
  issue_times: "ഇഷ്യൂ സമയങ്ങൾ",
  solved: "പരിഹരിച്ചു",
  visits: "സന്ദർശനങ്ങൾ",
  complaints: "പരാതികൾ",
  complaints_in_shift: "ഈ ഷിഫ്റ്റ് പരാതി",
  cleaner_arrivals: "വൃത്തിയുള്ള വരവ്",
  unnecessary_arrivals: "കോളില്ലാത്ത വരവുകൾ",
  unnecessary_arrivals_hint: "മുറിയിൽ തുറന്ന കോൾ ഇല്ലാതിരുന്ന സമയത്തെ ക്ലീനറുടെ സന്ദർശനം.",
  of_arrivals: "വരവുകളിൽ",
  response_time_SLA: "പ്രതികരണ സമയം",
  score: "സ്കോർ",
  avg_score: "ശരാശരി സ്കോർ",
  score_goal: "ഗോൾ നേടുക",
  top_problem_issues: "പ്രധാന പ്രശ്നങ്ങൾ",
  top_problem_rooms: "മുകളിലെ മുറികൾ",
  top_problem_hours: "മികച്ച സമയം",
  is_time_save: "സമയം ലാഭിച്ചു",
  options: "ഓപ്ഷനുകൾ",
  send_battery_alerts: "ബാറ്ററി അലേർട്ടുകൾ അയയ്ക്കുക",
  environment_alerts: "പരിസ്ഥിതി അലേർട്ടുകൾ",
  environment_alerts_description: "താപനിലയോ ഈർപ്പമോ അനുവദനീയമായ പരിധി വിട്ടുപോകുമ്പോൾ ഇമെയിൽ അലേർട്ടുകൾ അയയ്ക്കുക",
  environment_alert_emails: "പരിസ്ഥിതി മുന്നറിയിപ്പ് ഇമെയിലുകൾ",
  temperature_min: "താപനില മിനി",
  temperature_max: "താപനില പരമാവധി",
  humidity_min: "ഈർപ്പം മിനി",
  humidity_max: "പരമാവധി ഈർപ്പം",
  environment_alert_range_invalid: "പരിസ്ഥിതി അലേർട്ട് ശ്രേണികൾ സംഖ്യാപരമായിരിക്കണം കൂടാതെ മിനിറ്റ് പരമാവധിയേക്കാൾ കുറവോ തുല്യമോ ആയിരിക്കണം",
  coming_soon: "ഉടൻ വരുന്നു",
  alert_emails: "മുന്നറിയിപ്പ് ഇമെയിലുകൾ",
  alert_emails_placeholder: "ഇമെയിൽ വിലാസം നൽകുക",
  alert_language: "മുന്നറിയിപ്പ് ഭാഷ",
  select_language: "ഭാഷ തിരഞ്ഞെടുക്കുക",
  invalid_email_format: "ഒന്നോ അതിലധികമോ ഇമെയിൽ വിലാസങ്ങൾ അസാധുവാണ്",
  add_email: "മറ്റൊരു ഇമെയിൽ ചേർക്കുക",
  next: "അടുത്തത്",
  back: "തിരികെ",
  basic_information: "അടിസ്ഥാന വിവരങ്ങൾ",
  service_providers: "സേവന ദാതാക്കൾ",
  settings_alerts: "ക്രമീകരണങ്ങളും അലേർട്ടുകളും",
  configuration: "കോൺഫിഗറേഷൻ",
  contact_settings: "കോൺടാക്റ്റ് & ക്രമീകരണങ്ങൾ",
  notifications: "അറിയിപ്പുകൾ",
  features: "ഫീച്ചറുകൾ",
  battery_alerts: "ബാറ്ററി അലേർട്ടുകൾ",
  alerts_title: "അലേർട്ടുകൾ",
  location: "സ്ഥാനം",
  time_save_description: "സമയം ലാഭിക്കുന്ന ഫീച്ചറുകൾ പ്രവർത്തനക്ഷമമാക്കുക",
  exposures_description: "നോൺ എക്സ്പോഷർ ഡാറ്റ ട്രാക്ക് ചെയ്യുക",
  alerts_description: "ഉപകരണ വിവര അലേർട്ടുകൾ",
  shift_description: "സ്ഥിരസ്ഥിതി ഷിഫ്റ്റുകൾ സൃഷ്ടിക്കുക",
  battery_alerts_description: "കുറഞ്ഞ ബാറ്ററിക്ക് ഇമെയിൽ അലേർട്ടുകൾ അയയ്ക്കുക",
  est_ROI: "എസ്റ്റ് ROI",
  complaints_vs_visits: "പരാതികൾ vs സന്ദർശനങ്ങൾ",
  view_by_years: "വർഷങ്ങൾ കാണുക",
  view_by_months: "മാസങ്ങൾ കാണുക",
  view_by_weeks: "ആഴ്ചകൾ കാണുക",
  view_by_days: "ദിവസങ്ങൾ കാണുക",
  minutes: "മിനി",
  company: "കമ്പനി",
  site: "സൈറ്റ്",
  alerts: "ഉപകരണ വിവരം",
  performance: "പ്രകടനം",
  devices: "ഉപകരണങ്ങൾ",
  total_devices: "ആകെ ഉപകരണങ്ങൾ",
  working: "ജോലി ചെയ്യുന്നു",
  warning: "മുന്നറിയിപ്പ്",
  by_device_type: "ഉപകരണ തരം അനുസരിച്ച്",
  surveys: "സർവേകൾ",
  real_time: "തൽസമയം",
  "real-time": "തൽസമയം",
  admin: "അഡ്മിൻ",
  all: "എല്ലാം",
  overview: "അവലോകനം",
  exit_full_screen: "പൂർണ്ണ സ്ക്രീനിൽ നിന്ന് പുറത്തുകടക്കുക",
  full_screen: "പൂർണ്ണ സ്ക്രീൻ",
  total: "ആകെ",
  analytics: "അനലിറ്റിക്സ്",
  pdf_export_title_analytics: "അനലിറ്റിക്സ് റിപ്പോർട്ട്",
  pdf_export_title_cleaner_arrivals: "വൃത്തിയുള്ള വരവ്",
  communication: "ആശയവിനിമയം",
  overview_complaints_devices_caption: "ഉപകരണങ്ങൾ ഇൻസ്റ്റാൾ ചെയ്തു (സഞ്ചിത)",
  overview_complaints_devices_caption_hint: "ഇൻസ്റ്റാളേഷൻ തീയതികളെ അടിസ്ഥാനമാക്കി, ഓരോ മാസാവസാനവും സൈറ്റിൽ ഇൻസ്റ്റാൾ ചെയ്ത ഉപകരണങ്ങളുടെ ആകെ എണ്ണം.",
  overview_complaints_devices_toggle_aria: "പരാതി ചാർട്ടിന് കീഴിൽ ഇൻസ്റ്റാൾ ചെയ്ത ഉപകരണങ്ങൾ കാണിക്കുക അല്ലെങ്കിൽ മറയ്ക്കുക",
  communication_select_site_title: "ഒരു സൈറ്റ് തിരഞ്ഞെടുക്കുക",
  communication_select_site: "ആ സ്ഥലത്തിനായുള്ള കുറിപ്പുകൾ കാണാനും ചേർക്കാനും മുകളിലുള്ള ഫിൽട്ടറുകളിൽ നിന്ന് ഒരു കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക.",
  communication_viewing_site: "കാണുന്നത്",
  communication_add_note: "ഒരു കുറിപ്പ് ചേർക്കുക",
  communication_add_note_open_aria: "ആഡ് നോട്ട് ഡയലോഗ് തുറക്കുക",
  communication_form_hint: "ഈ സൈറ്റിലേക്ക് ആക്‌സസ് ഉള്ള എല്ലാവരുമായും അപ്‌ഡേറ്റുകളോ കുറിപ്പുകളോ പങ്കിടുക. അവർ പുതിയ നോട്ടുകൾ തത്സമയം കാണും.",
  communication_page_intro_title: "സൈറ്റ് കുറിപ്പുകൾ - ഈ ലൊക്കേഷനായി പങ്കിട്ട ലോഗ്",
  communication_page_intro_body: "നിങ്ങളുടെ ടീമിനായി ഹാൻഡ്ഓഫുകൾ, പ്രശ്‌നങ്ങൾ, അപ്‌ഡേറ്റുകൾ, മീറ്റിംഗ് കുറിപ്പുകൾ എന്നിവ നൽകാൻ ഈ പേജ് ഉപയോഗിക്കുക. പോർട്ടലിൽ ഈ സൈറ്റ് തുറക്കാൻ കഴിയുന്ന എല്ലാവർക്കും കുറിപ്പുകൾ വായിക്കാനും ചേർക്കാനും കഴിയും.",
  communication_page_intro_dismiss: "ഈ നുറുങ്ങ് മറയ്ക്കുക",
  communication_page_intro_aria: "സൈറ്റ് കുറിപ്പുകളെക്കുറിച്ച്",
  communication_content_placeholder: "നിങ്ങളുടെ കുറിപ്പ് ഇവിടെ എഴുതൂ...",
  communication_keyboard_hint: "പോസ്‌റ്റ് ചെയ്യാൻ Ctrl+Enter",
  communication_submitting: "പോസ്റ്റുചെയ്യുന്നു...",
  communication_submit: "കുറിപ്പ് പോസ്റ്റ് ചെയ്യുക",
  communication_recent_notes: "കുറിപ്പുകൾ",
  communication_search_placeholder: "രചയിതാവ് അല്ലെങ്കിൽ വാചകം പ്രകാരം തിരയുക...",
  communication_refresh: "പുതുക്കുക",
  communication_clear_filters: "ഫിൽട്ടറുകൾ മായ്ക്കുക",
  communication_search_aria_label: "കുറിപ്പുകൾ തിരയുക",
  communication_submit_aria_label: "കുറിപ്പ് പോസ്റ്റ് ചെയ്യുക",
  communication_copy_note_aria_label: "കുറിപ്പ് വാചകം പകർത്തുക",
  communication_copied: "ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തി.",
  communication_copy_empty: "പകർത്താൻ നോട്ട് ടെക്‌സ്‌റ്റ് ഒന്നുമില്ല.",
  communication_filter_hidden_one: "(1 കുറിപ്പ് ഫിൽട്ടറുകൾ മറച്ചിരിക്കുന്നു)",
  communication_filter_hidden_many: "({n} കുറിപ്പുകൾ ഫിൽട്ടറുകൾ മറച്ചിരിക്കുന്നു)",
  communication_request_timeout: "അഭ്യർത്ഥന സമയം കഴിഞ്ഞു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  communication_load_failed: "കുറിപ്പുകൾ ലോഡ് ചെയ്യാനായില്ല.",
  communication_retry: "വീണ്ടും ശ്രമിക്കുക",
  communication_no_matches: "നിങ്ങളുടെ തിരയലിനോ ഫിൽട്ടറുകൾക്കോ ​​പൊരുത്തപ്പെടുന്ന കുറിപ്പുകളൊന്നുമില്ല. അവ ക്രമീകരിക്കാൻ ശ്രമിക്കുക.",
  communication_no_entries: "ഇതുവരെ കുറിപ്പുകളൊന്നുമില്ല.",
  communication_no_entries_hint: "ആരംഭിക്കുന്നതിന് മുകളിൽ ഒരു കുറിപ്പ് ചേർക്കുക.",
  communication_just_now: "ഇപ്പോള്",
  communication_minutes_ago: "{n} മിനിറ്റ് മുമ്പ്",
  communication_hours_ago: "{n} മണിക്കൂർ മുമ്പ്",
  communication_days_ago: "{n} ദിവസം മുമ്പ്",
  communication_note_posted: "കുറിപ്പ് പോസ്റ്റ് ചെയ്തു.",
  communication_post_failed: "കുറിപ്പ് പോസ്റ്റ് ചെയ്യാൻ കഴിഞ്ഞില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  communication_note_type: "കുറിപ്പ് തരം",
  communication_type_general: "ജനറൽ",
  communication_type_update: "അപ്ഡേറ്റ്",
  communication_type_issue: "ഇഷ്യൂ",
  communication_type_follow_up: "ഫോളോ അപ്പ്",
  communication_type_meeting: "മീറ്റിംഗ് കുറിപ്പ്",
  communication_filter_all_types: "എല്ലാ തരങ്ങളും",
  communication_pinned: "പിൻ ചെയ്തു",
  communication_pin: "പിൻ",
  communication_unpin: "അൺപിൻ ചെയ്യുക",
  communication_pin_limit: "പരമാവധി 2 പിൻ ചെയ്തു",
  communication_pinned_toast: "കുറിപ്പ് പിൻ ചെയ്തു.",
  communication_unpinned_toast: "കുറിപ്പ് അൺപിൻ ചെയ്‌തു.",
  communication_pin_failed: "പിൻ അപ്ഡേറ്റ് ചെയ്യാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  communication_note_not_found: "കുറിപ്പ് കണ്ടെത്തിയില്ല അല്ലെങ്കിൽ നിങ്ങൾക്ക് ആക്സസ് ഇല്ല.",
  communication_site_not_in_filters: "ഈ കുറിപ്പിൻ്റെ സൈറ്റ് നിങ്ങളുടെ നിലവിലെ ഫിൽട്ടറുകളിൽ ഇല്ല. നിങ്ങൾക്ക് ആ ലൊക്കേഷനിലേക്ക് ആക്സസ് ഉണ്ടായേക്കില്ല.",
  communication_edit: "എഡിറ്റ് ചെയ്യുക",
  communication_delete: "ഇല്ലാതാക്കുക",
  communication_save: "സംരക്ഷിക്കുക",
  communication_cancel: "റദ്ദാക്കുക",
  communication_saving: "സംരക്ഷിക്കുന്നു...",
  communication_note_updated: "കുറിപ്പ് അപ്ഡേറ്റ് ചെയ്തു.",
  communication_update_failed: "Failed to update note. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  communication_delete_confirm: "ഈ കുറിപ്പ് ഇല്ലാതാക്കണമെന്ന് തീർച്ചയാണോ? ഈ പ്രവർത്തനം പഴയപടിയാക്കാനാകില്ല.",
  communication_delete_confirm_title: "കുറിപ്പ് ഇല്ലാതാക്കുക",
  communication_note_preview: "കുറിപ്പ് പ്രിവ്യൂ:",
  communication_note_deleted: "കുറിപ്പ് ഇല്ലാതാക്കി.",
  communication_delete_failed: "Failed to delete note. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  communication_edited: "എഡിറ്റ് ചെയ്തു",
  communication_show_more: "കൂടുതൽ കാണിക്കുക",
  communication_show_less: "കുറവ് കാണിക്കുക",
  communication_sort_date_newest: "ഏറ്റവും പുതിയത് ആദ്യം",
  communication_sort_date_oldest: "ഏറ്റവും പഴയത് ആദ്യം",
  communication_sort_author: "രചയിതാവ്",
  communication_sort_type: "തരം പ്രകാരം",
  communication_sort_pinned: "ആദ്യം പിൻ ചെയ്തു",
  communication_sort_label: "അടുക്കുക",
  communication_filter_by_type: "ടൈപ്പ് ചെയ്യുക",
  communication_filters_group_aria: "കുറിപ്പുകൾ ഫിൽട്ടർ ചെയ്ത് അടുക്കുക",
  communication_search_label_short: "തിരയുക",
  employees: "ജീവനക്കാർ",
  last_time_of_arrival: "എത്തിയ അവസാന സമയം",
  arrival_and_status: "വരവ് & നില",
  preview_arrivals: "പ്രിവ്യൂ വരവ്",
  "men toilet": "പുരുഷൻമാരുടെ ടോയ്‌ലറ്റ്",
  "women toilet": "സ്ത്രീ ടോയ്‌ലറ്റ്",
  "shared toilet": "പങ്കിട്ട ടോയ്‌ലറ്റ്",
  "unisex restroom": "യൂണിസെക്സ് ടോയ്‌ലറ്റ്",
  "handicapped toilet": "വികലാംഗ ടോയ്‌ലറ്റ്",
  "kitchen": "അടുക്കള",
  "tablet": "ടാബ്‌ലെറ്റ്",
  "office": "ഓഫീസ്",
  "logistics": "ലോജിസ്റ്റിക്സ്",
  "area": "ഏരിയ",
  "cafeteria": "കഫറ്റീരിയ",
  "lobby": "ലോബി",
  "cubicle": "ക്യൂബിക്കിൾ",
  "elevator": "ലിഫ്റ്റ്",
  "gym": "ജിം",
  dayOfWeek: "ദിവസങ്ങൾ",
  service_log: "സേവന ലോഗ്",
  rooms: "മുറികൾ",
  bulk_add_rooms: "ബൾക്ക് ആഡ് റൂമുകൾ",
  adding_to: "ഇതിലേക്ക് ചേർക്കുന്നു",
  add_rooms: "മുറികൾ ചേർക്കുക",
  room_names_one_per_line: "മുറിയുടെ പേരുകൾ (ഒരു വരിയിൽ ഒന്ന്)",
  "enter_at_least_one_room": "കുറഞ്ഞത് ഒരു മുറിയുടെ പേരെങ്കിലും നൽകുക",
  room_names_placeholder: "റൂം 1\\nറൂം 2\\nസ്ത്രീ ടോയ്‌ലറ്റ്",
  rooms_with_prefix: "പ്രിഫിക്സ് ഉള്ള മുറികൾ",
  apply_to_all_rooms: "എല്ലാ മുറികളിലേക്കും പ്രയോഗിക്കുക (ഓപ്ഷണൽ)",
  bulk_rooms_intro: "Add one or more groups. ഓരോ ഗ്രൂപ്പിനും അതിൻ്റേതായ കെട്ടിടം, തറ, മേഖല, ലിംഗഭേദം, മുറി എന്നിവയുടെ പേരുകളുണ്ട്.",
  group: "ഗ്രൂപ്പ്",
  add_group: "+ മറ്റൊരു ഗ്രൂപ്പ് ചേർക്കുക",
  adding_rooms: "മുറികൾ ചേർക്കുന്നു...",
  bulk_summary: "സംഗ്രഹം",
  in: "ഇൻ",
  bulk_rooms_success: "{n} മുറികൾ വിജയകരമായി ചേർത്തു",
  displayName: "മുറിയുടെ പേര്",
  SLA: "എസ്.എൽ.എ",
  supervisors: "സൂപ്പർവൈസർമാർ",
  supervisor: "സൂപ്പർവൈസർ",
  performance_analytics: "പ്രകടന വിശകലനം",
  arrivals: "ആഗമനങ്ങൾ",
  inspections: "പരിശോധനകൾ",
  avgResponseTime: "ശരാശരി പ്രതികരണ സമയം",
  missedSla: "മിസ്ഡ് സ്ല",
  cleaner_arrived: "ക്ലീനർ എത്തി",
  load_more: "കൂടുതൽ ലോഡ് ചെയ്യുക",
  login: "ലോഗിൻ",
  email: "ഇമെയിൽ",
  emails: "ഇമെയിലുകൾ",
  password: "രഹസ്യവാക്ക്",
  min: "മിനി",
  Logout: "പുറത്തുകടക്കുക",
  time_range: "സമയ പരിധി",
  select_time_range: "സമയ പരിധി തിരഞ്ഞെടുക്കുക",
  custom_time: "തീയതികൾ തിരഞ്ഞെടുക്കുക",
  last_day: "ഇന്നലെ",
  last_week: "കഴിഞ്ഞ 7 ദിവസം",
  last_month: "കഴിഞ്ഞ 30 ദിവസം",
  last_quarter: "കഴിഞ്ഞ 90 ദിവസം",
  last_6_months: "കഴിഞ്ഞ 6 മാസം",
  last_year: "കഴിഞ്ഞ 365 ദിവസം",
  data_by_hour: "മണിക്കൂർ പ്രകാരമുള്ള ഡാറ്റ",
  general: "ജനറൽ",
  cleaning: "വൃത്തിയാക്കൽ",
  maintenance: "മെയിൻ്റനൻസ്",
  start: "ആരംഭിക്കുക",
  start_time: "ആരംഭിക്കുന്ന സമയം",
  management_co: "മാനേജ്മെൻ്റ് കമ്പനി",
  cleaning_co: "ക്ലീനിംഗ് കമ്പനി",
  companies: "കമ്പനികൾ",
  name: "പേര്",
  site_count: "സൈറ്റ് #",
  associated_companies: "അസോസിയേറ്റഡ് എൻഡ് ക്ലയൻ്റുകൾ",
  OK: "ശരി",
  cancel: "റദ്ദാക്കുക",
  client: "ക്ലയൻ്റ്",
  dates: "തീയതികൾ",
  shift: "ഷിഫ്റ്റ്",
  issue: "ഇഷ്യൂ",
  time: "സമയം",
  "top complaint of the week": "ആഴ്‌ചയിലെ പ്രധാന പരാതി",
  "top room of the week": "ആഴ്ചയിലെ ഏറ്റവും ഉയർന്ന മുറി",
  "top hour of the week": "ആഴ്‌ചയിലെ ഏറ്റവും മികച്ച മണിക്കൂർ",
  "top complaint of the month": "മാസത്തിലെ ഏറ്റവും ഉയർന്ന പരാതി",
  "top room of the month": "മാസത്തിലെ ഏറ്റവും ഉയർന്ന മുറി",
  "top hour of the month": "മാസത്തിലെ ഏറ്റവും മികച്ച മണിക്കൂർ",
  franchises: "ഫ്രാഞ്ചൈസികൾ",
  add_franchise: "ഫ്രാഞ്ചൈസി ചേർക്കുക",
  room_names: "മുറിയുടെ പേര്",
  type: "ടൈപ്പ് ചെയ്യുക",
  please_select_company_site: "ദയവായി ഒരു കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക",
  number: "നമ്പർ",
  create_building_map: "കെട്ടിട മാപ്പ് സൃഷ്ടിക്കുക",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "ഈ ക്വിക്ക് വിസാർഡ് വഴി ഒരു കെട്ടിടത്തിലേക്ക് നിലകളും മുറികളും ചേർക്കാനുള്ള ഏറ്റവും വേഗമേറിയ മാർഗം",
  "avg number of toilets per floor": "ഓരോ നിലയിലും ഉള്ള ടോയ്‌ലറ്റുകളുടെ ശരാശരി എണ്ണം",
  "avg.number of toilet cells per room": "ഒരു മുറിയിലെ ടോയ്‌ലറ്റ് സെല്ലുകളുടെ ശരാശരി എണ്ണം",
  "number of floors": "നിലകളുടെ എണ്ണം",
  "avg.number of disabled toilets": "വികലാംഗ ടോയ്‌ലറ്റുകളുടെ ശരാശരി എണ്ണം",
  "avg.number of soap dispensers": "സോപ്പ് ഡിസ്പെൻസറുകളുടെ ശരാശരി എണ്ണം",
  reset_filter: "ഫിൽട്ടർ പുനഃസജ്ജമാക്കുക",
  add: "ചേർക്കുക",
  new_survey: "പുതിയ സർവേ",
  api_configuration: "API കോൺഫിഗറേഷൻ",
  please_edit_the_api_information: "API വിവരങ്ങൾ എഡിറ്റ് ചെയ്യുക",
  method: "രീതി",
  authorization: "അംഗീകാരം",
  api_url: "API_url",
  token: "ടോക്കൺ",
  endpoint: "അവസാന പോയിൻ്റ്",
  add_url: "URL ചേർക്കുക",
  remove: "നീക്കം ചെയ്യുക",
  format: "ഫോർമാറ്റ്",
  auth_api_key: "API കീ",
  auth_dynamic_key: "ഡൈനാമിക് കീ (GET)",
  auth_login_token: "ലോഗിൻ ടോക്കൺ (HTTP)",
  dynamic_token_url: "ടോക്കൺ URL (GET)",
  token_response_field_name: "പ്രതികരണമായി ടോക്കൺ ഫീൽഡ്",
  token_login_url: "ലോഗിൻ URL",
  login_request_method: "ലോഗിൻ അഭ്യർത്ഥന രീതി",
  login_request_body: "ലോഗിൻ അഭ്യർത്ഥന ബോഡി (JSON)",
  login_token_placeholder_hint: "ഓപ്ഷണൽ: ലോഗിൻ ബോഡി JSON-ൽ {{ടോക്കൺ}} മാറ്റിസ്ഥാപിക്കാൻ ഉപയോഗിക്കുന്ന രഹസ്യം",
  token_response_key: "ടോക്കൺ ഫീൽഡ് നാമം ആക്സസ് ചെയ്യുക",
  survey_api_auth_header_name: "ഓത്ത് തലക്കെട്ടിൻ്റെ പേര് (ഓപ്ഷണൽ)",
  survey_api_auth_header_prefix: "ആ ഹെഡറിലെ ടോക്കണിന് മുമ്പായി ടെക്‌സ്‌റ്റ് ചെയ്യുക",
  survey_api_auth_header_name_placeholder: "ഉദാ. അംഗീകാരം, X-Api-കീ",
  survey_api_auth_header_prefix_placeholder: "ഉദാ. ബെയറർ — അവസാന തലക്കെട്ട് ഇതാണ്: പ്രിഫിക്സ് + സ്പേസ് + ടോക്കൺ",
  api_request_info: "API അഭ്യർത്ഥന വിവരം",
  roomName: "മുറിയുടെ പേര്",
  servikName: "പരാതിയുടെ പേര്",
  siteName: "സൈറ്റിൻ്റെ പേര്",
  stage: "സ്റ്റേജ്",
  number_of_buttons: "ബട്ടണുകളുടെ എണ്ണം",
  button_shape: "ബട്ടൺ ആകൃതി",
  delay_time_stage: "കാലതാമസം സമയ ഘട്ടം",
  go_to_stage: "സ്റ്റേജിലേക്ക് പോകുക",
  color: "നിറം",
  add_stage: "സ്റ്റേജ് ചേർക്കുക",
  save: "സംരക്ഷിക്കുക",
  number_of_issues: "പ്രശ്നങ്ങളുടെ എണ്ണം",
  online: "ഓൺലൈൻ",
  offline: "ഓഫ്‌ലൈൻ",
  offline_devices: "ഓഫ്‌ലൈൻ ഉപകരണങ്ങൾ",
  no_offline_devices: "ഓഫ്‌ലൈൻ ഉപകരണങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
  working_devices: "പ്രവർത്തന ഉപകരണങ്ങൾ",
  no_working_devices: "പ്രവർത്തിക്കുന്ന ഉപകരണങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
  room_name: "മുറിയുടെ പേര്",
  installation_spot: "സ്പോട്ട്",
  device_id: "ഉപകരണ ഐഡി",
  date: "തീയതി",
  status: "നില",
  device_status: "ഉപകരണ നില",
  none: "ഒന്നുമില്ല",
  no_surveys_created: "സർവേകളൊന്നും സൃഷ്ടിച്ചിട്ടില്ല",
  dashboard: "ഡാഷ്ബോർഡ്",
  franchise_name: "ഫ്രാഞ്ചൈസി നാമം",
  franchise_country: "ഫ്രാഞ്ചൈസി രാജ്യം",
  choose_franchise: "ഫ്രാഞ്ചൈസി തിരഞ്ഞെടുക്കുക",
  choose_country: "രാജ്യം തിരഞ്ഞെടുക്കുക",
  select_template: "ടെംപ്ലേറ്റ് തിരഞ്ഞെടുക്കുക",
  default_survey: "സ്ഥിരസ്ഥിതി സർവേ",
  cleaning_survey: "ക്ലീനിംഗ് സർവേ",
  kitchen_survey: "അടുക്കള സർവേ",
  template: "ടെംപ്ലേറ്റ്",
  area_name: "പ്രദേശത്തിൻ്റെ പേര്",
  rooms_names: "മുറികളുടെ പേരുകൾ",
  rooms_number: "മുറികൾ #",
  assign_number: "അസൈൻ #",
  active_notification_task: "സജീവ അറിയിപ്പ് ടാസ്ക്",
  amount_limit: "കൌണ്ടർ ഇടവേള",
  after_max: "മാക്സിന് ശേഷമുള്ള കൗണ്ടർ",
  new_area: "പുതിയ പ്രദേശം",
  edit_area: "ഏരിയ എഡിറ്റ് ചെയ്യുക",
  tablet: "ടാബ്ലെറ്റ്",
  "counter women": "കൗണ്ടർ സ്ത്രീകൾ",
  "counter men": "കൗണ്ടർ മാൻ",
  "counter handicap": "എതിർ വൈകല്യം",
  "counter man/woman": "എതിർ പുരുഷൻ / സ്ത്രീ",
  "counter man / woman": "എതിർ പുരുഷൻ / സ്ത്രീ",
  "sensor liquid": "സെൻസർ ദ്രാവകം",
  "double toilet paper": "ഇരട്ട ടോയ്‌ലറ്റ് പേപ്പർ",
  "toilet paper": "ടോയിലറ്റ് പേപ്പർ",
  tag: "ടാഗ് ചെയ്യുക",
  "qr tag": "QR ടാഗ്",
  additional_info: "അധിക വിവരങ്ങൾ",
  servikCategory: "കോൾ തരം",
  dishwashing: "പാത്രം കഴുകൽ",
  cafeteria: "കഫറ്റീരിയ",
  "clean room": "വൃത്തിയുള്ള മുറി",
  office: "ഓഫീസ്",
  "meeting room": "മീറ്റിംഗ് റൂം",
  cubic: "ക്യൂബിക്",
  women: "സ്ത്രീകൾ",
  men: "പുരുഷന്മാർ",
  handicap: "വൈകല്യം",
  Combined: "സംയോജിപ്പിച്ചത്",
  kitchen: "അടുക്കള",
  east: "കിഴക്ക്",
  west: "പടിഞ്ഞാറ്",
  north: "വടക്ക്",
  south: "തെക്ക്",
  right: "ശരിയാണ്",
  left: "ഇടത്",
  center: "കേന്ദ്രം",
  up: "മുകളിലേക്ക്",
  down: "താഴേക്ക്",
  combined: "സംയോജിപ്പിച്ചത്",
  lobby: "ലോബി",
  entrance: "പ്രവേശനം",
  reception: "സ്വീകരണം",
  area: "ഏരിയ",
  mezzanine: "മെസാനൈൻ",
  gallery: "ഗാലറി",
  ground: "ഗ്രൗണ്ട്",
  elevator: "എലിവേറ്റർ",
  is_calculated: "കണക്കാക്കിയ മുറി",
  calculated_room: "കണക്കാക്കിയ മുറി",
  splitted_survey: "വിഭജിച്ച സർവേ",
  redirect_to_url: "url-ലേക്ക് റീഡയറക്‌ട് ചെയ്യുക",
  survey_site: "സർവേ സൈറ്റ്",
  clicks: "ക്ലിക്കുകൾ",
  add_stage_number_to_signal: "സ്റ്റേജ് നമ്പർ അറ്റാച്ചുചെയ്യുക",
  including_pad9: "പാഡ് 9 ഉൾപ്പെടെ",
  "Tech Manufacturers": "ടെക് നിർമ്മാതാക്കൾ",
  "Tech Offices": "ടെക് ഓഫീസുകൾ",
  "Offices": "ഓഫീസുകൾ",
  "Terminal": "ടെർമിനൽ",
  "Universities": "സർവകലാശാലകൾ",
  "Factories": "ഫാക്ടറികൾ",
  "Hospital": "ആശുപത്രി",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "കൺവീനിയൻസ് സ്റ്റോറുകൾ",
  "Food Chains": "ഭക്ഷണ ശൃംഖലകൾ",
  "Residential": "റെസിഡൻഷ്യൽ",
  "Shopping Center": "ഷോപ്പിംഗ് സെന്റർ",
  "Survey": "സർവേ",
  "Demo": "ഡെമോ",
  "Vision": "Vision",
  "Court": "കോടതി",
  "Office Management": "ഓഫീസ് മാനേജ്മെന്റ്",
  "Government Office": "സർക്കാർ ഓഫീസ്",
  default_name: "ഇംഗ്ലീഷിൽ പേര്",
  exposures: "ക്ലീൻ എക്സ്പോഷർ",
  exposures_tab: "റൂം പ്രവർത്തനം",
  expose_results: "ഫലങ്ങൾ",
  events_expose: "ഇവൻ്റുകൾ",
  expose_score: "നിരക്ക്",
  shift_events_expose: "ഇവൻ്റുകൾ മാറ്റി വെളിപ്പെടുത്തുക",
  type_of_site: "സൈറ്റിൻ്റെ തരം",
  morning_shift: "രാവിലെ ഷിഫ്റ്റ്",
  afternoon_shift: "ഉച്ചതിരിഞ്ഞ് ഷിഫ്റ്റ്",
  night_shift: "രാത്രി ഷിഫ്റ്റ്",
  update: "അപ്ഡേറ്റ്",
  restart: "പുനരാരംഭിക്കുക",
  send_data: "ഡാറ്റ അയയ്ക്കുക",
  send_count: "എണ്ണം അയയ്ക്കുക",
  blink: "മിന്നിമറയുക",
  beacon: "Beacon",
  like_btn: "ലൈക്ക് ബട്ടൺ",
  requires_like_btn: "ലൈക്ക് ബട്ടൺ ഓൺ ആയിരിക്കണം",
  maintenance_btn: "മെയിൻ്റനൻസ് ബട്ടൺ",
  battery: "ബാറ്ററി",
  version: "പതിപ്പ്",
  actions: "പ്രവർത്തനങ്ങൾ",
  device_actions: "ഉപകരണ പ്രവർത്തനങ്ങൾ",
  device_settings: "ഉപകരണ ക്രമീകരണങ്ങൾ",
  drains_battery: "ബാറ്ററി കളയുന്നു",
  latest_errors: "ഏറ്റവും പുതിയ പിശകുകൾ",
  no_errors: "പിശകുകളൊന്നുമില്ല",
  offline_calls: "ഓഫ്‌ലൈൻ കോളുകൾ",
  offline_duration_calls: "ഓഫ്‌ലൈൻ ദൈർഘ്യ കോളുകൾ",
  counterCalls: "കൌണ്ടർ കോളുകൾ",
  active: "സജീവമാണ്",
  no_active_supervisors: "സജീവമായ സൂപ്പർവൈസർമാരില്ല",
  active_supervisors_column: "സജീവ സൂപ്പർവൈസർമാർ",
  supervisors_active_label: "സൂപ്പർവൈസർമാർ ഇപ്പോൾ സജീവമാണ്",
  active_supervisors_coverage_hint: "സജീവ സൂപ്പർവൈസർമാർ ഈ ഏരിയ മൊബൈൽ ആപ്പിൽ സ്വിച്ച് ഓൺ ചെയ്തിട്ടുണ്ട്. ഇത് ഓൺലൈൻ സ്റ്റാറ്റസ് അല്ലെങ്കിൽ ശാരീരിക സാന്നിധ്യത്തെ സൂചിപ്പിക്കുന്നില്ല.",
  active_calculation: "സജീവ കണക്കുകൂട്ടൽ",
  pad: "പാഡ്",
  pad_counter: "പാഡ് കൗണ്ടർ",
  counter_status: "കൗണ്ടർ സ്റ്റാറ്റസ്",
  choose_state: "സംസ്ഥാനം തിരഞ്ഞെടുക്കുക",
  choose_city: "നഗരം തിരഞ്ഞെടുക്കുക",
  start_hour: "ആരംഭിക്കുന്ന മണിക്കൂർ",
  end_hour: "അവസാന മണിക്കൂർ",
  analytics_log: "അനലിറ്റിക്സ് ലോഗ്",
  or: "അല്ലെങ്കിൽ",
  no_data_available: "ഡാറ്റ ലഭ്യമല്ല",
  filter_by_cleaner: "ക്ലീനർ ഉപയോഗിച്ച് ഫിൽട്ടർ ചെയ്യുക",
  all_cleaners: "എല്ലാ ക്ലീനർമാർ",
  not_available: "N/A",
  failed_to_load_data: "ഡാറ്റ ലോഡുചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  new_task: "പുതിയ ചുമതല",
  new_personal_task: "പുതിയ വ്യക്തിഗത ചുമതല",
  task_assignment: "ടാസ്ക് അസൈൻമെൻ്റ്",
  task_assignment_room: "റൂം ടാസ്ക്",
  task_assignment_personal: "വ്യക്തിഗത ചുമതല (ക്ലീനർക്ക് നിയോഗിക്കുക)",
  temporarily_unavailable: "താൽക്കാലികമായി ലഭ്യമല്ല",
  task_details: "ടാസ്ക് വിശദാംശങ്ങൾ",
  task_languages: "ടാസ്ക് ഭാഷകൾ",
  task_languages_hint: "ഈ ടാസ്ക്കിനുള്ള ഭാഷകൾ തിരഞ്ഞെടുക്കുക. തിരഞ്ഞെടുത്ത ഓരോ ഭാഷയിലും നിങ്ങൾ തലക്കെട്ട് നൽകും.",
  settings_and_assignment: "ക്രമീകരണങ്ങളും അസൈൻമെൻ്റും",
  assignee: "അസൈനി",
  category: "വിഭാഗം",
  title: "തലക്കെട്ട്",
  task_type: "ടാസ്ക് തരം",
  task_category: "ടാസ്ക് വിഭാഗം",
  call_to_action: "പ്രവർത്തനത്തിലേക്ക് വിളിക്കുക",
  schedule: "ഷെഡ്യൂൾ",
  insert_text: "വാചകം ചേർക്കുക",
  select: "തിരഞ്ഞെടുക്കുക",
  select_all: "എല്ലാം തിരഞ്ഞെടുക്കുക",
  n_selected: "{count} തിരഞ്ഞെടുത്തു",
  clear_selection: "തിരഞ്ഞെടുപ്പ് മായ്ക്കുക",
  wa_bulk_edit: "Bulk edit",
  wa_bulk_edit_hint: "Apply one change to {count} selected work areas.",
  wa_bulk_action: "What do you want to change?",
  wa_bulk_set_counter: "Counter",
  wa_bulk_add_task: "Add notification task",
  wa_bulk_remove_task: "Remove notification task",
  wa_bulk_enable_counter: "Turn counter on if currently off",
  wa_bulk_apply_to_n: "Apply to {count} areas",
  wa_bulk_edit_result: "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  wa_bulk_set_counter_desc: "Turn counter on/off or set the same interval on selected areas",
  wa_bulk_add_task_desc: "Add one active notification task to selected areas",
  wa_bulk_remove_task_desc: "Remove one active notification task from selected areas",
  wa_bulk_enable_counter_hint: "Areas with counter currently off will be turned on",
  wa_bulk_search_task: "Search notification tasks",
  wa_bulk_selected_task: "Selected task",
  wa_bulk_counter_state: "Counter status",
  wa_bulk_counter_on: "Turn on",
  wa_bulk_counter_off: "Turn off",
  wa_bulk_counter_unchanged: "Keep status",
  wa_bulk_counter_on_hint: "Turn counter on for all selected areas and set the interval",
  wa_bulk_counter_off_hint: "Turn counter off for all selected areas",
  wa_bulk_counter_unchanged_hint: "Only update the interval; leave on/off as it is",
  wa_bulk_task_coverage_remove: "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  wa_bulk_task_coverage_add: "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  schedule_dates: "ഷെഡ്യൂൾ തീയതികൾ",
  language: "ഭാഷ",
  calendar: "കലണ്ടർ",
  operation: "ഓപ്പറേഷൻ",
  daily: "ദിവസേന",
  weekly: "പ്രതിവാരം",
  monthly: "പ്രതിമാസ",
  quarterly: "ത്രൈമാസിക",
  yearly: "വർഷം തോറും",
  sunday: "ഞായറാഴ്ച",
  monday: "തിങ്കളാഴ്ച",
  tuesday: "ചൊവ്വാഴ്ച",
  wednesday: "ബുധനാഴ്ച",
  thursday: "വ്യാഴാഴ്ച",
  friday: "വെള്ളിയാഴ്ച",
  saturday: "ശനിയാഴ്ച",
  january: "ജനുവരി",
  february: "ഫെബ്രുവരി",
  march: "മാർച്ച്",
  april: "ഏപ്രിൽ",
  may: "മെയ്",
  june: "ജൂൺ",
  july: "ജൂലൈ",
  august: "ഓഗസ്റ്റ്",
  september: "സെപ്റ്റംബർ",
  october: "ഒക്ടോബർ",
  november: "നവംബർ",
  december: "ഡിസംബർ",
  "1st week": "ഒന്നാം ആഴ്ച",
  "2nd week": "രണ്ടാം ആഴ്ച",
  "3rd week": "മൂന്നാം ആഴ്ച",
  "4th week": "നാലാമത്തെ ആഴ്ച",
  "5th week": "അഞ്ചാം ആഴ്ച",
  "1st quarter": "ഒന്നാം പാദം",
  "2nd quarter": "രണ്ടാം പാദം",
  "3rd quarter": "മൂന്നാം പാദം",
  "4th quarter": "നാലാം പാദം",
  edit_task: "ടാസ്ക് എഡിറ്റ് ചെയ്യുക",
  created_at: "എന്ന സ്ഥലത്ത് സൃഷ്ടിച്ചു",
  installed_at: "ൽ ഇൻസ്റ്റാൾ ചെയ്തു",
  hour: "മണിക്കൂർ",
  week_days: "ആഴ്ചയിലെ ദിവസങ്ങൾ",
  month_weeks: "മാസ ആഴ്ചകൾ",
  month_days: "മാസ ദിവസങ്ങൾ",
  no_tasks_found: "ടാസ്ക്കുകളൊന്നും കണ്ടെത്തിയില്ല",
  invalid_language: "അസാധുവായ ഭാഷ",
  no_active_tasks_found: "സജീവമായ ടാസ്ക്കുകളൊന്നും കണ്ടെത്തിയില്ല",
  edit: "എഡിറ്റ് ചെയ്യുക",
  send_date: "തീയതി അയയ്ക്കുക",
  invalid_date: "അസാധുവായ തീയതി",
  hour_must_be_after_current: "നിലവിലെ സമയത്തിന് ശേഷമുള്ള ഒരു മണിക്കൂർ തിരഞ്ഞെടുക്കുക",
  cells_num: "സെല്ലുകൾ #",
  sinks_num: "സിങ്കുകൾ #",
  urinals_num: "മൂത്രപ്പുരകൾ #",
  toilet_paper_size: "ടോയ്ലറ്റ് പേപ്പർ വലിപ്പം",
  email_configuration: "ഇമെയിൽ കോൺഫിഗറേഷൻ",
  please_edit_the_email_information: "ഇമെയിൽ വിവരങ്ങൾ എഡിറ്റ് ചെയ്യുക",
  email_sender_info: "ഇമെയിൽ അയച്ചയാളുടെ വിവരങ്ങൾ",
  email_subject_info: "വിഷയ വിവരം ഇമെയിൽ ചെയ്യുക",
  email_message_info: "ഇമെയിൽ സന്ദേശ വിവരം",
  companyName: "കമ്പനി പേര്",
  email_language: "ഇമെയിൽ ഭാഷ",
  complaint_language: "പരാതി ഭാഷ",
  email_message_format: "ഇമെയിൽ സന്ദേശ ഫോർമാറ്റ്",
  line: "ലൈൻ",
  list: "ലിസ്റ്റ്",
  roomType: "റൂം തരം",
  "By logging in, you agree to Buzzztech's": "ലോഗിൻ ചെയ്യുന്നതിലൂടെ, നിങ്ങൾ Buzztech's അംഗീകരിക്കുന്നു",
  "Terms and Conditions": "ഉപാധികളും നിബന്ധനകളും",
  and: "ഒപ്പം",
  "Privacy Policy": "സ്വകാര്യതാ നയം",
  "All actions within this panel are recorded for quality control and improvement": "ഈ പാനലിലെ എല്ലാ പ്രവർത്തനങ്ങളും ഗുണനിലവാര നിയന്ത്രണത്തിനും മെച്ചപ്പെടുത്തലിനും വേണ്ടി രേഖപ്പെടുത്തുന്നു",
  "You must agree to the terms and conditions": "നിങ്ങൾ നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കണം",
  months: "മാസങ്ങൾ",
  ref_id: "റഫറൻസ് ഐഡി",
  room_name_en: "മുറിയുടെ പേര് ഇംഗ്ലീഷിൽ",
  site_state: "സൈറ്റിൻ്റെ അവസ്ഥ",
  site_city: "സൈറ്റ് നഗരം",
  city: "നഗരം",
  state: "സംസ്ഥാനം",
  site_country: "സൈറ്റ് രാജ്യം",
  first_date: "ഒന്നാം തീയതി",
  pinned: "പിൻ ചെയ്തു",
  "no.": "ഇല്ല.",
  must_be_numbers: "അക്കങ്ങളായിരിക്കണം",
  must_be_3_digits: "3 അക്കങ്ങൾ ഉണ്ടായിരിക്കണം",
  must_have_english_title: "ഇംഗ്ലീഷ് തലക്കെട്ട് ഉണ്ടായിരിക്കണം",
  total_sites: "ആകെ",
  site_information: "സൈറ്റ് വിവരങ്ങൾ",
  holiday_offdays: "അവധി ദിവസങ്ങളും അവധി ദിനങ്ങളും",
  add_offday: "ദിവസം-ഓഫ്",
  add_holiday: "അവധി",
  name_under_chars: "25 പ്രതീകങ്ങളിൽ താഴെയുള്ള പേര്",
  days_comma_separated: "സാധുവായ ദിവസങ്ങൾ, കോമയാൽ വേർതിരിച്ചിരിക്കുന്നു",
  year: "വർഷം",
  month: "മാസം",
  day: "ദിവസം",
  holiday_name: "അവധിക്കാല നാമം",
  offday_name: "ഡേ-ഓഫ് പേര്",
  delete_confirmation_title: "നിങ്ങൾക്ക് ഉറപ്പാണോ?",
  delete_confirmation_message: "ഈ പ്രവർത്തനം പഴയപടിയാക്കാനാകില്ല.",
  are_you_sure: "നിങ്ങൾക്ക് ഉറപ്പാണോ?",
  israel: "ഇസ്രായേൽ",
  USA: "യുഎസ്എ",
  poland: "പോളണ്ട്",
  mexico: "മെക്സിക്കോ",
  cyprus: "സൈപ്രസ്",
  brazil: "ബ്രസീൽ",
  romania: "റൊമാനിയ",
  tablet_survey: "ടാബ്ലെറ്റ് സർവേ",
  no_shift_survey: "ഷിഫ്റ്റ് ടാബ്‌ലെറ്റ് സർവേ ഇല്ല",
  number_of_rows: "വരികളുടെ എണ്ണം",
  rating_shape: "റേറ്റിംഗ് ആകൃതി",
  content_survey: "ഉള്ളടക്ക സർവേ",
  rating_survey: "റേറ്റിംഗ് സർവേ",
  "device-alerts": "പ്രശ്നം",
  "device-active": "സജീവമാണ്",
  "device-search": "തിരയുക",
  mac_id: "MAC വിലാസം",
  qr_tag: "QR ടാഗ്",
  sensor: "സെൻസർ",
  image_survey: "ചിത്ര സർവേ",
  open_text: "ടെക്സ്റ്റ് തുറക്കുക",
  open_text_survey: "ടെക്സ്റ്റ് സർവേ തുറക്കുക",
  embedded_link: "ഉൾച്ചേർത്ത ലിങ്ക്",
  "device-counter": "കൗണ്ടർ",
  count: "എണ്ണുക",
  last_date: "അവസാന തീയതി",
  last_arrival: "അവസാന ക്ലീനർ വരവ്",
  cleaners: "ശുചീകരണ തൊഴിലാളികൾ",
  viewer: "കാഴ്ചക്കാരൻ",
  android: "ആൻഡ്രോയിഡ്",
  ios: "ഐഒഎസ്",
  no_users_found: "ഉപയോക്താക്കളെ കണ്ടെത്തിയില്ല",
  no_cleaners_found: "ശുചീകരണ തൊഴിലാളികളെ കണ്ടെത്തിയില്ല",
  new_cleaner: "പുതിയ ക്ലീനർ",
  edit_cleaner: "എഡിറ്റ് ക്ലീനർ",
  please_select: "ദയവായി തിരഞ്ഞെടുക്കുക",
  please_select_site_first: "ദയവായി ആദ്യം ഒരു സൈറ്റ് തിരഞ്ഞെടുക്കുക",
  working_areas: "പ്രവർത്തന മേഖലകൾ",
  no_working_areas: "ഇതുവരെ പ്രവർത്തന മേഖലകളൊന്നുമില്ല",
  working_area_alerts: "അലേർട്ടുകൾ",
  api: "API",
  task_target_by_working_areas: "പ്രവർത്തന മേഖലകൾ പ്രകാരം (തിരഞ്ഞെടുത്ത പ്രദേശങ്ങളിലെ എല്ലാ മുറികളും)",
  task_target_by_rooms: "പ്രത്യേക മുറികൾ വഴി",
  task_target_label: "ടാസ്ക് തുറക്കുന്നു",
  step_what: "എന്ത്",
  step_when: "എപ്പോൾ",
  step_where: "എവിടെ",
  step_options: "ഓപ്ഷനുകൾ",
  please_create_room_before_working_area: "ഒരു ജോലിസ്ഥലം സൃഷ്‌ടിക്കുന്നതിന് മുമ്പ് ദയവായി ഒരു മുറിയെങ്കിലും സൃഷ്‌ടിക്കുക",
  isWorkingInSite: "സൈറ്റിൽ പ്രവർത്തിക്കുന്നു",
  you_are_not_allowed_to_edit: "നിങ്ങൾക്ക് എഡിറ്റ് ചെയ്യാൻ അനുവാദമില്ല",
  you_are_not_allowed_to_remove: "നിങ്ങൾക്ക് നീക്കം ചെയ്യാൻ അനുവാദമില്ല",
  task: "ടാസ്ക്",
  portuguese: "പോർച്ചുഗീസ്",
  russian: "റഷ്യൻ",
  spanish: "സ്പാനിഷ്",
  polish: "പോളിഷ്",
  installer: "ഇൻസ്റ്റാളർ",
  once: "ഒരിക്കൽ",
  time_saved: "സമയം ലാഭിച്ചു",
  yes: "അതെ",
  no: "ഇല്ല",
  workingAreaNames: "പ്രവർത്തന മേഖലയുടെ പേരുകൾ",
  shift_rooms: "മുറികൾ",
  shift_validation_overlap: "ഈ ഷിഫ്റ്റ് \"{roomName}\" റൂമിലെ \"{shiftName}\" എന്നതുമായി ഓവർലാപ്പ് ചെയ്യുന്നു. ഷിഫ്റ്റുകളിലൊന്നിൽ നിന്ന് മുറി നീക്കം ചെയ്യുക അല്ലെങ്കിൽ അവരുടെ സമയം ക്രമീകരിക്കുക.",
  shift_validation_missing_fields: "ആവശ്യമായ എല്ലാ ഷിഫ്റ്റ് ഫീൽഡുകളും (മണിക്കൂർ, ദിവസങ്ങൾ, സൈറ്റ്) പൂരിപ്പിക്കുക.",
  shift_validation_empty_rooms: "ഈ ഷിഫ്റ്റിലേക്ക് ഒരു മുറിയെങ്കിലും നൽകുക.",
  shift_validation_no_valid_rooms: "ഈ ഷിഫ്റ്റിനായി സാധുവായ മുറികളൊന്നും തിരഞ്ഞെടുത്തിട്ടില്ല.",
  shift_validation_empty_room_map: "ഷിഫ്റ്റ് ഷെഡ്യൂൾ നിർമ്മിക്കാൻ കഴിഞ്ഞില്ല. തിരഞ്ഞെടുത്ത ദിവസങ്ങളും മണിക്കൂറുകളും പരിശോധിക്കുക.",
  new_shift: "പുതിയ ഷിഫ്റ്റ്",
  add_shift_inactive: "പ്രതിഫലന ഷിഫ്റ്റുകൾ ചേർക്കുക",
  remove_auto_shift_inactive: "സ്വയമേവയുള്ള പ്രതിഫലന ഷിഫ്റ്റുകൾ നീക്കം ചെയ്യുക",
  additional_options: "അധിക ഓപ്ഷനുകൾ",
  add_default_shifts: "ഡിഫോൾട്ട് ഷിഫ്റ്റുകൾ ചേർക്കുക",
  no_user_found: "ഒരു ഉപയോക്താവിനെയും കണ്ടെത്തിയില്ല",
  no_site_found: "സൈറ്റൊന്നും കണ്ടെത്തിയില്ല",
  open_complaints: "പരാതികൾ തുറക്കുക",
  site_alerts: "സൈറ്റ് അലേർട്ടുകൾ",
  open_sla_alerts: "പരാതി അലേർട്ടുകൾ തുറക്കുക",
  open_duration: "തുറന്ന കാലയളവ്",
  no_open_slas: "തുറന്ന SLA-കളൊന്നും കണ്ടെത്തിയില്ല",
  no_open_slas_description: "നിലവിൽ തുറന്ന SLA-കളുള്ള സൈറ്റുകളൊന്നുമില്ല.",
  no_slas_to_send: "ഈ സൈറ്റിനായി തുറന്ന SLA-കളൊന്നും കണ്ടെത്തിയില്ല",
  total_open_complaints: "മൊത്തം തുറന്ന പരാതികൾ",
  longest_duration: "ഏറ്റവും ദൈർഘ്യമേറിയ ദൈർഘ്യം",
  complaints_details: "പരാതികളുടെ വിശദാംശങ്ങൾ",
  rooms_with_open_complaints_percentage: "തുറന്ന പരാതികളുള്ള മുറികൾ",
  rooms_with_cleaner_arrival_percentage: "ക്ലീനർ അറൈവൽ ഉള്ള മുറികൾ",
  rooms_without_cleaner_arrival_percentage: "ക്ലീനർ വരവ് ഇല്ലാത്ത മുറികൾ",
  site_alerts_total_rooms: "ആകെ മുറികൾ",
  site_alerts_open_complaints_count: "തുറന്ന പരാതികളുടെ എണ്ണം",
  site_alerts_customer_opening_date: "ഉപഭോക്താവ് തുറക്കുന്ന തീയതി",
  company_country: "കമ്പനി രാജ്യം",
  select_message: "സന്ദേശം തിരഞ്ഞെടുക്കുക",
  message_no_cleaner_arrival: "എല്ലാവർക്കും ഹലോ,\\nഇന്ന് ക്ലീനർ വരവ് റിപ്പോർട്ട് ചെയ്യാത്ത മുറികളുണ്ടെന്ന കാര്യം ശ്രദ്ധിക്കുക.\\nദയവായി ഇത് കൈകാര്യം ചെയ്യുക",
  message_open_complaints: "എല്ലാവർക്കും ഹലോ,\\nഏറെക്കാലമായി തുറന്ന പരാതികളുള്ള നിരവധി മുറികളുണ്ടെന്ന കാര്യം ശ്രദ്ധിക്കുക.\\nദയവായി ഇത് കൈകാര്യം ചെയ്യുക",
  rooms_list: "മുറികൾ:",
  please_address_issues_promptly: "ദയവായി ഈ പ്രശ്നങ്ങൾ ഉടനടി പരിഹരിക്കുക.",
  no_results_found: "ഫലങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
  showing: "കാണിക്കുന്നു",
  per_page: "ഓരോ പേജിനും",
  whatsapp: "WhatsApp",
  loading: "ലോഡ് ചെയ്യുന്നു",
  error_opening_whatsapp: "വാട്ട്‌സ്ആപ്പ് തുറക്കുന്നതിൽ പിശക്. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  error_loading_slas: "SLA വിശദാംശങ്ങൾ ലോഡുചെയ്യുന്നതിൽ പിശക്. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  send_whatsapp: "വാട്സ്ആപ്പ് അയക്കുക",
  more_options: "കൂടുതൽ ഓപ്ഷനുകൾ",
  preview_message: "പ്രിവ്യൂ സന്ദേശം",
  copy_message: "സന്ദേശം പകർത്തുക",
  message_preview: "സന്ദേശ പ്രിവ്യൂ",
  phone_number_optional: "ഫോൺ നമ്പർ (ഓപ്ഷണൽ)",
  enter_phone_number: "ഫോൺ നമ്പർ നൽകുക (ഉദാ. +1234567890)",
  phone_number_hint: "ഒരു പ്രത്യേക കോൺടാക്റ്റ് ഇല്ലാതെ WhatsApp തുറക്കാൻ ശൂന്യമായി വിടുക",
  message_copied: "സന്ദേശം ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തി!",
  error_copying_message: "സന്ദേശം പകർത്തുന്നതിൽ പിശക്. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  opening_whatsapp: "വാട്ട്‌സ്ആപ്പ് തുറക്കുന്നു...",
  preview_message_description: "അയയ്ക്കുന്നതിന് മുമ്പ് സന്ദേശം പ്രിവ്യൂ ചെയ്ത് എഡിറ്റ് ചെയ്യുക",
  copy_message_description: "സന്ദേശം ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തുക",
  service_provider: "സേവന ദാതാവ്",
  "qr task": "QR ടാസ്ക്",
  qr_task: "QR ടാസ്ക്",
  all_day: "ദിവസം മുഴുവൻ",
  auto_start: "ഓട്ടോ സ്റ്റാർട്ട്",
  more_options: "കൂടുതൽ ഓപ്ഷനുകൾ",
  english_title: "ഇംഗ്ലീഷ് തലക്കെട്ട്",
  connectivity: "കണക്റ്റിവിറ്റി",
  power: "ശക്തി",
  "Your work has been saved": "നിങ്ങളുടെ ജോലി സംരക്ഷിച്ചു",
  schedule_call_time: "കോൾ സമയം ഷെഡ്യൂൾ ചെയ്യുക",
  schedule_call_gap: "കോൾ വിടവ് ഷെഡ്യൂൾ ചെയ്യുക",
  gapInMinutes: "മിനിറ്റുകൾക്കുള്ളിൽ വിടവ്",
  no_manual_calls_available: "മാനുവൽ കോളുകളൊന്നും ലഭ്യമല്ല",
  manual_calls: "മാനുവൽ കോളുകൾ",
  cleandexCalls: "Cleanandex വിളിക്കുന്നു",
  manualCalls: "മാനുവൽ കോളുകൾ",
  inactive: "നിഷ്ക്രിയം",
  "on hold": "ഹോൾഡ് ചെയ്തിരിക്കുന്നു",
  sequential: "തുടർച്ചയായി",
  ratio: "അനുപാതം",
  must_choose: "തിരഞ്ഞെടുക്കണം",
  surveyApp: "സർവേ ആപ്പ്",
  installation: "ഇൻസ്റ്റലേഷൻ",
  manager: "മാനേജർ",
  previous: "മുമ്പത്തെ",
  no_rooms_found: "മുറികളൊന്നും കണ്ടെത്തിയില്ല",
  show_calendar: "കലണ്ടർ കാണിക്കുക",
  seeAll: "എല്ലാം കാണുക",
  showPaginated: "പേജ് ചെയ്തത് കാണിക്കുക",
  cleaners_arrivals: "ശുചീകരണ തൊഴിലാളികളുടെ വരവ്",
  "qr validator": "QR വാലിഡേറ്റർ",
  qr_validator: "QR വാലിഡേറ്റർ",
  searchAddress: "ഒരു വിലാസത്തിനായി തിരയുക",
  sector: "മേഖല",
  add_address: "വിലാസം ചേർക്കുക",
  site_auto_attendance_enabled: "മൊബൈൽ ആപ്പ് ജിയോഫെൻസ് ഉപയോഗിച്ച് ഓട്ടോമാറ്റിക് ക്ലോക്ക്-ഇൻ, ക്ലോക്ക്-ഔട്ട് എന്നിവ അനുവദിക്കുക (ജീവനക്കാർക്ക് ആപ്പും ലൊക്കേഷൻ അനുമതിയും ആവശ്യമാണ്).",
  site_auto_attendance_requires_location: "സ്വയമേവയുള്ള ഹാജർ പ്രാപ്തമാക്കുന്നതിന് മുമ്പ് ആദ്യം മാപ്പിൽ ഒരു ലൊക്കേഷൻ സജ്ജീകരിക്കുക (പിൻ, 100 മീറ്റർ ചുറ്റളവിൽ).",
  site_mandatory_clock_in: "ജോലിക്ക് മുൻപ് ക്ലോക്ക് ഇൻ നിർബന്ധമാക്കുക",
  site_mandatory_clock_in_description: "ഈ സൈറ്റിലെ ജീവനക്കാർ മൊബൈൽ ആപ്പിലെ ക്ലീനിംഗ്, മെയിന്റനൻസ്, മിഷനുകൾ ടാബുകൾ തുറക്കുന്നതിന് മുൻപ് ക്ലോക്ക് ഇൻ ചെയ്യണം.",
  site_mandatory_clock_in_without_location: "ഈ സൈറ്റിന് മാപ്പ് ലൊക്കേഷൻ ഇല്ല, അതിനാൽ ജീവനക്കാരൻ സൈറ്റിൽ ഉള്ളപ്പോൾ ആപ്പിന് തിരിച്ചറിയാൻ കഴിയില്ല. ഒന്ന് സജ്ജീകരിക്കുന്നതുവരെ, ഈ ജീവനക്കാർക്ക് എല്ലായിടത്തും ഈ നിബന്ധന ബാധകമാണ്.",
  auto_attendance: "ഓട്ടോ ഹാജർ",
  auto_attendance_ready: "തയ്യാറാണ്",
  auto_attendance_off: "ഓഫ്",
  auto_attendance_needs_setup: "സജ്ജീകരണം ആവശ്യമാണ്",
  auto_attendance_ready_tooltip: "ടോഗിൾ ഓണാണ്, ജിയോഫെൻസ് റേഡിയസ് ≥ 100 മീ, ഓട്ടോമാറ്റിക് ക്ലോക്ക്-ഇൻ/ഔട്ടിനായി തയ്യാറാണ്.",
  auto_attendance_off_tooltip: "ടോഗിൾ ഓഫാണ്. യാന്ത്രിക ഹാജർ പ്രവർത്തനക്ഷമമാക്കാൻ സൈറ്റ് എഡിറ്റ് ചെയ്യുക.",
  auto_attendance_needs_setup_tooltip: "ടോഗിൾ ഓണാണ്, പക്ഷേ ജിയോഫെൻസ് കാണുന്നില്ല അല്ലെങ്കിൽ കുറഞ്ഞത് 100 മീറ്ററിൽ താഴെയാണ്. അത് പരിഹരിക്കാൻ സൈറ്റ് എഡിറ്റ് ചെയ്യുക.",
  edit_address: "വിലാസം എഡിറ്റ് ചെയ്യുക",
  choose_radius: "ആരം തിരഞ്ഞെടുക്കുക",
  cleandex: "ക്ലീൻഡെക്സ്",
  cleandex_column_tooltip: "പച്ച = ശരി. ചുവപ്പ് = വൃത്തിയാക്കാൻ ശുപാർശ ചെയ്യുന്നു.\\nവിശദാംശങ്ങൾക്ക് സെൽ ഐക്കൺ ഹോവർ ചെയ്യുക.",
  recommended_to_clean: "വൃത്തിയാക്കാൻ ശുപാർശ ചെയ്യുന്നു",
  cleandex_warning_level: "Cleandex മുന്നറിയിപ്പ് നില",
  select_warning_level: "മുന്നറിയിപ്പ് നില തിരഞ്ഞെടുക്കുക",
  bronze: "വെങ്കലം",
  silver: "വെള്ളി",
  gold: "സ്വർണ്ണം",
  ai: "AI",
  daily_employees_num: "പ്രതിദിന ജീവനക്കാരുടെ എണ്ണം",
  daily_shift_hours: "പ്രതിദിന ഷിഫ്റ്റ് സമയം",
  rooms_num: "മുറികളുടെ നമ്പർ",
  buildings_num: "കെട്ടിടങ്ങളുടെ നമ്പർ",
  cleaner_entries: "ക്ലീനർ എൻട്രികൾ",
  avg_daily_visits_monthly: "പ്രതിമാസ ശരാശരി പ്രതിദിന സന്ദർശനങ്ങൾ",
  avg_daily_cleaners_to_save: "ലാഭിക്കാൻ ശരാശരി പ്രതിദിന ക്ലീനർമാർ",
  saving_hours_per_day: "പ്രതിദിനം മണിക്കൂറുകൾ ലാഭിക്കുന്നു",
  saving_money_per_day: "പ്രതിദിനം പണം ലാഭിക്കുന്നു",
  saving_money_per_month: "പ്രതിമാസം പണം ലാഭിക്കുന്നു",
  cleaners_to_visitors_ratio: "സന്ദർശക അനുപാതം ക്ലീനർ",
  cleaning_time_in_minutes_per_room: "ഓരോ മുറിയിലും മിനിറ്റുകൾക്കുള്ളിൽ വൃത്തിയാക്കൽ സമയം",
  max_number_of_rooms_per_employee: "ഒരു ജീവനക്കാരന് പരമാവധി മുറികളുടെ എണ്ണം",
  break_time_per_hour: "മണിക്കൂറിൽ ഇടവേള സമയം",
  transition_time_between_tasks: "ജോലികൾക്കിടയിലുള്ള പരിവർത്തന സമയം",
  employer_cost_hour: "ഒരു മണിക്കൂറിന് തൊഴിലുടമയുടെ ചെലവ്",
  lobby_cleaning_per_floor: "ഓരോ നിലയിലും ലോബി വൃത്തിയാക്കൽ",
  desired_cleaning_time: "ആവശ്യമുള്ള ക്ലീനിംഗ് സമയം",
  desired_number_of_entries: "ആവശ്യമുള്ള എൻട്രികളുടെ എണ്ണം",
  buzz_system_cost_per_unit_per_month: "ഒരു യൂണിറ്റിന് പ്രതിമാസം Buzz സിസ്റ്റം ചെലവ്",
  total_buzz_system_cost_per_month: "പ്രതിമാസം ആകെ Buzz സിസ്റ്റം ചെലവ്",
  return_on_investment_in_months: "മാസങ്ങൾക്കുള്ളിൽ നിക്ഷേപത്തിൻ്റെ വരുമാനം",
  annual_savings: "വാർഷിക സമ്പാദ്യം",
  roi_calculator: "ROI കാൽക്കുലേറ്റർ",
  cleaning_work_plan: "ക്ലീനിംഗ് വർക്ക് പ്ലാൻ",
  cleaning_work_plan_intro: "തലക്കെട്ടിൽ കമ്പനിയുടെയും സൈറ്റിൻ്റെയും ഷിഫ്റ്റ് റൂം സ്ഥിതിവിവരക്കണക്കുകൾ ഉപയോഗിക്കുന്നു. തീയതി പരിധിക്കുള്ളിൽ ഏറ്റവും കൂടുതൽ സൈറ്റ് സന്ദർശനങ്ങളും ഡാഷ്‌ബോർഡ് ഫിൽട്ടറിൽ നിന്നുള്ള ഷിഫ്റ്റുകളും ഉള്ള ഒരു ദിവസത്തിൽ നിന്നാണ് സന്ദർശനങ്ങളും വരവുകളും വരുന്നത് (ഈ ടാബ് സമയവും ഫിൽട്ടർ നിയന്ത്രണങ്ങളും മറയ്ക്കുകയാണെങ്കിൽ പ്രകടനത്തിലോ അനലിറ്റിക്‌സിലോ സജ്ജമാക്കുക). ഓരോ വൃത്തിയുള്ള സന്ദർശനങ്ങൾ, സ്റ്റാഫ് ടാർഗെറ്റ്, മണിക്കൂർ ചെലവ്, ഓരോ ക്ലീനിനും ശരാശരി മിനിറ്റ് എന്നിവ നൽകുക; റൂം-ലെവൽ നിർദ്ദേശിച്ച ക്ലീനുകളും സംഗ്രഹ മൊത്തങ്ങളും കാണാൻ സൃഷ്ടിക്കുക.",
  cleaning_work_plan_default_n: "ഓരോ ക്ലീനിനും സന്ദർശനങ്ങൾ",
  cleaning_work_plan_cleaner_count: "ക്ലീനർ (ഓപ്ഷണൽ)",
  cleaning_work_plan_avg_minutes: "ശരാശരി വൃത്തിയാക്കൽ സമയം (മിനിറ്റ്)",
  cleaning_work_plan_run: "പ്ലാൻ സൃഷ്ടിക്കുക",
  cleaning_work_plan_export_csv: "Excel കയറ്റുമതി ചെയ്യുക",
  cleaning_work_plan_suggested_n: "ഓരോ ക്ലീനിനും സന്ദർശനങ്ങൾ",
  cleaning_work_plan_actual_cleans: "ആഗമനങ്ങൾ",
  cleaning_work_plan_actual_cleans_hint: "തിരക്കേറിയ ദിവസത്തിലെ ഷിഫ്റ്റ് റൂം സ്ഥിതിവിവരക്കണക്കുകളിൽ മൊത്തം ക്ലീനർ വരവ് (തിരഞ്ഞെടുത്ത ശ്രേണിയിലും ഫിൽട്ടറുകളിലും).",
  cleaning_work_plan_suggested_cleans: "നിർദ്ദേശിച്ച വൃത്തിയാക്കൽ",
  cleaning_work_plan_cleaner: "ക്ലീനർ",
  cleaning_work_plan_floors: "നിലകൾ",
  cleaning_work_plan_peak_day: "പീക്ക് ദിവസം",
  cleaning_work_plan_error: "ക്ലീനിംഗ് വർക്ക് പ്ലാൻ സൃഷ്ടിക്കാൻ കഴിഞ്ഞില്ല",
  cleaning_work_plan_no_rooms: "ഈ സൈറ്റിനായി മുറികളൊന്നും തിരികെ നൽകിയില്ല. സൈറ്റും തീയതി ശ്രേണിയും പരിശോധിക്കുക അല്ലെങ്കിൽ കൺട്രോൾ പാനലിൽ റൂമുകൾ ഉണ്ടെന്ന് പരിശോധിക്കുക.",
  cleaning_work_plan_need_filter: "ഹെഡറിൽ കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക, പ്രകടനത്തിലോ അനലിറ്റിക്സിലോ ഒരു തീയതി ശ്രേണി (ആവശ്യമെങ്കിൽ ഷിഫ്റ്റുകൾ) സജ്ജമാക്കുക, തുടർന്ന് വീണ്ടും ശ്രമിക്കുക.",
  cleaning_work_plan_settings: "പ്ലാൻ ക്രമീകരണങ്ങൾ",
  cleaning_work_plan_desired_employees: "ആവശ്യമുള്ള ജീവനക്കാരുടെ എണ്ണം",
  cleaning_work_plan_cost_per_hour: "മണിക്കൂറിന് ചെലവ്",
  cleaning_work_plan_estimated_cost_suggested: "കണക്കാക്കിയ ചെലവ് (നിർദ്ദേശിച്ച ജോലിഭാരം)",
  cleaning_work_plan_estimated_cost_actual: "കണക്കാക്കിയ ചെലവ് (യഥാർത്ഥ ജോലിഭാരം)",
  cleaning_work_plan_hours_per_cleaner: "ഓരോ ക്ലീനറും മണിക്കൂറുകൾ",
  cleaning_work_plan_metric_title: "മെട്രിക്",
  cleaning_work_plan_metric_avg_cleaning_min: "ശരാശരി വൃത്തിയാക്കൽ സമയം (മിനിറ്റ്)",
  cleaning_work_plan_metric_total_arrivals: "ആകെ വരവ്",
  cleaning_work_plan_metric_total_cleaning_min: "മൊത്തം വൃത്തിയാക്കൽ സമയം (മിനിറ്റ്)",
  cleaning_work_plan_metric_total_cleaning_hours: "മൊത്തം വൃത്തിയാക്കൽ സമയം (മണിക്കൂറുകൾ)",
  cleaning_work_plan_metric_hours_per_cleaner_row: "ഓരോ ക്ലീനറും മണിക്കൂറുകൾ",
  cleaning_work_plan_metric_num_cleaners: "ക്ലീനർമാരുടെ എണ്ണം",
  cleaning_work_plan_summary: "സംഗ്രഹം",
  cleaning_work_plan_summary_peak_note: "സന്ദർശനങ്ങൾ, വരവുകൾ, നിർദ്ദേശിച്ച ക്ലീനുകൾ എന്നിവ അനലിറ്റിക്‌സിൻ്റെ അതേ ഷിഫ്റ്റ് റൂം സ്ഥിതിവിവരക്കണക്കുകൾ ഉപയോഗിക്കുന്നു (ആഗമന സംഗ്രഹം ഉൾപ്പെടെ). ഫിൽട്ടർ കാലയളവിലെ ഏറ്റവും ഉയർന്ന സൈറ്റ് സന്ദർശനങ്ങളുള്ള കലണ്ടർ ദിവസമാണ് അവ ഏറ്റവും തിരക്കേറിയ ദിവസത്തിനുള്ളത്. റൂം ഫിൽട്ടർ പ്രയോഗിക്കാത്ത സമയത്തെ അവലോകനം പോലെ കണക്കാക്കിയ മുറികൾ മാത്രമേ ഉൾപ്പെടുത്തിയിട്ടുള്ളൂ.",
  cleaning_work_plan_summary_filter_period: "ഫിൽട്ടർ കാലയളവ്",
  cleaning_work_plan_summary_total_visits: "മൊത്തം സന്ദർശനങ്ങൾ",
  cleaning_work_plan_summary_total_arrivals: "ആകെ വരവ്",
  cleaning_work_plan_summary_employees_in_site: "സൈറ്റിലെ ജീവനക്കാർ",
  cleaning_work_plan_summary_shift_working_hours: "ജോലി സമയം മാറ്റുക",
  cleaning_work_plan_hours_unit: "എച്ച്",
  cleaning_work_plan_rooms_table: "മുറികൾ",
  cleaning_work_plan_cleaners_table: "ശുപാർശ ചെയ്ത ക്ലീനർ വിഹിതം",
  cleaning_work_plan_search_rooms: "മുറികൾ തിരയുക",
  cleaning_work_plan_total_minutes: "ആകെ മിനിറ്റുകൾ",
  cleaning_work_plan_actual_total_minutes: "യഥാർത്ഥ ആകെ മിനിറ്റ്",
  cleaning_work_plan_actual_total_minutes_hint: "തിരക്കേറിയ ദിവസം (തിരഞ്ഞെടുത്ത പരിധിക്കുള്ളിൽ) ഷിഫ്റ്റ് റൂം സ്ഥിതിവിവരക്കണക്കുകളിൽ റെക്കോർഡുചെയ്‌ത ക്ലീനർ വരവ്, ഓരോ ക്ലീനിനും നിങ്ങളുടെ ശരാശരി മിനിറ്റുകൾ കൊണ്ട് ഗുണിച്ചാൽ.",
  cleaning_work_plan_suggested_total_minutes: "നിർദ്ദേശിച്ച ആകെ മിനിറ്റ്",
  cleaning_work_plan_suggested_room_minutes: "നിർദ്ദേശിച്ച ക്ലീനിംഗ് മിനിറ്റ്",
  cleaning_work_plan_actual_room_minutes: "യഥാർത്ഥ ക്ലീനിംഗ് മിനിറ്റ്",
  cleaning_work_plan_cleaner_suggested_minutes: "നിർദ്ദേശിച്ച മിനിറ്റ്.",
  cleaning_work_plan_cleaner_actual_minutes: "യഥാർത്ഥ മിനിറ്റ്.",
  cleaning_work_plan_period: "കാലഘട്ടം",
  cleaning_work_plan_room_count: "മുറികളുടെ എണ്ണം",
  cleaning_work_plan_cleaners_working_in_site: "സൈറ്റിൽ ജോലി ചെയ്യുന്ന ക്ലീനർമാർ (ആപ്പ് കോൺടാക്റ്റുകൾ)",
  cleaning_work_plan_cleaners_connection_table: "മുറികൾ തോറും വൃത്തിയാക്കുന്നവർ",
  cleaning_work_plan_connected_rooms_count: "മുറികൾ",
  cleaning_work_plan_connected_floor_count: "നിലകളുടെ എണ്ണം",
  cleaning_work_plan_connected_floors_list: "നിലകൾ",
  cleaning_work_plan_visitor_cleaning_entry_ratio: "സന്ദർശക / ക്ലീനിംഗ് പ്രവേശന അനുപാതം",
  cleaning_work_plan_performance_comparison_table: "പ്രകടന താരതമ്യം",
  cleaning_work_plan_performance_comparison_empty: "താരതമ്യ വരികൾ കാണുന്നതിന് ക്ലീനർ കണക്ഷൻ ഡാറ്റ ലോഡ് ചെയ്യുക.",
  cleaning_work_plan_performance_col_index: "സൂചിക",
  cleaning_work_plan_performance_existing_plan: "നിലവിലുള്ള വർക്ക് പ്ലാൻ",
  cleaning_work_plan_performance_recommended_plan: "Buzztech ശുപാർശ ചെയ്യുന്ന പ്ലാൻ",
  cleaning_work_plan_perf_number_of_employees: "ജീവനക്കാരുടെ എണ്ണം",
  cleaning_work_plan_perf_working_hours_per_employee: "ഒരു ജീവനക്കാരന് ജോലി സമയം",
  cleaning_work_plan_perf_total_working_hours: "ആകെ ജോലി സമയം",
  cleaning_work_plan_perf_total_cleaning_hours: "മൊത്തം വൃത്തിയാക്കൽ സമയം",
  cleaning_work_plan_perf_daily_cost: "പ്രതിദിന ചെലവ്",
  cleaning_work_plan_perf_total_cleaning_visits: "മൊത്തം ശുചീകരണ സന്ദർശനങ്ങൾ",
  cleaning_work_plan_perf_busiest_area_visits: "ഏറ്റവും തിരക്കേറിയ തൊഴിൽ മേഖല - സന്ദർശനങ്ങൾ",
  cleaning_work_plan_perf_cleaning_to_busiest: "ഏറ്റവും തിരക്കേറിയ പ്രദേശത്തെ ശുചീകരണ സന്ദർശനങ്ങൾ",
  cleaning_work_plan_perf_max_cleaning_ratio: "പരമാവധി ക്ലീനിംഗ് അനുപാതം",
  cleaning_work_plan_perf_least_busy_visits: "ഏറ്റവും കുറഞ്ഞ തിരക്കുള്ള തൊഴിൽ മേഖല - സന്ദർശനങ്ങൾ",
  cleaning_work_plan_perf_cleaning_to_least: "തിരക്ക് കുറഞ്ഞ സ്ഥലത്തേക്കുള്ള സന്ദർശനം വൃത്തിയാക്കൽ",
  cleaning_work_plan_perf_min_cleaning_ratio: "ഏറ്റവും കുറഞ്ഞ ക്ലീനിംഗ് അനുപാതം",
  cleaning_work_plan_ai_allocate: "AI അനുവദിക്കുക",
  cleaning_work_plan_ai_allocation_result: "AI അലോക്കേഷൻ ഫലം",
  cleaning_work_plan_ai_allocation_loading: "AI അലോക്കേഷൻ സൃഷ്ടിക്കുന്നു...",
  cleaning_work_plan_ai_allocation_error: "AI അലോക്കേഷൻ സൃഷ്ടിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  cleaning_work_plan_ai_invalid_employees: "സാധുവായ ആവശ്യമുള്ള ജീവനക്കാരുടെ എണ്ണം സജ്ജമാക്കുക.",
  cleaning_work_plan_ai_status_elapsed: "കഴിഞ്ഞത്: {s}s",
  cleaning_work_plan_ai_status_hint: "സെർവർ നിരവധി AI ഘട്ടങ്ങൾ ക്രമത്തിൽ പ്രവർത്തിപ്പിക്കുന്നു (പ്രാരംഭ പദ്ധതി, ഭൂമിശാസ്ത്രം, സന്ദർശന ബാലൻസ്, തുടർന്ന് അന്തിമ ഔട്ട്പുട്ട്). ഇതിന് ഒന്നോ രണ്ടോ മിനിറ്റ് എടുത്തേക്കാം—ദയവായി ഈ പേജ് തുറന്നിടുക.",
  cleaning_work_plan_ai_status_step_1: "ഘട്ടം 1 - റൂമിൽ നിന്നും സന്ദർശന ഡാറ്റയിൽ നിന്നും ഒരു പ്രാരംഭ അസൈൻമെൻ്റ് ഡ്രാഫ്റ്റ് ചെയ്യുന്നു...",
  cleaning_work_plan_ai_status_step_2: "ഘട്ടം 2 - ഭൂമിശാസ്ത്രം ശുദ്ധീകരിക്കൽ (സമീപത്തുള്ള നിലകളും കെട്ടിടങ്ങളും ഗ്രൂപ്പുചെയ്യൽ)...",
  cleaning_work_plan_ai_status_step_3: "ഘട്ടം 3 - ക്ലീനർമാരിലുടനീളം ദൈനംദിന സന്ദർശനങ്ങൾ സന്തുലിതമാക്കുന്നു…",
  cleaning_work_plan_ai_status_step_4: "ഘട്ടം 4 - ഘടനാപരമായ വിഹിതം സൃഷ്ടിക്കുന്നു...",
  cleaning_work_plan_ai_status_step_5: "ഘട്ടം 5 - അന്തിമ അളവുകൾ സാധൂകരിക്കുകയും കമ്പ്യൂട്ടിംഗ് ചെയ്യുകയും ചെയ്യുന്നു…",
  cleaning_work_plan_ai_cleaner_number: "ക്ലീനർ #",
  cleaning_work_plan_room_minutes: "ക്ലീനിംഗ് മിനിറ്റ്",
  cleaning_work_plan_assigned_cleaner: "നിയോഗിക്കപ്പെട്ട ക്ലീനർ",
  cleaning_work_plan_summary_cleaners: "പ്ലാനിലെ ക്ലീനർമാർ",
  cleaning_work_plan_summary_avg_minutes: "ശരാശരി മിനിറ്റ് / വൃത്തിയാക്കുക",
  cleaning_work_plan_suggested_hours: "നിർദ്ദേശിച്ച ആകെ മണിക്കൂർ",
  cleaning_work_plan_actual_hours: "യഥാർത്ഥ മൊത്തം മണിക്കൂർ",
  cleaning_work_plan_avg_suggested_min_per_cleaner: "ശരാശരി നിർദ്ദേശിച്ച മിനിറ്റ് / ക്ലീനർ",
  cleaning_work_plan_avg_actual_min_per_cleaner: "ശരാശരി യഥാർത്ഥ മിനിറ്റ് / ക്ലീനർ",
  cleaning_work_plan_guidelines_title: "ഒപ്റ്റിമൈസേഷൻ മാർഗ്ഗനിർദ്ദേശങ്ങൾ",
  cleaning_work_plan_guidelines_intro: "ഈ ടൂൾ മാനുവൽ ക്ലീനിംഗ്-പ്ലാൻ ഒപ്റ്റിമൈസേഷൻ്റെ അതേ ലക്ഷ്യങ്ങൾ പിന്തുടരുന്നു: സന്ദർശന ഡാറ്റയിൽ നിന്നുള്ള ജോലിഭാരം, ഓരോ വൃത്തിയിലുമുള്ള നിങ്ങളുടെ ശരാശരി മിനിറ്റിൽ നിന്നുള്ള സമയം, നിലകൾ ഭൂമിശാസ്ത്രപരമായി വിവേകത്തോടെ നിലനിർത്തുമ്പോൾ ജോലിയെ സന്തുലിതമാക്കുന്ന സ്റ്റാഫിംഗ്.",
  cleaning_work_plan_guidelines_b1: "ഓരോ ക്ലീനിനും സന്ദർശനങ്ങൾ (ഡിഫോൾട്ട് 50) സാധാരണ 1:50-ശൈലി നിയമവുമായി പൊരുത്തപ്പെടുന്നു: ഓരോ മുറിയിലും നിർദ്ദേശിച്ച എൻട്രികൾ ≈ സന്ദർശനങ്ങൾ ÷ ഓരോ ക്ലീനിനും സന്ദർശനങ്ങൾ (റൗണ്ട് അപ്പ്). നിങ്ങൾ തിരഞ്ഞെടുത്ത തീയതി പരിധിക്കുള്ളിൽ ഏറ്റവും തിരക്കുള്ള ദിവസത്തിൽ നിന്നാണ് (ഏറ്റവും ഉയർന്ന സൈറ്റ് സന്ദർശനങ്ങൾ) സന്ദർശനങ്ങളും വരവുകളും എടുക്കുന്നത്, അതിനാൽ പ്ലാൻ ഒരു പീക്ക്-ലോഡ് ദിവസവുമായി പൊരുത്തപ്പെടുന്നു.",
  cleaning_work_plan_guidelines_b2: "നിങ്ങൾ ഒരു ക്ലീനർ എണ്ണം സജ്ജീകരിക്കുമ്പോൾ, ഓരോ കെട്ടിട നിലയും ഒരു ഗ്രൂപ്പാണ്. കെട്ടിടവും ഫ്ലോർ നമ്പറും അനുസരിച്ചാണ് നിലകൾ ക്രമീകരിച്ചിരിക്കുന്നത്, തുടർന്ന് ക്ലീനറുകളിലുടനീളം തുടർച്ചയായ ബ്ലോക്കുകളായി വിഭജിക്കപ്പെടുന്നു, അതിനാൽ നിർദ്ദേശിച്ച ക്ലീനുകൾ (സൂചിപ്പിക്കുന്ന ജോലി) സന്തുലിതമാക്കും, അതേസമയം അടുത്തുള്ള നിലകൾ ഒരേ ക്ലീനറിൽ തന്നെ തുടരും.",
  cleaning_work_plan_guidelines_b3: "ഒരേ കെട്ടിട നിലയിലുള്ള എല്ലാ ശുചിമുറികളും ഒരേ ക്ലീനറിലാണ് താമസിക്കുന്നത്, അതിനാൽ ആ നിലയിലെ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും മുറികൾ വ്യത്യസ്ത ക്ലീനർമാർക്കിടയിൽ വിഭജിക്കപ്പെടുന്നില്ല (അവ നിയന്ത്രണ പാനലിൽ ഒരേ നിലയുടെ മൂല്യം പങ്കിടുന്നിടത്തോളം).",
  cleaning_work_plan_guidelines_b4: "ഓരോ ക്ലീൻ ഡ്രൈവിനും നിർദ്ദേശിച്ചിട്ടുള്ള ശരാശരി മിനിറ്റുകളും ഒരു ക്ലീനർക്കുള്ള യഥാർത്ഥ ആകെ മിനിറ്റുകളും മണിക്കൂറുകളും ശരാശരി മിനിറ്റുകളും. യഥാർത്ഥ മൊത്തത്തിൽ റെക്കോർഡ് ചെയ്‌ത ക്ലീനർ വരവ് × നിങ്ങളുടെ ശരാശരി ഉപയോഗിക്കുന്നു; നിർദ്ദേശിച്ച ആകെത്തുക, നിങ്ങളുടെ ശരാശരി × സൂചിപ്പിക്കപ്പെട്ട ക്ലീനുകൾ ഉപയോഗിക്കുക.",
  cleaning_work_plan_guidelines_b5: "നിങ്ങൾക്ക് മറ്റെവിടെയെങ്കിലും അലോക്കേഷൻ പരിഷ്കരിക്കണമെങ്കിൽ എക്സ്പോർട്ട് CSV ഉപയോഗിക്കുക (ഉദാഹരണത്തിന് സന്ദർശന ബാലൻസ് കൂടുതൽ കർശനമാക്കുന്നതിന്).",
  cleaners_number: "ക്ലീനർ നമ്പർ",
  floors_num: "നിലകളുടെ നമ്പർ",
  avg_daily_cleaners_required: "ശരാശരി പ്രതിദിന ക്ലീനർ ആവശ്യമാണ്",
  app_pages: "ആപ്പ് പേജുകൾ",
  buzzzTime: "Buzz സമയം",
  missions: "ദൗത്യങ്ങൾ",
  send_emails: "ഇമെയിലുകൾ അയക്കുക",
  enter: "നൽകുക",
  account: "അക്കൗണ്ട്",
  privacy: "സ്വകാര്യത",
  personal_settings: "വ്യക്തിഗത ക്രമീകരണങ്ങൾ",
  personal_settings_lead: "നിങ്ങളുടെ ഭാഷയും സ്വകാര്യത മുൻഗണനകളും നിയന്ത്രിക്കുക.",
  personal_settings_read_only: "ഈ വിശദാംശങ്ങൾ നിയന്ത്രിക്കുന്നത് നിങ്ങളുടെ അഡ്‌മിനിസ്‌ട്രേറ്ററാണ്. എന്തെങ്കിലും അപ്ഡേറ്റ് ചെയ്യേണ്ടതുണ്ടെങ്കിൽ അവരെ ബന്ധപ്പെടുക.",
  change_password: "പാസ്‌വേഡ് മാറ്റുക",
  change_password_hint: "പാസ്‌വേഡ് മാറ്റുന്നത് നിങ്ങളുടെ മറ്റ് ഉപകരണങ്ങളിൽ നിന്ന് സൈൻ ഔട്ട് ചെയ്യും.",
  current_password: "നിലവിലെ പാസ്‌വേഡ്",
  new_password: "പുതിയ പാസ്‌വേഡ്",
  confirm_new_password: "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
  password_min_length: "പാസ്‌വേഡിന് കുറഞ്ഞത് 8 പ്രതീകങ്ങൾ ഉണ്ടായിരിക്കണം",
  passwords_do_not_match: "പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നില്ല",
  new_password_same_as_current: "പുതിയ പാസ്‌വേഡ് നിലവിലെ പാസ്‌വേഡിൽ നിന്ന് വ്യത്യസ്തമായിരിക്കണം",
  current_password_incorrect: "നിലവിലെ പാസ്‌വേഡ് തെറ്റാണ്",
  current_password_required: "നിലവിലെ പാസ്‌വേഡ് ആവശ്യമാണ്",
  password_changed_successfully: "പാസ്‌വേഡ് വിജയകരമായി മാറ്റി",
  change_password_failed: "പാസ്‌വേഡ് മാറ്റാൻ കഴിഞ്ഞില്ല",
  forgot_password: "Forgot password?",
  forgot_password_title: "Forgot password",
  forgot_password_hint: "Enter the email address for your panel account and we will send you a reset link if it exists.",
  forgot_password_sent: "If an account exists for that email, a reset link has been sent. Check your inbox.",
  forgot_password_invalid_email: "Please enter a valid email address",
  forgot_password_failed: "Could not send reset email. Please try again.",
  send_reset_link: "Send reset link",
  back_to_login: "Back to login",
  reset_password: "Reset password",
  reset_password_hint: "Choose a new password for your account.",
  reset_password_missing_token: "This reset link is incomplete. Request a new one from the login page.",
  reset_password_invalid_token: "This reset link is invalid or has expired. Request a new one.",
  reset_password_failed: "Could not reset password",
  password_reset_successfully: "Password reset successfully. You can log in with your new password.",
  login_invalid_credentials: "ഉപയോക്തൃനാമം അല്ലെങ്കിൽ പാസ്‌വേഡ് തെറ്റാണ്",
  login_credentials_required: "നിങ്ങളുടെ ഉപയോക്തൃനാമമോ ഇമെയിലോ പാസ്‌വേഡും നൽകുക",
  login_network_error: "സെർവറിലേക്ക് ബന്ധപ്പെടാൻ കഴിയുന്നില്ല. കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക",
  login_failed: "സൈൻ ഇൻ ചെയ്യാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക",
  login_too_many_attempts: "വളരെയധികം സൈൻ-ഇൻ ശ്രമങ്ങൾ. 15 മിനിറ്റ് കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക.",
  forgot_password_too_many: "പാസ്‌വേഡ് പുനഃസജ്ജീകരണ അഭ്യർത്ഥനകൾ വളരെയധികം. ഒരു മണിക്കൂർ കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക.",
  reset_password_too_many: "പാസ്‌വേഡ് പുനഃസജ്ജീകരണ ശ്രമങ്ങൾ വളരെയധികം. ഒരു മണിക്കൂർ കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക.",
  change_password_too_many: "പാസ്‌വേഡ് മാറ്റാനുള്ള ശ്രമങ്ങൾ വളരെയധികം. 15 മിനിറ്റ് കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക.",

  personal_settings_language_hint: "ഈ ബ്രൗസറിനായുള്ള മുഴുവൻ പോർട്ടലിനും ബാധകമാണ്.",
  personal_settings_privacy_hint: "ബാധകമായ സ്വകാര്യതാ നിയമങ്ങൾക്ക് കീഴിൽ നിങ്ങളുടെ സ്വകാര്യ ഡാറ്റ മായ്ക്കാൻ അഭ്യർത്ഥിക്കുക.",
  personal_settings_export_hint: "നിങ്ങളുടെ പോർട്ടൽ പ്രൊഫൈൽ, നിങ്ങൾക്ക് ആക്‌സസ് ചെയ്യാനാകുന്ന സൈറ്റുകൾ, ലിങ്ക് ചെയ്‌ത മൊബൈൽ ആപ്പ് പ്രൊഫൈൽ (നിങ്ങളുടെ ഫോൺ പൊരുത്തപ്പെടുമ്പോൾ) എന്നിവയെക്കുറിച്ച് ഞങ്ങൾ കൈവശം വച്ചിരിക്കുന്ന വ്യക്തിഗത ഡാറ്റയുടെ വായിക്കാനാകുന്ന JSON പകർപ്പ് ഡൗൺലോഡ് ചെയ്യുക. പ്രതിദിനം പരിമിതമായ കയറ്റുമതി.",
  "Download my data": "എൻ്റെ ഡാറ്റ ഡൗൺലോഡ് ചെയ്യുക",
  personal_settings_role: "പങ്ക്",
  "Request deletion of my data": "എൻ്റെ ഡാറ്റ ഇല്ലാതാക്കാൻ അഭ്യർത്ഥിക്കുക",
  "Request deletion of my data - confirm": "എൻ്റെ ഡാറ്റ ഇല്ലാതാക്കാൻ അഭ്യർത്ഥിക്കണോ? അഡ്മിനിസ്ട്രേറ്റർക്ക് ഒരു ഇമെയിൽ അയയ്ക്കും. നിങ്ങളുടെ അഭ്യർത്ഥന ഞങ്ങൾ 30 ദിവസത്തിനുള്ളിൽ പ്രോസസ്സ് ചെയ്യും.",
  "Request deletion of my data - success": "അഭ്യർത്ഥന അയച്ചു. ഞങ്ങൾ ഇത് 30 ദിവസത്തിനുള്ളിൽ പ്രോസസ്സ് ചെയ്യും.",
  "Request deletion of my data - error": "അഭ്യർത്ഥന സമർപ്പിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ privacy@buzzztech.com എന്ന ഇമെയിൽ വിലാസത്തിലേക്ക് അയയ്ക്കുക.",
  metrics: "മെട്രിക്സ്",
  select_three_metrics: "താരതമ്യം ചെയ്യാൻ 3 മെട്രിക്കുകൾ വരെ തിരഞ്ഞെടുക്കുക",
  select_four_metrics: "താരതമ്യം ചെയ്യാൻ 4 മെട്രിക്കുകൾ വരെ തിരഞ്ഞെടുക്കുക",
  legend: "ഇതിഹാസം",
  more_details: "കൂടുതൽ വിശദാംശങ്ങൾ",
  performance_overview: "പ്രകടന അവലോകനം",
  loading_chart: "ചാർട്ട് ലോഡ് ചെയ്യുന്നു",
  retry: "വീണ്ടും ശ്രമിക്കുക",
  performance_trending_upward: "പ്രകടനം മുകളിലേക്ക് നീങ്ങുന്നു",
  high_complaint_ratio: "ഉയർന്ന പരാതി അനുപാതം",
  click_bars_for_details: "ദൈനംദിന അനലിറ്റിക്‌സിലേക്ക് തുളച്ചുകയറാൻ ബാറുകളിൽ ക്ലിക്ക് ചെയ്യുക",
  refresh: "പുതുക്കുക",
  table: "മേശ",
  cards: "കാർഡുകൾ",
  no_recent_arrivals: "അടുത്തിടെ വന്നവരൊന്നുമില്ല",
  feedback_charts: "ഫീഡ്ബാക്ക് ചാർട്ടുകൾ",
  general_overview: "പൊതുവായ അവലോകനം",
  cleaning_complaints_breakdown: "ക്ലീനിംഗ് പരാതികളുടെ തകർച്ച",
  maintenance_complaints_breakdown: "മെയിൻ്റനൻസ് പരാതികളുടെ തകർച്ച",
  refresh_failed: "പുതുക്കൽ പരാജയപ്പെട്ടു",
  data_exported_successfully: "ഡാറ്റ വിജയകരമായി കയറ്റുമതി ചെയ്തു",
  data_export_failed: "ഡാറ്റ കയറ്റുമതി പരാജയപ്പെട്ടു",
  drill_down_unavailable: "ദിവസേനയുള്ള കാഴ്‌ചയ്‌ക്കായി മാത്രം ഡ്രിൽ-ഡൗൺ ലഭ്യമാണ്",
  sort_by: "ഇങ്ങനെ അടുക്കുക",
  no_active_shift: "സജീവമായ ഷിഫ്റ്റ് ഇല്ല",
  check_site_and_shift: "ഒരു സൈറ്റ് തിരഞ്ഞെടുത്തിട്ടുണ്ടോയെന്നും ഒരു സജീവ ഷിഫ്റ്റ് ഉണ്ടോ എന്നും പരിശോധിക്കുക",
  please_add_shift_first: "ദയവായി ആദ്യം ഷിഫ്റ്റ് ചേർക്കുക",
  cleandex_no_data_message: "ക്ലീൻഡെക്സ് ഡാറ്റയൊന്നും നിലവിൽ ലഭ്യമല്ല",
  task_no_data_message: "ടാസ്‌ക് ഡാറ്റകളൊന്നും നിലവിൽ ലഭ്യമല്ല",
  navigation: "നാവിഗേഷൻ",
  network_information: "നെറ്റ്‌വർക്ക് വിവരങ്ങൾ",
  target_effectiveness: "ടാർഗെറ്റ് ഫലപ്രാപ്തി",
  cleandex_call_cleaner: "ക്ലീൻഡെക്സ് കോൾ ക്ലീനർ",
  top_complaint: "പ്രധാന പരാതി",
  no_complaints: "പരാതിയില്ല",
  official_start_date: "ഔദ്യോഗിക ആരംഭ തീയതി",
  note_text: "കുറിപ്പ് വാചകം",
  add_note: "കുറിപ്പ് ചേർക്കുക",
  general_note: "പൊതു കുറിപ്പ്",
  general_note_short: "ജനറൽ",
  battery_short: "ബാറ്ററി",
  panel_short: "പാനൽ",
  technician_short: "ടെക്നീഷ്യൻ",
  battery_replacement: "ബാറ്ററി മാറ്റിസ്ഥാപിക്കൽ",
  device_maintenance: "ഉപകരണ പരിപാലനം",
  maintenance_type: "മെയിൻ്റനൻസ് തരം",
  panel_change: "പാനൽ മാറ്റം",
  technician_check: "ടെക്നീഷ്യൻ പരിശോധന",
  enter_note_details: "കുറിപ്പിൻ്റെ വിശദാംശങ്ങൾ നൽകുക",
  replacement_date: "മാറ്റിസ്ഥാപിക്കുന്ന തീയതി",
  replaced_by_name: "പേര് മാറ്റി",
  replacement_note: "മാറ്റിസ്ഥാപിക്കൽ കുറിപ്പ്",
  enter_replacement_details: "മാറ്റിസ്ഥാപിക്കാനുള്ള വിശദാംശങ്ങൾ നൽകുക",
  replacement_history: "മാറ്റിസ്ഥാപിക്കൽ ചരിത്രം",
  loading_history: "ചരിത്രം ലോഡുചെയ്യുന്നു",
  no_replacement_history: "മാറ്റിസ്ഥാപിക്കുന്നതിനുള്ള ചരിത്രമൊന്നും ലഭ്യമല്ല",
  enter_technician_name: "ടെക്നീഷ്യൻ്റെ പേര് നൽകുക",
  prefilled_from_account: "നിങ്ങളുടെ അക്കൗണ്ടിൽ നിന്ന് മുൻകൂട്ടി പൂരിപ്പിച്ചത് - നിങ്ങൾക്ക് എഡിറ്റ് ചെയ്യാം",
  user_information: "ഉപയോക്തൃ വിവരങ്ങൾ",
  enter_change_details: "മാറ്റം വിശദാംശങ്ങൾ നൽകുക",
  panel_change_history: "പാനൽ മാറ്റ ചരിത്രം",
  check_date: "തീയതി പരിശോധിക്കുക",
  checked_by_name: "പേര് പരിശോധിച്ചു",
  enter_check_details: "ചെക്ക് വിശദാംശങ്ങൾ നൽകുക",
  technician_check_history: "ടെക്നീഷ്യൻ ചരിത്രം പരിശോധിക്കുക",
  no_technician_check_history: "ടെക്നീഷ്യൻ പരിശോധന ചരിത്രം ലഭ്യമല്ല",
  change_date: "തീയതി മാറ്റുക",
  changed_by_name: "പേര് മാറ്റി",
  change_note: "കുറിപ്പ് മാറ്റുക",
  check_note: "കുറിപ്പ് പരിശോധിക്കുക",
  replaced_by: "മാറ്റിസ്ഥാപിച്ചു",
  no_data_entered: "ഡാറ്റ ഒന്നും നൽകിയിട്ടില്ല",
  no_panel_change_history: "പാനൽ മാറ്റ ചരിത്രമൊന്നും ലഭ്യമല്ല",
  invalid_username: "അസാധുവായ ഉപയോക്തൃനാമം",
  invalid_phone: "അസാധുവായ ഫോൺ നമ്പർ",
  username_must_be_at_least_5_characters: "ഉപയോക്തൃനാമത്തിൽ കുറഞ്ഞത് 5 പ്രതീകങ്ങൾ ഉണ്ടായിരിക്കണം",
  data_loading_please_wait: "ഡാറ്റ നിലവിൽ ലോഡ് ചെയ്യുന്നു. കാത്തിരിക്കൂ...",
  dates_not_changed: "തീയതികൾ മാറിയിട്ടില്ല. റീലോഡ് ആവശ്യമില്ല.",
  date_outside_stats_range: "തിരഞ്ഞെടുത്ത തീയതികൾ ലഭ്യമായ സ്റ്റാറ്റ് പരിധിക്ക് പുറത്താണ്.",

  date_range_invalid: "\"ഇതുവരെ\" തീയതി \"മുതൽ\" തീയതിയിലോ ശേഷമോ ആയിരിക്കണം.",
  filter_help_text: "ഫിൽട്ടർ നിയമങ്ങൾ: ഫ്ലോർ ഫിൽട്ടർ പ്രവർത്തനക്ഷമമാക്കാൻ ആദ്യം ബിൽഡിംഗ് തിരഞ്ഞെടുക്കുക. മിക്ക ഫിൽട്ടറുകളും ഒന്നിലധികം തിരഞ്ഞെടുപ്പുകളെ പിന്തുണയ്ക്കുന്നു.",
  select_building_first: "ഫ്ലോർ ഫിൽട്ടർ പ്രവർത്തനക്ഷമമാക്കാൻ ആദ്യം ഒരു കെട്ടിടം തിരഞ്ഞെടുക്കുക",
  cannot_select_gender_with_rooms: "മുറികൾ തിരഞ്ഞെടുക്കുമ്പോൾ മുറിയുടെ തരം തിരഞ്ഞെടുക്കാനാകില്ല",
  cannot_select_gender_with_rooms_tooltip: "മുറികൾ തിരഞ്ഞെടുക്കുമ്പോൾ മുറിയുടെ തരം ഫിൽട്ടർ ഉപയോഗിക്കാൻ കഴിയില്ല. ആദ്യം മുറികളുടെ തിരഞ്ഞെടുപ്പ് മായ്‌ക്കുക.",
  cannot_select_building_with_rooms: "മുറികൾ തിരഞ്ഞെടുക്കുമ്പോൾ കെട്ടിടം തിരഞ്ഞെടുക്കാനാകില്ല",
  cannot_select_building_with_rooms_tooltip: "മുറികൾ തിരഞ്ഞെടുക്കുമ്പോൾ ബിൽഡിംഗ് ഫിൽട്ടർ ഉപയോഗിക്കാൻ കഴിയില്ല. ആദ്യം മുറികളുടെ തിരഞ്ഞെടുപ്പ് മായ്‌ക്കുക.",
  multi_select_hint: "നിങ്ങൾക്ക് ഒന്നിലധികം ഓപ്ഷനുകൾ തിരഞ്ഞെടുക്കാം",
  filter_applied: "ഫിൽട്ടർ വിജയകരമായി പ്രയോഗിച്ചു",
  no_filters_selected: "ഫിൽട്ടറുകളൊന്നും തിരഞ്ഞെടുത്തിട്ടില്ല. കുറഞ്ഞത് ഒരു ഫിൽട്ടർ ഓപ്‌ഷനെങ്കിലും തിരഞ്ഞെടുക്കുക.",
  filters: "ഫിൽട്ടറുകൾ",
  location: "സ്ഥാനം",
  attributes: "ആട്രിബ്യൂട്ടുകൾ",
  applying: "അപേക്ഷിക്കുന്നു...",
  active_filters: "സജീവ ഫിൽട്ടറുകൾ",
  viewing_room: "വ്യൂവിംഗ് റൂം",
  multiple: "ഒന്നിലധികം",
  close: "അടയ്ക്കുക",
  save_replacement: "മാറ്റിസ്ഥാപിക്കൽ സംരക്ഷിക്കുക",
  save_change: "മാറ്റം സംരക്ഷിക്കുക",
  save_check: "ചെക്ക് സംരക്ഷിക്കുക",
  failed_to_load_maintenance_history: "മെയിൻ്റനൻസ് ഹിസ്റ്ററി ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  "Battery replacement recorded successfully": "ബാറ്ററി മാറ്റിസ്ഥാപിക്കൽ വിജയകരമായി രേഖപ്പെടുത്തി",
  "Panel change recorded successfully": "പാനൽ മാറ്റം വിജയകരമായി രേഖപ്പെടുത്തി",
  "Technician check recorded successfully": "ടെക്നീഷ്യൻ പരിശോധന വിജയകരമായി രേഖപ്പെടുത്തി",
  no_network_data_available: "നെറ്റ്‌വർക്ക് ഡാറ്റ ലഭ്യമല്ല",
  configuration: "കോൺഫിഗറേഷൻ",
  contact_settings: "കോൺടാക്റ്റ് & ക്രമീകരണങ്ങൾ",
  notifications: "അറിയിപ്പുകൾ",
  features: "ഫീച്ചറുകൾ",
  chat_ask_buzzz: "Buzzz-നോട് ചോദിക്കുക",
  chat_hide: "മറയ്ക്കുക",
  chat_buzzz_assistant: "Buzzz അസിസ്റ്റൻ്റ്",
  chat_export: "കയറ്റുമതി",
  chat_clear: "ക്ലിയർ",
  chat_unpin: "അൺപിൻ ചെയ്യുക",
  chat_pin: "പിൻ",
  chat_retry: "വീണ്ടും ശ്രമിക്കുക",
  chat_copy: "പകർത്തുക",
  chat_copied: "പകർത്തി!",
  chat_share: "പങ്കിടുക",
  chat_suggestions: "നിർദ്ദേശങ്ങൾ",
  chat_input_placeholder: "നിങ്ങളുടെ സ്ഥിതിവിവരക്കണക്കുകൾ ചോദിക്കൂ...",
  chat_stop: "നിർത്തുക",
  chat_error: "എന്തോ കുഴപ്പം സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  chat_placeholder: "നിങ്ങളുടെ ക്ലീനിംഗ് സ്ഥിതിവിവരക്കണക്കുകളെ കുറിച്ച് എന്നോട് ചോദിക്കൂ...",
  chat_placeholder_context: "{scope} നെ കുറിച്ച് ചോദിക്കൂ...",
  chat_chip_briefing: "രാവിലെ ബ്രീഫിംഗ്",
  chat_chip_live_status: "തത്സമയ നില",
  chat_chip_staff_status: "സ്റ്റാഫ് നില",
  chat_chip_summary: "സംഗ്രഹം",
  chat_chip_cleaning_priority: "ശുചീകരണത്തിന് മുൻഗണന",
  chat_chip_worst_rooms: "ഏറ്റവും മോശം മുറികൾ",
  chat_chip_focus: "ഫോക്കസ് ഏരിയകൾ",
  chat_chip_compare_periods: "കാലഘട്ടങ്ങൾ താരതമ്യം ചെയ്യുക",
  chat_chip_sla_issues: "SLA പ്രശ്നങ്ങൾ",
  chat_chip_shift_stats: "സ്ഥിതിവിവരക്കണക്കുകൾ മാറ്റുക",
  chat_chip_complaint_types: "പരാതി തരങ്ങൾ",
  chat_chip_busiest_hours: "ഏറ്റവും തിരക്കേറിയ സമയം",
  chat_chip_worst_days: "ഏറ്റവും മോശം ദിവസങ്ങൾ",
  chat_chip_improving: "മുറികൾ മെച്ചപ്പെടുത്തുന്നു",
  chat_chip_best_rooms: "മികച്ച മുറികൾ",
  chat_chip_help: "സഹായം",
  chat_chip_why_drilldown: "എന്തുകൊണ്ട്? താഴേക്ക് തുരത്തുക",
  chat_deep_analysis: "ആഴത്തിലുള്ള വിശകലനം (പതുക്കെ)",
  chat_greeting: "ഹായ് {name}, എനിക്ക് എങ്ങനെ സഹായിക്കാനാകും?",
  chat_status_online: "ഓൺലൈൻ",
  chat_status_thinking: "ചിന്തിക്കുന്നു...",
  chat_tool_overview: "ചുരുക്കവിവരണം വലിക്കുന്നു...",
  chat_tool_rooms: "മുറികൾ പരിശോധിക്കുന്നു...",
  chat_tool_hours: "സമയം വിശകലനം ചെയ്യുന്നു...",
  chat_tool_days: "പ്രതിദിന ഡാറ്റ അവലോകനം ചെയ്യുന്നു...",
  chat_tool_live: "തത്സമയ നില പരിശോധിക്കുന്നു...",
  chat_tool_priority: "മുൻഗണനകൾ പരിശോധിക്കുന്നു...",
  chat_tool_room_detail: "മുറിയുടെ വിശദാംശങ്ങൾ നേടുന്നു...",
  chat_tool_shifts: "ഷിഫ്റ്റുകൾ നോക്കുന്നു...",
  chat_tool_staff: "ജീവനക്കാരെ പരിശോധിക്കുന്നു...",
  chat_tool_devices: "ഉപകരണങ്ങൾ പരിശോധിക്കുന്നു...",
  chat_feedback_good: "നല്ല പ്രതികരണം",
  chat_feedback_bad: "മോശം പ്രതികരണം",
  chat_feedback_thanks: "നിങ്ങളുടെ ഫീഡ്‌ബാക്കിന് നന്ദി!",
  chat_feedback_wrong_data: "തെറ്റായ ഡാറ്റ",
  chat_feedback_didnt_understand: "മനസ്സിലായില്ല",
  chat_feedback_missing_info: "വിവരങ്ങൾ വിട്ടുപോയിരിക്കുന്നു",
  chat_feedback_bad_format: "മോശം ഫോർമാറ്റിംഗ്",
  chat_feedback_hallucinated: "നിർമ്മിച്ച നമ്പറുകൾ",
  chat_feedback_submit: "സമർപ്പിക്കുക",
  malayalam: "മലയാളം",
  monthMap: {
    1: 'ജന',
    2: 'ഫെബ',
    3: 'മാർ',
    4: 'ഏപ്ര',
    5: 'മേയ',
    6: 'ജൂൺ',
    7: 'ജൂല',
    8: 'ഓഗ',
    9: 'സെപ്',
    10: 'ഒക്ട',
    11: 'നവ',
    12: 'ഡിസ',
  },
  weekMap: {
    1: 'ഞായർ',
    2: 'തിങ്കൾ',
    3: 'ചൊവ്വ',
    4: 'ബുധൻ',
    5: 'വ്യാഴം',
    6: 'വെള്ളി',
    7: 'ശനി',
  },

  "español": "എസ്പാനോൾ",
  "français": "ഫ്രാൻസ്",
  "русский": "റുസ്കി",
  "አማርኛ": "አማርኛ",
  "português": "പോർച്ചുഗീസ്",
  "cleaner-activity": "ക്ലീനർ പ്രവർത്തനം",
  "device-actions": "ഉപകരണ പ്രവർത്തനങ്ങൾ",
  "pad-presence-testing": "പാഡ് സാന്നിധ്യം പരിശോധന",
  "real-time-cleaning": "തൽസമയം - ശുചീകരണം",
  "real-time-maintenance": "തൽസമയം - അറ്റകുറ്റപ്പണി",
  "no_real_time_tabs_permitted": "തൽസമയ ടാബുകൾ കാണാൻ നിങ്ങൾക്ക് അനുമതിയില്ല",
  "cleaner_activity": "ക്ലീനർ പ്രവർത്തനം",
  "pad_presence_testing": "പാഡ് സാന്നിധ്യം പരിശോധന",
  "pad_presence_testing_subtitle": "തിരഞ്ഞെടുത്ത സൈറ്റിലെ പാഡ് സാന്നിധ്യം തത്സമയ ട്രാക്കിംഗ്",
  "pad_presence_timeline": "തത്സമയം · സമയം",
  "pad_presence_sessions": "സാന്നിധ്യം",
  "pad_presence_offline_presses": "ഓഫ്‌ലൈൻ · ഫോൺ",
  "pad_presence_select_site_hint": "ഇന്നത്തെ പാഡ് സാന്നിധ്യം കാണുന്നതിന് തലക്കെട്ടിൽ ഒരു കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക.",
  "pad_presence_no_events": "അടുത്തിടെ വന്നവരൊന്നുമില്ല",
  "pad_presence_open": "തുറന്നിരിക്കുന്നു",
  "pad_presence_exit_phone": "ഫോൺ പുറത്തുകടക്കുക",
  "pad_presence_exit_auto": "ഓട്ടോ പുറത്തുകടക്കുക",
  "pad_presence_exit_stale": "അവസാനത്തേത് പുറത്തുകടക്കുക",
  "pad_presence_enter": "പ്രവേശനം",
  "pad_presence_exit": "പുറത്തുകടക്കുക",
  "pad_presence_offline": "ഓഫ്‌ലൈൻ",
  "pad_presence_faulty": "നിഷ്ക്രിയം",
  "pad_presence_employee": "ജീവനക്കാർ",
  "pad_presence_room": "മുറി",
  "pad_presence_time_from": "മുതൽ",
  "pad_presence_last_updated": "അപ്ഡേറ്റ് ചെയ്തു",
  "pad_presence_duration": "ദൈർഘ്യം",
  "pad_presence_exit_type": "പുറത്തുകടക്കുക · തരം",
  "pad_presence_button": "ബട്ടൺ",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "എണ്ണുക",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "എല്ലാ ജീവനക്കാർ",
  "pad_presence_all_rooms": "എല്ലാ മുറികൾ",
  "pad_presence_load_error": "ഉപകരണ കോഡ് പരിശോധിക്കാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക.",
  "pad_presence_in_room_now": "തുറക്കുക · മുറി · ഇപ്പോള്",
  "pad_presence_in_room": "ൽ",
  "pad_presence_since": "മുതൽ",
  "pad_presence_just_now": "ഇപ്പോള്",
  "pad_presence_pad": "പാഡ്",
  "pad_presence_phone": "ഫോൺ",
  "pad_presence_all_phones": "എല്ലാ ഫോൺ",
  "pad_presence_window": "കാണിക്കുക",
  "pad_presence_window_hour": "അവസാനത്തേത് മണിക്കൂർ",
  "pad_presence_window_today": "ഇന്ന്",
  "pad_presence_window_month": "അവസാനത്തേത് മാസം",
  "pad_presence_pads": "പാഡ് · സൈറ്റ്",
  "pad_presence_no_pads": "അസൈൻ ചെയ്യാത്ത മുറികൾ (പാഡ്)",
  "pad_presence_last_enter": "അവസാന ക്ലീനർ പ്രവേശനം",
  "pad_presence_last_offline": "അവസാനത്തേത് ഓഫ്‌ലൈൻ",
  "pad_presence_auto_exit_leave": "പുറത്തുകടക്കുക → ഓട്ടോ പുറത്തുകടക്കുക",
  "pad_presence_auto_exit_earliest": "പ്രവേശനം:",
  "pad_presence_auto_exit_passed": "ഇപ്പോഴും തുറന്നിരിക്കുന്നു = പാഡ്. അല്ലെങ്കിൽ പുറത്തുകടക്കുക 5മിനി 45. ദയവായി കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക",
  "cleaner_activity_live_footer": "തത്സമയം ഡാറ്റ അപ്‌ഡേറ്റുകൾ",
  "ca_empty_select_site_hint": "ഇന്നത്തെ ക്ലീനർ ആക്റ്റിവിറ്റി കാണുന്നതിന് തലക്കെട്ടിൽ ഒരു കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക.",
  "ca_empty_no_cleaners_hint": "ഈ സൈറ്റിലേക്കും നിലവിലെ ഷിഫ്റ്റിലേക്കും ക്ലീനർമാരെ നിയമിച്ചിട്ടില്ല. ഉപയോക്താക്കളിൽ സജീവ സൈറ്റുകളും ഷിഫ്റ്റുകളും നിയോഗിക്കുക.",
  "ca_empty_access_denied": "പ്രവേശനം തടയപ്പെട്ടു",
  "ca_empty_access_denied_hint": "ഈ സൈറ്റിനായുള്ള ക്ലീനർ ആക്റ്റിവിറ്റി കാണുന്നതിന് നിങ്ങൾക്ക് അനുമതിയില്ല.",
  "ca_empty_load_error_hint": "ക്ലീനർ പ്രവർത്തനം ലോഡ് ചെയ്യാനായില്ല. വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ പ്രശ്നം തുടരുകയാണെങ്കിൽ പിന്തുണയുമായി ബന്ധപ്പെടുക.",
  "ca_empty_no_filter_match": "ഈ ഫിൽട്ടറുകളുമായി പൊരുത്തപ്പെടുന്ന ഒരു ക്ലീനറും",
  "ca_empty_no_filter_match_hint": "ഫിൽട്ടറുകൾ മായ്‌ക്കാനോ മറ്റൊരു ക്ലീനർ, ജോലിസ്ഥലം അല്ലെങ്കിൽ മുറി തിരഞ്ഞെടുക്കാനോ ശ്രമിക്കുക.",
  "ca_timeline_all_cleaners": "ഇന്നത്തെ പ്രവർത്തനം - എല്ലാ ക്ലീനർമാരും",
  "ca_legend_work": "സജീവമാണ്",
  "ca_clock_sessions_more": "കൂടുതൽ",
  "ca_clock_sessions_less": "കുറവ് കാണിക്കുക",
  "ca_sort_label": "അടുക്കുക",
  "ca_sort_needs_attention": "ശ്രദ്ധ വേണം",
  "ca_sort_best_avg_response": "മികച്ച ശരാശരി പ്രതികരണം",
  "ca_sort_worst_avg_response": "ഏറ്റവും മോശം ശരാശരി പ്രതികരണം",
  "ca_sort_most_sla_breaches": "മിക്ക SLA ലംഘനങ്ങളും",
  "ca_sort_most_open_complaints": "ഏറ്റവും തുറന്ന പരാതികൾ",
  "ca_sort_most_work_time": "ഏറ്റവും കൂടുതൽ ജോലി സമയം",
  "ca_sort_least_work_time": "ഏറ്റവും കുറഞ്ഞ ജോലി സമയം",
  "ca_stat_avg_short": "ശരാശരി",
  "ca_stat_open_short": "തുറക്കുക",
  "ca_stat_breach_short": "ലംഘനം",
  "ca_stat_work_short": "ജോലി",
  "ca_assigned_room_avg_hint": "അസൈൻ ചെയ്‌ത മുറികൾക്ക് ഇന്നത്തെ ശരാശരി പ്രതികരണം",
  "ca_transit_tooltip": "ജോലികൾക്കിടയിലുള്ള യാത്രാ സമയം",
  "ca_transit_live_tooltip": "അവസാന ടാസ്ക് അവസാനിച്ചതിന് ശേഷമുള്ള സമയം",
  "ca_legend_visits": "കോളുകൾക്കിടയിലുള്ള സന്ദർശനങ്ങൾ",
  "ca_visits_between_sla": "മുൻ കോൾ അവസാനിച്ചതിന് ശേഷമുള്ള സന്ദർശനങ്ങൾ",
  "ca_apply": "പ്രയോഗിക്കുക",
  "ca_visits_since": "മുതൽ",
  "ca_deferred_tip_title": "മാറ്റിവച്ച പരാതി",
  "ca_deferred_tip_resolved": "പരിഹരിച്ചു",
  "ca_deferred_tip_desc_open": "ഇപ്പോഴും തുറന്നിരിക്കുന്നു - ക്ലീനർ ഇതിന് പകരം മറ്റ് മുറികൾ ആദ്യം സർവീസ് ചെയ്തു.",
  "ca_deferred_tip_desc_closed": "ക്ലീനർ ആദ്യം മറ്റ് മുറികളിൽ സർവീസ് നടത്തിയപ്പോൾ ഈ പരാതി തുറന്നുകിടന്നു.",
  "ca_deferred_tip_rooms_label": "ആദ്യം സേവനം ചെയ്തു:",
  "ca_attention_title": "ശ്രദ്ധ വേണം",
  "ca_attention_empty": "എല്ലാം വ്യക്തമാണ് - ഇപ്പോൾ പ്രശ്‌നങ്ങളൊന്നുമില്ല",
  "ca_attention_sla_breach_one": "{name} · SLA ലംഘിച്ചു",
  "ca_attention_sla_breach_many": "{name} · {count} SLA ലംഘനങ്ങൾ",
  "ca_attention_open_while_out_one": "{name} · ക്ലോക്ക് ഔട്ട് ആയപ്പോൾ തുറന്ന പരാതി",
  "ca_attention_open_while_out_many": "{name} · {count} ക്ലോക്ക് ഔട്ട് ആയപ്പോൾ തുറന്നിരിക്കുന്നു",
  "ca_attention_idle": "{name} · നിഷ്‌ക്രിയം {duration}",
  "ca_attention_late": "{name} · വൈകിയെത്തിയിരിക്കുന്നു",
  "ca_attention_show": "കാണിക്കുക",
  "ca_attention_hide": "മറയ്ക്കുക",
  "all": "എല്ലാം",
  "check_site_and_shift": "ഒരു സൈറ്റ് തിരഞ്ഞെടുത്തിട്ടുണ്ടോ എന്നും അതിന് സജീവമായ ഷിഫ്റ്റ് ഉണ്ടോ എന്നും പരിശോധിക്കുക",
  "cleaner": "ക്ലീനർ",
  "close": "അടയ്ക്കുക",
  "communication_clear_filters": "ഫിൽട്ടറുകൾ മായ്ക്കുക",
  "failed_to_load_data": "ഡാറ്റ ലോഡ് ചെയ്യാനായില്ല",
  "filters": "ഫിൽട്ടറുകൾ",
  "next": "അടുത്തത്",
  "no_active_shift": "സജീവ ഷിഫ്റ്റ് ഇല്ല",
  "no_cleaners_found": "ക്ലീനർമാരെ കണ്ടെത്തിയില്ല",
  "open_complaints": "തുറന്ന പരാതികൾ",
  "please_select_company_site": "ഒരു കമ്പനിയും സൈറ്റും തിരഞ്ഞെടുക്കുക",
  "refresh_failed": "പുതുക്കൽ പരാജയപ്പെട്ടു",
  "rooms": "മുറികൾ",
  "select": "തിരഞ്ഞെടുക്കുക",
  "shift": "ഷിഫ്റ്റ്",
  "working_area": "പ്രവർത്തന മേഖല",
  "ca_view_shift": "ഷിഫ്റ്റ്",
  "ca_view_history": "ചരിത്രം",
  "ca_filters_done": "പൂർത്തിയായി",
  "ca_hist_preset_this_month": "ഈ മാസം",
  "ca_hist_preset_last_month": "കഴിഞ്ഞ മാസം",
  "ca_hist_preset_this_week": "ഈ ആഴ്ച",
  "ca_hist_preset_last_week": "കഴിഞ്ഞ ആഴ്ച",
  "ca_hist_preset_custom": "ഇഷ്ടാനുസൃതം",
  "ca_hist_from": "മുതൽ",
  "ca_hist_to": "വരെ",
  "ca_hist_range_invalid": "ആരംഭ തീയതി അവസാന തീയതിക്ക് മുമ്പായിരിക്കണം",
  "ca_hist_range_too_long": "പരിധി പരമാവധി {max} ദിവസം ആകാം",
  "ca_hist_search": "പേര് അല്ലെങ്കിൽ ഫോൺ തിരയുക",
  "ca_hist_people_count": "{count} ജീവനക്കാർ",
  "ca_hist_kpi_days": "ജോലി ചെയ്ത ദിവസങ്ങൾ",
  "ca_hist_kpi_net": "അറ്റ മണിക്കൂറുകൾ",
  "ca_hist_kpi_breaks": "ഇടവേളകൾ",
  "ca_hist_col_person": "ജീവനക്കാരൻ",
  "ca_hist_col_total": "ആകെ മണിക്കൂറുകൾ",
  "ca_hist_col_total_tip": "ഇടവേളകൾക്ക് മുമ്പ് ക്ലോക്ക്-ഇൻ മുതൽ ക്ലോക്ക്-ഔട്ട് വരെ, ജീവനക്കാരൻ ആപ്പിൽ കാണുന്ന അതേ കണക്ക്",
  "ca_hist_col_net": "അറ്റ മണിക്കൂറുകൾ",
  "ca_hist_col_breaks": "ഇടവേളകൾ",
  "ca_hist_col_issues": "പ്രശ്നങ്ങൾ",
  "ca_hist_col_late": "വൈകി",
  "ca_hist_col_missed": "വിട്ടുപോയി",
  "ca_hist_col_no_clock_out": "ക്ലോക്ക്-ഔട്ട് ഇല്ല",
  "ca_hist_clocked_in_now": "ഇപ്പോൾ ക്ലോക്ക്-ഇൻ ചെയ്തിരിക്കുന്നു",
  "ca_hist_not_assigned": "ഈ സൈറ്റിലേക്ക് നിയോഗിച്ചിട്ടില്ല",
  "ca_hist_no_shift": "ഷിഫ്റ്റ് നിയോഗിച്ചിട്ടില്ല",
  "ca_hist_unknown_name": "അജ്ഞാതം",
  "ca_hist_empty": "ഈ കാലയളവിൽ ഹാജർ ഇല്ല",
  "ca_hist_empty_hint": "ഈ സൈറ്റിൽ ആരും ക്ലോക്ക്-ഇൻ ചെയ്തിട്ടില്ല, ജീവനക്കാരെ ഇതിലേക്ക് നിയോഗിച്ചിട്ടുമില്ല.",
  "ca_hist_no_match": "ഫിൽട്ടറുകളുമായി പൊരുത്തപ്പെടുന്ന ജീവനക്കാരില്ല",
  "ca_hist_load_error_hint": "ഹാജർ ചരിത്രം ലോഡ് ചെയ്യാനായില്ല. അൽപ്പസമയത്തിന് ശേഷം വീണ്ടും ശ്രമിക്കുക.",
  "ca_hist_prev_person": "മുമ്പത്തെ ജീവനക്കാരൻ",
  "ca_hist_next_person": "അടുത്ത ജീവനക്കാരൻ",
  "ca_hist_close": "അടയ്ക്കുക",
  "ca_hist_legend_worked": "ജോലി ചെയ്തു",
  "ca_hist_legend_late": "വൈകി",
  "ca_hist_legend_missed": "വിട്ടുപോയി",
  "ca_hist_legend_no_clock_out": "ക്ലോക്ക്-ഔട്ട് ഇല്ല",
  "ca_hist_late_by": "{duration} വൈകി",
  "ca_hist_late_tip": "{time}-ന് ക്ലോക്ക്-ഇൻ ചെയ്തു, {shift} {start}-ന് ആരംഭിക്കുന്നു",
  "ca_hist_missed": "വിട്ടുപോയി",
  "ca_hist_missed_tip": "ഷെഡ്യൂൾ ചെയ്ത ഷിഫ്റ്റ് ക്ലോക്ക്-ഇൻ ഇല്ലാതെ അവസാനിച്ചു",
  "ca_hist_no_clock_out": "ക്ലോക്ക്-ഔട്ട് ഇല്ല",
  "ca_hist_no_clock_out_tip": "സെഷൻ ഒരിക്കലും അടച്ചിട്ടില്ല; അതിന്റെ മണിക്കൂറുകൾ കണക്കാക്കില്ല",
  "ca_hist_in_progress": "ഇപ്പോഴും ക്ലോക്ക്-ഇൻ ചെയ്തിരിക്കുന്നു",
  "ca_hist_auto": "സ്വയം",
  "ca_hist_open_break": "തുറന്നത്",
  "ca_hist_day_col_gross": "ആകെ മണിക്കൂറുകൾ",
  "ca_hist_day_col_breaks": "ഇടവേളകൾ",
  "active_cleaners": "സജീവ ക്ലീനർമാർ",
  "closed_complaints": "അടച്ച പരാതികൾ",
  "total_work_time": "ആകെ ജോലി സമയം",
  "total_work_time_net": "ആകെ ജോലി സമയം (ഇന്നത്തെ നെറ്റ്)",
  "total_break_time": "ആകെ ഇടവേള സമയം",
  "avg_response_time": "ശരാശരി പരിഹരിച്ചു",
  "clocked_in": "ക്ലോക്ക് ചെയ്തു",
  "clocked_out": "ക്ലോക്ക് ഔട്ട്",
  "still_clocked_in": "ഇപ്പോഴും ക്ലോക്ക് ചെയ്തിരിക്കുന്നു",
  "clocked_in_late": "നേരം വൈകി",
  "total_hours": "ആകെ മണിക്കൂർ",
  "auto_punch": "ഓട്ടോ (ജിയോഫെൻസ്)",
  "manual_punch": "മാനുവൽ",
  "complaint_opened": "പരാതി തുറന്നു",
  "complaint_closed": "പരാതി അവസാനിപ്പിച്ചു",
  "complaint_still_open": "ഇപ്പോഴും തുറന്നിരിക്കുന്നു",
  "resolved_in": "ൽ പരിഹരിച്ചു",
  "open_for": "ഇതിനായി തുറക്കുക",
  "sla_breached": "SLA ലംഘിച്ചു",
  "no_activity_today": "ഇന്നും പ്രവർത്തനമൊന്നുമില്ല",
  "just_now": "ഇപ്പോള്",
  "ago": "മുമ്പ്",
  "today": "ഇന്ന്",
  "live": "തത്സമയം",
  "last_updated": "അപ്ഡേറ്റ് ചെയ്തു",
  "analytics_export_confirm": "Analytics CSV ഫയലുകൾ ഡൗൺലോഡ് ചെയ്യണോ?",
  "analytics_export_title": "അനലിറ്റിക്സ് ഡാറ്റ കയറ്റുമതി ചെയ്യുക",
  "analytics_export_description": "നിങ്ങളുടെ നിലവിൽ ഫിൽട്ടർ ചെയ്‌ത അനലിറ്റിക്‌സുള്ള ഒരു ZIP ഫയൽ ഡൗൺലോഡ് ചെയ്യപ്പെടും - സംഗ്രഹം, ഡോനട്ട്, മണിക്കൂറുകൾ, മുറികൾ, ക്ലീനർ/സൂപ്പർവൈസർ വരവ്.",
  "download": "ഡൗൺലോഡ് ചെയ്യുക",
  "analytics_export_blocked_loading": "അനലിറ്റിക്സ് ഡാറ്റ ഇപ്പോഴും ലോഡുചെയ്യുന്നു. ദയവായി കാത്തിരുന്ന് വീണ്ടും ശ്രമിക്കുക.",
  "analytics_export_blocked_no_data": "എക്‌സ്‌പോർട്ട് ചെയ്യാൻ അനലിറ്റിക്‌സ് ഡാറ്റകളൊന്നുമില്ല. നിങ്ങളുടെ ഫിൽട്ടറുകൾ പ്രയോഗിച്ച് പേജ് ലോഡ് ചെയ്യാൻ കാത്തിരിക്കുക.",
  "analytics_export_blocked_stale_filters": "ഫിൽട്ടറുകൾ മാറി. കയറ്റുമതി ചെയ്യുന്നതിന് മുമ്പ് ഫിൽട്ടറുകൾ പ്രയോഗിച്ച് അനലിറ്റിക്‌സ് റീലോഡ് ചെയ്യുന്നതിനായി കാത്തിരിക്കുക.",
  "have_you_finished_making_changes": "മാറ്റങ്ങൾ വരുത്തി കഴിഞ്ഞോ?",
  "assignment_issues_found": "അസൈൻമെന്റ് പ്രശ്നങ്ങൾ കണ്ടെത്തി",
  "unassigned_rooms_title": "അസൈൻ ചെയ്യാത്ത മുറികൾ",
  "overlapping_assignments_title": "ഓവർലാപ്പ് അസൈൻമെന്റുകൾ",
  "and_n_more": "കൂടാതെ {count} എണ്ണം കൂടി",
  "continue_anyway": "എന്തായാലും തുടരുക",
  "stay_and_fix": "തുടർന്ന് ശരിയാക്കുക",
  "assignment_coverage_issues": "{unassigned} അസൈൻ ചെയ്യാത്തത് · {overlaps} ഓവർലാപ്പുകൾ",
  "assignment_check_failed": "മുറി അസൈൻമെന്റുകൾ പരിശോധിക്കാനായില്ല",
  "tap_for_details": "വിശദാംശങ്ങൾക്ക് ടാപ്പ് ചെയ്യുക",

  "has_app": "ആപ്പ്",
  "has_app_tooltip": "ക്ലീനറിന് ആപ്പ് ഉണ്ട്",
  "notifications_tooltip": "പുഷ് അറിയിപ്പുകൾ ഓണാണ്",
  "assigned_to_rooms": "മുറികളിലേക്ക് നിയോഗിച്ചു",
  "assigned_to_rooms_tooltip": "ഈ സൈറ്റിലെ മുറികളിലേക്ക് നിയോഗിച്ചിരിക്കുന്നു",
  "recently_active": "അടുത്തിടെ സജീവം",
  "works_at_site": "സൈറ്റിൽ ജോലി ചെയ്യുന്നു",
  "recently_active_tooltip": "കഴിഞ്ഞ 30 മിനിറ്റിനുള്ളിൽ ആപ്പ് തുറന്നു",
}

export const sk = {
  ...serviks.sk,
  "notified": "Oznámené",
  "supervisor_arrival": "Príchod supervízora",
  "arrival": "Príchod",
  "arrival_badges": "Príchody na smeny",
  "visits_since_cleaned": "Návštevy od posledného čistenia",
  "visits_since_cleaned_short": "Od posledného čistenia",
  "filter": "Filter",
  "logo": "Logo",
  "sms": "SMS",
  "shifts": "Smeny",
  "call": "Zavolajte",
  "openCalls": "Otvorené hovory",
  "callsHistory": "História hovorov",
  "duration": "Trvanie",
  "time_start": "Začiatok času",
  "settings": "Nastavenia",
  "always": "Vždy",
  "off": "Vypnuté",
  "time_based": "Na základe času",
  "location_based": "Na základe polohy",
  "notification_mode": "Režim upozornení",
  "notification_times": "Časy upozornení",
  "notification_times_info": "Časové rozsahy sa spravujú z mobilnej aplikácie",
  "notification_location": "Miesto upozornenia",
  "notification_sound": "Zvuk upozornenia",
  "no_sound": "Žiadny zvuk",
  "default_sound": "Predvolený zvuk",
  "soft_bell": "Mäkký zvonček",
  "digital_sound": "Digitálny zvuk",
  "mallet_sound": "Zvuk paličky",
  "phone_sound": "Zvuk telefónu",
  "text_sound": "Textový zvuk",
  "manager_alert_delay": "Oneskorenie výstrahy manažéra",
  "snooze_interval": "Pripomenutie",
  "vocal_notifications": "Hlasové upozornenia",
  "no_delay": "Žiadne oneskorenie",
  "no_snooze": "Žiadna pripomienka",
  "lat": "lat",
  "lon": "Lon",
  "radius": "Polomer",
  "no_location_set": "Nie je nastavená žiadna poloha",
  "when_to_notify": "Kedy upozorniť",
  "notification_preferences": "Predvoľby upozornení",
  "assignment_configuration": "Priradenie a konfigurácia",
  "working_area": "Pracovná oblasť",
  "complaints_NC": "Reklamácie / NC",
  "SLA_NC": "SLA / NC",
  "arrivals_NC": "Príchody / NC",
  "staff": "personál",
  "cleaning_complaints": "Sťažnosti na čistenie",
  "export": "Exportovať",
  "maintenance_complaints": "Sťažnosti na údržbu",
  "maintenanceArrivals": "Príchody údržby",
  "maintenance_arrivals": "Príchody údržby",
  "last": "Posledný",
  "survey_name": "Názov prieskumu",
  "survey": "Prieskum",
  "pad_survey": "Prieskum podložky",
  "pad_no_maintenance_survey": "Podložka bez prieskumu údržby",
  "pad_kitchen": "Podložka kuchyne",
  "number_of_assigned_devices": "# priradených zariadení",
  "number_of_pages": "Počet strán",
  "date_created": "Dátum vytvorenia",
  "updated_by": "Aktualizované používateľom",
  "date_updated": "Dátum aktualizácie",
  "search": "Hľadať",
  "choose_type": "Vyberte typ",
  "permitted_sites": "Povolené stránky",
  "permitted_franchise": "Povolená franšíza",
  "permitted_companies": "Povolené spoločnosti",
  "panel_permitted": "Panel povolený",
  "end_time": "Čas ukončenia",
  "last_update": "Posledná aktualizácia",
  "add_device": "Pridať zariadenie",
  "detailed": "Podrobné",
  "analysis": "Analýza",
  "suggestion": "Návrh",
  "country": "Krajina",
  "management": "Manažment",
  "device": "Zariadenie",
  "mapping": "Mapovanie",
  "please_enter": "Zadajte",
  "new_device": "Nové zariadenie",
  "assign_device": "Priradiť zariadenie",
  "installSpot": "Miesto inštalácie",
  "device_type": "Typ zariadenia",
  "deviceCode": "Kód zariadenia",
  "device_code": "Kód zariadenia",
  "scan_or_enter_device_code": "Naskenujte alebo zadajte kód zariadenia...",
  "scan_device": "Priradit",
  "scan_qr_in_frame": "Zarovnajte QR kód do rámu. Pri malých kódoch držte telefón 15–25 cm ďaleko a ťuknite na náhľad pre opätovné zaostrenie, ak je obraz rozmazaný.",
  "checking_device_code": "Kontrola kódu zariadenia...",
  "camera_not_available": "Kamera nie je k dispozícii. Kód môžete zadať ručne.",
  "device_code_already_exists": "Tento kód zariadenia je už priradený inému senzoru.",
  "assigned_to_company_site_room": "Už priradené k {company} / {site} / {room}",
  "device_code_lookup_failed": "Kód zariadenia sa nepodarilo overiť. Skúste to znova.",
  "device_code_no_site_access": "Tento kód je už zaregistrovaný na mieste, ku ktorému nemáte prístup.",
  "device_code_check_unavailable": "Server kód nemohol overiť. Skúste to znova.",
  "device_code_not_a_code": "Skenovanie prečítalo „{code}“. Zadajte samotný kód zariadenia.",
  "device_code_open_failed": "Toto zariadenie sa nepodarilo otvoriť. Skúste to znova.",
  "device_code_save_failed": "Kód zariadenia sa nepodarilo uložiť. Skúste to znova.",
  "device_code_save_forbidden": "Toto zariadenie nemôžete zmeniť.",
  "confirm_replace_device_code": "Nahradiť kód zariadenia?",
  "confirm_replace_device_code_body": "Naozaj chcete nahradiť kód {oldCode} kódom {newCode}?",
  "room": "Izba",
  "edit_room": "Upraviť miestnosť",
  "edit_franchise": "Upraviť franšízu",
  "new_franchise": "Nová franšíza",
  "desc": "Popis",
  "address": "Adresa",
  "level": "úroveň",
  "no_companies_to_show": "Žiadne spoločnosti na zobrazenie",
  "company_type": "Typ spoločnosti",
  "region": "región",
  "new_company": "Nová spoločnosť",
  "edit_company": "Upraviť spoločnosť",
  "edit_user": "Upraviť používateľa",
  "C.arrivals": "Prišiel čistič",
  "C.complaints": "Sťažnosť na čistenie",
  "M.complaints": "Sťažnosti na údržbu",
  "M.Arrivals": "Príchody údržby",
  "analyses": "Analýzy",
  "clean_log": "Čistý denník",
  "maintenance_log": "Denník údržby",
  "likes": "Páči sa mi",
  "new_user": "Nový používateľ",
  "shift_parameters": "Parameter posunu",
  "add_shift": "Nová zmena",
  "edit_shift": "Upraviť zmenu",
  "username": "Používateľské meno",
  "first_name": "Krstné meno",
  "job_function": "Funkcia",
  "role": "Rola",
  "property_manager": "Správca nehnuteľnosti",
  "facility_manager": "Facility manažér",
  "site_manager": "Vedúci objektu",
  "workplace_manager": "Vedúci pracoviska",
  "cleaning_company_ceo": "Riaditeľ upratovacej firmy",
  "operations_manager": "Prevádzkový manažér",
  "area_manager": "Oblastný manažér",
  "site_cleaning_manager": "Vedúci upratovania objektu",
  "cleaning_supervisor": "Supervízor upratovania",
  "other": "Iné",
  "restroom_cleaner": "Upratovanie toaliet",
  "general_cleaner": "Všeobecný upratovač",
  "day_porter": "Denný pomocník",
  "office_cleaner": "Upratovanie kancelárií",
  "public_area_cleaner": "Upratovanie spoločných priestorov",
  "firstName": "Krstné meno",
  "description": "Popis",
  "last_name": "Priezvisko",
  "lastName": "Priezvisko",
  "phone": "Telefón",
  "building_area": "Stavebná plocha",
  "users": "Používatelia",
  "add_user": "Pridať používateľa",
  "sites": "Stránky",
  "new_site": "Nová stránka",
  "edit_site": "Upraviť stránku",
  "add_company": "Pridať spoločnosť",
  "franchise": "Franšíza",
  "floor": "Poschodie",
  "building": "Budovanie",
  "humidity": "Vlhkosť",
  "humidity_abbr": "Vlhký",
  "temperature": "Teplota",
  "temperature_abbr": "tepl",
  "gender": "Typ miestnosti",
  "display_name": "Meno",
  "zone": "Zóna",
  "shift_number": "Shift#",
  "shift_name": "Názov zmeny",
  "shift_currently_inactive": "Momentálne neaktívna zmena",
  "local_time": "Miestne",
  "end": "Koniec",
  "min_sla": "Min SLA",
  "max_sla": "Max SLA",
  "days": "dní",
  "complaints_percent": "% Sťažností",
  "sla_percent": "% SLA",
  "arrivals_percent": "% príchodov",
  "save_arrivals": "Uložiť",
  "clean_time": "Čas čistenia (min)",
  "tooltip_shift_number": "Poradie zobrazenia tohto posunu (napr. 1, 2).",
  "tooltip_shift_name": "Názov zmeny (napr. Ráno, Noc).",
  "tooltip_start_time": "Čas začiatku posunu v miestnom čase.",
  "tooltip_end_time": "Čas ukončenia posunu v miestnom čase.",
  "tooltip_cleaners_number": "Počet upratovačiek na tejto zmene.",
  "tooltip_min_sla": "Najlepší čas odozvy (minúty) na vybavenie sťažnosti na izbu; používa sa ako spodná hranica skóre.",
  "tooltip_max_sla": "Maximálny prijateľný čas odozvy (minúty) na vybavenie sťažnosti na izbu; používa sa ako horná hranica skóre.",
  "tooltip_arrivals": "Očakávané čistejšie príchody na izbu a deň; skóre porovnáva skutočné príchody k tomuto cieľu.",
  "tooltip_save_arrivals": "Čistejšie návštevy na izbu a deň pred BuzzzTV; používa sa na výpočet ušetreného času (teraz menej návštev = ušetrené minúty).",
  "tooltip_clean_time": "Minúty započítané na návštevu upratovačky v časovom výpočte (napr. 15).",
  "tooltip_complaints_percent": "Váha sťažností v skóre izby, keď má miestnosť návštevy (vyššia = sťažnosti ovplyvňujú skóre viac).",
  "tooltip_response_time_SLA": "Váha času odozvy v skóre miestnosti, keď má miestnosť návštevy (vyššia = rýchlejšia odozva je dôležitejšia).",
  "tooltip_arrivals_percent": "Váha príchodov v porovnaní s cieľom v skóre miestnosti, keď má miestnosť návštevy.",
  "tooltip_complaints_NC": "Váha sťažností v skóre, keď miestnosť nemá žiadne návštevy (žiadne počítadlo).",
  "tooltip_SLA_NC": "Váha času odozvy v skóre, keď miestnosť nemá žiadne návštevy.",
  "tooltip_arrivals_NC": "Váha príchodov v skóre, keď miestnosť nemá žiadne návštevy.",
  "tooltip_days": "Dni v týždni, kedy je táto zmena aktívna.",
  "tooltip_active_calculation": "Keď je povolená, tento posun je zahrnutý do skóre a časovo uložených výpočtov.",
  "auto_close_complaints_hour": "Hodina automatického zatvárania sťažností",
  "tooltip_auto_close_complaints_hour": "Miestna hodina, pri ktorej sa automaticky uzatvárajú otvorené zmluvy SLA v tejto zmene. Ak chcete deaktivovať, ponechajte prázdne.",
  "auto_close_maintenance_complaints_hour": "Hodina automatického zatvárania sťažností údržby",
  "tooltip_auto_close_maintenance_complaints_hour": "Miestna hodina, pri ktorej sa automaticky uzatvárajú otvorené SLA sťažností údržby v tejto zmene. Ak chcete deaktivovať, ponechajte prázdne.",
  "no_auto_close": "-- Žiadne --",
  "tooltip_shift_rooms": "Miestnosti pridelené tejto zmene. Ak chcete prejsť na úroveň lokality, ponechajte prázdne.",
  "company_name": "Názov spoločnosti",
  "site_name": "Názov lokality",
  "site_desc": "Popis lokality",
  "service_provider_name": "Poskytovateľ služieb",
  "service_provider_type": "Typ poskytovateľa služieb",
  "service_provider_desc": "Popis poskytovateľa služieb",
  "user": "Používateľ",
  "map": "Mapa",
  "delete": "Odstrániť",
  "new_room": "Nová izba",
  "issue_times": "Časy vydania",
  "solved": "Vyriešené",
  "visits": "Návštevy",
  "visits_also_went_up": "Návštevy tiež vzrástli",

  "complaints": "Sťažnosti",
  "complaints_in_shift": "Sťažuje sa na tento posun",
  "cleaner_arrivals": "Čistejšie príchody",
  "unnecessary_arrivals": "Príchody bez výzvy",
  "unnecessary_arrivals_hint": "Návšteva upratovača, kým v miestnosti nebolo otvorené hlásenie.",
  "of_arrivals": "z príchodov",
  "response_time_SLA": "Čas odozvy",
  "score": "skóre",
  "avg_score": "Priem. skóre",
  "score_goal": "Streliť gól",
  "top_problem_issues": "Hlavné problémy",
  "top_problem_rooms": "Najlepšie izby",
  "top_problem_hours": "Najlepšie hodiny",
  "is_time_save": "Čas ušetrený",
  "options": "Možnosti",
  "send_battery_alerts": "Posielajte upozornenia na batériu",
  "environment_alerts": "Upozornenia prostredia",
  "environment_alerts_description": "Odosielajte e-mailové upozornenia, keď teplota alebo vlhkosť opustí povolený rozsah",
  "environment_alert_emails": "E-maily s upozornením na životné prostredie",
  "temperature_min": "Teplota min",
  "temperature_max": "Teplota max",
  "humidity_min": "Vlhkosť min",
  "humidity_max": "Vlhkosť max",
  "environment_alert_range_invalid": "Rozsahy výstrah prostredia musia byť číselné a min musí byť menšie alebo rovné max",
  "coming_soon": "Už čoskoro",
  "alert_emails": "Upozorňujúce e-maily",
  "alert_emails_placeholder": "Zadajte e-mailovú adresu",
  "alert_language": "Jazyk upozornenia",
  "select_language": "Vyberte jazyk",
  "invalid_email_format": "Jedna alebo viac e-mailových adries je neplatných",
  "add_email": "Pridajte ďalší e-mail",
  "next": "Ďalej",
  "back": "Späť",
  "basic_information": "Základné informácie",
  "service_providers": "Poskytovatelia služieb",
  "settings_alerts": "Nastavenia a upozornenia",
  "battery_alerts": "Upozornenia na batérie",
  "alerts_title": "Upozornenia",
  "time_save_description": "Povoliť funkcie šetriace čas",
  "exposures_description": "Sledujte údaje bez expozície",
  "alerts_description": "Upozornenia na informácie o zariadení",
  "shift_description": "Vytvorte predvolené zmeny",
  "battery_alerts_description": "Odošlite e-mailové upozornenia na slabú batériu",
  "est_ROI": "Odhadovaná návratnosť investícií",
  "complaints_vs_visits": "Sťažnosti vs návštevy",
  "view_by_years": "Zobraziť roky",
  "view_by_months": "Zobraziť mesiace",
  "view_by_weeks": "Zobraziť týždne",
  "view_by_days": "Zobraziť dni",
  "minutes": "Min",
  "company": "Spoločnosť",
  "site": "stránky",
  "alerts": "Informácie o zariadeniach",
  "performance": "Výkon",
  "devices": "Zariadenia",
  "total_devices": "Celkový počet zariadení",
  "working": "Pracovné",
  "warning": "POZOR",
  "by_device_type": "Podľa typu zariadenia",
  "surveys": "Prieskumy",
  "real_time": "V reálnom čase",
  "real-time": "V reálnom čase",
  "admin": "Admin",
  "all": "Všetky",
  "overview": "Prehľad",
  "exit_full_screen": "Ukončiť celú obrazovku",
  "full_screen": "Celá obrazovka",
  "total": "Celkom",
  "analytics": "Analytics",
  "pdf_export_title_analytics": "prehľad služby Analytics",
  "pdf_export_title_cleaner_arrivals": "Čistejšie príchody",
  "communication": "Komunikácia",
  "overview_complaints_devices_caption": "Nainštalované zariadenia (kumulatívne)",
  "overview_complaints_devices_caption_hint": "Celkový počet zariadení nainštalovaných na mieste do konca každého mesiaca na základe dátumov inštalácie.",
  "overview_complaints_devices_toggle_aria": "Zobraziť alebo skryť zariadenia nainštalované pod tabuľkou sťažností",
  "communication_select_site_title": "Vyberte lokalitu",
  "communication_select_site": "Ak chcete zobraziť a pridať poznámky pre dané miesto, vyberte z filtrov vyššie spoločnosť a lokalitu.",
  "communication_viewing_site": "Prezeranie",
  "communication_add_note": "Pridajte poznámku",
  "communication_add_note_open_aria": "Otvorte dialógové okno pridania poznámky",
  "communication_form_hint": "Zdieľajte aktualizácie alebo poznámky s každým, kto má prístup k tejto lokalite. Nové poznámky uvidia v reálnom čase.",
  "communication_page_intro_title": "Poznámky k lokalite – zdieľaný denník pre toto miesto",
  "communication_page_intro_body": "Túto stránku použite na zanechanie odovzdaných úloh, problémov, aktualizácií a poznámok zo stretnutí pre váš tím. Každý, kto môže otvoriť túto stránku na portáli, môže čítať a pridávať poznámky.",
  "communication_page_intro_dismiss": "Skryť tento tip",
  "communication_page_intro_aria": "O poznámkach k lokalite",
  "communication_content_placeholder": "Sem napíšte svoju poznámku...",
  "communication_keyboard_hint": "Ctrl+Enter na odoslanie",
  "communication_submitting": "Uverejňuje sa...",
  "communication_submit": "Uverejniť poznámku",
  "communication_recent_notes": "Poznámky",
  "communication_search_placeholder": "Hľadať podľa autora alebo textu...",
  "communication_refresh": "Obnoviť",
  "communication_clear_filters": "Vymazať filtre",
  "communication_search_aria_label": "Vyhľadajte poznámky",
  "communication_submit_aria_label": "Uverejniť poznámku",
  "communication_copy_note_aria_label": "Skopírujte text poznámky",
  "communication_copied": "Skopírované do schránky.",
  "communication_copy_empty": "Neexistuje žiadny text poznámky na kopírovanie.",
  "communication_filter_hidden_one": "(1 poznámka skrytá filtrami)",
  "communication_filter_hidden_many": "({n} poznámok skrytých filtrami)",
  "communication_request_timeout": "Časový limit žiadosti vypršal. Skúste to znova.",
  "communication_load_failed": "Nepodarilo sa načítať poznámky.",
  "communication_retry": "Skúste to znova",
  "communication_no_matches": "Vášmu vyhľadávaniu ani filtrom nezodpovedajú žiadne poznámky. Skúste ich upraviť.",
  "communication_no_entries": "Zatiaľ žiadne poznámky.",
  "communication_no_entries_hint": "Začnite pridaním poznámky vyššie.",
  "communication_just_now": "Práve teraz",
  "communication_minutes_ago": "pred {n} min",
  "communication_hours_ago": "pred {n} h",
  "communication_days_ago": "pred {n} dňami",
  "communication_note_posted": "Poznámka zverejnená.",
  "communication_post_failed": "Nepodarilo sa uverejniť poznámku. Skúste to znova.",
  "communication_note_type": "Typ poznámky",
  "communication_type_general": "generál",
  "communication_type_update": "Aktualizovať",
  "communication_type_issue": "Vydanie",
  "communication_type_follow_up": "Sledovanie",
  "communication_type_meeting": "Poznámka zo stretnutia",
  "communication_filter_all_types": "Všetky typy",
  "communication_pinned": "Pripnuté",
  "communication_pin": "Pin",
  "communication_unpin": "Odopnúť",
  "communication_pin_limit": "Maximálne 2 pripnuté",
  "communication_pinned_toast": "Poznámka pripnutá.",
  "communication_unpinned_toast": "Poznámka bola odopnutá.",
  "communication_pin_failed": "Kód PIN sa nepodarilo aktualizovať. Skúste to znova.",
  "communication_note_not_found": "Poznámka sa nenašla alebo nemáte prístup.",
  "communication_site_not_in_filters": "Web tejto poznámky nie je vo vašich aktuálnych filtroch. Možno nemáte prístup k tejto polohe.",
  "communication_edit": "Upraviť",
  "communication_delete": "Odstrániť",
  "communication_save": "Uložiť",
  "communication_cancel": "Zrušiť",
  "communication_saving": "Ukladá sa...",
  "communication_note_updated": "Poznámka bola aktualizovaná.",
  "communication_update_failed": "Poznámku sa nepodarilo aktualizovať. Skúste to znova.",
  "communication_delete_confirm": "Naozaj chcete odstrániť túto poznámku? Túto akciu nie je možné vrátiť späť.",
  "communication_delete_confirm_title": "Odstrániť poznámku",
  "communication_note_preview": "Ukážka poznámky:",
  "communication_note_deleted": "Poznámka vymazaná.",
  "communication_delete_failed": "Poznámku sa nepodarilo odstrániť. Skúste to znova.",
  "communication_edited": "Upravené",
  "communication_show_more": "Ukáž viac",
  "communication_show_less": "Ukážte menej",
  "communication_sort_date_newest": "Najnovšie ako prvé",
  "communication_sort_date_oldest": "Najprv najstarší",
  "communication_sort_author": "Podľa autora",
  "communication_sort_type": "Podľa typu",
  "communication_sort_pinned": "Najprv pripnuté",
  "communication_sort_label": "Triediť",
  "communication_filter_by_type": "Typ",
  "communication_filters_group_aria": "Filtrujte a triedite poznámky",
  "communication_search_label_short": "Hľadať",
  "employees": "Zamestnanci",
  "last_time_of_arrival": "Posledný čas príchodu",
  "arrival_and_status": "Príchod a stav",
  "preview_arrivals": "Ukážka príchodov",
  "men toilet": "Pánska toaleta",
  "women toilet": "Dámska toaleta",
  "shared toilet": "Spoločná toaleta",
  "unisex restroom": "Unisex toaleta",
  "handicapped toilet": "Bezbariérové ​​WC",
  "kitchen": "Kuchyňa",
  "logistics": "Logistika",
  "cubicle": "Kabínka",
  "gym": "Posilňovňa",
  monthMap: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'Máj',
    6: 'Jún',
    7: 'Júl',
    8: 'Aug',
    9: 'Sep',
    10: 'Okt',
    11: 'Nov',
    12: 'Dec',
  },
  weekMap: {
    1: 'Nedeľa',
    2: 'Pondelok',
    3: 'Utorok',
    4: 'Streda',
    5: 'Štvrtok',
    6: 'Piatok',
    7: 'Sobota',
  },
  "dayOfWeek": "Dni",
  "service_log": "Servisný denník",
  "rooms": "Izby",
  "bulk_add_rooms": "Hromadné pridávanie miestností",
  "adding_to": "Pridáva sa do",
  "add_rooms": "Pridať miestnosti",
  "room_names_one_per_line": "Názvy miestností (jeden na riadok)",
  "enter_at_least_one_room": "Zadajte aspoň jeden názov miestnosti",
  "room_names_placeholder": "Izba 1\nIzba 2\nDámska toaleta",
  "rooms_with_prefix": "miestnosti s predponou",
  "apply_to_all_rooms": "Použiť na všetky miestnosti (voliteľné)",
  "bulk_rooms_intro": "Pridajte jednu alebo viac skupín. Každá skupina má svoju vlastnú budovu, poschodie, zónu, pohlavie a názvy miestností.",
  "group": "Skupina",
  "add_group": "+ Pridať ďalšiu skupinu",
  "adding_rooms": "Pridávajú sa miestnosti...",
  "bulk_summary": "Zhrnutie",
  "in": "v",
  "bulk_rooms_success": "Úspešne pridaných izieb: {n}",
  "displayName": "Názov miestnosti",
  "SLA": "SLA",
  "supervisors": "Dozorcovia",
  "supervisor": "Dozorca",
  "performance_analytics": "Analýza výkonnosti",
  "arrivals": "Prílety",
  "inspections": "Inšpekcie",
  "avgResponseTime": "Priemerný čas odozvy",
  "missedSla": "Chýbala Sla",
  "load_more": "Načítať viac",
  "login": "Prihláste sa",
  "email": "Email",
  "emails": "E-maily",
  "password": "heslo",
  "min": "Min",
  "Logout": "Odhlásiť sa",
  "time_range": "Časový rozsah",
  "select_time_range": "Vyberte časový rozsah",
  "custom_time": "Vyberte dátumy",
  "last_day": "včera",
  "last_week": "Posledných 7 dní",
  "last_month": "Posledných 30 dní",
  "last_quarter": "Posledných 90 dní",
  "last_6_months": "Posledných 6 mesiacov",
  "last_year": "Posledných 365 dní",
  "data_by_hour": "Údaje podľa hodín",
  "start": "Štart",
  "start_time": "Čas začiatku",
  "management_co": "Správcovská spoločnosť",
  "cleaning_co": "Upratovacia firma",
  "companies": "Spoločnosti",
  "name": "Meno",
  "site_count": "miesto #",
  "associated_companies": "Pridružení koncoví klienti",
  "OK": "OK",
  "cancel": "Zrušiť",
  "client": "Klient",
  "dates": "Dátumy",
  "shift": "Shift",
  "issue": "Vydanie",
  "time": "Čas",
  "top complaint of the week": "Top sťažnosť týždňa",
  "top room of the week": "Top izba týždňa",
  "top hour of the week": "Najlepšia hodina týždňa",
  "top complaint of the month": "Najlepšia sťažnosť mesiaca",
  "top room of the month": "Top izba mesiaca",
  "top hour of the month": "Najlepšia hodina v mesiaci",
  "franchises": "Franšízy",
  "add_franchise": "Pridať franšízu",
  "room_names": "Názov miestnosti",
  "type": "Typ",
  "please_select_company_site": "Vyberte spoločnosť a lokalitu",
  "number": "číslo",
  "create_building_map": "Vytvorte mapu budovy",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "Hej, najrýchlejší spôsob pridania poschodí a miestností do budov pomocou tohto rýchleho sprievodcu",
  "avg number of toilets per floor": "Priemerný počet toaliet na poschodie",
  "avg.number of toilet cells per room": "Priemerný počet WC buniek na izbu",
  "number of floors": "Počet poschodí",
  "avg.number of disabled toilets": "Priemerný počet bezbariérových toaliet",
  "avg.number of soap dispensers": "Priemerný počet dávkovačov mydla",
  "reset_filter": "Resetovať filter",
  "add": "Pridať",
  "new_survey": "Nový prieskum",
  "api_configuration": "Konfigurácia API",
  "please_edit_the_api_information": "Upravte informácie o rozhraní API",
  "method": "Metóda",
  "authorization": "Autorizácia",
  "api_url": "API_url",
  "token": "Token",
  "endpoint": "Koncový bod",
  "add_url": "Pridať adresu URL",
  "remove": "Odstrániť",
  "format": "Formátovať",
  "auth_api_key": "API kľúč",
  "auth_dynamic_key": "Dynamický kľúč (GET)",
  "auth_login_token": "Prihlasovací token (HTTP)",
  "dynamic_token_url": "Adresa URL tokenu (GET)",
  "token_response_field_name": "Pole tokenu ako odpoveď",
  "token_login_url": "Prihlasovacia adresa URL",
  "login_request_method": "Spôsob žiadosti o prihlásenie",
  "login_request_body": "Telo žiadosti o prihlásenie (JSON)",
  "login_token_placeholder_hint": "Voliteľné: tajný kľúč používaný na nahradenie {{tokenu}} v tele prihlásenia JSON",
  "token_response_key": "Názov poľa prístupového tokenu",
  "survey_api_auth_header_name": "Názov hlavičky autorizácie (voliteľné)",
  "survey_api_auth_header_prefix": "Text pred tokenom v tejto hlavičke",
  "survey_api_auth_header_name_placeholder": "napr. Autorizácia, X-Api-Key",
  "survey_api_auth_header_prefix_placeholder": "napr. Nosič — konečná hlavička je: predpona + medzera + token",
  "api_request_info": "Informácie o požiadavke API",
  "roomName": "Názov miestnosti",
  "servikName": "Názov sťažnosti",
  "siteName": "Názov lokality",
  "stage": "Etapa",
  "number_of_buttons": "Počet tlačidiel",
  "button_shape": "Tvar gombíka",
  "delay_time_stage": "Etapa času oneskorenia",
  "go_to_stage": "Choďte na pódium",
  "color": "Farba",
  "add_stage": "Pridať scénu",
  "save": "Uložiť",
  "number_of_issues": "počet problémov",
  "online": "Online",
  "offline": "Offline",
  "offline_devices": "Offline zariadenia",
  "no_offline_devices": "Nenašli sa žiadne offline zariadenia",
  "working_devices": "Pracovné zariadenia",
  "no_working_devices": "Nenašli sa žiadne funkčné zariadenia",
  "room_name": "Názov miestnosti",
  "installation_spot": "Spot",
  "device_id": "ID zariadenia",
  "date": "Dátum",
  "status": "Stav",
  "device_status": "Stav zariadenia",
  "none": "žiadny",
  "no_surveys_created": "Neboli vytvorené žiadne prieskumy",
  "dashboard": "Dashboard",
  "franchise_name": "Názov franšízy",
  "franchise_country": "Franšízová krajina",
  "choose_franchise": "Vyberte si franšízu",
  "choose_country": "Vyberte krajinu",
  "select_template": "Vyberte šablónu",
  "default_survey": "Predvolený prieskum",
  "cleaning_survey": "Prieskum upratovania",
  "kitchen_survey": "Prieskum kuchyne",
  "template": "Šablóna",
  "area_name": "Názov oblasti",
  "rooms_names": "Názvy miestností",
  "rooms_number": "miestnosti č.",
  "assign_number": "Priradiť #",
  "active_notification_task": "Aktívna oznamovacia úloha",
  "amount_limit": "Interval počítadla",
  "after_max": "Počítadlo po Max",
  "new_area": "Nová oblasť",
  "edit_area": "Upraviť oblasť",
  "tablet": "Tablet",
  "counter women": "Proti ženám",
  "counter men": "Counter man",
  "counter handicap": "Kontrahendikep",
  "counter man/woman": "Counter muž / žena",
  "counter man / woman": "Counter muž / žena",
  "sensor liquid": "Senzorová kvapalina",
  "double toilet paper": "Dvojitý toaletný papier",
  "toilet paper": "Toaletný papier",
  "tag": "Tag",
  "qr tag": "QR tag",
  "additional_info": "Ďalšie informácie",
  "servikCategory": "Typ hovoru",
  "cafeteria": "Jedáleň",
  "clean room": "Čistá miestnosť",
  "office": "Kancelária",
  "meeting room": "Zasadacia miestnosť",
  "cubic": "Kubický",
  "women": "Ženy",
  "men": "Muži",
  "handicap": "Handicap",
  "Combined": "Kombinované",
  "east": "východ",
  "west": "West",
  "north": "Severná",
  "south": "Juh",
  "right": "Správne",
  "left": "Vľavo",
  "center": "centrum",
  "up": "Hore",
  "down": "Dole",
  "combined": "Kombinované",
  "lobby": "Lobby",
  "entrance": "Vchod",
  "reception": "Recepcia",
  "area": "Oblasť",
  "mezzanine": "Medziposchodie",
  "gallery": "Galéria",
  "ground": "Ground",
  "elevator": "Výťah",
  "is_calculated": "Vypočítaná miestnosť",
  "calculated_room": "Vypočítaná miestnosť",
  "splitted_survey": "Rozdelený prieskum",
  "redirect_to_url": "Presmerovanie na url",
  "survey_site": "Prieskumná stránka",
  "clicks": "Kliknutia",
  "add_stage_number_to_signal": "Pripojte číslo etapy",
  "including_pad9": "Vrátane podložky9",
  "room_type_required": "Vyberte typ miestnosti pre každú skupinu",
  "Tech Manufacturers": "Technologickí výrobcovia",
  "Tech Offices": "Technologické kancelárie",
  "Offices": "Kancelárie",
  "Terminal": "Terminál",
  "Universities": "Univerzity",
  "Factories": "Továrne",
  "Hospital": "Nemocnica",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "Večierky",
  "Food Chains": "Potravinové reťazce",
  "Residential": "Rezidenčný",
  "Shopping Center": "Obchodné centrum",
  "Survey": "Prieskum",
  "Demo": "Ukážka",
  "Vision": "Vision",
  "Court": "Súd",
  "Office Management": "Správa kancelárií",
  "Government Office": "Úrad",
  "default_name": "Meno v angličtine",
  "exposures": "Čistá expozícia",
  "exposures_tab": "Aktivita miestnosti",
  "expose_results": "Výsledky",
  "events_expose": "Udalosti",
  "expose_score": "ohodnotiť",
  "shift_events_expose": "Posunúť udalosti a odhaliť",
  "type_of_site": "Typ lokality",
  "morning_shift": "Ranná zmena",
  "afternoon_shift": "Poobedná zmena",
  "night_shift": "Nočná zmena",
  "update": "Aktualizovať",
  "restart": "Reštartujte",
  "send_data": "Odoslať údaje",
  "send_count": "Počet odoslaní",
  "blink": "Žmurkanie",
  "beacon": "Beacon",
  "like_btn": "Tlačidlo Like",
  "requires_like_btn": "Vyžaduje zapnuté tlačidlo Like",
  "maintenance_btn": "Tlačidlo údržby",
  "battery": "Batéria",
  "version": "Verzia",
  "actions": "Akcie",
  "device_actions": "Akcie zariadenia",
  "device_settings": "Nastavenia zariadenia",
  "drains_battery": "Vybíja batériu",
  "latest_errors": "Najnovšie chyby",
  "no_errors": "Žiadne chyby",
  "offline_calls": "Offline hovory",
  "offline_duration_calls": "Trvanie hovorov offline",
  "counterCalls": "Počítadlo hovorov",
  "active": "Aktívne",
  "no_active_supervisors": "Žiadni aktívni supervízori",
  "active_supervisors_column": "Aktívni dozorcovia",
  "supervisors_active_label": "supervízori sú teraz aktívni",
  "active_supervisors_coverage_hint": "Aktívni supervízori majú túto oblasť zapnutú v mobilnej aplikácii. Neznamená to online stav alebo fyzickú prítomnosť.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "Aktívny výpočet",
  "pad": "Pad",
  "pad_counter": "Počítadlo podložiek",
  "counter_status": "Stav počítadla",
  "choose_state": "Vyberte štát",
  "choose_city": "Vyberte mesto",
  "start_hour": "Začiatok hodiny",
  "end_hour": "Koniec hodiny",
  "analytics_log": "Denník služby Analytics",
  "or": "alebo",
  "no_data_available": "Nie sú k dispozícii žiadne údaje",
  "filter_by_cleaner": "Filtrujte čističom",
  "all_cleaners": "Všetky čističe",
  "not_available": "N/A",
  "failed_to_load_data": "Nepodarilo sa načítať údaje",
  "new_task": "Nová úloha",
  "new_personal_task": "Nová osobná úloha",
  "task_assignment": "Zadanie úlohy",
  "task_assignment_room": "Úloha miestnosti",
  "task_assignment_personal": "Osobná úloha (prideliť upratovačke)",
  "temporarily_unavailable": "Dočasne nedostupné",
  "task_details": "Podrobnosti úlohy",
  "task_languages": "Jazyky úloh",
  "task_languages_hint": "Vyberte jazyky pre túto úlohu. Názov zadáte v každom zvolenom jazyku.",
  "settings_and_assignment": "Nastavenia a priradenie",
  "assignee": "Nadobúdateľ",
  "category": "Kategória",
  "title": "Názov",
  "task_type": "Typ úlohy",
  "task_category": "Kategória úlohy",
  "call_to_action": "Výzva na akciu",
  "schedule": "Rozvrh",
  "insert_text": "Vložte text",
  "select": "Vyberte",
  "select_all": "Vyberte možnosť Všetky",
  "n_selected": "Vybrané: {count}",
  "clear_selection": "Vymazať výber",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "Naplánujte si termíny",
  "language": "Jazyk",
  "calendar": "Kalendár",
  "operation": "Prevádzka",
  "daily": "Denne",
  "weekly": "Týždenne",
  "monthly": "Mesačne",
  "quarterly": "Štvrťročne",
  "yearly": "Ročne",
  "sunday": "nedeľa",
  "monday": "pondelok",
  "tuesday": "utorok",
  "wednesday": "streda",
  "thursday": "štvrtok",
  "friday": "piatok",
  "saturday": "sobota",
  "january": "januára",
  "february": "februára",
  "march": "marca",
  "april": "apríla",
  "may": "mája",
  "june": "júna",
  "july": "júla",
  "august": "augusta",
  "september": "septembra",
  "october": "októbra",
  "november": "novembra",
  "december": "decembra",
  "1st week": "1. týždeň",
  "2nd week": "2. týždeň",
  "3rd week": "3. týždeň",
  "4th week": "4. týždeň",
  "5th week": "5. týždeň",
  "1st quarter": "1. štvrťrok",
  "2nd quarter": "2. štvrťrok",
  "3rd quarter": "3. štvrťrok",
  "4th quarter": "4. štvrťrok",
  "edit_task": "Upraviť úlohu",
  "created_at": "Vytvorené o",
  "installed_at": "Nainštalované na",
  "hour": "hodina",
  "week_days": "Týždenné dni",
  "month_weeks": "Mesiac týždne",
  "month_days": "Mesiac dni",
  "no_tasks_found": "Nenašli sa žiadne úlohy",
  "invalid_language": "Neplatný jazyk",
  "no_active_tasks_found": "Nenašli sa žiadne aktívne úlohy",
  "edit": "Upraviť",
  "send_date": "Dátum odoslania",
  "invalid_date": "Neplatný dátum",
  "hour_must_be_after_current": "Vyberte hodinu, ktorá je po aktuálnom čase",
  "cells_num": "Bunky #",
  "sinks_num": "Umývadlá č.",
  "urinals_num": "Pisoáre č.",
  "toilet_paper_size": "Veľkosť toaletného papiera",
  "email_configuration": "Konfigurácia e-mailu",
  "please_edit_the_email_information": "Upravte e-mailové informácie",
  "email_sender_info": "Informácie o odosielateľovi e-mailu",
  "email_subject_info": "Informácie o predmete e-mailu",
  "email_message_info": "Informácie o e-mailovej správe",
  "companyName": "Názov spoločnosti",
  "email_language": "Jazyk e-mailu",
  "complaint_language": "Jazyk sťažností",
  "email_message_format": "Formát e-mailovej správy",
  "line": "Linka",
  "list": "Zoznam",
  "roomType": "Typ izby",
  "By logging in, you agree to Buzzztech's": "Prihlásením súhlasíte s Buzzztech's",
  "Terms and Conditions": "Zmluvné podmienky",
  "and": "A",
  "Privacy Policy": "Zásady ochrany osobných údajov",
  "All actions within this panel are recorded for quality control and improvement": "Všetky akcie v rámci tohto panelu sa zaznamenávajú kvôli kontrole a zlepšovaniu kvality",
  "You must agree to the terms and conditions": "Musíte súhlasiť so zmluvnými podmienkami",
  "months": "Mesiace",
  "ref_id": "Referenčné ID",
  "room_name_en": "Názov izby v angličtine",
  "site_state": "Stav lokality",
  "site_city": "Mesto lokality",
  "city": "Mesto",
  "state": "štátu",
  "site_country": "Krajina lokality",
  "first_date": "Prvé rande",
  "pinned": "Pripnuté",
  "no.": "Nie",
  "must_be_numbers": "Musia to byť čísla",
  "must_be_3_digits": "Musí mať 3 číslice",
  "must_have_english_title": "Musí mať anglický názov",
  "total_sites": "Celkom",
  "site_information": "Informácie o lokalite",
  "holiday_offdays": "Sviatky a voľné dni",
  "add_offday": "Deň voľna",
  "add_holiday": "Dovolenka",
  "name_under_chars": "Meno do 25 znakov",
  "days_comma_separated": "Platné dni oddelené čiarkou",
  "year": "rok",
  "month": "mesiac",
  "day": "deň",
  "holiday_name": "Názov dovolenky",
  "offday_name": "Meno dňa voľna",
  "delete_confirmation_title": "si si istý?",
  "delete_confirmation_message": "Túto akciu nie je možné vrátiť späť.",
  "are_you_sure": "si si istý?",
  "israel": "Izrael",
  "USA": "USA",
  "poland": "Poľsko",
  "mexico": "Mexiko",
  "cyprus": "Cyprus",
  "brazil": "Brazília",
  "romania": "Rumunsko",
  "netherlands": "Holandsko",
  "tablet_survey": "Tabletový prieskum",
  "no_shift_survey": "Žiadny prieskum týkajúci sa tabletu",
  "number_of_rows": "Počet riadkov",
  "rating_shape": "Tvar hodnotenia",
  "content_survey": "Prieskum obsahu",
  "rating_survey": "Hodnotiaci prieskum",
  "device-alerts": "Problém",
  "device-active": "Aktívne",
  "device-search": "Hľadať",
  "mac_id": "MAC adresu",
  "qr_tag": "QR tag",
  "sensor": "Senzor",
  "image_survey": "Obrazový prieskum",
  "open_text": "Otvorte text",
  "open_text_survey": "Otvoriť textový prieskum",
  "embedded_link": "Vložený odkaz",
  "device-counter": "Počítadlo",
  "count": "počítať",
  "last_date": "Posledný dátum",
  "last_arrival": "Posledný príchod čistejšieho",
  "cleaners": "Čistiace prostriedky",
  "viewer": "Divák",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "Nenašli sa žiadni používatelia",
  "no_cleaners_found": "Nenašli sa žiadne čistiace prostriedky",
  "new_cleaner": "Nový čistič",
  "edit_cleaner": "Upraviť čistič",
  "have_you_finished_making_changes": "Dokončili ste vykonávanie zmien?",
  "assignment_issues_found": "Našli sa problémy s priradením",
  "unassigned_rooms_title": "Nepriradené miestnosti",
  "overlapping_assignments_title": "Prekrývajúce sa priradenia",
  "and_n_more": "a ďalších {count}",
  "continue_anyway": "Aj tak pokračovať",
  "stay_and_fix": "Zostať a opraviť",
  "assignment_coverage_issues": "{unassigned} nepriradené · {overlaps} prekrytia",
  "assignment_check_failed": "Nepodarilo sa overiť priradenia miestností",
  "tap_for_details": "Klepnite pre podrobnosti",
  "has_app": "Aplikácia",
  "has_app_tooltip": "Upratovač má aplikáciu",
  "notifications_tooltip": "Push oznámenia sú zapnuté",
  "assigned_to_rooms": "Priradený k miestnostiam",
  "assigned_to_rooms_tooltip": "Má miestnosti na tomto mieste",
  "recently_active": "Nedávno aktívny",
  "works_at_site": "Pracuje na mieste",
  "recently_active_tooltip": "Otvoril aplikáciu za posledných 30 minút",
  "please_select": "Vyberte",
  "please_select_site_first": "Najprv vyberte lokalitu",
  "working_areas": "Pracovné oblasti",
  "no_working_areas": "Zatiaľ žiadne pracovné oblasti",
  "working_area_alerts": "Upozornenia",
  "api": "API",
  "task_target_by_working_areas": "Podľa pracovných oblastí (všetky miestnosti vo vybraných oblastiach)",
  "task_target_by_rooms": "Podľa konkrétnych miestností",
  "task_target_label": "Úloha sa otvorí",
  "step_what": "Čo?",
  "step_when": "Kedy",
  "step_where": "Kde",
  "step_options": "Možnosti",
  "please_create_room_before_working_area": "Pred vytvorením pracovnej oblasti vytvorte aspoň jednu miestnosť",
  "isWorkingInSite": "Práca na mieste",
  "you_are_not_allowed_to_edit": "Nemáte povolené upravovať",
  "you_are_not_allowed_to_remove": "Nemáte povolené odstraňovať",
  "task": "Úloha",
  "portuguese": "portugalčina",
  "russian": "ruský",
  "spanish": "španielčina",
  "polish": "poľský",
  "installer": "Inštalátor",
  "once": "Raz",
  "time_saved": "Čas ušetrený",
  "yes": "áno",
  "no": "Nie",
  "workingAreaNames": "Názvy pracovných oblastí",
  "shift_rooms": "Izby",
  "shift_validation_overlap": "Tento posun sa prekrýva s „{shiftName}“ v miestnosti „{roomName}“. Odstráňte miestnosť z jednej zo zmien alebo upravte ich otváraciu dobu.",
  "shift_validation_missing_fields": "Vyplňte všetky povinné polia pre zmenu (hodiny, dni a miesto).",
  "shift_validation_empty_rooms": "Priraďte k tejto zmene aspoň jednu miestnosť.",
  "shift_validation_no_valid_rooms": "Pre túto zmenu nie sú vybraté žiadne platné miestnosti.",
  "shift_validation_empty_room_map": "Nepodarilo sa zostaviť rozvrh zmien. Skontrolujte vybrané dni a hodiny.",
  "new_shift": "Nová zmena",
  "add_shift_inactive": "Pridajte reflexné posuny",
  "remove_auto_shift_inactive": "Odstráňte automatické reflexné posuny",
  "additional_options": "Ďalšie možnosti",
  "add_default_shifts": "Pridať predvolené posuny",
  "no_user_found": "Nenašiel sa žiadny používateľ",
  "no_site_found": "Nenašli sa žiadne stránky",
  "open_complaints": "Otvorte Sťažnosti",
  "site_alerts": "Upozornenia na stránky",
  "open_sla_alerts": "Otvorte upozornenia na sťažnosti",
  "open_duration": "Trvanie otvorenia",
  "no_open_slas": "Nenašli sa žiadne otvorené zmluvy SLA",
  "no_open_slas_description": "Momentálne neexistujú žiadne lokality s otvorenými zmluvami SLA.",
  "no_slas_to_send": "Pre túto lokalitu sa nenašli žiadne otvorené zmluvy SLA",
  "total_open_complaints": "Celkový počet otvorených sťažností",
  "longest_duration": "Najdlhšie trvanie",
  "complaints_details": "Podrobnosti o sťažnostiach",
  "rooms_with_open_complaints_percentage": "Izby s otvorenými sťažnosťami",
  "rooms_with_cleaner_arrival_percentage": "Izby s čistejším príchodom",
  "rooms_without_cleaner_arrival_percentage": "Izby bez príchodu čistejšieho",
  "site_alerts_total_rooms": "Celkový počet izieb",
  "site_alerts_open_complaints_count": "Počet otvorených sťažností",
  "site_alerts_customer_opening_date": "Dátum otvorenia zákazníka",
  "company_country": "Krajina spoločnosti",
  "select_message": "Vyberte položku Správa",
  "message_no_cleaner_arrival": "Ahojte všetci,\nUpozorňujeme, že v niektorých izbách dnes nebol nahlásený príchod čistejšieho.\nVyriešte to prosím",
  "message_open_complaints": "Ahojte všetci,\nUpozorňujeme, že existuje niekoľko izieb s otvorenými sťažnosťami na dlhú dobu.\nVyriešte to prosím",
  "rooms_list": "Izby:",
  "please_address_issues_promptly": "Vyriešte tieto problémy urýchlene.",
  "no_results_found": "Nenašli sa žiadne výsledky",
  "showing": "Zobrazuje sa",
  "per_page": "Na stránku",
  "whatsapp": "WhatsApp",
  "loading": "Načítava sa",
  "error_opening_whatsapp": "Chyba pri otváraní WhatsApp. Skúste to znova.",
  "error_loading_slas": "Chyba pri načítavaní podrobností SLA. Skúste to znova.",
  "send_whatsapp": "Odoslať WhatsApp",
  "preview_message": "Ukážka správy",
  "copy_message": "Kopírovať správu",
  "message_preview": "Ukážka správy",
  "phone_number_optional": "Telefónne číslo (voliteľné)",
  "enter_phone_number": "Zadajte telefónne číslo (napr. +1234567890)",
  "phone_number_hint": "Ak chcete otvoriť WhatsApp bez konkrétneho kontaktu, nechajte prázdne",
  "message_copied": "Správa bola skopírovaná do schránky!",
  "error_copying_message": "Chyba pri kopírovaní správy. Skúste to znova.",
  "opening_whatsapp": "Otvára sa WhatsApp...",
  "preview_message_description": "Pred odoslaním si správu zobrazte a upravte",
  "copy_message_description": "Skopírujte správu do schránky",
  "service_provider": "Poskytovateľ služieb",
  "qr task": "QR úloha",
  "qr_task": "QR úloha",
  "all_day": "Celý deň",
  "auto_start": "Automatický štart",
  "more_options": "Viac možností",
  "english_title": "anglický názov",
  "connectivity": "Konektivita",
  "power": "Sila",
  "Your work has been saved": "Vaša práca bola uložená",
  "schedule_call_time": "Naplánujte čas hovoru",
  "schedule_call_gap": "Naplánujte medzeru medzi hovormi",
  "gapInMinutes": "Medzera za pár minút",
  "no_manual_calls_available": "Nie sú k dispozícii žiadne manuálne hovory",
  "manual_calls": "Manuálne hovory",
  "cleandexCalls": "Hovory Cleandex",
  "manualCalls": "Manuálne hovory",
  "inactive": "Neaktívne",
  "on hold": "Podržané",
  "sequential": "Sekvenčné",
  "ratio": "Pomer",
  "must_choose": "Treba si vybrať",
  "surveyApp": "Prieskumná aplikácia",
  "installation": "Inštalácia",
  "manager": "manažér",
  "previous": "Predchádzajúce",
  "no_rooms_found": "Nenašli sa žiadne izby",
  "show_calendar": "Zobraziť kalendár",
  "seeAll": "Zobraziť všetky",
  "showPaginated": "Zobraziť stránkované",
  "cleaners_arrivals": "Príchody upratovačiek",
  "qr validator": "QR validátor",
  "qr_validator": "QR validátor",
  "searchAddress": "Vyhľadajte adresu",
  "sector": "Sektor",
  "add_address": "Pridať adresu",
  "site_auto_attendance_enabled": "Povoľte automatické prihlásenie a odhlásenie pomocou geofence mobilnej aplikácie (zamestnanci potrebujú povolenie aplikácie a polohy).",
  "site_auto_attendance_requires_location": "Pred povolením automatickej dochádzky najprv nastavte polohu na mape (špendlík a polomer aspoň 100 m).",
  "site_mandatory_clock_in": "Vyžadovať zaznamenanie príchodu pred prácou",
  "site_mandatory_clock_in_description": "Zamestnanci na tomto mieste musia zaznamenať príchod, než budú môcť otvoriť karty úklidu, údržby a úloh v mobilnej aplikácii.",
  "site_mandatory_clock_in_without_location": "Toto miesto nemá polohu na mape, takže aplikácia nerozpozná, kedy je zamestnanec na mieste. Kým ju nenastavíte, požiadavka platí pre týchto zamestnancov všade.",
  "auto_attendance": "Automatická dochádzka",
  "auto_attendance_ready": "Pripravený",
  "auto_attendance_off": "Vypnuté",
  "auto_attendance_needs_setup": "Vyžaduje nastavenie",
  "auto_attendance_ready_tooltip": "Prepínač je zapnutý, polomer geografického plotu ≥ 100 m, pripravený na automatické zapnutie/vypnutie.",
  "auto_attendance_off_tooltip": "Prepínač je vypnutý. Upravte stránku, aby ste povolili automatickú dochádzku.",
  "auto_attendance_needs_setup_tooltip": "Prepínač je zapnutý, ale geofence chýba alebo je pod minimom 100 m. Upravte web a opravte ho.",
  "edit_address": "Upraviť adresu",
  "choose_radius": "Vyberte polomer",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "Zelená = OK. Červená = Odporúča sa čistiť.\nPodrobnosti zobrazíte umiestnením kurzora myši na ikonu bunky.",
  "recommended_to_clean": "Odporúča sa čistiť",
  "cleandex_warning_level": "Úroveň varovania Cleandex",
  "select_warning_level": "Vyberte úroveň varovania",
  "bronze": "Bronzová",
  "silver": "Strieborná",
  "gold": "Zlato",
  "ai": "AI",
  "daily_employees_num": "Denný počet zamestnancov",
  "daily_shift_hours": "Hodiny dennej zmeny",
  "rooms_num": "Číslo izieb",
  "buildings_num": "Číslo budovy",
  "cleaner_entries": "Čistejšie záznamy",
  "avg_daily_visits_monthly": "Priem. denné návštevy za mesiac",
  "avg_daily_cleaners_to_save": "Priem. denné čistiace prostriedky na úsporu",
  "saving_hours_per_day": "Úspora hodín denne",
  "saving_money_per_day": "Úspora peňazí za deň",
  "saving_money_per_month": "Úspora peňazí za mesiac",
  "cleaners_to_visitors_ratio": "Pomer upratovačiek a návštevníkov",
  "cleaning_time_in_minutes_per_room": "Čas čistenia v minútach na izbu",
  "max_number_of_rooms_per_employee": "Maximálny počet izieb na zamestnanca",
  "break_time_per_hour": "Prestávka za hodinu",
  "transition_time_between_tasks": "Čas prechodu medzi úlohami",
  "employer_cost_hour": "Náklady zamestnávateľa na hodinu",
  "lobby_cleaning_per_floor": "Čistenie haly na poschodí",
  "desired_cleaning_time": "Požadovaný čas čistenia",
  "desired_number_of_entries": "Požadovaný počet záznamov",
  "buzz_system_cost_per_unit_per_month": "Cena systému Buzz na jednotku za mesiac",
  "total_buzz_system_cost_per_month": "Celkové náklady na systém Buzz za mesiac",
  "return_on_investment_in_months": "Návratnosť investície v mesiacoch",
  "annual_savings": "Ročné úspory",
  "roi_calculator": "Kalkulačka návratnosti investícií",
  "cleaning_work_plan": "Plán upratovacích prác",
  "cleaning_work_plan_intro": "Použije štatistiku zmenární pre spoločnosť a lokalitu v hlavičke. Návštevy a príchody pochádzajú z jedného dňa s najvyšším počtom návštev stránok v rámci rozsahu dátumov a posuny z filtra informačného panela (nastavte ich na Výkonnosť alebo Analytics, ak táto karta skrýva ovládacie prvky času a filtra). Zadajte návštevy na upratovanie, počet zamestnancov, hodinové náklady a priemerné minúty na upratovanie; vygenerujte, aby ste videli navrhované upratovania na úrovni miestnosti a súhrnné súčty.",
  "cleaning_work_plan_default_n": "Návštevy za čistenie",
  "cleaning_work_plan_cleaner_count": "Čistiace prostriedky (voliteľné)",
  "cleaning_work_plan_avg_minutes": "Priemerný čas čistenia (min)",
  "cleaning_work_plan_run": "Vytvorte plán",
  "cleaning_work_plan_export_csv": "Exportovať Excel",
  "cleaning_work_plan_suggested_n": "Návštevy za čistenie",
  "cleaning_work_plan_actual_cleans": "Prílety",
  "cleaning_work_plan_actual_cleans_hint": "Celkový počet príchodov čističov v štatistikách miestností na zmeny v deň špičky (v rámci zvoleného rozsahu a filtrov).",
  "cleaning_work_plan_suggested_cleans": "Odporúčané čistenie",
  "cleaning_work_plan_cleaner": "Čistič",
  "cleaning_work_plan_floors": "Podlahy",
  "cleaning_work_plan_peak_day": "Vrcholový deň",
  "cleaning_work_plan_error": "Nepodarilo sa vygenerovať pracovný plán čistenia",
  "cleaning_work_plan_no_rooms": "Pre túto stránku neboli vrátené žiadne izby. Skontrolujte lokalitu a rozsah dátumov alebo overte existenciu miestností na ovládacom paneli.",
  "cleaning_work_plan_need_filter": "Vyberte spoločnosť a web v hlavičke, nastavte rozsah dátumov (a v prípade potreby aj posuny) na stránke Výkonnosť alebo Analytics a skúste to znova.",
  "cleaning_work_plan_settings": "Nastavenia plánu",
  "cleaning_work_plan_desired_employees": "Požadovaný počet zamestnancov",
  "cleaning_work_plan_cost_per_hour": "Cena za hodinu",
  "cleaning_work_plan_estimated_cost_suggested": "Odhadované náklady (odporúčané pracovné zaťaženie)",
  "cleaning_work_plan_estimated_cost_actual": "Odhadované náklady (skutočné pracovné zaťaženie)",
  "cleaning_work_plan_hours_per_cleaner": "Hodiny na upratovačku",
  "cleaning_work_plan_metric_title": "Metrické",
  "cleaning_work_plan_metric_avg_cleaning_min": "Priem. čas čistenia (min)",
  "cleaning_work_plan_metric_total_arrivals": "Celkový počet príchodov",
  "cleaning_work_plan_metric_total_cleaning_min": "Celkový čas čistenia (min)",
  "cleaning_work_plan_metric_total_cleaning_hours": "Celkový čas čistenia (hodiny)",
  "cleaning_work_plan_metric_hours_per_cleaner_row": "Hodiny na upratovačku",
  "cleaning_work_plan_metric_num_cleaners": "Počet čistiacich prostriedkov",
  "cleaning_work_plan_summary": "Zhrnutie",
  "cleaning_work_plan_summary_peak_note": "Návštevy, príchody a navrhované upratovania používajú rovnaké pravidlá štatistiky miestností ako služba Analytics (vrátane agregácie príchodov). Sú určené pre špičkový deň – kalendárny deň s najvyššími návštevami stránok v období filtra. Zahrnuté sú iba vypočítané miestnosti, napríklad prehľad, keď nie je použitý žiadny filter miestností.",
  "cleaning_work_plan_summary_filter_period": "Obdobie filtrovania",
  "cleaning_work_plan_summary_total_visits": "Celkový počet návštev",
  "cleaning_work_plan_summary_total_arrivals": "Celkový počet príchodov",
  "cleaning_work_plan_summary_employees_in_site": "Zamestnanci na mieste",
  "cleaning_work_plan_summary_shift_working_hours": "Pracovná doba na smeny",
  "cleaning_work_plan_hours_unit": "h",
  "cleaning_work_plan_rooms_table": "Izby",
  "cleaning_work_plan_cleaners_table": "Odporúčané pridelenie čističa",
  "cleaning_work_plan_search_rooms": "Vyhľadajte miestnosti",
  "cleaning_work_plan_total_minutes": "Celkový počet minút",
  "cleaning_work_plan_actual_total_minutes": "Skutočný celkový počet minút",
  "cleaning_work_plan_actual_total_minutes_hint": "Zaznamenané príchody upratovačiek v štatistikách zmenární v deň špičky (v rámci zvoleného rozsahu), vynásobené vaším priemerným počtom minút na upratovanie.",
  "cleaning_work_plan_suggested_total_minutes": "Odporúčaný celkový počet minút",
  "cleaning_work_plan_suggested_room_minutes": "Odporúčané minúty čistenia",
  "cleaning_work_plan_actual_room_minutes": "Skutočné minúty čistenia",
  "cleaning_work_plan_cleaner_suggested_minutes": "Odporúčaná min.",
  "cleaning_work_plan_cleaner_actual_minutes": "Skutočná min.",
  "cleaning_work_plan_period": "Obdobie",
  "cleaning_work_plan_room_count": "Počet izieb",
  "cleaning_work_plan_cleaners_working_in_site": "Upratovačky pracujúce na mieste (kontakty aplikácie)",
  "cleaning_work_plan_cleaners_connection_table": "Upratovačky podľa izieb",
  "cleaning_work_plan_connected_rooms_count": "Izby",
  "cleaning_work_plan_connected_floor_count": "Počet poschodí",
  "cleaning_work_plan_connected_floors_list": "Podlahy",
  "cleaning_work_plan_visitor_cleaning_entry_ratio": "Pomer vstupného návštevníka/upratovania",
  "cleaning_work_plan_performance_comparison_table": "Porovnanie výkonu",
  "cleaning_work_plan_performance_comparison_empty": "Načítajte čistejšie údaje o pripojení, aby ste videli porovnávacie riadky.",
  "cleaning_work_plan_performance_col_index": "Index",
  "cleaning_work_plan_performance_existing_plan": "Existujúci pracovný plán",
  "cleaning_work_plan_performance_recommended_plan": "Plán odporúčaný spoločnosťou Buzzztech",
  "cleaning_work_plan_perf_number_of_employees": "Počet zamestnancov",
  "cleaning_work_plan_perf_working_hours_per_employee": "Pracovný čas na zamestnanca",
  "cleaning_work_plan_perf_total_working_hours": "Celkový pracovný čas",
  "cleaning_work_plan_perf_total_cleaning_hours": "Celkový počet hodín čistenia",
  "cleaning_work_plan_perf_daily_cost": "Denné náklady",
  "cleaning_work_plan_perf_total_cleaning_visits": "Celkové upratovacie návštevy",
  "cleaning_work_plan_perf_busiest_area_visits": "Najrušnejšia pracovná oblasť — návštevy",
  "cleaning_work_plan_perf_cleaning_to_busiest": "Upratovacie návštevy v najrušnejšej oblasti",
  "cleaning_work_plan_perf_max_cleaning_ratio": "Maximálny čistiaci pomer",
  "cleaning_work_plan_perf_least_busy_visits": "Najmenej rušná pracovná oblasť — návštevy",
  "cleaning_work_plan_perf_cleaning_to_least": "Upratovacie návštevy v najmenej frekventovanej oblasti",
  "cleaning_work_plan_perf_min_cleaning_ratio": "Minimálny čistiaci pomer",
  "cleaning_work_plan_ai_allocate": "Prideliť AI",
  "cleaning_work_plan_ai_allocation_result": "Výsledok pridelenia AI",
  "cleaning_work_plan_ai_allocation_loading": "Generuje sa pridelenie AI...",
  "cleaning_work_plan_ai_allocation_error": "Nepodarilo sa vygenerovať pridelenie AI. Skúste to znova.",
  "cleaning_work_plan_ai_invalid_employees": "Nastavte platný požadovaný počet zamestnancov.",
  "cleaning_work_plan_ai_status_elapsed": "Uplynulo: {s} s",
  "cleaning_work_plan_ai_status_hint": "Server spustí niekoľko krokov AI za sebou (počiatočný plán, geografia, bilancia návštev, potom konečný výstup). Môže to trvať jednu až dve minúty – nechajte túto stránku otvorenú.",
  "cleaning_work_plan_ai_status_step_1": "Krok 1 – vypracovanie úvodnej úlohy z údajov o miestnosti a návšteve…",
  "cleaning_work_plan_ai_status_step_2": "Krok 2 — dolaďovanie geografie (zoskupovanie blízkych poschodí a budov)…",
  "cleaning_work_plan_ai_status_step_3": "Krok 3 – vyváženie denných návštev medzi upratovačkami…",
  "cleaning_work_plan_ai_status_step_4": "Krok 4 – generovanie štruktúrovanej alokácie…",
  "cleaning_work_plan_ai_status_step_5": "Krok 5 – overenie a výpočet konečných metrík…",
  "cleaning_work_plan_ai_cleaner_number": "Čistič č.",
  "cleaning_work_plan_room_minutes": "Minúty čistenia",
  "cleaning_work_plan_assigned_cleaner": "Pridelený čistič",
  "cleaning_work_plan_summary_cleaners": "Čistiace prostriedky v pláne",
  "cleaning_work_plan_summary_avg_minutes": "Priem. minúty / čisté",
  "cleaning_work_plan_suggested_hours": "Navrhovaný celkový počet hodín",
  "cleaning_work_plan_actual_hours": "Skutočný celkový počet hodín",
  "cleaning_work_plan_avg_suggested_min_per_cleaner": "Priem. navrhovaný min / čistejší",
  "cleaning_work_plan_avg_actual_min_per_cleaner": "Priem. skutočný min / čistejší",
  "cleaning_work_plan_guidelines_title": "Pokyny na optimalizáciu",
  "cleaning_work_plan_guidelines_intro": "Tento nástroj sleduje rovnaké ciele ako manuálna optimalizácia plánu čistenia: pracovné zaťaženie na základe údajov o návšteve, čas z vašich priemerných minút na upratovanie a personálne obsadenie, ktoré vyvažuje prácu a zároveň udržiava podlahy geograficky rozumné.",
  "cleaning_work_plan_guidelines_b1": "Počet návštev na upratovanie (predvolených 50) zodpovedá obvyklému pravidlu v štýle 1:50: navrhované záznamy na izbu ≈ návštevy ÷ návštevy na upratovanie (zaokrúhlené nahor). Návštevy a príchody sa berú z najrušnejšieho dňa (najvyššie návštevy stránok) v rámci zvoleného rozsahu dátumov, takže plán zodpovedá dňu s najvyšším zaťažením.",
  "cleaning_work_plan_guidelines_b2": "Keď nastavíte počet čistejších, každé poschodie budovy je jedna skupina. Poschodia sú usporiadané podľa budovy a čísla poschodia, potom rozdelené na susediace bloky medzi čističmi, takže navrhované čistenie (implicitná práca) je vyvážené, zatiaľ čo okolité podlahy majú tendenciu zostať na rovnakom čističi.",
  "cleaning_work_plan_guidelines_b3": "Všetky toalety na tom istom poschodí budovy zostávajú s tou istou upratovačkou, takže mužské a ženské izby na tomto poschodí nie sú rozdelené medzi rôzne upratovačky (pokiaľ zdieľajú rovnakú hodnotu podlahy na ovládacom paneli).",
  "cleaning_work_plan_guidelines_b4": "Navrhovaný priemerný počet minút na čisté disky a skutočný celkový počet minút, hodín a priemerný počet minút na čistenie. Skutočné súčty používajú zaznamenané príchody čistejších × váš priemer; navrhované súčty používajú implicitné čistenie × váš priemer.",
  "cleaning_work_plan_guidelines_b5": "Použite Exportovať CSV, ak chcete spresniť pridelenie inde (napríklad ešte viac sprísniť zostatok návštev).",
  "cleaners_number": "Číslo čističa",
  "floors_num": "Číslo poschodí",
  "avg_daily_cleaners_required": "Vyžaduje sa priemerný denný počet čistiacich prostriedkov",
  "app_pages": "Stránky aplikácie",
  "buzzzTime": "Čas buzzu",
  "missions": "Misie",
  "send_emails": "Posielajte e-maily",
  "enter": "Zadajte",
  "account": "účtu",
  "privacy": "Ochrana osobných údajov",
  "personal_settings": "Osobné nastavenia",
  "personal_settings_lead": "Spravujte svoj jazyk a predvoľby ochrany osobných údajov.",
  "personal_settings_read_only": "Tieto podrobnosti spravuje váš správca. Kontaktujte ich, ak je potrebné niečo aktualizovať.",
  "change_password": "Zmeniť heslo",
  "change_password_hint": "Zmena hesla vás odhlási z ostatných zariadení.",
  "current_password": "Aktuálne heslo",
  "new_password": "Nové heslo",
  "confirm_new_password": "Potvrďte nové heslo",
  "password_min_length": "Heslo musí mať aspoň 8 znakov",
  "passwords_do_not_match": "Heslá sa nezhodujú",
  "new_password_same_as_current": "Nové heslo sa musí líšiť od aktuálneho",
  "current_password_incorrect": "Aktuálne heslo je nesprávne",
  "current_password_required": "Aktuálne heslo je povinné",
  "password_changed_successfully": "Heslo bolo úspešne zmenené",
  "change_password_failed": "Heslo sa nepodarilo zmeniť",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "Nesprávne používateľské meno alebo heslo",
  "login_credentials_required": "Zadajte používateľské meno alebo e-mail a heslo",
  "login_network_error": "Nepodarilo sa spojiť so serverom. Skontrolujte pripojenie a skúste znova",
  "login_failed": "Prihlásenie zlyhalo. Skúste znova",
  "login_too_many_attempts": "Príliš veľa pokusov o prihlásenie. Počkajte 15 minút a skúste znova.",
  "forgot_password_too_many": "Príliš veľa žiadostí o obnovenie hesla. Počkajte hodinu a skúste znova.",
  "reset_password_too_many": "Príliš veľa pokusov o obnovenie hesla. Počkajte hodinu a skúste znova.",
  "change_password_too_many": "Príliš veľa pokusov o zmenu hesla. Počkajte 15 minút a skúste znova.",

  "personal_settings_language_hint": "Platí pre celý portál pre tento prehliadač.",
  "personal_settings_privacy_hint": "Požiadajte o vymazanie svojich osobných údajov podľa platných zákonov o ochrane osobných údajov.",
  "personal_settings_export_hint": "Stiahnite si čitateľnú kópiu JSON osobných údajov, ktoré o vás uchovávame: váš portálový profil, lokality, ku ktorým máte prístup, a váš prepojený profil mobilnej aplikácie (ak sa váš telefón zhoduje). Obmedzený vývoz za deň.",
  "Download my data": "Stiahnite si moje údaje",
  "personal_settings_role": "Role",
  "Request deletion of my data": "Požiadať o vymazanie mojich údajov",
  "Request deletion of my data - confirm": "Požiadať o vymazanie mojich údajov? Správcovi bude odoslaný e-mail. Vašu žiadosť spracujeme do 30 dní.",
  "Request deletion of my data - success": "Žiadosť odoslaná. Spracujeme do 30 dní.",
  "Request deletion of my data - error": "Žiadosť sa nepodarilo odoslať. Skúste to znova alebo pošlite e-mail na adresu privacy@buzzztech.com.",
  "metrics": "Metriky",
  "select_three_metrics": "Vyberte až 3 metriky na porovnanie",
  "select_four_metrics": "Vyberte až 4 metriky na porovnanie",
  "legend": "Legenda",
  "more_details": "Viac podrobností",
  "performance_overview": "Prehľad výkonnosti",
  "loading_chart": "Načítava sa graf",
  "retry": "Skúste to znova",
  "performance_trending_upward": "Výkon má stúpajúcu tendenciu",
  "high_complaint_ratio": "Vysoký pomer sťažností",
  "click_bars_for_details": "Kliknutím na pruhy získate hĺbkovú analýzu dennej analýzy",
  "refresh": "Obnoviť",
  "table": "Tabuľka",
  "cards": "karty",
  "no_recent_arrivals": "Žiadne nedávne príchody",
  "feedback_charts": "Grafy spätnej väzby",
  "general_overview": "Všeobecný prehľad",
  "cleaning_complaints_breakdown": "Rozpis sťažností na čistenie",
  "maintenance_complaints_breakdown": "Rozdelenie sťažností na údržbu",
  "refresh_failed": "Obnovenie zlyhalo",
  "data_exported_successfully": "Údaje boli úspešne exportované",
  "data_export_failed": "Export údajov zlyhal",
  "drill_down_unavailable": "Rozbalenie je k dispozícii iba pre denné zobrazenie",
  "sort_by": "Zoradiť podľa",
  "no_active_shift": "Žiadna aktívna zmena",
  "check_site_and_shift": "Skontrolujte, či je vybratá lokalita a či má aktívnu zmenu",
  "please_add_shift_first": "Najprv pridajte posun",
  "cleandex_no_data_message": "Momentálne nie sú dostupné žiadne údaje cleandex",
  "task_no_data_message": "Momentálne nie sú k dispozícii žiadne údaje o úlohe",
  "navigation": "Navigácia",
  "network_information": "Informácie o sieti",
  "target_effectiveness": "Cieľová účinnosť",
  "cleandex_call_cleaner": "Cleandex čistič hovorov",
  "top_complaint": "Najvyššia sťažnosť",
  "no_complaints": "Žiadne sťažnosti",
  "official_start_date": "Oficiálny dátum začiatku",
  "note_text": "Text poznámky",
  "add_note": "Pridať poznámku",
  "general_note": "Všeobecná poznámka",
  "general_note_short": "generál",
  "battery_short": "Batéria",
  "panel_short": "Panel",
  "technician_short": "Technik",
  "battery_replacement": "Výmena batérie",
  "device_maintenance": "Údržba zariadenia",
  "maintenance_type": "Typ údržby",
  "panel_change": "Zmena panela",
  "technician_check": "Kontrola technikom",
  "enter_note_details": "Zadajte podrobnosti poznámky",
  "replacement_date": "Náhradný termín",
  "replaced_by_name": "Nahradené menom",
  "replacement_note": "Náhradná poznámka",
  "enter_replacement_details": "Zadajte podrobnosti o náhrade",
  "replacement_history": "História výmeny",
  "loading_history": "História načítavania",
  "no_replacement_history": "Nie je k dispozícii žiadna história výmen",
  "enter_technician_name": "Zadajte meno technika",
  "prefilled_from_account": "Predvyplnené z vášho účtu – môžete upraviť",
  "user_information": "Informácie o používateľovi",
  "enter_change_details": "Zadajte podrobnosti zmeny",
  "panel_change_history": "História zmien panela",
  "check_date": "Skontrolujte dátum",
  "checked_by_name": "Skontrolované podľa mena",
  "enter_check_details": "Zadajte podrobnosti o kontrole",
  "technician_check_history": "Technik kontroluje históriu",
  "no_technician_check_history": "Nie je k dispozícii žiadna história kontrol technika",
  "change_date": "Zmeniť dátum",
  "changed_by_name": "Zmenené podľa mena",
  "change_note": "Zmeniť poznámku",
  "check_note": "Skontrolujte poznámku",
  "replaced_by": "Nahradené používateľom",
  "no_data_entered": "Nie sú zadané žiadne údaje",
  "no_panel_change_history": "Nie je k dispozícii žiadna história zmien panela",
  "invalid_username": "Neplatné používateľské meno",
  "invalid_phone": "Neplatné telefónne číslo",
  "username_must_be_at_least_5_characters": "Používateľské meno musí mať aspoň 5 znakov",
  "data_loading_please_wait": "Údaje sa práve načítavajú. Čakajte prosím...",
  "dates_not_changed": "Dátumy sa nezmenili. Nie je potrebné opätovné načítanie.",
  "date_outside_stats_range": "Vybrané dátumy sú mimo dostupného rozsahu štatistík.",

  "date_range_invalid": "Dátum „do“ musí byť rovnaký alebo neskorší ako dátum „Od“.",
  "filter_help_text": "Pravidlá filtrovania: Ak chcete povoliť filter poschodia, najprv vyberte položku Budova. Väčšina filtrov podporuje viacnásobný výber.",
  "select_building_first": "Ak chcete aktivovať filter poschodí, vyberte najprv budovu",
  "cannot_select_gender_with_rooms": "Pri výbere miestností nie je možné vybrať typ miestnosti",
  "cannot_select_gender_with_rooms_tooltip": "Pri výbere miestností nie je možné použiť filter typu miestnosti. Najprv vymažte výber miestností.",
  "cannot_select_building_with_rooms": "Keď sú vybraté miestnosti, nie je možné vybrať budovu",
  "cannot_select_building_with_rooms_tooltip": "Filter budovy nemožno použiť, keď sú vybraté miestnosti. Najprv vymažte výber izieb.",
  "multi_select_hint": "Môžete vybrať viacero možností",
  "filter_applied": "Filter bol úspešne použitý",
  "no_filters_selected": "Nie sú vybraté žiadne filtre. Vyberte aspoň jednu možnosť filtra.",
  "filters": "Filtre",
  "location": "Poloha",
  "attributes": "Atribúty",
  "applying": "Uplatňuje sa...",
  "active_filters": "Aktívne filtre",
  "viewing_room": "Prehliadková miestnosť",
  "multiple": "Viacnásobné",
  "close": "Zavrieť",
  "save_replacement": "Uložiť výmenu",
  "save_change": "Uložiť zmenu",
  "save_check": "Uložiť šek",
  "failed_to_load_maintenance_history": "Nepodarilo sa načítať históriu údržby",
  "Battery replacement recorded successfully": "Výmena batérie bola úspešne zaznamenaná",
  "Panel change recorded successfully": "Zmena panelu bola úspešne zaznamenaná",
  "Technician check recorded successfully": "Kontrola technika bola úspešne zaznamenaná",
  "no_network_data_available": "Nie sú k dispozícii žiadne sieťové údaje",
  "configuration": "Konfigurácia",
  "contact_settings": "Kontakt a nastavenia",
  "notifications": "Upozornenia",
  "features": "Vlastnosti",
  "chat_ask_buzzz": "Opýtajte sa Buzzza",
  "chat_hide": "Skryť",
  "chat_buzzz_assistant": "Buzzz Assistant",
  "chat_export": "Exportovať",
  "chat_clear": "Vymazať",
  "chat_unpin": "Odopnúť",
  "chat_pin": "Pripnúť",
  "chat_retry": "Skúste to znova",
  "chat_copy": "Kopírovať",
  "chat_copied": "Skopírované!",
  "chat_share": "zdieľať",
  "chat_suggestions": "Návrhy",
  "chat_input_placeholder": "Opýtajte sa na svoje štatistiky...",
  "chat_stop": "Stop",
  "chat_error": "Niečo sa pokazilo. Skúste to znova.",
  "chat_placeholder": "Opýtajte sa ma na vaše štatistiky čistenia...",
  "chat_placeholder_context": "Opýtajte sa na {scope}...",
  "chat_chip_briefing": "Ranný brífing",
  "chat_chip_live_status": "Živý stav",
  "chat_chip_staff_status": "Stav personálu",
  "chat_chip_summary": "Zhrnutie",
  "chat_chip_cleaning_priority": "Priorita čistenia",
  "chat_chip_worst_rooms": "Najhoršie izby",
  "chat_chip_focus": "Oblasti zaostrenia",
  "chat_chip_compare_periods": "Porovnajte obdobia",
  "chat_chip_sla_issues": "problémy SLA",
  "chat_chip_shift_stats": "Štatistiky posunu",
  "chat_chip_complaint_types": "Typy sťažností",
  "chat_chip_busiest_hours": "Najrušnejšie hodiny",
  "chat_chip_worst_days": "Najhoršie dni",
  "chat_chip_improving": "Zlepšenie miestností",
  "chat_chip_best_rooms": "Najlepšie izby",
  "chat_chip_help": "Pomoc",
  "chat_chip_why_drilldown": "prečo? Prevŕtajte sa",
  "chat_deep_analysis": "Hlboká analýza (pomalšie)",
  "chat_greeting": "Dobrý deň, {name}, ako vám môžem pomôcť?",
  "chat_status_online": "Online",
  "chat_status_thinking": "Myslenie...",
  "chat_tool_overview": "Sťahujúci prehľad...",
  "chat_tool_rooms": "Prebieha kontrola miestností...",
  "chat_tool_hours": "Analyzujú sa hodiny...",
  "chat_tool_days": "Prebieha kontrola denných údajov...",
  "chat_tool_live": "Kontroluje sa aktuálny stav...",
  "chat_tool_priority": "Kontrolujú sa priority...",
  "chat_tool_room_detail": "Načítavajú sa podrobnosti o miestnosti...",
  "chat_tool_shifts": "Pri pohľade na zmeny...",
  "chat_tool_staff": "Kontrola personálu...",
  "chat_tool_devices": "Kontrolujú sa zariadenia...",
  "chat_feedback_good": "Dobrá odozva",
  "chat_feedback_bad": "Zlá odozva",
  "chat_feedback_thanks": "Ďakujeme za vašu spätnú väzbu!",
  "chat_feedback_wrong_data": "Nesprávne údaje",
  "chat_feedback_didnt_understand": "Nerozumel",
  "chat_feedback_missing_info": "Chýbajúce informácie",
  "chat_feedback_bad_format": "Zlé formátovanie",
  "chat_feedback_hallucinated": "Vymyslené čísla",
  "chat_feedback_submit": "Odoslať",

  "cleaner-activity": "Čistiaca činnosť",
  "device-actions": "Akcie zariadenia",
  "pad-presence-testing": "Test prítomnosti pri pade",
  "real-time-cleaning": "V reálnom čase - upratovanie",
  "real-time-maintenance": "V reálnom čase - údržba",
  "no_real_time_tabs_permitted": "Nemáte oprávnenie zobraziť žiadnu kartu v reálnom čase",
  "cleaner_activity": "Čistiaca činnosť",
  "pad_presence_testing": "Test prítomnosti pri pade",
  "pad_presence_testing_subtitle": "Vstupy, odchody a offline stlačenia padu odoslané z telefónu pre vybranú lokalitu",
  "pad_presence_timeline": "Živá časová os",
  "pad_presence_sessions": "Relácie prítomnosti",
  "pad_presence_offline_presses": "Offline stlačenia z telefónov",
  "pad_presence_select_site_hint": "Vyberte spoločnosť a lokalitu v hlavičke, aby ste sledovali udalosti prítomnosti.",
  "pad_presence_no_events": "V tomto období nie sú žiadne udalosti prítomnosti.",
  "pad_presence_open": "Otvorené",
  "pad_presence_exit_phone": "Odchod z telefónu",
  "pad_presence_exit_auto": "Automatický odchod",
  "pad_presence_exit_stale": "Zastaraný odchod",
  "pad_presence_enter": "Vstup",
  "pad_presence_exit": "Odchod",
  "pad_presence_offline": "Offline stlačenie",
  "pad_presence_faulty": "Chybné",
  "pad_presence_employee": "Zamestnanec",
  "pad_presence_room": "Miestnosť",
  "pad_presence_time_from": "Od",
  "pad_presence_last_updated": "Aktualizované",
  "pad_presence_duration": "Trvanie",
  "pad_presence_exit_type": "Typ odchodu",
  "pad_presence_button": "Tlačidlo",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "Počet",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "Všetci zamestnanci",
  "pad_presence_all_rooms": "Všetky miestnosti",
  "pad_presence_load_error": "Nepodarilo sa načítať údaje o prítomnosti pri pade.",
  "pad_presence_in_room_now": "Práve v miestnosti",
  "pad_presence_in_room": "v",
  "pad_presence_since": "od",
  "pad_presence_just_now": "Práve teraz",
  "pad_presence_pad": "Pad",
  "pad_presence_phone": "Telefón",
  "pad_presence_all_phones": "Všetky telefóny",
  "pad_presence_window": "Zobraziť",
  "pad_presence_window_hour": "Posledná hodina",
  "pad_presence_window_today": "Dnes",
  "pad_presence_window_month": "Posledný mesiac",
  "pad_presence_pads": "Pady na tejto lokalite",
  "pad_presence_no_pads": "Na tejto lokalite nie sú pady priradené k miestnostiam.",
  "pad_presence_last_enter": "Posledný vstup",
  "pad_presence_last_offline": "Posledné offline stlačenie",
  "pad_presence_auto_exit_leave": "Odíďte teraz → automatický odchod za",
  "pad_presence_auto_exit_earliest": "Najskôr od vstupu:",
  "pad_presence_auto_exit_passed": "Najskorší automatický odchod už uplynul. Stále otvorené = pad je stále počuť, alebo odíďte a počkajte 5m 45s.",
  "cleaner_activity_live_footer": "Aktualizácia údajov v reálnom čase",
  "ca_empty_select_site_hint": "Vyberte spoločnosť a lokalitu v hlavičke na zobrazenie čistejšej aktivity pre dnešok.",
  "ca_empty_no_cleaners_hint": "K tejto lokalite a aktuálnej zmene nie sú priradené žiadne upratovačky. Priraďte aktívne lokality a zmeny v časti Používatelia.",
  "ca_empty_access_denied": "Prístup odmietnutý",
  "ca_empty_access_denied_hint": "Nemáte povolenie na zobrazenie čistejšej aktivity pre túto lokalitu.",
  "ca_empty_load_error_hint": "Aktivitu čističa sa nepodarilo načítať. Skúste to znova alebo ak problém pretrváva, kontaktujte podporu.",
  "ca_empty_no_filter_match": "Týmto filtrom nezodpovedajú žiadne čistiace prostriedky",
  "ca_empty_no_filter_match_hint": "Skúste vyčistiť filtre alebo si vybrať iný čistič, pracovný priestor alebo miestnosť.",
  "ca_timeline_all_cleaners": "Dnešná aktivita — všetky upratovačky",
  "ca_legend_work": "Aktívne",
  "ca_clock_sessions_more": "viac",
  "ca_clock_sessions_less": "Ukážte menej",
  "ca_sort_label": "Triediť",
  "ca_sort_needs_attention": "Vyžaduje pozornosť",
  "ca_sort_best_avg_response": "Najlepšia priemerná odpoveď",
  "ca_sort_worst_avg_response": "Najhoršia priemerná odozva",
  "ca_sort_most_sla_breaches": "Väčšina porušení SLA",
  "ca_sort_most_open_complaints": "Väčšina otvorených sťažností",
  "ca_sort_most_work_time": "Najviac pracovného času",
  "ca_sort_least_work_time": "Najmenej pracovného času",
  "ca_stat_avg_short": "priem",
  "ca_stat_open_short": "OTVORENÉ",
  "ca_stat_breach_short": "porušenie",
  "ca_stat_work_short": "práce",
  "ca_assigned_room_avg_hint": "Priemerná odpoveď pre pridelené miestnosti dnes",
  "ca_transit_tooltip": "Čas prechodu medzi úlohami",
  "ca_transit_live_tooltip": "Čas od uzavretia poslednej úlohy",
  "ca_legend_visits": "Návštevy medzi hláseniami",
  "ca_visits_between_sla": "Návštevy od uzavretia predchádzajúceho hlásenia",
  "ca_apply": "Použiť",
  "ca_visits_since": "od",
  "ca_deferred_tip_title": "Odložená reklamácia",
  "ca_deferred_tip_resolved": "Vyriešené",
  "ca_deferred_tip_desc_open": "Stále otvorené – upratovačka namiesto tejto najprv obsluhovala iné izby.",
  "ca_deferred_tip_desc_closed": "Táto sťažnosť zostala otvorená, kým upratovačka najskôr obsluhovala ostatné izby.",
  "ca_deferred_tip_rooms_label": "Najprv servisované:",
  "ca_attention_title": "Vyžaduje pozornosť",
  "ca_attention_empty": "Všetko jasné – momentálne žiadne problémy",
  "ca_attention_sla_breach_one": "{name} · Porušenie SLA",
  "ca_attention_sla_breach_many": "{name} · {count} porušení SLA",
  "ca_attention_open_while_out_one": "{meno} · otvorená sťažnosť, keď je odhlásená",
  "ca_attention_open_while_out_many": "{name} · {count} otvorené, kým nie sú hodiny",
  "ca_attention_idle": "{name} · nečinný {duration}",
  "ca_attention_late": "{meno} · prišiel neskoro",
  "ca_attention_show": "Zobraziť",
  "ca_attention_hide": "Skryť",
  "cleaner": "Upratovač",
  "ca_view_shift": "Zmena",
  "ca_view_history": "História",
  "ca_filters_done": "Hotovo",
  "ca_hist_preset_this_month": "Tento mesiac",
  "ca_hist_preset_last_month": "Minulý mesiac",
  "ca_hist_preset_this_week": "Tento týždeň",
  "ca_hist_preset_last_week": "Minulý týždeň",
  "ca_hist_preset_custom": "Vlastný",
  "ca_hist_from": "Od",
  "ca_hist_to": "Do",
  "ca_hist_range_invalid": "Dátum začiatku musí byť pred dátumom konca",
  "ca_hist_range_too_long": "Rozsah môže byť najviac {max} dní",
  "ca_hist_search": "Hľadať meno alebo telefón",
  "ca_hist_people_count": "{count} zamestnancov",
  "ca_hist_kpi_days": "Odpracované dni",
  "ca_hist_kpi_net": "Čisté hodiny",
  "ca_hist_kpi_breaks": "Prestávky",
  "ca_hist_col_person": "Zamestnanec",
  "ca_hist_col_total": "Hodiny spolu",
  "ca_hist_col_total_tip": "Od príchodu po odchod pred prestávkami — rovnaká hodnota, akú zamestnanec vidí v aplikácii",
  "ca_hist_col_net": "Čisté hodiny",
  "ca_hist_col_breaks": "Prestávky",
  "ca_hist_col_issues": "Problémy",
  "ca_hist_col_late": "Neskoro",
  "ca_hist_col_missed": "Zmeškané",
  "ca_hist_col_no_clock_out": "Bez odchodu",
  "ca_hist_clocked_in_now": "Teraz prihlásený",
  "ca_hist_not_assigned": "Nepriradený k tejto lokalite",
  "ca_hist_no_shift": "Žiadna priradená zmena",
  "ca_hist_unknown_name": "Neznámy",
  "ca_hist_empty": "V tomto období žiadna dochádzka",
  "ca_hist_empty_hint": "Na tejto lokalite sa nikto neprihlásil a nie sú k nej priradení žiadni zamestnanci.",
  "ca_hist_no_match": "Filtrom nezodpovedá žiadny zamestnanec",
  "ca_hist_load_error_hint": "Históriu dochádzky sa nepodarilo načítať. Skúste to o chvíľu znova.",
  "ca_hist_prev_person": "Predchádzajúci zamestnanec",
  "ca_hist_next_person": "Ďalší zamestnanec",
  "ca_hist_close": "Zavrieť",
  "ca_hist_legend_worked": "Pracoval",
  "ca_hist_legend_late": "Neskoro",
  "ca_hist_legend_missed": "Zmeškané",
  "ca_hist_legend_no_clock_out": "Bez odchodu",
  "ca_hist_late_by": "Meškanie {duration}",
  "ca_hist_late_tip": "Príchod o {time}, {shift} začína o {start}",
  "ca_hist_missed": "Zmeškané",
  "ca_hist_missed_tip": "Plánovaná zmena skončila bez zaznamenaného príchodu",
  "ca_hist_no_clock_out": "Bez odchodu",
  "ca_hist_no_clock_out_tip": "Relácia nebola nikdy ukončená; jej hodiny sa nepočítajú",
  "ca_hist_in_progress": "Stále prihlásený",
  "ca_hist_auto": "auto",
  "ca_hist_open_break": "otvorená",
  "ca_hist_day_col_gross": "Hodiny spolu",
  "ca_hist_day_col_breaks": "Prestávky",
  "active_cleaners": "Aktívne čistiace prostriedky",
  "closed_complaints": "Uzavreté sťažnosti",
  "total_work_time": "Celkový pracovný čas",
  "total_work_time_net": "Celkový pracovný čas (dnes čistý)",
  "total_break_time": "Celkový čas prestávky",
  "avg_response_time": "Priem. vyriešené",
  "clocked_in": "Prihlásený",
  "clocked_out": "Odblokované",
  "still_clocked_in": "Stále prihlásené",
  "clocked_in_late": "Prihlásený neskoro",
  "total_hours": "Celkový počet hodín",
  "auto_punch": "Auto (geofence)",
  "manual_punch": "manuál",
  "complaint_opened": "Sťažnosť otvorená",
  "complaint_closed": "Reklamácia uzavretá",
  "complaint_still_open": "Stále otvorené",
  "resolved_in": "Vyriešené v",
  "open_for": "Otvorené pre",
  "sla_breached": "SLA bola porušená",
  "no_activity_today": "Dnes ešte žiadna aktivita",
  "just_now": "práve teraz",
  "ago": "pred",
  "today": "Dnes",
  "live": "Naživo",
  "last_updated": "Aktualizované",
  "analytics_export_confirm": "Stiahnuť analytické súbory CSV?",
  "analytics_export_title": "Exportujte analytické údaje",
  "analytics_export_description": "Stiahne sa súbor ZIP s vašou aktuálne filtrovanou analýzou – súhrn, šiška, hodiny, izby a príchody upratovačky/dozorcu.",
  "download": "Stiahnuť",
  "analytics_export_blocked_loading": "Údaje služby Analytics sa stále načítavajú. Please wait and try again.",
  "analytics_export_blocked_no_data": "Žiadne analytické údaje na export. Použite svoje filtre a počkajte, kým sa stránka načíta.",
  "analytics_export_blocked_stale_filters": "Filtre sa zmenili. Pred exportovaním použite filtre a počkajte, kým sa analytika znova načíta.",
}

export const ka = {
  ...serviks.ka,
  "notified": "ეცნობა",
  "supervisor_arrival": "ზედამხედველის ჩამოსვლა",
  "arrival": "ჩამოსვლა",
  "arrival_badges": "ცვლის ჩამოსვლა",
  "visits_since_cleaned": "ვიზიტები ბოლო გაწმენდის შემდეგ",
  "visits_since_cleaned_short": "ბოლო გაწმენდიდან",
  "filter": "ფილტრი",
  "logo": "ლოგო",
  "sms": "სმს",
  "shifts": "ცვლის",
  "call": "დარეკეთ",
  "openCalls": "გახსენით ზარები",
  "callsHistory": "ზარების ისტორია",
  "duration": "ხანგრძლივობა",
  "time_start": "დროის დაწყება",
  "settings": "პარამეტრები",
  "always": "ყოველთვის",
  "off": "გამორთულია",
  "time_based": "დროზე დაფუძნებული",
  "location_based": "მდებარეობაზე დაფუძნებული",
  "notification_mode": "შეტყობინებების რეჟიმი",
  "notification_times": "შეტყობინებების დრო",
  "notification_times_info": "დროის დიაპაზონი იმართება მობილური აპლიკაციიდან",
  "notification_location": "შეტყობინების მდებარეობა",
  "notification_sound": "შეტყობინების ხმა",
  "no_sound": "ხმა არ არის",
  "default_sound": "ნაგულისხმევი ხმა",
  "soft_bell": "რბილი ზარი",
  "digital_sound": "ციფრული ხმა",
  "mallet_sound": "მალეტის ხმა",
  "phone_sound": "ტელეფონის ხმა",
  "text_sound": "ტექსტის ხმა",
  "manager_alert_delay": "მენეჯერის გაფრთხილების დაგვიანება",
  "snooze_interval": "შეხსენება",
  "vocal_notifications": "ვოკალური შეტყობინებები",
  "no_delay": "დაყოვნების გარეშე",
  "no_snooze": "არანაირი შეხსენება",
  "lat": "ლათ",
  "lon": "ლონ",
  "radius": "რადიუსი",
  "no_location_set": "მდებარეობა არ არის მითითებული",
  "when_to_notify": "როდის უნდა შეატყობინოთ",
  "notification_preferences": "შეტყობინების პარამეტრები",
  "assignment_configuration": "დავალება და კონფიგურაცია",
  "working_area": "სამუშაო ფართობი",
  "complaints_NC": "საჩივრები / NC",
  "SLA_NC": "SLA / NC",
  "arrivals_NC": "ჩამოსვლა / NC",
  "staff": "პერსონალი",
  "cleaning_complaints": "დასუფთავების საჩივრები",
  "export": "ექსპორტი",
  "maintenance_complaints": "მოვლის საჩივრები",
  "maintenanceArrivals": "ტექნიკური ჩამოსვლა",
  "maintenance_arrivals": "ტექნიკური ჩამოსვლა",
  "last": "ბოლო",
  "survey_name": "გამოკითხვის სახელი",
  "survey": "გამოკითხვა",
  "pad_survey": "ბალიშის გამოკითხვა",
  "pad_no_maintenance_survey": "Pad არ არის ტექნიკური კვლევა",
  "pad_kitchen": "ბალიშის სამზარეულო",
  "number_of_assigned_devices": "# მინიჭებული მოწყობილობა",
  "number_of_pages": "# გვერდი",
  "date_created": "შექმნის თარიღი",
  "updated_by": "განახლებულია",
  "date_updated": "განახლების თარიღი",
  "search": "ძიება",
  "choose_type": "აირჩიეთ ტიპი",
  "permitted_sites": "ნებადართული საიტები",
  "permitted_franchise": "ნებადართული ფრენჩაიზია",
  "permitted_companies": "ნებადართული კომპანიები",
  "panel_permitted": "პანელი ნებადართულია",
  "end_time": "დასრულების დრო",
  "last_update": "ბოლო განახლება",
  "add_device": "მოწყობილობის დამატება",
  "detailed": "დეტალურად",
  "analysis": "ანალიზი",
  "suggestion": "წინადადება",
  "country": "ქვეყანა",
  "management": "მენეჯმენტი",
  "device": "მოწყობილობა",
  "mapping": "რუკების შედგენა",
  "please_enter": "გთხოვთ შეიყვანოთ",
  "new_device": "ახალი მოწყობილობა",
  "assign_device": "მოწყობილობის მინიჭება",
  "installSpot": "სამონტაჟო ადგილი",
  "device_type": "მოწყობილობის ტიპი",
  "deviceCode": "მოწყობილობის კოდი",
  "device_code": "მოწყობილობის კოდი",
  "scan_or_enter_device_code": "დაასკანირეთ ან შეიყვანეთ მოწყობილობის კოდი...",
  "scan_device": "მინიჭება",
  "scan_qr_in_frame": "განათავსეთ QR კოდი ჩარჩოში. პატარა კოდებისთვის დაიჭირეთ 15–25 სმ-ზე და შეეხეთ გადახვევას ხელახლა ფოკუსისთვის, თუ გამოსახულება ბუნდოვანია.",
  "checking_device_code": "მოწყობილობის კოდის შემოწმება...",
  "camera_not_available": "კამერა მიუწვდომელია. კოდის ხელით შეყვანა შეგიძლიათ.",
  "device_code_already_exists": "ეს მოწყობილობის კოდი უკვე მინიჭებულია სხვა სენსორზე.",
  "assigned_to_company_site_room": "უკვე მინიჭებულია {company} / {site} / {room}",
  "device_code_lookup_failed": "მოწყობილობის კოდის შემოწმება ვერ მოხერხდა. სცადეთ ხელახლა.",
  "device_code_no_site_access": "ეს კოდი უკვე რეგისტრირებულია ობიექტზე, რომელზეც წვდომა არ გაქვთ.",
  "device_code_check_unavailable": "სერვერმა კოდი ვერ შეამოწმა. სცადეთ ხელახლა.",
  "device_code_not_a_code": "სკანირებამ წაიკითხა „{code}“. შეიყვანეთ თავად მოწყობილობის კოდი.",
  "device_code_open_failed": "ამ მოწყობილობის გახსნა ვერ მოხერხდა. სცადეთ ხელახლა.",
  "device_code_save_failed": "მოწყობილობის კოდის შენახვა ვერ მოხერხდა. სცადეთ ხელახლა.",
  "device_code_save_forbidden": "ამ მოწყობილობის შეცვლა არ შეგიძლიათ.",
  "confirm_replace_device_code": "შევცვალოთ მოწყობილობის კოდი?",
  "confirm_replace_device_code_body": "დარწმუნებული ხართ, რომ გსურთ კოდის {oldCode} შეცვლა {newCode}-ით?",
  "room": "ოთახი",
  "edit_room": "ოთახის რედაქტირება",
  "edit_franchise": "ფრენჩაიზის რედაქტირება",
  "new_franchise": "ახალი ფრენჩაიზია",
  "desc": "აღწერა",
  "address": "მისამართი",
  "level": "დონე",
  "no_companies_to_show": "არ არის კომპანიების ჩვენება",
  "company_type": "კომპანიის ტიპი",
  "region": "რეგიონი",
  "new_company": "ახალი კომპანია",
  "edit_company": "კომპანიის რედაქტირება",
  "edit_user": "მომხმარებლის რედაქტირება",
  "C.arrivals": "დამლაგებელი ჩამოვიდა",
  "C.complaints": "დასუფთავების საჩივარი",
  "M.complaints": "მოვლის საჩივრები",
  "M.Arrivals": "ტექნიკური ჩამოსვლა",
  "analyses": "აანალიზებს",
  "clean_log": "სუფთა ჟურნალი",
  "maintenance_log": "ტექნიკური ჟურნალი",
  "likes": "მოსწონს",
  "new_user": "ახალი მომხმარებელი",
  "shift_parameters": "Shift პარამეტრი",
  "add_shift": "ახალი ცვლა",
  "edit_shift": "ცვლის რედაქტირება",
  "username": "მომხმარებლის სახელი",
  "first_name": "სახელი",
  "job_function": "როლი",
  "role": "როლი",
  "property_manager": "ქონების მენეჯერი",
  "facility_manager": "ობიექტის მენეჯერი",
  "site_manager": "საიტის მენეჯერი",
  "workplace_manager": "სამუშაო სივრცის მენეჯერი",
  "cleaning_company_ceo": "დასუფთავების კომპანიის დირექტორი",
  "operations_manager": "ოპერაციების მენეჯერი",
  "area_manager": "ზონის მენეჯერი",
  "site_cleaning_manager": "ობიექტის დასუფთავების მენეჯერი",
  "cleaning_supervisor": "დასუფთავების სუპერვაიზერი",
  "other": "სხვა",
  "restroom_cleaner": "საპირფარეშოს დამლაგებელი",
  "general_cleaner": "ზოგადი დამლაგებელი",
  "day_porter": "დღის პორტერი",
  "office_cleaner": "ოფისის დამლაგებელი",
  "public_area_cleaner": "საერთო სივრცის დამლაგებელი",
  "firstName": "სახელი",
  "description": "აღწერა",
  "last_name": "გვარი",
  "lastName": "გვარი",
  "phone": "ტელეფონი",
  "building_area": "შენობის ფართი",
  "users": "მომხმარებლები",
  "add_user": "მომხმარებლის დამატება",
  "sites": "საიტები",
  "new_site": "ახალი საიტი",
  "edit_site": "საიტის რედაქტირება",
  "add_company": "დაამატეთ კომპანია",
  "franchise": "ფრანშიზა",
  "floor": "სართული",
  "building": "შენობა",
  "humidity": "ტენიანობა",
  "humidity_abbr": "ტენიანი",
  "temperature": "ტემპერატურა",
  "temperature_abbr": "ტემპერატურა",
  "gender": "ოთახის ტიპი",
  "display_name": "სახელი",
  "zone": "ზონა",
  "shift_number": "Shift#",
  "shift_name": "სახელის შეცვლა",
  "shift_currently_inactive": "ამჟამად არააქტიური ცვლა",
  "local_time": "ადგილობრივი",
  "end": "დასასრული",
  "min_sla": "მინ SLA",
  "max_sla": "მაქს SLA",
  "days": "დღეები",
  "complaints_percent": "% საჩივრები",
  "sla_percent": "% SLA",
  "arrivals_percent": "% ჩამოსვლა",
  "save_arrivals": "შენახვა",
  "clean_time": "დასუფთავების დრო (წთ)",
  "tooltip_shift_number": "ამ ცვლის თანმიმდევრობის ჩვენება (მაგ. 1, 2).",
  "tooltip_shift_name": "ცვლის დასახელება (მაგ. დილა, ღამე).",
  "tooltip_start_time": "ადგილობრივი დროით გადაინაცვლეთ დაწყების დრო.",
  "tooltip_end_time": "ცვლის დასრულების დრო ადგილობრივი დროით.",
  "tooltip_cleaners_number": "დამლაგებლების რაოდენობა ამ ცვლაში.",
  "tooltip_min_sla": "საუკეთესო პასუხის დრო (წუთები) ოთახის საჩივრის განსახილველად; გამოიყენება როგორც ქულის ქვედა ზღვარი.",
  "tooltip_max_sla": "მაქსიმალური მისაღები პასუხის დრო (წუთები) ოთახის საჩივრის განსახილველად; გამოიყენება როგორც ქულის ზედა ზღვარი.",
  "tooltip_arrivals": "მოსალოდნელია დამლაგებლების ჩამოსვლა თითო ოთახში დღეში; ქულა ადარებს რეალურ ჩამოსვლას ამ სამიზნესთან.",
  "tooltip_save_arrivals": "უფრო სუფთა ვიზიტები თითო ოთახში დღეში BuzzzTV-მდე; გამოიყენება დაზოგილი დროის გამოსათვლელად (ახლა ნაკლები ვიზიტი = შენახული წუთი).",
  "tooltip_clean_time": "წუთები დათვლილია დამლაგებლის ვიზიტზე დროის დაზოგვის გაანგარიშებაში (მაგ. 15).",
  "tooltip_complaints_percent": "საჩივრების წონა ოთახის ქულაში, როდესაც ოთახში არის ვიზიტები (უფრო მაღალი = საჩივრები უფრო გავლენას ახდენს ქულაზე).",
  "tooltip_response_time_SLA": "პასუხის დროის წონა ოთახის ქულაში, როდესაც ოთახს აქვს ვიზიტები (უფრო მეტი = უფრო სწრაფი პასუხი უფრო მნიშვნელოვანია).",
  "tooltip_arrivals_percent": "ჩამოსვლის წონა და სამიზნე ოთახის ქულაში, როდესაც ოთახში არის ვიზიტები.",
  "tooltip_complaints_NC": "საჩივრების წონა ქულაში, როდესაც ოთახში არ არის ვიზიტები (არ არის მრიცხველი).",
  "tooltip_SLA_NC": "პასუხის დროის წონა ქულაში, როდესაც ოთახში არ არის ვიზიტები.",
  "tooltip_arrivals_NC": "ჩამოსვლის წონა ქულაში, როდესაც ოთახში არ არის ვიზიტები.",
  "tooltip_days": "კვირის დღეები, როდესაც ეს ცვლა აქტიურია.",
  "tooltip_active_calculation": "როდესაც ჩართულია, ეს ცვლა შედის ქულებსა და დროის დაზოგულ გამოთვლებში.",
  "auto_close_complaints_hour": "ავტომატური დახურვის საჩივრების საათი",
  "tooltip_auto_close_complaints_hour": "ადგილობრივი საათი, როდესაც ღია საჩივრის SLA-ები ამ ცვლაში ავტომატურად იხურება. დატოვეთ ცარიელი, რომ გამორთოთ.",
  "auto_close_maintenance_complaints_hour": "მოვლის საჩივრების ავტომატური დახურვის საათი",
  "tooltip_auto_close_maintenance_complaints_hour": "ადგილობრივი საათი, როდესაც ღია მოვლის საჩივრის SLA-ები ამ ცვლაში ავტომატურად იხურება. დატოვეთ ცარიელი, რომ გამორთოთ.",
  "no_auto_close": "-- არცერთი --",
  "tooltip_shift_rooms": "ამ ცვლაზე მინიჭებული ოთახები. დატოვეთ ცარიელი საიტის დონის ცვლისთვის.",
  "company_name": "კომპანიის სახელი",
  "site_name": "საიტის სახელი",
  "site_desc": "საიტის აღწერა",
  "service_provider_name": "სერვისის მიმწოდებელი",
  "service_provider_type": "სერვისის პროვაიდერის ტიპი",
  "service_provider_desc": "სერვისის პროვაიდერის აღწერა",
  "user": "მომხმარებელი",
  "map": "რუკა",
  "delete": "წაშლა",
  "new_room": "ახალი ოთახი",
  "issue_times": "გაცემის დრო",
  "solved": "მოგვარდა",
  "visits": "ვიზიტები",
  "visits_also_went_up": "ვიზიტებიც გაიზარდა",

  "complaints": "საჩივრები",
  "complaints_in_shift": "უჩივის ამ ცვლას",
  "cleaner_arrivals": "უფრო სუფთა ჩამოსვლა",
  "unnecessary_arrivals": "ჩამოსვლები გამოძახების გარეშე",
  "unnecessary_arrivals_hint": "დამლაგებლის ვიზიტი, სანამ ოთახში ღია გამოძახება არ იყო.",
  "of_arrivals": "ჩამოსვლებიდან",
  "response_time_SLA": "რეაგირების დრო",
  "score": "ქულა",
  "avg_score": "საშუალო ქულა",
  "score_goal": "გაიტანა გოლი",
  "top_problem_issues": "მთავარი საკითხები",
  "top_problem_rooms": "ტოპ ოთახები",
  "top_problem_hours": "საუკეთესო საათები",
  "is_time_save": "დრო დაზოგეს",
  "options": "ოფციები",
  "send_battery_alerts": "გააგზავნეთ ბატარეის სიგნალიზაცია",
  "environment_alerts": "გარემოს გაფრთხილებები",
  "environment_alerts_description": "გააგზავნეთ ელფოსტის შეტყობინებები, როდესაც ტემპერატურა ან ტენიანობა ტოვებს დაშვებულ დიაპაზონს",
  "environment_alert_emails": "გარემოს გაფრთხილების ელფოსტა",
  "temperature_min": "ტემპერატურა მინ",
  "temperature_max": "ტემპერატურა მაქს",
  "humidity_min": "ტენიანობა მინ",
  "humidity_max": "ტენიანობა მაქს",
  "environment_alert_range_invalid": "გარემოს გაფრთხილების დიაპაზონი უნდა იყოს რიცხვითი და min უნდა იყოს მაქსიმუმზე ნაკლები ან ტოლი",
  "coming_soon": "მალე",
  "alert_emails": "გაფრთხილების ელფოსტა",
  "alert_emails_placeholder": "შეიყვანეთ ელ.ფოსტის მისამართი",
  "alert_language": "გაფრთხილების ენა",
  "select_language": "აირჩიეთ ენა",
  "invalid_email_format": "ერთი ან მეტი ელფოსტის მისამართი არასწორია",
  "add_email": "დაამატეთ სხვა ელფოსტა",
  "next": "შემდეგი",
  "back": "უკან",
  "basic_information": "ძირითადი ინფორმაცია",
  "service_providers": "სერვისის პროვაიდერები",
  "settings_alerts": "პარამეტრები და გაფრთხილებები",
  "battery_alerts": "ბატარეის გაფრთხილებები",
  "alerts_title": "გაფრთხილებები",
  "time_save_description": "დროის დაზოგვის ფუნქციების ჩართვა",
  "exposures_description": "ადევნეთ თვალი არა ექსპოზიციის მონაცემებს",
  "alerts_description": "მოწყობილობის ინფორმაციის გაფრთხილებები",
  "shift_description": "შექმენით ნაგულისხმევი ცვლილებები",
  "battery_alerts_description": "გაგზავნეთ ელ.ფოსტის შეტყობინებები დაბალი ბატარეის შესახებ",
  "est_ROI": "ეს ROI",
  "complaints_vs_visits": "საჩივრები vs ვიზიტები",
  "view_by_years": "წლების ნახვა",
  "view_by_months": "თვეების ნახვა",
  "view_by_weeks": "კვირების ნახვა",
  "view_by_days": "დღეების ნახვა",
  "minutes": "მინ",
  "company": "კომპანია",
  "site": "საიტი",
  "alerts": "მოწყობილობების ინფორმაცია",
  "performance": "შესრულება",
  "devices": "მოწყობილობები",
  "total_devices": "სულ მოწყობილობები",
  "working": "სამუშაო",
  "warning": "გაფრთხილება",
  "by_device_type": "მოწყობილობის ტიპის მიხედვით",
  "surveys": "გამოკითხვები",
  "real_time": "რეალურ დროში",
  "real-time": "რეალურ დროში",
  "cleaner-activity": "სუფთა აქტივობა",
  "device-actions": "მოწყობილობის მოქმედებები",
  "pad-presence-testing": "პადი ყოფნა შემოწმება",
  "real-time-cleaning": "რეალურ დროში - დასუფთავება",
  "real-time-maintenance": "რეალურ დროში - მოვლა-შენახვა",
  "no_real_time_tabs_permitted": "არ გაქვთ უფლება ნახოთ რეალური დროის რომელიმე ჩანართი",
  "admin": "ადმინ",
  "all": "ყველა",
  "overview": "მიმოხილვა",
  "exit_full_screen": "სრული ეკრანიდან გამოსვლა",
  "full_screen": "სრული ეკრანი",
  "total": "სულ",
  "analytics": "ანალიტიკა",
  "pdf_export_title_analytics": "ანალიტიკის ანგარიში",
  "pdf_export_title_cleaner_arrivals": "უფრო სუფთა ჩამოსვლა",
  "communication": "კომუნიკაცია",
  "overview_complaints_devices_caption": "დაინსტალირებული მოწყობილობები (კუმულაციური)",
  "overview_complaints_devices_caption_hint": "საიტზე დაყენებული მოწყობილობების საერთო რაოდენობა ყოველი თვის ბოლომდე, ინსტალაციის თარიღების მიხედვით.",
  "overview_complaints_devices_toggle_aria": "საჩივრების დიაგრამის ქვეშ დაყენებული მოწყობილობების ჩვენება ან დამალვა",
  "communication_select_site_title": "აირჩიეთ საიტი",
  "communication_select_site": "აირჩიეთ კომპანია და საიტი ზემოთ მოცემული ფილტრებიდან, რომ ნახოთ და დაამატოთ შენიშვნები ამ მდებარეობისთვის.",
  "communication_viewing_site": "დათვალიერება",
  "communication_add_note": "დაამატეთ შენიშვნა",
  "communication_add_note_open_aria": "გახსენით ჩანაწერის დამატების დიალოგი",
  "communication_form_hint": "გაუზიარეთ განახლებები ან შენიშვნები ყველას, ვისაც აქვს წვდომა ამ საიტზე. ისინი ნახავენ ახალ შენიშვნებს რეალურ დროში.",
  "communication_page_intro_title": "საიტის შენიშვნები — გაზიარებული ჟურნალი ამ მდებარეობისთვის",
  "communication_page_intro_body": "გამოიყენეთ ეს გვერდი თქვენი გუნდისთვის გადაცემის, საკითხების, განახლებებისა და შეხვედრების ჩანაწერების დასატოვებლად. ყველას, ვისაც შეუძლია ამ საიტის გახსნა პორტალში, შეუძლია წაიკითხოს და დაამატოთ შენიშვნები.",
  "communication_page_intro_dismiss": "დამალეთ ეს წვერი",
  "communication_page_intro_aria": "საიტის შენიშვნების შესახებ",
  "communication_content_placeholder": "დაწერე შენი შენიშვნა აქ...",
  "communication_keyboard_hint": "Ctrl+Enter გამოქვეყნებისთვის",
  "communication_submitting": "გამოქვეყნება...",
  "communication_submit": "გამოაქვეყნეთ შენიშვნა",
  "communication_recent_notes": "შენიშვნები",
  "communication_search_placeholder": "ძიება ავტორის ან ტექსტის მიხედვით...",
  "communication_refresh": "განაახლეთ",
  "communication_clear_filters": "ფილტრების გასუფთავება",
  "communication_search_aria_label": "მოძებნეთ შენიშვნები",
  "communication_submit_aria_label": "გამოაქვეყნეთ შენიშვნა",
  "communication_copy_note_aria_label": "შენიშვნის ტექსტის კოპირება",
  "communication_copied": "კოპირებულია ბუფერში.",
  "communication_copy_empty": "შენიშვნის ტექსტი არ არის დასაკოპირებლად.",
  "communication_filter_hidden_one": "(1 შენიშვნა დამალულია ფილტრებით)",
  "communication_filter_hidden_many": "({n} შენიშვნა დამალულია ფილტრებით)",
  "communication_request_timeout": "მოთხოვნა ამოიწურა. გთხოვთ, სცადოთ ხელახლა.",
  "communication_load_failed": "შენიშვნების ჩატვირთვა ვერ მოხერხდა.",
  "communication_retry": "სცადეთ ხელახლა",
  "communication_no_matches": "არცერთი შენიშვნა არ შეესაბამება თქვენს ძიებას ან ფილტრებს. სცადეთ მათი მორგება.",
  "communication_no_entries": "შენიშვნები ჯერ არ არის.",
  "communication_no_entries_hint": "დასაწყებად დაამატეთ ზემოთ შენიშვნა.",
  "communication_just_now": "მხოლოდ ახლა",
  "communication_minutes_ago": "{n} წუთის წინ",
  "communication_hours_ago": "{n} საათის წინ",
  "communication_days_ago": "{n} დღის წინ",
  "communication_note_posted": "შენიშვნა გამოქვეყნებულია.",
  "communication_post_failed": "შენიშვნის გამოქვეყნება ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "communication_note_type": "შენიშვნის ტიპი",
  "communication_type_general": "გენერალი",
  "communication_type_update": "განახლება",
  "communication_type_issue": "საკითხი",
  "communication_type_follow_up": "შემდგომი დაკვირვება",
  "communication_type_meeting": "შეხვედრის ჩანაწერი",
  "communication_filter_all_types": "ყველა ტიპის",
  "communication_pinned": "ჩამაგრებული",
  "communication_pin": "პინი",
  "communication_unpin": "ჩამაგრების მოხსნა",
  "communication_pin_limit": "მაქსიმუმ 2 ჩამაგრებულია",
  "communication_pinned_toast": "ჩანიშვნა ჩამაგრებულია.",
  "communication_unpinned_toast": "ჩანიშვნა მოხსნილია.",
  "communication_pin_failed": "პინის განახლება ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "communication_note_not_found": "შენიშვნა ვერ მოიძებნა ან არ გაქვთ წვდომა.",
  "communication_site_not_in_filters": "ამ შენიშვნის საიტი არ არის თქვენს ამჟამინდელ ფილტრებში. თქვენ შეიძლება არ გქონდეთ წვდომა იმ ადგილას.",
  "communication_edit": "რედაქტირება",
  "communication_delete": "წაშლა",
  "communication_save": "შენახვა",
  "communication_cancel": "გაუქმება",
  "communication_saving": "მიმდინარეობს შენახვა...",
  "communication_note_updated": "შენიშვნა განახლებულია.",
  "communication_update_failed": "ჩანიშვნის განახლება ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "communication_delete_confirm": "დარწმუნებული ხართ, რომ გსურთ ამ ჩანიშვნის წაშლა? ამ მოქმედების გაუქმება შეუძლებელია.",
  "communication_delete_confirm_title": "შენიშვნის წაშლა",
  "communication_note_preview": "შენიშვნის გადახედვა:",
  "communication_note_deleted": "შენიშვნა წაშლილია.",
  "communication_delete_failed": "ჩანიშვნის წაშლა ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "communication_edited": "რედაქტირებულია",
  "communication_show_more": "მეტის ჩვენება",
  "communication_show_less": "ნაკლების ჩვენება",
  "communication_sort_date_newest": "ჯერ უახლესი",
  "communication_sort_date_oldest": "ჯერ ყველაზე ძველი",
  "communication_sort_author": "ავტორის მიერ",
  "communication_sort_type": "ტიპის მიხედვით",
  "communication_sort_pinned": "ჯერ ჩამაგრებულია",
  "communication_sort_label": "დალაგება",
  "communication_filter_by_type": "ტიპი",
  "communication_filters_group_aria": "გაფილტრეთ და დაალაგეთ შენიშვნები",
  "communication_search_label_short": "ძიება",
  "employees": "თანამშრომლები",
  "last_time_of_arrival": "ჩამოსვლის ბოლო დრო",
  "arrival_and_status": "ჩამოსვლა და სტატუსი",
  "preview_arrivals": "ჩამოსვლის წინასწარი გადახედვა",
  "men toilet": "მამაკაცის ტუალეტი",
  "women toilet": "ქალთა ტუალეტი",
  "shared toilet": "საერთო ტუალეტი",
  "unisex restroom": "უნისექს ტუალეტი",
  "handicapped toilet": "შეზღუდული შესაძლებლობის მქონე პირთა ტუალეტი",
  "kitchen": "სამზარეულო",
  "logistics": "ლოგისტიკა",
  "cubicle": "კაბინა",
  "gym": "სპორტდარბაზი",
  monthMap: {
    1: 'იან',
    2: 'თებ',
    3: 'მარ',
    4: 'აპრ',
    5: 'მაი',
    6: 'ივნ',
    7: 'ივლ',
    8: 'აგვ',
    9: 'სექ',
    10: 'ოქტ',
    11: 'ნოე',
    12: 'დეკ',
  },
  weekMap: {
    1: 'კვირა',
    2: 'ორშაბათი',
    3: 'სამშაბათი',
    4: 'ოთხშაბათი',
    5: 'ხუთშაბათი',
    6: 'პარასკევი',
    7: 'შაბათი',
  },
  "dayOfWeek": "დღეები",
  "service_log": "მომსახურების ჟურნალი",
  "rooms": "ოთახები",
  "bulk_add_rooms": "ოთახების ნაყარი დამატება",
  "adding_to": "ემატება",
  "add_rooms": "ოთახების დამატება",
  "room_names_one_per_line": "ოთახის სახელები (თითო სტრიქონზე)",
  "enter_at_least_one_room": "შეიყვანეთ მინიმუმ ერთი ოთახის სახელი",
  "room_names_placeholder": "ოთახი 1\nოთახი 2\nქალთა ტუალეტი",
  "rooms_with_prefix": "ოთახები პრეფიქსით",
  "apply_to_all_rooms": "ვრცელდება ყველა ოთახში (სურვილისამებრ)",
  "bulk_rooms_intro": "დაამატეთ ერთი ან მეტი ჯგუფი. თითოეულ ჯგუფს აქვს საკუთარი შენობა, სართული, ზონა, სქესი და ოთახის სახელები.",
  "group": "ჯგუფი",
  "add_group": "+ დაამატეთ სხვა ჯგუფი",
  "adding_rooms": "ოთახების დამატება...",
  "bulk_summary": "რეზიუმე",
  "in": "in",
  "bulk_rooms_success": "{n} ოთახი წარმატებით დაემატა",
  "displayName": "ოთახის სახელი",
  "SLA": "SLA",
  "supervisors": "ზედამხედველები",
  "supervisor": "ზედამხედველი",
  "performance_analytics": "შესრულების ანალიტიკა",
  "arrivals": "ჩამოსვლა",
  "inspections": "ინსპექტირება",
  "avgResponseTime": "პასუხის საშუალო დრო",
  "missedSla": "მონატრებული სლა",
  "load_more": "მეტი ჩატვირთვა",
  "login": "შესვლა",
  "email": "ელფოსტა",
  "emails": "ელფოსტა",
  "password": "პაროლი",
  "min": "მინ",
  "Logout": "გასვლა",
  "time_range": "დროის დიაპაზონი",
  "select_time_range": "აირჩიეთ დროის დიაპაზონი",
  "custom_time": "აირჩიეთ თარიღები",
  "last_day": "გუშინ",
  "last_week": "ბოლო 7 დღე",
  "last_month": "ბოლო 30 დღე",
  "last_quarter": "ბოლო 90 დღე",
  "last_6_months": "ბოლო 6 თვე",
  "last_year": "ბოლო 365 დღე",
  "data_by_hour": "მონაცემები საათების მიხედვით",
  "start": "დაწყება",
  "start_time": "დაწყების დრო",
  "management_co": "მმართველი კომპანია",
  "cleaning_co": "დასუფთავების კომპანია",
  "companies": "კომპანიები",
  "name": "სახელი",
  "site_count": "საიტი #",
  "associated_companies": "ასოცირებული საბოლოო კლიენტები",
  "OK": "OK",
  "cancel": "გაუქმება",
  "client": "კლიენტი",
  "dates": "თარიღები",
  "shift": "ცვლა",
  "issue": "საკითხი",
  "time": "დრო",
  "top complaint of the week": "კვირის მთავარი საჩივარი",
  "top room of the week": "კვირის საუკეთესო ოთახი",
  "top hour of the week": "კვირის საუკეთესო საათი",
  "top complaint of the month": "თვის მთავარი საჩივარი",
  "top room of the month": "თვის საუკეთესო ოთახი",
  "top hour of the month": "თვის საუკეთესო საათი",
  "franchises": "ფრანშიზები",
  "add_franchise": "ფრენჩაიზის დამატება",
  "room_names": "ოთახის სახელი",
  "type": "ტიპი",
  "please_select_company_site": "გთხოვთ, აირჩიოთ კომპანია და საიტი",
  "number": "ნომერი",
  "create_building_map": "შექმენით შენობის რუკა",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "ჰეი, ყველაზე სწრაფი გზა შენობებისთვის სართულებისა და ოთახების დასამატებლად ამ სწრაფი ოსტატის მეშვეობით",
  "avg number of toilets per floor": "ტუალეტების საშუალო რაოდენობა სართულზე",
  "avg.number of toilet cells per room": "ტუალეტის უჯრედების საშუალო რაოდენობა ოთახში",
  "number of floors": "სართულების რაოდენობა",
  "avg.number of disabled toilets": "შეზღუდული შესაძლებლობების მქონე ტუალეტების საშუალო რაოდენობა",
  "avg.number of soap dispensers": "საპნის დისპენსერების საშუალო რაოდენობა",
  "reset_filter": "ფილტრის გადატვირთვა",
  "add": "დამატება",
  "new_survey": "ახალი გამოკითხვა",
  "api_configuration": "API კონფიგურაცია",
  "please_edit_the_api_information": "გთხოვთ შეცვალოთ API ინფორმაცია",
  "method": "მეთოდი",
  "authorization": "ავტორიზაცია",
  "api_url": "API_url",
  "token": "ჟეტონი",
  "endpoint": "ბოლო წერტილი",
  "add_url": "URL-ის დამატება",
  "remove": "ამოღება",
  "format": "ფორმატი",
  "auth_api_key": "API გასაღები",
  "auth_dynamic_key": "დინამიური გასაღები (GET)",
  "auth_login_token": "შესვლის ნიშანი (HTTP)",
  "dynamic_token_url": "ტოკენის URL (GET)",
  "token_response_field_name": "საპასუხოდ ჟეტონის ველი",
  "token_login_url": "შესვლის URL",
  "login_request_method": "შესვლის მოთხოვნის მეთოდი",
  "login_request_body": "შესვლის მოთხოვნის ორგანო (JSON)",
  "login_token_placeholder_hint": "არასავალდებულო: საიდუმლო გამოიყენება {{token}}-ის ჩასანაცვლებლად შესვლის სხეულში JSON",
  "token_response_key": "წვდომა ჟეტონის ველის სახელზე",
  "survey_api_auth_header_name": "Auth header სახელი (არასავალდებულო)",
  "survey_api_auth_header_prefix": "ტექსტი ჟეტონამდე ამ სათაურში",
  "survey_api_auth_header_name_placeholder": "მაგ. ავტორიზაცია, X-Api-Key",
  "survey_api_auth_header_prefix_placeholder": "მაგ. Bearer — ბოლო სათაური არის: პრეფიქსი + სივრცე + ჟეტონი",
  "api_request_info": "API მოთხოვნის ინფორმაცია",
  "roomName": "ოთახის სახელი",
  "servikName": "საჩივრის სახელი",
  "siteName": "საიტის სახელი",
  "stage": "სცენა",
  "number_of_buttons": "ღილაკების რაოდენობა",
  "button_shape": "ღილაკის ფორმა",
  "delay_time_stage": "დროის დაგვიანების ეტაპი",
  "go_to_stage": "გადადით სცენაზე",
  "color": "ფერი",
  "add_stage": "ეტაპის დამატება",
  "save": "შენახვა",
  "number_of_issues": "საკითხების რაოდენობა",
  "online": "ონლაინ",
  "offline": "ხაზგარეშე",
  "offline_devices": "ხაზგარეშე მოწყობილობები",
  "no_offline_devices": "ხაზგარეშე მოწყობილობები ვერ მოიძებნა",
  "working_devices": "სამუშაო მოწყობილობები",
  "no_working_devices": "სამუშაო მოწყობილობები ვერ მოიძებნა",
  "room_name": "ოთახის სახელი",
  "installation_spot": "ადგილზე",
  "device_id": "მოწყობილობის ID",
  "date": "თარიღი",
  "status": "სტატუსი",
  "device_status": "მოწყობილობის სტატუსი",
  "none": "არცერთი",
  "no_surveys_created": "გამოკითხვები არ შეიქმნა",
  "dashboard": "დაფა",
  "franchise_name": "ფრენჩაიზის სახელი",
  "franchise_country": "ფრენჩაიზის ქვეყანა",
  "choose_franchise": "აირჩიეთ ფრენჩაიზია",
  "choose_country": "აირჩიეთ ქვეყანა",
  "select_template": "აირჩიეთ შაბლონი",
  "default_survey": "ნაგულისხმევი გამოკითხვა",
  "cleaning_survey": "დასუფთავების გამოკითხვა",
  "kitchen_survey": "სამზარეულოს გამოკითხვა",
  "template": "შაბლონი",
  "area_name": "ტერიტორიის სახელი",
  "rooms_names": "ოთახების სახელები",
  "rooms_number": "ოთახები #",
  "assign_number": "მინიჭება #",
  "active_notification_task": "აქტიური შეტყობინების ამოცანა",
  "amount_limit": "მრიცხველის ინტერვალი",
  "after_max": "მრიცხველი მაქს",
  "new_area": "ახალი ტერიტორია",
  "edit_area": "არეალის რედაქტირება",
  "tablet": "ტაბლეტი",
  "counter women": "მრიცხველი ქალები",
  "counter men": "მრიცხველი კაცი",
  "counter handicap": "კონტრ ჰანდიკაპი",
  "counter man/woman": "დახლი კაცი/ქალი",
  "counter man / woman": "დახლი კაცი/ქალი",
  "sensor liquid": "სენსორის სითხე",
  "double toilet paper": "ორმაგი ტუალეტის ქაღალდი",
  "toilet paper": "ტუალეტის ქაღალდი",
  "tag": "მონიშნეთ",
  "qr tag": "QR ტეგი",
  "additional_info": "დამატებითი ინფორმაცია",
  "servikCategory": "ზარის ტიპი",
  "cafeteria": "კაფეტერია",
  "clean room": "სუფთა ოთახი",
  "office": "ოფისი",
  "meeting room": "შეხვედრების ოთახი",
  "cubic": "კუბური",
  "women": "ქალები",
  "men": "მამაკაცები",
  "handicap": "ჰანდიკაპი",
  "Combined": "კომბინირებული",
  "east": "აღმოსავლეთი",
  "west": "დასავლეთი",
  "north": "ჩრდილოეთი",
  "south": "სამხრეთი",
  "right": "უფლება",
  "left": "მარცხენა",
  "center": "ცენტრი",
  "up": "ზემოთ",
  "down": "ქვემოთ",
  "combined": "კომბინირებული",
  "lobby": "ლობი",
  "entrance": "შესასვლელი",
  "reception": "მიღება",
  "area": "ფართობი",
  "mezzanine": "ანტრესოლით",
  "gallery": "გალერეა",
  "ground": "ადგილზე",
  "elevator": "ლიფტი",
  "is_calculated": "გამოთვლილი ოთახი",
  "calculated_room": "გამოთვლილი ოთახი",
  "splitted_survey": "გაყოფილი გამოკითხვა",
  "redirect_to_url": "გადამისამართება url-ზე",
  "survey_site": "გამოკითხვის საიტი",
  "clicks": "დაწკაპუნებები",
  "add_stage_number_to_signal": "მიამაგრეთ ეტაპის ნომერი",
  "including_pad9": "მათ შორის pad9",
  "room_type_required": "აირჩიეთ ოთახის ტიპი თითოეული ჯგუფისთვის",
  "Tech Manufacturers": "ტექნოლოგიური მწარმოებლები",
  "Tech Offices": "ტექნოლოგიური ოფისები",
  "Offices": "ოფისები",
  "Terminal": "ტერმინალი",
  "Universities": "უნივერსიტეტები",
  "Factories": "ქარხნები",
  "Hospital": "საავადმყოფო",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "მინიმარკეტები",
  "Food Chains": "კვების ქსელები",
  "Residential": "საცხოვრებელი",
  "Shopping Center": "სავაჭრო ცენტრი",
  "Survey": "გამოკითხვა",
  "Demo": "დემო",
  "Vision": "Vision",
  "Court": "სასამართლო",
  "Office Management": "ოფისის მართვა",
  "Government Office": "სახელმწიფო დაწესებულება",
  "default_name": "სახელი ინგლისურად",
  "exposures": "სუფთა ექსპოზიცია",
  "exposures_tab": "ოთახის აქტივობა",
  "cleaner_activity": "სუფთა აქტივობა",
  "pad_presence_testing": "პადი ყოფნა შემოწმება",
  "pad_presence_testing_subtitle": "არჩეულ საიტზე პადი ყოფნის თვალყურის დევნება რეალურ დროში",
  "pad_presence_timeline": "ცოცხალი · დრო",
  "pad_presence_sessions": "ყოფნა",
  "pad_presence_offline_presses": "ხაზგარეშე · ტელეფონი",
  "pad_presence_select_site_hint": "აირჩიეთ კომპანია და საიტი სათაურში, რათა ნახოთ პადის ყოფნა.",
  "pad_presence_no_events": "ბოლო ჩამოსვლები არ არის",
  "pad_presence_open": "ღიაა",
  "pad_presence_exit_phone": "ტელეფონი გამოსვლა",
  "pad_presence_exit_auto": "ავტომატური გამოსვლა",
  "pad_presence_exit_stale": "ბოლო გამოსვლა",
  "pad_presence_enter": "შესვლა",
  "pad_presence_exit": "გამოსვლა",
  "pad_presence_offline": "ხაზგარეშე",
  "pad_presence_faulty": "არააქტიური",
  "pad_presence_employee": "თანამშრომლები",
  "pad_presence_room": "ოთახი",
  "pad_presence_time_from": "გაწმენდიდან",
  "pad_presence_last_updated": "განახლებულია",
  "pad_presence_duration": "ხანგრძლივობა",
  "pad_presence_exit_type": "გამოსვლა · აირჩიეთ",
  "pad_presence_button": "ღილაკი",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "დათვალეთ",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "ყველა თანამშრომლები",
  "pad_presence_all_rooms": "ვრცელდება ოთახები",
  "pad_presence_load_error": "მოწყობილობის კოდის შემოწმება ვერ მოხერხდა. სცადეთ ხელახლა.",
  "pad_presence_in_room_now": "გახსნა · ოთახი · მხოლოდ ახლა",
  "pad_presence_in_room": "ში",
  "pad_presence_since": "გაწმენდიდან",
  "pad_presence_just_now": "მხოლოდ ახლა",
  "pad_presence_pad": "პადი",
  "pad_presence_phone": "ტელეფონი",
  "pad_presence_all_phones": "ყველა ტელეფონი",
  "pad_presence_window": "ჩვენება",
  "pad_presence_window_hour": "ბოლო საათი",
  "pad_presence_window_today": "დღეს",
  "pad_presence_window_month": "ბოლო თვე",
  "pad_presence_pads": "პადი · საიტი",
  "pad_presence_no_pads": "მიუნიჭებელი ოთახები (პადი)",
  "pad_presence_last_enter": "დამლაგებლის ბოლო შესვლა",
  "pad_presence_last_offline": "ბოლო ხაზგარეშე",
  "pad_presence_auto_exit_leave": "გამოსვლა → ავტომატური გამოსვლა",
  "pad_presence_auto_exit_earliest": "შესვლა:",
  "pad_presence_auto_exit_passed": "ჯერ კიდევ ღიაა = პადი. ან გამოსვლა 5მინ 45. გთხოვთ დაელოდოთ და სცადოთ ხელახლა",
  "cleaner_activity_live_footer": "მონაცემთა განახლება რეალურ დროში",
  "ca_empty_select_site_hint": "აირჩიეთ კომპანია და საიტი სათაურში, რათა ნახოთ დღევანდელი უფრო სუფთა აქტივობა.",
  "ca_empty_no_cleaners_hint": "დამლაგებლები არ არის დანიშნული ამ საიტზე და მიმდინარე ცვლაზე. მიანიჭეთ აქტიური საიტები და ცვლილებები მომხმარებლებში.",
  "ca_empty_access_denied": "წვდომა აკრძალულია",
  "ca_empty_access_denied_hint": "თქვენ არ გაქვთ ამ საიტის უფრო სუფთა აქტივობის ნახვის უფლება.",
  "ca_empty_load_error_hint": "სუფთა აქტივობის ჩატვირთვა ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა ან დაუკავშირდით მხარდაჭერას, თუ პრობლემა გაგრძელდება.",
  "ca_empty_no_filter_match": "არცერთი გამწმენდი არ შეესაბამება ამ ფილტრებს",
  "ca_empty_no_filter_match_hint": "სცადეთ ფილტრების გასუფთავება ან სხვა გამწმენდი, სამუშაო ადგილი ან ოთახის არჩევა.",
  "ca_timeline_all_cleaners": "დღევანდელი აქტივობა - ყველა დამლაგებელი",
  "ca_legend_work": "აქტიური",
  "ca_clock_sessions_more": "მეტი",
  "ca_clock_sessions_less": "ნაკლების ჩვენება",
  "ca_sort_label": "დალაგება",
  "ca_sort_needs_attention": "ყურადღებას საჭიროებს",
  "ca_sort_best_avg_response": "საუკეთესო საშუალო პასუხი",
  "ca_sort_worst_avg_response": "ყველაზე ცუდი საშუალო პასუხი",
  "ca_sort_most_sla_breaches": "SLA დარღვევის უმეტესობა",
  "ca_sort_most_open_complaints": "ყველაზე ღია საჩივრები",
  "ca_sort_most_work_time": "ყველაზე მეტი სამუშაო დრო",
  "ca_sort_least_work_time": "მინიმალური სამუშაო დრო",
  "ca_stat_avg_short": "საშ",
  "ca_stat_open_short": "გახსნა",
  "ca_stat_breach_short": "დარღვევა",
  "ca_stat_work_short": "მუშაობა",
  "ca_assigned_room_avg_hint": "საშუალო პასუხი დღეს დანიშნულ ოთახებზე",
  "ca_transit_tooltip": "ტრანზიტის დრო დავალებებს შორის",
  "ca_transit_live_tooltip": "ბოლო დავალების დახურვის დრო",
  "ca_legend_visits": "ვიზიტები გამოძახებებს შორის",
  "ca_visits_between_sla": "ვიზიტები წინა გამოძახების დახურვის შემდეგ",
  "ca_apply": "გამოყენება",
  "ca_visits_since": "დან",
  "ca_deferred_tip_title": "გადავადებული საჩივარი",
  "ca_deferred_tip_resolved": "მოგვარდა",
  "ca_deferred_tip_desc_open": "ჯერ კიდევ ღიაა - დამლაგებელი ამ ოთახების ნაცვლად ჯერ სხვა ოთახებს ემსახურებოდა.",
  "ca_deferred_tip_desc_closed": "ეს საჩივარი ღია დარჩა, სანამ დამლაგებელი ჯერ სხვა ოთახებს ემსახურებოდა.",
  "ca_deferred_tip_rooms_label": "მომსახურე პირველი:",
  "ca_attention_title": "ყურადღებას საჭიროებს",
  "ca_attention_empty": "ყველაფერი ნათელია - ახლა პრობლემები არ არის",
  "ca_attention_sla_breach_one": "{name} · SLA დაირღვა",
  "ca_attention_sla_breach_many": "{name} · {count} SLA დარღვევა",
  "ca_attention_open_while_out_one": "{name} · გახსენით საჩივარი, სანამ დრო არ არის",
  "ca_attention_open_while_out_many": "{name} · {count} ღიაა საათის გარეთ",
  "ca_attention_idle": "{name} · უმოქმედო {ხანგრძლივობა}",
  "ca_attention_late": "{name} · გვიანი საათი",
  "ca_attention_show": "ჩვენება",
  "ca_attention_hide": "დამალვა",
  "cleaner": "დამლაგებელი",
  "ca_view_shift": "ცვლა",
  "ca_view_history": "ისტორია",
  "ca_filters_done": "მზადაა",
  "ca_hist_preset_this_month": "ამ თვეში",
  "ca_hist_preset_last_month": "გასულ თვეში",
  "ca_hist_preset_this_week": "ამ კვირაში",
  "ca_hist_preset_last_week": "გასულ კვირაში",
  "ca_hist_preset_custom": "მორგებული",
  "ca_hist_from": "დან",
  "ca_hist_to": "მდე",
  "ca_hist_range_invalid": "დაწყების თარიღი უნდა უსწრებდეს დასრულების თარიღს",
  "ca_hist_range_too_long": "დიაპაზონი არ უნდა აღემატებოდეს {max} დღეს",
  "ca_hist_search": "ძებნა სახელით ან ტელეფონით",
  "ca_hist_people_count": "{count} თანამშრომელი",
  "ca_hist_kpi_days": "ნამუშევარი დღეები",
  "ca_hist_kpi_net": "წმინდა საათები",
  "ca_hist_kpi_breaks": "შესვენებები",
  "ca_hist_col_person": "თანამშრომელი",
  "ca_hist_col_total": "სულ საათები",
  "ca_hist_col_total_tip": "შემოსვლიდან გასვლამდე შესვენებების გამოკლების გარეშე — იგივე მაჩვენებელი, რასაც თანამშრომელი აპლიკაციაში ხედავს",
  "ca_hist_col_net": "წმინდა საათები",
  "ca_hist_col_breaks": "შესვენებები",
  "ca_hist_col_issues": "შენიშვნები",
  "ca_hist_col_late": "დაგვიანება",
  "ca_hist_col_missed": "გაცდენა",
  "ca_hist_col_no_clock_out": "გასვლის გარეშე",
  "ca_hist_clocked_in_now": "ახლა შემოსულია",
  "ca_hist_not_assigned": "ამ ობიექტზე არ არის მიმაგრებული",
  "ca_hist_no_shift": "ცვლა არ არის მინიჭებული",
  "ca_hist_unknown_name": "უცნობი",
  "ca_hist_empty": "ამ პერიოდში დასწრება არ არის",
  "ca_hist_empty_hint": "ამ ობიექტზე არავინ შემოსულა და თანამშრომლები მასზე მიმაგრებული არ არიან.",
  "ca_hist_no_match": "ფილტრებს არცერთი თანამშრომელი არ შეესაბამება",
  "ca_hist_load_error_hint": "დასწრების ისტორიის ჩატვირთვა ვერ მოხერხდა. სცადეთ ცოტა ხანში.",
  "ca_hist_prev_person": "წინა თანამშრომელი",
  "ca_hist_next_person": "შემდეგი თანამშრომელი",
  "ca_hist_close": "დახურვა",
  "ca_hist_legend_worked": "იმუშავა",
  "ca_hist_legend_late": "დაგვიანება",
  "ca_hist_legend_missed": "გაცდენა",
  "ca_hist_legend_no_clock_out": "გასვლის გარეშე",
  "ca_hist_late_by": "დაგვიანება {duration}",
  "ca_hist_late_tip": "შემოვიდა {time}-ზე, {shift} იწყება {start}-ზე",
  "ca_hist_missed": "გაცდენა",
  "ca_hist_missed_tip": "დაგეგმილი ცვლა დასრულდა შემოსვლის გარეშე",
  "ca_hist_no_clock_out": "გასვლის გარეშე",
  "ca_hist_no_clock_out_tip": "სესია არ დახურულა; მისი საათები არ ითვლება",
  "ca_hist_in_progress": "ჯერ კიდევ შემოსულია",
  "ca_hist_auto": "ავტო",
  "ca_hist_open_break": "ღია",
  "ca_hist_day_col_gross": "სულ საათები",
  "ca_hist_day_col_breaks": "შესვენებები",
  "active_cleaners": "აქტიური გამწმენდები",
  "closed_complaints": "დახურული საჩივრები",
  "total_work_time": "საერთო სამუშაო დრო",
  "total_work_time_net": "მთლიანი სამუშაო დრო (დღეს წმინდა)",
  "total_break_time": "სულ შესვენების დრო",
  "avg_response_time": "საშ. გადაწყდა",
  "clocked_in": "ჩაკეტილი",
  "clocked_out": "ჩაკეტილი",
  "still_clocked_in": "ჯერ კიდევ ჩართულია",
  "clocked_in_late": "გვიანი საათი",
  "total_hours": "სულ საათები",
  "auto_punch": "ავტომატური (geofence)",
  "manual_punch": "სახელმძღვანელო",
  "complaint_opened": "საჩივარი გაიხსნა",
  "complaint_closed": "საჩივარი დახურულია",
  "complaint_still_open": "ჯერ კიდევ ღიაა",
  "resolved_in": "გადაწყდა",
  "open_for": "გახსნა ამისთვის",
  "sla_breached": "SLA დაირღვა",
  "no_activity_today": "დღეს არანაირი აქტივობა არ არის",
  "just_now": "მხოლოდ ახლა",
  "ago": "წინ",
  "today": "დღეს",
  "live": "ცოცხალი",
  "last_updated": "განახლებულია",
  "expose_results": "შედეგები",
  "events_expose": "ღონისძიებები",
  "expose_score": "შეფასება",
  "shift_events_expose": "გადაიტანეთ მოვლენები და გამოავლინეთ",
  "type_of_site": "საიტის ტიპი",
  "morning_shift": "დილის ცვლა",
  "afternoon_shift": "შუადღის ცვლა",
  "night_shift": "ღამის ცვლა",
  "update": "განახლება",
  "restart": "გადატვირთეთ",
  "send_data": "მონაცემების გაგზავნა",
  "send_count": "გაგზავნეთ რაოდენობა",
  "blink": "მოციმციმე",
  "beacon": "მაშური",
  "like_btn": "მოწონების ღილაკი",
  "requires_like_btn": "საჭიროა მოწონების ღილაკის ჩართვა",
  "maintenance_btn": "მოვლის ღილაკი",
  "battery": "ბატარეა",
  "version": "ვერსია",
  "actions": "მოქმედებები",
  "device_actions": "მოწყობილობის მოქმედებები",
  "device_settings": "მოწყობილობის პარამეტრები",
  "drains_battery": "აქრობს ბატარეას",
  "latest_errors": "უახლესი შეცდომები",
  "no_errors": "შეცდომები არ არის",
  "offline_calls": "ოფლაინ ზარები",
  "offline_duration_calls": "ხაზგარეშე ხანგრძლივობის ზარები",
  "counterCalls": "საპასუხო ზარები",
  "active": "აქტიური",
  "no_active_supervisors": "აქტიური ზედამხედველები არ არიან",
  "active_supervisors_column": "აქტიური ზედამხედველები",
  "supervisors_active_label": "ზედამხედველები ახლა აქტიურია",
  "active_supervisors_coverage_hint": "აქტიურ ზედამხედველებს ეს არე ჩართული აქვთ მობილური აპლიკაციაში. ეს არ მიუთითებს ონლაინ სტატუსზე ან ფიზიკურ ყოფნაზე.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "აქტიური გაანგარიშება",
  "pad": "პადი",
  "pad_counter": "ბალიშის მრიცხველი",
  "counter_status": "მრიცხველის სტატუსი",
  "choose_state": "აირჩიეთ სახელმწიფო",
  "choose_city": "აირჩიეთ ქალაქი",
  "start_hour": "დაწყების საათი",
  "end_hour": "დასრულების საათი",
  "analytics_log": "ანალიტიკის ჟურნალი",
  "or": "ან",
  "no_data_available": "მონაცემები არ არის ხელმისაწვდომი",
  "filter_by_cleaner": "გაფილტვრა გამწმენდით",
  "all_cleaners": "ყველა საწმენდი",
  "not_available": "N/A",
  "failed_to_load_data": "მონაცემების ჩატვირთვა ვერ მოხერხდა",
  "new_task": "ახალი დავალება",
  "new_personal_task": "ახალი პირადი დავალება",
  "task_assignment": "დავალების დავალება",
  "task_assignment_room": "ოთახის დავალება",
  "task_assignment_personal": "პირადი დავალება (დაავალეთ დამლაგებელი)",
  "temporarily_unavailable": "დროებით მიუწვდომელია",
  "task_details": "დავალების დეტალები",
  "task_languages": "დავალების ენები",
  "task_languages_hint": "აირჩიეთ ენები ამ ამოცანისთვის. თქვენ შეიყვანთ სათაურს თითოეულ არჩეულ ენაზე.",
  "settings_and_assignment": "პარამეტრები და დავალება",
  "assignee": "დავალებული",
  "category": "კატეგორია",
  "title": "სათაური",
  "task_type": "დავალების ტიპი",
  "task_category": "დავალების კატეგორია",
  "call_to_action": "მოწოდება მოქმედებისკენ",
  "schedule": "განრიგი",
  "insert_text": "ტექსტის ჩასმა",
  "select": "აირჩიეთ",
  "select_all": "აირჩიეთ ყველა",
  "n_selected": "არჩეულია: {count}",
  "clear_selection": "არჩევის გასუფთავება",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "დაგეგმეთ თარიღები",
  "language": "ენა",
  "calendar": "კალენდარი",
  "operation": "ოპერაცია",
  "daily": "ყოველდღიური",
  "weekly": "ყოველკვირეული",
  "monthly": "ყოველთვიური",
  "quarterly": "კვარტალური",
  "yearly": "ყოველწლიურად",
  "sunday": "კვირა",
  "monday": "ორშაბათი",
  "tuesday": "სამშაბათი",
  "wednesday": "ოთხშაბათი",
  "thursday": "ხუთშაბათი",
  "friday": "პარასკევი",
  "saturday": "შაბათი",
  "january": "იანვარი",
  "february": "თებერვალი",
  "march": "მარტი",
  "april": "აპრილი",
  "may": "მაისი",
  "june": "ივნისი",
  "july": "ივლისი",
  "august": "აგვისტო",
  "september": "სექტემბერი",
  "october": "ოქტომბერი",
  "november": "ნოემბერი",
  "december": "დეკემბერი",
  "1st week": "1 კვირა",
  "2nd week": "მე-2 კვირა",
  "3rd week": "მე-3 კვირა",
  "4th week": "მე-4 კვირა",
  "5th week": "მე-5 კვირა",
  "1st quarter": "1-ლი კვარტალი",
  "2nd quarter": "მე-2 კვარტალი",
  "3rd quarter": "მე-3 კვარტალი",
  "4th quarter": "მე-4 კვარტალი",
  "edit_task": "დავალების რედაქტირება",
  "created_at": "შექმნილია",
  "installed_at": "დაინსტალირებულია",
  "hour": "საათი",
  "week_days": "კვირის დღეები",
  "month_weeks": "თვე კვირა",
  "month_days": "თვის დღეები",
  "no_tasks_found": "ამოცანები ვერ მოიძებნა",
  "invalid_language": "არასწორი ენა",
  "no_active_tasks_found": "აქტიური ამოცანები ვერ მოიძებნა",
  "edit": "რედაქტირება",
  "send_date": "გაგზავნის თარიღი",
  "invalid_date": "არასწორი თარიღი",
  "hour_must_be_after_current": "გთხოვთ, აირჩიოთ საათი, რომელიც არის მიმდინარე დროის შემდეგ",
  "cells_num": "უჯრედების #",
  "sinks_num": "ნიჟარები #",
  "urinals_num": "საშარდეები #",
  "toilet_paper_size": "ტუალეტის ქაღალდის ზომა",
  "email_configuration": "ელ.ფოსტის კონფიგურაცია",
  "please_edit_the_email_information": "გთხოვთ, შეცვალოთ ელ.ფოსტის ინფორმაცია",
  "email_sender_info": "ელფოსტის გამგზავნის ინფორმაცია",
  "email_subject_info": "ელ.ფოსტის თემის ინფორმაცია",
  "email_message_info": "ელ.ფოსტის შეტყობინების ინფორმაცია",
  "companyName": "კომპანიის სახელი",
  "email_language": "ელ.ფოსტის ენა",
  "complaint_language": "საჩივრის ენა",
  "email_message_format": "ელ.ფოსტის შეტყობინების ფორმატი",
  "line": "ხაზი",
  "list": "სია",
  "roomType": "ოთახის ტიპი",
  "By logging in, you agree to Buzzztech's": "სისტემაში შესვლით თქვენ ეთანხმებით Buzzztech-ს",
  "Terms and Conditions": "წესები და პირობები",
  "and": "და",
  "Privacy Policy": "კონფიდენციალურობის პოლიტიკა",
  "All actions within this panel are recorded for quality control and improvement": "ყველა ქმედება ამ პანელში ჩაწერილია ხარისხის კონტროლისა და გაუმჯობესებისთვის",
  "You must agree to the terms and conditions": "თქვენ უნდა დაეთანხმოთ წესებსა და პირობებს",
  "months": "თვეები",
  "ref_id": "მითითების ID",
  "room_name_en": "ოთახის სახელი ინგლისურად",
  "site_state": "საიტის მდგომარეობა",
  "site_city": "საიტის ქალაქი",
  "city": "ქალაქი",
  "state": "სახელმწიფო",
  "site_country": "საიტის ქვეყანა",
  "first_date": "პირველი პაემანი",
  "pinned": "ჩამაგრებული",
  "no.": "არა.",
  "must_be_numbers": "ნომრები უნდა იყოს",
  "must_be_3_digits": "უნდა იყოს 3 ციფრი",
  "must_have_english_title": "უნდა ჰქონდეს ინგლისური სათაური",
  "total_sites": "სულ",
  "site_information": "საიტის ინფორმაცია",
  "holiday_offdays": "არდადეგები და დასვენების დღეები",
  "add_offday": "დასვენების დღე",
  "add_holiday": "დღესასწაული",
  "name_under_chars": "დასახელება 25 სიმბოლოზე ნაკლები",
  "days_comma_separated": "მოქმედი დღეები, გამოყოფილი მძიმით",
  "year": "წელიწადი",
  "month": "თვე",
  "day": "დღე",
  "holiday_name": "დღესასწაულის სახელი",
  "offday_name": "დასვენების დღის სახელი",
  "delete_confirmation_title": "დარწმუნებული ხარ?",
  "delete_confirmation_message": "ამ მოქმედების გაუქმება შეუძლებელია.",
  "are_you_sure": "დარწმუნებული ხარ?",
  "israel": "ისრაელი",
  "USA": "აშშ",
  "poland": "პოლონეთი",
  "mexico": "მექსიკა",
  "cyprus": "კვიპროსი",
  "brazil": "ბრაზილია",
  "romania": "რუმინეთი",
  "netherlands": "ნიდერლანდები",
  "tablet_survey": "ტაბლეტის გამოკითხვა",
  "no_shift_survey": "ტაბლეტის ცვლის გამოკითხვა არ არის",
  "number_of_rows": "რიგების რაოდენობა",
  "rating_shape": "რეიტინგის ფორმა",
  "content_survey": "შინაარსის გამოკითხვა",
  "rating_survey": "რეიტინგის გამოკითხვა",
  "device-alerts": "პრობლემა",
  "device-active": "აქტიური",
  "device-search": "ძიება",
  "mac_id": "MAC მისამართი",
  "qr_tag": "QR ტეგი",
  "sensor": "სენსორი",
  "image_survey": "გამოსახულების გამოკითხვა",
  "open_text": "ტექსტის გახსნა",
  "open_text_survey": "გახსენით ტექსტური გამოკითხვა",
  "embedded_link": "ჩაშენებული ბმული",
  "device-counter": "მრიცხველი",
  "count": "დათვალეთ",
  "last_date": "ბოლო პაემანი",
  "last_arrival": "დამლაგებლის ბოლო ჩამოსვლა",
  "cleaners": "დამლაგებლები",
  "viewer": "მაყურებელი",
  "android": "Android",
  "ios": "iOS",
  "no_users_found": "მომხმარებელი ვერ მოიძებნა",
  "no_cleaners_found": "საწმენდები ვერ მოიძებნა",
  "new_cleaner": "ახალი გამწმენდი",
  "edit_cleaner": "დამლაგების რედაქტირება",
  "have_you_finished_making_changes": "დაასრულეთ ცვლილებების შეტანა?",
  "assignment_issues_found": "ნაპოვნია მინიჭების პრობლემები",
  "unassigned_rooms_title": "მიუნიჭებელი ოთახები",
  "overlapping_assignments_title": "გადაფარვადი მინიჭებები",
  "and_n_more": "და კიდევ {count}",
  "continue_anyway": "მაინც გაგრძელება",
  "stay_and_fix": "დარჩენა და გამოსწორება",
  "assignment_coverage_issues": "{unassigned} მიუნიჭებელი · {overlaps} გადაფარვა",
  "assignment_check_failed": "ოთახების მინიჭების შემოწმება ვერ მოხერხდა",
  "tap_for_details": "დააჭირეთ დეტალებისთვის",
  "has_app": "აპლიკაცია",
  "has_app_tooltip": "დამლაგებელს აქვს აპი",
  "notifications_tooltip": "Push შეტყობინებები ჩართულია",
  "assigned_to_rooms": "მინიჭებულია ოთახებზე",
  "assigned_to_rooms_tooltip": "მინიჭებულია ოთახები ამ საიტზე",
  "recently_active": "ბოლოს აქტიური",
  "works_at_site": "მუშაობს ობიექტზე",
  "recently_active_tooltip": "აპი გახსნა ბოლო 30 წუთში",
  "please_select": "გთხოვთ აირჩიოთ",
  "please_select_site_first": "გთხოვთ, ჯერ აირჩიეთ საიტი",
  "working_areas": "სამუშაო ადგილები",
  "no_working_areas": "სამუშაო ადგილები ჯერ არ არის",
  "working_area_alerts": "გაფრთხილებები",
  "api": "API",
  "task_target_by_working_areas": "სამუშაო ადგილების მიხედვით (ყველა ოთახი შერჩეულ ადგილებში)",
  "task_target_by_rooms": "კონკრეტული ოთახების მიხედვით",
  "task_target_label": "ამოცანა იხსნება",
  "step_what": "რა",
  "step_when": "როცა",
  "step_where": "სად",
  "step_options": "ოფციები",
  "please_create_room_before_working_area": "გთხოვთ, შექმნათ მინიმუმ ერთი ოთახი სამუშაო ადგილის შექმნამდე",
  "isWorkingInSite": "ადგილზე მუშაობა",
  "you_are_not_allowed_to_edit": "თქვენ არ გაქვთ რედაქტირების უფლება",
  "you_are_not_allowed_to_remove": "წაშლის უფლება არ გაქვს",
  "task": "დავალება",
  "portuguese": "პორტუგალიური",
  "russian": "რუსული",
  "spanish": "ესპანური",
  "polish": "პოლონური",
  "installer": "ინსტალერი",
  "once": "ერთხელ",
  "time_saved": "დაზოგილი დრო",
  "yes": "დიახ",
  "no": "არა",
  "workingAreaNames": "სამუშაო ადგილების სახელები",
  "shift_rooms": "ოთახები",
  "shift_validation_overlap": "ეს ცვლა ემთხვევა „{shiftName}“-ს ოთახში „{roomName}“. ამოიღეთ ოთახი ერთ-ერთი ცვლიდან ან შეცვალეთ მათი საათები.",
  "shift_validation_missing_fields": "გთხოვთ შეავსოთ ყველა საჭირო ცვლის ველი (საათები, დღეები და საიტი).",
  "shift_validation_empty_rooms": "გთხოვთ, ამ ცვლას დაუთმოთ მინიმუმ ერთი ოთახი.",
  "shift_validation_no_valid_rooms": "ამ ცვლისთვის მოქმედი ოთახები არჩეული არ არის.",
  "shift_validation_empty_room_map": "ცვლის განრიგის აგება ვერ მოხერხდა. შეამოწმეთ არჩეული დღეები და საათები.",
  "new_shift": "ახალი ცვლა",
  "add_shift_inactive": "დაამატეთ ამრეკლი ძვრები",
  "remove_auto_shift_inactive": "ამოიღეთ ავტომატური ამრეკლი ძვრები",
  "additional_options": "დამატებითი პარამეტრები",
  "add_default_shifts": "დაამატეთ ნაგულისხმევი ძვრები",
  "no_user_found": "მომხმარებელი ვერ მოიძებნა",
  "no_site_found": "საიტი ვერ მოიძებნა",
  "open_complaints": "გახსენით საჩივრები",
  "site_alerts": "საიტის გაფრთხილებები",
  "open_sla_alerts": "გახსენით საჩივრების გაფრთხილებები",
  "open_duration": "გახსნის ხანგრძლივობა",
  "no_open_slas": "ღია SLA ვერ მოიძებნა",
  "no_open_slas_description": "ამჟამად არ არის საიტები ღია SLA-ებით.",
  "no_slas_to_send": "ამ საიტისთვის ღია SLA ვერ მოიძებნა",
  "total_open_complaints": "სულ ღია საჩივრები",
  "longest_duration": "ყველაზე გრძელი ხანგრძლივობა",
  "complaints_details": "საჩივრების დეტალები",
  "rooms_with_open_complaints_percentage": "ოთახები ღია საჩივრებით",
  "rooms_with_cleaner_arrival_percentage": "ოთახები სუფთა ჩამოსვლასთან ერთად",
  "rooms_without_cleaner_arrival_percentage": "ოთახები სუფთა ჩასვლის გარეშე",
  "site_alerts_total_rooms": "სულ ოთახები",
  "site_alerts_open_complaints_count": "ღია საჩივრების რაოდენობა",
  "site_alerts_customer_opening_date": "კლიენტის გახსნის თარიღი",
  "company_country": "კომპანიის ქვეყანა",
  "select_message": "აირჩიეთ შეტყობინება",
  "message_no_cleaner_arrival": "გამარჯობა ყველას,\nგთხოვთ გაითვალისწინოთ, რომ არის ოთახები, სადაც დამლაგებლის ჩამოსვლა დღეს არ დაფიქსირებულა.\nგთხოვთ გაუმკლავდეთ ამას",
  "message_open_complaints": "გამარჯობა ყველას,\nგთხოვთ გაითვალისწინოთ, რომ არის რამდენიმე ოთახი ღია საჩივრებით დიდი ხნის განმავლობაში.\nგთხოვთ გაუმკლავდეთ ამას",
  "rooms_list": "ოთახები:",
  "please_address_issues_promptly": "გთხოვთ, დროულად მოაგვაროთ ეს საკითხები.",
  "no_results_found": "შედეგი ვერ მოიძებნა",
  "showing": "ჩვენება",
  "per_page": "თითო გვერდზე",
  "whatsapp": "WhatsApp",
  "loading": "იტვირთება",
  "error_opening_whatsapp": "WhatsApp-ის გახსნის შეცდომა. გთხოვთ, სცადოთ ხელახლა.",
  "error_loading_slas": "შეცდომა SLA დეტალების ჩატვირთვისას. გთხოვთ, სცადოთ ხელახლა.",
  "send_whatsapp": "გაგზავნეთ WhatsApp",
  "preview_message": "წინასწარი შეტყობინების გაგზავნა",
  "copy_message": "შეტყობინების კოპირება",
  "message_preview": "შეტყობინების გადახედვა",
  "phone_number_optional": "ტელეფონის ნომერი (სურვილისამებრ)",
  "enter_phone_number": "შეიყვანეთ ტელეფონის ნომერი (მაგ., +1234567890)",
  "phone_number_hint": "დატოვეთ ცარიელი, რათა გახსნათ WhatsApp კონკრეტული კონტაქტის გარეშე",
  "message_copied": "შეტყობინება დაკოპირდა ბუფერში!",
  "error_copying_message": "შეცდომა შეტყობინების კოპირებისას. გთხოვთ, სცადოთ ხელახლა.",
  "opening_whatsapp": "WhatsApp-ის გახსნა...",
  "preview_message_description": "გადახედეთ და დაარედაქტირეთ შეტყობინება გაგზავნამდე",
  "copy_message_description": "დააკოპირეთ შეტყობინება ბუფერში",
  "service_provider": "სერვისის მიმწოდებელი",
  "qr task": "QR ამოცანა",
  "qr_task": "QR ამოცანა",
  "all_day": "მთელი დღე",
  "auto_start": "ავტომატური დაწყება",
  "more_options": "მეტი ვარიანტი",
  "english_title": "ინგლისური სათაური",
  "connectivity": "დაკავშირება",
  "power": "ძალაუფლება",
  "Your work has been saved": "თქვენი ნამუშევარი შენახულია",
  "schedule_call_time": "დაგეგმეთ ზარის დრო",
  "schedule_call_gap": "ზარის ხარვეზის დაგეგმვა",
  "gapInMinutes": "უფსკრული წუთებში",
  "no_manual_calls_available": "ხელით ზარები არ არის ხელმისაწვდომი",
  "manual_calls": "ხელით ზარები",
  "cleandexCalls": "Cleandex რეკავს",
  "manualCalls": "ხელით ზარები",
  "inactive": "არააქტიური",
  "on hold": "მოლოდინში",
  "sequential": "თანმიმდევრული",
  "ratio": "თანაფარდობა",
  "must_choose": "უნდა აირჩიოს",
  "surveyApp": "გამოკითხვის აპლიკაცია",
  "installation": "ინსტალაცია",
  "manager": "მენეჯერი",
  "previous": "წინა",
  "no_rooms_found": "ოთახები არ მოიძებნა",
  "show_calendar": "კალენდრის ჩვენება",
  "seeAll": "იხილეთ ყველა",
  "showPaginated": "გვერდის ჩვენება",
  "cleaners_arrivals": "დამლაგებლების ჩამოსვლა",
  "qr validator": "QR ვალიდატორი",
  "qr_validator": "QR ვალიდატორი",
  "searchAddress": "მოძებნეთ მისამართი",
  "sector": "სექტორი",
  "add_address": "მისამართის დამატება",
  "site_auto_attendance_enabled": "დაუშვით ავტომატური საათის ჩართვისა და საათის გამორთვა მობილური აპლიკაციის geofence-ის გამოყენებით (თანამშრომლებს სჭირდებათ აპისა და მდებარეობის ნებართვა).",
  "site_auto_attendance_requires_location": "ავტომატური დასწრების ჩართვამდე ჯერ დააყენეთ მდებარეობა რუკაზე (პინი და რადიუსი მინიმუმ 100 მ).",
  "site_mandatory_clock_in": "სამუშაოს დაწყებამდე შემოსვლის რეგისტრაცია სავალდებულოა",
  "site_mandatory_clock_in_description": "ამ ობიექტის თანამშრომლებმა უნდა დაარეგისტრირონ შემოსვლა, სანამ მობილურ აპლიკაციაში დასუფთავების, მოვლისა და დავალებების ჩანართებს გახსნიან.",
  "site_mandatory_clock_in_without_location": "ამ ობიექტს რუკაზე მდებარეობა არ აქვს, ამიტომ აპლიკაცია ვერ ადგენს, როდის იმყოფება თანამშრომელი ობიექტზე. სანამ არ დააყენებთ, მოთხოვნა ამ თანამშრომლებზე ყველგან ვრცელდება.",
  "auto_attendance": "ავტო დასწრება",
  "auto_attendance_ready": "მზადაა",
  "auto_attendance_off": "გამორთულია",
  "auto_attendance_needs_setup": "დაყენება სჭირდება",
  "auto_attendance_ready_tooltip": "გადართვა ჩართულია.",
  "auto_attendance_off_tooltip": "გადართვა გამორთულია. შეცვალეთ საიტი, რათა ჩართოთ ავტომატური დასწრება.",
  "auto_attendance_needs_setup_tooltip": "გადართვა ჩართულია, მაგრამ გეოღობე აკლია ან 100 მეტრზე ნაკლებია. დაარედაქტირეთ საიტი მის გამოსასწორებლად.",
  "edit_address": "მისამართის რედაქტირება",
  "choose_radius": "აირჩიეთ რადიუსი",
  "cleandex": "Cleandex",
  "cleandex_column_tooltip": "მწვანე = კარგი. წითელი = რეკომენდირებულია გასაწმენდად.\nდეტალებისთვის გადაიტანეთ უჯრედის ხატულა.",
  "recommended_to_clean": "რეკომენდირებულია გაწმენდა",
  "cleandex_warning_level": "Cleandex გაფრთხილების დონე",
  "select_warning_level": "აირჩიეთ გაფრთხილების დონე",
  "bronze": "ბრინჯაო",
  "silver": "ვერცხლი",
  "gold": "ოქრო",
  "ai": "AI",
  "daily_employees_num": "ყოველდღიური თანამშრომლების რაოდენობა",
  "daily_shift_hours": "ყოველდღიური ცვლის საათები",
  "rooms_num": "ოთახების ნომერი",
  "buildings_num": "შენობების ნომერი",
  "cleaner_entries": "უფრო სუფთა ჩანაწერები",
  "avg_daily_visits_monthly": "საშუალო ყოველდღიური ვიზიტები ყოველთვიურად",
  "avg_daily_cleaners_to_save": "საშუალო ყოველდღიური საწმენდები დაზოგვისთვის",
  "saving_hours_per_day": "საათების დაზოგვა დღეში",
  "saving_money_per_day": "ფულის დაზოგვა დღეში",
  "saving_money_per_month": "ფულის დაზოგვა თვეში",
  "cleaners_to_visitors_ratio": "დამლაგებლების თანაფარდობა ვიზიტორებთან",
  "cleaning_time_in_minutes_per_room": "დასუფთავების დრო თითო ოთახში წუთებში",
  "max_number_of_rooms_per_employee": "ოთახების მაქსიმალური რაოდენობა ერთ თანამშრომელზე",
  "break_time_per_hour": "შესვენების დრო საათში",
  "transition_time_between_tasks": "დავალებებს შორის გადასვლის დრო",
  "employer_cost_hour": "დამსაქმებლის ღირებულება საათში",
  "lobby_cleaning_per_floor": "ლობის დასუფთავება თითო სართულზე",
  "desired_cleaning_time": "დასუფთავების სასურველი დრო",
  "desired_number_of_entries": "ჩანაწერების სასურველი რაოდენობა",
  "buzz_system_cost_per_unit_per_month": "Buzz სისტემის ღირებულება ერთეულზე თვეში",
  "total_buzz_system_cost_per_month": "მთლიანი Buzz სისტემის ღირებულება თვეში",
  "return_on_investment_in_months": "ინვესტიციის დაბრუნება თვეებში",
  "annual_savings": "წლიური დანაზოგი",
  "roi_calculator": "ROI კალკულატორი",
  "cleaning_work_plan": "დასუფთავების სამუშაო გეგმა",
  "cleaning_work_plan_intro": "სათაურში იყენებს ცვლის ოთახის სტატისტიკას კომპანიისთვის და საიტისთვის. ვიზიტები და ჩამოსვლა ხდება ერთი დღიდან, სადაც საიტის ყველაზე მეტი ვიზიტებია თარიღის დიაპაზონში და გადადის დაფის ფილტრიდან (დააყენეთ ისინი Performance-ზე ან Analytics-ზე, თუ ეს ჩანართი მალავს დროს და ფილტრის კონტროლს). შეიყვანეთ ვიზიტები ყოველ დასუფთავებაზე, პერსონალის სამიზნე, საათობრივი ღირებულება და საშუალო წუთები ყოველ დასუფთავებაზე; გენერირება ოთახის დონის შემოთავაზებული გაწმენდებისა და შემაჯამებელი ჯამების სანახავად.",
  "cleaning_work_plan_default_n": "ვიზიტები თითო სუფთად",
  "cleaning_work_plan_cleaner_count": "საწმენდები (სურვილისამებრ)",
  "cleaning_work_plan_avg_minutes": "დასუფთავების საშუალო დრო (წთ)",
  "cleaning_work_plan_run": "შექმენით გეგმა",
  "cleaning_work_plan_export_csv": "ექსპორტი Excel",
  "cleaning_work_plan_suggested_n": "ვიზიტები თითო სუფთად",
  "cleaning_work_plan_actual_cleans": "ჩამოსვლა",
  "cleaning_work_plan_actual_cleans_hint": "ცვლის ოთახში დამლაგებლების სულ ჩასვლის სტატისტიკა პიკის დღეს (არჩეული დიაპაზონისა და ფილტრების ფარგლებში).",
  "cleaning_work_plan_suggested_cleans": "რეკომენდებული წმენდა",
  "cleaning_work_plan_cleaner": "დამლაგებელი",
  "cleaning_work_plan_floors": "სართულები",
  "cleaning_work_plan_peak_day": "პიკის დღე",
  "cleaning_work_plan_error": "დასუფთავების სამუშაო გეგმის გენერირება ვერ მოხერხდა",
  "cleaning_work_plan_no_rooms": "ამ საიტისთვის ოთახები არ დაბრუნებულა. შეამოწმეთ საიტი და თარიღის დიაპაზონი, ან შეამოწმეთ ოთახების არსებობა საკონტროლო პანელში.",
  "cleaning_work_plan_need_filter": "აირჩიეთ კომპანია და საიტი სათაურში, დააყენეთ თარიღის დიაპაზონი (და საჭიროების შემთხვევაში გადაიტანეთ) Performance ან Analytics, შემდეგ სცადეთ ხელახლა.",
  "cleaning_work_plan_settings": "გეგმის პარამეტრები",
  "cleaning_work_plan_desired_employees": "თანამშრომლების სასურველი რაოდენობა",
  "cleaning_work_plan_cost_per_hour": "ღირებულება საათში",
  "cleaning_work_plan_estimated_cost_suggested": "სავარაუდო ღირებულება (სავარაუდო დატვირთვა)",
  "cleaning_work_plan_estimated_cost_actual": "სავარაუდო ღირებულება (ფაქტობრივი დატვირთვა)",
  "cleaning_work_plan_hours_per_cleaner": "საათები თითო დამლაგებელზე",
  "cleaning_work_plan_metric_title": "მეტრიკა",
  "cleaning_work_plan_metric_avg_cleaning_min": "საშ. დასუფთავების დრო (წთ)",
  "cleaning_work_plan_metric_total_arrivals": "სულ ჩამოსვლა",
  "cleaning_work_plan_metric_total_cleaning_min": "დასუფთავების მთლიანი დრო (წთ)",
  "cleaning_work_plan_metric_total_cleaning_hours": "დასუფთავების მთლიანი დრო (საათები)",
  "cleaning_work_plan_metric_hours_per_cleaner_row": "საათები თითო დამლაგებელზე",
  "cleaning_work_plan_metric_num_cleaners": "დამლაგებლების რაოდენობა",
  "cleaning_work_plan_summary": "რეზიუმე",
  "cleaning_work_plan_summary_peak_note": "ვიზიტები, ჩასვლები და შემოთავაზებული დასუფთავება იყენებს იმავე ცვლის ოთახის სტატისტიკის წესებს, როგორც Analytics (ჩამოსვლათა აგრეგაციის ჩათვლით). ისინი განკუთვნილია პიკის დღისთვის - კალენდარული დღისთვის, სადაც ყველაზე მეტი ვიზიტებია ფილტრის პერიოდში. შედის მხოლოდ გამოთვლილი ოთახები, როგორიცაა მიმოხილვა, როდესაც ოთახის ფილტრი არ არის გამოყენებული.",
  "cleaning_work_plan_summary_filter_period": "ფილტრაციის პერიოდი",
  "cleaning_work_plan_summary_total_visits": "სულ ვიზიტები",
  "cleaning_work_plan_summary_total_arrivals": "სულ ჩამოსვლა",
  "cleaning_work_plan_summary_employees_in_site": "თანამშრომლები ადგილზე",
  "cleaning_work_plan_summary_shift_working_hours": "ცვლის სამუშაო საათებს",
  "cleaning_work_plan_hours_unit": "თ",
  "cleaning_work_plan_rooms_table": "ოთახები",
  "cleaning_work_plan_cleaners_table": "რეკომენდებულია სუფთა განაწილება",
  "cleaning_work_plan_search_rooms": "ოთახების ძებნა",
  "cleaning_work_plan_total_minutes": "სულ წუთები",
  "cleaning_work_plan_actual_total_minutes": "ფაქტობრივი ჯამური წუთები",
  "cleaning_work_plan_actual_total_minutes_hint": "დაფიქსირდა დამლაგებლის ჩამოსვლა ცვლის ოთახის სტატისტიკაში პიკის დღეს (არჩეული დიაპაზონის ფარგლებში), გამრავლებული თქვენს საშუალო წუთზე ყოველ გაწმენდაზე.",
  "cleaning_work_plan_suggested_total_minutes": "შემოთავაზებული ჯამური წუთები",
  "cleaning_work_plan_suggested_room_minutes": "რეკომენდებული დასუფთავების წუთები",
  "cleaning_work_plan_actual_room_minutes": "ფაქტობრივი დასუფთავების წუთები",
  "cleaning_work_plan_cleaner_suggested_minutes": "შემოთავაზებული მინ.",
  "cleaning_work_plan_cleaner_actual_minutes": "ფაქტობრივი მინ.",
  "cleaning_work_plan_period": "პერიოდი",
  "cleaning_work_plan_room_count": "ოთახის რაოდენობა",
  "cleaning_work_plan_cleaners_working_in_site": "საიტზე მომუშავე დამლაგებლები (აპის კონტაქტები)",
  "cleaning_work_plan_cleaners_connection_table": "დამლაგებლები ოთახების მიხედვით",
  "cleaning_work_plan_connected_rooms_count": "ოთახები",
  "cleaning_work_plan_connected_floor_count": "სართულების რაოდენობა",
  "cleaning_work_plan_connected_floors_list": "სართულები",
  "cleaning_work_plan_visitor_cleaning_entry_ratio": "ვიზიტორის/დასუფთავების შესვლის თანაფარდობა",
  "cleaning_work_plan_performance_comparison_table": "შესრულების შედარება",
  "cleaning_work_plan_performance_comparison_empty": "ჩატვირთეთ უფრო სუფთა კავშირის მონაცემები შედარების რიგების სანახავად.",
  "cleaning_work_plan_performance_col_index": "ინდექსი",
  "cleaning_work_plan_performance_existing_plan": "არსებული სამუშაო გეგმა",
  "cleaning_work_plan_performance_recommended_plan": "Buzzztech-ის რეკომენდებული გეგმა",
  "cleaning_work_plan_perf_number_of_employees": "თანამშრომელთა რაოდენობა",
  "cleaning_work_plan_perf_working_hours_per_employee": "სამუშაო საათები თითო თანამშრომელზე",
  "cleaning_work_plan_perf_total_working_hours": "სულ სამუშაო საათები",
  "cleaning_work_plan_perf_total_cleaning_hours": "სულ დასუფთავების საათები",
  "cleaning_work_plan_perf_daily_cost": "დღიური ღირებულება",
  "cleaning_work_plan_perf_total_cleaning_visits": "სულ დასუფთავების ვიზიტები",
  "cleaning_work_plan_perf_busiest_area_visits": "ყველაზე დატვირთული სამუშაო ადგილი - ვიზიტები",
  "cleaning_work_plan_perf_cleaning_to_busiest": "დასუფთავების ვიზიტები ყველაზე დატვირთულ ადგილას",
  "cleaning_work_plan_perf_max_cleaning_ratio": "დასუფთავების მაქსიმალური თანაფარდობა",
  "cleaning_work_plan_perf_least_busy_visits": "ყველაზე ნაკლებად დატვირთული სამუშაო ადგილი - ვიზიტები",
  "cleaning_work_plan_perf_cleaning_to_least": "დასუფთავების ვიზიტები ნაკლებად დატვირთულ ადგილას",
  "cleaning_work_plan_perf_min_cleaning_ratio": "დასუფთავების მინიმალური თანაფარდობა",
  "cleaning_work_plan_ai_allocate": "AI გამოყოფა",
  "cleaning_work_plan_ai_allocation_result": "AI გამოყოფის შედეგი",
  "cleaning_work_plan_ai_allocation_loading": "ხელოვნური ინტელექტის გამოყოფის გენერირება...",
  "cleaning_work_plan_ai_allocation_error": "AI გამოყოფის გენერირება ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "cleaning_work_plan_ai_invalid_employees": "გთხოვთ, დააყენოთ თანამშრომლების სწორი სასურველი რაოდენობა.",
  "cleaning_work_plan_ai_status_elapsed": "გავიდა: {s}s",
  "cleaning_work_plan_ai_status_hint": "სერვერი აწარმოებს რამდენიმე AI ნაბიჯს თანმიმდევრობით (საწყისი გეგმა, გეოგრაფია, ვიზიტის ბალანსი, შემდეგ საბოლოო გამომავალი). ამას შეიძლება ერთი-ორი წუთი დასჭირდეს - გთხოვთ, ეს გვერდი ღიად დარჩეთ.",
  "cleaning_work_plan_ai_status_step_1": "ნაბიჯი 1 - საწყისი დავალების შედგენა ოთახიდან და ვიზიტის მონაცემებიდან…",
  "cleaning_work_plan_ai_status_step_2": "ნაბიჯი 2 - გეოგრაფიის დახვეწა (მიმდებარე სართულებისა და შენობების დაჯგუფება)…",
  "cleaning_work_plan_ai_status_step_3": "ნაბიჯი 3 - ყოველდღიური ვიზიტების დაბალანსება დამლაგებლებს შორის…",
  "cleaning_work_plan_ai_status_step_4": "ნაბიჯი 4 - სტრუქტურირებული განაწილების გენერირება…",
  "cleaning_work_plan_ai_status_step_5": "ნაბიჯი 5 - საბოლოო მეტრიკის დადასტურება და გამოთვლა…",
  "cleaning_work_plan_ai_cleaner_number": "დამლაგებელი #",
  "cleaning_work_plan_room_minutes": "დასუფთავების წუთები",
  "cleaning_work_plan_assigned_cleaner": "დანიშნული დამლაგებელი",
  "cleaning_work_plan_summary_cleaners": "საწმენდები გეგმაში",
  "cleaning_work_plan_summary_avg_minutes": "საშუალო წუთები / სუფთა",
  "cleaning_work_plan_suggested_hours": "შემოთავაზებული მთლიანი საათები",
  "cleaning_work_plan_actual_hours": "ფაქტობრივი ჯამური საათები",
  "cleaning_work_plan_avg_suggested_min_per_cleaner": "საშუალო შემოთავაზებული მინ/დამწმენდი",
  "cleaning_work_plan_avg_actual_min_per_cleaner": "საშუალო ფაქტობრივი წთ / გამწმენდი",
  "cleaning_work_plan_guidelines_title": "ოპტიმიზაციის სახელმძღვანელო მითითებები",
  "cleaning_work_plan_guidelines_intro": "ეს ხელსაწყო მიჰყვება იგივე მიზნებს, როგორც ხელით დასუფთავების გეგმის ოპტიმიზაცია: სამუშაო დატვირთვა ვიზიტის მონაცემებიდან, დრო თქვენი საშუალო წუთებიდან ერთ დასუფთავებაზე და პერსონალი, რომელიც აბალანსებს მუშაობას, ხოლო სართულები გეოგრაფიულად გონივრულია.",
  "cleaning_work_plan_guidelines_b1": "ვიზიტები ყოველ დასუფთავებაზე (ნაგულისხმევი 50) ემთხვევა ჩვეულ 1:50 სტილის წესს: შემოთავაზებული შენატანები თითო ოთახში ≈ ვიზიტები ÷ ვიზიტები ყოველ დასუფთავებაზე (დამრგვალდება ზემოთ). ვიზიტები და ჩამოსვლა მიიღება ყველაზე დატვირთული დღიდან (საიტზე ყველაზე მაღალი ვიზიტები) თქვენს მიერ არჩეული თარიღის დიაპაზონში, ასე რომ, გეგმა ემთხვევა პიკის დატვირთვის დღეს.",
  "cleaning_work_plan_guidelines_b2": "როდესაც ადგენთ სუფთა რაოდენობას, შენობის თითოეული სართული არის ერთი ჯგუფი. სართულები დალაგებულია შენობისა და იატაკის ნომრის მიხედვით, შემდეგ იყოფა მომიჯნავე ბლოკებად საწმენდ საშუალებებში, ასე რომ, შემოთავაზებული დასუფთავება (იგულისხმება სამუშაო) დაბალანსებულია, ხოლო ახლომდებარე სართულები, როგორც წესი, დარჩება იმავე საწმენდზე.",
  "cleaning_work_plan_guidelines_b3": "ყველა საპირფარეშო ერთსა და იმავე შენობის სართულზე რჩება ერთიდაიგივე დამლაგებელით, ამიტომ მამაკაცისა და ქალის ოთახები ამ სართულზე არ იყოფა სხვადასხვა დამლაგებლებს შორის (სანამ ისინი საკონტროლო პანელში ერთსა და იმავე სართულს იზიარებენ).",
  "cleaning_work_plan_guidelines_b4": "საშუალო წუთები შემოთავაზებულ სუფთა დისკზე და ფაქტობრივი ჯამური წუთები, საათები და საშუალო წუთები თითო დამლაგებლად. ფაქტობრივი ჯამები იყენებს დაფიქსირებულ სუფთა ჩამოსვლას × თქვენი საშუალო; შემოთავაზებული ჯამები გამოიყენეთ ნაგულისხმევი გაწმენდა × თქვენი საშუალო.",
  "cleaning_work_plan_guidelines_b5": "გამოიყენეთ Export CSV, თუ გსურთ დახვეწოთ განაწილება სხვაგან (მაგალითად, ვიზიტის ბალანსის კიდევ უფრო გამკაცრება).",
  "cleaners_number": "დამლაგებლების ნომერი",
  "floors_num": "სართულების ნომერი",
  "avg_daily_cleaners_required": "საჭიროა საშუალო ყოველდღიური საწმენდები",
  "app_pages": "აპლიკაციის გვერდები",
  "buzzzTime": "ზუზუნის დრო",
  "missions": "მისიები",
  "send_emails": "ელფოსტის გაგზავნა",
  "enter": "შედი",
  "account": "ანგარიში",
  "privacy": "კონფიდენციალურობა",
  "personal_settings": "პერსონალური პარამეტრები",
  "personal_settings_lead": "მართეთ თქვენი ენისა და კონფიდენციალურობის პარამეტრები.",
  "personal_settings_read_only": "ამ დეტალებს მართავს თქვენი ადმინისტრატორი. დაუკავშირდით მათ, თუ რამე განახლებას საჭიროებს.",
  "change_password": "პაროლის შეცვლა",
  "change_password_hint": "პაროლის შეცვლა გამოგიყვანთ სისტემიდან სხვა მოწყობილობებზე.",
  "current_password": "მიმდინარე პაროლი",
  "new_password": "ახალი პაროლი",
  "confirm_new_password": "დაადასტურეთ ახალი პაროლი",
  "password_min_length": "პაროლი უნდა შედგებოდეს მინიმუმ 8 სიმბოლოსგან",
  "passwords_do_not_match": "პაროლები არ ემთხვევა",
  "new_password_same_as_current": "ახალი პაროლი უნდა განსხვავდებოდეს მიმდინარესგან",
  "current_password_incorrect": "მიმდინარე პაროლი არასწორია",
  "current_password_required": "მიმდინარე პაროლი აუცილებელია",
  "password_changed_successfully": "პაროლი წარმატებით შეიცვალა",
  "change_password_failed": "პაროლის შეცვლა ვერ მოხერხდა",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "მომხმარებლის სახელი ან პაროლი არასწორია",
  "login_credentials_required": "შეიყვანეთ მომხმარებლის სახელი ან ელფოსტა და პაროლი",
  "login_network_error": "სერვერთან დაკავშირება ვერ მოხერხდა. შეამოწმეთ კავშირი და სცადეთ თავიდან",
  "login_failed": "შესვლა ვერ მოხერხდა. სცადეთ თავიდან",
  "login_too_many_attempts": "ძალიან ბევრი შესვლის მცდელობა. დაელოდეთ 15 წუთი და სცადეთ თავიდან.",
  "forgot_password_too_many": "პაროლის აღდგენის ძალიან ბევრი მოთხოვნა. დაელოდეთ ერთ საათს და სცადეთ თავიდან.",
  "reset_password_too_many": "პაროლის აღდგენის ძალიან ბევრი მცდელობა. დაელოდეთ ერთ საათს და სცადეთ თავიდან.",
  "change_password_too_many": "პაროლის შეცვლის ძალიან ბევრი მცდელობა. დაელოდეთ 15 წუთი და სცადეთ თავიდან.",

  "personal_settings_language_hint": "ვრცელდება ამ ბრაუზერის მთელ პორტალზე.",
  "personal_settings_privacy_hint": "მოითხოვეთ თქვენი პერსონალური მონაცემების წაშლა კონფიდენციალურობის შესახებ მოქმედი კანონმდებლობით.",
  "personal_settings_export_hint": "ჩამოტვირთეთ იკითხებადი JSON ასლი იმ პერსონალური მონაცემებისა, რომლებიც ჩვენ გვაქვს თქვენ შესახებ: თქვენი პორტალის პროფილი, საიტები, რომლებზეც შეგიძლიათ წვდომა და თქვენი მიბმული მობილური აპლიკაციის პროფილი (როდესაც თქვენი ტელეფონი ემთხვევა). შეზღუდული ექსპორტი დღეში.",
  "Download my data": "ჩამოტვირთეთ ჩემი მონაცემები",
  "personal_settings_role": "როლი",
  "Request deletion of my data": "მოითხოვეთ ჩემი მონაცემების წაშლა",
  "Request deletion of my data - confirm": "მოითხოვოთ ჩემი მონაცემების წაშლა? ელფოსტა გაეგზავნება ადმინისტრატორს. ჩვენ დავამუშავებთ თქვენს მოთხოვნას 30 დღის განმავლობაში.",
  "Request deletion of my data - success": "მოთხოვნა გაიგზავნა. ჩვენ მას დავამუშავებთ 30 დღის განმავლობაში.",
  "Request deletion of my data - error": "მოთხოვნის გაგზავნა ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა ან ელფოსტა privacy@buzzztech.com.",
  "metrics": "მეტრიკა",
  "select_three_metrics": "აირჩიეთ 3-მდე მეტრიკა შესადარებლად",
  "select_four_metrics": "აირჩიეთ 4-მდე მეტრიკა შესადარებლად",
  "legend": "ლეგენდა",
  "more_details": "მეტი დეტალები",
  "performance_overview": "შესრულების მიმოხილვა",
  "loading_chart": "ჩატვირთვა დიაგრამა",
  "retry": "ხელახლა სცადეთ",
  "performance_trending_upward": "შესრულების ტენდენცია აღმავალია",
  "high_complaint_ratio": "საჩივრების მაღალი კოეფიციენტი",
  "click_bars_for_details": "დააწკაპუნეთ ზოლებზე ყოველდღიური ანალიტიკის შესასწავლად",
  "refresh": "განაახლეთ",
  "table": "მაგიდა",
  "cards": "ბარათები",
  "no_recent_arrivals": "ბოლო ჩამოსვლები არ არის",
  "feedback_charts": "უკუკავშირის სქემები",
  "general_overview": "ზოგადი მიმოხილვა",
  "cleaning_complaints_breakdown": "დასუფთავების საჩივრების დაშლა",
  "maintenance_complaints_breakdown": "სარემონტო საჩივრების დაშლა",
  "refresh_failed": "განახლება ვერ მოხერხდა",
  "data_exported_successfully": "მონაცემები წარმატებით იქნა ექსპორტირებული",
  "data_export_failed": "მონაცემთა ექსპორტი ვერ მოხერხდა",
  "analytics_export_confirm": "ჩამოტვირთეთ ანალიტიკის CSV ფაილები?",
  "analytics_export_title": "ანალიტიკური მონაცემების ექსპორტი",
  "analytics_export_description": "ჩამოიტვირთება ZIP ფაილი თქვენი გაკეთებული გაფილტრული ანალიტიკით - რეზიუმე, დონატი, საათები, ოთახები და დამლაგებელი/ზედამხედველის ჩამოსვლა.",
  "download": "ჩამოტვირთვა",
  "analytics_export_blocked_loading": "ანალიტიკის მონაცემები ჯერ კიდევ იტვირთება. გთხოვთ დაელოდოთ და სცადოთ ხელახლა.",
  "analytics_export_blocked_no_data": "არ არის ანალიტიკური მონაცემები ექსპორტისთვის. გამოიყენეთ თქვენი ფილტრები და დაელოდეთ გვერდის ჩატვირთვას.",
  "analytics_export_blocked_stale_filters": "ფილტრები შეიცვალა. გამოიყენეთ ფილტრები და დაელოდეთ ანალიტიკის გადატვირთვას ექსპორტამდე.",
  "drill_down_unavailable": "Drill-down ხელმისაწვდომია მხოლოდ ყოველდღიური სანახავად",
  "sort_by": "დალაგება",
  "no_active_shift": "აქტიური ცვლა არ არის",
  "check_site_and_shift": "გთხოვთ, შეამოწმოთ არის თუ არა საიტი არჩეული და აქვს თუ არა აქტიური ცვლა",
  "please_add_shift_first": "გთხოვთ, ჯერ დაამატეთ ცვლა",
  "cleandex_no_data_message": "არ არსებობს cleandex მონაცემები ამჟამად",
  "task_no_data_message": "ამოცანის მონაცემები ამჟამად ხელმისაწვდომი არ არის",
  "navigation": "ნავიგაცია",
  "network_information": "ქსელის ინფორმაცია",
  "target_effectiveness": "მიზნობრივი ეფექტურობა",
  "cleandex_call_cleaner": "Cleandex ზარის გამწმენდი",
  "top_complaint": "მთავარი საჩივარი",
  "no_complaints": "არანაირი პრეტენზია",
  "official_start_date": "დაწყების ოფიციალური თარიღი",
  "note_text": "შენიშვნა ტექსტი",
  "add_note": "შენიშვნის დამატება",
  "general_note": "ზოგადი შენიშვნა",
  "general_note_short": "გენერალი",
  "battery_short": "ბატარეა",
  "panel_short": "პანელი",
  "technician_short": "ტექნიკოსი",
  "battery_replacement": "ბატარეის გამოცვლა",
  "device_maintenance": "მოწყობილობის მოვლა",
  "maintenance_type": "მოვლის ტიპი",
  "panel_change": "პანელის შეცვლა",
  "technician_check": "ტექნიკოსის შემოწმება",
  "enter_note_details": "შეიყვანეთ შენიშვნის დეტალები",
  "replacement_date": "ჩანაცვლების თარიღი",
  "replaced_by_name": "სახელით შეიცვალა",
  "replacement_note": "შემცვლელი შენიშვნა",
  "enter_replacement_details": "შეიყვანეთ ჩანაცვლების დეტალები",
  "replacement_history": "ჩანაცვლების ისტორია",
  "loading_history": "იტვირთება ისტორია",
  "no_replacement_history": "ჩანაცვლების ისტორია არ არის ხელმისაწვდომი",
  "enter_technician_name": "შეიყვანეთ ტექნიკოსის სახელი",
  "prefilled_from_account": "წინასწარ შევსებულია თქვენი ანგარიშიდან — შეგიძლიათ შეცვალოთ",
  "user_information": "მომხმარებლის ინფორმაცია",
  "enter_change_details": "შეიყვანეთ ცვლილების დეტალები",
  "panel_change_history": "პანელის ცვლილების ისტორია",
  "check_date": "შეამოწმეთ თარიღი",
  "checked_by_name": "შემოწმებულია სახელით",
  "enter_check_details": "შეიყვანეთ შემოწმების დეტალები",
  "technician_check_history": "ტექნიკოსი ამოწმებს ისტორიას",
  "no_technician_check_history": "ტექნიკოსის შემოწმების ისტორია არ არის ხელმისაწვდომი",
  "change_date": "თარიღის შეცვლა",
  "changed_by_name": "სახელით შეიცვალა",
  "change_note": "შენიშვნის შეცვლა",
  "check_note": "შეამოწმეთ შენიშვნა",
  "replaced_by": "შეცვალა",
  "no_data_entered": "მონაცემები არ არის შეყვანილი",
  "no_panel_change_history": "პანელის ცვლილების ისტორია არ არის ხელმისაწვდომი",
  "invalid_username": "მომხმარებლის სახელი არასწორია",
  "invalid_phone": "ტელეფონის ნომერი არასწორია",
  "username_must_be_at_least_5_characters": "მომხმარებლის სახელი უნდა იყოს მინიმუმ 5 სიმბოლო",
  "data_loading_please_wait": "მონაცემები ამჟამად იტვირთება. გთხოვთ დაელოდოთ...",
  "dates_not_changed": "თარიღები არ შეცვლილა. არ არის საჭირო გადატვირთვა.",
  "date_outside_stats_range": "არჩეული თარიღები ხელმისაწვდომი სტატისტიკის დიაპაზონს გარეთაა.",

  "date_range_invalid": "\"to\" თარიღი უნდა იყოს \"From\" თარიღით ან მის შემდეგ.",
  "filter_help_text": "ფილტრის წესები: ჯერ აირჩიეთ შენობა, რათა ჩართოთ იატაკის ფილტრი. ფილტრების უმეტესობა მხარს უჭერს მრავალ არჩევანს.",
  "select_building_first": "გთხოვთ, ჯერ აირჩიოთ შენობა იატაკის ფილტრის ჩასართავად",
  "cannot_select_gender_with_rooms": "ოთახების არჩევისას ოთახის ტიპის არჩევა შეუძლებელია",
  "cannot_select_gender_with_rooms_tooltip": "ოთახების არჩევისას ოთახის ტიპის ფილტრის გამოყენება შეუძლებელია. ჯერ გაასუფთავეთ ოთახების არჩევანი.",
  "cannot_select_building_with_rooms": "ოთახების შერჩევისას შენობის არჩევა შეუძლებელია",
  "cannot_select_building_with_rooms_tooltip": "შენობის ფილტრის გამოყენება შეუძლებელია ოთახების არჩევისას. გთხოვთ, ჯერ გაასუფთავოთ ოთახების არჩევანი.",
  "multi_select_hint": "შეგიძლიათ აირჩიოთ მრავალი ვარიანტი",
  "filter_applied": "ფილტრი წარმატებით იქნა გამოყენებული",
  "no_filters_selected": "არ არის არჩეული ფილტრები. აირჩიეთ მინიმუმ ერთი ფილტრის ვარიანტი.",
  "filters": "ფილტრები",
  "location": "მდებარეობა",
  "attributes": "ატრიბუტები",
  "applying": "მიმართვა...",
  "active_filters": "აქტიური ფილტრები",
  "viewing_room": "სანახავი ოთახი",
  "multiple": "მრავალჯერადი",
  "close": "დახურვა",
  "save_replacement": "ჩანაცვლების შენახვა",
  "save_change": "ცვლილებების შენახვა",
  "save_check": "ჩეკის შენახვა",
  "failed_to_load_maintenance_history": "ტექნიკური ისტორიის ჩატვირთვა ვერ მოხერხდა",
  "Battery replacement recorded successfully": "ბატარეის გამოცვლა ჩაწერილია წარმატებით",
  "Panel change recorded successfully": "პანელის ცვლილება წარმატებით ჩაიწერა",
  "Technician check recorded successfully": "ტექნიკოსის შემოწმება წარმატებით ჩაიწერა",
  "no_network_data_available": "ქსელის მონაცემები არ არის ხელმისაწვდომი",
  "configuration": "კონფიგურაცია",
  "contact_settings": "კონტაქტი და პარამეტრები",
  "notifications": "შეტყობინებები",
  "features": "მახასიათებლები",
  "chat_ask_buzzz": "ჰკითხეთ ბაზზს",
  "chat_hide": "დამალვა",
  "chat_buzzz_assistant": "Buzzz-ის ასისტენტი",
  "chat_export": "ექსპორტი",
  "chat_clear": "წაშლა",
  "chat_unpin": "ჩამაგრების მოხსნა",
  "chat_pin": "მიმაგრება",
  "chat_retry": "ხელახლა სცადეთ",
  "chat_copy": "კოპირება",
  "chat_copied": "კოპირებულია!",
  "chat_share": "გააზიარეთ",
  "chat_suggestions": "წინადადებები",
  "chat_input_placeholder": "ჰკითხეთ თქვენს სტატისტიკას...",
  "chat_stop": "გაჩერდი",
  "chat_error": "რაღაც შეფერხდა. გთხოვთ, სცადოთ ხელახლა.",
  "chat_placeholder": "მკითხე შენი დასუფთავების სტატისტიკის შესახებ...",
  "chat_placeholder_context": "იკითხეთ {scope}-ის შესახებ...",
  "chat_chip_briefing": "დილის ბრიფინგი",
  "chat_chip_live_status": "ცოცხალი სტატუსი",
  "chat_chip_staff_status": "პერსონალის სტატუსი",
  "chat_chip_summary": "რეზიუმე",
  "chat_chip_cleaning_priority": "დასუფთავების პრიორიტეტი",
  "chat_chip_worst_rooms": "ყველაზე ცუდი ოთახები",
  "chat_chip_focus": "ფოკუსირების სფეროები",
  "chat_chip_compare_periods": "შეადარეთ პერიოდები",
  "chat_chip_sla_issues": "SLA საკითხები",
  "chat_chip_shift_stats": "Shift სტატისტიკა",
  "chat_chip_complaint_types": "საჩივრის ტიპები",
  "chat_chip_busiest_hours": "ყველაზე დატვირთული საათები",
  "chat_chip_worst_days": "ყველაზე ცუდი დღეები",
  "chat_chip_improving": "ოთახების გაუმჯობესება",
  "chat_chip_best_rooms": "საუკეთესო ოთახები",
  "chat_chip_help": "დახმარება",
  "chat_chip_why_drilldown": "რატომ? გაბურღეთ",
  "chat_deep_analysis": "ღრმა ანალიზი (ნელი)",
  "chat_greeting": "გამარჯობა, {name}, როგორ შემიძლია დაგეხმაროთ?",
  "chat_status_online": "ონლაინ",
  "chat_status_thinking": "ფიქრი...",
  "chat_tool_overview": "მიმოხილვის ამოღება...",
  "chat_tool_rooms": "ოთახების შემოწმება...",
  "chat_tool_hours": "მიმდინარეობს საათების ანალიზი...",
  "chat_tool_days": "ყოველდღიური მონაცემების განხილვა...",
  "chat_tool_live": "ცოცხალი სტატუსის შემოწმება...",
  "chat_tool_priority": "პრიორიტეტების შემოწმება...",
  "chat_tool_room_detail": "ოთახის დეტალების მიღება...",
  "chat_tool_shifts": "ცვლილებებს ვუყურებ...",
  "chat_tool_staff": "პერსონალის შემოწმება...",
  "chat_tool_devices": "მიმდინარეობს მოწყობილობების შემოწმება...",
  "chat_feedback_good": "კარგი გამოხმაურება",
  "chat_feedback_bad": "ცუდი პასუხი",
  "chat_feedback_thanks": "გმადლობთ თქვენი გამოხმაურებისთვის!",
  "chat_feedback_wrong_data": "არასწორი მონაცემები",
  "chat_feedback_didnt_understand": "ვერ გაიგო",
  "chat_feedback_missing_info": "ინფორმაცია აკლია",
  "chat_feedback_bad_format": "ცუდი ფორმატირება",
  "chat_feedback_hallucinated": "შეადგინა ნომრები",
  "chat_feedback_submit": "გაგზავნა",
}


export const si = {
  ...serviks.si,
  "dashboard_widget_settings": "විජට් සැකසුම්",
  "dashboard_no_data": "දත්ත නොමැත",
  "dashboard_layout_saved": "උපකරණ පුවරුවේ පිරිසැලසුම සුරකින ලදී",
  "dashboard_layout_save_failed": "උපකරණ පුවරුවේ පිරිසැලසුම සුරැකීමට අසමත් විය",
  "notified": "දැනුම් දුන්නා",
  "supervisor_arrival": "අධීක්ෂක පැමිණීම",
  "arrival": "පැමිණීම",
  "arrival_badges": "මාරු පැමිණීම්",
  "visits_since_cleaned": "අවසන් වරට පිරිසිදු කළ දා සිට පැමිණීම්",
  "visits_since_cleaned_short": "අවසන් පිරිසිදු සිට",
  "filter": "පෙරහන",
  "logo": "ලාංඡනය",
  "counter": "කවුන්ටරය",
  "sms": "SMS",
  "shifts": "මාරුවීම්",
  "call": "අමතන්න",
  "openCalls": "ඇමතුම් විවෘත කරන්න",
  "callsHistory": "ඇමතුම් ඉතිහාසය",
  "duration": "කාලසීමාව",
  "time_start": "කාලය ආරම්භය",
  "settings": "සැකසීම්",
  "always": "සෑම විටම",
  "off": "අක්රියයි",
  "time_based": "කාලය පදනම් කරගත්",
  "location_based": "ස්ථානය පදනම් කරගත්",
  "notification_mode": "දැනුම්දීම් මාදිලිය",
  "notification_times": "දැනුම්දීමේ වේලාවන්",
  "notification_times_info": "ජංගම යෙදුමෙන් කාල පරාසයන් කළමනාකරණය කෙරේ",
  "notification_location": "දැනුම්දීමේ ස්ථානය",
  "notification_sound": "දැනුම්දීමේ ශබ්දය",
  "no_sound": "ශබ්දයක් නැත",
  "default_sound": "පෙරනිමි ශබ්දය",
  "soft_bell": "මෘදු සීනුව",
  "digital_sound": "ඩිජිටල් ශබ්දය",
  "mallet_sound": "මල්ලට් ශබ්දය",
  "phone_sound": "දුරකථන ශබ්දය",
  "text_sound": "පෙළ ශබ්දය",
  "manager_alert_delay": "කළමනාකරු ඇඟවීම් ප්‍රමාදය",
  "snooze_interval": "සිහිකැඳවීම",
  "vocal_notifications": "වාචික දැනුම්දීම්",
  "no_delay": "ප්‍රමාදයක් නැත",
  "no_snooze": "මතක් කිරීමක් නැත",
  "lat": "Lat",
  "lon": "ලෝන්",
  "radius": "අරය",
  "no_location_set": "ස්ථානයක් සකසා නැත",
  "when_to_notify": "දැනුම් දිය යුත්තේ කවදාද යන්න",
  "notification_preferences": "දැනුම්දීම් මනාප",
  "assignment_configuration": "පැවරීම සහ වින්‍යාස කිරීම",
  "status": "තත්ත්වය",
  "working_area": "වැඩ කරන ප්රදේශය",
  "complaints_NC": "පැමිණිලි / NC",
  "SLA_NC": "SLA / NC",
  "arrivals_NC": "පැමිණීම් / NC",
  "staff": "කාර්ය මණ්ඩලය",
  "cleaning_complaints": "පිරිසිදු කිරීමේ පැමිණිලි",
  "export": "අපනයනය කරන්න",
  "maintenance_complaints": "නඩත්තු පැමිණිලි",
  "maintenanceArrivals": "නඩත්තු පැමිණීම්",
  "maintenance_arrivals": "නඩත්තු පැමිණීම්",
  "last": "අන්තිම",
  "survey_name": "සමීක්ෂණයේ නම",
  "survey": "සමීක්ෂණය",
  "pad_survey": "පෑඩ් සමීක්ෂණය",
  "pad_no_maintenance_survey": "පෑඩ් නඩත්තු සමීක්ෂණයක් නොමැත",
  "pad_kitchen": "පෑඩ් කුස්සිය",
  "number_of_assigned_devices": "# පවරා ඇති උපාංග",
  "number_of_pages": "පිටු #කින්",
  "date_created": "සාදන ලද දිනය",
  "updated_by": "විසින් යාවත්කාලීන කරන ලදී",
  "date_updated": "දිනය යාවත්කාලීන කරන ලදී",
  "search": "සොයන්න",
  "choose_type": "වර්ගය තෝරන්න",
  "permitted_sites": "අවසර ලත් අඩවි",
  "permitted_franchise": "අවසර ලත් ඡන්ද බලය",
  "permitted_companies": "අවසර ලත් සමාගම්",
  "panel_permitted": "පැනලයට අවසර ඇත",
  "end_time": "අවසන් කාලය",
  "last_update": "අවසාන යාවත්කාලීන කිරීම",
  "add_device": "උපාංගය එක් කරන්න",
  "detailed": "සවිස්තරාත්මක",
  "analysis": "විශ්ලේෂණය",
  "suggestion": "යෝජනාව",
  "country": "රට",
  "management": "කළමනාකරණය",
  "device": "උපාංගය",
  "mapping": "සිතියම්ගත කිරීම",
  "please_enter": "කරුණාකර ඇතුල් කරන්න",
  "new_device": "නව උපාංගය",
  "assign_device": "උපාංගය පවරන්න",
  "installSpot": "ස්ථාපන ස්ථානය",
  "device_type": "උපාංග වර්ගය",
  "deviceCode": "උපාංග කේතය",
  "device_code": "උපාංග කේතය",
  "scan_or_enter_device_code": "උපාංග කේතය පරිලෝකනය කරන්න හෝ ඇතුළු කරන්න...",
  "scan_device": "පවරන්න",
  "scan_qr_in_frame": "රාමුවේ QR කේතය පෙළගස්වන්න. කුඩා කේත සඳහා, සෙන්ටිමීටර 15-25ක් දුරින් අල්ලාගෙන බොඳ නම් නැවත අවධානය යොමු කිරීමට පෙරදසුන තට්ටු කරන්න.",
  "checking_device_code": "උපාංග කේතය පරීක්ෂා කරමින්...",
  "camera_not_available": "කැමරාව ලබා ගත නොහැක. ඔබට කේතය අතින් ටයිප් කළ හැකිය.",
  "device_code_already_exists": "මෙම උපාංග කේතය දැනටමත් වෙනත් සංවේදකයකට පවරා ඇත.",
  "assigned_to_company_site_room": "දැනටමත් {company} / {site} / {room} වෙත පවරා ඇත",
  "device_code_lookup_failed": "උපාංග කේතය සත්‍යාපනය කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "device_code_no_site_access": "මෙම කේතය ඔබට ප්‍රවේශය නැති අඩවියක දැනටමත් ලියාපදිංචි වී ඇත.",
  "device_code_check_unavailable": "සේවාදායකයට කේතය පරීක්ෂා කළ නොහැකි විය. නැවත උත්සාහ කරන්න.",
  "device_code_not_a_code": "ස්කෑන් කිරීම \"{code}\" කියවීය. උපාංග කේතයම ඇතුළත් කරන්න.",
  "device_code_open_failed": "මෙම උපාංගය විවෘත කළ නොහැකි විය. නැවත උත්සාහ කරන්න.",
  "device_code_save_failed": "උපාංග කේතය සුරැකිය නොහැකි විය. නැවත උත්සාහ කරන්න.",
  "device_code_save_forbidden": "ඔබට මෙම උපාංගය වෙනස් කළ නොහැක.",
  "confirm_replace_device_code": "උපාංග කේතය ප්‍රතිස්ථාපනය කරන්නද?",
  "confirm_replace_device_code_body": "ඔබට උපාංග කේතය {oldCode} {newCode} සමඟ ප්‍රතිස්ථාපනය කිරීමට අවශ්‍ය බව විශ්වාසද?",
  "room": "කාමරය",
  "edit_room": "සංස්කරණය කාමරය",
  "edit_franchise": "ඡන්ද බලය සංස්කරණය කරන්න",
  "new_franchise": "නව ඡන්ද බලය",
  "desc": "විස්තරය",
  "address": "ලිපිනය",
  "level": "මට්ටම",
  "no_companies_to_show": "පෙන්වීමට සමාගම් නැත",
  "company_type": "සමාගම් වර්ගය",
  "region": "කලාපය",
  "new_company": "නව සමාගම",
  "edit_company": "සමාගම සංස්කරණය කරන්න",
  "edit_user": "පරිශීලක සංස්කරණය කරන්න",
  "C.arrivals": "පිරිසිදු කරන්නා පැමිණියේය",
  "C.complaints": "පිරිසිදු කිරීමේ පැමිණිල්ල",
  "M.complaints": "නඩත්තු පැමිණිලි",
  "M.Arrivals": "නඩත්තු පැමිණීම්",
  "analyses": "විශ්ලේෂණය කරයි",
  "clean_log": "පිරිසිදු ලොගය",
  "maintenance_log": "නඩත්තු ලොගය",
  "like": "කැමති",
  "likes": "කැමති",
  "new_user": "නව පරිශීලක",
  "shift_parameters": "Shift පරාමිතිය",
  "add_shift": "නව මාරුවක්",
  "edit_shift": "මාරුව සංස්කරණය කරන්න",
  "username": "පරිශීලක නාමය",
  "first_name": "මුල් නම",
  "job_function": "භූමිකාව",
  "role": "භූමිකාව",
  "property_manager": "දේපළ කළමනාකරු",
  "facility_manager": "පහසුකම් කළමනාකරු",
  "site_manager": "අඩවි කළමනාකරු",
  "workplace_manager": "සේවා ස්ථාන කළමනාකරු",
  "cleaning_company_ceo": "පිරිසිදු කිරීමේ සමාගමේ ප්‍රධාන විධායක",
  "operations_manager": "මෙහෙයුම් කළමනාකරු",
  "area_manager": "ප්‍රදේශ කළමනාකරු",
  "site_cleaning_manager": "අඩවි පිරිසිදු කිරීමේ කළමනාකරු",
  "cleaning_supervisor": "පිරිසිදු කිරීමේ අධීක්ෂක",
  "other": "වෙනත්",
  "restroom_cleaner": "වැසිකිළි පිරිසිදු කරන්නා",
  "general_cleaner": "සාමාන්‍ය පිරිසිදු කරන්නා",
  "day_porter": "දිවා පෝටර්",
  "office_cleaner": "කාර්යාල පිරිසිදු කරන්නා",
  "public_area_cleaner": "පොදු ප්‍රදේශ පිරිසිදු කරන්නා",
  "firstName": "මුල් නම",
  "description": "විස්තරය",
  "last_name": "අවසන් නම",
  "lastName": "අවසන් නම",
  "phone": "දුරකථනය",
  "building_area": "ගොඩනැගිලි ප්රදේශය",
  "users": "පරිශීලකයන්",
  "add_user": "පරිශීලක එකතු කරන්න",
  "sites": "අඩවි",
  "new_site": "නව අඩවිය",
  "edit_site": "අඩවිය සංස්කරණය කරන්න",
  "add_company": "සමාගම එකතු කරන්න",
  "franchise": "ඡන්ද බලය",
  "floor": "මහල",
  "building": "ගොඩනැගිල්ල",
  "humidity": "ආර්ද්රතාවය",
  "humidity_abbr": "තෙත්",
  "temperature": "උෂ්ණත්වය",
  "temperature_abbr": "උෂ්ණත්වය",
  "gender": "කාමර වර්ගය",
  "display_name": "නම",
  "zone": "කලාපය",
  "shift_number": "Shift#",
  "shift": "මාරු කරන්න",
  "shift_name": "මාරු නම",
  "shift_currently_inactive": "දැනට අක්‍රිය මාරුව",
  "local_time": "දේශීය",
  "end": "අවසානය",
  "min_sla": "අවම SLA",
  "max_sla": "උපරිම SLA",
  "days": "දින",
  "complaints_percent": "% පැමිණිලි",
  "sla_percent": "% SLA",
  "arrivals_percent": "% පැමිණීම්",
  "save_arrivals": "සුරකින්න",
  "clean_time": "පිරිසිදු කාලය (මිනි)",
  "tooltip_shift_number": "මෙම මාරුවේ අනුපිළිවෙල පෙන්වන්න (උදා. 1, 2).",
  "tooltip_shift_name": "මාරුවේ නම (උදා. උදේ, රාත්‍රිය).",
  "tooltip_start_time": "දේශීය වේලාවෙන් ආරම්භක වේලාව මාරු කරන්න.",
  "tooltip_end_time": "දේශීය වේලාවෙන් අවසන් වේලාව මාරු කරන්න.",
  "tooltip_cleaners_number": "මෙම මාරුවේ පිරිසිදු කරන්නන් ගණන.",
  "tooltip_min_sla": "කාමර පැමිණිල්ලක් හැසිරවීමට හොඳම ප්‍රතිචාර කාලය (විනාඩි); ලකුණු සඳහා පහළ සීමාව ලෙස භාවිතා වේ.",
  "tooltip_max_sla": "කාමර පැමිණිල්ලක් හැසිරවීමට උපරිම පිළිගත හැකි ප්‍රතිචාර කාලය (විනාඩි); ලකුණු සඳහා ඉහළ සීමාව ලෙස භාවිතා වේ.",
  "tooltip_arrivals": "දිනකට කාමරයකට අපේක්ෂිත පිරිසිදු පැමිණීම්; ලකුණු මෙම ඉලක්කයට සැබෑ පැමිණීම් සංසන්දනය කරයි.",
  "tooltip_save_arrivals": "BuzzzTV ට පෙර දිනකට කාමරයකට පිරිසිදු කරන්නන් පැමිණීම; ඉතිරි වූ කාලය ගණනය කිරීමට භාවිතා කරයි (දැන් අඩු සංචාර = මිනිත්තු ඉතිරි වේ).",
  "tooltip_clean_time": "කාලය ඉතිරි කරන ලද ගණනය කිරීමේ දී පිරිසිදු කරන්නෙකුගේ සංචාරයකට මිනිත්තු ගණන් කරන ලදී (උදා. 15).",
  "tooltip_complaints_percent": "කාමරයට පැමිණීම් ඇති විට කාමර ලකුණුවල ඇති පැමිණිලිවල බර (ඉහළ = පැමිණිලි ලකුණුවලට වඩා බලපායි).",
  "tooltip_response_time_SLA": "කාමරයට පැමිණීම් ඇති විට කාමර ලකුණු ප්‍රතිචාර කාලයෙහි බර (ඉහළ = වේගවත් ප්‍රතිචාරය වැදගත් වේ).",
  "tooltip_arrivals_percent": "කාමරයට පැමිණීම් ඇති විට කාමර ලකුණු වල පැමිණීමේ බර එදිරිව ඉලක්කය.",
  "tooltip_complaints_NC": "කාමරයට පැමිණීම් නොමැති විට (කවුන්ටරය නොමැති) ලකුණු වල පැමිණිලිවල බර.",
  "tooltip_SLA_NC": "කාමරයට පැමිණීම් නොමැති විට ලකුණු ප්‍රතිචාර කාලයෙහි බර.",
  "tooltip_arrivals_NC": "කාමරයට පැමිණීම් නොමැති විට ලකුණු වල පැමිණීම්වල බර.",
  "tooltip_days": "මෙම මාරුව ක්‍රියාත්මක වන සතියේ දින.",
  "tooltip_active_calculation": "සබල කළ විට, මෙම මාරුව ලකුණු සහ කාලය ඉතිරි කළ ගණනය කිරීම්වලට ඇතුළත් වේ.",
  "auto_close_complaints_hour": "පැමිණිලි පැය ස්වයංක්‍රීයව වසන්න",
  "tooltip_auto_close_complaints_hour": "මෙම මාරුවේ විවෘත පැමිණිලි SLA ස්වයංක්‍රීයව වසා ඇති ප්‍රාදේශීය වේලාව. අබල කිරීමට හිස්ව තබන්න.",
  "auto_close_maintenance_complaints_hour": "නඩත්තු පැමිණිලි පැය ස්වයංක්‍රීයව වසන්න",
  "tooltip_auto_close_maintenance_complaints_hour": "මෙම මාරුවේ විවෘත නඩත්තු පැමිණිලි SLA ස්වයංක්‍රීයව වසා ඇති දේශීය වේලාව. අබල කිරීමට හිස්ව තබන්න.",
  "no_auto_close": "-- නෑ --",
  "tooltip_shift_rooms": "මෙම මාරුව සඳහා වෙන් කර ඇති කාමර. අඩවි මට්ටමේ මාරුවක් සඳහා හිස්ව තබන්න.",
  "company_name": "සමාගමේ නම",
  "site_name": "අඩවියේ නම",
  "site_desc": "අඩවි විස්තරය",
  "service_provider_name": "සේවා සපයන්නා",
  "service_provider_type": "සේවා සපයන්නාගේ වර්ගය",
  "service_provider_desc": "සේවා සපයන්නාගේ විස්තරය",
  "user": "පරිශීලක",
  "map": "සිතියම",
  "delete": "මකන්න",
  "new_room": "නව කාමරය",
  "issue_times": "නිකුත් කරන වේලාවන්",
  "solved": "විසඳා ඇත",
  "visits": "සංචාරයන්",
  "visits_also_went_up": "සංචාරයන් ද ඉහළ ගියේය",

  "complaints": "පැමිණිලි",
  "complaints_in_shift": "මෙම මාරුව පැමිණිලි කරයි",
  "cleaner_arrivals": "පිරිසිදු පැමිණීම්",
  "unnecessary_arrivals": "ඇමතුමක් නොමැති පැමිණීම්",
  "unnecessary_arrivals_hint": "කාමරයේ විවෘත ඇමතුමක් නොතිබූ විට පිරිසිදු කරන්නාගේ පැමිණීමක්.",
  "of_arrivals": "පැමිණීම් වලින්",
  "response_time_SLA": "ප්‍රතිචාර කාලය",
  "score": "ස්කෝර්",
  "avg_score": "සාමාන්‍ය ලකුණු",
  "score_goal": "ඉලක්කය ලකුණු කරන්න",
  "top_problem_issues": "ඉහළ ගැටළු",
  "top_problem_rooms": "ඉහළ කාමර",
  "top_problem_hours": "ඉහළම පැය",
  "is_time_save": "කාලය ඉතිරි විය",
  "options": "විකල්ප",
  "send_battery_alerts": "බැටරි ඇඟවීම් යවන්න",
  "environment_alerts": "පරිසර අනතුරු ඇඟවීම්",
  "environment_alerts_description": "උෂ්ණත්වය හෝ ආර්ද්‍රතාවය අවසර ලත් පරාසයෙන් පිටවන විට ඊමේල් ඇඟවීම් යවන්න",
  "environment_alert_emails": "පාරිසරික අනතුරු ඇඟවීමේ ඊමේල්",
  "temperature_min": "උෂ්ණත්වය මිනි",
  "temperature_max": "උෂ්ණත්වය උපරිම",
  "humidity_min": "ආර්ද්රතාවය මිනි",
  "humidity_max": "ආර්ද්රතාවය උපරිම",
  "environment_alert_range_invalid": "පාරිසරික ඇඟවීම් පරාස සංඛ්‍යාත්මක විය යුතු අතර මිනිත්තුව උපරිමයට වඩා අඩු හෝ සමාන විය යුතුය",
  "coming_soon": "ඉක්මණින් පැමිණෙන",
  "alert_emails": "අනතුරු ඇඟවීමේ ඊමේල්",
  "alert_emails_placeholder": "ඊමේල් ලිපිනය ඇතුලත් කරන්න",
  "alert_language": "අනතුරු ඇඟවීමේ භාෂාව",
  "select_language": "භාෂාව තෝරන්න",
  "invalid_email_format": "ඊමේල් ලිපින එකක් හෝ කිහිපයක් වලංගු නොවේ",
  "add_email": "තවත් විද්‍යුත් තැපෑලක් එක් කරන්න",
  "next": "ඊළඟ",
  "back": "ආපසු",
  "basic_information": "මූලික තොරතුරු",
  "service_providers": "සේවා සපයන්නන්",
  "settings_alerts": "සැකසීම් සහ ඇඟවීම්",
  "configuration": "මානකරනය",
  "contact_settings": "සම්බන්ධතා සහ සැකසීම්",
  "notifications": "දැනුම්දීම්",
  "features": "විශේෂාංග",
  "battery_alerts": "බැටරි ඇඟවීම්",
  "alerts_title": "ඇඟවීම්",
  "location": "ස්ථානය",
  "time_save_description": "කාලය ඉතිරි කිරීමේ විශේෂාංග සබල කරන්න",
  "exposures_description": "නිරාවරණය නොවන දත්ත නිරීක්ෂණය කරන්න",
  "alerts_description": "උපාංග තොරතුරු ඇඟවීම්",
  "shift_description": "පෙරනිමි මාරුවීම් සාදන්න",
  "battery_alerts_description": "අඩු බැටරි සඳහා ඊමේල් ඇඟවීම් යවන්න",
  "est_ROI": "ඇස්තමේන්තුගත ROI",
  "complaints_vs_visits": "පැමිණීම් එදිරිව පැමිණිලි",
  "view_by_years": "අවුරුදු බලන්න",
  "view_by_months": "මාස බලන්න",
  "view_by_weeks": "සති බලන්න",
  "view_by_days": "දින බලන්න",
  "minutes": "අවම",
  "company": "සමාගම",
  "site": "අඩවිය",
  "alerts": "උපාංග තොරතුරු",
  "performance": "කාර්ය සාධනය",
  "devices": "උපාංග",
  "total_devices": "මුළු උපාංග",
  "working": "වැඩ කරනවා",
  "warning": "අවවාදයයි",
  "by_device_type": "උපාංග වර්ගය අනුව",
  "surveys": "සමීක්ෂණ",
  "real_time": "තත්ය කාලය",
  "real-time": "තත්ය කාලය",
  "cleaner-activity": "පිරිසිදු ක්රියාකාරිත්වය",
  "device-actions": "උපාංග ක්‍රියා",
  "pad-presence-testing": "පෑඩ් පැවැත්ම සත්‍යාපනය",
  "real-time-cleaning": "තත්‍ය කාලය - පිරිසිදු කිරීම",
  "real-time-maintenance": "තත්‍ය කාලය - නඩත්තුව",
  "no_real_time_tabs_permitted": "ඔබට කිසිදු තත්‍ය කාල ටැබයක් බැලීමට අවසර නැත",
  "admin": "පරිපාලක",
  "all": "සියල්ල",
  "overview": "දළ විශ්ලේෂණය",
  "exit_full_screen": "සම්පූර්ණ තිරයෙන් පිටවන්න",
  "full_screen": "පුන් තිරය",
  "total": "මුළු",
  "analytics": "විශ්ලේෂණ",
  "pdf_export_title_analytics": "විශ්ලේෂණ වාර්තාව",
  "pdf_export_title_cleaner_arrivals": "පිරිසිදු පැමිණීම්",
  "communication": "සන්නිවේදනය",
  "overview_complaints_devices_caption": "උපාංග ස්ථාපනය කර ඇත (සමුච්චිත)",
  "overview_complaints_devices_caption_hint": "ස්ථාපන දිනයන් මත පදනම්ව, සෑම මසකම අවසානය දක්වා අඩවියේ ස්ථාපනය කර ඇති මුළු උපාංග ගණන.",
  "overview_complaints_devices_toggle_aria": "පැමිණිලි සටහන යටතේ ස්ථාපනය කර ඇති උපාංග පෙන්වන්න හෝ සඟවන්න",
  "dashboard_customize": "අභිරුචිකරණය කරන්න",
  "dashboard_save_layout": "පිරිසැලසුම සුරකින්න",
  "dashboard_cancel_edit": "අවලංගු කරන්න",
  "dashboard_reset_default": "පෙරනිමියට යළි පිහිටුවන්න",
  "dashboard_add_widget": "විජට් එක් කරන්න",
  "dashboard_widget_unavailable": "මෙම අඩවිය සඳහා ලබා ගත නොහැක",
  "dashboard_widget_line_chart": "රේඛා සටහන",
  "dashboard_widget_room_table": "කාමර මේසය",
  "dashboard_widget_donuts": "ඩෝනට් ප්‍රස්ථාරය",
  "dashboard_widget_kpi_bar": "KPI කාඩ්පත",
  "dashboard_config_metric": "මෙට්රික්",
  "dashboard_config_time_range": "කාල පරාසය",
  "dashboard_config_view_mode": "දර්ශන මාදිලිය",
  "dashboard_config_donut": "ඩෝනට්",
  "dashboard_config_kpi": "කේපීඅයි",
  "dashboard_remove_widget": "විජට් ඉවත් කරන්න",
  "dashboard_drag_handle": "විජට් ගෙන යාමට අදින්න",
  "dashboard_configure": "වින්‍යාස කරන්න",
  "dashboard_edit_hint": "ගෙන යාමට අදින්න, ප්‍රමාණය වෙනස් කිරීමට කොන් භාවිතා කරන්න",
  "dashboard_dismiss_hint": "ඉවත් කරන්න",
  "dashboard_category_charts": "ප්‍රස්ථාර",
  "dashboard_category_tables": "වගු",
  "dashboard_category_kpis": "KPI",
  "dashboard_widget_line_chart_desc": "තෝරාගත් මෙට්රික් සඳහා ප්‍රවණතා රේඛාව",
  "dashboard_widget_room_table_desc": "කාමර ලකුණු සහ තත්‍ය කාලීන තත්ත්වය",
  "dashboard_widget_donuts_desc": "විශ්ලේෂණ ඩෝනට් ප්‍රස්ථාරය",
  "dashboard_widget_kpi_bar_desc": "තනි KPI සාරාංශ කාඩ්පත",
  "communication_select_site_title": "අඩවියක් තෝරන්න",
  "communication_select_site": "එම ස්ථානය සඳහා සටහන් බැලීමට සහ එක් කිරීමට ඉහත පෙරහන් වලින් සමාගමක් සහ අඩවියක් තෝරන්න.",
  "communication_viewing_site": "බැලීම",
  "communication_add_note": "සටහනක් එක් කරන්න",
  "communication_add_note_open_aria": "සටහන් එකතු කිරීමේ සංවාදය විවෘත කරන්න",
  "communication_form_hint": "මෙම අඩවියට ප්‍රවේශය ඇති සියලු දෙනා සමග යාවත්කාලීන හෝ සටහන් බෙදා ගන්න. ඔවුන් තථ්‍ය කාලය තුළ නව සටහන් දකිනු ඇත.",
  "communication_page_intro_title": "අඩවි සටහන් - මෙම ස්ථානය සඳහා බෙදාගත් ලොගය",
  "communication_page_intro_body": "ඔබගේ කණ්ඩායම සඳහා භාරදීම, ගැටළු, යාවත්කාලීන සහ රැස්වීම් සටහන් තැබීමට මෙම පිටුව භාවිතා කරන්න. ද්වාරය තුළ මෙම වෙබ් අඩවිය විවෘත කළ හැකි සෑම කෙනෙකුටම කියවීමට සහ සටහන් එකතු කිරීමට හැකිය.",
  "communication_page_intro_dismiss": "මෙම ඉඟිය සඟවන්න",
  "communication_page_intro_aria": "අඩවි සටහන් ගැන",
  "communication_content_placeholder": "ඔබේ සටහන මෙහි ලියන්න...",
  "communication_keyboard_hint": "පළ කිරීමට Ctrl+Enter",
  "communication_submitting": "පළ කරමින්...",
  "communication_submit": "සටහන තබන්න",
  "communication_recent_notes": "සටහන්",
  "communication_search_placeholder": "කර්තෘ හෝ පෙළ අනුව සොයන්න...",
  "communication_refresh": "නැවුම් කරන්න",
  "communication_clear_filters": "පෙරහන් හිස් කරන්න",
  "communication_search_aria_label": "සටහන් සොයන්න",
  "communication_submit_aria_label": "සටහන තබන්න",
  "communication_copy_note_aria_label": "සටහන් පෙළ පිටපත් කරන්න",
  "communication_copied": "පසුරු පුවරුවට පිටපත් කර ඇත.",
  "communication_copy_empty": "පිටපත් කිරීමට සටහන් පෙළක් නොමැත.",
  "communication_filter_hidden_one": "(1 සටහනක් පෙරහන් මගින් සඟවා ඇත)",
  "communication_filter_hidden_many": "({n} සටහන් පෙරහන් මගින් සඟවා ඇත)",
  "communication_request_timeout": "ඉල්ලීම කල් ඉකුත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "communication_load_failed": "සටහන් පූරණය කළ නොහැකි විය.",
  "communication_retry": "නැවත උත්සාහ කරන්න",
  "communication_no_matches": "ඔබගේ සෙවුමට හෝ පෙරහන් වලට ගැලපෙන සටහන් නැත. ඒවා සකස් කිරීමට උත්සාහ කරන්න.",
  "communication_no_entries": "තවමත් සටහන් නැත.",
  "communication_no_entries_hint": "ආරම්භ කිරීමට ඉහත සටහනක් එක් කරන්න.",
  "communication_just_now": "මේ දැන්",
  "communication_minutes_ago": "මිනිත්තු {n}කට පෙර",
  "communication_hours_ago": "පැය {n} කට පෙර",
  "communication_days_ago": "දින {n}කට පෙර",
  "communication_note_posted": "සටහනක් පළ කර ඇත.",
  "communication_post_failed": "සටහන තැබීමට නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "communication_note_type": "සටහන් වර්ගය",
  "communication_type_general": "ජෙනරාල්",
  "communication_type_update": "යාවත්කාලීන කරන්න",
  "communication_type_issue": "කලාපය",
  "communication_type_follow_up": "පසු විපරම",
  "communication_type_meeting": "රැස්වීමේ සටහන",
  "communication_filter_all_types": "සියලුම වර්ග",
  "communication_pinned": "පින් කර ඇත",
  "communication_pin": "පින් කරන්න",
  "communication_unpin": "ඇමුණුම ඉවත් කරන්න",
  "communication_pin_limit": "උපරිම 2 අමුණා ඇත",
  "communication_pinned_toast": "සටහන අමුණා ඇත.",
  "communication_unpinned_toast": "සටහන ගලවා ඇත.",
  "communication_pin_failed": "පින් යාවත්කාලීන කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "communication_note_not_found": "සටහන හමු නොවීය හෝ ඔබට ප්‍රවේශය නැත.",
  "communication_site_not_in_filters": "මෙම සටහනේ අඩවිය ඔබගේ වත්මන් පෙරහන් වල නොමැත. ඔබට එම ස්ථානයට ප්‍රවේශය නොමැති විය හැක.",
  "communication_edit": "සංස්කරණය කරන්න",
  "communication_delete": "මකන්න",
  "communication_save": "සුරකින්න",
  "communication_cancel": "අවලංගු කරන්න",
  "communication_saving": "සුරකිමින්...",
  "communication_note_updated": "සටහන යාවත්කාලීන කරන ලදී.",
  "communication_update_failed": "සටහන යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "communication_delete_confirm": "ඔබට මෙම සටහන මැකීමට අවශ්‍ය බව විශ්වාසද? මෙම ක්‍රියාව පසුගමනය කළ නොහැක.",
  "communication_delete_confirm_title": "සටහන මකන්න",
  "communication_note_preview": "සටහන පෙරදසුන:",
  "communication_note_deleted": "සටහන මකා දමන ලදී.",
  "communication_delete_failed": "සටහන මැකීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "communication_edited": "සංස්කරණය කළා",
  "communication_show_more": "තව පෙන්වන්න",
  "communication_show_less": "අඩුවෙන් පෙන්වන්න",
  "communication_sort_date_newest": "අලුත්ම මුලින්ම",
  "communication_sort_date_oldest": "පැරණිම පළමු",
  "communication_sort_author": "කතුවරයා විසිනි",
  "communication_sort_type": "වර්ගය අනුව",
  "communication_sort_pinned": "මුලින්ම පින් කළා",
  "communication_sort_label": "වර්ග කරන්න",
  "communication_filter_by_type": "ටයිප් කරන්න",
  "communication_filters_group_aria": "සටහන් පෙරීම සහ වර්ග කිරීම",
  "communication_search_label_short": "සොයන්න",
  "employees": "සේවකයින්",
  "last_time_of_arrival": "පැමිණීමේ අවසාන කාලය",
  "arrival_and_status": "පැමිණීම සහ තත්ත්වය",
  "preview_arrivals": "පැමිණීම් පෙරදසුන් කරන්න",
  "men toilet": "පිරිමි වැසිකිළිය",
  "women toilet": "කාන්තා වැසිකිළිය",
  "shared toilet": "හවුල් වැසිකිළිය",
  "unisex restroom": "යුනිසෙක්ස් වැසිකිළිය",
  "handicapped toilet": "ආබාධිත වැසිකිළිය",
  "logistics": "සැපයුම්",
  "cubicle": "කුටිය",
  "gym": "ව්‍යායාම ශාලාව",
  "monthMap": {
    "1": "ජන",
    "2": "පෙබ",
    "3": "මාර්",
    "4": "අප්‍රේල්",
    "5": "මැයි",
    "6": "ජූනි",
    "7": "ජූලි",
    "8": "අගෝ",
    "9": "සැප්",
    "10": "ඔක්",
    "11": "නොවැ",
    "12": "දෙසැ"
  },
  "weekMap": {
    "1": "ඉරිදා",
    "2": "සඳුදා",
    "3": "අඟහරුවාදා",
    "4": "බදාදා",
    "5": "බ්‍රහස්පතින්දා",
    "6": "සිකුරාදා",
    "7": "සෙනසුරාදා"
  },
  "dayOfWeek": "දින",
  "service_log": "සේවා ලොගය",
  "rooms": "කාමර",
  "bulk_add_rooms": "තොග වශයෙන් කාමර එකතු කරන්න",
  "adding_to": "වෙත එකතු කිරීම",
  "add_rooms": "කාමර එකතු කරන්න",
  "room_names_one_per_line": "කාමර නම් (පේළියකට එකක්)",
  "enter_at_least_one_room": "අවම වශයෙන් කාමර නමක් ඇතුළත් කරන්න",
  "room_names_placeholder": "කාමර 1\nකාමර 2\nකාන්තා වැසිකිළිය",
  "rooms_with_prefix": "උපසර්ගය සහිත කාමර",
  "apply_to_all_rooms": "සියලුම කාමර සඳහා අයදුම් කරන්න (විකල්ප)",
  "bulk_rooms_intro": "කණ්ඩායම් එකක් හෝ කිහිපයක් එකතු කරන්න. සෑම කණ්ඩායමකටම තමන්ගේම ගොඩනැගිල්ලක්, බිම, කලාපය, ස්ත්‍රී පුරුෂ භාවය සහ කාමර නම් ඇත.",
  "group": "කණ්ඩායම",
  "add_group": "+ තවත් කණ්ඩායමක් එක් කරන්න",
  "adding_rooms": "කාමර එකතු කරමින්...",
  "bulk_summary": "සාරාංශය",
  "in": "තුළ",
  "bulk_rooms_success": "කාමර {n}ක් සාර්ථකව එකතු කරන ලදී",
  "displayName": "කාමරයේ නම",
  "SLA": "එස්.එල්.ඒ",
  "supervisors": "සුපරීක්ෂකවරු",
  "supervisor": "සුපරීක්ෂක",
  "performance_analytics": "කාර්ය සාධන විශ්ලේෂණ",
  "arrivals": "පැමිණීම්",
  "inspections": "පරීක්ෂා කිරීම්",
  "avgResponseTime": "සාමාන්‍ය ප්‍රතිචාර කාලය",
  "missedSla": "මිස්ඩ් ස්ලා",
  "cleaner_arrived": "පිරිසිදු කරන්නා පැමිණියේය",
  "load_more": "වැඩිපුර පටවන්න",
  "login": "ඇතුල් වන්න",
  "email": "ඊමේල් කරන්න",
  "emails": "ඊමේල්",
  "password": "මුරපදය",
  "min": "අවම",
  "Logout": "පිටවීම",
  "time_range": "කාල පරාසය",
  "select_time_range": "කාල පරාසය තෝරන්න",
  "custom_time": "දිනයන් තෝරන්න",
  "last_day": "ඊයේ",
  "last_week": "පසුගිය දින 7",
  "last_month": "පසුගිය දින 30",
  "last_quarter": "පසුගිය දින 90",
  "last_6_months": "පසුගිය මාස 6",
  "last_year": "පසුගිය දින 365",
  "data_by_hour": "පැයෙන් දත්ත",
  "general": "ජෙනරාල්",
  "cleaning": "පිරිසිදු කිරීම",
  "maintenance": "නඩත්තු කිරීම",
  "start": "ආරම්භ කරන්න",
  "start_time": "ආරම්භක වේලාව",
  "management_co": "කළමනාකරණ සමාගම",
  "cleaning_co": "පිරිසිදු කිරීමේ සමාගම",
  "companies": "සමාගම්",
  "name": "නම",
  "site_count": "අඩවිය #",
  "associated_companies": "ආශ්රිත අවසන් ගනුදෙනුකරුවන්",
  "OK": "හරි",
  "cancel": "අවලංගු කරන්න",
  "client": "සේවාදායකයා",
  "dates": "දිනයන්",
  "issue": "කලාපය",
  "time": "කාලය",
  "top complaint of the week": "සතියේ ඉහළම පැමිණිල්ල",
  "top room of the week": "සතියේ ඉහළම කාමරය",
  "top hour of the week": "සතියේ ඉහළම පැය",
  "top complaint of the month": "මාසයේ ඉහළම පැමිණිල්ල",
  "top room of the month": "මාසයේ ඉහළම කාමරය",
  "top hour of the month": "මාසයේ ඉහළම පැය",
  "franchises": "බලයලත්",
  "add_franchise": "ඡන්ද බලය එක් කරන්න",
  "room_names": "කාමරයේ නම",
  "type": "ටයිප් කරන්න",
  "please_select_company_site": "කරුණාකර සමාගමක් සහ අඩවියක් තෝරන්න",
  "number": "අංකය",
  "create_building_map": "ගොඩනැගිලි සිතියමක් සාදන්න",
  "hey quickest way to add floors and rooms to a buildings via this quick wizard": "හේ මෙම ඉක්මන් විශාරදයා හරහා ගොඩනැඟිලිවලට තට්ටු සහ කාමර එක් කිරීමට ඉක්මන්ම ක්‍රමය",
  "avg number of toilets per floor": "මහලකට සාමාන්‍ය වැසිකිලි ගණන",
  "avg.number of toilet cells per room": "සාමාන්‍ය කාමරයකට වැසිකිලි සෛල ගණන",
  "number of floors": "මහල් ගණන",
  "avg.number of disabled toilets": "සාමාන්‍ය ආබාධිත වැසිකිළි සංඛ්‍යාව",
  "avg.number of soap dispensers": "සාමාන්‍ය සබන් ඩිස්පෙන්සර් ගණන",
  "reset_filter": "පෙරහන යළි පිහිටුවන්න",
  "add": "එකතු කරන්න",
  "new_survey": "නව සමීක්ෂණය",
  "api_configuration": "API වින්‍යාසය",
  "please_edit_the_api_information": "කරුණාකර API තොරතුරු සංස්කරණය කරන්න",
  "method": "ක්රමය",
  "authorization": "අවසර දීම",
  "api_url": "API_url",
  "token": "ටෝකනය",
  "endpoint": "අන්ත ලක්ෂ්‍යය",
  "add_url": "URL එකතු කරන්න",
  "remove": "ඉවත් කරන්න",
  "format": "ආකෘතිය",
  "auth_api_key": "API යතුර",
  "auth_dynamic_key": "ගතික යතුර (GET)",
  "auth_login_token": "පිවිසුම් ටෝකනය (HTTP)",
  "dynamic_token_url": "ටෝකන URL (GET)",
  "token_response_field_name": "ප්‍රතිචාර වශයෙන් ටෝකන් ක්ෂේත්‍රය",
  "token_login_url": "පිවිසුම් URL",
  "login_request_method": "ලොගින් ඉල්ලීම් ක්‍රමය",
  "login_request_body": "පිවිසුම් ඉල්ලීම් ශරීරය (JSON)",
  "login_token_placeholder_hint": "වෛකල්පිත: JSON පුරනය වීමේ සිරුරේ {{ටෝකන්}} ප්‍රතිස්ථාපනය කිරීමට භාවිතා කරන රහස",
  "token_response_key": "ප්‍රවේශ ටෝකන් ක්ෂේත්‍ර නාමය",
  "survey_api_auth_header_name": "සත්‍යාපන ශීර්ෂ නාමය (විකල්ප)",
  "survey_api_auth_header_prefix": "එම ශීර්ෂයේ ඇති ටෝකනයට පෙර පෙළ යවන්න",
  "survey_api_auth_header_name_placeholder": "උදා. අවසරය, X-Api-Key",
  "survey_api_auth_header_prefix_placeholder": "උදා. දරන්නා - අවසාන ශීර්ෂකය වන්නේ: උපසර්ගය + ඉඩ + ටෝකනය",
  "api_request_info": "API ඉල්ලීම් තොරතුරු",
  "roomName": "කාමරයේ නම",
  "servikName": "පැමිණිල්ලේ නම",
  "siteName": "අඩවියේ නම",
  "stage": "වේදිකාව",
  "number_of_buttons": "බොත්තම් ගණන",
  "button_shape": "බොත්තම් හැඩය",
  "delay_time_stage": "ප්රමාද කාල අදියර",
  "go_to_stage": "වේදිකාවට යන්න",
  "color": "වර්ණය",
  "add_stage": "අදියර එකතු කරන්න",
  "save": "සුරකින්න",
  "number_of_issues": "ගැටළු ගණන",
  "online": "ඔන්ලයින්",
  "offline": "නොබැඳි",
  "offline_devices": "නොබැඳි උපාංග",
  "no_offline_devices": "නොබැඳි උපාංග කිසිවක් හමු නොවීය",
  "working_devices": "වැඩ කරන උපාංග",
  "no_working_devices": "වැඩ කරන උපාංග හමු නොවිණි",
  "room_name": "කාමරයේ නම",
  "installation_spot": "ස්ථානය",
  "device_id": "උපාංග හැඳුනුම්පත",
  "date": "දිනය",
  "device_status": "උපාංග තත්ත්වය",
  "none": "කිසිවක් නැත",
  "no_surveys_created": "සමීක්ෂණ නිර්මාණය කර නැත",
  "dashboard": "උපකරණ පුවරුව",
  "franchise_name": "ෆ්‍රැන්චයිස් නම",
  "franchise_country": "ෆ්‍රැන්චයිස් රට",
  "choose_franchise": "ඡන්ද බලය තෝරන්න",
  "choose_country": "රට තෝරන්න",
  "select_template": "අච්චුව තෝරන්න",
  "default_survey": "පෙරනිමි සමීක්ෂණය",
  "cleaning_survey": "පිරිසිදු කිරීමේ සමීක්ෂණය",
  "kitchen_survey": "මුළුතැන්ගෙයි සමීක්ෂණය",
  "template": "සැකිල්ල",
  "area_name": "ප්රදේශයේ නම",
  "rooms_names": "කාමර නම්",
  "rooms_number": "කාමර #",
  "assign_number": "පවරන්න #",
  "active_notification_task": "ක්රියාකාරී දැනුම්දීමේ කාර්යය",
  "amount_limit": "කවුන්ටර පරතරය",
  "after_max": "මැක්ස් පසු කවුන්ටරය",
  "new_area": "නව ප්රදේශය",
  "edit_area": "ප්‍රදේශය සංස්කරණය කරන්න",
  "tablet": "ටැබ්ලට්",
  "counter women": "ප්රතිවිරෝධී කාන්තාවන්",
  "counter men": "කවුන්ටර් මිනිහා",
  "counter handicap": "ප්රතිවිරෝධතා",
  "counter man/woman": "ප්‍රති පුරුෂයා / ස්ත්‍රිය",
  "counter man / woman": "ප්‍රති පුරුෂයා / ස්ත්‍රිය",
  "sensor liquid": "සංවේදක දියර",
  "double toilet paper": "ද්විත්ව වැසිකිලි කඩදාසි",
  "toilet paper": "ටොයිලට් පේපර්",
  "tag": "ටැග් කරන්න",
  "qr tag": "QR ටැගය",
  "additional_info": "අමතර තොරතුරු",
  "servikCategory": "ඇමතුම් වර්ගය",
  "dishwashing": "පිඟන් සේදීම",
  "cafeteria": "ආපනශාලාව",
  "clean room": "පිරිසිදු කාමරය",
  "office": "කාර්යාලය",
  "meeting room": "රැස්වීම් කාමරය",
  "cubic": "ඝනක",
  "women": "කාන්තාවන්",
  "men": "පිරිමි",
  "handicap": "ආබාධිත",
  "Combined": "ඒකාබද්ධ",
  "kitchen": "කුස්සිය",
  "east": "නැගෙනහිර",
  "west": "බටහිර",
  "north": "උතුර",
  "south": "දකුණ",
  "right": "හරි",
  "left": "වම",
  "center": "මධ්යස්ථානය",
  "up": "ඉහළට",
  "down": "පහළට",
  "combined": "ඒකාබද්ධ",
  "lobby": "ලොබිය",
  "entrance": "ඇතුල්වීම",
  "reception": "පිළිගැනීම",
  "area": "ප්රදේශය",
  "mezzanine": "මෙසානින්",
  "gallery": "ගැලරිය",
  "ground": "බිම",
  "elevator": "සෝපානය",
  "is_calculated": "ගණනය කළ කාමරය",
  "calculated_room": "ගණනය කළ කාමරය",
  "splitted_survey": "බෙදුණු සමීක්ෂණය",
  "redirect_to_url": "url වෙත හරවා යවන්න",
  "survey_site": "සමීක්ෂණ අඩවිය",
  "clicks": "ක්ලික් කිරීම්",
  "add_stage_number_to_signal": "අදියර අංකය අමුණන්න",
  "including_pad9": "පෑඩ් 9 ඇතුළුව",
  "room_type_required": "සෑම කණ්ඩායමක් සඳහාම කාමර වර්ගයක් තෝරන්න",
  "Tech Manufacturers": "තාක්ෂණ නිෂ්පාදකයින්",
  "Tech Offices": "තාක්ෂණ කාර්යාල",
  "Offices": "කාර්යාල",
  "Terminal": "පර්යන්තය",
  "Universities": "විශ්වවිද්‍යාල",
  "Factories": "කර්මාන්තශාලා",
  "Hospital": "රෝහල",
  "Buzzz Management": "Buzzz Management",
  "Convenience Stores": "පහසු වෙළඳසැල්",
  "Food Chains": "ආහාර දාම",
  "Residential": "නේවාසික",
  "Shopping Center": "සාප්පු සංකීර්ණය",
  "Survey": "සමීක්ෂණය",
  "Demo": "ආදර්ශනය",
  "Vision": "Vision",
  "Court": "උසාවිය",
  "Office Management": "කාර්යාල කළමනාකරණය",
  "Government Office": "රජයේ කාර්යාලය",
  "default_name": "ඉංග්‍රීසියෙන් නම",
  "exposures": "පිරිසිදු නිරාවරණය",
  "exposures_tab": "කාමර ක්‍රියාකාරකම්",
  "cleaner_activity": "පිරිසිදු ක්රියාකාරිත්වය",
  "pad_presence_testing": "පෑඩ් පැවැත්ම සත්‍යාපනය",
  "pad_presence_testing_subtitle": "තෝරාගත් අඩවියේ පෑඩ් පැවැත්ම තත්‍ය කාලීන නිරීක්ෂණය කිරීම",
  "pad_presence_timeline": "සජීවීව · කාලය",
  "pad_presence_sessions": "පැවැත්ම",
  "pad_presence_offline_presses": "නොබැඳි · දුරකථනය",
  "pad_presence_select_site_hint": "අද දින පෑඩ් පැවැත්ම බැලීමට ශීර්ෂයේ ඇති සමාගමක් සහ අඩවියක් තෝරන්න.",
  "pad_presence_no_events": "මෑත පැවැත්ම නැත",
  "pad_presence_open": "විවෘතයි",
  "pad_presence_exit_phone": "දුරකථනය පිටවන්න",
  "pad_presence_exit_auto": "ස්වයංක්‍රීය පිටවන්න",
  "pad_presence_exit_stale": "අන්තිම පිටවන්න",
  "pad_presence_enter": "ප්‍රවේශය",
  "pad_presence_exit": "පිටවන්න",
  "pad_presence_offline": "නොබැඳි",
  "pad_presence_faulty": "අක්රියයි",
  "pad_presence_employee": "සේවකයින්",
  "pad_presence_room": "කාමරය",
  "pad_presence_time_from": "සිට",
  "pad_presence_last_updated": "යාවත්කාලීන කරන ලදී",
  "pad_presence_duration": "කාලසීමාව",
  "pad_presence_exit_type": "පිටවන්න · වර්ගය",
  "pad_presence_button": "බොත්තම",
  "pad_presence_servik": "Servik",
  "pad_presence_count": "ගණන් කරන්න",
  "pad_presence_rssi": "RSSI",
  "pad_presence_all_employees": "සියලුම සේවකයින්",
  "pad_presence_all_rooms": "සියලුම කාමර",
  "pad_presence_load_error": "උපාංග කේතය සත්‍යාපනය කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "pad_presence_in_room_now": "විවෘත · කාමරය · මේ දැන්",
  "pad_presence_in_room": "තුළ",
  "pad_presence_since": "සිට",
  "pad_presence_just_now": "මේ දැන්",
  "pad_presence_pad": "පෑඩ්",
  "pad_presence_phone": "දුරකථනය",
  "pad_presence_all_phones": "සියලුම දුරකථනය",
  "pad_presence_window": "පෙන්වන්න",
  "pad_presence_window_hour": "අන්තිම පැය",
  "pad_presence_window_today": "අද",
  "pad_presence_window_month": "අන්තිම මාසය",
  "pad_presence_pads": "පෑඩ් · අඩවිය",
  "pad_presence_no_pads": "පැවරුම් නොකළ කාමර (පෑඩ්)",
  "pad_presence_last_enter": "අවසන් ප්‍රවේශය ප්‍රවේශය",
  "pad_presence_last_offline": "අන්තිම නොබැඳි",
  "pad_presence_auto_exit_leave": "පිටවන්න → ස්වයංක්‍රීය පිටවන්න",
  "pad_presence_auto_exit_earliest": "ප්‍රවේශය:",
  "pad_presence_auto_exit_passed": "තවමත් විවෘතයි = පෑඩ්. හෝ පිටවන්න 5අවම 45. කරුණාකර රැඳී සිට නැවත උත්සාහ කරන්න",
  "cleaner_activity_live_footer": "තථ්‍ය කාලීන දත්ත යාවත්කාලීන",
  "ca_empty_select_site_hint": "අද දින පිරිසිදු ක්‍රියාකාරකම් බැලීමට ශීර්ෂයේ ඇති සමාගමක් සහ අඩවියක් තෝරන්න.",
  "ca_empty_no_cleaners_hint": "මෙම අඩවියට සහ වත්මන් මාරුව සඳහා පිරිසිදු කරන්නන් පවරනු නොලැබේ. පරිශීලකයන් තුළ සක්‍රිය අඩවි සහ මාරුවීම් පවරන්න.",
  "ca_empty_access_denied": "ප්රවේශය ප්රතික්ෂේප විණි",
  "ca_empty_access_denied_hint": "මෙම අඩවිය සඳහා පිරිසිදු ක්‍රියාකාරකම් බැලීමට ඔබට අවසර නැත.",
  "ca_empty_load_error_hint": "පිරිසිදු ක්‍රියාකාරකම් පූරණය කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න හෝ ගැටලුව දිගටම පවතී නම් සහය අමතන්න.",
  "ca_empty_no_filter_match": "මෙම පෙරහන් වලට ගැලපෙන කිසිදු පිරිසිදු කරන්නන් නොමැත",
  "ca_empty_no_filter_match_hint": "පෙරහන් ඉවත් කිරීමට හෝ වෙනත් පිරිසිදුකාරකයක්, වැඩ කරන ප්‍රදේශයක් හෝ කාමරයක් තෝරා ගැනීමට උත්සාහ කරන්න.",
  "ca_timeline_all_cleaners": "අද ක්රියාකාරිත්වය - සියලු පිරිසිදු කරන්නන්",
  "ca_legend_work": "ක්රියාකාරී",
  "ca_clock_sessions_more": "තව",
  "ca_clock_sessions_less": "අඩුවෙන් පෙන්වන්න",
  "ca_sort_label": "වර්ග කරන්න",
  "ca_sort_needs_attention": "අවධානය අවශ්යයි",
  "ca_sort_best_avg_response": "හොඳම සාමාන්‍ය ප්‍රතිචාරය",
  "ca_sort_worst_avg_response": "නරකම සාමාන්‍ය ප්‍රතිචාරය",
  "ca_sort_most_sla_breaches": "බොහෝ SLA කඩ කිරීම්",
  "ca_sort_most_open_complaints": "බොහෝ විවෘත පැමිණිලි",
  "ca_sort_most_work_time": "වැඩිපුරම වැඩ කරන කාලය",
  "ca_sort_least_work_time": "අවම වැඩ කාලය",
  "ca_stat_avg_short": "සාමාන්‍ය",
  "ca_stat_open_short": "විවෘත",
  "ca_stat_breach_short": "උල්ලංඝනය",
  "ca_stat_work_short": "වැඩ",
  "ca_assigned_room_avg_hint": "අද පවරන ලද කාමර සඳහා සාමාන්‍ය ප්‍රතිචාරය",
  "ca_transit_tooltip": "කාර්යයන් අතර සංක්‍රමණ කාලය",
  "ca_transit_live_tooltip": "අවසන් කාර්යය වසා දැමූ වේලාව",
  "ca_legend_visits": "ඇමතුම් අතර පැමිණීම්",
  "ca_visits_between_sla": "පෙර ඇමතුම වසා දැමූ පසු පැමිණීම්",
  "ca_apply": "යොදන්න",
  "ca_visits_since": "සිට",
  "ca_deferred_tip_title": "කල් දැමූ පැමිණිල්ල",
  "ca_deferred_tip_resolved": "විසඳා ඇත",
  "ca_deferred_tip_desc_open": "තවමත් විවෘතයි - පිරිසිදු කරන්නා මෙය වෙනුවට වෙනත් කාමරවලට ප්‍රථමයෙන් සේවය කළේය.",
  "ca_deferred_tip_desc_closed": "පිරිසිදු කරන්නා පළමුව අනෙකුත් කාමරවල සේවය කරන අතරතුර මෙම පැමිණිල්ල විවෘතව පැවතුනි.",
  "ca_deferred_tip_rooms_label": "පළමුව සේවය කළේ:",
  "ca_attention_title": "අවධානය අවශ්යයි",
  "ca_attention_empty": "සියල්ල පැහැදිලිය - දැන් ගැටළු නොමැත",
  "ca_attention_sla_breach_one": "{name} · SLA කඩ විය",
  "ca_attention_sla_breach_many": "{name} · {count} SLA කඩකිරීම්",
  "ca_attention_open_while_out_one": "{name} · කාලය අවසන් වූ විට විවෘත පැමිණිල්ල",
  "ca_attention_open_while_out_many": "{name} · {count} ඔරලෝසුව අවසන් වූ විට විවෘතයි",
  "ca_attention_idle": "{name} · idle {duration}",
  "ca_attention_late": "{name} · ප්‍රමාද වී ඇත",
  "ca_attention_show": "පෙන්වන්න",
  "ca_attention_hide": "සඟවන්න",
  "ca_view_shift": "මුර පාළුව",
  "ca_view_history": "ඉතිහාසය",
  "ca_filters_done": "අවසන්",
  "ca_hist_preset_this_month": "මෙම මාසය",
  "ca_hist_preset_last_month": "පසුගිය මාසය",
  "ca_hist_preset_this_week": "මෙම සතිය",
  "ca_hist_preset_last_week": "පසුගිය සතිය",
  "ca_hist_preset_custom": "අභිරුචි",
  "ca_hist_from": "සිට",
  "ca_hist_to": "දක්වා",
  "ca_hist_range_invalid": "ආරම්භක දිනය අවසන් දිනයට පෙර විය යුතුය",
  "ca_hist_range_too_long": "පරාසය උපරිම දින {max} ක් විය හැක",
  "ca_hist_search": "නම හෝ දුරකථනය සොයන්න",
  "ca_hist_people_count": "සේවකයින් {count}",
  "ca_hist_kpi_days": "වැඩ කළ දින",
  "ca_hist_kpi_net": "ශුද්ධ පැය",
  "ca_hist_kpi_breaks": "විවේක",
  "ca_hist_col_person": "සේවකයා",
  "ca_hist_col_total": "මුළු පැය",
  "ca_hist_col_total_tip": "විවේකවලට පෙර ඇතුළත් වීමේ සිට පිටවීම දක්වා, සේවකයා යෙදුමේ දකින එම අගයම",
  "ca_hist_col_net": "ශුද්ධ පැය",
  "ca_hist_col_breaks": "විවේක",
  "ca_hist_col_issues": "ගැටලු",
  "ca_hist_col_late": "ප්‍රමාද",
  "ca_hist_col_missed": "මඟ හැරුණු",
  "ca_hist_col_no_clock_out": "පිටවීමක් නැත",
  "ca_hist_clocked_in_now": "දැන් ඇතුළත් වී ඇත",
  "ca_hist_not_assigned": "මෙම ස්ථානයට පවරා නැත",
  "ca_hist_no_shift": "මුර පාළුවක් පවරා නැත",
  "ca_hist_unknown_name": "නොදනී",
  "ca_hist_empty": "මෙම කාලයේ පැමිණීමක් නැත",
  "ca_hist_empty_hint": "මෙම ස්ථානයේ කිසිවෙකු ඇතුළත් වී නැති අතර සේවකයින් එයට පවරා නැත.",
  "ca_hist_no_match": "පෙරහන්වලට ගැළපෙන සේවකයින් නැත",
  "ca_hist_load_error_hint": "පැමිණීමේ ඉතිහාසය පූරණය කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.",
  "ca_hist_prev_person": "පෙර සේවකයා",
  "ca_hist_next_person": "ඊළඟ සේවකයා",
  "ca_hist_close": "වසන්න",
  "ca_hist_legend_worked": "වැඩ කළා",
  "ca_hist_legend_late": "ප්‍රමාද",
  "ca_hist_legend_missed": "මඟ හැරුණු",
  "ca_hist_legend_no_clock_out": "පිටවීමක් නැත",
  "ca_hist_late_by": "{duration} ප්‍රමාද",
  "ca_hist_late_tip": "{time} ට ඇතුළත් විය, {shift} {start} ට ආරම්භ වේ",
  "ca_hist_missed": "මඟ හැරුණු",
  "ca_hist_missed_tip": "සැලසුම් කළ මුර පාළුව ඇතුළත් වීමකින් තොරව අවසන් විය",
  "ca_hist_no_clock_out": "පිටවීමක් නැත",
  "ca_hist_no_clock_out_tip": "සැසිය කිසි විටෙකත් වසා නැත; එහි පැය ගණන් නොගනී",
  "ca_hist_in_progress": "තවමත් ඇතුළත් වී ඇත",
  "ca_hist_auto": "ස්වයං",
  "ca_hist_open_break": "විවෘත",
  "ca_hist_day_col_gross": "මුළු පැය",
  "ca_hist_day_col_breaks": "විවේක",
  "active_cleaners": "ක්රියාකාරී පිරිසිදු කරන්නන්",
  "closed_complaints": "සංවෘත පැමිණිලි",
  "total_work_time": "සම්පූර්ණ වැඩ කාලය",
  "total_work_time_net": "මුළු වැඩ කාලය (අද ශුද්ධ)",
  "total_break_time": "සම්පූර්ණ විවේක කාලය",
  "avg_response_time": "සාමාන්‍ය විසඳා ඇත",
  "cleaner": "පිරිසිදු කරන්නා",
  "clocked_in": "ඔරලෝසුව ඇත",
  "clocked_out": "ඔරලෝසුව වසා ඇත",
  "still_clocked_in": "තවමත් ඔරලෝසුව ඇත",
  "clocked_in_late": "ප්‍රමාද වී ඇත",
  "total_hours": "මුළු පැය",
  "auto_punch": "ස්වයංක්‍රීය (භූ වැට)",
  "manual_punch": "අත්පොත",
  "complaint_opened": "පැමිණිල්ල විවෘත කරන ලදී",
  "complaint_closed": "පැමිණිල්ල වසා ඇත",
  "complaint_still_open": "තවමත් විවෘතයි",
  "resolved_in": "තුළ විසඳා ඇත",
  "open_for": "සඳහා විවෘතයි",
  "sla_breached": "SLA කඩ කළා",
  "no_activity_today": "අදටත් ක්‍රියාකාරකමක් නැත",
  "just_now": "මේ දැන්",
  "ago": "කලින්",
  "today": "අද",
  "live": "සජීවීව",
  "last_updated": "යාවත්කාලීන කරන ලදී",
  "expose_results": "ප්රතිඵල",
  "events_expose": "සිදුවීම්",
  "expose_score": "අගය කරන්න",
  "shift_events_expose": "සිදුවීම් මාරු කර නිරාවරණය කරන්න",
  "type_of_site": "අඩවියේ වර්ගය",
  "morning_shift": "උදෑසන වැඩ මුරය",
  "afternoon_shift": "දහවල් මාරුව",
  "night_shift": "රාත්රී මුරය",
  "update": "යාවත්කාලීන කරන්න",
  "restart": "යළි අරඹන්න",
  "send_data": "දත්ත යවන්න",
  "send_count": "ගණන් යවන්න",
  "blink": "ඇසිපිය හෙළන්න",
  "beacon": "Beacon",
  "like_btn": "කැමති බොත්තම",
  "requires_like_btn": "කැමති බොත්තම ක්‍රියාත්මක විය යුතුය",
  "maintenance_btn": "නඩත්තු බොත්තම",
  "battery": "බැටරි",
  "version": "අනුවාදය",
  "actions": "ක්රියාවන්",
  "device_actions": "උපාංග ක්රියා",
  "device_settings": "උපාංග සැකසුම්",
  "drains_battery": "බැටරිය බැස යයි",
  "latest_errors": "නවතම දෝෂ",
  "no_errors": "දෝෂ නොමැත",
  "offline_calls": "නොබැඳි ඇමතුම්",
  "offline_duration_calls": "නොබැඳි කාල සීමාව ඇමතුම්",
  "counterCalls": "කවුන්ටර ඇමතුම්",
  "active": "ක්රියාකාරී",
  "no_active_supervisors": "ක්‍රියාකාරී අධීක්ෂකවරු නැත",
  "active_supervisors_column": "ක්රියාකාරී අධීක්ෂකවරුන්",
  "supervisors_active_label": "අධීක්ෂකවරු දැන් ක්‍රියාත්මකයි",
  "active_supervisors_coverage_hint": "ක්‍රියාකාරී අධීක්ෂකවරුන් මෙම ප්‍රදේශය ජංගම යෙදුම තුළ ක්‍රියාත්මක කර ඇත. මෙය සබැඳි තත්ත්වය හෝ භෞතික පැවැත්මක් පෙන්නුම් නොකරයි.",

  "site_supervisor_coverage_ok": "Fully covered — {covered}/{total} rooms have an active supervisor",
  "site_supervisor_coverage_issues": "{count} rooms without an active supervisor",
  "site_supervisor_coverage_title": "Rooms without an active supervisor",
  "uncovered_rooms_title": "Uncovered rooms",
  "uncovered_working_areas_title": "Working areas with no active supervisor",
  "active_calculation": "ක්රියාකාරී ගණනය කිරීම",
  "pad": "පෑඩ්",
  "pad_counter": "පෑඩ් කවුන්ටරය",
  "counter_status": "කවුන්ටර තත්ත්වය",
  "choose_state": "රාජ්යය තෝරන්න",
  "choose_city": "නගරය තෝරන්න",
  "start_hour": "ආරම්භක පැය",
  "end_hour": "අවසන් පැය",
  "analytics_log": "විශ්ලේෂණ ලොගය",
  "or": "හෝ",
  "no_data_available": "දත්ත නොමැත",
  "filter_by_cleaner": "පිරිසිදු කරන්නා විසින් පෙරීම",
  "all_cleaners": "සියලුම පිරිසිදු කරන්නන්",
  "not_available": "N/A",
  "failed_to_load_data": "දත්ත පූරණය කිරීමට අසමත් විය",
  "new_task": "නව කාර්යය",
  "new_personal_task": "නව පුද්ගලික කාර්යය",
  "task_assignment": "කාර්යය පැවරීම",
  "task_assignment_room": "කාමර කාර්යය",
  "task_assignment_personal": "පුද්ගලික කාර්යය (පිරිසිදු කරන්නාට පැවරීම)",
  "temporarily_unavailable": "තාවකාලිකව ලබා ගත නොහැක",
  "task_details": "කාර්යය විස්තර",
  "task_languages": "කාර්ය භාෂා",
  "task_languages_hint": "මෙම කාර්යය සඳහා භාෂා තෝරන්න. ඔබ තෝරාගත් සෑම භාෂාවකම මාතෘකාව ඇතුළත් කරනු ඇත.",
  "settings_and_assignment": "සැකසීම් සහ පැවරුම",
  "assignee": "පැවරුම්කරු",
  "category": "ප්රවර්ගය",
  "title": "මාතෘකාව",
  "task_type": "කාර්ය වර්ගය",
  "task_category": "කාර්ය ප්රවර්ගය",
  "call_to_action": "ක්රියා කිරීමට අමතන්න",
  "schedule": "කාලසටහන",
  "insert_text": "පෙළ ඇතුළු කරන්න",
  "select": "තෝරන්න",
  "select_all": "සියල්ල තෝරන්න",
  "n_selected": "{count} තෝරා ඇත",
  "clear_selection": "තේරීම මකන්න",
  "wa_bulk_edit": "Bulk edit",
  "wa_bulk_edit_hint": "Apply one change to {count} selected work areas.",
  "wa_bulk_action": "What do you want to change?",
  "wa_bulk_set_counter": "Counter",
  "wa_bulk_add_task": "Add notification task",
  "wa_bulk_remove_task": "Remove notification task",
  "wa_bulk_enable_counter": "Turn counter on if currently off",
  "wa_bulk_apply_to_n": "Apply to {count} areas",
  "wa_bulk_edit_result": "Updated {updated} · Unchanged {unchanged} · Skipped {skipped}",
  "wa_bulk_set_counter_desc": "Turn counter on/off or set the same interval on selected areas",
  "wa_bulk_add_task_desc": "Add one active notification task to selected areas",
  "wa_bulk_remove_task_desc": "Remove one active notification task from selected areas",
  "wa_bulk_enable_counter_hint": "Areas with counter currently off will be turned on",
  "wa_bulk_search_task": "Search notification tasks",
  "wa_bulk_selected_task": "Selected task",
  "wa_bulk_counter_state": "Counter status",
  "wa_bulk_counter_on": "Turn on",
  "wa_bulk_counter_off": "Turn off",
  "wa_bulk_counter_unchanged": "Keep status",
  "wa_bulk_counter_on_hint": "Turn counter on for all selected areas and set the interval",
  "wa_bulk_counter_off_hint": "Turn counter off for all selected areas",
  "wa_bulk_counter_unchanged_hint": "Only update the interval; leave on/off as it is",
  "wa_bulk_task_coverage_remove": "{withTask} of {total} selected areas have this task · {willChange} will be updated",
  "wa_bulk_task_coverage_add": "{withTask} of {total} selected areas already have this task · {willChange} will be updated",
  "schedule_dates": "කාලසටහන් දිනයන්",
  "language": "භාෂාව",
  "calendar": "දින දර්ශනය",
  "operation": "මෙහෙයුම",
  "daily": "දිනපතා",
  "weekly": "සතිපතා",
  "monthly": "මාසිකව",
  "quarterly": "කාර්තුමය",
  "yearly": "වාර්ෂිකව",
  "sunday": "ඉරිදා",
  "monday": "සඳුදා",
  "tuesday": "අඟහරුවාදා",
  "wednesday": "බදාදා",
  "thursday": "බ්‍රහස්පතින්දා",
  "friday": "සිකුරාදා",
  "saturday": "සෙනසුරාදා",
  "january": "ජනවාරි",
  "february": "පෙබරවාරි",
  "march": "මාර්තු",
  "april": "අප්රේල්",
  "may": "මැයි",
  "june": "ජූනි",
  "july": "ජූලි",
  "august": "අගෝස්තු",
  "september": "සැප්තැම්බර්",
  "october": "ඔක්තෝබර්",
  "november": "නොවැම්බර්",
  "december": "දෙසැම්බර්",
  "1st week": "1 වන සතිය",
  "2nd week": "2 වන සතිය",
  "3rd week": "3 වන සතිය",
  "4th week": "4 වන සතිය",
  "5th week": "5 වන සතිය",
  "1st quarter": "1 වන කාර්තුව",
  "2nd quarter": "2 වන කාර්තුව",
  "3rd quarter": "3 වන කාර්තුව",
  "4th quarter": "4 වන කාර්තුව",
  "edit_task": "කාර්යය සංස්කරණය කරන්න",
  "created_at": "දී නිර්මාණය කරන ලදී",
  "installed_at": "හිදී ස්ථාපනය කර ඇත",
  "hour": "පැය",
  "week_days": "සතියේ දින",
  "month_weeks": "මාස සති",
  "month_days": "මාසයේ දින",
  "no_tasks_found": "කාර්ය කිසිවක් හමු නොවීය",
  "invalid_language": "වලංගු නොවන භාෂාවක්",
  "no_active_tasks_found": "සක්‍රිය කාර්යයන් හමු නොවිණි",
  "edit": "සංස්කරණය කරන්න",
  "send_date": "දිනය යවන්න",
  "invalid_date": "වලංගු නොවන දිනය",
  "hour_must_be_after_current": "කරුණාකර වත්මන් වේලාවෙන් පසු පැයක් තෝරන්න",
  "cells_num": "කොටු #",
  "sinks_num": "සින්ක් #",
  "urinals_num": "මුත්‍රා #",
  "toilet_paper_size": "වැසිකිලි කඩදාසි ප්රමාණය",
  "email_configuration": "ඊමේල් වින්‍යාසය",
  "please_edit_the_email_information": "කරුණාකර ඊමේල් තොරතුරු සංස්කරණය කරන්න",
  "email_sender_info": "ඊමේල් යවන්නාගේ තොරතුරු",
  "email_subject_info": "විෂය තොරතුරු විද්‍යුත් තැපැල් කරන්න",
  "email_message_info": "ඊමේල් පණිවිඩ තොරතුරු",
  "companyName": "සමාගමේ නම",
  "email_language": "ඊමේල් භාෂාව",
  "complaint_language": "පැමිණිලි භාෂාව",
  "email_message_format": "ඊමේල් පණිවිඩ ආකෘතිය",
  "line": "රේඛාව",
  "list": "ලැයිස්තුව",
  "roomType": "කාමර වර්ගය",
  "By logging in, you agree to Buzzztech's": "පුරනය වීමෙන්, ඔබ Buzztech's වෙත එකඟ වේ",
  "Terms and Conditions": "නියම සහ කොන්දේසි",
  "and": "සහ",
  "Privacy Policy": "රහස්යතා ප්රතිපත්තිය",
  "All actions within this panel are recorded for quality control and improvement": "මෙම පැනලය තුළ ඇති සියලුම ක්‍රියා තත්ත්ව පාලනය සහ වැඩිදියුණු කිරීම සඳහා වාර්තා කර ඇත",
  "You must agree to the terms and conditions": "ඔබ නියමයන් සහ කොන්දේසි වලට එකඟ විය යුතුය",
  "months": "මාස",
  "ref_id": "යොමු id",
  "room_name_en": "කාමර නම ඉංග්‍රීසියෙන්",
  "site_state": "අඩවි තත්ත්වය",
  "site_city": "අඩවි නගරය",
  "city": "නගරය",
  "state": "රාජ්ය",
  "site_country": "අඩවියේ රට",
  "first_date": "පළමු දිනය",
  "pinned": "පින් කර ඇත",
  "no.": "නැත.",
  "must_be_numbers": "ඉලක්කම් විය යුතුය",
  "must_be_3_digits": "ඉලක්කම් 3ක් විය යුතුය",
  "must_have_english_title": "ඉංග්‍රීසි මාතෘකාවක් තිබිය යුතුය",
  "total_sites": "මුළු",
  "site_information": "අඩවි තොරතුරු",
  "holiday_offdays": "නිවාඩු සහ නිවාඩු දින",
  "add_offday": "නිවාඩු දින",
  "add_holiday": "නිවාඩු",
  "name_under_chars": "අක්ෂර 25 ට අඩු නම",
  "days_comma_separated": "වලංගු දින, කොමාවකින් වෙන් කර ඇත",
  "year": "වසර",
  "month": "මාසය",
  "day": "දවස",
  "holiday_name": "නිවාඩු නම",
  "offday_name": "නිවාඩු දින නම",
  "delete_confirmation_title": "ඔයාට විශ්වාස ද?",
  "delete_confirmation_message": "මෙම ක්‍රියාව පසුගමනය කළ නොහැක.",
  "are_you_sure": "ඔයාට විශ්වාස ද?",
  "israel": "ඊශ්රායලය",
  "USA": "ඇඑජ",
  "poland": "පෝලන්තය",
  "mexico": "මෙක්සිකෝව",
  "cyprus": "සයිප්රසය",
  "brazil": "බ්රසීලය",
  "romania": "රුමේනියාව",
  "netherlands": "නෙදර්ලන්තය",
  "tablet_survey": "ටැබ්ලට් සමීක්ෂණය",
  "no_shift_survey": "මාරු ටැබ්ලට් සමීක්ෂණයක් නැත",
  "number_of_rows": "පේළි ගණන",
  "rating_shape": "ශ්රේණිගත කිරීමේ හැඩය",
  "content_survey": "අන්තර්ගත සමීක්ෂණය",
  "rating_survey": "ශ්රේණිගත කිරීමේ සමීක්ෂණය",
  "device-alerts": "ගැටලුව",
  "device-active": "ක්රියාකාරී",
  "device-search": "සොයන්න",
  "mac_id": "MAC ලිපිනය",
  "qr_tag": "QR ටැගය",
  "sensor": "සංවේදකය",
  "image_survey": "රූප සමීක්ෂණය",
  "open_text": "පෙළ විවෘත කරන්න",
  "open_text_survey": "පෙළ සමීක්ෂණය විවෘත කරන්න",
  "embedded_link": "එබ්බවූ සබැඳිය",
  "device-counter": "කවුන්ටරය",
  "count": "ගණන් කරන්න",
  "last_date": "අවසාන දිනය",
  "last_arrival": "අවසන් පිරිසිදු පැමිණීම",
  "cleaners": "පිරිසිදු කරන්නන්",
  "viewer": "නරඹන්නා",
  "android": "ඇන්ඩ්රොයිඩ්",
  "ios": "iOS",
  "no_users_found": "පරිශීලකයන් හමු නොවීය",
  "no_cleaners_found": "පිරිසිදු කරන්නන් හමු නොවීය",
  "new_cleaner": "නව පිරිසිදු කරන්නා",
  "edit_cleaner": "පිරිසිදු කරන්නා සංස්කරණය කරන්න",
  "have_you_finished_making_changes": "ඔබ වෙනස්කම් කිරීම අවසන් කළාද?",
  "assignment_issues_found": "පැවරුම් ගැටළු හමු විය",
  "unassigned_rooms_title": "පැවරුම් නොකළ කාමර",
  "overlapping_assignments_title": "අතිච්ඡාදන පැවරුම්",
  "and_n_more": "සහ තවත් {count}",
  "continue_anyway": "කෙසේ හෝ ඉදිරියට යන්න",
  "stay_and_fix": "රැඳී සිට නිවැරදි කරන්න",
  "assignment_coverage_issues": "{unassigned} පැවරුම් නැත · {overlaps} අතිච්ඡාදන",
  "assignment_check_failed": "කාමර පැවරුම් සත්‍යාපනය කළ නොහැකි විය",
  "tap_for_details": "විස්තර සඳහා තට්ටු කරන්න",
  "has_app": "ඇප්",
  "has_app_tooltip": "පිරිසිදු කරන්නාට යෙදුම ඇත",
  "notifications_tooltip": "පුෂ් දැනුම්දීම් සක්‍රීයයි",
  "assigned_to_rooms": "කාමරවලට පවරා ඇත",
  "assigned_to_rooms_tooltip": "මෙම අඩවියේ කාමර සඳහා පවරා ඇත",
  "recently_active": "මෑතකදී සක්‍රීයයි",
  "works_at_site": "ස්ථානයේ වැඩ කරයි",
  "recently_active_tooltip": "පසුගිය මිනිත්තු 30 තුළ යෙදුම විවෘත කළේය",
  "please_select": "කරුණාකර තෝරන්න",
  "please_select_site_first": "කරුණාකර පළමුව අඩවියක් තෝරන්න",
  "working_areas": "වැඩ කරන ප්රදේශ",
  "no_working_areas": "තවමත් වැඩ කරන ප්‍රදේශ නොමැත",
  "working_area_alerts": "ඇඟවීම්",
  "api": "API",
  "task_target_by_working_areas": "වැඩ කරන ප්‍රදේශ අනුව (තෝරාගත් ප්‍රදේශවල සියලුම කාමර)",
  "task_target_by_rooms": "විශේෂිත කාමර වලින්",
  "task_target_label": "කාර්යය විවෘත වේ",
  "step_what": "කුමක් ද",
  "step_when": "කවදා ද",
  "step_where": "කොහෙද",
  "step_options": "විකල්ප",
  "please_create_room_before_working_area": "කරුණාකර වැඩ කරන ප්‍රදේශයක් සෑදීමට පෙර අවම වශයෙන් එක් කාමරයක් සාදන්න",
  "isWorkingInSite": "අඩවියේ වැඩ කිරීම",
  "you_are_not_allowed_to_edit": "ඔබට සංස්කරණය කිරීමට අවසර නැත",
  "you_are_not_allowed_to_remove": "ඔබට ඉවත් කිරීමට අවසර නැත",
  "task": "කාර්යය",
  "portuguese": "පෘතුගීසි",
  "russian": "රුසියානු",
  "spanish": "ස්පාඤ්ඤ",
  "polish": "පෝලන්ත",
  "installer": "ස්ථාපකය",
  "once": "වරක්",
  "time_saved": "කාලය ඉතිරි කර ඇත",
  "yes": "ඔව්",
  "no": "නැත",
  "workingAreaNames": "වැඩ කරන ප්රදේශයේ නම්",
  "shift_rooms": "කාමර",
  "shift_validation_overlap": "මෙම මාරුව \"{roomName}\" කාමරයේ \"{shiftName}\" සමඟ අතිච්ඡාදනය වේ. එක් මාරුවකින් කාමරය ඉවත් කරන්න හෝ ඔවුන්ගේ පැය ගණන සකස් කරන්න.",
  "shift_validation_missing_fields": "කරුණාකර අවශ්‍ය සියලුම මාරු ක්ෂේත්‍ර (පැය, දින, සහ අඩවිය) පුරවන්න.",
  "shift_validation_empty_rooms": "කරුණාකර මෙම මාරුවට අවම වශයෙන් එක් කාමරයක්වත් පවරන්න.",
  "shift_validation_no_valid_rooms": "මෙම මාරුව සඳහා වලංගු කාමර තෝරාගෙන නොමැත.",
  "shift_validation_empty_room_map": "වැඩ මුර කාලසටහන ගොඩ නැගීමට නොහැකි විය. තෝරාගත් දින සහ පැය පරීක්ෂා කරන්න.",
  "new_shift": "නව මාරුවක්",
  "add_shift_inactive": "පරාවර්තක මාරු එකතු කරන්න",
  "remove_auto_shift_inactive": "ස්වයංක්‍රීය පරාවර්තක මාරු ඉවත් කරන්න",
  "additional_options": "අමතර විකල්ප",
  "add_default_shifts": "පෙරනිමි මාරු එකතු කරන්න",
  "no_user_found": "පරිශීලකයෙකු හමු නොවීය",
  "no_site_found": "අඩවියක් හමු නොවීය",
  "open_complaints": "විවෘත පැමිණිලි",
  "site_alerts": "අඩවි ඇඟවීම්",
  "open_sla_alerts": "පැමිණිලි ඇඟවීම් විවෘත කරන්න",
  "open_duration": "විවෘත කාල සීමාව",
  "no_open_slas": "විවෘත SLA හමු නොවීය",
  "no_open_slas_description": "දැනට විවෘත SLA සහිත අඩවි නොමැත.",
  "no_slas_to_send": "මෙම අඩවිය සඳහා විවෘත SLA කිසිවක් හමු නොවීය",
  "total_open_complaints": "සම්පූර්ණ විවෘත පැමිණිලි",
  "longest_duration": "දීර්ඝතම කාලසීමාව",
  "complaints_details": "පැමිණිලි විස්තර",
  "rooms_with_open_complaints_percentage": "විවෘත පැමිණිලි සහිත කාමර",
  "rooms_with_cleaner_arrival_percentage": "පිරිසිදු පැමිණීම සහිත කාමර",
  "rooms_without_cleaner_arrival_percentage": "පිරිසිදු පැමිණීමක් නොමැති කාමර",
  "site_alerts_total_rooms": "මුළු කාමර",
  "site_alerts_open_complaints_count": "විවෘත පැමිණිලි ගණන",
  "site_alerts_customer_opening_date": "පාරිභෝගිකයා විවෘත කරන දිනය",
  "company_country": "සමාගම් රට",
  "select_message": "පණිවිඩය තෝරන්න",
  "message_no_cleaner_arrival": "ආයුබෝවන් හැමෝටම,\nපිරිසිදු කරන්නන් පැමිණීම අද වාර්තා නොවූ කාමර ඇති බව කරුණාවෙන් සලකන්න.\nකරුණාකර මෙය හසුරුවන්න",
  "message_open_complaints": "ආයුබෝවන් හැමෝටම,\nදීර්ඝ කාලයක් තිස්සේ විවෘත පැමිණිලි සහිත කාමර කිහිපයක් ඇති බව කරුණාවෙන් සලකන්න.\nකරුණාකර මෙය හසුරුවන්න",
  "rooms_list": "කාමර:",
  "please_address_issues_promptly": "කරුණාකර මෙම ගැටළු වලට වහා විසඳුම් ලබා දෙන්න.",
  "no_results_found": "ප්‍රතිඵල හමු නොවිණි",
  "showing": "පෙන්වමින්",
  "per_page": "පිටුවකට",
  "whatsapp": "WhatsApp",
  "loading": "පැටවීම",
  "error_opening_whatsapp": "WhatsApp විවෘත කිරීමේ දෝෂයකි. කරුණාකර නැවත උත්සාහ කරන්න.",
  "error_loading_slas": "SLA විස්තර පූරණය කිරීමේ දෝෂයකි. කරුණාකර නැවත උත්සාහ කරන්න.",
  "send_whatsapp": "WhatsApp යවන්න",
  "more_options": "තවත් විකල්ප",
  "preview_message": "පණිවිඩය පෙරදසුන් කරන්න",
  "copy_message": "පණිවිඩය පිටපත් කරන්න",
  "message_preview": "පණිවිඩ පෙරදසුන",
  "phone_number_optional": "දුරකථන අංකය (විකල්ප)",
  "enter_phone_number": "දුරකථන අංකය ඇතුළු කරන්න (උදා., +1234567890)",
  "phone_number_hint": "නිශ්චිත සම්බන්ධතාවයකින් තොරව WhatsApp විවෘත කිරීමට හිස්ව තබන්න",
  "message_copied": "පණිවිඩය පසුරු පුවරුවට පිටපත් කරන ලදී!",
  "error_copying_message": "පණිවිඩය පිටපත් කිරීමේ දෝෂයකි. කරුණාකර නැවත උත්සාහ කරන්න.",
  "opening_whatsapp": "WhatsApp විවෘත කරමින්...",
  "preview_message_description": "යැවීමට පෙර පණිවිඩය පෙරදසුන් කර සංස්කරණය කරන්න",
  "copy_message_description": "පණිවිඩය පසුරු පුවරුවට පිටපත් කරන්න",
  "service_provider": "සේවා සපයන්නා",
  "qr task": "QR කාර්යය",
  "qr_task": "QR කාර්යය",
  "all_day": "මුළු දවසම",
  "auto_start": "ස්වයංක්‍රීය ආරම්භය",
  "english_title": "ඉංග්රීසි මාතෘකාව",
  "connectivity": "සම්බන්ධතාවය",
  "power": "බලය",
  "Your work has been saved": "ඔබගේ කාර්යය සුරැකී ඇත",
  "schedule_call_time": "ඇමතුම් කාලය උපලේඛනගත කරන්න",
  "schedule_call_gap": "ඇමතුම් පරතරය උපලේඛනගත කරන්න",
  "gapInMinutes": "විනාඩි වල පරතරය",
  "no_manual_calls_available": "අතින් ඇමතුම් නොමැත",
  "manual_calls": "අතින් ඇමතුම්",
  "cleandexCalls": "Cleandex ඇමතුම්",
  "manualCalls": "අතින් ඇමතුම්",
  "inactive": "අක්රියයි",
  "on hold": "රඳවා ගත්",
  "sequential": "අනුක්රමික",
  "ratio": "අනුපාතය",
  "must_choose": "තෝරාගත යුතුය",
  "surveyApp": "සමීක්ෂණ යෙදුම",
  "installation": "ස්ථාපනය",
  "manager": "කළමනාකරු",
  "previous": "පෙර",
  "no_rooms_found": "කාමර කිසිවක් හමු නොවීය",
  "show_calendar": "දින දර්ශනය පෙන්වන්න",
  "seeAll": "සියල්ල බලන්න",
  "showPaginated": "පිටු සහිත පෙන්වන්න",
  "cleaners_arrivals": "පිරිසිදු කරන්නන් පැමිණීම",
  "qr validator": "QR වලංගුකාරකය",
  "qr_validator": "QR වලංගුකාරකය",
  "searchAddress": "ලිපිනයක් සොයන්න",
  "sector": "අංශය",
  "add_address": "ලිපිනය එකතු කරන්න",
  "site_auto_attendance_enabled": "මොබයිල් ඇප් geofence භාවිතයෙන් ස්වයංක්‍රීය ඔරලෝසුව ඇතුළු වීමට සහ ඔරලෝසුවෙන් පිටතට යාමට ඉඩ දෙන්න (සේවකයින්ට යෙදුම සහ ස්ථාන අවසරය අවශ්‍ය වේ).",
  "site_auto_attendance_requires_location": "ස්වයංක්‍රීය පැමිණීම සක්‍රීය කිරීමට පෙර සිතියමෙහි පළමුව ස්ථානයක් සකසන්න (පින් සහ අවම වශයෙන් මීටර් 100 අරය).",
  "site_mandatory_clock_in": "වැඩ ආරම්භ කිරීමට පෙර ඔරලෝසුවට ඇතුළු වීම අවශ්‍යයි",
  "site_mandatory_clock_in_description": "මෙම ස්ථානයේ සේවකයින් ජංගම යෙදුමේ පිරිසිදු කිරීම, නඩත්තුව සහ මෙහෙවර ටැබ් විවෘත කිරීමට පෙර ඔරලෝසුවට ඇතුළු විය යුතුය.",
  "site_mandatory_clock_in_without_location": "මෙම ස්ථානයට සිතියම් පිහිටීමක් නොමැති බැවින්, සේවකයෙකු ස්ථානයේ සිටින විට යෙදුමට හඳුනාගත නොහැක. ඔබ එකක් සකසන තුරු, මෙම අවශ්‍යතාවය මෙම සේවකයින්ට සෑම තැනකදීම අදාළ වේ.",
  "auto_attendance": "ස්වයංක්‍රීය පැමිණීම",
  "auto_attendance_ready": "සූදානම්",
  "auto_attendance_off": "අක්රියයි",
  "auto_attendance_needs_setup": "සැකසුම අවශ්‍යයි",
  "auto_attendance_ready_tooltip": "ටොගල කිරීම ක්‍රියාත්මකයි, භූ-වැට අරය ≥ 100m, ස්වයංක්‍රීය ඔරලෝසුව-ඇතුළට/පිටතට සූදානම්.",
  "auto_attendance_off_tooltip": "ටොගල් අක්‍රියයි. ස්වයංක්‍රීය පැමිණීම සබල කිරීමට අඩවිය සංස්කරණය කරන්න.",
  "auto_attendance_needs_setup_tooltip": "ටොගල කිරීම ක්‍රියාත්මක නමුත් භූ වැට අස්ථානගත වී හෝ අවම වශයෙන් මීටර් 100ට වඩා අඩුය. එය නිවැරදි කිරීමට වෙබ් අඩවිය සංස්කරණය කරන්න.",
  "edit_address": "ලිපිනය සංස්කරණය කරන්න",
  "choose_radius": "අරය තෝරන්න",
  "cleandex": "ක්ලින්ඩෙක්ස්",
  "cleandex_column_tooltip": "කොළ = හරි. රතු = පිරිසිදු කිරීමට නිර්දේශ කෙරේ.\nවිස්තර සඳහා සෛල නිරූපකය ගෙනයන්න.",
  "recommended_to_clean": "පිරිසිදු කිරීමට නිර්දේශ කෙරේ",
  "cleandex_warning_level": "Cleandex අනතුරු ඇඟවීමේ මට්ටම",
  "select_warning_level": "අනතුරු ඇඟවීමේ මට්ටම තෝරන්න",
  "bronze": "ලෝකඩ",
  "silver": "රිදී",
  "gold": "රන්",
  "ai": "AI",
  "daily_employees_num": "දෛනික සේවක සංඛ්යාව",
  "daily_shift_hours": "දෛනික වැඩ මුර පැය",
  "rooms_num": "කාමර අංකය",
  "buildings_num": "ගොඩනැගිලි අංකය",
  "cleaner_entries": "පිරිසිදු ඇතුළත් කිරීම්",
  "avg_daily_visits_monthly": "සාමාන්‍ය දෛනික පැමිණීම් මාසිකව",
  "avg_daily_cleaners_to_save": "ඉතිරි කිරීමට සාමාන්‍ය දෛනික පිරිසිදු කරන්නන්",
  "saving_hours_per_day": "දිනකට පැය ඉතිරි කිරීම",
  "saving_money_per_day": "දිනකට මුදල් ඉතිරි කිරීම",
  "saving_money_per_month": "මසකට මුදල් ඉතිරි කිරීම",
  "cleaners_to_visitors_ratio": "පිරිසිදු කරන්නන් සහ අමුත්තන්ගේ අනුපාතය",
  "cleaning_time_in_minutes_per_room": "කාමරයකට මිනිත්තු කිහිපයකින් පිරිසිදු කිරීමේ කාලය",
  "max_number_of_rooms_per_employee": "සේවකයෙකු සඳහා උපරිම කාමර සංඛ්යාව",
  "break_time_per_hour": "පැයකට විවේක කාලය",
  "transition_time_between_tasks": "කාර්යයන් අතර සංක්‍රාන්ති කාලය",
  "employer_cost_hour": "පැයකට සේවායෝජකයාගේ පිරිවැය",
  "lobby_cleaning_per_floor": "එක් මහලකට ලොබි පිරිසිදු කිරීම",
  "desired_cleaning_time": "අපේක්ෂිත පිරිසිදු කිරීමේ කාලය",
  "desired_number_of_entries": "අපේක්ෂිත ඇතුළත් කිරීම් ගණන",
  "buzz_system_cost_per_unit_per_month": "Buzz පද්ධති ඒකකයකට මසකට පිරිවැය",
  "total_buzz_system_cost_per_month": "මසකට සම්පූර්ණ Buzz පද්ධති පිරිවැය",
  "return_on_investment_in_months": "මාස කිහිපයකින් ආයෝජනයේ ප්‍රතිලාභ",
  "annual_savings": "වාර්ෂික ඉතුරුම්",
  "roi_calculator": "ROI කැල්කියුලේටරය",
  "cleaning_work_plan": "පිරිසිදු කිරීමේ වැඩ සැලැස්ම",
  "cleaning_work_plan_intro": "ශීර්ෂය තුළ සමාගම සහ අඩවිය සඳහා මාරු කාමර සංඛ්‍යාලේඛන භාවිත කරයි. පැමිණීම් සහ පැමිණීම් පැමිණෙන්නේ දින පරාසය තුළ ඉහළම අඩවි නැරඹීම් සහිත එක් දිනකින් සහ උපකරණ පුවරු පෙරහන වෙතින් මාරුවීම් (මෙම ටැබය වේලාව සහ පෙරහන් පාලනය සඟවන්නේ නම් කාර්ය සාධනය හෝ විශ්ලේෂණ මත ඒවා සකසන්න). පිරිසිදු කිරීමකට පැමිණීම්, කාර්ය මණ්ඩල ඉලක්කය, පැයක පිරිවැය සහ පිරිසිදු කිරීමකට සාමාන්‍ය මිනිත්තු ඇතුළත් කරන්න; කාමර මට්ටමේ යෝජිත පිරිසිදු කිරීම් සහ සාරාංශ එකතුව බැලීමට උත්පාදනය කරන්න.",
  "cleaning_work_plan_default_n": "පිරිසිදු කිරීමකට පැමිණීම්",
  "cleaning_work_plan_cleaner_count": "පිරිසිදු කරන්නන් (විකල්ප)",
  "cleaning_work_plan_avg_minutes": "සාමාන්‍ය පිරිසිදු කිරීමේ කාලය (විනාඩි)",
  "cleaning_work_plan_run": "සැලැස්ම ජනනය කරන්න",
  "cleaning_work_plan_export_csv": "Excel අපනයනය කරන්න",
  "cleaning_work_plan_suggested_n": "පිරිසිදු කිරීමකට පැමිණීම්",
  "cleaning_work_plan_actual_cleans": "පැමිණීම්",
  "cleaning_work_plan_actual_cleans_hint": "උපරිම දිනයේ (තෝරාගත් පරාසය සහ පෙරහන් තුළ) මාරු කාමර සංඛ්‍යාලේඛනවල සම්පූර්ණ පිරිසිදු පැමිණීම්.",
  "cleaning_work_plan_suggested_cleans": "යෝජිත පිරිසිදු කිරීම්",
  "cleaning_work_plan_cleaner": "පිරිසිදු කරන්නා",
  "cleaning_work_plan_floors": "මහල්",
  "cleaning_work_plan_peak_day": "උපරිම දිනය",
  "cleaning_work_plan_error": "පිරිසිදු කිරීමේ වැඩ සැලැස්ම උත්පාදනය කිරීමට නොහැකි විය",
  "cleaning_work_plan_no_rooms": "මෙම වෙබ් අඩවිය සඳහා කාමර කිසිවක් ආපසු ලබා දුන්නේ නැත. අඩවි සහ දින පරාසය පරීක්ෂා කරන්න, නැතහොත් පාලක පැනලයේ කාමර පවතින බව තහවුරු කරන්න.",
  "cleaning_work_plan_need_filter": "ශීර්ෂකය තුළ සමාගම සහ අඩවිය තෝරන්න, කාර්ය සාධනය හෝ විශ්ලේෂණ මත දින පරාසයක් (සහ අවශ්‍ය නම් මාරු කරන්න) සකසන්න, ඉන්පසු නැවත උත්සාහ කරන්න.",
  "cleaning_work_plan_settings": "සැලසුම් සැකසුම්",
  "cleaning_work_plan_desired_employees": "අපේක්ෂිත සේවක සංඛ්යාව",
  "cleaning_work_plan_cost_per_hour": "පැයකට වියදම",
  "cleaning_work_plan_estimated_cost_suggested": "ඇස්තමේන්තුගත පිරිවැය (යෝජිත වැඩ බර)",
  "cleaning_work_plan_estimated_cost_actual": "ඇස්තමේන්තුගත පිරිවැය (සැබෑ වැඩ බර)",
  "cleaning_work_plan_hours_per_cleaner": "පිරිසිදු කරන්නෙකුට පැය",
  "cleaning_work_plan_metric_title": "මෙට්රික්",
  "cleaning_work_plan_metric_avg_cleaning_min": "සාමාන්‍ය පිරිසිදු කිරීමේ කාලය (මිනි)",
  "cleaning_work_plan_metric_total_arrivals": "සම්පූර්ණ පැමිණීම්",
  "cleaning_work_plan_metric_total_cleaning_min": "සම්පූර්ණ පිරිසිදු කිරීමේ කාලය (මිනි)",
  "cleaning_work_plan_metric_total_cleaning_hours": "සම්පූර්ණ පිරිසිදු කිරීමේ කාලය (පැය)",
  "cleaning_work_plan_metric_hours_per_cleaner_row": "පිරිසිදු කරන්නෙකුට පැය",
  "cleaning_work_plan_metric_num_cleaners": "පිරිසිදු කරන්නන් සංඛ්යාව",
  "cleaning_work_plan_summary": "සාරාංශය",
  "cleaning_work_plan_summary_peak_note": "පැමිණීම්, පැමිණීම් සහ යෝජිත පිරිසිදු කිරීම් විශ්ලේෂණ (පැමිණීම් එකතු කිරීම ඇතුළුව) ලෙස එකම මාරු කාමර සංඛ්‍යාලේඛන රීති භාවිතා කරයි. ඒවා උපරිම දිනය සඳහා වේ—පෙරහන කාල සීමාව තුළ වැඩිම අඩවි සංචාරයන් සහිත දින දර්ශන දිනය. කාමර පෙරහන යොදන්නේ නැති විට දළ විශ්ලේෂණය වැනි ගණනය කළ කාමර පමණක් ඇතුළත් වේ.",
  "cleaning_work_plan_summary_filter_period": "පෙරහන් කාලය",
  "cleaning_work_plan_summary_total_visits": "සම්පූර්ණ පැමිණීම්",
  "cleaning_work_plan_summary_total_arrivals": "සම්පූර්ණ පැමිණීම්",
  "cleaning_work_plan_summary_employees_in_site": "අඩවියේ සේවකයින්",
  "cleaning_work_plan_summary_shift_working_hours": "වැඩ කරන වේලාවන් මාරු කරන්න",
  "cleaning_work_plan_hours_unit": "h",
  "cleaning_work_plan_rooms_table": "කාමර",
  "cleaning_work_plan_cleaners_table": "නිර්දේශිත පිරිසිදු වෙන් කිරීම",
  "cleaning_work_plan_search_rooms": "සෙවුම් කාමර",
  "cleaning_work_plan_total_minutes": "මුළු මිනිත්තු",
  "cleaning_work_plan_actual_total_minutes": "සැබෑ මුළු මිනිත්තු",
  "cleaning_work_plan_actual_total_minutes_hint": "උපරිම දිනයේ (තෝරාගත් පරාසය තුළ) මුර කාමර සංඛ්‍යාලේඛනවල වාර්තා කරන ලද පිරිසිදු කරන්නන්ගේ පැමිණීම්, පිරිසිදු කිරීමකට ඔබේ සාමාන්‍ය මිනිත්තු වලින් ගුණ කරනු ලැබේ.",
  "cleaning_work_plan_suggested_total_minutes": "යෝජිත මුළු මිනිත්තු",
  "cleaning_work_plan_suggested_room_minutes": "යෝජිත පිරිසිදු කිරීමේ මිනිත්තු",
  "cleaning_work_plan_actual_room_minutes": "සැබෑ පිරිසිදු කිරීමේ මිනිත්තු",
  "cleaning_work_plan_cleaner_suggested_minutes": "යෝජිත මිනි.",
  "cleaning_work_plan_cleaner_actual_minutes": "සැබෑ මිනිත්තු.",
  "cleaning_work_plan_period": "කාලසීමාව",
  "cleaning_work_plan_room_count": "කාමර ගණන",
  "cleaning_work_plan_cleaners_working_in_site": "අඩවියේ වැඩ කරන පිරිසිදු කරන්නන් (යෙදුම් සම්බන්ධතා)",
  "cleaning_work_plan_cleaners_connection_table": "කාමර අනුව පිරිසිදු කරන්නන්",
  "cleaning_work_plan_connected_rooms_count": "කාමර",
  "cleaning_work_plan_connected_floor_count": "මහල් ගණන",
  "cleaning_work_plan_connected_floors_list": "මහල්",
  "cleaning_work_plan_visitor_cleaning_entry_ratio": "අමුත්තන් / පිරිසිදු කිරීමේ ප්රවේශ අනුපාතය",
  "cleaning_work_plan_performance_comparison_table": "කාර්ය සාධන සංසන්දනය",
  "cleaning_work_plan_performance_comparison_empty": "සංසන්දනාත්මක පේළි බැලීමට පිරිසිදු සම්බන්ධතා දත්ත පූරණය කරන්න.",
  "cleaning_work_plan_performance_col_index": "දර්ශකය",
  "cleaning_work_plan_performance_existing_plan": "පවතින වැඩ සැලැස්ම",
  "cleaning_work_plan_performance_recommended_plan": "Buzztech නිර්දේශිත සැලැස්ම",
  "cleaning_work_plan_perf_number_of_employees": "සේවක සංඛ්යාව",
  "cleaning_work_plan_perf_working_hours_per_employee": "සේවකයෙකු සඳහා වැඩ කරන වේලාවන්",
  "cleaning_work_plan_perf_total_working_hours": "මුළු වැඩ කරන පැය ගණන",
  "cleaning_work_plan_perf_total_cleaning_hours": "සම්පූර්ණ පිරිසිදු කිරීමේ පැය",
  "cleaning_work_plan_perf_daily_cost": "දෛනික පිරිවැය",
  "cleaning_work_plan_perf_total_cleaning_visits": "සම්පූර්ණ පිරිසිදු කිරීමේ චාරිකා",
  "cleaning_work_plan_perf_busiest_area_visits": "කාර්යබහුලම වැඩ ප්රදේශය - සංචාරයන්",
  "cleaning_work_plan_perf_cleaning_to_busiest": "කාර්යබහුලම ප්‍රදේශයට පිරිසිදු කිරීමේ චාරිකා",
  "cleaning_work_plan_perf_max_cleaning_ratio": "උපරිම පිරිසිදු කිරීමේ අනුපාතය",
  "cleaning_work_plan_perf_least_busy_visits": "අවම කාර්යබහුල සේවා ප්රදේශය - සංචාරයන්",
  "cleaning_work_plan_perf_cleaning_to_least": "අවම කාර්යබහුල ප්‍රදේශයකට පිරිසිදු කිරීම",
  "cleaning_work_plan_perf_min_cleaning_ratio": "අවම පිරිසිදු කිරීමේ අනුපාතය",
  "cleaning_work_plan_ai_allocate": "AI වෙන් කරන්න",
  "cleaning_work_plan_ai_allocation_result": "AI වෙන් කිරීමේ ප්‍රතිඵලය",
  "cleaning_work_plan_ai_allocation_loading": "AI වෙන් කිරීම් උත්පාදනය කරමින්...",
  "cleaning_work_plan_ai_allocation_error": "AI වෙන් කිරීම උත්පාදනය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  "cleaning_work_plan_ai_invalid_employees": "කරුණාකර වලංගු අපේක්ෂිත සේවක සංඛ්‍යාවක් සකසන්න.",
  "cleaning_work_plan_ai_status_elapsed": "ගත වූ: {s}s",
  "cleaning_work_plan_ai_status_hint": "සේවාදායකය AI පියවර කිහිපයක් අනුපිළිවෙලින් ක්‍රියාත්මක කරයි (ආරම්භක සැලැස්ම, භූගෝල විද්‍යාව, සංචාර ශේෂය, පසුව අවසාන ප්‍රතිදානය). මෙයට මිනිත්තු එකක් හෝ දෙකක් ගත විය හැක-කරුණාකර මෙම පිටුව විවෘතව තබා ගන්න.",
  "cleaning_work_plan_ai_status_step_1": "පියවර 1 - කාමරයෙන් මූලික පැවරුමක් කෙටුම්පත් කිරීම සහ දත්ත පැමිණීම...",
  "cleaning_work_plan_ai_status_step_2": "පියවර 2 - භූගෝල විද්‍යාව පිරිපහදු කිරීම (අසල තට්ටු සහ ගොඩනැගිලි කාණ්ඩගත කිරීම)...",
  "cleaning_work_plan_ai_status_step_3": "පියවර 3 - පිරිසිදු කරන්නන් හරහා දෛනික සංචාර සමතුලිත කිරීම…",
  "cleaning_work_plan_ai_status_step_4": "පියවර 4 - ව්‍යුහගත ප්‍රතිපාදන උත්පාදනය කිරීම...",
  "cleaning_work_plan_ai_status_step_5": "පියවර 5 - අවසාන ප්‍රමිතික වලංගු කිරීම සහ ගණනය කිරීම...",
  "cleaning_work_plan_ai_cleaner_number": "පිරිසිදු කරන්නා #",
  "cleaning_work_plan_room_minutes": "පිරිසිදු කිරීමේ මිනිත්තු",
  "cleaning_work_plan_assigned_cleaner": "පවරා ඇති පිරිසිදු කරන්නා",
  "cleaning_work_plan_summary_cleaners": "සැලැස්ම තුළ පිරිසිදු කරන්නන්",
  "cleaning_work_plan_summary_avg_minutes": "සාමාන්‍ය මිනිත්තු / පිරිසිදු",
  "cleaning_work_plan_suggested_hours": "යෝජිත මුළු පැය ගණන",
  "cleaning_work_plan_actual_hours": "සැබෑ මුළු පැය",
  "cleaning_work_plan_avg_suggested_min_per_cleaner": "සාමාන්‍ය යෝජිත මිනිත්තු / පිරිසිදු කරන්නා",
  "cleaning_work_plan_avg_actual_min_per_cleaner": "සාමාන්‍ය සත්‍ය මිනිත්තු / පිරිසිදු කරන්නා",
  "cleaning_work_plan_guidelines_title": "ප්‍රශස්තකරණ මාර්ගෝපදේශ",
  "cleaning_work_plan_guidelines_intro": "මෙම මෙවලම අතින් පිරිසිදු කිරීමේ-සැලසුම් ප්‍රශස්තකරණයට සමාන ඉලක්ක අනුගමනය කරයි: සංචාරයේ දත්ත වලින් වැඩ බර, පිරිසිදු කිරීමකට ඔබේ සාමාන්‍ය මිනිත්තු වලින් කාලය, සහ බිම් භූගෝලීය වශයෙන් සංවේදීව තබා ගනිමින් වැඩ සමතුලිත කරන කාර්ය මණ්ඩලය.",
  "cleaning_work_plan_guidelines_b1": "පිරිසිදු එකකට පැමිණීම් (පෙරනිමිය 50) සාමාන්‍ය 1:50-විලාස රීතියට ගැලපේ: කාමරයකට යෝජිත ඇතුළත් කිරීම් ≈ පැමිණීම් ÷ පිරිසිදු කිරීමකට පැමිණීම් (වට කර ඇත). පැමිණීම් සහ පැමිණීම් ඔබගේ තෝරාගත් දින පරාසය තුළ කාර්යබහුලම දිනයෙන් (ඉහළම අඩවි පැමිණීම්) ගනු ලැබේ, එබැවින් සැලැස්ම උපරිම බර දිනයකට ගැලපේ.",
  "cleaning_work_plan_guidelines_b2": "ඔබ පිරිසිදු ගණනය කිරීමක් සැකසූ විට, එක් එක් ගොඩනැඟිලි තට්ටුව එක් කණ්ඩායමකි. මහල් ගොඩනැගිලි සහ බිම් අංකය අනුව ඇණවුම් කරනු ලැබේ, පසුව පිරිසිදු කරන්නන් හරහා යාබද කුට්ටි වලට බෙදනු ලැබේ, එවිට යෝජිත පිරිසිදු කිරීම් (ව්‍යංග වැඩ) සමතුලිත වන අතර අසල ඇති මහල් එකම පිරිසිදුකාරකයක රැඳී සිටියි.",
  "cleaning_work_plan_guidelines_b3": "එකම ගොඩනැඟිල්ලේ මහලේ ඇති සියලුම විවේකාගාර එකම පිරිසිදු කරන්නෙකු සමඟ පවතී, එබැවින් එම මහලේ ඇති පිරිමි සහ කාන්තා කාමර විවිධ පිරිසිදු කරන්නන් අතර බෙදී නැත (පාලක පැනලයේ එකම බිම් අගය බෙදා ගන්නා තාක් කල්).",
  "cleaning_work_plan_guidelines_b4": "යෝජිත පිරිසිදු ධාවකයකට සාමාන්‍ය මිනිත්තු සහ පිරිසිදු කරන්නෙකු සඳහා සත්‍ය මුළු මිනිත්තු, පැය සහ සාමාන්‍ය මිනිත්තු. සත්‍ය එකතුව වාර්තාගත පිරිසිදු පැමිණීම් භාවිතා කරයි × ඔබේ සාමාන්‍යය; යෝජිත එකතුව ව්‍යංග පිරිසිදු කිරීම් භාවිතා කරයි × ඔබේ සාමාන්‍යය.",
  "cleaning_work_plan_guidelines_b5": "ඔබට වෙනත් තැනක වෙන් කිරීම පිරිපහදු කිරීමට අවශ්‍ය නම් අපනයන CSV භාවිතා කරන්න (උදාහරණයක් ලෙස සංචාර ශේෂය තවදුරටත් තද කිරීමට).",
  "cleaners_number": "පිරිසිදු කරන්නන් අංකය",
  "floors_num": "මහල් අංකය",
  "avg_daily_cleaners_required": "සාමාන්‍ය දෛනික පිරිසිදු කරන්නන් අවශ්‍ය වේ",
  "app_pages": "යෙදුම් පිටු",
  "buzzzTime": "Buzzz කාලය",
  "missions": "දූත මණ්ඩල",
  "send_emails": "ඊමේල් යවන්න",
  "enter": "ඇතුල් කරන්න",
  "account": "ගිණුම",
  "privacy": "පෞද්ගලිකත්වය",
  "personal_settings": "පුද්ගලික සැකසුම්",
  "personal_settings_lead": "ඔබේ භාෂාව සහ රහස්‍යතා මනාප කළමනාකරණය කරන්න.",
  "personal_settings_read_only": "මෙම විස්තර කළමනාකරණය කරනු ලබන්නේ ඔබේ පරිපාලක විසිනි. යමක් යාවත්කාලීන කිරීමට අවශ්‍ය නම් ඔවුන් අමතන්න.",
  "change_password": "මුරපදය වෙනස් කරන්න",
  "change_password_hint": "මුරපදය වෙනස් කිරීමෙන් ඔබගේ අනෙකුත් උපාංගවලින් ඉවත් වනු ඇත.",
  "current_password": "වත්මන් මුරපදය",
  "new_password": "නව මුරපදය",
  "confirm_new_password": "නව මුරපදය තහවුරු කරන්න",
  "password_min_length": "මුරපදයේ අවම වශයෙන් අකුරු 8ක් තිබිය යුතුය",
  "passwords_do_not_match": "මුරපද නොගැලපේ",
  "new_password_same_as_current": "නව මුරපදය වත්මන් මුරපදයට වඩා වෙනස් විය යුතුය",
  "current_password_incorrect": "වත්මන් මුරපදය වැරදිය",
  "current_password_required": "වත්මන් මුරපදය අවශ්‍යයි",
  "password_changed_successfully": "මුරපදය සාර්ථකව වෙනස් විය",
  "change_password_failed": "මුරපදය වෙනස් කළ නොහැකි විය",
  "forgot_password": "Forgot password?",
  "forgot_password_title": "Forgot password",
  "forgot_password_hint": "Enter the email address for your panel account and we will send you a reset link if it exists.",
  "forgot_password_sent": "If an account exists for that email, a reset link has been sent. Check your inbox.",
  "forgot_password_invalid_email": "Please enter a valid email address",
  "forgot_password_failed": "Could not send reset email. Please try again.",
  "send_reset_link": "Send reset link",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "reset_password_hint": "Choose a new password for your account.",
  "reset_password_missing_token": "This reset link is incomplete. Request a new one from the login page.",
  "reset_password_invalid_token": "This reset link is invalid or has expired. Request a new one.",
  "reset_password_failed": "Could not reset password",
  "password_reset_successfully": "Password reset successfully. You can log in with your new password.",
  "login_invalid_credentials": "පරිශීලක නාමය හෝ මුරපදය වැරදිය",
  "login_credentials_required": "ඔබගේ පරිශීලක නාමය හෝ විද්‍යුත් තැපෑල සහ මුරපදය ඇතුළත් කරන්න",
  "login_network_error": "සේවාදායකය වෙත සම්බන්ධ විය නොහැක. සම්බන්ධතාව පරීක්ෂා කර නැවත උත්සාහ කරන්න",
  "login_failed": "පිවිසීමට නොහැකි විය. නැවත උත්සාහ කරන්න",
  "login_too_many_attempts": "පිවිසුම් උත්සාහයන් වැඩියි. මිනිත්තු 15ක් රැඳී නැවත උත්සාහ කරන්න.",
  "forgot_password_too_many": "මුරපද යළි සැකසීමේ ඉල්ලීම් වැඩියි. පැයක් රැඳී නැවත උත්සාහ කරන්න.",
  "reset_password_too_many": "මුරපද යළි සැකසීමේ උත්සාහයන් වැඩියි. පැයක් රැඳී නැවත උත්සාහ කරන්න.",
  "change_password_too_many": "මුරපදය වෙනස් කිරීමේ උත්සාහයන් වැඩියි. මිනිත්තු 15ක් රැඳී නැවත උත්සාහ කරන්න.",

  "personal_settings_language_hint": "මෙම බ්‍රවුසරය සඳහා මුළු ද්වාරයටම අදාළ වේ.",
  "personal_settings_privacy_hint": "අදාළ රහස්‍යතා නීති යටතේ ඔබගේ පුද්ගලික දත්ත මැකීමට ඉල්ලන්න.",
  "personal_settings_export_hint": "ඔබ ගැන අප සතුව ඇති පුද්ගලික දත්තවල කියවිය හැකි JSON පිටපතක් බාගන්න: ඔබේ ද්වාර පැතිකඩ, ඔබට ප්‍රවේශ විය හැකි අඩවි සහ ඔබේ සම්බන්ධිත ජංගම යෙදුම් පැතිකඩ (ඔබේ දුරකථනය ගැළපෙන විට). දිනකට සීමිත අපනයන.",
  "Download my data": "මගේ දත්ත බාගන්න",
  "personal_settings_role": "භූමිකාව",
  "Request deletion of my data": "මගේ දත්ත මකා දැමීමට ඉල්ලන්න",
  "Request deletion of my data - confirm": "මගේ දත්ත මකා දැමීමට ඉල්ලන්නද? පරිපාලක වෙත විද්‍යුත් තැපෑලක් යවනු ලැබේ. අපි ඔබගේ ඉල්ලීම දින 30ක් ඇතුළත ක්‍රියාවට නංවන්නෙමු.",
  "Request deletion of my data - success": "ඉල්ලීම යවා ඇත. අපි එය දින 30 ක් ඇතුළත සකසන්නෙමු.",
  "Request deletion of my data - error": "ඉල්ලීම ඉදිරිපත් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න නැතහොත් privacy@buzzztech.com විද්‍යුත් තැපෑලෙන් කරන්න.",
  "metrics": "මෙට්රික්ස්",
  "select_three_metrics": "සංසන්දනය කිරීමට ප්‍රමිතික 3ක් දක්වා තෝරන්න",
  "select_four_metrics": "සංසන්දනය කිරීමට ප්‍රමිතික 4ක් දක්වා තෝරන්න",
  "legend": "පුරාවෘත්තය",
  "more_details": "වැඩි විස්තර",
  "performance_overview": "කාර්ය සාධන දළ විශ්ලේෂණය",
  "loading_chart": "ප්‍රස්ථාරය පූරණය වේ",
  "retry": "නැවත උත්සාහ කරන්න",
  "performance_trending_upward": "කාර්ය සාධනය ඉහළට නැඹුරු වේ",
  "high_complaint_ratio": "ඉහළ පැමිණිලි අනුපාතය",
  "click_bars_for_details": "දෛනික විශ්ලේෂණ වෙත සරඹ කිරීමට තීරු මත ක්ලික් කරන්න",
  "refresh": "නැවුම් කරන්න",
  "table": "මේසය",
  "cards": "කාඩ්පත්",
  "no_recent_arrivals": "මෑත පැමිණීම් නැත",
  "feedback_charts": "ප්‍රතිපෝෂණ ප්‍රස්ථාර",
  "general_overview": "සාමාන්ය දළ විශ්ලේෂණය",
  "cleaning_complaints_breakdown": "පිරිසිදු කිරීමේ පැමිණිලි බිඳවැටීම",
  "maintenance_complaints_breakdown": "නඩත්තු පැමිණිලි බිඳවැටීම",
  "refresh_failed": "නැවුම් කිරීම අසාර්ථක විය",
  "data_exported_successfully": "දත්ත සාර්ථකව අපනයනය කරන ලදී",
  "data_export_failed": "දත්ත අපනයනය අසාර්ථක විය",
  "analytics_export_confirm": "විශ්ලේෂණ CSV ගොනු බාගන්නද?",
  "analytics_export_title": "විශ්ලේෂණ දත්ත අපනයනය කරන්න",
  "analytics_export_description": "ඔබගේ දැනට පෙරන ලද විශ්ලේෂණ සහිත ZIP ගොනුවක් බාගනු ඇත - සාරාංශය, ඩෝනට්, පැය, කාමර සහ පිරිසිදු කරන්නා/අධීක්ෂක පැමිණීම්.",
  "download": "බාගන්න",
  "analytics_export_blocked_loading": "විශ්ලේෂණ දත්ත තවමත් පූරණය වේ. කරුණාකර රැඳී සිට නැවත උත්සාහ කරන්න.",
  "analytics_export_blocked_no_data": "නිර්යාත කිරීමට විශ්ලේෂණ දත්ත නැත. ඔබගේ පෙරහන් යොදන්න සහ පිටුව පූරණය වන තෙක් රැඳී සිටින්න.",
  "analytics_export_blocked_stale_filters": "පෙරහන් වෙනස් වී ඇත. නිර්යාත කිරීමට පෙර පෙරහන් යොදන්න සහ විශ්ලේෂණ නැවත පූරණය වන තෙක් රැඳී සිටින්න.",
  "drill_down_unavailable": "ඩ්‍රිල්-ඩවුන් ඇත්තේ දිනපතා බැලීම සඳහා පමණි",
  "sort_by": "අනුව තෝරන්න",
  "no_active_shift": "ක්‍රියාකාරී මාරුවක් නොමැත",
  "check_site_and_shift": "කරුණාකර අඩවියක් තෝරාගෙන සක්‍රිය මාරුවක් තිබේදැයි පරීක්ෂා කරන්න",
  "please_add_shift_first": "කරුණාකර පළමුව මාරුව එක් කරන්න",
  "cleandex_no_data_message": "Cleandex දත්ත දැනට නොමැත",
  "task_no_data_message": "කාර්ය දත්ත දැනට නොමැත",
  "navigation": "සංචාලනය",
  "network_information": "ජාල තොරතුරු",
  "target_effectiveness": "ඉලක්කගත කාර්යක්ෂමතාව",
  "cleandex_call_cleaner": "Cleandex ඇමතුම් පිරිසිදු කරන්නා",
  "top_complaint": "ඉහළම පැමිණිල්ල",
  "no_complaints": "පැමිණිලි නැත",
  "official_start_date": "නිල ආරම්භක දිනය",
  "note_text": "සටහන් පෙළ",
  "add_note": "සටහන එකතු කරන්න",
  "general_note": "පොදු සටහන",
  "general_note_short": "ජෙනරාල්",
  "battery_short": "බැටරි",
  "panel_short": "පැනලය",
  "technician_short": "කාර්මික ශිල්පියා",
  "battery_replacement": "බැටරි ප්රතිස්ථාපනය",
  "device_maintenance": "උපාංගය නඩත්තු කිරීම",
  "maintenance_type": "නඩත්තු වර්ගය",
  "panel_change": "පැනලය වෙනස් කිරීම",
  "technician_check": "කාර්මික පරීක්ෂාව",
  "enter_note_details": "සටහන් විස්තර ඇතුලත් කරන්න",
  "replacement_date": "ආදේශන දිනය",
  "replaced_by_name": "නමින් ආදේශ කර ඇත",
  "replacement_note": "ආදේශන සටහන",
  "enter_replacement_details": "ආදේශන විස්තර ඇතුළත් කරන්න",
  "replacement_history": "ආදේශන ඉතිහාසය",
  "loading_history": "ඉතිහාසය පූරණය වේ",
  "no_replacement_history": "ප්‍රතිස්ථාපන ඉතිහාසයක් නොමැත",
  "enter_technician_name": "කාර්මිකයාගේ නම ඇතුළත් කරන්න",
  "prefilled_from_account": "ඔබගේ ගිණුමෙන් පෙර පුරවා ඇත - ඔබට සංස්කරණය කළ හැක",
  "user_information": "පරිශීලක තොරතුරු",
  "enter_change_details": "වෙනස් කිරීමේ විස්තර ඇතුළත් කරන්න",
  "panel_change_history": "පැනල වෙනස් කිරීමේ ඉතිහාසය",
  "check_date": "දිනය පරීක්ෂා කරන්න",
  "checked_by_name": "නමින් පරීක්ෂා කර ඇත",
  "enter_check_details": "චෙක්පත් විස්තර ඇතුලත් කරන්න",
  "technician_check_history": "කාර්මිකයා ඉතිහාසය පරීක්ෂා කරයි",
  "no_technician_check_history": "ඉතිහාසය පිරික්සීමට කිසිදු කාර්මික ශිල්පියෙක් නොමැත",
  "change_date": "දිනය වෙනස් කරන්න",
  "changed_by_name": "නමින් වෙනස් කර ඇත",
  "change_note": "සටහන වෙනස් කරන්න",
  "check_note": "සටහන පරීක්ෂා කරන්න",
  "replaced_by": "විසින් ප්රතිස්ථාපනය කරන ලදී",
  "no_data_entered": "දත්ත ඇතුලත් කර නැත",
  "no_panel_change_history": "පැනල වෙනස් කිරීමේ ඉතිහාසයක් නොමැත",
  "invalid_username": "වලංගු නොවන පරිශීලක නාමය",
  "invalid_phone": "වලංගු නොවන දුරකථන අංකයක්",
  "username_must_be_at_least_5_characters": "පරිශීලක නාමය අවම වශයෙන් අක්ෂර 5 ක් විය යුතුය",
  "data_loading_please_wait": "දත්ත දැනට පූරණය වේ. කරුණාකර රැඳී සිටින්න...",
  "dates_not_changed": "දිනයන් වෙනස් වී නැත. රීලෝඩ් අවශ්‍ය නැත.",
  "date_outside_stats_range": "තෝරාගත් දිනයන් ලබා ගත හැකි සංඛ්‍යාලේඛන පරාසයෙන් පිටතයි.",

  "date_range_invalid": "\"සිට\" දිනය \"සිට\" දිනයේ හෝ ඊට පසු විය යුතුය.",
  "filter_help_text": "පෙරහන් රීති: මහල පෙරහන සක්‍රීය කිරීමට පළමුව ගොඩනැගිල්ල තෝරන්න. බොහෝ පෙරහන් බහු තේරීම් සඳහා සහය දක්වයි.",
  "select_building_first": "Floor filter සබල කිරීමට කරුණාකර පළමුව ගොඩනැගිල්ලක් තෝරන්න",
  "cannot_select_gender_with_rooms": "කාමර තෝරන විට කාමර වර්ගය තෝරාගත නොහැක",
  "cannot_select_gender_with_rooms_tooltip": "කාමර තෝරා ගත් විට කාමර වර්ගය පෙරහන භාවිතා කළ නොහැක. කරුණාකර පළමුව කාමර තේරීම ඉවත් කරන්න.",
  "cannot_select_building_with_rooms": "කාමර තෝරන විට ගොඩනැගිල්ල තෝරාගත නොහැක",
  "cannot_select_building_with_rooms_tooltip": "කාමර තෝරා ගත් විට ගොඩනැගිලි පෙරහන භාවිතා කළ නොහැක. කරුණාකර පළමුව කාමර තේරීම ඉවත් කරන්න.",
  "multi_select_hint": "ඔබට විකල්ප කිහිපයක් තෝරා ගත හැකිය",
  "filter_applied": "පෙරහන සාර්ථකව යොදන ලදී",
  "no_filters_selected": "පෙරහන් තෝරා නැත. අවම වශයෙන් එක් පෙරහන් විකල්පයක් තෝරන්න.",
  "filters": "පෙරහන්",
  "attributes": "ගුණාංග",
  "applying": "අයදුම් කරමින්...",
  "active_filters": "ක්රියාකාරී පෙරහන්",
  "viewing_room": "නැරඹුම් කාමරය",
  "multiple": "බහු",
  "close": "වසන්න",
  "save_replacement": "ආදේශනය සුරකින්න",
  "save_change": "වෙනස් කිරීම සුරකින්න",
  "save_check": "චෙක්පත සුරකින්න",
  "failed_to_load_maintenance_history": "නඩත්තු ඉතිහාසය පූරණය කිරීමට අසමත් විය",
  "Battery replacement recorded successfully": "බැටරි ප්‍රතිස්ථාපනය සාර්ථක ලෙස සටහන් විය",
  "Panel change recorded successfully": "පැනල වෙනස් කිරීම සාර්ථකව වාර්තා විය",
  "Technician check recorded successfully": "කාර්මික පරීක්ෂාව සාර්ථකව වාර්තා විය",
  "no_network_data_available": "ජාල දත්ත නොමැත",
  "chat_ask_buzzz": "Buzzz අසන්න",
  "chat_hide": "සඟවන්න",
  "chat_buzzz_assistant": "Buzzz සහකාර",
  "chat_export": "අපනයනය කරන්න",
  "chat_clear": "පැහැදිලියි",
  "chat_unpin": "ඇමුණුම ඉවත් කරන්න",
  "chat_pin": "පින් කරන්න",
  "chat_retry": "නැවත උත්සාහ කරන්න",
  "chat_copy": "පිටපත් කරන්න",
  "chat_copied": "පිටපත් කළා!",
  "chat_share": "බෙදාගන්න",
  "chat_suggestions": "යෝජනා",
  "chat_input_placeholder": "ඔබේ සංඛ්‍යාලේඛන ගැන විමසන්න...",
  "chat_stop": "නවත්වන්න",
  "chat_error": "යමක් වැරදී ඇත. කරුණාකර නැවත උත්සාහ කරන්න.",
  "chat_placeholder": "ඔබේ පිරිසිදු කිරීමේ සංඛ්‍යාලේඛන ගැන මගෙන් අසන්න...",
  "chat_placeholder_context": "{scope} ගැන විමසන්න...",
  "chat_chip_briefing": "උදෑසන දැනුවත් කිරීම",
  "chat_chip_live_status": "සජීවී තත්ත්වය",
  "chat_chip_staff_status": "කාර්ය මණ්ඩල තත්ත්වය",
  "chat_chip_summary": "සාරාංශය",
  "chat_chip_cleaning_priority": "පිරිසිදු කිරීමේ ප්‍රමුඛතාවය",
  "chat_chip_worst_rooms": "නරකම කාමර",
  "chat_chip_focus": "අවධානය යොමු කරන ප්රදේශ",
  "chat_chip_compare_periods": "කාල පරිච්ඡේද සසඳන්න",
  "chat_chip_sla_issues": "SLA ගැටළු",
  "chat_chip_shift_stats": "මාරු සංඛ්යා ලේඛන",
  "chat_chip_complaint_types": "පැමිණිලි වර්ග",
  "chat_chip_busiest_hours": "කාර්යබහුලම පැය",
  "chat_chip_worst_days": "නරකම දවස්",
  "chat_chip_improving": "කාමර වැඩිදියුණු කිරීම",
  "chat_chip_best_rooms": "හොඳම කාමර",
  "chat_chip_help": "උදව්",
  "chat_chip_why_drilldown": "ඇයි? පහළට සිදුරු කරන්න",
  "chat_deep_analysis": "ගැඹුරු විශ්ලේෂණය (මන්දගාමී)",
  "chat_greeting": "හායි {name}, මම උදව් කරන්නේ කෙසේද?",
  "chat_status_online": "ඔන්ලයින්",
  "chat_status_thinking": "සිතමින්...",
  "chat_tool_overview": "දළ විශ්ලේෂණය අදින්නේ...",
  "chat_tool_rooms": "කාමර පරීක්ෂා කරමින්...",
  "chat_tool_hours": "පැය ගණන් විශ්ලේෂණය කරමින්...",
  "chat_tool_days": "දෛනික දත්ත සමාලෝචනය කරමින්...",
  "chat_tool_live": "සජීවී තත්ත්වය පරීක්ෂා කරමින්...",
  "chat_tool_priority": "ප්‍රමුඛතා පරීක්ෂා කරමින්...",
  "chat_tool_room_detail": "කාමර විස්තර ලබා ගනිමින්...",
  "chat_tool_shifts": "මාරුවීම් බලනවා...",
  "chat_tool_staff": "කාර්ය මණ්ඩලය පරීක්ෂා කරමින්...",
  "chat_tool_devices": "උපාංග පරීක්ෂා කරමින්...",
  "chat_feedback_good": "හොඳ ප්‍රතිචාරයක්",
  "chat_feedback_bad": "නරක ප්රතිචාර",
  "chat_feedback_thanks": "ඔබගේ ප්‍රතිපෝෂණයට ස්තූතියි!",
  "chat_feedback_wrong_data": "වැරදි දත්ත",
  "chat_feedback_didnt_understand": "තේරුනේ නෑ",
  "chat_feedback_missing_info": "තොරතුරු අතුරුදහන්",
  "chat_feedback_bad_format": "නරක හැඩතල ගැන්වීම",
  "chat_feedback_hallucinated": "සෑදූ අංක",
  "chat_feedback_submit": "ඉදිරිපත් කරන්න"
}
